/* eslint-disable */
/* tslint:disable */

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import { FieldPolicy, FieldReadFunction, TypePolicies, TypePolicy } from '@apollo/client/cache';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: any; output: any; }
  DateTime: { input: string; output: string; }
  Day: { input: any; output: any; }
  Decimal: { input: any; output: any; }
  GenericScalar: { input: any; output: any; }
  Hour: { input: any; output: any; }
  JSON: { input: any; output: any; }
  JSONString: { input: string; output: string; }
  Metadata: { input: Record<string, string>; output: Record<string, string>; }
  Minute: { input: any; output: any; }
  PositiveDecimal: { input: any; output: any; }
  PositiveInt: { input: any; output: any; }
  UUID: { input: string; output: string; }
  Upload: { input: any; output: any; }
  WeightScalar: { input: any; output: any; }
  _Any: { input: any; output: any; }
};

/**
 * Create a new address for the customer.
 *
 * Requires one of following set of permissions: AUTHENTICATED_USER or AUTHENTICATED_APP + IMPERSONATE_USER.
 *
 * Triggers the following webhook events:
 * - CUSTOMER_UPDATED (async): A customer account was updated.
 * - ADDRESS_CREATED (async): An address was created.
 */
export type AccountAddressCreate = {
  __typename?: 'AccountAddressCreate';
  /** @deprecated Use `errors` field instead. */
  accountErrors: Array<AccountError>;
  address?: Maybe<Address>;
  errors: Array<AccountError>;
  /** A user instance for which the address was created. */
  user?: Maybe<User>;
};

/**
 * Deletes an address of the logged-in user. Requires one of the following permissions: MANAGE_USERS, IS_OWNER.
 *
 * Triggers the following webhook events:
 * - ADDRESS_DELETED (async): An address was deleted.
 */
export type AccountAddressDelete = {
  __typename?: 'AccountAddressDelete';
  /** @deprecated Use `errors` field instead. */
  accountErrors: Array<AccountError>;
  address?: Maybe<Address>;
  errors: Array<AccountError>;
  /** A user instance for which the address was deleted. */
  user?: Maybe<User>;
};

/**
 * Updates an address of the logged-in user. Requires one of the following permissions: MANAGE_USERS, IS_OWNER.
 *
 * Triggers the following webhook events:
 * - ADDRESS_UPDATED (async): An address was updated.
 */
export type AccountAddressUpdate = {
  __typename?: 'AccountAddressUpdate';
  /** @deprecated Use `errors` field instead. */
  accountErrors: Array<AccountError>;
  address?: Maybe<Address>;
  errors: Array<AccountError>;
  /** A user object for which the address was edited. */
  user?: Maybe<User>;
};

/** Event sent when account change email is requested. */
export type AccountChangeEmailRequested = Event & {
  __typename?: 'AccountChangeEmailRequested';
  /** The channel data. */
  channel?: Maybe<Channel>;
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<IssuingPrincipal>;
  /** The new email address the user wants to change to. */
  newEmail?: Maybe<Scalars['String']['output']>;
  /** The application receiving the webhook. */
  recipient?: Maybe<App>;
  /** The URL to redirect the user after he accepts the request. */
  redirectUrl?: Maybe<Scalars['String']['output']>;
  /** Shop data. */
  shop?: Maybe<Shop>;
  /** The token required to confirm request. */
  token?: Maybe<Scalars['String']['output']>;
  /** The user the event relates to. */
  user?: Maybe<User>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

/** Event sent when account confirmation requested. This event is always sent. enableAccountConfirmationByEmail flag set to True is not required. */
export type AccountConfirmationRequested = Event & {
  __typename?: 'AccountConfirmationRequested';
  /** The channel data. */
  channel?: Maybe<Channel>;
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<IssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient?: Maybe<App>;
  /** The URL to redirect the user after he accepts the request. */
  redirectUrl?: Maybe<Scalars['String']['output']>;
  /** Shop data. */
  shop?: Maybe<Shop>;
  /** The token required to confirm request. */
  token?: Maybe<Scalars['String']['output']>;
  /** The user the event relates to. */
  user?: Maybe<User>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

/** Event sent when account is confirmed. */
export type AccountConfirmed = Event & {
  __typename?: 'AccountConfirmed';
  /** The channel data. */
  channel?: Maybe<Channel>;
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<IssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient?: Maybe<App>;
  /** The URL to redirect the user after he accepts the request. */
  redirectUrl?: Maybe<Scalars['String']['output']>;
  /** Shop data. */
  shop?: Maybe<Shop>;
  /** The token required to confirm request. */
  token?: Maybe<Scalars['String']['output']>;
  /** The user the event relates to. */
  user?: Maybe<User>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

/**
 * Remove user account.
 *
 * Requires one of the following permissions: AUTHENTICATED_USER.
 *
 * Triggers the following webhook events:
 * - ACCOUNT_DELETED (async): Account was deleted.
 */
export type AccountDelete = {
  __typename?: 'AccountDelete';
  /** @deprecated Use `errors` field instead. */
  accountErrors: Array<AccountError>;
  errors: Array<AccountError>;
  user?: Maybe<User>;
};

/** Event sent when account delete is requested. */
export type AccountDeleteRequested = Event & {
  __typename?: 'AccountDeleteRequested';
  /** The channel data. */
  channel?: Maybe<Channel>;
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<IssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient?: Maybe<App>;
  /** The URL to redirect the user after he accepts the request. */
  redirectUrl?: Maybe<Scalars['String']['output']>;
  /** Shop data. */
  shop?: Maybe<Shop>;
  /** The token required to confirm request. */
  token?: Maybe<Scalars['String']['output']>;
  /** The user the event relates to. */
  user?: Maybe<User>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

/** Event sent when account is deleted. */
export type AccountDeleted = Event & {
  __typename?: 'AccountDeleted';
  /** The channel data. */
  channel?: Maybe<Channel>;
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<IssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient?: Maybe<App>;
  /** The URL to redirect the user after he accepts the request. */
  redirectUrl?: Maybe<Scalars['String']['output']>;
  /** Shop data. */
  shop?: Maybe<Shop>;
  /** The token required to confirm request. */
  token?: Maybe<Scalars['String']['output']>;
  /** The user the event relates to. */
  user?: Maybe<User>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

/** Event sent when account email is changed. */
export type AccountEmailChanged = Event & {
  __typename?: 'AccountEmailChanged';
  /** The channel data. */
  channel?: Maybe<Channel>;
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<IssuingPrincipal>;
  /** The new email address. */
  newEmail?: Maybe<Scalars['String']['output']>;
  /** The application receiving the webhook. */
  recipient?: Maybe<App>;
  /** The URL to redirect the user after he accepts the request. */
  redirectUrl?: Maybe<Scalars['String']['output']>;
  /** Shop data. */
  shop?: Maybe<Shop>;
  /** The token required to confirm request. */
  token?: Maybe<Scalars['String']['output']>;
  /** The user the event relates to. */
  user?: Maybe<User>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

/** Represents errors in account mutations. */
export type AccountError = {
  __typename?: 'AccountError';
  /** A type of address that causes the error. */
  addressType?: Maybe<AddressTypeEnum>;
  /** The error code. */
  code: AccountErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field?: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message?: Maybe<Scalars['String']['output']>;
};

export type AccountErrorCode =
  | 'ACCOUNT_NOT_CONFIRMED'
  | 'ACTIVATE_OWN_ACCOUNT'
  | 'ACTIVATE_SUPERUSER_ACCOUNT'
  | 'CHANNEL_INACTIVE'
  | 'DEACTIVATE_OWN_ACCOUNT'
  | 'DEACTIVATE_SUPERUSER_ACCOUNT'
  | 'DELETE_NON_STAFF_USER'
  | 'DELETE_OWN_ACCOUNT'
  | 'DELETE_STAFF_ACCOUNT'
  | 'DELETE_SUPERUSER_ACCOUNT'
  | 'DUPLICATED_INPUT_ITEM'
  | 'FILE_SIZE_LIMIT_EXCEEDED'
  | 'GRAPHQL_ERROR'
  | 'INACTIVE'
  | 'INVALID'
  | 'INVALID_CREDENTIALS'
  | 'INVALID_PASSWORD'
  | 'JWT_DECODE_ERROR'
  | 'JWT_INVALID_CSRF_TOKEN'
  | 'JWT_INVALID_TOKEN'
  | 'JWT_MISSING_TOKEN'
  | 'JWT_SIGNATURE_EXPIRED'
  | 'LEFT_NOT_MANAGEABLE_PERMISSION'
  | 'LOGIN_ATTEMPT_DELAYED'
  | 'MISSING_CHANNEL_SLUG'
  | 'NOT_FOUND'
  | 'OUT_OF_SCOPE_GROUP'
  | 'OUT_OF_SCOPE_PERMISSION'
  | 'OUT_OF_SCOPE_USER'
  | 'PASSWORD_ENTIRELY_NUMERIC'
  | 'PASSWORD_RESET_ALREADY_REQUESTED'
  | 'PASSWORD_TOO_COMMON'
  | 'PASSWORD_TOO_SHORT'
  | 'PASSWORD_TOO_SIMILAR'
  | 'REQUIRED'
  | 'UNIQUE'
  | 'UNKNOWN_IP_ADDRESS';

/** Fields required to update the user. */
export type AccountInput = {
  /** Billing address of the customer. */
  defaultBillingAddress?: InputMaybe<AddressInput>;
  /** Shipping address of the customer. */
  defaultShippingAddress?: InputMaybe<AddressInput>;
  /** Given name. */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** User language code. */
  languageCode?: InputMaybe<LanguageCodeEnum>;
  /** Family name. */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /**
   * Fields required to update the user metadata. Can be read by any API client authorized to read the object it's attached to.
   *
   * Warning: never store sensitive information, including financial data such as credit card details.
   */
  metadata?: InputMaybe<Array<MetadataInput>>;
};

/**
 * Register a new user.
 *
 * Triggers the following webhook events:
 * - CUSTOMER_CREATED (async): A new customer account was created.
 * - NOTIFY_USER (async): A notification for account confirmation.
 * - ACCOUNT_CONFIRMATION_REQUESTED (async): An user confirmation was requested. This event is always sent regardless of settings.
 */
export type AccountRegister = {
  __typename?: 'AccountRegister';
  /** @deprecated Use `errors` field instead. */
  accountErrors: Array<AccountError>;
  errors: Array<AccountError>;
  /** Informs whether users need to confirm their email address. */
  requiresConfirmation?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated The field always returns a `User` object constructed from the input data. The `user.id` is always empty. To determine whether the user exists in Saleor, query via an external app with the required permissions. */
  user?: Maybe<User>;
};

/** Fields required to create a user. */
export type AccountRegisterInput = {
  /** Slug of a channel which will be used to notify users. Optional when only one channel exists. */
  channel?: InputMaybe<Scalars['String']['input']>;
  /** The email address of the user. */
  email: Scalars['String']['input'];
  /** Given name. */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** User language code. */
  languageCode?: InputMaybe<LanguageCodeEnum>;
  /** Family name. */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /**
   * User public metadata. Can be read by any API client authorized to read the object it's attached to.
   *
   * Warning: never store sensitive information, including financial data such as credit card details.
   */
  metadata?: InputMaybe<Array<MetadataInput>>;
  /** Password. */
  password: Scalars['String']['input'];
  /** Base of frontend URL that will be needed to create confirmation URL. Required when account confirmation is enabled. */
  redirectUrl?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Sends an email with the account removal link for the logged-in user.
 *
 * Requires one of the following permissions: AUTHENTICATED_USER.
 *
 * Triggers the following webhook events:
 * - NOTIFY_USER (async): A notification for account delete request.
 * - ACCOUNT_DELETE_REQUESTED (async): An account delete requested.
 */
export type AccountRequestDeletion = {
  __typename?: 'AccountRequestDeletion';
  /** @deprecated Use `errors` field instead. */
  accountErrors: Array<AccountError>;
  errors: Array<AccountError>;
};

/**
 * Sets a default address for the authenticated user.
 *
 * Requires one of the following permissions: AUTHENTICATED_USER.
 *
 * Triggers the following webhook events:
 * - CUSTOMER_UPDATED (async): A customer's address was updated.
 */
export type AccountSetDefaultAddress = {
  __typename?: 'AccountSetDefaultAddress';
  /** @deprecated Use `errors` field instead. */
  accountErrors: Array<AccountError>;
  errors: Array<AccountError>;
  /** An updated user instance. */
  user?: Maybe<User>;
};

/** Event sent when setting a new password is requested. */
export type AccountSetPasswordRequested = Event & {
  __typename?: 'AccountSetPasswordRequested';
  /** The channel data. */
  channel?: Maybe<Channel>;
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<IssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient?: Maybe<App>;
  /** The URL to redirect the user after he accepts the request. */
  redirectUrl?: Maybe<Scalars['String']['output']>;
  /** Shop data. */
  shop?: Maybe<Shop>;
  /** The token required to confirm request. */
  token?: Maybe<Scalars['String']['output']>;
  /** The user the event relates to. */
  user?: Maybe<User>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

/**
 * Updates the account of the logged-in user.
 *
 * Requires one of following set of permissions: AUTHENTICATED_USER or AUTHENTICATED_APP + IMPERSONATE_USER.
 *
 * Triggers the following webhook events:
 * - CUSTOMER_UPDATED (async): A customer account was updated.
 * - CUSTOMER_METADATA_UPDATED (async): Optionally called when customer's metadata was updated.
 */
export type AccountUpdate = {
  __typename?: 'AccountUpdate';
  /** @deprecated Use `errors` field instead. */
  accountErrors: Array<AccountError>;
  errors: Array<AccountError>;
  user?: Maybe<User>;
};

/** Represents user address data. */
export type Address = Node & ObjectWithMetadata & {
  __typename?: 'Address';
  /** The city of the address. */
  city: Scalars['String']['output'];
  /** The district of the address. */
  cityArea: Scalars['String']['output'];
  /** Company or organization name. */
  companyName: Scalars['String']['output'];
  /** The country of the address. */
  country: CountryDisplay;
  /** The country area of the address. */
  countryArea: Scalars['String']['output'];
  /** The given name of the address. */
  firstName: Scalars['String']['output'];
  /** The ID of the address. */
  id: Scalars['ID']['output'];
  /** Address is user's default billing address. */
  isDefaultBillingAddress?: Maybe<Scalars['Boolean']['output']>;
  /** Address is user's default shipping address. */
  isDefaultShippingAddress?: Maybe<Scalars['Boolean']['output']>;
  /** The family name of the address. */
  lastName: Scalars['String']['output'];
  /** List of public metadata items. Can be accessed without permissions. */
  metadata: Array<MetadataItem>;
  /**
   * A single key from public metadata.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   */
  metafield?: Maybe<Scalars['String']['output']>;
  /** Public metadata. Use `keys` to control which fields you want to include. The default is to include everything. */
  metafields?: Maybe<Scalars['Metadata']['output']>;
  /** The phone number assigned the address. */
  phone?: Maybe<Scalars['String']['output']>;
  /** The postal code of the address. */
  postalCode: Scalars['String']['output'];
  /** List of private metadata items. Requires staff permissions to access. */
  privateMetadata: Array<MetadataItem>;
  /**
   * A single key from private metadata. Requires staff permissions to access.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   */
  privateMetafield?: Maybe<Scalars['String']['output']>;
  /** Private metadata. Requires staff permissions to access. Use `keys` to control which fields you want to include. The default is to include everything. */
  privateMetafields?: Maybe<Scalars['Metadata']['output']>;
  /** The first line of the address. */
  streetAddress1: Scalars['String']['output'];
  /** The second line of the address. */
  streetAddress2: Scalars['String']['output'];
};


/** Represents user address data. */
export type AddressMetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Represents user address data. */
export type AddressMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Represents user address data. */
export type AddressPrivateMetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Represents user address data. */
export type AddressPrivateMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};

/**
 * Creates user address.
 *
 * Requires one of the following permissions: MANAGE_USERS.
 *
 * Triggers the following webhook events:
 * - ADDRESS_CREATED (async): A new address was created.
 */
export type AddressCreate = {
  __typename?: 'AddressCreate';
  /** @deprecated Use `errors` field instead. */
  accountErrors: Array<AccountError>;
  address?: Maybe<Address>;
  errors: Array<AccountError>;
  /** A user instance for which the address was created. */
  user?: Maybe<User>;
};

/** Event sent when new address is created. */
export type AddressCreated = Event & {
  __typename?: 'AddressCreated';
  /** The address the event relates to. */
  address?: Maybe<Address>;
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<IssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient?: Maybe<App>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

/**
 * Deletes an address.
 *
 * Requires one of the following permissions: MANAGE_USERS.
 *
 * Triggers the following webhook events:
 * - ADDRESS_DELETED (async): An address was deleted.
 */
export type AddressDelete = {
  __typename?: 'AddressDelete';
  /** @deprecated Use `errors` field instead. */
  accountErrors: Array<AccountError>;
  address?: Maybe<Address>;
  errors: Array<AccountError>;
  /** A user instance for which the address was deleted. */
  user?: Maybe<User>;
};

/** Event sent when address is deleted. */
export type AddressDeleted = Event & {
  __typename?: 'AddressDeleted';
  /** The address the event relates to. */
  address?: Maybe<Address>;
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<IssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient?: Maybe<App>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

/** Filtering options for addresses. */
export type AddressFilterInput = {
  country?: InputMaybe<CountryCodeEnumFilterInput>;
  phoneNumber?: InputMaybe<StringFilterInput>;
};

export type AddressInput = {
  /** City. */
  city?: InputMaybe<Scalars['String']['input']>;
  /** District. */
  cityArea?: InputMaybe<Scalars['String']['input']>;
  /** Company or organization. */
  companyName?: InputMaybe<Scalars['String']['input']>;
  /** Country. */
  country?: InputMaybe<CountryCode>;
  /** State or province. */
  countryArea?: InputMaybe<Scalars['String']['input']>;
  /** Given name. */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** Family name. */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /**
   * Address public metadata. Can be read by any API client authorized to read the object it's attached to.
   *
   * Warning: never store sensitive information, including financial data such as credit card details.
   */
  metadata?: InputMaybe<Array<MetadataInput>>;
  /**
   * Phone number.
   *
   * Phone numbers are validated with Google's [libphonenumber](https://github.com/google/libphonenumber) library.
   */
  phone?: InputMaybe<Scalars['String']['input']>;
  /** Postal code. */
  postalCode?: InputMaybe<Scalars['String']['input']>;
  /**
   * Determine if the address should be validated. By default, Saleor accepts only address inputs matching ruleset from [Google Address Data]{https://chromium-i18n.appspot.com/ssl-address), using [i18naddress](https://github.com/mirumee/google-i18n-address) library. Some mutations may require additional permissions to use the the field. More info about permissions can be found in relevant mutation.
   *
   * Added in Saleor 3.19.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  skipValidation?: InputMaybe<Scalars['Boolean']['input']>;
  /** Address. */
  streetAddress1?: InputMaybe<Scalars['String']['input']>;
  /** Address. */
  streetAddress2?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Sets a default address for the given user.
 *
 * Requires one of the following permissions: MANAGE_USERS.
 *
 * Triggers the following webhook events:
 * - CUSTOMER_UPDATED (async): A customer was updated.
 */
export type AddressSetDefault = {
  __typename?: 'AddressSetDefault';
  /** @deprecated Use `errors` field instead. */
  accountErrors: Array<AccountError>;
  errors: Array<AccountError>;
  /** An updated user instance. */
  user?: Maybe<User>;
};

export type AddressTypeEnum =
  | 'BILLING'
  | 'SHIPPING';

/**
 * Updates an address.
 *
 * Requires one of the following permissions: MANAGE_USERS.
 *
 * Triggers the following webhook events:
 * - ADDRESS_UPDATED (async): An address was updated.
 */
export type AddressUpdate = {
  __typename?: 'AddressUpdate';
  /** @deprecated Use `errors` field instead. */
  accountErrors: Array<AccountError>;
  address?: Maybe<Address>;
  errors: Array<AccountError>;
  /** A user object for which the address was edited. */
  user?: Maybe<User>;
};

/** Event sent when address is updated. */
export type AddressUpdated = Event & {
  __typename?: 'AddressUpdated';
  /** The address the event relates to. */
  address?: Maybe<Address>;
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<IssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient?: Maybe<App>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

/** Represents address validation rules for a country. */
export type AddressValidationData = {
  __typename?: 'AddressValidationData';
  /**
   * The address format of the address validation rule.
   *
   * Many fields in the JSON refer to address fields by one-letter abbreviations. These are defined as follows:
   *
   * - `N`: Name
   * - `O`: Organization
   * - `A`: Street Address Line(s)
   * - `D`: Dependent locality (may be an inner-city district or a suburb)
   * - `C`: City or Locality
   * - `S`: Administrative area such as a state, province, island etc
   * - `Z`: Zip or postal code
   * - `X`: Sorting code
   *
   * [Click here for more information.](https://github.com/google/libaddressinput/wiki/AddressValidationMetadata)
   */
  addressFormat: Scalars['String']['output'];
  /**
   * The latin address format of the address validation rule.
   *
   * Many fields in the JSON refer to address fields by one-letter abbreviations. These are defined as follows:
   *
   * - `N`: Name
   * - `O`: Organization
   * - `A`: Street Address Line(s)
   * - `D`: Dependent locality (may be an inner-city district or a suburb)
   * - `C`: City or Locality
   * - `S`: Administrative area such as a state, province, island etc
   * - `Z`: Zip or postal code
   * - `X`: Sorting code
   *
   * [Click here for more information.](https://github.com/google/libaddressinput/wiki/AddressValidationMetadata)
   */
  addressLatinFormat: Scalars['String']['output'];
  /** The allowed fields to use in address. */
  allowedFields: Array<Scalars['String']['output']>;
  /** The available choices for the city area of the address validation rule. */
  cityAreaChoices: Array<ChoiceValue>;
  /** The formal name of the city area of the address validation rule. */
  cityAreaType: Scalars['String']['output'];
  /** The available choices for the city of the address validation rule. */
  cityChoices: Array<ChoiceValue>;
  /** The formal name of the city of the address validation rule. */
  cityType: Scalars['String']['output'];
  /** The available choices for the country area of the address validation rule. */
  countryAreaChoices: Array<ChoiceValue>;
  /** The formal name of the county area of the address validation rule. */
  countryAreaType: Scalars['String']['output'];
  /** The country code of the address validation rule. */
  countryCode: Scalars['String']['output'];
  /** The country name of the address validation rule. */
  countryName: Scalars['String']['output'];
  /** The example postal code of the address validation rule. */
  postalCodeExamples: Array<Scalars['String']['output']>;
  /** The regular expression for postal code validation. */
  postalCodeMatchers: Array<Scalars['String']['output']>;
  /** The postal code prefix of the address validation rule. */
  postalCodePrefix: Scalars['String']['output'];
  /** The formal name of the postal code of the address validation rule. */
  postalCodeType: Scalars['String']['output'];
  /** The required fields to create a valid address. */
  requiredFields: Array<Scalars['String']['output']>;
  /** The list of fields that should be in upper case for address validation rule. */
  upperFields: Array<Scalars['String']['output']>;
};

/** Represents allocation. */
export type Allocation = Node & {
  __typename?: 'Allocation';
  /** The ID of allocation. */
  id: Scalars['ID']['output'];
  /**
   * Quantity allocated for orders.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS, MANAGE_ORDERS.
   */
  quantity: Scalars['Int']['output'];
  /**
   * The warehouse were items were allocated.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS, MANAGE_ORDERS.
   */
  warehouse: Warehouse;
};

/**
 * Determine the allocation strategy for the channel.
 *
 *     PRIORITIZE_SORTING_ORDER - allocate stocks according to the warehouses' order
 *     within the channel
 *
 *     PRIORITIZE_HIGH_STOCK - allocate stock in a warehouse with the most stock
 *
 */
export type AllocationStrategyEnum =
  | 'PRIORITIZE_HIGH_STOCK'
  | 'PRIORITIZE_SORTING_ORDER';

/** Represents app data. */
export type App = Node & ObjectWithMetadata & {
  __typename?: 'App';
  /** Description of this app. */
  aboutApp?: Maybe<Scalars['String']['output']>;
  /** JWT token used to authenticate by third-party app. */
  accessToken?: Maybe<Scalars['String']['output']>;
  /** URL to iframe with the app. */
  appUrl?: Maybe<Scalars['String']['output']>;
  /** The App's author name. */
  author?: Maybe<Scalars['String']['output']>;
  /** App's brand data. */
  brand?: Maybe<AppBrand>;
  /**
   * Circuit breaker last state change date.
   *
   * Added in Saleor 3.21.
   */
  breakerLastStateChange?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Circuit breaker state, if open, sync webhooks operation is disrupted.
   *
   * Added in Saleor 3.21.
   */
  breakerState: CircuitBreakerStateEnum;
  /**
   * URL to iframe with the configuration for the app.
   * @deprecated Use `appUrl` instead.
   */
  configurationUrl?: Maybe<Scalars['String']['output']>;
  /** The date and time when the app was created. */
  created?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Description of the data privacy defined for this app.
   * @deprecated Use `dataPrivacyUrl` instead.
   */
  dataPrivacy?: Maybe<Scalars['String']['output']>;
  /** URL to details about the privacy policy on the app owner page. */
  dataPrivacyUrl?: Maybe<Scalars['String']['output']>;
  /** App's dashboard extensions. */
  extensions: Array<AppExtension>;
  /** Homepage of the app. */
  homepageUrl?: Maybe<Scalars['String']['output']>;
  /** The ID of the app. */
  id: Scalars['ID']['output'];
  /**
   * Canonical app ID from the manifest
   *
   * Added in Saleor 3.19.
   */
  identifier?: Maybe<Scalars['String']['output']>;
  /** Determine if app will be set active or not. */
  isActive?: Maybe<Scalars['Boolean']['output']>;
  /** URL to manifest used during app's installation. */
  manifestUrl?: Maybe<Scalars['String']['output']>;
  /** List of public metadata items. Can be accessed without permissions. */
  metadata: Array<MetadataItem>;
  /**
   * A single key from public metadata.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   */
  metafield?: Maybe<Scalars['String']['output']>;
  /** Public metadata. Use `keys` to control which fields you want to include. The default is to include everything. */
  metafields?: Maybe<Scalars['Metadata']['output']>;
  /** Name of the app. */
  name?: Maybe<Scalars['String']['output']>;
  /** List of the app's permissions. */
  permissions?: Maybe<Array<Permission>>;
  /** List of private metadata items. Requires staff permissions to access. */
  privateMetadata: Array<MetadataItem>;
  /**
   * A single key from private metadata. Requires staff permissions to access.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   */
  privateMetafield?: Maybe<Scalars['String']['output']>;
  /** Private metadata. Requires staff permissions to access. Use `keys` to control which fields you want to include. The default is to include everything. */
  privateMetafields?: Maybe<Scalars['Metadata']['output']>;
  /**
   * List of problems associated with this app.
   *
   * Added in Saleor 3.22.
   *
   * Requires one of the following permissions: AUTHENTICATED_APP, MANAGE_APPS.
   */
  problems?: Maybe<Array<AppProblem>>;
  /** Support page for the app. */
  supportUrl?: Maybe<Scalars['String']['output']>;
  /**
   * Last 4 characters of the tokens.
   *
   * Requires one of the following permissions: MANAGE_APPS, OWNER.
   */
  tokens?: Maybe<Array<AppToken>>;
  /** Type of the app. */
  type?: Maybe<AppTypeEnum>;
  /** Version number of the app. */
  version?: Maybe<Scalars['String']['output']>;
  /**
   * List of webhooks assigned to this app.
   *
   * Requires one of the following permissions: MANAGE_APPS, OWNER.
   */
  webhooks?: Maybe<Array<Webhook>>;
};


/** Represents app data. */
export type AppMetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Represents app data. */
export type AppMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Represents app data. */
export type AppPrivateMetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Represents app data. */
export type AppPrivateMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Represents app data. */
export type AppProblemsArgs = {
  limit?: InputMaybe<Scalars['PositiveInt']['input']>;
};

/**
 * Activate the app.
 *
 * Requires one of the following permissions: MANAGE_APPS.
 *
 * Triggers the following webhook events:
 * - APP_STATUS_CHANGED (async): An app was activated.
 */
export type AppActivate = {
  __typename?: 'AppActivate';
  app?: Maybe<App>;
  /** @deprecated Use `errors` field instead. */
  appErrors: Array<AppError>;
  errors: Array<AppError>;
};

/** Represents the app's brand data. */
export type AppBrand = {
  __typename?: 'AppBrand';
  /** App's logos details. */
  logo: AppBrandLogo;
};

/** Represents the app's brand logo data. */
export type AppBrandLogo = {
  __typename?: 'AppBrandLogo';
  /** URL to the default logo image. */
  default: Scalars['String']['output'];
};


/** Represents the app's brand logo data. */
export type AppBrandLogoDefaultArgs = {
  format?: InputMaybe<IconThumbnailFormatEnum>;
  size?: InputMaybe<Scalars['Int']['input']>;
};

export type AppCountableConnection = {
  __typename?: 'AppCountableConnection';
  edges: Array<AppCountableEdge>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** A total count of items in the collection. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type AppCountableEdge = {
  __typename?: 'AppCountableEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: App;
};

/**
 * Creates a new app. Requires the following permissions: AUTHENTICATED_STAFF_USER and MANAGE_APPS.
 *
 * Triggers the following webhook events:
 * - APP_INSTALLED (async): An app was installed.
 */
export type AppCreate = {
  __typename?: 'AppCreate';
  app?: Maybe<App>;
  /** @deprecated Use `errors` field instead. */
  appErrors: Array<AppError>;
  /** The newly created authentication token. */
  authToken?: Maybe<Scalars['String']['output']>;
  errors: Array<AppError>;
};

/**
 * Deactivate the app.
 *
 * Requires one of the following permissions: MANAGE_APPS.
 *
 * Triggers the following webhook events:
 * - APP_STATUS_CHANGED (async): An app was deactivated.
 */
export type AppDeactivate = {
  __typename?: 'AppDeactivate';
  app?: Maybe<App>;
  /** @deprecated Use `errors` field instead. */
  appErrors: Array<AppError>;
  errors: Array<AppError>;
};

/**
 * Deletes an app.
 *
 * Requires one of the following permissions: MANAGE_APPS.
 *
 * Triggers the following webhook events:
 * - APP_DELETED (async): An app was deleted.
 */
export type AppDelete = {
  __typename?: 'AppDelete';
  app?: Maybe<App>;
  /** @deprecated Use `errors` field instead. */
  appErrors: Array<AppError>;
  errors: Array<AppError>;
};

/**
 * Deletes failed installation.
 *
 * Requires one of the following permissions: MANAGE_APPS.
 */
export type AppDeleteFailedInstallation = {
  __typename?: 'AppDeleteFailedInstallation';
  /** @deprecated Use `errors` field instead. */
  appErrors: Array<AppError>;
  appInstallation?: Maybe<AppInstallation>;
  errors: Array<AppError>;
};

/** Event sent when app is deleted. */
export type AppDeleted = Event & {
  __typename?: 'AppDeleted';
  /** The application the event relates to. */
  app?: Maybe<App>;
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<IssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient?: Maybe<App>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

export type AppError = {
  __typename?: 'AppError';
  /** The error code. */
  code: AppErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field?: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message?: Maybe<Scalars['String']['output']>;
  /** List of permissions which causes the error. */
  permissions?: Maybe<Array<PermissionEnum>>;
};

export type AppErrorCode =
  | 'FORBIDDEN'
  | 'GRAPHQL_ERROR'
  | 'INVALID'
  | 'INVALID_CUSTOM_HEADERS'
  | 'INVALID_MANIFEST_FORMAT'
  | 'INVALID_PERMISSION'
  | 'INVALID_STATUS'
  | 'INVALID_URL_FORMAT'
  | 'MANIFEST_URL_CANT_CONNECT'
  | 'NOT_FOUND'
  | 'OUT_OF_SCOPE_APP'
  | 'OUT_OF_SCOPE_PERMISSION'
  | 'REQUIRED'
  | 'UNIQUE'
  | 'UNSUPPORTED_SALEOR_VERSION';

/** Represents app data. */
export type AppExtension = Node & {
  __typename?: 'AppExtension';
  /** JWT token used to authenticate by third-party app extension. */
  accessToken?: Maybe<Scalars['String']['output']>;
  /** The app assigned to app extension. */
  app: App;
  /** The ID of the app extension. */
  id: Scalars['ID']['output'];
  /** Label of the extension to show in the dashboard. */
  label: Scalars['String']['output'];
  /**
   * Place where given extension will be mounted.
   * @deprecated Use `mountName` instead.
   */
  mount: AppExtensionMountEnum;
  /**
   * Name of the extension mount point in the dashboard. Replaces `mount`
   *
   * Added in Saleor 3.22.
   */
  mountName: Scalars['String']['output'];
  /**
   * App extension options.
   *
   * Added in Saleor 3.22.
   * @deprecated Use `settings` field instead.
   */
  options?: Maybe<AppExtensionPossibleOptions>;
  /** List of the app extension's permissions. */
  permissions: Array<Permission>;
  /**
   * App extension settings. Replaces `options` field.
   *
   * Added in Saleor 3.22.
   */
  settings: Scalars['JSON']['output'];
  /**
   * Type of way how app extension will be opened.
   * @deprecated Use `targetName` instead.
   */
  target: AppExtensionTargetEnum;
  /**
   * Name of the extension target in the dashboard. Replaces `target`
   *
   * Added in Saleor 3.22.
   */
  targetName: Scalars['String']['output'];
  /** URL of a view where extension's iframe is placed. */
  url: Scalars['String']['output'];
};

export type AppExtensionCountableConnection = {
  __typename?: 'AppExtensionCountableConnection';
  edges: Array<AppExtensionCountableEdge>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** A total count of items in the collection. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type AppExtensionCountableEdge = {
  __typename?: 'AppExtensionCountableEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: AppExtension;
};

export type AppExtensionFilterInput = {
  /**
   * DEPRECATED: Use `mountName` instead.
   *
   * DEPRECATED: this field will be removed.
   */
  mount?: InputMaybe<Array<AppExtensionMountEnum>>;
  /**
   * Plain-text mount name (case insensitive)
   *
   * Added in Saleor 3.22.
   */
  mountName?: InputMaybe<Array<Scalars['String']['input']>>;
  /**
   * DEPRECATED: Use `targetName` instead.
   *
   * DEPRECATED: this field will be removed.
   */
  target?: InputMaybe<AppExtensionTargetEnum>;
  /**
   * Plain-text target name (case insensitive)
   *
   * Added in Saleor 3.22.
   */
  targetName?: InputMaybe<Scalars['String']['input']>;
};

/** All places where app extension can be mounted. */
export type AppExtensionMountEnum =
  | 'CATEGORY_DETAILS_MORE_ACTIONS'
  | 'CATEGORY_OVERVIEW_CREATE'
  | 'CATEGORY_OVERVIEW_MORE_ACTIONS'
  | 'COLLECTION_DETAILS_MORE_ACTIONS'
  | 'COLLECTION_DETAILS_WIDGETS'
  | 'COLLECTION_OVERVIEW_CREATE'
  | 'COLLECTION_OVERVIEW_MORE_ACTIONS'
  | 'CUSTOMER_DETAILS_MORE_ACTIONS'
  | 'CUSTOMER_DETAILS_WIDGETS'
  | 'CUSTOMER_OVERVIEW_CREATE'
  | 'CUSTOMER_OVERVIEW_MORE_ACTIONS'
  | 'DISCOUNT_DETAILS_MORE_ACTIONS'
  | 'DISCOUNT_OVERVIEW_CREATE'
  | 'DISCOUNT_OVERVIEW_MORE_ACTIONS'
  | 'DRAFT_ORDER_DETAILS_MORE_ACTIONS'
  | 'DRAFT_ORDER_DETAILS_WIDGETS'
  | 'DRAFT_ORDER_OVERVIEW_CREATE'
  | 'DRAFT_ORDER_OVERVIEW_MORE_ACTIONS'
  | 'GIFT_CARD_DETAILS_MORE_ACTIONS'
  | 'GIFT_CARD_DETAILS_WIDGETS'
  | 'GIFT_CARD_OVERVIEW_CREATE'
  | 'GIFT_CARD_OVERVIEW_MORE_ACTIONS'
  | 'MENU_DETAILS_MORE_ACTIONS'
  | 'MENU_OVERVIEW_CREATE'
  | 'MENU_OVERVIEW_MORE_ACTIONS'
  | 'NAVIGATION_CATALOG'
  | 'NAVIGATION_CUSTOMERS'
  | 'NAVIGATION_DISCOUNTS'
  | 'NAVIGATION_ORDERS'
  | 'NAVIGATION_PAGES'
  | 'NAVIGATION_TRANSLATIONS'
  | 'ORDER_DETAILS_MORE_ACTIONS'
  | 'ORDER_DETAILS_WIDGETS'
  | 'ORDER_OVERVIEW_CREATE'
  | 'ORDER_OVERVIEW_MORE_ACTIONS'
  | 'PAGE_DETAILS_MORE_ACTIONS'
  | 'PAGE_OVERVIEW_CREATE'
  | 'PAGE_OVERVIEW_MORE_ACTIONS'
  | 'PAGE_TYPE_DETAILS_MORE_ACTIONS'
  | 'PAGE_TYPE_OVERVIEW_CREATE'
  | 'PAGE_TYPE_OVERVIEW_MORE_ACTIONS'
  | 'PRODUCT_DETAILS_MORE_ACTIONS'
  | 'PRODUCT_DETAILS_WIDGETS'
  | 'PRODUCT_OVERVIEW_CREATE'
  | 'PRODUCT_OVERVIEW_MORE_ACTIONS'
  | 'TRANSLATIONS_MORE_ACTIONS'
  | 'VOUCHER_DETAILS_MORE_ACTIONS'
  | 'VOUCHER_DETAILS_WIDGETS'
  | 'VOUCHER_OVERVIEW_CREATE'
  | 'VOUCHER_OVERVIEW_MORE_ACTIONS';

/** Represents the options for an app extension. */
export type AppExtensionOptionsNewTab = {
  __typename?: 'AppExtensionOptionsNewTab';
  /**
   * Options controlling behavior of the NEW_TAB extension target
   * @deprecated Use `settings` field directly.
   */
  newTabTarget?: Maybe<NewTabTargetOptions>;
};

/** Represents the options for an app extension. */
export type AppExtensionOptionsWidget = {
  __typename?: 'AppExtensionOptionsWidget';
  /**
   * Options for displaying a Widget
   * @deprecated Use `settings` field directly.
   */
  widgetTarget?: Maybe<WidgetTargetOptions>;
};

export type AppExtensionPossibleOptions = AppExtensionOptionsNewTab | AppExtensionOptionsWidget;

/**
 * All available ways of opening an app extension.
 *
 *     POPUP - app's extension will be mounted as a popup window
 *     APP_PAGE - redirect to app's page
 *
 */
export type AppExtensionTargetEnum =
  | 'APP_PAGE'
  | 'NEW_TAB'
  | 'POPUP'
  | 'WIDGET';

/**
 * Fetch and validate manifest.
 *
 * Requires one of the following permissions: MANAGE_APPS.
 */
export type AppFetchManifest = {
  __typename?: 'AppFetchManifest';
  /** @deprecated Use `errors` field instead. */
  appErrors: Array<AppError>;
  errors: Array<AppError>;
  /** The validated manifest. */
  manifest?: Maybe<Manifest>;
};

export type AppFilterInput = {
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<AppTypeEnum>;
};

export type AppInput = {
  /**
   * Canonical app ID. If not provided, the identifier will be generated based on app.id.
   *
   * Added in Saleor 3.19.
   */
  identifier?: InputMaybe<Scalars['String']['input']>;
  /** Name of the app. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** List of permission code names to assign to this app. */
  permissions?: InputMaybe<Array<PermissionEnum>>;
};

/** Install new app by using app manifest. Requires the following permissions: AUTHENTICATED_STAFF_USER and MANAGE_APPS. */
export type AppInstall = {
  __typename?: 'AppInstall';
  /** @deprecated Use `errors` field instead. */
  appErrors: Array<AppError>;
  appInstallation?: Maybe<AppInstallation>;
  errors: Array<AppError>;
};

export type AppInstallInput = {
  /** Determine if app will be set active or not. */
  activateAfterInstallation?: InputMaybe<Scalars['Boolean']['input']>;
  /** Name of the app to install. */
  appName?: InputMaybe<Scalars['String']['input']>;
  /** URL to app's manifest in JSON format. */
  manifestUrl?: InputMaybe<Scalars['String']['input']>;
  /** List of permission code names to assign to this app. */
  permissions?: InputMaybe<Array<PermissionEnum>>;
};

/** Represents ongoing installation of app. */
export type AppInstallation = Job & Node & {
  __typename?: 'AppInstallation';
  /** The name of the app installation. */
  appName: Scalars['String']['output'];
  /** App's brand data. */
  brand?: Maybe<AppBrand>;
  /** Created date time of job in ISO 8601 format. */
  createdAt: Scalars['DateTime']['output'];
  /** The ID of the app installation. */
  id: Scalars['ID']['output'];
  /** The URL address of manifest for the app installation. */
  manifestUrl: Scalars['String']['output'];
  /** Job message. */
  message?: Maybe<Scalars['String']['output']>;
  /** Job status. */
  status: JobStatusEnum;
  /** Date time of job last update in ISO 8601 format. */
  updatedAt: Scalars['DateTime']['output'];
};

/** Event sent when new app is installed. */
export type AppInstalled = Event & {
  __typename?: 'AppInstalled';
  /** The application the event relates to. */
  app?: Maybe<App>;
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<IssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient?: Maybe<App>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

/** Represents the app's manifest brand data. */
export type AppManifestBrand = {
  __typename?: 'AppManifestBrand';
  /** App's logos details. */
  logo: AppManifestBrandLogo;
};

/** Represents the app's manifest brand data. */
export type AppManifestBrandLogo = {
  __typename?: 'AppManifestBrandLogo';
  /** Data URL with a base64 encoded logo image. */
  default: Scalars['String']['output'];
};


/** Represents the app's manifest brand data. */
export type AppManifestBrandLogoDefaultArgs = {
  format?: InputMaybe<IconThumbnailFormatEnum>;
  size?: InputMaybe<Scalars['Int']['input']>;
};

export type AppManifestExtension = {
  __typename?: 'AppManifestExtension';
  /** Label of the extension to show in the dashboard. */
  label: Scalars['String']['output'];
  /**
   * Place where given extension will be mounted.
   * @deprecated Use `mountName` instead.
   */
  mount: AppExtensionMountEnum;
  /**
   * Name of the extension mount point in the dashboard. Replaces `mount`
   *
   * Added in Saleor 3.22.
   */
  mountName: Scalars['String']['output'];
  /** List of the app extension's permissions. */
  permissions: Array<Permission>;
  /**
   * JSON object with settings for this extension.
   *
   * Added in Saleor 3.22.
   */
  settings: Scalars['JSON']['output'];
  /**
   * Type of way how app extension will be opened.
   * @deprecated Use `targetName` instead.
   */
  target: AppExtensionTargetEnum;
  /**
   * Name of the extension target in the dashboard. Replaces `target`
   *
   * Added in Saleor 3.22.
   */
  targetName: Scalars['String']['output'];
  /** URL of a view where extension's iframe is placed. */
  url: Scalars['String']['output'];
};

export type AppManifestRequiredSaleorVersion = {
  __typename?: 'AppManifestRequiredSaleorVersion';
  /** Required Saleor version as semver range. */
  constraint: Scalars['String']['output'];
  /** Informs if the Saleor version matches the required one. */
  satisfied: Scalars['Boolean']['output'];
};

export type AppManifestWebhook = {
  __typename?: 'AppManifestWebhook';
  /** The asynchronous events that webhook wants to subscribe. */
  asyncEvents?: Maybe<Array<WebhookEventTypeAsyncEnum>>;
  /** The name of the webhook. */
  name: Scalars['String']['output'];
  /** Subscription query of a webhook */
  query: Scalars['String']['output'];
  /** The synchronous events that webhook wants to subscribe. */
  syncEvents?: Maybe<Array<WebhookEventTypeSyncEnum>>;
  /** The url to receive the payload. */
  targetUrl: Scalars['String']['output'];
};

/**
 * Represents a problem associated with an app.
 *
 * Added in Saleor 3.22.
 */
export type AppProblem = Node & {
  __typename?: 'AppProblem';
  /**
   * Number of occurrences.
   *
   * Added in Saleor 3.22.
   */
  count: Scalars['Int']['output'];
  /**
   * The date and time when the problem was created.
   *
   * Added in Saleor 3.22.
   */
  createdAt: Scalars['DateTime']['output'];
  /**
   * Dismissal information. Null if the problem has not been dismissed.
   *
   * Added in Saleor 3.22.
   *
   * Requires one of the following permissions: AUTHENTICATED_APP, MANAGE_APPS.
   */
  dismissed?: Maybe<AppProblemDismissed>;
  /**
   * The ID of the app problem.
   *
   * Added in Saleor 3.22.
   */
  id: Scalars['ID']['output'];
  /**
   * Whether the problem has reached critical threshold.
   *
   * Added in Saleor 3.22.
   */
  isCritical: Scalars['Boolean']['output'];
  /**
   * Key identifying the type of problem.
   *
   * Added in Saleor 3.22.
   */
  key: Scalars['String']['output'];
  /**
   * The problem message.
   *
   * Added in Saleor 3.22.
   */
  message: Scalars['String']['output'];
  /**
   * The date and time when the problem was last updated.
   *
   * Added in Saleor 3.22.
   */
  updatedAt: Scalars['DateTime']['output'];
};

/**
 * Add a problem to the calling app.
 *
 * Added in Saleor 3.22.
 *
 * Requires one of the following permissions: AUTHENTICATED_APP.
 */
export type AppProblemCreate = {
  __typename?: 'AppProblemCreate';
  /** The created or updated app problem. */
  appProblem?: Maybe<AppProblem>;
  errors: Array<AppProblemCreateError>;
};

export type AppProblemCreateError = {
  __typename?: 'AppProblemCreateError';
  /** The error code. */
  code: AppProblemCreateErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field?: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message?: Maybe<Scalars['String']['output']>;
};

export type AppProblemCreateErrorCode =
  | 'GRAPHQL_ERROR'
  | 'INVALID'
  | 'NOT_FOUND'
  | 'REQUIRED';

export type AppProblemCreateInput = {
  /** Time window in minutes for aggregating problems with the same key. Defaults to 60. If 0, a new problem is always created. */
  aggregationPeriod?: InputMaybe<Scalars['Minute']['input']>;
  /** If set, the problem becomes critical when count reaches this value. If sent again with higher value than already counted, problem can be de-escalated. */
  criticalThreshold?: InputMaybe<Scalars['PositiveInt']['input']>;
  /** Key identifying the type of problem. App can add multiple problems under the same key, to merge them together or delete them in batch. Must be between 3 and 128 characters. */
  key: Scalars['String']['input'];
  /** The problem message to display. Must be at least 3 characters. Messages longer than 2048 characters will be truncated to 2048 characters with '...' suffix. */
  message: Scalars['String']['input'];
};

/**
 * Dismiss problems for an app.
 *
 * Added in Saleor 3.22.
 *
 * Requires one of the following permissions: MANAGE_APPS, AUTHENTICATED_APP.
 */
export type AppProblemDismiss = {
  __typename?: 'AppProblemDismiss';
  errors: Array<AppProblemDismissError>;
};

/** Input for app callers to dismiss their own problems. */
export type AppProblemDismissByAppInput = {
  /** List of problem IDs to dismiss. Cannot be combined with keys. Max 100. */
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** List of problem keys to dismiss. Cannot be combined with ids. Max 100. */
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Input for staff callers to dismiss problems by IDs. */
export type AppProblemDismissByStaffWithIdsInput = {
  /** List of problem IDs to dismiss. Max 100. */
  ids: Array<Scalars['ID']['input']>;
};

/** Input for staff callers to dismiss problems by keys. */
export type AppProblemDismissByStaffWithKeysInput = {
  /** ID of the app whose problems to dismiss. */
  app: Scalars['ID']['input'];
  /** List of problem keys to dismiss. Max 100. */
  keys: Array<Scalars['String']['input']>;
};

export type AppProblemDismissError = {
  __typename?: 'AppProblemDismissError';
  /** The error code. */
  code: AppProblemDismissErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field?: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message?: Maybe<Scalars['String']['output']>;
};

export type AppProblemDismissErrorCode =
  | 'GRAPHQL_ERROR'
  | 'INVALID'
  | 'NOT_FOUND'
  | 'OUT_OF_SCOPE_APP'
  | 'REQUIRED';

/** Input for dismissing app problems. Only one can be specified. */
export type AppProblemDismissInput = {
  /** For app callers only - dismiss own problems. */
  byApp?: InputMaybe<AppProblemDismissByAppInput>;
  /** For staff callers - dismiss problems by IDs. */
  byStaffWithIds?: InputMaybe<AppProblemDismissByStaffWithIdsInput>;
  /** For staff callers - dismiss problems by keys for specified app. */
  byStaffWithKeys?: InputMaybe<AppProblemDismissByStaffWithKeysInput>;
};

/**
 * Dismissal information for an app problem.
 *
 * Added in Saleor 3.22.
 */
export type AppProblemDismissed = {
  __typename?: 'AppProblemDismissed';
  /**
   * Whether the problem was dismissed by an App or a User.
   *
   * Added in Saleor 3.22.
   */
  by: AppProblemDismissedByEnum;
  /**
   * The user who dismissed this problem. Null if dismissed by an app or the user was deleted.
   *
   * Added in Saleor 3.22.
   *
   * Requires one of the following permissions: MANAGE_STAFF.
   */
  user?: Maybe<User>;
  /**
   * Email of the user who dismissed this problem. Preserved even if the user is deleted.
   *
   * Added in Saleor 3.22.
   *
   * Requires one of the following permissions: AUTHENTICATED_STAFF_USER.
   */
  userEmail?: Maybe<Scalars['String']['output']>;
};

export type AppProblemDismissedByEnum =
  | 'APP'
  | 'USER';

/**
 * Re-enable sync webhooks for provided app. Can be used to manually re-enable sync webhooks for the app before the cooldown period ends.
 *
 * Added in Saleor 3.21.
 *
 * Requires one of the following permissions: MANAGE_APPS.
 */
export type AppReenableSyncWebhooks = {
  __typename?: 'AppReenableSyncWebhooks';
  /** App for which sync webhooks were re-enabled. */
  app?: Maybe<App>;
  /** @deprecated Use `errors` field instead. */
  appErrors: Array<AppError>;
  errors: Array<AppError>;
};

/**
 * Retry failed installation of new app.
 *
 * Requires one of the following permissions: MANAGE_APPS.
 *
 * Triggers the following webhook events:
 * - APP_INSTALLED (async): An app was installed.
 */
export type AppRetryInstall = {
  __typename?: 'AppRetryInstall';
  /** @deprecated Use `errors` field instead. */
  appErrors: Array<AppError>;
  appInstallation?: Maybe<AppInstallation>;
  errors: Array<AppError>;
};

export type AppSortField =
  /** Sort apps by creation date. */
  | 'CREATION_DATE'
  /** Sort apps by name. */
  | 'NAME';

export type AppSortingInput = {
  /** Specifies the direction in which to sort apps. */
  direction: OrderDirection;
  /** Sort apps by the selected field. */
  field: AppSortField;
};

/** Event sent when app status has changed. */
export type AppStatusChanged = Event & {
  __typename?: 'AppStatusChanged';
  /** The application the event relates to. */
  app?: Maybe<App>;
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<IssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient?: Maybe<App>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

/** Represents token data. */
export type AppToken = Node & {
  __typename?: 'AppToken';
  /** Last 4 characters of the token. */
  authToken?: Maybe<Scalars['String']['output']>;
  /** The ID of the app token. */
  id: Scalars['ID']['output'];
  /** Name of the authenticated token. */
  name?: Maybe<Scalars['String']['output']>;
};

/**
 * Creates a new token.
 *
 * Requires one of the following permissions: MANAGE_APPS.
 */
export type AppTokenCreate = {
  __typename?: 'AppTokenCreate';
  /** @deprecated Use `errors` field instead. */
  appErrors: Array<AppError>;
  appToken?: Maybe<AppToken>;
  /** The newly created authentication token. */
  authToken?: Maybe<Scalars['String']['output']>;
  errors: Array<AppError>;
};

/**
 * Deletes an authentication token assigned to app.
 *
 * Requires one of the following permissions: MANAGE_APPS.
 */
export type AppTokenDelete = {
  __typename?: 'AppTokenDelete';
  /** @deprecated Use `errors` field instead. */
  appErrors: Array<AppError>;
  appToken?: Maybe<AppToken>;
  errors: Array<AppError>;
};

export type AppTokenInput = {
  /** ID of app. */
  app: Scalars['ID']['input'];
  /** Name of the token. */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Verify provided app token. */
export type AppTokenVerify = {
  __typename?: 'AppTokenVerify';
  /** @deprecated Use `errors` field instead. */
  appErrors: Array<AppError>;
  errors: Array<AppError>;
  /** Determine if token is valid or not. */
  valid: Scalars['Boolean']['output'];
};

/** Enum determining type of your App. */
export type AppTypeEnum =
  /** Local Saleor App. The app is fully manageable from dashboard. You can change assigned permissions, add webhooks, or authentication token */
  | 'LOCAL'
  /** Third party external App. Installation is fully automated. Saleor uses a defined App manifest to gather all required information. */
  | 'THIRDPARTY';

/**
 * Updates an existing app.
 *
 * Requires one of the following permissions: MANAGE_APPS.
 *
 * Triggers the following webhook events:
 * - APP_UPDATED (async): An app was updated.
 */
export type AppUpdate = {
  __typename?: 'AppUpdate';
  app?: Maybe<App>;
  /** @deprecated Use `errors` field instead. */
  appErrors: Array<AppError>;
  errors: Array<AppError>;
};

/** Event sent when app is updated. */
export type AppUpdated = Event & {
  __typename?: 'AppUpdated';
  /** The application the event relates to. */
  app?: Maybe<App>;
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<IssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient?: Maybe<App>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

export type AreaUnitsEnum =
  | 'SQ_CM'
  | 'SQ_DM'
  | 'SQ_FT'
  | 'SQ_INCH'
  | 'SQ_KM'
  | 'SQ_M'
  | 'SQ_MM'
  | 'SQ_YD';

/**
 * Assigns storefront's navigation menus.
 *
 * Requires one of the following permissions: MANAGE_MENUS, MANAGE_SETTINGS.
 */
export type AssignNavigation = {
  __typename?: 'AssignNavigation';
  errors: Array<MenuError>;
  /** Assigned navigation menu. */
  menu?: Maybe<Menu>;
  /** @deprecated Use `errors` field instead. */
  menuErrors: Array<MenuError>;
};

/**
 * Represents an attribute assigned to an object.
 *
 * Added in Saleor 3.22.
 */
export type AssignedAttribute = {
  /** Attribute assigned to an object. */
  attribute: Attribute;
};

export type AssignedAttributeReferenceInput = {
  /** Returns objects with a reference pointing to a category identified by the given slug. */
  categorySlugs?: InputMaybe<ContainsFilterInput>;
  /** Returns objects with a reference pointing to a collection identified by the given slug. */
  collectionSlugs?: InputMaybe<ContainsFilterInput>;
  /** Returns objects with a reference pointing to a page identified by the given slug. */
  pageSlugs?: InputMaybe<ContainsFilterInput>;
  /** Returns objects with a reference pointing to a product identified by the given slug. */
  productSlugs?: InputMaybe<ContainsFilterInput>;
  /** Returns objects with a reference pointing to a product variant identified by the given sku. */
  productVariantSkus?: InputMaybe<ContainsFilterInput>;
  /** Returns objects with a reference pointing to an object identified by the given ID. */
  referencedIds?: InputMaybe<ContainsFilterInput>;
};

export type AssignedAttributeValueInput = {
  /** Filter by boolean value for attributes of boolean type. */
  boolean?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by date value for attributes of date type. */
  date?: InputMaybe<DateRangeInput>;
  /** Filter by date time value for attributes of date time type. */
  dateTime?: InputMaybe<DateTimeRangeInput>;
  /** Filter by name assigned to AttributeValue. */
  name?: InputMaybe<StringFilterInput>;
  /** Filter by numeric value for attributes of numeric type. */
  numeric?: InputMaybe<DecimalFilterInput>;
  /** Filter by reference attribute value. */
  reference?: InputMaybe<AssignedAttributeReferenceInput>;
  /** Filter by slug assigned to AttributeValue. */
  slug?: InputMaybe<StringFilterInput>;
};

export type AssignedAttributeWhereInput = {
  /** Filter by attribute slug. */
  slug?: InputMaybe<Scalars['String']['input']>;
  /** Filter by value of the attribute. Only one value input field is allowed. If provided more than one, the error will be raised. */
  value?: InputMaybe<AssignedAttributeValueInput>;
};

/**
 * Represents a boolean attribute.
 *
 * Added in Saleor 3.22.
 */
export type AssignedBooleanAttribute = AssignedAttribute & {
  __typename?: 'AssignedBooleanAttribute';
  /** Attribute assigned to an object. */
  attribute: Attribute;
  /** The assigned boolean value. */
  value?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * Represents a single choice value of the attribute.
 *
 * Added in Saleor 3.22.
 */
export type AssignedChoiceAttributeValue = {
  __typename?: 'AssignedChoiceAttributeValue';
  /** Name of a value displayed in the interface. */
  name?: Maybe<Scalars['String']['output']>;
  /** Internal representation of a value (unique per attribute). */
  slug?: Maybe<Scalars['String']['output']>;
  /** Translation of the name. */
  translation?: Maybe<Scalars['String']['output']>;
};


/**
 * Represents a single choice value of the attribute.
 *
 * Added in Saleor 3.22.
 */
export type AssignedChoiceAttributeValueTranslationArgs = {
  languageCode: LanguageCodeEnum;
};

/**
 * Represents a date attribute.
 *
 * Added in Saleor 3.22.
 */
export type AssignedDateAttribute = AssignedAttribute & {
  __typename?: 'AssignedDateAttribute';
  /** Attribute assigned to an object. */
  attribute: Attribute;
  /** The assigned date value. */
  value?: Maybe<Scalars['Date']['output']>;
};

/**
 * Represents a date time attribute.
 *
 * Added in Saleor 3.22.
 */
export type AssignedDateTimeAttribute = AssignedAttribute & {
  __typename?: 'AssignedDateTimeAttribute';
  /** Attribute assigned to an object. */
  attribute: Attribute;
  /** The assigned date time value. */
  value?: Maybe<Scalars['DateTime']['output']>;
};

/**
 * Represents file attribute.
 *
 * Added in Saleor 3.22.
 */
export type AssignedFileAttribute = AssignedAttribute & {
  __typename?: 'AssignedFileAttribute';
  /** Attribute assigned to an object. */
  attribute: Attribute;
  /** The assigned file. */
  value?: Maybe<File>;
};

/**
 * Represents multi category reference attribute.
 *
 * Added in Saleor 3.22.
 */
export type AssignedMultiCategoryReferenceAttribute = AssignedAttribute & {
  __typename?: 'AssignedMultiCategoryReferenceAttribute';
  /** Attribute assigned to an object. */
  attribute: Attribute;
  /** List of assigned category references. */
  value: Array<Category>;
};


/**
 * Represents multi category reference attribute.
 *
 * Added in Saleor 3.22.
 */
export type AssignedMultiCategoryReferenceAttributeValueArgs = {
  limit?: InputMaybe<Scalars['PositiveInt']['input']>;
};

/**
 * Represents a multi choice attribute.
 *
 * Added in Saleor 3.22.
 */
export type AssignedMultiChoiceAttribute = AssignedAttribute & {
  __typename?: 'AssignedMultiChoiceAttribute';
  /** Attribute assigned to an object. */
  attribute: Attribute;
  /** List of assigned choice values. */
  value: Array<AssignedChoiceAttributeValue>;
};


/**
 * Represents a multi choice attribute.
 *
 * Added in Saleor 3.22.
 */
export type AssignedMultiChoiceAttributeValueArgs = {
  limit?: InputMaybe<Scalars['PositiveInt']['input']>;
};

/**
 * Represents multi collection reference attribute.
 *
 * Added in Saleor 3.22.
 */
export type AssignedMultiCollectionReferenceAttribute = AssignedAttribute & {
  __typename?: 'AssignedMultiCollectionReferenceAttribute';
  /** Attribute assigned to an object. */
  attribute: Attribute;
  /** List of assigned collection references. */
  value: Array<Collection>;
};


/**
 * Represents multi collection reference attribute.
 *
 * Added in Saleor 3.22.
 */
export type AssignedMultiCollectionReferenceAttributeValueArgs = {
  limit?: InputMaybe<Scalars['PositiveInt']['input']>;
};

/**
 * Represents multi page reference attribute.
 *
 * Added in Saleor 3.22.
 */
export type AssignedMultiPageReferenceAttribute = AssignedAttribute & {
  __typename?: 'AssignedMultiPageReferenceAttribute';
  /** Attribute assigned to an object. */
  attribute: Attribute;
  /** List of assigned page references. */
  value: Array<Page>;
};


/**
 * Represents multi page reference attribute.
 *
 * Added in Saleor 3.22.
 */
export type AssignedMultiPageReferenceAttributeValueArgs = {
  limit?: InputMaybe<Scalars['PositiveInt']['input']>;
};

/**
 * Represents multi product reference attribute.
 *
 * Added in Saleor 3.22.
 */
export type AssignedMultiProductReferenceAttribute = AssignedAttribute & {
  __typename?: 'AssignedMultiProductReferenceAttribute';
  /** Attribute assigned to an object. */
  attribute: Attribute;
  /** List of assigned product references. */
  value: Array<Product>;
};


/**
 * Represents multi product reference attribute.
 *
 * Added in Saleor 3.22.
 */
export type AssignedMultiProductReferenceAttributeValueArgs = {
  limit?: InputMaybe<Scalars['PositiveInt']['input']>;
};

/**
 * Represents multi product variant reference attribute.
 *
 * Added in Saleor 3.22.
 */
export type AssignedMultiProductVariantReferenceAttribute = AssignedAttribute & {
  __typename?: 'AssignedMultiProductVariantReferenceAttribute';
  /** Attribute assigned to an object. */
  attribute: Attribute;
  /** List of assigned product variant references. */
  value: Array<ProductVariant>;
};


/**
 * Represents multi product variant reference attribute.
 *
 * Added in Saleor 3.22.
 */
export type AssignedMultiProductVariantReferenceAttributeValueArgs = {
  limit?: InputMaybe<Scalars['PositiveInt']['input']>;
};

/**
 * Represents a numeric value of an attribute.
 *
 * Added in Saleor 3.22.
 */
export type AssignedNumericAttribute = AssignedAttribute & {
  __typename?: 'AssignedNumericAttribute';
  /** Attribute assigned to an object. */
  attribute: Attribute;
  /** The assigned numeric value. */
  value?: Maybe<Scalars['Float']['output']>;
};

/**
 * Represents plain text attribute.
 *
 * Added in Saleor 3.22.
 */
export type AssignedPlainTextAttribute = AssignedAttribute & {
  __typename?: 'AssignedPlainTextAttribute';
  /** Attribute assigned to an object. */
  attribute: Attribute;
  /** Translation of the plain text content in the specified language. */
  translation?: Maybe<Scalars['String']['output']>;
  /** The assigned plain text content. */
  value?: Maybe<Scalars['String']['output']>;
};


/**
 * Represents plain text attribute.
 *
 * Added in Saleor 3.22.
 */
export type AssignedPlainTextAttributeTranslationArgs = {
  languageCode: LanguageCodeEnum;
};

/**
 * Represents single category reference attribute.
 *
 * Added in Saleor 3.22.
 */
export type AssignedSingleCategoryReferenceAttribute = AssignedAttribute & {
  __typename?: 'AssignedSingleCategoryReferenceAttribute';
  /** Attribute assigned to an object. */
  attribute: Attribute;
  /** The assigned category reference. */
  value?: Maybe<Category>;
};

/**
 * Represents a single choice attribute.
 *
 * Added in Saleor 3.22.
 */
export type AssignedSingleChoiceAttribute = AssignedAttribute & {
  __typename?: 'AssignedSingleChoiceAttribute';
  /** Attribute assigned to an object. */
  attribute: Attribute;
  /** The assigned choice value. */
  value?: Maybe<AssignedChoiceAttributeValue>;
};

/**
 * Represents single collection reference attribute.
 *
 * Added in Saleor 3.22.
 */
export type AssignedSingleCollectionReferenceAttribute = AssignedAttribute & {
  __typename?: 'AssignedSingleCollectionReferenceAttribute';
  /** Attribute assigned to an object. */
  attribute: Attribute;
  /** The assigned collection reference. */
  value?: Maybe<Collection>;
};

/**
 * Represents single page reference attribute.
 *
 * Added in Saleor 3.22.
 */
export type AssignedSinglePageReferenceAttribute = AssignedAttribute & {
  __typename?: 'AssignedSinglePageReferenceAttribute';
  /** Attribute assigned to an object. */
  attribute: Attribute;
  /** The assigned page reference. */
  value?: Maybe<Page>;
};

/**
 * Represents single product reference attribute.
 *
 * Added in Saleor 3.22.
 */
export type AssignedSingleProductReferenceAttribute = AssignedAttribute & {
  __typename?: 'AssignedSingleProductReferenceAttribute';
  /** Attribute assigned to an object. */
  attribute: Attribute;
  /** The assigned product reference. */
  value?: Maybe<Product>;
};

/**
 * Represents single product variant reference attribute.
 *
 * Added in Saleor 3.22.
 */
export type AssignedSingleProductVariantReferenceAttribute = AssignedAttribute & {
  __typename?: 'AssignedSingleProductVariantReferenceAttribute';
  /** Attribute assigned to an object. */
  attribute: Attribute;
  /** The assigned product variant reference. */
  value?: Maybe<ProductVariant>;
};

/**
 * Represents a swatch attribute.
 *
 * Added in Saleor 3.22.
 */
export type AssignedSwatchAttribute = AssignedAttribute & {
  __typename?: 'AssignedSwatchAttribute';
  /** Attribute assigned to an object. */
  attribute: Attribute;
  /** The assigned swatch value. */
  value?: Maybe<AssignedSwatchAttributeValue>;
};

/**
 * Represents a single swatch value.
 *
 * Added in Saleor 3.22.
 */
export type AssignedSwatchAttributeValue = {
  __typename?: 'AssignedSwatchAttributeValue';
  /** File associated with the attribute. */
  file?: Maybe<File>;
  /** Hex color code. */
  hexColor?: Maybe<Scalars['String']['output']>;
  /** Name of the selected swatch value.  */
  name?: Maybe<Scalars['String']['output']>;
  /** Slug of the selected swatch value. */
  slug?: Maybe<Scalars['String']['output']>;
};

/**
 * Represents text attribute.
 *
 * Added in Saleor 3.22.
 */
export type AssignedTextAttribute = AssignedAttribute & {
  __typename?: 'AssignedTextAttribute';
  /** Attribute assigned to an object. */
  attribute: Attribute;
  /** Translation of the rich text content in the specified language. */
  translation?: Maybe<Scalars['JSON']['output']>;
  /** The assigned rich text content. */
  value?: Maybe<Scalars['JSON']['output']>;
};


/**
 * Represents text attribute.
 *
 * Added in Saleor 3.22.
 */
export type AssignedTextAttributeTranslationArgs = {
  languageCode: LanguageCodeEnum;
};

/** Represents assigned attribute to variant with variant selection attached. */
export type AssignedVariantAttribute = {
  __typename?: 'AssignedVariantAttribute';
  /** Attribute assigned to variant. */
  attribute: Attribute;
  /** Determines, whether assigned attribute is allowed for variant selection. Supported variant types for variant selection are: ['dropdown', 'boolean', 'swatch', 'numeric'] */
  variantSelection: Scalars['Boolean']['output'];
};

/** Custom attribute of a product. Attributes can be assigned to products and variants at the product type level. */
export type Attribute = Node & ObjectWithMetadata & {
  __typename?: 'Attribute';
  /**
   * Whether the attribute can be displayed in the admin product list. Requires one of the following permissions: MANAGE_PAGES, MANAGE_PAGE_TYPES_AND_ATTRIBUTES, MANAGE_PRODUCTS, MANAGE_PRODUCT_TYPES_AND_ATTRIBUTES.
   * @deprecated No longer supported
   */
  availableInGrid: Scalars['Boolean']['output'];
  /** A list of predefined attribute choices available for selection. Available only for attributes with predefined choices. */
  choices?: Maybe<AttributeValueCountableConnection>;
  /** The entity type which can be used as a reference. */
  entityType?: Maybe<AttributeEntityTypeEnum>;
  /** External ID of this attribute. */
  externalReference?: Maybe<Scalars['String']['output']>;
  /** Whether the attribute can be filtered in dashboard. Requires one of the following permissions: MANAGE_PAGES, MANAGE_PAGE_TYPES_AND_ATTRIBUTES, MANAGE_PRODUCTS, MANAGE_PRODUCT_TYPES_AND_ATTRIBUTES. */
  filterableInDashboard: Scalars['Boolean']['output'];
  /**
   * Whether the attribute can be filtered in storefront. Requires one of the following permissions: MANAGE_PAGES, MANAGE_PAGE_TYPES_AND_ATTRIBUTES, MANAGE_PRODUCTS, MANAGE_PRODUCT_TYPES_AND_ATTRIBUTES.
   * @deprecated No longer supported
   */
  filterableInStorefront: Scalars['Boolean']['output'];
  /** The ID of the attribute. */
  id: Scalars['ID']['output'];
  /** The input type to use for entering attribute values in the dashboard. */
  inputType?: Maybe<AttributeInputTypeEnum>;
  /** List of public metadata items. Can be accessed without permissions. */
  metadata: Array<MetadataItem>;
  /**
   * A single key from public metadata.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   */
  metafield?: Maybe<Scalars['String']['output']>;
  /** Public metadata. Use `keys` to control which fields you want to include. The default is to include everything. */
  metafields?: Maybe<Scalars['Metadata']['output']>;
  /** Name of an attribute displayed in the interface. */
  name?: Maybe<Scalars['String']['output']>;
  /** List of private metadata items. Requires staff permissions to access. */
  privateMetadata: Array<MetadataItem>;
  /**
   * A single key from private metadata. Requires staff permissions to access.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   */
  privateMetafield?: Maybe<Scalars['String']['output']>;
  /** Private metadata. Requires staff permissions to access. Use `keys` to control which fields you want to include. The default is to include everything. */
  privateMetafields?: Maybe<Scalars['Metadata']['output']>;
  /** A list of product types that use this attribute as a product attribute. */
  productTypes: ProductTypeCountableConnection;
  /** A list of product types that use this attribute as a product variant attribute. */
  productVariantTypes: ProductTypeCountableConnection;
  /**
   * The reference types (product or page type) that are used to narrow down the choices of reference objects.
   *
   * Added in Saleor 3.22.
   */
  referenceTypes?: Maybe<Array<ReferenceType>>;
  /** Internal representation of an attribute name. */
  slug?: Maybe<Scalars['String']['output']>;
  /**
   * The position of the attribute in the storefront navigation (0 by default). Requires one of the following permissions: MANAGE_PAGES, MANAGE_PAGE_TYPES_AND_ATTRIBUTES, MANAGE_PRODUCTS, MANAGE_PRODUCT_TYPES_AND_ATTRIBUTES.
   * @deprecated No longer supported
   */
  storefrontSearchPosition: Scalars['Int']['output'];
  /** Returns translated attribute fields for the given language code. */
  translation?: Maybe<AttributeTranslation>;
  /** The attribute type. */
  type?: Maybe<AttributeTypeEnum>;
  /** The unit of attribute values. */
  unit?: Maybe<MeasurementUnitsEnum>;
  /** Whether the attribute requires values to be passed or not. Requires one of the following permissions: MANAGE_PAGES, MANAGE_PAGE_TYPES_AND_ATTRIBUTES, MANAGE_PRODUCTS, MANAGE_PRODUCT_TYPES_AND_ATTRIBUTES. */
  valueRequired: Scalars['Boolean']['output'];
  /** Whether the attribute should be visible or not in storefront. Requires one of the following permissions: MANAGE_PAGES, MANAGE_PAGE_TYPES_AND_ATTRIBUTES, MANAGE_PRODUCTS, MANAGE_PRODUCT_TYPES_AND_ATTRIBUTES. */
  visibleInStorefront: Scalars['Boolean']['output'];
  /** Flag indicating that attribute has predefined choices. */
  withChoices: Scalars['Boolean']['output'];
};


/** Custom attribute of a product. Attributes can be assigned to products and variants at the product type level. */
export type AttributeChoicesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<AttributeValueFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<AttributeChoicesSortingInput>;
  where?: InputMaybe<AttributeValueWhereInput>;
};


/** Custom attribute of a product. Attributes can be assigned to products and variants at the product type level. */
export type AttributeMetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Custom attribute of a product. Attributes can be assigned to products and variants at the product type level. */
export type AttributeMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Custom attribute of a product. Attributes can be assigned to products and variants at the product type level. */
export type AttributePrivateMetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Custom attribute of a product. Attributes can be assigned to products and variants at the product type level. */
export type AttributePrivateMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Custom attribute of a product. Attributes can be assigned to products and variants at the product type level. */
export type AttributeProductTypesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Custom attribute of a product. Attributes can be assigned to products and variants at the product type level. */
export type AttributeProductVariantTypesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Custom attribute of a product. Attributes can be assigned to products and variants at the product type level. */
export type AttributeReferenceTypesArgs = {
  limit?: InputMaybe<Scalars['PositiveInt']['input']>;
};


/** Custom attribute of a product. Attributes can be assigned to products and variants at the product type level. */
export type AttributeTranslationArgs = {
  languageCode: LanguageCodeEnum;
};

/**
 * Creates attributes.
 *
 * Triggers the following webhook events:
 * - ATTRIBUTE_CREATED (async): An attribute was created.
 */
export type AttributeBulkCreate = {
  __typename?: 'AttributeBulkCreate';
  /** Returns how many objects were created. */
  count: Scalars['Int']['output'];
  errors: Array<AttributeBulkCreateError>;
  /** List of the created attributes. */
  results: Array<AttributeBulkCreateResult>;
};

export type AttributeBulkCreateError = {
  __typename?: 'AttributeBulkCreateError';
  /** The error code. */
  code: AttributeBulkCreateErrorCode;
  /** The error message. */
  message?: Maybe<Scalars['String']['output']>;
  /** Path to field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  path?: Maybe<Scalars['String']['output']>;
};

export type AttributeBulkCreateErrorCode =
  | 'ALREADY_EXISTS'
  | 'BLANK'
  | 'DUPLICATED_INPUT_ITEM'
  | 'GRAPHQL_ERROR'
  | 'INVALID'
  | 'MAX_LENGTH'
  | 'NOT_FOUND'
  | 'REQUIRED'
  | 'UNIQUE';

export type AttributeBulkCreateResult = {
  __typename?: 'AttributeBulkCreateResult';
  /** Attribute data. */
  attribute?: Maybe<Attribute>;
  /** List of errors occurred on create attempt. */
  errors?: Maybe<Array<AttributeBulkCreateError>>;
};

/**
 * Deletes attributes.
 *
 * Requires one of the following permissions: MANAGE_PAGE_TYPES_AND_ATTRIBUTES.
 *
 * Triggers the following webhook events:
 * - ATTRIBUTE_DELETED (async): An attribute was deleted.
 */
export type AttributeBulkDelete = {
  __typename?: 'AttributeBulkDelete';
  /** @deprecated Use `errors` field instead. */
  attributeErrors: Array<AttributeError>;
  /** Returns how many objects were affected. */
  count: Scalars['Int']['output'];
  errors: Array<AttributeError>;
};

/**
 * Creates/updates translations for attributes.
 *
 * Requires one of the following permissions: MANAGE_TRANSLATIONS.
 */
export type AttributeBulkTranslate = {
  __typename?: 'AttributeBulkTranslate';
  /** Returns how many translations were created/updated. */
  count: Scalars['Int']['output'];
  errors: Array<AttributeBulkTranslateError>;
  /** List of the translations. */
  results: Array<AttributeBulkTranslateResult>;
};

export type AttributeBulkTranslateError = {
  __typename?: 'AttributeBulkTranslateError';
  /** The error code. */
  code: AttributeTranslateErrorCode;
  /** The error message. */
  message?: Maybe<Scalars['String']['output']>;
  /** Path to field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  path?: Maybe<Scalars['String']['output']>;
};

export type AttributeBulkTranslateInput = {
  /** External reference of an attribute. */
  externalReference?: InputMaybe<Scalars['String']['input']>;
  /** Attribute ID. */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Translation language code. */
  languageCode: LanguageCodeEnum;
  /** Translation fields. */
  translationFields: NameTranslationInput;
};

export type AttributeBulkTranslateResult = {
  __typename?: 'AttributeBulkTranslateResult';
  /** List of errors occurred on translation attempt. */
  errors?: Maybe<Array<AttributeBulkTranslateError>>;
  /** Attribute translation data. */
  translation?: Maybe<AttributeTranslation>;
};

/**
 * Updates attributes.
 *
 * Triggers the following webhook events:
 * - ATTRIBUTE_UPDATED (async): An attribute was updated. Optionally called when new attribute value was created or deleted.
 * - ATTRIBUTE_VALUE_CREATED (async): Called optionally when an attribute value was created.
 * - ATTRIBUTE_VALUE_DELETED (async): Called optionally when an attribute value was deleted.
 */
export type AttributeBulkUpdate = {
  __typename?: 'AttributeBulkUpdate';
  /** Returns how many objects were updated. */
  count: Scalars['Int']['output'];
  errors: Array<AttributeBulkUpdateError>;
  /** List of the updated attributes. */
  results: Array<AttributeBulkUpdateResult>;
};

export type AttributeBulkUpdateError = {
  __typename?: 'AttributeBulkUpdateError';
  /** The error code. */
  code: AttributeBulkUpdateErrorCode;
  /** The error message. */
  message?: Maybe<Scalars['String']['output']>;
  /** Path to field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  path?: Maybe<Scalars['String']['output']>;
};

export type AttributeBulkUpdateErrorCode =
  | 'ALREADY_EXISTS'
  | 'BLANK'
  | 'DUPLICATED_INPUT_ITEM'
  | 'GRAPHQL_ERROR'
  | 'INVALID'
  | 'MAX_LENGTH'
  | 'NOT_FOUND'
  | 'REQUIRED'
  | 'UNIQUE';

export type AttributeBulkUpdateInput = {
  /** External ID of this attribute. */
  externalReference?: InputMaybe<Scalars['String']['input']>;
  /** Fields to update. */
  fields: AttributeUpdateInput;
  /** ID of an attribute to update. */
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type AttributeBulkUpdateResult = {
  __typename?: 'AttributeBulkUpdateResult';
  /** Attribute data. */
  attribute?: Maybe<Attribute>;
  /** List of errors occurred on update attempt. */
  errors?: Maybe<Array<AttributeBulkUpdateError>>;
};

export type AttributeChoicesSortField =
  /** Sort attribute choice by name. */
  | 'NAME'
  /** Sort attribute choice by slug. */
  | 'SLUG';

export type AttributeChoicesSortingInput = {
  /** Specifies the direction in which to sort attribute choices. */
  direction: OrderDirection;
  /** Sort attribute choices by the selected field. */
  field: AttributeChoicesSortField;
};

export type AttributeCountableConnection = {
  __typename?: 'AttributeCountableConnection';
  edges: Array<AttributeCountableEdge>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** A total count of items in the collection. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type AttributeCountableEdge = {
  __typename?: 'AttributeCountableEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Attribute;
};

/**
 * Creates an attribute.
 *
 * Triggers the following webhook events:
 * - ATTRIBUTE_CREATED (async): An attribute was created.
 */
export type AttributeCreate = {
  __typename?: 'AttributeCreate';
  /** The created attribute. */
  attribute?: Maybe<Attribute>;
  /** @deprecated Use `errors` field instead. */
  attributeErrors: Array<AttributeError>;
  errors: Array<AttributeError>;
};

/**
 * Represents an input for create of attribute.
 *
 * NOTE: Deprecated fields `filterableInStorefront`, `storefrontSearchPosition` and `availableInGrid` are not supported in bulk mutations: `attributeBulkCreate`, `attributeBulkUpdate`.
 */
export type AttributeCreateInput = {
  /**
   * Whether the attribute can be displayed in the admin product list.
   *
   * DEPRECATED: this field will be removed.
   */
  availableInGrid?: InputMaybe<Scalars['Boolean']['input']>;
  /** The entity type which can be used as a reference. */
  entityType?: InputMaybe<AttributeEntityTypeEnum>;
  /** External ID of this attribute. */
  externalReference?: InputMaybe<Scalars['String']['input']>;
  /** Whether the attribute can be filtered in dashboard. */
  filterableInDashboard?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Whether the attribute can be filtered in storefront.
   *
   * DEPRECATED: this field will be removed.
   */
  filterableInStorefront?: InputMaybe<Scalars['Boolean']['input']>;
  /** The input type to use for entering attribute values in the dashboard. */
  inputType?: InputMaybe<AttributeInputTypeEnum>;
  /** Whether the attribute is for variants only. */
  isVariantOnly?: InputMaybe<Scalars['Boolean']['input']>;
  /** Name of an attribute displayed in the interface. */
  name: Scalars['String']['input'];
  /**
   * Specifies reference types to narrow down the choices of reference objects. Applicable only for `REFERENCE` and `SINGLE_REFERENCE` attributes with `PRODUCT`, `PRODUCT_VARIANT` and `PAGE` entity types. Accepts `ProductType` IDs for `PRODUCT` and `PRODUCT_VARIANT` entity types, and `PageType` IDs for `PAGE` entity type. If omitted, all objects of the selected entity type are available as attribute values.
   *
   * A maximum of 100 reference types can be specified.
   *
   * Added in Saleor 3.22.
   */
  referenceTypes?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Internal representation of an attribute name. */
  slug?: InputMaybe<Scalars['String']['input']>;
  /**
   * The position of the attribute in the storefront navigation (0 by default).
   *
   * DEPRECATED: this field will be removed.
   */
  storefrontSearchPosition?: InputMaybe<Scalars['Int']['input']>;
  /** The attribute type. */
  type: AttributeTypeEnum;
  /** The unit of attribute values. */
  unit?: InputMaybe<MeasurementUnitsEnum>;
  /** Whether the attribute requires values to be passed or not. */
  valueRequired?: InputMaybe<Scalars['Boolean']['input']>;
  /** List of attribute's values. */
  values?: InputMaybe<Array<AttributeValueCreateInput>>;
  /** Whether the attribute should be visible or not in storefront. */
  visibleInStorefront?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Event sent when new attribute is created. */
export type AttributeCreated = Event & {
  __typename?: 'AttributeCreated';
  /** The attribute the event relates to. */
  attribute?: Maybe<Attribute>;
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<IssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient?: Maybe<App>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

/**
 * Deletes an attribute.
 *
 * Requires one of the following permissions: MANAGE_PRODUCT_TYPES_AND_ATTRIBUTES.
 *
 * Triggers the following webhook events:
 * - ATTRIBUTE_DELETED (async): An attribute was deleted.
 */
export type AttributeDelete = {
  __typename?: 'AttributeDelete';
  attribute?: Maybe<Attribute>;
  /** @deprecated Use `errors` field instead. */
  attributeErrors: Array<AttributeError>;
  errors: Array<AttributeError>;
};

/** Event sent when attribute is deleted. */
export type AttributeDeleted = Event & {
  __typename?: 'AttributeDeleted';
  /** The attribute the event relates to. */
  attribute?: Maybe<Attribute>;
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<IssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient?: Maybe<App>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

export type AttributeEntityTypeEnum =
  | 'CATEGORY'
  | 'COLLECTION'
  | 'PAGE'
  | 'PRODUCT'
  | 'PRODUCT_VARIANT';

export type AttributeEntityTypeEnumFilterInput = {
  /** The value equal to. */
  eq?: InputMaybe<AttributeEntityTypeEnum>;
  /** The value included in. */
  oneOf?: InputMaybe<Array<AttributeEntityTypeEnum>>;
};

export type AttributeError = {
  __typename?: 'AttributeError';
  /** The error code. */
  code: AttributeErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field?: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message?: Maybe<Scalars['String']['output']>;
};

export type AttributeErrorCode =
  | 'ALREADY_EXISTS'
  | 'GRAPHQL_ERROR'
  | 'INVALID'
  | 'NOT_FOUND'
  | 'REQUIRED'
  | 'UNIQUE';

export type AttributeFilterInput = {
  availableInGrid?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Specifies the channel by which the data should be filtered.
   *
   * DEPRECATED: this field will be removed. Use root-level channel argument instead.
   */
  channel?: InputMaybe<Scalars['String']['input']>;
  filterableInDashboard?: InputMaybe<Scalars['Boolean']['input']>;
  filterableInStorefront?: InputMaybe<Scalars['Boolean']['input']>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  inCategory?: InputMaybe<Scalars['ID']['input']>;
  inCollection?: InputMaybe<Scalars['ID']['input']>;
  isVariantOnly?: InputMaybe<Scalars['Boolean']['input']>;
  metadata?: InputMaybe<Array<MetadataFilter>>;
  search?: InputMaybe<Scalars['String']['input']>;
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
  type?: InputMaybe<AttributeTypeEnum>;
  valueRequired?: InputMaybe<Scalars['Boolean']['input']>;
  visibleInStorefront?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AttributeInput = {
  /**
   * The boolean value of the attribute. Requires `slug` to be provided.
   *
   * DEPRECATED: this field will be removed. Use `value` instead.
   */
  boolean?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * The date range that the returned values should be in. In case of date/time attributes, the UTC midnight of the given date is used. Requires `slug` to be provided.
   *
   * DEPRECATED: this field will be removed. Use `value` instead.
   */
  date?: InputMaybe<DateRangeInput>;
  /**
   * The date/time range that the returned values should be in. Requires `slug` to be provided.
   *
   * DEPRECATED: this field will be removed. Use `value` instead.
   */
  dateTime?: InputMaybe<DateTimeRangeInput>;
  /** Internal representation of an attribute name. */
  slug?: InputMaybe<Scalars['String']['input']>;
  /** Filter by value of the attribute. Only one value input field is allowed. If provided more than one, the error will be raised. Cannot be combined with deprecated fields of `AttributeInput`.  */
  value?: InputMaybe<AssignedAttributeValueInput>;
  /**
   * Slugs identifying the attributeValues associated with the Attribute. When specified, it filters the results to include only records with one of the matching values. Requires `slug` to be provided.
   *
   * DEPRECATED: this field will be removed. Use `value` instead.
   */
  values?: InputMaybe<Array<Scalars['String']['input']>>;
  /**
   * The range that the returned values should be in. Requires `slug` to be provided.
   *
   * DEPRECATED: this field will be removed. Use `value` instead.
   */
  valuesRange?: InputMaybe<IntRangeInput>;
};

export type AttributeInputTypeEnum =
  | 'BOOLEAN'
  | 'DATE'
  | 'DATE_TIME'
  | 'DROPDOWN'
  | 'FILE'
  | 'MULTISELECT'
  | 'NUMERIC'
  | 'PLAIN_TEXT'
  | 'REFERENCE'
  | 'RICH_TEXT'
  | 'SINGLE_REFERENCE'
  | 'SWATCH';

export type AttributeInputTypeEnumFilterInput = {
  /** The value equal to. */
  eq?: InputMaybe<AttributeInputTypeEnum>;
  /** The value included in. */
  oneOf?: InputMaybe<Array<AttributeInputTypeEnum>>;
};

/**
 * Reorder the values of an attribute.
 *
 * Requires one of the following permissions: MANAGE_PRODUCT_TYPES_AND_ATTRIBUTES.
 *
 * Triggers the following webhook events:
 * - ATTRIBUTE_VALUE_UPDATED (async): An attribute value was updated.
 * - ATTRIBUTE_UPDATED (async): An attribute was updated.
 */
export type AttributeReorderValues = {
  __typename?: 'AttributeReorderValues';
  /** Attribute from which values are reordered. */
  attribute?: Maybe<Attribute>;
  /** @deprecated Use `errors` field instead. */
  attributeErrors: Array<AttributeError>;
  errors: Array<AttributeError>;
};

export type AttributeSortField =
  /** Sort attributes based on whether they can be displayed or not in a product grid. */
  | 'AVAILABLE_IN_GRID'
  /** Sort attributes by the filterable in dashboard flag */
  | 'FILTERABLE_IN_DASHBOARD'
  /** Sort attributes by the filterable in storefront flag */
  | 'FILTERABLE_IN_STOREFRONT'
  /** Sort attributes by the variant only flag */
  | 'IS_VARIANT_ONLY'
  /** Sort attributes by name */
  | 'NAME'
  /** Sort attributes by slug */
  | 'SLUG'
  /** Sort attributes by their position in storefront */
  | 'STOREFRONT_SEARCH_POSITION'
  /** Sort attributes by the value required flag */
  | 'VALUE_REQUIRED'
  /** Sort attributes by visibility in the storefront */
  | 'VISIBLE_IN_STOREFRONT';

export type AttributeSortingInput = {
  /** Specifies the direction in which to sort attributes. */
  direction: OrderDirection;
  /** Sort attributes by the selected field. */
  field: AttributeSortField;
};

/** Represents attribute's original translatable fields and related translations. */
export type AttributeTranslatableContent = Node & {
  __typename?: 'AttributeTranslatableContent';
  /**
   * Custom attribute of a product.
   * @deprecated Get model fields from the root level queries.
   */
  attribute?: Maybe<Attribute>;
  /** The ID of the attribute to translate. */
  attributeId: Scalars['ID']['output'];
  /** The ID of the attribute translatable content. */
  id: Scalars['ID']['output'];
  /** Name of the attribute to translate. */
  name: Scalars['String']['output'];
  /** Returns translated attribute fields for the given language code. */
  translation?: Maybe<AttributeTranslation>;
};


/** Represents attribute's original translatable fields and related translations. */
export type AttributeTranslatableContentTranslationArgs = {
  languageCode: LanguageCodeEnum;
};

/**
 * Creates/updates translations for an attribute.
 *
 * Requires one of the following permissions: MANAGE_TRANSLATIONS.
 */
export type AttributeTranslate = {
  __typename?: 'AttributeTranslate';
  attribute?: Maybe<Attribute>;
  errors: Array<TranslationError>;
  /** @deprecated Use `errors` field instead. */
  translationErrors: Array<TranslationError>;
};

export type AttributeTranslateErrorCode =
  | 'GRAPHQL_ERROR'
  | 'INVALID'
  | 'NOT_FOUND'
  | 'REQUIRED';

/** Represents attribute translations. */
export type AttributeTranslation = Node & {
  __typename?: 'AttributeTranslation';
  /** The ID of the attribute translation. */
  id: Scalars['ID']['output'];
  /** Translation language. */
  language: LanguageDisplay;
  /** Translated attribute name. */
  name: Scalars['String']['output'];
  /** Represents the attribute fields to translate. */
  translatableContent?: Maybe<AttributeTranslatableContent>;
};

export type AttributeTypeEnum =
  | 'PAGE_TYPE'
  | 'PRODUCT_TYPE';

export type AttributeTypeEnumFilterInput = {
  /** The value equal to. */
  eq?: InputMaybe<AttributeTypeEnum>;
  /** The value included in. */
  oneOf?: InputMaybe<Array<AttributeTypeEnum>>;
};

/**
 * Updates attribute.
 *
 * Requires one of the following permissions: MANAGE_PRODUCT_TYPES_AND_ATTRIBUTES.
 *
 * Triggers the following webhook events:
 * - ATTRIBUTE_UPDATED (async): An attribute was updated.
 */
export type AttributeUpdate = {
  __typename?: 'AttributeUpdate';
  /** The updated attribute. */
  attribute?: Maybe<Attribute>;
  /** @deprecated Use `errors` field instead. */
  attributeErrors: Array<AttributeError>;
  errors: Array<AttributeError>;
};

/**
 * Represents an input for update of attribute.
 *
 * NOTE: Deprecated fields `filterableInStorefront`, `storefrontSearchPosition` and `availableInGrid` are not supported in bulk mutations: `attributeBulkCreate`, `attributeBulkUpdate`.
 */
export type AttributeUpdateInput = {
  /** New values to be created for this attribute. */
  addValues?: InputMaybe<Array<AttributeValueUpdateInput>>;
  /**
   * Whether the attribute can be displayed in the admin product list.
   *
   * DEPRECATED: this field will be removed.
   */
  availableInGrid?: InputMaybe<Scalars['Boolean']['input']>;
  /** External ID of this product. */
  externalReference?: InputMaybe<Scalars['String']['input']>;
  /** Whether the attribute can be filtered in dashboard. */
  filterableInDashboard?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Whether the attribute can be filtered in storefront.
   *
   * DEPRECATED: this field will be removed.
   */
  filterableInStorefront?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the attribute is for variants only. */
  isVariantOnly?: InputMaybe<Scalars['Boolean']['input']>;
  /** Name of an attribute displayed in the interface. */
  name?: InputMaybe<Scalars['String']['input']>;
  /**
   * Specifies reference types to narrow down the choices of reference objects. Applicable only for `REFERENCE` and `SINGLE_REFERENCE` attributes with `PRODUCT`, `PRODUCT_VARIANT` and `PAGE` entity types. Accepts `ProductType` IDs for `PRODUCT` and `PRODUCT_VARIANT` entity types, and `PageType` IDs for `PAGE` entity type. If omitted, all objects of the selected entity type are available as attribute values.
   *
   * A maximum of 100 reference types can be specified.
   *
   * Added in Saleor 3.22.
   */
  referenceTypes?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** IDs of values to be removed from this attribute. */
  removeValues?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Internal representation of an attribute name. */
  slug?: InputMaybe<Scalars['String']['input']>;
  /**
   * The position of the attribute in the storefront navigation (0 by default).
   *
   * DEPRECATED: this field will be removed.
   */
  storefrontSearchPosition?: InputMaybe<Scalars['Int']['input']>;
  /** The unit of attribute values. */
  unit?: InputMaybe<MeasurementUnitsEnum>;
  /** Whether the attribute requires values to be passed or not. */
  valueRequired?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the attribute should be visible or not in storefront. */
  visibleInStorefront?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Event sent when attribute is updated. */
export type AttributeUpdated = Event & {
  __typename?: 'AttributeUpdated';
  /** The attribute the event relates to. */
  attribute?: Maybe<Attribute>;
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<IssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient?: Maybe<App>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

/** Represents a value of an attribute. */
export type AttributeValue = Node & {
  __typename?: 'AttributeValue';
  /** Represents the boolean value of the attribute value. */
  boolean?: Maybe<Scalars['Boolean']['output']>;
  /** Represents the date value of the attribute value. */
  date?: Maybe<Scalars['Date']['output']>;
  /** Represents the date/time value of the attribute value. */
  dateTime?: Maybe<Scalars['DateTime']['output']>;
  /** External ID of this attribute value. */
  externalReference?: Maybe<Scalars['String']['output']>;
  /** Represents file URL and content type (if attribute value is a file). */
  file?: Maybe<File>;
  /** The ID of the attribute value. */
  id: Scalars['ID']['output'];
  /** The input type to use for entering attribute values in the dashboard. */
  inputType?: Maybe<AttributeInputTypeEnum>;
  /** Name of a value displayed in the interface. */
  name?: Maybe<Scalars['String']['output']>;
  /** Represents the text of the attribute value, plain text without formatting. */
  plainText?: Maybe<Scalars['String']['output']>;
  /** The ID of the referenced object. */
  reference?: Maybe<Scalars['ID']['output']>;
  /**
   * Represents the text of the attribute value, includes formatting.
   *
   * Rich text format. For reference see https://editorjs.io/
   */
  richText?: Maybe<Scalars['JSONString']['output']>;
  /** Internal representation of a value (unique per attribute). */
  slug?: Maybe<Scalars['String']['output']>;
  /** Returns translated attribute value fields for the given language code. */
  translation?: Maybe<AttributeValueTranslation>;
  /** Represent value of the attribute value (e.g. color values for swatch attributes). */
  value?: Maybe<Scalars['String']['output']>;
};


/** Represents a value of an attribute. */
export type AttributeValueTranslationArgs = {
  languageCode: LanguageCodeEnum;
};

/**
 * Deletes values of attributes.
 *
 * Requires one of the following permissions: MANAGE_PAGE_TYPES_AND_ATTRIBUTES.
 *
 * Triggers the following webhook events:
 * - ATTRIBUTE_VALUE_DELETED (async): An attribute value was deleted.
 * - ATTRIBUTE_UPDATED (async): An attribute was updated.
 */
export type AttributeValueBulkDelete = {
  __typename?: 'AttributeValueBulkDelete';
  /** @deprecated Use `errors` field instead. */
  attributeErrors: Array<AttributeError>;
  /** Returns how many objects were affected. */
  count: Scalars['Int']['output'];
  errors: Array<AttributeError>;
};

/**
 * Creates/updates translations for attribute values.
 *
 * Requires one of the following permissions: MANAGE_TRANSLATIONS.
 */
export type AttributeValueBulkTranslate = {
  __typename?: 'AttributeValueBulkTranslate';
  /** Returns how many translations were created/updated. */
  count: Scalars['Int']['output'];
  errors: Array<AttributeValueBulkTranslateError>;
  /** List of the translations. */
  results: Array<AttributeValueBulkTranslateResult>;
};

export type AttributeValueBulkTranslateError = {
  __typename?: 'AttributeValueBulkTranslateError';
  /** The error code. */
  code: AttributeValueTranslateErrorCode;
  /** The error message. */
  message?: Maybe<Scalars['String']['output']>;
  /** Path to field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  path?: Maybe<Scalars['String']['output']>;
};

export type AttributeValueBulkTranslateInput = {
  /** External reference of an attribute value. */
  externalReference?: InputMaybe<Scalars['String']['input']>;
  /** Attribute value ID. */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Translation language code. */
  languageCode: LanguageCodeEnum;
  /** Translation fields. */
  translationFields: AttributeValueTranslationInput;
};

export type AttributeValueBulkTranslateResult = {
  __typename?: 'AttributeValueBulkTranslateResult';
  /** List of errors occurred on translation attempt. */
  errors?: Maybe<Array<AttributeValueBulkTranslateError>>;
  /** Attribute value translation data. */
  translation?: Maybe<AttributeValueTranslation>;
};

export type AttributeValueCountableConnection = {
  __typename?: 'AttributeValueCountableConnection';
  edges: Array<AttributeValueCountableEdge>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** A total count of items in the collection. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type AttributeValueCountableEdge = {
  __typename?: 'AttributeValueCountableEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: AttributeValue;
};

/**
 * Creates a value for an attribute.
 *
 * Requires one of the following permissions: MANAGE_PRODUCTS.
 *
 * Triggers the following webhook events:
 * - ATTRIBUTE_VALUE_CREATED (async): An attribute value was created.
 * - ATTRIBUTE_UPDATED (async): An attribute was updated.
 */
export type AttributeValueCreate = {
  __typename?: 'AttributeValueCreate';
  /** The updated attribute. */
  attribute?: Maybe<Attribute>;
  /** @deprecated Use `errors` field instead. */
  attributeErrors: Array<AttributeError>;
  attributeValue?: Maybe<AttributeValue>;
  errors: Array<AttributeError>;
};

export type AttributeValueCreateInput = {
  /** File content type. */
  contentType?: InputMaybe<Scalars['String']['input']>;
  /** External ID of this attribute value. */
  externalReference?: InputMaybe<Scalars['String']['input']>;
  /** URL of the file attribute. Every time, a new value is created. */
  fileUrl?: InputMaybe<Scalars['String']['input']>;
  /** Name of a value displayed in the interface. */
  name: Scalars['String']['input'];
  /**
   * Represents the text of the attribute value, plain text without formatting.
   *
   * DEPRECATED: this field will be removed.The plain text attribute hasn't got predefined value, so can be specified only from instance that supports the given attribute.
   */
  plainText?: InputMaybe<Scalars['String']['input']>;
  /**
   * Represents the text of the attribute value, includes formatting.
   *
   * Rich text format. For reference see https://editorjs.io/
   *
   * DEPRECATED: this field will be removed.The rich text attribute hasn't got predefined value, so can be specified only from instance that supports the given attribute.
   */
  richText?: InputMaybe<Scalars['JSONString']['input']>;
  /** Represent value of the attribute value (e.g. color values for swatch attributes). */
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Event sent when new attribute value is created. */
export type AttributeValueCreated = Event & {
  __typename?: 'AttributeValueCreated';
  /** The attribute value the event relates to. */
  attributeValue?: Maybe<AttributeValue>;
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<IssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient?: Maybe<App>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

/**
 * Deletes a value of an attribute.
 *
 * Requires one of the following permissions: MANAGE_PRODUCT_TYPES_AND_ATTRIBUTES.
 *
 * Triggers the following webhook events:
 * - ATTRIBUTE_VALUE_DELETED (async): An attribute value was deleted.
 * - ATTRIBUTE_UPDATED (async): An attribute was updated.
 */
export type AttributeValueDelete = {
  __typename?: 'AttributeValueDelete';
  /** The updated attribute. */
  attribute?: Maybe<Attribute>;
  /** @deprecated Use `errors` field instead. */
  attributeErrors: Array<AttributeError>;
  attributeValue?: Maybe<AttributeValue>;
  errors: Array<AttributeError>;
};

/** Event sent when attribute value is deleted. */
export type AttributeValueDeleted = Event & {
  __typename?: 'AttributeValueDeleted';
  /** The attribute value the event relates to. */
  attributeValue?: Maybe<AttributeValue>;
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<IssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient?: Maybe<App>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

export type AttributeValueFilterInput = {
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type AttributeValueInput = {
  /** Represents the boolean value of the attribute value. */
  boolean?: InputMaybe<Scalars['Boolean']['input']>;
  /** File content type. */
  contentType?: InputMaybe<Scalars['String']['input']>;
  /** Represents the date value of the attribute value. */
  date?: InputMaybe<Scalars['Date']['input']>;
  /** Represents the date/time value of the attribute value. */
  dateTime?: InputMaybe<Scalars['DateTime']['input']>;
  /** Attribute value ID or external reference. */
  dropdown?: InputMaybe<AttributeValueSelectableTypeInput>;
  /** External ID of this attribute. */
  externalReference?: InputMaybe<Scalars['String']['input']>;
  /** URL of the file attribute. Every time, a new value is created. */
  file?: InputMaybe<Scalars['String']['input']>;
  /** ID of the selected attribute. */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** List of attribute value IDs or external references. */
  multiselect?: InputMaybe<Array<AttributeValueSelectableTypeInput>>;
  /** Numeric value of an attribute. */
  numeric?: InputMaybe<Scalars['String']['input']>;
  /** Plain text content. */
  plainText?: InputMaybe<Scalars['String']['input']>;
  /**
   * ID of the referenced entity for single reference attribute.
   *
   * Added in Saleor 3.22.
   */
  reference?: InputMaybe<Scalars['ID']['input']>;
  /** List of entity IDs that will be used as references. */
  references?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Text content in JSON format. */
  richText?: InputMaybe<Scalars['JSONString']['input']>;
  /** Attribute value ID or external reference. */
  swatch?: InputMaybe<AttributeValueSelectableTypeInput>;
  /**
   * The value or slug of an attribute to resolve. If the passed value is non-existent, it will be created.
   *
   * DEPRECATED: this field will be removed.
   */
  values?: InputMaybe<Array<Scalars['String']['input']>>;
};

/**
 * Represents attribute value.
 * 1. If ID is provided, then attribute value will be resolved by ID.
 * 2. If externalReference is provided, then attribute value will be resolved by external reference.
 * 3. If value is provided, then attribute value will be resolved by value. If this attribute value doesn't exist, then it will be created.
 * 4. If externalReference and value is provided then new attribute value will be created.
 */
export type AttributeValueSelectableTypeInput = {
  /** External reference of an attribute value. */
  externalReference?: InputMaybe<Scalars['String']['input']>;
  /** ID of an attribute value. */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** The value or slug of an attribute to resolve. If the passed value is non-existent, it will be created. */
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Represents attribute value's original translatable fields and related translations. */
export type AttributeValueTranslatableContent = Node & {
  __typename?: 'AttributeValueTranslatableContent';
  /** Associated attribute that can be translated. */
  attribute?: Maybe<AttributeTranslatableContent>;
  /**
   * Represents a value of an attribute.
   * @deprecated Get model fields from the root level queries.
   */
  attributeValue?: Maybe<AttributeValue>;
  /** The ID of the attribute value to translate. */
  attributeValueId: Scalars['ID']['output'];
  /** The ID of the attribute value translatable content. */
  id: Scalars['ID']['output'];
  /** Name of the attribute value to translate. */
  name: Scalars['String']['output'];
  /** Attribute plain text value. */
  plainText?: Maybe<Scalars['String']['output']>;
  /**
   * Attribute value.
   *
   * Rich text format. For reference see https://editorjs.io/
   */
  richText?: Maybe<Scalars['JSONString']['output']>;
  /** Returns translated attribute value fields for the given language code. */
  translation?: Maybe<AttributeValueTranslation>;
};


/** Represents attribute value's original translatable fields and related translations. */
export type AttributeValueTranslatableContentTranslationArgs = {
  languageCode: LanguageCodeEnum;
};

/**
 * Creates/updates translations for an attribute value.
 *
 * Requires one of the following permissions: MANAGE_TRANSLATIONS.
 */
export type AttributeValueTranslate = {
  __typename?: 'AttributeValueTranslate';
  attributeValue?: Maybe<AttributeValue>;
  errors: Array<TranslationError>;
  /** @deprecated Use `errors` field instead. */
  translationErrors: Array<TranslationError>;
};

export type AttributeValueTranslateErrorCode =
  | 'GRAPHQL_ERROR'
  | 'INVALID'
  | 'NOT_FOUND'
  | 'REQUIRED';

/** Represents attribute value translations. */
export type AttributeValueTranslation = Node & {
  __typename?: 'AttributeValueTranslation';
  /** The ID of the attribute value translation. */
  id: Scalars['ID']['output'];
  /** Translation language. */
  language: LanguageDisplay;
  /** Translated attribute value name. */
  name: Scalars['String']['output'];
  /** Translated plain text attribute value . */
  plainText?: Maybe<Scalars['String']['output']>;
  /**
   * Translated rich-text attribute value.
   *
   * Rich text format. For reference see https://editorjs.io/
   */
  richText?: Maybe<Scalars['JSONString']['output']>;
  /** Represents the attribute value fields to translate. */
  translatableContent?: Maybe<AttributeValueTranslatableContent>;
};

export type AttributeValueTranslationInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  /** Translated text. */
  plainText?: InputMaybe<Scalars['String']['input']>;
  /**
   * Translated text.
   *
   * Rich text format. For reference see https://editorjs.io/
   */
  richText?: InputMaybe<Scalars['JSONString']['input']>;
};

/**
 * Updates value of an attribute.
 *
 * Requires one of the following permissions: MANAGE_PRODUCT_TYPES_AND_ATTRIBUTES.
 *
 * Triggers the following webhook events:
 * - ATTRIBUTE_VALUE_UPDATED (async): An attribute value was updated.
 * - ATTRIBUTE_UPDATED (async): An attribute was updated.
 */
export type AttributeValueUpdate = {
  __typename?: 'AttributeValueUpdate';
  /** The updated attribute. */
  attribute?: Maybe<Attribute>;
  /** @deprecated Use `errors` field instead. */
  attributeErrors: Array<AttributeError>;
  attributeValue?: Maybe<AttributeValue>;
  errors: Array<AttributeError>;
};

export type AttributeValueUpdateInput = {
  /** File content type. */
  contentType?: InputMaybe<Scalars['String']['input']>;
  /** External ID of this attribute value. */
  externalReference?: InputMaybe<Scalars['String']['input']>;
  /** URL of the file attribute. Every time, a new value is created. */
  fileUrl?: InputMaybe<Scalars['String']['input']>;
  /** Name of a value displayed in the interface. */
  name?: InputMaybe<Scalars['String']['input']>;
  /**
   * Represents the text of the attribute value, plain text without formatting.
   *
   * DEPRECATED: this field will be removed.The plain text attribute hasn't got predefined value, so can be specified only from instance that supports the given attribute.
   */
  plainText?: InputMaybe<Scalars['String']['input']>;
  /**
   * Represents the text of the attribute value, includes formatting.
   *
   * Rich text format. For reference see https://editorjs.io/
   *
   * DEPRECATED: this field will be removed.The rich text attribute hasn't got predefined value, so can be specified only from instance that supports the given attribute.
   */
  richText?: InputMaybe<Scalars['JSONString']['input']>;
  /** Represent value of the attribute value (e.g. color values for swatch attributes). */
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Event sent when attribute value is updated. */
export type AttributeValueUpdated = Event & {
  __typename?: 'AttributeValueUpdated';
  /** The attribute value the event relates to. */
  attributeValue?: Maybe<AttributeValue>;
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<IssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient?: Maybe<App>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

/** Where filtering options for attribute values. */
export type AttributeValueWhereInput = {
  /** List of conditions that must be met. */
  AND?: InputMaybe<Array<AttributeValueWhereInput>>;
  /** A list of conditions of which at least one must be met. */
  OR?: InputMaybe<Array<AttributeValueWhereInput>>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  name?: InputMaybe<StringFilterInput>;
  slug?: InputMaybe<StringFilterInput>;
};

/** Where filtering options. */
export type AttributeWhereInput = {
  /** List of conditions that must be met. */
  AND?: InputMaybe<Array<AttributeWhereInput>>;
  /** A list of conditions of which at least one must be met. */
  OR?: InputMaybe<Array<AttributeWhereInput>>;
  entityType?: InputMaybe<AttributeEntityTypeEnumFilterInput>;
  filterableInDashboard?: InputMaybe<Scalars['Boolean']['input']>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  inCategory?: InputMaybe<Scalars['ID']['input']>;
  inCollection?: InputMaybe<Scalars['ID']['input']>;
  inputType?: InputMaybe<AttributeInputTypeEnumFilterInput>;
  metadata?: InputMaybe<Array<MetadataFilter>>;
  name?: InputMaybe<StringFilterInput>;
  slug?: InputMaybe<StringFilterInput>;
  type?: InputMaybe<AttributeTypeEnumFilterInput>;
  unit?: InputMaybe<MeasurementUnitsEnumFilterInput>;
  valueRequired?: InputMaybe<Scalars['Boolean']['input']>;
  visibleInStorefront?: InputMaybe<Scalars['Boolean']['input']>;
  withChoices?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BulkAttributeValueInput = {
  /** The boolean value of an attribute to resolve. If the passed value is non-existent, it will be created. */
  boolean?: InputMaybe<Scalars['Boolean']['input']>;
  /** File content type. */
  contentType?: InputMaybe<Scalars['String']['input']>;
  /** Represents the date value of the attribute value. */
  date?: InputMaybe<Scalars['Date']['input']>;
  /** Represents the date/time value of the attribute value. */
  dateTime?: InputMaybe<Scalars['DateTime']['input']>;
  /** Attribute value ID. */
  dropdown?: InputMaybe<AttributeValueSelectableTypeInput>;
  /** External ID of this attribute. */
  externalReference?: InputMaybe<Scalars['String']['input']>;
  /** URL of the file attribute. Every time, a new value is created. */
  file?: InputMaybe<Scalars['String']['input']>;
  /** ID of the selected attribute. */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** List of attribute value IDs. */
  multiselect?: InputMaybe<Array<AttributeValueSelectableTypeInput>>;
  /** Numeric value of an attribute. */
  numeric?: InputMaybe<Scalars['String']['input']>;
  /** Plain text content. */
  plainText?: InputMaybe<Scalars['String']['input']>;
  /**
   * ID of the referenced entity for single reference attribute.
   *
   * Added in Saleor 3.22.
   */
  reference?: InputMaybe<Scalars['ID']['input']>;
  /** List of entity IDs that will be used as references. */
  references?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Text content in JSON format. */
  richText?: InputMaybe<Scalars['JSONString']['input']>;
  /** Attribute value ID. */
  swatch?: InputMaybe<AttributeValueSelectableTypeInput>;
  /**
   * The value or slug of an attribute to resolve. If the passed value is non-existent, it will be created.
   *
   * DEPRECATED: this field will be removed.
   */
  values?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type BulkProductError = {
  __typename?: 'BulkProductError';
  /** List of attributes IDs which causes the error. */
  attributes?: Maybe<Array<Scalars['ID']['output']>>;
  /** List of channel IDs which causes the error. */
  channels?: Maybe<Array<Scalars['ID']['output']>>;
  /** The error code. */
  code: ProductErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field?: Maybe<Scalars['String']['output']>;
  /** Index of an input list item that caused the error. */
  index?: Maybe<Scalars['Int']['output']>;
  /** The error message. */
  message?: Maybe<Scalars['String']['output']>;
  /** List of attribute values IDs which causes the error. */
  values?: Maybe<Array<Scalars['ID']['output']>>;
  /** List of warehouse IDs which causes the error. */
  warehouses?: Maybe<Array<Scalars['ID']['output']>>;
};

export type BulkStockError = {
  __typename?: 'BulkStockError';
  /** List of attributes IDs which causes the error. */
  attributes?: Maybe<Array<Scalars['ID']['output']>>;
  /** The error code. */
  code: ProductErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field?: Maybe<Scalars['String']['output']>;
  /** Index of an input list item that caused the error. */
  index?: Maybe<Scalars['Int']['output']>;
  /** The error message. */
  message?: Maybe<Scalars['String']['output']>;
  /** List of attribute values IDs which causes the error. */
  values?: Maybe<Array<Scalars['ID']['output']>>;
};

/** Synchronous webhook for calculating checkout/order taxes. */
export type CalculateTaxes = Event & {
  __typename?: 'CalculateTaxes';
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<IssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient?: Maybe<App>;
  taxBase: TaxableObject;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

export type CardInput = {
  /** Payment method nonce, a token returned by the appropriate provider's SDK. */
  code: Scalars['String']['input'];
  /** Card security code. */
  cvc?: InputMaybe<Scalars['String']['input']>;
  /** Information about currency and amount. */
  money: MoneyInput;
};

/**
 * Represents a card payment method used for a transaction.
 *
 * Added in Saleor 3.22.
 */
export type CardPaymentMethodDetails = PaymentMethodDetails & {
  __typename?: 'CardPaymentMethodDetails';
  /** Card brand. */
  brand?: Maybe<Scalars['String']['output']>;
  /** Two-digit number representing the card’s expiration month. */
  expMonth?: Maybe<Scalars['Int']['output']>;
  /** Four-digit number representing the card’s expiration year. */
  expYear?: Maybe<Scalars['Int']['output']>;
  /** First 4 digits of the card number. */
  firstDigits?: Maybe<Scalars['String']['output']>;
  /** Last 4 digits of the card number. */
  lastDigits?: Maybe<Scalars['String']['output']>;
  /** Name of the payment method. */
  name: Scalars['String']['output'];
};

export type CardPaymentMethodDetailsInput = {
  /** Brand of the payment method used for the transaction. Max length is 40 characters. */
  brand?: InputMaybe<Scalars['String']['input']>;
  /** Expiration month of the card used for the transaction. Value must be between 1 and 12. */
  expMonth?: InputMaybe<Scalars['Int']['input']>;
  /** Expiration year of the card used for the transaction. Value must be between 2000 and 9999. */
  expYear?: InputMaybe<Scalars['Int']['input']>;
  /** First digits of the card used for the transaction. Max length is 4 characters. */
  firstDigits?: InputMaybe<Scalars['String']['input']>;
  /** Last digits of the card used for the transaction. Max length is 4 characters. */
  lastDigits?: InputMaybe<Scalars['String']['input']>;
  /** Name of the payment method used for the transaction. Max length is 256 characters. */
  name: Scalars['String']['input'];
};

export type CatalogueInput = {
  /** Categories related to the discount. */
  categories?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Collections related to the discount. */
  collections?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Products related to the discount. */
  products?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Product variant related to the discount. */
  variants?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type CataloguePredicateInput = {
  /** List of conditions that must be met. */
  AND?: InputMaybe<Array<CataloguePredicateInput>>;
  /** A list of conditions of which at least one must be met. */
  OR?: InputMaybe<Array<CataloguePredicateInput>>;
  /** Defines the category conditions to be met. */
  categoryPredicate?: InputMaybe<CategoryWhereInput>;
  /** Defines the collection conditions to be met. */
  collectionPredicate?: InputMaybe<CollectionWhereInput>;
  /** Defines the product conditions to be met. */
  productPredicate?: InputMaybe<ProductWhereInput>;
  /** Defines the product variant conditions to be met. */
  variantPredicate?: InputMaybe<ProductVariantWhereInput>;
};

/** Represents a single category of products. Categories allow to organize products in a tree-hierarchies which can be used for navigation in the storefront. */
export type Category = Node & ObjectWithMetadata & {
  __typename?: 'Category';
  /** List of ancestors of the category. */
  ancestors?: Maybe<CategoryCountableConnection>;
  /** Background image of the category. */
  backgroundImage?: Maybe<Image>;
  /** List of children of the category. */
  children?: Maybe<CategoryCountableConnection>;
  /**
   * Description of the category.
   *
   * Rich text format. For reference see https://editorjs.io/
   */
  description?: Maybe<Scalars['JSONString']['output']>;
  /**
   * Description of the category.
   *
   * Rich text format. For reference see https://editorjs.io/
   * @deprecated Use the `description` field instead.
   */
  descriptionJson?: Maybe<Scalars['JSONString']['output']>;
  /** The ID of the category. */
  id: Scalars['ID']['output'];
  /** Level of the category. */
  level: Scalars['Int']['output'];
  /** List of public metadata items. Can be accessed without permissions. */
  metadata: Array<MetadataItem>;
  /**
   * A single key from public metadata.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   */
  metafield?: Maybe<Scalars['String']['output']>;
  /** Public metadata. Use `keys` to control which fields you want to include. The default is to include everything. */
  metafields?: Maybe<Scalars['Metadata']['output']>;
  /** Name of category */
  name: Scalars['String']['output'];
  /** Parent category. */
  parent?: Maybe<Category>;
  /** List of private metadata items. Requires staff permissions to access. */
  privateMetadata: Array<MetadataItem>;
  /**
   * A single key from private metadata. Requires staff permissions to access.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   */
  privateMetafield?: Maybe<Scalars['String']['output']>;
  /** Private metadata. Requires staff permissions to access. Use `keys` to control which fields you want to include. The default is to include everything. */
  privateMetafields?: Maybe<Scalars['Metadata']['output']>;
  /** List of products in the category. Requires the following permissions to include the unpublished items: MANAGE_ORDERS, MANAGE_DISCOUNTS, MANAGE_PRODUCTS. */
  products?: Maybe<ProductCountableConnection>;
  /** SEO description of category. */
  seoDescription?: Maybe<Scalars['String']['output']>;
  /** SEO title of category. */
  seoTitle?: Maybe<Scalars['String']['output']>;
  /** Slug of the category. */
  slug: Scalars['String']['output'];
  /** Returns translated category fields for the given language code. */
  translation?: Maybe<CategoryTranslation>;
  /** The date and time when the category was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};


/** Represents a single category of products. Categories allow to organize products in a tree-hierarchies which can be used for navigation in the storefront. */
export type CategoryAncestorsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Represents a single category of products. Categories allow to organize products in a tree-hierarchies which can be used for navigation in the storefront. */
export type CategoryBackgroundImageArgs = {
  format?: InputMaybe<ThumbnailFormatEnum>;
  size?: InputMaybe<Scalars['Int']['input']>;
};


/** Represents a single category of products. Categories allow to organize products in a tree-hierarchies which can be used for navigation in the storefront. */
export type CategoryChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Represents a single category of products. Categories allow to organize products in a tree-hierarchies which can be used for navigation in the storefront. */
export type CategoryMetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Represents a single category of products. Categories allow to organize products in a tree-hierarchies which can be used for navigation in the storefront. */
export type CategoryMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Represents a single category of products. Categories allow to organize products in a tree-hierarchies which can be used for navigation in the storefront. */
export type CategoryPrivateMetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Represents a single category of products. Categories allow to organize products in a tree-hierarchies which can be used for navigation in the storefront. */
export type CategoryPrivateMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Represents a single category of products. Categories allow to organize products in a tree-hierarchies which can be used for navigation in the storefront. */
export type CategoryProductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  channel?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ProductFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<ProductOrder>;
  where?: InputMaybe<ProductWhereInput>;
};


/** Represents a single category of products. Categories allow to organize products in a tree-hierarchies which can be used for navigation in the storefront. */
export type CategoryTranslationArgs = {
  languageCode: LanguageCodeEnum;
};

/**
 * Deletes categories.
 *
 * Requires one of the following permissions: MANAGE_PRODUCTS.
 */
export type CategoryBulkDelete = {
  __typename?: 'CategoryBulkDelete';
  /** Returns how many objects were affected. */
  count: Scalars['Int']['output'];
  errors: Array<ProductError>;
  /** @deprecated Use `errors` field instead. */
  productErrors: Array<ProductError>;
};

export type CategoryCountableConnection = {
  __typename?: 'CategoryCountableConnection';
  edges: Array<CategoryCountableEdge>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** A total count of items in the collection. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type CategoryCountableEdge = {
  __typename?: 'CategoryCountableEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Category;
};

/**
 * Creates a new category.
 *
 * Requires one of the following permissions: MANAGE_PRODUCTS.
 */
export type CategoryCreate = {
  __typename?: 'CategoryCreate';
  category?: Maybe<Category>;
  errors: Array<ProductError>;
  /** @deprecated Use `errors` field instead. */
  productErrors: Array<ProductError>;
};

/** Event sent when new category is created. */
export type CategoryCreated = Event & {
  __typename?: 'CategoryCreated';
  /** The category the event relates to. */
  category?: Maybe<Category>;
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<IssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient?: Maybe<App>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

/**
 * Deletes a category.
 *
 * Requires one of the following permissions: MANAGE_PRODUCTS.
 */
export type CategoryDelete = {
  __typename?: 'CategoryDelete';
  category?: Maybe<Category>;
  errors: Array<ProductError>;
  /** @deprecated Use `errors` field instead. */
  productErrors: Array<ProductError>;
};

/** Event sent when category is deleted. */
export type CategoryDeleted = Event & {
  __typename?: 'CategoryDeleted';
  /** The category the event relates to. */
  category?: Maybe<Category>;
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<IssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient?: Maybe<App>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

export type CategoryFilterInput = {
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  metadata?: InputMaybe<Array<MetadataFilter>>;
  search?: InputMaybe<Scalars['String']['input']>;
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter by when was the most recent update. */
  updatedAt?: InputMaybe<DateTimeRangeInput>;
};

export type CategoryInput = {
  /** Background image file. */
  backgroundImage?: InputMaybe<Scalars['Upload']['input']>;
  /** Alt text for a product media. */
  backgroundImageAlt?: InputMaybe<Scalars['String']['input']>;
  /**
   * Category description.
   *
   * Rich text format. For reference see https://editorjs.io/
   */
  description?: InputMaybe<Scalars['JSONString']['input']>;
  /**
   * Fields required to update the category metadata. Can be read by any API client authorized to read the object it's attached to.
   *
   * Warning: never store sensitive information, including financial data such as credit card details.
   */
  metadata?: InputMaybe<Array<MetadataInput>>;
  /** Category name. */
  name?: InputMaybe<Scalars['String']['input']>;
  /**
   * Fields required to update the category private metadata. Requires permissions to modify and to read the metadata of the object it's attached to.
   *
   * Warning: never store sensitive information, including financial data such as credit card details.
   */
  privateMetadata?: InputMaybe<Array<MetadataInput>>;
  /** Search engine optimization fields. */
  seo?: InputMaybe<SeoInput>;
  /** Category slug. */
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type CategorySortField =
  /** Sort categories by name. */
  | 'NAME'
  /** Sort categories by product count. */
  | 'PRODUCT_COUNT'
  /** Sort categories by subcategory count. */
  | 'SUBCATEGORY_COUNT';

export type CategorySortingInput = {
  /**
   * Specifies the channel in which to sort the data.
   *
   * DEPRECATED: this field will be removed. Use root-level channel argument instead.
   */
  channel?: InputMaybe<Scalars['String']['input']>;
  /** Specifies the direction in which to sort categories. */
  direction: OrderDirection;
  /** Sort categories by the selected field. */
  field: CategorySortField;
};

/** Represents category original translatable fields and related translations. */
export type CategoryTranslatableContent = Node & {
  __typename?: 'CategoryTranslatableContent';
  /**
   * Represents a single category of products.
   * @deprecated Get model fields from the root level queries.
   */
  category?: Maybe<Category>;
  /** The ID of the category to translate. */
  categoryId: Scalars['ID']['output'];
  /**
   * Category description to translate.
   *
   * Rich text format. For reference see https://editorjs.io/
   */
  description?: Maybe<Scalars['JSONString']['output']>;
  /**
   * Description of the category.
   *
   * Rich text format. For reference see https://editorjs.io/
   * @deprecated Use the `description` field instead.
   */
  descriptionJson?: Maybe<Scalars['JSONString']['output']>;
  /** The ID of the category translatable content. */
  id: Scalars['ID']['output'];
  /** Name of the category translatable content. */
  name: Scalars['String']['output'];
  /** SEO description to translate. */
  seoDescription?: Maybe<Scalars['String']['output']>;
  /** SEO title to translate. */
  seoTitle?: Maybe<Scalars['String']['output']>;
  /**
   * Slug to translate.
   *
   * Added in Saleor 3.21.
   */
  slug?: Maybe<Scalars['String']['output']>;
  /** Returns translated category fields for the given language code. */
  translation?: Maybe<CategoryTranslation>;
};


/** Represents category original translatable fields and related translations. */
export type CategoryTranslatableContentTranslationArgs = {
  languageCode: LanguageCodeEnum;
};

/**
 * Creates/updates translations for a category.
 *
 * Requires one of the following permissions: MANAGE_TRANSLATIONS.
 */
export type CategoryTranslate = {
  __typename?: 'CategoryTranslate';
  category?: Maybe<Category>;
  errors: Array<TranslationError>;
  /** @deprecated Use `errors` field instead. */
  translationErrors: Array<TranslationError>;
};

/** Represents category translations. */
export type CategoryTranslation = Node & {
  __typename?: 'CategoryTranslation';
  /**
   * Translated description of the category.
   *
   * Rich text format. For reference see https://editorjs.io/
   */
  description?: Maybe<Scalars['JSONString']['output']>;
  /**
   * Translated description of the category.
   *
   * Rich text format. For reference see https://editorjs.io/
   * @deprecated Use the `description` field instead.
   */
  descriptionJson?: Maybe<Scalars['JSONString']['output']>;
  /** The ID of the category translation. */
  id: Scalars['ID']['output'];
  /** Translation language. */
  language: LanguageDisplay;
  /** Translated category name. */
  name?: Maybe<Scalars['String']['output']>;
  /** Translated SEO description. */
  seoDescription?: Maybe<Scalars['String']['output']>;
  /** Translated SEO title. */
  seoTitle?: Maybe<Scalars['String']['output']>;
  /**
   * Translated category slug.
   *
   * Added in Saleor 3.21.
   */
  slug?: Maybe<Scalars['String']['output']>;
  /** Represents the category fields to translate. */
  translatableContent?: Maybe<CategoryTranslatableContent>;
};

/**
 * Updates a category.
 *
 * Requires one of the following permissions: MANAGE_PRODUCTS.
 */
export type CategoryUpdate = {
  __typename?: 'CategoryUpdate';
  category?: Maybe<Category>;
  errors: Array<ProductError>;
  /** @deprecated Use `errors` field instead. */
  productErrors: Array<ProductError>;
};

/** Event sent when category is updated. */
export type CategoryUpdated = Event & {
  __typename?: 'CategoryUpdated';
  /** The category the event relates to. */
  category?: Maybe<Category>;
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<IssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient?: Maybe<App>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

export type CategoryWhereInput = {
  /** List of conditions that must be met. */
  AND?: InputMaybe<Array<CategoryWhereInput>>;
  /** A list of conditions of which at least one must be met. */
  OR?: InputMaybe<Array<CategoryWhereInput>>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  metadata?: InputMaybe<Array<MetadataFilter>>;
};

/** Represents channel. */
export type Channel = Node & ObjectWithMetadata & {
  __typename?: 'Channel';
  /** Shipping methods that are available for the channel. */
  availableShippingMethodsPerCountry?: Maybe<Array<ShippingMethodsPerCountry>>;
  /**
   * Channel-specific checkout settings.
   *
   * Requires one of the following permissions: MANAGE_CHANNELS, MANAGE_CHECKOUTS.
   */
  checkoutSettings: CheckoutSettings;
  /** List of shippable countries for the channel. */
  countries?: Maybe<Array<CountryDisplay>>;
  /**
   * A currency that is assigned to the channel.
   *
   * Requires one of the following permissions: AUTHENTICATED_APP, AUTHENTICATED_STAFF_USER.
   */
  currencyCode: Scalars['String']['output'];
  /**
   * Default country for the channel. Default country can be used in checkout to determine the stock quantities or calculate taxes when the country was not explicitly provided.
   *
   * Requires one of the following permissions: AUTHENTICATED_APP, AUTHENTICATED_STAFF_USER.
   */
  defaultCountry: CountryDisplay;
  /**
   * Whether a channel has associated orders.
   *
   * Requires one of the following permissions: MANAGE_CHANNELS.
   */
  hasOrders: Scalars['Boolean']['output'];
  /** The ID of the channel. */
  id: Scalars['ID']['output'];
  /**
   * Whether the channel is active.
   *
   * Requires one of the following permissions: AUTHENTICATED_APP, AUTHENTICATED_STAFF_USER.
   */
  isActive: Scalars['Boolean']['output'];
  /** List of public metadata items. Can be accessed without permissions. */
  metadata: Array<MetadataItem>;
  /**
   * A single key from public metadata.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   */
  metafield?: Maybe<Scalars['String']['output']>;
  /** Public metadata. Use `keys` to control which fields you want to include. The default is to include everything. */
  metafields?: Maybe<Scalars['Metadata']['output']>;
  /**
   * Name of the channel.
   *
   * Requires one of the following permissions: AUTHENTICATED_APP, AUTHENTICATED_STAFF_USER.
   */
  name: Scalars['String']['output'];
  /**
   * Channel-specific order settings.
   *
   * Requires one of the following permissions: MANAGE_CHANNELS, MANAGE_ORDERS.
   */
  orderSettings: OrderSettings;
  /**
   * Channel-specific payment settings.
   *
   * Requires one of the following permissions: MANAGE_CHANNELS, HANDLE_PAYMENTS.
   */
  paymentSettings: PaymentSettings;
  /** List of private metadata items. Requires staff permissions to access. */
  privateMetadata: Array<MetadataItem>;
  /**
   * A single key from private metadata. Requires staff permissions to access.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   */
  privateMetafield?: Maybe<Scalars['String']['output']>;
  /** Private metadata. Requires staff permissions to access. Use `keys` to control which fields you want to include. The default is to include everything. */
  privateMetafields?: Maybe<Scalars['Metadata']['output']>;
  /** Slug of the channel. */
  slug: Scalars['String']['output'];
  /**
   * Define the stock setting for this channel.
   *
   * Requires one of the following permissions: AUTHENTICATED_APP, AUTHENTICATED_STAFF_USER.
   */
  stockSettings: StockSettings;
  /**
   * Channel specific tax configuration.
   *
   * Added in Saleor 3.20.
   *
   * Requires one of the following permissions: AUTHENTICATED_STAFF_USER, AUTHENTICATED_APP.
   */
  taxConfiguration: TaxConfiguration;
  /**
   * List of warehouses assigned to this channel.
   *
   * Requires one of the following permissions: AUTHENTICATED_APP, AUTHENTICATED_STAFF_USER.
   */
  warehouses: Array<Warehouse>;
};


/** Represents channel. */
export type ChannelAvailableShippingMethodsPerCountryArgs = {
  countries?: InputMaybe<Array<CountryCode>>;
};


/** Represents channel. */
export type ChannelMetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Represents channel. */
export type ChannelMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Represents channel. */
export type ChannelPrivateMetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Represents channel. */
export type ChannelPrivateMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};

/**
 * Activate a channel.
 *
 * Requires one of the following permissions: MANAGE_CHANNELS.
 *
 * Triggers the following webhook events:
 * - CHANNEL_STATUS_CHANGED (async): A channel was activated.
 */
export type ChannelActivate = {
  __typename?: 'ChannelActivate';
  /** Activated channel. */
  channel?: Maybe<Channel>;
  /** @deprecated Use `errors` field instead. */
  channelErrors: Array<ChannelError>;
  errors: Array<ChannelError>;
};

/**
 * Creates a new channel.
 *
 * Requires one of the following permissions: MANAGE_CHANNELS.
 *
 * Triggers the following webhook events:
 * - CHANNEL_CREATED (async): A channel was created.
 */
export type ChannelCreate = {
  __typename?: 'ChannelCreate';
  channel?: Maybe<Channel>;
  /** @deprecated Use `errors` field instead. */
  channelErrors: Array<ChannelError>;
  errors: Array<ChannelError>;
};

export type ChannelCreateInput = {
  /** List of shipping zones to assign to the channel. */
  addShippingZones?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** List of warehouses to assign to the channel. */
  addWarehouses?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The channel checkout settings */
  checkoutSettings?: InputMaybe<CheckoutSettingsInput>;
  /** Currency of the channel. */
  currencyCode: Scalars['String']['input'];
  /** Default country for the channel. Default country can be used in checkout to determine the stock quantities or calculate taxes when the country was not explicitly provided. */
  defaultCountry: CountryCode;
  /** Determine if channel will be set active or not. */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Channel public metadata. Can be read by any API client authorized to read the object it's attached to.
   *
   * Warning: never store sensitive information, including financial data such as credit card details.
   */
  metadata?: InputMaybe<Array<MetadataInput>>;
  /** Name of the channel. */
  name: Scalars['String']['input'];
  /** The channel order settings */
  orderSettings?: InputMaybe<OrderSettingsInput>;
  /** The channel payment settings */
  paymentSettings?: InputMaybe<PaymentSettingsInput>;
  /**
   * Channel private metadata. Requires permissions to modify and to read the metadata of the object it's attached to.
   *
   * Warning: never store sensitive information, including financial data such as credit card details.
   */
  privateMetadata?: InputMaybe<Array<MetadataInput>>;
  /** Slug of the channel. */
  slug: Scalars['String']['input'];
  /** The channel stock settings. */
  stockSettings?: InputMaybe<StockSettingsInput>;
};

/** Event sent when new channel is created. */
export type ChannelCreated = Event & {
  __typename?: 'ChannelCreated';
  /** The channel the event relates to. */
  channel?: Maybe<Channel>;
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<IssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient?: Maybe<App>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

/**
 * Deactivate a channel.
 *
 * Requires one of the following permissions: MANAGE_CHANNELS.
 *
 * Triggers the following webhook events:
 * - CHANNEL_STATUS_CHANGED (async): A channel was deactivated.
 */
export type ChannelDeactivate = {
  __typename?: 'ChannelDeactivate';
  /** Deactivated channel. */
  channel?: Maybe<Channel>;
  /** @deprecated Use `errors` field instead. */
  channelErrors: Array<ChannelError>;
  errors: Array<ChannelError>;
};

/**
 * Deletes a channel. Orders associated with the deleted channel will be moved to the target channel. Checkouts, product availability, and pricing will be removed.
 *
 * Requires one of the following permissions: MANAGE_CHANNELS.
 *
 * Triggers the following webhook events:
 * - CHANNEL_DELETED (async): A channel was deleted.
 */
export type ChannelDelete = {
  __typename?: 'ChannelDelete';
  channel?: Maybe<Channel>;
  /** @deprecated Use `errors` field instead. */
  channelErrors: Array<ChannelError>;
  errors: Array<ChannelError>;
};

export type ChannelDeleteInput = {
  /** ID of a channel to migrate orders from the origin channel. Target channel has to have the same currency as the origin. */
  channelId: Scalars['ID']['input'];
};

/** Event sent when channel is deleted. */
export type ChannelDeleted = Event & {
  __typename?: 'ChannelDeleted';
  /** The channel the event relates to. */
  channel?: Maybe<Channel>;
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<IssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient?: Maybe<App>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

export type ChannelError = {
  __typename?: 'ChannelError';
  /** The error code. */
  code: ChannelErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field?: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message?: Maybe<Scalars['String']['output']>;
  /** List of shipping zone IDs which causes the error. */
  shippingZones?: Maybe<Array<Scalars['ID']['output']>>;
  /** List of warehouses IDs which causes the error. */
  warehouses?: Maybe<Array<Scalars['ID']['output']>>;
};

export type ChannelErrorCode =
  | 'ALREADY_EXISTS'
  | 'CHANNELS_CURRENCY_MUST_BE_THE_SAME'
  | 'CHANNEL_WITH_ORDERS'
  | 'DUPLICATED_INPUT_ITEM'
  | 'GRAPHQL_ERROR'
  | 'INVALID'
  | 'NOT_FOUND'
  | 'REQUIRED'
  | 'UNIQUE';

export type ChannelListingUpdateInput = {
  /** ID of a channel listing. */
  channelListing: Scalars['ID']['input'];
  /** Cost price of the variant in channel. */
  costPrice?: InputMaybe<Scalars['PositiveDecimal']['input']>;
  /** The threshold for preorder variant in channel. */
  preorderThreshold?: InputMaybe<Scalars['Int']['input']>;
  /** Price of the particular variant in channel. */
  price?: InputMaybe<Scalars['PositiveDecimal']['input']>;
  /** Price of the variant before discount. */
  priorPrice?: InputMaybe<Scalars['PositiveDecimal']['input']>;
};

/** Event sent when channel metadata is updated. */
export type ChannelMetadataUpdated = Event & {
  __typename?: 'ChannelMetadataUpdated';
  /** The channel the event relates to. */
  channel?: Maybe<Channel>;
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<IssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient?: Maybe<App>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

/**
 * Reorder the warehouses of a channel.
 *
 * Requires one of the following permissions: MANAGE_CHANNELS.
 */
export type ChannelReorderWarehouses = {
  __typename?: 'ChannelReorderWarehouses';
  /** Channel within the warehouses are reordered. */
  channel?: Maybe<Channel>;
  errors: Array<ChannelError>;
};

/** Event sent when channel status has changed. */
export type ChannelStatusChanged = Event & {
  __typename?: 'ChannelStatusChanged';
  /** The channel the event relates to. */
  channel?: Maybe<Channel>;
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<IssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient?: Maybe<App>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

/**
 * Update a channel.
 *
 * Requires one of the following permissions: MANAGE_CHANNELS.
 * Requires one of the following permissions when updating only `orderSettings` field: `MANAGE_CHANNELS`, `MANAGE_ORDERS`.
 * Requires one of the following permissions when updating only `checkoutSettings` field: `MANAGE_CHANNELS`, `MANAGE_CHECKOUTS`.
 * Requires one of the following permissions when updating only `paymentSettings` field: `MANAGE_CHANNELS`, `HANDLE_PAYMENTS`.
 *
 * Triggers the following webhook events:
 * - CHANNEL_UPDATED (async): A channel was updated.
 * - CHANNEL_METADATA_UPDATED (async): Optionally triggered when public or private metadata is updated.
 */
export type ChannelUpdate = {
  __typename?: 'ChannelUpdate';
  channel?: Maybe<Channel>;
  /** @deprecated Use `errors` field instead. */
  channelErrors: Array<ChannelError>;
  errors: Array<ChannelError>;
};

export type ChannelUpdateInput = {
  /** List of shipping zones to assign to the channel. */
  addShippingZones?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** List of warehouses to assign to the channel. */
  addWarehouses?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The channel checkout settings */
  checkoutSettings?: InputMaybe<CheckoutSettingsInput>;
  /** Default country for the channel. Default country can be used in checkout to determine the stock quantities or calculate taxes when the country was not explicitly provided. */
  defaultCountry?: InputMaybe<CountryCode>;
  /** Determine if channel will be set active or not. */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Channel public metadata. Can be read by any API client authorized to read the object it's attached to.
   *
   * Warning: never store sensitive information, including financial data such as credit card details.
   */
  metadata?: InputMaybe<Array<MetadataInput>>;
  /** Name of the channel. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The channel order settings */
  orderSettings?: InputMaybe<OrderSettingsInput>;
  /** The channel payment settings */
  paymentSettings?: InputMaybe<PaymentSettingsInput>;
  /**
   * Channel private metadata. Requires permissions to modify and to read the metadata of the object it's attached to.
   *
   * Warning: never store sensitive information, including financial data such as credit card details.
   */
  privateMetadata?: InputMaybe<Array<MetadataInput>>;
  /** List of shipping zones to unassign from the channel. */
  removeShippingZones?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** List of warehouses to unassign from the channel. */
  removeWarehouses?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Slug of the channel. */
  slug?: InputMaybe<Scalars['String']['input']>;
  /** The channel stock settings. */
  stockSettings?: InputMaybe<StockSettingsInput>;
};

/** Event sent when channel is updated. */
export type ChannelUpdated = Event & {
  __typename?: 'ChannelUpdated';
  /** The channel the event relates to. */
  channel?: Maybe<Channel>;
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<IssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient?: Maybe<App>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

/** Checkout object. */
export type Checkout = Node & ObjectWithMetadata & {
  __typename?: 'Checkout';
  /**
   * The authorize status of the checkout.
   *
   * Triggers the following webhook events:
   * - CHECKOUT_CALCULATE_TAXES (sync): Optionally triggered when checkout prices are expired.
   */
  authorizeStatus: CheckoutAuthorizeStatusEnum;
  /** Collection points that can be used for this order. */
  availableCollectionPoints: Array<Warehouse>;
  /**
   * List of available payment gateways.
   *
   * Triggers the following webhook events:
   * - PAYMENT_LIST_GATEWAYS (sync): Fetch payment gateways available for checkout.
   */
  availablePaymentGateways: Array<PaymentGateway>;
  /**
   * Shipping methods that can be used with this checkout.
   *
   * Triggers the following webhook events:
   * - SHIPPING_LIST_METHODS_FOR_CHECKOUT (sync): Optionally triggered when cached external shipping methods are invalid.
   * - CHECKOUT_FILTER_SHIPPING_METHODS (sync): Optionally triggered when cached filtered shipping methods are invalid.
   * @deprecated Use `shippingMethods` instead.
   */
  availableShippingMethods: Array<ShippingMethod>;
  /** The billing address of the checkout. */
  billingAddress?: Maybe<Address>;
  /** The channel for which checkout was created. */
  channel: Channel;
  /**
   * The charge status of the checkout.
   *
   * Triggers the following webhook events:
   * - CHECKOUT_CALCULATE_TAXES (sync): Optionally triggered when checkout prices are expired.
   */
  chargeStatus: CheckoutChargeStatusEnum;
  /** The date and time when the checkout was created. */
  created: Scalars['DateTime']['output'];
  /**
   * The customer note for the checkout.
   *
   * Added in Saleor 3.21.
   */
  customerNote: Scalars['String']['output'];
  /**
   * The delivery method selected for this checkout.
   *
   * Triggers the following webhook events:
   * - SHIPPING_LIST_METHODS_FOR_CHECKOUT (sync): Optionally triggered when cached external shipping methods are invalid.
   * - CHECKOUT_FILTER_SHIPPING_METHODS (sync): Optionally triggered when cached filtered shipping methods are invalid.
   */
  deliveryMethod?: Maybe<DeliveryMethod>;
  /** The total discount applied to the checkout. Note: Only discount created via voucher are included in this field. */
  discount?: Maybe<Money>;
  /** The name of voucher assigned to the checkout. */
  discountName?: Maybe<Scalars['String']['output']>;
  /** Determines whether displayed prices should include taxes. */
  displayGrossPrices: Scalars['Boolean']['output'];
  /** Email of a customer. */
  email?: Maybe<Scalars['String']['output']>;
  /** List of gift cards associated with this checkout. */
  giftCards: Array<GiftCard>;
  /** The ID of the checkout. */
  id: Scalars['ID']['output'];
  /** Returns True, if checkout requires shipping. */
  isShippingRequired: Scalars['Boolean']['output'];
  /** Checkout language code. */
  languageCode: LanguageCodeEnum;
  /** @deprecated Use `updatedAt` instead. */
  lastChange: Scalars['DateTime']['output'];
  /** A list of checkout lines, each containing information about an item in the checkout. */
  lines: Array<CheckoutLine>;
  /** List of public metadata items. Can be accessed without permissions. */
  metadata: Array<MetadataItem>;
  /**
   * A single key from public metadata.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   */
  metafield?: Maybe<Scalars['String']['output']>;
  /** Public metadata. Use `keys` to control which fields you want to include. The default is to include everything. */
  metafields?: Maybe<Scalars['Metadata']['output']>;
  /**
   * The note for the checkout.
   * @deprecated Use `customerNote` instead.
   */
  note: Scalars['String']['output'];
  /** List of private metadata items. Requires staff permissions to access. */
  privateMetadata: Array<MetadataItem>;
  /**
   * A single key from private metadata. Requires staff permissions to access.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   */
  privateMetafield?: Maybe<Scalars['String']['output']>;
  /** Private metadata. Requires staff permissions to access. Use `keys` to control which fields you want to include. The default is to include everything. */
  privateMetafields?: Maybe<Scalars['Metadata']['output']>;
  /** List of problems with the checkout. */
  problems?: Maybe<Array<CheckoutProblem>>;
  /** The number of items purchased. */
  quantity: Scalars['Int']['output'];
  /** The shipping address of the checkout. */
  shippingAddress?: Maybe<Address>;
  /**
   * The shipping method related with checkout.
   *
   * Triggers the following webhook events:
   * - SHIPPING_LIST_METHODS_FOR_CHECKOUT (sync): Optionally triggered when cached external shipping methods are invalid.
   * - CHECKOUT_FILTER_SHIPPING_METHODS (sync): Optionally triggered when cached filtered shipping methods are invalid.
   * @deprecated Use `deliveryMethod` instead.
   */
  shippingMethod?: Maybe<ShippingMethod>;
  /**
   * Shipping methods that can be used with this checkout.
   *
   * Triggers the following webhook events:
   * - SHIPPING_LIST_METHODS_FOR_CHECKOUT (sync): Optionally triggered when cached external shipping methods are invalid.
   * - CHECKOUT_FILTER_SHIPPING_METHODS (sync): Optionally triggered when cached filtered shipping methods are invalid.
   */
  shippingMethods: Array<ShippingMethod>;
  /**
   * The price of the shipping, with all the taxes included. Set to 0 when no delivery method is selected.
   *
   * Triggers the following webhook events:
   * - CHECKOUT_CALCULATE_TAXES (sync): Optionally triggered when checkout prices are expired.
   */
  shippingPrice: TaxedMoney;
  /** Date when oldest stock reservation for this checkout expires or null if no stock is reserved. */
  stockReservationExpires?: Maybe<Scalars['DateTime']['output']>;
  /** List of user's stored payment methods that can be used in this checkout session. It uses the channel that the checkout was created in. When `amount` is not provided, `checkout.total` will be used as a default value. */
  storedPaymentMethods?: Maybe<Array<StoredPaymentMethod>>;
  /**
   * The price of the checkout before shipping, with taxes included.
   *
   * Triggers the following webhook events:
   * - CHECKOUT_CALCULATE_TAXES (sync): Optionally triggered when checkout prices are expired.
   */
  subtotalPrice: TaxedMoney;
  /** Returns True if checkout has to be exempt from taxes. */
  taxExemption: Scalars['Boolean']['output'];
  /** The checkout's token. */
  token: Scalars['UUID']['output'];
  /**
   * The difference between the paid and the checkout total amount.
   *
   * Triggers the following webhook events:
   * - CHECKOUT_CALCULATE_TAXES (sync): Optionally triggered when checkout prices are expired.
   */
  totalBalance: Money;
  /**
   * The sum of the checkout line prices, with all the taxes,shipping costs, and discounts included.
   *
   * Triggers the following webhook events:
   * - CHECKOUT_CALCULATE_TAXES (sync): Optionally triggered when checkout prices are expired.
   */
  totalPrice: TaxedMoney;
  /** List of transactions for the checkout. Requires one of the following permissions: MANAGE_CHECKOUTS, HANDLE_PAYMENTS. */
  transactions?: Maybe<Array<TransactionItem>>;
  /** Translation of the discountName field in the language set in Checkout.languageCode field.Note: this field is set automatically when Checkout.languageCode is defined; otherwise it's null */
  translatedDiscountName?: Maybe<Scalars['String']['output']>;
  /** Time of last modification of the given checkout. */
  updatedAt: Scalars['DateTime']['output'];
  /** The user assigned to the checkout. Requires one of the following permissions: MANAGE_USERS, HANDLE_PAYMENTS, OWNER. */
  user?: Maybe<User>;
  /**
   * The voucher assigned to the checkout.
   *
   * Added in Saleor 3.18.
   *
   * Requires one of the following permissions: MANAGE_DISCOUNTS.
   */
  voucher?: Maybe<Voucher>;
  /** The code of voucher assigned to the checkout. */
  voucherCode?: Maybe<Scalars['String']['output']>;
};


/** Checkout object. */
export type CheckoutMetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Checkout object. */
export type CheckoutMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Checkout object. */
export type CheckoutPrivateMetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Checkout object. */
export type CheckoutPrivateMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Checkout object. */
export type CheckoutStoredPaymentMethodsArgs = {
  amount?: InputMaybe<Scalars['PositiveDecimal']['input']>;
};

/**
 * Adds a gift card or a voucher to a checkout.
 *
 * Triggers the following webhook events:
 * - CHECKOUT_UPDATED (async): A checkout was updated.
 */
export type CheckoutAddPromoCode = {
  __typename?: 'CheckoutAddPromoCode';
  /** The checkout with the added gift card or voucher. */
  checkout?: Maybe<Checkout>;
  /** @deprecated Use `errors` field instead. */
  checkoutErrors: Array<CheckoutError>;
  errors: Array<CheckoutError>;
};

export type CheckoutAddressValidationRules = {
  /** Determines if an error should be raised when the provided address doesn't match the expected format. Example: using letters for postal code when the numbers are expected. */
  checkFieldsFormat?: InputMaybe<Scalars['Boolean']['input']>;
  /** Determines if an error should be raised when the provided address doesn't have all the required fields. The list of required fields is dynamic and depends on the country code (use the `addressValidationRules` query to fetch them). Note: country code is mandatory for all addresses regardless of the rules provided in this input. */
  checkRequiredFields?: InputMaybe<Scalars['Boolean']['input']>;
  /** Determines if Saleor should apply normalization on address fields. Example: converting city field to uppercase letters. */
  enableFieldsNormalization?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * Determine a current authorize status for checkout.
 *
 *     We treat the checkout as fully authorized when the sum of authorized and charged
 *     funds cover the checkout.total.
 *     We treat the checkout as partially authorized when the sum of authorized and charged
 *     funds covers only part of the checkout.total
 *     We treat the checkout as not authorized when the sum of authorized and charged funds
 *     is 0.
 *
 *     NONE - the funds are not authorized
 *     PARTIAL - the cover funds don't cover fully the checkout's total
 *     FULL - the cover funds covers the checkout's total
 *
 */
export type CheckoutAuthorizeStatusEnum =
  | 'FULL'
  | 'NONE'
  | 'PARTIAL';

export type CheckoutAutoCompleteInput = {
  /** Specifies the earliest date on which fully paid checkouts can begin to be automatically completed. Fully paid checkouts dated before this cut-off will not be automatically completed. Must be less than the threshold of the oldest modified checkout eligible for automatic completion. Default is current date time. */
  cutOffDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** The time in minutes after which the fully paid checkout will be automatically completed. Default is 30. Set to 0 for immediate completion. Should be less than the threshold for the oldest modified checkout eligible for automatic completion. */
  delay?: InputMaybe<Scalars['Minute']['input']>;
  /** Default `false`. Determines if the paid checkouts should be automatically completed. This setting applies only to checkouts where payment was processed through transactions.When enabled, the checkout will be automatically completed once the checkout `charge_status` reaches `FULL`. This occurs when the total sum of charged and authorized transaction amounts equals or exceeds the checkout's total amount. */
  enabled: Scalars['Boolean']['input'];
};

/**
 * Updates billing address in the existing checkout.
 *
 * Triggers the following webhook events:
 * - CHECKOUT_UPDATED (async): A checkout was updated.
 */
export type CheckoutBillingAddressUpdate = {
  __typename?: 'CheckoutBillingAddressUpdate';
  /** An updated checkout. */
  checkout?: Maybe<Checkout>;
  /** @deprecated Use `errors` field instead. */
  checkoutErrors: Array<CheckoutError>;
  errors: Array<CheckoutError>;
};

/**
 * Determine the current charge status for the checkout.
 *
 *     The checkout is considered overcharged when the sum of the transactionItem's charge
 *     amounts exceeds the value of `checkout.total`.
 *     If the sum of the transactionItem's charge amounts equals
 *     `checkout.total`, we consider the checkout to be fully charged.
 *     If the sum of the transactionItem's charge amounts covers a part of the
 *     `checkout.total`, we treat the checkout as partially charged.
 *
 *
 *     NONE - the funds are not charged.
 *     PARTIAL - the funds that are charged don't cover the checkout's total
 *     FULL - the funds that are charged fully cover the checkout's total
 *     OVERCHARGED - the charged funds are bigger than checkout's total
 *
 */
export type CheckoutChargeStatusEnum =
  | 'FULL'
  | 'NONE'
  | 'OVERCHARGED'
  | 'PARTIAL';

/**
 * Completes the checkout. As a result a new order is created. The mutation allows to create the unpaid order when setting `orderSettings.allowUnpaidOrders` for given `Channel` is set to `true`. When `orderSettings.allowUnpaidOrders` is set to `false`, checkout can be completed only when attached `Payment`/`TransactionItem`s fully cover the checkout's total. When processing the checkout with `Payment`, in case of required additional confirmation step like 3D secure, the `confirmationNeeded` flag will be set to True and no order will be created until payment is confirmed with second call of this mutation.
 *
 * Triggers the following webhook events:
 * - SHIPPING_LIST_METHODS_FOR_CHECKOUT (sync): Optionally triggered when cached external shipping methods are invalid.
 * - CHECKOUT_FILTER_SHIPPING_METHODS (sync): Optionally triggered when cached filtered shipping methods are invalid.
 * - CHECKOUT_CALCULATE_TAXES (sync): Optionally triggered when checkout prices are expired.
 * - ORDER_CREATED (async): Triggered when order is created.
 * - NOTIFY_USER (async): A notification for order placement.
 * - NOTIFY_USER (async): A staff notification for order placement.
 * - ORDER_UPDATED (async): Triggered when order received the update after placement.
 * - ORDER_PAID (async): Triggered when newly created order is paid.
 * - ORDER_FULLY_PAID (async): Triggered when newly created order is fully paid.
 * - ORDER_CONFIRMED (async): Optionally triggered when newly created order are automatically marked as confirmed.
 */
export type CheckoutComplete = {
  __typename?: 'CheckoutComplete';
  /** @deprecated Use `errors` field instead. */
  checkoutErrors: Array<CheckoutError>;
  /** Confirmation data used to process additional authorization steps. */
  confirmationData?: Maybe<Scalars['JSONString']['output']>;
  /** Set to true if payment needs to be confirmed before checkout is complete. */
  confirmationNeeded: Scalars['Boolean']['output'];
  errors: Array<CheckoutError>;
  /** Placed order. */
  order?: Maybe<Order>;
};

export type CheckoutCountableConnection = {
  __typename?: 'CheckoutCountableConnection';
  edges: Array<CheckoutCountableEdge>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** A total count of items in the collection. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type CheckoutCountableEdge = {
  __typename?: 'CheckoutCountableEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Checkout;
};

/**
 * Create a new checkout.
 *
 * `skipValidation` field requires HANDLE_CHECKOUTS and AUTHENTICATED_APP permissions.
 *
 * Triggers the following webhook events:
 * - CHECKOUT_CREATED (async): A checkout was created.
 */
export type CheckoutCreate = {
  __typename?: 'CheckoutCreate';
  checkout?: Maybe<Checkout>;
  /** @deprecated Use `errors` field instead. */
  checkoutErrors: Array<CheckoutError>;
  /**
   * Whether the checkout was created or the current active one was returned. Refer to checkoutLinesAdd and checkoutLinesUpdate to merge a cart with an active checkout.
   * @deprecated Always returns `true`.
   */
  created?: Maybe<Scalars['Boolean']['output']>;
  errors: Array<CheckoutError>;
};

/** Creates a new checkout from existing order. */
export type CheckoutCreateFromOrder = {
  __typename?: 'CheckoutCreateFromOrder';
  /** Created checkout. */
  checkout?: Maybe<Checkout>;
  errors: Array<CheckoutCreateFromOrderError>;
  /** Variants that were not attached to the checkout. */
  unavailableVariants?: Maybe<Array<CheckoutCreateFromOrderUnavailableVariant>>;
};

export type CheckoutCreateFromOrderError = {
  __typename?: 'CheckoutCreateFromOrderError';
  /** The error code. */
  code: CheckoutCreateFromOrderErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field?: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message?: Maybe<Scalars['String']['output']>;
};

export type CheckoutCreateFromOrderErrorCode =
  | 'CHANNEL_INACTIVE'
  | 'GRAPHQL_ERROR'
  | 'INVALID'
  | 'ORDER_NOT_FOUND'
  | 'TAX_ERROR';

export type CheckoutCreateFromOrderUnavailableVariant = {
  __typename?: 'CheckoutCreateFromOrderUnavailableVariant';
  /** The error code. */
  code: CheckoutCreateFromOrderUnavailableVariantErrorCode;
  /** Order line ID that is unavailable. */
  lineId: Scalars['ID']['output'];
  /** The error message. */
  message: Scalars['String']['output'];
  /** Variant ID that is unavailable. */
  variantId: Scalars['ID']['output'];
};

export type CheckoutCreateFromOrderUnavailableVariantErrorCode =
  | 'INSUFFICIENT_STOCK'
  | 'NOT_FOUND'
  | 'PRODUCT_NOT_PUBLISHED'
  | 'PRODUCT_UNAVAILABLE_FOR_PURCHASE'
  | 'QUANTITY_GREATER_THAN_LIMIT'
  | 'UNAVAILABLE_VARIANT_IN_CHANNEL';

export type CheckoutCreateInput = {
  /** Billing address of the customer. `skipValidation` requires HANDLE_CHECKOUTS and AUTHENTICATED_APP permissions. */
  billingAddress?: InputMaybe<AddressInput>;
  /** Slug of a channel in which to create a checkout. */
  channel?: InputMaybe<Scalars['String']['input']>;
  /** The customer's email address. */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Checkout language code. */
  languageCode?: InputMaybe<LanguageCodeEnum>;
  /** A list of checkout lines, each containing information about an item in the checkout. */
  lines: Array<CheckoutLineInput>;
  /**
   * Checkout public metadata. Can be read by any API client authorized to read the object it's attached to.
   *
   * Warning: never store sensitive information, including financial data such as credit card details.
   *
   * Added in Saleor 3.21.
   */
  metadata?: InputMaybe<Array<MetadataInput>>;
  /**
   * Checkout private metadata. Requires one of the following permissions: MANAGE_CHECKOUTS, HANDLE_CHECKOUTS
   *
   * Requires permissions to modify and to read the metadata of the object it's attached to.
   *
   * Warning: never store sensitive information, including financial data such as credit card details.
   *
   * Added in Saleor 3.21.
   */
  privateMetadata?: InputMaybe<Array<MetadataInput>>;
  /**
   * Indicates whether the billing address should be saved to the user’s address book upon checkout completion. Can only be set when a billing address is provided. If not specified along with the address, the default behavior is to save the address.
   *
   * Added in Saleor 3.21.
   */
  saveBillingAddress?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Indicates whether the shipping address should be saved to the user’s address book upon checkout completion.Can only be set when a shipping address is provided. If not specified along with the address, the default behavior is to save the address.
   *
   * Added in Saleor 3.21.
   */
  saveShippingAddress?: InputMaybe<Scalars['Boolean']['input']>;
  /** The mailing address to where the checkout will be shipped. Note: the address will be ignored if the checkout doesn't contain shippable items. `skipValidation` requires HANDLE_CHECKOUTS and AUTHENTICATED_APP permissions. */
  shippingAddress?: InputMaybe<AddressInput>;
  /** The checkout validation rules that can be changed. */
  validationRules?: InputMaybe<CheckoutValidationRules>;
};

/** Event sent when new checkout is created. */
export type CheckoutCreated = Event & {
  __typename?: 'CheckoutCreated';
  /** The checkout the event relates to. */
  checkout?: Maybe<Checkout>;
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<IssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient?: Maybe<App>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

/**
 * Sets the customer as the owner of the checkout.
 *
 * Requires one of the following permissions: AUTHENTICATED_APP, AUTHENTICATED_USER.
 *
 * Triggers the following webhook events:
 * - CHECKOUT_UPDATED (async): A checkout was updated.
 */
export type CheckoutCustomerAttach = {
  __typename?: 'CheckoutCustomerAttach';
  /** An updated checkout. */
  checkout?: Maybe<Checkout>;
  /** @deprecated Use `errors` field instead. */
  checkoutErrors: Array<CheckoutError>;
  errors: Array<CheckoutError>;
};

/**
 * Removes the user assigned as the owner of the checkout.
 *
 * Requires one of the following permissions: AUTHENTICATED_APP, AUTHENTICATED_USER.
 *
 * Triggers the following webhook events:
 * - CHECKOUT_UPDATED (async): A checkout was updated.
 */
export type CheckoutCustomerDetach = {
  __typename?: 'CheckoutCustomerDetach';
  /** An updated checkout. */
  checkout?: Maybe<Checkout>;
  /** @deprecated Use `errors` field instead. */
  checkoutErrors: Array<CheckoutError>;
  errors: Array<CheckoutError>;
};

/**
 * Updates customer note in the existing checkout object.
 *
 * Added in Saleor 3.21.
 *
 * Triggers the following webhook events:
 * - CHECKOUT_UPDATED (async): A checkout was updated.
 */
export type CheckoutCustomerNoteUpdate = {
  __typename?: 'CheckoutCustomerNoteUpdate';
  /** An updated checkout. */
  checkout?: Maybe<Checkout>;
  /** @deprecated Use `errors` field instead. */
  checkoutErrors: Array<CheckoutError>;
  errors: Array<CheckoutError>;
};

/**
 * Updates the delivery method (shipping method or pick up point) of the checkout. Updates the checkout shipping_address for click and collect delivery for a warehouse address.
 *
 * Triggers the following webhook events:
 * - SHIPPING_LIST_METHODS_FOR_CHECKOUT (sync): Triggered when updating the checkout delivery method with the external one.
 * - CHECKOUT_UPDATED (async): A checkout was updated.
 */
export type CheckoutDeliveryMethodUpdate = {
  __typename?: 'CheckoutDeliveryMethodUpdate';
  /** An updated checkout. */
  checkout?: Maybe<Checkout>;
  errors: Array<CheckoutError>;
};

/**
 * Updates email address in the existing checkout object.
 *
 * Triggers the following webhook events:
 * - CHECKOUT_UPDATED (async): A checkout was updated.
 */
export type CheckoutEmailUpdate = {
  __typename?: 'CheckoutEmailUpdate';
  /** An updated checkout. */
  checkout?: Maybe<Checkout>;
  /** @deprecated Use `errors` field instead. */
  checkoutErrors: Array<CheckoutError>;
  errors: Array<CheckoutError>;
};

export type CheckoutError = {
  __typename?: 'CheckoutError';
  /** A type of address that causes the error. */
  addressType?: Maybe<AddressTypeEnum>;
  /** The error code. */
  code: CheckoutErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field?: Maybe<Scalars['String']['output']>;
  /** List of line Ids which cause the error. */
  lines?: Maybe<Array<Scalars['ID']['output']>>;
  /** The error message. */
  message?: Maybe<Scalars['String']['output']>;
  /** List of variant IDs which causes the error. */
  variants?: Maybe<Array<Scalars['ID']['output']>>;
};

export type CheckoutErrorCode =
  | 'BILLING_ADDRESS_NOT_SET'
  | 'CHANNEL_INACTIVE'
  | 'CHECKOUT_NOT_FULLY_PAID'
  | 'DELIVERY_METHOD_NOT_APPLICABLE'
  | 'EMAIL_NOT_SET'
  | 'GIFT_CARD_NOT_APPLICABLE'
  | 'GRAPHQL_ERROR'
  | 'INACTIVE_PAYMENT'
  | 'INSUFFICIENT_STOCK'
  | 'INVALID'
  | 'INVALID_SHIPPING_METHOD'
  | 'MISSING_ADDRESS_DATA'
  | 'MISSING_CHANNEL_SLUG'
  | 'NON_EDITABLE_GIFT_LINE'
  | 'NON_REMOVABLE_GIFT_LINE'
  | 'NOT_FOUND'
  | 'NO_LINES'
  | 'PAYMENT_ERROR'
  | 'PRODUCT_NOT_PUBLISHED'
  | 'PRODUCT_UNAVAILABLE_FOR_PURCHASE'
  | 'QUANTITY_GREATER_THAN_LIMIT'
  | 'REQUIRED'
  | 'SHIPPING_ADDRESS_NOT_SET'
  | 'SHIPPING_CHANGE_FORBIDDEN'
  | 'SHIPPING_METHOD_NOT_APPLICABLE'
  | 'SHIPPING_METHOD_NOT_SET'
  | 'SHIPPING_NOT_REQUIRED'
  | 'TAX_ERROR'
  | 'UNAVAILABLE_VARIANT_IN_CHANNEL'
  | 'UNIQUE'
  | 'VOUCHER_NOT_APPLICABLE'
  | 'ZERO_QUANTITY';

export type CheckoutFilterInput = {
  authorizeStatus?: InputMaybe<Array<CheckoutAuthorizeStatusEnum>>;
  channels?: InputMaybe<Array<Scalars['ID']['input']>>;
  chargeStatus?: InputMaybe<Array<CheckoutChargeStatusEnum>>;
  created?: InputMaybe<DateRangeInput>;
  customer?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Array<MetadataFilter>>;
  search?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<DateRangeInput>;
};

/** Filter shipping methods for checkout. */
export type CheckoutFilterShippingMethods = Event & {
  __typename?: 'CheckoutFilterShippingMethods';
  /** The checkout the event relates to. */
  checkout?: Maybe<Checkout>;
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<IssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient?: Maybe<App>;
  /** Shipping methods that can be used with this checkout. */
  shippingMethods?: Maybe<Array<ShippingMethod>>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

/**
 * Event sent when a checkout was fully authorized. A checkout is considered fully authorized when its `authorizeStatus` is `FULL`.
 *
 * It is triggered only for checkouts whose payments are processed through the Transaction API.
 */
export type CheckoutFullyAuthorized = Event & {
  __typename?: 'CheckoutFullyAuthorized';
  /** The checkout the event relates to. */
  checkout?: Maybe<Checkout>;
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<IssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient?: Maybe<App>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

/**
 * Event sent when a checkout was fully paid. A checkout is considered fully paid when its `chargeStatus` is `FULL` or `OVERCHARGED`. This event is not sent if payments are only authorized but not fully charged.
 *
 * It is triggered only for checkouts whose payments are processed through the Transaction API.
 */
export type CheckoutFullyPaid = Event & {
  __typename?: 'CheckoutFullyPaid';
  /** The checkout the event relates to. */
  checkout?: Maybe<Checkout>;
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<IssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient?: Maybe<App>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

/**
 * Updates language code in the existing checkout.
 *
 * Triggers the following webhook events:
 * - CHECKOUT_UPDATED (async): A checkout was updated.
 */
export type CheckoutLanguageCodeUpdate = {
  __typename?: 'CheckoutLanguageCodeUpdate';
  /** An updated checkout. */
  checkout?: Maybe<Checkout>;
  /** @deprecated Use `errors` field instead. */
  checkoutErrors: Array<CheckoutError>;
  errors: Array<CheckoutError>;
};

/** Represents an item in the checkout. */
export type CheckoutLine = Node & ObjectWithMetadata & {
  __typename?: 'CheckoutLine';
  /** The ID of the checkout line. */
  id: Scalars['ID']['output'];
  /**
   * Determine if the line is a gift.
   *
   * Added in Saleor 3.19.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  isGift?: Maybe<Scalars['Boolean']['output']>;
  /** List of public metadata items. Can be accessed without permissions. */
  metadata: Array<MetadataItem>;
  /**
   * A single key from public metadata.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   */
  metafield?: Maybe<Scalars['String']['output']>;
  /** Public metadata. Use `keys` to control which fields you want to include. The default is to include everything. */
  metafields?: Maybe<Scalars['Metadata']['output']>;
  /**
   * The sum of the checkout line price prior to promotion.
   *
   * Added in Saleor 3.21.
   */
  priorTotalPrice?: Maybe<Money>;
  /**
   * The unit price of the checkout line prior to promotion.
   *
   * Added in Saleor 3.21.
   */
  priorUnitPrice?: Maybe<Money>;
  /** List of private metadata items. Requires staff permissions to access. */
  privateMetadata: Array<MetadataItem>;
  /**
   * A single key from private metadata. Requires staff permissions to access.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   */
  privateMetafield?: Maybe<Scalars['String']['output']>;
  /** Private metadata. Requires staff permissions to access. Use `keys` to control which fields you want to include. The default is to include everything. */
  privateMetafields?: Maybe<Scalars['Metadata']['output']>;
  /** List of problems with the checkout line. */
  problems?: Maybe<Array<CheckoutLineProblem>>;
  /** The quantity of product variant assigned to the checkout line. */
  quantity: Scalars['Int']['output'];
  /** Indicates whether the item need to be delivered. */
  requiresShipping: Scalars['Boolean']['output'];
  /**
   * The sum of the checkout line price, taxes and discounts.
   *
   * Triggers the following webhook events:
   * - CHECKOUT_CALCULATE_TAXES (sync): Optionally triggered when checkout prices are expired.
   */
  totalPrice: TaxedMoney;
  /** The sum of the checkout line price, without discounts. */
  undiscountedTotalPrice: Money;
  /** The unit price of the checkout line, without discounts. */
  undiscountedUnitPrice: Money;
  /**
   * The unit price of the checkout line, with taxes and discounts.
   *
   * Triggers the following webhook events:
   * - CHECKOUT_CALCULATE_TAXES (sync): Optionally triggered when checkout prices are expired.
   */
  unitPrice: TaxedMoney;
  /** The product variant from which the checkout line was created. */
  variant: ProductVariant;
};


/** Represents an item in the checkout. */
export type CheckoutLineMetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Represents an item in the checkout. */
export type CheckoutLineMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Represents an item in the checkout. */
export type CheckoutLinePrivateMetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Represents an item in the checkout. */
export type CheckoutLinePrivateMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CheckoutLineCountableConnection = {
  __typename?: 'CheckoutLineCountableConnection';
  edges: Array<CheckoutLineCountableEdge>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** A total count of items in the collection. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type CheckoutLineCountableEdge = {
  __typename?: 'CheckoutLineCountableEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CheckoutLine;
};

/**
 * Deletes a CheckoutLine.
 *
 * Triggers the following webhook events:
 * - CHECKOUT_UPDATED (async): A checkout was updated.
 */
export type CheckoutLineDelete = {
  __typename?: 'CheckoutLineDelete';
  /** An updated checkout. */
  checkout?: Maybe<Checkout>;
  /** @deprecated Use `errors` field instead. */
  checkoutErrors: Array<CheckoutError>;
  errors: Array<CheckoutError>;
};

export type CheckoutLineInput = {
  /** Flag that allow force splitting the same variant into multiple lines by skipping the matching logic.  */
  forceNewLine?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Fields required to update the object's metadata. Can be read by any API client authorized to read the object it's attached to.
   *
   * Warning: never store sensitive information, including financial data such as credit card details.
   */
  metadata?: InputMaybe<Array<MetadataInput>>;
  /** Custom price of the item. Can be set only by apps with `HANDLE_CHECKOUTS` permission. When the line with the same variant will be provided multiple times, the last price will be used. */
  price?: InputMaybe<Scalars['PositiveDecimal']['input']>;
  /** The number of items purchased. */
  quantity: Scalars['Int']['input'];
  /** ID of the product variant. */
  variantId: Scalars['ID']['input'];
};

/** Represents an problem in the checkout line. */
export type CheckoutLineProblem = CheckoutLineProblemInsufficientStock | CheckoutLineProblemVariantNotAvailable;

/** Indicates insufficient stock for a given checkout line.Placing the order will not be possible until solving this problem. */
export type CheckoutLineProblemInsufficientStock = {
  __typename?: 'CheckoutLineProblemInsufficientStock';
  /** Available quantity of a variant. */
  availableQuantity?: Maybe<Scalars['Int']['output']>;
  /** The line that has variant with insufficient stock. */
  line: CheckoutLine;
  /** The variant with insufficient stock. */
  variant: ProductVariant;
};

/** The variant assigned to the checkout line is not available.Placing the order will not be possible until solving this problem. */
export type CheckoutLineProblemVariantNotAvailable = {
  __typename?: 'CheckoutLineProblemVariantNotAvailable';
  /** The line that has variant that is not available. */
  line: CheckoutLine;
};

export type CheckoutLineUpdateInput = {
  /** ID of the line. */
  lineId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * Checkout line public metadata. Will add and update keys. To delete keys use deleteMetadata mutation.
   *
   * Added in Saleor 3.21. Can be read by any API client authorized to read the object it's attached to.
   *
   * Warning: never store sensitive information, including financial data such as credit card details.
   */
  metadata?: InputMaybe<Array<MetadataInput>>;
  /** Custom price of the item. Can be set only by apps with `HANDLE_CHECKOUTS` permission. When the line with the same variant will be provided multiple times, the last price will be used. */
  price?: InputMaybe<Scalars['PositiveDecimal']['input']>;
  /** The number of items purchased. Optional for apps, required for any other users. */
  quantity?: InputMaybe<Scalars['Int']['input']>;
  /**
   * ID of the product variant.
   *
   * DEPRECATED: this field will be removed. Use `lineId` instead.
   */
  variantId?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * Adds a checkout line to the existing checkout.If line was already in checkout, its quantity will be increased.
 *
 * Triggers the following webhook events:
 * - CHECKOUT_UPDATED (async): A checkout was updated.
 */
export type CheckoutLinesAdd = {
  __typename?: 'CheckoutLinesAdd';
  /** An updated checkout. */
  checkout?: Maybe<Checkout>;
  /** @deprecated Use `errors` field instead. */
  checkoutErrors: Array<CheckoutError>;
  errors: Array<CheckoutError>;
};

/**
 * Deletes checkout lines.
 *
 * Triggers the following webhook events:
 * - CHECKOUT_UPDATED (async): A checkout was updated.
 */
export type CheckoutLinesDelete = {
  __typename?: 'CheckoutLinesDelete';
  /** An updated checkout. */
  checkout?: Maybe<Checkout>;
  errors: Array<CheckoutError>;
};

/**
 * Updates checkout line in the existing checkout.
 *
 * Triggers the following webhook events:
 * - CHECKOUT_UPDATED (async): A checkout was updated.
 */
export type CheckoutLinesUpdate = {
  __typename?: 'CheckoutLinesUpdate';
  /** An updated checkout. */
  checkout?: Maybe<Checkout>;
  /** @deprecated Use `errors` field instead. */
  checkoutErrors: Array<CheckoutError>;
  errors: Array<CheckoutError>;
};

/** Event sent when checkout metadata is updated. */
export type CheckoutMetadataUpdated = Event & {
  __typename?: 'CheckoutMetadataUpdated';
  /** The checkout the event relates to. */
  checkout?: Maybe<Checkout>;
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<IssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient?: Maybe<App>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

/** Creates a new payment for given checkout. */
export type CheckoutPaymentCreate = {
  __typename?: 'CheckoutPaymentCreate';
  /** Related checkout object. */
  checkout?: Maybe<Checkout>;
  errors: Array<PaymentError>;
  /** A newly created payment. */
  payment?: Maybe<Payment>;
  /** @deprecated Use `errors` field instead. */
  paymentErrors: Array<PaymentError>;
};

/** Represents an problem in the checkout. */
export type CheckoutProblem = CheckoutLineProblemInsufficientStock | CheckoutLineProblemVariantNotAvailable;

/**
 * Remove a gift card or a voucher from a checkout.
 *
 * Triggers the following webhook events:
 * - CHECKOUT_UPDATED (async): A checkout was updated.
 */
export type CheckoutRemovePromoCode = {
  __typename?: 'CheckoutRemovePromoCode';
  /** The checkout with the removed gift card or voucher. */
  checkout?: Maybe<Checkout>;
  /** @deprecated Use `errors` field instead. */
  checkoutErrors: Array<CheckoutError>;
  errors: Array<CheckoutError>;
};

/** Represents the channel-specific checkout settings. */
export type CheckoutSettings = {
  __typename?: 'CheckoutSettings';
  /**
   * The date time defines the earliest checkout creation date on which fully paid checkouts can begin to be automatically completed.
   *
   * Added in Saleor 3.22.
   */
  automaticCompletionCutOffDate?: Maybe<Scalars['DateTime']['output']>;
  /**
   * The time in minutes to wait after a checkout is fully paid before automatically completing it.
   *
   * Added in Saleor 3.22.
   */
  automaticCompletionDelay?: Maybe<Scalars['Minute']['output']>;
  /**
   * Default `false`. Determines if the paid checkouts should be automatically completed. This setting applies only to checkouts where payment was processed through transactions.When enabled, the checkout will be automatically completed once the checkout `charge_status` reaches `FULL`. This occurs when the total sum of charged and authorized transaction amounts equals or exceeds the checkout's total amount.
   *
   * Added in Saleor 3.20.
   */
  automaticallyCompleteFullyPaidCheckouts: Scalars['Boolean']['output'];
  /**
   * Default `true`. Determines if the checkout mutations should use legacy error flow. In legacy flow, all mutations can raise an exception unrelated to the requested action - (e.g. out-of-stock exception when updating checkoutShippingAddress.) If `false`, the errors will be aggregated in `checkout.problems` field. Some of the `problems` can block the finalizing checkout process. The legacy flow will be removed in Saleor 4.0. The flow with `checkout.problems` will be the default one.
   *
   * DEPRECATED: this field will be removed.
   */
  useLegacyErrorFlow: Scalars['Boolean']['output'];
};

export type CheckoutSettingsInput = {
  /**
   * Settings for automatic completion of fully paid checkouts.
   *
   * Added in Saleor 3.22.
   */
  automaticCompletion?: InputMaybe<CheckoutAutoCompleteInput>;
  /**
   * Default `false`. Determines if the paid checkouts should be automatically completed. This setting applies only to checkouts where payment was processed through transactions.When enabled, the checkout will be automatically completed once the checkout `authorize_status` reaches `FULL`. This occurs when the total sum of charged and authorized transaction amounts equals or exceeds the checkout's total amount.
   *
   * Added in Saleor 3.20.
   *
   * DEPRECATED: this field will be removed. Use `automatic_completion` instead.
   */
  automaticallyCompleteFullyPaidCheckouts?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Default `true`. Determines if the checkout mutations should use legacy error flow. In legacy flow, all mutations can raise an exception unrelated to the requested action - (e.g. out-of-stock exception when updating checkoutShippingAddress.) If `false`, the errors will be aggregated in `checkout.problems` field. Some of the `problems` can block the finalizing checkout process. The legacy flow will be removed in Saleor 4.0. The flow with `checkout.problems` will be the default one.
   *
   * DEPRECATED: this field will be removed.
   */
  useLegacyErrorFlow?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * Updates shipping address in the existing checkout.
 *
 * Triggers the following webhook events:
 * - CHECKOUT_UPDATED (async): A checkout was updated.
 */
export type CheckoutShippingAddressUpdate = {
  __typename?: 'CheckoutShippingAddressUpdate';
  /** An updated checkout. */
  checkout?: Maybe<Checkout>;
  /** @deprecated Use `errors` field instead. */
  checkoutErrors: Array<CheckoutError>;
  errors: Array<CheckoutError>;
};

/**
 * Updates the shipping method of the checkout.
 *
 * Triggers the following webhook events:
 * - SHIPPING_LIST_METHODS_FOR_CHECKOUT (sync): Triggered when updating the checkout shipping method with the external one.
 * - CHECKOUT_UPDATED (async): A checkout was updated.
 */
export type CheckoutShippingMethodUpdate = {
  __typename?: 'CheckoutShippingMethodUpdate';
  /** An updated checkout. */
  checkout?: Maybe<Checkout>;
  /** @deprecated Use `errors` field instead. */
  checkoutErrors: Array<CheckoutError>;
  errors: Array<CheckoutError>;
};

export type CheckoutSortField =
  /** Sort checkouts by creation date. */
  | 'CREATION_DATE'
  /** Sort checkouts by customer. */
  | 'CUSTOMER'
  /** Sort checkouts by payment. */
  | 'PAYMENT';

export type CheckoutSortingInput = {
  /** Specifies the direction in which to sort checkouts. */
  direction: OrderDirection;
  /** Sort checkouts by the selected field. */
  field: CheckoutSortField;
};

/** Event sent when checkout is updated. */
export type CheckoutUpdated = Event & {
  __typename?: 'CheckoutUpdated';
  /** The checkout the event relates to. */
  checkout?: Maybe<Checkout>;
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<IssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient?: Maybe<App>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

export type CheckoutValidationRules = {
  /** The validation rules that can be applied to provided billing address data. */
  billingAddress?: InputMaybe<CheckoutAddressValidationRules>;
  /** The validation rules that can be applied to provided shipping address data. */
  shippingAddress?: InputMaybe<CheckoutAddressValidationRules>;
};

export type ChoiceValue = {
  __typename?: 'ChoiceValue';
  /** The raw name of the choice. */
  raw?: Maybe<Scalars['String']['output']>;
  /** The verbose name of the choice. */
  verbose?: Maybe<Scalars['String']['output']>;
};

/** Enum determining the state of a circuit breaker. */
export type CircuitBreakerStateEnum =
  /** The breaker is conducting (requests are passing through). */
  | 'CLOSED'
  /** The breaker is in a trial period (to close or open). Note that unlike classic breaker patterns, this is not a state where we are throttling the number of requests, it's a state similar to CLOSED but with different thresholds. */
  | 'HALF_OPEN'
  /** The breaker is tripped (no requests are passing). Breaker will enter half-open state after cooldown period. */
  | 'OPEN';

/** Represents a collection of products. */
export type Collection = Node & ObjectWithMetadata & {
  __typename?: 'Collection';
  /** Background image of the collection. */
  backgroundImage?: Maybe<Image>;
  /** Channel given to retrieve this collection. Also used by federation gateway to resolve this object in a federated query. */
  channel?: Maybe<Scalars['String']['output']>;
  /**
   * List of channels in which the collection is available.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  channelListings?: Maybe<Array<CollectionChannelListing>>;
  /**
   * Description of the collection.
   *
   * Rich text format. For reference see https://editorjs.io/
   */
  description?: Maybe<Scalars['JSONString']['output']>;
  /**
   * Description of the collection.
   *
   * Rich text format. For reference see https://editorjs.io/
   * @deprecated Use the `description` field instead.
   */
  descriptionJson?: Maybe<Scalars['JSONString']['output']>;
  /** The ID of the collection. */
  id: Scalars['ID']['output'];
  /** List of public metadata items. Can be accessed without permissions. */
  metadata: Array<MetadataItem>;
  /**
   * A single key from public metadata.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   */
  metafield?: Maybe<Scalars['String']['output']>;
  /** Public metadata. Use `keys` to control which fields you want to include. The default is to include everything. */
  metafields?: Maybe<Scalars['Metadata']['output']>;
  /** Name of the collection. */
  name: Scalars['String']['output'];
  /** List of private metadata items. Requires staff permissions to access. */
  privateMetadata: Array<MetadataItem>;
  /**
   * A single key from private metadata. Requires staff permissions to access.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   */
  privateMetafield?: Maybe<Scalars['String']['output']>;
  /** Private metadata. Requires staff permissions to access. Use `keys` to control which fields you want to include. The default is to include everything. */
  privateMetafields?: Maybe<Scalars['Metadata']['output']>;
  /** List of products in this collection. */
  products?: Maybe<ProductCountableConnection>;
  /** SEO description of the collection. */
  seoDescription?: Maybe<Scalars['String']['output']>;
  /** SEO title of the collection. */
  seoTitle?: Maybe<Scalars['String']['output']>;
  /** Slug of the collection. */
  slug: Scalars['String']['output'];
  /** Returns translated collection fields for the given language code. */
  translation?: Maybe<CollectionTranslation>;
};


/** Represents a collection of products. */
export type CollectionBackgroundImageArgs = {
  format?: InputMaybe<ThumbnailFormatEnum>;
  size?: InputMaybe<Scalars['Int']['input']>;
};


/** Represents a collection of products. */
export type CollectionMetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Represents a collection of products. */
export type CollectionMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Represents a collection of products. */
export type CollectionPrivateMetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Represents a collection of products. */
export type CollectionPrivateMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Represents a collection of products. */
export type CollectionProductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ProductFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<ProductOrder>;
  where?: InputMaybe<ProductWhereInput>;
};


/** Represents a collection of products. */
export type CollectionTranslationArgs = {
  languageCode: LanguageCodeEnum;
};

/**
 * Adds products to a collection.
 *
 * Requires one of the following permissions: MANAGE_PRODUCTS.
 */
export type CollectionAddProducts = {
  __typename?: 'CollectionAddProducts';
  /** Collection to which products will be added. */
  collection?: Maybe<Collection>;
  /** @deprecated Use `errors` field instead. */
  collectionErrors: Array<CollectionError>;
  errors: Array<CollectionError>;
};

/**
 * Deletes collections.
 *
 * Requires one of the following permissions: MANAGE_PRODUCTS.
 */
export type CollectionBulkDelete = {
  __typename?: 'CollectionBulkDelete';
  /** @deprecated Use `errors` field instead. */
  collectionErrors: Array<CollectionError>;
  /** Returns how many objects were affected. */
  count: Scalars['Int']['output'];
  errors: Array<CollectionError>;
};

/** Represents collection channel listing. */
export type CollectionChannelListing = Node & {
  __typename?: 'CollectionChannelListing';
  /** The channel to which the collection belongs. */
  channel: Channel;
  /** The ID of the collection channel listing. */
  id: Scalars['ID']['output'];
  /** Indicates if the collection is published in the channel. */
  isPublished: Scalars['Boolean']['output'];
  /** @deprecated Use the `publishedAt` field to fetch the publication date. */
  publicationDate?: Maybe<Scalars['Date']['output']>;
  /** The collection publication date. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CollectionChannelListingError = {
  __typename?: 'CollectionChannelListingError';
  /** List of attributes IDs which causes the error. */
  attributes?: Maybe<Array<Scalars['ID']['output']>>;
  /** List of channels IDs which causes the error. */
  channels?: Maybe<Array<Scalars['ID']['output']>>;
  /** The error code. */
  code: ProductErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field?: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message?: Maybe<Scalars['String']['output']>;
  /** List of attribute values IDs which causes the error. */
  values?: Maybe<Array<Scalars['ID']['output']>>;
};

/**
 * Manage collection's availability in channels.
 *
 * Requires one of the following permissions: MANAGE_PRODUCTS.
 */
export type CollectionChannelListingUpdate = {
  __typename?: 'CollectionChannelListingUpdate';
  /** An updated collection instance. */
  collection?: Maybe<Collection>;
  /** @deprecated Use `errors` field instead. */
  collectionChannelListingErrors: Array<CollectionChannelListingError>;
  errors: Array<CollectionChannelListingError>;
};

export type CollectionChannelListingUpdateInput = {
  /** List of channels to which the collection should be assigned. */
  addChannels?: InputMaybe<Array<PublishableChannelListingInput>>;
  /** List of channels from which the collection should be unassigned. */
  removeChannels?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** Represents a connection to a list of collections. */
export type CollectionCountableConnection = {
  __typename?: 'CollectionCountableConnection';
  edges: Array<CollectionCountableEdge>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** A total count of items in the collection. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type CollectionCountableEdge = {
  __typename?: 'CollectionCountableEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Collection;
};

/**
 * Creates a new collection.
 *
 * Requires one of the following permissions: MANAGE_PRODUCTS.
 */
export type CollectionCreate = {
  __typename?: 'CollectionCreate';
  collection?: Maybe<Collection>;
  /** @deprecated Use `errors` field instead. */
  collectionErrors: Array<CollectionError>;
  errors: Array<CollectionError>;
};

export type CollectionCreateInput = {
  /** Background image file. */
  backgroundImage?: InputMaybe<Scalars['Upload']['input']>;
  /** Alt text for an image. */
  backgroundImageAlt?: InputMaybe<Scalars['String']['input']>;
  /**
   * Description of the collection.
   *
   * Rich text format. For reference see https://editorjs.io/
   */
  description?: InputMaybe<Scalars['JSONString']['input']>;
  /** Informs whether a collection is published. */
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Fields required to update the collection metadata. Can be read by any API client authorized to read the object it's attached to.
   *
   * Warning: never store sensitive information, including financial data such as credit card details.
   */
  metadata?: InputMaybe<Array<MetadataInput>>;
  /** Name of the collection. */
  name?: InputMaybe<Scalars['String']['input']>;
  /**
   * Fields required to update the collection private metadata. Requires permissions to modify and to read the metadata of the object it's attached to.
   *
   * Warning: never store sensitive information, including financial data such as credit card details.
   */
  privateMetadata?: InputMaybe<Array<MetadataInput>>;
  /** List of products to be added to the collection. */
  products?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**
   * Publication date. ISO 8601 standard.
   *
   * DEPRECATED: this field will be removed.
   */
  publicationDate?: InputMaybe<Scalars['Date']['input']>;
  /** Search engine optimization fields. */
  seo?: InputMaybe<SeoInput>;
  /** Slug of the collection. */
  slug?: InputMaybe<Scalars['String']['input']>;
};

/** Event sent when new collection is created. */
export type CollectionCreated = Event & {
  __typename?: 'CollectionCreated';
  /** The collection the event relates to. */
  collection?: Maybe<Collection>;
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<IssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient?: Maybe<App>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};


/** Event sent when new collection is created. */
export type CollectionCreatedCollectionArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Deletes a collection.
 *
 * Requires one of the following permissions: MANAGE_PRODUCTS.
 */
export type CollectionDelete = {
  __typename?: 'CollectionDelete';
  collection?: Maybe<Collection>;
  /** @deprecated Use `errors` field instead. */
  collectionErrors: Array<CollectionError>;
  errors: Array<CollectionError>;
};

/** Event sent when collection is deleted. */
export type CollectionDeleted = Event & {
  __typename?: 'CollectionDeleted';
  /** The collection the event relates to. */
  collection?: Maybe<Collection>;
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<IssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient?: Maybe<App>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};


/** Event sent when collection is deleted. */
export type CollectionDeletedCollectionArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
};

export type CollectionError = {
  __typename?: 'CollectionError';
  /** The error code. */
  code: CollectionErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field?: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message?: Maybe<Scalars['String']['output']>;
  /** List of products IDs which causes the error. */
  products?: Maybe<Array<Scalars['ID']['output']>>;
};

export type CollectionErrorCode =
  | 'CANNOT_MANAGE_PRODUCT_WITHOUT_VARIANT'
  | 'DUPLICATED_INPUT_ITEM'
  | 'FILE_SIZE_LIMIT_EXCEEDED'
  | 'GRAPHQL_ERROR'
  | 'INVALID'
  | 'NOT_FOUND'
  | 'REQUIRED'
  | 'UNIQUE';

export type CollectionFilterInput = {
  /**
   * Specifies the channel by which the data should be filtered.
   *
   * DEPRECATED: this field will be removed. Use root-level channel argument instead.
   */
  channel?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  metadata?: InputMaybe<Array<MetadataFilter>>;
  published?: InputMaybe<CollectionPublished>;
  search?: InputMaybe<Scalars['String']['input']>;
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CollectionInput = {
  /** Background image file. */
  backgroundImage?: InputMaybe<Scalars['Upload']['input']>;
  /** Alt text for an image. */
  backgroundImageAlt?: InputMaybe<Scalars['String']['input']>;
  /**
   * Description of the collection.
   *
   * Rich text format. For reference see https://editorjs.io/
   */
  description?: InputMaybe<Scalars['JSONString']['input']>;
  /** Informs whether a collection is published. */
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Fields required to update the collection metadata. Can be read by any API client authorized to read the object it's attached to.
   *
   * Warning: never store sensitive information, including financial data such as credit card details.
   */
  metadata?: InputMaybe<Array<MetadataInput>>;
  /** Name of the collection. */
  name?: InputMaybe<Scalars['String']['input']>;
  /**
   * Fields required to update the collection private metadata. Requires permissions to modify and to read the metadata of the object it's attached to.
   *
   * Warning: never store sensitive information, including financial data such as credit card details.
   */
  privateMetadata?: InputMaybe<Array<MetadataInput>>;
  /**
   * Publication date. ISO 8601 standard.
   *
   * DEPRECATED: this field will be removed.
   */
  publicationDate?: InputMaybe<Scalars['Date']['input']>;
  /** Search engine optimization fields. */
  seo?: InputMaybe<SeoInput>;
  /** Slug of the collection. */
  slug?: InputMaybe<Scalars['String']['input']>;
};

/** Event sent when collection metadata is updated. */
export type CollectionMetadataUpdated = Event & {
  __typename?: 'CollectionMetadataUpdated';
  /** The collection the event relates to. */
  collection?: Maybe<Collection>;
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<IssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient?: Maybe<App>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};


/** Event sent when collection metadata is updated. */
export type CollectionMetadataUpdatedCollectionArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
};

export type CollectionPublished =
  | 'HIDDEN'
  | 'PUBLISHED';

/**
 * Remove products from a collection.
 *
 * Requires one of the following permissions: MANAGE_PRODUCTS.
 */
export type CollectionRemoveProducts = {
  __typename?: 'CollectionRemoveProducts';
  /** Collection from which products will be removed. */
  collection?: Maybe<Collection>;
  /** @deprecated Use `errors` field instead. */
  collectionErrors: Array<CollectionError>;
  errors: Array<CollectionError>;
};

/**
 * Reorder the products of a collection.
 *
 * Requires one of the following permissions: MANAGE_PRODUCTS.
 */
export type CollectionReorderProducts = {
  __typename?: 'CollectionReorderProducts';
  /** Collection from which products are reordered. */
  collection?: Maybe<Collection>;
  /** @deprecated Use `errors` field instead. */
  collectionErrors: Array<CollectionError>;
  errors: Array<CollectionError>;
};

export type CollectionSortField =
  /**
   * Sort collections by availability.
   *
   * This option requires a channel filter to work as the values can vary between channels.
   */
  | 'AVAILABILITY'
  /** Sort collections by name. */
  | 'NAME'
  /** Sort collections by product count. */
  | 'PRODUCT_COUNT'
  /**
   * Sort collections by publication date.
   *
   * This option requires a channel filter to work as the values can vary between channels.
   */
  | 'PUBLICATION_DATE'
  /**
   * Sort collections by published at.
   *
   * This option requires a channel filter to work as the values can vary between channels.
   */
  | 'PUBLISHED_AT';

export type CollectionSortingInput = {
  /**
   * Specifies the channel in which to sort the data.
   *
   * DEPRECATED: this field will be removed. Use root-level channel argument instead.
   */
  channel?: InputMaybe<Scalars['String']['input']>;
  /** Specifies the direction in which to sort collections. */
  direction: OrderDirection;
  /** Sort collections by the selected field. */
  field: CollectionSortField;
};

/** Represents collection's original translatable fields and related translations. */
export type CollectionTranslatableContent = Node & {
  __typename?: 'CollectionTranslatableContent';
  /**
   * Represents a collection of products.
   * @deprecated Get model fields from the root level queries.
   */
  collection?: Maybe<Collection>;
  /** The ID of the collection to translate. */
  collectionId: Scalars['ID']['output'];
  /**
   * Collection's description to translate.
   *
   * Rich text format. For reference see https://editorjs.io/
   */
  description?: Maybe<Scalars['JSONString']['output']>;
  /**
   * Description of the collection.
   *
   * Rich text format. For reference see https://editorjs.io/
   * @deprecated Use the `description` field instead.
   */
  descriptionJson?: Maybe<Scalars['JSONString']['output']>;
  /** The ID of the collection translatable content. */
  id: Scalars['ID']['output'];
  /** Collection's name to translate. */
  name: Scalars['String']['output'];
  /** SEO description to translate. */
  seoDescription?: Maybe<Scalars['String']['output']>;
  /** SEO title to translate. */
  seoTitle?: Maybe<Scalars['String']['output']>;
  /**
   * Slug to translate
   *
   * Added in Saleor 3.21.
   */
  slug?: Maybe<Scalars['String']['output']>;
  /** Returns translated collection fields for the given language code. */
  translation?: Maybe<CollectionTranslation>;
};


/** Represents collection's original translatable fields and related translations. */
export type CollectionTranslatableContentTranslationArgs = {
  languageCode: LanguageCodeEnum;
};

/**
 * Creates/updates translations for a collection.
 *
 * Requires one of the following permissions: MANAGE_TRANSLATIONS.
 */
export type CollectionTranslate = {
  __typename?: 'CollectionTranslate';
  collection?: Maybe<Collection>;
  errors: Array<TranslationError>;
  /** @deprecated Use `errors` field instead. */
  translationErrors: Array<TranslationError>;
};

/** Represents collection translations. */
export type CollectionTranslation = Node & {
  __typename?: 'CollectionTranslation';
  /**
   * Translated description of the collection.
   *
   * Rich text format. For reference see https://editorjs.io/
   */
  description?: Maybe<Scalars['JSONString']['output']>;
  /**
   * Translated description of the collection.
   *
   * Rich text format. For reference see https://editorjs.io/
   * @deprecated Use the `description` field instead.
   */
  descriptionJson?: Maybe<Scalars['JSONString']['output']>;
  /** The ID of the collection translation. */
  id: Scalars['ID']['output'];
  /** Translation language. */
  language: LanguageDisplay;
  /** Translated collection name. */
  name?: Maybe<Scalars['String']['output']>;
  /** Translated SEO description. */
  seoDescription?: Maybe<Scalars['String']['output']>;
  /** Translated SEO title. */
  seoTitle?: Maybe<Scalars['String']['output']>;
  /**
   * Translated collection slug.
   *
   * Added in Saleor 3.21.
   */
  slug?: Maybe<Scalars['String']['output']>;
  /** Represents the collection fields to translate. */
  translatableContent?: Maybe<CollectionTranslatableContent>;
};

/**
 * Updates a collection.
 *
 * Requires one of the following permissions: MANAGE_PRODUCTS.
 */
export type CollectionUpdate = {
  __typename?: 'CollectionUpdate';
  collection?: Maybe<Collection>;
  /** @deprecated Use `errors` field instead. */
  collectionErrors: Array<CollectionError>;
  errors: Array<CollectionError>;
};

/** Event sent when collection is updated. */
export type CollectionUpdated = Event & {
  __typename?: 'CollectionUpdated';
  /** The collection the event relates to. */
  collection?: Maybe<Collection>;
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<IssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient?: Maybe<App>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};


/** Event sent when collection is updated. */
export type CollectionUpdatedCollectionArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
};

export type CollectionWhereInput = {
  /** List of conditions that must be met. */
  AND?: InputMaybe<Array<CollectionWhereInput>>;
  /** A list of conditions of which at least one must be met. */
  OR?: InputMaybe<Array<CollectionWhereInput>>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  metadata?: InputMaybe<Array<MetadataFilter>>;
};

/** Stores information about a single configuration field. */
export type ConfigurationItem = {
  __typename?: 'ConfigurationItem';
  /** Help text for the field. */
  helpText?: Maybe<Scalars['String']['output']>;
  /** Label for the field. */
  label?: Maybe<Scalars['String']['output']>;
  /** Name of the field. */
  name: Scalars['String']['output'];
  /** Type of the field. */
  type?: Maybe<ConfigurationTypeFieldEnum>;
  /** Current value of the field. */
  value?: Maybe<Scalars['String']['output']>;
};

export type ConfigurationItemInput = {
  /** Name of the field to update. */
  name: Scalars['String']['input'];
  /** Value of the given field to update. */
  value?: InputMaybe<Scalars['String']['input']>;
};

export type ConfigurationTypeFieldEnum =
  | 'BOOLEAN'
  | 'MULTILINE'
  | 'OUTPUT'
  | 'PASSWORD'
  | 'SECRET'
  | 'SECRETMULTILINE'
  | 'STRING';

/**
 * Confirm user account with token sent by email during registration.
 *
 * Triggers the following webhook events:
 * - ACCOUNT_CONFIRMED (async): Account was confirmed.
 */
export type ConfirmAccount = {
  __typename?: 'ConfirmAccount';
  /** @deprecated Use `errors` field instead. */
  accountErrors: Array<AccountError>;
  errors: Array<AccountError>;
  /** An activated user account. */
  user?: Maybe<User>;
};

/**
 * Confirm the email change of the logged-in user.
 *
 * Requires one of the following permissions: AUTHENTICATED_USER.
 *
 * Triggers the following webhook events:
 * - CUSTOMER_UPDATED (async): A customer account was updated.
 * - NOTIFY_USER (async): A notification that account email change was confirmed.
 * - ACCOUNT_EMAIL_CHANGED (async): An account email was changed.
 */
export type ConfirmEmailChange = {
  __typename?: 'ConfirmEmailChange';
  /** @deprecated Use `errors` field instead. */
  accountErrors: Array<AccountError>;
  errors: Array<AccountError>;
  /** A user instance with a new email. */
  user?: Maybe<User>;
};

/** Define the filtering options for fields that can contain multiple values. */
export type ContainsFilterInput = {
  /** The field contains all of the specified values. */
  containsAll?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The field contains at least one of the specified values. */
  containsAny?: InputMaybe<Array<Scalars['String']['input']>>;
};

/**
 * Represents country codes defined by the ISO 3166-1 alpha-2 standard.
 *
 * The `EU` value is DEPRECATED and will be removed in Saleor 3.21.
 */
export type CountryCode =
  /** Andorra */
  | 'AD'
  /** United Arab Emirates */
  | 'AE'
  /** Afghanistan */
  | 'AF'
  /** Antigua and Barbuda */
  | 'AG'
  /** Anguilla */
  | 'AI'
  /** Albania */
  | 'AL'
  /** Armenia */
  | 'AM'
  /** Angola */
  | 'AO'
  /** Antarctica */
  | 'AQ'
  /** Argentina */
  | 'AR'
  /** American Samoa */
  | 'AS'
  /** Austria */
  | 'AT'
  /** Australia */
  | 'AU'
  /** Aruba */
  | 'AW'
  /** Åland Islands */
  | 'AX'
  /** Azerbaijan */
  | 'AZ'
  /** Bosnia and Herzegovina */
  | 'BA'
  /** Barbados */
  | 'BB'
  /** Bangladesh */
  | 'BD'
  /** Belgium */
  | 'BE'
  /** Burkina Faso */
  | 'BF'
  /** Bulgaria */
  | 'BG'
  /** Bahrain */
  | 'BH'
  /** Burundi */
  | 'BI'
  /** Benin */
  | 'BJ'
  /** Saint Barthélemy */
  | 'BL'
  /** Bermuda */
  | 'BM'
  /** Brunei */
  | 'BN'
  /** Bolivia */
  | 'BO'
  /** Bonaire, Sint Eustatius and Saba */
  | 'BQ'
  /** Brazil */
  | 'BR'
  /** Bahamas */
  | 'BS'
  /** Bhutan */
  | 'BT'
  /** Bouvet Island */
  | 'BV'
  /** Botswana */
  | 'BW'
  /** Belarus */
  | 'BY'
  /** Belize */
  | 'BZ'
  /** Canada */
  | 'CA'
  /** Cocos (Keeling) Islands */
  | 'CC'
  /** Congo (the Democratic Republic of the) */
  | 'CD'
  /** Central African Republic */
  | 'CF'
  /** Congo */
  | 'CG'
  /** Switzerland */
  | 'CH'
  /** Côte d'Ivoire */
  | 'CI'
  /** Cook Islands */
  | 'CK'
  /** Chile */
  | 'CL'
  /** Cameroon */
  | 'CM'
  /** China */
  | 'CN'
  /** Colombia */
  | 'CO'
  /** Costa Rica */
  | 'CR'
  /** Cuba */
  | 'CU'
  /** Cabo Verde */
  | 'CV'
  /** Curaçao */
  | 'CW'
  /** Christmas Island */
  | 'CX'
  /** Cyprus */
  | 'CY'
  /** Czechia */
  | 'CZ'
  /** Germany */
  | 'DE'
  /** Djibouti */
  | 'DJ'
  /** Denmark */
  | 'DK'
  /** Dominica */
  | 'DM'
  /** Dominican Republic */
  | 'DO'
  /** Algeria */
  | 'DZ'
  /** Ecuador */
  | 'EC'
  /** Estonia */
  | 'EE'
  /** Egypt */
  | 'EG'
  /** Western Sahara */
  | 'EH'
  /** Eritrea */
  | 'ER'
  /** Spain */
  | 'ES'
  /** Ethiopia */
  | 'ET'
  /** European Union */
  | 'EU'
  /** Finland */
  | 'FI'
  /** Fiji */
  | 'FJ'
  /** Falkland Islands (Malvinas) */
  | 'FK'
  /** Micronesia */
  | 'FM'
  /** Faroe Islands */
  | 'FO'
  /** France */
  | 'FR'
  /** Gabon */
  | 'GA'
  /** United Kingdom */
  | 'GB'
  /** Grenada */
  | 'GD'
  /** Georgia */
  | 'GE'
  /** French Guiana */
  | 'GF'
  /** Guernsey */
  | 'GG'
  /** Ghana */
  | 'GH'
  /** Gibraltar */
  | 'GI'
  /** Greenland */
  | 'GL'
  /** Gambia */
  | 'GM'
  /** Guinea */
  | 'GN'
  /** Guadeloupe */
  | 'GP'
  /** Equatorial Guinea */
  | 'GQ'
  /** Greece */
  | 'GR'
  /** South Georgia and the South Sandwich Islands */
  | 'GS'
  /** Guatemala */
  | 'GT'
  /** Guam */
  | 'GU'
  /** Guinea-Bissau */
  | 'GW'
  /** Guyana */
  | 'GY'
  /** Hong Kong */
  | 'HK'
  /** Heard Island and McDonald Islands */
  | 'HM'
  /** Honduras */
  | 'HN'
  /** Croatia */
  | 'HR'
  /** Haiti */
  | 'HT'
  /** Hungary */
  | 'HU'
  /** Indonesia */
  | 'ID'
  /** Ireland */
  | 'IE'
  /** Israel */
  | 'IL'
  /** Isle of Man */
  | 'IM'
  /** India */
  | 'IN'
  /** British Indian Ocean Territory */
  | 'IO'
  /** Iraq */
  | 'IQ'
  /** Iran */
  | 'IR'
  /** Iceland */
  | 'IS'
  /** Italy */
  | 'IT'
  /** Jersey */
  | 'JE'
  /** Jamaica */
  | 'JM'
  /** Jordan */
  | 'JO'
  /** Japan */
  | 'JP'
  /** Kenya */
  | 'KE'
  /** Kyrgyzstan */
  | 'KG'
  /** Cambodia */
  | 'KH'
  /** Kiribati */
  | 'KI'
  /** Comoros */
  | 'KM'
  /** Saint Kitts and Nevis */
  | 'KN'
  /** North Korea */
  | 'KP'
  /** South Korea */
  | 'KR'
  /** Kuwait */
  | 'KW'
  /** Cayman Islands */
  | 'KY'
  /** Kazakhstan */
  | 'KZ'
  /** Laos */
  | 'LA'
  /** Lebanon */
  | 'LB'
  /** Saint Lucia */
  | 'LC'
  /** Liechtenstein */
  | 'LI'
  /** Sri Lanka */
  | 'LK'
  /** Liberia */
  | 'LR'
  /** Lesotho */
  | 'LS'
  /** Lithuania */
  | 'LT'
  /** Luxembourg */
  | 'LU'
  /** Latvia */
  | 'LV'
  /** Libya */
  | 'LY'
  /** Morocco */
  | 'MA'
  /** Monaco */
  | 'MC'
  /** Moldova */
  | 'MD'
  /** Montenegro */
  | 'ME'
  /** Saint Martin (French part) */
  | 'MF'
  /** Madagascar */
  | 'MG'
  /** Marshall Islands */
  | 'MH'
  /** North Macedonia */
  | 'MK'
  /** Mali */
  | 'ML'
  /** Myanmar */
  | 'MM'
  /** Mongolia */
  | 'MN'
  /** Macao */
  | 'MO'
  /** Northern Mariana Islands */
  | 'MP'
  /** Martinique */
  | 'MQ'
  /** Mauritania */
  | 'MR'
  /** Montserrat */
  | 'MS'
  /** Malta */
  | 'MT'
  /** Mauritius */
  | 'MU'
  /** Maldives */
  | 'MV'
  /** Malawi */
  | 'MW'
  /** Mexico */
  | 'MX'
  /** Malaysia */
  | 'MY'
  /** Mozambique */
  | 'MZ'
  /** Namibia */
  | 'NA'
  /** New Caledonia */
  | 'NC'
  /** Niger */
  | 'NE'
  /** Norfolk Island */
  | 'NF'
  /** Nigeria */
  | 'NG'
  /** Nicaragua */
  | 'NI'
  /** Netherlands */
  | 'NL'
  /** Norway */
  | 'NO'
  /** Nepal */
  | 'NP'
  /** Nauru */
  | 'NR'
  /** Niue */
  | 'NU'
  /** New Zealand */
  | 'NZ'
  /** Oman */
  | 'OM'
  /** Panama */
  | 'PA'
  /** Peru */
  | 'PE'
  /** French Polynesia */
  | 'PF'
  /** Papua New Guinea */
  | 'PG'
  /** Philippines */
  | 'PH'
  /** Pakistan */
  | 'PK'
  /** Poland */
  | 'PL'
  /** Saint Pierre and Miquelon */
  | 'PM'
  /** Pitcairn */
  | 'PN'
  /** Puerto Rico */
  | 'PR'
  /** Palestine, State of */
  | 'PS'
  /** Portugal */
  | 'PT'
  /** Palau */
  | 'PW'
  /** Paraguay */
  | 'PY'
  /** Qatar */
  | 'QA'
  /** Réunion */
  | 'RE'
  /** Romania */
  | 'RO'
  /** Serbia */
  | 'RS'
  /** Russia */
  | 'RU'
  /** Rwanda */
  | 'RW'
  /** Saudi Arabia */
  | 'SA'
  /** Solomon Islands */
  | 'SB'
  /** Seychelles */
  | 'SC'
  /** Sudan */
  | 'SD'
  /** Sweden */
  | 'SE'
  /** Singapore */
  | 'SG'
  /** Saint Helena, Ascension and Tristan da Cunha */
  | 'SH'
  /** Slovenia */
  | 'SI'
  /** Svalbard and Jan Mayen */
  | 'SJ'
  /** Slovakia */
  | 'SK'
  /** Sierra Leone */
  | 'SL'
  /** San Marino */
  | 'SM'
  /** Senegal */
  | 'SN'
  /** Somalia */
  | 'SO'
  /** Suriname */
  | 'SR'
  /** South Sudan */
  | 'SS'
  /** Sao Tome and Principe */
  | 'ST'
  /** El Salvador */
  | 'SV'
  /** Sint Maarten (Dutch part) */
  | 'SX'
  /** Syria */
  | 'SY'
  /** Eswatini */
  | 'SZ'
  /** Turks and Caicos Islands */
  | 'TC'
  /** Chad */
  | 'TD'
  /** French Southern Territories */
  | 'TF'
  /** Togo */
  | 'TG'
  /** Thailand */
  | 'TH'
  /** Tajikistan */
  | 'TJ'
  /** Tokelau */
  | 'TK'
  /** Timor-Leste */
  | 'TL'
  /** Turkmenistan */
  | 'TM'
  /** Tunisia */
  | 'TN'
  /** Tonga */
  | 'TO'
  /** Türkiye */
  | 'TR'
  /** Trinidad and Tobago */
  | 'TT'
  /** Tuvalu */
  | 'TV'
  /** Taiwan */
  | 'TW'
  /** Tanzania */
  | 'TZ'
  /** Ukraine */
  | 'UA'
  /** Uganda */
  | 'UG'
  /** United States Minor Outlying Islands */
  | 'UM'
  /** United States of America */
  | 'US'
  /** Uruguay */
  | 'UY'
  /** Uzbekistan */
  | 'UZ'
  /** Holy See */
  | 'VA'
  /** Saint Vincent and the Grenadines */
  | 'VC'
  /** Venezuela */
  | 'VE'
  /** Virgin Islands (British) */
  | 'VG'
  /** Virgin Islands (U.S.) */
  | 'VI'
  /** Vietnam */
  | 'VN'
  /** Vanuatu */
  | 'VU'
  /** Wallis and Futuna */
  | 'WF'
  /** Samoa */
  | 'WS'
  /** Kosovo */
  | 'XK'
  /** Yemen */
  | 'YE'
  /** Mayotte */
  | 'YT'
  /** South Africa */
  | 'ZA'
  /** Zambia */
  | 'ZM'
  /** Zimbabwe */
  | 'ZW';

/** Filter by country code. */
export type CountryCodeEnumFilterInput = {
  /** The value equal to. */
  eq?: InputMaybe<CountryCode>;
  /** The value not included in. */
  notOneOf?: InputMaybe<Array<CountryCode>>;
  /** The value included in. */
  oneOf?: InputMaybe<Array<CountryCode>>;
};

export type CountryDisplay = {
  __typename?: 'CountryDisplay';
  /** Country code. */
  code: Scalars['String']['output'];
  /** Country name. */
  country: Scalars['String']['output'];
  /**
   * Country tax.
   * @deprecated Always returns `null`. Use `TaxClassCountryRate` type to manage tax rates per country.
   */
  vat?: Maybe<Vat>;
};

export type CountryFilterInput = {
  /** Boolean for filtering countries by having shipping zone assigned.If 'true', return countries with shipping zone assigned.If 'false', return countries without any shipping zone assigned.If the argument is not provided (null), return all countries. */
  attachedToShippingZones?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CountryRateInput = {
  /** Country in which this rate applies. */
  countryCode: CountryCode;
  /** Tax rate value provided as percentage. Example: provide `23` to represent `23%` tax rate. */
  rate: Scalars['Float']['input'];
};

export type CountryRateUpdateInput = {
  /** Country in which this rate applies. */
  countryCode: CountryCode;
  /** Tax rate value provided as percentage. Example: provide `23` to represent `23%` tax rate. Provide `null` to remove the particular rate. */
  rate?: InputMaybe<Scalars['Float']['input']>;
};

/** Create JWT token. */
export type CreateToken = {
  __typename?: 'CreateToken';
  /** @deprecated Use `errors` field instead. */
  accountErrors: Array<AccountError>;
  /** CSRF token required to re-generate access token. */
  csrfToken?: Maybe<Scalars['String']['output']>;
  errors: Array<AccountError>;
  /** JWT refresh token, required to re-generate access token. */
  refreshToken?: Maybe<Scalars['String']['output']>;
  /** JWT token, required to authenticate. */
  token?: Maybe<Scalars['String']['output']>;
  /** A user instance. */
  user?: Maybe<User>;
};

export type CreditCard = {
  __typename?: 'CreditCard';
  /** Card brand. */
  brand: Scalars['String']['output'];
  /** Two-digit number representing the card’s expiration month. */
  expMonth?: Maybe<Scalars['Int']['output']>;
  /** Four-digit number representing the card’s expiration year. */
  expYear?: Maybe<Scalars['Int']['output']>;
  /** First 4 digits of the card number. */
  firstDigits?: Maybe<Scalars['String']['output']>;
  /** Last 4 digits of the card number. */
  lastDigits: Scalars['String']['output'];
};

/**
 * Deletes customers.
 *
 * Requires one of the following permissions: MANAGE_USERS.
 *
 * Triggers the following webhook events:
 * - CUSTOMER_DELETED (async): A customer account was deleted.
 */
export type CustomerBulkDelete = {
  __typename?: 'CustomerBulkDelete';
  /** @deprecated Use `errors` field instead. */
  accountErrors: Array<AccountError>;
  /** Returns how many objects were affected. */
  count: Scalars['Int']['output'];
  errors: Array<AccountError>;
};

export type CustomerBulkResult = {
  __typename?: 'CustomerBulkResult';
  /** Customer data. */
  customer?: Maybe<User>;
  /** List of errors that occurred during the update attempt. */
  errors?: Maybe<Array<CustomerBulkUpdateError>>;
};

/**
 * Updates customers.
 *
 * Requires one of the following permissions: MANAGE_USERS.
 *
 * Triggers the following webhook events:
 * - CUSTOMER_UPDATED (async): A customer account was updated.
 * - CUSTOMER_METADATA_UPDATED (async): Optionally called when customer's metadata was updated.
 */
export type CustomerBulkUpdate = {
  __typename?: 'CustomerBulkUpdate';
  /** Returns how many objects were created. */
  count: Scalars['Int']['output'];
  errors: Array<CustomerBulkUpdateError>;
  /** List of the updated customers. */
  results: Array<CustomerBulkResult>;
};

export type CustomerBulkUpdateError = {
  __typename?: 'CustomerBulkUpdateError';
  /** The error code. */
  code: CustomerBulkUpdateErrorCode;
  /** The error message. */
  message?: Maybe<Scalars['String']['output']>;
  /** Path to field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  path?: Maybe<Scalars['String']['output']>;
};

export type CustomerBulkUpdateErrorCode =
  | 'BLANK'
  | 'DUPLICATED_INPUT_ITEM'
  | 'GRAPHQL_ERROR'
  | 'INVALID'
  | 'MAX_LENGTH'
  | 'NOT_FOUND'
  | 'REQUIRED'
  | 'UNIQUE';

export type CustomerBulkUpdateInput = {
  /** External ID of a customer to update. */
  externalReference?: InputMaybe<Scalars['String']['input']>;
  /** ID of a customer to update. */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Fields required to update a customer. */
  input: CustomerInput;
};

/**
 * Creates a new customer.
 *
 * Requires one of the following permissions: MANAGE_USERS.
 *
 * Triggers the following webhook events:
 * - CUSTOMER_CREATED (async): A new customer account was created.
 * - CUSTOMER_METADATA_UPDATED (async): Optionally called when customer's metadata was updated.
 * - NOTIFY_USER (async): A notification for setting the password.
 * - ACCOUNT_SET_PASSWORD_REQUESTED (async): Setting a new password for the account is requested.
 */
export type CustomerCreate = {
  __typename?: 'CustomerCreate';
  /** @deprecated Use `errors` field instead. */
  accountErrors: Array<AccountError>;
  errors: Array<AccountError>;
  user?: Maybe<User>;
};

/** Event sent when new customer user is created. */
export type CustomerCreated = Event & {
  __typename?: 'CustomerCreated';
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<IssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient?: Maybe<App>;
  /** The user the event relates to. */
  user?: Maybe<User>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

/**
 * Deletes a customer.
 *
 * Requires one of the following permissions: MANAGE_USERS.
 *
 * Triggers the following webhook events:
 * - CUSTOMER_DELETED (async): A customer account was deleted.
 */
export type CustomerDelete = {
  __typename?: 'CustomerDelete';
  /** @deprecated Use `errors` field instead. */
  accountErrors: Array<AccountError>;
  errors: Array<AccountError>;
  user?: Maybe<User>;
};

/** History log of the customer. */
export type CustomerEvent = Node & {
  __typename?: 'CustomerEvent';
  /** App that performed the action. */
  app?: Maybe<App>;
  /** Number of objects concerned by the event. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Date when event happened at in ISO 8601 format. */
  date?: Maybe<Scalars['DateTime']['output']>;
  /** The ID of the customer event. */
  id: Scalars['ID']['output'];
  /** Content of the event. */
  message?: Maybe<Scalars['String']['output']>;
  /** The concerned order. */
  order?: Maybe<Order>;
  /** The concerned order line. */
  orderLine?: Maybe<OrderLine>;
  /** Customer event type. */
  type?: Maybe<CustomerEventsEnum>;
  /** User who performed the action. */
  user?: Maybe<User>;
};

export type CustomerEventsEnum =
  | 'ACCOUNT_ACTIVATED'
  | 'ACCOUNT_CREATED'
  | 'ACCOUNT_DEACTIVATED'
  | 'CUSTOMER_DELETED'
  | 'DIGITAL_LINK_DOWNLOADED'
  | 'EMAIL_ASSIGNED'
  | 'EMAIL_CHANGED'
  | 'EMAIL_CHANGED_REQUEST'
  | 'NAME_ASSIGNED'
  | 'NOTE_ADDED'
  | 'NOTE_ADDED_TO_ORDER'
  | 'PASSWORD_CHANGED'
  | 'PASSWORD_RESET'
  | 'PASSWORD_RESET_LINK_SENT'
  | 'PLACED_ORDER';

export type CustomerFilterInput = {
  dateJoined?: InputMaybe<DateRangeInput>;
  /** Filter by ids. */
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  metadata?: InputMaybe<Array<MetadataFilter>>;
  numberOfOrders?: InputMaybe<IntRangeInput>;
  placedOrders?: InputMaybe<DateRangeInput>;
  search?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<DateTimeRangeInput>;
};

export type CustomerInput = {
  /** Billing address of the customer. */
  defaultBillingAddress?: InputMaybe<AddressInput>;
  /** Shipping address of the customer. */
  defaultShippingAddress?: InputMaybe<AddressInput>;
  /** The unique email address of the user. */
  email?: InputMaybe<Scalars['String']['input']>;
  /** External ID of the customer. */
  externalReference?: InputMaybe<Scalars['String']['input']>;
  /** Given name. */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** User account is active. */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** User account is confirmed. */
  isConfirmed?: InputMaybe<Scalars['Boolean']['input']>;
  /** User language code. */
  languageCode?: InputMaybe<LanguageCodeEnum>;
  /** Family name. */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /**
   * Fields required to update the user metadata. Can be read by any API client authorized to read the object it's attached to.
   *
   * Warning: never store sensitive information, including financial data such as credit card details.
   */
  metadata?: InputMaybe<Array<MetadataInput>>;
  /** A note about the user. */
  note?: InputMaybe<Scalars['String']['input']>;
  /**
   * Fields required to update the user private metadata. Requires permissions to modify and to read the metadata of the object it's attached to.
   *
   * Warning: never store sensitive information, including financial data such as credit card details.
   */
  privateMetadata?: InputMaybe<Array<MetadataInput>>;
};

/** Event sent when customer user metadata is updated. */
export type CustomerMetadataUpdated = Event & {
  __typename?: 'CustomerMetadataUpdated';
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<IssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient?: Maybe<App>;
  /** The user the event relates to. */
  user?: Maybe<User>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

export type CustomerOrderWhereInput = {
  /** List of conditions that must be met. */
  AND?: InputMaybe<Array<CustomerOrderWhereInput>>;
  /** A list of conditions of which at least one must be met. */
  OR?: InputMaybe<Array<CustomerOrderWhereInput>>;
  /** Filter by authorize status. */
  authorizeStatus?: InputMaybe<OrderAuthorizeStatusEnumFilterInput>;
  /** Filter by billing address of the order. */
  billingAddress?: InputMaybe<AddressFilterInput>;
  /** Filter by channel. */
  channelId?: InputMaybe<GlobalIdFilterInput>;
  /** Filter by charge status. */
  chargeStatus?: InputMaybe<OrderChargeStatusEnumFilterInput>;
  /** Filter by checkout id. */
  checkoutId?: InputMaybe<GlobalIdFilterInput>;
  /** Filter by checkout token. */
  checkoutToken?: InputMaybe<UuidFilterInput>;
  /** Filter order by created at date. */
  createdAt?: InputMaybe<DateTimeRangeInput>;
  /** Filter by whether the order has any fulfillments. */
  hasFulfillments?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by whether the order has any invoices. */
  hasInvoices?: InputMaybe<Scalars['Boolean']['input']>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter by invoice data associated with the order. Each list item represents conditions that must be satisfied by a single object. The filter matches orders that have related objects meeting all specified groups of conditions. */
  invoices?: InputMaybe<Array<InvoiceFilterInput>>;
  /** Filter by whether the order uses the click and collect delivery method. */
  isClickAndCollect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter based on whether the order includes a gift card purchase. */
  isGiftCardBought?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter based on whether a gift card was used in the order. */
  isGiftCardUsed?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by number of lines in the order. */
  linesCount?: InputMaybe<IntFilterInput>;
  /** Filter by metadata fields. */
  metadata?: InputMaybe<MetadataFilterInput>;
  /** Filter by order number. */
  number?: InputMaybe<IntFilterInput>;
  /** Filter by the product type of related order lines. */
  productTypeId?: InputMaybe<GlobalIdFilterInput>;
  /** Filter by shipping address of the order. */
  shippingAddress?: InputMaybe<AddressFilterInput>;
  /** Filter by order status. */
  status?: InputMaybe<OrderStatusEnumFilterInput>;
  /** Filter by total gross amount of the order. */
  totalGross?: InputMaybe<PriceFilterInput>;
  /** Filter by total net amount of the order. */
  totalNet?: InputMaybe<PriceFilterInput>;
  /** Filter order by updated at date. */
  updatedAt?: InputMaybe<DateTimeRangeInput>;
  /** Filter by user email. */
  userEmail?: InputMaybe<StringFilterInput>;
  /** Filter by voucher code used in the order. */
  voucherCode?: InputMaybe<StringFilterInput>;
};

/**
 * Updates an existing customer.
 *
 * Requires one of the following permissions: MANAGE_USERS.
 *
 * Triggers the following webhook events:
 * - CUSTOMER_UPDATED (async): A new customer account was updated.
 * - CUSTOMER_METADATA_UPDATED (async): Optionally called when customer's metadata was updated.
 */
export type CustomerUpdate = {
  __typename?: 'CustomerUpdate';
  /** @deprecated Use `errors` field instead. */
  accountErrors: Array<AccountError>;
  errors: Array<AccountError>;
  user?: Maybe<User>;
};

/** Event sent when customer user is updated. */
export type CustomerUpdated = Event & {
  __typename?: 'CustomerUpdated';
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<IssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient?: Maybe<App>;
  /** The user the event relates to. */
  user?: Maybe<User>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

export type CustomerWhereInput = {
  /** List of conditions that must be met. */
  AND?: InputMaybe<Array<CustomerWhereInput>>;
  /** A list of conditions of which at least one must be met. */
  OR?: InputMaybe<Array<CustomerWhereInput>>;
  /** Filter by addresses data associated with user. */
  addresses?: InputMaybe<AddressFilterInput>;
  /** Filter by date joined. */
  dateJoined?: InputMaybe<DateTimeRangeInput>;
  /** Filter by email address. */
  email?: InputMaybe<StringFilterInput>;
  /** Filter by first name. */
  firstName?: InputMaybe<StringFilterInput>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter by whether the user is active. */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by last name. */
  lastName?: InputMaybe<StringFilterInput>;
  /** Filter by metadata fields. */
  metadata?: InputMaybe<MetadataFilterInput>;
  /** Filter by number of orders placed by the user. */
  numberOfOrders?: InputMaybe<IntFilterInput>;
  /** Filter by date when orders were placed. */
  placedOrdersAt?: InputMaybe<DateTimeRangeInput>;
  /** Filter by last updated date. */
  updatedAt?: InputMaybe<DateTimeRangeInput>;
};

export type DateRangeInput = {
  /** Start date. */
  gte?: InputMaybe<Scalars['Date']['input']>;
  /** End date. */
  lte?: InputMaybe<Scalars['Date']['input']>;
};

/** Define the filtering options for date time fields. */
export type DateTimeFilterInput = {
  /** The value equal to. */
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  /** The value included in. */
  oneOf?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  /** The value in range. */
  range?: InputMaybe<DateTimeRangeInput>;
};

export type DateTimeRangeInput = {
  /** Start date. */
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** End date. */
  lte?: InputMaybe<Scalars['DateTime']['input']>;
};

/**
 * Deactivate all JWT tokens of the currently authenticated user.
 *
 * Requires one of the following permissions: AUTHENTICATED_USER.
 */
export type DeactivateAllUserTokens = {
  __typename?: 'DeactivateAllUserTokens';
  /** @deprecated Use `errors` field instead. */
  accountErrors: Array<AccountError>;
  errors: Array<AccountError>;
};

/** Define the filtering options for decimal fields. */
export type DecimalFilterInput = {
  /** The value equal to. */
  eq?: InputMaybe<Scalars['Decimal']['input']>;
  /** The value included in. */
  oneOf?: InputMaybe<Array<Scalars['Decimal']['input']>>;
  /** The value in range. */
  range?: InputMaybe<DecimalRangeInput>;
};

export type DecimalRangeInput = {
  /** Decimal value greater than or equal to. */
  gte?: InputMaybe<Scalars['Decimal']['input']>;
  /** Decimal value less than or equal to. */
  lte?: InputMaybe<Scalars['Decimal']['input']>;
};

/** Delete metadata of an object. To use it, you need to have access to the modified object. */
export type DeleteMetadata = {
  __typename?: 'DeleteMetadata';
  errors: Array<MetadataError>;
  item?: Maybe<ObjectWithMetadata>;
  /** @deprecated Use `errors` field instead. */
  metadataErrors: Array<MetadataError>;
};

/** Delete object's private metadata. To use it, you need to be an authenticated staff user or an app and have access to the modified object. */
export type DeletePrivateMetadata = {
  __typename?: 'DeletePrivateMetadata';
  errors: Array<MetadataError>;
  item?: Maybe<ObjectWithMetadata>;
  /** @deprecated Use `errors` field instead. */
  metadataErrors: Array<MetadataError>;
};

/** Represents a delivery method chosen for the checkout. `Warehouse` type is used when checkout is marked as "click and collect" and `ShippingMethod` otherwise. */
export type DeliveryMethod = ShippingMethod | Warehouse;

/** Represents digital content associated with a product variant. */
export type DigitalContent = Node & ObjectWithMetadata & {
  __typename?: 'DigitalContent';
  /** Indicator for automatic fulfillment of digital content. */
  automaticFulfillment: Scalars['Boolean']['output'];
  /** File associated with digital content. */
  contentFile: Scalars['String']['output'];
  /** The ID of the digital content. */
  id: Scalars['ID']['output'];
  /** Maximum number of allowed downloads for the digital content. */
  maxDownloads?: Maybe<Scalars['Int']['output']>;
  /** List of public metadata items. Can be accessed without permissions. */
  metadata: Array<MetadataItem>;
  /**
   * A single key from public metadata.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   */
  metafield?: Maybe<Scalars['String']['output']>;
  /** Public metadata. Use `keys` to control which fields you want to include. The default is to include everything. */
  metafields?: Maybe<Scalars['Metadata']['output']>;
  /** List of private metadata items. Requires staff permissions to access. */
  privateMetadata: Array<MetadataItem>;
  /**
   * A single key from private metadata. Requires staff permissions to access.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   */
  privateMetafield?: Maybe<Scalars['String']['output']>;
  /** Private metadata. Requires staff permissions to access. Use `keys` to control which fields you want to include. The default is to include everything. */
  privateMetafields?: Maybe<Scalars['Metadata']['output']>;
  /** Product variant assigned to digital content. */
  productVariant: ProductVariant;
  /** Number of days the URL for the digital content remains valid. */
  urlValidDays?: Maybe<Scalars['Int']['output']>;
  /** List of URLs for the digital variant. */
  urls?: Maybe<Array<DigitalContentUrl>>;
  /** Default settings indicator for digital content. */
  useDefaultSettings: Scalars['Boolean']['output'];
};


/** Represents digital content associated with a product variant. */
export type DigitalContentMetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Represents digital content associated with a product variant. */
export type DigitalContentMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Represents digital content associated with a product variant. */
export type DigitalContentPrivateMetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Represents digital content associated with a product variant. */
export type DigitalContentPrivateMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** A connection to a list of digital content items. */
export type DigitalContentCountableConnection = {
  __typename?: 'DigitalContentCountableConnection';
  edges: Array<DigitalContentCountableEdge>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** A total count of items in the collection. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type DigitalContentCountableEdge = {
  __typename?: 'DigitalContentCountableEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: DigitalContent;
};

/**
 * Create new digital content. This mutation must be sent as a `multipart` request. More detailed specs of the upload format can be found here: https://github.com/jaydenseric/graphql-multipart-request-spec
 *
 * Requires one of the following permissions: MANAGE_PRODUCTS.
 */
export type DigitalContentCreate = {
  __typename?: 'DigitalContentCreate';
  content?: Maybe<DigitalContent>;
  errors: Array<ProductError>;
  /** @deprecated Use `errors` field instead. */
  productErrors: Array<ProductError>;
  variant?: Maybe<ProductVariant>;
};

/**
 * Remove digital content assigned to given variant.
 *
 * Requires one of the following permissions: MANAGE_PRODUCTS.
 */
export type DigitalContentDelete = {
  __typename?: 'DigitalContentDelete';
  errors: Array<ProductError>;
  /** @deprecated Use `errors` field instead. */
  productErrors: Array<ProductError>;
  variant?: Maybe<ProductVariant>;
};

export type DigitalContentInput = {
  /** Overwrite default automatic_fulfillment setting for variant. */
  automaticFulfillment?: InputMaybe<Scalars['Boolean']['input']>;
  /** Determines how many times a download link can be accessed by a customer. */
  maxDownloads?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Fields required to update the digital content metadata. Can be read by any API client authorized to read the object it's attached to.
   *
   * Warning: never store sensitive information, including financial data such as credit card details.
   */
  metadata?: InputMaybe<Array<MetadataInput>>;
  /**
   * Fields required to update the digital content private metadata. Requires permissions to modify and to read the metadata of the object it's attached to.
   *
   * Warning: never store sensitive information, including financial data such as credit card details.
   */
  privateMetadata?: InputMaybe<Array<MetadataInput>>;
  /** Determines for how many days a download link is active since it was generated. */
  urlValidDays?: InputMaybe<Scalars['Int']['input']>;
  /** Use default digital content settings for this product. */
  useDefaultSettings: Scalars['Boolean']['input'];
};

/**
 * Updates digital content.
 *
 * Requires one of the following permissions: MANAGE_PRODUCTS.
 */
export type DigitalContentUpdate = {
  __typename?: 'DigitalContentUpdate';
  content?: Maybe<DigitalContent>;
  errors: Array<ProductError>;
  /** @deprecated Use `errors` field instead. */
  productErrors: Array<ProductError>;
  variant?: Maybe<ProductVariant>;
};

export type DigitalContentUploadInput = {
  /** Overwrite default automatic_fulfillment setting for variant. */
  automaticFulfillment?: InputMaybe<Scalars['Boolean']['input']>;
  /** Represents an file in a multipart request. */
  contentFile: Scalars['Upload']['input'];
  /** Determines how many times a download link can be accessed by a customer. */
  maxDownloads?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Fields required to update the digital content metadata. Can be read by any API client authorized to read the object it's attached to.
   *
   * Warning: never store sensitive information, including financial data such as credit card details.
   */
  metadata?: InputMaybe<Array<MetadataInput>>;
  /**
   * Fields required to update the digital content private metadata. Requires permissions to modify and to read the metadata of the object it's attached to.
   *
   * Warning: never store sensitive information, including financial data such as credit card details.
   */
  privateMetadata?: InputMaybe<Array<MetadataInput>>;
  /** Determines for how many days a download link is active since it was generated. */
  urlValidDays?: InputMaybe<Scalars['Int']['input']>;
  /** Use default digital content settings for this product. */
  useDefaultSettings: Scalars['Boolean']['input'];
};

/** Represents a URL for digital content. */
export type DigitalContentUrl = Node & {
  __typename?: 'DigitalContentUrl';
  /** Digital content associated with the URL. */
  content: DigitalContent;
  /** Date and time when the digital content URL was created. */
  created: Scalars['DateTime']['output'];
  /** Number of times digital content has been downloaded. */
  downloadNum: Scalars['Int']['output'];
  /** The ID of the digital content URL. */
  id: Scalars['ID']['output'];
  /** UUID of digital content. */
  token: Scalars['UUID']['output'];
  /** URL for digital content. */
  url?: Maybe<Scalars['String']['output']>;
};

/**
 * Generate new URL to digital content.
 *
 * Requires one of the following permissions: MANAGE_PRODUCTS.
 */
export type DigitalContentUrlCreate = {
  __typename?: 'DigitalContentUrlCreate';
  digitalContentUrl?: Maybe<DigitalContentUrl>;
  errors: Array<ProductError>;
  /** @deprecated Use `errors` field instead. */
  productErrors: Array<ProductError>;
};

export type DigitalContentUrlCreateInput = {
  /** Digital content ID which URL will belong to. */
  content: Scalars['ID']['input'];
};

export type DiscountError = {
  __typename?: 'DiscountError';
  /** List of channels IDs which causes the error. */
  channels?: Maybe<Array<Scalars['ID']['output']>>;
  /** The error code. */
  code: DiscountErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field?: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message?: Maybe<Scalars['String']['output']>;
  /** List of products IDs which causes the error. */
  products?: Maybe<Array<Scalars['ID']['output']>>;
  /**
   * List of voucher codes which causes the error.
   *
   * Added in Saleor 3.18.
   */
  voucherCodes?: Maybe<Array<Scalars['String']['output']>>;
};

export type DiscountErrorCode =
  | 'ALREADY_EXISTS'
  | 'CANNOT_MANAGE_PRODUCT_WITHOUT_VARIANT'
  | 'DUPLICATED_INPUT_ITEM'
  | 'GRAPHQL_ERROR'
  | 'INVALID'
  | 'NOT_FOUND'
  | 'REQUIRED'
  | 'UNIQUE'
  | 'VOUCHER_ALREADY_USED';

export type DiscountStatusEnum =
  | 'ACTIVE'
  | 'EXPIRED'
  | 'SCHEDULED';

export type DiscountValueTypeEnum =
  | 'FIXED'
  | 'PERCENTAGE';

export type DiscountedObjectWhereInput = {
  /** List of conditions that must be met. */
  AND?: InputMaybe<Array<DiscountedObjectWhereInput>>;
  /** A list of conditions of which at least one must be met. */
  OR?: InputMaybe<Array<DiscountedObjectWhereInput>>;
  /** Filter by the base subtotal price. */
  baseSubtotalPrice?: InputMaybe<DecimalFilterInput>;
  /** Filter by the base total price. */
  baseTotalPrice?: InputMaybe<DecimalFilterInput>;
};

export type DistanceUnitsEnum =
  | 'CM'
  | 'DM'
  | 'FT'
  | 'INCH'
  | 'KM'
  | 'M'
  | 'MM'
  | 'YD';

/** Represents API domain. */
export type Domain = {
  __typename?: 'Domain';
  /** The host name of the domain. */
  host: Scalars['String']['output'];
  /** Inform if SSL is enabled. */
  sslEnabled: Scalars['Boolean']['output'];
  /** The absolute URL of the API. */
  url: Scalars['String']['output'];
};

/**
 * Deletes draft orders.
 *
 * Requires one of the following permissions: MANAGE_ORDERS.
 */
export type DraftOrderBulkDelete = {
  __typename?: 'DraftOrderBulkDelete';
  /** Returns how many objects were affected. */
  count: Scalars['Int']['output'];
  errors: Array<OrderError>;
  /** @deprecated Use `errors` field instead. */
  orderErrors: Array<OrderError>;
};

/**
 * Completes creating an order.
 *
 * Requires one of the following permissions: MANAGE_ORDERS.
 */
export type DraftOrderComplete = {
  __typename?: 'DraftOrderComplete';
  errors: Array<OrderError>;
  /** Completed order. */
  order?: Maybe<Order>;
  /** @deprecated Use `errors` field instead. */
  orderErrors: Array<OrderError>;
};

/**
 * Creates a new draft order.
 *
 * Requires one of the following permissions: MANAGE_ORDERS.
 */
export type DraftOrderCreate = {
  __typename?: 'DraftOrderCreate';
  errors: Array<OrderError>;
  order?: Maybe<Order>;
  /** @deprecated Use `errors` field instead. */
  orderErrors: Array<OrderError>;
};

export type DraftOrderCreateInput = {
  /** Billing address of the customer. */
  billingAddress?: InputMaybe<AddressInput>;
  /** ID of the channel associated with the order. */
  channelId?: InputMaybe<Scalars['ID']['input']>;
  /** A note from a customer. Visible by customers in the order summary. */
  customerNote?: InputMaybe<Scalars['String']['input']>;
  /**
   * Discount amount for the order.
   *
   * DEPRECATED: this field will be removed. Providing a value for the field has no effect. Use `orderDiscountAdd` mutation instead.
   */
  discount?: InputMaybe<Scalars['PositiveDecimal']['input']>;
  /** External ID of this order. */
  externalReference?: InputMaybe<Scalars['String']['input']>;
  /**
   * Order language code.
   *
   * Added in Saleor 3.21.
   */
  languageCode?: InputMaybe<LanguageCodeEnum>;
  /** Variant line input consisting of variant ID and quantity of products. */
  lines?: InputMaybe<Array<OrderLineCreateInput>>;
  /**
   * Order public metadata.
   *
   * Added in Saleor 3.21. Can be read by any API client authorized to read the object it's attached to.
   *
   * Warning: never store sensitive information, including financial data such as credit card details.
   */
  metadata?: InputMaybe<Array<MetadataInput>>;
  /**
   * Order private metadata.
   *
   * Added in Saleor 3.21. Requires permissions to modify and to read the metadata of the object it's attached to.
   *
   * Warning: never store sensitive information, including financial data such as credit card details.
   */
  privateMetadata?: InputMaybe<Array<MetadataInput>>;
  /** URL of a view where users should be redirected to see the order details. URL in RFC 1808 format. */
  redirectUrl?: InputMaybe<Scalars['String']['input']>;
  /**
   * Indicates whether the billing address should be saved to the user’s address book upon draft order completion. Can only be set when a billing address is provided. If not specified along with the address, the default behavior is to not save the address.
   *
   * Added in Saleor 3.21.
   */
  saveBillingAddress?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Indicates whether the shipping address should be saved to the user’s address book upon draft order completion.Can only be set when a shipping address is provided. If not specified along with the address, the default behavior is to not save the address.
   *
   * Added in Saleor 3.21.
   */
  saveShippingAddress?: InputMaybe<Scalars['Boolean']['input']>;
  /** Shipping address of the customer. */
  shippingAddress?: InputMaybe<AddressInput>;
  /** ID of a selected shipping method. */
  shippingMethod?: InputMaybe<Scalars['ID']['input']>;
  /** Customer associated with the draft order. */
  user?: InputMaybe<Scalars['ID']['input']>;
  /** Email address of the customer. */
  userEmail?: InputMaybe<Scalars['String']['input']>;
  /** ID of the voucher associated with the order. */
  voucher?: InputMaybe<Scalars['ID']['input']>;
  /**
   * A code of the voucher associated with the order.
   *
   * Added in Saleor 3.18.
   */
  voucherCode?: InputMaybe<Scalars['String']['input']>;
};

/** Event sent when new draft order is created. */
export type DraftOrderCreated = Event & {
  __typename?: 'DraftOrderCreated';
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<IssuingPrincipal>;
  /** The order the event relates to. */
  order?: Maybe<Order>;
  /** The application receiving the webhook. */
  recipient?: Maybe<App>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

/**
 * Deletes a draft order.
 *
 * Requires one of the following permissions: MANAGE_ORDERS.
 */
export type DraftOrderDelete = {
  __typename?: 'DraftOrderDelete';
  errors: Array<OrderError>;
  order?: Maybe<Order>;
  /** @deprecated Use `errors` field instead. */
  orderErrors: Array<OrderError>;
};

/** Event sent when draft order is deleted. */
export type DraftOrderDeleted = Event & {
  __typename?: 'DraftOrderDeleted';
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<IssuingPrincipal>;
  /** The order the event relates to. */
  order?: Maybe<Order>;
  /** The application receiving the webhook. */
  recipient?: Maybe<App>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

export type DraftOrderInput = {
  /** Billing address of the customer. */
  billingAddress?: InputMaybe<AddressInput>;
  /** ID of the channel associated with the order. */
  channelId?: InputMaybe<Scalars['ID']['input']>;
  /** A note from a customer. Visible by customers in the order summary. */
  customerNote?: InputMaybe<Scalars['String']['input']>;
  /**
   * Discount amount for the order.
   *
   * DEPRECATED: this field will be removed. Providing a value for the field has no effect. Use `orderDiscountAdd` mutation instead.
   */
  discount?: InputMaybe<Scalars['PositiveDecimal']['input']>;
  /** External ID of this order. */
  externalReference?: InputMaybe<Scalars['String']['input']>;
  /**
   * Order language code.
   *
   * Added in Saleor 3.21.
   */
  languageCode?: InputMaybe<LanguageCodeEnum>;
  /**
   * Order public metadata.
   *
   * Added in Saleor 3.21. Can be read by any API client authorized to read the object it's attached to.
   *
   * Warning: never store sensitive information, including financial data such as credit card details.
   */
  metadata?: InputMaybe<Array<MetadataInput>>;
  /**
   * Order private metadata.
   *
   * Added in Saleor 3.21. Requires permissions to modify and to read the metadata of the object it's attached to.
   *
   * Warning: never store sensitive information, including financial data such as credit card details.
   */
  privateMetadata?: InputMaybe<Array<MetadataInput>>;
  /** URL of a view where users should be redirected to see the order details. URL in RFC 1808 format. */
  redirectUrl?: InputMaybe<Scalars['String']['input']>;
  /**
   * Indicates whether the billing address should be saved to the user’s address book upon draft order completion. Can only be set when a billing address is provided. If not specified along with the address, the default behavior is to not save the address.
   *
   * Added in Saleor 3.21.
   */
  saveBillingAddress?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Indicates whether the shipping address should be saved to the user’s address book upon draft order completion.Can only be set when a shipping address is provided. If not specified along with the address, the default behavior is to not save the address.
   *
   * Added in Saleor 3.21.
   */
  saveShippingAddress?: InputMaybe<Scalars['Boolean']['input']>;
  /** Shipping address of the customer. */
  shippingAddress?: InputMaybe<AddressInput>;
  /** ID of a selected shipping method. */
  shippingMethod?: InputMaybe<Scalars['ID']['input']>;
  /** Customer associated with the draft order. */
  user?: InputMaybe<Scalars['ID']['input']>;
  /** Email address of the customer. */
  userEmail?: InputMaybe<Scalars['String']['input']>;
  /** ID of the voucher associated with the order. */
  voucher?: InputMaybe<Scalars['ID']['input']>;
  /**
   * A code of the voucher associated with the order.
   *
   * Added in Saleor 3.18.
   */
  voucherCode?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Deletes order lines.
 *
 * Requires one of the following permissions: MANAGE_ORDERS.
 */
export type DraftOrderLinesBulkDelete = {
  __typename?: 'DraftOrderLinesBulkDelete';
  /** Returns how many objects were affected. */
  count: Scalars['Int']['output'];
  errors: Array<OrderError>;
  /** @deprecated Use `errors` field instead. */
  orderErrors: Array<OrderError>;
};

/**
 * Updates a draft order.
 *
 * Requires one of the following permissions: MANAGE_ORDERS.
 */
export type DraftOrderUpdate = {
  __typename?: 'DraftOrderUpdate';
  errors: Array<OrderError>;
  order?: Maybe<Order>;
  /** @deprecated Use `errors` field instead. */
  orderErrors: Array<OrderError>;
};

/** Event sent when draft order is updated. */
export type DraftOrderUpdated = Event & {
  __typename?: 'DraftOrderUpdated';
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<IssuingPrincipal>;
  /** The order the event relates to. */
  order?: Maybe<Order>;
  /** The application receiving the webhook. */
  recipient?: Maybe<App>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

export type DraftOrderWhereInput = {
  /** List of conditions that must be met. */
  AND?: InputMaybe<Array<DraftOrderWhereInput>>;
  /** A list of conditions of which at least one must be met. */
  OR?: InputMaybe<Array<DraftOrderWhereInput>>;
  /** Filter by authorize status. */
  authorizeStatus?: InputMaybe<OrderAuthorizeStatusEnumFilterInput>;
  /** Filter by billing address of the order. */
  billingAddress?: InputMaybe<AddressFilterInput>;
  /** Filter by channel. */
  channelId?: InputMaybe<GlobalIdFilterInput>;
  /** Filter by charge status. */
  chargeStatus?: InputMaybe<OrderChargeStatusEnumFilterInput>;
  /** Filter order by created at date. */
  createdAt?: InputMaybe<DateTimeRangeInput>;
  /** Filter by order events. Each list item represents conditions that must be satisfied by a single object. The filter matches orders that have related objects meeting all specified groups of conditions. */
  events?: InputMaybe<Array<OrderEventFilterInput>>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter by whether the order uses the click and collect delivery method. */
  isClickAndCollect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by line items associated with the order. Each list item represents conditions that must be satisfied by a single object. The filter matches orders that have related objects meeting all specified groups of conditions. */
  lines?: InputMaybe<Array<LinesFilterInput>>;
  /** Filter by number of lines in the order. */
  linesCount?: InputMaybe<IntFilterInput>;
  /** Filter by metadata fields. */
  metadata?: InputMaybe<MetadataFilterInput>;
  /** Filter by order number. */
  number?: InputMaybe<IntFilterInput>;
  /** Filter by the product type of related order lines. */
  productTypeId?: InputMaybe<GlobalIdFilterInput>;
  /** Filter by shipping address of the order. */
  shippingAddress?: InputMaybe<AddressFilterInput>;
  /** Filter by total gross amount of the order. */
  totalGross?: InputMaybe<PriceFilterInput>;
  /** Filter by total net amount of the order. */
  totalNet?: InputMaybe<PriceFilterInput>;
  /** Filter by transaction data associated with the order. Each list item represents conditions that must be satisfied by a single object. The filter matches orders that have related objects meeting all specified groups of conditions. */
  transactions?: InputMaybe<Array<TransactionFilterInput>>;
  /** Filter order by updated at date. */
  updatedAt?: InputMaybe<DateTimeRangeInput>;
  /** Filter by user. */
  user?: InputMaybe<GlobalIdFilterInput>;
  /** Filter by user email. */
  userEmail?: InputMaybe<StringFilterInput>;
  /** Filter by voucher code used in the order. */
  voucherCode?: InputMaybe<StringFilterInput>;
};

export type ErrorPolicyEnum =
  /** Save what is possible within a single row. If there are errors in an input data row, try to save it partially and skip the invalid part. */
  | 'IGNORE_FAILED'
  /** Reject all rows if there is at least one error in any of them. */
  | 'REJECT_EVERYTHING'
  /** Reject rows with errors. */
  | 'REJECT_FAILED_ROWS';

export type Event = {
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<IssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient?: Maybe<App>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

/** Event delivery. */
export type EventDelivery = Node & {
  __typename?: 'EventDelivery';
  /** Event delivery attempts. */
  attempts?: Maybe<EventDeliveryAttemptCountableConnection>;
  /** Creation time of an event delivery. */
  createdAt: Scalars['DateTime']['output'];
  /** Webhook event type. */
  eventType: WebhookEventTypeEnum;
  /** The ID of an event delivery. */
  id: Scalars['ID']['output'];
  /** Event payload. */
  payload?: Maybe<Scalars['String']['output']>;
  /** Event delivery status. */
  status: EventDeliveryStatusEnum;
};


/** Event delivery. */
export type EventDeliveryAttemptsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<EventDeliveryAttemptSortingInput>;
};

/** Event delivery attempts. */
export type EventDeliveryAttempt = Node & {
  __typename?: 'EventDeliveryAttempt';
  /** Event delivery creation date and time. */
  createdAt: Scalars['DateTime']['output'];
  /** Delivery attempt duration. */
  duration?: Maybe<Scalars['Float']['output']>;
  /** The ID of Event Delivery Attempt. */
  id: Scalars['ID']['output'];
  /** Request headers for delivery attempt. */
  requestHeaders?: Maybe<Scalars['String']['output']>;
  /** Delivery attempt response content. */
  response?: Maybe<Scalars['String']['output']>;
  /** Response headers for delivery attempt. */
  responseHeaders?: Maybe<Scalars['String']['output']>;
  /** Delivery attempt response status code. */
  responseStatusCode?: Maybe<Scalars['Int']['output']>;
  /** Event delivery status. */
  status: EventDeliveryStatusEnum;
  /** Task id for delivery attempt. */
  taskId?: Maybe<Scalars['String']['output']>;
};

export type EventDeliveryAttemptCountableConnection = {
  __typename?: 'EventDeliveryAttemptCountableConnection';
  edges: Array<EventDeliveryAttemptCountableEdge>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** A total count of items in the collection. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type EventDeliveryAttemptCountableEdge = {
  __typename?: 'EventDeliveryAttemptCountableEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: EventDeliveryAttempt;
};

export type EventDeliveryAttemptSortField =
  /** Sort event delivery attempts by created at. */
  | 'CREATED_AT';

export type EventDeliveryAttemptSortingInput = {
  /** Specifies the direction in which to sort attempts. */
  direction: OrderDirection;
  /** Sort attempts by the selected field. */
  field: EventDeliveryAttemptSortField;
};

export type EventDeliveryCountableConnection = {
  __typename?: 'EventDeliveryCountableConnection';
  edges: Array<EventDeliveryCountableEdge>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** A total count of items in the collection. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type EventDeliveryCountableEdge = {
  __typename?: 'EventDeliveryCountableEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: EventDelivery;
};

export type EventDeliveryFilterInput = {
  eventType?: InputMaybe<WebhookEventTypeEnum>;
  status?: InputMaybe<EventDeliveryStatusEnum>;
};

/**
 * Retries event delivery.
 *
 * Requires one of the following permissions: MANAGE_APPS.
 */
export type EventDeliveryRetry = {
  __typename?: 'EventDeliveryRetry';
  /** Event delivery. */
  delivery?: Maybe<EventDelivery>;
  errors: Array<WebhookError>;
};

export type EventDeliverySortField =
  /** Sort event deliveries by created at. */
  | 'CREATED_AT';

export type EventDeliverySortingInput = {
  /** Specifies the direction in which to sort deliveries. */
  direction: OrderDirection;
  /** Sort deliveries by the selected field. */
  field: EventDeliverySortField;
};

export type EventDeliveryStatusEnum =
  | 'FAILED'
  | 'PENDING'
  | 'SUCCESS';

export type ExportError = {
  __typename?: 'ExportError';
  /** The error code. */
  code: ExportErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field?: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message?: Maybe<Scalars['String']['output']>;
};

export type ExportErrorCode =
  | 'GRAPHQL_ERROR'
  | 'INVALID'
  | 'NOT_FOUND'
  | 'REQUIRED';

/** History log of export file. */
export type ExportEvent = Node & {
  __typename?: 'ExportEvent';
  /** App which performed the action. Requires one of the following permissions: OWNER, MANAGE_APPS. */
  app?: Maybe<App>;
  /** Date when event happened at in ISO 8601 format. */
  date: Scalars['DateTime']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  /** Content of the event. */
  message: Scalars['String']['output'];
  /** Export event type. */
  type: ExportEventsEnum;
  /** User who performed the action. Requires one of the following permissions: OWNER, MANAGE_STAFF. */
  user?: Maybe<User>;
};

export type ExportEventsEnum =
  | 'EXPORTED_FILE_SENT'
  | 'EXPORT_DELETED'
  | 'EXPORT_FAILED'
  | 'EXPORT_FAILED_INFO_SENT'
  | 'EXPORT_PENDING'
  | 'EXPORT_SUCCESS';

/** Represents a job data of exported file. */
export type ExportFile = Job & Node & {
  __typename?: 'ExportFile';
  /** The app which requests file export. */
  app?: Maybe<App>;
  /** Created date time of job in ISO 8601 format. */
  createdAt: Scalars['DateTime']['output'];
  /** List of events associated with the export. */
  events?: Maybe<Array<ExportEvent>>;
  /** The ID of the export file. */
  id: Scalars['ID']['output'];
  /** Job message. */
  message?: Maybe<Scalars['String']['output']>;
  /** Job status. */
  status: JobStatusEnum;
  /** Date time of job last update in ISO 8601 format. */
  updatedAt: Scalars['DateTime']['output'];
  /** The URL of field to download. */
  url?: Maybe<Scalars['String']['output']>;
  /** The user who requests file export. */
  user?: Maybe<User>;
};

export type ExportFileCountableConnection = {
  __typename?: 'ExportFileCountableConnection';
  edges: Array<ExportFileCountableEdge>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** A total count of items in the collection. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type ExportFileCountableEdge = {
  __typename?: 'ExportFileCountableEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ExportFile;
};

export type ExportFileFilterInput = {
  app?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<DateTimeRangeInput>;
  status?: InputMaybe<JobStatusEnum>;
  updatedAt?: InputMaybe<DateTimeRangeInput>;
  user?: InputMaybe<Scalars['String']['input']>;
};

export type ExportFileSortField =
  | 'CREATED_AT'
  | 'LAST_MODIFIED_AT'
  | 'STATUS'
  | 'UPDATED_AT';

export type ExportFileSortingInput = {
  /** Specifies the direction in which to sort export file. */
  direction: OrderDirection;
  /** Sort export file by the selected field. */
  field: ExportFileSortField;
};

/**
 * Export gift cards to csv file.
 *
 * Requires one of the following permissions: MANAGE_GIFT_CARD.
 *
 * Triggers the following webhook events:
 * - NOTIFY_USER (async): A notification for the exported file.
 * - GIFT_CARD_EXPORT_COMPLETED (async): A notification for the exported file.
 */
export type ExportGiftCards = {
  __typename?: 'ExportGiftCards';
  errors: Array<ExportError>;
  /** The newly created export file job which is responsible for export data. */
  exportFile?: Maybe<ExportFile>;
};

export type ExportGiftCardsInput = {
  /** Type of exported file. */
  fileType: FileTypesEnum;
  /** Filtering options for gift cards. */
  filter?: InputMaybe<GiftCardFilterInput>;
  /** List of gift cards IDs to export. */
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Determine which gift cards should be exported. */
  scope: ExportScope;
};

export type ExportInfoInput = {
  /** List of attribute ids witch should be exported. */
  attributes?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** List of channels ids which should be exported. */
  channels?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** List of product fields witch should be exported. */
  fields?: InputMaybe<Array<ProductFieldEnum>>;
  /** List of warehouse ids witch should be exported. */
  warehouses?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * Export products to csv file.
 *
 * Requires one of the following permissions: MANAGE_PRODUCTS.
 *
 * Triggers the following webhook events:
 * - NOTIFY_USER (async): A notification for the exported file.
 * - PRODUCT_EXPORT_COMPLETED (async): A notification for the exported file.
 */
export type ExportProducts = {
  __typename?: 'ExportProducts';
  errors: Array<ExportError>;
  /** @deprecated Use `errors` field instead. */
  exportErrors: Array<ExportError>;
  /** The newly created export file job which is responsible for export data. */
  exportFile?: Maybe<ExportFile>;
};

export type ExportProductsInput = {
  /** Input with info about fields which should be exported. */
  exportInfo?: InputMaybe<ExportInfoInput>;
  /** Type of exported file. */
  fileType: FileTypesEnum;
  /** Filtering options for products. */
  filter?: InputMaybe<ProductFilterInput>;
  /** List of products IDs to export. */
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Determine which products should be exported. */
  scope: ExportScope;
};

export type ExportScope =
  /** Export all products. */
  | 'ALL'
  /** Export the filtered products. */
  | 'FILTER'
  /** Export products with given ids. */
  | 'IDS';

/**
 * Export voucher codes to csv/xlsx file.
 *
 * Added in Saleor 3.18.
 *
 * Note: this API is currently in Feature Preview and can be subject to changes at later point.
 *
 * Requires one of the following permissions: MANAGE_DISCOUNTS.
 *
 * Triggers the following webhook events:
 * - VOUCHER_CODE_EXPORT_COMPLETED (async): A notification for the exported file.
 */
export type ExportVoucherCodes = {
  __typename?: 'ExportVoucherCodes';
  errors: Array<ExportError>;
  /** The newly created export file job which is responsible for export data. */
  exportFile?: Maybe<ExportFile>;
};

export type ExportVoucherCodesInput = {
  /** Type of exported file. */
  fileType: FileTypesEnum;
  /** List of voucher code IDs to export. */
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The ID of the voucher. If provided, exports all codes belonging to the voucher. */
  voucherId?: InputMaybe<Scalars['ID']['input']>;
};

/** External authentication plugin. */
export type ExternalAuthentication = {
  __typename?: 'ExternalAuthentication';
  /** ID of external authentication plugin. */
  id: Scalars['String']['output'];
  /** Name of external authentication plugin. */
  name?: Maybe<Scalars['String']['output']>;
};

/** Prepare external authentication URL for user by custom plugin. */
export type ExternalAuthenticationUrl = {
  __typename?: 'ExternalAuthenticationUrl';
  /** @deprecated Use `errors` field instead. */
  accountErrors: Array<AccountError>;
  /** The data returned by authentication plugin. */
  authenticationData?: Maybe<Scalars['JSONString']['output']>;
  errors: Array<AccountError>;
};

/** Logout user by custom plugin. */
export type ExternalLogout = {
  __typename?: 'ExternalLogout';
  /** @deprecated Use `errors` field instead. */
  accountErrors: Array<AccountError>;
  errors: Array<AccountError>;
  /** The data returned by authentication plugin. */
  logoutData?: Maybe<Scalars['JSONString']['output']>;
};

export type ExternalNotificationError = {
  __typename?: 'ExternalNotificationError';
  /** The error code. */
  code: ExternalNotificationErrorCodes;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field?: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message?: Maybe<Scalars['String']['output']>;
};

export type ExternalNotificationErrorCodes =
  | 'CHANNEL_INACTIVE'
  | 'INVALID_MODEL_TYPE'
  | 'NOT_FOUND'
  | 'REQUIRED';

/** Trigger sending a notification with the notify plugin method. Serializes nodes provided as ids parameter and includes this data in the notification payload. */
export type ExternalNotificationTrigger = {
  __typename?: 'ExternalNotificationTrigger';
  errors: Array<ExternalNotificationError>;
};

export type ExternalNotificationTriggerInput = {
  /** External event type. This field is passed to a plugin as an event type. */
  externalEventType: Scalars['String']['input'];
  /** Additional payload that will be merged with the one based on the business object ID. */
  extraPayload?: InputMaybe<Scalars['JSONString']['input']>;
  /** The list of customers or orders node IDs that will be serialized and included in the notification payload. */
  ids: Array<Scalars['ID']['input']>;
};

/** Obtain external access tokens for user by custom plugin. */
export type ExternalObtainAccessTokens = {
  __typename?: 'ExternalObtainAccessTokens';
  /** @deprecated Use `errors` field instead. */
  accountErrors: Array<AccountError>;
  /** CSRF token required to re-generate external access token. */
  csrfToken?: Maybe<Scalars['String']['output']>;
  errors: Array<AccountError>;
  /** The refresh token, required to re-generate external access token. */
  refreshToken?: Maybe<Scalars['String']['output']>;
  /** The token, required to authenticate. */
  token?: Maybe<Scalars['String']['output']>;
  /** A user instance. */
  user?: Maybe<User>;
};

/** Refresh user's access by custom plugin. */
export type ExternalRefresh = {
  __typename?: 'ExternalRefresh';
  /** @deprecated Use `errors` field instead. */
  accountErrors: Array<AccountError>;
  /** CSRF token required to re-generate external access token. */
  csrfToken?: Maybe<Scalars['String']['output']>;
  errors: Array<AccountError>;
  /** The refresh token, required to re-generate external access token. */
  refreshToken?: Maybe<Scalars['String']['output']>;
  /** The token, required to authenticate. */
  token?: Maybe<Scalars['String']['output']>;
  /** A user instance. */
  user?: Maybe<User>;
};

/** Verify external authentication data by plugin. */
export type ExternalVerify = {
  __typename?: 'ExternalVerify';
  /** @deprecated Use `errors` field instead. */
  accountErrors: Array<AccountError>;
  errors: Array<AccountError>;
  /** Determine if authentication data is valid or not. */
  isValid: Scalars['Boolean']['output'];
  /** User assigned to data. */
  user?: Maybe<User>;
  /** External data. */
  verifyData?: Maybe<Scalars['JSONString']['output']>;
};

export type File = {
  __typename?: 'File';
  /** Content type of the file. */
  contentType?: Maybe<Scalars['String']['output']>;
  /** The URL of the file. */
  url: Scalars['String']['output'];
};

export type FileTypesEnum =
  | 'CSV'
  | 'XLSX';

/**
 * Upload a file. This mutation must be sent as a `multipart` request. More detailed specs of the upload format can be found here: https://github.com/jaydenseric/graphql-multipart-request-spec
 *
 * Requires one of the following permissions: AUTHENTICATED_APP, AUTHENTICATED_STAFF_USER.
 */
export type FileUpload = {
  __typename?: 'FileUpload';
  errors: Array<UploadError>;
  /** @deprecated Use `errors` field instead. */
  uploadErrors: Array<UploadError>;
  uploadedFile?: Maybe<File>;
};

/** Represents order fulfillment. */
export type Fulfillment = Node & ObjectWithMetadata & {
  __typename?: 'Fulfillment';
  /** Date and time when fulfillment was created. */
  created: Scalars['DateTime']['output'];
  /** Sequence in which the fulfillments were created for an order. */
  fulfillmentOrder: Scalars['Int']['output'];
  /** ID of the fulfillment. */
  id: Scalars['ID']['output'];
  /** List of lines for the fulfillment. */
  lines?: Maybe<Array<FulfillmentLine>>;
  /** List of public metadata items. Can be accessed without permissions. */
  metadata: Array<MetadataItem>;
  /**
   * A single key from public metadata.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   */
  metafield?: Maybe<Scalars['String']['output']>;
  /** Public metadata. Use `keys` to control which fields you want to include. The default is to include everything. */
  metafields?: Maybe<Scalars['Metadata']['output']>;
  /** List of private metadata items. Requires staff permissions to access. */
  privateMetadata: Array<MetadataItem>;
  /**
   * A single key from private metadata. Requires staff permissions to access.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   */
  privateMetafield?: Maybe<Scalars['String']['output']>;
  /** Private metadata. Requires staff permissions to access. Use `keys` to control which fields you want to include. The default is to include everything. */
  privateMetafields?: Maybe<Scalars['Metadata']['output']>;
  /** Amount of refunded shipping price. */
  shippingRefundedAmount?: Maybe<Money>;
  /** Status of fulfillment. */
  status: FulfillmentStatus;
  /** User-friendly fulfillment status. */
  statusDisplay?: Maybe<Scalars['String']['output']>;
  /** Total refunded amount assigned to this fulfillment. */
  totalRefundedAmount?: Maybe<Money>;
  /** Fulfillment tracking number. */
  trackingNumber: Scalars['String']['output'];
  /** Warehouse from fulfillment was fulfilled. */
  warehouse?: Maybe<Warehouse>;
};


/** Represents order fulfillment. */
export type FulfillmentMetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Represents order fulfillment. */
export type FulfillmentMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Represents order fulfillment. */
export type FulfillmentPrivateMetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Represents order fulfillment. */
export type FulfillmentPrivateMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};

/**
 * Approve existing fulfillment.
 *
 * Requires one of the following permissions: MANAGE_ORDERS.
 *
 * Triggers the following webhook events:
 * - FULFILLMENT_APPROVED (async): Fulfillment is approved.
 */
export type FulfillmentApprove = {
  __typename?: 'FulfillmentApprove';
  errors: Array<OrderError>;
  /** An approved fulfillment. */
  fulfillment?: Maybe<Fulfillment>;
  /** Order which fulfillment was approved. */
  order?: Maybe<Order>;
  /** @deprecated Use `errors` field instead. */
  orderErrors: Array<OrderError>;
};

/** Event sent when fulfillment is approved. */
export type FulfillmentApproved = Event & {
  __typename?: 'FulfillmentApproved';
  /** The fulfillment the event relates to. */
  fulfillment?: Maybe<Fulfillment>;
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<IssuingPrincipal>;
  /** If true, send a notification to the customer. */
  notifyCustomer: Scalars['Boolean']['output'];
  /** The order the fulfillment belongs to. */
  order?: Maybe<Order>;
  /** The application receiving the webhook. */
  recipient?: Maybe<App>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

/**
 * Cancels existing fulfillment and optionally restocks items.
 *
 * Requires one of the following permissions: MANAGE_ORDERS.
 */
export type FulfillmentCancel = {
  __typename?: 'FulfillmentCancel';
  errors: Array<OrderError>;
  /** A canceled fulfillment. */
  fulfillment?: Maybe<Fulfillment>;
  /** Order which fulfillment was cancelled. */
  order?: Maybe<Order>;
  /** @deprecated Use `errors` field instead. */
  orderErrors: Array<OrderError>;
};

export type FulfillmentCancelInput = {
  /** ID of a warehouse where items will be restocked. Optional when fulfillment is in WAITING_FOR_APPROVAL state. */
  warehouseId?: InputMaybe<Scalars['ID']['input']>;
};

/** Event sent when fulfillment is canceled. */
export type FulfillmentCanceled = Event & {
  __typename?: 'FulfillmentCanceled';
  /** The fulfillment the event relates to. */
  fulfillment?: Maybe<Fulfillment>;
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<IssuingPrincipal>;
  /** The order the fulfillment belongs to. */
  order?: Maybe<Order>;
  /** The application receiving the webhook. */
  recipient?: Maybe<App>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

/** Event sent when new fulfillment is created. */
export type FulfillmentCreated = Event & {
  __typename?: 'FulfillmentCreated';
  /** The fulfillment the event relates to. */
  fulfillment?: Maybe<Fulfillment>;
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<IssuingPrincipal>;
  /** If true, the app should send a notification to the customer. */
  notifyCustomer: Scalars['Boolean']['output'];
  /** The order the fulfillment belongs to. */
  order?: Maybe<Order>;
  /** The application receiving the webhook. */
  recipient?: Maybe<App>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

/** Filter input for order fulfillments data. */
export type FulfillmentFilterInput = {
  /** Filter by metadata fields. */
  metadata?: InputMaybe<MetadataFilterInput>;
  /** Filter by fulfillment status. */
  status?: InputMaybe<FulfillmentStatusEnumFilterInput>;
  /** Filter by fulfillment warehouse. */
  warehouse?: InputMaybe<FulfillmentWarehouseFilterInput>;
};

/** Represents line of the fulfillment. */
export type FulfillmentLine = Node & {
  __typename?: 'FulfillmentLine';
  /** ID of the fulfillment line. */
  id: Scalars['ID']['output'];
  /** The order line to which the fulfillment line is related. */
  orderLine?: Maybe<OrderLine>;
  /** The number of items included in the fulfillment line. */
  quantity: Scalars['Int']['output'];
};

/** Event sent when fulfillment metadata is updated. */
export type FulfillmentMetadataUpdated = Event & {
  __typename?: 'FulfillmentMetadataUpdated';
  /** The fulfillment the event relates to. */
  fulfillment?: Maybe<Fulfillment>;
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<IssuingPrincipal>;
  /** The order the fulfillment belongs to. */
  order?: Maybe<Order>;
  /** The application receiving the webhook. */
  recipient?: Maybe<App>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

/**
 * Refund products.
 *
 * Requires one of the following permissions: MANAGE_ORDERS.
 */
export type FulfillmentRefundProducts = {
  __typename?: 'FulfillmentRefundProducts';
  errors: Array<OrderError>;
  /** A refunded fulfillment. */
  fulfillment?: Maybe<Fulfillment>;
  /** Order which fulfillment was refunded. */
  order?: Maybe<Order>;
  /** @deprecated Use `errors` field instead. */
  orderErrors: Array<OrderError>;
};

/**
 * Return products.
 *
 * Requires one of the following permissions: MANAGE_ORDERS.
 */
export type FulfillmentReturnProducts = {
  __typename?: 'FulfillmentReturnProducts';
  errors: Array<OrderError>;
  /** Order which fulfillment was returned. */
  order?: Maybe<Order>;
  /** @deprecated Use `errors` field instead. */
  orderErrors: Array<OrderError>;
  /** A replace fulfillment. */
  replaceFulfillment?: Maybe<Fulfillment>;
  /** A draft order which was created for products with replace flag. */
  replaceOrder?: Maybe<Order>;
  /** A return fulfillment. */
  returnFulfillment?: Maybe<Fulfillment>;
};

export type FulfillmentStatus =
  | 'CANCELED'
  | 'FULFILLED'
  | 'REFUNDED'
  | 'REFUNDED_AND_RETURNED'
  | 'REPLACED'
  | 'RETURNED'
  | 'WAITING_FOR_APPROVAL';

/** Filter by fulfillment status. */
export type FulfillmentStatusEnumFilterInput = {
  /** The value equal to. */
  eq?: InputMaybe<FulfillmentStatus>;
  /** The value included in. */
  oneOf?: InputMaybe<Array<FulfillmentStatus>>;
};

/** Event sent when the tracking number is updated. */
export type FulfillmentTrackingNumberUpdated = Event & {
  __typename?: 'FulfillmentTrackingNumberUpdated';
  /** The fulfillment the event relates to. */
  fulfillment?: Maybe<Fulfillment>;
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<IssuingPrincipal>;
  /** The order the fulfillment belongs to. */
  order?: Maybe<Order>;
  /** The application receiving the webhook. */
  recipient?: Maybe<App>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

/**
 * Updates a fulfillment for an order.
 *
 * Requires one of the following permissions: MANAGE_ORDERS.
 *
 * Triggers the following webhook events:
 * - FULFILLMENT_TRACKING_NUMBER_UPDATED (async): Fulfillment tracking number is updated.
 */
export type FulfillmentUpdateTracking = {
  __typename?: 'FulfillmentUpdateTracking';
  errors: Array<OrderError>;
  /** A fulfillment with updated tracking. */
  fulfillment?: Maybe<Fulfillment>;
  /** Order for which fulfillment was updated. */
  order?: Maybe<Order>;
  /** @deprecated Use `errors` field instead. */
  orderErrors: Array<OrderError>;
};

export type FulfillmentUpdateTrackingInput = {
  /** If true, send an email notification to the customer. */
  notifyCustomer?: InputMaybe<Scalars['Boolean']['input']>;
  /** Fulfillment tracking number. */
  trackingNumber?: InputMaybe<Scalars['String']['input']>;
};

/** Filter input for fulfillment warehouses. */
export type FulfillmentWarehouseFilterInput = {
  /** Filter fulfillments by warehouse external reference. */
  externalReference?: InputMaybe<StringFilterInput>;
  /** Filter fulfillments by warehouse ID. */
  id?: InputMaybe<GlobalIdFilterInput>;
  /** Filter fulfillments by warehouse slug. */
  slug?: InputMaybe<StringFilterInput>;
};

/** Payment gateway client configuration key and value pair. */
export type GatewayConfigLine = {
  __typename?: 'GatewayConfigLine';
  /** Gateway config key. */
  field: Scalars['String']['output'];
  /** Gateway config value for key. */
  value?: Maybe<Scalars['String']['output']>;
};

/** A gift card is a prepaid electronic payment card accepted in stores. They can be used during checkout by providing a valid gift card codes. */
export type GiftCard = Node & ObjectWithMetadata & {
  __typename?: 'GiftCard';
  /**
   * App which created the gift card.
   *
   * Requires one of the following permissions: MANAGE_APPS, OWNER.
   */
  app?: Maybe<App>;
  /** Slug of the channel where the gift card was bought. */
  boughtInChannel?: Maybe<Scalars['String']['output']>;
  /**
   * Gift card code. It can be fetched both by a staff member with 'MANAGE_GIFT_CARD' when gift card hasn't been used yet or a user who bought or issued the gift card.
   *
   * Requires one of the following permissions: MANAGE_GIFT_CARD, OWNER.
   */
  code: Scalars['String']['output'];
  /** Date and time when gift card was created. */
  created: Scalars['DateTime']['output'];
  /** The user who bought or issued a gift card. */
  createdBy?: Maybe<User>;
  /**
   * Email address of the user who bought or issued gift card.
   *
   * Requires one of the following permissions: MANAGE_USERS, OWNER.
   */
  createdByEmail?: Maybe<Scalars['String']['output']>;
  currentBalance: Money;
  /** Code in format which allows displaying in a user interface. */
  displayCode: Scalars['String']['output'];
  /**
   * End date of gift card.
   * @deprecated Use `expiryDate` field instead.
   */
  endDate?: Maybe<Scalars['DateTime']['output']>;
  /**
   * List of events associated with the gift card. Requires MANAGE_GIFT_CARD permission to access all events. Users with MANAGE_ORDERS permission can access only USED_IN_ORDER events.
   *
   * Requires one of the following permissions: MANAGE_GIFT_CARD, MANAGE_ORDERS.
   */
  events: Array<GiftCardEvent>;
  /** Expiry date of the gift card. */
  expiryDate?: Maybe<Scalars['Date']['output']>;
  /** ID of the gift card. */
  id: Scalars['ID']['output'];
  initialBalance: Money;
  isActive: Scalars['Boolean']['output'];
  /** Last 4 characters of gift card code. */
  last4CodeChars: Scalars['String']['output'];
  /** Date and time when gift card was last used. */
  lastUsedOn?: Maybe<Scalars['DateTime']['output']>;
  /** List of public metadata items. Can be accessed without permissions. */
  metadata: Array<MetadataItem>;
  /**
   * A single key from public metadata.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   */
  metafield?: Maybe<Scalars['String']['output']>;
  /** Public metadata. Use `keys` to control which fields you want to include. The default is to include everything. */
  metafields?: Maybe<Scalars['Metadata']['output']>;
  /** List of private metadata items. Requires staff permissions to access. */
  privateMetadata: Array<MetadataItem>;
  /**
   * A single key from private metadata. Requires staff permissions to access.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   */
  privateMetafield?: Maybe<Scalars['String']['output']>;
  /** Private metadata. Requires staff permissions to access. Use `keys` to control which fields you want to include. The default is to include everything. */
  privateMetafields?: Maybe<Scalars['Metadata']['output']>;
  /** Related gift card product. */
  product?: Maybe<Product>;
  /**
   * Start date of gift card.
   * @deprecated No longer supported
   */
  startDate?: Maybe<Scalars['DateTime']['output']>;
  /**
   * The gift card tag.
   *
   * Requires one of the following permissions: MANAGE_GIFT_CARD.
   */
  tags: Array<GiftCardTag>;
  /**
   * The customer who used a gift card.
   * @deprecated No longer supported
   */
  usedBy?: Maybe<User>;
  /**
   * Email address of the customer who used a gift card.
   * @deprecated No longer supported
   */
  usedByEmail?: Maybe<Scalars['String']['output']>;
  /**
   * The customer who bought a gift card.
   * @deprecated Use `createdBy` field instead.
   */
  user?: Maybe<User>;
};


/** A gift card is a prepaid electronic payment card accepted in stores. They can be used during checkout by providing a valid gift card codes. */
export type GiftCardEventsArgs = {
  filter?: InputMaybe<GiftCardEventFilterInput>;
};


/** A gift card is a prepaid electronic payment card accepted in stores. They can be used during checkout by providing a valid gift card codes. */
export type GiftCardMetafieldArgs = {
  key: Scalars['String']['input'];
};


/** A gift card is a prepaid electronic payment card accepted in stores. They can be used during checkout by providing a valid gift card codes. */
export type GiftCardMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** A gift card is a prepaid electronic payment card accepted in stores. They can be used during checkout by providing a valid gift card codes. */
export type GiftCardPrivateMetafieldArgs = {
  key: Scalars['String']['input'];
};


/** A gift card is a prepaid electronic payment card accepted in stores. They can be used during checkout by providing a valid gift card codes. */
export type GiftCardPrivateMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};

/**
 * Activate a gift card.
 *
 * Requires one of the following permissions: MANAGE_GIFT_CARD.
 *
 * Triggers the following webhook events:
 * - GIFT_CARD_STATUS_CHANGED (async): A gift card was activated.
 */
export type GiftCardActivate = {
  __typename?: 'GiftCardActivate';
  errors: Array<GiftCardError>;
  /** Activated gift card. */
  giftCard?: Maybe<GiftCard>;
  /** @deprecated Use `errors` field instead. */
  giftCardErrors: Array<GiftCardError>;
};

/**
 * Adds note to the gift card.
 *
 * Requires one of the following permissions: MANAGE_GIFT_CARD.
 *
 * Triggers the following webhook events:
 * - GIFT_CARD_UPDATED (async): A gift card was updated.
 */
export type GiftCardAddNote = {
  __typename?: 'GiftCardAddNote';
  errors: Array<GiftCardError>;
  /** Gift card note created. */
  event?: Maybe<GiftCardEvent>;
  /** Gift card with the note added. */
  giftCard?: Maybe<GiftCard>;
};

export type GiftCardAddNoteInput = {
  /** Note message. */
  message: Scalars['String']['input'];
};

/**
 * Activate gift cards.
 *
 * Requires one of the following permissions: MANAGE_GIFT_CARD.
 *
 * Triggers the following webhook events:
 * - GIFT_CARD_STATUS_CHANGED (async): A gift card was activated.
 */
export type GiftCardBulkActivate = {
  __typename?: 'GiftCardBulkActivate';
  /** Returns how many objects were affected. */
  count: Scalars['Int']['output'];
  errors: Array<GiftCardError>;
};

/**
 * Creates gift cards.
 *
 * Requires one of the following permissions: MANAGE_GIFT_CARD.
 *
 * Triggers the following webhook events:
 * - GIFT_CARD_CREATED (async): A gift card was created.
 * - NOTIFY_USER (async): A notification for created gift card.
 */
export type GiftCardBulkCreate = {
  __typename?: 'GiftCardBulkCreate';
  /** Returns how many objects were created. */
  count: Scalars['Int']['output'];
  errors: Array<GiftCardError>;
  /** List of created gift cards. */
  giftCards: Array<GiftCard>;
};

export type GiftCardBulkCreateInput = {
  /** Balance of the gift card. */
  balance: PriceInput;
  /** The number of cards to issue. */
  count: Scalars['Int']['input'];
  /** The gift card expiry date. */
  expiryDate?: InputMaybe<Scalars['Date']['input']>;
  /** Determine if gift card is active. */
  isActive: Scalars['Boolean']['input'];
  /** The gift card tags. */
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

/**
 * Deactivate gift cards.
 *
 * Requires one of the following permissions: MANAGE_GIFT_CARD.
 *
 * Triggers the following webhook events:
 * - GIFT_CARD_STATUS_CHANGED (async): A gift card was deactivated.
 */
export type GiftCardBulkDeactivate = {
  __typename?: 'GiftCardBulkDeactivate';
  /** Returns how many objects were affected. */
  count: Scalars['Int']['output'];
  errors: Array<GiftCardError>;
};

/**
 * Deletes gift cards.
 *
 * Requires one of the following permissions: MANAGE_GIFT_CARD.
 *
 * Triggers the following webhook events:
 * - GIFT_CARD_DELETED (async): A gift card was deleted.
 */
export type GiftCardBulkDelete = {
  __typename?: 'GiftCardBulkDelete';
  /** Returns how many objects were affected. */
  count: Scalars['Int']['output'];
  errors: Array<GiftCardError>;
};

export type GiftCardCountableConnection = {
  __typename?: 'GiftCardCountableConnection';
  edges: Array<GiftCardCountableEdge>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** A total count of items in the collection. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type GiftCardCountableEdge = {
  __typename?: 'GiftCardCountableEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: GiftCard;
};

/**
 * Creates a new gift card.
 *
 * Requires one of the following permissions: MANAGE_GIFT_CARD.
 *
 * Triggers the following webhook events:
 * - GIFT_CARD_CREATED (async): A gift card was created.
 * - NOTIFY_USER (async): A notification for created gift card.
 */
export type GiftCardCreate = {
  __typename?: 'GiftCardCreate';
  errors: Array<GiftCardError>;
  giftCard?: Maybe<GiftCard>;
  /** @deprecated Use `errors` field instead. */
  giftCardErrors: Array<GiftCardError>;
};

export type GiftCardCreateInput = {
  /** The gift card tags to add. */
  addTags?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Balance of the gift card. */
  balance: PriceInput;
  /** Slug of a channel from which the email should be sent. */
  channel?: InputMaybe<Scalars['String']['input']>;
  /**
   * Code to use the gift card.
   *
   * DEPRECATED: this field will be removed. The code is now auto generated.
   */
  code?: InputMaybe<Scalars['String']['input']>;
  /**
   * End date of the gift card in ISO 8601 format.
   *
   * DEPRECATED: this field will be removed. Use `expiryDate` from `expirySettings` instead.
   */
  endDate?: InputMaybe<Scalars['Date']['input']>;
  /** The gift card expiry date. */
  expiryDate?: InputMaybe<Scalars['Date']['input']>;
  /** Determine if gift card is active. */
  isActive: Scalars['Boolean']['input'];
  /**
   * Gift Card public metadata.
   *
   * Added in Saleor 3.21. Can be read by any API client authorized to read the object it's attached to.
   *
   * Warning: never store sensitive information, including financial data such as credit card details.
   */
  metadata?: InputMaybe<Array<MetadataInput>>;
  /** The gift card note from the staff member. */
  note?: InputMaybe<Scalars['String']['input']>;
  /**
   * Gift Card private metadata.
   *
   * Added in Saleor 3.21. Requires permissions to modify and to read the metadata of the object it's attached to.
   *
   * Warning: never store sensitive information, including financial data such as credit card details.
   */
  privateMetadata?: InputMaybe<Array<MetadataInput>>;
  /**
   * Start date of the gift card in ISO 8601 format.
   *
   * DEPRECATED: this field will be removed.
   */
  startDate?: InputMaybe<Scalars['Date']['input']>;
  /** Email of the customer to whom gift card will be sent. */
  userEmail?: InputMaybe<Scalars['String']['input']>;
};

/** Event sent when new gift card is created. */
export type GiftCardCreated = Event & {
  __typename?: 'GiftCardCreated';
  /** The gift card the event relates to. */
  giftCard?: Maybe<GiftCard>;
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<IssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient?: Maybe<App>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

/**
 * Deactivate a gift card.
 *
 * Requires one of the following permissions: MANAGE_GIFT_CARD.
 *
 * Triggers the following webhook events:
 * - GIFT_CARD_STATUS_CHANGED (async): A gift card was deactivated.
 */
export type GiftCardDeactivate = {
  __typename?: 'GiftCardDeactivate';
  errors: Array<GiftCardError>;
  /** Deactivated gift card. */
  giftCard?: Maybe<GiftCard>;
  /** @deprecated Use `errors` field instead. */
  giftCardErrors: Array<GiftCardError>;
};

/**
 * Deletes gift card.
 *
 * Requires one of the following permissions: MANAGE_GIFT_CARD.
 *
 * Triggers the following webhook events:
 * - GIFT_CARD_DELETED (async): A gift card was deleted.
 */
export type GiftCardDelete = {
  __typename?: 'GiftCardDelete';
  errors: Array<GiftCardError>;
  giftCard?: Maybe<GiftCard>;
  /** @deprecated Use `errors` field instead. */
  giftCardErrors: Array<GiftCardError>;
};

/** Event sent when gift card is deleted. */
export type GiftCardDeleted = Event & {
  __typename?: 'GiftCardDeleted';
  /** The gift card the event relates to. */
  giftCard?: Maybe<GiftCard>;
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<IssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient?: Maybe<App>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

export type GiftCardError = {
  __typename?: 'GiftCardError';
  /** The error code. */
  code: GiftCardErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field?: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message?: Maybe<Scalars['String']['output']>;
  /** List of tag values that cause the error. */
  tags?: Maybe<Array<Scalars['String']['output']>>;
};

export type GiftCardErrorCode =
  | 'ALREADY_EXISTS'
  | 'DUPLICATED_INPUT_ITEM'
  | 'EXPIRED_GIFT_CARD'
  | 'GRAPHQL_ERROR'
  | 'INVALID'
  | 'NOT_FOUND'
  | 'REQUIRED'
  | 'UNIQUE';

/** History log of the gift card. */
export type GiftCardEvent = Node & {
  __typename?: 'GiftCardEvent';
  /** App that performed the action. Requires one of the following permissions: MANAGE_APPS, OWNER. */
  app?: Maybe<App>;
  /** The gift card balance. */
  balance?: Maybe<GiftCardEventBalance>;
  /** Date when event happened at in ISO 8601 format. */
  date?: Maybe<Scalars['DateTime']['output']>;
  /** Email of the customer. */
  email?: Maybe<Scalars['String']['output']>;
  /** The gift card expiry date. */
  expiryDate?: Maybe<Scalars['Date']['output']>;
  /** ID of the event associated with a gift card. */
  id: Scalars['ID']['output'];
  /** Content of the event. */
  message?: Maybe<Scalars['String']['output']>;
  /** Previous gift card expiry date. */
  oldExpiryDate?: Maybe<Scalars['Date']['output']>;
  /** The list of old gift card tags. */
  oldTags?: Maybe<Array<Scalars['String']['output']>>;
  /** The order ID where gift card was used or bought. */
  orderId?: Maybe<Scalars['ID']['output']>;
  /** User-friendly number of an order where gift card was used or bought. */
  orderNumber?: Maybe<Scalars['String']['output']>;
  /** The list of gift card tags. */
  tags?: Maybe<Array<Scalars['String']['output']>>;
  /** Gift card event type. */
  type?: Maybe<GiftCardEventsEnum>;
  /** User who performed the action. Requires one of the following permissions: MANAGE_USERS, MANAGE_STAFF, OWNER. */
  user?: Maybe<User>;
};

export type GiftCardEventBalance = {
  __typename?: 'GiftCardEventBalance';
  /** Current balance of the gift card. */
  currentBalance: Money;
  /** Initial balance of the gift card. */
  initialBalance?: Maybe<Money>;
  /** Previous current balance of the gift card. */
  oldCurrentBalance?: Maybe<Money>;
  /** Previous initial balance of the gift card. */
  oldInitialBalance?: Maybe<Money>;
};

export type GiftCardEventFilterInput = {
  orders?: InputMaybe<Array<Scalars['ID']['input']>>;
  type?: InputMaybe<GiftCardEventsEnum>;
};

export type GiftCardEventsEnum =
  | 'ACTIVATED'
  | 'BALANCE_RESET'
  | 'BOUGHT'
  | 'DEACTIVATED'
  | 'EXPIRY_DATE_UPDATED'
  | 'ISSUED'
  | 'NOTE_ADDED'
  | 'RESENT'
  | 'SENT_TO_CUSTOMER'
  | 'TAGS_UPDATED'
  | 'UPDATED'
  | 'USED_IN_ORDER';

/** Event sent when gift card export is completed. */
export type GiftCardExportCompleted = Event & {
  __typename?: 'GiftCardExportCompleted';
  /** The export file for gift cards. */
  export?: Maybe<ExportFile>;
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<IssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient?: Maybe<App>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

export type GiftCardFilterInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  createdByEmail?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  currentBalance?: InputMaybe<PriceRangeInput>;
  initialBalance?: InputMaybe<PriceRangeInput>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  metadata?: InputMaybe<Array<MetadataFilter>>;
  products?: InputMaybe<Array<Scalars['ID']['input']>>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  used?: InputMaybe<Scalars['Boolean']['input']>;
  usedBy?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** Event sent when gift card metadata is updated. */
export type GiftCardMetadataUpdated = Event & {
  __typename?: 'GiftCardMetadataUpdated';
  /** The gift card the event relates to. */
  giftCard?: Maybe<GiftCard>;
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<IssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient?: Maybe<App>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

/**
 * Resend a gift card.
 *
 * Requires one of the following permissions: MANAGE_GIFT_CARD.
 *
 * Triggers the following webhook events:
 * - NOTIFY_USER (async): A notification for gift card resend.
 */
export type GiftCardResend = {
  __typename?: 'GiftCardResend';
  errors: Array<GiftCardError>;
  /** Gift card which has been sent. */
  giftCard?: Maybe<GiftCard>;
};

export type GiftCardResendInput = {
  /** Slug of a channel from which the email should be sent. */
  channel: Scalars['String']['input'];
  /** Email to which gift card should be send. */
  email?: InputMaybe<Scalars['String']['input']>;
  /** ID of a gift card to resend. */
  id: Scalars['ID']['input'];
};

/** Event sent when gift card is e-mailed. */
export type GiftCardSent = Event & {
  __typename?: 'GiftCardSent';
  /** Slug of a channel for which this gift card email was sent. */
  channel?: Maybe<Scalars['String']['output']>;
  /** The gift card the event relates to. */
  giftCard?: Maybe<GiftCard>;
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<IssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient?: Maybe<App>;
  /** E-mail address to which gift card was sent. */
  sentToEmail?: Maybe<Scalars['String']['output']>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

/** Gift card related settings from site settings. */
export type GiftCardSettings = {
  __typename?: 'GiftCardSettings';
  /** The gift card expiry period settings. */
  expiryPeriod?: Maybe<TimePeriod>;
  /** The gift card expiry type settings. */
  expiryType: GiftCardSettingsExpiryTypeEnum;
};

export type GiftCardSettingsError = {
  __typename?: 'GiftCardSettingsError';
  /** The error code. */
  code: GiftCardSettingsErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field?: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message?: Maybe<Scalars['String']['output']>;
};

export type GiftCardSettingsErrorCode =
  | 'GRAPHQL_ERROR'
  | 'INVALID'
  | 'REQUIRED';

export type GiftCardSettingsExpiryTypeEnum =
  | 'EXPIRY_PERIOD'
  | 'NEVER_EXPIRE';

/**
 * Update gift card settings.
 *
 * Requires one of the following permissions: MANAGE_GIFT_CARD.
 */
export type GiftCardSettingsUpdate = {
  __typename?: 'GiftCardSettingsUpdate';
  errors: Array<GiftCardSettingsError>;
  /** Gift card settings. */
  giftCardSettings?: Maybe<GiftCardSettings>;
};

export type GiftCardSettingsUpdateInput = {
  /** Defines gift card expiry period. */
  expiryPeriod?: InputMaybe<TimePeriodInputType>;
  /** Defines gift card default expiry settings. */
  expiryType?: InputMaybe<GiftCardSettingsExpiryTypeEnum>;
};

export type GiftCardSortField =
  /** Sort gift cards by created at. */
  | 'CREATED_AT'
  /** Sort gift cards by current balance. */
  | 'CURRENT_BALANCE'
  /** Sort gift cards by product. */
  | 'PRODUCT'
  /** Sort gift cards by used by. */
  | 'USED_BY';

export type GiftCardSortingInput = {
  /** Specifies the direction in which to sort gift cards. */
  direction: OrderDirection;
  /** Sort gift cards by the selected field. */
  field: GiftCardSortField;
};

/** Event sent when gift card status has changed. */
export type GiftCardStatusChanged = Event & {
  __typename?: 'GiftCardStatusChanged';
  /** The gift card the event relates to. */
  giftCard?: Maybe<GiftCard>;
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<IssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient?: Maybe<App>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

/** The gift card tag. */
export type GiftCardTag = Node & {
  __typename?: 'GiftCardTag';
  /** ID of the tag associated with a gift card. */
  id: Scalars['ID']['output'];
  /** Name of the tag associated with a gift card. */
  name: Scalars['String']['output'];
};

export type GiftCardTagCountableConnection = {
  __typename?: 'GiftCardTagCountableConnection';
  edges: Array<GiftCardTagCountableEdge>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** A total count of items in the collection. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type GiftCardTagCountableEdge = {
  __typename?: 'GiftCardTagCountableEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: GiftCardTag;
};

export type GiftCardTagFilterInput = {
  search?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Update a gift card.
 *
 * Requires one of the following permissions: MANAGE_GIFT_CARD.
 *
 * Triggers the following webhook events:
 * - GIFT_CARD_UPDATED (async): A gift card was updated.
 */
export type GiftCardUpdate = {
  __typename?: 'GiftCardUpdate';
  errors: Array<GiftCardError>;
  giftCard?: Maybe<GiftCard>;
  /** @deprecated Use `errors` field instead. */
  giftCardErrors: Array<GiftCardError>;
};

export type GiftCardUpdateInput = {
  /** The gift card tags to add. */
  addTags?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The gift card balance amount. */
  balanceAmount?: InputMaybe<Scalars['PositiveDecimal']['input']>;
  /**
   * End date of the gift card in ISO 8601 format.
   *
   * DEPRECATED: this field will be removed. Use `expiryDate` from `expirySettings` instead.
   */
  endDate?: InputMaybe<Scalars['Date']['input']>;
  /** The gift card expiry date. */
  expiryDate?: InputMaybe<Scalars['Date']['input']>;
  /**
   * Gift Card public metadata.
   *
   * Added in Saleor 3.21. Can be read by any API client authorized to read the object it's attached to.
   *
   * Warning: never store sensitive information, including financial data such as credit card details.
   */
  metadata?: InputMaybe<Array<MetadataInput>>;
  /**
   * Gift Card private metadata.
   *
   * Added in Saleor 3.21. Requires permissions to modify and to read the metadata of the object it's attached to.
   *
   * Warning: never store sensitive information, including financial data such as credit card details.
   */
  privateMetadata?: InputMaybe<Array<MetadataInput>>;
  /** The gift card tags to remove. */
  removeTags?: InputMaybe<Array<Scalars['String']['input']>>;
  /**
   * Start date of the gift card in ISO 8601 format.
   *
   * DEPRECATED: this field will be removed.
   */
  startDate?: InputMaybe<Scalars['Date']['input']>;
};

/** Event sent when gift card is updated. */
export type GiftCardUpdated = Event & {
  __typename?: 'GiftCardUpdated';
  /** The gift card the event relates to. */
  giftCard?: Maybe<GiftCard>;
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<IssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient?: Maybe<App>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

/** Define the filtering options for foreign key fields. */
export type GlobalIdFilterInput = {
  /** The value equal to. */
  eq?: InputMaybe<Scalars['ID']['input']>;
  /** The value included in. */
  oneOf?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** Represents permission group data. */
export type Group = Node & {
  __typename?: 'Group';
  /** List of channels the group has access to. */
  accessibleChannels?: Maybe<Array<Channel>>;
  /** The ID of the group. */
  id: Scalars['ID']['output'];
  /** The name of the group. */
  name: Scalars['String']['output'];
  /** List of group permissions */
  permissions?: Maybe<Array<Permission>>;
  /** Determine if the group have restricted access to channels. */
  restrictedAccessToChannels: Scalars['Boolean']['output'];
  /** True, if the currently authenticated user has rights to manage a group. */
  userCanManage: Scalars['Boolean']['output'];
  /**
   * List of group users
   *
   * Requires one of the following permissions: MANAGE_STAFF.
   */
  users?: Maybe<Array<User>>;
};

export type GroupCountableConnection = {
  __typename?: 'GroupCountableConnection';
  edges: Array<GroupCountableEdge>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** A total count of items in the collection. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type GroupCountableEdge = {
  __typename?: 'GroupCountableEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Group;
};

export type HttpMethod =
  | 'GET'
  | 'POST';

/** Thumbnail formats for icon images. */
export type IconThumbnailFormatEnum =
  | 'ORIGINAL'
  | 'WEBP';

/** Represents an image. */
export type Image = {
  __typename?: 'Image';
  /** Alt text for an image. */
  alt?: Maybe<Scalars['String']['output']>;
  /** The URL of the image. */
  url: Scalars['String']['output'];
};

/** Define the filtering options for integer fields. */
export type IntFilterInput = {
  /** The value equal to. */
  eq?: InputMaybe<Scalars['Int']['input']>;
  /** The value included in. */
  oneOf?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** The value in range. */
  range?: InputMaybe<IntRangeInput>;
};

export type IntRangeInput = {
  /** Value greater than or equal to. */
  gte?: InputMaybe<Scalars['Int']['input']>;
  /** Value less than or equal to. */
  lte?: InputMaybe<Scalars['Int']['input']>;
};

/** Represents an Invoice. */
export type Invoice = Job & Node & ObjectWithMetadata & {
  __typename?: 'Invoice';
  /** Date and time at which invoice was created. */
  createdAt: Scalars['DateTime']['output'];
  /**
   * URL to view an invoice.
   * @deprecated Use `url` field.
   */
  externalUrl?: Maybe<Scalars['String']['output']>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  /** Message associated with an invoice. */
  message?: Maybe<Scalars['String']['output']>;
  /** List of public metadata items. Can be accessed without permissions. */
  metadata: Array<MetadataItem>;
  /**
   * A single key from public metadata.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   */
  metafield?: Maybe<Scalars['String']['output']>;
  /** Public metadata. Use `keys` to control which fields you want to include. The default is to include everything. */
  metafields?: Maybe<Scalars['Metadata']['output']>;
  /** Invoice number. */
  number?: Maybe<Scalars['String']['output']>;
  /** Order related to the invoice. */
  order?: Maybe<Order>;
  /** List of private metadata items. Requires staff permissions to access. */
  privateMetadata: Array<MetadataItem>;
  /**
   * A single key from private metadata. Requires staff permissions to access.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   */
  privateMetafield?: Maybe<Scalars['String']['output']>;
  /** Private metadata. Requires staff permissions to access. Use `keys` to control which fields you want to include. The default is to include everything. */
  privateMetafields?: Maybe<Scalars['Metadata']['output']>;
  /** Job status. */
  status: JobStatusEnum;
  /** Date and time at which invoice was updated. */
  updatedAt: Scalars['DateTime']['output'];
  /** URL to view/download an invoice. */
  url?: Maybe<Scalars['String']['output']>;
};


/** Represents an Invoice. */
export type InvoiceMetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Represents an Invoice. */
export type InvoiceMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Represents an Invoice. */
export type InvoicePrivateMetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Represents an Invoice. */
export type InvoicePrivateMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};

/**
 * Creates a ready to send invoice.
 *
 * Requires one of the following permissions: MANAGE_ORDERS.
 */
export type InvoiceCreate = {
  __typename?: 'InvoiceCreate';
  errors: Array<InvoiceError>;
  invoice?: Maybe<Invoice>;
  /** @deprecated Use `errors` field instead. */
  invoiceErrors: Array<InvoiceError>;
};

export type InvoiceCreateInput = {
  /**
   * Fields required to update the invoice metadata. Can be read by any API client authorized to read the object it's attached to.
   *
   * Warning: never store sensitive information, including financial data such as credit card details.
   */
  metadata?: InputMaybe<Array<MetadataInput>>;
  /** Invoice number. */
  number: Scalars['String']['input'];
  /**
   * Fields required to update the invoice private metadata. Requires permissions to modify and to read the metadata of the object it's attached to.
   *
   * Warning: never store sensitive information, including financial data such as credit card details.
   */
  privateMetadata?: InputMaybe<Array<MetadataInput>>;
  /** URL of an invoice to download. */
  url: Scalars['String']['input'];
};

/**
 * Deletes an invoice.
 *
 * Requires one of the following permissions: MANAGE_ORDERS.
 */
export type InvoiceDelete = {
  __typename?: 'InvoiceDelete';
  errors: Array<InvoiceError>;
  invoice?: Maybe<Invoice>;
  /** @deprecated Use `errors` field instead. */
  invoiceErrors: Array<InvoiceError>;
};

/** Event sent when invoice is deleted. */
export type InvoiceDeleted = Event & {
  __typename?: 'InvoiceDeleted';
  /** The invoice the event relates to. */
  invoice?: Maybe<Invoice>;
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<IssuingPrincipal>;
  /** Order related to the invoice. */
  order?: Maybe<Order>;
  /** The application receiving the webhook. */
  recipient?: Maybe<App>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

export type InvoiceError = {
  __typename?: 'InvoiceError';
  /** The error code. */
  code: InvoiceErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field?: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message?: Maybe<Scalars['String']['output']>;
};

export type InvoiceErrorCode =
  | 'EMAIL_NOT_SET'
  | 'INVALID_STATUS'
  | 'NOT_FOUND'
  | 'NOT_READY'
  | 'NO_INVOICE_PLUGIN'
  | 'NUMBER_NOT_SET'
  | 'REQUIRED'
  | 'URL_NOT_SET';

/** Filter input for invoices. */
export type InvoiceFilterInput = {
  /** Filter invoices by creation date. */
  createdAt?: InputMaybe<DateTimeRangeInput>;
};

/**
 * Request an invoice for the order using plugin.
 *
 * Requires one of the following permissions: MANAGE_ORDERS.
 *
 * Triggers the following webhook events:
 * - INVOICE_REQUESTED (async): An invoice was requested.
 */
export type InvoiceRequest = {
  __typename?: 'InvoiceRequest';
  errors: Array<InvoiceError>;
  invoice?: Maybe<Invoice>;
  /** @deprecated Use `errors` field instead. */
  invoiceErrors: Array<InvoiceError>;
  /** Order related to an invoice. */
  order?: Maybe<Order>;
};

/**
 * Requests deletion of an invoice.
 *
 * Requires one of the following permissions: MANAGE_ORDERS.
 *
 * Triggers the following webhook events:
 * - INVOICE_DELETED (async): An invoice was requested to delete.
 */
export type InvoiceRequestDelete = {
  __typename?: 'InvoiceRequestDelete';
  errors: Array<InvoiceError>;
  invoice?: Maybe<Invoice>;
  /** @deprecated Use `errors` field instead. */
  invoiceErrors: Array<InvoiceError>;
};

/** Event sent when invoice is requested. */
export type InvoiceRequested = Event & {
  __typename?: 'InvoiceRequested';
  /** The invoice the event relates to. */
  invoice?: Maybe<Invoice>;
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<IssuingPrincipal>;
  /** Order related to the invoice. */
  order: Order;
  /** The application receiving the webhook. */
  recipient?: Maybe<App>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

/**
 * Send an invoice notification to the customer.
 *
 * Requires one of the following permissions: MANAGE_ORDERS.
 *
 * Triggers the following webhook events:
 * - INVOICE_SENT (async): A notification for invoice send
 * - NOTIFY_USER (async): A notification for invoice send
 */
export type InvoiceSendNotification = {
  __typename?: 'InvoiceSendNotification';
  errors: Array<InvoiceError>;
  invoice?: Maybe<Invoice>;
  /** @deprecated Use `errors` field instead. */
  invoiceErrors: Array<InvoiceError>;
};

/** Event sent when invoice is sent. */
export type InvoiceSent = Event & {
  __typename?: 'InvoiceSent';
  /** The invoice the event relates to. */
  invoice?: Maybe<Invoice>;
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<IssuingPrincipal>;
  /** Order related to the invoice. */
  order?: Maybe<Order>;
  /** The application receiving the webhook. */
  recipient?: Maybe<App>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

/**
 * Updates an invoice.
 *
 * Requires one of the following permissions: MANAGE_ORDERS.
 */
export type InvoiceUpdate = {
  __typename?: 'InvoiceUpdate';
  errors: Array<InvoiceError>;
  invoice?: Maybe<Invoice>;
  /** @deprecated Use `errors` field instead. */
  invoiceErrors: Array<InvoiceError>;
};

export type IssuingPrincipal = App | User;

export type Job = {
  /** Created date time of job in ISO 8601 format. */
  createdAt: Scalars['DateTime']['output'];
  /** Job message. */
  message?: Maybe<Scalars['String']['output']>;
  /** Job status. */
  status: JobStatusEnum;
  /** Date time of job last update in ISO 8601 format. */
  updatedAt: Scalars['DateTime']['output'];
};

export type JobStatusEnum =
  | 'DELETED'
  | 'FAILED'
  | 'PENDING'
  | 'SUCCESS';

/** Language code enum. It contains all the languages supported by Saleor. */
export type LanguageCodeEnum =
  /** Afrikaans */
  | 'AF'
  /** Afrikaans (Namibia) */
  | 'AF_NA'
  /** Afrikaans (South Africa) */
  | 'AF_ZA'
  /** Aghem */
  | 'AGQ'
  /** Aghem (Cameroon) */
  | 'AGQ_CM'
  /** Akan */
  | 'AK'
  /** Akan (Ghana) */
  | 'AK_GH'
  /** Amharic */
  | 'AM'
  /** Amharic (Ethiopia) */
  | 'AM_ET'
  /** Arabic */
  | 'AR'
  /** Arabic (United Arab Emirates) */
  | 'AR_AE'
  /** Arabic (Bahrain) */
  | 'AR_BH'
  /** Arabic (Djibouti) */
  | 'AR_DJ'
  /** Arabic (Algeria) */
  | 'AR_DZ'
  /** Arabic (Egypt) */
  | 'AR_EG'
  /** Arabic (Western Sahara) */
  | 'AR_EH'
  /** Arabic (Eritrea) */
  | 'AR_ER'
  /** Arabic (Israel) */
  | 'AR_IL'
  /** Arabic (Iraq) */
  | 'AR_IQ'
  /** Arabic (Jordan) */
  | 'AR_JO'
  /** Arabic (Comoros) */
  | 'AR_KM'
  /** Arabic (Kuwait) */
  | 'AR_KW'
  /** Arabic (Lebanon) */
  | 'AR_LB'
  /** Arabic (Libya) */
  | 'AR_LY'
  /** Arabic (Morocco) */
  | 'AR_MA'
  /** Arabic (Mauritania) */
  | 'AR_MR'
  /** Arabic (Oman) */
  | 'AR_OM'
  /** Arabic (Palestinian Territories) */
  | 'AR_PS'
  /** Arabic (Qatar) */
  | 'AR_QA'
  /** Arabic (Saudi Arabia) */
  | 'AR_SA'
  /** Arabic (Sudan) */
  | 'AR_SD'
  /** Arabic (Somalia) */
  | 'AR_SO'
  /** Arabic (South Sudan) */
  | 'AR_SS'
  /** Arabic (Syria) */
  | 'AR_SY'
  /** Arabic (Chad) */
  | 'AR_TD'
  /** Arabic (Tunisia) */
  | 'AR_TN'
  /** Arabic (Yemen) */
  | 'AR_YE'
  /** Assamese */
  | 'AS'
  /** Asu */
  | 'ASA'
  /** Asu (Tanzania) */
  | 'ASA_TZ'
  /** Asturian */
  | 'AST'
  /** Asturian (Spain) */
  | 'AST_ES'
  /** Assamese (India) */
  | 'AS_IN'
  /** Azerbaijani */
  | 'AZ'
  /** Azerbaijani (Cyrillic) */
  | 'AZ_CYRL'
  /** Azerbaijani (Cyrillic, Azerbaijan) */
  | 'AZ_CYRL_AZ'
  /** Azerbaijani (Latin) */
  | 'AZ_LATN'
  /** Azerbaijani (Latin, Azerbaijan) */
  | 'AZ_LATN_AZ'
  /** Basaa */
  | 'BAS'
  /** Basaa (Cameroon) */
  | 'BAS_CM'
  /** Belarusian */
  | 'BE'
  /** Bemba */
  | 'BEM'
  /** Bemba (Zambia) */
  | 'BEM_ZM'
  /** Bena */
  | 'BEZ'
  /** Bena (Tanzania) */
  | 'BEZ_TZ'
  /** Belarusian (Belarus) */
  | 'BE_BY'
  /** Bulgarian */
  | 'BG'
  /** Bulgarian (Bulgaria) */
  | 'BG_BG'
  /** Bambara */
  | 'BM'
  /** Bambara (Mali) */
  | 'BM_ML'
  /** Bangla */
  | 'BN'
  /** Bangla (Bangladesh) */
  | 'BN_BD'
  /** Bangla (India) */
  | 'BN_IN'
  /** Tibetan */
  | 'BO'
  /** Tibetan (China) */
  | 'BO_CN'
  /** Tibetan (India) */
  | 'BO_IN'
  /** Breton */
  | 'BR'
  /** Bodo */
  | 'BRX'
  /** Bodo (India) */
  | 'BRX_IN'
  /** Breton (France) */
  | 'BR_FR'
  /** Bosnian */
  | 'BS'
  /** Bosnian (Cyrillic) */
  | 'BS_CYRL'
  /** Bosnian (Cyrillic, Bosnia & Herzegovina) */
  | 'BS_CYRL_BA'
  /** Bosnian (Latin) */
  | 'BS_LATN'
  /** Bosnian (Latin, Bosnia & Herzegovina) */
  | 'BS_LATN_BA'
  /** Catalan */
  | 'CA'
  /** Catalan (Andorra) */
  | 'CA_AD'
  /** Catalan (Spain) */
  | 'CA_ES'
  /** Catalan (Spain, Valencian) */
  | 'CA_ES_VALENCIA'
  /** Catalan (France) */
  | 'CA_FR'
  /** Catalan (Italy) */
  | 'CA_IT'
  /** Chakma */
  | 'CCP'
  /** Chakma (Bangladesh) */
  | 'CCP_BD'
  /** Chakma (India) */
  | 'CCP_IN'
  /** Chechen */
  | 'CE'
  /** Cebuano */
  | 'CEB'
  /** Cebuano (Philippines) */
  | 'CEB_PH'
  /** Chechen (Russia) */
  | 'CE_RU'
  /** Chiga */
  | 'CGG'
  /** Chiga (Uganda) */
  | 'CGG_UG'
  /** Cherokee */
  | 'CHR'
  /** Cherokee (United States) */
  | 'CHR_US'
  /** Central Kurdish */
  | 'CKB'
  /** Central Kurdish (Iraq) */
  | 'CKB_IQ'
  /** Central Kurdish (Iran) */
  | 'CKB_IR'
  /** Czech */
  | 'CS'
  /** Czech (Czechia) */
  | 'CS_CZ'
  /** Church Slavic */
  | 'CU'
  /** Church Slavic (Russia) */
  | 'CU_RU'
  /** Welsh */
  | 'CY'
  /** Welsh (United Kingdom) */
  | 'CY_GB'
  /** Danish */
  | 'DA'
  /** Taita */
  | 'DAV'
  /** Taita (Kenya) */
  | 'DAV_KE'
  /** Danish (Denmark) */
  | 'DA_DK'
  /** Danish (Greenland) */
  | 'DA_GL'
  /** German */
  | 'DE'
  /** German (Austria) */
  | 'DE_AT'
  /** German (Belgium) */
  | 'DE_BE'
  /** German (Switzerland) */
  | 'DE_CH'
  /** German (Germany) */
  | 'DE_DE'
  /** German (Italy) */
  | 'DE_IT'
  /** German (Liechtenstein) */
  | 'DE_LI'
  /** German (Luxembourg) */
  | 'DE_LU'
  /** Zarma */
  | 'DJE'
  /** Zarma (Niger) */
  | 'DJE_NE'
  /** Lower Sorbian */
  | 'DSB'
  /** Lower Sorbian (Germany) */
  | 'DSB_DE'
  /** Duala */
  | 'DUA'
  /** Duala (Cameroon) */
  | 'DUA_CM'
  /** Jola-Fonyi */
  | 'DYO'
  /** Jola-Fonyi (Senegal) */
  | 'DYO_SN'
  /** Dzongkha */
  | 'DZ'
  /** Dzongkha (Bhutan) */
  | 'DZ_BT'
  /** Embu */
  | 'EBU'
  /** Embu (Kenya) */
  | 'EBU_KE'
  /** Ewe */
  | 'EE'
  /** Ewe (Ghana) */
  | 'EE_GH'
  /** Ewe (Togo) */
  | 'EE_TG'
  /** Greek */
  | 'EL'
  /** Greek (Cyprus) */
  | 'EL_CY'
  /** Greek (Greece) */
  | 'EL_GR'
  /** English */
  | 'EN'
  /** English (United Arab Emirates) */
  | 'EN_AE'
  /** English (Antigua & Barbuda) */
  | 'EN_AG'
  /** English (Anguilla) */
  | 'EN_AI'
  /** English (American Samoa) */
  | 'EN_AS'
  /** English (Austria) */
  | 'EN_AT'
  /** English (Australia) */
  | 'EN_AU'
  /** English (Barbados) */
  | 'EN_BB'
  /** English (Belgium) */
  | 'EN_BE'
  /** English (Burundi) */
  | 'EN_BI'
  /** English (Bermuda) */
  | 'EN_BM'
  /** English (Bahamas) */
  | 'EN_BS'
  /** English (Botswana) */
  | 'EN_BW'
  /** English (Belize) */
  | 'EN_BZ'
  /** English (Canada) */
  | 'EN_CA'
  /** English (Cocos (Keeling) Islands) */
  | 'EN_CC'
  /** English (Switzerland) */
  | 'EN_CH'
  /** English (Cook Islands) */
  | 'EN_CK'
  /** English (Cameroon) */
  | 'EN_CM'
  /** English (Christmas Island) */
  | 'EN_CX'
  /** English (Cyprus) */
  | 'EN_CY'
  /** English (Germany) */
  | 'EN_DE'
  /** English (Diego Garcia) */
  | 'EN_DG'
  /** English (Denmark) */
  | 'EN_DK'
  /** English (Dominica) */
  | 'EN_DM'
  /** English (Eritrea) */
  | 'EN_ER'
  /** English (Finland) */
  | 'EN_FI'
  /** English (Fiji) */
  | 'EN_FJ'
  /** English (Falkland Islands) */
  | 'EN_FK'
  /** English (Micronesia) */
  | 'EN_FM'
  /** English (United Kingdom) */
  | 'EN_GB'
  /** English (Grenada) */
  | 'EN_GD'
  /** English (Guernsey) */
  | 'EN_GG'
  /** English (Ghana) */
  | 'EN_GH'
  /** English (Gibraltar) */
  | 'EN_GI'
  /** English (Gambia) */
  | 'EN_GM'
  /** English (Guam) */
  | 'EN_GU'
  /** English (Guyana) */
  | 'EN_GY'
  /** English (Hong Kong SAR China) */
  | 'EN_HK'
  /** English (Ireland) */
  | 'EN_IE'
  /** English (Israel) */
  | 'EN_IL'
  /** English (Isle of Man) */
  | 'EN_IM'
  /** English (India) */
  | 'EN_IN'
  /** English (British Indian Ocean Territory) */
  | 'EN_IO'
  /** English (Jersey) */
  | 'EN_JE'
  /** English (Jamaica) */
  | 'EN_JM'
  /** English (Kenya) */
  | 'EN_KE'
  /** English (Kiribati) */
  | 'EN_KI'
  /** English (St. Kitts & Nevis) */
  | 'EN_KN'
  /** English (Cayman Islands) */
  | 'EN_KY'
  /** English (St. Lucia) */
  | 'EN_LC'
  /** English (Liberia) */
  | 'EN_LR'
  /** English (Lesotho) */
  | 'EN_LS'
  /** English (Madagascar) */
  | 'EN_MG'
  /** English (Marshall Islands) */
  | 'EN_MH'
  /** English (Macao SAR China) */
  | 'EN_MO'
  /** English (Northern Mariana Islands) */
  | 'EN_MP'
  /** English (Montserrat) */
  | 'EN_MS'
  /** English (Malta) */
  | 'EN_MT'
  /** English (Mauritius) */
  | 'EN_MU'
  /** English (Malawi) */
  | 'EN_MW'
  /** English (Malaysia) */
  | 'EN_MY'
  /** English (Namibia) */
  | 'EN_NA'
  /** English (Norfolk Island) */
  | 'EN_NF'
  /** English (Nigeria) */
  | 'EN_NG'
  /** English (Netherlands) */
  | 'EN_NL'
  /** English (Nauru) */
  | 'EN_NR'
  /** English (Niue) */
  | 'EN_NU'
  /** English (New Zealand) */
  | 'EN_NZ'
  /** English (Papua New Guinea) */
  | 'EN_PG'
  /** English (Philippines) */
  | 'EN_PH'
  /** English (Pakistan) */
  | 'EN_PK'
  /** English (Pitcairn Islands) */
  | 'EN_PN'
  /** English (Puerto Rico) */
  | 'EN_PR'
  /** English (Palau) */
  | 'EN_PW'
  /** English (Rwanda) */
  | 'EN_RW'
  /** English (Solomon Islands) */
  | 'EN_SB'
  /** English (Seychelles) */
  | 'EN_SC'
  /** English (Sudan) */
  | 'EN_SD'
  /** English (Sweden) */
  | 'EN_SE'
  /** English (Singapore) */
  | 'EN_SG'
  /** English (St. Helena) */
  | 'EN_SH'
  /** English (Slovenia) */
  | 'EN_SI'
  /** English (Sierra Leone) */
  | 'EN_SL'
  /** English (South Sudan) */
  | 'EN_SS'
  /** English (Sint Maarten) */
  | 'EN_SX'
  /** English (Eswatini) */
  | 'EN_SZ'
  /** English (Turks & Caicos Islands) */
  | 'EN_TC'
  /** English (Tokelau) */
  | 'EN_TK'
  /** English (Tonga) */
  | 'EN_TO'
  /** English (Trinidad & Tobago) */
  | 'EN_TT'
  /** English (Tuvalu) */
  | 'EN_TV'
  /** English (Tanzania) */
  | 'EN_TZ'
  /** English (Uganda) */
  | 'EN_UG'
  /** English (U.S. Outlying Islands) */
  | 'EN_UM'
  /** English (United States) */
  | 'EN_US'
  /** English (St. Vincent & Grenadines) */
  | 'EN_VC'
  /** English (British Virgin Islands) */
  | 'EN_VG'
  /** English (U.S. Virgin Islands) */
  | 'EN_VI'
  /** English (Vanuatu) */
  | 'EN_VU'
  /** English (Samoa) */
  | 'EN_WS'
  /** English (South Africa) */
  | 'EN_ZA'
  /** English (Zambia) */
  | 'EN_ZM'
  /** English (Zimbabwe) */
  | 'EN_ZW'
  /** Esperanto */
  | 'EO'
  /** Spanish */
  | 'ES'
  /** Spanish (Argentina) */
  | 'ES_AR'
  /** Spanish (Bolivia) */
  | 'ES_BO'
  /** Spanish (Brazil) */
  | 'ES_BR'
  /** Spanish (Belize) */
  | 'ES_BZ'
  /** Spanish (Chile) */
  | 'ES_CL'
  /** Spanish (Colombia) */
  | 'ES_CO'
  /** Spanish (Costa Rica) */
  | 'ES_CR'
  /** Spanish (Cuba) */
  | 'ES_CU'
  /** Spanish (Dominican Republic) */
  | 'ES_DO'
  /** Spanish (Ceuta & Melilla) */
  | 'ES_EA'
  /** Spanish (Ecuador) */
  | 'ES_EC'
  /** Spanish (Spain) */
  | 'ES_ES'
  /** Spanish (Equatorial Guinea) */
  | 'ES_GQ'
  /** Spanish (Guatemala) */
  | 'ES_GT'
  /** Spanish (Honduras) */
  | 'ES_HN'
  /** Spanish (Canary Islands) */
  | 'ES_IC'
  /** Spanish (Mexico) */
  | 'ES_MX'
  /** Spanish (Nicaragua) */
  | 'ES_NI'
  /** Spanish (Panama) */
  | 'ES_PA'
  /** Spanish (Peru) */
  | 'ES_PE'
  /** Spanish (Philippines) */
  | 'ES_PH'
  /** Spanish (Puerto Rico) */
  | 'ES_PR'
  /** Spanish (Paraguay) */
  | 'ES_PY'
  /** Spanish (El Salvador) */
  | 'ES_SV'
  /** Spanish (United States) */
  | 'ES_US'
  /** Spanish (Uruguay) */
  | 'ES_UY'
  /** Spanish (Venezuela) */
  | 'ES_VE'
  /** Estonian */
  | 'ET'
  /** Estonian (Estonia) */
  | 'ET_EE'
  /** Basque */
  | 'EU'
  /** Basque (Spain) */
  | 'EU_ES'
  /** Ewondo */
  | 'EWO'
  /** Ewondo (Cameroon) */
  | 'EWO_CM'
  /** Persian */
  | 'FA'
  /** Persian (Afghanistan) */
  | 'FA_AF'
  /** Persian (Iran) */
  | 'FA_IR'
  /** Fulah */
  | 'FF'
  /** Fulah (Adlam) */
  | 'FF_ADLM'
  /** Fulah (Adlam, Burkina Faso) */
  | 'FF_ADLM_BF'
  /** Fulah (Adlam, Cameroon) */
  | 'FF_ADLM_CM'
  /** Fulah (Adlam, Ghana) */
  | 'FF_ADLM_GH'
  /** Fulah (Adlam, Gambia) */
  | 'FF_ADLM_GM'
  /** Fulah (Adlam, Guinea) */
  | 'FF_ADLM_GN'
  /** Fulah (Adlam, Guinea-Bissau) */
  | 'FF_ADLM_GW'
  /** Fulah (Adlam, Liberia) */
  | 'FF_ADLM_LR'
  /** Fulah (Adlam, Mauritania) */
  | 'FF_ADLM_MR'
  /** Fulah (Adlam, Niger) */
  | 'FF_ADLM_NE'
  /** Fulah (Adlam, Nigeria) */
  | 'FF_ADLM_NG'
  /** Fulah (Adlam, Sierra Leone) */
  | 'FF_ADLM_SL'
  /** Fulah (Adlam, Senegal) */
  | 'FF_ADLM_SN'
  /** Fulah (Latin) */
  | 'FF_LATN'
  /** Fulah (Latin, Burkina Faso) */
  | 'FF_LATN_BF'
  /** Fulah (Latin, Cameroon) */
  | 'FF_LATN_CM'
  /** Fulah (Latin, Ghana) */
  | 'FF_LATN_GH'
  /** Fulah (Latin, Gambia) */
  | 'FF_LATN_GM'
  /** Fulah (Latin, Guinea) */
  | 'FF_LATN_GN'
  /** Fulah (Latin, Guinea-Bissau) */
  | 'FF_LATN_GW'
  /** Fulah (Latin, Liberia) */
  | 'FF_LATN_LR'
  /** Fulah (Latin, Mauritania) */
  | 'FF_LATN_MR'
  /** Fulah (Latin, Niger) */
  | 'FF_LATN_NE'
  /** Fulah (Latin, Nigeria) */
  | 'FF_LATN_NG'
  /** Fulah (Latin, Sierra Leone) */
  | 'FF_LATN_SL'
  /** Fulah (Latin, Senegal) */
  | 'FF_LATN_SN'
  /** Finnish */
  | 'FI'
  /** Filipino */
  | 'FIL'
  /** Filipino (Philippines) */
  | 'FIL_PH'
  /** Finnish (Finland) */
  | 'FI_FI'
  /** Faroese */
  | 'FO'
  /** Faroese (Denmark) */
  | 'FO_DK'
  /** Faroese (Faroe Islands) */
  | 'FO_FO'
  /** French */
  | 'FR'
  /** French (Belgium) */
  | 'FR_BE'
  /** French (Burkina Faso) */
  | 'FR_BF'
  /** French (Burundi) */
  | 'FR_BI'
  /** French (Benin) */
  | 'FR_BJ'
  /** French (St. Barthélemy) */
  | 'FR_BL'
  /** French (Canada) */
  | 'FR_CA'
  /** French (Congo - Kinshasa) */
  | 'FR_CD'
  /** French (Central African Republic) */
  | 'FR_CF'
  /** French (Congo - Brazzaville) */
  | 'FR_CG'
  /** French (Switzerland) */
  | 'FR_CH'
  /** French (Côte d’Ivoire) */
  | 'FR_CI'
  /** French (Cameroon) */
  | 'FR_CM'
  /** French (Djibouti) */
  | 'FR_DJ'
  /** French (Algeria) */
  | 'FR_DZ'
  /** French (France) */
  | 'FR_FR'
  /** French (Gabon) */
  | 'FR_GA'
  /** French (French Guiana) */
  | 'FR_GF'
  /** French (Guinea) */
  | 'FR_GN'
  /** French (Guadeloupe) */
  | 'FR_GP'
  /** French (Equatorial Guinea) */
  | 'FR_GQ'
  /** French (Haiti) */
  | 'FR_HT'
  /** French (Comoros) */
  | 'FR_KM'
  /** French (Luxembourg) */
  | 'FR_LU'
  /** French (Morocco) */
  | 'FR_MA'
  /** French (Monaco) */
  | 'FR_MC'
  /** French (St. Martin) */
  | 'FR_MF'
  /** French (Madagascar) */
  | 'FR_MG'
  /** French (Mali) */
  | 'FR_ML'
  /** French (Martinique) */
  | 'FR_MQ'
  /** French (Mauritania) */
  | 'FR_MR'
  /** French (Mauritius) */
  | 'FR_MU'
  /** French (New Caledonia) */
  | 'FR_NC'
  /** French (Niger) */
  | 'FR_NE'
  /** French (French Polynesia) */
  | 'FR_PF'
  /** French (St. Pierre & Miquelon) */
  | 'FR_PM'
  /** French (Réunion) */
  | 'FR_RE'
  /** French (Rwanda) */
  | 'FR_RW'
  /** French (Seychelles) */
  | 'FR_SC'
  /** French (Senegal) */
  | 'FR_SN'
  /** French (Syria) */
  | 'FR_SY'
  /** French (Chad) */
  | 'FR_TD'
  /** French (Togo) */
  | 'FR_TG'
  /** French (Tunisia) */
  | 'FR_TN'
  /** French (Vanuatu) */
  | 'FR_VU'
  /** French (Wallis & Futuna) */
  | 'FR_WF'
  /** French (Mayotte) */
  | 'FR_YT'
  /** Friulian */
  | 'FUR'
  /** Friulian (Italy) */
  | 'FUR_IT'
  /** Western Frisian */
  | 'FY'
  /** Western Frisian (Netherlands) */
  | 'FY_NL'
  /** Irish */
  | 'GA'
  /** Irish (United Kingdom) */
  | 'GA_GB'
  /** Irish (Ireland) */
  | 'GA_IE'
  /** Scottish Gaelic */
  | 'GD'
  /** Scottish Gaelic (United Kingdom) */
  | 'GD_GB'
  /** Galician */
  | 'GL'
  /** Galician (Spain) */
  | 'GL_ES'
  /** Swiss German */
  | 'GSW'
  /** Swiss German (Switzerland) */
  | 'GSW_CH'
  /** Swiss German (France) */
  | 'GSW_FR'
  /** Swiss German (Liechtenstein) */
  | 'GSW_LI'
  /** Gujarati */
  | 'GU'
  /** Gusii */
  | 'GUZ'
  /** Gusii (Kenya) */
  | 'GUZ_KE'
  /** Gujarati (India) */
  | 'GU_IN'
  /** Manx */
  | 'GV'
  /** Manx (Isle of Man) */
  | 'GV_IM'
  /** Hausa */
  | 'HA'
  /** Hawaiian */
  | 'HAW'
  /** Hawaiian (United States) */
  | 'HAW_US'
  /** Hausa (Ghana) */
  | 'HA_GH'
  /** Hausa (Niger) */
  | 'HA_NE'
  /** Hausa (Nigeria) */
  | 'HA_NG'
  /** Hebrew */
  | 'HE'
  /** Hebrew (Israel) */
  | 'HE_IL'
  /** Hindi */
  | 'HI'
  /** Hindi (India) */
  | 'HI_IN'
  /** Croatian */
  | 'HR'
  /** Croatian (Bosnia & Herzegovina) */
  | 'HR_BA'
  /** Croatian (Croatia) */
  | 'HR_HR'
  /** Upper Sorbian */
  | 'HSB'
  /** Upper Sorbian (Germany) */
  | 'HSB_DE'
  /** Hungarian */
  | 'HU'
  /** Hungarian (Hungary) */
  | 'HU_HU'
  /** Armenian */
  | 'HY'
  /** Armenian (Armenia) */
  | 'HY_AM'
  /** Interlingua */
  | 'IA'
  /** Indonesian */
  | 'ID'
  /** Indonesian (Indonesia) */
  | 'ID_ID'
  /** Igbo */
  | 'IG'
  /** Igbo (Nigeria) */
  | 'IG_NG'
  /** Sichuan Yi */
  | 'II'
  /** Sichuan Yi (China) */
  | 'II_CN'
  /** Icelandic */
  | 'IS'
  /** Icelandic (Iceland) */
  | 'IS_IS'
  /** Italian */
  | 'IT'
  /** Italian (Switzerland) */
  | 'IT_CH'
  /** Italian (Italy) */
  | 'IT_IT'
  /** Italian (San Marino) */
  | 'IT_SM'
  /** Italian (Vatican City) */
  | 'IT_VA'
  /** Japanese */
  | 'JA'
  /** Japanese (Japan) */
  | 'JA_JP'
  /** Ngomba */
  | 'JGO'
  /** Ngomba (Cameroon) */
  | 'JGO_CM'
  /** Machame */
  | 'JMC'
  /** Machame (Tanzania) */
  | 'JMC_TZ'
  /** Javanese */
  | 'JV'
  /** Javanese (Indonesia) */
  | 'JV_ID'
  /** Georgian */
  | 'KA'
  /** Kabyle */
  | 'KAB'
  /** Kabyle (Algeria) */
  | 'KAB_DZ'
  /** Kamba */
  | 'KAM'
  /** Kamba (Kenya) */
  | 'KAM_KE'
  /** Georgian (Georgia) */
  | 'KA_GE'
  /** Makonde */
  | 'KDE'
  /** Makonde (Tanzania) */
  | 'KDE_TZ'
  /** Kabuverdianu */
  | 'KEA'
  /** Kabuverdianu (Cape Verde) */
  | 'KEA_CV'
  /** Koyra Chiini */
  | 'KHQ'
  /** Koyra Chiini (Mali) */
  | 'KHQ_ML'
  /** Kikuyu */
  | 'KI'
  /** Kikuyu (Kenya) */
  | 'KI_KE'
  /** Kazakh */
  | 'KK'
  /** Kako */
  | 'KKJ'
  /** Kako (Cameroon) */
  | 'KKJ_CM'
  /** Kazakh (Kazakhstan) */
  | 'KK_KZ'
  /** Kalaallisut */
  | 'KL'
  /** Kalenjin */
  | 'KLN'
  /** Kalenjin (Kenya) */
  | 'KLN_KE'
  /** Kalaallisut (Greenland) */
  | 'KL_GL'
  /** Khmer */
  | 'KM'
  /** Khmer (Cambodia) */
  | 'KM_KH'
  /** Kannada */
  | 'KN'
  /** Kannada (India) */
  | 'KN_IN'
  /** Korean */
  | 'KO'
  /** Konkani */
  | 'KOK'
  /** Konkani (India) */
  | 'KOK_IN'
  /** Korean (North Korea) */
  | 'KO_KP'
  /** Korean (South Korea) */
  | 'KO_KR'
  /** Kashmiri */
  | 'KS'
  /** Shambala */
  | 'KSB'
  /** Shambala (Tanzania) */
  | 'KSB_TZ'
  /** Bafia */
  | 'KSF'
  /** Bafia (Cameroon) */
  | 'KSF_CM'
  /** Colognian */
  | 'KSH'
  /** Colognian (Germany) */
  | 'KSH_DE'
  /** Kashmiri (Arabic) */
  | 'KS_ARAB'
  /** Kashmiri (Arabic, India) */
  | 'KS_ARAB_IN'
  /** Kurdish */
  | 'KU'
  /** Kurdish (Turkey) */
  | 'KU_TR'
  /** Cornish */
  | 'KW'
  /** Cornish (United Kingdom) */
  | 'KW_GB'
  /** Kyrgyz */
  | 'KY'
  /** Kyrgyz (Kyrgyzstan) */
  | 'KY_KG'
  /** Langi */
  | 'LAG'
  /** Langi (Tanzania) */
  | 'LAG_TZ'
  /** Luxembourgish */
  | 'LB'
  /** Luxembourgish (Luxembourg) */
  | 'LB_LU'
  /** Ganda */
  | 'LG'
  /** Ganda (Uganda) */
  | 'LG_UG'
  /** Lakota */
  | 'LKT'
  /** Lakota (United States) */
  | 'LKT_US'
  /** Lingala */
  | 'LN'
  /** Lingala (Angola) */
  | 'LN_AO'
  /** Lingala (Congo - Kinshasa) */
  | 'LN_CD'
  /** Lingala (Central African Republic) */
  | 'LN_CF'
  /** Lingala (Congo - Brazzaville) */
  | 'LN_CG'
  /** Lao */
  | 'LO'
  /** Lao (Laos) */
  | 'LO_LA'
  /** Northern Luri */
  | 'LRC'
  /** Northern Luri (Iraq) */
  | 'LRC_IQ'
  /** Northern Luri (Iran) */
  | 'LRC_IR'
  /** Lithuanian */
  | 'LT'
  /** Lithuanian (Lithuania) */
  | 'LT_LT'
  /** Luba-Katanga */
  | 'LU'
  /** Luo */
  | 'LUO'
  /** Luo (Kenya) */
  | 'LUO_KE'
  /** Luyia */
  | 'LUY'
  /** Luyia (Kenya) */
  | 'LUY_KE'
  /** Luba-Katanga (Congo - Kinshasa) */
  | 'LU_CD'
  /** Latvian */
  | 'LV'
  /** Latvian (Latvia) */
  | 'LV_LV'
  /** Maithili */
  | 'MAI'
  /** Maithili (India) */
  | 'MAI_IN'
  /** Masai */
  | 'MAS'
  /** Masai (Kenya) */
  | 'MAS_KE'
  /** Masai (Tanzania) */
  | 'MAS_TZ'
  /** Meru */
  | 'MER'
  /** Meru (Kenya) */
  | 'MER_KE'
  /** Morisyen */
  | 'MFE'
  /** Morisyen (Mauritius) */
  | 'MFE_MU'
  /** Malagasy */
  | 'MG'
  /** Makhuwa-Meetto */
  | 'MGH'
  /** Makhuwa-Meetto (Mozambique) */
  | 'MGH_MZ'
  /** Metaʼ */
  | 'MGO'
  /** Metaʼ (Cameroon) */
  | 'MGO_CM'
  /** Malagasy (Madagascar) */
  | 'MG_MG'
  /** Maori */
  | 'MI'
  /** Maori (New Zealand) */
  | 'MI_NZ'
  /** Macedonian */
  | 'MK'
  /** Macedonian (North Macedonia) */
  | 'MK_MK'
  /** Malayalam */
  | 'ML'
  /** Malayalam (India) */
  | 'ML_IN'
  /** Mongolian */
  | 'MN'
  /** Manipuri */
  | 'MNI'
  /** Manipuri (Bangla) */
  | 'MNI_BENG'
  /** Manipuri (Bangla, India) */
  | 'MNI_BENG_IN'
  /** Mongolian (Mongolia) */
  | 'MN_MN'
  /** Marathi */
  | 'MR'
  /** Marathi (India) */
  | 'MR_IN'
  /** Malay */
  | 'MS'
  /** Malay (Brunei) */
  | 'MS_BN'
  /** Malay (Indonesia) */
  | 'MS_ID'
  /** Malay (Malaysia) */
  | 'MS_MY'
  /** Malay (Singapore) */
  | 'MS_SG'
  /** Maltese */
  | 'MT'
  /** Maltese (Malta) */
  | 'MT_MT'
  /** Mundang */
  | 'MUA'
  /** Mundang (Cameroon) */
  | 'MUA_CM'
  /** Burmese */
  | 'MY'
  /** Burmese (Myanmar (Burma)) */
  | 'MY_MM'
  /** Mazanderani */
  | 'MZN'
  /** Mazanderani (Iran) */
  | 'MZN_IR'
  /** Nama */
  | 'NAQ'
  /** Nama (Namibia) */
  | 'NAQ_NA'
  /** Norwegian Bokmål */
  | 'NB'
  /** Norwegian Bokmål (Norway) */
  | 'NB_NO'
  /** Norwegian Bokmål (Svalbard & Jan Mayen) */
  | 'NB_SJ'
  /** North Ndebele */
  | 'ND'
  /** Low German */
  | 'NDS'
  /** Low German (Germany) */
  | 'NDS_DE'
  /** Low German (Netherlands) */
  | 'NDS_NL'
  /** North Ndebele (Zimbabwe) */
  | 'ND_ZW'
  /** Nepali */
  | 'NE'
  /** Nepali (India) */
  | 'NE_IN'
  /** Nepali (Nepal) */
  | 'NE_NP'
  /** Dutch */
  | 'NL'
  /** Dutch (Aruba) */
  | 'NL_AW'
  /** Dutch (Belgium) */
  | 'NL_BE'
  /** Dutch (Caribbean Netherlands) */
  | 'NL_BQ'
  /** Dutch (Curaçao) */
  | 'NL_CW'
  /** Dutch (Netherlands) */
  | 'NL_NL'
  /** Dutch (Suriname) */
  | 'NL_SR'
  /** Dutch (Sint Maarten) */
  | 'NL_SX'
  /** Kwasio */
  | 'NMG'
  /** Kwasio (Cameroon) */
  | 'NMG_CM'
  /** Norwegian Nynorsk */
  | 'NN'
  /** Ngiemboon */
  | 'NNH'
  /** Ngiemboon (Cameroon) */
  | 'NNH_CM'
  /** Norwegian Nynorsk (Norway) */
  | 'NN_NO'
  /** Nuer */
  | 'NUS'
  /** Nuer (South Sudan) */
  | 'NUS_SS'
  /** Nyankole */
  | 'NYN'
  /** Nyankole (Uganda) */
  | 'NYN_UG'
  /** Oromo */
  | 'OM'
  /** Oromo (Ethiopia) */
  | 'OM_ET'
  /** Oromo (Kenya) */
  | 'OM_KE'
  /** Odia */
  | 'OR'
  /** Odia (India) */
  | 'OR_IN'
  /** Ossetic */
  | 'OS'
  /** Ossetic (Georgia) */
  | 'OS_GE'
  /** Ossetic (Russia) */
  | 'OS_RU'
  /** Punjabi */
  | 'PA'
  /** Punjabi (Arabic) */
  | 'PA_ARAB'
  /** Punjabi (Arabic, Pakistan) */
  | 'PA_ARAB_PK'
  /** Punjabi (Gurmukhi) */
  | 'PA_GURU'
  /** Punjabi (Gurmukhi, India) */
  | 'PA_GURU_IN'
  /** Nigerian Pidgin */
  | 'PCM'
  /** Nigerian Pidgin (Nigeria) */
  | 'PCM_NG'
  /** Polish */
  | 'PL'
  /** Polish (Poland) */
  | 'PL_PL'
  /** Prussian */
  | 'PRG'
  /** Pashto */
  | 'PS'
  /** Pashto (Afghanistan) */
  | 'PS_AF'
  /** Pashto (Pakistan) */
  | 'PS_PK'
  /** Portuguese */
  | 'PT'
  /** Portuguese (Angola) */
  | 'PT_AO'
  /** Portuguese (Brazil) */
  | 'PT_BR'
  /** Portuguese (Switzerland) */
  | 'PT_CH'
  /** Portuguese (Cape Verde) */
  | 'PT_CV'
  /** Portuguese (Equatorial Guinea) */
  | 'PT_GQ'
  /** Portuguese (Guinea-Bissau) */
  | 'PT_GW'
  /** Portuguese (Luxembourg) */
  | 'PT_LU'
  /** Portuguese (Macao SAR China) */
  | 'PT_MO'
  /** Portuguese (Mozambique) */
  | 'PT_MZ'
  /** Portuguese (Portugal) */
  | 'PT_PT'
  /** Portuguese (São Tomé & Príncipe) */
  | 'PT_ST'
  /** Portuguese (Timor-Leste) */
  | 'PT_TL'
  /** Quechua */
  | 'QU'
  /** Quechua (Bolivia) */
  | 'QU_BO'
  /** Quechua (Ecuador) */
  | 'QU_EC'
  /** Quechua (Peru) */
  | 'QU_PE'
  /** Romansh */
  | 'RM'
  /** Romansh (Switzerland) */
  | 'RM_CH'
  /** Rundi */
  | 'RN'
  /** Rundi (Burundi) */
  | 'RN_BI'
  /** Romanian */
  | 'RO'
  /** Rombo */
  | 'ROF'
  /** Rombo (Tanzania) */
  | 'ROF_TZ'
  /** Romanian (Moldova) */
  | 'RO_MD'
  /** Romanian (Romania) */
  | 'RO_RO'
  /** Russian */
  | 'RU'
  /** Russian (Belarus) */
  | 'RU_BY'
  /** Russian (Kyrgyzstan) */
  | 'RU_KG'
  /** Russian (Kazakhstan) */
  | 'RU_KZ'
  /** Russian (Moldova) */
  | 'RU_MD'
  /** Russian (Russia) */
  | 'RU_RU'
  /** Russian (Ukraine) */
  | 'RU_UA'
  /** Kinyarwanda */
  | 'RW'
  /** Rwa */
  | 'RWK'
  /** Rwa (Tanzania) */
  | 'RWK_TZ'
  /** Kinyarwanda (Rwanda) */
  | 'RW_RW'
  /** Sakha */
  | 'SAH'
  /** Sakha (Russia) */
  | 'SAH_RU'
  /** Samburu */
  | 'SAQ'
  /** Samburu (Kenya) */
  | 'SAQ_KE'
  /** Santali */
  | 'SAT'
  /** Santali (Ol Chiki) */
  | 'SAT_OLCK'
  /** Santali (Ol Chiki, India) */
  | 'SAT_OLCK_IN'
  /** Sangu */
  | 'SBP'
  /** Sangu (Tanzania) */
  | 'SBP_TZ'
  /** Sindhi */
  | 'SD'
  /** Sindhi (Arabic) */
  | 'SD_ARAB'
  /** Sindhi (Arabic, Pakistan) */
  | 'SD_ARAB_PK'
  /** Sindhi (Devanagari) */
  | 'SD_DEVA'
  /** Sindhi (Devanagari, India) */
  | 'SD_DEVA_IN'
  /** Northern Sami */
  | 'SE'
  /** Sena */
  | 'SEH'
  /** Sena (Mozambique) */
  | 'SEH_MZ'
  /** Koyraboro Senni */
  | 'SES'
  /** Koyraboro Senni (Mali) */
  | 'SES_ML'
  /** Northern Sami (Finland) */
  | 'SE_FI'
  /** Northern Sami (Norway) */
  | 'SE_NO'
  /** Northern Sami (Sweden) */
  | 'SE_SE'
  /** Sango */
  | 'SG'
  /** Sango (Central African Republic) */
  | 'SG_CF'
  /** Tachelhit */
  | 'SHI'
  /** Tachelhit (Latin) */
  | 'SHI_LATN'
  /** Tachelhit (Latin, Morocco) */
  | 'SHI_LATN_MA'
  /** Tachelhit (Tifinagh) */
  | 'SHI_TFNG'
  /** Tachelhit (Tifinagh, Morocco) */
  | 'SHI_TFNG_MA'
  /** Sinhala */
  | 'SI'
  /** Sinhala (Sri Lanka) */
  | 'SI_LK'
  /** Slovak */
  | 'SK'
  /** Slovak (Slovakia) */
  | 'SK_SK'
  /** Slovenian */
  | 'SL'
  /** Slovenian (Slovenia) */
  | 'SL_SI'
  /** Inari Sami */
  | 'SMN'
  /** Inari Sami (Finland) */
  | 'SMN_FI'
  /** Shona */
  | 'SN'
  /** Shona (Zimbabwe) */
  | 'SN_ZW'
  /** Somali */
  | 'SO'
  /** Somali (Djibouti) */
  | 'SO_DJ'
  /** Somali (Ethiopia) */
  | 'SO_ET'
  /** Somali (Kenya) */
  | 'SO_KE'
  /** Somali (Somalia) */
  | 'SO_SO'
  /** Albanian */
  | 'SQ'
  /** Albanian (Albania) */
  | 'SQ_AL'
  /** Albanian (North Macedonia) */
  | 'SQ_MK'
  /** Albanian (Kosovo) */
  | 'SQ_XK'
  /** Serbian */
  | 'SR'
  /** Serbian (Cyrillic) */
  | 'SR_CYRL'
  /** Serbian (Cyrillic, Bosnia & Herzegovina) */
  | 'SR_CYRL_BA'
  /** Serbian (Cyrillic, Montenegro) */
  | 'SR_CYRL_ME'
  /** Serbian (Cyrillic, Serbia) */
  | 'SR_CYRL_RS'
  /** Serbian (Cyrillic, Kosovo) */
  | 'SR_CYRL_XK'
  /** Serbian (Latin) */
  | 'SR_LATN'
  /** Serbian (Latin, Bosnia & Herzegovina) */
  | 'SR_LATN_BA'
  /** Serbian (Latin, Montenegro) */
  | 'SR_LATN_ME'
  /** Serbian (Latin, Serbia) */
  | 'SR_LATN_RS'
  /** Serbian (Latin, Kosovo) */
  | 'SR_LATN_XK'
  /** Sundanese */
  | 'SU'
  /** Sundanese (Latin) */
  | 'SU_LATN'
  /** Sundanese (Latin, Indonesia) */
  | 'SU_LATN_ID'
  /** Swedish */
  | 'SV'
  /** Swedish (Åland Islands) */
  | 'SV_AX'
  /** Swedish (Finland) */
  | 'SV_FI'
  /** Swedish (Sweden) */
  | 'SV_SE'
  /** Swahili */
  | 'SW'
  /** Swahili (Congo - Kinshasa) */
  | 'SW_CD'
  /** Swahili (Kenya) */
  | 'SW_KE'
  /** Swahili (Tanzania) */
  | 'SW_TZ'
  /** Swahili (Uganda) */
  | 'SW_UG'
  /** Tamil */
  | 'TA'
  /** Tamil (India) */
  | 'TA_IN'
  /** Tamil (Sri Lanka) */
  | 'TA_LK'
  /** Tamil (Malaysia) */
  | 'TA_MY'
  /** Tamil (Singapore) */
  | 'TA_SG'
  /** Telugu */
  | 'TE'
  /** Teso */
  | 'TEO'
  /** Teso (Kenya) */
  | 'TEO_KE'
  /** Teso (Uganda) */
  | 'TEO_UG'
  /** Telugu (India) */
  | 'TE_IN'
  /** Tajik */
  | 'TG'
  /** Tajik (Tajikistan) */
  | 'TG_TJ'
  /** Thai */
  | 'TH'
  /** Thai (Thailand) */
  | 'TH_TH'
  /** Tigrinya */
  | 'TI'
  /** Tigrinya (Eritrea) */
  | 'TI_ER'
  /** Tigrinya (Ethiopia) */
  | 'TI_ET'
  /** Turkmen */
  | 'TK'
  /** Turkmen (Turkmenistan) */
  | 'TK_TM'
  /** Tongan */
  | 'TO'
  /** Tongan (Tonga) */
  | 'TO_TO'
  /** Turkish */
  | 'TR'
  /** Turkish (Cyprus) */
  | 'TR_CY'
  /** Turkish (Turkey) */
  | 'TR_TR'
  /** Tatar */
  | 'TT'
  /** Tatar (Russia) */
  | 'TT_RU'
  /** Tasawaq */
  | 'TWQ'
  /** Tasawaq (Niger) */
  | 'TWQ_NE'
  /** Central Atlas Tamazight */
  | 'TZM'
  /** Central Atlas Tamazight (Morocco) */
  | 'TZM_MA'
  /** Uyghur */
  | 'UG'
  /** Uyghur (China) */
  | 'UG_CN'
  /** Ukrainian */
  | 'UK'
  /** Ukrainian (Ukraine) */
  | 'UK_UA'
  /** Urdu */
  | 'UR'
  /** Urdu (India) */
  | 'UR_IN'
  /** Urdu (Pakistan) */
  | 'UR_PK'
  /** Uzbek */
  | 'UZ'
  /** Uzbek (Arabic) */
  | 'UZ_ARAB'
  /** Uzbek (Arabic, Afghanistan) */
  | 'UZ_ARAB_AF'
  /** Uzbek (Cyrillic) */
  | 'UZ_CYRL'
  /** Uzbek (Cyrillic, Uzbekistan) */
  | 'UZ_CYRL_UZ'
  /** Uzbek (Latin) */
  | 'UZ_LATN'
  /** Uzbek (Latin, Uzbekistan) */
  | 'UZ_LATN_UZ'
  /** Vai */
  | 'VAI'
  /** Vai (Latin) */
  | 'VAI_LATN'
  /** Vai (Latin, Liberia) */
  | 'VAI_LATN_LR'
  /** Vai (Vai) */
  | 'VAI_VAII'
  /** Vai (Vai, Liberia) */
  | 'VAI_VAII_LR'
  /** Vietnamese */
  | 'VI'
  /** Vietnamese (Vietnam) */
  | 'VI_VN'
  /** Volapük */
  | 'VO'
  /** Vunjo */
  | 'VUN'
  /** Vunjo (Tanzania) */
  | 'VUN_TZ'
  /** Walser */
  | 'WAE'
  /** Walser (Switzerland) */
  | 'WAE_CH'
  /** Wolof */
  | 'WO'
  /** Wolof (Senegal) */
  | 'WO_SN'
  /** Xhosa */
  | 'XH'
  /** Xhosa (South Africa) */
  | 'XH_ZA'
  /** Soga */
  | 'XOG'
  /** Soga (Uganda) */
  | 'XOG_UG'
  /** Yangben */
  | 'YAV'
  /** Yangben (Cameroon) */
  | 'YAV_CM'
  /** Yiddish */
  | 'YI'
  /** Yoruba */
  | 'YO'
  /** Yoruba (Benin) */
  | 'YO_BJ'
  /** Yoruba (Nigeria) */
  | 'YO_NG'
  /** Cantonese */
  | 'YUE'
  /** Cantonese (Simplified) */
  | 'YUE_HANS'
  /** Cantonese (Simplified, China) */
  | 'YUE_HANS_CN'
  /** Cantonese (Traditional) */
  | 'YUE_HANT'
  /** Cantonese (Traditional, Hong Kong SAR China) */
  | 'YUE_HANT_HK'
  /** Standard Moroccan Tamazight */
  | 'ZGH'
  /** Standard Moroccan Tamazight (Morocco) */
  | 'ZGH_MA'
  /** Chinese */
  | 'ZH'
  /** Chinese (Simplified) */
  | 'ZH_HANS'
  /** Chinese (Simplified, China) */
  | 'ZH_HANS_CN'
  /** Chinese (Simplified, Hong Kong SAR China) */
  | 'ZH_HANS_HK'
  /** Chinese (Simplified, Macao SAR China) */
  | 'ZH_HANS_MO'
  /** Chinese (Simplified, Singapore) */
  | 'ZH_HANS_SG'
  /** Chinese (Traditional) */
  | 'ZH_HANT'
  /** Chinese (Traditional, Hong Kong SAR China) */
  | 'ZH_HANT_HK'
  /** Chinese (Traditional, Macao SAR China) */
  | 'ZH_HANT_MO'
  /** Chinese (Traditional, Taiwan) */
  | 'ZH_HANT_TW'
  /** Zulu */
  | 'ZU'
  /** Zulu (South Africa) */
  | 'ZU_ZA';

export type LanguageDisplay = {
  __typename?: 'LanguageDisplay';
  /** ISO 639 representation of the language name. */
  code: LanguageCodeEnum;
  /** Full name of the language. */
  language: Scalars['String']['output'];
};

/** Store the current and allowed usage. */
export type LimitInfo = {
  __typename?: 'LimitInfo';
  /** Defines the allowed maximum resource usage, null means unlimited. */
  allowedUsage: Limits;
  /** Defines the current resource usage. */
  currentUsage: Limits;
};

export type Limits = {
  __typename?: 'Limits';
  /** Defines the number of channels. */
  channels?: Maybe<Scalars['Int']['output']>;
  /** Defines the number of order. */
  orders?: Maybe<Scalars['Int']['output']>;
  /** Defines the number of product variants. */
  productVariants?: Maybe<Scalars['Int']['output']>;
  /** Defines the number of staff users. */
  staffUsers?: Maybe<Scalars['Int']['output']>;
  /** Defines the number of warehouses. */
  warehouses?: Maybe<Scalars['Int']['output']>;
};

/** Filter input for order lines data. */
export type LinesFilterInput = {
  /** Filter by metadata fields of order lines. */
  metadata?: InputMaybe<MetadataFilterInput>;
};

/**
 * List payment methods stored for the user by payment gateway.
 *
 * Note: this API is currently in Feature Preview and can be subject to changes at later point.
 */
export type ListStoredPaymentMethods = Event & {
  __typename?: 'ListStoredPaymentMethods';
  /** Channel in context which was used to fetch the list of payment methods. */
  channel: Channel;
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<IssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient?: Maybe<App>;
  /** The user for which the app should return a list of payment methods. */
  user: User;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

/** The manifest definition. */
export type Manifest = {
  __typename?: 'Manifest';
  /** Description of the app displayed in the dashboard. */
  about?: Maybe<Scalars['String']['output']>;
  /** App website rendered in the dashboard. */
  appUrl?: Maybe<Scalars['String']['output']>;
  /** The audience that will be included in all JWT tokens for the app. */
  audience?: Maybe<Scalars['String']['output']>;
  /** The App's author name. */
  author?: Maybe<Scalars['String']['output']>;
  /** App's brand data. */
  brand?: Maybe<AppManifestBrand>;
  /**
   * URL to iframe with the configuration for the app.
   * @deprecated Use `appUrl` instead.
   */
  configurationUrl?: Maybe<Scalars['String']['output']>;
  /**
   * Description of the data privacy defined for this app.
   * @deprecated Use `dataPrivacyUrl` instead.
   */
  dataPrivacy?: Maybe<Scalars['String']['output']>;
  /** URL to the full privacy policy. */
  dataPrivacyUrl?: Maybe<Scalars['String']['output']>;
  /** List of extensions that will be mounted in Saleor's dashboard. For details, please [see the extension section.](https://docs.saleor.io/developer/extending/apps/extending-dashboard-with-apps#key-concepts) */
  extensions: Array<AppManifestExtension>;
  /** External URL to the app homepage. */
  homepageUrl?: Maybe<Scalars['String']['output']>;
  /** The identifier of the manifest for the app. */
  identifier: Scalars['String']['output'];
  /** The name of the manifest for the app . */
  name: Scalars['String']['output'];
  /** The array permissions required for the app. */
  permissions?: Maybe<Array<Permission>>;
  /** Determines the app's required Saleor version as semver range. */
  requiredSaleorVersion?: Maybe<AppManifestRequiredSaleorVersion>;
  /** External URL to the page where app users can find support. */
  supportUrl?: Maybe<Scalars['String']['output']>;
  /** Endpoint used during process of app installation, [see installing an app.](https://docs.saleor.io/developer/extending/apps/installing-apps#installing-an-app) */
  tokenTargetUrl?: Maybe<Scalars['String']['output']>;
  /** The version of the manifest for the app. */
  version: Scalars['String']['output'];
  /** List of the app's webhooks. */
  webhooks: Array<AppManifestWebhook>;
};

/** Metadata for the Margin class. */
export type Margin = {
  __typename?: 'Margin';
  /** The starting value of the margin. */
  start?: Maybe<Scalars['Int']['output']>;
  /** The ending value of the margin. */
  stop?: Maybe<Scalars['Int']['output']>;
};

/**
 * Determine the mark as paid strategy for the channel.
 *
 *     TRANSACTION_FLOW - new orders marked as paid will receive a
 *     `TransactionItem` object, that will cover the `order.total`.
 *
 *     PAYMENT_FLOW - new orders marked as paid will receive a
 *     `Payment` object, that will cover the `order.total`.
 *
 *
 */
export type MarkAsPaidStrategyEnum =
  | 'PAYMENT_FLOW'
  | 'TRANSACTION_FLOW';

export type MeasurementUnitsEnum =
  | 'ACRE_FT'
  | 'ACRE_IN'
  | 'CM'
  | 'CUBIC_CENTIMETER'
  | 'CUBIC_DECIMETER'
  | 'CUBIC_FOOT'
  | 'CUBIC_INCH'
  | 'CUBIC_METER'
  | 'CUBIC_MILLIMETER'
  | 'CUBIC_YARD'
  | 'DM'
  | 'FL_OZ'
  | 'FT'
  | 'G'
  | 'INCH'
  | 'KG'
  | 'KM'
  | 'LB'
  | 'LITER'
  | 'M'
  | 'MM'
  | 'OZ'
  | 'PINT'
  | 'QT'
  | 'SQ_CM'
  | 'SQ_DM'
  | 'SQ_FT'
  | 'SQ_INCH'
  | 'SQ_KM'
  | 'SQ_M'
  | 'SQ_MM'
  | 'SQ_YD'
  | 'TONNE'
  | 'YD';

export type MeasurementUnitsEnumFilterInput = {
  /** The value equal to. */
  eq?: InputMaybe<MeasurementUnitsEnum>;
  /** The value included in. */
  oneOf?: InputMaybe<Array<MeasurementUnitsEnum>>;
};

export type MediaChoicesSortField =
  /** Sort media by ID. */
  | 'ID';

export type MediaInput = {
  /** Alt text for a product media. */
  alt?: InputMaybe<Scalars['String']['input']>;
  /** Represents an image file in a multipart request. */
  image?: InputMaybe<Scalars['Upload']['input']>;
  /** Represents an URL to an external media. */
  mediaUrl?: InputMaybe<Scalars['String']['input']>;
};

export type MediaSortingInput = {
  /** Specifies the direction in which to sort media. */
  direction: OrderDirection;
  /** Sort media by the selected field. */
  field: MediaChoicesSortField;
};

/** Represents a single menu - an object that is used to help navigate through the store. */
export type Menu = Node & ObjectWithMetadata & {
  __typename?: 'Menu';
  /** The ID of the menu. */
  id: Scalars['ID']['output'];
  /** Menu items associated with this menu. */
  items?: Maybe<Array<MenuItem>>;
  /** List of public metadata items. Can be accessed without permissions. */
  metadata: Array<MetadataItem>;
  /**
   * A single key from public metadata.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   */
  metafield?: Maybe<Scalars['String']['output']>;
  /** Public metadata. Use `keys` to control which fields you want to include. The default is to include everything. */
  metafields?: Maybe<Scalars['Metadata']['output']>;
  /** The name of the menu. */
  name: Scalars['String']['output'];
  /** List of private metadata items. Requires staff permissions to access. */
  privateMetadata: Array<MetadataItem>;
  /**
   * A single key from private metadata. Requires staff permissions to access.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   */
  privateMetafield?: Maybe<Scalars['String']['output']>;
  /** Private metadata. Requires staff permissions to access. Use `keys` to control which fields you want to include. The default is to include everything. */
  privateMetafields?: Maybe<Scalars['Metadata']['output']>;
  /** Slug of the menu. */
  slug: Scalars['String']['output'];
};


/** Represents a single menu - an object that is used to help navigate through the store. */
export type MenuMetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Represents a single menu - an object that is used to help navigate through the store. */
export type MenuMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Represents a single menu - an object that is used to help navigate through the store. */
export type MenuPrivateMetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Represents a single menu - an object that is used to help navigate through the store. */
export type MenuPrivateMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};

/**
 * Deletes menus.
 *
 * Requires one of the following permissions: MANAGE_MENUS.
 *
 * Triggers the following webhook events:
 * - MENU_DELETED (async): A menu was deleted.
 */
export type MenuBulkDelete = {
  __typename?: 'MenuBulkDelete';
  /** Returns how many objects were affected. */
  count: Scalars['Int']['output'];
  errors: Array<MenuError>;
  /** @deprecated Use `errors` field instead. */
  menuErrors: Array<MenuError>;
};

export type MenuCountableConnection = {
  __typename?: 'MenuCountableConnection';
  edges: Array<MenuCountableEdge>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** A total count of items in the collection. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type MenuCountableEdge = {
  __typename?: 'MenuCountableEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Menu;
};

/**
 * Creates a new Menu.
 *
 * Requires one of the following permissions: MANAGE_MENUS.
 *
 * Triggers the following webhook events:
 * - MENU_CREATED (async): A menu was created.
 */
export type MenuCreate = {
  __typename?: 'MenuCreate';
  errors: Array<MenuError>;
  menu?: Maybe<Menu>;
  /** @deprecated Use `errors` field instead. */
  menuErrors: Array<MenuError>;
};

export type MenuCreateInput = {
  /** List of menu items. */
  items?: InputMaybe<Array<MenuItemInput>>;
  /** Name of the menu. */
  name: Scalars['String']['input'];
  /** Slug of the menu. Will be generated if not provided. */
  slug?: InputMaybe<Scalars['String']['input']>;
};

/** Event sent when new menu is created. */
export type MenuCreated = Event & {
  __typename?: 'MenuCreated';
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<IssuingPrincipal>;
  /** The menu the event relates to. */
  menu?: Maybe<Menu>;
  /** The application receiving the webhook. */
  recipient?: Maybe<App>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};


/** Event sent when new menu is created. */
export type MenuCreatedMenuArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Deletes a menu.
 *
 * Requires one of the following permissions: MANAGE_MENUS.
 *
 * Triggers the following webhook events:
 * - MENU_DELETED (async): A menu was deleted.
 */
export type MenuDelete = {
  __typename?: 'MenuDelete';
  errors: Array<MenuError>;
  menu?: Maybe<Menu>;
  /** @deprecated Use `errors` field instead. */
  menuErrors: Array<MenuError>;
};

/** Event sent when menu is deleted. */
export type MenuDeleted = Event & {
  __typename?: 'MenuDeleted';
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<IssuingPrincipal>;
  /** The menu the event relates to. */
  menu?: Maybe<Menu>;
  /** The application receiving the webhook. */
  recipient?: Maybe<App>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};


/** Event sent when menu is deleted. */
export type MenuDeletedMenuArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
};

export type MenuError = {
  __typename?: 'MenuError';
  /** The error code. */
  code: MenuErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field?: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message?: Maybe<Scalars['String']['output']>;
};

export type MenuErrorCode =
  | 'CANNOT_ASSIGN_NODE'
  | 'GRAPHQL_ERROR'
  | 'INVALID'
  | 'INVALID_MENU_ITEM'
  | 'NOT_FOUND'
  | 'NO_MENU_ITEM_PROVIDED'
  | 'REQUIRED'
  | 'TOO_MANY_MENU_ITEMS'
  | 'UNIQUE';

export type MenuFilterInput = {
  metadata?: InputMaybe<Array<MetadataFilter>>;
  search?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Array<Scalars['String']['input']>>;
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type MenuInput = {
  /** Name of the menu. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Slug of the menu. */
  slug?: InputMaybe<Scalars['String']['input']>;
};

/** Represents a single item of the related menu. Can store categories, collection or pages. */
export type MenuItem = Node & ObjectWithMetadata & {
  __typename?: 'MenuItem';
  /** Category associated with the menu item. */
  category?: Maybe<Category>;
  /** Represents the child items of the current menu item. */
  children?: Maybe<Array<MenuItem>>;
  /** A collection associated with this menu item. Requires one of the following permissions to include the unpublished items: MANAGE_ORDERS, MANAGE_DISCOUNTS, MANAGE_PRODUCTS. */
  collection?: Maybe<Collection>;
  /** The ID of the menu item. */
  id: Scalars['ID']['output'];
  /** Indicates the position of the menu item within the menu structure. */
  level: Scalars['Int']['output'];
  /** Represents the menu to which the menu item belongs. */
  menu: Menu;
  /** List of public metadata items. Can be accessed without permissions. */
  metadata: Array<MetadataItem>;
  /**
   * A single key from public metadata.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   */
  metafield?: Maybe<Scalars['String']['output']>;
  /** Public metadata. Use `keys` to control which fields you want to include. The default is to include everything. */
  metafields?: Maybe<Scalars['Metadata']['output']>;
  /** The name of the menu item. */
  name: Scalars['String']['output'];
  /** A page associated with this menu item. Requires one of the following permissions to include unpublished items: MANAGE_PAGES. */
  page?: Maybe<Page>;
  /** ID of parent menu item. If empty, menu will be top level menu. */
  parent?: Maybe<MenuItem>;
  /** List of private metadata items. Requires staff permissions to access. */
  privateMetadata: Array<MetadataItem>;
  /**
   * A single key from private metadata. Requires staff permissions to access.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   */
  privateMetafield?: Maybe<Scalars['String']['output']>;
  /** Private metadata. Requires staff permissions to access. Use `keys` to control which fields you want to include. The default is to include everything. */
  privateMetafields?: Maybe<Scalars['Metadata']['output']>;
  /** Returns translated menu item fields for the given language code. */
  translation?: Maybe<MenuItemTranslation>;
  /** URL to the menu item. */
  url?: Maybe<Scalars['String']['output']>;
};


/** Represents a single item of the related menu. Can store categories, collection or pages. */
export type MenuItemMetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Represents a single item of the related menu. Can store categories, collection or pages. */
export type MenuItemMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Represents a single item of the related menu. Can store categories, collection or pages. */
export type MenuItemPrivateMetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Represents a single item of the related menu. Can store categories, collection or pages. */
export type MenuItemPrivateMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Represents a single item of the related menu. Can store categories, collection or pages. */
export type MenuItemTranslationArgs = {
  languageCode: LanguageCodeEnum;
};

/**
 * Deletes menu items.
 *
 * Requires one of the following permissions: MANAGE_MENUS.
 *
 * Triggers the following webhook events:
 * - MENU_ITEM_DELETED (async): A menu item was deleted.
 */
export type MenuItemBulkDelete = {
  __typename?: 'MenuItemBulkDelete';
  /** Returns how many objects were affected. */
  count: Scalars['Int']['output'];
  errors: Array<MenuError>;
  /** @deprecated Use `errors` field instead. */
  menuErrors: Array<MenuError>;
};

export type MenuItemCountableConnection = {
  __typename?: 'MenuItemCountableConnection';
  edges: Array<MenuItemCountableEdge>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** A total count of items in the collection. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type MenuItemCountableEdge = {
  __typename?: 'MenuItemCountableEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: MenuItem;
};

/**
 * Creates a new menu item.
 *
 * Requires one of the following permissions: MANAGE_MENUS.
 *
 * Triggers the following webhook events:
 * - MENU_ITEM_CREATED (async): A menu item was created.
 */
export type MenuItemCreate = {
  __typename?: 'MenuItemCreate';
  errors: Array<MenuError>;
  /** @deprecated Use `errors` field instead. */
  menuErrors: Array<MenuError>;
  menuItem?: Maybe<MenuItem>;
};

export type MenuItemCreateInput = {
  /** Category to which item points. */
  category?: InputMaybe<Scalars['ID']['input']>;
  /** Collection to which item points. */
  collection?: InputMaybe<Scalars['ID']['input']>;
  /** Menu to which item belongs. */
  menu: Scalars['ID']['input'];
  /** Name of the menu item. */
  name: Scalars['String']['input'];
  /** Page to which item points. */
  page?: InputMaybe<Scalars['ID']['input']>;
  /** ID of the parent menu. If empty, menu will be top level menu. */
  parent?: InputMaybe<Scalars['ID']['input']>;
  /** URL of the pointed item. */
  url?: InputMaybe<Scalars['String']['input']>;
};

/** Event sent when new menu item is created. */
export type MenuItemCreated = Event & {
  __typename?: 'MenuItemCreated';
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<IssuingPrincipal>;
  /** The menu item the event relates to. */
  menuItem?: Maybe<MenuItem>;
  /** The application receiving the webhook. */
  recipient?: Maybe<App>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};


/** Event sent when new menu item is created. */
export type MenuItemCreatedMenuItemArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Deletes a menu item.
 *
 * Requires one of the following permissions: MANAGE_MENUS.
 *
 * Triggers the following webhook events:
 * - MENU_ITEM_DELETED (async): A menu item was deleted.
 */
export type MenuItemDelete = {
  __typename?: 'MenuItemDelete';
  errors: Array<MenuError>;
  /** @deprecated Use `errors` field instead. */
  menuErrors: Array<MenuError>;
  menuItem?: Maybe<MenuItem>;
};

/** Event sent when menu item is deleted. */
export type MenuItemDeleted = Event & {
  __typename?: 'MenuItemDeleted';
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<IssuingPrincipal>;
  /** The menu item the event relates to. */
  menuItem?: Maybe<MenuItem>;
  /** The application receiving the webhook. */
  recipient?: Maybe<App>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};


/** Event sent when menu item is deleted. */
export type MenuItemDeletedMenuItemArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
};

export type MenuItemFilterInput = {
  metadata?: InputMaybe<Array<MetadataFilter>>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type MenuItemInput = {
  /** Category to which item points. */
  category?: InputMaybe<Scalars['ID']['input']>;
  /** Collection to which item points. */
  collection?: InputMaybe<Scalars['ID']['input']>;
  /** Name of the menu item. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Page to which item points. */
  page?: InputMaybe<Scalars['ID']['input']>;
  /** URL of the pointed item. */
  url?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Moves items of menus.
 *
 * Requires one of the following permissions: MANAGE_MENUS.
 *
 * Triggers the following webhook events:
 * - MENU_ITEM_UPDATED (async): Optionally triggered when sort order or parent changed for menu item.
 */
export type MenuItemMove = {
  __typename?: 'MenuItemMove';
  errors: Array<MenuError>;
  /** Assigned menu to move within. */
  menu?: Maybe<Menu>;
  /** @deprecated Use `errors` field instead. */
  menuErrors: Array<MenuError>;
};

export type MenuItemMoveInput = {
  /** The menu item ID to move. */
  itemId: Scalars['ID']['input'];
  /** ID of the parent menu. If empty, menu will be top level menu. */
  parentId?: InputMaybe<Scalars['ID']['input']>;
  /** The new relative sorting position of the item (from -inf to +inf). 1 moves the item one position forward, -1 moves the item one position backward, 0 leaves the item unchanged. */
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
};

export type MenuItemSortingInput = {
  /** Specifies the direction in which to sort menu items. */
  direction: OrderDirection;
  /** Sort menu items by the selected field. */
  field: MenuItemsSortField;
};

/** Represents menu item's original translatable fields and related translations. */
export type MenuItemTranslatableContent = Node & {
  __typename?: 'MenuItemTranslatableContent';
  /** The ID of the menu item translatable content. */
  id: Scalars['ID']['output'];
  /**
   * Represents a single item of the related menu. Can store categories, collection or pages.
   * @deprecated Get model fields from the root level queries.
   */
  menuItem?: Maybe<MenuItem>;
  /** The ID of the menu item to translate. */
  menuItemId: Scalars['ID']['output'];
  /** Name of the menu item to translate. */
  name: Scalars['String']['output'];
  /** Returns translated menu item fields for the given language code. */
  translation?: Maybe<MenuItemTranslation>;
};


/** Represents menu item's original translatable fields and related translations. */
export type MenuItemTranslatableContentTranslationArgs = {
  languageCode: LanguageCodeEnum;
};

/**
 * Creates/updates translations for a menu item.
 *
 * Requires one of the following permissions: MANAGE_TRANSLATIONS.
 */
export type MenuItemTranslate = {
  __typename?: 'MenuItemTranslate';
  errors: Array<TranslationError>;
  menuItem?: Maybe<MenuItem>;
  /** @deprecated Use `errors` field instead. */
  translationErrors: Array<TranslationError>;
};

/** Represents menu item translations. */
export type MenuItemTranslation = Node & {
  __typename?: 'MenuItemTranslation';
  /** The ID of the menu item translation. */
  id: Scalars['ID']['output'];
  /** Translation language. */
  language: LanguageDisplay;
  /** Translated menu item name. */
  name: Scalars['String']['output'];
  /** Represents the menu item fields to translate. */
  translatableContent?: Maybe<MenuItemTranslatableContent>;
};

/**
 * Updates a menu item.
 *
 * Requires one of the following permissions: MANAGE_MENUS.
 *
 * Triggers the following webhook events:
 * - MENU_ITEM_UPDATED (async): A menu item was updated.
 */
export type MenuItemUpdate = {
  __typename?: 'MenuItemUpdate';
  errors: Array<MenuError>;
  /** @deprecated Use `errors` field instead. */
  menuErrors: Array<MenuError>;
  menuItem?: Maybe<MenuItem>;
};

/** Event sent when menu item is updated. */
export type MenuItemUpdated = Event & {
  __typename?: 'MenuItemUpdated';
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<IssuingPrincipal>;
  /** The menu item the event relates to. */
  menuItem?: Maybe<MenuItem>;
  /** The application receiving the webhook. */
  recipient?: Maybe<App>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};


/** Event sent when menu item is updated. */
export type MenuItemUpdatedMenuItemArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
};

export type MenuItemsSortField =
  /** Sort menu items by name. */
  | 'NAME';

export type MenuSortField =
  /** Sort menus by items count. */
  | 'ITEMS_COUNT'
  /** Sort menus by name. */
  | 'NAME';

export type MenuSortingInput = {
  /** Specifies the direction in which to sort menus. */
  direction: OrderDirection;
  /** Sort menus by the selected field. */
  field: MenuSortField;
};

/**
 * Updates a menu.
 *
 * Requires one of the following permissions: MANAGE_MENUS.
 *
 * Triggers the following webhook events:
 * - MENU_UPDATED (async): A menu was updated.
 */
export type MenuUpdate = {
  __typename?: 'MenuUpdate';
  errors: Array<MenuError>;
  menu?: Maybe<Menu>;
  /** @deprecated Use `errors` field instead. */
  menuErrors: Array<MenuError>;
};

/** Event sent when menu is updated. */
export type MenuUpdated = Event & {
  __typename?: 'MenuUpdated';
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<IssuingPrincipal>;
  /** The menu the event relates to. */
  menu?: Maybe<Menu>;
  /** The application receiving the webhook. */
  recipient?: Maybe<App>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};


/** Event sent when menu is updated. */
export type MenuUpdatedMenuArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataError = {
  __typename?: 'MetadataError';
  /** The error code. */
  code: MetadataErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field?: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message?: Maybe<Scalars['String']['output']>;
};

export type MetadataErrorCode =
  | 'GRAPHQL_ERROR'
  | 'INVALID'
  | 'NOT_FOUND'
  | 'NOT_UPDATED'
  | 'REQUIRED';

export type MetadataFilter = {
  /** Key of a metadata item. */
  key: Scalars['String']['input'];
  /** Value of a metadata item. */
  value?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Allows filtering based on metadata key/value pairs.
 *
 *         Examples:
 *         - `{key: "size"}`
 *           Matches objects where the metadata key "size" exists, regardless of its value.
 *         - `{key: "color", value: {oneOf: ["blue", "green"]}}`
 *           Matches objects where the metadata key "color" is set to either "blue" or "green".
 *         - `{key: "status", value: {eq: "active"}}`
 *           Matches objects where the metadata key "status" is set to "active".
 *
 */
export type MetadataFilterInput = {
  /** Key to filter by. If not other fields provided - checking the existence of the key in metadata. */
  key: Scalars['String']['input'];
  /** Value to filter by. */
  value?: InputMaybe<MetadataValueFilterInput>;
};

export type MetadataInput = {
  /** Key of a metadata item. */
  key: Scalars['String']['input'];
  /** Value of a metadata item. */
  value: Scalars['String']['input'];
};

export type MetadataItem = {
  __typename?: 'MetadataItem';
  /** Key of a metadata item. */
  key: Scalars['String']['output'];
  /** Value of a metadata item. */
  value: Scalars['String']['output'];
};

/** Define the filtering options for metadata value fields. */
export type MetadataValueFilterInput = {
  /** The value equal to. */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** The value included in. */
  oneOf?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Represents amount of money in specific currency. */
export type Money = {
  __typename?: 'Money';
  /** Amount of money. */
  amount: Scalars['Float']['output'];
  /** Currency code. */
  currency: Scalars['String']['output'];
  /** Number of digits after the decimal point in the currency. */
  fractionDigits: Scalars['Int']['output'];
  /** Amount of money represented as an integer in the smallest currency unit. */
  fractionalAmount: Scalars['Int']['output'];
};

export type MoneyInput = {
  /** Amount of money. */
  amount: Scalars['PositiveDecimal']['input'];
  /** Currency code. */
  currency: Scalars['String']['input'];
};

/** Represents a range of amounts of money. */
export type MoneyRange = {
  __typename?: 'MoneyRange';
  /** Lower bound of a price range. */
  start?: Maybe<Money>;
  /** Upper bound of a price range. */
  stop?: Maybe<Money>;
};

export type MoveProductInput = {
  /** The ID of the product to move. */
  productId: Scalars['ID']['input'];
  /** The relative sorting position of the product (from -inf to +inf) starting from the first given product's actual position.1 moves the item one position forward, -1 moves the item one position backward, 0 leaves the item unchanged. */
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  /**
   * Create a new address for the customer.
   *
   * Requires one of following set of permissions: AUTHENTICATED_USER or AUTHENTICATED_APP + IMPERSONATE_USER.
   *
   * Triggers the following webhook events:
   * - CUSTOMER_UPDATED (async): A customer account was updated.
   * - ADDRESS_CREATED (async): An address was created.
   */
  accountAddressCreate?: Maybe<AccountAddressCreate>;
  /**
   * Deletes an address of the logged-in user. Requires one of the following permissions: MANAGE_USERS, IS_OWNER.
   *
   * Triggers the following webhook events:
   * - ADDRESS_DELETED (async): An address was deleted.
   */
  accountAddressDelete?: Maybe<AccountAddressDelete>;
  /**
   * Updates an address of the logged-in user. Requires one of the following permissions: MANAGE_USERS, IS_OWNER.
   *
   * Triggers the following webhook events:
   * - ADDRESS_UPDATED (async): An address was updated.
   */
  accountAddressUpdate?: Maybe<AccountAddressUpdate>;
  /**
   * Remove user account.
   *
   * Requires one of the following permissions: AUTHENTICATED_USER.
   *
   * Triggers the following webhook events:
   * - ACCOUNT_DELETED (async): Account was deleted.
   */
  accountDelete?: Maybe<AccountDelete>;
  /**
   * Register a new user.
   *
   * Triggers the following webhook events:
   * - CUSTOMER_CREATED (async): A new customer account was created.
   * - NOTIFY_USER (async): A notification for account confirmation.
   * - ACCOUNT_CONFIRMATION_REQUESTED (async): An user confirmation was requested. This event is always sent regardless of settings.
   */
  accountRegister?: Maybe<AccountRegister>;
  /**
   * Sends an email with the account removal link for the logged-in user.
   *
   * Requires one of the following permissions: AUTHENTICATED_USER.
   *
   * Triggers the following webhook events:
   * - NOTIFY_USER (async): A notification for account delete request.
   * - ACCOUNT_DELETE_REQUESTED (async): An account delete requested.
   */
  accountRequestDeletion?: Maybe<AccountRequestDeletion>;
  /**
   * Sets a default address for the authenticated user.
   *
   * Requires one of the following permissions: AUTHENTICATED_USER.
   *
   * Triggers the following webhook events:
   * - CUSTOMER_UPDATED (async): A customer's address was updated.
   */
  accountSetDefaultAddress?: Maybe<AccountSetDefaultAddress>;
  /**
   * Updates the account of the logged-in user.
   *
   * Requires one of following set of permissions: AUTHENTICATED_USER or AUTHENTICATED_APP + IMPERSONATE_USER.
   *
   * Triggers the following webhook events:
   * - CUSTOMER_UPDATED (async): A customer account was updated.
   * - CUSTOMER_METADATA_UPDATED (async): Optionally called when customer's metadata was updated.
   */
  accountUpdate?: Maybe<AccountUpdate>;
  /**
   * Creates user address.
   *
   * Requires one of the following permissions: MANAGE_USERS.
   *
   * Triggers the following webhook events:
   * - ADDRESS_CREATED (async): A new address was created.
   */
  addressCreate?: Maybe<AddressCreate>;
  /**
   * Deletes an address.
   *
   * Requires one of the following permissions: MANAGE_USERS.
   *
   * Triggers the following webhook events:
   * - ADDRESS_DELETED (async): An address was deleted.
   */
  addressDelete?: Maybe<AddressDelete>;
  /**
   * Sets a default address for the given user.
   *
   * Requires one of the following permissions: MANAGE_USERS.
   *
   * Triggers the following webhook events:
   * - CUSTOMER_UPDATED (async): A customer was updated.
   */
  addressSetDefault?: Maybe<AddressSetDefault>;
  /**
   * Updates an address.
   *
   * Requires one of the following permissions: MANAGE_USERS.
   *
   * Triggers the following webhook events:
   * - ADDRESS_UPDATED (async): An address was updated.
   */
  addressUpdate?: Maybe<AddressUpdate>;
  /**
   * Activate the app.
   *
   * Requires one of the following permissions: MANAGE_APPS.
   *
   * Triggers the following webhook events:
   * - APP_STATUS_CHANGED (async): An app was activated.
   */
  appActivate?: Maybe<AppActivate>;
  /**
   * Creates a new app. Requires the following permissions: AUTHENTICATED_STAFF_USER and MANAGE_APPS.
   *
   * Triggers the following webhook events:
   * - APP_INSTALLED (async): An app was installed.
   */
  appCreate?: Maybe<AppCreate>;
  /**
   * Deactivate the app.
   *
   * Requires one of the following permissions: MANAGE_APPS.
   *
   * Triggers the following webhook events:
   * - APP_STATUS_CHANGED (async): An app was deactivated.
   */
  appDeactivate?: Maybe<AppDeactivate>;
  /**
   * Deletes an app.
   *
   * Requires one of the following permissions: MANAGE_APPS.
   *
   * Triggers the following webhook events:
   * - APP_DELETED (async): An app was deleted.
   */
  appDelete?: Maybe<AppDelete>;
  /**
   * Deletes failed installation.
   *
   * Requires one of the following permissions: MANAGE_APPS.
   */
  appDeleteFailedInstallation?: Maybe<AppDeleteFailedInstallation>;
  /**
   * Fetch and validate manifest.
   *
   * Requires one of the following permissions: MANAGE_APPS.
   */
  appFetchManifest?: Maybe<AppFetchManifest>;
  /** Install new app by using app manifest. Requires the following permissions: AUTHENTICATED_STAFF_USER and MANAGE_APPS. */
  appInstall?: Maybe<AppInstall>;
  /**
   * Add a problem to the calling app.
   *
   * Added in Saleor 3.22.
   *
   * Requires one of the following permissions: AUTHENTICATED_APP.
   */
  appProblemCreate?: Maybe<AppProblemCreate>;
  /**
   * Dismiss problems for an app.
   *
   * Added in Saleor 3.22.
   *
   * Requires one of the following permissions: MANAGE_APPS, AUTHENTICATED_APP.
   */
  appProblemDismiss?: Maybe<AppProblemDismiss>;
  /**
   * Re-enable sync webhooks for provided app. Can be used to manually re-enable sync webhooks for the app before the cooldown period ends.
   *
   * Added in Saleor 3.21.
   *
   * Requires one of the following permissions: MANAGE_APPS.
   */
  appReenableSyncWebhooks?: Maybe<AppReenableSyncWebhooks>;
  /**
   * Retry failed installation of new app.
   *
   * Requires one of the following permissions: MANAGE_APPS.
   *
   * Triggers the following webhook events:
   * - APP_INSTALLED (async): An app was installed.
   */
  appRetryInstall?: Maybe<AppRetryInstall>;
  /**
   * Creates a new token.
   *
   * Requires one of the following permissions: MANAGE_APPS.
   */
  appTokenCreate?: Maybe<AppTokenCreate>;
  /**
   * Deletes an authentication token assigned to app.
   *
   * Requires one of the following permissions: MANAGE_APPS.
   */
  appTokenDelete?: Maybe<AppTokenDelete>;
  /** Verify provided app token. */
  appTokenVerify?: Maybe<AppTokenVerify>;
  /**
   * Updates an existing app.
   *
   * Requires one of the following permissions: MANAGE_APPS.
   *
   * Triggers the following webhook events:
   * - APP_UPDATED (async): An app was updated.
   */
  appUpdate?: Maybe<AppUpdate>;
  /**
   * Assigns storefront's navigation menus.
   *
   * Requires one of the following permissions: MANAGE_MENUS, MANAGE_SETTINGS.
   */
  assignNavigation?: Maybe<AssignNavigation>;
  /**
   * Add shipping zone to given warehouse.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  assignWarehouseShippingZone?: Maybe<WarehouseShippingZoneAssign>;
  /**
   * Creates attributes.
   *
   * Triggers the following webhook events:
   * - ATTRIBUTE_CREATED (async): An attribute was created.
   */
  attributeBulkCreate?: Maybe<AttributeBulkCreate>;
  /**
   * Deletes attributes.
   *
   * Requires one of the following permissions: MANAGE_PAGE_TYPES_AND_ATTRIBUTES.
   *
   * Triggers the following webhook events:
   * - ATTRIBUTE_DELETED (async): An attribute was deleted.
   */
  attributeBulkDelete?: Maybe<AttributeBulkDelete>;
  /**
   * Creates/updates translations for attributes.
   *
   * Requires one of the following permissions: MANAGE_TRANSLATIONS.
   */
  attributeBulkTranslate?: Maybe<AttributeBulkTranslate>;
  /**
   * Updates attributes.
   *
   * Triggers the following webhook events:
   * - ATTRIBUTE_UPDATED (async): An attribute was updated. Optionally called when new attribute value was created or deleted.
   * - ATTRIBUTE_VALUE_CREATED (async): Called optionally when an attribute value was created.
   * - ATTRIBUTE_VALUE_DELETED (async): Called optionally when an attribute value was deleted.
   */
  attributeBulkUpdate?: Maybe<AttributeBulkUpdate>;
  /**
   * Creates an attribute.
   *
   * Triggers the following webhook events:
   * - ATTRIBUTE_CREATED (async): An attribute was created.
   */
  attributeCreate?: Maybe<AttributeCreate>;
  /**
   * Deletes an attribute.
   *
   * Requires one of the following permissions: MANAGE_PRODUCT_TYPES_AND_ATTRIBUTES.
   *
   * Triggers the following webhook events:
   * - ATTRIBUTE_DELETED (async): An attribute was deleted.
   */
  attributeDelete?: Maybe<AttributeDelete>;
  /**
   * Reorder the values of an attribute.
   *
   * Requires one of the following permissions: MANAGE_PRODUCT_TYPES_AND_ATTRIBUTES.
   *
   * Triggers the following webhook events:
   * - ATTRIBUTE_VALUE_UPDATED (async): An attribute value was updated.
   * - ATTRIBUTE_UPDATED (async): An attribute was updated.
   */
  attributeReorderValues?: Maybe<AttributeReorderValues>;
  /**
   * Creates/updates translations for an attribute.
   *
   * Requires one of the following permissions: MANAGE_TRANSLATIONS.
   */
  attributeTranslate?: Maybe<AttributeTranslate>;
  /**
   * Updates attribute.
   *
   * Requires one of the following permissions: MANAGE_PRODUCT_TYPES_AND_ATTRIBUTES.
   *
   * Triggers the following webhook events:
   * - ATTRIBUTE_UPDATED (async): An attribute was updated.
   */
  attributeUpdate?: Maybe<AttributeUpdate>;
  /**
   * Deletes values of attributes.
   *
   * Requires one of the following permissions: MANAGE_PAGE_TYPES_AND_ATTRIBUTES.
   *
   * Triggers the following webhook events:
   * - ATTRIBUTE_VALUE_DELETED (async): An attribute value was deleted.
   * - ATTRIBUTE_UPDATED (async): An attribute was updated.
   */
  attributeValueBulkDelete?: Maybe<AttributeValueBulkDelete>;
  /**
   * Creates/updates translations for attribute values.
   *
   * Requires one of the following permissions: MANAGE_TRANSLATIONS.
   */
  attributeValueBulkTranslate?: Maybe<AttributeValueBulkTranslate>;
  /**
   * Creates a value for an attribute.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   *
   * Triggers the following webhook events:
   * - ATTRIBUTE_VALUE_CREATED (async): An attribute value was created.
   * - ATTRIBUTE_UPDATED (async): An attribute was updated.
   */
  attributeValueCreate?: Maybe<AttributeValueCreate>;
  /**
   * Deletes a value of an attribute.
   *
   * Requires one of the following permissions: MANAGE_PRODUCT_TYPES_AND_ATTRIBUTES.
   *
   * Triggers the following webhook events:
   * - ATTRIBUTE_VALUE_DELETED (async): An attribute value was deleted.
   * - ATTRIBUTE_UPDATED (async): An attribute was updated.
   */
  attributeValueDelete?: Maybe<AttributeValueDelete>;
  /**
   * Creates/updates translations for an attribute value.
   *
   * Requires one of the following permissions: MANAGE_TRANSLATIONS.
   */
  attributeValueTranslate?: Maybe<AttributeValueTranslate>;
  /**
   * Updates value of an attribute.
   *
   * Requires one of the following permissions: MANAGE_PRODUCT_TYPES_AND_ATTRIBUTES.
   *
   * Triggers the following webhook events:
   * - ATTRIBUTE_VALUE_UPDATED (async): An attribute value was updated.
   * - ATTRIBUTE_UPDATED (async): An attribute was updated.
   */
  attributeValueUpdate?: Maybe<AttributeValueUpdate>;
  /**
   * Deletes categories.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  categoryBulkDelete?: Maybe<CategoryBulkDelete>;
  /**
   * Creates a new category.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  categoryCreate?: Maybe<CategoryCreate>;
  /**
   * Deletes a category.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  categoryDelete?: Maybe<CategoryDelete>;
  /**
   * Creates/updates translations for a category.
   *
   * Requires one of the following permissions: MANAGE_TRANSLATIONS.
   */
  categoryTranslate?: Maybe<CategoryTranslate>;
  /**
   * Updates a category.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  categoryUpdate?: Maybe<CategoryUpdate>;
  /**
   * Activate a channel.
   *
   * Requires one of the following permissions: MANAGE_CHANNELS.
   *
   * Triggers the following webhook events:
   * - CHANNEL_STATUS_CHANGED (async): A channel was activated.
   */
  channelActivate?: Maybe<ChannelActivate>;
  /**
   * Creates a new channel.
   *
   * Requires one of the following permissions: MANAGE_CHANNELS.
   *
   * Triggers the following webhook events:
   * - CHANNEL_CREATED (async): A channel was created.
   */
  channelCreate?: Maybe<ChannelCreate>;
  /**
   * Deactivate a channel.
   *
   * Requires one of the following permissions: MANAGE_CHANNELS.
   *
   * Triggers the following webhook events:
   * - CHANNEL_STATUS_CHANGED (async): A channel was deactivated.
   */
  channelDeactivate?: Maybe<ChannelDeactivate>;
  /**
   * Deletes a channel. Orders associated with the deleted channel will be moved to the target channel. Checkouts, product availability, and pricing will be removed.
   *
   * Requires one of the following permissions: MANAGE_CHANNELS.
   *
   * Triggers the following webhook events:
   * - CHANNEL_DELETED (async): A channel was deleted.
   */
  channelDelete?: Maybe<ChannelDelete>;
  /**
   * Reorder the warehouses of a channel.
   *
   * Requires one of the following permissions: MANAGE_CHANNELS.
   */
  channelReorderWarehouses?: Maybe<ChannelReorderWarehouses>;
  /**
   * Update a channel.
   *
   * Requires one of the following permissions: MANAGE_CHANNELS.
   * Requires one of the following permissions when updating only `orderSettings` field: `MANAGE_CHANNELS`, `MANAGE_ORDERS`.
   * Requires one of the following permissions when updating only `checkoutSettings` field: `MANAGE_CHANNELS`, `MANAGE_CHECKOUTS`.
   * Requires one of the following permissions when updating only `paymentSettings` field: `MANAGE_CHANNELS`, `HANDLE_PAYMENTS`.
   *
   * Triggers the following webhook events:
   * - CHANNEL_UPDATED (async): A channel was updated.
   * - CHANNEL_METADATA_UPDATED (async): Optionally triggered when public or private metadata is updated.
   */
  channelUpdate?: Maybe<ChannelUpdate>;
  /**
   * Adds a gift card or a voucher to a checkout.
   *
   * Triggers the following webhook events:
   * - CHECKOUT_UPDATED (async): A checkout was updated.
   */
  checkoutAddPromoCode?: Maybe<CheckoutAddPromoCode>;
  /**
   * Updates billing address in the existing checkout.
   *
   * Triggers the following webhook events:
   * - CHECKOUT_UPDATED (async): A checkout was updated.
   */
  checkoutBillingAddressUpdate?: Maybe<CheckoutBillingAddressUpdate>;
  /**
   * Completes the checkout. As a result a new order is created. The mutation allows to create the unpaid order when setting `orderSettings.allowUnpaidOrders` for given `Channel` is set to `true`. When `orderSettings.allowUnpaidOrders` is set to `false`, checkout can be completed only when attached `Payment`/`TransactionItem`s fully cover the checkout's total. When processing the checkout with `Payment`, in case of required additional confirmation step like 3D secure, the `confirmationNeeded` flag will be set to True and no order will be created until payment is confirmed with second call of this mutation.
   *
   * Triggers the following webhook events:
   * - SHIPPING_LIST_METHODS_FOR_CHECKOUT (sync): Optionally triggered when cached external shipping methods are invalid.
   * - CHECKOUT_FILTER_SHIPPING_METHODS (sync): Optionally triggered when cached filtered shipping methods are invalid.
   * - CHECKOUT_CALCULATE_TAXES (sync): Optionally triggered when checkout prices are expired.
   * - ORDER_CREATED (async): Triggered when order is created.
   * - NOTIFY_USER (async): A notification for order placement.
   * - NOTIFY_USER (async): A staff notification for order placement.
   * - ORDER_UPDATED (async): Triggered when order received the update after placement.
   * - ORDER_PAID (async): Triggered when newly created order is paid.
   * - ORDER_FULLY_PAID (async): Triggered when newly created order is fully paid.
   * - ORDER_CONFIRMED (async): Optionally triggered when newly created order are automatically marked as confirmed.
   */
  checkoutComplete?: Maybe<CheckoutComplete>;
  /**
   * Create a new checkout.
   *
   * `skipValidation` field requires HANDLE_CHECKOUTS and AUTHENTICATED_APP permissions.
   *
   * Triggers the following webhook events:
   * - CHECKOUT_CREATED (async): A checkout was created.
   */
  checkoutCreate?: Maybe<CheckoutCreate>;
  /** Creates a new checkout from existing order. */
  checkoutCreateFromOrder?: Maybe<CheckoutCreateFromOrder>;
  /**
   * Sets the customer as the owner of the checkout.
   *
   * Requires one of the following permissions: AUTHENTICATED_APP, AUTHENTICATED_USER.
   *
   * Triggers the following webhook events:
   * - CHECKOUT_UPDATED (async): A checkout was updated.
   */
  checkoutCustomerAttach?: Maybe<CheckoutCustomerAttach>;
  /**
   * Removes the user assigned as the owner of the checkout.
   *
   * Requires one of the following permissions: AUTHENTICATED_APP, AUTHENTICATED_USER.
   *
   * Triggers the following webhook events:
   * - CHECKOUT_UPDATED (async): A checkout was updated.
   */
  checkoutCustomerDetach?: Maybe<CheckoutCustomerDetach>;
  /**
   * Updates customer note in the existing checkout object.
   *
   * Added in Saleor 3.21.
   *
   * Triggers the following webhook events:
   * - CHECKOUT_UPDATED (async): A checkout was updated.
   */
  checkoutCustomerNoteUpdate?: Maybe<CheckoutCustomerNoteUpdate>;
  /**
   * Updates the delivery method (shipping method or pick up point) of the checkout. Updates the checkout shipping_address for click and collect delivery for a warehouse address.
   *
   * Triggers the following webhook events:
   * - SHIPPING_LIST_METHODS_FOR_CHECKOUT (sync): Triggered when updating the checkout delivery method with the external one.
   * - CHECKOUT_UPDATED (async): A checkout was updated.
   */
  checkoutDeliveryMethodUpdate?: Maybe<CheckoutDeliveryMethodUpdate>;
  /**
   * Updates email address in the existing checkout object.
   *
   * Triggers the following webhook events:
   * - CHECKOUT_UPDATED (async): A checkout was updated.
   */
  checkoutEmailUpdate?: Maybe<CheckoutEmailUpdate>;
  /**
   * Updates language code in the existing checkout.
   *
   * Triggers the following webhook events:
   * - CHECKOUT_UPDATED (async): A checkout was updated.
   */
  checkoutLanguageCodeUpdate?: Maybe<CheckoutLanguageCodeUpdate>;
  /**
   * Deletes a CheckoutLine.
   *
   * Triggers the following webhook events:
   * - CHECKOUT_UPDATED (async): A checkout was updated.
   * @deprecated Use `checkoutLinesDelete` instead.
   */
  checkoutLineDelete?: Maybe<CheckoutLineDelete>;
  /**
   * Adds a checkout line to the existing checkout.If line was already in checkout, its quantity will be increased.
   *
   * Triggers the following webhook events:
   * - CHECKOUT_UPDATED (async): A checkout was updated.
   */
  checkoutLinesAdd?: Maybe<CheckoutLinesAdd>;
  /**
   * Deletes checkout lines.
   *
   * Triggers the following webhook events:
   * - CHECKOUT_UPDATED (async): A checkout was updated.
   */
  checkoutLinesDelete?: Maybe<CheckoutLinesDelete>;
  /**
   * Updates checkout line in the existing checkout.
   *
   * Triggers the following webhook events:
   * - CHECKOUT_UPDATED (async): A checkout was updated.
   */
  checkoutLinesUpdate?: Maybe<CheckoutLinesUpdate>;
  /** Creates a new payment for given checkout. */
  checkoutPaymentCreate?: Maybe<CheckoutPaymentCreate>;
  /**
   * Remove a gift card or a voucher from a checkout.
   *
   * Triggers the following webhook events:
   * - CHECKOUT_UPDATED (async): A checkout was updated.
   */
  checkoutRemovePromoCode?: Maybe<CheckoutRemovePromoCode>;
  /**
   * Updates shipping address in the existing checkout.
   *
   * Triggers the following webhook events:
   * - CHECKOUT_UPDATED (async): A checkout was updated.
   */
  checkoutShippingAddressUpdate?: Maybe<CheckoutShippingAddressUpdate>;
  /**
   * Updates the shipping method of the checkout.
   *
   * Triggers the following webhook events:
   * - SHIPPING_LIST_METHODS_FOR_CHECKOUT (sync): Triggered when updating the checkout shipping method with the external one.
   * - CHECKOUT_UPDATED (async): A checkout was updated.
   * @deprecated Use `checkoutDeliveryMethodUpdate` instead.
   */
  checkoutShippingMethodUpdate?: Maybe<CheckoutShippingMethodUpdate>;
  /**
   * Adds products to a collection.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  collectionAddProducts?: Maybe<CollectionAddProducts>;
  /**
   * Deletes collections.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  collectionBulkDelete?: Maybe<CollectionBulkDelete>;
  /**
   * Manage collection's availability in channels.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  collectionChannelListingUpdate?: Maybe<CollectionChannelListingUpdate>;
  /**
   * Creates a new collection.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  collectionCreate?: Maybe<CollectionCreate>;
  /**
   * Deletes a collection.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  collectionDelete?: Maybe<CollectionDelete>;
  /**
   * Remove products from a collection.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  collectionRemoveProducts?: Maybe<CollectionRemoveProducts>;
  /**
   * Reorder the products of a collection.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  collectionReorderProducts?: Maybe<CollectionReorderProducts>;
  /**
   * Creates/updates translations for a collection.
   *
   * Requires one of the following permissions: MANAGE_TRANSLATIONS.
   */
  collectionTranslate?: Maybe<CollectionTranslate>;
  /**
   * Updates a collection.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  collectionUpdate?: Maybe<CollectionUpdate>;
  /**
   * Confirm user account with token sent by email during registration.
   *
   * Triggers the following webhook events:
   * - ACCOUNT_CONFIRMED (async): Account was confirmed.
   */
  confirmAccount?: Maybe<ConfirmAccount>;
  /**
   * Confirm the email change of the logged-in user.
   *
   * Requires one of the following permissions: AUTHENTICATED_USER.
   *
   * Triggers the following webhook events:
   * - CUSTOMER_UPDATED (async): A customer account was updated.
   * - NOTIFY_USER (async): A notification that account email change was confirmed.
   * - ACCOUNT_EMAIL_CHANGED (async): An account email was changed.
   */
  confirmEmailChange?: Maybe<ConfirmEmailChange>;
  /**
   * Creates a new warehouse.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  createWarehouse?: Maybe<WarehouseCreate>;
  /**
   * Deletes customers.
   *
   * Requires one of the following permissions: MANAGE_USERS.
   *
   * Triggers the following webhook events:
   * - CUSTOMER_DELETED (async): A customer account was deleted.
   */
  customerBulkDelete?: Maybe<CustomerBulkDelete>;
  /**
   * Updates customers.
   *
   * Requires one of the following permissions: MANAGE_USERS.
   *
   * Triggers the following webhook events:
   * - CUSTOMER_UPDATED (async): A customer account was updated.
   * - CUSTOMER_METADATA_UPDATED (async): Optionally called when customer's metadata was updated.
   */
  customerBulkUpdate?: Maybe<CustomerBulkUpdate>;
  /**
   * Creates a new customer.
   *
   * Requires one of the following permissions: MANAGE_USERS.
   *
   * Triggers the following webhook events:
   * - CUSTOMER_CREATED (async): A new customer account was created.
   * - CUSTOMER_METADATA_UPDATED (async): Optionally called when customer's metadata was updated.
   * - NOTIFY_USER (async): A notification for setting the password.
   * - ACCOUNT_SET_PASSWORD_REQUESTED (async): Setting a new password for the account is requested.
   */
  customerCreate?: Maybe<CustomerCreate>;
  /**
   * Deletes a customer.
   *
   * Requires one of the following permissions: MANAGE_USERS.
   *
   * Triggers the following webhook events:
   * - CUSTOMER_DELETED (async): A customer account was deleted.
   */
  customerDelete?: Maybe<CustomerDelete>;
  /**
   * Updates an existing customer.
   *
   * Requires one of the following permissions: MANAGE_USERS.
   *
   * Triggers the following webhook events:
   * - CUSTOMER_UPDATED (async): A new customer account was updated.
   * - CUSTOMER_METADATA_UPDATED (async): Optionally called when customer's metadata was updated.
   */
  customerUpdate?: Maybe<CustomerUpdate>;
  /** Delete metadata of an object. To use it, you need to have access to the modified object. */
  deleteMetadata?: Maybe<DeleteMetadata>;
  /** Delete object's private metadata. To use it, you need to be an authenticated staff user or an app and have access to the modified object. */
  deletePrivateMetadata?: Maybe<DeletePrivateMetadata>;
  /**
   * Deletes selected warehouse.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  deleteWarehouse?: Maybe<WarehouseDelete>;
  /**
   * Create new digital content. This mutation must be sent as a `multipart` request. More detailed specs of the upload format can be found here: https://github.com/jaydenseric/graphql-multipart-request-spec
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   * @deprecated Support for Digital Content is deprecated and will be removed in Saleor v3.23.0. This functionality is legacy and undocumented, and is not part of the supported API. Users should not rely on this behavior.
   */
  digitalContentCreate?: Maybe<DigitalContentCreate>;
  /**
   * Remove digital content assigned to given variant.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   * @deprecated Support for Digital Content is deprecated and will be removed in Saleor v3.23.0. This functionality is legacy and undocumented, and is not part of the supported API. Users should not rely on this behavior.
   */
  digitalContentDelete?: Maybe<DigitalContentDelete>;
  /**
   * Updates digital content.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   * @deprecated Support for Digital Content is deprecated and will be removed in Saleor v3.23.0. This functionality is legacy and undocumented, and is not part of the supported API. Users should not rely on this behavior.
   */
  digitalContentUpdate?: Maybe<DigitalContentUpdate>;
  /**
   * Generate new URL to digital content.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   * @deprecated Support for Digital Content is deprecated and will be removed in Saleor v3.23.0. This functionality is legacy and undocumented, and is not part of the supported API. Users should not rely on this behavior.
   */
  digitalContentUrlCreate?: Maybe<DigitalContentUrlCreate>;
  /**
   * Deletes draft orders.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   */
  draftOrderBulkDelete?: Maybe<DraftOrderBulkDelete>;
  /**
   * Completes creating an order.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   */
  draftOrderComplete?: Maybe<DraftOrderComplete>;
  /**
   * Creates a new draft order.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   */
  draftOrderCreate?: Maybe<DraftOrderCreate>;
  /**
   * Deletes a draft order.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   */
  draftOrderDelete?: Maybe<DraftOrderDelete>;
  /**
   * Deletes order lines.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   * @deprecated No longer supported
   */
  draftOrderLinesBulkDelete?: Maybe<DraftOrderLinesBulkDelete>;
  /**
   * Updates a draft order.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   */
  draftOrderUpdate?: Maybe<DraftOrderUpdate>;
  /**
   * Retries event delivery.
   *
   * Requires one of the following permissions: MANAGE_APPS.
   */
  eventDeliveryRetry?: Maybe<EventDeliveryRetry>;
  /**
   * Export gift cards to csv file.
   *
   * Requires one of the following permissions: MANAGE_GIFT_CARD.
   *
   * Triggers the following webhook events:
   * - NOTIFY_USER (async): A notification for the exported file.
   * - GIFT_CARD_EXPORT_COMPLETED (async): A notification for the exported file.
   */
  exportGiftCards?: Maybe<ExportGiftCards>;
  /**
   * Export products to csv file.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   *
   * Triggers the following webhook events:
   * - NOTIFY_USER (async): A notification for the exported file.
   * - PRODUCT_EXPORT_COMPLETED (async): A notification for the exported file.
   */
  exportProducts?: Maybe<ExportProducts>;
  /**
   * Export voucher codes to csv/xlsx file.
   *
   * Added in Saleor 3.18.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   *
   * Requires one of the following permissions: MANAGE_DISCOUNTS.
   *
   * Triggers the following webhook events:
   * - VOUCHER_CODE_EXPORT_COMPLETED (async): A notification for the exported file.
   */
  exportVoucherCodes?: Maybe<ExportVoucherCodes>;
  /** Prepare external authentication URL for user by custom plugin. */
  externalAuthenticationUrl?: Maybe<ExternalAuthenticationUrl>;
  /** Logout user by custom plugin. */
  externalLogout?: Maybe<ExternalLogout>;
  /**
   * Trigger sending a notification with the notify plugin method. Serializes nodes provided as ids parameter and includes this data in the notification payload.
   * @deprecated No longer supported
   */
  externalNotificationTrigger?: Maybe<ExternalNotificationTrigger>;
  /** Obtain external access tokens for user by custom plugin. */
  externalObtainAccessTokens?: Maybe<ExternalObtainAccessTokens>;
  /** Refresh user's access by custom plugin. */
  externalRefresh?: Maybe<ExternalRefresh>;
  /** Verify external authentication data by plugin. */
  externalVerify?: Maybe<ExternalVerify>;
  /**
   * Upload a file. This mutation must be sent as a `multipart` request. More detailed specs of the upload format can be found here: https://github.com/jaydenseric/graphql-multipart-request-spec
   *
   * Requires one of the following permissions: AUTHENTICATED_APP, AUTHENTICATED_STAFF_USER.
   */
  fileUpload?: Maybe<FileUpload>;
  /**
   * Activate a gift card.
   *
   * Requires one of the following permissions: MANAGE_GIFT_CARD.
   *
   * Triggers the following webhook events:
   * - GIFT_CARD_STATUS_CHANGED (async): A gift card was activated.
   */
  giftCardActivate?: Maybe<GiftCardActivate>;
  /**
   * Adds note to the gift card.
   *
   * Requires one of the following permissions: MANAGE_GIFT_CARD.
   *
   * Triggers the following webhook events:
   * - GIFT_CARD_UPDATED (async): A gift card was updated.
   */
  giftCardAddNote?: Maybe<GiftCardAddNote>;
  /**
   * Activate gift cards.
   *
   * Requires one of the following permissions: MANAGE_GIFT_CARD.
   *
   * Triggers the following webhook events:
   * - GIFT_CARD_STATUS_CHANGED (async): A gift card was activated.
   */
  giftCardBulkActivate?: Maybe<GiftCardBulkActivate>;
  /**
   * Creates gift cards.
   *
   * Requires one of the following permissions: MANAGE_GIFT_CARD.
   *
   * Triggers the following webhook events:
   * - GIFT_CARD_CREATED (async): A gift card was created.
   * - NOTIFY_USER (async): A notification for created gift card.
   */
  giftCardBulkCreate?: Maybe<GiftCardBulkCreate>;
  /**
   * Deactivate gift cards.
   *
   * Requires one of the following permissions: MANAGE_GIFT_CARD.
   *
   * Triggers the following webhook events:
   * - GIFT_CARD_STATUS_CHANGED (async): A gift card was deactivated.
   */
  giftCardBulkDeactivate?: Maybe<GiftCardBulkDeactivate>;
  /**
   * Deletes gift cards.
   *
   * Requires one of the following permissions: MANAGE_GIFT_CARD.
   *
   * Triggers the following webhook events:
   * - GIFT_CARD_DELETED (async): A gift card was deleted.
   */
  giftCardBulkDelete?: Maybe<GiftCardBulkDelete>;
  /**
   * Creates a new gift card.
   *
   * Requires one of the following permissions: MANAGE_GIFT_CARD.
   *
   * Triggers the following webhook events:
   * - GIFT_CARD_CREATED (async): A gift card was created.
   * - NOTIFY_USER (async): A notification for created gift card.
   */
  giftCardCreate?: Maybe<GiftCardCreate>;
  /**
   * Deactivate a gift card.
   *
   * Requires one of the following permissions: MANAGE_GIFT_CARD.
   *
   * Triggers the following webhook events:
   * - GIFT_CARD_STATUS_CHANGED (async): A gift card was deactivated.
   */
  giftCardDeactivate?: Maybe<GiftCardDeactivate>;
  /**
   * Deletes gift card.
   *
   * Requires one of the following permissions: MANAGE_GIFT_CARD.
   *
   * Triggers the following webhook events:
   * - GIFT_CARD_DELETED (async): A gift card was deleted.
   */
  giftCardDelete?: Maybe<GiftCardDelete>;
  /**
   * Resend a gift card.
   *
   * Requires one of the following permissions: MANAGE_GIFT_CARD.
   *
   * Triggers the following webhook events:
   * - NOTIFY_USER (async): A notification for gift card resend.
   */
  giftCardResend?: Maybe<GiftCardResend>;
  /**
   * Update gift card settings.
   *
   * Requires one of the following permissions: MANAGE_GIFT_CARD.
   */
  giftCardSettingsUpdate?: Maybe<GiftCardSettingsUpdate>;
  /**
   * Update a gift card.
   *
   * Requires one of the following permissions: MANAGE_GIFT_CARD.
   *
   * Triggers the following webhook events:
   * - GIFT_CARD_UPDATED (async): A gift card was updated.
   */
  giftCardUpdate?: Maybe<GiftCardUpdate>;
  /**
   * Creates a ready to send invoice.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   */
  invoiceCreate?: Maybe<InvoiceCreate>;
  /**
   * Deletes an invoice.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   */
  invoiceDelete?: Maybe<InvoiceDelete>;
  /**
   * Request an invoice for the order using plugin.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   *
   * Triggers the following webhook events:
   * - INVOICE_REQUESTED (async): An invoice was requested.
   */
  invoiceRequest?: Maybe<InvoiceRequest>;
  /**
   * Requests deletion of an invoice.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   *
   * Triggers the following webhook events:
   * - INVOICE_DELETED (async): An invoice was requested to delete.
   */
  invoiceRequestDelete?: Maybe<InvoiceRequestDelete>;
  /**
   * Send an invoice notification to the customer.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   *
   * Triggers the following webhook events:
   * - INVOICE_SENT (async): A notification for invoice send
   * - NOTIFY_USER (async): A notification for invoice send
   */
  invoiceSendNotification?: Maybe<InvoiceSendNotification>;
  /**
   * Updates an invoice.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   */
  invoiceUpdate?: Maybe<InvoiceUpdate>;
  /**
   * Deletes menus.
   *
   * Requires one of the following permissions: MANAGE_MENUS.
   *
   * Triggers the following webhook events:
   * - MENU_DELETED (async): A menu was deleted.
   */
  menuBulkDelete?: Maybe<MenuBulkDelete>;
  /**
   * Creates a new Menu.
   *
   * Requires one of the following permissions: MANAGE_MENUS.
   *
   * Triggers the following webhook events:
   * - MENU_CREATED (async): A menu was created.
   */
  menuCreate?: Maybe<MenuCreate>;
  /**
   * Deletes a menu.
   *
   * Requires one of the following permissions: MANAGE_MENUS.
   *
   * Triggers the following webhook events:
   * - MENU_DELETED (async): A menu was deleted.
   */
  menuDelete?: Maybe<MenuDelete>;
  /**
   * Deletes menu items.
   *
   * Requires one of the following permissions: MANAGE_MENUS.
   *
   * Triggers the following webhook events:
   * - MENU_ITEM_DELETED (async): A menu item was deleted.
   */
  menuItemBulkDelete?: Maybe<MenuItemBulkDelete>;
  /**
   * Creates a new menu item.
   *
   * Requires one of the following permissions: MANAGE_MENUS.
   *
   * Triggers the following webhook events:
   * - MENU_ITEM_CREATED (async): A menu item was created.
   */
  menuItemCreate?: Maybe<MenuItemCreate>;
  /**
   * Deletes a menu item.
   *
   * Requires one of the following permissions: MANAGE_MENUS.
   *
   * Triggers the following webhook events:
   * - MENU_ITEM_DELETED (async): A menu item was deleted.
   */
  menuItemDelete?: Maybe<MenuItemDelete>;
  /**
   * Moves items of menus.
   *
   * Requires one of the following permissions: MANAGE_MENUS.
   *
   * Triggers the following webhook events:
   * - MENU_ITEM_UPDATED (async): Optionally triggered when sort order or parent changed for menu item.
   */
  menuItemMove?: Maybe<MenuItemMove>;
  /**
   * Creates/updates translations for a menu item.
   *
   * Requires one of the following permissions: MANAGE_TRANSLATIONS.
   */
  menuItemTranslate?: Maybe<MenuItemTranslate>;
  /**
   * Updates a menu item.
   *
   * Requires one of the following permissions: MANAGE_MENUS.
   *
   * Triggers the following webhook events:
   * - MENU_ITEM_UPDATED (async): A menu item was updated.
   */
  menuItemUpdate?: Maybe<MenuItemUpdate>;
  /**
   * Updates a menu.
   *
   * Requires one of the following permissions: MANAGE_MENUS.
   *
   * Triggers the following webhook events:
   * - MENU_UPDATED (async): A menu was updated.
   */
  menuUpdate?: Maybe<MenuUpdate>;
  /**
   * Adds note to the order.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   * @deprecated Use `orderNoteAdd` instead.
   */
  orderAddNote?: Maybe<OrderAddNote>;
  /**
   * Cancels orders.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   */
  orderBulkCancel?: Maybe<OrderBulkCancel>;
  /**
   * Creates multiple orders.
   *
   * Requires one of the following permissions: MANAGE_ORDERS_IMPORT.
   */
  orderBulkCreate?: Maybe<OrderBulkCreate>;
  /**
   * Cancel an order.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   */
  orderCancel?: Maybe<OrderCancel>;
  /**
   * Capture an order.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   */
  orderCapture?: Maybe<OrderCapture>;
  /**
   * Confirms an unconfirmed order by changing status to unfulfilled.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   */
  orderConfirm?: Maybe<OrderConfirm>;
  /**
   * Create new order from existing checkout. Requires the following permissions: AUTHENTICATED_APP and HANDLE_CHECKOUTS.
   *
   * Triggers the following webhook events:
   * - SHIPPING_LIST_METHODS_FOR_CHECKOUT (sync): Optionally triggered when cached external shipping methods are invalid.
   * - CHECKOUT_FILTER_SHIPPING_METHODS (sync): Optionally triggered when cached filtered shipping methods are invalid.
   * - CHECKOUT_CALCULATE_TAXES (sync): Optionally triggered when checkout prices are expired.
   * - ORDER_CREATED (async): Triggered when order is created.
   * - NOTIFY_USER (async): A notification for order placement.
   * - NOTIFY_USER (async): A staff notification for order placement.
   * - ORDER_UPDATED (async): Triggered when order received the update after placement.
   * - ORDER_PAID (async): Triggered when newly created order is paid.
   * - ORDER_FULLY_PAID (async): Triggered when newly created order is fully paid.
   * - ORDER_CONFIRMED (async): Optionally triggered when newly created order are automatically marked as confirmed.
   */
  orderCreateFromCheckout?: Maybe<OrderCreateFromCheckout>;
  /**
   * Adds discount to the order.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   */
  orderDiscountAdd?: Maybe<OrderDiscountAdd>;
  /**
   * Remove discount from the order.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   */
  orderDiscountDelete?: Maybe<OrderDiscountDelete>;
  /**
   * Update discount for the order.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   */
  orderDiscountUpdate?: Maybe<OrderDiscountUpdate>;
  /**
   * Creates new fulfillments for an order.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   *
   * Triggers the following webhook events:
   * - FULFILLMENT_CREATED (async): A new fulfillment is created.
   * - ORDER_FULFILLED (async): Order is fulfilled.
   * - FULFILLMENT_TRACKING_NUMBER_UPDATED (async): Sent when fulfillment tracking number is updated.
   * - FULFILLMENT_APPROVED (async): A fulfillment is approved.
   */
  orderFulfill?: Maybe<OrderFulfill>;
  /**
   * Approve existing fulfillment.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   *
   * Triggers the following webhook events:
   * - FULFILLMENT_APPROVED (async): Fulfillment is approved.
   */
  orderFulfillmentApprove?: Maybe<FulfillmentApprove>;
  /**
   * Cancels existing fulfillment and optionally restocks items.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   */
  orderFulfillmentCancel?: Maybe<FulfillmentCancel>;
  /**
   * Refund products.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   */
  orderFulfillmentRefundProducts?: Maybe<FulfillmentRefundProducts>;
  /**
   * Return products.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   */
  orderFulfillmentReturnProducts?: Maybe<FulfillmentReturnProducts>;
  /**
   * Updates a fulfillment for an order.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   *
   * Triggers the following webhook events:
   * - FULFILLMENT_TRACKING_NUMBER_UPDATED (async): Fulfillment tracking number is updated.
   */
  orderFulfillmentUpdateTracking?: Maybe<FulfillmentUpdateTracking>;
  /**
   * Adds granted refund to the order.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   */
  orderGrantRefundCreate?: Maybe<OrderGrantRefundCreate>;
  /**
   * Updates granted refund.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   */
  orderGrantRefundUpdate?: Maybe<OrderGrantRefundUpdate>;
  /**
   * Deletes an order line from an order.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   */
  orderLineDelete?: Maybe<OrderLineDelete>;
  /**
   * Remove discount applied to the order line.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   */
  orderLineDiscountRemove?: Maybe<OrderLineDiscountRemove>;
  /**
   * Update discount for the order line.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   */
  orderLineDiscountUpdate?: Maybe<OrderLineDiscountUpdate>;
  /**
   * Updates an order line of an order.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   */
  orderLineUpdate?: Maybe<OrderLineUpdate>;
  /**
   * Creates order lines for an order.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   */
  orderLinesCreate?: Maybe<OrderLinesCreate>;
  /**
   * Mark order as manually paid.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   */
  orderMarkAsPaid?: Maybe<OrderMarkAsPaid>;
  /**
   * Adds note to the order.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   */
  orderNoteAdd?: Maybe<OrderNoteAdd>;
  /**
   * Updates note of an order.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   */
  orderNoteUpdate?: Maybe<OrderNoteUpdate>;
  /**
   * Refund an order.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   */
  orderRefund?: Maybe<OrderRefund>;
  /**
   * Update shop order settings across all channels. Returns `orderSettings` for the first `channel` in alphabetical order.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   * @deprecated Use `channelUpdate` mutation instead.
   */
  orderSettingsUpdate?: Maybe<OrderSettingsUpdate>;
  /**
   * Updates an order.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   */
  orderUpdate?: Maybe<OrderUpdate>;
  /**
   * Updates a shipping method of the order. Requires shipping method ID to update, when null is passed then currently assigned shipping method is removed.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   */
  orderUpdateShipping?: Maybe<OrderUpdateShipping>;
  /**
   * Void an order.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   */
  orderVoid?: Maybe<OrderVoid>;
  /**
   * Assign attributes to a given page type.
   *
   * Requires one of the following permissions: MANAGE_PAGE_TYPES_AND_ATTRIBUTES.
   */
  pageAttributeAssign?: Maybe<PageAttributeAssign>;
  /**
   * Unassign attributes from a given page type.
   *
   * Requires one of the following permissions: MANAGE_PAGE_TYPES_AND_ATTRIBUTES.
   */
  pageAttributeUnassign?: Maybe<PageAttributeUnassign>;
  /**
   * Deletes pages.
   *
   * Requires one of the following permissions: MANAGE_PAGES.
   */
  pageBulkDelete?: Maybe<PageBulkDelete>;
  /**
   * Publish pages.
   *
   * Requires one of the following permissions: MANAGE_PAGES.
   */
  pageBulkPublish?: Maybe<PageBulkPublish>;
  /**
   * Creates a new page.
   *
   * Requires one of the following permissions: MANAGE_PAGES.
   */
  pageCreate?: Maybe<PageCreate>;
  /**
   * Deletes a page.
   *
   * Requires one of the following permissions: MANAGE_PAGES.
   */
  pageDelete?: Maybe<PageDelete>;
  /**
   * Reorder page attribute values.
   *
   * Requires one of the following permissions: MANAGE_PAGES.
   */
  pageReorderAttributeValues?: Maybe<PageReorderAttributeValues>;
  /**
   * Creates/updates translations for a page.
   *
   * Requires one of the following permissions: MANAGE_TRANSLATIONS.
   */
  pageTranslate?: Maybe<PageTranslate>;
  /**
   * Deletes page types.
   *
   * Requires one of the following permissions: MANAGE_PAGE_TYPES_AND_ATTRIBUTES.
   */
  pageTypeBulkDelete?: Maybe<PageTypeBulkDelete>;
  /**
   * Creates a new page type.
   *
   * Requires one of the following permissions: MANAGE_PAGE_TYPES_AND_ATTRIBUTES.
   */
  pageTypeCreate?: Maybe<PageTypeCreate>;
  /**
   * Deletes a page type.
   *
   * Requires one of the following permissions: MANAGE_PAGE_TYPES_AND_ATTRIBUTES.
   */
  pageTypeDelete?: Maybe<PageTypeDelete>;
  /**
   * Reorder the attributes of a page type.
   *
   * Requires one of the following permissions: MANAGE_PAGE_TYPES_AND_ATTRIBUTES.
   */
  pageTypeReorderAttributes?: Maybe<PageTypeReorderAttributes>;
  /**
   * Updates page type.
   *
   * Requires one of the following permissions: MANAGE_PAGE_TYPES_AND_ATTRIBUTES.
   */
  pageTypeUpdate?: Maybe<PageTypeUpdate>;
  /**
   * Updates an existing page.
   *
   * Requires one of the following permissions: MANAGE_PAGES.
   */
  pageUpdate?: Maybe<PageUpdate>;
  /**
   * Change the password of the logged in user.
   *
   * Requires one of the following permissions: AUTHENTICATED_USER.
   */
  passwordChange?: Maybe<PasswordChange>;
  /**
   * Captures the authorized payment amount.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   */
  paymentCapture?: Maybe<PaymentCapture>;
  /** Check payment balance. */
  paymentCheckBalance?: Maybe<PaymentCheckBalance>;
  /** Initializes a payment gateway session. It triggers the webhook `PAYMENT_GATEWAY_INITIALIZE_SESSION`, to the requested `paymentGateways`. If `paymentGateways` is not provided, the webhook will be send to all subscribed payment gateways. There is a limit of 100 transaction items per checkout / order. */
  paymentGatewayInitialize?: Maybe<PaymentGatewayInitialize>;
  /**
   * Initializes payment gateway for tokenizing payment method session.
   *
   * Requires one of the following permissions: AUTHENTICATED_USER.
   *
   * Triggers the following webhook events:
   * - PAYMENT_GATEWAY_INITIALIZE_TOKENIZATION_SESSION (sync): The customer requested to initialize payment gateway for tokenization.
   */
  paymentGatewayInitializeTokenization?: Maybe<PaymentGatewayInitializeTokenization>;
  /** Initializes payment process when it is required by gateway. */
  paymentInitialize?: Maybe<PaymentInitialize>;
  /**
   * Tokenize payment method.
   *
   * Requires one of the following permissions: AUTHENTICATED_USER.
   *
   * Triggers the following webhook events:
   * - PAYMENT_METHOD_INITIALIZE_TOKENIZATION_SESSION (sync): The customer requested to tokenize payment method.
   */
  paymentMethodInitializeTokenization?: Maybe<PaymentMethodInitializeTokenization>;
  /**
   * Tokenize payment method.
   *
   * Requires one of the following permissions: AUTHENTICATED_USER.
   *
   * Triggers the following webhook events:
   * - PAYMENT_METHOD_PROCESS_TOKENIZATION_SESSION (sync): The customer continues payment method tokenization.
   */
  paymentMethodProcessTokenization?: Maybe<PaymentMethodProcessTokenization>;
  /**
   * Refunds the captured payment amount.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   */
  paymentRefund?: Maybe<PaymentRefund>;
  /**
   * Voids the authorized payment.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   */
  paymentVoid?: Maybe<PaymentVoid>;
  /**
   * Create new permission group. Apps are not allowed to perform this mutation.
   *
   * Requires one of the following permissions: MANAGE_STAFF.
   *
   * Triggers the following webhook events:
   * - PERMISSION_GROUP_CREATED (async)
   */
  permissionGroupCreate?: Maybe<PermissionGroupCreate>;
  /**
   * Delete permission group. Apps are not allowed to perform this mutation.
   *
   * Requires one of the following permissions: MANAGE_STAFF.
   *
   * Triggers the following webhook events:
   * - PERMISSION_GROUP_DELETED (async)
   */
  permissionGroupDelete?: Maybe<PermissionGroupDelete>;
  /**
   * Update permission group. Apps are not allowed to perform this mutation.
   *
   * Requires one of the following permissions: MANAGE_STAFF.
   *
   * Triggers the following webhook events:
   * - PERMISSION_GROUP_UPDATED (async)
   */
  permissionGroupUpdate?: Maybe<PermissionGroupUpdate>;
  /**
   * Update plugin configuration.
   *
   * Requires one of the following permissions: MANAGE_PLUGINS.
   */
  pluginUpdate?: Maybe<PluginUpdate>;
  /**
   * Assign attributes to a given product type.
   *
   * Requires one of the following permissions: MANAGE_PRODUCT_TYPES_AND_ATTRIBUTES.
   */
  productAttributeAssign?: Maybe<ProductAttributeAssign>;
  /**
   * Update attributes assigned to product variant for given product type.
   *
   * Requires one of the following permissions: MANAGE_PRODUCT_TYPES_AND_ATTRIBUTES.
   */
  productAttributeAssignmentUpdate?: Maybe<ProductAttributeAssignmentUpdate>;
  /**
   * Un-assign attributes from a given product type.
   *
   * Requires one of the following permissions: MANAGE_PRODUCT_TYPES_AND_ATTRIBUTES.
   */
  productAttributeUnassign?: Maybe<ProductAttributeUnassign>;
  /**
   * Creates products.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  productBulkCreate?: Maybe<ProductBulkCreate>;
  /**
   * Deletes products.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  productBulkDelete?: Maybe<ProductBulkDelete>;
  /**
   * Creates/updates translations for products.
   *
   * Requires one of the following permissions: MANAGE_TRANSLATIONS.
   *
   * Triggers the following webhook events:
   * - TRANSLATION_CREATED (async): Called when a translation was created.
   * - TRANSLATION_UPDATED (async): Called when a translation was updated.
   */
  productBulkTranslate?: Maybe<ProductBulkTranslate>;
  /**
   * Manage product's availability in channels.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  productChannelListingUpdate?: Maybe<ProductChannelListingUpdate>;
  /**
   * Creates a new product.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  productCreate?: Maybe<ProductCreate>;
  /**
   * Deletes a product.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  productDelete?: Maybe<ProductDelete>;
  /**
   * Deletes product media.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  productMediaBulkDelete?: Maybe<ProductMediaBulkDelete>;
  /**
   * Create a media object (image or video URL) associated with product. For image, this mutation must be sent as a `multipart` request. More detailed specs of the upload format can be found here: https://github.com/jaydenseric/graphql-multipart-request-spec
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  productMediaCreate?: Maybe<ProductMediaCreate>;
  /**
   * Deletes a product media.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  productMediaDelete?: Maybe<ProductMediaDelete>;
  /**
   * Changes ordering of the product media.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  productMediaReorder?: Maybe<ProductMediaReorder>;
  /**
   * Updates a product media.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  productMediaUpdate?: Maybe<ProductMediaUpdate>;
  /**
   * Reorder product attribute values.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  productReorderAttributeValues?: Maybe<ProductReorderAttributeValues>;
  /**
   * Creates/updates translations for a product.
   *
   * Requires one of the following permissions: MANAGE_TRANSLATIONS.
   */
  productTranslate?: Maybe<ProductTranslate>;
  /**
   * Deletes product types.
   *
   * Requires one of the following permissions: MANAGE_PRODUCT_TYPES_AND_ATTRIBUTES.
   */
  productTypeBulkDelete?: Maybe<ProductTypeBulkDelete>;
  /**
   * Creates a new product type.
   *
   * Requires one of the following permissions: MANAGE_PRODUCT_TYPES_AND_ATTRIBUTES.
   */
  productTypeCreate?: Maybe<ProductTypeCreate>;
  /**
   * Deletes a product type.
   *
   * Requires one of the following permissions: MANAGE_PRODUCT_TYPES_AND_ATTRIBUTES.
   */
  productTypeDelete?: Maybe<ProductTypeDelete>;
  /**
   * Reorder the attributes of a product type.
   *
   * Requires one of the following permissions: MANAGE_PRODUCT_TYPES_AND_ATTRIBUTES.
   */
  productTypeReorderAttributes?: Maybe<ProductTypeReorderAttributes>;
  /**
   * Updates an existing product type.
   *
   * Requires one of the following permissions: MANAGE_PRODUCT_TYPES_AND_ATTRIBUTES.
   */
  productTypeUpdate?: Maybe<ProductTypeUpdate>;
  /**
   * Updates an existing product.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  productUpdate?: Maybe<ProductUpdate>;
  /**
   * Creates product variants for a given product.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  productVariantBulkCreate?: Maybe<ProductVariantBulkCreate>;
  /**
   * Deletes product variants.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  productVariantBulkDelete?: Maybe<ProductVariantBulkDelete>;
  /**
   * Creates/updates translations for product variants.
   *
   * Requires one of the following permissions: MANAGE_TRANSLATIONS.
   *
   * Triggers the following webhook events:
   * - TRANSLATION_CREATED (async): A translation was created.
   * - TRANSLATION_UPDATED (async): A translation was updated.
   */
  productVariantBulkTranslate?: Maybe<ProductVariantBulkTranslate>;
  /**
   * Updates multiple product variants.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  productVariantBulkUpdate?: Maybe<ProductVariantBulkUpdate>;
  /**
   * Manage product variant prices in channels.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  productVariantChannelListingUpdate?: Maybe<ProductVariantChannelListingUpdate>;
  /**
   * Creates a new variant for a product.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  productVariantCreate?: Maybe<ProductVariantCreate>;
  /**
   * Deletes a product variant.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  productVariantDelete?: Maybe<ProductVariantDelete>;
  /**
   * Deactivates product variant preorder. It changes all preorder allocation into regular allocation.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  productVariantPreorderDeactivate?: Maybe<ProductVariantPreorderDeactivate>;
  /**
   * Reorder the variants of a product. Mutation updates updated_at on product and triggers PRODUCT_UPDATED webhook.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  productVariantReorder?: Maybe<ProductVariantReorder>;
  /**
   * Reorder product variant attribute values.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  productVariantReorderAttributeValues?: Maybe<ProductVariantReorderAttributeValues>;
  /**
   * Set default variant for a product. Mutation triggers PRODUCT_UPDATED webhook.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  productVariantSetDefault?: Maybe<ProductVariantSetDefault>;
  /**
   * Creates stocks for product variant.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  productVariantStocksCreate?: Maybe<ProductVariantStocksCreate>;
  /**
   * Deletes stocks from product variant.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  productVariantStocksDelete?: Maybe<ProductVariantStocksDelete>;
  /**
   * Updates stocks for product variant.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  productVariantStocksUpdate?: Maybe<ProductVariantStocksUpdate>;
  /**
   * Creates/updates translations for a product variant.
   *
   * Requires one of the following permissions: MANAGE_TRANSLATIONS.
   */
  productVariantTranslate?: Maybe<ProductVariantTranslate>;
  /**
   * Updates an existing variant for product.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  productVariantUpdate?: Maybe<ProductVariantUpdate>;
  /**
   * Deletes promotions.
   *
   * Requires one of the following permissions: MANAGE_DISCOUNTS.
   *
   * Triggers the following webhook events:
   * - PROMOTION_DELETED (async): A promotion was deleted.
   */
  promotionBulkDelete?: Maybe<PromotionBulkDelete>;
  /**
   * Creates a new promotion.
   *
   * Requires one of the following permissions: MANAGE_DISCOUNTS.
   *
   * Triggers the following webhook events:
   * - PROMOTION_CREATED (async): A promotion was created.
   * - PROMOTION_STARTED (async): Optionally called if promotion was started.
   */
  promotionCreate?: Maybe<PromotionCreate>;
  /**
   * Deletes a promotion.
   *
   * Requires one of the following permissions: MANAGE_DISCOUNTS.
   *
   * Triggers the following webhook events:
   * - PROMOTION_DELETED (async): A promotion was deleted.
   */
  promotionDelete?: Maybe<PromotionDelete>;
  /**
   * Creates a new promotion rule.
   *
   * Requires one of the following permissions: MANAGE_DISCOUNTS.
   *
   * Triggers the following webhook events:
   * - PROMOTION_RULE_CREATED (async): A promotion rule was created.
   */
  promotionRuleCreate?: Maybe<PromotionRuleCreate>;
  /**
   * Deletes a promotion rule.
   *
   * Requires one of the following permissions: MANAGE_DISCOUNTS.
   *
   * Triggers the following webhook events:
   * - PROMOTION_RULE_DELETED (async): A promotion rule was deleted.
   */
  promotionRuleDelete?: Maybe<PromotionRuleDelete>;
  /**
   * Creates/updates translations for a promotion rule.
   *
   * Requires one of the following permissions: MANAGE_TRANSLATIONS.
   */
  promotionRuleTranslate?: Maybe<PromotionRuleTranslate>;
  /**
   * Updates an existing promotion rule.
   *
   * Requires one of the following permissions: MANAGE_DISCOUNTS.
   *
   * Triggers the following webhook events:
   * - PROMOTION_RULE_UPDATED (async): A promotion rule was updated.
   */
  promotionRuleUpdate?: Maybe<PromotionRuleUpdate>;
  /**
   * Creates/updates translations for a promotion.
   *
   * Requires one of the following permissions: MANAGE_TRANSLATIONS.
   */
  promotionTranslate?: Maybe<PromotionTranslate>;
  /**
   * Updates an existing promotion.
   *
   * Requires one of the following permissions: MANAGE_DISCOUNTS.
   *
   * Triggers the following webhook events:
   * - PROMOTION_UPDATED (async): A promotion was updated.
   * - PROMOTION_STARTED (async): Optionally called if promotion was started.
   * - PROMOTION_ENDED (async): Optionally called if promotion was ended.
   */
  promotionUpdate?: Maybe<PromotionUpdate>;
  /**
   * Updates RefundSettings. The `Page` (Model) Type will be cleared from `reasonReferenceType`. When it's cleared, passing reason reference to refund mutations is no longer accepted and will raise error.
   *
   * Added in Saleor 3.22.
   *
   * Requires one of the following permissions: MANAGE_SETTINGS.
   */
  refundReasonReferenceClear?: Maybe<RefundReasonReferenceTypeClear>;
  /**
   * Update refund settings across all channels.
   *
   * Added in Saleor 3.22.
   *
   * Requires one of the following permissions: MANAGE_SETTINGS.
   */
  refundSettingsUpdate?: Maybe<RefundSettingsUpdate>;
  /**
   * Request email change of the logged in user.
   *
   * Requires one of the following permissions: AUTHENTICATED_USER.
   *
   * Triggers the following webhook events:
   * - NOTIFY_USER (async): A notification for account email change.
   * - ACCOUNT_CHANGE_EMAIL_REQUESTED (async): An account email change was requested.
   */
  requestEmailChange?: Maybe<RequestEmailChange>;
  /**
   * Sends an email with the account password modification link.
   *
   * Triggers the following webhook events:
   * - NOTIFY_USER (async): A notification for password reset.
   * - ACCOUNT_SET_PASSWORD_REQUESTED (async): Setting a new password for the account is requested.
   * - STAFF_SET_PASSWORD_REQUESTED (async): Setting a new password for the staff account is requested.
   */
  requestPasswordReset?: Maybe<RequestPasswordReset>;
  /**
   * Deletes sales.
   *
   * Requires one of the following permissions: MANAGE_DISCOUNTS.
   *
   * Triggers the following webhook events:
   * - SALE_DELETED (async): A sale was deleted.
   */
  saleBulkDelete?: Maybe<SaleBulkDelete>;
  /**
   * Adds products, categories, collections to a sale.
   *
   * Requires one of the following permissions: MANAGE_DISCOUNTS.
   *
   * Triggers the following webhook events:
   * - SALE_UPDATED (async): A sale was updated.
   * @deprecated Use `promotionRuleCreate` and `promotionRuleUpdate` mutations instead.
   */
  saleCataloguesAdd?: Maybe<SaleAddCatalogues>;
  /**
   * Removes products, categories, collections from a sale.
   *
   * Requires one of the following permissions: MANAGE_DISCOUNTS.
   *
   * Triggers the following webhook events:
   * - SALE_UPDATED (async): A sale was updated.
   * @deprecated Use `promotionRuleUpdate` and `promotionRuleDelete` mutations instead.
   */
  saleCataloguesRemove?: Maybe<SaleRemoveCatalogues>;
  /**
   * Manage sale's availability in channels.
   *
   * Requires one of the following permissions: MANAGE_DISCOUNTS.
   * @deprecated Use `promotionRuleUpdate` mutation instead.
   */
  saleChannelListingUpdate?: Maybe<SaleChannelListingUpdate>;
  /**
   * Creates a new sale.
   *
   * Requires one of the following permissions: MANAGE_DISCOUNTS.
   *
   * Triggers the following webhook events:
   * - SALE_CREATED (async): A sale was created.
   * @deprecated Use `promotionCreate` mutation instead.
   */
  saleCreate?: Maybe<SaleCreate>;
  /**
   * Deletes a sale.
   *
   * Requires one of the following permissions: MANAGE_DISCOUNTS.
   *
   * Triggers the following webhook events:
   * - SALE_DELETED (async): A sale was deleted.
   * @deprecated Use `promotionDelete` mutation instead.
   */
  saleDelete?: Maybe<SaleDelete>;
  /**
   * Creates/updates translations for a sale.
   *
   * Requires one of the following permissions: MANAGE_TRANSLATIONS.
   * @deprecated Use `promotionTranslate` mutation instead.
   */
  saleTranslate?: Maybe<SaleTranslate>;
  /**
   * Updates a sale.
   *
   * Requires one of the following permissions: MANAGE_DISCOUNTS.
   *
   * Triggers the following webhook events:
   * - SALE_UPDATED (async): A sale was updated.
   * - SALE_TOGGLE (async): Optionally triggered when a sale is started or stopped.
   * @deprecated Use `promotionUpdate` mutation instead.
   */
  saleUpdate?: Maybe<SaleUpdate>;
  /**
   * Sends a notification confirmation.
   *
   * Requires one of the following permissions: AUTHENTICATED_USER.
   *
   * Triggers the following webhook events:
   * - NOTIFY_USER (async): A notification for account confirmation.
   * - ACCOUNT_CONFIRMATION_REQUESTED (async): An account confirmation was requested. This event is always sent regardless of settings.
   */
  sendConfirmationEmail?: Maybe<SendConfirmationEmail>;
  /** Sets the user's password from the token sent by email using the RequestPasswordReset mutation. */
  setPassword?: Maybe<SetPassword>;
  /**
   * Manage shipping method's availability in channels.
   *
   * Requires one of the following permissions: MANAGE_SHIPPING.
   */
  shippingMethodChannelListingUpdate?: Maybe<ShippingMethodChannelListingUpdate>;
  /**
   * Deletes shipping prices.
   *
   * Requires one of the following permissions: MANAGE_SHIPPING.
   */
  shippingPriceBulkDelete?: Maybe<ShippingPriceBulkDelete>;
  /**
   * Creates a new shipping price.
   *
   * Requires one of the following permissions: MANAGE_SHIPPING.
   */
  shippingPriceCreate?: Maybe<ShippingPriceCreate>;
  /**
   * Deletes a shipping price.
   *
   * Requires one of the following permissions: MANAGE_SHIPPING.
   */
  shippingPriceDelete?: Maybe<ShippingPriceDelete>;
  /**
   * Exclude products from shipping price.
   *
   * Requires one of the following permissions: MANAGE_SHIPPING.
   */
  shippingPriceExcludeProducts?: Maybe<ShippingPriceExcludeProducts>;
  /**
   * Remove product from excluded list for shipping price.
   *
   * Requires one of the following permissions: MANAGE_SHIPPING.
   */
  shippingPriceRemoveProductFromExclude?: Maybe<ShippingPriceRemoveProductFromExclude>;
  /**
   * Creates/updates translations for a shipping method.
   *
   * Requires one of the following permissions: MANAGE_TRANSLATIONS.
   */
  shippingPriceTranslate?: Maybe<ShippingPriceTranslate>;
  /**
   * Updates a new shipping price.
   *
   * Requires one of the following permissions: MANAGE_SHIPPING.
   */
  shippingPriceUpdate?: Maybe<ShippingPriceUpdate>;
  /**
   * Deletes shipping zones.
   *
   * Requires one of the following permissions: MANAGE_SHIPPING.
   */
  shippingZoneBulkDelete?: Maybe<ShippingZoneBulkDelete>;
  /**
   * Creates a new shipping zone.
   *
   * Requires one of the following permissions: MANAGE_SHIPPING.
   */
  shippingZoneCreate?: Maybe<ShippingZoneCreate>;
  /**
   * Deletes a shipping zone.
   *
   * Requires one of the following permissions: MANAGE_SHIPPING.
   */
  shippingZoneDelete?: Maybe<ShippingZoneDelete>;
  /**
   * Updates a new shipping zone.
   *
   * Requires one of the following permissions: MANAGE_SHIPPING.
   */
  shippingZoneUpdate?: Maybe<ShippingZoneUpdate>;
  /**
   * Update the shop's address. If the `null` value is passed, the currently selected address will be deleted.
   *
   * Requires one of the following permissions: MANAGE_SETTINGS.
   */
  shopAddressUpdate?: Maybe<ShopAddressUpdate>;
  /**
   * Updates site domain of the shop.
   *
   * Requires one of the following permissions: MANAGE_SETTINGS.
   * @deprecated Use `PUBLIC_URL` environment variable instead.
   */
  shopDomainUpdate?: Maybe<ShopDomainUpdate>;
  /**
   * Fetch tax rates.
   *
   * Requires one of the following permissions: MANAGE_SETTINGS.
   * @deprecated No longer supported
   */
  shopFetchTaxRates?: Maybe<ShopFetchTaxRates>;
  /**
   * Creates/updates translations for shop settings.
   *
   * Requires one of the following permissions: MANAGE_TRANSLATIONS.
   */
  shopSettingsTranslate?: Maybe<ShopSettingsTranslate>;
  /**
   * Updates shop settings.
   *
   * Requires one of the following permissions: MANAGE_SETTINGS.
   *
   * Triggers the following webhook events:
   * - SHOP_METADATA_UPDATED (async): Optionally triggered when public or private metadata is updated.
   */
  shopSettingsUpdate?: Maybe<ShopSettingsUpdate>;
  /**
   * Deletes staff users. Apps are not allowed to perform this mutation.
   *
   * Requires one of the following permissions: MANAGE_STAFF.
   *
   * Triggers the following webhook events:
   * - STAFF_DELETED (async): A staff account was deleted.
   */
  staffBulkDelete?: Maybe<StaffBulkDelete>;
  /**
   * Creates a new staff user. Apps are not allowed to perform this mutation.
   *
   * Requires one of the following permissions: MANAGE_STAFF.
   *
   * Triggers the following webhook events:
   * - STAFF_CREATED (async): A new staff account was created.
   * - NOTIFY_USER (async): A notification for setting the password.
   * - STAFF_SET_PASSWORD_REQUESTED (async): Setting a new password for the staff account is requested.
   */
  staffCreate?: Maybe<StaffCreate>;
  /**
   * Deletes a staff user. Apps are not allowed to perform this mutation.
   *
   * Requires one of the following permissions: MANAGE_STAFF.
   *
   * Triggers the following webhook events:
   * - STAFF_DELETED (async): A staff account was deleted.
   */
  staffDelete?: Maybe<StaffDelete>;
  /**
   * Creates a new staff notification recipient.
   *
   * Requires one of the following permissions: MANAGE_SETTINGS.
   */
  staffNotificationRecipientCreate?: Maybe<StaffNotificationRecipientCreate>;
  /**
   * Deletes staff notification recipient.
   *
   * Requires one of the following permissions: MANAGE_SETTINGS.
   */
  staffNotificationRecipientDelete?: Maybe<StaffNotificationRecipientDelete>;
  /**
   * Updates a staff notification recipient.
   *
   * Requires one of the following permissions: MANAGE_SETTINGS.
   */
  staffNotificationRecipientUpdate?: Maybe<StaffNotificationRecipientUpdate>;
  /**
   * Updates an existing staff user. Apps are not allowed to perform this mutation.
   *
   * Requires one of the following permissions: MANAGE_STAFF.
   *
   * Triggers the following webhook events:
   * - STAFF_UPDATED (async): A staff account was updated.
   */
  staffUpdate?: Maybe<StaffUpdate>;
  /**
   * Updates stocks for a given variant and warehouse. Variant and warehouse selectors have to be the same for all stock inputs. Is not allowed to use 'variantId' in one input and 'variantExternalReference' in another.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   *
   * Triggers the following webhook events:
   * - PRODUCT_VARIANT_STOCK_UPDATED (async): A product variant stock details were updated.
   */
  stockBulkUpdate?: Maybe<StockBulkUpdate>;
  /**
   * Request to delete a stored payment method on payment provider side.
   *
   * Requires one of the following permissions: AUTHENTICATED_USER.
   *
   * Triggers the following webhook events:
   * - STORED_PAYMENT_METHOD_DELETE_REQUESTED (sync): The customer requested to delete a payment method.
   */
  storedPaymentMethodRequestDelete?: Maybe<StoredPaymentMethodRequestDelete>;
  /**
   * Creates a tax class.
   *
   * Requires one of the following permissions: MANAGE_TAXES.
   */
  taxClassCreate?: Maybe<TaxClassCreate>;
  /**
   * Deletes a tax class. After deleting the tax class any products, product types or shipping methods using it are updated to use the default tax class.
   *
   * Requires one of the following permissions: MANAGE_TAXES.
   */
  taxClassDelete?: Maybe<TaxClassDelete>;
  /**
   * Updates a tax class.
   *
   * Requires one of the following permissions: MANAGE_TAXES.
   */
  taxClassUpdate?: Maybe<TaxClassUpdate>;
  /**
   * Updates tax configuration for a channel.
   *
   * Requires one of the following permissions: MANAGE_TAXES.
   */
  taxConfigurationUpdate?: Maybe<TaxConfigurationUpdate>;
  /**
   * Remove all tax class rates for a specific country.
   *
   * Requires one of the following permissions: MANAGE_TAXES.
   */
  taxCountryConfigurationDelete?: Maybe<TaxCountryConfigurationDelete>;
  /**
   * Updates tax class rates for a specific country.
   *
   * Requires one of the following permissions: MANAGE_TAXES.
   */
  taxCountryConfigurationUpdate?: Maybe<TaxCountryConfigurationUpdate>;
  /**
   * Exempt checkout or order from charging the taxes. When tax exemption is enabled, taxes won't be charged for the checkout or order. Taxes may still be calculated in cases when product prices are entered with the tax included and the net price needs to be known.
   *
   * Requires one of the following permissions: MANAGE_TAXES.
   */
  taxExemptionManage?: Maybe<TaxExemptionManage>;
  /** Create JWT token. */
  tokenCreate?: Maybe<CreateToken>;
  /** Refresh JWT token. Mutation tries to take refreshToken from the input. If it fails it will try to take `refreshToken` from the http-only cookie `refreshToken`. `csrfToken` is required when `refreshToken` is provided as a cookie. */
  tokenRefresh?: Maybe<RefreshToken>;
  /** Verify JWT token. */
  tokenVerify?: Maybe<VerifyToken>;
  /**
   * Deactivate all JWT tokens of the currently authenticated user.
   *
   * Requires one of the following permissions: AUTHENTICATED_USER.
   */
  tokensDeactivateAll?: Maybe<DeactivateAllUserTokens>;
  /**
   * Creates transaction for checkout or order.
   *
   * Requires one of the following permissions: HANDLE_PAYMENTS.
   */
  transactionCreate?: Maybe<TransactionCreate>;
  /**
   * Report the event for the transaction.
   *
   * Requires the following permissions: OWNER and HANDLE_PAYMENTS for apps, HANDLE_PAYMENTS for staff users. Staff user cannot update a transaction that is owned by the app.
   *
   * Triggers the following webhook events:
   * - TRANSACTION_ITEM_METADATA_UPDATED (async): Optionally called when transaction's metadata was updated.
   * - CHECKOUT_FULLY_PAID (async): Optionally called when the checkout charge status changed to `FULL` or `OVERCHARGED`.
   * - ORDER_UPDATED (async): Optionally called when the transaction is related to the order and the order was updated.
   */
  transactionEventReport?: Maybe<TransactionEventReport>;
  /** Initializes a transaction session. It triggers the webhook `TRANSACTION_INITIALIZE_SESSION`, to the requested `paymentGateways`. There is a limit of 100 transaction items per checkout / order. */
  transactionInitialize?: Maybe<TransactionInitialize>;
  /** Processes a transaction session. It triggers the webhook `TRANSACTION_PROCESS_SESSION`, to the assigned `paymentGateways`.  */
  transactionProcess?: Maybe<TransactionProcess>;
  /**
   * Request an action for payment transaction.
   *
   * Requires one of the following permissions: HANDLE_PAYMENTS.
   */
  transactionRequestAction?: Maybe<TransactionRequestAction>;
  /**
   * Request a refund for payment transaction based on granted refund.
   *
   * Requires one of the following permissions: HANDLE_PAYMENTS.
   */
  transactionRequestRefundForGrantedRefund?: Maybe<TransactionRequestRefundForGrantedRefund>;
  /**
   * Update transaction.
   *
   * Requires the following permissions: OWNER and HANDLE_PAYMENTS for apps, HANDLE_PAYMENTS for staff users. Staff user cannot update a transaction that is owned by the app.
   */
  transactionUpdate?: Maybe<TransactionUpdate>;
  /**
   * Remove shipping zone from given warehouse.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  unassignWarehouseShippingZone?: Maybe<WarehouseShippingZoneUnassign>;
  /**
   * Updates metadata of an object.Requires permissions to modify and to read the metadata of the object it's attached to.
   *
   * Warning: never store sensitive information, including financial data such as credit card details.
   */
  updateMetadata?: Maybe<UpdateMetadata>;
  /**
   * Updates private metadata of an object. Requires permissions to modify and to read the metadata of the object it's attached to.
   *
   * Warning: never store sensitive information, including financial data such as credit card details.
   */
  updatePrivateMetadata?: Maybe<UpdatePrivateMetadata>;
  /**
   * Updates given warehouse.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  updateWarehouse?: Maybe<WarehouseUpdate>;
  /**
   * Deletes a user avatar. Only for staff members.
   *
   * Requires one of the following permissions: AUTHENTICATED_STAFF_USER.
   */
  userAvatarDelete?: Maybe<UserAvatarDelete>;
  /**
   * Create a user avatar. Only for staff members. This mutation must be sent as a `multipart` request. More detailed specs of the upload format can be found here: https://github.com/jaydenseric/graphql-multipart-request-spec
   *
   * Requires one of the following permissions: AUTHENTICATED_STAFF_USER.
   */
  userAvatarUpdate?: Maybe<UserAvatarUpdate>;
  /**
   * Activate or deactivate users.
   *
   * Requires one of the following permissions: MANAGE_USERS.
   */
  userBulkSetActive?: Maybe<UserBulkSetActive>;
  /**
   * Assign an media to a product variant.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  variantMediaAssign?: Maybe<VariantMediaAssign>;
  /**
   * Unassign an media from a product variant.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  variantMediaUnassign?: Maybe<VariantMediaUnassign>;
  /**
   * Deletes vouchers.
   *
   * Requires one of the following permissions: MANAGE_DISCOUNTS.
   *
   * Triggers the following webhook events:
   * - VOUCHER_DELETED (async): A voucher was deleted.
   */
  voucherBulkDelete?: Maybe<VoucherBulkDelete>;
  /**
   * Adds products, categories, collections to a voucher.
   *
   * Requires one of the following permissions: MANAGE_DISCOUNTS.
   *
   * Triggers the following webhook events:
   * - VOUCHER_UPDATED (async): A voucher was updated.
   */
  voucherCataloguesAdd?: Maybe<VoucherAddCatalogues>;
  /**
   * Removes products, categories, collections from a voucher.
   *
   * Requires one of the following permissions: MANAGE_DISCOUNTS.
   *
   * Triggers the following webhook events:
   * - VOUCHER_UPDATED (async): A voucher was updated.
   */
  voucherCataloguesRemove?: Maybe<VoucherRemoveCatalogues>;
  /**
   * Manage voucher's availability in channels.
   *
   * Requires one of the following permissions: MANAGE_DISCOUNTS.
   *
   * Triggers the following webhook events:
   * - VOUCHER_UPDATED (async): A voucher was updated.
   */
  voucherChannelListingUpdate?: Maybe<VoucherChannelListingUpdate>;
  /**
   * Deletes voucher codes.
   *
   * Added in Saleor 3.18.
   *
   * Requires one of the following permissions: MANAGE_DISCOUNTS.
   *
   * Triggers the following webhook events:
   * - VOUCHER_CODES_DELETED (async): A voucher codes were deleted.
   */
  voucherCodeBulkDelete?: Maybe<VoucherCodeBulkDelete>;
  /**
   * Creates a new voucher.
   *
   * Requires one of the following permissions: MANAGE_DISCOUNTS.
   *
   * Triggers the following webhook events:
   * - VOUCHER_CREATED (async): A voucher was created.
   * - VOUCHER_CODES_CREATED (async): A voucher codes were created.
   */
  voucherCreate?: Maybe<VoucherCreate>;
  /**
   * Deletes a voucher.
   *
   * Requires one of the following permissions: MANAGE_DISCOUNTS.
   *
   * Triggers the following webhook events:
   * - VOUCHER_DELETED (async): A voucher was deleted.
   */
  voucherDelete?: Maybe<VoucherDelete>;
  /**
   * Creates/updates translations for a voucher.
   *
   * Requires one of the following permissions: MANAGE_TRANSLATIONS.
   */
  voucherTranslate?: Maybe<VoucherTranslate>;
  /**
   * Updates a voucher.
   *
   * Requires one of the following permissions: MANAGE_DISCOUNTS.
   *
   * Triggers the following webhook events:
   * - VOUCHER_UPDATED (async): A voucher was updated.
   * - VOUCHER_CODES_CREATED (async): A voucher code was created.
   */
  voucherUpdate?: Maybe<VoucherUpdate>;
  /**
   * Creates a new webhook subscription.
   *
   * Requires one of the following permissions: MANAGE_APPS, AUTHENTICATED_APP.
   */
  webhookCreate?: Maybe<WebhookCreate>;
  /**
   * Deletes a webhook. Before the deletion, the webhook is deactivated to pause any deliveries that are already scheduled. The deletion might fail if delivery is in progress. In such a case, the webhook is not deleted but remains deactivated.
   *
   * Requires one of the following permissions: MANAGE_APPS, AUTHENTICATED_APP.
   */
  webhookDelete?: Maybe<WebhookDelete>;
  /**
   * Performs a dry run of a webhook event. Supports a single event (the first, if multiple provided in the `query`). Requires permission relevant to processed event.
   *
   * Requires one of the following permissions: AUTHENTICATED_STAFF_USER.
   */
  webhookDryRun?: Maybe<WebhookDryRun>;
  /**
   * Trigger a webhook event. Supports a single event (the first, if multiple provided in the `webhook.subscription_query`). Requires permission relevant to processed event. Successfully delivered webhook returns `delivery` with status='PENDING' and empty payload.
   *
   * Requires one of the following permissions: AUTHENTICATED_STAFF_USER.
   */
  webhookTrigger?: Maybe<WebhookTrigger>;
  /**
   * Updates a webhook subscription.
   *
   * Requires one of the following permissions: MANAGE_APPS, AUTHENTICATED_APP.
   */
  webhookUpdate?: Maybe<WebhookUpdate>;
};


export type MutationAccountAddressCreateArgs = {
  customerId?: InputMaybe<Scalars['ID']['input']>;
  input: AddressInput;
  type?: InputMaybe<AddressTypeEnum>;
};


export type MutationAccountAddressDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAccountAddressUpdateArgs = {
  id: Scalars['ID']['input'];
  input: AddressInput;
};


export type MutationAccountDeleteArgs = {
  token: Scalars['String']['input'];
};


export type MutationAccountRegisterArgs = {
  input: AccountRegisterInput;
};


export type MutationAccountRequestDeletionArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
  redirectUrl: Scalars['String']['input'];
};


export type MutationAccountSetDefaultAddressArgs = {
  id: Scalars['ID']['input'];
  type: AddressTypeEnum;
};


export type MutationAccountUpdateArgs = {
  customerId?: InputMaybe<Scalars['ID']['input']>;
  input: AccountInput;
};


export type MutationAddressCreateArgs = {
  input: AddressInput;
  userId: Scalars['ID']['input'];
};


export type MutationAddressDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAddressSetDefaultArgs = {
  addressId: Scalars['ID']['input'];
  type: AddressTypeEnum;
  userId: Scalars['ID']['input'];
};


export type MutationAddressUpdateArgs = {
  id: Scalars['ID']['input'];
  input: AddressInput;
};


export type MutationAppActivateArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAppCreateArgs = {
  input: AppInput;
};


export type MutationAppDeactivateArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAppDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAppDeleteFailedInstallationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAppFetchManifestArgs = {
  manifestUrl: Scalars['String']['input'];
};


export type MutationAppInstallArgs = {
  input: AppInstallInput;
};


export type MutationAppProblemCreateArgs = {
  input: AppProblemCreateInput;
};


export type MutationAppProblemDismissArgs = {
  input: AppProblemDismissInput;
};


export type MutationAppReenableSyncWebhooksArgs = {
  appId: Scalars['ID']['input'];
};


export type MutationAppRetryInstallArgs = {
  activateAfterInstallation?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
};


export type MutationAppTokenCreateArgs = {
  input: AppTokenInput;
};


export type MutationAppTokenDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAppTokenVerifyArgs = {
  token: Scalars['String']['input'];
};


export type MutationAppUpdateArgs = {
  id: Scalars['ID']['input'];
  input: AppInput;
};


export type MutationAssignNavigationArgs = {
  menu?: InputMaybe<Scalars['ID']['input']>;
  navigationType: NavigationType;
};


export type MutationAssignWarehouseShippingZoneArgs = {
  id: Scalars['ID']['input'];
  shippingZoneIds: Array<Scalars['ID']['input']>;
};


export type MutationAttributeBulkCreateArgs = {
  attributes: Array<AttributeCreateInput>;
  errorPolicy?: InputMaybe<ErrorPolicyEnum>;
};


export type MutationAttributeBulkDeleteArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationAttributeBulkTranslateArgs = {
  errorPolicy?: InputMaybe<ErrorPolicyEnum>;
  translations: Array<AttributeBulkTranslateInput>;
};


export type MutationAttributeBulkUpdateArgs = {
  attributes: Array<AttributeBulkUpdateInput>;
  errorPolicy?: InputMaybe<ErrorPolicyEnum>;
};


export type MutationAttributeCreateArgs = {
  input: AttributeCreateInput;
};


export type MutationAttributeDeleteArgs = {
  externalReference?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationAttributeReorderValuesArgs = {
  attributeId: Scalars['ID']['input'];
  moves: Array<ReorderInput>;
};


export type MutationAttributeTranslateArgs = {
  id: Scalars['ID']['input'];
  input: NameTranslationInput;
  languageCode: LanguageCodeEnum;
};


export type MutationAttributeUpdateArgs = {
  externalReference?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  input: AttributeUpdateInput;
};


export type MutationAttributeValueBulkDeleteArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationAttributeValueBulkTranslateArgs = {
  errorPolicy?: InputMaybe<ErrorPolicyEnum>;
  translations: Array<AttributeValueBulkTranslateInput>;
};


export type MutationAttributeValueCreateArgs = {
  attribute: Scalars['ID']['input'];
  input: AttributeValueCreateInput;
};


export type MutationAttributeValueDeleteArgs = {
  externalReference?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationAttributeValueTranslateArgs = {
  id: Scalars['ID']['input'];
  input: AttributeValueTranslationInput;
  languageCode: LanguageCodeEnum;
};


export type MutationAttributeValueUpdateArgs = {
  externalReference?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  input: AttributeValueUpdateInput;
};


export type MutationCategoryBulkDeleteArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationCategoryCreateArgs = {
  input: CategoryInput;
  parent?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationCategoryDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationCategoryTranslateArgs = {
  id: Scalars['ID']['input'];
  input: TranslationInput;
  languageCode: LanguageCodeEnum;
};


export type MutationCategoryUpdateArgs = {
  id: Scalars['ID']['input'];
  input: CategoryInput;
};


export type MutationChannelActivateArgs = {
  id: Scalars['ID']['input'];
};


export type MutationChannelCreateArgs = {
  input: ChannelCreateInput;
};


export type MutationChannelDeactivateArgs = {
  id: Scalars['ID']['input'];
};


export type MutationChannelDeleteArgs = {
  id: Scalars['ID']['input'];
  input?: InputMaybe<ChannelDeleteInput>;
};


export type MutationChannelReorderWarehousesArgs = {
  channelId: Scalars['ID']['input'];
  moves: Array<ReorderInput>;
};


export type MutationChannelUpdateArgs = {
  id: Scalars['ID']['input'];
  input: ChannelUpdateInput;
};


export type MutationCheckoutAddPromoCodeArgs = {
  checkoutId?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  promoCode: Scalars['String']['input'];
  token?: InputMaybe<Scalars['UUID']['input']>;
};


export type MutationCheckoutBillingAddressUpdateArgs = {
  billingAddress: AddressInput;
  checkoutId?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  saveAddress?: InputMaybe<Scalars['Boolean']['input']>;
  token?: InputMaybe<Scalars['UUID']['input']>;
  validationRules?: InputMaybe<CheckoutAddressValidationRules>;
};


export type MutationCheckoutCompleteArgs = {
  checkoutId?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  metadata?: InputMaybe<Array<MetadataInput>>;
  paymentData?: InputMaybe<Scalars['JSONString']['input']>;
  redirectUrl?: InputMaybe<Scalars['String']['input']>;
  storeSource?: InputMaybe<Scalars['Boolean']['input']>;
  token?: InputMaybe<Scalars['UUID']['input']>;
};


export type MutationCheckoutCreateArgs = {
  input: CheckoutCreateInput;
};


export type MutationCheckoutCreateFromOrderArgs = {
  id: Scalars['ID']['input'];
};


export type MutationCheckoutCustomerAttachArgs = {
  checkoutId?: InputMaybe<Scalars['ID']['input']>;
  customerId?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  token?: InputMaybe<Scalars['UUID']['input']>;
};


export type MutationCheckoutCustomerDetachArgs = {
  checkoutId?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  token?: InputMaybe<Scalars['UUID']['input']>;
};


export type MutationCheckoutCustomerNoteUpdateArgs = {
  customerNote: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};


export type MutationCheckoutDeliveryMethodUpdateArgs = {
  deliveryMethodId?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  token?: InputMaybe<Scalars['UUID']['input']>;
};


export type MutationCheckoutEmailUpdateArgs = {
  checkoutId?: InputMaybe<Scalars['ID']['input']>;
  email: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  token?: InputMaybe<Scalars['UUID']['input']>;
};


export type MutationCheckoutLanguageCodeUpdateArgs = {
  checkoutId?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  languageCode: LanguageCodeEnum;
  token?: InputMaybe<Scalars['UUID']['input']>;
};


export type MutationCheckoutLineDeleteArgs = {
  checkoutId?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lineId?: InputMaybe<Scalars['ID']['input']>;
  token?: InputMaybe<Scalars['UUID']['input']>;
};


export type MutationCheckoutLinesAddArgs = {
  checkoutId?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lines: Array<CheckoutLineInput>;
  token?: InputMaybe<Scalars['UUID']['input']>;
};


export type MutationCheckoutLinesDeleteArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  linesIds: Array<Scalars['ID']['input']>;
  token?: InputMaybe<Scalars['UUID']['input']>;
};


export type MutationCheckoutLinesUpdateArgs = {
  checkoutId?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lines: Array<CheckoutLineUpdateInput>;
  token?: InputMaybe<Scalars['UUID']['input']>;
};


export type MutationCheckoutPaymentCreateArgs = {
  checkoutId?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  input: PaymentInput;
  token?: InputMaybe<Scalars['UUID']['input']>;
};


export type MutationCheckoutRemovePromoCodeArgs = {
  checkoutId?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  promoCode?: InputMaybe<Scalars['String']['input']>;
  promoCodeId?: InputMaybe<Scalars['ID']['input']>;
  token?: InputMaybe<Scalars['UUID']['input']>;
};


export type MutationCheckoutShippingAddressUpdateArgs = {
  checkoutId?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  saveAddress?: InputMaybe<Scalars['Boolean']['input']>;
  shippingAddress: AddressInput;
  token?: InputMaybe<Scalars['UUID']['input']>;
  validationRules?: InputMaybe<CheckoutAddressValidationRules>;
};


export type MutationCheckoutShippingMethodUpdateArgs = {
  checkoutId?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  shippingMethodId?: InputMaybe<Scalars['ID']['input']>;
  token?: InputMaybe<Scalars['UUID']['input']>;
};


export type MutationCollectionAddProductsArgs = {
  collectionId: Scalars['ID']['input'];
  products: Array<Scalars['ID']['input']>;
};


export type MutationCollectionBulkDeleteArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationCollectionChannelListingUpdateArgs = {
  id: Scalars['ID']['input'];
  input: CollectionChannelListingUpdateInput;
};


export type MutationCollectionCreateArgs = {
  input: CollectionCreateInput;
};


export type MutationCollectionDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationCollectionRemoveProductsArgs = {
  collectionId: Scalars['ID']['input'];
  products: Array<Scalars['ID']['input']>;
};


export type MutationCollectionReorderProductsArgs = {
  collectionId: Scalars['ID']['input'];
  moves: Array<MoveProductInput>;
};


export type MutationCollectionTranslateArgs = {
  id: Scalars['ID']['input'];
  input: TranslationInput;
  languageCode: LanguageCodeEnum;
};


export type MutationCollectionUpdateArgs = {
  id: Scalars['ID']['input'];
  input: CollectionInput;
};


export type MutationConfirmAccountArgs = {
  email: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


export type MutationConfirmEmailChangeArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
  token: Scalars['String']['input'];
};


export type MutationCreateWarehouseArgs = {
  input: WarehouseCreateInput;
};


export type MutationCustomerBulkDeleteArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationCustomerBulkUpdateArgs = {
  customers: Array<CustomerBulkUpdateInput>;
  errorPolicy?: InputMaybe<ErrorPolicyEnum>;
};


export type MutationCustomerCreateArgs = {
  input: UserCreateInput;
};


export type MutationCustomerDeleteArgs = {
  externalReference?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationCustomerUpdateArgs = {
  externalReference?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  input: CustomerInput;
};


export type MutationDeleteMetadataArgs = {
  id: Scalars['ID']['input'];
  keys: Array<Scalars['String']['input']>;
};


export type MutationDeletePrivateMetadataArgs = {
  id: Scalars['ID']['input'];
  keys: Array<Scalars['String']['input']>;
};


export type MutationDeleteWarehouseArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDigitalContentCreateArgs = {
  input: DigitalContentUploadInput;
  variantId: Scalars['ID']['input'];
};


export type MutationDigitalContentDeleteArgs = {
  variantId: Scalars['ID']['input'];
};


export type MutationDigitalContentUpdateArgs = {
  input: DigitalContentInput;
  variantId: Scalars['ID']['input'];
};


export type MutationDigitalContentUrlCreateArgs = {
  input: DigitalContentUrlCreateInput;
};


export type MutationDraftOrderBulkDeleteArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationDraftOrderCompleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDraftOrderCreateArgs = {
  input: DraftOrderCreateInput;
};


export type MutationDraftOrderDeleteArgs = {
  externalReference?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationDraftOrderLinesBulkDeleteArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationDraftOrderUpdateArgs = {
  externalReference?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  input: DraftOrderInput;
};


export type MutationEventDeliveryRetryArgs = {
  id: Scalars['ID']['input'];
};


export type MutationExportGiftCardsArgs = {
  input: ExportGiftCardsInput;
};


export type MutationExportProductsArgs = {
  input: ExportProductsInput;
};


export type MutationExportVoucherCodesArgs = {
  input: ExportVoucherCodesInput;
};


export type MutationExternalAuthenticationUrlArgs = {
  input: Scalars['JSONString']['input'];
  pluginId: Scalars['String']['input'];
};


export type MutationExternalLogoutArgs = {
  input: Scalars['JSONString']['input'];
  pluginId: Scalars['String']['input'];
};


export type MutationExternalNotificationTriggerArgs = {
  channel: Scalars['String']['input'];
  input: ExternalNotificationTriggerInput;
  pluginId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationExternalObtainAccessTokensArgs = {
  input: Scalars['JSONString']['input'];
  pluginId: Scalars['String']['input'];
};


export type MutationExternalRefreshArgs = {
  input: Scalars['JSONString']['input'];
  pluginId: Scalars['String']['input'];
};


export type MutationExternalVerifyArgs = {
  input: Scalars['JSONString']['input'];
  pluginId: Scalars['String']['input'];
};


export type MutationFileUploadArgs = {
  file: Scalars['Upload']['input'];
};


export type MutationGiftCardActivateArgs = {
  id: Scalars['ID']['input'];
};


export type MutationGiftCardAddNoteArgs = {
  id: Scalars['ID']['input'];
  input: GiftCardAddNoteInput;
};


export type MutationGiftCardBulkActivateArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationGiftCardBulkCreateArgs = {
  input: GiftCardBulkCreateInput;
};


export type MutationGiftCardBulkDeactivateArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationGiftCardBulkDeleteArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationGiftCardCreateArgs = {
  input: GiftCardCreateInput;
};


export type MutationGiftCardDeactivateArgs = {
  id: Scalars['ID']['input'];
};


export type MutationGiftCardDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationGiftCardResendArgs = {
  input: GiftCardResendInput;
};


export type MutationGiftCardSettingsUpdateArgs = {
  input: GiftCardSettingsUpdateInput;
};


export type MutationGiftCardUpdateArgs = {
  id: Scalars['ID']['input'];
  input: GiftCardUpdateInput;
};


export type MutationInvoiceCreateArgs = {
  input: InvoiceCreateInput;
  orderId: Scalars['ID']['input'];
};


export type MutationInvoiceDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationInvoiceRequestArgs = {
  number?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['ID']['input'];
};


export type MutationInvoiceRequestDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationInvoiceSendNotificationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationInvoiceUpdateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateInvoiceInput;
};


export type MutationMenuBulkDeleteArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationMenuCreateArgs = {
  input: MenuCreateInput;
};


export type MutationMenuDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationMenuItemBulkDeleteArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationMenuItemCreateArgs = {
  input: MenuItemCreateInput;
};


export type MutationMenuItemDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationMenuItemMoveArgs = {
  menu: Scalars['ID']['input'];
  moves: Array<MenuItemMoveInput>;
};


export type MutationMenuItemTranslateArgs = {
  id: Scalars['ID']['input'];
  input: NameTranslationInput;
  languageCode: LanguageCodeEnum;
};


export type MutationMenuItemUpdateArgs = {
  id: Scalars['ID']['input'];
  input: MenuItemInput;
};


export type MutationMenuUpdateArgs = {
  id: Scalars['ID']['input'];
  input: MenuInput;
};


export type MutationOrderAddNoteArgs = {
  input: OrderAddNoteInput;
  order: Scalars['ID']['input'];
};


export type MutationOrderBulkCancelArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationOrderBulkCreateArgs = {
  errorPolicy?: InputMaybe<ErrorPolicyEnum>;
  orders: Array<OrderBulkCreateInput>;
  stockUpdatePolicy?: InputMaybe<StockUpdatePolicyEnum>;
};


export type MutationOrderCancelArgs = {
  id: Scalars['ID']['input'];
};


export type MutationOrderCaptureArgs = {
  amount: Scalars['PositiveDecimal']['input'];
  id: Scalars['ID']['input'];
};


export type MutationOrderConfirmArgs = {
  id: Scalars['ID']['input'];
};


export type MutationOrderCreateFromCheckoutArgs = {
  id: Scalars['ID']['input'];
  metadata?: InputMaybe<Array<MetadataInput>>;
  privateMetadata?: InputMaybe<Array<MetadataInput>>;
  removeCheckout?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationOrderDiscountAddArgs = {
  input: OrderDiscountCommonInput;
  orderId: Scalars['ID']['input'];
};


export type MutationOrderDiscountDeleteArgs = {
  discountId: Scalars['ID']['input'];
};


export type MutationOrderDiscountUpdateArgs = {
  discountId: Scalars['ID']['input'];
  input: OrderDiscountCommonInput;
};


export type MutationOrderFulfillArgs = {
  input: OrderFulfillInput;
  order?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationOrderFulfillmentApproveArgs = {
  allowStockToBeExceeded?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  notifyCustomer: Scalars['Boolean']['input'];
};


export type MutationOrderFulfillmentCancelArgs = {
  id: Scalars['ID']['input'];
  input?: InputMaybe<FulfillmentCancelInput>;
};


export type MutationOrderFulfillmentRefundProductsArgs = {
  input: OrderRefundProductsInput;
  order: Scalars['ID']['input'];
};


export type MutationOrderFulfillmentReturnProductsArgs = {
  input: OrderReturnProductsInput;
  order: Scalars['ID']['input'];
};


export type MutationOrderFulfillmentUpdateTrackingArgs = {
  id: Scalars['ID']['input'];
  input: FulfillmentUpdateTrackingInput;
};


export type MutationOrderGrantRefundCreateArgs = {
  id: Scalars['ID']['input'];
  input: OrderGrantRefundCreateInput;
};


export type MutationOrderGrantRefundUpdateArgs = {
  id: Scalars['ID']['input'];
  input: OrderGrantRefundUpdateInput;
};


export type MutationOrderLineDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationOrderLineDiscountRemoveArgs = {
  orderLineId: Scalars['ID']['input'];
};


export type MutationOrderLineDiscountUpdateArgs = {
  input: OrderDiscountCommonInput;
  orderLineId: Scalars['ID']['input'];
};


export type MutationOrderLineUpdateArgs = {
  id: Scalars['ID']['input'];
  input: OrderLineInput;
};


export type MutationOrderLinesCreateArgs = {
  id: Scalars['ID']['input'];
  input: Array<OrderLineCreateInput>;
};


export type MutationOrderMarkAsPaidArgs = {
  id: Scalars['ID']['input'];
  transactionReference?: InputMaybe<Scalars['String']['input']>;
};


export type MutationOrderNoteAddArgs = {
  input: OrderNoteInput;
  order: Scalars['ID']['input'];
};


export type MutationOrderNoteUpdateArgs = {
  input: OrderNoteInput;
  note: Scalars['ID']['input'];
};


export type MutationOrderRefundArgs = {
  amount: Scalars['PositiveDecimal']['input'];
  id: Scalars['ID']['input'];
};


export type MutationOrderSettingsUpdateArgs = {
  input: OrderSettingsUpdateInput;
};


export type MutationOrderUpdateArgs = {
  externalReference?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  input: OrderUpdateInput;
};


export type MutationOrderUpdateShippingArgs = {
  input: OrderUpdateShippingInput;
  order: Scalars['ID']['input'];
};


export type MutationOrderVoidArgs = {
  id: Scalars['ID']['input'];
};


export type MutationPageAttributeAssignArgs = {
  attributeIds: Array<Scalars['ID']['input']>;
  pageTypeId: Scalars['ID']['input'];
};


export type MutationPageAttributeUnassignArgs = {
  attributeIds: Array<Scalars['ID']['input']>;
  pageTypeId: Scalars['ID']['input'];
};


export type MutationPageBulkDeleteArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationPageBulkPublishArgs = {
  ids: Array<Scalars['ID']['input']>;
  isPublished: Scalars['Boolean']['input'];
};


export type MutationPageCreateArgs = {
  input: PageCreateInput;
};


export type MutationPageDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationPageReorderAttributeValuesArgs = {
  attributeId: Scalars['ID']['input'];
  moves: Array<ReorderInput>;
  pageId: Scalars['ID']['input'];
};


export type MutationPageTranslateArgs = {
  id: Scalars['ID']['input'];
  input: PageTranslationInput;
  languageCode: LanguageCodeEnum;
};


export type MutationPageTypeBulkDeleteArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationPageTypeCreateArgs = {
  input: PageTypeCreateInput;
};


export type MutationPageTypeDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationPageTypeReorderAttributesArgs = {
  moves: Array<ReorderInput>;
  pageTypeId: Scalars['ID']['input'];
};


export type MutationPageTypeUpdateArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  input: PageTypeUpdateInput;
};


export type MutationPageUpdateArgs = {
  id: Scalars['ID']['input'];
  input: PageInput;
};


export type MutationPasswordChangeArgs = {
  newPassword: Scalars['String']['input'];
  oldPassword?: InputMaybe<Scalars['String']['input']>;
};


export type MutationPaymentCaptureArgs = {
  amount?: InputMaybe<Scalars['PositiveDecimal']['input']>;
  paymentId: Scalars['ID']['input'];
};


export type MutationPaymentCheckBalanceArgs = {
  input: PaymentCheckBalanceInput;
};


export type MutationPaymentGatewayInitializeArgs = {
  amount?: InputMaybe<Scalars['PositiveDecimal']['input']>;
  id: Scalars['ID']['input'];
  paymentGateways?: InputMaybe<Array<PaymentGatewayToInitialize>>;
};


export type MutationPaymentGatewayInitializeTokenizationArgs = {
  channel: Scalars['String']['input'];
  data?: InputMaybe<Scalars['JSON']['input']>;
  id: Scalars['String']['input'];
};


export type MutationPaymentInitializeArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
  gateway: Scalars['String']['input'];
  paymentData?: InputMaybe<Scalars['JSONString']['input']>;
};


export type MutationPaymentMethodInitializeTokenizationArgs = {
  channel: Scalars['String']['input'];
  data?: InputMaybe<Scalars['JSON']['input']>;
  id: Scalars['String']['input'];
  paymentFlowToSupport: TokenizedPaymentFlowEnum;
};


export type MutationPaymentMethodProcessTokenizationArgs = {
  channel: Scalars['String']['input'];
  data?: InputMaybe<Scalars['JSON']['input']>;
  id: Scalars['String']['input'];
};


export type MutationPaymentRefundArgs = {
  amount?: InputMaybe<Scalars['PositiveDecimal']['input']>;
  paymentId: Scalars['ID']['input'];
};


export type MutationPaymentVoidArgs = {
  paymentId: Scalars['ID']['input'];
};


export type MutationPermissionGroupCreateArgs = {
  input: PermissionGroupCreateInput;
};


export type MutationPermissionGroupDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationPermissionGroupUpdateArgs = {
  id: Scalars['ID']['input'];
  input: PermissionGroupUpdateInput;
};


export type MutationPluginUpdateArgs = {
  channelId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  input: PluginUpdateInput;
};


export type MutationProductAttributeAssignArgs = {
  operations: Array<ProductAttributeAssignInput>;
  productTypeId: Scalars['ID']['input'];
};


export type MutationProductAttributeAssignmentUpdateArgs = {
  operations: Array<ProductAttributeAssignmentUpdateInput>;
  productTypeId: Scalars['ID']['input'];
};


export type MutationProductAttributeUnassignArgs = {
  attributeIds: Array<Scalars['ID']['input']>;
  productTypeId: Scalars['ID']['input'];
};


export type MutationProductBulkCreateArgs = {
  errorPolicy?: InputMaybe<ErrorPolicyEnum>;
  products: Array<ProductBulkCreateInput>;
};


export type MutationProductBulkDeleteArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationProductBulkTranslateArgs = {
  errorPolicy?: InputMaybe<ErrorPolicyEnum>;
  translations: Array<ProductBulkTranslateInput>;
};


export type MutationProductChannelListingUpdateArgs = {
  id: Scalars['ID']['input'];
  input: ProductChannelListingUpdateInput;
};


export type MutationProductCreateArgs = {
  input: ProductCreateInput;
};


export type MutationProductDeleteArgs = {
  externalReference?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationProductMediaBulkDeleteArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationProductMediaCreateArgs = {
  input: ProductMediaCreateInput;
};


export type MutationProductMediaDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationProductMediaReorderArgs = {
  mediaIds: Array<Scalars['ID']['input']>;
  productId: Scalars['ID']['input'];
};


export type MutationProductMediaUpdateArgs = {
  id: Scalars['ID']['input'];
  input: ProductMediaUpdateInput;
};


export type MutationProductReorderAttributeValuesArgs = {
  attributeId: Scalars['ID']['input'];
  moves: Array<ReorderInput>;
  productId: Scalars['ID']['input'];
};


export type MutationProductTranslateArgs = {
  id: Scalars['ID']['input'];
  input: TranslationInput;
  languageCode: LanguageCodeEnum;
};


export type MutationProductTypeBulkDeleteArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationProductTypeCreateArgs = {
  input: ProductTypeInput;
};


export type MutationProductTypeDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationProductTypeReorderAttributesArgs = {
  moves: Array<ReorderInput>;
  productTypeId: Scalars['ID']['input'];
  type: ProductAttributeType;
};


export type MutationProductTypeUpdateArgs = {
  id: Scalars['ID']['input'];
  input: ProductTypeInput;
};


export type MutationProductUpdateArgs = {
  externalReference?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  input: ProductInput;
};


export type MutationProductVariantBulkCreateArgs = {
  errorPolicy?: InputMaybe<ErrorPolicyEnum>;
  product: Scalars['ID']['input'];
  variants: Array<ProductVariantBulkCreateInput>;
};


export type MutationProductVariantBulkDeleteArgs = {
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  skus?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationProductVariantBulkTranslateArgs = {
  errorPolicy?: InputMaybe<ErrorPolicyEnum>;
  translations: Array<ProductVariantBulkTranslateInput>;
};


export type MutationProductVariantBulkUpdateArgs = {
  errorPolicy?: InputMaybe<ErrorPolicyEnum>;
  product: Scalars['ID']['input'];
  variants: Array<ProductVariantBulkUpdateInput>;
};


export type MutationProductVariantChannelListingUpdateArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  input: Array<ProductVariantChannelListingAddInput>;
  sku?: InputMaybe<Scalars['String']['input']>;
};


export type MutationProductVariantCreateArgs = {
  input: ProductVariantCreateInput;
};


export type MutationProductVariantDeleteArgs = {
  externalReference?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  sku?: InputMaybe<Scalars['String']['input']>;
};


export type MutationProductVariantPreorderDeactivateArgs = {
  id: Scalars['ID']['input'];
};


export type MutationProductVariantReorderArgs = {
  moves: Array<ReorderInput>;
  productId: Scalars['ID']['input'];
};


export type MutationProductVariantReorderAttributeValuesArgs = {
  attributeId: Scalars['ID']['input'];
  moves: Array<ReorderInput>;
  variantId: Scalars['ID']['input'];
};


export type MutationProductVariantSetDefaultArgs = {
  productId: Scalars['ID']['input'];
  variantId: Scalars['ID']['input'];
};


export type MutationProductVariantStocksCreateArgs = {
  stocks: Array<StockInput>;
  variantId: Scalars['ID']['input'];
};


export type MutationProductVariantStocksDeleteArgs = {
  sku?: InputMaybe<Scalars['String']['input']>;
  variantId?: InputMaybe<Scalars['ID']['input']>;
  warehouseIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type MutationProductVariantStocksUpdateArgs = {
  sku?: InputMaybe<Scalars['String']['input']>;
  stocks: Array<StockInput>;
  variantId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationProductVariantTranslateArgs = {
  id: Scalars['ID']['input'];
  input: NameTranslationInput;
  languageCode: LanguageCodeEnum;
};


export type MutationProductVariantUpdateArgs = {
  externalReference?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  input: ProductVariantInput;
  sku?: InputMaybe<Scalars['String']['input']>;
};


export type MutationPromotionBulkDeleteArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationPromotionCreateArgs = {
  input: PromotionCreateInput;
};


export type MutationPromotionDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationPromotionRuleCreateArgs = {
  input: PromotionRuleCreateInput;
};


export type MutationPromotionRuleDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationPromotionRuleTranslateArgs = {
  id: Scalars['ID']['input'];
  input: PromotionRuleTranslationInput;
  languageCode: LanguageCodeEnum;
};


export type MutationPromotionRuleUpdateArgs = {
  id: Scalars['ID']['input'];
  input: PromotionRuleUpdateInput;
};


export type MutationPromotionTranslateArgs = {
  id: Scalars['ID']['input'];
  input: PromotionTranslationInput;
  languageCode: LanguageCodeEnum;
};


export type MutationPromotionUpdateArgs = {
  id: Scalars['ID']['input'];
  input: PromotionUpdateInput;
};


export type MutationRefundSettingsUpdateArgs = {
  input: RefundSettingsUpdateInput;
};


export type MutationRequestEmailChangeArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
  newEmail: Scalars['String']['input'];
  password: Scalars['String']['input'];
  redirectUrl: Scalars['String']['input'];
};


export type MutationRequestPasswordResetArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  redirectUrl: Scalars['String']['input'];
};


export type MutationSaleBulkDeleteArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationSaleCataloguesAddArgs = {
  id: Scalars['ID']['input'];
  input: CatalogueInput;
};


export type MutationSaleCataloguesRemoveArgs = {
  id: Scalars['ID']['input'];
  input: CatalogueInput;
};


export type MutationSaleChannelListingUpdateArgs = {
  id: Scalars['ID']['input'];
  input: SaleChannelListingInput;
};


export type MutationSaleCreateArgs = {
  input: SaleInput;
};


export type MutationSaleDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationSaleTranslateArgs = {
  id: Scalars['ID']['input'];
  input: NameTranslationInput;
  languageCode: LanguageCodeEnum;
};


export type MutationSaleUpdateArgs = {
  id: Scalars['ID']['input'];
  input: SaleInput;
};


export type MutationSendConfirmationEmailArgs = {
  channel: Scalars['String']['input'];
  redirectUrl: Scalars['String']['input'];
};


export type MutationSetPasswordArgs = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


export type MutationShippingMethodChannelListingUpdateArgs = {
  id: Scalars['ID']['input'];
  input: ShippingMethodChannelListingInput;
};


export type MutationShippingPriceBulkDeleteArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationShippingPriceCreateArgs = {
  input: ShippingPriceInput;
};


export type MutationShippingPriceDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationShippingPriceExcludeProductsArgs = {
  id: Scalars['ID']['input'];
  input: ShippingPriceExcludeProductsInput;
};


export type MutationShippingPriceRemoveProductFromExcludeArgs = {
  id: Scalars['ID']['input'];
  products: Array<Scalars['ID']['input']>;
};


export type MutationShippingPriceTranslateArgs = {
  id: Scalars['ID']['input'];
  input: ShippingPriceTranslationInput;
  languageCode: LanguageCodeEnum;
};


export type MutationShippingPriceUpdateArgs = {
  id: Scalars['ID']['input'];
  input: ShippingPriceInput;
};


export type MutationShippingZoneBulkDeleteArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationShippingZoneCreateArgs = {
  input: ShippingZoneCreateInput;
};


export type MutationShippingZoneDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationShippingZoneUpdateArgs = {
  id: Scalars['ID']['input'];
  input: ShippingZoneUpdateInput;
};


export type MutationShopAddressUpdateArgs = {
  input?: InputMaybe<AddressInput>;
};


export type MutationShopDomainUpdateArgs = {
  input?: InputMaybe<SiteDomainInput>;
};


export type MutationShopSettingsTranslateArgs = {
  input: ShopSettingsTranslationInput;
  languageCode: LanguageCodeEnum;
};


export type MutationShopSettingsUpdateArgs = {
  input: ShopSettingsInput;
};


export type MutationStaffBulkDeleteArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationStaffCreateArgs = {
  input: StaffCreateInput;
};


export type MutationStaffDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationStaffNotificationRecipientCreateArgs = {
  input: StaffNotificationRecipientInput;
};


export type MutationStaffNotificationRecipientDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationStaffNotificationRecipientUpdateArgs = {
  id: Scalars['ID']['input'];
  input: StaffNotificationRecipientInput;
};


export type MutationStaffUpdateArgs = {
  id: Scalars['ID']['input'];
  input: StaffUpdateInput;
};


export type MutationStockBulkUpdateArgs = {
  errorPolicy?: InputMaybe<ErrorPolicyEnum>;
  stocks: Array<StockBulkUpdateInput>;
};


export type MutationStoredPaymentMethodRequestDeleteArgs = {
  channel: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};


export type MutationTaxClassCreateArgs = {
  input: TaxClassCreateInput;
};


export type MutationTaxClassDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationTaxClassUpdateArgs = {
  id: Scalars['ID']['input'];
  input: TaxClassUpdateInput;
};


export type MutationTaxConfigurationUpdateArgs = {
  id: Scalars['ID']['input'];
  input: TaxConfigurationUpdateInput;
};


export type MutationTaxCountryConfigurationDeleteArgs = {
  countryCode: CountryCode;
};


export type MutationTaxCountryConfigurationUpdateArgs = {
  countryCode: CountryCode;
  updateTaxClassRates: Array<TaxClassRateInput>;
};


export type MutationTaxExemptionManageArgs = {
  id: Scalars['ID']['input'];
  taxExemption: Scalars['Boolean']['input'];
};


export type MutationTokenCreateArgs = {
  audience?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};


export type MutationTokenRefreshArgs = {
  csrfToken?: InputMaybe<Scalars['String']['input']>;
  refreshToken?: InputMaybe<Scalars['String']['input']>;
};


export type MutationTokenVerifyArgs = {
  token: Scalars['String']['input'];
};


export type MutationTransactionCreateArgs = {
  id: Scalars['ID']['input'];
  transaction: TransactionCreateInput;
  transactionEvent?: InputMaybe<TransactionEventInput>;
};


export type MutationTransactionEventReportArgs = {
  amount?: InputMaybe<Scalars['PositiveDecimal']['input']>;
  availableActions?: InputMaybe<Array<TransactionActionEnum>>;
  externalUrl?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  paymentMethodDetails?: InputMaybe<PaymentMethodDetailsInput>;
  pspReference: Scalars['String']['input'];
  time?: InputMaybe<Scalars['DateTime']['input']>;
  token?: InputMaybe<Scalars['UUID']['input']>;
  transactionMetadata?: InputMaybe<Array<MetadataInput>>;
  transactionPrivateMetadata?: InputMaybe<Array<MetadataInput>>;
  type: TransactionEventTypeEnum;
};


export type MutationTransactionInitializeArgs = {
  action?: InputMaybe<TransactionFlowStrategyEnum>;
  amount?: InputMaybe<Scalars['PositiveDecimal']['input']>;
  customerIpAddress?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
  paymentGateway: PaymentGatewayToInitialize;
};


export type MutationTransactionProcessArgs = {
  customerIpAddress?: InputMaybe<Scalars['String']['input']>;
  data?: InputMaybe<Scalars['JSON']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  token?: InputMaybe<Scalars['UUID']['input']>;
};


export type MutationTransactionRequestActionArgs = {
  actionType: TransactionActionEnum;
  amount?: InputMaybe<Scalars['PositiveDecimal']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  refundReason?: InputMaybe<Scalars['String']['input']>;
  refundReasonReference?: InputMaybe<Scalars['ID']['input']>;
  token?: InputMaybe<Scalars['UUID']['input']>;
};


export type MutationTransactionRequestRefundForGrantedRefundArgs = {
  grantedRefundId: Scalars['ID']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  token?: InputMaybe<Scalars['UUID']['input']>;
};


export type MutationTransactionUpdateArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  token?: InputMaybe<Scalars['UUID']['input']>;
  transaction?: InputMaybe<TransactionUpdateInput>;
  transactionEvent?: InputMaybe<TransactionEventInput>;
};


export type MutationUnassignWarehouseShippingZoneArgs = {
  id: Scalars['ID']['input'];
  shippingZoneIds: Array<Scalars['ID']['input']>;
};


export type MutationUpdateMetadataArgs = {
  id: Scalars['ID']['input'];
  input: Array<MetadataInput>;
};


export type MutationUpdatePrivateMetadataArgs = {
  id: Scalars['ID']['input'];
  input: Array<MetadataInput>;
};


export type MutationUpdateWarehouseArgs = {
  externalReference?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  input: WarehouseUpdateInput;
};


export type MutationUserAvatarUpdateArgs = {
  image: Scalars['Upload']['input'];
};


export type MutationUserBulkSetActiveArgs = {
  ids: Array<Scalars['ID']['input']>;
  isActive: Scalars['Boolean']['input'];
};


export type MutationVariantMediaAssignArgs = {
  mediaId: Scalars['ID']['input'];
  variantId: Scalars['ID']['input'];
};


export type MutationVariantMediaUnassignArgs = {
  mediaId: Scalars['ID']['input'];
  variantId: Scalars['ID']['input'];
};


export type MutationVoucherBulkDeleteArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationVoucherCataloguesAddArgs = {
  id: Scalars['ID']['input'];
  input: CatalogueInput;
};


export type MutationVoucherCataloguesRemoveArgs = {
  id: Scalars['ID']['input'];
  input: CatalogueInput;
};


export type MutationVoucherChannelListingUpdateArgs = {
  id: Scalars['ID']['input'];
  input: VoucherChannelListingInput;
};


export type MutationVoucherCodeBulkDeleteArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationVoucherCreateArgs = {
  input: VoucherInput;
};


export type MutationVoucherDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationVoucherTranslateArgs = {
  id: Scalars['ID']['input'];
  input: NameTranslationInput;
  languageCode: LanguageCodeEnum;
};


export type MutationVoucherUpdateArgs = {
  id: Scalars['ID']['input'];
  input: VoucherInput;
};


export type MutationWebhookCreateArgs = {
  input: WebhookCreateInput;
};


export type MutationWebhookDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationWebhookDryRunArgs = {
  objectId: Scalars['ID']['input'];
  query: Scalars['String']['input'];
};


export type MutationWebhookTriggerArgs = {
  objectId: Scalars['ID']['input'];
  webhookId: Scalars['ID']['input'];
};


export type MutationWebhookUpdateArgs = {
  id: Scalars['ID']['input'];
  input: WebhookUpdateInput;
};

export type NameTranslationInput = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type NavigationType =
  /** Main storefront navigation. */
  | 'MAIN'
  /** Secondary storefront navigation. */
  | 'SECONDARY';

/** Represents the NEW_TAB target options for an app extension. */
export type NewTabTargetOptions = {
  __typename?: 'NewTabTargetOptions';
  /**
   * HTTP method for New Tab target (GET or POST)
   * @deprecated Use `settings` field directly.
   */
  method: HttpMethod;
};

/** An object with an ID */
export type Node = {
  /** The ID of the object. */
  id: Scalars['ID']['output'];
};

/**
 * An object with attributes.
 *
 * Added in Saleor 3.22.
 */
export type ObjectWithAttributes = {
  /**
   * Get a single attribute attached to the object by attribute slug.
   *
   * Added in Saleor 3.22.
   */
  assignedAttribute?: Maybe<AssignedAttribute>;
  /**
   * List of attributes assigned to the object.
   *
   * Added in Saleor 3.22.
   */
  assignedAttributes: Array<AssignedAttribute>;
};


/**
 * An object with attributes.
 *
 * Added in Saleor 3.22.
 */
export type ObjectWithAttributesAssignedAttributeArgs = {
  slug: Scalars['String']['input'];
};


/**
 * An object with attributes.
 *
 * Added in Saleor 3.22.
 */
export type ObjectWithAttributesAssignedAttributesArgs = {
  limit?: InputMaybe<Scalars['PositiveInt']['input']>;
};

export type ObjectWithMetadata = {
  /** List of public metadata items. Can be accessed without permissions. */
  metadata: Array<MetadataItem>;
  /**
   * A single key from public metadata.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   */
  metafield?: Maybe<Scalars['String']['output']>;
  /** Public metadata. Use `keys` to control which fields you want to include. The default is to include everything. */
  metafields?: Maybe<Scalars['Metadata']['output']>;
  /** List of private metadata items. Requires staff permissions to access. */
  privateMetadata: Array<MetadataItem>;
  /**
   * A single key from private metadata. Requires staff permissions to access.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   */
  privateMetafield?: Maybe<Scalars['String']['output']>;
  /** Private metadata. Requires staff permissions to access. Use `keys` to control which fields you want to include. The default is to include everything. */
  privateMetafields?: Maybe<Scalars['Metadata']['output']>;
};


export type ObjectWithMetadataMetafieldArgs = {
  key: Scalars['String']['input'];
};


export type ObjectWithMetadataMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type ObjectWithMetadataPrivateMetafieldArgs = {
  key: Scalars['String']['input'];
};


export type ObjectWithMetadataPrivateMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Represents an order in the shop. */
export type Order = Node & ObjectWithMetadata & {
  __typename?: 'Order';
  /** List of actions that can be performed in the current state of an order. */
  actions: Array<OrderAction>;
  /** The authorize status of the order. */
  authorizeStatus: OrderAuthorizeStatusEnum;
  /** Collection points that can be used for this order. */
  availableCollectionPoints: Array<Warehouse>;
  /**
   * Shipping methods that can be used with this order.
   * @deprecated Use `shippingMethods`, this field will be removed in 4.0
   */
  availableShippingMethods?: Maybe<Array<ShippingMethod>>;
  /** Billing address. The full data can be access for orders created in Saleor 3.2 and later, for other orders requires one of the following permissions: MANAGE_ORDERS, OWNER. */
  billingAddress?: Maybe<Address>;
  /** Informs whether a draft order can be finalized(turned into a regular order). */
  canFinalize: Scalars['Boolean']['output'];
  /** Channel through which the order was placed. */
  channel: Channel;
  /** The charge status of the order. */
  chargeStatus: OrderChargeStatusEnum;
  /** ID of the checkout that the order was created from. */
  checkoutId?: Maybe<Scalars['ID']['output']>;
  /** Name of the collection point where the order should be picked up by the customer. */
  collectionPointName?: Maybe<Scalars['String']['output']>;
  /** Date and time when the order was created. */
  created: Scalars['DateTime']['output'];
  /** Additional information provided by the customer about the order. */
  customerNote: Scalars['String']['output'];
  /** The delivery method selected for this order. */
  deliveryMethod?: Maybe<DeliveryMethod>;
  /**
   * Returns applied discount.
   * @deprecated Use the `discounts` field instead.
   */
  discount?: Maybe<Money>;
  /**
   * Discount name.
   * @deprecated Use the `discounts` field instead.
   */
  discountName?: Maybe<Scalars['String']['output']>;
  /** List of all discounts assigned to the order. */
  discounts: Array<OrderDiscount>;
  /** Determines whether displayed prices should include taxes. */
  displayGrossPrices: Scalars['Boolean']['output'];
  /** List of errors that occurred during order validation. */
  errors: Array<OrderError>;
  /**
   * List of events associated with the order.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   */
  events: Array<OrderEvent>;
  /** External ID of this order. */
  externalReference?: Maybe<Scalars['String']['output']>;
  /** List of shipments for the order. */
  fulfillments: Array<Fulfillment>;
  /** List of user gift cards. */
  giftCards: Array<GiftCard>;
  /**
   * List of granted refunds.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   */
  grantedRefunds: Array<OrderGrantedRefund>;
  /** ID of the order. */
  id: Scalars['ID']['output'];
  /** List of order invoices. Can be fetched for orders created in Saleor 3.2 and later, for other orders requires one of the following permissions: MANAGE_ORDERS, OWNER. */
  invoices: Array<Invoice>;
  /** Informs if an order is fully paid. */
  isPaid: Scalars['Boolean']['output'];
  /** Returns True, if order requires shipping. */
  isShippingRequired: Scalars['Boolean']['output'];
  /** @deprecated Use the `languageCodeEnum` field to fetch the language code. */
  languageCode: Scalars['String']['output'];
  /** Order language code. */
  languageCodeEnum: LanguageCodeEnum;
  /** List of order lines. */
  lines: Array<OrderLine>;
  /** List of public metadata items. Can be accessed without permissions. */
  metadata: Array<MetadataItem>;
  /**
   * A single key from public metadata.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   */
  metafield?: Maybe<Scalars['String']['output']>;
  /** Public metadata. Use `keys` to control which fields you want to include. The default is to include everything. */
  metafields?: Maybe<Scalars['Metadata']['output']>;
  /** User-friendly number of an order. */
  number: Scalars['String']['output'];
  /** The order origin. */
  origin: OrderOriginEnum;
  /** The ID of the order that was the base for this order. */
  original?: Maybe<Scalars['ID']['output']>;
  /** Internal payment status. */
  paymentStatus: PaymentChargeStatusEnum;
  /** User-friendly payment status. */
  paymentStatusDisplay: Scalars['String']['output'];
  /** List of payments for the order. */
  payments: Array<Payment>;
  /** List of private metadata items. Requires staff permissions to access. */
  privateMetadata: Array<MetadataItem>;
  /**
   * A single key from private metadata. Requires staff permissions to access.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   */
  privateMetafield?: Maybe<Scalars['String']['output']>;
  /** Private metadata. Requires staff permissions to access. Use `keys` to control which fields you want to include. The default is to include everything. */
  privateMetafields?: Maybe<Scalars['Metadata']['output']>;
  /** URL to which user should be redirected after order is placed. */
  redirectUrl?: Maybe<Scalars['String']['output']>;
  /** Shipping address. The full data can be access for orders created in Saleor 3.2 and later, for other orders requires one of the following permissions: MANAGE_ORDERS, OWNER. */
  shippingAddress?: Maybe<Address>;
  /**
   * Shipping method for this order.
   * @deprecated Use `deliveryMethod` instead.
   */
  shippingMethod?: Maybe<ShippingMethod>;
  /** Method used for shipping. */
  shippingMethodName?: Maybe<Scalars['String']['output']>;
  /** Shipping methods related to this order. */
  shippingMethods: Array<ShippingMethod>;
  /** Total price of shipping. */
  shippingPrice: TaxedMoney;
  /**
   * Denormalized tax class assigned to the shipping method.
   *
   * Requires one of the following permissions: AUTHENTICATED_STAFF_USER, AUTHENTICATED_APP.
   */
  shippingTaxClass?: Maybe<TaxClass>;
  /** Denormalized public metadata of the shipping method's tax class. */
  shippingTaxClassMetadata: Array<MetadataItem>;
  /** Denormalized name of the tax class assigned to the shipping method. */
  shippingTaxClassName?: Maybe<Scalars['String']['output']>;
  /** Denormalized private metadata of the shipping method's tax class. Requires staff permissions to access. */
  shippingTaxClassPrivateMetadata: Array<MetadataItem>;
  /** The shipping tax rate value. */
  shippingTaxRate: Scalars['Float']['output'];
  /** Status of the order. */
  status: OrderStatus;
  /** User-friendly order status. */
  statusDisplay: Scalars['String']['output'];
  /** The sum of line prices not including shipping. */
  subtotal: TaxedMoney;
  /** Returns True if order has to be exempt from taxes. */
  taxExemption: Scalars['Boolean']['output'];
  /** @deprecated Use `id` instead. */
  token: Scalars['String']['output'];
  /** Total amount of the order. */
  total: TaxedMoney;
  /**
   * Total amount of ongoing authorize requests for the order's transactions.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   */
  totalAuthorizePending: Money;
  /** Amount authorized for the order. */
  totalAuthorized: Money;
  /** The difference between the paid and the order total amount. */
  totalBalance: Money;
  /**
   * Total amount of ongoing cancel requests for the order's transactions.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   */
  totalCancelPending: Money;
  /** Amount canceled for the order. */
  totalCanceled: Money;
  /**
   * Amount captured for the order.
   * @deprecated Use `totalCharged` instead.
   */
  totalCaptured: Money;
  /**
   * Total amount of ongoing charge requests for the order's transactions.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   */
  totalChargePending: Money;
  /** Amount charged for the order. */
  totalCharged: Money;
  /**
   * Total amount of granted refund.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   */
  totalGrantedRefund: Money;
  /**
   * Total amount of ongoing refund requests for the order's transactions.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   */
  totalRefundPending: Money;
  /** Total refund amount for the order. */
  totalRefunded: Money;
  /**
   * The difference amount between granted refund and the amounts that are pending and refunded.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   */
  totalRemainingGrant: Money;
  /**
   * Google Analytics tracking client ID.
   *
   * DEPRECATED: this field will be removed.
   */
  trackingClientId: Scalars['String']['output'];
  /** List of transactions for the order. Requires one of the following permissions: MANAGE_ORDERS, HANDLE_PAYMENTS. */
  transactions: Array<TransactionItem>;
  /**
   * Translated discount name.
   * @deprecated Use the `discounts` field instead.
   */
  translatedDiscountName?: Maybe<Scalars['String']['output']>;
  /**
   * Undiscounted total price of shipping.
   *
   * Added in Saleor 3.19.
   */
  undiscountedShippingPrice: Money;
  /** Undiscounted total amount of the order. */
  undiscountedTotal: TaxedMoney;
  /** Date and time when the order was created. */
  updatedAt: Scalars['DateTime']['output'];
  /** User who placed the order. This field is set only for orders placed by authenticated users. Can be fetched for orders created in Saleor 3.2 and later, for other orders requires one of the following permissions: MANAGE_USERS, MANAGE_ORDERS, HANDLE_PAYMENTS, OWNER. */
  user?: Maybe<User>;
  /** Email address of the customer. The full data can be access for orders created in Saleor 3.2 and later, for other orders requires one of the following permissions: MANAGE_ORDERS, OWNER. */
  userEmail?: Maybe<Scalars['String']['output']>;
  /** Voucher linked to the order. */
  voucher?: Maybe<Voucher>;
  /**
   * Voucher code that was used for Order.
   *
   * Added in Saleor 3.18.
   */
  voucherCode?: Maybe<Scalars['String']['output']>;
  /** Weight of the order. */
  weight: Weight;
};


/** Represents an order in the shop. */
export type OrderMetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Represents an order in the shop. */
export type OrderMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Represents an order in the shop. */
export type OrderPrivateMetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Represents an order in the shop. */
export type OrderPrivateMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OrderAction =
  /** Represents the capture action. */
  | 'CAPTURE'
  /** Represents a mark-as-paid action. */
  | 'MARK_AS_PAID'
  /** Represents a refund action. */
  | 'REFUND'
  /** Represents a void action. */
  | 'VOID';

/**
 * Adds note to the order.
 *
 * Requires one of the following permissions: MANAGE_ORDERS.
 */
export type OrderAddNote = {
  __typename?: 'OrderAddNote';
  errors: Array<OrderError>;
  /** Order note created. */
  event?: Maybe<OrderEvent>;
  /** Order with the note added. */
  order?: Maybe<Order>;
  /** @deprecated Use `errors` field instead. */
  orderErrors: Array<OrderError>;
};

export type OrderAddNoteInput = {
  /** Note message. */
  message: Scalars['String']['input'];
};

/**
 * Determine a current authorize status for order.
 *
 *     We treat the order as fully authorized when the sum of authorized and charged funds
 *     cover the `order.total`-`order.totalGrantedRefund`.
 *     We treat the order as partially authorized when the sum of authorized and charged
 *     funds covers only part of the `order.total`-`order.totalGrantedRefund`.
 *     We treat the order as not authorized when the sum of authorized and charged funds is
 *     0.
 *
 *     NONE - the funds are not authorized
 *     PARTIAL - the funds that are authorized and charged don't cover fully the
 *     `order.total`-`order.totalGrantedRefund`
 *     FULL - the funds that are authorized and charged fully cover the
 *     `order.total`-`order.totalGrantedRefund`
 *
 */
export type OrderAuthorizeStatusEnum =
  | 'FULL'
  | 'NONE'
  | 'PARTIAL';

/** Filter by authorize status. */
export type OrderAuthorizeStatusEnumFilterInput = {
  /** The value equal to. */
  eq?: InputMaybe<OrderAuthorizeStatusEnum>;
  /** The value included in. */
  oneOf?: InputMaybe<Array<OrderAuthorizeStatusEnum>>;
};

/**
 * Cancels orders.
 *
 * Requires one of the following permissions: MANAGE_ORDERS.
 */
export type OrderBulkCancel = {
  __typename?: 'OrderBulkCancel';
  /** Returns how many objects were affected. */
  count: Scalars['Int']['output'];
  errors: Array<OrderError>;
  /** @deprecated Use `errors` field instead. */
  orderErrors: Array<OrderError>;
};

/**
 * Creates multiple orders.
 *
 * Requires one of the following permissions: MANAGE_ORDERS_IMPORT.
 */
export type OrderBulkCreate = {
  __typename?: 'OrderBulkCreate';
  /** Returns how many objects were created. */
  count: Scalars['Int']['output'];
  errors: Array<OrderBulkCreateError>;
  /** List of the created orders. */
  results: Array<OrderBulkCreateResult>;
};

export type OrderBulkCreateDeliveryMethodInput = {
  /** The ID of the shipping method. */
  shippingMethodId?: InputMaybe<Scalars['ID']['input']>;
  /** The name of the shipping method. */
  shippingMethodName?: InputMaybe<Scalars['String']['input']>;
  /** The price of the shipping. */
  shippingPrice?: InputMaybe<TaxedMoneyInput>;
  /** The ID of the tax class. */
  shippingTaxClassId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * Metadata of the tax class. Can be read by any API client authorized to read the object it's attached to.
   *
   * Warning: never store sensitive information, including financial data such as credit card details.
   */
  shippingTaxClassMetadata?: InputMaybe<Array<MetadataInput>>;
  /** The name of the tax class. */
  shippingTaxClassName?: InputMaybe<Scalars['String']['input']>;
  /**
   * Private metadata of the tax class. Requires permissions to modify and to read the metadata of the object it's attached to.
   *
   * Warning: never store sensitive information, including financial data such as credit card details.
   */
  shippingTaxClassPrivateMetadata?: InputMaybe<Array<MetadataInput>>;
  /** Tax rate of the shipping. */
  shippingTaxRate?: InputMaybe<Scalars['PositiveDecimal']['input']>;
  /** The ID of the warehouse. */
  warehouseId?: InputMaybe<Scalars['ID']['input']>;
  /** The name of the warehouse. */
  warehouseName?: InputMaybe<Scalars['String']['input']>;
};

export type OrderBulkCreateError = {
  __typename?: 'OrderBulkCreateError';
  /** The error code. */
  code?: Maybe<OrderBulkCreateErrorCode>;
  /** The error message. */
  message?: Maybe<Scalars['String']['output']>;
  /** Path to field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  path?: Maybe<Scalars['String']['output']>;
};

export type OrderBulkCreateErrorCode =
  | 'BULK_LIMIT'
  | 'FUTURE_DATE'
  | 'GRAPHQL_ERROR'
  | 'INCORRECT_CURRENCY'
  | 'INSUFFICIENT_STOCK'
  | 'INVALID'
  | 'INVALID_QUANTITY'
  | 'METADATA_KEY_REQUIRED'
  | 'NEGATIVE_INDEX'
  | 'NON_EXISTING_STOCK'
  | 'NOTE_LENGTH'
  | 'NOT_FOUND'
  | 'NO_RELATED_ORDER_LINE'
  | 'ORDER_LINE_FULFILLMENT_LINE_MISMATCH'
  | 'PRICE_ERROR'
  | 'REQUIRED'
  | 'TOO_MANY_IDENTIFIERS'
  | 'UNIQUE';

export type OrderBulkCreateFulfillmentInput = {
  /** List of items informing how to fulfill the order. */
  lines?: InputMaybe<Array<OrderBulkCreateFulfillmentLineInput>>;
  /** Fulfillment's tracking code. */
  trackingCode?: InputMaybe<Scalars['String']['input']>;
};

export type OrderBulkCreateFulfillmentLineInput = {
  /** 0-based index of order line, which the fulfillment line refers to. */
  orderLineIndex: Scalars['Int']['input'];
  /** The number of line items to be fulfilled from given warehouse. */
  quantity: Scalars['Int']['input'];
  /** The external ID of the product variant. */
  variantExternalReference?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the product variant. */
  variantId?: InputMaybe<Scalars['ID']['input']>;
  /** The SKU of the product variant. */
  variantSku?: InputMaybe<Scalars['String']['input']>;
  /** ID of the warehouse from which the item will be fulfilled. */
  warehouse: Scalars['ID']['input'];
};

export type OrderBulkCreateInput = {
  /** Billing address of the customer. */
  billingAddress: AddressInput;
  /** Slug of the channel associated with the order. */
  channel: Scalars['String']['input'];
  /** The date, when the order was inserted to Saleor database. */
  createdAt: Scalars['DateTime']['input'];
  /** Currency code. */
  currency: Scalars['String']['input'];
  /** Note about customer. */
  customerNote?: InputMaybe<Scalars['String']['input']>;
  /** The delivery method selected for this order. */
  deliveryMethod?: InputMaybe<OrderBulkCreateDeliveryMethodInput>;
  /** List of discounts. */
  discounts?: InputMaybe<Array<OrderDiscountCommonInput>>;
  /** Determines whether displayed prices should include taxes. */
  displayGrossPrices?: InputMaybe<Scalars['Boolean']['input']>;
  /** External ID of the order. */
  externalReference?: InputMaybe<Scalars['String']['input']>;
  /** Fulfillments of the order. */
  fulfillments?: InputMaybe<Array<OrderBulkCreateFulfillmentInput>>;
  /** List of gift card codes associated with the order. */
  giftCards?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Invoices related to the order. */
  invoices?: InputMaybe<Array<OrderBulkCreateInvoiceInput>>;
  /** Order language code. */
  languageCode: LanguageCodeEnum;
  /** List of order lines. */
  lines: Array<OrderBulkCreateOrderLineInput>;
  /**
   * Metadata of the order. Can be read by any API client authorized to read the object it's attached to.
   *
   * Warning: never store sensitive information, including financial data such as credit card details.
   */
  metadata?: InputMaybe<Array<MetadataInput>>;
  /** Notes related to the order. */
  notes?: InputMaybe<Array<OrderBulkCreateNoteInput>>;
  /**
   * Private metadata of the order. Requires permissions to modify and to read the metadata of the object it's attached to.
   *
   * Warning: never store sensitive information, including financial data such as credit card details.
   */
  privateMetadata?: InputMaybe<Array<MetadataInput>>;
  /** URL of a view, where users should be redirected to see the order details. */
  redirectUrl?: InputMaybe<Scalars['String']['input']>;
  /** Shipping address of the customer. */
  shippingAddress?: InputMaybe<AddressInput>;
  /** Status of the order. */
  status?: InputMaybe<OrderStatus>;
  /** Transactions related to the order. */
  transactions?: InputMaybe<Array<TransactionCreateInput>>;
  /** Customer associated with the order. */
  user: OrderBulkCreateUserInput;
  /**
   * Code of a voucher associated with the order.
   *
   * Added in Saleor 3.18.
   */
  voucherCode?: InputMaybe<Scalars['String']['input']>;
  /** Weight of the order in kg. */
  weight?: InputMaybe<Scalars['WeightScalar']['input']>;
};

export type OrderBulkCreateInvoiceInput = {
  /** The date, when the invoice was created. */
  createdAt: Scalars['DateTime']['input'];
  /**
   * Metadata of the invoice. Can be read by any API client authorized to read the object it's attached to.
   *
   * Warning: never store sensitive information, including financial data such as credit card details.
   */
  metadata?: InputMaybe<Array<MetadataInput>>;
  /** Invoice number. */
  number?: InputMaybe<Scalars['String']['input']>;
  /**
   * Private metadata of the invoice. Requires permissions to modify and to read the metadata of the object it's attached to.
   *
   * Warning: never store sensitive information, including financial data such as credit card details.
   */
  privateMetadata?: InputMaybe<Array<MetadataInput>>;
  /** URL of the invoice to download. */
  url?: InputMaybe<Scalars['String']['input']>;
};

export type OrderBulkCreateNoteInput = {
  /** The app ID associated with the message. */
  appId?: InputMaybe<Scalars['ID']['input']>;
  /** The date associated with the message. */
  date?: InputMaybe<Scalars['DateTime']['input']>;
  /** Note message. Max characters: 255. */
  message: Scalars['String']['input'];
  /** The user email associated with the message. */
  userEmail?: InputMaybe<Scalars['ID']['input']>;
  /** The user external ID associated with the message. */
  userExternalReference?: InputMaybe<Scalars['ID']['input']>;
  /** The user ID associated with the message. */
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type OrderBulkCreateOrderLineInput = {
  /** The date, when the order line was created. */
  createdAt: Scalars['DateTime']['input'];
  /** Gift card flag. */
  isGiftCard: Scalars['Boolean']['input'];
  /** Determines whether shipping of the order line items is required. */
  isShippingRequired: Scalars['Boolean']['input'];
  /**
   * Metadata of the order line. Can be read by any API client authorized to read the object it's attached to.
   *
   * Warning: never store sensitive information, including financial data such as credit card details.
   */
  metadata?: InputMaybe<Array<MetadataInput>>;
  /**
   * Private metadata of the order line. Requires permissions to modify and to read the metadata of the object it's attached to.
   *
   * Warning: never store sensitive information, including financial data such as credit card details.
   */
  privateMetadata?: InputMaybe<Array<MetadataInput>>;
  /** The name of the product. */
  productName?: InputMaybe<Scalars['String']['input']>;
  /**
   * The SKU of the product.
   *
   * Added in Saleor 3.18.
   */
  productSku?: InputMaybe<Scalars['String']['input']>;
  /** Number of items in the order line */
  quantity: Scalars['Int']['input'];
  /** The ID of the tax class. */
  taxClassId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * Metadata of the tax class. Can be read by any API client authorized to read the object it's attached to.
   *
   * Warning: never store sensitive information, including financial data such as credit card details.
   */
  taxClassMetadata?: InputMaybe<Array<MetadataInput>>;
  /** The name of the tax class. */
  taxClassName?: InputMaybe<Scalars['String']['input']>;
  /**
   * Private metadata of the tax class. Requires permissions to modify and to read the metadata of the object it's attached to.
   *
   * Warning: never store sensitive information, including financial data such as credit card details.
   */
  taxClassPrivateMetadata?: InputMaybe<Array<MetadataInput>>;
  /** Tax rate of the order line. */
  taxRate?: InputMaybe<Scalars['PositiveDecimal']['input']>;
  /** Price of the order line. */
  totalPrice: TaxedMoneyInput;
  /** Translation of the product name. */
  translatedProductName?: InputMaybe<Scalars['String']['input']>;
  /** Translation of the product variant name. */
  translatedVariantName?: InputMaybe<Scalars['String']['input']>;
  /** Price of the order line excluding applied discount. */
  undiscountedTotalPrice: TaxedMoneyInput;
  /**
   * Reason of the discount on order line.
   *
   * Added in Saleor 3.19.
   */
  unitDiscountReason?: InputMaybe<Scalars['String']['input']>;
  /**
   * Type of the discount: fixed or percent
   *
   * Added in Saleor 3.19.
   */
  unitDiscountType?: InputMaybe<DiscountValueTypeEnum>;
  /**
   * Value of the discount. Can store fixed value or percent value
   *
   * Added in Saleor 3.19.
   */
  unitDiscountValue?: InputMaybe<Scalars['PositiveDecimal']['input']>;
  /** The external ID of the product variant. */
  variantExternalReference?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the product variant. */
  variantId?: InputMaybe<Scalars['ID']['input']>;
  /** The name of the product variant. */
  variantName?: InputMaybe<Scalars['String']['input']>;
  /** The SKU of the product variant. */
  variantSku?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the warehouse, where the line will be allocated. */
  warehouse: Scalars['ID']['input'];
};

export type OrderBulkCreateResult = {
  __typename?: 'OrderBulkCreateResult';
  /** List of errors occurred on create attempt. */
  errors?: Maybe<Array<OrderBulkCreateError>>;
  /** Order data. */
  order?: Maybe<Order>;
};

export type OrderBulkCreateUserInput = {
  /** Customer email associated with the order. */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Customer external ID associated with the order. */
  externalReference?: InputMaybe<Scalars['String']['input']>;
  /** Customer ID associated with the order. */
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Event sent when orders are imported. */
export type OrderBulkCreated = Event & {
  __typename?: 'OrderBulkCreated';
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<IssuingPrincipal>;
  /** The orders the event relates to. */
  orders?: Maybe<Array<Order>>;
  /** The application receiving the webhook. */
  recipient?: Maybe<App>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

/**
 * Cancel an order.
 *
 * Requires one of the following permissions: MANAGE_ORDERS.
 */
export type OrderCancel = {
  __typename?: 'OrderCancel';
  errors: Array<OrderError>;
  /** Canceled order. */
  order?: Maybe<Order>;
  /** @deprecated Use `errors` field instead. */
  orderErrors: Array<OrderError>;
};

/** Event sent when order is canceled. */
export type OrderCancelled = Event & {
  __typename?: 'OrderCancelled';
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<IssuingPrincipal>;
  /** The order the event relates to. */
  order?: Maybe<Order>;
  /** The application receiving the webhook. */
  recipient?: Maybe<App>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

/**
 * Capture an order.
 *
 * Requires one of the following permissions: MANAGE_ORDERS.
 */
export type OrderCapture = {
  __typename?: 'OrderCapture';
  errors: Array<OrderError>;
  /** Captured order. */
  order?: Maybe<Order>;
  /** @deprecated Use `errors` field instead. */
  orderErrors: Array<OrderError>;
};

/**
 * Determine the current charge status for the order.
 *
 *     An order is considered overcharged when the sum of the
 *     transactionItem's charge amounts exceeds the value of
 *     `order.total` - `order.totalGrantedRefund`.
 *     If the sum of the transactionItem's charge amounts equals
 *     `order.total` - `order.totalGrantedRefund`, we consider the order to be fully
 *     charged.
 *     If the sum of the transactionItem's charge amounts covers a part of the
 *     `order.total` - `order.totalGrantedRefund`, we treat the order as partially charged.
 *
 *     NONE - the funds are not charged.
 *     PARTIAL - the funds that are charged don't cover the
 *     `order.total`-`order.totalGrantedRefund`
 *     FULL - the funds that are charged fully cover the
 *     `order.total`-`order.totalGrantedRefund`
 *     OVERCHARGED - the charged funds are bigger than the
 *     `order.total`-`order.totalGrantedRefund`
 *
 */
export type OrderChargeStatusEnum =
  | 'FULL'
  | 'NONE'
  | 'OVERCHARGED'
  | 'PARTIAL';

/** Filter by charge status. */
export type OrderChargeStatusEnumFilterInput = {
  /** The value equal to. */
  eq?: InputMaybe<OrderChargeStatusEnum>;
  /** The value included in. */
  oneOf?: InputMaybe<Array<OrderChargeStatusEnum>>;
};

/**
 * Confirms an unconfirmed order by changing status to unfulfilled.
 *
 * Requires one of the following permissions: MANAGE_ORDERS.
 */
export type OrderConfirm = {
  __typename?: 'OrderConfirm';
  errors: Array<OrderError>;
  /** Order which has been confirmed. */
  order?: Maybe<Order>;
  /** @deprecated Use `errors` field instead. */
  orderErrors: Array<OrderError>;
};

/** Event sent when order is confirmed. */
export type OrderConfirmed = Event & {
  __typename?: 'OrderConfirmed';
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<IssuingPrincipal>;
  /** The order the event relates to. */
  order?: Maybe<Order>;
  /** The application receiving the webhook. */
  recipient?: Maybe<App>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

export type OrderCountableConnection = {
  __typename?: 'OrderCountableConnection';
  edges: Array<OrderCountableEdge>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** A total count of items in the collection. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type OrderCountableEdge = {
  __typename?: 'OrderCountableEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Order;
};

/**
 * Create new order from existing checkout. Requires the following permissions: AUTHENTICATED_APP and HANDLE_CHECKOUTS.
 *
 * Triggers the following webhook events:
 * - SHIPPING_LIST_METHODS_FOR_CHECKOUT (sync): Optionally triggered when cached external shipping methods are invalid.
 * - CHECKOUT_FILTER_SHIPPING_METHODS (sync): Optionally triggered when cached filtered shipping methods are invalid.
 * - CHECKOUT_CALCULATE_TAXES (sync): Optionally triggered when checkout prices are expired.
 * - ORDER_CREATED (async): Triggered when order is created.
 * - NOTIFY_USER (async): A notification for order placement.
 * - NOTIFY_USER (async): A staff notification for order placement.
 * - ORDER_UPDATED (async): Triggered when order received the update after placement.
 * - ORDER_PAID (async): Triggered when newly created order is paid.
 * - ORDER_FULLY_PAID (async): Triggered when newly created order is fully paid.
 * - ORDER_CONFIRMED (async): Optionally triggered when newly created order are automatically marked as confirmed.
 */
export type OrderCreateFromCheckout = {
  __typename?: 'OrderCreateFromCheckout';
  errors: Array<OrderCreateFromCheckoutError>;
  /** Placed order. */
  order?: Maybe<Order>;
};

export type OrderCreateFromCheckoutError = {
  __typename?: 'OrderCreateFromCheckoutError';
  /** The error code. */
  code: OrderCreateFromCheckoutErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field?: Maybe<Scalars['String']['output']>;
  /** List of line Ids which cause the error. */
  lines?: Maybe<Array<Scalars['ID']['output']>>;
  /** The error message. */
  message?: Maybe<Scalars['String']['output']>;
  /** List of variant IDs which causes the error. */
  variants?: Maybe<Array<Scalars['ID']['output']>>;
};

export type OrderCreateFromCheckoutErrorCode =
  | 'BILLING_ADDRESS_NOT_SET'
  | 'CHANNEL_INACTIVE'
  | 'CHECKOUT_NOT_FOUND'
  | 'EMAIL_NOT_SET'
  | 'GIFT_CARD_NOT_APPLICABLE'
  | 'GRAPHQL_ERROR'
  | 'INSUFFICIENT_STOCK'
  | 'INVALID_SHIPPING_METHOD'
  | 'NO_LINES'
  | 'SHIPPING_ADDRESS_NOT_SET'
  | 'SHIPPING_METHOD_NOT_SET'
  | 'TAX_ERROR'
  | 'UNAVAILABLE_VARIANT_IN_CHANNEL'
  | 'VOUCHER_NOT_APPLICABLE';

/** Event sent when new order is created. */
export type OrderCreated = Event & {
  __typename?: 'OrderCreated';
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<IssuingPrincipal>;
  /** The order the event relates to. */
  order?: Maybe<Order>;
  /** The application receiving the webhook. */
  recipient?: Maybe<App>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

export type OrderDirection =
  /** Specifies an ascending sort order. */
  | 'ASC'
  /** Specifies a descending sort order. */
  | 'DESC';

/** Contains all details related to the applied discount to the order. */
export type OrderDiscount = Node & {
  __typename?: 'OrderDiscount';
  /**
   * Returns amount of discount.
   * @deprecated Use `total` instead.
   */
  amount: Money;
  /** The ID of discount applied. */
  id: Scalars['ID']['output'];
  /** The name of applied discount. */
  name?: Maybe<Scalars['String']['output']>;
  /**
   * Explanation for the applied discount.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   */
  reason?: Maybe<Scalars['String']['output']>;
  /**
   * The amount of discount applied to the order.
   *
   * Added in Saleor 3.21.
   */
  total: Money;
  /** Translated name of the applied discount. */
  translatedName?: Maybe<Scalars['String']['output']>;
  /** The type of applied discount: Sale, Voucher or Manual. */
  type: OrderDiscountType;
  /** Value of the discount. Can store fixed value or percent value */
  value: Scalars['PositiveDecimal']['output'];
  /** Type of the discount: fixed or percent */
  valueType: DiscountValueTypeEnum;
};

/**
 * Adds discount to the order.
 *
 * Requires one of the following permissions: MANAGE_ORDERS.
 */
export type OrderDiscountAdd = {
  __typename?: 'OrderDiscountAdd';
  errors: Array<OrderError>;
  /** Order which has been discounted. */
  order?: Maybe<Order>;
  /** @deprecated Use `errors` field instead. */
  orderErrors: Array<OrderError>;
};

export type OrderDiscountCommonInput = {
  /** Explanation for the applied discount. */
  reason?: InputMaybe<Scalars['String']['input']>;
  /** Value of the discount. Can store fixed value or percent value */
  value: Scalars['PositiveDecimal']['input'];
  /** Type of the discount: fixed or percent */
  valueType: DiscountValueTypeEnum;
};

/**
 * Remove discount from the order.
 *
 * Requires one of the following permissions: MANAGE_ORDERS.
 */
export type OrderDiscountDelete = {
  __typename?: 'OrderDiscountDelete';
  errors: Array<OrderError>;
  /** Order which has removed discount. */
  order?: Maybe<Order>;
  /** @deprecated Use `errors` field instead. */
  orderErrors: Array<OrderError>;
};

export type OrderDiscountType =
  | 'MANUAL'
  | 'ORDER_PROMOTION'
  | 'PROMOTION'
  | 'SALE'
  | 'VOUCHER';

/**
 * Update discount for the order.
 *
 * Requires one of the following permissions: MANAGE_ORDERS.
 */
export type OrderDiscountUpdate = {
  __typename?: 'OrderDiscountUpdate';
  errors: Array<OrderError>;
  /** Order which has been discounted. */
  order?: Maybe<Order>;
  /** @deprecated Use `errors` field instead. */
  orderErrors: Array<OrderError>;
};

export type OrderDraftFilterInput = {
  channels?: InputMaybe<Array<Scalars['ID']['input']>>;
  created?: InputMaybe<DateRangeInput>;
  customer?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Array<MetadataFilter>>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type OrderError = {
  __typename?: 'OrderError';
  /** A type of address that causes the error. */
  addressType?: Maybe<AddressTypeEnum>;
  /** The error code. */
  code: OrderErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field?: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message?: Maybe<Scalars['String']['output']>;
  /** List of order line IDs that cause the error. */
  orderLines?: Maybe<Array<Scalars['ID']['output']>>;
  /** List of product variants that are associated with the error */
  variants?: Maybe<Array<Scalars['ID']['output']>>;
  /** Warehouse ID which causes the error. */
  warehouse?: Maybe<Scalars['ID']['output']>;
};

export type OrderErrorCode =
  | 'BILLING_ADDRESS_NOT_SET'
  | 'CANNOT_CANCEL_FULFILLMENT'
  | 'CANNOT_CANCEL_ORDER'
  | 'CANNOT_DELETE'
  | 'CANNOT_DISCOUNT'
  | 'CANNOT_FULFILL_UNPAID_ORDER'
  | 'CANNOT_REFUND'
  | 'CAPTURE_INACTIVE_PAYMENT'
  | 'CHANNEL_INACTIVE'
  | 'DUPLICATED_INPUT_ITEM'
  | 'FULFILL_ORDER_LINE'
  | 'GIFT_CARD_LINE'
  | 'GRAPHQL_ERROR'
  | 'INSUFFICIENT_STOCK'
  | 'INVALID'
  | 'INVALID_QUANTITY'
  | 'INVALID_VOUCHER'
  | 'INVALID_VOUCHER_CODE'
  | 'MISSING_ADDRESS_DATA'
  | 'NON_EDITABLE_GIFT_LINE'
  | 'NON_REMOVABLE_GIFT_LINE'
  | 'NOT_AVAILABLE_IN_CHANNEL'
  | 'NOT_EDITABLE'
  | 'NOT_FOUND'
  | 'ORDER_NO_SHIPPING_ADDRESS'
  | 'PAYMENT_ERROR'
  | 'PAYMENT_MISSING'
  | 'PRODUCT_NOT_PUBLISHED'
  | 'PRODUCT_UNAVAILABLE_FOR_PURCHASE'
  | 'REQUIRED'
  | 'SHIPPING_METHOD_NOT_APPLICABLE'
  | 'SHIPPING_METHOD_REQUIRED'
  | 'TAX_ERROR'
  | 'TRANSACTION_ERROR'
  | 'UNIQUE'
  | 'VOID_INACTIVE_PAYMENT'
  | 'ZERO_QUANTITY';

/** History log of the order. */
export type OrderEvent = Node & {
  __typename?: 'OrderEvent';
  /** Amount of money. */
  amount?: Maybe<Scalars['Float']['output']>;
  /** App that performed the action. Requires of of the following permissions: MANAGE_APPS, MANAGE_ORDERS, OWNER. */
  app?: Maybe<App>;
  /** Composed ID of the Fulfillment. */
  composedId?: Maybe<Scalars['String']['output']>;
  /** Date when event happened at in ISO 8601 format. */
  date?: Maybe<Scalars['DateTime']['output']>;
  /** The discount applied to the order. */
  discount?: Maybe<OrderEventDiscountObject>;
  /** Email of the customer. */
  email?: Maybe<Scalars['String']['output']>;
  /** Type of an email sent to the customer. */
  emailType?: Maybe<OrderEventsEmailsEnum>;
  /** The lines fulfilled. */
  fulfilledItems?: Maybe<Array<FulfillmentLine>>;
  /** ID of the event associated with an order. */
  id: Scalars['ID']['output'];
  /** Number of an invoice related to the order. */
  invoiceNumber?: Maybe<Scalars['String']['output']>;
  /** The concerned lines. */
  lines?: Maybe<Array<OrderEventOrderLineObject>>;
  /** Content of the event. */
  message?: Maybe<Scalars['String']['output']>;
  /** User-friendly number of an order. */
  orderNumber?: Maybe<Scalars['String']['output']>;
  /** List of oversold lines names. */
  oversoldItems?: Maybe<Array<Scalars['String']['output']>>;
  /** The payment gateway of the payment. */
  paymentGateway?: Maybe<Scalars['String']['output']>;
  /** The payment reference from the payment provider. */
  paymentId?: Maybe<Scalars['String']['output']>;
  /** Number of items. */
  quantity?: Maybe<Scalars['Int']['output']>;
  /** The reference of payment's transaction. */
  reference?: Maybe<Scalars['String']['output']>;
  /** The order event which is related to this event. */
  related?: Maybe<OrderEvent>;
  /** The order which is related to this order. */
  relatedOrder?: Maybe<Order>;
  /** Define if shipping costs were included to the refund. */
  shippingCostsIncluded?: Maybe<Scalars['Boolean']['output']>;
  /** The transaction reference of captured payment. */
  transactionReference?: Maybe<Scalars['String']['output']>;
  /** Order event type. */
  type?: Maybe<OrderEventsEnum>;
  /** User who performed the action. */
  user?: Maybe<User>;
  /** The warehouse were items were restocked. */
  warehouse?: Maybe<Warehouse>;
};

export type OrderEventCountableConnection = {
  __typename?: 'OrderEventCountableConnection';
  edges: Array<OrderEventCountableEdge>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** A total count of items in the collection. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type OrderEventCountableEdge = {
  __typename?: 'OrderEventCountableEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: OrderEvent;
};

export type OrderEventDiscountObject = {
  __typename?: 'OrderEventDiscountObject';
  /** Returns amount of discount. */
  amount?: Maybe<Money>;
  /** Returns amount of discount. */
  oldAmount?: Maybe<Money>;
  /** Value of the discount. Can store fixed value or percent value. */
  oldValue?: Maybe<Scalars['PositiveDecimal']['output']>;
  /** Type of the discount: fixed or percent. */
  oldValueType?: Maybe<DiscountValueTypeEnum>;
  /** Explanation for the applied discount. */
  reason?: Maybe<Scalars['String']['output']>;
  /** Value of the discount. Can store fixed value or percent value. */
  value: Scalars['PositiveDecimal']['output'];
  /** Type of the discount: fixed or percent. */
  valueType: DiscountValueTypeEnum;
};

/** Filter input for order events data. */
export type OrderEventFilterInput = {
  /** Filter order events by date. */
  date?: InputMaybe<DateTimeRangeInput>;
  /** Filter order events by type. */
  type?: InputMaybe<OrderEventTypeEnumFilterInput>;
};

export type OrderEventOrderLineObject = {
  __typename?: 'OrderEventOrderLineObject';
  /** The discount applied to the order line. */
  discount?: Maybe<OrderEventDiscountObject>;
  /** The variant name. */
  itemName?: Maybe<Scalars['String']['output']>;
  /** The order line. */
  orderLine?: Maybe<OrderLine>;
  /** The variant quantity. */
  quantity?: Maybe<Scalars['Int']['output']>;
};

export type OrderEventTypeEnumFilterInput = {
  /** The value equal to. */
  eq?: InputMaybe<OrderEventsEnum>;
  /** The value included in. */
  oneOf?: InputMaybe<Array<OrderEventsEnum>>;
};

export type OrderEventsEmailsEnum =
  | 'CONFIRMED'
  | 'DIGITAL_LINKS'
  | 'FULFILLMENT_CONFIRMATION'
  | 'ORDER_CANCEL'
  | 'ORDER_CONFIRMATION'
  | 'ORDER_REFUND'
  | 'PAYMENT_CONFIRMATION'
  | 'SHIPPING_CONFIRMATION'
  | 'TRACKING_UPDATED';

/** The different order event types.  */
export type OrderEventsEnum =
  | 'ADDED_PRODUCTS'
  | 'CANCELED'
  | 'CONFIRMED'
  | 'DRAFT_CREATED'
  | 'DRAFT_CREATED_FROM_REPLACE'
  | 'EMAIL_SENT'
  | 'EXPIRED'
  | 'EXTERNAL_SERVICE_NOTIFICATION'
  | 'FULFILLMENT_AWAITS_APPROVAL'
  | 'FULFILLMENT_CANCELED'
  | 'FULFILLMENT_FULFILLED_ITEMS'
  | 'FULFILLMENT_REFUNDED'
  | 'FULFILLMENT_REPLACED'
  | 'FULFILLMENT_RESTOCKED_ITEMS'
  | 'FULFILLMENT_RETURNED'
  | 'INVOICE_GENERATED'
  | 'INVOICE_REQUESTED'
  | 'INVOICE_SENT'
  | 'INVOICE_UPDATED'
  | 'NOTE_ADDED'
  | 'NOTE_UPDATED'
  | 'ORDER_DISCOUNT_ADDED'
  | 'ORDER_DISCOUNT_AUTOMATICALLY_UPDATED'
  | 'ORDER_DISCOUNT_DELETED'
  | 'ORDER_DISCOUNT_UPDATED'
  | 'ORDER_FULLY_PAID'
  | 'ORDER_LINE_DISCOUNT_REMOVED'
  | 'ORDER_LINE_DISCOUNT_UPDATED'
  | 'ORDER_LINE_PRODUCT_DELETED'
  | 'ORDER_LINE_VARIANT_DELETED'
  | 'ORDER_MARKED_AS_PAID'
  | 'ORDER_REPLACEMENT_CREATED'
  | 'OTHER'
  | 'OVERSOLD_ITEMS'
  | 'PAYMENT_AUTHORIZED'
  | 'PAYMENT_CAPTURED'
  | 'PAYMENT_FAILED'
  | 'PAYMENT_REFUNDED'
  | 'PAYMENT_VOIDED'
  | 'PLACED'
  | 'PLACED_AUTOMATICALLY_FROM_PAID_CHECKOUT'
  | 'PLACED_FROM_DRAFT'
  | 'REMOVED_PRODUCTS'
  | 'TRACKING_UPDATED'
  | 'TRANSACTION_CANCEL_REQUESTED'
  | 'TRANSACTION_CHARGE_REQUESTED'
  | 'TRANSACTION_EVENT'
  | 'TRANSACTION_MARK_AS_PAID_FAILED'
  | 'TRANSACTION_REFUND_REQUESTED'
  | 'UPDATED_ADDRESS';

/** Event sent when order becomes expired. */
export type OrderExpired = Event & {
  __typename?: 'OrderExpired';
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<IssuingPrincipal>;
  /** The order the event relates to. */
  order?: Maybe<Order>;
  /** The application receiving the webhook. */
  recipient?: Maybe<App>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

export type OrderFilterInput = {
  authorizeStatus?: InputMaybe<Array<OrderAuthorizeStatusEnum>>;
  channels?: InputMaybe<Array<Scalars['ID']['input']>>;
  chargeStatus?: InputMaybe<Array<OrderChargeStatusEnum>>;
  checkoutIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  checkoutTokens?: InputMaybe<Array<Scalars['UUID']['input']>>;
  created?: InputMaybe<DateRangeInput>;
  customer?: InputMaybe<Scalars['String']['input']>;
  giftCardBought?: InputMaybe<Scalars['Boolean']['input']>;
  giftCardUsed?: InputMaybe<Scalars['Boolean']['input']>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  isClickAndCollect?: InputMaybe<Scalars['Boolean']['input']>;
  isPreorder?: InputMaybe<Scalars['Boolean']['input']>;
  metadata?: InputMaybe<Array<MetadataFilter>>;
  numbers?: InputMaybe<Array<Scalars['String']['input']>>;
  paymentStatus?: InputMaybe<Array<PaymentChargeStatusEnum>>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<OrderStatusFilter>>;
  updatedAt?: InputMaybe<DateTimeRangeInput>;
};

/** Filter shipping methods for order. */
export type OrderFilterShippingMethods = Event & {
  __typename?: 'OrderFilterShippingMethods';
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<IssuingPrincipal>;
  /** The order the event relates to. */
  order?: Maybe<Order>;
  /** The application receiving the webhook. */
  recipient?: Maybe<App>;
  /** Shipping methods that can be used with this checkout. */
  shippingMethods?: Maybe<Array<ShippingMethod>>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

/**
 * Creates new fulfillments for an order.
 *
 * Requires one of the following permissions: MANAGE_ORDERS.
 *
 * Triggers the following webhook events:
 * - FULFILLMENT_CREATED (async): A new fulfillment is created.
 * - ORDER_FULFILLED (async): Order is fulfilled.
 * - FULFILLMENT_TRACKING_NUMBER_UPDATED (async): Sent when fulfillment tracking number is updated.
 * - FULFILLMENT_APPROVED (async): A fulfillment is approved.
 */
export type OrderFulfill = {
  __typename?: 'OrderFulfill';
  errors: Array<OrderError>;
  /** List of created fulfillments. */
  fulfillments?: Maybe<Array<Fulfillment>>;
  /** Fulfilled order. */
  order?: Maybe<Order>;
  /** @deprecated Use `errors` field instead. */
  orderErrors: Array<OrderError>;
};

export type OrderFulfillInput = {
  /** If true, then allow proceed fulfillment when stock is exceeded. */
  allowStockToBeExceeded?: InputMaybe<Scalars['Boolean']['input']>;
  /** List of items informing how to fulfill the order. */
  lines: Array<OrderFulfillLineInput>;
  /** If true, send an email notification to the customer. */
  notifyCustomer?: InputMaybe<Scalars['Boolean']['input']>;
  /** Fulfillment tracking number. */
  trackingNumber?: InputMaybe<Scalars['String']['input']>;
};

export type OrderFulfillLineInput = {
  /** The ID of the order line. */
  orderLineId?: InputMaybe<Scalars['ID']['input']>;
  /** List of stock items to create. */
  stocks: Array<OrderFulfillStockInput>;
};

export type OrderFulfillStockInput = {
  /** The number of line items to be fulfilled from given warehouse. */
  quantity: Scalars['Int']['input'];
  /** ID of the warehouse from which the item will be fulfilled. */
  warehouse: Scalars['ID']['input'];
};

/** Event sent when order is fulfilled. */
export type OrderFulfilled = Event & {
  __typename?: 'OrderFulfilled';
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<IssuingPrincipal>;
  /** The order the event relates to. */
  order?: Maybe<Order>;
  /** The application receiving the webhook. */
  recipient?: Maybe<App>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

/** Event sent when order is fully paid. */
export type OrderFullyPaid = Event & {
  __typename?: 'OrderFullyPaid';
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<IssuingPrincipal>;
  /** The order the event relates to. */
  order?: Maybe<Order>;
  /** The application receiving the webhook. */
  recipient?: Maybe<App>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

/** The order is fully refunded. */
export type OrderFullyRefunded = Event & {
  __typename?: 'OrderFullyRefunded';
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<IssuingPrincipal>;
  /** The order the event relates to. */
  order?: Maybe<Order>;
  /** The application receiving the webhook. */
  recipient?: Maybe<App>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

/**
 * Adds granted refund to the order.
 *
 * Requires one of the following permissions: MANAGE_ORDERS.
 */
export type OrderGrantRefundCreate = {
  __typename?: 'OrderGrantRefundCreate';
  errors: Array<OrderGrantRefundCreateError>;
  /** Created granted refund. */
  grantedRefund?: Maybe<OrderGrantedRefund>;
  /** Order which has assigned new grant refund. */
  order?: Maybe<Order>;
};

export type OrderGrantRefundCreateError = {
  __typename?: 'OrderGrantRefundCreateError';
  /** The error code. */
  code: OrderGrantRefundCreateErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field?: Maybe<Scalars['String']['output']>;
  /** List of lines which cause the error. */
  lines?: Maybe<Array<OrderGrantRefundCreateLineError>>;
  /** The error message. */
  message?: Maybe<Scalars['String']['output']>;
};

export type OrderGrantRefundCreateErrorCode =
  | 'AMOUNT_GREATER_THAN_AVAILABLE'
  | 'GRAPHQL_ERROR'
  | 'INVALID'
  | 'NOT_FOUND'
  | 'REQUIRED'
  | 'SHIPPING_COSTS_ALREADY_GRANTED';

export type OrderGrantRefundCreateInput = {
  /** Amount of the granted refund. If not provided, the amount will be calculated automatically based on provided `lines` and `grantRefundForShipping`. */
  amount?: InputMaybe<Scalars['Decimal']['input']>;
  /** Determine if granted refund should include shipping costs. */
  grantRefundForShipping?: InputMaybe<Scalars['Boolean']['input']>;
  /** Lines to assign to granted refund. */
  lines?: InputMaybe<Array<OrderGrantRefundCreateLineInput>>;
  /** Reason of the granted refund. */
  reason?: InputMaybe<Scalars['String']['input']>;
  /**
   * ID of a `Page` (Model) to reference in reason.
   *
   * Added in Saleor 3.22.
   */
  reasonReference?: InputMaybe<Scalars['ID']['input']>;
  /**
   * The ID of the transaction item related to the granted refund. If `amount` provided in the input, the transaction.chargedAmount needs to be equal or greater than provided `amount`.If `amount` is not provided in the input and calculated automatically by Saleor, the `min(calculatedAmount, transaction.chargedAmount)` will be used. Field required starting from Saleor 3.21.
   *
   * Added in Saleor 3.20.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  transactionId: Scalars['ID']['input'];
};

export type OrderGrantRefundCreateLineError = {
  __typename?: 'OrderGrantRefundCreateLineError';
  /** The error code. */
  code: OrderGrantRefundCreateLineErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field?: Maybe<Scalars['String']['output']>;
  /** The ID of the line related to the error. */
  lineId: Scalars['ID']['output'];
  /** The error message. */
  message?: Maybe<Scalars['String']['output']>;
};

export type OrderGrantRefundCreateLineErrorCode =
  | 'GRAPHQL_ERROR'
  | 'NOT_FOUND'
  | 'QUANTITY_GREATER_THAN_AVAILABLE';

export type OrderGrantRefundCreateLineInput = {
  /** The ID of the order line. */
  id: Scalars['ID']['input'];
  /** The quantity of line items to be marked to refund. */
  quantity: Scalars['Int']['input'];
  /** Reason of the granted refund for the line. */
  reason?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Updates granted refund.
 *
 * Requires one of the following permissions: MANAGE_ORDERS.
 */
export type OrderGrantRefundUpdate = {
  __typename?: 'OrderGrantRefundUpdate';
  errors: Array<OrderGrantRefundUpdateError>;
  /** Created granted refund. */
  grantedRefund?: Maybe<OrderGrantedRefund>;
  /** Order which has assigned updated grant refund. */
  order?: Maybe<Order>;
};

export type OrderGrantRefundUpdateError = {
  __typename?: 'OrderGrantRefundUpdateError';
  /** List of lines to add which cause the error. */
  addLines?: Maybe<Array<OrderGrantRefundUpdateLineError>>;
  /** The error code. */
  code: OrderGrantRefundUpdateErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field?: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message?: Maybe<Scalars['String']['output']>;
  /** List of lines to remove which cause the error. */
  removeLines?: Maybe<Array<OrderGrantRefundUpdateLineError>>;
};

export type OrderGrantRefundUpdateErrorCode =
  | 'AMOUNT_GREATER_THAN_AVAILABLE'
  | 'GRAPHQL_ERROR'
  | 'INVALID'
  | 'NOT_FOUND'
  | 'REQUIRED'
  | 'SHIPPING_COSTS_ALREADY_GRANTED';

export type OrderGrantRefundUpdateInput = {
  /** Lines to assign to granted refund. */
  addLines?: InputMaybe<Array<OrderGrantRefundUpdateLineAddInput>>;
  /** Amount of the granted refund. if not provided and `addLines` or `removeLines` or `grantRefundForShipping` is provided, amount will be calculated automatically. */
  amount?: InputMaybe<Scalars['Decimal']['input']>;
  /** Determine if granted refund should include shipping costs. */
  grantRefundForShipping?: InputMaybe<Scalars['Boolean']['input']>;
  /** Reason of the granted refund. */
  reason?: InputMaybe<Scalars['String']['input']>;
  /**
   * ID of a `Page` (Model) to reference in reason.
   *
   * Added in Saleor 3.22.
   */
  reasonReference?: InputMaybe<Scalars['ID']['input']>;
  /** Lines to remove from granted refund. */
  removeLines?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**
   * The ID of the transaction item related to the granted refund. If `amount` provided in the input, the transaction.chargedAmount needs to be equal or greater than provided `amount`.If `amount` is not provided in the input and calculated automatically by Saleor, the `min(calculatedAmount, transaction.chargedAmount)` will be used.Field will be required starting from Saleor 3.21.
   *
   * Added in Saleor 3.20.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  transactionId?: InputMaybe<Scalars['ID']['input']>;
};

export type OrderGrantRefundUpdateLineAddInput = {
  /** The ID of the order line. */
  id: Scalars['ID']['input'];
  /** The quantity of line items to be marked to refund. */
  quantity: Scalars['Int']['input'];
  /** Reason of the granted refund for the line. */
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type OrderGrantRefundUpdateLineError = {
  __typename?: 'OrderGrantRefundUpdateLineError';
  /** The error code. */
  code: OrderGrantRefundUpdateLineErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field?: Maybe<Scalars['String']['output']>;
  /** The ID of the line related to the error. */
  lineId: Scalars['ID']['output'];
  /** The error message. */
  message?: Maybe<Scalars['String']['output']>;
};

export type OrderGrantRefundUpdateLineErrorCode =
  | 'GRAPHQL_ERROR'
  | 'NOT_FOUND'
  | 'QUANTITY_GREATER_THAN_AVAILABLE';

/** The details of granted refund. */
export type OrderGrantedRefund = {
  __typename?: 'OrderGrantedRefund';
  /** Refund amount. */
  amount: Money;
  /** App that performed the action. */
  app?: Maybe<App>;
  /** Time of creation. */
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  /** Lines assigned to the granted refund. */
  lines?: Maybe<Array<OrderGrantedRefundLine>>;
  /**
   * Reason of the refund.
   *
   * Added in Saleor 3.22.
   */
  reason?: Maybe<Scalars['String']['output']>;
  /**
   * Reason Model (Page) reference for refund.
   *
   * Added in Saleor 3.22.
   */
  reasonReference?: Maybe<Page>;
  /** If true, the refunded amount includes the shipping price.If false, the refunded amount does not include the shipping price. */
  shippingCostsIncluded: Scalars['Boolean']['output'];
  /**
   * Status of the granted refund calculated based on transactionItem assigned to granted refund.
   *
   * Added in Saleor 3.20.
   */
  status: OrderGrantedRefundStatusEnum;
  /**
   * The transaction assigned to the granted refund.
   *
   * Added in Saleor 3.20.
   */
  transaction?: Maybe<TransactionItem>;
  /**
   * List of refund events associated with the granted refund.
   *
   * Added in Saleor 3.20.
   */
  transactionEvents?: Maybe<Array<TransactionEvent>>;
  /** Time of last update. */
  updatedAt: Scalars['DateTime']['output'];
  /** User who performed the action. Requires of of the following permissions: MANAGE_USERS, MANAGE_STAFF, OWNER. */
  user?: Maybe<User>;
};

/** Represents granted refund line. */
export type OrderGrantedRefundLine = {
  __typename?: 'OrderGrantedRefundLine';
  id: Scalars['ID']['output'];
  /** Line of the order associated with this granted refund. */
  orderLine: OrderLine;
  /** Number of items to refund. */
  quantity: Scalars['Int']['output'];
  /** Reason for refunding the line. */
  reason?: Maybe<Scalars['String']['output']>;
};

/**
 * Represents the status of a granted refund.
 *
 *     NONE - the refund on related transactionItem is not processed
 *     PENDING - the refund on related transactionItem is pending
 *     FULL - the refund on related transactionItem is fully processed
 *     FAIL - the refund on related transactionItem failed
 *
 */
export type OrderGrantedRefundStatusEnum =
  | 'FAILURE'
  | 'NONE'
  | 'PENDING'
  | 'SUCCESS';

/** Represents order line of particular order. */
export type OrderLine = Node & ObjectWithMetadata & {
  __typename?: 'OrderLine';
  /**
   * List of allocations across warehouses.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS, MANAGE_ORDERS.
   */
  allocations?: Maybe<Array<Allocation>>;
  digitalContentUrl?: Maybe<DigitalContentUrl>;
  /**
   * List of applied discounts
   *
   * Added in Saleor 3.21.
   */
  discounts?: Maybe<Array<OrderLineDiscount>>;
  /** ID of the order line. */
  id: Scalars['ID']['output'];
  /**
   * Determine if the line is a gift.
   *
   * Added in Saleor 3.19.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  isGift?: Maybe<Scalars['Boolean']['output']>;
  /** Returns True, if the line unit price was overridden. */
  isPriceOverridden?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the product variant requires shipping. */
  isShippingRequired: Scalars['Boolean']['output'];
  /** List of public metadata items. Can be accessed without permissions. */
  metadata: Array<MetadataItem>;
  /**
   * A single key from public metadata.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   */
  metafield?: Maybe<Scalars['String']['output']>;
  /** Public metadata. Use `keys` to control which fields you want to include. The default is to include everything. */
  metafields?: Maybe<Scalars['Metadata']['output']>;
  /** List of private metadata items. Requires staff permissions to access. */
  privateMetadata: Array<MetadataItem>;
  /**
   * A single key from private metadata. Requires staff permissions to access.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   */
  privateMetafield?: Maybe<Scalars['String']['output']>;
  /** Private metadata. Requires staff permissions to access. Use `keys` to control which fields you want to include. The default is to include everything. */
  privateMetafields?: Maybe<Scalars['Metadata']['output']>;
  /** Name of the product in order line. */
  productName: Scalars['String']['output'];
  /** SKU of the product variant. */
  productSku?: Maybe<Scalars['String']['output']>;
  /** The ID of the product variant. */
  productVariantId?: Maybe<Scalars['String']['output']>;
  /** Number of variant items ordered. */
  quantity: Scalars['Int']['output'];
  /** Number of variant items fulfilled. */
  quantityFulfilled: Scalars['Int']['output'];
  /** A quantity of items remaining to be fulfilled. */
  quantityToFulfill: Scalars['Int']['output'];
  /** Denormalized sale ID, set when order line is created for a product variant that is on sale. */
  saleId?: Maybe<Scalars['ID']['output']>;
  /**
   * Denormalized tax class of the product in this order line.
   *
   * Requires one of the following permissions: AUTHENTICATED_STAFF_USER, AUTHENTICATED_APP.
   */
  taxClass?: Maybe<TaxClass>;
  /** Denormalized public metadata of the tax class. */
  taxClassMetadata: Array<MetadataItem>;
  /** Denormalized name of the tax class. */
  taxClassName?: Maybe<Scalars['String']['output']>;
  /** Denormalized private metadata of the tax class. Requires staff permissions to access. */
  taxClassPrivateMetadata: Array<MetadataItem>;
  /** Rate of tax applied on product variant. */
  taxRate: Scalars['Float']['output'];
  thumbnail?: Maybe<Image>;
  /** Price of the order line. */
  totalPrice: TaxedMoney;
  /** Product name in the customer's language */
  translatedProductName: Scalars['String']['output'];
  /** Variant name in the customer's language */
  translatedVariantName: Scalars['String']['output'];
  /** Price of the order line without discounts. */
  undiscountedTotalPrice: TaxedMoney;
  /** Price of the single item in the order line without any discount applied. */
  undiscountedUnitPrice: TaxedMoney;
  /** Sum of the line-level discounts applied to the order line. Order-level discounts which affect the line are not visible in this field. For order-level discount portion (if any), please query `order.discounts` field. */
  unitDiscount: Money;
  /** Reason for line-level discounts applied on the order line. Order-level discounts which affect the line are not visible in this field. For order-level discount reason (if any), please query `order.discounts` field. */
  unitDiscountReason?: Maybe<Scalars['String']['output']>;
  /** Type of the discount: `fixed` or `percent`. This field shouldn't be used when multiple discounts affect the line. There is a limitation, that after running `checkoutComplete` mutation the field is always set to `fixed`. */
  unitDiscountType?: Maybe<DiscountValueTypeEnum>;
  /** Value of the discount. Can store fixed value or percent value. This field shouldn't be used when multiple discounts affect the line. There is a limitation, that after running `checkoutComplete` mutation the field always stores fixed value. */
  unitDiscountValue: Scalars['PositiveDecimal']['output'];
  /** Price of the single item in the order line with all the line-level discounts and order-level discount portions applied. */
  unitPrice: TaxedMoney;
  /** A purchased product variant. Note: this field may be null if the variant has been removed from stock at all. Requires one of the following permissions to include the unpublished items: MANAGE_ORDERS, MANAGE_DISCOUNTS, MANAGE_PRODUCTS. */
  variant?: Maybe<ProductVariant>;
  /** Name of the variant of product in order line. */
  variantName: Scalars['String']['output'];
  /** Voucher code that was used for this order line. */
  voucherCode?: Maybe<Scalars['String']['output']>;
};


/** Represents order line of particular order. */
export type OrderLineMetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Represents order line of particular order. */
export type OrderLineMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Represents order line of particular order. */
export type OrderLinePrivateMetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Represents order line of particular order. */
export type OrderLinePrivateMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Represents order line of particular order. */
export type OrderLineThumbnailArgs = {
  format?: InputMaybe<ThumbnailFormatEnum>;
  size?: InputMaybe<Scalars['Int']['input']>;
};

export type OrderLineCreateInput = {
  /** Flag that allow force splitting the same variant into multiple lines by skipping the matching logic.  */
  forceNewLine?: InputMaybe<Scalars['Boolean']['input']>;
  /** Custom price of the item.When the line with the same variant will be provided multiple times, the last price will be used. */
  price?: InputMaybe<Scalars['PositiveDecimal']['input']>;
  /** Number of variant items ordered. */
  quantity: Scalars['Int']['input'];
  /** Product variant ID. */
  variantId: Scalars['ID']['input'];
};

/**
 * Deletes an order line from an order.
 *
 * Requires one of the following permissions: MANAGE_ORDERS.
 */
export type OrderLineDelete = {
  __typename?: 'OrderLineDelete';
  errors: Array<OrderError>;
  /** A related order. */
  order?: Maybe<Order>;
  /** @deprecated Use `errors` field instead. */
  orderErrors: Array<OrderError>;
  /** An order line that was deleted. */
  orderLine?: Maybe<OrderLine>;
};

/** Represent the discount applied to order line. */
export type OrderLineDiscount = {
  __typename?: 'OrderLineDiscount';
  /** The ID of discount applied. */
  id: Scalars['ID']['output'];
  /** The name of applied discount. */
  name?: Maybe<Scalars['String']['output']>;
  /**
   * Explanation for the applied discount.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   */
  reason?: Maybe<Scalars['String']['output']>;
  /** The discount amount applied to the line item. */
  total: Money;
  /** Translated name of the applied discount. */
  translatedName?: Maybe<Scalars['String']['output']>;
  /** The type of applied discount: Sale, Voucher or Manual. */
  type: OrderDiscountType;
  /** The discount amount applied to the single line unit. */
  unit: Money;
  /** Value of the discount. Can store fixed value or percent value */
  value: Scalars['PositiveDecimal']['output'];
  /** Type of the discount: fixed or percent */
  valueType: DiscountValueTypeEnum;
};

/**
 * Remove discount applied to the order line.
 *
 * Requires one of the following permissions: MANAGE_ORDERS.
 */
export type OrderLineDiscountRemove = {
  __typename?: 'OrderLineDiscountRemove';
  errors: Array<OrderError>;
  /** Order which is related to line which has removed discount. */
  order?: Maybe<Order>;
  /** @deprecated Use `errors` field instead. */
  orderErrors: Array<OrderError>;
  /** Order line which has removed discount. */
  orderLine?: Maybe<OrderLine>;
};

/**
 * Update discount for the order line.
 *
 * Requires one of the following permissions: MANAGE_ORDERS.
 */
export type OrderLineDiscountUpdate = {
  __typename?: 'OrderLineDiscountUpdate';
  errors: Array<OrderError>;
  /** Order which is related to the discounted line. */
  order?: Maybe<Order>;
  /** @deprecated Use `errors` field instead. */
  orderErrors: Array<OrderError>;
  /** Order line which has been discounted. */
  orderLine?: Maybe<OrderLine>;
};

export type OrderLineInput = {
  /** Number of variant items ordered. */
  quantity: Scalars['Int']['input'];
};

/**
 * Updates an order line of an order.
 *
 * Requires one of the following permissions: MANAGE_ORDERS.
 */
export type OrderLineUpdate = {
  __typename?: 'OrderLineUpdate';
  errors: Array<OrderError>;
  /** Related order. */
  order?: Maybe<Order>;
  /** @deprecated Use `errors` field instead. */
  orderErrors: Array<OrderError>;
  orderLine?: Maybe<OrderLine>;
};

/**
 * Creates order lines for an order.
 *
 * Requires one of the following permissions: MANAGE_ORDERS.
 */
export type OrderLinesCreate = {
  __typename?: 'OrderLinesCreate';
  errors: Array<OrderError>;
  /** Related order. */
  order?: Maybe<Order>;
  /** @deprecated Use `errors` field instead. */
  orderErrors: Array<OrderError>;
  /** List of added order lines. */
  orderLines?: Maybe<Array<OrderLine>>;
};

/**
 * Mark order as manually paid.
 *
 * Requires one of the following permissions: MANAGE_ORDERS.
 */
export type OrderMarkAsPaid = {
  __typename?: 'OrderMarkAsPaid';
  errors: Array<OrderError>;
  /** Order marked as paid. */
  order?: Maybe<Order>;
  /** @deprecated Use `errors` field instead. */
  orderErrors: Array<OrderError>;
};

/** Event sent when order metadata is updated. */
export type OrderMetadataUpdated = Event & {
  __typename?: 'OrderMetadataUpdated';
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<IssuingPrincipal>;
  /** The order the event relates to. */
  order?: Maybe<Order>;
  /** The application receiving the webhook. */
  recipient?: Maybe<App>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

/**
 * Adds note to the order.
 *
 * Requires one of the following permissions: MANAGE_ORDERS.
 */
export type OrderNoteAdd = {
  __typename?: 'OrderNoteAdd';
  errors: Array<OrderNoteAddError>;
  /** Order note created. */
  event?: Maybe<OrderEvent>;
  /** Order with the note added. */
  order?: Maybe<Order>;
};

export type OrderNoteAddError = {
  __typename?: 'OrderNoteAddError';
  /** The error code. */
  code?: Maybe<OrderNoteAddErrorCode>;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field?: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message?: Maybe<Scalars['String']['output']>;
};

export type OrderNoteAddErrorCode =
  | 'GRAPHQL_ERROR'
  | 'REQUIRED';

export type OrderNoteInput = {
  /** Note message. */
  message: Scalars['String']['input'];
};

/**
 * Updates note of an order.
 *
 * Requires one of the following permissions: MANAGE_ORDERS.
 */
export type OrderNoteUpdate = {
  __typename?: 'OrderNoteUpdate';
  errors: Array<OrderNoteUpdateError>;
  /** Order note updated. */
  event?: Maybe<OrderEvent>;
  /** Order with the note updated. */
  order?: Maybe<Order>;
};

export type OrderNoteUpdateError = {
  __typename?: 'OrderNoteUpdateError';
  /** The error code. */
  code?: Maybe<OrderNoteUpdateErrorCode>;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field?: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message?: Maybe<Scalars['String']['output']>;
};

export type OrderNoteUpdateErrorCode =
  | 'GRAPHQL_ERROR'
  | 'NOT_FOUND'
  | 'REQUIRED';

export type OrderOrCheckout = Checkout | Order;

export type OrderOriginEnum =
  | 'BULK_CREATE'
  | 'CHECKOUT'
  | 'DRAFT'
  | 'REISSUE';

/** Payment has been made. The order may be partially or fully paid. */
export type OrderPaid = Event & {
  __typename?: 'OrderPaid';
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<IssuingPrincipal>;
  /** The order the event relates to. */
  order?: Maybe<Order>;
  /** The application receiving the webhook. */
  recipient?: Maybe<App>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

export type OrderPredicateInput = {
  /** List of conditions that must be met. */
  AND?: InputMaybe<Array<OrderPredicateInput>>;
  /** A list of conditions of which at least one must be met. */
  OR?: InputMaybe<Array<OrderPredicateInput>>;
  /** Defines the conditions related to checkout and order objects. */
  discountedObjectPredicate?: InputMaybe<DiscountedObjectWhereInput>;
};

/**
 * Refund an order.
 *
 * Requires one of the following permissions: MANAGE_ORDERS.
 */
export type OrderRefund = {
  __typename?: 'OrderRefund';
  errors: Array<OrderError>;
  /** A refunded order. */
  order?: Maybe<Order>;
  /** @deprecated Use `errors` field instead. */
  orderErrors: Array<OrderError>;
};

export type OrderRefundFulfillmentLineInput = {
  /** The ID of the fulfillment line to refund. */
  fulfillmentLineId: Scalars['ID']['input'];
  /** The number of items to be refunded. */
  quantity: Scalars['Int']['input'];
};

export type OrderRefundLineInput = {
  /** The ID of the order line to refund. */
  orderLineId: Scalars['ID']['input'];
  /** The number of items to be refunded. */
  quantity: Scalars['Int']['input'];
};

export type OrderRefundProductsInput = {
  /** The total amount of refund when the value is provided manually. */
  amountToRefund?: InputMaybe<Scalars['PositiveDecimal']['input']>;
  /** List of fulfilled lines to refund. */
  fulfillmentLines?: InputMaybe<Array<OrderRefundFulfillmentLineInput>>;
  /** If true, Saleor will refund shipping costs. If amountToRefund is providedincludeShippingCosts will be ignored. */
  includeShippingCosts?: InputMaybe<Scalars['Boolean']['input']>;
  /** List of unfulfilled lines to refund. */
  orderLines?: InputMaybe<Array<OrderRefundLineInput>>;
};

/** The order received a refund. The order may be partially or fully refunded. */
export type OrderRefunded = Event & {
  __typename?: 'OrderRefunded';
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<IssuingPrincipal>;
  /** The order the event relates to. */
  order?: Maybe<Order>;
  /** The application receiving the webhook. */
  recipient?: Maybe<App>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

export type OrderReturnFulfillmentLineInput = {
  /** The ID of the fulfillment line to return. */
  fulfillmentLineId: Scalars['ID']['input'];
  /** The number of items to be returned. */
  quantity: Scalars['Int']['input'];
  /** Determines, if the line should be added to replace order. */
  replace?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OrderReturnLineInput = {
  /** The ID of the order line to return. */
  orderLineId: Scalars['ID']['input'];
  /** The number of items to be returned. */
  quantity: Scalars['Int']['input'];
  /** Determines, if the line should be added to replace order. */
  replace?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OrderReturnProductsInput = {
  /** The total amount of refund when the value is provided manually. */
  amountToRefund?: InputMaybe<Scalars['PositiveDecimal']['input']>;
  /** List of fulfilled lines to return. */
  fulfillmentLines?: InputMaybe<Array<OrderReturnFulfillmentLineInput>>;
  /** If true, Saleor will refund shipping costs. If amountToRefund is providedincludeShippingCosts will be ignored. */
  includeShippingCosts?: InputMaybe<Scalars['Boolean']['input']>;
  /** List of unfulfilled lines to return. */
  orderLines?: InputMaybe<Array<OrderReturnLineInput>>;
  /** If true, Saleor will call refund action for all lines. */
  refund?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Represents the channel-specific order settings. */
export type OrderSettings = {
  __typename?: 'OrderSettings';
  /** Determine if it is possible to place unpaid order by calling `checkoutComplete` mutation. */
  allowUnpaidOrders: Scalars['Boolean']['output'];
  /** When disabled, all new orders from checkout will be marked as unconfirmed. When enabled orders from checkout will become unfulfilled immediately. */
  automaticallyConfirmAllNewOrders: Scalars['Boolean']['output'];
  /** When enabled, all non-shippable gift card orders will be fulfilled automatically. */
  automaticallyFulfillNonShippableGiftCard: Scalars['Boolean']['output'];
  /** The time in days after expired orders will be deleted. */
  deleteExpiredOrdersAfter: Scalars['Day']['output'];
  /**
   * Time in hours after which the draft order line price will be refreshed.
   *
   * Added in Saleor 3.21.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  draftOrderLinePriceFreezePeriod?: Maybe<Scalars['Hour']['output']>;
  /** Expiration time in minutes. Default null - means do not expire any orders. */
  expireOrdersAfter?: Maybe<Scalars['Minute']['output']>;
  /**
   * Determine if voucher applied on draft order should be count toward voucher usage.
   *
   * Added in Saleor 3.18.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  includeDraftOrderInVoucherUsage: Scalars['Boolean']['output'];
  /**
   * Determine what strategy will be used to mark the order as paid. Based on the chosen option, the proper object will be created and attached to the order when it's manually marked as paid.
   * `PAYMENT_FLOW` - [default option] creates the `Payment` object.
   * `TRANSACTION_FLOW` - creates the `TransactionItem` object.
   */
  markAsPaidStrategy: MarkAsPaidStrategyEnum;
  /**
   * This flag only affects orders created from checkout and applies specifically to vouchers of the types: `SPECIFIC_PRODUCT` and `ENTIRE_ORDER` with `applyOncePerOrder` enabled.
   * - When legacy propagation is enabled, discounts from these vouchers are represented as `OrderDiscount` objects, attached to the order and returned in the `Order.discounts` field. Additionally, percentage-based vouchers are converted to fixed-value discounts.
   * - When legacy propagation is disabled, discounts are represented as `OrderLineDiscount` objects, attached to individual lines and returned in the `OrderLine.discounts` field. In this case, percentage-based vouchers retain their original type.
   * In future releases, `OrderLineDiscount` will become the default behavior, and this flag will be deprecated and removed.
   *
   * Added in Saleor 3.21.
   */
  useLegacyLineDiscountPropagation: Scalars['Boolean']['output'];
};

export type OrderSettingsError = {
  __typename?: 'OrderSettingsError';
  /** The error code. */
  code: OrderSettingsErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field?: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message?: Maybe<Scalars['String']['output']>;
};

export type OrderSettingsErrorCode =
  | 'INVALID';

export type OrderSettingsInput = {
  /** Determine if it is possible to place unpaid order by calling `checkoutComplete` mutation. */
  allowUnpaidOrders?: InputMaybe<Scalars['Boolean']['input']>;
  /** When disabled, all new orders from checkout will be marked as unconfirmed. When enabled orders from checkout will become unfulfilled immediately. By default set to True */
  automaticallyConfirmAllNewOrders?: InputMaybe<Scalars['Boolean']['input']>;
  /** When enabled, all non-shippable gift card orders will be fulfilled automatically. By default set to True. */
  automaticallyFulfillNonShippableGiftCard?: InputMaybe<Scalars['Boolean']['input']>;
  /** The time in days after expired orders will be deleted.Allowed range is from 1 to 120. */
  deleteExpiredOrdersAfter?: InputMaybe<Scalars['Day']['input']>;
  /**
   * Time in hours after which the draft order line price will be refreshed. Default value is 24 hours. Enter 0 or null to disable.
   *
   * Added in Saleor 3.21.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  draftOrderLinePriceFreezePeriod?: InputMaybe<Scalars['Hour']['input']>;
  /** Expiration time in minutes. Default null - means do not expire any orders. Enter 0 or null to disable. */
  expireOrdersAfter?: InputMaybe<Scalars['Minute']['input']>;
  /**
   * Specify whether a coupon applied to draft orders will count toward voucher usage.
   *
   * Warning:  when switching this setting from `false` to `true`, the vouchers will be disconnected from all draft orders.
   *
   * Added in Saleor 3.18.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  includeDraftOrderInVoucherUsage?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Determine what strategy will be used to mark the order as paid. Based on the chosen option, the proper object will be created and attached to the order when it's manually marked as paid.
   * `PAYMENT_FLOW` - [default option] creates the `Payment` object.
   * `TRANSACTION_FLOW` - creates the `TransactionItem` object.
   */
  markAsPaidStrategy?: InputMaybe<MarkAsPaidStrategyEnum>;
  /**
   * This flag only affects orders created from checkout and applies specifically to vouchers of the types: `SPECIFIC_PRODUCT` and `ENTIRE_ORDER` with `applyOncePerOrder` enabled.
   * - When legacy propagation is enabled, discounts from these vouchers are represented as `OrderDiscount` objects, attached to the order and returned in the `Order.discounts` field. Additionally, percentage-based vouchers are converted to fixed-value discounts.
   * - When legacy propagation is disabled, discounts are represented as `OrderLineDiscount` objects, attached to individual lines and returned in the `OrderLine.discounts` field. In this case, percentage-based vouchers retain their original type.
   * In future releases, `OrderLineDiscount` will become the default behavior, and this flag will be deprecated and removed.
   *
   * Added in Saleor 3.21.
   */
  useLegacyLineDiscountPropagation?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * Update shop order settings across all channels. Returns `orderSettings` for the first `channel` in alphabetical order.
 *
 * Requires one of the following permissions: MANAGE_ORDERS.
 */
export type OrderSettingsUpdate = {
  __typename?: 'OrderSettingsUpdate';
  errors: Array<OrderSettingsError>;
  /** Order settings. */
  orderSettings?: Maybe<OrderSettings>;
  /** @deprecated Use `errors` field instead. */
  orderSettingsErrors: Array<OrderSettingsError>;
};

export type OrderSettingsUpdateInput = {
  /** When disabled, all new orders from checkout will be marked as unconfirmed. When enabled orders from checkout will become unfulfilled immediately. By default set to True */
  automaticallyConfirmAllNewOrders?: InputMaybe<Scalars['Boolean']['input']>;
  /** When enabled, all non-shippable gift card orders will be fulfilled automatically. By default set to True. */
  automaticallyFulfillNonShippableGiftCard?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OrderSortField =
  /** Sort orders by creation date. */
  | 'CREATED_AT'
  /** Sort orders by creation date */
  | 'CREATION_DATE'
  /** Sort orders by customer. */
  | 'CUSTOMER'
  /** Sort orders by fulfillment status. */
  | 'FULFILLMENT_STATUS'
  /** Sort orders by last modified date. */
  | 'LAST_MODIFIED_AT'
  /** Sort orders by number. */
  | 'NUMBER'
  /** Sort orders by payment status. */
  | 'PAYMENT'
  /** Sort orders by rank. Note: This option is available only with the `search` filter. */
  | 'RANK'
  /**
   * Sort orders by order status.
   *
   * Added in Saleor 3.22.
   */
  | 'STATUS';

export type OrderSortingInput = {
  /** Specifies the direction in which to sort orders. */
  direction: OrderDirection;
  /** Sort orders by the selected field. */
  field: OrderSortField;
};

export type OrderStatus =
  | 'CANCELED'
  | 'DRAFT'
  | 'EXPIRED'
  | 'FULFILLED'
  | 'PARTIALLY_FULFILLED'
  | 'PARTIALLY_RETURNED'
  | 'RETURNED'
  | 'UNCONFIRMED'
  | 'UNFULFILLED';

/** Filter by order status. */
export type OrderStatusEnumFilterInput = {
  /** The value equal to. */
  eq?: InputMaybe<OrderStatus>;
  /** The value included in. */
  oneOf?: InputMaybe<Array<OrderStatus>>;
};

export type OrderStatusFilter =
  | 'CANCELED'
  | 'FULFILLED'
  | 'PARTIALLY_FULFILLED'
  | 'READY_TO_CAPTURE'
  | 'READY_TO_FULFILL'
  | 'UNCONFIRMED'
  | 'UNFULFILLED';

/**
 * Updates an order.
 *
 * Requires one of the following permissions: MANAGE_ORDERS.
 */
export type OrderUpdate = {
  __typename?: 'OrderUpdate';
  errors: Array<OrderError>;
  order?: Maybe<Order>;
  /** @deprecated Use `errors` field instead. */
  orderErrors: Array<OrderError>;
};

export type OrderUpdateInput = {
  /** Billing address of the customer. */
  billingAddress?: InputMaybe<AddressInput>;
  /** External ID of this order. */
  externalReference?: InputMaybe<Scalars['String']['input']>;
  /**
   * Order language code.
   *
   * Added in Saleor 3.21.
   */
  languageCode?: InputMaybe<LanguageCodeEnum>;
  /**
   * Order public metadata.
   *
   * Added in Saleor 3.21.Can be read by any API client authorized to read the object it's attached to.
   *
   * Warning: never store sensitive information, including financial data such as credit card details.
   */
  metadata?: InputMaybe<Array<MetadataInput>>;
  /**
   * Order private metadata.
   *
   * Added in Saleor 3.21.Requires permissions to modify and to read the metadata of the object it's attached to.
   *
   * Warning: never store sensitive information, including financial data such as credit card details.
   */
  privateMetadata?: InputMaybe<Array<MetadataInput>>;
  /** Shipping address of the customer. */
  shippingAddress?: InputMaybe<AddressInput>;
  /** Email address of the customer. */
  userEmail?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Updates a shipping method of the order. Requires shipping method ID to update, when null is passed then currently assigned shipping method is removed.
 *
 * Requires one of the following permissions: MANAGE_ORDERS.
 */
export type OrderUpdateShipping = {
  __typename?: 'OrderUpdateShipping';
  errors: Array<OrderError>;
  /** Order with updated shipping method. */
  order?: Maybe<Order>;
  /** @deprecated Use `errors` field instead. */
  orderErrors: Array<OrderError>;
};

export type OrderUpdateShippingInput = {
  /** ID of the selected shipping method, pass null to remove currently assigned shipping method. */
  shippingMethod?: InputMaybe<Scalars['ID']['input']>;
};

/** Event sent when order is updated. */
export type OrderUpdated = Event & {
  __typename?: 'OrderUpdated';
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<IssuingPrincipal>;
  /** The order the event relates to. */
  order?: Maybe<Order>;
  /** The application receiving the webhook. */
  recipient?: Maybe<App>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

/**
 * Void an order.
 *
 * Requires one of the following permissions: MANAGE_ORDERS.
 */
export type OrderVoid = {
  __typename?: 'OrderVoid';
  errors: Array<OrderError>;
  /** A voided order. */
  order?: Maybe<Order>;
  /** @deprecated Use `errors` field instead. */
  orderErrors: Array<OrderError>;
};

export type OrderWhereInput = {
  /** List of conditions that must be met. */
  AND?: InputMaybe<Array<OrderWhereInput>>;
  /** A list of conditions of which at least one must be met. */
  OR?: InputMaybe<Array<OrderWhereInput>>;
  /** Filter by authorize status. */
  authorizeStatus?: InputMaybe<OrderAuthorizeStatusEnumFilterInput>;
  /** Filter by billing address of the order. */
  billingAddress?: InputMaybe<AddressFilterInput>;
  /** Filter by channel. */
  channelId?: InputMaybe<GlobalIdFilterInput>;
  /** Filter by charge status. */
  chargeStatus?: InputMaybe<OrderChargeStatusEnumFilterInput>;
  /** Filter by checkout id. */
  checkoutId?: InputMaybe<GlobalIdFilterInput>;
  /** Filter by checkout token. */
  checkoutToken?: InputMaybe<UuidFilterInput>;
  /** Filter order by created at date. */
  createdAt?: InputMaybe<DateTimeRangeInput>;
  /** Filter by order events. Each list item represents conditions that must be satisfied by a single object. The filter matches orders that have related objects meeting all specified groups of conditions. */
  events?: InputMaybe<Array<OrderEventFilterInput>>;
  /** Filter by fulfillment data associated with the order. Each list item represents conditions that must be satisfied by a single object. The filter matches orders that have related objects meeting all specified groups of conditions. */
  fulfillments?: InputMaybe<Array<FulfillmentFilterInput>>;
  /** Filter by whether the order has any fulfillments. */
  hasFulfillments?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by whether the order has any invoices. */
  hasInvoices?: InputMaybe<Scalars['Boolean']['input']>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter by invoice data associated with the order. Each list item represents conditions that must be satisfied by a single object. The filter matches orders that have related objects meeting all specified groups of conditions. */
  invoices?: InputMaybe<Array<InvoiceFilterInput>>;
  /** Filter by whether the order uses the click and collect delivery method. */
  isClickAndCollect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter based on whether the order includes a gift card purchase. */
  isGiftCardBought?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter based on whether a gift card was used in the order. */
  isGiftCardUsed?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by line items associated with the order. Each list item represents conditions that must be satisfied by a single object. The filter matches orders that have related objects meeting all specified groups of conditions. */
  lines?: InputMaybe<Array<LinesFilterInput>>;
  /** Filter by number of lines in the order. */
  linesCount?: InputMaybe<IntFilterInput>;
  /** Filter by metadata fields. */
  metadata?: InputMaybe<MetadataFilterInput>;
  /** Filter by order number. */
  number?: InputMaybe<IntFilterInput>;
  /** Filter by the product type of related order lines. */
  productTypeId?: InputMaybe<GlobalIdFilterInput>;
  /** Filter by shipping address of the order. */
  shippingAddress?: InputMaybe<AddressFilterInput>;
  /** Filter by order status. */
  status?: InputMaybe<OrderStatusEnumFilterInput>;
  /** Filter by total gross amount of the order. */
  totalGross?: InputMaybe<PriceFilterInput>;
  /** Filter by total net amount of the order. */
  totalNet?: InputMaybe<PriceFilterInput>;
  /** Filter by transaction data associated with the order. Each list item represents conditions that must be satisfied by a single object. The filter matches orders that have related objects meeting all specified groups of conditions. */
  transactions?: InputMaybe<Array<TransactionFilterInput>>;
  /** Filter order by updated at date. */
  updatedAt?: InputMaybe<DateTimeRangeInput>;
  /** Filter by user. */
  user?: InputMaybe<GlobalIdFilterInput>;
  /** Filter by user email. */
  userEmail?: InputMaybe<StringFilterInput>;
  /** Filter by voucher code used in the order. */
  voucherCode?: InputMaybe<StringFilterInput>;
};

/**
 * Represents a payment method used for a transaction.
 *
 * Added in Saleor 3.22.
 */
export type OtherPaymentMethodDetails = PaymentMethodDetails & {
  __typename?: 'OtherPaymentMethodDetails';
  /** Name of the payment method. */
  name: Scalars['String']['output'];
};

export type OtherPaymentMethodDetailsInput = {
  /** Name of the payment method used for the transaction. */
  name: Scalars['String']['input'];
};

/** A static page that can be manually added by a shop operator through the dashboard. */
export type Page = Node & ObjectWithAttributes & ObjectWithMetadata & {
  __typename?: 'Page';
  /**
   * Get a single attribute attached to page by attribute slug.
   *
   * Added in Saleor 3.22.
   */
  assignedAttribute?: Maybe<AssignedAttribute>;
  /**
   * List of attributes assigned to this page.
   *
   * Added in Saleor 3.22.
   */
  assignedAttributes: Array<AssignedAttribute>;
  /**
   * Get a single attribute attached to page by attribute slug.
   * @deprecated Use `assignedAttribute` field instead.
   */
  attribute?: Maybe<SelectedAttribute>;
  /**
   * List of attributes assigned to this page.
   * @deprecated Use `assignedAttributes` field instead.
   */
  attributes: Array<SelectedAttribute>;
  /**
   * Content of the page.
   *
   * Rich text format. For reference see https://editorjs.io/
   */
  content?: Maybe<Scalars['JSONString']['output']>;
  /**
   * Content of the page.
   *
   * Rich text format. For reference see https://editorjs.io/
   * @deprecated Use the `content` field instead.
   */
  contentJson: Scalars['JSONString']['output'];
  /** Date and time at which page was created. */
  created: Scalars['DateTime']['output'];
  /** ID of the page. */
  id: Scalars['ID']['output'];
  /** Determines if the page is published. */
  isPublished: Scalars['Boolean']['output'];
  /** List of public metadata items. Can be accessed without permissions. */
  metadata: Array<MetadataItem>;
  /**
   * A single key from public metadata.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   */
  metafield?: Maybe<Scalars['String']['output']>;
  /** Public metadata. Use `keys` to control which fields you want to include. The default is to include everything. */
  metafields?: Maybe<Scalars['Metadata']['output']>;
  /** Determines the type of page */
  pageType: PageType;
  /** List of private metadata items. Requires staff permissions to access. */
  privateMetadata: Array<MetadataItem>;
  /**
   * A single key from private metadata. Requires staff permissions to access.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   */
  privateMetafield?: Maybe<Scalars['String']['output']>;
  /** Private metadata. Requires staff permissions to access. Use `keys` to control which fields you want to include. The default is to include everything. */
  privateMetafields?: Maybe<Scalars['Metadata']['output']>;
  /** @deprecated Use the `publishedAt` field to fetch the publication date. */
  publicationDate?: Maybe<Scalars['Date']['output']>;
  /** The page publication date. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Description of the page for SEO. */
  seoDescription?: Maybe<Scalars['String']['output']>;
  /** Title of the page for SEO. */
  seoTitle?: Maybe<Scalars['String']['output']>;
  /** Slug of the page. */
  slug: Scalars['String']['output'];
  /** Title of the page. */
  title: Scalars['String']['output'];
  /** Returns translated page fields for the given language code. */
  translation?: Maybe<PageTranslation>;
};


/** A static page that can be manually added by a shop operator through the dashboard. */
export type PageAssignedAttributeArgs = {
  slug: Scalars['String']['input'];
};


/** A static page that can be manually added by a shop operator through the dashboard. */
export type PageAssignedAttributesArgs = {
  limit?: InputMaybe<Scalars['PositiveInt']['input']>;
};


/** A static page that can be manually added by a shop operator through the dashboard. */
export type PageAttributeArgs = {
  slug: Scalars['String']['input'];
};


/** A static page that can be manually added by a shop operator through the dashboard. */
export type PageMetafieldArgs = {
  key: Scalars['String']['input'];
};


/** A static page that can be manually added by a shop operator through the dashboard. */
export type PageMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** A static page that can be manually added by a shop operator through the dashboard. */
export type PagePrivateMetafieldArgs = {
  key: Scalars['String']['input'];
};


/** A static page that can be manually added by a shop operator through the dashboard. */
export type PagePrivateMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** A static page that can be manually added by a shop operator through the dashboard. */
export type PageTranslationArgs = {
  languageCode: LanguageCodeEnum;
};

/**
 * Assign attributes to a given page type.
 *
 * Requires one of the following permissions: MANAGE_PAGE_TYPES_AND_ATTRIBUTES.
 */
export type PageAttributeAssign = {
  __typename?: 'PageAttributeAssign';
  errors: Array<PageError>;
  /** @deprecated Use `errors` field instead. */
  pageErrors: Array<PageError>;
  /** The updated page type. */
  pageType?: Maybe<PageType>;
};

/**
 * Unassign attributes from a given page type.
 *
 * Requires one of the following permissions: MANAGE_PAGE_TYPES_AND_ATTRIBUTES.
 */
export type PageAttributeUnassign = {
  __typename?: 'PageAttributeUnassign';
  errors: Array<PageError>;
  /** @deprecated Use `errors` field instead. */
  pageErrors: Array<PageError>;
  /** The updated page type. */
  pageType?: Maybe<PageType>;
};

/**
 * Deletes pages.
 *
 * Requires one of the following permissions: MANAGE_PAGES.
 */
export type PageBulkDelete = {
  __typename?: 'PageBulkDelete';
  /** Returns how many objects were affected. */
  count: Scalars['Int']['output'];
  errors: Array<PageError>;
  /** @deprecated Use `errors` field instead. */
  pageErrors: Array<PageError>;
};

/**
 * Publish pages.
 *
 * Requires one of the following permissions: MANAGE_PAGES.
 */
export type PageBulkPublish = {
  __typename?: 'PageBulkPublish';
  /** Returns how many objects were affected. */
  count: Scalars['Int']['output'];
  errors: Array<PageError>;
  /** @deprecated Use `errors` field instead. */
  pageErrors: Array<PageError>;
};

export type PageCountableConnection = {
  __typename?: 'PageCountableConnection';
  edges: Array<PageCountableEdge>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** A total count of items in the collection. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type PageCountableEdge = {
  __typename?: 'PageCountableEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Page;
};

/**
 * Creates a new page.
 *
 * Requires one of the following permissions: MANAGE_PAGES.
 */
export type PageCreate = {
  __typename?: 'PageCreate';
  errors: Array<PageError>;
  page?: Maybe<Page>;
  /** @deprecated Use `errors` field instead. */
  pageErrors: Array<PageError>;
};

export type PageCreateInput = {
  /** List of attributes. */
  attributes?: InputMaybe<Array<AttributeValueInput>>;
  /**
   * Page content.
   *
   * Rich text format. For reference see https://editorjs.io/
   */
  content?: InputMaybe<Scalars['JSONString']['input']>;
  /** Determines if page is visible in the storefront. */
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  /** ID of the page type that page belongs to. */
  pageType: Scalars['ID']['input'];
  /**
   * Publication date. ISO 8601 standard.
   *
   * DEPRECATED: this field will be removed. Use `publishedAt` field instead.
   */
  publicationDate?: InputMaybe<Scalars['String']['input']>;
  /** Publication date time. ISO 8601 standard. */
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Search engine optimization fields. */
  seo?: InputMaybe<SeoInput>;
  /** Page internal name. */
  slug?: InputMaybe<Scalars['String']['input']>;
  /** Page title. */
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Event sent when new page is created. */
export type PageCreated = Event & {
  __typename?: 'PageCreated';
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<IssuingPrincipal>;
  /** The page the event relates to. */
  page?: Maybe<Page>;
  /** The application receiving the webhook. */
  recipient?: Maybe<App>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

/**
 * Deletes a page.
 *
 * Requires one of the following permissions: MANAGE_PAGES.
 */
export type PageDelete = {
  __typename?: 'PageDelete';
  errors: Array<PageError>;
  page?: Maybe<Page>;
  /** @deprecated Use `errors` field instead. */
  pageErrors: Array<PageError>;
};

/** Event sent when page is deleted. */
export type PageDeleted = Event & {
  __typename?: 'PageDeleted';
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<IssuingPrincipal>;
  /** The page the event relates to. */
  page?: Maybe<Page>;
  /** The application receiving the webhook. */
  recipient?: Maybe<App>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

export type PageError = {
  __typename?: 'PageError';
  /** List of attributes IDs which causes the error. */
  attributes?: Maybe<Array<Scalars['ID']['output']>>;
  /** The error code. */
  code: PageErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field?: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message?: Maybe<Scalars['String']['output']>;
  /** List of attribute values IDs which causes the error. */
  values?: Maybe<Array<Scalars['ID']['output']>>;
};

export type PageErrorCode =
  | 'ATTRIBUTE_ALREADY_ASSIGNED'
  | 'DUPLICATED_INPUT_ITEM'
  | 'GRAPHQL_ERROR'
  | 'INVALID'
  | 'NOT_FOUND'
  | 'REQUIRED'
  | 'UNIQUE';

export type PageFilterInput = {
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  metadata?: InputMaybe<Array<MetadataFilter>>;
  pageTypes?: InputMaybe<Array<Scalars['ID']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** The Relay compliant `PageInfo` type, containing data necessary to paginate this connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type PageInput = {
  /** List of attributes. */
  attributes?: InputMaybe<Array<AttributeValueInput>>;
  /**
   * Page content.
   *
   * Rich text format. For reference see https://editorjs.io/
   */
  content?: InputMaybe<Scalars['JSONString']['input']>;
  /** Determines if page is visible in the storefront. */
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Publication date. ISO 8601 standard.
   *
   * DEPRECATED: this field will be removed. Use `publishedAt` field instead.
   */
  publicationDate?: InputMaybe<Scalars['String']['input']>;
  /** Publication date time. ISO 8601 standard. */
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Search engine optimization fields. */
  seo?: InputMaybe<SeoInput>;
  /** Page internal name. */
  slug?: InputMaybe<Scalars['String']['input']>;
  /** Page title. */
  title?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Reorder page attribute values.
 *
 * Requires one of the following permissions: MANAGE_PAGES.
 */
export type PageReorderAttributeValues = {
  __typename?: 'PageReorderAttributeValues';
  errors: Array<PageError>;
  /** Page from which attribute values are reordered. */
  page?: Maybe<Page>;
  /** @deprecated Use `errors` field instead. */
  pageErrors: Array<PageError>;
};

export type PageSortField =
  /** Sort pages by creation date. */
  | 'CREATED_AT'
  /** Sort pages by creation date. */
  | 'CREATION_DATE'
  /** Sort pages by publication date. */
  | 'PUBLICATION_DATE'
  /** Sort pages by publication date. */
  | 'PUBLISHED_AT'
  /** Sort pages by slug. */
  | 'SLUG'
  /** Sort pages by title. */
  | 'TITLE'
  /** Sort pages by visibility. */
  | 'VISIBILITY';

export type PageSortingInput = {
  /** Specifies the direction in which to sort pages. */
  direction: OrderDirection;
  /** Sort pages by the selected field. */
  field: PageSortField;
};

/** Represents page's original translatable fields and related translations. */
export type PageTranslatableContent = Node & {
  __typename?: 'PageTranslatableContent';
  /** List of page content attribute values that can be translated. */
  attributeValues: Array<AttributeValueTranslatableContent>;
  /**
   * Content of the page to translate.
   *
   * Rich text format. For reference see https://editorjs.io/
   */
  content?: Maybe<Scalars['JSONString']['output']>;
  /**
   * Content of the page.
   *
   * Rich text format. For reference see https://editorjs.io/
   * @deprecated Use the `content` field instead.
   */
  contentJson?: Maybe<Scalars['JSONString']['output']>;
  /** The ID of the page translatable content. */
  id: Scalars['ID']['output'];
  /**
   * A static page that can be manually added by a shop operator through the dashboard.
   * @deprecated Get model fields from the root level queries.
   */
  page?: Maybe<Page>;
  /** The ID of the page to translate. */
  pageId: Scalars['ID']['output'];
  /** SEO description to translate. */
  seoDescription?: Maybe<Scalars['String']['output']>;
  /** SEO title to translate. */
  seoTitle?: Maybe<Scalars['String']['output']>;
  /**
   * Slug to translate.
   *
   * Added in Saleor 3.21.
   */
  slug?: Maybe<Scalars['String']['output']>;
  /** Page title to translate. */
  title: Scalars['String']['output'];
  /** Returns translated page fields for the given language code. */
  translation?: Maybe<PageTranslation>;
};


/** Represents page's original translatable fields and related translations. */
export type PageTranslatableContentTranslationArgs = {
  languageCode: LanguageCodeEnum;
};

/**
 * Creates/updates translations for a page.
 *
 * Requires one of the following permissions: MANAGE_TRANSLATIONS.
 */
export type PageTranslate = {
  __typename?: 'PageTranslate';
  errors: Array<TranslationError>;
  page?: Maybe<PageTranslatableContent>;
  /** @deprecated Use `errors` field instead. */
  translationErrors: Array<TranslationError>;
};

/** Represents page translations. */
export type PageTranslation = Node & {
  __typename?: 'PageTranslation';
  /**
   * Translated content of the page.
   *
   * Rich text format. For reference see https://editorjs.io/
   */
  content?: Maybe<Scalars['JSONString']['output']>;
  /**
   * Translated description of the page.
   *
   * Rich text format. For reference see https://editorjs.io/
   * @deprecated Use the `content` field instead.
   */
  contentJson?: Maybe<Scalars['JSONString']['output']>;
  /** The ID of the page translation. */
  id: Scalars['ID']['output'];
  /** Translation language. */
  language: LanguageDisplay;
  /** Translated SEO description. */
  seoDescription?: Maybe<Scalars['String']['output']>;
  /** Translated SEO title. */
  seoTitle?: Maybe<Scalars['String']['output']>;
  /**
   * Translated page slug.
   *
   * Added in Saleor 3.21.
   */
  slug?: Maybe<Scalars['String']['output']>;
  /** Translated page title. */
  title?: Maybe<Scalars['String']['output']>;
  /** Represents the page fields to translate. */
  translatableContent?: Maybe<PageTranslatableContent>;
};

export type PageTranslationInput = {
  /**
   * Translated page content.
   *
   * Rich text format. For reference see https://editorjs.io/
   */
  content?: InputMaybe<Scalars['JSONString']['input']>;
  seoDescription?: InputMaybe<Scalars['String']['input']>;
  seoTitle?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Represents a type of page. It defines what attributes are available to pages of this type. */
export type PageType = Node & ObjectWithMetadata & {
  __typename?: 'PageType';
  /** Page attributes of that page type. */
  attributes?: Maybe<Array<Attribute>>;
  /**
   * Attributes that can be assigned to the page type.
   *
   * Requires one of the following permissions: MANAGE_PAGES, MANAGE_PAGE_TYPES_AND_ATTRIBUTES.
   */
  availableAttributes?: Maybe<AttributeCountableConnection>;
  /**
   * Whether page type has pages assigned.
   *
   * Requires one of the following permissions: MANAGE_PAGES, MANAGE_PAGE_TYPES_AND_ATTRIBUTES.
   */
  hasPages?: Maybe<Scalars['Boolean']['output']>;
  /** ID of the page type. */
  id: Scalars['ID']['output'];
  /** List of public metadata items. Can be accessed without permissions. */
  metadata: Array<MetadataItem>;
  /**
   * A single key from public metadata.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   */
  metafield?: Maybe<Scalars['String']['output']>;
  /** Public metadata. Use `keys` to control which fields you want to include. The default is to include everything. */
  metafields?: Maybe<Scalars['Metadata']['output']>;
  /** Name of the page type. */
  name: Scalars['String']['output'];
  /** List of private metadata items. Requires staff permissions to access. */
  privateMetadata: Array<MetadataItem>;
  /**
   * A single key from private metadata. Requires staff permissions to access.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   */
  privateMetafield?: Maybe<Scalars['String']['output']>;
  /** Private metadata. Requires staff permissions to access. Use `keys` to control which fields you want to include. The default is to include everything. */
  privateMetafields?: Maybe<Scalars['Metadata']['output']>;
  /** Slug of the page type. */
  slug: Scalars['String']['output'];
};


/** Represents a type of page. It defines what attributes are available to pages of this type. */
export type PageTypeAvailableAttributesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<AttributeFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<AttributeWhereInput>;
};


/** Represents a type of page. It defines what attributes are available to pages of this type. */
export type PageTypeMetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Represents a type of page. It defines what attributes are available to pages of this type. */
export type PageTypeMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Represents a type of page. It defines what attributes are available to pages of this type. */
export type PageTypePrivateMetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Represents a type of page. It defines what attributes are available to pages of this type. */
export type PageTypePrivateMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};

/**
 * Deletes page types.
 *
 * Requires one of the following permissions: MANAGE_PAGE_TYPES_AND_ATTRIBUTES.
 */
export type PageTypeBulkDelete = {
  __typename?: 'PageTypeBulkDelete';
  /** Returns how many objects were affected. */
  count: Scalars['Int']['output'];
  errors: Array<PageError>;
  /** @deprecated Use `errors` field instead. */
  pageErrors: Array<PageError>;
};

export type PageTypeCountableConnection = {
  __typename?: 'PageTypeCountableConnection';
  edges: Array<PageTypeCountableEdge>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** A total count of items in the collection. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type PageTypeCountableEdge = {
  __typename?: 'PageTypeCountableEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: PageType;
};

/**
 * Creates a new page type.
 *
 * Requires one of the following permissions: MANAGE_PAGE_TYPES_AND_ATTRIBUTES.
 */
export type PageTypeCreate = {
  __typename?: 'PageTypeCreate';
  errors: Array<PageError>;
  /** @deprecated Use `errors` field instead. */
  pageErrors: Array<PageError>;
  pageType?: Maybe<PageType>;
};

export type PageTypeCreateInput = {
  /** List of attribute IDs to be assigned to the page type. */
  addAttributes?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Name of the page type. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Page type slug. */
  slug?: InputMaybe<Scalars['String']['input']>;
};

/** Event sent when new page type is created. */
export type PageTypeCreated = Event & {
  __typename?: 'PageTypeCreated';
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<IssuingPrincipal>;
  /** The page type the event relates to. */
  pageType?: Maybe<PageType>;
  /** The application receiving the webhook. */
  recipient?: Maybe<App>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

/**
 * Deletes a page type.
 *
 * Requires one of the following permissions: MANAGE_PAGE_TYPES_AND_ATTRIBUTES.
 */
export type PageTypeDelete = {
  __typename?: 'PageTypeDelete';
  errors: Array<PageError>;
  /** @deprecated Use `errors` field instead. */
  pageErrors: Array<PageError>;
  pageType?: Maybe<PageType>;
};

/** Event sent when page type is deleted. */
export type PageTypeDeleted = Event & {
  __typename?: 'PageTypeDeleted';
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<IssuingPrincipal>;
  /** The page type the event relates to. */
  pageType?: Maybe<PageType>;
  /** The application receiving the webhook. */
  recipient?: Maybe<App>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

export type PageTypeFilterInput = {
  search?: InputMaybe<Scalars['String']['input']>;
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
};

/**
 * Reorder the attributes of a page type.
 *
 * Requires one of the following permissions: MANAGE_PAGE_TYPES_AND_ATTRIBUTES.
 */
export type PageTypeReorderAttributes = {
  __typename?: 'PageTypeReorderAttributes';
  errors: Array<PageError>;
  /** @deprecated Use `errors` field instead. */
  pageErrors: Array<PageError>;
  /** Page type from which attributes are reordered. */
  pageType?: Maybe<PageType>;
};

export type PageTypeSortField =
  /** Sort page types by name. */
  | 'NAME'
  /** Sort page types by slug. */
  | 'SLUG';

export type PageTypeSortingInput = {
  /** Specifies the direction in which to sort page types. */
  direction: OrderDirection;
  /** Sort page types by the selected field. */
  field: PageTypeSortField;
};

/**
 * Updates page type.
 *
 * Requires one of the following permissions: MANAGE_PAGE_TYPES_AND_ATTRIBUTES.
 */
export type PageTypeUpdate = {
  __typename?: 'PageTypeUpdate';
  errors: Array<PageError>;
  /** @deprecated Use `errors` field instead. */
  pageErrors: Array<PageError>;
  pageType?: Maybe<PageType>;
};

export type PageTypeUpdateInput = {
  /** List of attribute IDs to be assigned to the page type. */
  addAttributes?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Name of the page type. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** List of attribute IDs to be assigned to the page type. */
  removeAttributes?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Page type slug. */
  slug?: InputMaybe<Scalars['String']['input']>;
};

/** Event sent when page type is updated. */
export type PageTypeUpdated = Event & {
  __typename?: 'PageTypeUpdated';
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<IssuingPrincipal>;
  /** The page type the event relates to. */
  pageType?: Maybe<PageType>;
  /** The application receiving the webhook. */
  recipient?: Maybe<App>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

/**
 * Updates an existing page.
 *
 * Requires one of the following permissions: MANAGE_PAGES.
 */
export type PageUpdate = {
  __typename?: 'PageUpdate';
  errors: Array<PageError>;
  page?: Maybe<Page>;
  /** @deprecated Use `errors` field instead. */
  pageErrors: Array<PageError>;
};

/** Event sent when page is updated. */
export type PageUpdated = Event & {
  __typename?: 'PageUpdated';
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<IssuingPrincipal>;
  /** The page the event relates to. */
  page?: Maybe<Page>;
  /** The application receiving the webhook. */
  recipient?: Maybe<App>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

export type PageWhereInput = {
  /** List of conditions that must be met. */
  AND?: InputMaybe<Array<PageWhereInput>>;
  /** A list of conditions of which at least one must be met. */
  OR?: InputMaybe<Array<PageWhereInput>>;
  /** Filter by attributes associated with the page. */
  attributes?: InputMaybe<Array<AssignedAttributeWhereInput>>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter by metadata fields. */
  metadata?: InputMaybe<MetadataFilterInput>;
  /** Filter by page type. */
  pageType?: InputMaybe<GlobalIdFilterInput>;
  /** Filter by page slug. */
  slug?: InputMaybe<StringFilterInput>;
};

/**
 * Change the password of the logged in user.
 *
 * Requires one of the following permissions: AUTHENTICATED_USER.
 */
export type PasswordChange = {
  __typename?: 'PasswordChange';
  /** @deprecated Use `errors` field instead. */
  accountErrors: Array<AccountError>;
  errors: Array<AccountError>;
  /** A user instance with a new password. */
  user?: Maybe<User>;
};

/** Represents a payment of a given type. */
export type Payment = Node & ObjectWithMetadata & {
  __typename?: 'Payment';
  /**
   * List of actions that can be performed in the current state of a payment.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   */
  actions: Array<OrderAction>;
  /**
   * Maximum amount of money that can be captured.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   */
  availableCaptureAmount?: Maybe<Money>;
  /**
   * Maximum amount of money that can be refunded.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   */
  availableRefundAmount?: Maybe<Money>;
  /** Total amount captured for this payment. */
  capturedAmount?: Maybe<Money>;
  /** Internal payment status. */
  chargeStatus: PaymentChargeStatusEnum;
  /** Checkout associated with a payment. */
  checkout?: Maybe<Checkout>;
  /** Date and time at which payment was created. */
  created: Scalars['DateTime']['output'];
  /** The details of the card used for this payment. */
  creditCard?: Maybe<CreditCard>;
  /**
   * IP address of the user who created the payment.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   */
  customerIpAddress?: Maybe<Scalars['String']['output']>;
  /** Payment gateway used for payment. */
  gateway: Scalars['String']['output'];
  /** ID of the payment. */
  id: Scalars['ID']['output'];
  /** Determines if the payment is active or not. */
  isActive: Scalars['Boolean']['output'];
  /** List of public metadata items. Can be accessed without permissions. */
  metadata: Array<MetadataItem>;
  /**
   * A single key from public metadata.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   */
  metafield?: Maybe<Scalars['String']['output']>;
  /** Public metadata. Use `keys` to control which fields you want to include. The default is to include everything. */
  metafields?: Maybe<Scalars['Metadata']['output']>;
  /** Date and time at which payment was modified. */
  modified: Scalars['DateTime']['output'];
  /** Order associated with a payment. */
  order?: Maybe<Order>;
  /**
   * Informs whether this is a partial payment.
   * @deprecated This field is reserved for the Adyen Gateway plugin. For other gateways, its value is always `false`. This field will be removed in 3.23 along with the plugin.
   */
  partial: Scalars['Boolean']['output'];
  /** Type of method used for payment. */
  paymentMethodType: Scalars['String']['output'];
  /** List of private metadata items. Requires staff permissions to access. */
  privateMetadata: Array<MetadataItem>;
  /**
   * A single key from private metadata. Requires staff permissions to access.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   */
  privateMetafield?: Maybe<Scalars['String']['output']>;
  /** Private metadata. Requires staff permissions to access. Use `keys` to control which fields you want to include. The default is to include everything. */
  privateMetafields?: Maybe<Scalars['Metadata']['output']>;
  /** PSP reference of the payment. */
  pspReference?: Maybe<Scalars['String']['output']>;
  /** Unique token associated with a payment. */
  token: Scalars['String']['output'];
  /** Total amount of the payment. */
  total?: Maybe<Money>;
  /**
   * List of all transactions within this payment.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   */
  transactions?: Maybe<Array<Transaction>>;
};


/** Represents a payment of a given type. */
export type PaymentMetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Represents a payment of a given type. */
export type PaymentMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Represents a payment of a given type. */
export type PaymentPrivateMetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Represents a payment of a given type. */
export type PaymentPrivateMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Authorize payment. */
export type PaymentAuthorize = Event & {
  __typename?: 'PaymentAuthorize';
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<IssuingPrincipal>;
  /** Look up a payment. */
  payment?: Maybe<Payment>;
  /** The application receiving the webhook. */
  recipient?: Maybe<App>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

/**
 * Captures the authorized payment amount.
 *
 * Requires one of the following permissions: MANAGE_ORDERS.
 */
export type PaymentCapture = {
  __typename?: 'PaymentCapture';
  errors: Array<PaymentError>;
  /** Updated payment. */
  payment?: Maybe<Payment>;
  /** @deprecated Use `errors` field instead. */
  paymentErrors: Array<PaymentError>;
};

/** Capture payment. */
export type PaymentCaptureEvent = Event & {
  __typename?: 'PaymentCaptureEvent';
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<IssuingPrincipal>;
  /** Look up a payment. */
  payment?: Maybe<Payment>;
  /** The application receiving the webhook. */
  recipient?: Maybe<App>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

export type PaymentChargeStatusEnum =
  | 'CANCELLED'
  | 'FULLY_CHARGED'
  | 'FULLY_REFUNDED'
  | 'NOT_CHARGED'
  | 'PARTIALLY_CHARGED'
  | 'PARTIALLY_REFUNDED'
  | 'PENDING'
  | 'REFUSED';

/** Check payment balance. */
export type PaymentCheckBalance = {
  __typename?: 'PaymentCheckBalance';
  /** Response from the gateway. */
  data?: Maybe<Scalars['JSONString']['output']>;
  errors: Array<PaymentError>;
  /** @deprecated Use `errors` field instead. */
  paymentErrors: Array<PaymentError>;
};

export type PaymentCheckBalanceInput = {
  /** Information about card. */
  card: CardInput;
  /** Slug of a channel for which the data should be returned. */
  channel: Scalars['String']['input'];
  /** An ID of a payment gateway to check. */
  gatewayId: Scalars['String']['input'];
  /** Payment method name. */
  method: Scalars['String']['input'];
};

/** Confirm payment. */
export type PaymentConfirmEvent = Event & {
  __typename?: 'PaymentConfirmEvent';
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<IssuingPrincipal>;
  /** Look up a payment. */
  payment?: Maybe<Payment>;
  /** The application receiving the webhook. */
  recipient?: Maybe<App>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

export type PaymentCountableConnection = {
  __typename?: 'PaymentCountableConnection';
  edges: Array<PaymentCountableEdge>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** A total count of items in the collection. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type PaymentCountableEdge = {
  __typename?: 'PaymentCountableEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Payment;
};

export type PaymentError = {
  __typename?: 'PaymentError';
  /** The error code. */
  code: PaymentErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field?: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message?: Maybe<Scalars['String']['output']>;
  /** List of variant IDs which causes the error. */
  variants?: Maybe<Array<Scalars['ID']['output']>>;
};

export type PaymentErrorCode =
  | 'BALANCE_CHECK_ERROR'
  | 'BILLING_ADDRESS_NOT_SET'
  | 'CHANNEL_INACTIVE'
  | 'CHECKOUT_COMPLETION_IN_PROGRESS'
  | 'CHECKOUT_EMAIL_NOT_SET'
  | 'CHECKOUT_HAS_TRANSACTION'
  | 'GRAPHQL_ERROR'
  | 'INVALID'
  | 'INVALID_SHIPPING_METHOD'
  | 'NOT_FOUND'
  | 'NOT_SUPPORTED_GATEWAY'
  | 'NO_CHECKOUT_LINES'
  | 'PARTIAL_PAYMENT_NOT_ALLOWED'
  | 'PAYMENT_ERROR'
  | 'REQUIRED'
  | 'SHIPPING_ADDRESS_NOT_SET'
  | 'SHIPPING_METHOD_NOT_SET'
  | 'UNAVAILABLE_VARIANT_IN_CHANNEL'
  | 'UNIQUE';

export type PaymentFilterInput = {
  checkouts?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter by ids. */
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** Available payment gateway backend with configuration necessary to setup client. */
export type PaymentGateway = {
  __typename?: 'PaymentGateway';
  /** Payment gateway client configuration. */
  config: Array<GatewayConfigLine>;
  /** Payment gateway supported currencies. */
  currencies: Array<Scalars['String']['output']>;
  /** Payment gateway ID. */
  id: Scalars['ID']['output'];
  /** Payment gateway name. */
  name: Scalars['String']['output'];
};

export type PaymentGatewayConfig = {
  __typename?: 'PaymentGatewayConfig';
  /** The JSON data required to initialize the payment gateway. */
  data?: Maybe<Scalars['JSON']['output']>;
  errors?: Maybe<Array<PaymentGatewayConfigError>>;
  /** The app identifier. */
  id: Scalars['String']['output'];
};

export type PaymentGatewayConfigError = {
  __typename?: 'PaymentGatewayConfigError';
  /** The error code. */
  code: PaymentGatewayConfigErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field?: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message?: Maybe<Scalars['String']['output']>;
};

export type PaymentGatewayConfigErrorCode =
  | 'GRAPHQL_ERROR'
  | 'INVALID'
  | 'NOT_FOUND';

/** Initializes a payment gateway session. It triggers the webhook `PAYMENT_GATEWAY_INITIALIZE_SESSION`, to the requested `paymentGateways`. If `paymentGateways` is not provided, the webhook will be send to all subscribed payment gateways. There is a limit of 100 transaction items per checkout / order. */
export type PaymentGatewayInitialize = {
  __typename?: 'PaymentGatewayInitialize';
  errors: Array<PaymentGatewayInitializeError>;
  /** List of payment gateway configurations. */
  gatewayConfigs?: Maybe<Array<PaymentGatewayConfig>>;
};

export type PaymentGatewayInitializeError = {
  __typename?: 'PaymentGatewayInitializeError';
  /** The error code. */
  code: PaymentGatewayInitializeErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field?: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message?: Maybe<Scalars['String']['output']>;
};

export type PaymentGatewayInitializeErrorCode =
  | 'GRAPHQL_ERROR'
  | 'INVALID'
  | 'NOT_FOUND';

/** Event sent when user wants to initialize the payment gateway. */
export type PaymentGatewayInitializeSession = Event & {
  __typename?: 'PaymentGatewayInitializeSession';
  /** Amount requested for initializing the payment gateway. */
  amount?: Maybe<Scalars['PositiveDecimal']['output']>;
  /** Payment gateway data in JSON format, received from storefront. */
  data?: Maybe<Scalars['JSON']['output']>;
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<IssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient?: Maybe<App>;
  /** Checkout or order */
  sourceObject: OrderOrCheckout;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

/**
 * Initializes payment gateway for tokenizing payment method session.
 *
 * Requires one of the following permissions: AUTHENTICATED_USER.
 *
 * Triggers the following webhook events:
 * - PAYMENT_GATEWAY_INITIALIZE_TOKENIZATION_SESSION (sync): The customer requested to initialize payment gateway for tokenization.
 */
export type PaymentGatewayInitializeTokenization = {
  __typename?: 'PaymentGatewayInitializeTokenization';
  /** A data returned by payment app. */
  data?: Maybe<Scalars['JSON']['output']>;
  errors: Array<PaymentGatewayInitializeTokenizationError>;
  /** A status of the payment gateway initialization. */
  result: PaymentGatewayInitializeTokenizationResult;
};

export type PaymentGatewayInitializeTokenizationError = {
  __typename?: 'PaymentGatewayInitializeTokenizationError';
  /** The error code. */
  code: PaymentGatewayInitializeTokenizationErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field?: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message?: Maybe<Scalars['String']['output']>;
};

export type PaymentGatewayInitializeTokenizationErrorCode =
  | 'CHANNEL_INACTIVE'
  | 'GATEWAY_ERROR'
  | 'GRAPHQL_ERROR'
  | 'INVALID'
  | 'NOT_FOUND';

/**
 * Result of initialize payment gateway for tokenization of payment method.
 *
 *     The result of initialize payment gateway for tokenization of payment method.
 *     SUCCESSFULLY_INITIALIZED - The payment gateway was successfully initialized.
 *     FAILED_TO_INITIALIZE - The payment gateway was not initialized.
 *     FAILED_TO_DELIVER - The request to initialize payment gateway was not delivered.
 *
 */
export type PaymentGatewayInitializeTokenizationResult =
  | 'FAILED_TO_DELIVER'
  | 'FAILED_TO_INITIALIZE'
  | 'SUCCESSFULLY_INITIALIZED';

/** Event sent to initialize a new session in payment gateway to store the payment method.  */
export type PaymentGatewayInitializeTokenizationSession = Event & {
  __typename?: 'PaymentGatewayInitializeTokenizationSession';
  /** Channel related to the requested action. */
  channel: Channel;
  /** Payment gateway data in JSON format, received from storefront. */
  data?: Maybe<Scalars['JSON']['output']>;
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<IssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient?: Maybe<App>;
  /** The user related to the requested action. */
  user: User;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

export type PaymentGatewayToInitialize = {
  /** The data that will be passed to the payment gateway. */
  data?: InputMaybe<Scalars['JSON']['input']>;
  /** The identifier of the payment gateway app to initialize. */
  id: Scalars['String']['input'];
};

/** Initializes payment process when it is required by gateway. */
export type PaymentInitialize = {
  __typename?: 'PaymentInitialize';
  errors: Array<PaymentError>;
  /** Payment that was initialized. */
  initializedPayment?: Maybe<PaymentInitialized>;
  /** @deprecated Use `errors` field instead. */
  paymentErrors: Array<PaymentError>;
};

/** Server-side data generated by a payment gateway. Optional step when the payment provider requires an additional action to initialize payment session. */
export type PaymentInitialized = {
  __typename?: 'PaymentInitialized';
  /** Initialized data by gateway. */
  data?: Maybe<Scalars['JSONString']['output']>;
  /** ID of a payment gateway. */
  gateway: Scalars['String']['output'];
  /** Payment gateway name. */
  name: Scalars['String']['output'];
};

export type PaymentInput = {
  /** Total amount of the transaction, including all taxes and discounts. If no amount is provided, the checkout total will be used. */
  amount?: InputMaybe<Scalars['PositiveDecimal']['input']>;
  /** A gateway to use with that payment. */
  gateway: Scalars['String']['input'];
  /**
   * User public metadata. Can be read by any API client authorized to read the object it's attached to.
   *
   * Warning: never store sensitive information, including financial data such as credit card details.
   */
  metadata?: InputMaybe<Array<MetadataInput>>;
  /** URL of a storefront view where user should be redirected after requiring additional actions. Payment with additional actions will not be finished if this field is not provided. */
  returnUrl?: InputMaybe<Scalars['String']['input']>;
  /** Payment store type. */
  storePaymentMethod?: InputMaybe<StorePaymentMethodEnum>;
  /** Client-side generated payment token, representing customer's billing data in a secure manner. */
  token?: InputMaybe<Scalars['String']['input']>;
};

/** List payment gateways. */
export type PaymentListGateways = Event & {
  __typename?: 'PaymentListGateways';
  /** The checkout the event relates to. */
  checkout?: Maybe<Checkout>;
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<IssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient?: Maybe<App>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

/**
 * Represents a payment method used for a transaction.
 *
 * Added in Saleor 3.22.
 */
export type PaymentMethodDetails = {
  /** Name of the payment method. */
  name: Scalars['String']['output'];
};

export type PaymentMethodDetailsCardFilterInput = {
  /** Filter by payment method brand used to pay for the order. */
  brand?: InputMaybe<StringFilterInput>;
};

export type PaymentMethodDetailsFilterInput = {
  /** Filter by card details used to pay for the order. Skips `type` filter if provided. */
  card?: InputMaybe<PaymentMethodDetailsCardFilterInput>;
  /** Filter by payment method type used to pay for the order. */
  type?: InputMaybe<PaymentMethodTypeEnumFilterInput>;
};

/**
 * Details of the payment method used for the transaction. One of `card` or `other` is required.
 *
 * Added in Saleor 3.22.
 */
export type PaymentMethodDetailsInput = {
  /** Details of the card payment method used for the transaction. */
  card?: InputMaybe<CardPaymentMethodDetailsInput>;
  /** Details of the non-card payment method used for this transaction. */
  other?: InputMaybe<OtherPaymentMethodDetailsInput>;
};

/**
 * Tokenize payment method.
 *
 * Requires one of the following permissions: AUTHENTICATED_USER.
 *
 * Triggers the following webhook events:
 * - PAYMENT_METHOD_INITIALIZE_TOKENIZATION_SESSION (sync): The customer requested to tokenize payment method.
 */
export type PaymentMethodInitializeTokenization = {
  __typename?: 'PaymentMethodInitializeTokenization';
  /** A data returned by the payment app. */
  data?: Maybe<Scalars['JSON']['output']>;
  errors: Array<PaymentMethodInitializeTokenizationError>;
  /** The identifier of the payment method. */
  id?: Maybe<Scalars['String']['output']>;
  /** A status of the payment method tokenization. */
  result: PaymentMethodTokenizationResult;
};

export type PaymentMethodInitializeTokenizationError = {
  __typename?: 'PaymentMethodInitializeTokenizationError';
  /** The error code. */
  code: PaymentMethodInitializeTokenizationErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field?: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message?: Maybe<Scalars['String']['output']>;
};

export type PaymentMethodInitializeTokenizationErrorCode =
  | 'CHANNEL_INACTIVE'
  | 'GATEWAY_ERROR'
  | 'GRAPHQL_ERROR'
  | 'INVALID'
  | 'NOT_FOUND';

/** Event sent when user requests a tokenization of payment method. */
export type PaymentMethodInitializeTokenizationSession = Event & {
  __typename?: 'PaymentMethodInitializeTokenizationSession';
  /** Channel related to the requested action. */
  channel: Channel;
  /** Payment gateway data in JSON format, received from storefront. */
  data?: Maybe<Scalars['JSON']['output']>;
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<IssuingPrincipal>;
  /** The payment flow that the tokenized payment method should support. */
  paymentFlowToSupport: TokenizedPaymentFlowEnum;
  /** The application receiving the webhook. */
  recipient?: Maybe<App>;
  /** The user related to the requested action. */
  user: User;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

/**
 * Tokenize payment method.
 *
 * Requires one of the following permissions: AUTHENTICATED_USER.
 *
 * Triggers the following webhook events:
 * - PAYMENT_METHOD_PROCESS_TOKENIZATION_SESSION (sync): The customer continues payment method tokenization.
 */
export type PaymentMethodProcessTokenization = {
  __typename?: 'PaymentMethodProcessTokenization';
  /** A data returned by the payment app. */
  data?: Maybe<Scalars['JSON']['output']>;
  errors: Array<PaymentMethodProcessTokenizationError>;
  /** The identifier of the payment method. */
  id?: Maybe<Scalars['String']['output']>;
  /** A status of the payment method tokenization. */
  result: PaymentMethodTokenizationResult;
};

export type PaymentMethodProcessTokenizationError = {
  __typename?: 'PaymentMethodProcessTokenizationError';
  /** The error code. */
  code: PaymentMethodProcessTokenizationErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field?: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message?: Maybe<Scalars['String']['output']>;
};

export type PaymentMethodProcessTokenizationErrorCode =
  | 'CHANNEL_INACTIVE'
  | 'GATEWAY_ERROR'
  | 'GRAPHQL_ERROR'
  | 'INVALID'
  | 'NOT_FOUND';

/** Event sent when user continues a tokenization of payment method. */
export type PaymentMethodProcessTokenizationSession = Event & {
  __typename?: 'PaymentMethodProcessTokenizationSession';
  /** Channel related to the requested action. */
  channel: Channel;
  /** Payment gateway data in JSON format, received from storefront. */
  data?: Maybe<Scalars['JSON']['output']>;
  /** The ID returned by app from `PAYMENT_METHOD_INITIALIZE_TOKENIZATION_SESSION` webhook. */
  id: Scalars['String']['output'];
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<IssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient?: Maybe<App>;
  /** The user related to the requested action. */
  user: User;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

export type PaymentMethodRequestDeleteError = {
  __typename?: 'PaymentMethodRequestDeleteError';
  /** The error code. */
  code: StoredPaymentMethodRequestDeleteErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field?: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message?: Maybe<Scalars['String']['output']>;
};

/**
 * Result of tokenization of payment method.
 *
 *     SUCCESSFULLY_TOKENIZED - The payment method was successfully tokenized.
 *     ADDITIONAL_ACTION_REQUIRED - The additional action is required to tokenize payment
 *     method.
 *     PENDING - The payment method is pending tokenization.
 *     FAILED_TO_TOKENIZE - The payment method was not tokenized.
 *     FAILED_TO_DELIVER - The request to tokenize payment method was not delivered.
 *
 */
export type PaymentMethodTokenizationResult =
  | 'ADDITIONAL_ACTION_REQUIRED'
  | 'FAILED_TO_DELIVER'
  | 'FAILED_TO_TOKENIZE'
  | 'PENDING'
  | 'SUCCESSFULLY_TOKENIZED';

/**
 * Represents possible payment method types.
 *
 *     The following types are possible:
 *     CARD - represents a card payment method.
 *     OTHER - represents any payment method that is not a card payment.
 *
 *
 */
export type PaymentMethodTypeEnum =
  | 'CARD'
  | 'OTHER';

export type PaymentMethodTypeEnumFilterInput = {
  /** The value equal to. */
  eq?: InputMaybe<PaymentMethodTypeEnum>;
  /** The value included in. */
  oneOf?: InputMaybe<Array<PaymentMethodTypeEnum>>;
};

/** Process payment. */
export type PaymentProcessEvent = Event & {
  __typename?: 'PaymentProcessEvent';
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<IssuingPrincipal>;
  /** Look up a payment. */
  payment?: Maybe<Payment>;
  /** The application receiving the webhook. */
  recipient?: Maybe<App>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

/**
 * Refunds the captured payment amount.
 *
 * Requires one of the following permissions: MANAGE_ORDERS.
 */
export type PaymentRefund = {
  __typename?: 'PaymentRefund';
  errors: Array<PaymentError>;
  /** Updated payment. */
  payment?: Maybe<Payment>;
  /** @deprecated Use `errors` field instead. */
  paymentErrors: Array<PaymentError>;
};

/** Refund payment. */
export type PaymentRefundEvent = Event & {
  __typename?: 'PaymentRefundEvent';
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<IssuingPrincipal>;
  /** Look up a payment. */
  payment?: Maybe<Payment>;
  /** The application receiving the webhook. */
  recipient?: Maybe<App>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

/** Represents the channel-specific payment settings. */
export type PaymentSettings = {
  __typename?: 'PaymentSettings';
  /**
   * Specifies the earliest date on which funds for expired checkouts can begin to be released. Expired checkouts dated before this cut-off will not have their funds released. Additionally, no funds will be released for checkouts that are more than one year old, regardless of the cut-off date.
   *
   * Added in Saleor 3.20.
   */
  checkoutReleaseFundsCutOffDate?: Maybe<Scalars['DateTime']['output']>;
  /**
   * The time in hours after which funds for expired checkouts will be released.
   *
   * Added in Saleor 3.20.
   */
  checkoutTtlBeforeReleasingFunds?: Maybe<Scalars['Hour']['output']>;
  /** Determine the transaction flow strategy to be used. Include the selected option in the payload sent to the payment app, as a requested action for the transaction. */
  defaultTransactionFlowStrategy: TransactionFlowStrategyEnum;
  /**
   * Determine if the funds for expired checkouts should be released automatically.
   *
   * Added in Saleor 3.20.
   */
  releaseFundsForExpiredCheckouts?: Maybe<Scalars['Boolean']['output']>;
};

export type PaymentSettingsInput = {
  /**
   * Specifies the earliest date on which funds for expired checkouts can begin to be released. Expired checkouts dated before this cut-off will not have their funds released. Additionally, no funds will be released for checkouts that are more than one year old, regardless of the cut-off date.
   *
   * Added in Saleor 3.20.
   */
  checkoutReleaseFundsCutOffDate?: InputMaybe<Scalars['DateTime']['input']>;
  /**
   * The time in hours after which funds for expired checkouts will be released.
   *
   * Added in Saleor 3.20.
   */
  checkoutTtlBeforeReleasingFunds?: InputMaybe<Scalars['Hour']['input']>;
  /** Determine the transaction flow strategy to be used. Include the selected option in the payload sent to the payment app, as a requested action for the transaction. */
  defaultTransactionFlowStrategy?: InputMaybe<TransactionFlowStrategyEnum>;
  /**
   * Determine if the funds for expired checkouts should be released automatically.
   *
   * Added in Saleor 3.20.
   */
  releaseFundsForExpiredCheckouts?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Represents a payment source stored for user in payment gateway, such as credit card. */
export type PaymentSource = {
  __typename?: 'PaymentSource';
  /** Stored credit card details if available. */
  creditCardInfo?: Maybe<CreditCard>;
  /** Payment gateway name. */
  gateway: Scalars['String']['output'];
  /**
   * List of public metadata items.
   *
   * Can be accessed without permissions.
   */
  metadata: Array<MetadataItem>;
  /** ID of stored payment method. */
  paymentMethodId?: Maybe<Scalars['String']['output']>;
};

/**
 * Voids the authorized payment.
 *
 * Requires one of the following permissions: MANAGE_ORDERS.
 */
export type PaymentVoid = {
  __typename?: 'PaymentVoid';
  errors: Array<PaymentError>;
  /** Updated payment. */
  payment?: Maybe<Payment>;
  /** @deprecated Use `errors` field instead. */
  paymentErrors: Array<PaymentError>;
};

/** Void payment. */
export type PaymentVoidEvent = Event & {
  __typename?: 'PaymentVoidEvent';
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<IssuingPrincipal>;
  /** Look up a payment. */
  payment?: Maybe<Payment>;
  /** The application receiving the webhook. */
  recipient?: Maybe<App>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

/** Represents a permission object in a friendly form. */
export type Permission = {
  __typename?: 'Permission';
  /** Internal code for permission. */
  code: PermissionEnum;
  /** Describe action(s) allowed to do by permission. */
  name: Scalars['String']['output'];
};

export type PermissionEnum =
  | 'HANDLE_CHECKOUTS'
  | 'HANDLE_PAYMENTS'
  | 'HANDLE_TAXES'
  | 'IMPERSONATE_USER'
  | 'MANAGE_APPS'
  | 'MANAGE_CHANNELS'
  | 'MANAGE_CHECKOUTS'
  | 'MANAGE_DISCOUNTS'
  | 'MANAGE_GIFT_CARD'
  | 'MANAGE_MENUS'
  | 'MANAGE_OBSERVABILITY'
  | 'MANAGE_ORDERS'
  | 'MANAGE_ORDERS_IMPORT'
  | 'MANAGE_PAGES'
  | 'MANAGE_PAGE_TYPES_AND_ATTRIBUTES'
  | 'MANAGE_PLUGINS'
  | 'MANAGE_PRODUCTS'
  | 'MANAGE_PRODUCT_TYPES_AND_ATTRIBUTES'
  | 'MANAGE_SETTINGS'
  | 'MANAGE_SHIPPING'
  | 'MANAGE_STAFF'
  | 'MANAGE_TAXES'
  | 'MANAGE_TRANSLATIONS'
  | 'MANAGE_USERS';

/**
 * Create new permission group. Apps are not allowed to perform this mutation.
 *
 * Requires one of the following permissions: MANAGE_STAFF.
 *
 * Triggers the following webhook events:
 * - PERMISSION_GROUP_CREATED (async)
 */
export type PermissionGroupCreate = {
  __typename?: 'PermissionGroupCreate';
  errors: Array<PermissionGroupError>;
  group?: Maybe<Group>;
  /** @deprecated Use `errors` field instead. */
  permissionGroupErrors: Array<PermissionGroupError>;
};

export type PermissionGroupCreateInput = {
  /** List of channels to assign to this group. */
  addChannels?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** List of permission code names to assign to this group. */
  addPermissions?: InputMaybe<Array<PermissionEnum>>;
  /** List of users to assign to this group. */
  addUsers?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Group name. */
  name: Scalars['String']['input'];
  /** Determine if the group has restricted access to channels.  DEFAULT: False */
  restrictedAccessToChannels?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Event sent when new permission group is created. */
export type PermissionGroupCreated = Event & {
  __typename?: 'PermissionGroupCreated';
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<IssuingPrincipal>;
  /** The permission group the event relates to. */
  permissionGroup?: Maybe<Group>;
  /** The application receiving the webhook. */
  recipient?: Maybe<App>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

/**
 * Delete permission group. Apps are not allowed to perform this mutation.
 *
 * Requires one of the following permissions: MANAGE_STAFF.
 *
 * Triggers the following webhook events:
 * - PERMISSION_GROUP_DELETED (async)
 */
export type PermissionGroupDelete = {
  __typename?: 'PermissionGroupDelete';
  errors: Array<PermissionGroupError>;
  group?: Maybe<Group>;
  /** @deprecated Use `errors` field instead. */
  permissionGroupErrors: Array<PermissionGroupError>;
};

/** Event sent when permission group is deleted. */
export type PermissionGroupDeleted = Event & {
  __typename?: 'PermissionGroupDeleted';
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<IssuingPrincipal>;
  /** The permission group the event relates to. */
  permissionGroup?: Maybe<Group>;
  /** The application receiving the webhook. */
  recipient?: Maybe<App>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

export type PermissionGroupError = {
  __typename?: 'PermissionGroupError';
  /** List of channels IDs which causes the error. */
  channels?: Maybe<Array<Scalars['ID']['output']>>;
  /** The error code. */
  code: PermissionGroupErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field?: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message?: Maybe<Scalars['String']['output']>;
  /** List of permissions which causes the error. */
  permissions?: Maybe<Array<PermissionEnum>>;
  /** List of user IDs which causes the error. */
  users?: Maybe<Array<Scalars['ID']['output']>>;
};

export type PermissionGroupErrorCode =
  | 'ASSIGN_NON_STAFF_MEMBER'
  | 'CANNOT_REMOVE_FROM_LAST_GROUP'
  | 'DUPLICATED_INPUT_ITEM'
  | 'LEFT_NOT_MANAGEABLE_PERMISSION'
  | 'OUT_OF_SCOPE_CHANNEL'
  | 'OUT_OF_SCOPE_PERMISSION'
  | 'OUT_OF_SCOPE_USER'
  | 'REQUIRED'
  | 'UNIQUE';

export type PermissionGroupFilterInput = {
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
};

/** Sorting options for permission groups. */
export type PermissionGroupSortField =
  /** Sort permission group accounts by name. */
  | 'NAME';

export type PermissionGroupSortingInput = {
  /** Specifies the direction in which to sort permission group. */
  direction: OrderDirection;
  /** Sort permission group by the selected field. */
  field: PermissionGroupSortField;
};

/**
 * Update permission group. Apps are not allowed to perform this mutation.
 *
 * Requires one of the following permissions: MANAGE_STAFF.
 *
 * Triggers the following webhook events:
 * - PERMISSION_GROUP_UPDATED (async)
 */
export type PermissionGroupUpdate = {
  __typename?: 'PermissionGroupUpdate';
  errors: Array<PermissionGroupError>;
  group?: Maybe<Group>;
  /** @deprecated Use `errors` field instead. */
  permissionGroupErrors: Array<PermissionGroupError>;
};

export type PermissionGroupUpdateInput = {
  /** List of channels to assign to this group. */
  addChannels?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** List of permission code names to assign to this group. */
  addPermissions?: InputMaybe<Array<PermissionEnum>>;
  /** List of users to assign to this group. */
  addUsers?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Group name. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** List of channels to unassign from this group. */
  removeChannels?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** List of permission code names to unassign from this group. */
  removePermissions?: InputMaybe<Array<PermissionEnum>>;
  /** List of users to unassign from this group. */
  removeUsers?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Determine if the group has restricted access to channels. */
  restrictedAccessToChannels?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Event sent when permission group is updated. */
export type PermissionGroupUpdated = Event & {
  __typename?: 'PermissionGroupUpdated';
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<IssuingPrincipal>;
  /** The permission group the event relates to. */
  permissionGroup?: Maybe<Group>;
  /** The application receiving the webhook. */
  recipient?: Maybe<App>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

/** Plugin. */
export type Plugin = {
  __typename?: 'Plugin';
  /** Channel-specific plugin configuration. */
  channelConfigurations: Array<PluginConfiguration>;
  /** Description of the plugin. */
  description: Scalars['String']['output'];
  /** Global configuration of the plugin (not channel-specific). */
  globalConfiguration?: Maybe<PluginConfiguration>;
  /** Identifier of the plugin. */
  id: Scalars['ID']['output'];
  /** Name of the plugin. */
  name: Scalars['String']['output'];
};

/** Stores information about a configuration of plugin. */
export type PluginConfiguration = {
  __typename?: 'PluginConfiguration';
  /** Determines if plugin is active or not. */
  active: Scalars['Boolean']['output'];
  /** The channel to which the plugin configuration is assigned to. */
  channel?: Maybe<Channel>;
  /** Configuration of the plugin. */
  configuration?: Maybe<Array<ConfigurationItem>>;
};

export type PluginConfigurationType =
  | 'GLOBAL'
  | 'PER_CHANNEL';

export type PluginCountableConnection = {
  __typename?: 'PluginCountableConnection';
  edges: Array<PluginCountableEdge>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** A total count of items in the collection. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type PluginCountableEdge = {
  __typename?: 'PluginCountableEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Plugin;
};

export type PluginError = {
  __typename?: 'PluginError';
  /** The error code. */
  code: PluginErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field?: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message?: Maybe<Scalars['String']['output']>;
};

export type PluginErrorCode =
  | 'GRAPHQL_ERROR'
  | 'INVALID'
  | 'NOT_FOUND'
  | 'PLUGIN_MISCONFIGURED'
  | 'REQUIRED'
  | 'UNIQUE';

export type PluginFilterInput = {
  search?: InputMaybe<Scalars['String']['input']>;
  statusInChannels?: InputMaybe<PluginStatusInChannelsInput>;
  type?: InputMaybe<PluginConfigurationType>;
};

export type PluginSortField =
  | 'IS_ACTIVE'
  | 'NAME';

export type PluginSortingInput = {
  /** Specifies the direction in which to sort plugins. */
  direction: OrderDirection;
  /** Sort plugins by the selected field. */
  field: PluginSortField;
};

export type PluginStatusInChannelsInput = {
  active: Scalars['Boolean']['input'];
  channels: Array<Scalars['ID']['input']>;
};

/**
 * Update plugin configuration.
 *
 * Requires one of the following permissions: MANAGE_PLUGINS.
 */
export type PluginUpdate = {
  __typename?: 'PluginUpdate';
  errors: Array<PluginError>;
  plugin?: Maybe<Plugin>;
  /** @deprecated Use `errors` field instead. */
  pluginsErrors: Array<PluginError>;
};

export type PluginUpdateInput = {
  /** Indicates whether the plugin should be enabled. */
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** Configuration of the plugin. */
  configuration?: InputMaybe<Array<ConfigurationItemInput>>;
};

export type PostalCodeRuleInclusionTypeEnum =
  | 'EXCLUDE'
  | 'INCLUDE';

/** Represents preorder settings for product variant. */
export type PreorderData = {
  __typename?: 'PreorderData';
  /** Preorder end date. */
  endDate?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Total number of sold product variant during preorder.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  globalSoldUnits: Scalars['Int']['output'];
  /**
   * The global preorder threshold for product variant.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  globalThreshold?: Maybe<Scalars['Int']['output']>;
};

export type PreorderSettingsInput = {
  /** The end date for preorder. */
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** The global threshold for preorder variant. */
  globalThreshold?: InputMaybe<Scalars['Int']['input']>;
};

/** Represents preorder variant data for channel. */
export type PreorderThreshold = {
  __typename?: 'PreorderThreshold';
  /** Preorder threshold for product variant in this channel. */
  quantity?: Maybe<Scalars['Int']['output']>;
  /** Number of sold product variant in this channel. */
  soldUnits: Scalars['Int']['output'];
};

export type PriceFilterInput = {
  /** The amount of the price to filter by. */
  amount: DecimalFilterInput;
  /** The currency of the price to filter by. */
  currency?: InputMaybe<Scalars['String']['input']>;
};

export type PriceInput = {
  /** Amount of money. */
  amount: Scalars['PositiveDecimal']['input'];
  /** Currency code. */
  currency: Scalars['String']['input'];
};

export type PriceRangeInput = {
  /** Price greater than or equal to. */
  gte?: InputMaybe<Scalars['Float']['input']>;
  /** Price less than or equal to. */
  lte?: InputMaybe<Scalars['Float']['input']>;
};

/** Represents an individual item for sale in the storefront. */
export type Product = Node & ObjectWithAttributes & ObjectWithMetadata & {
  __typename?: 'Product';
  /**
   * Get a single attribute attached to product by attribute slug.
   *
   * Added in Saleor 3.22.
   */
  assignedAttribute?: Maybe<AssignedAttribute>;
  /**
   * List of attributes assigned to this product.
   *
   * Added in Saleor 3.22.
   */
  assignedAttributes: Array<AssignedAttribute>;
  /**
   * Get a single attribute attached to product by attribute slug.
   * @deprecated Use the `assignedAttribute` field instead.
   */
  attribute?: Maybe<SelectedAttribute>;
  /**
   * List of attributes assigned to this product.
   * @deprecated Use the `assignedAttributes` field instead.
   */
  attributes: Array<SelectedAttribute>;
  /**
   * Date when product is available for purchase.
   * @deprecated Use the `availableForPurchaseAt` field to fetch the available for purchase date.
   */
  availableForPurchase?: Maybe<Scalars['Date']['output']>;
  /** Date when product is available for purchase. */
  availableForPurchaseAt?: Maybe<Scalars['DateTime']['output']>;
  category?: Maybe<Category>;
  /** Channel given to retrieve this product. Also used by federation gateway to resolve this object in a federated query. */
  channel?: Maybe<Scalars['String']['output']>;
  /**
   * List of availability in channels for the product.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  channelListings?: Maybe<Array<ProductChannelListing>>;
  /** @deprecated Use `Channel.taxConfiguration` field to determine whether tax collection is enabled. */
  chargeTaxes: Scalars['Boolean']['output'];
  /** List of collections for the product. Requires the following permissions to include the unpublished items: MANAGE_ORDERS, MANAGE_DISCOUNTS, MANAGE_PRODUCTS. */
  collections?: Maybe<Array<Collection>>;
  /** The date and time when the product was created. */
  created: Scalars['DateTime']['output'];
  /** Default variant of the product. */
  defaultVariant?: Maybe<ProductVariant>;
  /**
   * Description of the product.
   *
   * Rich text format. For reference see https://editorjs.io/
   */
  description?: Maybe<Scalars['JSONString']['output']>;
  /**
   * Description of the product.
   *
   * Rich text format. For reference see https://editorjs.io/
   * @deprecated Use the `description` field instead.
   */
  descriptionJson?: Maybe<Scalars['JSONString']['output']>;
  /** External ID of this product. */
  externalReference?: Maybe<Scalars['String']['output']>;
  /** The ID of the product. */
  id: Scalars['ID']['output'];
  /**
   * Get a single product image by ID.
   * @deprecated Use the `mediaById` field instead.
   */
  imageById?: Maybe<ProductImage>;
  /**
   * List of images for the product.
   * @deprecated Use the `media` field instead.
   */
  images?: Maybe<Array<ProductImage>>;
  /** Whether the product is in stock, set as available for purchase in the given channel, and published. */
  isAvailable?: Maybe<Scalars['Boolean']['output']>;
  /** Refers to a state that can be set by admins to control whether a product is available for purchase in storefronts. This does not guarantee the availability of stock. When set to `False`, this product is still visible to customers, but it cannot be purchased. */
  isAvailableForPurchase?: Maybe<Scalars['Boolean']['output']>;
  /** List of media for the product. */
  media?: Maybe<Array<ProductMedia>>;
  /** Get a single product media by ID. */
  mediaById?: Maybe<ProductMedia>;
  /** List of public metadata items. Can be accessed without permissions. */
  metadata: Array<MetadataItem>;
  /**
   * A single key from public metadata.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   */
  metafield?: Maybe<Scalars['String']['output']>;
  /** Public metadata. Use `keys` to control which fields you want to include. The default is to include everything. */
  metafields?: Maybe<Scalars['Metadata']['output']>;
  /** SEO description of the product. */
  name: Scalars['String']['output'];
  /** Lists the storefront product's pricing, the current price and discounts, only meant for displaying. */
  pricing?: Maybe<ProductPricingInfo>;
  /** List of private metadata items. Requires staff permissions to access. */
  privateMetadata: Array<MetadataItem>;
  /**
   * A single key from private metadata. Requires staff permissions to access.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   */
  privateMetafield?: Maybe<Scalars['String']['output']>;
  /** Private metadata. Requires staff permissions to access. Use `keys` to control which fields you want to include. The default is to include everything. */
  privateMetafields?: Maybe<Scalars['Metadata']['output']>;
  /** Type of the product. */
  productType: ProductType;
  /**
   * List of variants for the product. Requires the following permissions to include the unpublished items: MANAGE_ORDERS, MANAGE_DISCOUNTS, MANAGE_PRODUCTS.
   *
   * Added in Saleor 3.21.
   */
  productVariants?: Maybe<ProductVariantCountableConnection>;
  /** Rating of the product. */
  rating?: Maybe<Scalars['Float']['output']>;
  /** SEO description of the product. */
  seoDescription?: Maybe<Scalars['String']['output']>;
  /** SEO title of the product. */
  seoTitle?: Maybe<Scalars['String']['output']>;
  /** Slug of the product. */
  slug: Scalars['String']['output'];
  /**
   * Tax class assigned to this product type. All products of this product type use this tax class, unless it's overridden in the `Product` type.
   *
   * Requires one of the following permissions: AUTHENTICATED_STAFF_USER, AUTHENTICATED_APP.
   */
  taxClass?: Maybe<TaxClass>;
  /**
   * A type of tax. Assigned by enabled tax gateway
   * @deprecated Use `taxClass` field instead.
   */
  taxType?: Maybe<TaxType>;
  /** Thumbnail of the product. */
  thumbnail?: Maybe<Image>;
  /** Returns translated product fields for the given language code. */
  translation?: Maybe<ProductTranslation>;
  /** The date and time when the product was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  /**
   * Get a single variant by SKU or ID.
   * @deprecated Use top-level `variant` query.
   */
  variant?: Maybe<ProductVariant>;
  /**
   * List of variants for the product. Requires the following permissions to include the unpublished items: MANAGE_ORDERS, MANAGE_DISCOUNTS, MANAGE_PRODUCTS.
   * @deprecated Use `productVariants` field instead.
   */
  variants?: Maybe<Array<ProductVariant>>;
  /** Weight of the product. */
  weight?: Maybe<Weight>;
};


/** Represents an individual item for sale in the storefront. */
export type ProductAssignedAttributeArgs = {
  slug: Scalars['String']['input'];
};


/** Represents an individual item for sale in the storefront. */
export type ProductAssignedAttributesArgs = {
  limit?: InputMaybe<Scalars['PositiveInt']['input']>;
};


/** Represents an individual item for sale in the storefront. */
export type ProductAttributeArgs = {
  slug: Scalars['String']['input'];
};


/** Represents an individual item for sale in the storefront. */
export type ProductImageByIdArgs = {
  id: Scalars['ID']['input'];
};


/** Represents an individual item for sale in the storefront. */
export type ProductIsAvailableArgs = {
  address?: InputMaybe<AddressInput>;
};


/** Represents an individual item for sale in the storefront. */
export type ProductMediaArgs = {
  sortBy?: InputMaybe<MediaSortingInput>;
};


/** Represents an individual item for sale in the storefront. */
export type ProductMediaByIdArgs = {
  id: Scalars['ID']['input'];
};


/** Represents an individual item for sale in the storefront. */
export type ProductMetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Represents an individual item for sale in the storefront. */
export type ProductMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Represents an individual item for sale in the storefront. */
export type ProductPricingArgs = {
  address?: InputMaybe<AddressInput>;
};


/** Represents an individual item for sale in the storefront. */
export type ProductPrivateMetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Represents an individual item for sale in the storefront. */
export type ProductPrivateMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Represents an individual item for sale in the storefront. */
export type ProductProductVariantsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ProductVariantFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<ProductVariantSortingInput>;
  where?: InputMaybe<ProductVariantWhereInput>;
};


/** Represents an individual item for sale in the storefront. */
export type ProductThumbnailArgs = {
  format?: InputMaybe<ThumbnailFormatEnum>;
  size?: InputMaybe<Scalars['Int']['input']>;
};


/** Represents an individual item for sale in the storefront. */
export type ProductTranslationArgs = {
  languageCode: LanguageCodeEnum;
};


/** Represents an individual item for sale in the storefront. */
export type ProductVariantArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  sku?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Assign attributes to a given product type.
 *
 * Requires one of the following permissions: MANAGE_PRODUCT_TYPES_AND_ATTRIBUTES.
 */
export type ProductAttributeAssign = {
  __typename?: 'ProductAttributeAssign';
  errors: Array<ProductError>;
  /** @deprecated Use `errors` field instead. */
  productErrors: Array<ProductError>;
  /** The updated product type. */
  productType?: Maybe<ProductType>;
};

export type ProductAttributeAssignInput = {
  /** The ID of the attribute to assign. */
  id: Scalars['ID']['input'];
  /** The attribute type to be assigned as. */
  type: ProductAttributeType;
  /** Whether attribute is allowed in variant selection. Allowed types are: ['dropdown', 'boolean', 'swatch', 'numeric']. */
  variantSelection?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * Update attributes assigned to product variant for given product type.
 *
 * Requires one of the following permissions: MANAGE_PRODUCT_TYPES_AND_ATTRIBUTES.
 */
export type ProductAttributeAssignmentUpdate = {
  __typename?: 'ProductAttributeAssignmentUpdate';
  errors: Array<ProductError>;
  /** @deprecated Use `errors` field instead. */
  productErrors: Array<ProductError>;
  /** The updated product type. */
  productType?: Maybe<ProductType>;
};

export type ProductAttributeAssignmentUpdateInput = {
  /** The ID of the attribute to assign. */
  id: Scalars['ID']['input'];
  /** Whether attribute is allowed in variant selection. Allowed types are: ['dropdown', 'boolean', 'swatch', 'numeric']. */
  variantSelection: Scalars['Boolean']['input'];
};

export type ProductAttributeType =
  | 'PRODUCT'
  | 'VARIANT';

/**
 * Un-assign attributes from a given product type.
 *
 * Requires one of the following permissions: MANAGE_PRODUCT_TYPES_AND_ATTRIBUTES.
 */
export type ProductAttributeUnassign = {
  __typename?: 'ProductAttributeUnassign';
  errors: Array<ProductError>;
  /** @deprecated Use `errors` field instead. */
  productErrors: Array<ProductError>;
  /** The updated product type. */
  productType?: Maybe<ProductType>;
};

/**
 * Creates products.
 *
 * Requires one of the following permissions: MANAGE_PRODUCTS.
 */
export type ProductBulkCreate = {
  __typename?: 'ProductBulkCreate';
  /** Returns how many objects were created. */
  count: Scalars['Int']['output'];
  errors: Array<ProductBulkCreateError>;
  /** List of the created products. */
  results: Array<ProductBulkResult>;
};

export type ProductBulkCreateError = {
  __typename?: 'ProductBulkCreateError';
  /** List of attributes IDs which causes the error. */
  attributes?: Maybe<Array<Scalars['ID']['output']>>;
  /** List of channel IDs which causes the error. */
  channels?: Maybe<Array<Scalars['ID']['output']>>;
  /** The error code. */
  code: ProductBulkCreateErrorCode;
  /** The error message. */
  message?: Maybe<Scalars['String']['output']>;
  /** Path to field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  path?: Maybe<Scalars['String']['output']>;
  /** List of attribute values IDs which causes the error. */
  values?: Maybe<Array<Scalars['ID']['output']>>;
  /** List of warehouse IDs which causes the error. */
  warehouses?: Maybe<Array<Scalars['ID']['output']>>;
};

export type ProductBulkCreateErrorCode =
  | 'ATTRIBUTE_ALREADY_ASSIGNED'
  | 'ATTRIBUTE_CANNOT_BE_ASSIGNED'
  | 'ATTRIBUTE_VARIANTS_DISABLED'
  | 'BLANK'
  | 'DUPLICATED_INPUT_ITEM'
  | 'FILE_SIZE_LIMIT_EXCEEDED'
  | 'GRAPHQL_ERROR'
  | 'INVALID'
  | 'INVALID_PRICE'
  | 'MAX_LENGTH'
  | 'NOT_FOUND'
  | 'PRODUCT_NOT_ASSIGNED_TO_CHANNEL'
  | 'PRODUCT_WITHOUT_CATEGORY'
  | 'REQUIRED'
  | 'UNIQUE'
  | 'UNSUPPORTED_MEDIA_PROVIDER';

export type ProductBulkCreateInput = {
  /** List of attributes. */
  attributes?: InputMaybe<Array<AttributeValueInput>>;
  /** ID of the product's category. */
  category?: InputMaybe<Scalars['ID']['input']>;
  /** List of channels in which the product is available. */
  channelListings?: InputMaybe<Array<ProductChannelListingCreateInput>>;
  /**
   * Determine if taxes are being charged for the product.
   *
   * DEPRECATED: this field will be removed. Use `Channel.taxConfiguration` to configure whether tax collection is enabled.
   */
  chargeTaxes?: InputMaybe<Scalars['Boolean']['input']>;
  /** List of IDs of collections that the product belongs to. */
  collections?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**
   * Product description.
   *
   * Rich text format. For reference see https://editorjs.io/
   */
  description?: InputMaybe<Scalars['JSONString']['input']>;
  /** External ID of this product. */
  externalReference?: InputMaybe<Scalars['String']['input']>;
  /** List of media inputs associated with the product. */
  media?: InputMaybe<Array<MediaInput>>;
  /**
   * Fields required to update the product metadata. Can be read by any API client authorized to read the object it's attached to.
   *
   * Warning: never store sensitive information, including financial data such as credit card details.
   */
  metadata?: InputMaybe<Array<MetadataInput>>;
  /** Product name. */
  name?: InputMaybe<Scalars['String']['input']>;
  /**
   * Fields required to update the product private metadata. Requires permissions to modify and to read the metadata of the object it's attached to.
   *
   * Warning: never store sensitive information, including financial data such as credit card details.
   */
  privateMetadata?: InputMaybe<Array<MetadataInput>>;
  /** ID of the type that product belongs to. */
  productType: Scalars['ID']['input'];
  /** Defines the product rating value. */
  rating?: InputMaybe<Scalars['Float']['input']>;
  /** Search engine optimization fields. */
  seo?: InputMaybe<SeoInput>;
  /** Product slug. */
  slug?: InputMaybe<Scalars['String']['input']>;
  /** ID of a tax class to assign to this product. If not provided, product will use the tax class which is assigned to the product type. */
  taxClass?: InputMaybe<Scalars['ID']['input']>;
  /**
   * Tax rate for enabled tax gateway.
   *
   * DEPRECATED: this field will be removed. Use tax classes to control the tax calculation for a product. If taxCode is provided, Saleor will try to find a tax class with given code (codes are stored in metadata) and assign it. If no tax class is found, it would be created and assigned.
   */
  taxCode?: InputMaybe<Scalars['String']['input']>;
  /** Input list of product variants to create. */
  variants?: InputMaybe<Array<ProductVariantBulkCreateInput>>;
  /** Weight of the Product. */
  weight?: InputMaybe<Scalars['WeightScalar']['input']>;
};

/**
 * Deletes products.
 *
 * Requires one of the following permissions: MANAGE_PRODUCTS.
 */
export type ProductBulkDelete = {
  __typename?: 'ProductBulkDelete';
  /** Returns how many objects were affected. */
  count: Scalars['Int']['output'];
  errors: Array<ProductError>;
  /** @deprecated Use `errors` field instead. */
  productErrors: Array<ProductError>;
};

export type ProductBulkResult = {
  __typename?: 'ProductBulkResult';
  /** List of errors occurred on create attempt. */
  errors?: Maybe<Array<ProductBulkCreateError>>;
  /** Product data. */
  product?: Maybe<Product>;
};

/**
 * Creates/updates translations for products.
 *
 * Requires one of the following permissions: MANAGE_TRANSLATIONS.
 *
 * Triggers the following webhook events:
 * - TRANSLATION_CREATED (async): Called when a translation was created.
 * - TRANSLATION_UPDATED (async): Called when a translation was updated.
 */
export type ProductBulkTranslate = {
  __typename?: 'ProductBulkTranslate';
  /** Returns how many translations were created/updated. */
  count: Scalars['Int']['output'];
  errors: Array<ProductBulkTranslateError>;
  /** List of the translations. */
  results: Array<ProductBulkTranslateResult>;
};

export type ProductBulkTranslateError = {
  __typename?: 'ProductBulkTranslateError';
  /** The error code. */
  code: ProductTranslateErrorCode;
  /** The error message. */
  message?: Maybe<Scalars['String']['output']>;
  /** Path to field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  path?: Maybe<Scalars['String']['output']>;
};

export type ProductBulkTranslateInput = {
  /** External reference of an product. */
  externalReference?: InputMaybe<Scalars['String']['input']>;
  /** Product ID. */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Translation language code. */
  languageCode: LanguageCodeEnum;
  /** Translation fields. */
  translationFields: TranslationInput;
};

export type ProductBulkTranslateResult = {
  __typename?: 'ProductBulkTranslateResult';
  /** List of errors occurred on translation attempt. */
  errors?: Maybe<Array<ProductBulkTranslateError>>;
  /** Product translation data. */
  translation?: Maybe<ProductTranslation>;
};

/** Represents product channel listing. */
export type ProductChannelListing = Node & {
  __typename?: 'ProductChannelListing';
  /** @deprecated Use the `availableForPurchaseAt` field to fetch the available for purchase date. */
  availableForPurchase?: Maybe<Scalars['Date']['output']>;
  /** The product available for purchase date time. */
  availableForPurchaseAt?: Maybe<Scalars['DateTime']['output']>;
  /** The channel in which the product is listed. */
  channel: Channel;
  /** The price of the cheapest variant (including discounts). */
  discountedPrice?: Maybe<Money>;
  /** The ID of the product channel listing. */
  id: Scalars['ID']['output'];
  /** Refers to a state that can be set by admins to control whether a product is available for purchase in storefronts in this channel. This does not guarantee the availability of stock. When set to `False`, this product is still visible to customers, but it cannot be purchased. */
  isAvailableForPurchase?: Maybe<Scalars['Boolean']['output']>;
  /** Indicates if the product is published in the channel. */
  isPublished: Scalars['Boolean']['output'];
  /**
   * Range of margin percentage value.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  margin?: Maybe<Margin>;
  /** Lists the storefront product's pricing, the current price and discounts, only meant for displaying. */
  pricing?: Maybe<ProductPricingInfo>;
  /** @deprecated Use the `publishedAt` field to fetch the publication date. */
  publicationDate?: Maybe<Scalars['Date']['output']>;
  /** The product publication date time. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Purchase cost of product.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  purchaseCost?: Maybe<MoneyRange>;
  /** Indicates product visibility in the channel listings. */
  visibleInListings: Scalars['Boolean']['output'];
};


/** Represents product channel listing. */
export type ProductChannelListingPricingArgs = {
  address?: InputMaybe<AddressInput>;
};

export type ProductChannelListingAddInput = {
  /** List of variants to which the channel should be assigned. */
  addVariants?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** A start date time from which a product will be available for purchase. When not set and `isAvailable` is set to True, the current day is assumed. */
  availableForPurchaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  /**
   * A start date from which a product will be available for purchase. When not set and isAvailable is set to True, the current day is assumed.
   *
   * DEPRECATED: this field will be removed. Use `availableForPurchaseAt` field instead.
   */
  availableForPurchaseDate?: InputMaybe<Scalars['Date']['input']>;
  /** ID of a channel. */
  channelId: Scalars['ID']['input'];
  /** Determines if product should be available for purchase in this channel. This does not guarantee the availability of stock. When set to `False`, this product is still visible to customers, but it cannot be purchased. */
  isAvailableForPurchase?: InputMaybe<Scalars['Boolean']['input']>;
  /** Determines if object is visible to customers. */
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Publication date. ISO 8601 standard.
   *
   * DEPRECATED: this field will be removed. Use `publishedAt` field instead.
   */
  publicationDate?: InputMaybe<Scalars['Date']['input']>;
  /** Publication date time. ISO 8601 standard. */
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** List of variants from which the channel should be unassigned. */
  removeVariants?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Determines if product is visible in product listings (doesn't apply to product collections). */
  visibleInListings?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProductChannelListingCreateInput = {
  /** A start date time from which a product will be available for purchase. When not set and `isAvailable` is set to True, the current day is assumed. */
  availableForPurchaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** ID of a channel. */
  channelId: Scalars['ID']['input'];
  /** Determines if product should be available for purchase in this channel. This does not guarantee the availability of stock. When set to `False`, this product is still visible to customers, but it cannot be purchased. */
  isAvailableForPurchase?: InputMaybe<Scalars['Boolean']['input']>;
  /** Determines if object is visible to customers. */
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  /** Publication date time. ISO 8601 standard. */
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Determines if product is visible in product listings (doesn't apply to product collections). */
  visibleInListings?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProductChannelListingError = {
  __typename?: 'ProductChannelListingError';
  /** List of attributes IDs which causes the error. */
  attributes?: Maybe<Array<Scalars['ID']['output']>>;
  /** List of channels IDs which causes the error. */
  channels?: Maybe<Array<Scalars['ID']['output']>>;
  /** The error code. */
  code: ProductErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field?: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message?: Maybe<Scalars['String']['output']>;
  /** List of attribute values IDs which causes the error. */
  values?: Maybe<Array<Scalars['ID']['output']>>;
  /** List of variants IDs which causes the error. */
  variants?: Maybe<Array<Scalars['ID']['output']>>;
};

/**
 * Manage product's availability in channels.
 *
 * Requires one of the following permissions: MANAGE_PRODUCTS.
 */
export type ProductChannelListingUpdate = {
  __typename?: 'ProductChannelListingUpdate';
  errors: Array<ProductChannelListingError>;
  /** An updated product instance. */
  product?: Maybe<Product>;
  /** @deprecated Use `errors` field instead. */
  productChannelListingErrors: Array<ProductChannelListingError>;
};

export type ProductChannelListingUpdateInput = {
  /** List of channels from which the product should be unassigned. */
  removeChannels?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** List of channels to which the product should be assigned or updated. */
  updateChannels?: InputMaybe<Array<ProductChannelListingAddInput>>;
};

export type ProductCountableConnection = {
  __typename?: 'ProductCountableConnection';
  edges: Array<ProductCountableEdge>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** A total count of items in the collection. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type ProductCountableEdge = {
  __typename?: 'ProductCountableEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Product;
};

/**
 * Creates a new product.
 *
 * Requires one of the following permissions: MANAGE_PRODUCTS.
 */
export type ProductCreate = {
  __typename?: 'ProductCreate';
  errors: Array<ProductError>;
  product?: Maybe<Product>;
  /** @deprecated Use `errors` field instead. */
  productErrors: Array<ProductError>;
};

export type ProductCreateInput = {
  /** List of attributes. */
  attributes?: InputMaybe<Array<AttributeValueInput>>;
  /** ID of the product's category. */
  category?: InputMaybe<Scalars['ID']['input']>;
  /**
   * Determine if taxes are being charged for the product.
   *
   * DEPRECATED: this field will be removed. Use `Channel.taxConfiguration` to configure whether tax collection is enabled.
   */
  chargeTaxes?: InputMaybe<Scalars['Boolean']['input']>;
  /** List of IDs of collections that the product belongs to. */
  collections?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**
   * Product description.
   *
   * Rich text format. For reference see https://editorjs.io/
   */
  description?: InputMaybe<Scalars['JSONString']['input']>;
  /** External ID of this product. */
  externalReference?: InputMaybe<Scalars['String']['input']>;
  /**
   * Fields required to update the product metadata. Can be read by any API client authorized to read the object it's attached to.
   *
   * Warning: never store sensitive information, including financial data such as credit card details.
   */
  metadata?: InputMaybe<Array<MetadataInput>>;
  /** Product name. */
  name?: InputMaybe<Scalars['String']['input']>;
  /**
   * Fields required to update the product private metadata. Requires permissions to modify and to read the metadata of the object it's attached to.
   *
   * Warning: never store sensitive information, including financial data such as credit card details.
   */
  privateMetadata?: InputMaybe<Array<MetadataInput>>;
  /** ID of the type that product belongs to. */
  productType: Scalars['ID']['input'];
  /** Defines the product rating value. */
  rating?: InputMaybe<Scalars['Float']['input']>;
  /** Search engine optimization fields. */
  seo?: InputMaybe<SeoInput>;
  /** Product slug. */
  slug?: InputMaybe<Scalars['String']['input']>;
  /** ID of a tax class to assign to this product. If not provided, product will use the tax class which is assigned to the product type. */
  taxClass?: InputMaybe<Scalars['ID']['input']>;
  /**
   * Tax rate for enabled tax gateway.
   *
   * DEPRECATED: this field will be removed. Use tax classes to control the tax calculation for a product. If taxCode is provided, Saleor will try to find a tax class with given code (codes are stored in metadata) and assign it. If no tax class is found, it would be created and assigned.
   */
  taxCode?: InputMaybe<Scalars['String']['input']>;
  /** Weight of the Product. */
  weight?: InputMaybe<Scalars['WeightScalar']['input']>;
};

/** Event sent when new product is created. */
export type ProductCreated = Event & {
  __typename?: 'ProductCreated';
  /** The category of the product. */
  category?: Maybe<Category>;
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<IssuingPrincipal>;
  /** The product the event relates to. */
  product?: Maybe<Product>;
  /** The application receiving the webhook. */
  recipient?: Maybe<App>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};


/** Event sent when new product is created. */
export type ProductCreatedProductArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Deletes a product.
 *
 * Requires one of the following permissions: MANAGE_PRODUCTS.
 */
export type ProductDelete = {
  __typename?: 'ProductDelete';
  errors: Array<ProductError>;
  product?: Maybe<Product>;
  /** @deprecated Use `errors` field instead. */
  productErrors: Array<ProductError>;
};

/** Event sent when product is deleted. */
export type ProductDeleted = Event & {
  __typename?: 'ProductDeleted';
  /** The category of the product. */
  category?: Maybe<Category>;
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<IssuingPrincipal>;
  /** The product the event relates to. */
  product?: Maybe<Product>;
  /** The application receiving the webhook. */
  recipient?: Maybe<App>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};


/** Event sent when product is deleted. */
export type ProductDeletedProductArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
};

export type ProductError = {
  __typename?: 'ProductError';
  /** List of attributes IDs which causes the error. */
  attributes?: Maybe<Array<Scalars['ID']['output']>>;
  /** The error code. */
  code: ProductErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field?: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message?: Maybe<Scalars['String']['output']>;
  /** List of attribute values IDs which causes the error. */
  values?: Maybe<Array<Scalars['ID']['output']>>;
};

export type ProductErrorCode =
  | 'ALREADY_EXISTS'
  | 'ATTRIBUTE_ALREADY_ASSIGNED'
  | 'ATTRIBUTE_CANNOT_BE_ASSIGNED'
  | 'ATTRIBUTE_VARIANTS_DISABLED'
  | 'CANNOT_MANAGE_PRODUCT_WITHOUT_VARIANT'
  | 'DUPLICATED_INPUT_ITEM'
  | 'FILE_SIZE_LIMIT_EXCEEDED'
  | 'GRAPHQL_ERROR'
  | 'INVALID'
  | 'INVALID_FILE_TYPE'
  | 'INVALID_PRICE'
  | 'MEDIA_ALREADY_ASSIGNED'
  | 'NOT_FOUND'
  | 'NOT_PRODUCTS_IMAGE'
  | 'NOT_PRODUCTS_VARIANT'
  | 'PREORDER_VARIANT_CANNOT_BE_DEACTIVATED'
  | 'PRODUCT_NOT_ASSIGNED_TO_CHANNEL'
  | 'PRODUCT_WITHOUT_CATEGORY'
  | 'REQUIRED'
  | 'UNIQUE'
  | 'UNSUPPORTED_MEDIA_PROVIDER'
  | 'UNSUPPORTED_MIME_TYPE'
  | 'VARIANT_NO_DIGITAL_CONTENT';

/** Event sent when product export is completed. */
export type ProductExportCompleted = Event & {
  __typename?: 'ProductExportCompleted';
  /** The export file for products. */
  export?: Maybe<ExportFile>;
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<IssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient?: Maybe<App>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

export type ProductFieldEnum =
  | 'CATEGORY'
  | 'CHARGE_TAXES'
  | 'COLLECTIONS'
  | 'DESCRIPTION'
  | 'NAME'
  | 'PRODUCT_MEDIA'
  | 'PRODUCT_TYPE'
  | 'PRODUCT_WEIGHT'
  | 'VARIANT_ID'
  | 'VARIANT_MEDIA'
  | 'VARIANT_SKU'
  | 'VARIANT_WEIGHT';

export type ProductFilterInput = {
  attributes?: InputMaybe<Array<AttributeInput>>;
  /** Filter by the date of availability for purchase. */
  availableFrom?: InputMaybe<Scalars['DateTime']['input']>;
  categories?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**
   * Specifies the channel by which the data should be filtered.
   *
   * DEPRECATED: this field will be removed. Use root-level channel argument instead.
   */
  channel?: InputMaybe<Scalars['String']['input']>;
  collections?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter on whether product is a gift card or not. */
  giftCard?: InputMaybe<Scalars['Boolean']['input']>;
  hasCategory?: InputMaybe<Scalars['Boolean']['input']>;
  hasPreorderedVariants?: InputMaybe<Scalars['Boolean']['input']>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter by availability for purchase. */
  isAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by visibility in product listings. */
  isVisibleInListing?: InputMaybe<Scalars['Boolean']['input']>;
  metadata?: InputMaybe<Array<MetadataFilter>>;
  /** Filter by the lowest variant price after discounts. */
  minimalPrice?: InputMaybe<PriceRangeInput>;
  price?: InputMaybe<PriceRangeInput>;
  productTypes?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter by the publication date. */
  publishedFrom?: InputMaybe<Scalars['DateTime']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter by variants having specific stock status. */
  stockAvailability?: InputMaybe<StockAvailability>;
  stocks?: InputMaybe<ProductStockFilterInput>;
  /** Filter by when was the most recent update. */
  updatedAt?: InputMaybe<DateTimeRangeInput>;
};

/** Represents a product image. */
export type ProductImage = {
  __typename?: 'ProductImage';
  /** The alt text of the image. */
  alt?: Maybe<Scalars['String']['output']>;
  /** The ID of the image. */
  id: Scalars['ID']['output'];
  /** The new relative sorting position of the item (from -inf to +inf). 1 moves the item one position forward, -1 moves the item one position backward, 0 leaves the item unchanged. */
  sortOrder?: Maybe<Scalars['Int']['output']>;
  /** The URL of the image. */
  url: Scalars['String']['output'];
};


/** Represents a product image. */
export type ProductImageUrlArgs = {
  format?: InputMaybe<ThumbnailFormatEnum>;
  size?: InputMaybe<Scalars['Int']['input']>;
};

export type ProductInput = {
  /** List of attributes. */
  attributes?: InputMaybe<Array<AttributeValueInput>>;
  /** ID of the product's category. */
  category?: InputMaybe<Scalars['ID']['input']>;
  /**
   * Determine if taxes are being charged for the product.
   *
   * DEPRECATED: this field will be removed. Use `Channel.taxConfiguration` to configure whether tax collection is enabled.
   */
  chargeTaxes?: InputMaybe<Scalars['Boolean']['input']>;
  /** List of IDs of collections that the product belongs to. */
  collections?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**
   * Product description.
   *
   * Rich text format. For reference see https://editorjs.io/
   */
  description?: InputMaybe<Scalars['JSONString']['input']>;
  /** External ID of this product. */
  externalReference?: InputMaybe<Scalars['String']['input']>;
  /**
   * Fields required to update the product metadata. Can be read by any API client authorized to read the object it's attached to.
   *
   * Warning: never store sensitive information, including financial data such as credit card details.
   */
  metadata?: InputMaybe<Array<MetadataInput>>;
  /** Product name. */
  name?: InputMaybe<Scalars['String']['input']>;
  /**
   * Fields required to update the product private metadata. Requires permissions to modify and to read the metadata of the object it's attached to.
   *
   * Warning: never store sensitive information, including financial data such as credit card details.
   */
  privateMetadata?: InputMaybe<Array<MetadataInput>>;
  /** Defines the product rating value. */
  rating?: InputMaybe<Scalars['Float']['input']>;
  /** Search engine optimization fields. */
  seo?: InputMaybe<SeoInput>;
  /** Product slug. */
  slug?: InputMaybe<Scalars['String']['input']>;
  /** ID of a tax class to assign to this product. If not provided, product will use the tax class which is assigned to the product type. */
  taxClass?: InputMaybe<Scalars['ID']['input']>;
  /**
   * Tax rate for enabled tax gateway.
   *
   * DEPRECATED: this field will be removed. Use tax classes to control the tax calculation for a product. If taxCode is provided, Saleor will try to find a tax class with given code (codes are stored in metadata) and assign it. If no tax class is found, it would be created and assigned.
   */
  taxCode?: InputMaybe<Scalars['String']['input']>;
  /** Weight of the Product. */
  weight?: InputMaybe<Scalars['WeightScalar']['input']>;
};

/** Represents a product media. */
export type ProductMedia = Node & ObjectWithMetadata & {
  __typename?: 'ProductMedia';
  /** The alt text of the media. */
  alt: Scalars['String']['output'];
  /** The unique ID of the product media. */
  id: Scalars['ID']['output'];
  /** List of public metadata items. Can be accessed without permissions. */
  metadata: Array<MetadataItem>;
  /**
   * A single key from public metadata.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   */
  metafield?: Maybe<Scalars['String']['output']>;
  /** Public metadata. Use `keys` to control which fields you want to include. The default is to include everything. */
  metafields?: Maybe<Scalars['Metadata']['output']>;
  /** The oEmbed data of the media. */
  oembedData: Scalars['JSONString']['output'];
  /** List of private metadata items. Requires staff permissions to access. */
  privateMetadata: Array<MetadataItem>;
  /**
   * A single key from private metadata. Requires staff permissions to access.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   */
  privateMetafield?: Maybe<Scalars['String']['output']>;
  /** Private metadata. Requires staff permissions to access. Use `keys` to control which fields you want to include. The default is to include everything. */
  privateMetafields?: Maybe<Scalars['Metadata']['output']>;
  /** Product id the media refers to. */
  productId?: Maybe<Scalars['ID']['output']>;
  /** The sort order of the media. */
  sortOrder?: Maybe<Scalars['Int']['output']>;
  /** The type of the media. */
  type: ProductMediaType;
  /** The URL of the media. */
  url: Scalars['String']['output'];
};


/** Represents a product media. */
export type ProductMediaMetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Represents a product media. */
export type ProductMediaMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Represents a product media. */
export type ProductMediaPrivateMetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Represents a product media. */
export type ProductMediaPrivateMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Represents a product media. */
export type ProductMediaUrlArgs = {
  format?: InputMaybe<ThumbnailFormatEnum>;
  size?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * Deletes product media.
 *
 * Requires one of the following permissions: MANAGE_PRODUCTS.
 */
export type ProductMediaBulkDelete = {
  __typename?: 'ProductMediaBulkDelete';
  /** Returns how many objects were affected. */
  count: Scalars['Int']['output'];
  errors: Array<ProductError>;
  /** @deprecated Use `errors` field instead. */
  productErrors: Array<ProductError>;
};

/**
 * Create a media object (image or video URL) associated with product. For image, this mutation must be sent as a `multipart` request. More detailed specs of the upload format can be found here: https://github.com/jaydenseric/graphql-multipart-request-spec
 *
 * Requires one of the following permissions: MANAGE_PRODUCTS.
 */
export type ProductMediaCreate = {
  __typename?: 'ProductMediaCreate';
  errors: Array<ProductError>;
  media?: Maybe<ProductMedia>;
  product?: Maybe<Product>;
  /** @deprecated Use `errors` field instead. */
  productErrors: Array<ProductError>;
};

export type ProductMediaCreateInput = {
  /** Alt text for a product media. */
  alt?: InputMaybe<Scalars['String']['input']>;
  /** Represents an image file in a multipart request. */
  image?: InputMaybe<Scalars['Upload']['input']>;
  /** Represents an URL to an external media. */
  mediaUrl?: InputMaybe<Scalars['String']['input']>;
  /** ID of an product. */
  product: Scalars['ID']['input'];
};

/** Event sent when new product media is created. */
export type ProductMediaCreated = Event & {
  __typename?: 'ProductMediaCreated';
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<IssuingPrincipal>;
  /** The product media the event relates to. */
  productMedia?: Maybe<ProductMedia>;
  /** The application receiving the webhook. */
  recipient?: Maybe<App>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

/**
 * Deletes a product media.
 *
 * Requires one of the following permissions: MANAGE_PRODUCTS.
 */
export type ProductMediaDelete = {
  __typename?: 'ProductMediaDelete';
  errors: Array<ProductError>;
  media?: Maybe<ProductMedia>;
  product?: Maybe<Product>;
  /** @deprecated Use `errors` field instead. */
  productErrors: Array<ProductError>;
};

/** Event sent when product media is deleted. */
export type ProductMediaDeleted = Event & {
  __typename?: 'ProductMediaDeleted';
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<IssuingPrincipal>;
  /** The product media the event relates to. */
  productMedia?: Maybe<ProductMedia>;
  /** The application receiving the webhook. */
  recipient?: Maybe<App>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

/**
 * Changes ordering of the product media.
 *
 * Requires one of the following permissions: MANAGE_PRODUCTS.
 */
export type ProductMediaReorder = {
  __typename?: 'ProductMediaReorder';
  errors: Array<ProductError>;
  media?: Maybe<Array<ProductMedia>>;
  product?: Maybe<Product>;
  /** @deprecated Use `errors` field instead. */
  productErrors: Array<ProductError>;
};

export type ProductMediaType =
  | 'IMAGE'
  | 'VIDEO';

/**
 * Updates a product media.
 *
 * Requires one of the following permissions: MANAGE_PRODUCTS.
 */
export type ProductMediaUpdate = {
  __typename?: 'ProductMediaUpdate';
  errors: Array<ProductError>;
  media?: Maybe<ProductMedia>;
  product?: Maybe<Product>;
  /** @deprecated Use `errors` field instead. */
  productErrors: Array<ProductError>;
};

export type ProductMediaUpdateInput = {
  /** Alt text for a product media. */
  alt?: InputMaybe<Scalars['String']['input']>;
};

/** Event sent when product media is updated. */
export type ProductMediaUpdated = Event & {
  __typename?: 'ProductMediaUpdated';
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<IssuingPrincipal>;
  /** The product media the event relates to. */
  productMedia?: Maybe<ProductMedia>;
  /** The application receiving the webhook. */
  recipient?: Maybe<App>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

/** Event sent when product metadata is updated. */
export type ProductMetadataUpdated = Event & {
  __typename?: 'ProductMetadataUpdated';
  /** The category of the product. */
  category?: Maybe<Category>;
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<IssuingPrincipal>;
  /** The product the event relates to. */
  product?: Maybe<Product>;
  /** The application receiving the webhook. */
  recipient?: Maybe<App>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};


/** Event sent when product metadata is updated. */
export type ProductMetadataUpdatedProductArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
};

export type ProductOrder = {
  /**
   * Sort product by the selected attribute's values.
   * Note: this doesn't take translations into account yet.
   */
  attributeId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * Specifies the channel in which to sort the data.
   *
   * DEPRECATED: this field will be removed. Use root-level channel argument instead.
   */
  channel?: InputMaybe<Scalars['String']['input']>;
  /** Specifies the direction in which to sort products. */
  direction: OrderDirection;
  /** Sort products by the selected field. */
  field?: InputMaybe<ProductOrderField>;
};

export type ProductOrderField =
  /**
   * Sort products by collection. Note: This option is available only for the `Collection.products` query.
   *
   * This option requires a channel filter to work as the values can vary between channels.
   */
  | 'COLLECTION'
  /** Sort products by creation date. */
  | 'CREATED_AT'
  /** Sort products by update date. */
  | 'DATE'
  /** Sort products by update date. */
  | 'LAST_MODIFIED'
  /** Sort products by update date. */
  | 'LAST_MODIFIED_AT'
  /**
   * Sort products by a minimal price of a product's variant.
   *
   * This option requires a channel filter to work as the values can vary between channels.
   */
  | 'MINIMAL_PRICE'
  /** Sort products by name. */
  | 'NAME'
  /**
   * Sort products by price.
   *
   * This option requires a channel filter to work as the values can vary between channels.
   */
  | 'PRICE'
  /**
   * Sort products by publication date.
   *
   * This option requires a channel filter to work as the values can vary between channels.
   */
  | 'PUBLICATION_DATE'
  /**
   * Sort products by publication status.
   *
   * This option requires a channel filter to work as the values can vary between channels.
   */
  | 'PUBLISHED'
  /**
   * Sort products by publication date.
   *
   * This option requires a channel filter to work as the values can vary between channels.
   */
  | 'PUBLISHED_AT'
  /** Sort products by rank. Note: This option is available only with the `search` filter. */
  | 'RANK'
  /** Sort products by rating. */
  | 'RATING'
  /** Sort products by type. */
  | 'TYPE';

/** Represents availability of a product in the storefront. */
export type ProductPricingInfo = {
  __typename?: 'ProductPricingInfo';
  /** The discount amount if in sale (null otherwise). */
  discount?: Maybe<TaxedMoney>;
  /**
   * The discount amount in the local currency.
   * @deprecated Always returns `null`.
   */
  discountLocalCurrency?: Maybe<TaxedMoney>;
  /**
   * The discount amount compared to prior price. Null if product is not on sale or prior price was not provided in VariantChannelListing
   *
   * Added in Saleor 3.21.
   */
  discountPrior?: Maybe<TaxedMoney>;
  /** Determines whether displayed prices should include taxes. */
  displayGrossPrices: Scalars['Boolean']['output'];
  /** Whether it is in sale or not. */
  onSale?: Maybe<Scalars['Boolean']['output']>;
  /** The discounted price range of the product variants. */
  priceRange?: Maybe<TaxedMoneyRange>;
  /**
   * The discounted price range of the product variants in the local currency.
   * @deprecated Always returns `null`.
   */
  priceRangeLocalCurrency?: Maybe<TaxedMoneyRange>;
  /**
   * The prior price range of the product variants.
   *
   * Added in Saleor 3.21.
   */
  priceRangePrior?: Maybe<TaxedMoneyRange>;
  /** The undiscounted price range of the product variants. */
  priceRangeUndiscounted?: Maybe<TaxedMoneyRange>;
};

/**
 * Reorder product attribute values.
 *
 * Requires one of the following permissions: MANAGE_PRODUCTS.
 */
export type ProductReorderAttributeValues = {
  __typename?: 'ProductReorderAttributeValues';
  errors: Array<ProductError>;
  /** Product from which attribute values are reordered. */
  product?: Maybe<Product>;
  /** @deprecated Use `errors` field instead. */
  productErrors: Array<ProductError>;
};

export type ProductStockFilterInput = {
  quantity?: InputMaybe<IntRangeInput>;
  warehouseIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** Represents product's original translatable fields and related translations. */
export type ProductTranslatableContent = Node & {
  __typename?: 'ProductTranslatableContent';
  /** List of product attribute values that can be translated. */
  attributeValues: Array<AttributeValueTranslatableContent>;
  /**
   * Product's description to translate.
   *
   * Rich text format. For reference see https://editorjs.io/
   */
  description?: Maybe<Scalars['JSONString']['output']>;
  /**
   * Description of the product.
   *
   * Rich text format. For reference see https://editorjs.io/
   * @deprecated Use the `description` field instead.
   */
  descriptionJson?: Maybe<Scalars['JSONString']['output']>;
  /** The ID of the product translatable content. */
  id: Scalars['ID']['output'];
  /** Product's name to translate. */
  name: Scalars['String']['output'];
  /**
   * Represents an individual item for sale in the storefront.
   * @deprecated Get model fields from the root level queries.
   */
  product?: Maybe<Product>;
  /** The ID of the product to translate. */
  productId: Scalars['ID']['output'];
  /** SEO description to translate. */
  seoDescription?: Maybe<Scalars['String']['output']>;
  /** SEO title to translate. */
  seoTitle?: Maybe<Scalars['String']['output']>;
  /**
   * Slug to translate.
   *
   * Added in Saleor 3.21.
   */
  slug?: Maybe<Scalars['String']['output']>;
  /** Returns translated product fields for the given language code. */
  translation?: Maybe<ProductTranslation>;
};


/** Represents product's original translatable fields and related translations. */
export type ProductTranslatableContentTranslationArgs = {
  languageCode: LanguageCodeEnum;
};

/**
 * Creates/updates translations for a product.
 *
 * Requires one of the following permissions: MANAGE_TRANSLATIONS.
 */
export type ProductTranslate = {
  __typename?: 'ProductTranslate';
  errors: Array<TranslationError>;
  product?: Maybe<Product>;
  /** @deprecated Use `errors` field instead. */
  translationErrors: Array<TranslationError>;
};

export type ProductTranslateErrorCode =
  | 'GRAPHQL_ERROR'
  | 'INVALID'
  | 'NOT_FOUND'
  | 'REQUIRED';

/** Represents product translations. */
export type ProductTranslation = Node & {
  __typename?: 'ProductTranslation';
  /**
   * Translated description of the product.
   *
   * Rich text format. For reference see https://editorjs.io/
   */
  description?: Maybe<Scalars['JSONString']['output']>;
  /**
   * Translated description of the product.
   *
   * Rich text format. For reference see https://editorjs.io/
   * @deprecated Use the `description` field instead.
   */
  descriptionJson?: Maybe<Scalars['JSONString']['output']>;
  /** The ID of the product translation. */
  id: Scalars['ID']['output'];
  /** Translation language. */
  language: LanguageDisplay;
  /** Translated product name. */
  name?: Maybe<Scalars['String']['output']>;
  /** Translated SEO description. */
  seoDescription?: Maybe<Scalars['String']['output']>;
  /** Translated SEO title. */
  seoTitle?: Maybe<Scalars['String']['output']>;
  /**
   * Translated product slug.
   *
   * Added in Saleor 3.21.
   */
  slug?: Maybe<Scalars['String']['output']>;
  /** Represents the product fields to translate. */
  translatableContent?: Maybe<ProductTranslatableContent>;
};

/** Represents a type of product. It defines what attributes are available to products of this type. */
export type ProductType = Node & ObjectWithMetadata & {
  __typename?: 'ProductType';
  /** Variant attributes of that product type with attached variant selection. */
  assignedVariantAttributes?: Maybe<Array<AssignedVariantAttribute>>;
  /**
   * List of attributes which can be assigned to this product type.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  availableAttributes?: Maybe<AttributeCountableConnection>;
  /** Whether the product type has variants. */
  hasVariants: Scalars['Boolean']['output'];
  /** The ID of the product type. */
  id: Scalars['ID']['output'];
  /** Whether the product type is digital. */
  isDigital: Scalars['Boolean']['output'];
  /** Whether shipping is required for this product type. */
  isShippingRequired: Scalars['Boolean']['output'];
  /** The product type kind. */
  kind: ProductTypeKindEnum;
  /** List of public metadata items. Can be accessed without permissions. */
  metadata: Array<MetadataItem>;
  /**
   * A single key from public metadata.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   */
  metafield?: Maybe<Scalars['String']['output']>;
  /** Public metadata. Use `keys` to control which fields you want to include. The default is to include everything. */
  metafields?: Maybe<Scalars['Metadata']['output']>;
  /** Name of the product type. */
  name: Scalars['String']['output'];
  /** List of private metadata items. Requires staff permissions to access. */
  privateMetadata: Array<MetadataItem>;
  /**
   * A single key from private metadata. Requires staff permissions to access.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   */
  privateMetafield?: Maybe<Scalars['String']['output']>;
  /** Private metadata. Requires staff permissions to access. Use `keys` to control which fields you want to include. The default is to include everything. */
  privateMetafields?: Maybe<Scalars['Metadata']['output']>;
  /** Product attributes of that product type. */
  productAttributes?: Maybe<Array<Attribute>>;
  /**
   * List of products of this type.
   * @deprecated Use the top-level `products` query with the `productTypes` filter.
   */
  products?: Maybe<ProductCountableConnection>;
  /** Slug of the product type. */
  slug: Scalars['String']['output'];
  /**
   * Tax class assigned to this product type. All products of this product type use this tax class, unless it's overridden in the `Product` type.
   *
   * Requires one of the following permissions: AUTHENTICATED_STAFF_USER, AUTHENTICATED_APP.
   */
  taxClass?: Maybe<TaxClass>;
  /**
   * A type of tax. Assigned by enabled tax gateway
   * @deprecated Use `taxClass` field instead.
   */
  taxType?: Maybe<TaxType>;
  /**
   * Variant attributes of that product type.
   * @deprecated Use `assignedVariantAttributes` instead.
   */
  variantAttributes?: Maybe<Array<Attribute>>;
  /** Weight of the product type. */
  weight?: Maybe<Weight>;
};


/** Represents a type of product. It defines what attributes are available to products of this type. */
export type ProductTypeAssignedVariantAttributesArgs = {
  variantSelection?: InputMaybe<VariantAttributeScope>;
};


/** Represents a type of product. It defines what attributes are available to products of this type. */
export type ProductTypeAvailableAttributesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<AttributeFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<AttributeWhereInput>;
};


/** Represents a type of product. It defines what attributes are available to products of this type. */
export type ProductTypeMetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Represents a type of product. It defines what attributes are available to products of this type. */
export type ProductTypeMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Represents a type of product. It defines what attributes are available to products of this type. */
export type ProductTypePrivateMetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Represents a type of product. It defines what attributes are available to products of this type. */
export type ProductTypePrivateMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Represents a type of product. It defines what attributes are available to products of this type. */
export type ProductTypeProductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  channel?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Represents a type of product. It defines what attributes are available to products of this type. */
export type ProductTypeVariantAttributesArgs = {
  variantSelection?: InputMaybe<VariantAttributeScope>;
};

/**
 * Deletes product types.
 *
 * Requires one of the following permissions: MANAGE_PRODUCT_TYPES_AND_ATTRIBUTES.
 */
export type ProductTypeBulkDelete = {
  __typename?: 'ProductTypeBulkDelete';
  /** Returns how many objects were affected. */
  count: Scalars['Int']['output'];
  errors: Array<ProductError>;
  /** @deprecated Use `errors` field instead. */
  productErrors: Array<ProductError>;
};

export type ProductTypeConfigurable =
  | 'CONFIGURABLE'
  | 'SIMPLE';

export type ProductTypeCountableConnection = {
  __typename?: 'ProductTypeCountableConnection';
  edges: Array<ProductTypeCountableEdge>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** A total count of items in the collection. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type ProductTypeCountableEdge = {
  __typename?: 'ProductTypeCountableEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ProductType;
};

/**
 * Creates a new product type.
 *
 * Requires one of the following permissions: MANAGE_PRODUCT_TYPES_AND_ATTRIBUTES.
 */
export type ProductTypeCreate = {
  __typename?: 'ProductTypeCreate';
  errors: Array<ProductError>;
  /** @deprecated Use `errors` field instead. */
  productErrors: Array<ProductError>;
  productType?: Maybe<ProductType>;
};

/**
 * Deletes a product type.
 *
 * Requires one of the following permissions: MANAGE_PRODUCT_TYPES_AND_ATTRIBUTES.
 */
export type ProductTypeDelete = {
  __typename?: 'ProductTypeDelete';
  errors: Array<ProductError>;
  /** @deprecated Use `errors` field instead. */
  productErrors: Array<ProductError>;
  productType?: Maybe<ProductType>;
};

export type ProductTypeEnum =
  | 'DIGITAL'
  | 'SHIPPABLE';

export type ProductTypeFilterInput = {
  configurable?: InputMaybe<ProductTypeConfigurable>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  kind?: InputMaybe<ProductTypeKindEnum>;
  metadata?: InputMaybe<Array<MetadataFilter>>;
  productType?: InputMaybe<ProductTypeEnum>;
  search?: InputMaybe<Scalars['String']['input']>;
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ProductTypeInput = {
  /** Determines if product of this type has multiple variants. This option mainly simplifies product management in the dashboard. There is always at least one variant created under the hood. */
  hasVariants?: InputMaybe<Scalars['Boolean']['input']>;
  /** Determines if products are digital. */
  isDigital?: InputMaybe<Scalars['Boolean']['input']>;
  /** Determines if shipping is required for products of this variant. */
  isShippingRequired?: InputMaybe<Scalars['Boolean']['input']>;
  /** The product type kind. */
  kind?: InputMaybe<ProductTypeKindEnum>;
  /** Name of the product type. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** List of attributes shared among all product variants. */
  productAttributes?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Product type slug. */
  slug?: InputMaybe<Scalars['String']['input']>;
  /** ID of a tax class to assign to this product type. All products of this product type would use this tax class, unless it's overridden in the `Product` type. */
  taxClass?: InputMaybe<Scalars['ID']['input']>;
  /**
   * Tax rate for enabled tax gateway.
   *
   * DEPRECATED: this field will be removed. Use tax classes to control the tax calculation for a product type. If taxCode is provided, Saleor will try to find a tax class with given code (codes are stored in metadata) and assign it. If no tax class is found, it would be created and assigned.
   */
  taxCode?: InputMaybe<Scalars['String']['input']>;
  /** List of attributes used to distinguish between different variants of a product. */
  variantAttributes?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Weight of the ProductType items. */
  weight?: InputMaybe<Scalars['WeightScalar']['input']>;
};

export type ProductTypeKindEnum =
  | 'GIFT_CARD'
  | 'NORMAL';

/**
 * Reorder the attributes of a product type.
 *
 * Requires one of the following permissions: MANAGE_PRODUCT_TYPES_AND_ATTRIBUTES.
 */
export type ProductTypeReorderAttributes = {
  __typename?: 'ProductTypeReorderAttributes';
  errors: Array<ProductError>;
  /** @deprecated Use `errors` field instead. */
  productErrors: Array<ProductError>;
  /** Product type from which attributes are reordered. */
  productType?: Maybe<ProductType>;
};

export type ProductTypeSortField =
  /** Sort products by type. */
  | 'DIGITAL'
  /** Sort products by name. */
  | 'NAME'
  /** Sort products by shipping. */
  | 'SHIPPING_REQUIRED';

export type ProductTypeSortingInput = {
  /** Specifies the direction in which to sort product types. */
  direction: OrderDirection;
  /** Sort product types by the selected field. */
  field: ProductTypeSortField;
};

/**
 * Updates an existing product type.
 *
 * Requires one of the following permissions: MANAGE_PRODUCT_TYPES_AND_ATTRIBUTES.
 */
export type ProductTypeUpdate = {
  __typename?: 'ProductTypeUpdate';
  errors: Array<ProductError>;
  /** @deprecated Use `errors` field instead. */
  productErrors: Array<ProductError>;
  productType?: Maybe<ProductType>;
};

/**
 * Updates an existing product.
 *
 * Requires one of the following permissions: MANAGE_PRODUCTS.
 */
export type ProductUpdate = {
  __typename?: 'ProductUpdate';
  errors: Array<ProductError>;
  product?: Maybe<Product>;
  /** @deprecated Use `errors` field instead. */
  productErrors: Array<ProductError>;
};

/** Event sent when product is updated. */
export type ProductUpdated = Event & {
  __typename?: 'ProductUpdated';
  /** The category of the product. */
  category?: Maybe<Category>;
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<IssuingPrincipal>;
  /** The product the event relates to. */
  product?: Maybe<Product>;
  /** The application receiving the webhook. */
  recipient?: Maybe<App>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};


/** Event sent when product is updated. */
export type ProductUpdatedProductArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
};

/** Represents a version of a product such as different size or color. */
export type ProductVariant = Node & ObjectWithAttributes & ObjectWithMetadata & {
  __typename?: 'ProductVariant';
  /**
   * Get a single attribute attached to product by attribute slug.
   *
   * Added in Saleor 3.22.
   */
  assignedAttribute?: Maybe<AssignedAttribute>;
  /**
   * List of attributes assigned to this variant.
   *
   * Added in Saleor 3.22.
   */
  assignedAttributes: Array<AssignedAttribute>;
  /**
   * List of attributes assigned to this variant.
   * @deprecated Use the `assignedAttributes` field instead.
   */
  attributes: Array<SelectedAttribute>;
  /** Channel given to retrieve this product variant. Also used by federation gateway to resolve this object in a federated query. */
  channel?: Maybe<Scalars['String']['output']>;
  /**
   * List of price information in channels for the product.
   *
   * Requires one of the following permissions: AUTHENTICATED_APP, AUTHENTICATED_STAFF_USER.
   */
  channelListings?: Maybe<Array<ProductVariantChannelListing>>;
  /** The date and time when the product variant was created. */
  created: Scalars['DateTime']['output'];
  /**
   * Digital content for the product variant.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  digitalContent?: Maybe<DigitalContent>;
  /** External ID of this product. */
  externalReference?: Maybe<Scalars['String']['output']>;
  /** The ID of the product variant. */
  id: Scalars['ID']['output'];
  /**
   * List of images for the product variant.
   * @deprecated Use the `media` field instead.
   */
  images?: Maybe<Array<ProductImage>>;
  /** Gross margin percentage value. */
  margin?: Maybe<Scalars['Int']['output']>;
  /** List of media for the product variant. */
  media?: Maybe<Array<ProductMedia>>;
  /** List of public metadata items. Can be accessed without permissions. */
  metadata: Array<MetadataItem>;
  /**
   * A single key from public metadata.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   */
  metafield?: Maybe<Scalars['String']['output']>;
  /** Public metadata. Use `keys` to control which fields you want to include. The default is to include everything. */
  metafields?: Maybe<Scalars['Metadata']['output']>;
  /** The name of the product variant. */
  name: Scalars['String']['output'];
  /** Preorder data for product variant. */
  preorder?: Maybe<PreorderData>;
  /** Lists the storefront variant's pricing, the current price and discounts, only meant for displaying. */
  pricing?: Maybe<VariantPricingInfo>;
  /** List of private metadata items. Requires staff permissions to access. */
  privateMetadata: Array<MetadataItem>;
  /**
   * A single key from private metadata. Requires staff permissions to access.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   */
  privateMetafield?: Maybe<Scalars['String']['output']>;
  /** Private metadata. Requires staff permissions to access. Use `keys` to control which fields you want to include. The default is to include everything. */
  privateMetafields?: Maybe<Scalars['Metadata']['output']>;
  /** The product to which the variant belongs. */
  product: Product;
  /** Quantity of a product available for sale in one checkout. Field value will be `null` when no `limitQuantityPerCheckout` in global settings has been set, and `productVariant` stocks are not tracked. */
  quantityAvailable?: Maybe<Scalars['Int']['output']>;
  /** The maximum quantity of this variant that a customer can purchase. */
  quantityLimitPerCustomer?: Maybe<Scalars['Int']['output']>;
  /**
   * Total quantity ordered.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  quantityOrdered?: Maybe<Scalars['Int']['output']>;
  /**
   * Total revenue generated by a variant in given period of time. Note: this field should be queried using `reportProductSales` query as it uses optimizations suitable for such calculations.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  revenue?: Maybe<TaxedMoney>;
  /** The SKU (stock keeping unit) of the product variant. */
  sku?: Maybe<Scalars['String']['output']>;
  /**
   * Stocks for the product variant.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS, MANAGE_ORDERS.
   */
  stocks?: Maybe<Array<Stock>>;
  /** Determines if the inventory of this variant should be tracked. If false, the quantity won't change when customers buy this item. If the field is not provided, `Shop.trackInventoryByDefault` will be used. */
  trackInventory: Scalars['Boolean']['output'];
  /** Returns translated product variant fields for the given language code. */
  translation?: Maybe<ProductVariantTranslation>;
  /** The date and time when the product variant was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  /** The weight of the product variant. */
  weight?: Maybe<Weight>;
};


/** Represents a version of a product such as different size or color. */
export type ProductVariantAssignedAttributeArgs = {
  slug: Scalars['String']['input'];
};


/** Represents a version of a product such as different size or color. */
export type ProductVariantAssignedAttributesArgs = {
  limit?: InputMaybe<Scalars['PositiveInt']['input']>;
};


/** Represents a version of a product such as different size or color. */
export type ProductVariantAttributesArgs = {
  variantSelection?: InputMaybe<VariantAttributeScope>;
};


/** Represents a version of a product such as different size or color. */
export type ProductVariantMetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Represents a version of a product such as different size or color. */
export type ProductVariantMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Represents a version of a product such as different size or color. */
export type ProductVariantPricingArgs = {
  address?: InputMaybe<AddressInput>;
};


/** Represents a version of a product such as different size or color. */
export type ProductVariantPrivateMetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Represents a version of a product such as different size or color. */
export type ProductVariantPrivateMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Represents a version of a product such as different size or color. */
export type ProductVariantQuantityAvailableArgs = {
  address?: InputMaybe<AddressInput>;
  countryCode?: InputMaybe<CountryCode>;
};


/** Represents a version of a product such as different size or color. */
export type ProductVariantRevenueArgs = {
  period?: InputMaybe<ReportingPeriod>;
};


/** Represents a version of a product such as different size or color. */
export type ProductVariantStocksArgs = {
  address?: InputMaybe<AddressInput>;
  countryCode?: InputMaybe<CountryCode>;
};


/** Represents a version of a product such as different size or color. */
export type ProductVariantTranslationArgs = {
  languageCode: LanguageCodeEnum;
};

/** Event sent when product variant is back in stock. */
export type ProductVariantBackInStock = Event & {
  __typename?: 'ProductVariantBackInStock';
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<IssuingPrincipal>;
  /** The product variant the event relates to. */
  productVariant?: Maybe<ProductVariant>;
  /** The application receiving the webhook. */
  recipient?: Maybe<App>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
  /** Look up a warehouse. */
  warehouse?: Maybe<Warehouse>;
};


/** Event sent when product variant is back in stock. */
export type ProductVariantBackInStockProductVariantArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Creates product variants for a given product.
 *
 * Requires one of the following permissions: MANAGE_PRODUCTS.
 */
export type ProductVariantBulkCreate = {
  __typename?: 'ProductVariantBulkCreate';
  /** @deprecated Use `errors` field instead. */
  bulkProductErrors: Array<BulkProductError>;
  /** Returns how many objects were created. */
  count: Scalars['Int']['output'];
  errors: Array<BulkProductError>;
  /**
   * List of the created variants.
   *
   * DEPRECATED: this field will be removed.
   */
  productVariants: Array<ProductVariant>;
  /** List of the created variants. */
  results: Array<ProductVariantBulkResult>;
};

export type ProductVariantBulkCreateInput = {
  /** List of attributes specific to this variant. */
  attributes: Array<BulkAttributeValueInput>;
  /** List of prices assigned to channels. */
  channelListings?: InputMaybe<Array<ProductVariantChannelListingAddInput>>;
  /** External ID of this product variant. */
  externalReference?: InputMaybe<Scalars['String']['input']>;
  /**
   * Fields required to update the product variant metadata. Can be read by any API client authorized to read the object it's attached to.
   *
   * Warning: never store sensitive information, including financial data such as credit card details.
   */
  metadata?: InputMaybe<Array<MetadataInput>>;
  /** Variant name. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Determines if variant is in preorder. */
  preorder?: InputMaybe<PreorderSettingsInput>;
  /**
   * Fields required to update the product variant private metadata. Requires permissions to modify and to read the metadata of the object it's attached to.
   *
   * Warning: never store sensitive information, including financial data such as credit card details.
   */
  privateMetadata?: InputMaybe<Array<MetadataInput>>;
  /** Determines maximum quantity of `ProductVariant`,that can be bought in a single checkout. */
  quantityLimitPerCustomer?: InputMaybe<Scalars['Int']['input']>;
  /** Stock keeping unit. */
  sku?: InputMaybe<Scalars['String']['input']>;
  /** Stocks of a product available for sale. */
  stocks?: InputMaybe<Array<StockInput>>;
  /** Determines if the inventory of this variant should be tracked. If false, the quantity won't change when customers buy this item. If the field is not provided, `Shop.trackInventoryByDefault` will be used. */
  trackInventory?: InputMaybe<Scalars['Boolean']['input']>;
  /** Weight of the Product Variant. */
  weight?: InputMaybe<Scalars['WeightScalar']['input']>;
};

/**
 * Deletes product variants.
 *
 * Requires one of the following permissions: MANAGE_PRODUCTS.
 */
export type ProductVariantBulkDelete = {
  __typename?: 'ProductVariantBulkDelete';
  /** Returns how many objects were affected. */
  count: Scalars['Int']['output'];
  errors: Array<ProductError>;
  /** @deprecated Use `errors` field instead. */
  productErrors: Array<ProductError>;
};

export type ProductVariantBulkError = {
  __typename?: 'ProductVariantBulkError';
  /** List of attributes IDs which causes the error. */
  attributes?: Maybe<Array<Scalars['ID']['output']>>;
  /** List of channel listings IDs which causes the error. */
  channelListings?: Maybe<Array<Scalars['ID']['output']>>;
  /** List of channel IDs which causes the error. */
  channels?: Maybe<Array<Scalars['ID']['output']>>;
  /** The error code. */
  code: ProductVariantBulkErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field?: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message?: Maybe<Scalars['String']['output']>;
  /** Path to field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  path?: Maybe<Scalars['String']['output']>;
  /** List of stocks IDs which causes the error. */
  stocks?: Maybe<Array<Scalars['ID']['output']>>;
  /** List of attribute values IDs which causes the error. */
  values?: Maybe<Array<Scalars['ID']['output']>>;
  /** List of warehouse IDs which causes the error. */
  warehouses?: Maybe<Array<Scalars['ID']['output']>>;
};

export type ProductVariantBulkErrorCode =
  | 'ATTRIBUTE_ALREADY_ASSIGNED'
  | 'ATTRIBUTE_CANNOT_BE_ASSIGNED'
  | 'ATTRIBUTE_VARIANTS_DISABLED'
  | 'DUPLICATED_INPUT_ITEM'
  | 'GRAPHQL_ERROR'
  | 'INVALID'
  | 'INVALID_PRICE'
  | 'NOT_FOUND'
  | 'NOT_PRODUCTS_VARIANT'
  | 'PRODUCT_NOT_ASSIGNED_TO_CHANNEL'
  | 'REQUIRED'
  | 'STOCK_ALREADY_EXISTS'
  | 'UNIQUE';

export type ProductVariantBulkResult = {
  __typename?: 'ProductVariantBulkResult';
  /** List of errors occurred on create attempt. */
  errors?: Maybe<Array<ProductVariantBulkError>>;
  /** Product variant data. */
  productVariant?: Maybe<ProductVariant>;
};

/**
 * Creates/updates translations for product variants.
 *
 * Requires one of the following permissions: MANAGE_TRANSLATIONS.
 *
 * Triggers the following webhook events:
 * - TRANSLATION_CREATED (async): A translation was created.
 * - TRANSLATION_UPDATED (async): A translation was updated.
 */
export type ProductVariantBulkTranslate = {
  __typename?: 'ProductVariantBulkTranslate';
  /** Returns how many translations were created/updated. */
  count: Scalars['Int']['output'];
  errors: Array<ProductVariantBulkTranslateError>;
  /** List of the translations. */
  results: Array<ProductVariantBulkTranslateResult>;
};

export type ProductVariantBulkTranslateError = {
  __typename?: 'ProductVariantBulkTranslateError';
  /** The error code. */
  code: ProductVariantTranslateErrorCode;
  /** The error message. */
  message?: Maybe<Scalars['String']['output']>;
  /** Path to field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  path?: Maybe<Scalars['String']['output']>;
};

export type ProductVariantBulkTranslateInput = {
  /** External reference of a product variant. */
  externalReference?: InputMaybe<Scalars['String']['input']>;
  /** Product variant ID. */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Translation language code. */
  languageCode: LanguageCodeEnum;
  /** Translation fields. */
  translationFields: NameTranslationInput;
};

export type ProductVariantBulkTranslateResult = {
  __typename?: 'ProductVariantBulkTranslateResult';
  /** List of errors occurred on translation attempt. */
  errors?: Maybe<Array<ProductVariantBulkTranslateError>>;
  /** Product variant translation data. */
  translation?: Maybe<ProductVariantTranslation>;
};

/**
 * Updates multiple product variants.
 *
 * Requires one of the following permissions: MANAGE_PRODUCTS.
 */
export type ProductVariantBulkUpdate = {
  __typename?: 'ProductVariantBulkUpdate';
  /** Returns how many objects were updated. */
  count: Scalars['Int']['output'];
  errors: Array<ProductVariantBulkError>;
  /** List of the updated variants. */
  results: Array<ProductVariantBulkResult>;
};

/** Input fields to update product variants. */
export type ProductVariantBulkUpdateInput = {
  /** List of attributes specific to this variant. */
  attributes?: InputMaybe<Array<BulkAttributeValueInput>>;
  /** Channel listings input. */
  channelListings?: InputMaybe<ProductVariantChannelListingUpdateInput>;
  /** External ID of this product variant. */
  externalReference?: InputMaybe<Scalars['String']['input']>;
  /** ID of the product variant to update. */
  id: Scalars['ID']['input'];
  /**
   * Fields required to update the product variant metadata. Can be read by any API client authorized to read the object it's attached to.
   *
   * Warning: never store sensitive information, including financial data such as credit card details.
   */
  metadata?: InputMaybe<Array<MetadataInput>>;
  /** Variant name. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Determines if variant is in preorder. */
  preorder?: InputMaybe<PreorderSettingsInput>;
  /**
   * Fields required to update the product variant private metadata. Requires permissions to modify and to read the metadata of the object it's attached to.
   *
   * Warning: never store sensitive information, including financial data such as credit card details.
   */
  privateMetadata?: InputMaybe<Array<MetadataInput>>;
  /** Determines maximum quantity of `ProductVariant`,that can be bought in a single checkout. */
  quantityLimitPerCustomer?: InputMaybe<Scalars['Int']['input']>;
  /** Stock keeping unit. */
  sku?: InputMaybe<Scalars['String']['input']>;
  /** Stocks input. */
  stocks?: InputMaybe<ProductVariantStocksUpdateInput>;
  /** Determines if the inventory of this variant should be tracked. If false, the quantity won't change when customers buy this item. If the field is not provided, `Shop.trackInventoryByDefault` will be used. */
  trackInventory?: InputMaybe<Scalars['Boolean']['input']>;
  /** Weight of the Product Variant. */
  weight?: InputMaybe<Scalars['WeightScalar']['input']>;
};

/** Represents product variant channel listing. */
export type ProductVariantChannelListing = Node & {
  __typename?: 'ProductVariantChannelListing';
  /** The channel to which the variant listing belongs. */
  channel: Channel;
  /** Cost price of the variant. */
  costPrice?: Maybe<Money>;
  /** The ID of the variant channel listing. */
  id: Scalars['ID']['output'];
  /**
   * Gross margin percentage value.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  margin?: Maybe<Scalars['Int']['output']>;
  /** Preorder variant data. */
  preorderThreshold?: Maybe<PreorderThreshold>;
  /** The price of the variant. */
  price?: Maybe<Money>;
  /**
   * Prior price of the variant used for discount calculations.
   *
   * Added in Saleor 3.21.
   */
  priorPrice?: Maybe<Money>;
};

export type ProductVariantChannelListingAddInput = {
  /** ID of a channel. */
  channelId: Scalars['ID']['input'];
  /** Cost price of the variant in channel. */
  costPrice?: InputMaybe<Scalars['PositiveDecimal']['input']>;
  /** The threshold for preorder variant in channel. */
  preorderThreshold?: InputMaybe<Scalars['Int']['input']>;
  /** Price of the particular variant in channel. */
  price: Scalars['PositiveDecimal']['input'];
  /**
   * Previous price of the variant in channel. Useful for providing promotion information required by customer protection laws such as EU Omnibus directive.
   *
   * Added in Saleor 3.21.
   */
  priorPrice?: InputMaybe<Scalars['PositiveDecimal']['input']>;
};

/**
 * Manage product variant prices in channels.
 *
 * Requires one of the following permissions: MANAGE_PRODUCTS.
 */
export type ProductVariantChannelListingUpdate = {
  __typename?: 'ProductVariantChannelListingUpdate';
  errors: Array<ProductChannelListingError>;
  /** @deprecated Use `errors` field instead. */
  productChannelListingErrors: Array<ProductChannelListingError>;
  /** An updated product variant instance. */
  variant?: Maybe<ProductVariant>;
};

export type ProductVariantChannelListingUpdateInput = {
  /** List of channels to create variant channel listings. */
  create?: InputMaybe<Array<ProductVariantChannelListingAddInput>>;
  /** List of channel listings to remove. */
  remove?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** List of channel listings to update. */
  update?: InputMaybe<Array<ChannelListingUpdateInput>>;
};

export type ProductVariantCountableConnection = {
  __typename?: 'ProductVariantCountableConnection';
  edges: Array<ProductVariantCountableEdge>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** A total count of items in the collection. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type ProductVariantCountableEdge = {
  __typename?: 'ProductVariantCountableEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ProductVariant;
};

/**
 * Creates a new variant for a product.
 *
 * Requires one of the following permissions: MANAGE_PRODUCTS.
 */
export type ProductVariantCreate = {
  __typename?: 'ProductVariantCreate';
  errors: Array<ProductError>;
  /** @deprecated Use `errors` field instead. */
  productErrors: Array<ProductError>;
  productVariant?: Maybe<ProductVariant>;
};

export type ProductVariantCreateInput = {
  /** List of attributes specific to this variant. */
  attributes: Array<AttributeValueInput>;
  /** External ID of this product variant. */
  externalReference?: InputMaybe<Scalars['String']['input']>;
  /**
   * Fields required to update the product variant metadata. Can be read by any API client authorized to read the object it's attached to.
   *
   * Warning: never store sensitive information, including financial data such as credit card details.
   */
  metadata?: InputMaybe<Array<MetadataInput>>;
  /** Variant name. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Determines if variant is in preorder. */
  preorder?: InputMaybe<PreorderSettingsInput>;
  /**
   * Fields required to update the product variant private metadata. Requires permissions to modify and to read the metadata of the object it's attached to.
   *
   * Warning: never store sensitive information, including financial data such as credit card details.
   */
  privateMetadata?: InputMaybe<Array<MetadataInput>>;
  /** Product ID of which type is the variant. */
  product: Scalars['ID']['input'];
  /** Determines maximum quantity of `ProductVariant`,that can be bought in a single checkout. */
  quantityLimitPerCustomer?: InputMaybe<Scalars['Int']['input']>;
  /** Stock keeping unit. */
  sku?: InputMaybe<Scalars['String']['input']>;
  /** Stocks of a product available for sale. */
  stocks?: InputMaybe<Array<StockInput>>;
  /** Determines if the inventory of this variant should be tracked. If false, the quantity won't change when customers buy this item. If the field is not provided, `Shop.trackInventoryByDefault` will be used. */
  trackInventory?: InputMaybe<Scalars['Boolean']['input']>;
  /** Weight of the Product Variant. */
  weight?: InputMaybe<Scalars['WeightScalar']['input']>;
};

/** Event sent when new product variant is created. */
export type ProductVariantCreated = Event & {
  __typename?: 'ProductVariantCreated';
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<IssuingPrincipal>;
  /** The product variant the event relates to. */
  productVariant?: Maybe<ProductVariant>;
  /** The application receiving the webhook. */
  recipient?: Maybe<App>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};


/** Event sent when new product variant is created. */
export type ProductVariantCreatedProductVariantArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Deletes a product variant.
 *
 * Requires one of the following permissions: MANAGE_PRODUCTS.
 */
export type ProductVariantDelete = {
  __typename?: 'ProductVariantDelete';
  errors: Array<ProductError>;
  /** @deprecated Use `errors` field instead. */
  productErrors: Array<ProductError>;
  productVariant?: Maybe<ProductVariant>;
};

/** Event sent when product variant is deleted. */
export type ProductVariantDeleted = Event & {
  __typename?: 'ProductVariantDeleted';
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<IssuingPrincipal>;
  /** The product variant the event relates to. */
  productVariant?: Maybe<ProductVariant>;
  /** The application receiving the webhook. */
  recipient?: Maybe<App>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};


/** Event sent when product variant is deleted. */
export type ProductVariantDeletedProductVariantArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Event sent when product variant discounted price is recalculated.
 *
 * Added in Saleor 3.22.
 */
export type ProductVariantDiscountedPriceUpdated = Event & {
  __typename?: 'ProductVariantDiscountedPriceUpdated';
  /** The channel where the price changed. */
  channel: Channel;
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<IssuingPrincipal>;
  /** The new discounted price. */
  newPrice: Money;
  /** The previous discounted price. */
  previousPrice: Money;
  /** The product variant the event relates to. */
  productVariant: ProductVariant;
  /** The application receiving the webhook. */
  recipient?: Maybe<App>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

export type ProductVariantFilterInput = {
  isPreorder?: InputMaybe<Scalars['Boolean']['input']>;
  metadata?: InputMaybe<Array<MetadataFilter>>;
  search?: InputMaybe<Scalars['String']['input']>;
  sku?: InputMaybe<Array<Scalars['String']['input']>>;
  updatedAt?: InputMaybe<DateTimeRangeInput>;
};

export type ProductVariantInput = {
  /** List of attributes specific to this variant. */
  attributes?: InputMaybe<Array<AttributeValueInput>>;
  /** External ID of this product variant. */
  externalReference?: InputMaybe<Scalars['String']['input']>;
  /**
   * Fields required to update the product variant metadata. Can be read by any API client authorized to read the object it's attached to.
   *
   * Warning: never store sensitive information, including financial data such as credit card details.
   */
  metadata?: InputMaybe<Array<MetadataInput>>;
  /** Variant name. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Determines if variant is in preorder. */
  preorder?: InputMaybe<PreorderSettingsInput>;
  /**
   * Fields required to update the product variant private metadata. Requires permissions to modify and to read the metadata of the object it's attached to.
   *
   * Warning: never store sensitive information, including financial data such as credit card details.
   */
  privateMetadata?: InputMaybe<Array<MetadataInput>>;
  /** Determines maximum quantity of `ProductVariant`,that can be bought in a single checkout. */
  quantityLimitPerCustomer?: InputMaybe<Scalars['Int']['input']>;
  /** Stock keeping unit. */
  sku?: InputMaybe<Scalars['String']['input']>;
  /** Determines if the inventory of this variant should be tracked. If false, the quantity won't change when customers buy this item. If the field is not provided, `Shop.trackInventoryByDefault` will be used. */
  trackInventory?: InputMaybe<Scalars['Boolean']['input']>;
  /** Weight of the Product Variant. */
  weight?: InputMaybe<Scalars['WeightScalar']['input']>;
};

/** Event sent when product variant metadata is updated. */
export type ProductVariantMetadataUpdated = Event & {
  __typename?: 'ProductVariantMetadataUpdated';
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<IssuingPrincipal>;
  /** The product variant the event relates to. */
  productVariant?: Maybe<ProductVariant>;
  /** The application receiving the webhook. */
  recipient?: Maybe<App>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};


/** Event sent when product variant metadata is updated. */
export type ProductVariantMetadataUpdatedProductVariantArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
};

/** Event sent when product variant is out of stock. */
export type ProductVariantOutOfStock = Event & {
  __typename?: 'ProductVariantOutOfStock';
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<IssuingPrincipal>;
  /** The product variant the event relates to. */
  productVariant?: Maybe<ProductVariant>;
  /** The application receiving the webhook. */
  recipient?: Maybe<App>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
  /** Look up a warehouse. */
  warehouse?: Maybe<Warehouse>;
};


/** Event sent when product variant is out of stock. */
export type ProductVariantOutOfStockProductVariantArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Deactivates product variant preorder. It changes all preorder allocation into regular allocation.
 *
 * Requires one of the following permissions: MANAGE_PRODUCTS.
 */
export type ProductVariantPreorderDeactivate = {
  __typename?: 'ProductVariantPreorderDeactivate';
  errors: Array<ProductError>;
  /** Product variant with ended preorder. */
  productVariant?: Maybe<ProductVariant>;
};

/**
 * Reorder the variants of a product. Mutation updates updated_at on product and triggers PRODUCT_UPDATED webhook.
 *
 * Requires one of the following permissions: MANAGE_PRODUCTS.
 */
export type ProductVariantReorder = {
  __typename?: 'ProductVariantReorder';
  errors: Array<ProductError>;
  product?: Maybe<Product>;
  /** @deprecated Use `errors` field instead. */
  productErrors: Array<ProductError>;
};

/**
 * Reorder product variant attribute values.
 *
 * Requires one of the following permissions: MANAGE_PRODUCTS.
 */
export type ProductVariantReorderAttributeValues = {
  __typename?: 'ProductVariantReorderAttributeValues';
  errors: Array<ProductError>;
  /** @deprecated Use `errors` field instead. */
  productErrors: Array<ProductError>;
  /** Product variant from which attribute values are reordered. */
  productVariant?: Maybe<ProductVariant>;
};

/**
 * Set default variant for a product. Mutation triggers PRODUCT_UPDATED webhook.
 *
 * Requires one of the following permissions: MANAGE_PRODUCTS.
 */
export type ProductVariantSetDefault = {
  __typename?: 'ProductVariantSetDefault';
  errors: Array<ProductError>;
  product?: Maybe<Product>;
  /** @deprecated Use `errors` field instead. */
  productErrors: Array<ProductError>;
};

export type ProductVariantSortField =
  /** Sort product variants by last modification date. */
  | 'LAST_MODIFIED_AT';

export type ProductVariantSortingInput = {
  /** Specifies the direction in which to sort productVariants. */
  direction: OrderDirection;
  /** Sort productVariants by the selected field. */
  field: ProductVariantSortField;
};

/** Event sent when product variant stock is updated. */
export type ProductVariantStockUpdated = Event & {
  __typename?: 'ProductVariantStockUpdated';
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<IssuingPrincipal>;
  /** The product variant the event relates to. */
  productVariant?: Maybe<ProductVariant>;
  /** The application receiving the webhook. */
  recipient?: Maybe<App>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
  /** Look up a warehouse. */
  warehouse?: Maybe<Warehouse>;
};


/** Event sent when product variant stock is updated. */
export type ProductVariantStockUpdatedProductVariantArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Creates stocks for product variant.
 *
 * Requires one of the following permissions: MANAGE_PRODUCTS.
 */
export type ProductVariantStocksCreate = {
  __typename?: 'ProductVariantStocksCreate';
  /** @deprecated Use `errors` field instead. */
  bulkStockErrors: Array<BulkStockError>;
  errors: Array<BulkStockError>;
  /** Updated product variant. */
  productVariant?: Maybe<ProductVariant>;
};

/**
 * Deletes stocks from product variant.
 *
 * Requires one of the following permissions: MANAGE_PRODUCTS.
 */
export type ProductVariantStocksDelete = {
  __typename?: 'ProductVariantStocksDelete';
  errors: Array<StockError>;
  /** Updated product variant. */
  productVariant?: Maybe<ProductVariant>;
  /** @deprecated Use `errors` field instead. */
  stockErrors: Array<StockError>;
};

/**
 * Updates stocks for product variant.
 *
 * Requires one of the following permissions: MANAGE_PRODUCTS.
 */
export type ProductVariantStocksUpdate = {
  __typename?: 'ProductVariantStocksUpdate';
  /** @deprecated Use `errors` field instead. */
  bulkStockErrors: Array<BulkStockError>;
  errors: Array<BulkStockError>;
  /** Updated product variant. */
  productVariant?: Maybe<ProductVariant>;
};

export type ProductVariantStocksUpdateInput = {
  /** List of warehouses to create stocks. */
  create?: InputMaybe<Array<StockInput>>;
  /** List of stocks to remove. */
  remove?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** List of stocks to update. */
  update?: InputMaybe<Array<StockUpdateInput>>;
};

/** Represents product variant's original translatable fields and related translations. */
export type ProductVariantTranslatableContent = Node & {
  __typename?: 'ProductVariantTranslatableContent';
  /** List of product variant attribute values that can be translated. */
  attributeValues: Array<AttributeValueTranslatableContent>;
  /** The ID of the product variant translatable content. */
  id: Scalars['ID']['output'];
  /** Name of the product variant to translate. */
  name: Scalars['String']['output'];
  /**
   * Represents a version of a product such as different size or color.
   * @deprecated Get model fields from the root level queries.
   */
  productVariant?: Maybe<ProductVariant>;
  /** The ID of the product variant to translate. */
  productVariantId: Scalars['ID']['output'];
  /** Returns translated product variant fields for the given language code. */
  translation?: Maybe<ProductVariantTranslation>;
};


/** Represents product variant's original translatable fields and related translations. */
export type ProductVariantTranslatableContentTranslationArgs = {
  languageCode: LanguageCodeEnum;
};

/**
 * Creates/updates translations for a product variant.
 *
 * Requires one of the following permissions: MANAGE_TRANSLATIONS.
 */
export type ProductVariantTranslate = {
  __typename?: 'ProductVariantTranslate';
  errors: Array<TranslationError>;
  productVariant?: Maybe<ProductVariant>;
  /** @deprecated Use `errors` field instead. */
  translationErrors: Array<TranslationError>;
};

export type ProductVariantTranslateErrorCode =
  | 'GRAPHQL_ERROR'
  | 'INVALID'
  | 'NOT_FOUND'
  | 'REQUIRED';

/** Represents product variant translations. */
export type ProductVariantTranslation = Node & {
  __typename?: 'ProductVariantTranslation';
  /** The ID of the product variant translation. */
  id: Scalars['ID']['output'];
  /** Translation language. */
  language: LanguageDisplay;
  /** Translated product variant name. */
  name: Scalars['String']['output'];
  /** Represents the product variant fields to translate. */
  translatableContent?: Maybe<ProductVariantTranslatableContent>;
};

/**
 * Updates an existing variant for product.
 *
 * Requires one of the following permissions: MANAGE_PRODUCTS.
 */
export type ProductVariantUpdate = {
  __typename?: 'ProductVariantUpdate';
  errors: Array<ProductError>;
  /** @deprecated Use `errors` field instead. */
  productErrors: Array<ProductError>;
  productVariant?: Maybe<ProductVariant>;
};

/** Event sent when product variant is updated. */
export type ProductVariantUpdated = Event & {
  __typename?: 'ProductVariantUpdated';
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<IssuingPrincipal>;
  /** The product variant the event relates to. */
  productVariant?: Maybe<ProductVariant>;
  /** The application receiving the webhook. */
  recipient?: Maybe<App>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};


/** Event sent when product variant is updated. */
export type ProductVariantUpdatedProductVariantArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
};

export type ProductVariantWhereInput = {
  /** List of conditions that must be met. */
  AND?: InputMaybe<Array<ProductVariantWhereInput>>;
  /** A list of conditions of which at least one must be met. */
  OR?: InputMaybe<Array<ProductVariantWhereInput>>;
  /**
   * Filter by attributes associated with the variant.
   *
   * Added in Saleor 3.22.
   */
  attributes?: InputMaybe<Array<AssignedAttributeWhereInput>>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  metadata?: InputMaybe<Array<MetadataFilter>>;
  /** Filter by product SKU. */
  sku?: InputMaybe<StringFilterInput>;
  /** Filter by when was the most recent update. */
  updatedAt?: InputMaybe<DateTimeRangeInput>;
};

export type ProductWhereInput = {
  /** List of conditions that must be met. */
  AND?: InputMaybe<Array<ProductWhereInput>>;
  /** A list of conditions of which at least one must be met. */
  OR?: InputMaybe<Array<ProductWhereInput>>;
  /** Filter by attributes associated with the product. */
  attributes?: InputMaybe<Array<AttributeInput>>;
  /** Filter by the date of availability for purchase. */
  availableFrom?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter by product category. */
  category?: InputMaybe<GlobalIdFilterInput>;
  /** Filter by collection. */
  collection?: InputMaybe<GlobalIdFilterInput>;
  /** Filter on whether product is a gift card or not. */
  giftCard?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by product with category assigned. */
  hasCategory?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by product with preordered variants. */
  hasPreorderedVariants?: InputMaybe<Scalars['Boolean']['input']>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter by availability for purchase. */
  isAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by public visibility. */
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by visibility on the channel. */
  isVisibleInListing?: InputMaybe<Scalars['Boolean']['input']>;
  metadata?: InputMaybe<Array<MetadataFilter>>;
  /** Filter by the lowest variant price after discounts. */
  minimalPrice?: InputMaybe<DecimalFilterInput>;
  /** Filter by product name. */
  name?: InputMaybe<StringFilterInput>;
  /** Filter by product variant price. */
  price?: InputMaybe<DecimalFilterInput>;
  /** Filter by product type. */
  productType?: InputMaybe<GlobalIdFilterInput>;
  /** Filter by the publication date. */
  publishedFrom?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter by product slug. */
  slug?: InputMaybe<StringFilterInput>;
  /** Filter by variants having specific stock status. */
  stockAvailability?: InputMaybe<StockAvailability>;
  /** Filter by stock of the product variant. */
  stocks?: InputMaybe<ProductStockFilterInput>;
  /** Filter by when was the most recent update. */
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

/** Represents the promotion that allow creating discounts based on given conditions, and is visible to all the customers. */
export type Promotion = Node & ObjectWithMetadata & {
  __typename?: 'Promotion';
  /** Date time of promotion creation. */
  createdAt: Scalars['DateTime']['output'];
  /** Description of the promotion. */
  description?: Maybe<Scalars['JSON']['output']>;
  /** End date of the promotion. */
  endDate?: Maybe<Scalars['DateTime']['output']>;
  /** The list of events associated with the promotion. */
  events?: Maybe<Array<PromotionEvent>>;
  id: Scalars['ID']['output'];
  /** List of public metadata items. Can be accessed without permissions. */
  metadata: Array<MetadataItem>;
  /**
   * A single key from public metadata.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   */
  metafield?: Maybe<Scalars['String']['output']>;
  /** Public metadata. Use `keys` to control which fields you want to include. The default is to include everything. */
  metafields?: Maybe<Scalars['Metadata']['output']>;
  /** Name of the promotion. */
  name: Scalars['String']['output'];
  /** List of private metadata items. Requires staff permissions to access. */
  privateMetadata: Array<MetadataItem>;
  /**
   * A single key from private metadata. Requires staff permissions to access.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   */
  privateMetafield?: Maybe<Scalars['String']['output']>;
  /** Private metadata. Requires staff permissions to access. Use `keys` to control which fields you want to include. The default is to include everything. */
  privateMetafields?: Maybe<Scalars['Metadata']['output']>;
  /** The list of promotion rules. */
  rules?: Maybe<Array<PromotionRule>>;
  /** Start date of the promotion. */
  startDate: Scalars['DateTime']['output'];
  /** Returns translated promotion fields for the given language code. */
  translation?: Maybe<PromotionTranslation>;
  /**
   * The type of the promotion. Implicate if the discount is applied on catalogue or order level.
   *
   * Added in Saleor 3.19.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  type?: Maybe<PromotionTypeEnum>;
  /** Date time of last update of promotion. */
  updatedAt: Scalars['DateTime']['output'];
};


/** Represents the promotion that allow creating discounts based on given conditions, and is visible to all the customers. */
export type PromotionMetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Represents the promotion that allow creating discounts based on given conditions, and is visible to all the customers. */
export type PromotionMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Represents the promotion that allow creating discounts based on given conditions, and is visible to all the customers. */
export type PromotionPrivateMetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Represents the promotion that allow creating discounts based on given conditions, and is visible to all the customers. */
export type PromotionPrivateMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Represents the promotion that allow creating discounts based on given conditions, and is visible to all the customers. */
export type PromotionTranslationArgs = {
  languageCode: LanguageCodeEnum;
};

/**
 * Deletes promotions.
 *
 * Requires one of the following permissions: MANAGE_DISCOUNTS.
 *
 * Triggers the following webhook events:
 * - PROMOTION_DELETED (async): A promotion was deleted.
 */
export type PromotionBulkDelete = {
  __typename?: 'PromotionBulkDelete';
  /** Returns how many objects were affected. */
  count: Scalars['Int']['output'];
  errors: Array<DiscountError>;
};

export type PromotionCountableConnection = {
  __typename?: 'PromotionCountableConnection';
  edges: Array<PromotionCountableEdge>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** A total count of items in the collection. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type PromotionCountableEdge = {
  __typename?: 'PromotionCountableEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Promotion;
};

/**
 * Creates a new promotion.
 *
 * Requires one of the following permissions: MANAGE_DISCOUNTS.
 *
 * Triggers the following webhook events:
 * - PROMOTION_CREATED (async): A promotion was created.
 * - PROMOTION_STARTED (async): Optionally called if promotion was started.
 */
export type PromotionCreate = {
  __typename?: 'PromotionCreate';
  errors: Array<PromotionCreateError>;
  promotion?: Maybe<Promotion>;
};

export type PromotionCreateError = {
  __typename?: 'PromotionCreateError';
  /** The error code. */
  code: PromotionCreateErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field?: Maybe<Scalars['String']['output']>;
  /** Limit of gifts assigned to promotion rule. */
  giftsLimit?: Maybe<Scalars['Int']['output']>;
  /** Number of gifts defined for this promotion rule exceeding the limit. */
  giftsLimitExceedBy?: Maybe<Scalars['Int']['output']>;
  /** Index of an input list item that caused the error. */
  index?: Maybe<Scalars['Int']['output']>;
  /** The error message. */
  message?: Maybe<Scalars['String']['output']>;
  /** Limit of rules with orderPredicate defined. */
  rulesLimit?: Maybe<Scalars['Int']['output']>;
  /** Number of rules with orderPredicate defined exceeding the limit. */
  rulesLimitExceedBy?: Maybe<Scalars['Int']['output']>;
};

export type PromotionCreateErrorCode =
  | 'GIFTS_NUMBER_LIMIT'
  | 'GRAPHQL_ERROR'
  | 'INVALID'
  | 'INVALID_GIFT_TYPE'
  | 'INVALID_PRECISION'
  | 'MISSING_CHANNELS'
  | 'MULTIPLE_CURRENCIES_NOT_ALLOWED'
  | 'NOT_FOUND'
  | 'REQUIRED'
  | 'RULES_NUMBER_LIMIT';

export type PromotionCreateInput = {
  /** Promotion description. */
  description?: InputMaybe<Scalars['JSON']['input']>;
  /** The end date of the promotion in ISO 8601 format. */
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Promotion name. */
  name: Scalars['String']['input'];
  /** List of promotion rules. */
  rules?: InputMaybe<Array<PromotionRuleInput>>;
  /** The start date of the promotion in ISO 8601 format. */
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  /**
   * Defines the promotion type. Implicate the required promotion rules predicate type and whether the promotion rules will give the catalogue or order discount.
   *
   * Added in Saleor 3.19.
   */
  type: PromotionTypeEnum;
};

/** Event sent when new promotion is created. */
export type PromotionCreated = Event & {
  __typename?: 'PromotionCreated';
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<IssuingPrincipal>;
  /** The promotion the event relates to. */
  promotion?: Maybe<Promotion>;
  /** The application receiving the webhook. */
  recipient?: Maybe<App>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

/** History log of the promotion created event. */
export type PromotionCreatedEvent = Node & PromotionEventInterface & {
  __typename?: 'PromotionCreatedEvent';
  /**
   * User or App that created the promotion event.
   *
   * Requires one of the following permissions: MANAGE_STAFF, MANAGE_APPS, OWNER.
   */
  createdBy?: Maybe<UserOrApp>;
  /** Date when event happened. */
  date: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  /** Promotion event type. */
  type: PromotionEventsEnum;
};

/**
 * Deletes a promotion.
 *
 * Requires one of the following permissions: MANAGE_DISCOUNTS.
 *
 * Triggers the following webhook events:
 * - PROMOTION_DELETED (async): A promotion was deleted.
 */
export type PromotionDelete = {
  __typename?: 'PromotionDelete';
  errors: Array<PromotionDeleteError>;
  promotion?: Maybe<Promotion>;
};

export type PromotionDeleteError = {
  __typename?: 'PromotionDeleteError';
  /** The error code. */
  code: PromotionDeleteErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field?: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message?: Maybe<Scalars['String']['output']>;
};

export type PromotionDeleteErrorCode =
  | 'GRAPHQL_ERROR'
  | 'NOT_FOUND';

/** Event sent when promotion is deleted. */
export type PromotionDeleted = Event & {
  __typename?: 'PromotionDeleted';
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<IssuingPrincipal>;
  /** The promotion the event relates to. */
  promotion?: Maybe<Promotion>;
  /** The application receiving the webhook. */
  recipient?: Maybe<App>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

/** The event informs about the end of the promotion. */
export type PromotionEnded = Event & {
  __typename?: 'PromotionEnded';
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<IssuingPrincipal>;
  /** The promotion the event relates to. */
  promotion?: Maybe<Promotion>;
  /** The application receiving the webhook. */
  recipient?: Maybe<App>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

/** History log of the promotion ended event. */
export type PromotionEndedEvent = Node & PromotionEventInterface & {
  __typename?: 'PromotionEndedEvent';
  /**
   * User or App that created the promotion event.
   *
   * Requires one of the following permissions: MANAGE_STAFF, MANAGE_APPS, OWNER.
   */
  createdBy?: Maybe<UserOrApp>;
  /** Date when event happened. */
  date: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  /** Promotion event type. */
  type: PromotionEventsEnum;
};

export type PromotionEvent = PromotionCreatedEvent | PromotionEndedEvent | PromotionRuleCreatedEvent | PromotionRuleDeletedEvent | PromotionRuleUpdatedEvent | PromotionStartedEvent | PromotionUpdatedEvent;

export type PromotionEventInterface = {
  /**
   * User or App that created the promotion event.
   *
   * Requires one of the following permissions: MANAGE_STAFF, MANAGE_APPS, OWNER.
   */
  createdBy?: Maybe<UserOrApp>;
  /** Date when event happened. */
  date: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  /** Promotion event type. */
  type: PromotionEventsEnum;
};

export type PromotionEventsEnum =
  | 'PROMOTION_CREATED'
  | 'PROMOTION_ENDED'
  | 'PROMOTION_STARTED'
  | 'PROMOTION_UPDATED'
  | 'RULE_CREATED'
  | 'RULE_DELETED'
  | 'RULE_UPDATED';

/** Represents the promotion rule that specifies the conditions that must be met to apply the promotion discount. */
export type PromotionRule = Node & {
  __typename?: 'PromotionRule';
  /** The catalogue predicate that must be met to apply the rule reward. */
  cataloguePredicate?: Maybe<Scalars['JSON']['output']>;
  /**
   * List of channels where the rule applies.
   *
   * Requires one of the following permissions: AUTHENTICATED_APP, AUTHENTICATED_STAFF_USER.
   */
  channels?: Maybe<Array<Channel>>;
  /** Description of the promotion rule. */
  description?: Maybe<Scalars['JSON']['output']>;
  /**
   * Product variant IDs available as a gift to choose.
   *
   * Added in Saleor 3.19.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  giftIds?: Maybe<Array<Scalars['ID']['output']>>;
  /**
   * Defines the maximum number of gifts to choose from the gifts list.
   *
   * Added in Saleor 3.19.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  giftsLimit?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  /** Name of the promotion rule. */
  name?: Maybe<Scalars['String']['output']>;
  /**
   * The checkout/order predicate that must be met to apply the rule reward.
   *
   * Added in Saleor 3.19.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  orderPredicate?: Maybe<Scalars['JSON']['output']>;
  /**
   * The type of the predicate that must be met to apply the reward.
   *
   * Added in Saleor 3.19.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  predicateType?: Maybe<PromotionTypeEnum>;
  /** Promotion to which the rule belongs. */
  promotion?: Maybe<Promotion>;
  /**
   * The reward type of the promotion rule.
   *
   * Added in Saleor 3.19.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  rewardType?: Maybe<RewardTypeEnum>;
  /**
   * The reward value of the promotion rule. Defines the discount value applied when the rule conditions are met.
   *
   * Added in Saleor 3.19.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  rewardValue?: Maybe<Scalars['PositiveDecimal']['output']>;
  /** The type of reward value of the promotion rule. */
  rewardValueType?: Maybe<RewardValueTypeEnum>;
  /** Returns translated promotion rule fields for the given language code. */
  translation?: Maybe<PromotionRuleTranslation>;
};


/** Represents the promotion rule that specifies the conditions that must be met to apply the promotion discount. */
export type PromotionRuleTranslationArgs = {
  languageCode: LanguageCodeEnum;
};

/**
 * Creates a new promotion rule.
 *
 * Requires one of the following permissions: MANAGE_DISCOUNTS.
 *
 * Triggers the following webhook events:
 * - PROMOTION_RULE_CREATED (async): A promotion rule was created.
 */
export type PromotionRuleCreate = {
  __typename?: 'PromotionRuleCreate';
  errors: Array<PromotionRuleCreateError>;
  promotionRule?: Maybe<PromotionRule>;
};

export type PromotionRuleCreateError = {
  __typename?: 'PromotionRuleCreateError';
  /** The error code. */
  code: PromotionRuleCreateErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field?: Maybe<Scalars['String']['output']>;
  /** Limit of gifts assigned to promotion rule. */
  giftsLimit?: Maybe<Scalars['Int']['output']>;
  /** Number of gifts defined for this promotion rule exceeding the limit. */
  giftsLimitExceedBy?: Maybe<Scalars['Int']['output']>;
  /** The error message. */
  message?: Maybe<Scalars['String']['output']>;
  /** Limit of rules with orderPredicate defined. */
  rulesLimit?: Maybe<Scalars['Int']['output']>;
  /** Number of rules with orderPredicate defined exceeding the limit. */
  rulesLimitExceedBy?: Maybe<Scalars['Int']['output']>;
};

export type PromotionRuleCreateErrorCode =
  | 'GIFTS_NUMBER_LIMIT'
  | 'GRAPHQL_ERROR'
  | 'INVALID'
  | 'INVALID_GIFT_TYPE'
  | 'INVALID_PRECISION'
  | 'MISSING_CHANNELS'
  | 'MULTIPLE_CURRENCIES_NOT_ALLOWED'
  | 'NOT_FOUND'
  | 'REQUIRED'
  | 'RULES_NUMBER_LIMIT';

export type PromotionRuleCreateInput = {
  /** Defines the conditions on the catalogue level that must be met for the reward to be applied. */
  cataloguePredicate?: InputMaybe<CataloguePredicateInput>;
  /** List of channel ids to which the rule should apply to. */
  channels?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Promotion rule description. */
  description?: InputMaybe<Scalars['JSON']['input']>;
  /**
   * Product variant IDs available as a gift to choose.
   *
   * Added in Saleor 3.19.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  gifts?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Promotion rule name. */
  name?: InputMaybe<Scalars['String']['input']>;
  /**
   * Defines the conditions on the checkout/draft order level that must be met for the reward to be applied.
   *
   * Added in Saleor 3.19.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  orderPredicate?: InputMaybe<OrderPredicateInput>;
  /** The ID of the promotion that rule belongs to. */
  promotion: Scalars['ID']['input'];
  /**
   * Defines the reward type of the promotion rule.
   *
   * Added in Saleor 3.19.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  rewardType?: InputMaybe<RewardTypeEnum>;
  /** Defines the discount value. Required when catalogue predicate is provided. */
  rewardValue?: InputMaybe<Scalars['PositiveDecimal']['input']>;
  /** Defines the promotion rule reward value type. Must be provided together with reward value. */
  rewardValueType?: InputMaybe<RewardValueTypeEnum>;
};

/** Event sent when new promotion rule is created. */
export type PromotionRuleCreated = Event & {
  __typename?: 'PromotionRuleCreated';
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<IssuingPrincipal>;
  /** The promotion rule the event relates to. */
  promotionRule?: Maybe<PromotionRule>;
  /** The application receiving the webhook. */
  recipient?: Maybe<App>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

/** History log of the promotion rule created event. */
export type PromotionRuleCreatedEvent = Node & PromotionEventInterface & PromotionRuleEventInterface & {
  __typename?: 'PromotionRuleCreatedEvent';
  /**
   * User or App that created the promotion event.
   *
   * Requires one of the following permissions: MANAGE_STAFF, MANAGE_APPS, OWNER.
   */
  createdBy?: Maybe<UserOrApp>;
  /** Date when event happened. */
  date: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  /** The rule ID associated with the promotion event. */
  ruleId?: Maybe<Scalars['String']['output']>;
  /** Promotion event type. */
  type: PromotionEventsEnum;
};

/**
 * Deletes a promotion rule.
 *
 * Requires one of the following permissions: MANAGE_DISCOUNTS.
 *
 * Triggers the following webhook events:
 * - PROMOTION_RULE_DELETED (async): A promotion rule was deleted.
 */
export type PromotionRuleDelete = {
  __typename?: 'PromotionRuleDelete';
  errors: Array<PromotionRuleDeleteError>;
  promotionRule?: Maybe<PromotionRule>;
};

export type PromotionRuleDeleteError = {
  __typename?: 'PromotionRuleDeleteError';
  /** The error code. */
  code: PromotionRuleDeleteErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field?: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message?: Maybe<Scalars['String']['output']>;
};

export type PromotionRuleDeleteErrorCode =
  | 'GRAPHQL_ERROR'
  | 'NOT_FOUND';

/** Event sent when new promotion rule is deleted. */
export type PromotionRuleDeleted = Event & {
  __typename?: 'PromotionRuleDeleted';
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<IssuingPrincipal>;
  /** The promotion rule the event relates to. */
  promotionRule?: Maybe<PromotionRule>;
  /** The application receiving the webhook. */
  recipient?: Maybe<App>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

/** History log of the promotion rule created event. */
export type PromotionRuleDeletedEvent = Node & PromotionEventInterface & PromotionRuleEventInterface & {
  __typename?: 'PromotionRuleDeletedEvent';
  /**
   * User or App that created the promotion event.
   *
   * Requires one of the following permissions: MANAGE_STAFF, MANAGE_APPS, OWNER.
   */
  createdBy?: Maybe<UserOrApp>;
  /** Date when event happened. */
  date: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  /** The rule ID associated with the promotion event. */
  ruleId?: Maybe<Scalars['String']['output']>;
  /** Promotion event type. */
  type: PromotionEventsEnum;
};

/** History log of the promotion event related to rule. */
export type PromotionRuleEventInterface = {
  /** The rule ID associated with the promotion event. */
  ruleId?: Maybe<Scalars['String']['output']>;
};

export type PromotionRuleInput = {
  /** Defines the conditions on the catalogue level that must be met for the reward to be applied. */
  cataloguePredicate?: InputMaybe<CataloguePredicateInput>;
  /** List of channel ids to which the rule should apply to. */
  channels?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Promotion rule description. */
  description?: InputMaybe<Scalars['JSON']['input']>;
  /**
   * Product variant IDs available as a gift to choose.
   *
   * Added in Saleor 3.19.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  gifts?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Promotion rule name. */
  name?: InputMaybe<Scalars['String']['input']>;
  /**
   * Defines the conditions on the checkout/draft order level that must be met for the reward to be applied.
   *
   * Added in Saleor 3.19.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  orderPredicate?: InputMaybe<OrderPredicateInput>;
  /**
   * Defines the reward type of the promotion rule.
   *
   * Added in Saleor 3.19.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  rewardType?: InputMaybe<RewardTypeEnum>;
  /** Defines the discount value. Required when catalogue predicate is provided. */
  rewardValue?: InputMaybe<Scalars['PositiveDecimal']['input']>;
  /** Defines the promotion rule reward value type. Must be provided together with reward value. */
  rewardValueType?: InputMaybe<RewardValueTypeEnum>;
};

/** Represents promotion rule's original translatable fields and related translations. */
export type PromotionRuleTranslatableContent = Node & {
  __typename?: 'PromotionRuleTranslatableContent';
  /**
   * Description of the promotion rule.
   *
   * Rich text format. For reference see https://editorjs.io/
   */
  description?: Maybe<Scalars['JSONString']['output']>;
  /** ID of the promotion rule translatable content. */
  id: Scalars['ID']['output'];
  /** Name of the promotion rule. */
  name?: Maybe<Scalars['String']['output']>;
  /** ID of the promotion rule to translate. */
  promotionRuleId: Scalars['ID']['output'];
  /** Returns translated promotion rule fields for the given language code. */
  translation?: Maybe<PromotionRuleTranslation>;
};


/** Represents promotion rule's original translatable fields and related translations. */
export type PromotionRuleTranslatableContentTranslationArgs = {
  languageCode: LanguageCodeEnum;
};

/**
 * Creates/updates translations for a promotion rule.
 *
 * Requires one of the following permissions: MANAGE_TRANSLATIONS.
 */
export type PromotionRuleTranslate = {
  __typename?: 'PromotionRuleTranslate';
  errors: Array<TranslationError>;
  promotionRule?: Maybe<PromotionRule>;
};

/** Represents promotion rule translations. */
export type PromotionRuleTranslation = Node & {
  __typename?: 'PromotionRuleTranslation';
  /**
   * Translated description of the promotion rule.
   *
   * Rich text format. For reference see https://editorjs.io/
   */
  description?: Maybe<Scalars['JSONString']['output']>;
  /** ID of the promotion rule translation. */
  id: Scalars['ID']['output'];
  /** Translation language. */
  language: LanguageDisplay;
  /** Translated name of the promotion rule. */
  name?: Maybe<Scalars['String']['output']>;
  /** Represents the promotion rule fields to translate. */
  translatableContent?: Maybe<PromotionRuleTranslatableContent>;
};

export type PromotionRuleTranslationInput = {
  /**
   * Translated promotion description.
   *
   * Rich text format. For reference see https://editorjs.io/
   */
  description?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Updates an existing promotion rule.
 *
 * Requires one of the following permissions: MANAGE_DISCOUNTS.
 *
 * Triggers the following webhook events:
 * - PROMOTION_RULE_UPDATED (async): A promotion rule was updated.
 */
export type PromotionRuleUpdate = {
  __typename?: 'PromotionRuleUpdate';
  errors: Array<PromotionRuleUpdateError>;
  promotionRule?: Maybe<PromotionRule>;
};

export type PromotionRuleUpdateError = {
  __typename?: 'PromotionRuleUpdateError';
  /** List of channel IDs which causes the error. */
  channels?: Maybe<Array<Scalars['ID']['output']>>;
  /** The error code. */
  code: PromotionRuleUpdateErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field?: Maybe<Scalars['String']['output']>;
  /** Limit of gifts assigned to promotion rule. */
  giftsLimit?: Maybe<Scalars['Int']['output']>;
  /** Number of gifts defined for this promotion rule exceeding the limit. */
  giftsLimitExceedBy?: Maybe<Scalars['Int']['output']>;
  /** The error message. */
  message?: Maybe<Scalars['String']['output']>;
};

export type PromotionRuleUpdateErrorCode =
  | 'DUPLICATED_INPUT_ITEM'
  | 'GIFTS_NUMBER_LIMIT'
  | 'GRAPHQL_ERROR'
  | 'INVALID'
  | 'INVALID_GIFT_TYPE'
  | 'INVALID_PRECISION'
  | 'MISSING_CHANNELS'
  | 'MULTIPLE_CURRENCIES_NOT_ALLOWED'
  | 'NOT_FOUND'
  | 'REQUIRED';

export type PromotionRuleUpdateInput = {
  /** List of channel ids to add. */
  addChannels?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**
   * List of variant IDs available as a gift to add.
   *
   * Added in Saleor 3.19.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  addGifts?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Defines the conditions on the catalogue level that must be met for the reward to be applied. */
  cataloguePredicate?: InputMaybe<CataloguePredicateInput>;
  /** Promotion rule description. */
  description?: InputMaybe<Scalars['JSON']['input']>;
  /** Promotion rule name. */
  name?: InputMaybe<Scalars['String']['input']>;
  /**
   * Defines the conditions on the checkout/draft order level that must be met for the reward to be applied.
   *
   * Added in Saleor 3.19.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  orderPredicate?: InputMaybe<OrderPredicateInput>;
  /** List of channel ids to remove. */
  removeChannels?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**
   * List of variant IDs available as a gift to remove.
   *
   * Added in Saleor 3.19.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  removeGifts?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**
   * Defines the reward type of the promotion rule.
   *
   * Added in Saleor 3.19.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  rewardType?: InputMaybe<RewardTypeEnum>;
  /** Defines the discount value. Required when catalogue predicate is provided. */
  rewardValue?: InputMaybe<Scalars['PositiveDecimal']['input']>;
  /** Defines the promotion rule reward value type. Must be provided together with reward value. */
  rewardValueType?: InputMaybe<RewardValueTypeEnum>;
};

/** Event sent when new promotion rule is updated. */
export type PromotionRuleUpdated = Event & {
  __typename?: 'PromotionRuleUpdated';
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<IssuingPrincipal>;
  /** The promotion rule the event relates to. */
  promotionRule?: Maybe<PromotionRule>;
  /** The application receiving the webhook. */
  recipient?: Maybe<App>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

/** History log of the promotion rule created event. */
export type PromotionRuleUpdatedEvent = Node & PromotionEventInterface & PromotionRuleEventInterface & {
  __typename?: 'PromotionRuleUpdatedEvent';
  /**
   * User or App that created the promotion event.
   *
   * Requires one of the following permissions: MANAGE_STAFF, MANAGE_APPS, OWNER.
   */
  createdBy?: Maybe<UserOrApp>;
  /** Date when event happened. */
  date: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  /** The rule ID associated with the promotion event. */
  ruleId?: Maybe<Scalars['String']['output']>;
  /** Promotion event type. */
  type: PromotionEventsEnum;
};

export type PromotionSortField =
  /** Sort promotions by creation date. */
  | 'CREATED_AT'
  /** Sort promotions by end date. */
  | 'END_DATE'
  /** Sort promotions by name. */
  | 'NAME'
  /** Sort promotions by start date. */
  | 'START_DATE';

export type PromotionSortingInput = {
  /** Specifies the direction in which to sort promotions. */
  direction: OrderDirection;
  /** Sort promotions by the selected field. */
  field: PromotionSortField;
};

/** The event informs about the start of the promotion. */
export type PromotionStarted = Event & {
  __typename?: 'PromotionStarted';
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<IssuingPrincipal>;
  /** The promotion the event relates to. */
  promotion?: Maybe<Promotion>;
  /** The application receiving the webhook. */
  recipient?: Maybe<App>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

/** History log of the promotion started event. */
export type PromotionStartedEvent = Node & PromotionEventInterface & {
  __typename?: 'PromotionStartedEvent';
  /**
   * User or App that created the promotion event.
   *
   * Requires one of the following permissions: MANAGE_STAFF, MANAGE_APPS, OWNER.
   */
  createdBy?: Maybe<UserOrApp>;
  /** Date when event happened. */
  date: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  /** Promotion event type. */
  type: PromotionEventsEnum;
};

/** Represents promotion's original translatable fields and related translations. */
export type PromotionTranslatableContent = Node & {
  __typename?: 'PromotionTranslatableContent';
  /**
   * Description of the promotion.
   *
   * Rich text format. For reference see https://editorjs.io/
   */
  description?: Maybe<Scalars['JSONString']['output']>;
  /** ID of the promotion translatable content. */
  id: Scalars['ID']['output'];
  /** Name of the promotion. */
  name: Scalars['String']['output'];
  /** ID of the promotion to translate. */
  promotionId: Scalars['ID']['output'];
  /** Returns translated promotion fields for the given language code. */
  translation?: Maybe<PromotionTranslation>;
};


/** Represents promotion's original translatable fields and related translations. */
export type PromotionTranslatableContentTranslationArgs = {
  languageCode: LanguageCodeEnum;
};

/**
 * Creates/updates translations for a promotion.
 *
 * Requires one of the following permissions: MANAGE_TRANSLATIONS.
 */
export type PromotionTranslate = {
  __typename?: 'PromotionTranslate';
  errors: Array<TranslationError>;
  promotion?: Maybe<Promotion>;
};

/** Represents promotion translations. */
export type PromotionTranslation = Node & {
  __typename?: 'PromotionTranslation';
  /**
   * Translated description of the promotion.
   *
   * Rich text format. For reference see https://editorjs.io/
   */
  description?: Maybe<Scalars['JSONString']['output']>;
  /** ID of the promotion translation. */
  id: Scalars['ID']['output'];
  /** Translation language. */
  language: LanguageDisplay;
  /** Translated name of the promotion. */
  name?: Maybe<Scalars['String']['output']>;
  /** Represents the promotion fields to translate. */
  translatableContent?: Maybe<PromotionTranslatableContent>;
};

export type PromotionTranslationInput = {
  /**
   * Translated promotion description.
   *
   * Rich text format. For reference see https://editorjs.io/
   */
  description?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type PromotionTypeEnum =
  | 'CATALOGUE'
  | 'ORDER';

export type PromotionTypeEnumFilterInput = {
  /** The value equal to. */
  eq?: InputMaybe<PromotionTypeEnum>;
  /** The value included in. */
  oneOf?: InputMaybe<Array<PromotionTypeEnum>>;
};

/**
 * Updates an existing promotion.
 *
 * Requires one of the following permissions: MANAGE_DISCOUNTS.
 *
 * Triggers the following webhook events:
 * - PROMOTION_UPDATED (async): A promotion was updated.
 * - PROMOTION_STARTED (async): Optionally called if promotion was started.
 * - PROMOTION_ENDED (async): Optionally called if promotion was ended.
 */
export type PromotionUpdate = {
  __typename?: 'PromotionUpdate';
  errors: Array<PromotionUpdateError>;
  promotion?: Maybe<Promotion>;
};

export type PromotionUpdateError = {
  __typename?: 'PromotionUpdateError';
  /** The error code. */
  code: PromotionUpdateErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field?: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message?: Maybe<Scalars['String']['output']>;
};

export type PromotionUpdateErrorCode =
  | 'GRAPHQL_ERROR'
  | 'INVALID'
  | 'NOT_FOUND'
  | 'REQUIRED';

export type PromotionUpdateInput = {
  /** Promotion description. */
  description?: InputMaybe<Scalars['JSON']['input']>;
  /** The end date of the promotion in ISO 8601 format. */
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Promotion name. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The start date of the promotion in ISO 8601 format. */
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Event sent when promotion is updated. */
export type PromotionUpdated = Event & {
  __typename?: 'PromotionUpdated';
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<IssuingPrincipal>;
  /** The promotion the event relates to. */
  promotion?: Maybe<Promotion>;
  /** The application receiving the webhook. */
  recipient?: Maybe<App>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

/** History log of the promotion updated event. */
export type PromotionUpdatedEvent = Node & PromotionEventInterface & {
  __typename?: 'PromotionUpdatedEvent';
  /**
   * User or App that created the promotion event.
   *
   * Requires one of the following permissions: MANAGE_STAFF, MANAGE_APPS, OWNER.
   */
  createdBy?: Maybe<UserOrApp>;
  /** Date when event happened. */
  date: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  /** Promotion event type. */
  type: PromotionEventsEnum;
};

export type PromotionWhereInput = {
  /** List of conditions that must be met. */
  AND?: InputMaybe<Array<PromotionWhereInput>>;
  /** A list of conditions of which at least one must be met. */
  OR?: InputMaybe<Array<PromotionWhereInput>>;
  /** Filter promotions by end date. */
  endDate?: InputMaybe<DateTimeFilterInput>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  isOldSale?: InputMaybe<Scalars['Boolean']['input']>;
  metadata?: InputMaybe<Array<MetadataFilter>>;
  /** Filter by promotion name. */
  name?: InputMaybe<StringFilterInput>;
  /** Filter promotions by start date. */
  startDate?: InputMaybe<DateTimeFilterInput>;
  type?: InputMaybe<PromotionTypeEnumFilterInput>;
};

export type PublishableChannelListingInput = {
  /** ID of a channel. */
  channelId: Scalars['ID']['input'];
  /** Determines if object is visible to customers. */
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Publication date. ISO 8601 standard.
   *
   * DEPRECATED: this field will be removed. Use `publishedAt` field instead.
   */
  publicationDate?: InputMaybe<Scalars['Date']['input']>;
  /** Publication date time. ISO 8601 standard. */
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type Query = {
  __typename?: 'Query';
  _entities?: Maybe<Array<Maybe<_Entity>>>;
  _service?: Maybe<_Service>;
  /**
   * Look up an address by ID.
   *
   * Requires one of the following permissions: MANAGE_USERS, OWNER.
   */
  address?: Maybe<Address>;
  /** Returns address validation rules. */
  addressValidationRules?: Maybe<AddressValidationData>;
  /**
   * Look up an app by ID. If ID is not provided, return the currently authenticated app.
   *
   * Requires one of the following permissions: AUTHENTICATED_STAFF_USER AUTHENTICATED_APP. The authenticated app has access to its resources. Fetching different apps requires MANAGE_APPS permission.
   */
  app?: Maybe<App>;
  /**
   * Look up an app extension by ID.
   *
   * Requires one of the following permissions: AUTHENTICATED_STAFF_USER, AUTHENTICATED_APP.
   */
  appExtension?: Maybe<AppExtension>;
  /**
   * List of all extensions.
   *
   * Requires one of the following permissions: AUTHENTICATED_STAFF_USER, AUTHENTICATED_APP.
   */
  appExtensions?: Maybe<AppExtensionCountableConnection>;
  /**
   * List of the apps.
   *
   * Requires one of the following permissions: AUTHENTICATED_STAFF_USER, MANAGE_APPS.
   */
  apps?: Maybe<AppCountableConnection>;
  /**
   * List of all apps installations
   *
   * Requires one of the following permissions: MANAGE_APPS.
   */
  appsInstallations: Array<AppInstallation>;
  /** Look up an attribute by ID, slug or external reference. */
  attribute?: Maybe<Attribute>;
  /** List of the shop's attributes. */
  attributes?: Maybe<AttributeCountableConnection>;
  /** List of the shop's categories. */
  categories?: Maybe<CategoryCountableConnection>;
  /** Look up a category by ID or slug. */
  category?: Maybe<Category>;
  /** Look up a channel by ID or slug. */
  channel?: Maybe<Channel>;
  /**
   * List of all channels.
   *
   * Requires one of the following permissions: AUTHENTICATED_APP, AUTHENTICATED_STAFF_USER.
   */
  channels?: Maybe<Array<Channel>>;
  /**
   * Look up a checkout by id.
   *
   * Requires one of the following permissions to query a checkout, if a checkout is in inactive channel: MANAGE_CHECKOUTS, IMPERSONATE_USER, HANDLE_PAYMENTS.
   */
  checkout?: Maybe<Checkout>;
  /**
   * List of checkout lines. The query will not initiate any external requests, including fetching external shipping methods, filtering available shipping methods, or performing external tax calculations.
   *
   * Requires one of the following permissions: MANAGE_CHECKOUTS.
   */
  checkoutLines?: Maybe<CheckoutLineCountableConnection>;
  /**
   * List of checkouts. The query will not initiate any external requests, including fetching external shipping methods, filtering available shipping methods, or performing external tax calculations.
   *
   * Requires one of the following permissions: MANAGE_CHECKOUTS, HANDLE_PAYMENTS.
   */
  checkouts?: Maybe<CheckoutCountableConnection>;
  /** Look up a collection by ID or slug. If slugLanguageCode is provided, category will be fetched by slug translation. Requires one of the following permissions to include the unpublished items: MANAGE_ORDERS, MANAGE_DISCOUNTS, MANAGE_PRODUCTS. */
  collection?: Maybe<Collection>;
  /** List of the shop's collections. Requires one of the following permissions to include the unpublished items: MANAGE_ORDERS, MANAGE_DISCOUNTS, MANAGE_PRODUCTS. */
  collections?: Maybe<CollectionCountableConnection>;
  /**
   * List of the shop's customers. This list includes all users who registered through the accountRegister mutation. Additionally, staff users who have placed an order using their account will also appear in this list.
   *
   * Requires one of the following permissions: MANAGE_ORDERS, MANAGE_USERS.
   */
  customers?: Maybe<UserCountableConnection>;
  /**
   * Look up digital content by ID.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   * @deprecated Support for Digital Content is deprecated and will be removed in Saleor v3.23.0. This functionality is legacy and undocumented, and is not part of the supported API. Users should not rely on this behavior.
   */
  digitalContent?: Maybe<DigitalContent>;
  /**
   * List of digital content.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   * @deprecated Support for Digital Content is deprecated and will be removed in Saleor v3.23.0. This functionality is legacy and undocumented, and is not part of the supported API. Users should not rely on this behavior.
   */
  digitalContents?: Maybe<DigitalContentCountableConnection>;
  /**
   * List of draft orders. The query will not initiate any external requests, including filtering available shipping methods, or performing external tax calculations.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   */
  draftOrders?: Maybe<OrderCountableConnection>;
  /**
   * Look up a export file by ID.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  exportFile?: Maybe<ExportFile>;
  /**
   * List of export files.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  exportFiles?: Maybe<ExportFileCountableConnection>;
  /**
   * Look up a gift card by ID.
   *
   * Requires one of the following permissions: MANAGE_GIFT_CARD.
   */
  giftCard?: Maybe<GiftCard>;
  /**
   * List of gift card currencies.
   *
   * Requires one of the following permissions: MANAGE_GIFT_CARD.
   */
  giftCardCurrencies: Array<Scalars['String']['output']>;
  /**
   * Gift card related settings from site settings.
   *
   * Requires one of the following permissions: MANAGE_GIFT_CARD.
   */
  giftCardSettings: GiftCardSettings;
  /**
   * List of gift card tags.
   *
   * Requires one of the following permissions: MANAGE_GIFT_CARD.
   */
  giftCardTags?: Maybe<GiftCardTagCountableConnection>;
  /**
   * List of gift cards.
   *
   * Requires one of the following permissions: MANAGE_GIFT_CARD.
   */
  giftCards?: Maybe<GiftCardCountableConnection>;
  /**
   * List of activity events to display on homepage (at the moment it only contains order-events).
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   * @deprecated No longer supported
   */
  homepageEvents?: Maybe<OrderEventCountableConnection>;
  /** Return the currently authenticated user. */
  me?: Maybe<User>;
  /** Look up a navigation menu by ID or name. */
  menu?: Maybe<Menu>;
  /** Look up a menu item by ID. */
  menuItem?: Maybe<MenuItem>;
  /** List of the storefronts's menu items. */
  menuItems?: Maybe<MenuItemCountableConnection>;
  /** List of the storefront's menus. */
  menus?: Maybe<MenuCountableConnection>;
  /** Look up an order by ID or external reference. */
  order?: Maybe<Order>;
  /**
   * Look up an order by token.
   * @deprecated No longer supported
   */
  orderByToken?: Maybe<Order>;
  /**
   * Order related settings from site settings. Returns `orderSettings` for the first `channel` in alphabetical order.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   * @deprecated Use the `channel` query to fetch the `orderSettings` field instead.
   */
  orderSettings?: Maybe<OrderSettings>;
  /**
   * List of orders. The query will not initiate any external requests, including filtering available shipping methods, or performing external tax calculations.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   */
  orders?: Maybe<OrderCountableConnection>;
  /**
   * Return the total sales amount from a specific period.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   * @deprecated No longer supported
   */
  ordersTotal?: Maybe<TaxedMoney>;
  /** Look up a page by ID or slug. */
  page?: Maybe<Page>;
  /** Look up a page type by ID. */
  pageType?: Maybe<PageType>;
  /** List of the page types. */
  pageTypes?: Maybe<PageTypeCountableConnection>;
  /** List of the shop's pages. */
  pages?: Maybe<PageCountableConnection>;
  /**
   * Look up a payment by ID.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   */
  payment?: Maybe<Payment>;
  /**
   * List of payments.
   *
   * Requires one of the following permissions: MANAGE_ORDERS.
   */
  payments?: Maybe<PaymentCountableConnection>;
  /**
   * Look up permission group by ID.
   *
   * Requires one of the following permissions: MANAGE_STAFF.
   */
  permissionGroup?: Maybe<Group>;
  /**
   * List of permission groups.
   *
   * Requires one of the following permissions: MANAGE_STAFF.
   */
  permissionGroups?: Maybe<GroupCountableConnection>;
  /**
   * Look up a plugin by ID.
   *
   * Requires one of the following permissions: MANAGE_PLUGINS.
   */
  plugin?: Maybe<Plugin>;
  /**
   * List of plugins.
   *
   * Requires one of the following permissions: MANAGE_PLUGINS.
   */
  plugins?: Maybe<PluginCountableConnection>;
  /** Look up a product by ID. Requires one of the following permissions to include the unpublished items: MANAGE_ORDERS, MANAGE_DISCOUNTS, MANAGE_PRODUCTS. */
  product?: Maybe<Product>;
  /** Look up a product type by ID. */
  productType?: Maybe<ProductType>;
  /** List of the shop's product types. */
  productTypes?: Maybe<ProductTypeCountableConnection>;
  /** Look up a product variant by ID or SKU. Requires one of the following permissions to include the unpublished items: MANAGE_ORDERS, MANAGE_DISCOUNTS, MANAGE_PRODUCTS. */
  productVariant?: Maybe<ProductVariant>;
  /** List of product variants. Requires one of the following permissions to include the unpublished items: MANAGE_ORDERS, MANAGE_DISCOUNTS, MANAGE_PRODUCTS. */
  productVariants?: Maybe<ProductVariantCountableConnection>;
  /** List of the shop's products. Requires one of the following permissions to include the unpublished items: MANAGE_ORDERS, MANAGE_DISCOUNTS, MANAGE_PRODUCTS. */
  products?: Maybe<ProductCountableConnection>;
  /**
   * Look up a promotion by ID.
   *
   * Requires one of the following permissions: MANAGE_DISCOUNTS.
   */
  promotion?: Maybe<Promotion>;
  /**
   * List of the promotions.
   *
   * Requires one of the following permissions: MANAGE_DISCOUNTS.
   */
  promotions?: Maybe<PromotionCountableConnection>;
  /** Refunds related settings. Returns `RefundSettings` configuration, global for the entire shop. */
  refundSettings: RefundSettings;
  /**
   * List of top selling products.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   * @deprecated No longer supported
   */
  reportProductSales?: Maybe<ProductVariantCountableConnection>;
  /**
   * Look up a sale by ID.
   *
   * Requires one of the following permissions: MANAGE_DISCOUNTS.
   * @deprecated Use the `promotion` query instead.
   */
  sale?: Maybe<Sale>;
  /**
   * List of the shop's sales.
   *
   * Requires one of the following permissions: MANAGE_DISCOUNTS.
   * @deprecated Use the `promotions` query instead.
   */
  sales?: Maybe<SaleCountableConnection>;
  /**
   * Look up a shipping zone by ID.
   *
   * Requires one of the following permissions: MANAGE_SHIPPING.
   */
  shippingZone?: Maybe<ShippingZone>;
  /**
   * List of the shop's shipping zones.
   *
   * Requires one of the following permissions: MANAGE_SHIPPING.
   */
  shippingZones?: Maybe<ShippingZoneCountableConnection>;
  /** Return information about the shop. */
  shop: Shop;
  /**
   * List of the shop's staff users.
   *
   * Requires one of the following permissions: MANAGE_STAFF.
   */
  staffUsers?: Maybe<UserCountableConnection>;
  /**
   * Look up a stock by ID
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  stock?: Maybe<Stock>;
  /**
   * List of stocks.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS.
   */
  stocks?: Maybe<StockCountableConnection>;
  /**
   * Look up a tax class.
   *
   * Requires one of the following permissions: AUTHENTICATED_STAFF_USER, AUTHENTICATED_APP.
   */
  taxClass?: Maybe<TaxClass>;
  /**
   * List of tax classes.
   *
   * Requires one of the following permissions: AUTHENTICATED_STAFF_USER, AUTHENTICATED_APP.
   */
  taxClasses?: Maybe<TaxClassCountableConnection>;
  /**
   * Look up a tax configuration.
   *
   * Requires one of the following permissions: AUTHENTICATED_STAFF_USER, AUTHENTICATED_APP.
   */
  taxConfiguration?: Maybe<TaxConfiguration>;
  /**
   * List of tax configurations.
   *
   * Requires one of the following permissions: AUTHENTICATED_STAFF_USER, AUTHENTICATED_APP.
   */
  taxConfigurations?: Maybe<TaxConfigurationCountableConnection>;
  /**
   * Tax class rates grouped by country.
   *
   * Requires one of the following permissions: AUTHENTICATED_STAFF_USER, AUTHENTICATED_APP.
   */
  taxCountryConfiguration?: Maybe<TaxCountryConfiguration>;
  /**
   *
   *
   * Requires one of the following permissions: AUTHENTICATED_STAFF_USER, AUTHENTICATED_APP.
   */
  taxCountryConfigurations?: Maybe<Array<TaxCountryConfiguration>>;
  /**
   * List of all tax rates available from tax gateway.
   * @deprecated Use `taxClasses` field instead.
   */
  taxTypes?: Maybe<Array<TaxType>>;
  /**
   * Look up a transaction by ID.
   *
   * Requires one of the following permissions: HANDLE_PAYMENTS, MANAGE_ORDERS.
   */
  transaction?: Maybe<TransactionItem>;
  /**
   * List of transactions. For apps with `MANAGE_ORDERS` permission, returns all transactions. For apps with just `HANDLE_PAYMENTS` permission, returns only transactions created by that app. For staff users, returns transactions from orders and checkouts in channels they have access to.
   *
   * Added in Saleor 3.22.
   *
   * Requires one of the following permissions: HANDLE_PAYMENTS, MANAGE_ORDERS.
   */
  transactions?: Maybe<TransactionCountableConnection>;
  /**
   * Lookup a translatable item by ID.
   *
   * Requires one of the following permissions: MANAGE_TRANSLATIONS.
   */
  translation?: Maybe<TranslatableItem>;
  /**
   * Returns a list of all translatable items of a given kind.
   *
   * Requires one of the following permissions: MANAGE_TRANSLATIONS.
   */
  translations?: Maybe<TranslatableItemConnection>;
  /**
   * Look up a user by ID or email address.
   *
   * Requires one of the following permissions: MANAGE_STAFF, MANAGE_USERS, MANAGE_ORDERS.
   */
  user?: Maybe<User>;
  /**
   * Look up a voucher by ID.
   *
   * Requires one of the following permissions: MANAGE_DISCOUNTS.
   */
  voucher?: Maybe<Voucher>;
  /**
   * List of the shop's vouchers.
   *
   * Requires one of the following permissions: MANAGE_DISCOUNTS.
   */
  vouchers?: Maybe<VoucherCountableConnection>;
  /**
   * Look up a warehouse by ID.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS, MANAGE_ORDERS, MANAGE_SHIPPING.
   */
  warehouse?: Maybe<Warehouse>;
  /**
   * List of warehouses.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS, MANAGE_ORDERS, MANAGE_SHIPPING.
   */
  warehouses?: Maybe<WarehouseCountableConnection>;
  /** Look up a webhook by ID. Requires one of the following permissions: MANAGE_APPS, OWNER. */
  webhook?: Maybe<Webhook>;
  /**
   * List of all available webhook events.
   *
   * Requires one of the following permissions: MANAGE_APPS.
   * @deprecated Use `WebhookEventTypeAsyncEnum` and `WebhookEventTypeSyncEnum` to get available event types.
   */
  webhookEvents?: Maybe<Array<WebhookEvent>>;
  /** Retrieve a sample payload for a given webhook event based on real data. It can be useful for some integrations where sample payload is required. */
  webhookSamplePayload?: Maybe<Scalars['JSONString']['output']>;
};


export type Query_EntitiesArgs = {
  representations?: InputMaybe<Array<InputMaybe<Scalars['_Any']['input']>>>;
};


export type QueryAddressArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAddressValidationRulesArgs = {
  city?: InputMaybe<Scalars['String']['input']>;
  cityArea?: InputMaybe<Scalars['String']['input']>;
  countryArea?: InputMaybe<Scalars['String']['input']>;
  countryCode: CountryCode;
};


export type QueryAppArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryAppExtensionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAppExtensionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<AppExtensionFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAppsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<AppFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<AppSortingInput>;
};


export type QueryAttributeArgs = {
  externalReference?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAttributesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  channel?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<AttributeFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<AttributeSortingInput>;
  where?: InputMaybe<AttributeWhereInput>;
};


export type QueryCategoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<CategoryFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<CategorySortingInput>;
  where?: InputMaybe<CategoryWhereInput>;
};


export type QueryCategoryArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  slugLanguageCode?: InputMaybe<LanguageCodeEnum>;
};


export type QueryChannelArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCheckoutArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  token?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryCheckoutLinesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCheckoutsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  channel?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<CheckoutFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<CheckoutSortingInput>;
};


export type QueryCollectionArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  slugLanguageCode?: InputMaybe<LanguageCodeEnum>;
};


export type QueryCollectionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  channel?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<CollectionFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<CollectionSortingInput>;
  where?: InputMaybe<CollectionWhereInput>;
};


export type QueryCustomersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<CustomerFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<UserSortingInput>;
  where?: InputMaybe<CustomerWhereInput>;
};


export type QueryDigitalContentArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDigitalContentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryDraftOrdersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<OrderDraftFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<OrderSortingInput>;
  where?: InputMaybe<DraftOrderWhereInput>;
};


export type QueryExportFileArgs = {
  id: Scalars['ID']['input'];
};


export type QueryExportFilesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ExportFileFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<ExportFileSortingInput>;
};


export type QueryGiftCardArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGiftCardTagsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<GiftCardTagFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGiftCardsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<GiftCardFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<GiftCardSortingInput>;
};


export type QueryHomepageEventsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMenuArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMenuItemArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};


export type QueryMenuItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  channel?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<MenuItemFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<MenuItemSortingInput>;
};


export type QueryMenusArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  channel?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<MenuFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<MenuSortingInput>;
};


export type QueryOrderArgs = {
  externalReference?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryOrderByTokenArgs = {
  token: Scalars['UUID']['input'];
};


export type QueryOrdersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  channel?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<OrderFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<OrderSortingInput>;
  where?: InputMaybe<OrderWhereInput>;
};


export type QueryOrdersTotalArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
  period?: InputMaybe<ReportingPeriod>;
};


export type QueryPageArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  slugLanguageCode?: InputMaybe<LanguageCodeEnum>;
};


export type QueryPageTypeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPageTypesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<PageTypeFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<PageTypeSortingInput>;
};


export type QueryPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  channel?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<PageFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<PageSortingInput>;
  where?: InputMaybe<PageWhereInput>;
};


export type QueryPaymentArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPaymentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<PaymentFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPermissionGroupArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPermissionGroupsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<PermissionGroupFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<PermissionGroupSortingInput>;
};


export type QueryPluginArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPluginsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<PluginFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<PluginSortingInput>;
};


export type QueryProductArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  slugLanguageCode?: InputMaybe<LanguageCodeEnum>;
};


export type QueryProductTypeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryProductTypesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ProductTypeFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<ProductTypeSortingInput>;
};


export type QueryProductVariantArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  sku?: InputMaybe<Scalars['String']['input']>;
};


export type QueryProductVariantsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  channel?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ProductVariantFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<ProductVariantSortingInput>;
  where?: InputMaybe<ProductVariantWhereInput>;
};


export type QueryProductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  channel?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ProductFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<ProductOrder>;
  where?: InputMaybe<ProductWhereInput>;
};


export type QueryPromotionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPromotionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<PromotionSortingInput>;
  where?: InputMaybe<PromotionWhereInput>;
};


export type QueryReportProductSalesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  channel: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  period: ReportingPeriod;
};


export type QuerySaleArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};


export type QuerySalesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  channel?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<SaleFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<SaleSortingInput>;
};


export type QueryShippingZoneArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};


export type QueryShippingZonesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  channel?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ShippingZoneFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryStaffUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<StaffUserInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<UserSortingInput>;
};


export type QueryStockArgs = {
  id: Scalars['ID']['input'];
};


export type QueryStocksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<StockFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTaxClassArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTaxClassesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<TaxClassFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<TaxClassSortingInput>;
};


export type QueryTaxConfigurationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTaxConfigurationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<TaxConfigurationFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTaxCountryConfigurationArgs = {
  countryCode: CountryCode;
};


export type QueryTransactionArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  token?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryTransactionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TransactionWhereInput>;
};


export type QueryTranslationArgs = {
  id: Scalars['ID']['input'];
  kind: TranslatableKinds;
};


export type QueryTranslationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  kind: TranslatableKinds;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryUserArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryVoucherArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};


export type QueryVouchersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  channel?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<VoucherFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<VoucherSortingInput>;
};


export type QueryWarehouseArgs = {
  externalReference?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryWarehousesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<WarehouseFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<WarehouseSortingInput>;
};


export type QueryWebhookArgs = {
  id: Scalars['ID']['input'];
};


export type QueryWebhookSamplePayloadArgs = {
  eventType: WebhookSampleEventTypeEnum;
};

/** Represents a reduced VAT rate for a particular type of goods. */
export type ReducedRate = {
  __typename?: 'ReducedRate';
  /** Reduced VAT rate in percent. */
  rate: Scalars['Float']['output'];
  /** A type of goods. */
  rateType: Scalars['String']['output'];
};

/**
 * The reference types (product or page type) that are used to narrow down the choices of reference objects.
 * ProductType applicable for reference attribute with `PRODUCT` or `PRODUCT_VARIANT` entity type.
 * PageType applicable for reference attribute with `PAGE` entity type.
 */
export type ReferenceType = PageType | ProductType;

/** Refresh JWT token. Mutation tries to take refreshToken from the input. If it fails it will try to take `refreshToken` from the http-only cookie `refreshToken`. `csrfToken` is required when `refreshToken` is provided as a cookie. */
export type RefreshToken = {
  __typename?: 'RefreshToken';
  /** @deprecated Use `errors` field instead. */
  accountErrors: Array<AccountError>;
  errors: Array<AccountError>;
  /** JWT token, required to authenticate. */
  token?: Maybe<Scalars['String']['output']>;
  /** A user instance. */
  user?: Maybe<User>;
};

/**
 * Updates RefundSettings. The `Page` (Model) Type will be cleared from `reasonReferenceType`. When it's cleared, passing reason reference to refund mutations is no longer accepted and will raise error.
 *
 * Added in Saleor 3.22.
 *
 * Requires one of the following permissions: MANAGE_SETTINGS.
 */
export type RefundReasonReferenceTypeClear = {
  __typename?: 'RefundReasonReferenceTypeClear';
  errors: Array<RefundReasonReferenceTypeClearError>;
  /** Refund settings. */
  refundSettings: RefundSettings;
  /** @deprecated Use `errors` field instead. */
  refundSettingsErrors: Array<RefundReasonReferenceTypeClearError>;
};

export type RefundReasonReferenceTypeClearError = {
  __typename?: 'RefundReasonReferenceTypeClearError';
  /** Failed to clear refund reason reference type */
  code: RefundSettingsErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field?: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message?: Maybe<Scalars['String']['output']>;
};

/**
 * Refund related settings from site settings.
 *
 * Added in Saleor 3.22.
 */
export type RefundSettings = {
  __typename?: 'RefundSettings';
  /** Model type used for refund reasons. */
  reasonReferenceType?: Maybe<PageType>;
};

export type RefundSettingsErrorCode =
  | 'GRAPHQL_ERROR'
  | 'INVALID'
  | 'REQUIRED';

/**
 * Update refund settings across all channels.
 *
 * Added in Saleor 3.22.
 *
 * Requires one of the following permissions: MANAGE_SETTINGS.
 */
export type RefundSettingsUpdate = {
  __typename?: 'RefundSettingsUpdate';
  errors: Array<RefundSettingsUpdateError>;
  /** Refund settings. */
  refundSettings: RefundSettings;
  /** @deprecated Use `errors` field instead. */
  refundSettingsErrors: Array<RefundSettingsUpdateError>;
};

export type RefundSettingsUpdateError = {
  __typename?: 'RefundSettingsUpdateError';
  /** Failed to update Refund Settings */
  code: RefundSettingsErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field?: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message?: Maybe<Scalars['String']['output']>;
};

export type RefundSettingsUpdateInput = {
  /**
   * The ID of a model type, that will be used to reference refund reasons. All models with of this type will be accepted as refund reasons.
   *
   * Added in Saleor 3.22.
   */
  refundReasonReferenceType: Scalars['ID']['input'];
};

export type ReorderInput = {
  /** The ID of the item to move. */
  id: Scalars['ID']['input'];
  /** The new relative sorting position of the item (from -inf to +inf). 1 moves the item one position forward, -1 moves the item one position backward, 0 leaves the item unchanged. */
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
};

export type ReportingPeriod =
  | 'THIS_MONTH'
  | 'TODAY';

/**
 * Request email change of the logged in user.
 *
 * Requires one of the following permissions: AUTHENTICATED_USER.
 *
 * Triggers the following webhook events:
 * - NOTIFY_USER (async): A notification for account email change.
 * - ACCOUNT_CHANGE_EMAIL_REQUESTED (async): An account email change was requested.
 */
export type RequestEmailChange = {
  __typename?: 'RequestEmailChange';
  /** @deprecated Use `errors` field instead. */
  accountErrors: Array<AccountError>;
  errors: Array<AccountError>;
  /** A user instance. */
  user?: Maybe<User>;
};

/**
 * Sends an email with the account password modification link.
 *
 * Triggers the following webhook events:
 * - NOTIFY_USER (async): A notification for password reset.
 * - ACCOUNT_SET_PASSWORD_REQUESTED (async): Setting a new password for the account is requested.
 * - STAFF_SET_PASSWORD_REQUESTED (async): Setting a new password for the staff account is requested.
 */
export type RequestPasswordReset = {
  __typename?: 'RequestPasswordReset';
  /** @deprecated Use `errors` field instead. */
  accountErrors: Array<AccountError>;
  errors: Array<AccountError>;
};

export type RewardTypeEnum =
  | 'GIFT'
  | 'SUBTOTAL_DISCOUNT';

export type RewardValueTypeEnum =
  | 'FIXED'
  | 'PERCENTAGE';

/**
 * Sales allow creating discounts for categories, collections or products and are visible to all the customers.
 *
 * DEPRECATED: this type will be removed. Use `Promotion` type instead.
 */
export type Sale = Node & ObjectWithMetadata & {
  __typename?: 'Sale';
  /** List of categories this sale applies to. */
  categories?: Maybe<CategoryCountableConnection>;
  /**
   * List of channels available for the sale.
   *
   * Requires one of the following permissions: MANAGE_DISCOUNTS.
   */
  channelListings?: Maybe<Array<SaleChannelListing>>;
  /**
   * List of collections this sale applies to.
   *
   * Requires one of the following permissions: MANAGE_DISCOUNTS.
   */
  collections?: Maybe<CollectionCountableConnection>;
  /** The date and time when the sale was created. */
  created: Scalars['DateTime']['output'];
  /** Currency code for sale. */
  currency?: Maybe<Scalars['String']['output']>;
  /** Sale value. */
  discountValue?: Maybe<Scalars['Float']['output']>;
  /** The end date and time of the sale. */
  endDate?: Maybe<Scalars['DateTime']['output']>;
  /** The ID of the sale. */
  id: Scalars['ID']['output'];
  /** List of public metadata items. Can be accessed without permissions. */
  metadata: Array<MetadataItem>;
  /**
   * A single key from public metadata.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   */
  metafield?: Maybe<Scalars['String']['output']>;
  /** Public metadata. Use `keys` to control which fields you want to include. The default is to include everything. */
  metafields?: Maybe<Scalars['Metadata']['output']>;
  /** The name of the sale. */
  name: Scalars['String']['output'];
  /** List of private metadata items. Requires staff permissions to access. */
  privateMetadata: Array<MetadataItem>;
  /**
   * A single key from private metadata. Requires staff permissions to access.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   */
  privateMetafield?: Maybe<Scalars['String']['output']>;
  /** Private metadata. Requires staff permissions to access. Use `keys` to control which fields you want to include. The default is to include everything. */
  privateMetafields?: Maybe<Scalars['Metadata']['output']>;
  /**
   * List of products this sale applies to.
   *
   * Requires one of the following permissions: MANAGE_DISCOUNTS.
   */
  products?: Maybe<ProductCountableConnection>;
  /** The start date and time of the sale. */
  startDate: Scalars['DateTime']['output'];
  /** Returns translated sale fields for the given language code. */
  translation?: Maybe<SaleTranslation>;
  /** Type of the sale, fixed or percentage. */
  type: SaleType;
  /** The date and time when the sale was updated. */
  updatedAt: Scalars['DateTime']['output'];
  /**
   * List of product variants this sale applies to.
   *
   * Requires one of the following permissions: MANAGE_DISCOUNTS.
   */
  variants?: Maybe<ProductVariantCountableConnection>;
};


/**
 * Sales allow creating discounts for categories, collections or products and are visible to all the customers.
 *
 * DEPRECATED: this type will be removed. Use `Promotion` type instead.
 */
export type SaleCategoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * Sales allow creating discounts for categories, collections or products and are visible to all the customers.
 *
 * DEPRECATED: this type will be removed. Use `Promotion` type instead.
 */
export type SaleCollectionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * Sales allow creating discounts for categories, collections or products and are visible to all the customers.
 *
 * DEPRECATED: this type will be removed. Use `Promotion` type instead.
 */
export type SaleMetafieldArgs = {
  key: Scalars['String']['input'];
};


/**
 * Sales allow creating discounts for categories, collections or products and are visible to all the customers.
 *
 * DEPRECATED: this type will be removed. Use `Promotion` type instead.
 */
export type SaleMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


/**
 * Sales allow creating discounts for categories, collections or products and are visible to all the customers.
 *
 * DEPRECATED: this type will be removed. Use `Promotion` type instead.
 */
export type SalePrivateMetafieldArgs = {
  key: Scalars['String']['input'];
};


/**
 * Sales allow creating discounts for categories, collections or products and are visible to all the customers.
 *
 * DEPRECATED: this type will be removed. Use `Promotion` type instead.
 */
export type SalePrivateMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


/**
 * Sales allow creating discounts for categories, collections or products and are visible to all the customers.
 *
 * DEPRECATED: this type will be removed. Use `Promotion` type instead.
 */
export type SaleProductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * Sales allow creating discounts for categories, collections or products and are visible to all the customers.
 *
 * DEPRECATED: this type will be removed. Use `Promotion` type instead.
 */
export type SaleTranslationArgs = {
  languageCode: LanguageCodeEnum;
};


/**
 * Sales allow creating discounts for categories, collections or products and are visible to all the customers.
 *
 * DEPRECATED: this type will be removed. Use `Promotion` type instead.
 */
export type SaleVariantsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * Adds products, categories, collections to a sale.
 *
 * Requires one of the following permissions: MANAGE_DISCOUNTS.
 *
 * Triggers the following webhook events:
 * - SALE_UPDATED (async): A sale was updated.
 */
export type SaleAddCatalogues = {
  __typename?: 'SaleAddCatalogues';
  /** @deprecated Use `errors` field instead. */
  discountErrors: Array<DiscountError>;
  errors: Array<DiscountError>;
  /** Sale of which catalogue IDs will be modified. */
  sale?: Maybe<Sale>;
};

/**
 * Deletes sales.
 *
 * Requires one of the following permissions: MANAGE_DISCOUNTS.
 *
 * Triggers the following webhook events:
 * - SALE_DELETED (async): A sale was deleted.
 */
export type SaleBulkDelete = {
  __typename?: 'SaleBulkDelete';
  /** Returns how many objects were affected. */
  count: Scalars['Int']['output'];
  /** @deprecated Use `errors` field instead. */
  discountErrors: Array<DiscountError>;
  errors: Array<DiscountError>;
};

/**
 * Represents sale channel listing.
 *
 * DEPRECATED: this type will be removed. Use `PromotionRule` type instead.
 */
export type SaleChannelListing = Node & {
  __typename?: 'SaleChannelListing';
  /** The channel in which the sale is available. */
  channel: Channel;
  /** The currency in which the discount value is specified. */
  currency: Scalars['String']['output'];
  /** The value of the discount applied to the sale in the channel. */
  discountValue: Scalars['Float']['output'];
  /** The ID of the channel listing. */
  id: Scalars['ID']['output'];
};

export type SaleChannelListingAddInput = {
  /** ID of a channel. */
  channelId: Scalars['ID']['input'];
  /** The value of the discount. */
  discountValue: Scalars['PositiveDecimal']['input'];
};

export type SaleChannelListingInput = {
  /** List of channels to which the sale should be assigned. */
  addChannels?: InputMaybe<Array<SaleChannelListingAddInput>>;
  /** List of channels from which the sale should be unassigned. */
  removeChannels?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * Manage sale's availability in channels.
 *
 * Requires one of the following permissions: MANAGE_DISCOUNTS.
 */
export type SaleChannelListingUpdate = {
  __typename?: 'SaleChannelListingUpdate';
  /** @deprecated Use `errors` field instead. */
  discountErrors: Array<DiscountError>;
  errors: Array<DiscountError>;
  /** An updated sale instance. */
  sale?: Maybe<Sale>;
};

export type SaleCountableConnection = {
  __typename?: 'SaleCountableConnection';
  edges: Array<SaleCountableEdge>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** A total count of items in the collection. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type SaleCountableEdge = {
  __typename?: 'SaleCountableEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Sale;
};

/**
 * Creates a new sale.
 *
 * Requires one of the following permissions: MANAGE_DISCOUNTS.
 *
 * Triggers the following webhook events:
 * - SALE_CREATED (async): A sale was created.
 */
export type SaleCreate = {
  __typename?: 'SaleCreate';
  /** @deprecated Use `errors` field instead. */
  discountErrors: Array<DiscountError>;
  errors: Array<DiscountError>;
  sale?: Maybe<Sale>;
};

/**
 * Event sent when new sale is created.
 *
 * DEPRECATED: this event will be removed. Use `PromotionCreated` event instead.
 */
export type SaleCreated = Event & {
  __typename?: 'SaleCreated';
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<IssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient?: Maybe<App>;
  /** The sale the event relates to. */
  sale?: Maybe<Sale>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};


/**
 * Event sent when new sale is created.
 *
 * DEPRECATED: this event will be removed. Use `PromotionCreated` event instead.
 */
export type SaleCreatedSaleArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Deletes a sale.
 *
 * Requires one of the following permissions: MANAGE_DISCOUNTS.
 *
 * Triggers the following webhook events:
 * - SALE_DELETED (async): A sale was deleted.
 */
export type SaleDelete = {
  __typename?: 'SaleDelete';
  /** @deprecated Use `errors` field instead. */
  discountErrors: Array<DiscountError>;
  errors: Array<DiscountError>;
  sale?: Maybe<Sale>;
};

/**
 * Event sent when sale is deleted.
 *
 * DEPRECATED: this event will be removed. Use `PromotionDeleted` event instead.
 */
export type SaleDeleted = Event & {
  __typename?: 'SaleDeleted';
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<IssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient?: Maybe<App>;
  /** The sale the event relates to. */
  sale?: Maybe<Sale>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};


/**
 * Event sent when sale is deleted.
 *
 * DEPRECATED: this event will be removed. Use `PromotionDeleted` event instead.
 */
export type SaleDeletedSaleArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
};

export type SaleFilterInput = {
  metadata?: InputMaybe<Array<MetadataFilter>>;
  saleType?: InputMaybe<DiscountValueTypeEnum>;
  search?: InputMaybe<Scalars['String']['input']>;
  started?: InputMaybe<DateTimeRangeInput>;
  status?: InputMaybe<Array<DiscountStatusEnum>>;
  updatedAt?: InputMaybe<DateTimeRangeInput>;
};

export type SaleInput = {
  /** Categories related to the discount. */
  categories?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Collections related to the discount. */
  collections?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** End date of the voucher in ISO 8601 format. */
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Voucher name. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Products related to the discount. */
  products?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Start date of the voucher in ISO 8601 format. */
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Fixed or percentage. */
  type?: InputMaybe<DiscountValueTypeEnum>;
  /** Value of the voucher. */
  value?: InputMaybe<Scalars['PositiveDecimal']['input']>;
  variants?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * Removes products, categories, collections from a sale.
 *
 * Requires one of the following permissions: MANAGE_DISCOUNTS.
 *
 * Triggers the following webhook events:
 * - SALE_UPDATED (async): A sale was updated.
 */
export type SaleRemoveCatalogues = {
  __typename?: 'SaleRemoveCatalogues';
  /** @deprecated Use `errors` field instead. */
  discountErrors: Array<DiscountError>;
  errors: Array<DiscountError>;
  /** Sale of which catalogue IDs will be modified. */
  sale?: Maybe<Sale>;
};

export type SaleSortField =
  /** Sort sales by creation date. */
  | 'CREATED_AT'
  /** Sort sales by end date. */
  | 'END_DATE'
  /** Sort sales by last modification date. */
  | 'LAST_MODIFIED_AT'
  /** Sort sales by name. */
  | 'NAME'
  /** Sort sales by start date. */
  | 'START_DATE'
  /** Sort sales by type. */
  | 'TYPE'
  /**
   * Sort sales by value.
   *
   * This option requires a channel filter to work as the values can vary between channels.
   */
  | 'VALUE';

export type SaleSortingInput = {
  /**
   * Specifies the channel in which to sort the data.
   *
   * DEPRECATED: this field will be removed. Use root-level channel argument instead.
   */
  channel?: InputMaybe<Scalars['String']['input']>;
  /** Specifies the direction in which to sort sales. */
  direction: OrderDirection;
  /** Sort sales by the selected field. */
  field: SaleSortField;
};

/**
 * The event informs about the start or end of the sale.
 *
 * DEPRECATED: this event will be removed. Use `PromotionStarted` and `PromotionEnded` events instead.
 */
export type SaleToggle = Event & {
  __typename?: 'SaleToggle';
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<IssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient?: Maybe<App>;
  /** The sale the event relates to. */
  sale?: Maybe<Sale>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};


/**
 * The event informs about the start or end of the sale.
 *
 * DEPRECATED: this event will be removed. Use `PromotionStarted` and `PromotionEnded` events instead.
 */
export type SaleToggleSaleArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Represents sale's original translatable fields and related translations.
 *
 * DEPRECATED: this type will be removed. Use `PromotionTranslatableContent` instead.
 */
export type SaleTranslatableContent = Node & {
  __typename?: 'SaleTranslatableContent';
  /** The ID of the sale translatable content. */
  id: Scalars['ID']['output'];
  /** Name of the sale to translate. */
  name: Scalars['String']['output'];
  /**
   * Sales allow creating discounts for categories, collections or products and are visible to all the customers.
   *
   * Requires one of the following permissions: MANAGE_DISCOUNTS.
   * @deprecated Get model fields from the root level queries.
   */
  sale?: Maybe<Sale>;
  /** The ID of the sale to translate. */
  saleId: Scalars['ID']['output'];
  /** Returns translated sale fields for the given language code. */
  translation?: Maybe<SaleTranslation>;
};


/**
 * Represents sale's original translatable fields and related translations.
 *
 * DEPRECATED: this type will be removed. Use `PromotionTranslatableContent` instead.
 */
export type SaleTranslatableContentTranslationArgs = {
  languageCode: LanguageCodeEnum;
};

/**
 * Creates/updates translations for a sale.
 *
 * Requires one of the following permissions: MANAGE_TRANSLATIONS.
 */
export type SaleTranslate = {
  __typename?: 'SaleTranslate';
  errors: Array<TranslationError>;
  sale?: Maybe<Sale>;
  /** @deprecated Use `errors` field instead. */
  translationErrors: Array<TranslationError>;
};

/**
 * Represents sale translations.
 *
 * DEPRECATED: this type will be removed. Use `PromotionTranslation` instead.
 */
export type SaleTranslation = Node & {
  __typename?: 'SaleTranslation';
  /** The ID of the sale translation. */
  id: Scalars['ID']['output'];
  /** Translation language. */
  language: LanguageDisplay;
  /** Translated name of sale. */
  name?: Maybe<Scalars['String']['output']>;
  /** Represents the sale fields to translate. */
  translatableContent?: Maybe<SaleTranslatableContent>;
};

export type SaleType =
  | 'FIXED'
  | 'PERCENTAGE';

/**
 * Updates a sale.
 *
 * Requires one of the following permissions: MANAGE_DISCOUNTS.
 *
 * Triggers the following webhook events:
 * - SALE_UPDATED (async): A sale was updated.
 * - SALE_TOGGLE (async): Optionally triggered when a sale is started or stopped.
 */
export type SaleUpdate = {
  __typename?: 'SaleUpdate';
  /** @deprecated Use `errors` field instead. */
  discountErrors: Array<DiscountError>;
  errors: Array<DiscountError>;
  sale?: Maybe<Sale>;
};

/**
 * Event sent when sale is updated.
 *
 * DEPRECATED: this event will be removed. Use `PromotionUpdated` event instead.
 */
export type SaleUpdated = Event & {
  __typename?: 'SaleUpdated';
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<IssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient?: Maybe<App>;
  /** The sale the event relates to. */
  sale?: Maybe<Sale>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};


/**
 * Event sent when sale is updated.
 *
 * DEPRECATED: this event will be removed. Use `PromotionUpdated` event instead.
 */
export type SaleUpdatedSaleArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
};

/** Represents an assigned attribute to an object. */
export type SelectedAttribute = {
  __typename?: 'SelectedAttribute';
  /** Name of an attribute displayed in the interface. */
  attribute: Attribute;
  /** Values of an attribute. */
  values: Array<AttributeValue>;
};

/**
 * Sends a notification confirmation.
 *
 * Requires one of the following permissions: AUTHENTICATED_USER.
 *
 * Triggers the following webhook events:
 * - NOTIFY_USER (async): A notification for account confirmation.
 * - ACCOUNT_CONFIRMATION_REQUESTED (async): An account confirmation was requested. This event is always sent regardless of settings.
 */
export type SendConfirmationEmail = {
  __typename?: 'SendConfirmationEmail';
  errors: Array<SendConfirmationEmailError>;
};

export type SendConfirmationEmailError = {
  __typename?: 'SendConfirmationEmailError';
  /** The error code. */
  code: SendConfirmationEmailErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field?: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message?: Maybe<Scalars['String']['output']>;
};

export type SendConfirmationEmailErrorCode =
  | 'ACCOUNT_CONFIRMED'
  | 'CONFIRMATION_ALREADY_REQUESTED'
  | 'INVALID'
  | 'MISSING_CHANNEL_SLUG';

export type SeoInput = {
  /** SEO description. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** SEO title. */
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Sets the user's password from the token sent by email using the RequestPasswordReset mutation. */
export type SetPassword = {
  __typename?: 'SetPassword';
  /** @deprecated Use `errors` field instead. */
  accountErrors: Array<AccountError>;
  /** CSRF token required to re-generate access token. */
  csrfToken?: Maybe<Scalars['String']['output']>;
  errors: Array<AccountError>;
  /** JWT refresh token, required to re-generate access token. */
  refreshToken?: Maybe<Scalars['String']['output']>;
  /** JWT token, required to authenticate. */
  token?: Maybe<Scalars['String']['output']>;
  /** A user instance. */
  user?: Maybe<User>;
};

export type ShippingError = {
  __typename?: 'ShippingError';
  /** List of channels IDs which causes the error. */
  channels?: Maybe<Array<Scalars['ID']['output']>>;
  /** The error code. */
  code: ShippingErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field?: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message?: Maybe<Scalars['String']['output']>;
  /** List of warehouse IDs which causes the error. */
  warehouses?: Maybe<Array<Scalars['ID']['output']>>;
};

export type ShippingErrorCode =
  | 'ALREADY_EXISTS'
  | 'DUPLICATED_INPUT_ITEM'
  | 'GRAPHQL_ERROR'
  | 'INVALID'
  | 'MAX_LESS_THAN_MIN'
  | 'NOT_FOUND'
  | 'REQUIRED'
  | 'UNIQUE';

/** List shipping methods for checkout. */
export type ShippingListMethodsForCheckout = Event & {
  __typename?: 'ShippingListMethodsForCheckout';
  /** The checkout the event relates to. */
  checkout?: Maybe<Checkout>;
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<IssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient?: Maybe<App>;
  /** Shipping methods that can be used with this checkout. */
  shippingMethods?: Maybe<Array<ShippingMethod>>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

/** Shipping methods that can be used as means of shipping for orders and checkouts. */
export type ShippingMethod = Node & ObjectWithMetadata & {
  __typename?: 'ShippingMethod';
  /** Describes if this shipping method is active and can be selected. */
  active: Scalars['Boolean']['output'];
  /**
   * Shipping method description.
   *
   * Rich text format. For reference see https://editorjs.io/
   */
  description?: Maybe<Scalars['JSONString']['output']>;
  /** Unique ID of ShippingMethod available for Order. */
  id: Scalars['ID']['output'];
  /** Maximum delivery days for this shipping method. */
  maximumDeliveryDays?: Maybe<Scalars['Int']['output']>;
  /** Maximum order price for this shipping method. */
  maximumOrderPrice?: Maybe<Money>;
  /**
   * Maximum order weight for this shipping method.
   * @deprecated No longer supported
   */
  maximumOrderWeight?: Maybe<Weight>;
  /** Message connected to this shipping method. */
  message?: Maybe<Scalars['String']['output']>;
  /** List of public metadata items. Can be accessed without permissions. */
  metadata: Array<MetadataItem>;
  /**
   * A single key from public metadata.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   */
  metafield?: Maybe<Scalars['String']['output']>;
  /** Public metadata. Use `keys` to control which fields you want to include. The default is to include everything. */
  metafields?: Maybe<Scalars['Metadata']['output']>;
  /** Minimum delivery days for this shipping method. */
  minimumDeliveryDays?: Maybe<Scalars['Int']['output']>;
  /** Minimal order price for this shipping method. */
  minimumOrderPrice?: Maybe<Money>;
  /**
   * Minimum order weight for this shipping method.
   * @deprecated No longer supported
   */
  minimumOrderWeight?: Maybe<Weight>;
  /** Shipping method name. */
  name: Scalars['String']['output'];
  /** The price of selected shipping method. */
  price: Money;
  /** List of private metadata items. Requires staff permissions to access. */
  privateMetadata: Array<MetadataItem>;
  /**
   * A single key from private metadata. Requires staff permissions to access.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   */
  privateMetafield?: Maybe<Scalars['String']['output']>;
  /** Private metadata. Requires staff permissions to access. Use `keys` to control which fields you want to include. The default is to include everything. */
  privateMetafields?: Maybe<Scalars['Metadata']['output']>;
  /** Returns translated shipping method fields for the given language code. */
  translation?: Maybe<ShippingMethodTranslation>;
  /**
   * Type of the shipping method.
   * @deprecated No longer supported
   */
  type?: Maybe<ShippingMethodTypeEnum>;
};


/** Shipping methods that can be used as means of shipping for orders and checkouts. */
export type ShippingMethodMetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Shipping methods that can be used as means of shipping for orders and checkouts. */
export type ShippingMethodMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Shipping methods that can be used as means of shipping for orders and checkouts. */
export type ShippingMethodPrivateMetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Shipping methods that can be used as means of shipping for orders and checkouts. */
export type ShippingMethodPrivateMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Shipping methods that can be used as means of shipping for orders and checkouts. */
export type ShippingMethodTranslationArgs = {
  languageCode: LanguageCodeEnum;
};

/** Represents shipping method channel listing. */
export type ShippingMethodChannelListing = Node & {
  __typename?: 'ShippingMethodChannelListing';
  /** The channel associated with the shipping method channel listing. */
  channel: Channel;
  /** The ID of shipping method channel listing. */
  id: Scalars['ID']['output'];
  /** Maximum order price. */
  maximumOrderPrice?: Maybe<Money>;
  /** Minimum order price. */
  minimumOrderPrice?: Maybe<Money>;
  /** Price of the shipping method in the associated channel. */
  price?: Maybe<Money>;
};

export type ShippingMethodChannelListingAddInput = {
  /** ID of a channel. */
  channelId: Scalars['ID']['input'];
  /** Maximum order price to use this shipping method. */
  maximumOrderPrice?: InputMaybe<Scalars['PositiveDecimal']['input']>;
  /** Minimum order price to use this shipping method. */
  minimumOrderPrice?: InputMaybe<Scalars['PositiveDecimal']['input']>;
  /** Shipping price of the shipping method in this channel. */
  price?: InputMaybe<Scalars['PositiveDecimal']['input']>;
};

export type ShippingMethodChannelListingInput = {
  /** List of channels to which the shipping method should be assigned. */
  addChannels?: InputMaybe<Array<ShippingMethodChannelListingAddInput>>;
  /** List of channels from which the shipping method should be unassigned. */
  removeChannels?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * Manage shipping method's availability in channels.
 *
 * Requires one of the following permissions: MANAGE_SHIPPING.
 */
export type ShippingMethodChannelListingUpdate = {
  __typename?: 'ShippingMethodChannelListingUpdate';
  errors: Array<ShippingError>;
  /** @deprecated Use `errors` field instead. */
  shippingErrors: Array<ShippingError>;
  /** An updated shipping method instance. */
  shippingMethod?: Maybe<ShippingMethodType>;
};

/** Represents shipping method postal code rule. */
export type ShippingMethodPostalCodeRule = Node & {
  __typename?: 'ShippingMethodPostalCodeRule';
  /** End address range. */
  end?: Maybe<Scalars['String']['output']>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  /** Inclusion type of the postal code rule. */
  inclusionType?: Maybe<PostalCodeRuleInclusionTypeEnum>;
  /** Start address range. */
  start?: Maybe<Scalars['String']['output']>;
};

/** Represents shipping method's original translatable fields and related translations. */
export type ShippingMethodTranslatableContent = Node & {
  __typename?: 'ShippingMethodTranslatableContent';
  /**
   * Shipping method description to translate.
   *
   * Rich text format. For reference see https://editorjs.io/
   */
  description?: Maybe<Scalars['JSONString']['output']>;
  /** The ID of the shipping method translatable content. */
  id: Scalars['ID']['output'];
  /** Shipping method name to translate. */
  name: Scalars['String']['output'];
  /**
   * Shipping method are the methods you'll use to get customer's orders  to them. They are directly exposed to the customers.
   *
   * Requires one of the following permissions: MANAGE_SHIPPING.
   * @deprecated Get model fields from the root level queries.
   */
  shippingMethod?: Maybe<ShippingMethodType>;
  /** The ID of the shipping method to translate. */
  shippingMethodId: Scalars['ID']['output'];
  /** Returns translated shipping method fields for the given language code. */
  translation?: Maybe<ShippingMethodTranslation>;
};


/** Represents shipping method's original translatable fields and related translations. */
export type ShippingMethodTranslatableContentTranslationArgs = {
  languageCode: LanguageCodeEnum;
};

/** Represents shipping method translations. */
export type ShippingMethodTranslation = Node & {
  __typename?: 'ShippingMethodTranslation';
  /**
   * Translated description of the shipping method.
   *
   * Rich text format. For reference see https://editorjs.io/
   */
  description?: Maybe<Scalars['JSONString']['output']>;
  /** The ID of the shipping method translation. */
  id: Scalars['ID']['output'];
  /** Translation language. */
  language: LanguageDisplay;
  /** Translated shipping method name. */
  name?: Maybe<Scalars['String']['output']>;
  /** Represents the shipping method fields to translate. */
  translatableContent?: Maybe<ShippingMethodTranslatableContent>;
};

/** Shipping method are the methods you'll use to get customer's orders to them. They are directly exposed to the customers. */
export type ShippingMethodType = Node & ObjectWithMetadata & {
  __typename?: 'ShippingMethodType';
  /**
   * List of channels available for the method.
   *
   * Requires one of the following permissions: MANAGE_SHIPPING.
   */
  channelListings?: Maybe<Array<ShippingMethodChannelListing>>;
  /**
   * Shipping method description.
   *
   * Rich text format. For reference see https://editorjs.io/
   */
  description?: Maybe<Scalars['JSONString']['output']>;
  /**
   * List of excluded products for the shipping method.
   *
   * Requires one of the following permissions: MANAGE_SHIPPING.
   */
  excludedProducts?: Maybe<ProductCountableConnection>;
  /** Shipping method ID. */
  id: Scalars['ID']['output'];
  /** Maximum number of days for delivery. */
  maximumDeliveryDays?: Maybe<Scalars['Int']['output']>;
  /** The price of the cheapest variant (including discounts). */
  maximumOrderPrice?: Maybe<Money>;
  /** Maximum order weight to use this shipping method. */
  maximumOrderWeight?: Maybe<Weight>;
  /** List of public metadata items. Can be accessed without permissions. */
  metadata: Array<MetadataItem>;
  /**
   * A single key from public metadata.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   */
  metafield?: Maybe<Scalars['String']['output']>;
  /** Public metadata. Use `keys` to control which fields you want to include. The default is to include everything. */
  metafields?: Maybe<Scalars['Metadata']['output']>;
  /** Minimal number of days for delivery. */
  minimumDeliveryDays?: Maybe<Scalars['Int']['output']>;
  /** The price of the cheapest variant (including discounts). */
  minimumOrderPrice?: Maybe<Money>;
  /** Minimum order weight to use this shipping method. */
  minimumOrderWeight?: Maybe<Weight>;
  /** Shipping method name. */
  name: Scalars['String']['output'];
  /** Postal code ranges rule of exclusion or inclusion of the shipping method. */
  postalCodeRules?: Maybe<Array<ShippingMethodPostalCodeRule>>;
  /** List of private metadata items. Requires staff permissions to access. */
  privateMetadata: Array<MetadataItem>;
  /**
   * A single key from private metadata. Requires staff permissions to access.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   */
  privateMetafield?: Maybe<Scalars['String']['output']>;
  /** Private metadata. Requires staff permissions to access. Use `keys` to control which fields you want to include. The default is to include everything. */
  privateMetafields?: Maybe<Scalars['Metadata']['output']>;
  /**
   * Tax class assigned to this shipping method.
   *
   * Requires one of the following permissions: AUTHENTICATED_STAFF_USER, AUTHENTICATED_APP.
   */
  taxClass?: Maybe<TaxClass>;
  /** Returns translated shipping method fields for the given language code. */
  translation?: Maybe<ShippingMethodTranslation>;
  /** Type of the shipping method. */
  type?: Maybe<ShippingMethodTypeEnum>;
};


/** Shipping method are the methods you'll use to get customer's orders to them. They are directly exposed to the customers. */
export type ShippingMethodTypeExcludedProductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Shipping method are the methods you'll use to get customer's orders to them. They are directly exposed to the customers. */
export type ShippingMethodTypeMetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Shipping method are the methods you'll use to get customer's orders to them. They are directly exposed to the customers. */
export type ShippingMethodTypeMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Shipping method are the methods you'll use to get customer's orders to them. They are directly exposed to the customers. */
export type ShippingMethodTypePrivateMetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Shipping method are the methods you'll use to get customer's orders to them. They are directly exposed to the customers. */
export type ShippingMethodTypePrivateMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Shipping method are the methods you'll use to get customer's orders to them. They are directly exposed to the customers. */
export type ShippingMethodTypeTranslationArgs = {
  languageCode: LanguageCodeEnum;
};

export type ShippingMethodTypeEnum =
  | 'PRICE'
  | 'WEIGHT';

/** List of shipping methods available for the country. */
export type ShippingMethodsPerCountry = {
  __typename?: 'ShippingMethodsPerCountry';
  /** The country code. */
  countryCode: CountryCode;
  /** List of available shipping methods. */
  shippingMethods?: Maybe<Array<ShippingMethod>>;
};

export type ShippingPostalCodeRulesCreateInputRange = {
  /** End range of the postal code. */
  end?: InputMaybe<Scalars['String']['input']>;
  /** Start range of the postal code. */
  start: Scalars['String']['input'];
};

/**
 * Deletes shipping prices.
 *
 * Requires one of the following permissions: MANAGE_SHIPPING.
 */
export type ShippingPriceBulkDelete = {
  __typename?: 'ShippingPriceBulkDelete';
  /** Returns how many objects were affected. */
  count: Scalars['Int']['output'];
  errors: Array<ShippingError>;
  /** @deprecated Use `errors` field instead. */
  shippingErrors: Array<ShippingError>;
};

/**
 * Creates a new shipping price.
 *
 * Requires one of the following permissions: MANAGE_SHIPPING.
 */
export type ShippingPriceCreate = {
  __typename?: 'ShippingPriceCreate';
  errors: Array<ShippingError>;
  /** @deprecated Use `errors` field instead. */
  shippingErrors: Array<ShippingError>;
  shippingMethod?: Maybe<ShippingMethodType>;
  /** A shipping zone to which the shipping method belongs. */
  shippingZone?: Maybe<ShippingZone>;
};

/** Event sent when new shipping price is created. */
export type ShippingPriceCreated = Event & {
  __typename?: 'ShippingPriceCreated';
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<IssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient?: Maybe<App>;
  /** The shipping method the event relates to. */
  shippingMethod?: Maybe<ShippingMethodType>;
  /** The shipping zone the shipping method belongs to. */
  shippingZone?: Maybe<ShippingZone>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};


/** Event sent when new shipping price is created. */
export type ShippingPriceCreatedShippingMethodArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
};


/** Event sent when new shipping price is created. */
export type ShippingPriceCreatedShippingZoneArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Deletes a shipping price.
 *
 * Requires one of the following permissions: MANAGE_SHIPPING.
 */
export type ShippingPriceDelete = {
  __typename?: 'ShippingPriceDelete';
  errors: Array<ShippingError>;
  /** @deprecated Use `errors` field instead. */
  shippingErrors: Array<ShippingError>;
  /** A shipping method to delete. */
  shippingMethod?: Maybe<ShippingMethodType>;
  /** A shipping zone to which the shipping method belongs. */
  shippingZone?: Maybe<ShippingZone>;
};

/** Event sent when shipping price is deleted. */
export type ShippingPriceDeleted = Event & {
  __typename?: 'ShippingPriceDeleted';
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<IssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient?: Maybe<App>;
  /** The shipping method the event relates to. */
  shippingMethod?: Maybe<ShippingMethodType>;
  /** The shipping zone the shipping method belongs to. */
  shippingZone?: Maybe<ShippingZone>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};


/** Event sent when shipping price is deleted. */
export type ShippingPriceDeletedShippingMethodArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
};


/** Event sent when shipping price is deleted. */
export type ShippingPriceDeletedShippingZoneArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Exclude products from shipping price.
 *
 * Requires one of the following permissions: MANAGE_SHIPPING.
 */
export type ShippingPriceExcludeProducts = {
  __typename?: 'ShippingPriceExcludeProducts';
  errors: Array<ShippingError>;
  /** @deprecated Use `errors` field instead. */
  shippingErrors: Array<ShippingError>;
  /** A shipping method with new list of excluded products. */
  shippingMethod?: Maybe<ShippingMethodType>;
};

export type ShippingPriceExcludeProductsInput = {
  /** List of products which will be excluded. */
  products: Array<Scalars['ID']['input']>;
};

export type ShippingPriceInput = {
  /** Postal code rules to add. */
  addPostalCodeRules?: InputMaybe<Array<ShippingPostalCodeRulesCreateInputRange>>;
  /** Postal code rules to delete. */
  deletePostalCodeRules?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Shipping method description. */
  description?: InputMaybe<Scalars['JSONString']['input']>;
  /** Inclusion type for currently assigned postal code rules. */
  inclusionType?: InputMaybe<PostalCodeRuleInclusionTypeEnum>;
  /** Maximum number of days for delivery. */
  maximumDeliveryDays?: InputMaybe<Scalars['Int']['input']>;
  /** Maximum order weight to use this shipping method. */
  maximumOrderWeight?: InputMaybe<Scalars['WeightScalar']['input']>;
  /** Minimal number of days for delivery. */
  minimumDeliveryDays?: InputMaybe<Scalars['Int']['input']>;
  /** Minimum order weight to use this shipping method. */
  minimumOrderWeight?: InputMaybe<Scalars['WeightScalar']['input']>;
  /** Name of the shipping method. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Shipping zone this method belongs to. */
  shippingZone?: InputMaybe<Scalars['ID']['input']>;
  /** ID of a tax class to assign to this shipping method. If not provided, the default tax class will be used. */
  taxClass?: InputMaybe<Scalars['ID']['input']>;
  /** Shipping type: price or weight based. */
  type?: InputMaybe<ShippingMethodTypeEnum>;
};

/**
 * Remove product from excluded list for shipping price.
 *
 * Requires one of the following permissions: MANAGE_SHIPPING.
 */
export type ShippingPriceRemoveProductFromExclude = {
  __typename?: 'ShippingPriceRemoveProductFromExclude';
  errors: Array<ShippingError>;
  /** @deprecated Use `errors` field instead. */
  shippingErrors: Array<ShippingError>;
  /** A shipping method with new list of excluded products. */
  shippingMethod?: Maybe<ShippingMethodType>;
};

/**
 * Creates/updates translations for a shipping method.
 *
 * Requires one of the following permissions: MANAGE_TRANSLATIONS.
 */
export type ShippingPriceTranslate = {
  __typename?: 'ShippingPriceTranslate';
  errors: Array<TranslationError>;
  shippingMethod?: Maybe<ShippingMethodType>;
  /** @deprecated Use `errors` field instead. */
  translationErrors: Array<TranslationError>;
};

export type ShippingPriceTranslationInput = {
  /**
   * Translated shipping method description.
   *
   * Rich text format. For reference see https://editorjs.io/
   */
  description?: InputMaybe<Scalars['JSONString']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Updates a new shipping price.
 *
 * Requires one of the following permissions: MANAGE_SHIPPING.
 */
export type ShippingPriceUpdate = {
  __typename?: 'ShippingPriceUpdate';
  errors: Array<ShippingError>;
  /** @deprecated Use `errors` field instead. */
  shippingErrors: Array<ShippingError>;
  shippingMethod?: Maybe<ShippingMethodType>;
  /** A shipping zone to which the shipping method belongs. */
  shippingZone?: Maybe<ShippingZone>;
};

/** Event sent when shipping price is updated. */
export type ShippingPriceUpdated = Event & {
  __typename?: 'ShippingPriceUpdated';
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<IssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient?: Maybe<App>;
  /** The shipping method the event relates to. */
  shippingMethod?: Maybe<ShippingMethodType>;
  /** The shipping zone the shipping method belongs to. */
  shippingZone?: Maybe<ShippingZone>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};


/** Event sent when shipping price is updated. */
export type ShippingPriceUpdatedShippingMethodArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
};


/** Event sent when shipping price is updated. */
export type ShippingPriceUpdatedShippingZoneArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
};

/** Represents a shipping zone in the shop. Zones are the concept used only for grouping shipping methods in the dashboard, and are never exposed to the customers directly. */
export type ShippingZone = Node & ObjectWithMetadata & {
  __typename?: 'ShippingZone';
  /** List of channels for shipping zone. */
  channels: Array<Channel>;
  /** List of countries available for the method. */
  countries: Array<CountryDisplay>;
  /** Indicates if the shipping zone is default one. */
  default: Scalars['Boolean']['output'];
  /** Description of a shipping zone. */
  description?: Maybe<Scalars['String']['output']>;
  /** The ID of shipping zone. */
  id: Scalars['ID']['output'];
  /** List of public metadata items. Can be accessed without permissions. */
  metadata: Array<MetadataItem>;
  /**
   * A single key from public metadata.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   */
  metafield?: Maybe<Scalars['String']['output']>;
  /** Public metadata. Use `keys` to control which fields you want to include. The default is to include everything. */
  metafields?: Maybe<Scalars['Metadata']['output']>;
  /** Shipping zone name. */
  name: Scalars['String']['output'];
  /** Lowest and highest prices for the shipping. */
  priceRange?: Maybe<MoneyRange>;
  /** List of private metadata items. Requires staff permissions to access. */
  privateMetadata: Array<MetadataItem>;
  /**
   * A single key from private metadata. Requires staff permissions to access.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   */
  privateMetafield?: Maybe<Scalars['String']['output']>;
  /** Private metadata. Requires staff permissions to access. Use `keys` to control which fields you want to include. The default is to include everything. */
  privateMetafields?: Maybe<Scalars['Metadata']['output']>;
  /** List of shipping methods available for orders shipped to countries within this shipping zone. */
  shippingMethods?: Maybe<Array<ShippingMethodType>>;
  /** List of warehouses for shipping zone. */
  warehouses: Array<Warehouse>;
};


/** Represents a shipping zone in the shop. Zones are the concept used only for grouping shipping methods in the dashboard, and are never exposed to the customers directly. */
export type ShippingZoneMetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Represents a shipping zone in the shop. Zones are the concept used only for grouping shipping methods in the dashboard, and are never exposed to the customers directly. */
export type ShippingZoneMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Represents a shipping zone in the shop. Zones are the concept used only for grouping shipping methods in the dashboard, and are never exposed to the customers directly. */
export type ShippingZonePrivateMetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Represents a shipping zone in the shop. Zones are the concept used only for grouping shipping methods in the dashboard, and are never exposed to the customers directly. */
export type ShippingZonePrivateMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};

/**
 * Deletes shipping zones.
 *
 * Requires one of the following permissions: MANAGE_SHIPPING.
 */
export type ShippingZoneBulkDelete = {
  __typename?: 'ShippingZoneBulkDelete';
  /** Returns how many objects were affected. */
  count: Scalars['Int']['output'];
  errors: Array<ShippingError>;
  /** @deprecated Use `errors` field instead. */
  shippingErrors: Array<ShippingError>;
};

export type ShippingZoneCountableConnection = {
  __typename?: 'ShippingZoneCountableConnection';
  edges: Array<ShippingZoneCountableEdge>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** A total count of items in the collection. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type ShippingZoneCountableEdge = {
  __typename?: 'ShippingZoneCountableEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ShippingZone;
};

/**
 * Creates a new shipping zone.
 *
 * Requires one of the following permissions: MANAGE_SHIPPING.
 */
export type ShippingZoneCreate = {
  __typename?: 'ShippingZoneCreate';
  errors: Array<ShippingError>;
  /** @deprecated Use `errors` field instead. */
  shippingErrors: Array<ShippingError>;
  shippingZone?: Maybe<ShippingZone>;
};

export type ShippingZoneCreateInput = {
  /** List of channels to assign to the shipping zone. */
  addChannels?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** List of warehouses to assign to a shipping zone */
  addWarehouses?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** List of countries in this shipping zone. */
  countries?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Default shipping zone will be used for countries not covered by other zones. */
  default?: InputMaybe<Scalars['Boolean']['input']>;
  /** Description of the shipping zone. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Shipping zone's name. Visible only to the staff. */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Event sent when new shipping zone is created. */
export type ShippingZoneCreated = Event & {
  __typename?: 'ShippingZoneCreated';
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<IssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient?: Maybe<App>;
  /** The shipping zone the event relates to. */
  shippingZone?: Maybe<ShippingZone>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};


/** Event sent when new shipping zone is created. */
export type ShippingZoneCreatedShippingZoneArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Deletes a shipping zone.
 *
 * Requires one of the following permissions: MANAGE_SHIPPING.
 */
export type ShippingZoneDelete = {
  __typename?: 'ShippingZoneDelete';
  errors: Array<ShippingError>;
  /** @deprecated Use `errors` field instead. */
  shippingErrors: Array<ShippingError>;
  shippingZone?: Maybe<ShippingZone>;
};

/** Event sent when shipping zone is deleted. */
export type ShippingZoneDeleted = Event & {
  __typename?: 'ShippingZoneDeleted';
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<IssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient?: Maybe<App>;
  /** The shipping zone the event relates to. */
  shippingZone?: Maybe<ShippingZone>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};


/** Event sent when shipping zone is deleted. */
export type ShippingZoneDeletedShippingZoneArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
};

export type ShippingZoneFilterInput = {
  channels?: InputMaybe<Array<Scalars['ID']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
};

/** Event sent when shipping zone metadata is updated. */
export type ShippingZoneMetadataUpdated = Event & {
  __typename?: 'ShippingZoneMetadataUpdated';
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<IssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient?: Maybe<App>;
  /** The shipping zone the event relates to. */
  shippingZone?: Maybe<ShippingZone>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};


/** Event sent when shipping zone metadata is updated. */
export type ShippingZoneMetadataUpdatedShippingZoneArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Updates a new shipping zone.
 *
 * Requires one of the following permissions: MANAGE_SHIPPING.
 */
export type ShippingZoneUpdate = {
  __typename?: 'ShippingZoneUpdate';
  errors: Array<ShippingError>;
  /** @deprecated Use `errors` field instead. */
  shippingErrors: Array<ShippingError>;
  shippingZone?: Maybe<ShippingZone>;
};

export type ShippingZoneUpdateInput = {
  /** List of channels to assign to the shipping zone. */
  addChannels?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** List of warehouses to assign to a shipping zone */
  addWarehouses?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** List of countries in this shipping zone. */
  countries?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Default shipping zone will be used for countries not covered by other zones. */
  default?: InputMaybe<Scalars['Boolean']['input']>;
  /** Description of the shipping zone. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Shipping zone's name. Visible only to the staff. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** List of channels to unassign from the shipping zone. */
  removeChannels?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** List of warehouses to unassign from a shipping zone */
  removeWarehouses?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** Event sent when shipping zone is updated. */
export type ShippingZoneUpdated = Event & {
  __typename?: 'ShippingZoneUpdated';
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<IssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient?: Maybe<App>;
  /** The shipping zone the event relates to. */
  shippingZone?: Maybe<ShippingZone>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};


/** Event sent when shipping zone is updated. */
export type ShippingZoneUpdatedShippingZoneArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
};

/** Represents a shop resource containing general shop data and configuration. */
export type Shop = ObjectWithMetadata & {
  __typename?: 'Shop';
  /**
   * Determines if user can login without confirmation when `enableAccountConfirmation` is enabled.
   *
   * Requires one of the following permissions: MANAGE_SETTINGS.
   */
  allowLoginWithoutConfirmation?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Enable automatic fulfillment for all digital products.
   *
   * Requires one of the following permissions: MANAGE_SETTINGS.
   */
  automaticFulfillmentDigitalProducts?: Maybe<Scalars['Boolean']['output']>;
  /** List of available external authentications. */
  availableExternalAuthentications: Array<ExternalAuthentication>;
  /** List of available payment gateways. */
  availablePaymentGateways: Array<PaymentGateway>;
  /** Shipping methods that are available for the shop. */
  availableShippingMethods?: Maybe<Array<ShippingMethod>>;
  /**
   * List of tax apps that can be assigned to the channel. The list will be calculated by Saleor based on the apps that are subscribed to webhooks related to tax calculations: CHECKOUT_CALCULATE_TAXES
   *
   * Added in Saleor 3.19.
   *
   * Requires one of the following permissions: AUTHENTICATED_STAFF_USER, MANAGE_APPS.
   */
  availableTaxApps: Array<App>;
  /**
   * List of all currencies supported by shop's channels.
   *
   * Requires one of the following permissions: AUTHENTICATED_STAFF_USER, AUTHENTICATED_APP.
   */
  channelCurrencies: Array<Scalars['String']['output']>;
  /**
   * Charge taxes on shipping.
   * @deprecated Use `ShippingMethodType.taxClass` to determine whether taxes are calculated for shipping methods; if a tax class is set, the taxes will be calculated, otherwise no tax rate will be applied.
   */
  chargeTaxesOnShipping: Scalars['Boolean']['output'];
  /** Company address. */
  companyAddress?: Maybe<Address>;
  /** List of countries available in the shop. */
  countries: Array<CountryDisplay>;
  /** URL of a view where customers can set their password. */
  customerSetPasswordUrl?: Maybe<Scalars['String']['output']>;
  /** Shop's default country. */
  defaultCountry?: Maybe<CountryDisplay>;
  /**
   * Default number of max downloads per digital content URL.
   *
   * Requires one of the following permissions: MANAGE_SETTINGS.
   */
  defaultDigitalMaxDownloads?: Maybe<Scalars['Int']['output']>;
  /**
   * Default number of days which digital content URL will be valid.
   *
   * Requires one of the following permissions: MANAGE_SETTINGS.
   */
  defaultDigitalUrlValidDays?: Maybe<Scalars['Int']['output']>;
  /**
   * Default shop's email sender's address.
   *
   * Requires one of the following permissions: MANAGE_SETTINGS.
   */
  defaultMailSenderAddress?: Maybe<Scalars['String']['output']>;
  /**
   * Default shop's email sender's name.
   *
   * Requires one of the following permissions: MANAGE_SETTINGS.
   */
  defaultMailSenderName?: Maybe<Scalars['String']['output']>;
  /** Default weight unit. */
  defaultWeightUnit?: Maybe<WeightUnitsEnum>;
  /** Shop's description. */
  description?: Maybe<Scalars['String']['output']>;
  /**
   * Display prices with tax in store.
   * @deprecated Use `Channel.taxConfiguration` to determine whether to display gross or net prices.
   */
  displayGrossPrices: Scalars['Boolean']['output'];
  /** Shop's domain data. */
  domain: Domain;
  /**
   * Determines if account confirmation by email is enabled.
   *
   * Requires one of the following permissions: MANAGE_SETTINGS.
   */
  enableAccountConfirmationByEmail?: Maybe<Scalars['Boolean']['output']>;
  /** Allow to approve fulfillments which are unpaid. */
  fulfillmentAllowUnpaid: Scalars['Boolean']['output'];
  /** Automatically approve all new fulfillments. */
  fulfillmentAutoApprove: Scalars['Boolean']['output'];
  /** Header text. */
  headerText?: Maybe<Scalars['String']['output']>;
  /** ID of the shop. */
  id: Scalars['ID']['output'];
  /**
   * Include taxes in prices.
   * @deprecated Use `Channel.taxConfiguration.pricesEnteredWithTax` to determine whether prices are entered with tax.
   */
  includeTaxesInPrices: Scalars['Boolean']['output'];
  /** List of the shops's supported languages. */
  languages: Array<LanguageDisplay>;
  /**
   * Default number of maximum line quantity in single checkout (per single checkout line).
   *
   * Requires one of the following permissions: MANAGE_SETTINGS.
   */
  limitQuantityPerCheckout?: Maybe<Scalars['Int']['output']>;
  /**
   * Resource limitations and current usage if any set for a shop
   *
   * Requires one of the following permissions: AUTHENTICATED_STAFF_USER.
   * @deprecated No longer supported
   */
  limits: LimitInfo;
  /** List of public metadata items. Can be accessed without permissions. */
  metadata: Array<MetadataItem>;
  /**
   * A single key from public metadata.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   */
  metafield?: Maybe<Scalars['String']['output']>;
  /** Public metadata. Use `keys` to control which fields you want to include. The default is to include everything. */
  metafields?: Maybe<Scalars['Metadata']['output']>;
  /** Shop's name. */
  name: Scalars['String']['output'];
  /** List of available permissions. */
  permissions: Array<Permission>;
  /** List of possible phone prefixes. */
  phonePrefixes: Array<Scalars['String']['output']>;
  /**
   * When enabled, address fields that are not valid for a given country (according to Google's i18n address data) will be preserved instead of being removed during validation. Validation errors are still returned.
   *
   * Added in Saleor 3.22.
   *
   * Requires one of the following permissions: MANAGE_SETTINGS.
   */
  preserveAllAddressFields: Scalars['Boolean']['output'];
  /** List of private metadata items. Requires staff permissions to access. */
  privateMetadata: Array<MetadataItem>;
  /**
   * A single key from private metadata. Requires staff permissions to access.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   */
  privateMetafield?: Maybe<Scalars['String']['output']>;
  /** Private metadata. Requires staff permissions to access. Use `keys` to control which fields you want to include. The default is to include everything. */
  privateMetafields?: Maybe<Scalars['Metadata']['output']>;
  /**
   * Default number of minutes stock will be reserved for anonymous checkout or null when stock reservation is disabled.
   *
   * Requires one of the following permissions: MANAGE_SETTINGS.
   */
  reserveStockDurationAnonymousUser?: Maybe<Scalars['Int']['output']>;
  /**
   * Default number of minutes stock will be reserved for authenticated checkout or null when stock reservation is disabled.
   *
   * Requires one of the following permissions: MANAGE_SETTINGS.
   */
  reserveStockDurationAuthenticatedUser?: Maybe<Scalars['Int']['output']>;
  /** Minor Saleor API version. */
  schemaVersion: Scalars['String']['output'];
  /**
   * List of staff notification recipients.
   *
   * Requires one of the following permissions: MANAGE_SETTINGS.
   */
  staffNotificationRecipients?: Maybe<Array<StaffNotificationRecipient>>;
  /** This field is used as a default value for `ProductVariant.trackInventory`. */
  trackInventoryByDefault?: Maybe<Scalars['Boolean']['output']>;
  /** Returns translated shop fields for the given language code. */
  translation?: Maybe<ShopTranslation>;
  /**
   * Use legacy update webhook emission. When enabled, update webhooks (e.g. `customerUpdated`,`productVariantUpdated`) are sent even when only metadata changes. When disabled, update webhooks are not sent for metadata-only changes; only metadata-specific webhooks (e.g., `customerMetadataUpdated`, `productVariantMetadataUpdated`) are sent.
   *
   * Added in Saleor 3.22.
   * @deprecated No longer supported
   */
  useLegacyUpdateWebhookEmission?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Saleor API version.
   *
   * Requires one of the following permissions: AUTHENTICATED_STAFF_USER, AUTHENTICATED_APP.
   */
  version: Scalars['String']['output'];
};


/** Represents a shop resource containing general shop data and configuration. */
export type ShopAvailablePaymentGatewaysArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
};


/** Represents a shop resource containing general shop data and configuration. */
export type ShopAvailableShippingMethodsArgs = {
  address?: InputMaybe<AddressInput>;
  channel: Scalars['String']['input'];
};


/** Represents a shop resource containing general shop data and configuration. */
export type ShopCountriesArgs = {
  filter?: InputMaybe<CountryFilterInput>;
  languageCode?: InputMaybe<LanguageCodeEnum>;
};


/** Represents a shop resource containing general shop data and configuration. */
export type ShopMetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Represents a shop resource containing general shop data and configuration. */
export type ShopMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Represents a shop resource containing general shop data and configuration. */
export type ShopPrivateMetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Represents a shop resource containing general shop data and configuration. */
export type ShopPrivateMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Represents a shop resource containing general shop data and configuration. */
export type ShopTranslationArgs = {
  languageCode: LanguageCodeEnum;
};

/**
 * Update the shop's address. If the `null` value is passed, the currently selected address will be deleted.
 *
 * Requires one of the following permissions: MANAGE_SETTINGS.
 */
export type ShopAddressUpdate = {
  __typename?: 'ShopAddressUpdate';
  errors: Array<ShopError>;
  /** Updated shop. */
  shop?: Maybe<Shop>;
  /** @deprecated Use `errors` field instead. */
  shopErrors: Array<ShopError>;
};

/**
 * Updates site domain of the shop.
 *
 * Requires one of the following permissions: MANAGE_SETTINGS.
 */
export type ShopDomainUpdate = {
  __typename?: 'ShopDomainUpdate';
  errors: Array<ShopError>;
  /** Updated shop. */
  shop?: Maybe<Shop>;
  /** @deprecated Use `errors` field instead. */
  shopErrors: Array<ShopError>;
};

export type ShopError = {
  __typename?: 'ShopError';
  /** The error code. */
  code: ShopErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field?: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message?: Maybe<Scalars['String']['output']>;
};

export type ShopErrorCode =
  | 'ALREADY_EXISTS'
  | 'CANNOT_FETCH_TAX_RATES'
  | 'GRAPHQL_ERROR'
  | 'INVALID'
  | 'NOT_FOUND'
  | 'REQUIRED'
  | 'UNIQUE';

/**
 * Fetch tax rates.
 *
 * Requires one of the following permissions: MANAGE_SETTINGS.
 */
export type ShopFetchTaxRates = {
  __typename?: 'ShopFetchTaxRates';
  errors: Array<ShopError>;
  /** Updated shop. */
  shop?: Maybe<Shop>;
  /** @deprecated Use `errors` field instead. */
  shopErrors: Array<ShopError>;
};

/** Event sent when shop metadata is updated. */
export type ShopMetadataUpdated = Event & {
  __typename?: 'ShopMetadataUpdated';
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<IssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient?: Maybe<App>;
  /** Shop data. */
  shop?: Maybe<Shop>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

export type ShopSettingsInput = {
  /** Enable possibility to login without account confirmation. */
  allowLoginWithoutConfirmation?: InputMaybe<Scalars['Boolean']['input']>;
  /** Enable automatic fulfillment for all digital products. */
  automaticFulfillmentDigitalProducts?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Charge taxes on shipping.
   *
   * DEPRECATED: this field will be removed. To enable taxes for a shipping method, assign a tax class to the shipping method with `shippingPriceCreate` or `shippingPriceUpdate` mutations.
   */
  chargeTaxesOnShipping?: InputMaybe<Scalars['Boolean']['input']>;
  /** URL of a view where customers can set their password. */
  customerSetPasswordUrl?: InputMaybe<Scalars['String']['input']>;
  /** Default number of max downloads per digital content URL. */
  defaultDigitalMaxDownloads?: InputMaybe<Scalars['Int']['input']>;
  /** Default number of days which digital content URL will be valid. */
  defaultDigitalUrlValidDays?: InputMaybe<Scalars['Int']['input']>;
  /** Default email sender's address. */
  defaultMailSenderAddress?: InputMaybe<Scalars['String']['input']>;
  /** Default email sender's name. */
  defaultMailSenderName?: InputMaybe<Scalars['String']['input']>;
  /** Default weight unit. */
  defaultWeightUnit?: InputMaybe<WeightUnitsEnum>;
  /** SEO description. */
  description?: InputMaybe<Scalars['String']['input']>;
  /**
   * Display prices with tax in store.
   *
   * DEPRECATED: this field will be removed. Use `taxConfigurationUpdate` mutation to configure this setting per channel or country.
   */
  displayGrossPrices?: InputMaybe<Scalars['Boolean']['input']>;
  /** Enable automatic account confirmation by email. */
  enableAccountConfirmationByEmail?: InputMaybe<Scalars['Boolean']['input']>;
  /** Enable ability to approve fulfillments which are unpaid. */
  fulfillmentAllowUnpaid?: InputMaybe<Scalars['Boolean']['input']>;
  /** Enable automatic approval of all new fulfillments. */
  fulfillmentAutoApprove?: InputMaybe<Scalars['Boolean']['input']>;
  /** Header text. */
  headerText?: InputMaybe<Scalars['String']['input']>;
  /**
   * Include taxes in prices.
   *
   * DEPRECATED: this field will be removed. Use `taxConfigurationUpdate` mutation to configure this setting per channel or country.
   */
  includeTaxesInPrices?: InputMaybe<Scalars['Boolean']['input']>;
  /** Default number of maximum line quantity in single checkout. Minimum possible value is 1, default value is 50. */
  limitQuantityPerCheckout?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Shop public metadata. Can be read by any API client authorized to read the object it's attached to.
   *
   * Warning: never store sensitive information, including financial data such as credit card details.
   */
  metadata?: InputMaybe<Array<MetadataInput>>;
  /**
   * When enabled, address fields that are not valid for a given country (according to Google's i18n address data) will be preserved instead of being removed during validation. Validation errors are still returned.
   *
   * Added in Saleor 3.22.
   */
  preserveAllAddressFields?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Shop private metadata. Requires permissions to modify and to read the metadata of the object it's attached to.
   *
   * Warning: never store sensitive information, including financial data such as credit card details.
   */
  privateMetadata?: InputMaybe<Array<MetadataInput>>;
  /** Default number of minutes stock will be reserved for anonymous checkout. Enter 0 or null to disable. */
  reserveStockDurationAnonymousUser?: InputMaybe<Scalars['Int']['input']>;
  /** Default number of minutes stock will be reserved for authenticated checkout. Enter 0 or null to disable. */
  reserveStockDurationAuthenticatedUser?: InputMaybe<Scalars['Int']['input']>;
  /** This field is used as a default value for `ProductVariant.trackInventory`. */
  trackInventoryByDefault?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Use legacy update webhook emission. When enabled, update webhooks (e.g. `customerUpdated`,`productVariantUpdated`) are sent even when only metadata changes. When disabled, update webhooks are not sent for metadata-only changes; only metadata-specific webhooks (e.g., `customerMetadataUpdated`, `productVariantMetadataUpdated`) are sent.
   *
   * Added in Saleor 3.22.
   *
   * DEPRECATED: this field will be removed.
   */
  useLegacyUpdateWebhookEmission?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * Creates/updates translations for shop settings.
 *
 * Requires one of the following permissions: MANAGE_TRANSLATIONS.
 */
export type ShopSettingsTranslate = {
  __typename?: 'ShopSettingsTranslate';
  errors: Array<TranslationError>;
  /** Updated shop settings. */
  shop?: Maybe<Shop>;
  /** @deprecated Use `errors` field instead. */
  translationErrors: Array<TranslationError>;
};

export type ShopSettingsTranslationInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  headerText?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Updates shop settings.
 *
 * Requires one of the following permissions: MANAGE_SETTINGS.
 *
 * Triggers the following webhook events:
 * - SHOP_METADATA_UPDATED (async): Optionally triggered when public or private metadata is updated.
 */
export type ShopSettingsUpdate = {
  __typename?: 'ShopSettingsUpdate';
  errors: Array<ShopError>;
  /** Updated shop. */
  shop?: Maybe<Shop>;
  /** @deprecated Use `errors` field instead. */
  shopErrors: Array<ShopError>;
};

/** Represents shop translations. */
export type ShopTranslation = Node & {
  __typename?: 'ShopTranslation';
  /** Translated description of sale. */
  description: Scalars['String']['output'];
  /** Translated header text of sale. */
  headerText: Scalars['String']['output'];
  /** The ID of the shop translation. */
  id: Scalars['ID']['output'];
  /** Translation language. */
  language: LanguageDisplay;
};

export type SiteDomainInput = {
  /** Domain name for shop. */
  domain?: InputMaybe<Scalars['String']['input']>;
  /** Shop site name. */
  name?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Deletes staff users. Apps are not allowed to perform this mutation.
 *
 * Requires one of the following permissions: MANAGE_STAFF.
 *
 * Triggers the following webhook events:
 * - STAFF_DELETED (async): A staff account was deleted.
 */
export type StaffBulkDelete = {
  __typename?: 'StaffBulkDelete';
  /** Returns how many objects were affected. */
  count: Scalars['Int']['output'];
  errors: Array<StaffError>;
  /** @deprecated Use `errors` field instead. */
  staffErrors: Array<StaffError>;
};

/**
 * Creates a new staff user. Apps are not allowed to perform this mutation.
 *
 * Requires one of the following permissions: MANAGE_STAFF.
 *
 * Triggers the following webhook events:
 * - STAFF_CREATED (async): A new staff account was created.
 * - NOTIFY_USER (async): A notification for setting the password.
 * - STAFF_SET_PASSWORD_REQUESTED (async): Setting a new password for the staff account is requested.
 */
export type StaffCreate = {
  __typename?: 'StaffCreate';
  errors: Array<StaffError>;
  /** @deprecated Use `errors` field instead. */
  staffErrors: Array<StaffError>;
  user?: Maybe<User>;
};

/** Fields required to create a staff user. */
export type StaffCreateInput = {
  /** List of permission group IDs to which user should be assigned. */
  addGroups?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The unique email address of the user. */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Given name. */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** User account is active. */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Family name. */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /**
   * Fields required to update the user metadata. Can be read by any API client authorized to read the object it's attached to.
   *
   * Warning: never store sensitive information, including financial data such as credit card details.
   */
  metadata?: InputMaybe<Array<MetadataInput>>;
  /** A note about the user. */
  note?: InputMaybe<Scalars['String']['input']>;
  /**
   * Fields required to update the user private metadata. Requires permissions to modify and to read the metadata of the object it's attached to.
   *
   * Warning: never store sensitive information, including financial data such as credit card details.
   */
  privateMetadata?: InputMaybe<Array<MetadataInput>>;
  /** URL of a view where users should be redirected to set the password. URL in RFC 1808 format. */
  redirectUrl?: InputMaybe<Scalars['String']['input']>;
};

/** Event sent when new staff user is created. */
export type StaffCreated = Event & {
  __typename?: 'StaffCreated';
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<IssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient?: Maybe<App>;
  /** The user the event relates to. */
  user?: Maybe<User>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

/**
 * Deletes a staff user. Apps are not allowed to perform this mutation.
 *
 * Requires one of the following permissions: MANAGE_STAFF.
 *
 * Triggers the following webhook events:
 * - STAFF_DELETED (async): A staff account was deleted.
 */
export type StaffDelete = {
  __typename?: 'StaffDelete';
  errors: Array<StaffError>;
  /** @deprecated Use `errors` field instead. */
  staffErrors: Array<StaffError>;
  user?: Maybe<User>;
};

/** Event sent when staff user is deleted. */
export type StaffDeleted = Event & {
  __typename?: 'StaffDeleted';
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<IssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient?: Maybe<App>;
  /** The user the event relates to. */
  user?: Maybe<User>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

export type StaffError = {
  __typename?: 'StaffError';
  /** A type of address that causes the error. */
  addressType?: Maybe<AddressTypeEnum>;
  /** The error code. */
  code: AccountErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field?: Maybe<Scalars['String']['output']>;
  /** List of permission group IDs which cause the error. */
  groups?: Maybe<Array<Scalars['ID']['output']>>;
  /** The error message. */
  message?: Maybe<Scalars['String']['output']>;
  /** List of permissions which causes the error. */
  permissions?: Maybe<Array<PermissionEnum>>;
  /** List of user IDs which causes the error. */
  users?: Maybe<Array<Scalars['ID']['output']>>;
};

/** Represents status of a staff account. */
export type StaffMemberStatus =
  /** User account has been activated. */
  | 'ACTIVE'
  /** User account has not been activated yet. */
  | 'DEACTIVATED';

/** Represents a recipient of email notifications send by Saleor, such as notifications about new orders. Notifications can be assigned to staff users or arbitrary email addresses. */
export type StaffNotificationRecipient = Node & {
  __typename?: 'StaffNotificationRecipient';
  /** Determines if a notification active. */
  active?: Maybe<Scalars['Boolean']['output']>;
  /** Returns email address of a user subscribed to email notifications. */
  email?: Maybe<Scalars['String']['output']>;
  /** The ID of the staff notification recipient. */
  id: Scalars['ID']['output'];
  /** Returns a user subscribed to email notifications. */
  user?: Maybe<User>;
};

/**
 * Creates a new staff notification recipient.
 *
 * Requires one of the following permissions: MANAGE_SETTINGS.
 */
export type StaffNotificationRecipientCreate = {
  __typename?: 'StaffNotificationRecipientCreate';
  errors: Array<ShopError>;
  /** @deprecated Use `errors` field instead. */
  shopErrors: Array<ShopError>;
  staffNotificationRecipient?: Maybe<StaffNotificationRecipient>;
};

/**
 * Deletes staff notification recipient.
 *
 * Requires one of the following permissions: MANAGE_SETTINGS.
 */
export type StaffNotificationRecipientDelete = {
  __typename?: 'StaffNotificationRecipientDelete';
  errors: Array<ShopError>;
  /** @deprecated Use `errors` field instead. */
  shopErrors: Array<ShopError>;
  staffNotificationRecipient?: Maybe<StaffNotificationRecipient>;
};

export type StaffNotificationRecipientInput = {
  /** Determines if a notification active. */
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** Email address of a user subscribed to email notifications. */
  email?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the user subscribed to email notifications.. */
  user?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * Updates a staff notification recipient.
 *
 * Requires one of the following permissions: MANAGE_SETTINGS.
 */
export type StaffNotificationRecipientUpdate = {
  __typename?: 'StaffNotificationRecipientUpdate';
  errors: Array<ShopError>;
  /** @deprecated Use `errors` field instead. */
  shopErrors: Array<ShopError>;
  staffNotificationRecipient?: Maybe<StaffNotificationRecipient>;
};

/** Event sent when setting a new password for staff is requested. */
export type StaffSetPasswordRequested = Event & {
  __typename?: 'StaffSetPasswordRequested';
  /** The channel data. */
  channel?: Maybe<Channel>;
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<IssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient?: Maybe<App>;
  /** The URL to redirect the user after he accepts the request. */
  redirectUrl?: Maybe<Scalars['String']['output']>;
  /** Shop data. */
  shop?: Maybe<Shop>;
  /** The token required to confirm request. */
  token?: Maybe<Scalars['String']['output']>;
  /** The user the event relates to. */
  user?: Maybe<User>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

/**
 * Updates an existing staff user. Apps are not allowed to perform this mutation.
 *
 * Requires one of the following permissions: MANAGE_STAFF.
 *
 * Triggers the following webhook events:
 * - STAFF_UPDATED (async): A staff account was updated.
 */
export type StaffUpdate = {
  __typename?: 'StaffUpdate';
  errors: Array<StaffError>;
  /** @deprecated Use `errors` field instead. */
  staffErrors: Array<StaffError>;
  user?: Maybe<User>;
};

/** Fields required to update a staff user. */
export type StaffUpdateInput = {
  /** List of permission group IDs to which user should be assigned. */
  addGroups?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The unique email address of the user. */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Given name. */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** User account is active. */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Family name. */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /**
   * Fields required to update the user metadata. Can be read by any API client authorized to read the object it's attached to.
   *
   * Warning: never store sensitive information, including financial data such as credit card details.
   */
  metadata?: InputMaybe<Array<MetadataInput>>;
  /** A note about the user. */
  note?: InputMaybe<Scalars['String']['input']>;
  /**
   * Fields required to update the user private metadata. Requires permissions to modify and to read the metadata of the object it's attached to.
   *
   * Warning: never store sensitive information, including financial data such as credit card details.
   */
  privateMetadata?: InputMaybe<Array<MetadataInput>>;
  /** List of permission group IDs from which user should be unassigned. */
  removeGroups?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** Event sent when staff user is updated. */
export type StaffUpdated = Event & {
  __typename?: 'StaffUpdated';
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<IssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient?: Maybe<App>;
  /** The user the event relates to. */
  user?: Maybe<User>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

export type StaffUserInput = {
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<StaffMemberStatus>;
};

/** Represents stock. */
export type Stock = Node & {
  __typename?: 'Stock';
  /** The ID of stock. */
  id: Scalars['ID']['output'];
  /** Information about the product variant. */
  productVariant: ProductVariant;
  /**
   * Quantity of a product in the warehouse's possession, including the allocated stock that is waiting for shipment.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS, MANAGE_ORDERS.
   */
  quantity: Scalars['Int']['output'];
  /**
   * Quantity allocated for orders.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS, MANAGE_ORDERS.
   */
  quantityAllocated: Scalars['Int']['output'];
  /**
   * Quantity reserved for checkouts.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS, MANAGE_ORDERS.
   */
  quantityReserved: Scalars['Int']['output'];
  /** The warehouse associated with the stock. */
  warehouse: Warehouse;
};

export type StockAvailability =
  | 'IN_STOCK'
  | 'OUT_OF_STOCK';

export type StockBulkResult = {
  __typename?: 'StockBulkResult';
  /** List of errors occurred on create or update attempt. */
  errors?: Maybe<Array<StockBulkUpdateError>>;
  /** Stock data. */
  stock?: Maybe<Stock>;
};

/**
 * Updates stocks for a given variant and warehouse. Variant and warehouse selectors have to be the same for all stock inputs. Is not allowed to use 'variantId' in one input and 'variantExternalReference' in another.
 *
 * Requires one of the following permissions: MANAGE_PRODUCTS.
 *
 * Triggers the following webhook events:
 * - PRODUCT_VARIANT_STOCK_UPDATED (async): A product variant stock details were updated.
 */
export type StockBulkUpdate = {
  __typename?: 'StockBulkUpdate';
  /** Returns how many objects were updated. */
  count: Scalars['Int']['output'];
  errors: Array<StockBulkUpdateError>;
  /** List of the updated stocks. */
  results: Array<StockBulkResult>;
};

export type StockBulkUpdateError = {
  __typename?: 'StockBulkUpdateError';
  /** The error code. */
  code: StockBulkUpdateErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field?: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message?: Maybe<Scalars['String']['output']>;
};

export type StockBulkUpdateErrorCode =
  | 'GRAPHQL_ERROR'
  | 'INVALID'
  | 'NOT_FOUND'
  | 'REQUIRED';

export type StockBulkUpdateInput = {
  /** Quantity of items available for sell. */
  quantity: Scalars['Int']['input'];
  /** Variant external reference. */
  variantExternalReference?: InputMaybe<Scalars['String']['input']>;
  /** Variant ID. */
  variantId?: InputMaybe<Scalars['ID']['input']>;
  /** Warehouse external reference. */
  warehouseExternalReference?: InputMaybe<Scalars['String']['input']>;
  /** Warehouse ID. */
  warehouseId?: InputMaybe<Scalars['ID']['input']>;
};

export type StockCountableConnection = {
  __typename?: 'StockCountableConnection';
  edges: Array<StockCountableEdge>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** A total count of items in the collection. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type StockCountableEdge = {
  __typename?: 'StockCountableEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Stock;
};

export type StockError = {
  __typename?: 'StockError';
  /** The error code. */
  code: StockErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field?: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message?: Maybe<Scalars['String']['output']>;
};

export type StockErrorCode =
  | 'ALREADY_EXISTS'
  | 'GRAPHQL_ERROR'
  | 'INVALID'
  | 'NOT_FOUND'
  | 'REQUIRED'
  | 'UNIQUE';

export type StockFilterInput = {
  quantity?: InputMaybe<Scalars['Float']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type StockInput = {
  /** Quantity of items available for sell. */
  quantity: Scalars['Int']['input'];
  /** Warehouse in which stock is located. */
  warehouse: Scalars['ID']['input'];
};

/** Represents the channel stock settings. */
export type StockSettings = {
  __typename?: 'StockSettings';
  /** Allocation strategy defines the preference of warehouses for allocations and reservations. */
  allocationStrategy: AllocationStrategyEnum;
};

export type StockSettingsInput = {
  /** Allocation strategy options. Strategy defines the preference of warehouses for allocations and reservations. */
  allocationStrategy: AllocationStrategyEnum;
};

export type StockUpdateInput = {
  /** Quantity of items available for sell. */
  quantity: Scalars['Int']['input'];
  /** Stock. */
  stock: Scalars['ID']['input'];
};

/**
 * Determine how stocks should be updated, while processing an order.
 *
 *     SKIP - stocks are not checked and not updated.
 *     UPDATE - only do update, if there is enough stock.
 *     FORCE - force update, if there is not enough stock.
 *
 */
export type StockUpdatePolicyEnum =
  | 'FORCE'
  | 'SKIP'
  | 'UPDATE';

/** Enum representing the type of a payment storage in a gateway. */
export type StorePaymentMethodEnum =
  /** Storage is disabled. The payment is not stored. */
  | 'NONE'
  /** Off session storage type. The payment is stored to be reused even if the customer is absent. */
  | 'OFF_SESSION'
  /** On session storage type. The payment is stored only to be reused when the customer is present in the checkout flow. */
  | 'ON_SESSION';

/** Represents a payment method stored for user (tokenized) in payment gateway. */
export type StoredPaymentMethod = {
  __typename?: 'StoredPaymentMethod';
  /** Stored credit card details if available. */
  creditCardInfo?: Maybe<CreditCard>;
  /** JSON data returned by Payment Provider app for this payment method. */
  data?: Maybe<Scalars['JSON']['output']>;
  /** Payment gateway that stores this payment method. */
  gateway: PaymentGateway;
  /** Stored payment method ID. */
  id: Scalars['ID']['output'];
  /** Payment method name. Example: last 4 digits of credit card, obfuscated email, etc. */
  name?: Maybe<Scalars['String']['output']>;
  /** ID of stored payment method used to make payment actions. Note: method ID is unique only within the payment gateway. */
  paymentMethodId: Scalars['String']['output'];
  supportedPaymentFlows?: Maybe<Array<TokenizedPaymentFlowEnum>>;
  /** Type of the payment method. Example: credit card, wallet, etc. */
  type: Scalars['String']['output'];
};

/** Event sent when user requests to delete a payment method. */
export type StoredPaymentMethodDeleteRequested = Event & {
  __typename?: 'StoredPaymentMethodDeleteRequested';
  /** Channel related to the requested delete action. */
  channel: Channel;
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<IssuingPrincipal>;
  /** The ID of the payment method that should be deleted by the payment gateway. */
  paymentMethodId: Scalars['String']['output'];
  /** The application receiving the webhook. */
  recipient?: Maybe<App>;
  /** The user for which the app should proceed with payment method delete request. */
  user: User;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

/**
 * Request to delete a stored payment method on payment provider side.
 *
 * Requires one of the following permissions: AUTHENTICATED_USER.
 *
 * Triggers the following webhook events:
 * - STORED_PAYMENT_METHOD_DELETE_REQUESTED (sync): The customer requested to delete a payment method.
 */
export type StoredPaymentMethodRequestDelete = {
  __typename?: 'StoredPaymentMethodRequestDelete';
  errors: Array<PaymentMethodRequestDeleteError>;
  /** The result of deleting a stored payment method. */
  result: StoredPaymentMethodRequestDeleteResult;
};

export type StoredPaymentMethodRequestDeleteErrorCode =
  | 'CHANNEL_INACTIVE'
  | 'GATEWAY_ERROR'
  | 'GRAPHQL_ERROR'
  | 'INVALID'
  | 'NOT_FOUND';

/**
 * Result of deleting a stored payment method.
 *
 *     This enum is used to determine the result of deleting a stored payment method.
 *     SUCCESSFULLY_DELETED - The stored payment method was successfully deleted.
 *     FAILED_TO_DELETE - The stored payment method was not deleted.
 *     FAILED_TO_DELIVER - The request to delete the stored payment method was not
 *     delivered.
 *
 */
export type StoredPaymentMethodRequestDeleteResult =
  | 'FAILED_TO_DELETE'
  | 'FAILED_TO_DELIVER'
  | 'SUCCESSFULLY_DELETED';

/** Define the filtering options for string fields. */
export type StringFilterInput = {
  /** The value equal to. */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** The value included in. */
  oneOf?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type Subscription = {
  __typename?: 'Subscription';
  /**
   * Event sent when new checkout is created.
   *
   * Added in Saleor 3.21.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  checkoutCreated?: Maybe<CheckoutCreated>;
  /**
   * Event sent when checkout is fully authorized.
   *
   * Added in Saleor 3.21.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  checkoutFullyAuthorized?: Maybe<CheckoutFullyAuthorized>;
  /**
   * Event sent when checkout is fully-paid.
   *
   * Added in Saleor 3.21.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  checkoutFullyPaid?: Maybe<CheckoutFullyPaid>;
  /**
   * Event sent when checkout metadata is updated.
   *
   * Added in Saleor 3.21.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  checkoutMetadataUpdated?: Maybe<CheckoutMetadataUpdated>;
  /**
   * Event sent when checkout is updated.
   *
   * Added in Saleor 3.21.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  checkoutUpdated?: Maybe<CheckoutUpdated>;
  /**
   * Event sent when new draft order is created.
   *
   * Added in Saleor 3.20.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  draftOrderCreated?: Maybe<DraftOrderCreated>;
  /**
   * Event sent when draft order is deleted.
   *
   * Added in Saleor 3.20.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  draftOrderDeleted?: Maybe<DraftOrderDeleted>;
  /**
   * Event sent when draft order is updated.
   *
   * Added in Saleor 3.20.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  draftOrderUpdated?: Maybe<DraftOrderUpdated>;
  /** Look up subscription event. */
  event?: Maybe<Event>;
  /**
   * Event sent when orders are imported.
   *
   * Added in Saleor 3.20.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  orderBulkCreated?: Maybe<OrderBulkCreated>;
  /**
   * Event sent when order is cancelled.
   *
   * Added in Saleor 3.20.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  orderCancelled?: Maybe<OrderCancelled>;
  /**
   * Event sent when order is confirmed.
   *
   * Added in Saleor 3.20.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  orderConfirmed?: Maybe<OrderConfirmed>;
  /**
   * Event sent when new order is created.
   *
   * Added in Saleor 3.20.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  orderCreated?: Maybe<OrderCreated>;
  /**
   * Event sent when order becomes expired.
   *
   * Added in Saleor 3.20.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  orderExpired?: Maybe<OrderExpired>;
  /**
   * Event sent when order is fulfilled.
   *
   * Added in Saleor 3.20.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  orderFulfilled?: Maybe<OrderFulfilled>;
  /**
   * Event sent when order is fully paid.
   *
   * Added in Saleor 3.20.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  orderFullyPaid?: Maybe<OrderFullyPaid>;
  /**
   * The order is fully refunded.
   *
   * Added in Saleor 3.20.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  orderFullyRefunded?: Maybe<OrderFullyRefunded>;
  /**
   * Event sent when order metadata is updated.
   *
   * Added in Saleor 3.20.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  orderMetadataUpdated?: Maybe<OrderMetadataUpdated>;
  /**
   * Payment has been made. The order may be partially or fully paid.
   *
   * Added in Saleor 3.20.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  orderPaid?: Maybe<OrderPaid>;
  /**
   * The order received a refund. The order may be partially or fully refunded.
   *
   * Added in Saleor 3.20.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  orderRefunded?: Maybe<OrderRefunded>;
  /**
   * Event sent when order is updated.
   *
   * Added in Saleor 3.20.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  orderUpdated?: Maybe<OrderUpdated>;
  /**
   * Event sent when product variant discounted price is recalculated.
   *
   * Added in Saleor 3.22.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  productVariantDiscountedPriceUpdated?: Maybe<ProductVariantDiscountedPriceUpdated>;
};


export type SubscriptionCheckoutCreatedArgs = {
  channels?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type SubscriptionCheckoutFullyAuthorizedArgs = {
  channels?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type SubscriptionCheckoutFullyPaidArgs = {
  channels?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type SubscriptionCheckoutMetadataUpdatedArgs = {
  channels?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type SubscriptionCheckoutUpdatedArgs = {
  channels?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type SubscriptionDraftOrderCreatedArgs = {
  channels?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type SubscriptionDraftOrderDeletedArgs = {
  channels?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type SubscriptionDraftOrderUpdatedArgs = {
  channels?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type SubscriptionOrderBulkCreatedArgs = {
  channels?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type SubscriptionOrderCancelledArgs = {
  channels?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type SubscriptionOrderConfirmedArgs = {
  channels?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type SubscriptionOrderCreatedArgs = {
  channels?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type SubscriptionOrderExpiredArgs = {
  channels?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type SubscriptionOrderFulfilledArgs = {
  channels?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type SubscriptionOrderFullyPaidArgs = {
  channels?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type SubscriptionOrderFullyRefundedArgs = {
  channels?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type SubscriptionOrderMetadataUpdatedArgs = {
  channels?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type SubscriptionOrderPaidArgs = {
  channels?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type SubscriptionOrderRefundedArgs = {
  channels?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type SubscriptionOrderUpdatedArgs = {
  channels?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type SubscriptionProductVariantDiscountedPriceUpdatedArgs = {
  channels?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type TaxCalculationStrategy =
  | 'FLAT_RATES'
  | 'TAX_APP';

/** Tax class is a named object used to define tax rates per country. Tax class can be assigned to product types, products and shipping methods to define their tax rates. */
export type TaxClass = Node & ObjectWithMetadata & {
  __typename?: 'TaxClass';
  /** Country-specific tax rates for this tax class. */
  countries: Array<TaxClassCountryRate>;
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  /** List of public metadata items. Can be accessed without permissions. */
  metadata: Array<MetadataItem>;
  /**
   * A single key from public metadata.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   */
  metafield?: Maybe<Scalars['String']['output']>;
  /** Public metadata. Use `keys` to control which fields you want to include. The default is to include everything. */
  metafields?: Maybe<Scalars['Metadata']['output']>;
  /** Name of the tax class. */
  name: Scalars['String']['output'];
  /** List of private metadata items. Requires staff permissions to access. */
  privateMetadata: Array<MetadataItem>;
  /**
   * A single key from private metadata. Requires staff permissions to access.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   */
  privateMetafield?: Maybe<Scalars['String']['output']>;
  /** Private metadata. Requires staff permissions to access. Use `keys` to control which fields you want to include. The default is to include everything. */
  privateMetafields?: Maybe<Scalars['Metadata']['output']>;
};


/** Tax class is a named object used to define tax rates per country. Tax class can be assigned to product types, products and shipping methods to define their tax rates. */
export type TaxClassMetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Tax class is a named object used to define tax rates per country. Tax class can be assigned to product types, products and shipping methods to define their tax rates. */
export type TaxClassMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Tax class is a named object used to define tax rates per country. Tax class can be assigned to product types, products and shipping methods to define their tax rates. */
export type TaxClassPrivateMetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Tax class is a named object used to define tax rates per country. Tax class can be assigned to product types, products and shipping methods to define their tax rates. */
export type TaxClassPrivateMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type TaxClassCountableConnection = {
  __typename?: 'TaxClassCountableConnection';
  edges: Array<TaxClassCountableEdge>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** A total count of items in the collection. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type TaxClassCountableEdge = {
  __typename?: 'TaxClassCountableEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: TaxClass;
};

/** Tax rate for a country. When tax class is null, it represents the default tax rate for that country; otherwise it's a country tax rate specific to the given tax class. */
export type TaxClassCountryRate = {
  __typename?: 'TaxClassCountryRate';
  /** Country in which this tax rate applies. */
  country: CountryDisplay;
  /** Tax rate value. */
  rate: Scalars['Float']['output'];
  /** Related tax class. */
  taxClass?: Maybe<TaxClass>;
};

/**
 * Creates a tax class.
 *
 * Requires one of the following permissions: MANAGE_TAXES.
 */
export type TaxClassCreate = {
  __typename?: 'TaxClassCreate';
  errors: Array<TaxClassCreateError>;
  taxClass?: Maybe<TaxClass>;
};

export type TaxClassCreateError = {
  __typename?: 'TaxClassCreateError';
  /** The error code. */
  code: TaxClassCreateErrorCode;
  /** List of country codes for which the configuration is invalid. */
  countryCodes: Array<Scalars['String']['output']>;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field?: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message?: Maybe<Scalars['String']['output']>;
};

export type TaxClassCreateErrorCode =
  | 'GRAPHQL_ERROR'
  | 'INVALID'
  | 'NOT_FOUND';

export type TaxClassCreateInput = {
  /** List of country-specific tax rates to create for this tax class. */
  createCountryRates?: InputMaybe<Array<CountryRateInput>>;
  /** Name of the tax class. */
  name: Scalars['String']['input'];
};

/**
 * Deletes a tax class. After deleting the tax class any products, product types or shipping methods using it are updated to use the default tax class.
 *
 * Requires one of the following permissions: MANAGE_TAXES.
 */
export type TaxClassDelete = {
  __typename?: 'TaxClassDelete';
  errors: Array<TaxClassDeleteError>;
  taxClass?: Maybe<TaxClass>;
};

export type TaxClassDeleteError = {
  __typename?: 'TaxClassDeleteError';
  /** The error code. */
  code: TaxClassDeleteErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field?: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message?: Maybe<Scalars['String']['output']>;
};

export type TaxClassDeleteErrorCode =
  | 'GRAPHQL_ERROR'
  | 'INVALID'
  | 'NOT_FOUND';

export type TaxClassFilterInput = {
  countries?: InputMaybe<Array<CountryCode>>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  metadata?: InputMaybe<Array<MetadataFilter>>;
};

export type TaxClassRateInput = {
  /** Tax rate value. */
  rate?: InputMaybe<Scalars['Float']['input']>;
  /** ID of a tax class for which to update the tax rate */
  taxClassId?: InputMaybe<Scalars['ID']['input']>;
};

export type TaxClassSortField =
  /** Sort tax classes by name. */
  | 'NAME';

export type TaxClassSortingInput = {
  /** Specifies the direction in which to sort tax classes. */
  direction: OrderDirection;
  /** Sort tax classes by the selected field. */
  field: TaxClassSortField;
};

/**
 * Updates a tax class.
 *
 * Requires one of the following permissions: MANAGE_TAXES.
 */
export type TaxClassUpdate = {
  __typename?: 'TaxClassUpdate';
  errors: Array<TaxClassUpdateError>;
  taxClass?: Maybe<TaxClass>;
};

export type TaxClassUpdateError = {
  __typename?: 'TaxClassUpdateError';
  /** The error code. */
  code: TaxClassUpdateErrorCode;
  /** List of country codes for which the configuration is invalid. */
  countryCodes: Array<Scalars['String']['output']>;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field?: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message?: Maybe<Scalars['String']['output']>;
};

export type TaxClassUpdateErrorCode =
  | 'DUPLICATED_INPUT_ITEM'
  | 'GRAPHQL_ERROR'
  | 'INVALID'
  | 'NOT_FOUND';

export type TaxClassUpdateInput = {
  /** Name of the tax class. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** List of country codes for which to remove the tax class rates. Note: It removes all rates for given country code. */
  removeCountryRates?: InputMaybe<Array<CountryCode>>;
  /** List of country-specific tax rates to create or update for this tax class. */
  updateCountryRates?: InputMaybe<Array<CountryRateUpdateInput>>;
};

/** Channel-specific tax configuration. */
export type TaxConfiguration = Node & ObjectWithMetadata & {
  __typename?: 'TaxConfiguration';
  /** A channel to which the tax configuration applies to. */
  channel: Channel;
  /** Determines whether taxes are charged in the given channel. */
  chargeTaxes: Scalars['Boolean']['output'];
  /** List of country-specific exceptions in tax configuration. */
  countries: Array<TaxConfigurationPerCountry>;
  /** Determines whether displayed prices should include taxes. */
  displayGrossPrices: Scalars['Boolean']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  /** List of public metadata items. Can be accessed without permissions. */
  metadata: Array<MetadataItem>;
  /**
   * A single key from public metadata.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   */
  metafield?: Maybe<Scalars['String']['output']>;
  /** Public metadata. Use `keys` to control which fields you want to include. The default is to include everything. */
  metafields?: Maybe<Scalars['Metadata']['output']>;
  /** Determines whether prices are entered with the tax included. */
  pricesEnteredWithTax: Scalars['Boolean']['output'];
  /** List of private metadata items. Requires staff permissions to access. */
  privateMetadata: Array<MetadataItem>;
  /**
   * A single key from private metadata. Requires staff permissions to access.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   */
  privateMetafield?: Maybe<Scalars['String']['output']>;
  /** Private metadata. Requires staff permissions to access. Use `keys` to control which fields you want to include. The default is to include everything. */
  privateMetafields?: Maybe<Scalars['Metadata']['output']>;
  /**
   * The tax app `App.identifier` that will be used to calculate the taxes for the given channel. Empty value for `TAX_APP` set as `taxCalculationStrategy` means that Saleor will iterate over all installed tax apps. If multiple tax apps exist with provided tax app id use the `App` with newest `created` date. Will become mandatory in 4.0 for `TAX_APP` `taxCalculationStrategy`.
   *
   * Added in Saleor 3.19.
   */
  taxAppId?: Maybe<Scalars['String']['output']>;
  /** The default strategy to use for tax calculation in the given channel. Taxes can be calculated either using user-defined flat rates or with a tax app. Empty value means that no method is selected and taxes are not calculated. */
  taxCalculationStrategy?: Maybe<TaxCalculationStrategy>;
  /**
   * Determines whether to use weighted tax for shipping. When set to true, the tax rate for shipping will be calculated based on the weighted average of tax rates from the order or checkout lines.
   *
   * Added in Saleor 3.21.
   */
  useWeightedTaxForShipping?: Maybe<Scalars['Boolean']['output']>;
};


/** Channel-specific tax configuration. */
export type TaxConfigurationMetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Channel-specific tax configuration. */
export type TaxConfigurationMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Channel-specific tax configuration. */
export type TaxConfigurationPrivateMetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Channel-specific tax configuration. */
export type TaxConfigurationPrivateMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type TaxConfigurationCountableConnection = {
  __typename?: 'TaxConfigurationCountableConnection';
  edges: Array<TaxConfigurationCountableEdge>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** A total count of items in the collection. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type TaxConfigurationCountableEdge = {
  __typename?: 'TaxConfigurationCountableEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: TaxConfiguration;
};

export type TaxConfigurationFilterInput = {
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  metadata?: InputMaybe<Array<MetadataFilter>>;
};

/** Country-specific exceptions of a channel's tax configuration. */
export type TaxConfigurationPerCountry = {
  __typename?: 'TaxConfigurationPerCountry';
  /** Determines whether taxes are charged in this country. */
  chargeTaxes: Scalars['Boolean']['output'];
  /** Country in which this configuration applies. */
  country: CountryDisplay;
  /** Determines whether displayed prices should include taxes for this country. */
  displayGrossPrices: Scalars['Boolean']['output'];
  /**
   * The tax app `App.identifier` that will be used to calculate the taxes for the given channel and country. If not provided, use the value from the channel's tax configuration.
   *
   * Added in Saleor 3.19.
   */
  taxAppId?: Maybe<Scalars['String']['output']>;
  /** A country-specific strategy to use for tax calculation. Taxes can be calculated either using user-defined flat rates or with a tax app. If not provided, use the value from the channel's tax configuration. */
  taxCalculationStrategy?: Maybe<TaxCalculationStrategy>;
  /**
   * Determines whether to use weighted tax for shipping. When set to true, the tax rate for shipping will be calculated based on the weighted average of tax rates from the order or checkout lines.
   *
   * Added in Saleor 3.21.
   */
  useWeightedTaxForShipping?: Maybe<Scalars['Boolean']['output']>;
};

export type TaxConfigurationPerCountryInput = {
  /** Determines whether taxes are charged in this country. */
  chargeTaxes: Scalars['Boolean']['input'];
  /** Country in which this configuration applies. */
  countryCode: CountryCode;
  /** Determines whether displayed prices should include taxes for this country. */
  displayGrossPrices: Scalars['Boolean']['input'];
  /**
   * The tax app `App.identifier` that will be used to calculate the taxes for the given channel and country. If not provided, use the value from the channel's tax configuration.
   *
   * Added in Saleor 3.19.
   */
  taxAppId?: InputMaybe<Scalars['String']['input']>;
  /** A country-specific strategy to use for tax calculation. Taxes can be calculated either using user-defined flat rates or with a tax app. If not provided, use the value from the channel's tax configuration. */
  taxCalculationStrategy?: InputMaybe<TaxCalculationStrategy>;
  /**
   * Determines whether to use weighted tax for shipping. When set to true, the tax rate for shipping will be calculated based on the weighted average of tax rates from the order or checkout lines. Default value is `False`.Can be used only with `taxCalculationStrategy` set to `FLAT_RATES`.
   *
   * Added in Saleor 3.21.
   */
  useWeightedTaxForShipping?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * Updates tax configuration for a channel.
 *
 * Requires one of the following permissions: MANAGE_TAXES.
 */
export type TaxConfigurationUpdate = {
  __typename?: 'TaxConfigurationUpdate';
  errors: Array<TaxConfigurationUpdateError>;
  taxConfiguration?: Maybe<TaxConfiguration>;
};

export type TaxConfigurationUpdateError = {
  __typename?: 'TaxConfigurationUpdateError';
  /** The error code. */
  code: TaxConfigurationUpdateErrorCode;
  /** List of country codes for which the configuration is invalid. */
  countryCodes: Array<Scalars['String']['output']>;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field?: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message?: Maybe<Scalars['String']['output']>;
};

export type TaxConfigurationUpdateErrorCode =
  | 'DUPLICATED_INPUT_ITEM'
  | 'GRAPHQL_ERROR'
  | 'INVALID'
  | 'NOT_FOUND';

export type TaxConfigurationUpdateInput = {
  /** Determines whether taxes are charged in the given channel. */
  chargeTaxes?: InputMaybe<Scalars['Boolean']['input']>;
  /** Determines whether displayed prices should include taxes. */
  displayGrossPrices?: InputMaybe<Scalars['Boolean']['input']>;
  /** Determines whether prices are entered with the tax included. */
  pricesEnteredWithTax?: InputMaybe<Scalars['Boolean']['input']>;
  /** List of country codes for which to remove the tax configuration. */
  removeCountriesConfiguration?: InputMaybe<Array<CountryCode>>;
  /**
   * The tax app `App.identifier` that will be used to calculate the taxes for the given channel. Empty value for `TAX_APP` set as `taxCalculationStrategy` means that Saleor will iterate over all installed tax apps. If multiple tax apps exist with provided tax app id use the `App` with newest `created` date. It's possible to set plugin by using prefix `plugin:` with `PLUGIN_ID` e.g. with Avalara `plugin:mirumee.taxes.avalara`.Will become mandatory in 4.0 for `TAX_APP` `taxCalculationStrategy`.
   *
   * Added in Saleor 3.19.
   */
  taxAppId?: InputMaybe<Scalars['String']['input']>;
  /** The default strategy to use for tax calculation in the given channel. Taxes can be calculated either using user-defined flat rates or with a tax app. Empty value means that no method is selected and taxes are not calculated. */
  taxCalculationStrategy?: InputMaybe<TaxCalculationStrategy>;
  /** List of tax country configurations to create or update (identified by a country code). */
  updateCountriesConfiguration?: InputMaybe<Array<TaxConfigurationPerCountryInput>>;
  /**
   * Determines whether to use weighted tax for shipping. When set to true, the tax rate for shipping will be calculated based on the weighted average of tax rates from the order or checkout lines. Default value is `False`.Can be used only with `taxCalculationStrategy` set to `FLAT_RATES`.
   *
   * Added in Saleor 3.21.
   */
  useWeightedTaxForShipping?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Tax class rates grouped by country. */
export type TaxCountryConfiguration = {
  __typename?: 'TaxCountryConfiguration';
  /** A country for which tax class rates are grouped. */
  country: CountryDisplay;
  /** List of tax class rates. */
  taxClassCountryRates: Array<TaxClassCountryRate>;
};

/**
 * Remove all tax class rates for a specific country.
 *
 * Requires one of the following permissions: MANAGE_TAXES.
 */
export type TaxCountryConfigurationDelete = {
  __typename?: 'TaxCountryConfigurationDelete';
  errors: Array<TaxCountryConfigurationDeleteError>;
  /** Updated tax class rates grouped by a country. */
  taxCountryConfiguration?: Maybe<TaxCountryConfiguration>;
};

export type TaxCountryConfigurationDeleteError = {
  __typename?: 'TaxCountryConfigurationDeleteError';
  /** The error code. */
  code: TaxCountryConfigurationDeleteErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field?: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message?: Maybe<Scalars['String']['output']>;
};

export type TaxCountryConfigurationDeleteErrorCode =
  | 'GRAPHQL_ERROR'
  | 'INVALID'
  | 'NOT_FOUND';

/**
 * Updates tax class rates for a specific country.
 *
 * Requires one of the following permissions: MANAGE_TAXES.
 */
export type TaxCountryConfigurationUpdate = {
  __typename?: 'TaxCountryConfigurationUpdate';
  errors: Array<TaxCountryConfigurationUpdateError>;
  /** Updated tax class rates grouped by a country. */
  taxCountryConfiguration?: Maybe<TaxCountryConfiguration>;
};

export type TaxCountryConfigurationUpdateError = {
  __typename?: 'TaxCountryConfigurationUpdateError';
  /** The error code. */
  code: TaxCountryConfigurationUpdateErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field?: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message?: Maybe<Scalars['String']['output']>;
  /** List of tax class IDs for which the update failed. */
  taxClassIds: Array<Scalars['String']['output']>;
};

export type TaxCountryConfigurationUpdateErrorCode =
  | 'CANNOT_CREATE_NEGATIVE_RATE'
  | 'GRAPHQL_ERROR'
  | 'INVALID'
  | 'NOT_FOUND'
  | 'ONLY_ONE_DEFAULT_COUNTRY_RATE_ALLOWED';

/**
 * Exempt checkout or order from charging the taxes. When tax exemption is enabled, taxes won't be charged for the checkout or order. Taxes may still be calculated in cases when product prices are entered with the tax included and the net price needs to be known.
 *
 * Requires one of the following permissions: MANAGE_TAXES.
 */
export type TaxExemptionManage = {
  __typename?: 'TaxExemptionManage';
  errors: Array<TaxExemptionManageError>;
  taxableObject?: Maybe<TaxSourceObject>;
};

export type TaxExemptionManageError = {
  __typename?: 'TaxExemptionManageError';
  /** The error code. */
  code: TaxExemptionManageErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field?: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message?: Maybe<Scalars['String']['output']>;
};

export type TaxExemptionManageErrorCode =
  | 'GRAPHQL_ERROR'
  | 'INVALID'
  | 'NOT_EDITABLE_ORDER'
  | 'NOT_FOUND';

export type TaxSourceLine = CheckoutLine | OrderLine;

export type TaxSourceObject = Checkout | Order;

/** Representation of tax types fetched from tax gateway. */
export type TaxType = {
  __typename?: 'TaxType';
  /** Description of the tax type. */
  description?: Maybe<Scalars['String']['output']>;
  /** External tax code used to identify given tax group. */
  taxCode?: Maybe<Scalars['String']['output']>;
};

/** Taxable object. */
export type TaxableObject = {
  __typename?: 'TaxableObject';
  /** The address data. */
  address?: Maybe<Address>;
  channel: Channel;
  /** The currency of the object. */
  currency: Scalars['String']['output'];
  /** List of discounts. */
  discounts: Array<TaxableObjectDiscount>;
  /** List of lines assigned to the object. */
  lines: Array<TaxableObjectLine>;
  /** Determines if prices contain entered tax.. */
  pricesEnteredWithTax: Scalars['Boolean']['output'];
  /** The price of shipping method, includes shipping voucher discount if applied. */
  shippingPrice: Money;
  /** The source object related to this tax object. */
  sourceObject: TaxSourceObject;
};

/** Taxable object discount. */
export type TaxableObjectDiscount = {
  __typename?: 'TaxableObjectDiscount';
  /** The amount of the discount. */
  amount: Money;
  /** The name of the discount. */
  name?: Maybe<Scalars['String']['output']>;
  /** Indicates which part of the order the discount should affect: SUBTOTAL or SHIPPING. */
  type: TaxableObjectDiscountTypeEnum;
};

/** Indicates which part of the order the discount should affect: SUBTOTAL or SHIPPING. */
export type TaxableObjectDiscountTypeEnum =
  | 'SHIPPING'
  | 'SUBTOTAL';

export type TaxableObjectLine = {
  __typename?: 'TaxableObjectLine';
  /** Determines if taxes are being charged for the product. */
  chargeTaxes: Scalars['Boolean']['output'];
  /** The product name. */
  productName: Scalars['String']['output'];
  /** The product sku. */
  productSku?: Maybe<Scalars['String']['output']>;
  /** Number of items. */
  quantity: Scalars['Int']['output'];
  /** The source line related to this tax line. */
  sourceLine: TaxSourceLine;
  /** Price of the order line. The price includes catalogue promotions, specific product and applied once per order voucher discounts. The price does not include the entire order discount. */
  totalPrice: Money;
  /** Price of the single item in the order line. The price includes catalogue promotions, specific product and applied once per order voucher discounts. The price does not include the entire order discount. */
  unitPrice: Money;
  /** The variant name. */
  variantName: Scalars['String']['output'];
};

/** Represents a monetary value with taxes. In cases where taxes were not applied, net and gross values will be equal. */
export type TaxedMoney = {
  __typename?: 'TaxedMoney';
  /** Currency code. */
  currency: Scalars['String']['output'];
  /** Amount of money including taxes. */
  gross: Money;
  /** Amount of money without taxes. */
  net: Money;
  /** Amount of taxes. */
  tax: Money;
};

export type TaxedMoneyInput = {
  /** Gross value of an item. */
  gross: Scalars['PositiveDecimal']['input'];
  /** Net value of an item. */
  net: Scalars['PositiveDecimal']['input'];
};

/** Represents a range of monetary values. */
export type TaxedMoneyRange = {
  __typename?: 'TaxedMoneyRange';
  /** Lower bound of a price range. */
  start?: Maybe<TaxedMoney>;
  /** Upper bound of a price range. */
  stop?: Maybe<TaxedMoney>;
};

/** Event sent when thumbnail is created. */
export type ThumbnailCreated = Event & {
  __typename?: 'ThumbnailCreated';
  /** Thumbnail id. */
  id?: Maybe<Scalars['ID']['output']>;
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<IssuingPrincipal>;
  /** Original media url. */
  mediaUrl?: Maybe<Scalars['String']['output']>;
  /** Object the thumbnail refers to. */
  objectId?: Maybe<Scalars['ID']['output']>;
  /** The application receiving the webhook. */
  recipient?: Maybe<App>;
  /** Thumbnail url. */
  url?: Maybe<Scalars['String']['output']>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

export type ThumbnailFormatEnum =
  | 'AVIF'
  | 'ORIGINAL'
  | 'WEBP';

export type TimePeriod = {
  __typename?: 'TimePeriod';
  /** The length of the period. */
  amount: Scalars['Int']['output'];
  /** The type of the period. */
  type: TimePeriodTypeEnum;
};

export type TimePeriodInputType = {
  /** The length of the period. */
  amount: Scalars['Int']['input'];
  /** The type of the period. */
  type: TimePeriodTypeEnum;
};

export type TimePeriodTypeEnum =
  | 'DAY'
  | 'MONTH'
  | 'WEEK'
  | 'YEAR';

/**
 * Represents possible tokenized payment flows that can be used to process payment.
 *
 *     The following flows are possible:
 *     INTERACTIVE - Payment method can be used for 1 click checkout - it's prefilled in
 *     checkout form (might require additional authentication from user)
 *
 */
export type TokenizedPaymentFlowEnum =
  | 'INTERACTIVE';

/** An object representing a single payment. */
export type Transaction = Node & {
  __typename?: 'Transaction';
  /** Total amount of the transaction. */
  amount?: Maybe<Money>;
  /** Date and time at which transaction was created. */
  created: Scalars['DateTime']['output'];
  /** Error associated with transaction, if any. */
  error?: Maybe<Scalars['String']['output']>;
  /**
   * Response returned by payment gateway.
   * @deprecated This field is a part of a legacy Payments API. Please use apps instead.
   */
  gatewayResponse: Scalars['JSONString']['output'];
  /** ID of the transaction. */
  id: Scalars['ID']['output'];
  /** Determines if the transaction was successful. */
  isSuccess: Scalars['Boolean']['output'];
  /** Determines the type of transaction. */
  kind: TransactionKind;
  /** Determines the payment associated with a transaction. */
  payment: Payment;
  /** Unique token associated with a transaction. */
  token: Scalars['String']['output'];
};

export type TransactionAction = {
  __typename?: 'TransactionAction';
  /** Determines the action type. */
  actionType: TransactionActionEnum;
  /** Transaction request amount. */
  amount: Scalars['PositiveDecimal']['output'];
  /** Currency code. */
  currency: Scalars['String']['output'];
};

/**
 * Represents possible actions on payment transaction.
 *
 *     The following actions are possible:
 *     CHARGE - Represents the charge action.
 *     REFUND - Represents a refund action.
 *     CANCEL - Represents a cancel action. Added in Saleor 3.12.
 *
 */
export type TransactionActionEnum =
  | 'CANCEL'
  | 'CHARGE'
  | 'REFUND';

/** Event sent when transaction cancelation is requested. */
export type TransactionCancelationRequested = Event & {
  __typename?: 'TransactionCancelationRequested';
  /** Requested action data. */
  action: TransactionAction;
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<IssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient?: Maybe<App>;
  /** Look up a transaction. */
  transaction?: Maybe<TransactionItem>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

/** Event sent when transaction charge is requested. */
export type TransactionChargeRequested = Event & {
  __typename?: 'TransactionChargeRequested';
  /** Requested action data. */
  action: TransactionAction;
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<IssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient?: Maybe<App>;
  /** Look up a transaction. */
  transaction?: Maybe<TransactionItem>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

export type TransactionCountableConnection = {
  __typename?: 'TransactionCountableConnection';
  edges: Array<TransactionCountableEdge>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** A total count of items in the collection. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type TransactionCountableEdge = {
  __typename?: 'TransactionCountableEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: TransactionItem;
};

/**
 * Creates transaction for checkout or order.
 *
 * Requires one of the following permissions: HANDLE_PAYMENTS.
 */
export type TransactionCreate = {
  __typename?: 'TransactionCreate';
  errors: Array<TransactionCreateError>;
  transaction?: Maybe<TransactionItem>;
};

export type TransactionCreateError = {
  __typename?: 'TransactionCreateError';
  /** The error code. */
  code: TransactionCreateErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field?: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message?: Maybe<Scalars['String']['output']>;
};

export type TransactionCreateErrorCode =
  | 'GRAPHQL_ERROR'
  | 'INCORRECT_CURRENCY'
  | 'INVALID'
  | 'METADATA_KEY_REQUIRED'
  | 'NOT_FOUND'
  | 'UNIQUE';

export type TransactionCreateInput = {
  /** Amount authorized by this transaction. */
  amountAuthorized?: InputMaybe<MoneyInput>;
  /** Amount canceled by this transaction. */
  amountCanceled?: InputMaybe<MoneyInput>;
  /** Amount charged by this transaction. */
  amountCharged?: InputMaybe<MoneyInput>;
  /** Amount refunded by this transaction. */
  amountRefunded?: InputMaybe<MoneyInput>;
  /** List of all possible actions for the transaction */
  availableActions?: InputMaybe<Array<TransactionActionEnum>>;
  /** The url that will allow to redirect user to payment provider page with transaction event details. */
  externalUrl?: InputMaybe<Scalars['String']['input']>;
  /** The message of the transaction. */
  message?: InputMaybe<Scalars['String']['input']>;
  /**
   * Payment public metadata. Can be read by any API client authorized to read the object it's attached to.
   *
   * Warning: never store sensitive information, including financial data such as credit card details.
   */
  metadata?: InputMaybe<Array<MetadataInput>>;
  /** Payment name of the transaction. */
  name?: InputMaybe<Scalars['String']['input']>;
  /**
   * Details of the payment method used for the transaction.
   *
   * Added in Saleor 3.22.
   */
  paymentMethodDetails?: InputMaybe<PaymentMethodDetailsInput>;
  /**
   * Payment private metadata. Requires permissions to modify and to read the metadata of the object it's attached to.
   *
   * Warning: never store sensitive information, including financial data such as credit card details.
   */
  privateMetadata?: InputMaybe<Array<MetadataInput>>;
  /** PSP Reference of the transaction. */
  pspReference?: InputMaybe<Scalars['String']['input']>;
};

/** Represents transaction's event. */
export type TransactionEvent = Node & {
  __typename?: 'TransactionEvent';
  /** The amount related to this event. */
  amount: Money;
  /** Date and time at which a transaction event was created. */
  createdAt: Scalars['DateTime']['output'];
  /** User or App that created the transaction event. */
  createdBy?: Maybe<UserOrApp>;
  /** The url that will allow to redirect user to payment provider page with transaction details. */
  externalUrl: Scalars['String']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  /** Idempotency key assigned to the event. */
  idempotencyKey?: Maybe<Scalars['String']['output']>;
  /** Message related to the transaction's event. */
  message: Scalars['String']['output'];
  /** PSP reference of transaction. */
  pspReference: Scalars['String']['output'];
  /**
   * Reason model of the transaction refund.
   *
   * Added in Saleor 3.22.
   */
  reasonReference?: Maybe<Page>;
  /** The type of action related to this event. */
  type?: Maybe<TransactionEventTypeEnum>;
};

export type TransactionEventInput = {
  /** The message related to the event. */
  message?: InputMaybe<Scalars['String']['input']>;
  /** PSP Reference related to this action. */
  pspReference?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Report the event for the transaction.
 *
 * Requires the following permissions: OWNER and HANDLE_PAYMENTS for apps, HANDLE_PAYMENTS for staff users. Staff user cannot update a transaction that is owned by the app.
 *
 * Triggers the following webhook events:
 * - TRANSACTION_ITEM_METADATA_UPDATED (async): Optionally called when transaction's metadata was updated.
 * - CHECKOUT_FULLY_PAID (async): Optionally called when the checkout charge status changed to `FULL` or `OVERCHARGED`.
 * - ORDER_UPDATED (async): Optionally called when the transaction is related to the order and the order was updated.
 */
export type TransactionEventReport = {
  __typename?: 'TransactionEventReport';
  /** Defines if the reported event hasn't been processed earlier. */
  alreadyProcessed?: Maybe<Scalars['Boolean']['output']>;
  errors: Array<TransactionEventReportError>;
  /** The transaction related to the reported event. */
  transaction?: Maybe<TransactionItem>;
  /** The event assigned to this report. if `alreadyProcessed` is set to `true`, the previously processed event will be returned. */
  transactionEvent?: Maybe<TransactionEvent>;
};

export type TransactionEventReportError = {
  __typename?: 'TransactionEventReportError';
  /** The error code. */
  code: TransactionEventReportErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field?: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message?: Maybe<Scalars['String']['output']>;
};

export type TransactionEventReportErrorCode =
  | 'ALREADY_EXISTS'
  | 'GRAPHQL_ERROR'
  | 'INCORRECT_DETAILS'
  | 'INVALID'
  | 'NOT_FOUND'
  | 'REQUIRED';

/**
 * Represents possible event types.
 *
 *     Added in Saleor 3.12.
 *
 *     The following types are possible:
 *     AUTHORIZATION_SUCCESS - represents success authorization.
 *     AUTHORIZATION_FAILURE - represents failure authorization.
 *     AUTHORIZATION_ADJUSTMENT - represents authorization adjustment.
 *     AUTHORIZATION_REQUEST - represents authorization request.
 *     AUTHORIZATION_ACTION_REQUIRED - represents authorization that needs
 *     additional actions from the customer.
 *     CHARGE_ACTION_REQUIRED - represents charge that needs
 *     additional actions from the customer.
 *     CHARGE_SUCCESS - represents success charge.
 *     CHARGE_FAILURE - represents failure charge.
 *     CHARGE_BACK - represents chargeback.
 *     CHARGE_REQUEST - represents charge request.
 *     REFUND_SUCCESS - represents success refund.
 *     REFUND_FAILURE - represents failure refund.
 *     REFUND_REVERSE - represents reverse refund.
 *     REFUND_REQUEST - represents refund request.
 *     CANCEL_SUCCESS - represents success cancel.
 *     CANCEL_FAILURE - represents failure cancel.
 *     CANCEL_REQUEST - represents cancel request.
 *     INFO - represents info event.
 *
 */
export type TransactionEventTypeEnum =
  | 'AUTHORIZATION_ACTION_REQUIRED'
  | 'AUTHORIZATION_ADJUSTMENT'
  | 'AUTHORIZATION_FAILURE'
  | 'AUTHORIZATION_REQUEST'
  | 'AUTHORIZATION_SUCCESS'
  | 'CANCEL_FAILURE'
  | 'CANCEL_REQUEST'
  | 'CANCEL_SUCCESS'
  | 'CHARGE_ACTION_REQUIRED'
  | 'CHARGE_BACK'
  | 'CHARGE_FAILURE'
  | 'CHARGE_REQUEST'
  | 'CHARGE_SUCCESS'
  | 'INFO'
  | 'REFUND_FAILURE'
  | 'REFUND_REQUEST'
  | 'REFUND_REVERSE'
  | 'REFUND_SUCCESS';

/** Filter input for transactions. */
export type TransactionFilterInput = {
  /** Filter by metadata fields of transactions. */
  metadata?: InputMaybe<MetadataFilterInput>;
  /** Filter by payment method details used to pay for the order. */
  paymentMethodDetails?: InputMaybe<PaymentMethodDetailsFilterInput>;
  /**
   * Filter by PSP reference of transactions.
   *
   * Added in Saleor 3.22.
   */
  pspReference?: InputMaybe<StringFilterInput>;
};

/**
 * Determine the transaction flow strategy.
 *
 *     AUTHORIZATION - the processed transaction should be only authorized
 *     CHARGE - the processed transaction should be charged.
 *
 */
export type TransactionFlowStrategyEnum =
  | 'AUTHORIZATION'
  | 'CHARGE';

/** Initializes a transaction session. It triggers the webhook `TRANSACTION_INITIALIZE_SESSION`, to the requested `paymentGateways`. There is a limit of 100 transaction items per checkout / order. */
export type TransactionInitialize = {
  __typename?: 'TransactionInitialize';
  /** The JSON data required to finalize the payment. */
  data?: Maybe<Scalars['JSON']['output']>;
  errors: Array<TransactionInitializeError>;
  /** The initialized transaction. */
  transaction?: Maybe<TransactionItem>;
  /** The event created for the initialized transaction. */
  transactionEvent?: Maybe<TransactionEvent>;
};

export type TransactionInitializeError = {
  __typename?: 'TransactionInitializeError';
  /** The error code. */
  code: TransactionInitializeErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field?: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message?: Maybe<Scalars['String']['output']>;
};

export type TransactionInitializeErrorCode =
  | 'CHECKOUT_COMPLETION_IN_PROGRESS'
  | 'GRAPHQL_ERROR'
  | 'INVALID'
  | 'NOT_FOUND'
  | 'UNIQUE';

/** Event sent when user starts processing the payment. */
export type TransactionInitializeSession = Event & {
  __typename?: 'TransactionInitializeSession';
  /** Action to proceed for the transaction */
  action: TransactionProcessAction;
  /** The customer's IP address. If not provided as a parameter in the mutation, Saleor will try to determine the customer's IP address on its own. */
  customerIpAddress?: Maybe<Scalars['String']['output']>;
  /** Payment gateway data in JSON format, received from storefront. */
  data?: Maybe<Scalars['JSON']['output']>;
  /** Idempotency key assigned to the transaction initialize. */
  idempotencyKey: Scalars['String']['output'];
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<IssuingPrincipal>;
  /** Merchant reference assigned to this payment. */
  merchantReference: Scalars['String']['output'];
  /** The application receiving the webhook. */
  recipient?: Maybe<App>;
  /** Checkout or order */
  sourceObject: OrderOrCheckout;
  /** Look up a transaction. */
  transaction: TransactionItem;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

/** Represents a payment transaction. */
export type TransactionItem = Node & ObjectWithMetadata & {
  __typename?: 'TransactionItem';
  /** List of actions that can be performed in the current state of a payment. */
  actions: Array<TransactionActionEnum>;
  /** Total amount of ongoing authorization requests for the transaction. */
  authorizePendingAmount: Money;
  /** Total amount authorized for this payment. */
  authorizedAmount: Money;
  /** Total amount of ongoing cancel requests for the transaction. */
  cancelPendingAmount: Money;
  /** Total amount canceled for this payment. */
  canceledAmount: Money;
  /** Total amount of ongoing charge requests for the transaction. */
  chargePendingAmount: Money;
  /** Total amount charged for this payment. */
  chargedAmount: Money;
  /** The related checkout. */
  checkout?: Maybe<Checkout>;
  /** Date and time at which payment transaction was created. */
  createdAt: Scalars['DateTime']['output'];
  /** User or App that created the transaction. */
  createdBy?: Maybe<UserOrApp>;
  /** List of all transaction's events. */
  events: Array<TransactionEvent>;
  /** The url that will allow to redirect user to payment provider page with transaction details. */
  externalUrl: Scalars['String']['output'];
  /** The ID of the object. */
  id: Scalars['ID']['output'];
  /** Message related to the transaction. */
  message: Scalars['String']['output'];
  /** List of public metadata items. Can be accessed without permissions. */
  metadata: Array<MetadataItem>;
  /**
   * A single key from public metadata.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   */
  metafield?: Maybe<Scalars['String']['output']>;
  /** Public metadata. Use `keys` to control which fields you want to include. The default is to include everything. */
  metafields?: Maybe<Scalars['Metadata']['output']>;
  /** Date and time at which payment transaction was modified. */
  modifiedAt: Scalars['DateTime']['output'];
  /** Name of the transaction. */
  name: Scalars['String']['output'];
  /** The related order. */
  order?: Maybe<Order>;
  /**
   * The payment method used for this transaction.
   *
   * Added in Saleor 3.22.
   */
  paymentMethodDetails?: Maybe<PaymentMethodDetails>;
  /** List of private metadata items. Requires staff permissions to access. */
  privateMetadata: Array<MetadataItem>;
  /**
   * A single key from private metadata. Requires staff permissions to access.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   */
  privateMetafield?: Maybe<Scalars['String']['output']>;
  /** Private metadata. Requires staff permissions to access. Use `keys` to control which fields you want to include. The default is to include everything. */
  privateMetafields?: Maybe<Scalars['Metadata']['output']>;
  /** PSP reference of transaction. */
  pspReference: Scalars['String']['output'];
  /**
   * Reason of the refund.
   *
   * Added in Saleor 3.22.
   */
  reason?: Maybe<Scalars['String']['output']>;
  /**
   * Reason `Page` (Model) for refund.
   *
   * Added in Saleor 3.22.
   */
  reasonReference?: Maybe<Page>;
  /** Total amount of ongoing refund requests for the transaction. */
  refundPendingAmount: Money;
  /** Total amount refunded for this payment. */
  refundedAmount: Money;
  /** The transaction token. */
  token: Scalars['UUID']['output'];
};


/** Represents a payment transaction. */
export type TransactionItemMetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Represents a payment transaction. */
export type TransactionItemMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Represents a payment transaction. */
export type TransactionItemPrivateMetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Represents a payment transaction. */
export type TransactionItemPrivateMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Event sent when transaction item metadata is updated. */
export type TransactionItemMetadataUpdated = Event & {
  __typename?: 'TransactionItemMetadataUpdated';
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<IssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient?: Maybe<App>;
  /** Look up a transaction. */
  transaction?: Maybe<TransactionItem>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

export type TransactionKind =
  | 'ACTION_TO_CONFIRM'
  | 'AUTH'
  | 'CANCEL'
  | 'CAPTURE'
  | 'CONFIRM'
  | 'EXTERNAL'
  | 'PENDING'
  | 'REFUND'
  | 'REFUND_ONGOING'
  | 'VOID';

/** Processes a transaction session. It triggers the webhook `TRANSACTION_PROCESS_SESSION`, to the assigned `paymentGateways`.  */
export type TransactionProcess = {
  __typename?: 'TransactionProcess';
  /** The json data required to finalize the payment. */
  data?: Maybe<Scalars['JSON']['output']>;
  errors: Array<TransactionProcessError>;
  /** The processed transaction. */
  transaction?: Maybe<TransactionItem>;
  /** The event created for the processed transaction. */
  transactionEvent?: Maybe<TransactionEvent>;
};

export type TransactionProcessAction = {
  __typename?: 'TransactionProcessAction';
  actionType: TransactionFlowStrategyEnum;
  /** Transaction amount to process. */
  amount: Scalars['PositiveDecimal']['output'];
  /** Currency of the amount. */
  currency: Scalars['String']['output'];
};

export type TransactionProcessError = {
  __typename?: 'TransactionProcessError';
  /** The error code. */
  code: TransactionProcessErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field?: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message?: Maybe<Scalars['String']['output']>;
};

export type TransactionProcessErrorCode =
  | 'CHECKOUT_COMPLETION_IN_PROGRESS'
  | 'GRAPHQL_ERROR'
  | 'INVALID'
  | 'MISSING_PAYMENT_APP'
  | 'MISSING_PAYMENT_APP_RELATION'
  | 'NOT_FOUND'
  | 'TRANSACTION_ALREADY_PROCESSED';

/** Event sent when user has additional payment action to process. */
export type TransactionProcessSession = Event & {
  __typename?: 'TransactionProcessSession';
  /** Action to proceed for the transaction */
  action: TransactionProcessAction;
  /** The customer's IP address. If not provided as a parameter in the mutation, Saleor will try to determine the customer's IP address on its own. */
  customerIpAddress?: Maybe<Scalars['String']['output']>;
  /** Payment gateway data in JSON format, received from storefront. */
  data?: Maybe<Scalars['JSON']['output']>;
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<IssuingPrincipal>;
  /** Merchant reference assigned to this payment. */
  merchantReference: Scalars['String']['output'];
  /** The application receiving the webhook. */
  recipient?: Maybe<App>;
  /** Checkout or order */
  sourceObject: OrderOrCheckout;
  /** Look up a transaction. */
  transaction: TransactionItem;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

/** Event sent when transaction refund is requested. */
export type TransactionRefundRequested = Event & {
  __typename?: 'TransactionRefundRequested';
  /** Requested action data. */
  action: TransactionAction;
  /**
   * Granted refund related to refund request.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  grantedRefund?: Maybe<OrderGrantedRefund>;
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<IssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient?: Maybe<App>;
  /** Look up a transaction. */
  transaction?: Maybe<TransactionItem>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

/**
 * Request an action for payment transaction.
 *
 * Requires one of the following permissions: HANDLE_PAYMENTS.
 */
export type TransactionRequestAction = {
  __typename?: 'TransactionRequestAction';
  errors: Array<TransactionRequestActionError>;
  transaction?: Maybe<TransactionItem>;
};

export type TransactionRequestActionError = {
  __typename?: 'TransactionRequestActionError';
  /** The error code. */
  code: TransactionRequestActionErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field?: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message?: Maybe<Scalars['String']['output']>;
};

export type TransactionRequestActionErrorCode =
  | 'GRAPHQL_ERROR'
  | 'INVALID'
  | 'MISSING_TRANSACTION_ACTION_REQUEST_WEBHOOK'
  | 'NOT_FOUND'
  | 'REQUIRED';

/**
 * Request a refund for payment transaction based on granted refund.
 *
 * Requires one of the following permissions: HANDLE_PAYMENTS.
 */
export type TransactionRequestRefundForGrantedRefund = {
  __typename?: 'TransactionRequestRefundForGrantedRefund';
  errors: Array<TransactionRequestRefundForGrantedRefundError>;
  transaction?: Maybe<TransactionItem>;
};

export type TransactionRequestRefundForGrantedRefundError = {
  __typename?: 'TransactionRequestRefundForGrantedRefundError';
  /** The error code. */
  code: TransactionRequestRefundForGrantedRefundErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field?: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message?: Maybe<Scalars['String']['output']>;
};

export type TransactionRequestRefundForGrantedRefundErrorCode =
  | 'AMOUNT_GREATER_THAN_AVAILABLE'
  | 'GRAPHQL_ERROR'
  | 'INVALID'
  | 'MISSING_TRANSACTION_ACTION_REQUEST_WEBHOOK'
  | 'NOT_FOUND'
  | 'REFUND_ALREADY_PROCESSED'
  | 'REFUND_IS_PENDING';

/**
 * Update transaction.
 *
 * Requires the following permissions: OWNER and HANDLE_PAYMENTS for apps, HANDLE_PAYMENTS for staff users. Staff user cannot update a transaction that is owned by the app.
 */
export type TransactionUpdate = {
  __typename?: 'TransactionUpdate';
  errors: Array<TransactionUpdateError>;
  transaction?: Maybe<TransactionItem>;
};

export type TransactionUpdateError = {
  __typename?: 'TransactionUpdateError';
  /** The error code. */
  code: TransactionUpdateErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field?: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message?: Maybe<Scalars['String']['output']>;
};

export type TransactionUpdateErrorCode =
  | 'GRAPHQL_ERROR'
  | 'INCORRECT_CURRENCY'
  | 'INVALID'
  | 'METADATA_KEY_REQUIRED'
  | 'NOT_FOUND'
  | 'UNIQUE';

export type TransactionUpdateInput = {
  /** Amount authorized by this transaction. */
  amountAuthorized?: InputMaybe<MoneyInput>;
  /** Amount canceled by this transaction. */
  amountCanceled?: InputMaybe<MoneyInput>;
  /** Amount charged by this transaction. */
  amountCharged?: InputMaybe<MoneyInput>;
  /** Amount refunded by this transaction. */
  amountRefunded?: InputMaybe<MoneyInput>;
  /** List of all possible actions for the transaction */
  availableActions?: InputMaybe<Array<TransactionActionEnum>>;
  /** The url that will allow to redirect user to payment provider page with transaction event details. */
  externalUrl?: InputMaybe<Scalars['String']['input']>;
  /** The message of the transaction. */
  message?: InputMaybe<Scalars['String']['input']>;
  /**
   * Payment public metadata. Can be read by any API client authorized to read the object it's attached to.
   *
   * Warning: never store sensitive information, including financial data such as credit card details.
   */
  metadata?: InputMaybe<Array<MetadataInput>>;
  /** Payment name of the transaction. */
  name?: InputMaybe<Scalars['String']['input']>;
  /**
   * Details of the payment method used for the transaction.
   *
   * Added in Saleor 3.22.
   */
  paymentMethodDetails?: InputMaybe<PaymentMethodDetailsInput>;
  /**
   * Payment private metadata. Requires permissions to modify and to read the metadata of the object it's attached to.
   *
   * Warning: never store sensitive information, including financial data such as credit card details.
   */
  privateMetadata?: InputMaybe<Array<MetadataInput>>;
  /** PSP Reference of the transaction. */
  pspReference?: InputMaybe<Scalars['String']['input']>;
};

export type TransactionWhereInput = {
  /** List of conditions that must be met. */
  AND?: InputMaybe<Array<TransactionWhereInput>>;
  /** A list of conditions of which at least one must be met. */
  OR?: InputMaybe<Array<TransactionWhereInput>>;
  /** Filter by app identifier. */
  appIdentifier?: InputMaybe<StringFilterInput>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter by PSP reference. */
  pspReference?: InputMaybe<StringFilterInput>;
};

export type TranslatableItem = AttributeTranslatableContent | AttributeValueTranslatableContent | CategoryTranslatableContent | CollectionTranslatableContent | MenuItemTranslatableContent | PageTranslatableContent | ProductTranslatableContent | ProductVariantTranslatableContent | PromotionRuleTranslatableContent | PromotionTranslatableContent | SaleTranslatableContent | ShippingMethodTranslatableContent | VoucherTranslatableContent;

export type TranslatableItemConnection = {
  __typename?: 'TranslatableItemConnection';
  edges: Array<TranslatableItemEdge>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** A total count of items in the collection. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type TranslatableItemEdge = {
  __typename?: 'TranslatableItemEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: TranslatableItem;
};

export type TranslatableKinds =
  | 'ATTRIBUTE'
  | 'ATTRIBUTE_VALUE'
  | 'CATEGORY'
  | 'COLLECTION'
  | 'MENU_ITEM'
  | 'PAGE'
  | 'PRODUCT'
  | 'PROMOTION'
  | 'PROMOTION_RULE'
  | 'SALE'
  | 'SHIPPING_METHOD'
  | 'VARIANT'
  | 'VOUCHER';

/** Event sent when new translation is created. */
export type TranslationCreated = Event & {
  __typename?: 'TranslationCreated';
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<IssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient?: Maybe<App>;
  /** The translation the event relates to. */
  translation?: Maybe<TranslationTypes>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

export type TranslationError = {
  __typename?: 'TranslationError';
  /** The error code. */
  code: TranslationErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field?: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message?: Maybe<Scalars['String']['output']>;
};

export type TranslationErrorCode =
  | 'GRAPHQL_ERROR'
  | 'INVALID'
  | 'NOT_FOUND'
  | 'REQUIRED'
  | 'UNIQUE';

export type TranslationInput = {
  /**
   * Translated description.
   *
   * Rich text format. For reference see https://editorjs.io/
   */
  description?: InputMaybe<Scalars['JSONString']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  seoDescription?: InputMaybe<Scalars['String']['input']>;
  seoTitle?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type TranslationTypes = AttributeTranslation | AttributeValueTranslation | CategoryTranslation | CollectionTranslation | MenuItemTranslation | PageTranslation | ProductTranslation | ProductVariantTranslation | PromotionRuleTranslation | PromotionTranslation | SaleTranslation | ShippingMethodTranslation | VoucherTranslation;

/** Event sent when translation is updated. */
export type TranslationUpdated = Event & {
  __typename?: 'TranslationUpdated';
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<IssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient?: Maybe<App>;
  /** The translation the event relates to. */
  translation?: Maybe<TranslationTypes>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

/** Define the filtering options for string fields. */
export type UuidFilterInput = {
  /** The value equal to. */
  eq?: InputMaybe<Scalars['UUID']['input']>;
  /** The value included in. */
  oneOf?: InputMaybe<Array<Scalars['UUID']['input']>>;
};

export type UpdateInvoiceInput = {
  /**
   * Fields required to update the invoice metadata. Can be read by any API client authorized to read the object it's attached to.
   *
   * Warning: never store sensitive information, including financial data such as credit card details.
   */
  metadata?: InputMaybe<Array<MetadataInput>>;
  /** Invoice number */
  number?: InputMaybe<Scalars['String']['input']>;
  /**
   * Fields required to update the invoice private metadata. Requires permissions to modify and to read the metadata of the object it's attached to.
   *
   * Warning: never store sensitive information, including financial data such as credit card details.
   */
  privateMetadata?: InputMaybe<Array<MetadataInput>>;
  /** URL of an invoice to download. */
  url?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Updates metadata of an object.Requires permissions to modify and to read the metadata of the object it's attached to.
 *
 * Warning: never store sensitive information, including financial data such as credit card details.
 */
export type UpdateMetadata = {
  __typename?: 'UpdateMetadata';
  errors: Array<MetadataError>;
  item?: Maybe<ObjectWithMetadata>;
  /** @deprecated Use `errors` field instead. */
  metadataErrors: Array<MetadataError>;
};

/**
 * Updates private metadata of an object. Requires permissions to modify and to read the metadata of the object it's attached to.
 *
 * Warning: never store sensitive information, including financial data such as credit card details.
 */
export type UpdatePrivateMetadata = {
  __typename?: 'UpdatePrivateMetadata';
  errors: Array<MetadataError>;
  item?: Maybe<ObjectWithMetadata>;
  /** @deprecated Use `errors` field instead. */
  metadataErrors: Array<MetadataError>;
};

export type UploadError = {
  __typename?: 'UploadError';
  /** The error code. */
  code: UploadErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field?: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message?: Maybe<Scalars['String']['output']>;
};

export type UploadErrorCode =
  | 'GRAPHQL_ERROR'
  | 'INVALID_FILE_TYPE'
  | 'UNSUPPORTED_MIME_TYPE';

/** Represents user data. */
export type User = Node & ObjectWithMetadata & {
  __typename?: 'User';
  /** List of channels the user has access to. The sum of channels from all user groups. If at least one group has `restrictedAccessToChannels` set to False - all channels are returned. */
  accessibleChannels?: Maybe<Array<Channel>>;
  /** List of all user's addresses. */
  addresses: Array<Address>;
  /** The avatar of the user. */
  avatar?: Maybe<Image>;
  /**
   * Returns the last open checkout of this user.
   * @deprecated Use the `checkoutTokens` field to fetch the user checkouts.
   */
  checkout?: Maybe<Checkout>;
  /** Returns the checkout ID's assigned to this user. */
  checkoutIds?: Maybe<Array<Scalars['ID']['output']>>;
  /**
   * Returns the checkout UUID's assigned to this user.
   * @deprecated Use `checkoutIds` instead.
   */
  checkoutTokens?: Maybe<Array<Scalars['UUID']['output']>>;
  /** Returns checkouts assigned to this user. The query will not initiate any external requests, including fetching external shipping methods, filtering available shipping methods, or performing external tax calculations. */
  checkouts?: Maybe<CheckoutCountableConnection>;
  /** The data when the user create account. */
  dateJoined: Scalars['DateTime']['output'];
  /** The default billing address of the user. */
  defaultBillingAddress?: Maybe<Address>;
  /** The default shipping address of the user. */
  defaultShippingAddress?: Maybe<Address>;
  /** List of user's permission groups which user can manage. */
  editableGroups?: Maybe<Array<Group>>;
  /** The email address of the user. */
  email: Scalars['String']['output'];
  /**
   * List of events associated with the user.
   *
   * Requires one of the following permissions: MANAGE_USERS, MANAGE_STAFF.
   */
  events?: Maybe<Array<CustomerEvent>>;
  /** External ID of this user. */
  externalReference?: Maybe<Scalars['String']['output']>;
  /** The given name of the address. */
  firstName: Scalars['String']['output'];
  /** List of the user gift cards. */
  giftCards?: Maybe<GiftCardCountableConnection>;
  /** The ID of the user. */
  id: Scalars['ID']['output'];
  /** Determine if the user is active. */
  isActive: Scalars['Boolean']['output'];
  /** Determines if user has confirmed email. */
  isConfirmed: Scalars['Boolean']['output'];
  /** Determine if the user is a staff admin. */
  isStaff: Scalars['Boolean']['output'];
  /** User language code. */
  languageCode: LanguageCodeEnum;
  /** The date when the user last time log in to the system. */
  lastLogin?: Maybe<Scalars['DateTime']['output']>;
  /** The family name of the address. */
  lastName: Scalars['String']['output'];
  /** List of public metadata items. Can be accessed without permissions. */
  metadata: Array<MetadataItem>;
  /**
   * A single key from public metadata.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   */
  metafield?: Maybe<Scalars['String']['output']>;
  /** Public metadata. Use `keys` to control which fields you want to include. The default is to include everything. */
  metafields?: Maybe<Scalars['Metadata']['output']>;
  /**
   * A note about the customer.
   *
   * Requires one of the following permissions: MANAGE_USERS, MANAGE_STAFF.
   */
  note?: Maybe<Scalars['String']['output']>;
  /** List of user's orders. The query will not initiate any external requests, including filtering available shipping methods, or performing external tax calculations. Requires one of the following permissions: MANAGE_STAFF, OWNER. */
  orders?: Maybe<OrderCountableConnection>;
  /** List of user's permission groups. */
  permissionGroups?: Maybe<Array<Group>>;
  /** List of private metadata items. Requires staff permissions to access. */
  privateMetadata: Array<MetadataItem>;
  /**
   * A single key from private metadata. Requires staff permissions to access.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   */
  privateMetafield?: Maybe<Scalars['String']['output']>;
  /** Private metadata. Requires staff permissions to access. Use `keys` to control which fields you want to include. The default is to include everything. */
  privateMetafields?: Maybe<Scalars['Metadata']['output']>;
  /** Determine if user have restricted access to channels. False if at least one user group has `restrictedAccessToChannels` set to False. */
  restrictedAccessToChannels: Scalars['Boolean']['output'];
  /** Returns a list of user's stored payment methods that can be used in provided channel. The field returns a list of stored payment methods by payment apps. When `amount` is not provided, 0 will be used as default value. */
  storedPaymentMethods?: Maybe<Array<StoredPaymentMethod>>;
  /** List of stored payment sources. The field returns a list of payment sources stored for payment plugins. */
  storedPaymentSources?: Maybe<Array<PaymentSource>>;
  /** The data when the user last update the account information. */
  updatedAt: Scalars['DateTime']['output'];
  /** List of user's permissions. */
  userPermissions?: Maybe<Array<UserPermission>>;
};


/** Represents user data. */
export type UserAvatarArgs = {
  format?: InputMaybe<ThumbnailFormatEnum>;
  size?: InputMaybe<Scalars['Int']['input']>;
};


/** Represents user data. */
export type UserCheckoutIdsArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
};


/** Represents user data. */
export type UserCheckoutTokensArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
};


/** Represents user data. */
export type UserCheckoutsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  channel?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Represents user data. */
export type UserGiftCardsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Represents user data. */
export type UserMetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Represents user data. */
export type UserMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Represents user data. */
export type UserOrdersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CustomerOrderWhereInput>;
};


/** Represents user data. */
export type UserPrivateMetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Represents user data. */
export type UserPrivateMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Represents user data. */
export type UserStoredPaymentMethodsArgs = {
  channel: Scalars['String']['input'];
};


/** Represents user data. */
export type UserStoredPaymentSourcesArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Deletes a user avatar. Only for staff members.
 *
 * Requires one of the following permissions: AUTHENTICATED_STAFF_USER.
 */
export type UserAvatarDelete = {
  __typename?: 'UserAvatarDelete';
  /** @deprecated Use `errors` field instead. */
  accountErrors: Array<AccountError>;
  errors: Array<AccountError>;
  /** An updated user instance. */
  user?: Maybe<User>;
};

/**
 * Create a user avatar. Only for staff members. This mutation must be sent as a `multipart` request. More detailed specs of the upload format can be found here: https://github.com/jaydenseric/graphql-multipart-request-spec
 *
 * Requires one of the following permissions: AUTHENTICATED_STAFF_USER.
 */
export type UserAvatarUpdate = {
  __typename?: 'UserAvatarUpdate';
  /** @deprecated Use `errors` field instead. */
  accountErrors: Array<AccountError>;
  errors: Array<AccountError>;
  /** An updated user instance. */
  user?: Maybe<User>;
};

/**
 * Activate or deactivate users.
 *
 * Requires one of the following permissions: MANAGE_USERS.
 */
export type UserBulkSetActive = {
  __typename?: 'UserBulkSetActive';
  /** @deprecated Use `errors` field instead. */
  accountErrors: Array<AccountError>;
  /** Returns how many objects were affected. */
  count: Scalars['Int']['output'];
  errors: Array<AccountError>;
};

export type UserCountableConnection = {
  __typename?: 'UserCountableConnection';
  edges: Array<UserCountableEdge>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** A total count of items in the collection. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type UserCountableEdge = {
  __typename?: 'UserCountableEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: User;
};

export type UserCreateInput = {
  /** Slug of a channel which will be used for notify user. Optional when only one channel exists. */
  channel?: InputMaybe<Scalars['String']['input']>;
  /** Billing address of the customer. */
  defaultBillingAddress?: InputMaybe<AddressInput>;
  /** Shipping address of the customer. */
  defaultShippingAddress?: InputMaybe<AddressInput>;
  /** The unique email address of the user. */
  email?: InputMaybe<Scalars['String']['input']>;
  /** External ID of the customer. */
  externalReference?: InputMaybe<Scalars['String']['input']>;
  /** Given name. */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** User account is active. */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * User account is confirmed.
   *
   * DEPRECATED: this field will be removed.
   *
   * The user will be always set as unconfirmed. The confirmation will take place when the user sets the password.
   */
  isConfirmed?: InputMaybe<Scalars['Boolean']['input']>;
  /** User language code. */
  languageCode?: InputMaybe<LanguageCodeEnum>;
  /** Family name. */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /**
   * Fields required to update the user metadata. Can be read by any API client authorized to read the object it's attached to.
   *
   * Warning: never store sensitive information, including financial data such as credit card details.
   */
  metadata?: InputMaybe<Array<MetadataInput>>;
  /** A note about the user. */
  note?: InputMaybe<Scalars['String']['input']>;
  /**
   * Fields required to update the user private metadata. Requires permissions to modify and to read the metadata of the object it's attached to.
   *
   * Warning: never store sensitive information, including financial data such as credit card details.
   */
  privateMetadata?: InputMaybe<Array<MetadataInput>>;
  /** URL of a view where users should be redirected to set the password. URL in RFC 1808 format. */
  redirectUrl?: InputMaybe<Scalars['String']['input']>;
};

export type UserOrApp = App | User;

/** Represents user's permissions. */
export type UserPermission = {
  __typename?: 'UserPermission';
  /** Internal code for permission. */
  code: PermissionEnum;
  /** Describe action(s) allowed to do by permission. */
  name: Scalars['String']['output'];
  /** List of user permission groups which contains this permission. */
  sourcePermissionGroups?: Maybe<Array<Group>>;
};


/** Represents user's permissions. */
export type UserPermissionSourcePermissionGroupsArgs = {
  userId: Scalars['ID']['input'];
};

export type UserSortField =
  /** Sort users by created at. */
  | 'CREATED_AT'
  /** Sort users by email. */
  | 'EMAIL'
  /** Sort users by first name. */
  | 'FIRST_NAME'
  /** Sort users by last modified at. */
  | 'LAST_MODIFIED_AT'
  /** Sort users by last name. */
  | 'LAST_NAME'
  /** Sort users by order count. */
  | 'ORDER_COUNT';

export type UserSortingInput = {
  /** Specifies the direction in which to sort users. */
  direction: OrderDirection;
  /** Sort users by the selected field. */
  field: UserSortField;
};

/** Represents a VAT rate for a country. */
export type Vat = {
  __typename?: 'VAT';
  /** Country code. */
  countryCode: Scalars['String']['output'];
  /** Country's VAT rate exceptions for specific types of goods. */
  reducedRates: Array<ReducedRate>;
  /** Standard VAT rate in percent. */
  standardRate?: Maybe<Scalars['Float']['output']>;
};

export type VariantAttributeScope =
  | 'ALL'
  | 'NOT_VARIANT_SELECTION'
  | 'VARIANT_SELECTION';

/**
 * Assign an media to a product variant.
 *
 * Requires one of the following permissions: MANAGE_PRODUCTS.
 */
export type VariantMediaAssign = {
  __typename?: 'VariantMediaAssign';
  errors: Array<ProductError>;
  media?: Maybe<ProductMedia>;
  /** @deprecated Use `errors` field instead. */
  productErrors: Array<ProductError>;
  productVariant?: Maybe<ProductVariant>;
};

/**
 * Unassign an media from a product variant.
 *
 * Requires one of the following permissions: MANAGE_PRODUCTS.
 */
export type VariantMediaUnassign = {
  __typename?: 'VariantMediaUnassign';
  errors: Array<ProductError>;
  media?: Maybe<ProductMedia>;
  /** @deprecated Use `errors` field instead. */
  productErrors: Array<ProductError>;
  productVariant?: Maybe<ProductVariant>;
};

/** Represents availability of a variant in the storefront. */
export type VariantPricingInfo = {
  __typename?: 'VariantPricingInfo';
  /** The discount amount if in sale (null otherwise). */
  discount?: Maybe<TaxedMoney>;
  /**
   * The discount amount in the local currency.
   * @deprecated Always returns `null`.
   */
  discountLocalCurrency?: Maybe<TaxedMoney>;
  /**
   * The discount amount compared to prior price. Null if product is not on sale or prior price was not provided in VariantChannelListing
   *
   * Added in Saleor 3.21.
   */
  discountPrior?: Maybe<TaxedMoney>;
  /** Whether it is in sale or not. */
  onSale?: Maybe<Scalars['Boolean']['output']>;
  /** The price, with any discount subtracted. */
  price?: Maybe<TaxedMoney>;
  /**
   * The discounted price in the local currency.
   * @deprecated Always returns `null`.
   */
  priceLocalCurrency?: Maybe<TaxedMoney>;
  /**
   * The price prior to discount.
   *
   * Added in Saleor 3.21.
   */
  pricePrior?: Maybe<TaxedMoney>;
  /** The price without any discount. */
  priceUndiscounted?: Maybe<TaxedMoney>;
};

/** Verify JWT token. */
export type VerifyToken = {
  __typename?: 'VerifyToken';
  /** @deprecated Use `errors` field instead. */
  accountErrors: Array<AccountError>;
  errors: Array<AccountError>;
  /** Determine if token is valid or not. */
  isValid: Scalars['Boolean']['output'];
  /** JWT payload. */
  payload?: Maybe<Scalars['GenericScalar']['output']>;
  /** User assigned to token. */
  user?: Maybe<User>;
};

export type VolumeUnitsEnum =
  | 'ACRE_FT'
  | 'ACRE_IN'
  | 'CUBIC_CENTIMETER'
  | 'CUBIC_DECIMETER'
  | 'CUBIC_FOOT'
  | 'CUBIC_INCH'
  | 'CUBIC_METER'
  | 'CUBIC_MILLIMETER'
  | 'CUBIC_YARD'
  | 'FL_OZ'
  | 'LITER'
  | 'PINT'
  | 'QT';

/** Vouchers allow giving discounts to particular customers on categories, collections or specific products. They can be used during checkout by providing valid voucher codes. */
export type Voucher = Node & ObjectWithMetadata & {
  __typename?: 'Voucher';
  /** Determine if the voucher usage should be limited to one use per customer. */
  applyOncePerCustomer: Scalars['Boolean']['output'];
  /** Determine if the voucher should be applied once per order. If set to True, the voucher is applied to a single cheapest eligible product in checkout. */
  applyOncePerOrder: Scalars['Boolean']['output'];
  /** List of categories this voucher applies to. */
  categories?: Maybe<CategoryCountableConnection>;
  /**
   * List of availability in channels for the voucher.
   *
   * Requires one of the following permissions: MANAGE_DISCOUNTS.
   */
  channelListings?: Maybe<Array<VoucherChannelListing>>;
  /**
   * The code of the voucher.
   *
   * DEPRECATED: this field will be removed.
   */
  code?: Maybe<Scalars['String']['output']>;
  /**
   * List of codes available for this voucher.
   *
   * Added in Saleor 3.18.
   */
  codes?: Maybe<VoucherCodeCountableConnection>;
  /**
   * List of collections this voucher applies to.
   *
   * Requires one of the following permissions: MANAGE_DISCOUNTS.
   */
  collections?: Maybe<CollectionCountableConnection>;
  /** List of countries available for the shipping voucher. */
  countries?: Maybe<Array<CountryDisplay>>;
  /** Currency code for voucher. */
  currency?: Maybe<Scalars['String']['output']>;
  /** Voucher value. */
  discountValue?: Maybe<Scalars['Float']['output']>;
  /** Determines a type of discount for voucher - value or percentage */
  discountValueType: DiscountValueTypeEnum;
  /** The end date and time of voucher. */
  endDate?: Maybe<Scalars['DateTime']['output']>;
  /** The ID of the voucher. */
  id: Scalars['ID']['output'];
  /** List of public metadata items. Can be accessed without permissions. */
  metadata: Array<MetadataItem>;
  /**
   * A single key from public metadata.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   */
  metafield?: Maybe<Scalars['String']['output']>;
  /** Public metadata. Use `keys` to control which fields you want to include. The default is to include everything. */
  metafields?: Maybe<Scalars['Metadata']['output']>;
  /** Determine minimum quantity of items for checkout. */
  minCheckoutItemsQuantity?: Maybe<Scalars['Int']['output']>;
  /** Minimum order value to apply voucher. */
  minSpent?: Maybe<Money>;
  /** The name of the voucher. */
  name?: Maybe<Scalars['String']['output']>;
  /** Determine if the voucher is available only for staff members. */
  onlyForStaff: Scalars['Boolean']['output'];
  /** List of private metadata items. Requires staff permissions to access. */
  privateMetadata: Array<MetadataItem>;
  /**
   * A single key from private metadata. Requires staff permissions to access.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   */
  privateMetafield?: Maybe<Scalars['String']['output']>;
  /** Private metadata. Requires staff permissions to access. Use `keys` to control which fields you want to include. The default is to include everything. */
  privateMetafields?: Maybe<Scalars['Metadata']['output']>;
  /**
   * List of products this voucher applies to.
   *
   * Requires one of the following permissions: MANAGE_DISCOUNTS.
   */
  products?: Maybe<ProductCountableConnection>;
  /**
   * Determine if the voucher codes can be used once or multiple times.
   *
   * Added in Saleor 3.18.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  singleUse: Scalars['Boolean']['output'];
  /** The start date and time of voucher. */
  startDate: Scalars['DateTime']['output'];
  /** Returns translated voucher fields for the given language code. */
  translation?: Maybe<VoucherTranslation>;
  /** Determines a type of voucher. */
  type: VoucherTypeEnum;
  /** The number of times a voucher can be used. */
  usageLimit?: Maybe<Scalars['Int']['output']>;
  /** Usage count of the voucher. */
  used: Scalars['Int']['output'];
  /**
   * List of product variants this voucher applies to.
   *
   * Requires one of the following permissions: MANAGE_DISCOUNTS.
   */
  variants?: Maybe<ProductVariantCountableConnection>;
};


/** Vouchers allow giving discounts to particular customers on categories, collections or specific products. They can be used during checkout by providing valid voucher codes. */
export type VoucherCategoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Vouchers allow giving discounts to particular customers on categories, collections or specific products. They can be used during checkout by providing valid voucher codes. */
export type VoucherCodesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Vouchers allow giving discounts to particular customers on categories, collections or specific products. They can be used during checkout by providing valid voucher codes. */
export type VoucherCollectionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Vouchers allow giving discounts to particular customers on categories, collections or specific products. They can be used during checkout by providing valid voucher codes. */
export type VoucherMetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Vouchers allow giving discounts to particular customers on categories, collections or specific products. They can be used during checkout by providing valid voucher codes. */
export type VoucherMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Vouchers allow giving discounts to particular customers on categories, collections or specific products. They can be used during checkout by providing valid voucher codes. */
export type VoucherPrivateMetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Vouchers allow giving discounts to particular customers on categories, collections or specific products. They can be used during checkout by providing valid voucher codes. */
export type VoucherPrivateMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Vouchers allow giving discounts to particular customers on categories, collections or specific products. They can be used during checkout by providing valid voucher codes. */
export type VoucherProductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Vouchers allow giving discounts to particular customers on categories, collections or specific products. They can be used during checkout by providing valid voucher codes. */
export type VoucherTranslationArgs = {
  languageCode: LanguageCodeEnum;
};


/** Vouchers allow giving discounts to particular customers on categories, collections or specific products. They can be used during checkout by providing valid voucher codes. */
export type VoucherVariantsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * Adds products, categories, collections to a voucher.
 *
 * Requires one of the following permissions: MANAGE_DISCOUNTS.
 *
 * Triggers the following webhook events:
 * - VOUCHER_UPDATED (async): A voucher was updated.
 */
export type VoucherAddCatalogues = {
  __typename?: 'VoucherAddCatalogues';
  /** @deprecated Use `errors` field instead. */
  discountErrors: Array<DiscountError>;
  errors: Array<DiscountError>;
  /** Voucher of which catalogue IDs will be modified. */
  voucher?: Maybe<Voucher>;
};

/**
 * Deletes vouchers.
 *
 * Requires one of the following permissions: MANAGE_DISCOUNTS.
 *
 * Triggers the following webhook events:
 * - VOUCHER_DELETED (async): A voucher was deleted.
 */
export type VoucherBulkDelete = {
  __typename?: 'VoucherBulkDelete';
  /** Returns how many objects were affected. */
  count: Scalars['Int']['output'];
  /** @deprecated Use `errors` field instead. */
  discountErrors: Array<DiscountError>;
  errors: Array<DiscountError>;
};

/** Represents voucher channel listing. */
export type VoucherChannelListing = Node & {
  __typename?: 'VoucherChannelListing';
  /** The channel in which voucher can be applied. */
  channel: Channel;
  /** Currency code for voucher in a channel. */
  currency: Scalars['String']['output'];
  /** The value of the discount on voucher in a channel. */
  discountValue: Scalars['Float']['output'];
  /** The ID of channel listing. */
  id: Scalars['ID']['output'];
  /** Minimum order value for voucher to apply in channel. */
  minSpent?: Maybe<Money>;
};

export type VoucherChannelListingAddInput = {
  /** ID of a channel. */
  channelId: Scalars['ID']['input'];
  /** Value of the voucher. */
  discountValue?: InputMaybe<Scalars['PositiveDecimal']['input']>;
  /** Min purchase amount required to apply the voucher. */
  minAmountSpent?: InputMaybe<Scalars['PositiveDecimal']['input']>;
};

export type VoucherChannelListingInput = {
  /** List of channels to which the voucher should be assigned. */
  addChannels?: InputMaybe<Array<VoucherChannelListingAddInput>>;
  /** List of channels from which the voucher should be unassigned. */
  removeChannels?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * Manage voucher's availability in channels.
 *
 * Requires one of the following permissions: MANAGE_DISCOUNTS.
 *
 * Triggers the following webhook events:
 * - VOUCHER_UPDATED (async): A voucher was updated.
 */
export type VoucherChannelListingUpdate = {
  __typename?: 'VoucherChannelListingUpdate';
  /** @deprecated Use `errors` field instead. */
  discountErrors: Array<DiscountError>;
  errors: Array<DiscountError>;
  /** An updated voucher instance. */
  voucher?: Maybe<Voucher>;
};

/**
 * Represents voucher code.
 *
 * Added in Saleor 3.18.
 *
 * Note: this API is currently in Feature Preview and can be subject to changes at later point.
 */
export type VoucherCode = {
  __typename?: 'VoucherCode';
  /** Code to use the voucher. */
  code?: Maybe<Scalars['String']['output']>;
  /** Date time of code creation. */
  createdAt: Scalars['DateTime']['output'];
  /** The ID of the voucher code. */
  id: Scalars['ID']['output'];
  /** Whether a code is active or not. */
  isActive?: Maybe<Scalars['Boolean']['output']>;
  /** Number of times a code has been used. */
  used?: Maybe<Scalars['Int']['output']>;
};

/**
 * Deletes voucher codes.
 *
 * Added in Saleor 3.18.
 *
 * Requires one of the following permissions: MANAGE_DISCOUNTS.
 *
 * Triggers the following webhook events:
 * - VOUCHER_CODES_DELETED (async): A voucher codes were deleted.
 */
export type VoucherCodeBulkDelete = {
  __typename?: 'VoucherCodeBulkDelete';
  /** Returns how many codes were deleted. */
  count: Scalars['Int']['output'];
  errors: Array<VoucherCodeBulkDeleteError>;
};

export type VoucherCodeBulkDeleteError = {
  __typename?: 'VoucherCodeBulkDeleteError';
  /** The error code. */
  code: VoucherCodeBulkDeleteErrorCode;
  /** The error message. */
  message?: Maybe<Scalars['String']['output']>;
  /** Path to field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  path?: Maybe<Scalars['String']['output']>;
  /** List of voucher codes which causes the error. */
  voucherCodes?: Maybe<Array<Scalars['ID']['output']>>;
};

export type VoucherCodeBulkDeleteErrorCode =
  | 'GRAPHQL_ERROR'
  | 'INVALID'
  | 'NOT_FOUND';

export type VoucherCodeCountableConnection = {
  __typename?: 'VoucherCodeCountableConnection';
  edges: Array<VoucherCodeCountableEdge>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** A total count of items in the collection. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type VoucherCodeCountableEdge = {
  __typename?: 'VoucherCodeCountableEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: VoucherCode;
};

/**
 * Event sent when voucher code export is completed.
 *
 * Added in Saleor 3.18.
 */
export type VoucherCodeExportCompleted = Event & {
  __typename?: 'VoucherCodeExportCompleted';
  /** The export file for voucher codes. */
  export?: Maybe<ExportFile>;
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<IssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient?: Maybe<App>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
};

/**
 * Event sent when new voucher codes were created.
 *
 * Added in Saleor 3.19.
 */
export type VoucherCodesCreated = Event & {
  __typename?: 'VoucherCodesCreated';
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<IssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient?: Maybe<App>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
  /** The voucher codes the event relates to. */
  voucherCodes?: Maybe<Array<VoucherCode>>;
};

/**
 * Event sent when voucher codes were deleted.
 *
 * Added in Saleor 3.19.
 */
export type VoucherCodesDeleted = Event & {
  __typename?: 'VoucherCodesDeleted';
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<IssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient?: Maybe<App>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
  /** The voucher codes the event relates to. */
  voucherCodes?: Maybe<Array<VoucherCode>>;
};

export type VoucherCountableConnection = {
  __typename?: 'VoucherCountableConnection';
  edges: Array<VoucherCountableEdge>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** A total count of items in the collection. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type VoucherCountableEdge = {
  __typename?: 'VoucherCountableEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Voucher;
};

/**
 * Creates a new voucher.
 *
 * Requires one of the following permissions: MANAGE_DISCOUNTS.
 *
 * Triggers the following webhook events:
 * - VOUCHER_CREATED (async): A voucher was created.
 * - VOUCHER_CODES_CREATED (async): A voucher codes were created.
 */
export type VoucherCreate = {
  __typename?: 'VoucherCreate';
  /** @deprecated Use `errors` field instead. */
  discountErrors: Array<DiscountError>;
  errors: Array<DiscountError>;
  voucher?: Maybe<Voucher>;
};

/** Event sent when new voucher is created. */
export type VoucherCreated = Event & {
  __typename?: 'VoucherCreated';
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<IssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient?: Maybe<App>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
  /** The voucher the event relates to. */
  voucher?: Maybe<Voucher>;
};


/** Event sent when new voucher is created. */
export type VoucherCreatedVoucherArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Deletes a voucher.
 *
 * Requires one of the following permissions: MANAGE_DISCOUNTS.
 *
 * Triggers the following webhook events:
 * - VOUCHER_DELETED (async): A voucher was deleted.
 */
export type VoucherDelete = {
  __typename?: 'VoucherDelete';
  /** @deprecated Use `errors` field instead. */
  discountErrors: Array<DiscountError>;
  errors: Array<DiscountError>;
  voucher?: Maybe<Voucher>;
};

/** Event sent when voucher is deleted. */
export type VoucherDeleted = Event & {
  __typename?: 'VoucherDeleted';
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<IssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient?: Maybe<App>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
  /** The voucher the event relates to. */
  voucher?: Maybe<Voucher>;
};


/** Event sent when voucher is deleted. */
export type VoucherDeletedVoucherArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
};

export type VoucherDiscountType =
  | 'FIXED'
  | 'PERCENTAGE'
  | 'SHIPPING';

export type VoucherFilterInput = {
  discountType?: InputMaybe<Array<VoucherDiscountType>>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  metadata?: InputMaybe<Array<MetadataFilter>>;
  search?: InputMaybe<Scalars['String']['input']>;
  started?: InputMaybe<DateTimeRangeInput>;
  status?: InputMaybe<Array<DiscountStatusEnum>>;
  timesUsed?: InputMaybe<IntRangeInput>;
};

export type VoucherInput = {
  /**
   * List of codes to add.
   *
   * Added in Saleor 3.18.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  addCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Voucher should be applied once per customer. */
  applyOncePerCustomer?: InputMaybe<Scalars['Boolean']['input']>;
  /** Voucher should be applied to the cheapest item or entire order. */
  applyOncePerOrder?: InputMaybe<Scalars['Boolean']['input']>;
  /** Categories discounted by the voucher. */
  categories?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**
   * Code to use the voucher.
   *
   * DEPRECATED: this field will be removed. Use `addCodes` instead.
   */
  code?: InputMaybe<Scalars['String']['input']>;
  /** Collections discounted by the voucher. */
  collections?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Country codes that can be used with the shipping voucher. */
  countries?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Choices: fixed or percentage. */
  discountValueType?: InputMaybe<DiscountValueTypeEnum>;
  /** End date of the voucher in ISO 8601 format. */
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Minimal quantity of checkout items required to apply the voucher. */
  minCheckoutItemsQuantity?: InputMaybe<Scalars['Int']['input']>;
  /** Voucher name. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Voucher can be used only by staff user. */
  onlyForStaff?: InputMaybe<Scalars['Boolean']['input']>;
  /** Products discounted by the voucher. */
  products?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**
   * When set to 'True', each voucher code can be used only once; otherwise, codes can be used multiple times depending on `usageLimit`.
   *
   * The option can only be changed if none of the voucher codes have been used.
   *
   * Added in Saleor 3.18.
   *
   * Note: this API is currently in Feature Preview and can be subject to changes at later point.
   */
  singleUse?: InputMaybe<Scalars['Boolean']['input']>;
  /** Start date of the voucher in ISO 8601 format. */
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Voucher type: PRODUCT, CATEGORY SHIPPING or ENTIRE_ORDER. */
  type?: InputMaybe<VoucherTypeEnum>;
  /** Limit number of times this voucher can be used in total. */
  usageLimit?: InputMaybe<Scalars['Int']['input']>;
  /** Variants discounted by the voucher. */
  variants?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** Event sent when voucher metadata is updated. */
export type VoucherMetadataUpdated = Event & {
  __typename?: 'VoucherMetadataUpdated';
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<IssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient?: Maybe<App>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
  /** The voucher the event relates to. */
  voucher?: Maybe<Voucher>;
};


/** Event sent when voucher metadata is updated. */
export type VoucherMetadataUpdatedVoucherArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Removes products, categories, collections from a voucher.
 *
 * Requires one of the following permissions: MANAGE_DISCOUNTS.
 *
 * Triggers the following webhook events:
 * - VOUCHER_UPDATED (async): A voucher was updated.
 */
export type VoucherRemoveCatalogues = {
  __typename?: 'VoucherRemoveCatalogues';
  /** @deprecated Use `errors` field instead. */
  discountErrors: Array<DiscountError>;
  errors: Array<DiscountError>;
  /** Voucher of which catalogue IDs will be modified. */
  voucher?: Maybe<Voucher>;
};

export type VoucherSortField =
  /** Sort vouchers by code. */
  | 'CODE'
  /** Sort vouchers by end date. */
  | 'END_DATE'
  /**
   * Sort vouchers by minimum spent amount.
   *
   * This option requires a channel filter to work as the values can vary between channels.
   */
  | 'MINIMUM_SPENT_AMOUNT'
  /**
   * Sort vouchers by name.
   *
   * Added in Saleor 3.18.
   */
  | 'NAME'
  /** Sort vouchers by start date. */
  | 'START_DATE'
  /** Sort vouchers by type. */
  | 'TYPE'
  /** Sort vouchers by usage limit. */
  | 'USAGE_LIMIT'
  /**
   * Sort vouchers by value.
   *
   * This option requires a channel filter to work as the values can vary between channels.
   */
  | 'VALUE';

export type VoucherSortingInput = {
  /**
   * Specifies the channel in which to sort the data.
   *
   * DEPRECATED: this field will be removed. Use root-level channel argument instead.
   */
  channel?: InputMaybe<Scalars['String']['input']>;
  /** Specifies the direction in which to sort vouchers. */
  direction: OrderDirection;
  /** Sort vouchers by the selected field. */
  field: VoucherSortField;
};

/** Represents voucher's original translatable fields and related translations. */
export type VoucherTranslatableContent = Node & {
  __typename?: 'VoucherTranslatableContent';
  /** The ID of the voucher translatable content. */
  id: Scalars['ID']['output'];
  /** Voucher name to translate. */
  name?: Maybe<Scalars['String']['output']>;
  /** Returns translated voucher fields for the given language code. */
  translation?: Maybe<VoucherTranslation>;
  /**
   * Vouchers allow giving discounts to particular customers on categories, collections or specific products. They can be used during checkout by providing valid voucher codes.
   *
   * Requires one of the following permissions: MANAGE_DISCOUNTS.
   * @deprecated Get model fields from the root level queries.
   */
  voucher?: Maybe<Voucher>;
  /** The ID of the voucher to translate. */
  voucherId: Scalars['ID']['output'];
};


/** Represents voucher's original translatable fields and related translations. */
export type VoucherTranslatableContentTranslationArgs = {
  languageCode: LanguageCodeEnum;
};

/**
 * Creates/updates translations for a voucher.
 *
 * Requires one of the following permissions: MANAGE_TRANSLATIONS.
 */
export type VoucherTranslate = {
  __typename?: 'VoucherTranslate';
  errors: Array<TranslationError>;
  /** @deprecated Use `errors` field instead. */
  translationErrors: Array<TranslationError>;
  voucher?: Maybe<Voucher>;
};

/** Represents voucher translations. */
export type VoucherTranslation = Node & {
  __typename?: 'VoucherTranslation';
  /** The ID of the voucher translation. */
  id: Scalars['ID']['output'];
  /** Translation language. */
  language: LanguageDisplay;
  /** Translated voucher name. */
  name?: Maybe<Scalars['String']['output']>;
  /** Represents the voucher fields to translate. */
  translatableContent?: Maybe<VoucherTranslatableContent>;
};

export type VoucherTypeEnum =
  | 'ENTIRE_ORDER'
  | 'SHIPPING'
  | 'SPECIFIC_PRODUCT';

/**
 * Updates a voucher.
 *
 * Requires one of the following permissions: MANAGE_DISCOUNTS.
 *
 * Triggers the following webhook events:
 * - VOUCHER_UPDATED (async): A voucher was updated.
 * - VOUCHER_CODES_CREATED (async): A voucher code was created.
 */
export type VoucherUpdate = {
  __typename?: 'VoucherUpdate';
  /** @deprecated Use `errors` field instead. */
  discountErrors: Array<DiscountError>;
  errors: Array<DiscountError>;
  voucher?: Maybe<Voucher>;
};

/** Event sent when voucher is updated. */
export type VoucherUpdated = Event & {
  __typename?: 'VoucherUpdated';
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<IssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient?: Maybe<App>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
  /** The voucher the event relates to. */
  voucher?: Maybe<Voucher>;
};


/** Event sent when voucher is updated. */
export type VoucherUpdatedVoucherArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
};

/** Represents warehouse. */
export type Warehouse = Node & ObjectWithMetadata & {
  __typename?: 'Warehouse';
  /** Address of the warehouse. */
  address: Address;
  /** Click and collect options: local, all or disabled. */
  clickAndCollectOption: WarehouseClickAndCollectOptionEnum;
  /**
   * Warehouse company name.
   * @deprecated Use `Address.companyName` instead.
   */
  companyName: Scalars['String']['output'];
  /** Warehouse email. */
  email: Scalars['String']['output'];
  /** External ID of this warehouse. */
  externalReference?: Maybe<Scalars['String']['output']>;
  /** The ID of the warehouse. */
  id: Scalars['ID']['output'];
  /** Determine if the warehouse is private. */
  isPrivate: Scalars['Boolean']['output'];
  /** List of public metadata items. Can be accessed without permissions. */
  metadata: Array<MetadataItem>;
  /**
   * A single key from public metadata.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   */
  metafield?: Maybe<Scalars['String']['output']>;
  /** Public metadata. Use `keys` to control which fields you want to include. The default is to include everything. */
  metafields?: Maybe<Scalars['Metadata']['output']>;
  /** Warehouse name. */
  name: Scalars['String']['output'];
  /** List of private metadata items. Requires staff permissions to access. */
  privateMetadata: Array<MetadataItem>;
  /**
   * A single key from private metadata. Requires staff permissions to access.
   *
   * Tip: Use GraphQL aliases to fetch multiple keys.
   */
  privateMetafield?: Maybe<Scalars['String']['output']>;
  /** Private metadata. Requires staff permissions to access. Use `keys` to control which fields you want to include. The default is to include everything. */
  privateMetafields?: Maybe<Scalars['Metadata']['output']>;
  /** Shipping zones supported by the warehouse. */
  shippingZones: ShippingZoneCountableConnection;
  /** Warehouse slug. */
  slug: Scalars['String']['output'];
  /**
   * Stocks that belong to this warehouse.
   *
   * Added in Saleor 3.20.
   *
   * Requires one of the following permissions: MANAGE_PRODUCTS, MANAGE_ORDERS.
   */
  stocks?: Maybe<StockCountableConnection>;
};


/** Represents warehouse. */
export type WarehouseMetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Represents warehouse. */
export type WarehouseMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Represents warehouse. */
export type WarehousePrivateMetafieldArgs = {
  key: Scalars['String']['input'];
};


/** Represents warehouse. */
export type WarehousePrivateMetafieldsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Represents warehouse. */
export type WarehouseShippingZonesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Represents warehouse. */
export type WarehouseStocksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type WarehouseClickAndCollectOptionEnum =
  | 'ALL'
  | 'DISABLED'
  | 'LOCAL';

export type WarehouseCountableConnection = {
  __typename?: 'WarehouseCountableConnection';
  edges: Array<WarehouseCountableEdge>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** A total count of items in the collection. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type WarehouseCountableEdge = {
  __typename?: 'WarehouseCountableEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Warehouse;
};

/**
 * Creates a new warehouse.
 *
 * Requires one of the following permissions: MANAGE_PRODUCTS.
 */
export type WarehouseCreate = {
  __typename?: 'WarehouseCreate';
  errors: Array<WarehouseError>;
  warehouse?: Maybe<Warehouse>;
  /** @deprecated Use `errors` field instead. */
  warehouseErrors: Array<WarehouseError>;
};

export type WarehouseCreateInput = {
  /** Address of the warehouse. */
  address: AddressInput;
  /** The email address of the warehouse. */
  email?: InputMaybe<Scalars['String']['input']>;
  /** External ID of the warehouse. */
  externalReference?: InputMaybe<Scalars['String']['input']>;
  /** Warehouse name. */
  name: Scalars['String']['input'];
  /**
   * Shipping zones supported by the warehouse.
   *
   * DEPRECATED: this field will be removed. Providing the zone ids will raise a ValidationError.
   */
  shippingZones?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Warehouse slug. */
  slug?: InputMaybe<Scalars['String']['input']>;
};

/** Event sent when new warehouse is created. */
export type WarehouseCreated = Event & {
  __typename?: 'WarehouseCreated';
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<IssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient?: Maybe<App>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
  /** The warehouse the event relates to. */
  warehouse?: Maybe<Warehouse>;
};

/**
 * Deletes selected warehouse.
 *
 * Requires one of the following permissions: MANAGE_PRODUCTS.
 */
export type WarehouseDelete = {
  __typename?: 'WarehouseDelete';
  errors: Array<WarehouseError>;
  warehouse?: Maybe<Warehouse>;
  /** @deprecated Use `errors` field instead. */
  warehouseErrors: Array<WarehouseError>;
};

/** Event sent when warehouse is deleted. */
export type WarehouseDeleted = Event & {
  __typename?: 'WarehouseDeleted';
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<IssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient?: Maybe<App>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
  /** The warehouse the event relates to. */
  warehouse?: Maybe<Warehouse>;
};

export type WarehouseError = {
  __typename?: 'WarehouseError';
  /** The error code. */
  code: WarehouseErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field?: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message?: Maybe<Scalars['String']['output']>;
  /** List of shipping zones IDs which causes the error. */
  shippingZones?: Maybe<Array<Scalars['ID']['output']>>;
};

export type WarehouseErrorCode =
  | 'ALREADY_EXISTS'
  | 'GRAPHQL_ERROR'
  | 'INVALID'
  | 'NOT_FOUND'
  | 'REQUIRED'
  | 'UNIQUE';

export type WarehouseFilterInput = {
  channels?: InputMaybe<Array<Scalars['ID']['input']>>;
  clickAndCollectOption?: InputMaybe<WarehouseClickAndCollectOptionEnum>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  isPrivate?: InputMaybe<Scalars['Boolean']['input']>;
  metadata?: InputMaybe<Array<MetadataFilter>>;
  search?: InputMaybe<Scalars['String']['input']>;
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Event sent when warehouse metadata is updated. */
export type WarehouseMetadataUpdated = Event & {
  __typename?: 'WarehouseMetadataUpdated';
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<IssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient?: Maybe<App>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
  /** The warehouse the event relates to. */
  warehouse?: Maybe<Warehouse>;
};

/**
 * Add shipping zone to given warehouse.
 *
 * Requires one of the following permissions: MANAGE_PRODUCTS.
 */
export type WarehouseShippingZoneAssign = {
  __typename?: 'WarehouseShippingZoneAssign';
  errors: Array<WarehouseError>;
  warehouse?: Maybe<Warehouse>;
  /** @deprecated Use `errors` field instead. */
  warehouseErrors: Array<WarehouseError>;
};

/**
 * Remove shipping zone from given warehouse.
 *
 * Requires one of the following permissions: MANAGE_PRODUCTS.
 */
export type WarehouseShippingZoneUnassign = {
  __typename?: 'WarehouseShippingZoneUnassign';
  errors: Array<WarehouseError>;
  warehouse?: Maybe<Warehouse>;
  /** @deprecated Use `errors` field instead. */
  warehouseErrors: Array<WarehouseError>;
};

export type WarehouseSortField =
  /** Sort warehouses by name. */
  | 'NAME';

export type WarehouseSortingInput = {
  /** Specifies the direction in which to sort warehouses. */
  direction: OrderDirection;
  /** Sort warehouses by the selected field. */
  field: WarehouseSortField;
};

/**
 * Updates given warehouse.
 *
 * Requires one of the following permissions: MANAGE_PRODUCTS.
 */
export type WarehouseUpdate = {
  __typename?: 'WarehouseUpdate';
  errors: Array<WarehouseError>;
  warehouse?: Maybe<Warehouse>;
  /** @deprecated Use `errors` field instead. */
  warehouseErrors: Array<WarehouseError>;
};

export type WarehouseUpdateInput = {
  /** Address of the warehouse. */
  address?: InputMaybe<AddressInput>;
  /** Click and collect options: local, all or disabled. */
  clickAndCollectOption?: InputMaybe<WarehouseClickAndCollectOptionEnum>;
  /** The email address of the warehouse. */
  email?: InputMaybe<Scalars['String']['input']>;
  /** External ID of the warehouse. */
  externalReference?: InputMaybe<Scalars['String']['input']>;
  /** Visibility of warehouse stocks. */
  isPrivate?: InputMaybe<Scalars['Boolean']['input']>;
  /** Warehouse name. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Warehouse slug. */
  slug?: InputMaybe<Scalars['String']['input']>;
};

/** Event sent when warehouse is updated. */
export type WarehouseUpdated = Event & {
  __typename?: 'WarehouseUpdated';
  /** Time of the event. */
  issuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user or application that triggered the event. */
  issuingPrincipal?: Maybe<IssuingPrincipal>;
  /** The application receiving the webhook. */
  recipient?: Maybe<App>;
  /** Saleor version that triggered the event. */
  version?: Maybe<Scalars['String']['output']>;
  /** The warehouse the event relates to. */
  warehouse?: Maybe<Warehouse>;
};

/** Webhook. */
export type Webhook = Node & {
  __typename?: 'Webhook';
  /** The app associated with Webhook. */
  app: App;
  /** List of asynchronous webhook events. */
  asyncEvents: Array<WebhookEventAsync>;
  /** Custom headers, which will be added to HTTP request. */
  customHeaders?: Maybe<Scalars['JSONString']['output']>;
  /** Event deliveries. */
  eventDeliveries?: Maybe<EventDeliveryCountableConnection>;
  /**
   * List of webhook events.
   * @deprecated Use `asyncEvents` or `syncEvents` instead.
   */
  events: Array<WebhookEvent>;
  /** The ID of webhook. */
  id: Scalars['ID']['output'];
  /** Informs if webhook is activated. */
  isActive: Scalars['Boolean']['output'];
  /** The name of webhook. */
  name?: Maybe<Scalars['String']['output']>;
  /**
   * Used to create a hash signature for each payload.
   * @deprecated As of Saleor 3.5, webhook payloads default to signing using a verifiable JWS.
   */
  secretKey?: Maybe<Scalars['String']['output']>;
  /** Used to define payloads for specific events. */
  subscriptionQuery?: Maybe<Scalars['String']['output']>;
  /** List of synchronous webhook events. */
  syncEvents: Array<WebhookEventSync>;
  /** Target URL for webhook. */
  targetUrl: Scalars['String']['output'];
};


/** Webhook. */
export type WebhookEventDeliveriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<EventDeliveryFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<EventDeliverySortingInput>;
};

/**
 * Creates a new webhook subscription.
 *
 * Requires one of the following permissions: MANAGE_APPS, AUTHENTICATED_APP.
 */
export type WebhookCreate = {
  __typename?: 'WebhookCreate';
  errors: Array<WebhookError>;
  webhook?: Maybe<Webhook>;
  /** @deprecated Use `errors` field instead. */
  webhookErrors: Array<WebhookError>;
};

export type WebhookCreateInput = {
  /** ID of the app to which webhook belongs. */
  app?: InputMaybe<Scalars['ID']['input']>;
  /** The asynchronous events that webhook wants to subscribe. */
  asyncEvents?: InputMaybe<Array<WebhookEventTypeAsyncEnum>>;
  /** Custom headers, which will be added to HTTP request. There is a limitation of 5 headers per webhook and 998 characters per header.Only `X-*`, `Authorization*`, and `BrokerProperties` keys are allowed. */
  customHeaders?: InputMaybe<Scalars['JSONString']['input']>;
  /**
   * The events that webhook wants to subscribe.
   *
   * DEPRECATED: this field will be removed. Use `asyncEvents` or `syncEvents` instead.
   */
  events?: InputMaybe<Array<WebhookEventTypeEnum>>;
  /** Determine if webhook will be set active or not. */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** The name of the webhook. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Subscription query used to define a webhook payload. */
  query?: InputMaybe<Scalars['String']['input']>;
  /**
   * The secret key used to create a hash signature with each payload.
   *
   * DEPRECATED: this field will be removed. As of Saleor 3.5, webhook payloads default to signing using a verifiable JWS.
   */
  secretKey?: InputMaybe<Scalars['String']['input']>;
  /** The synchronous events that webhook wants to subscribe. */
  syncEvents?: InputMaybe<Array<WebhookEventTypeSyncEnum>>;
  /** The url to receive the payload. */
  targetUrl?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Deletes a webhook. Before the deletion, the webhook is deactivated to pause any deliveries that are already scheduled. The deletion might fail if delivery is in progress. In such a case, the webhook is not deleted but remains deactivated.
 *
 * Requires one of the following permissions: MANAGE_APPS, AUTHENTICATED_APP.
 */
export type WebhookDelete = {
  __typename?: 'WebhookDelete';
  errors: Array<WebhookError>;
  webhook?: Maybe<Webhook>;
  /** @deprecated Use `errors` field instead. */
  webhookErrors: Array<WebhookError>;
};

/**
 * Performs a dry run of a webhook event. Supports a single event (the first, if multiple provided in the `query`). Requires permission relevant to processed event.
 *
 * Requires one of the following permissions: AUTHENTICATED_STAFF_USER.
 */
export type WebhookDryRun = {
  __typename?: 'WebhookDryRun';
  errors: Array<WebhookDryRunError>;
  /** JSON payload, that would be sent out to webhook's target URL. */
  payload?: Maybe<Scalars['JSONString']['output']>;
};

export type WebhookDryRunError = {
  __typename?: 'WebhookDryRunError';
  /** The error code. */
  code: WebhookDryRunErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field?: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message?: Maybe<Scalars['String']['output']>;
};

export type WebhookDryRunErrorCode =
  | 'GRAPHQL_ERROR'
  | 'INVALID_ID'
  | 'MISSING_EVENT'
  | 'MISSING_PERMISSION'
  | 'MISSING_SUBSCRIPTION'
  | 'NOT_FOUND'
  | 'SYNTAX'
  | 'TYPE_NOT_SUPPORTED'
  | 'UNABLE_TO_PARSE';

export type WebhookError = {
  __typename?: 'WebhookError';
  /** The error code. */
  code: WebhookErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field?: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message?: Maybe<Scalars['String']['output']>;
};

export type WebhookErrorCode =
  | 'DELETE_FAILED'
  | 'GRAPHQL_ERROR'
  | 'INVALID'
  | 'INVALID_CUSTOM_HEADERS'
  | 'INVALID_NOTIFY_WITH_SUBSCRIPTION'
  | 'MISSING_EVENT'
  | 'MISSING_SUBSCRIPTION'
  | 'NOT_FOUND'
  | 'REQUIRED'
  | 'SYNTAX'
  | 'UNABLE_TO_PARSE'
  | 'UNIQUE';

/** Webhook event. */
export type WebhookEvent = {
  __typename?: 'WebhookEvent';
  /** Internal name of the event type. */
  eventType: WebhookEventTypeEnum;
  /** Display name of the event. */
  name: Scalars['String']['output'];
};

/** Asynchronous webhook event. */
export type WebhookEventAsync = {
  __typename?: 'WebhookEventAsync';
  /** Internal name of the event type. */
  eventType: WebhookEventTypeAsyncEnum;
  /** Display name of the event. */
  name: Scalars['String']['output'];
};

/** Synchronous webhook event. */
export type WebhookEventSync = {
  __typename?: 'WebhookEventSync';
  /** Internal name of the event type. */
  eventType: WebhookEventTypeSyncEnum;
  /** Display name of the event. */
  name: Scalars['String']['output'];
};

/** Enum determining type of webhook. */
export type WebhookEventTypeAsyncEnum =
  /** An account email change is requested. */
  | 'ACCOUNT_CHANGE_EMAIL_REQUESTED'
  /** An account confirmation is requested. */
  | 'ACCOUNT_CONFIRMATION_REQUESTED'
  /** An account is confirmed. */
  | 'ACCOUNT_CONFIRMED'
  /** An account is deleted. */
  | 'ACCOUNT_DELETED'
  /** An account delete is requested. */
  | 'ACCOUNT_DELETE_REQUESTED'
  /** An account email was changed */
  | 'ACCOUNT_EMAIL_CHANGED'
  /** Setting a new password for the account is requested. */
  | 'ACCOUNT_SET_PASSWORD_REQUESTED'
  /** A new address created. */
  | 'ADDRESS_CREATED'
  /** An address deleted. */
  | 'ADDRESS_DELETED'
  /** An address updated. */
  | 'ADDRESS_UPDATED'
  /** All the events. */
  | 'ANY_EVENTS'
  /** An app deleted. */
  | 'APP_DELETED'
  /** A new app installed. */
  | 'APP_INSTALLED'
  /** An app status is changed. */
  | 'APP_STATUS_CHANGED'
  /** An app updated. */
  | 'APP_UPDATED'
  /** A new attribute is created. */
  | 'ATTRIBUTE_CREATED'
  /** An attribute is deleted. */
  | 'ATTRIBUTE_DELETED'
  /** An attribute is updated. */
  | 'ATTRIBUTE_UPDATED'
  /** A new attribute value is created. */
  | 'ATTRIBUTE_VALUE_CREATED'
  /** An attribute value is deleted. */
  | 'ATTRIBUTE_VALUE_DELETED'
  /** An attribute value is updated. */
  | 'ATTRIBUTE_VALUE_UPDATED'
  /** A new category created. */
  | 'CATEGORY_CREATED'
  /** A category is deleted. */
  | 'CATEGORY_DELETED'
  /** A category is updated. */
  | 'CATEGORY_UPDATED'
  /** A new channel created. */
  | 'CHANNEL_CREATED'
  /** A channel is deleted. */
  | 'CHANNEL_DELETED'
  /** A channel metadata is updated. */
  | 'CHANNEL_METADATA_UPDATED'
  /** A channel status is changed. */
  | 'CHANNEL_STATUS_CHANGED'
  /** A channel is updated. */
  | 'CHANNEL_UPDATED'
  /** A new checkout is created. */
  | 'CHECKOUT_CREATED'
  /**
   * A checkout was fully authorized (its `authorizeStatus` is `FULL`).
   *
   * This event is emitted only for checkouts whose payments are processed through the Transaction API.
   */
  | 'CHECKOUT_FULLY_AUTHORIZED'
  /**
   * A checkout was fully paid (its `chargeStatus` is `FULL` or `OVERCHARGED`). This event is not sent if payments are only authorized but not fully charged.
   *
   * This event is emitted only for checkouts whose payments are processed through the Transaction API.
   */
  | 'CHECKOUT_FULLY_PAID'
  /** A checkout metadata is updated. */
  | 'CHECKOUT_METADATA_UPDATED'
  /** A checkout is updated. It also triggers all updates related to the checkout. */
  | 'CHECKOUT_UPDATED'
  /** A new collection is created. */
  | 'COLLECTION_CREATED'
  /** A collection is deleted. */
  | 'COLLECTION_DELETED'
  /** A collection metadata is updated. */
  | 'COLLECTION_METADATA_UPDATED'
  /** A collection is updated. */
  | 'COLLECTION_UPDATED'
  /** A new customer account is created. */
  | 'CUSTOMER_CREATED'
  /** A customer account is deleted. */
  | 'CUSTOMER_DELETED'
  /** A customer account metadata is updated. */
  | 'CUSTOMER_METADATA_UPDATED'
  /** A customer account is updated. */
  | 'CUSTOMER_UPDATED'
  /** A draft order is created. */
  | 'DRAFT_ORDER_CREATED'
  /** A draft order is deleted. */
  | 'DRAFT_ORDER_DELETED'
  /** A draft order is updated. */
  | 'DRAFT_ORDER_UPDATED'
  /** A fulfillment is approved. */
  | 'FULFILLMENT_APPROVED'
  /** A fulfillment is cancelled. */
  | 'FULFILLMENT_CANCELED'
  /** A new fulfillment is created. */
  | 'FULFILLMENT_CREATED'
  /** A fulfillment metadata is updated. */
  | 'FULFILLMENT_METADATA_UPDATED'
  | 'FULFILLMENT_TRACKING_NUMBER_UPDATED'
  /** A new gift card created. */
  | 'GIFT_CARD_CREATED'
  /** A gift card is deleted. */
  | 'GIFT_CARD_DELETED'
  /** A gift card export is completed. */
  | 'GIFT_CARD_EXPORT_COMPLETED'
  /** A gift card metadata is updated. */
  | 'GIFT_CARD_METADATA_UPDATED'
  /** A gift card has been sent. */
  | 'GIFT_CARD_SENT'
  /** A gift card status is changed. */
  | 'GIFT_CARD_STATUS_CHANGED'
  /** A gift card is updated. */
  | 'GIFT_CARD_UPDATED'
  /** An invoice is deleted. */
  | 'INVOICE_DELETED'
  /** An invoice for order requested. */
  | 'INVOICE_REQUESTED'
  /** Invoice has been sent. */
  | 'INVOICE_SENT'
  /** A new menu created. */
  | 'MENU_CREATED'
  /** A menu is deleted. */
  | 'MENU_DELETED'
  /** A new menu item created. */
  | 'MENU_ITEM_CREATED'
  /** A menu item is deleted. */
  | 'MENU_ITEM_DELETED'
  /** A menu item is updated. */
  | 'MENU_ITEM_UPDATED'
  /** A menu is updated. */
  | 'MENU_UPDATED'
  /** User notification triggered. */
  | 'NOTIFY_USER'
  /** An observability event is created. */
  | 'OBSERVABILITY'
  /** Orders are imported. */
  | 'ORDER_BULK_CREATED'
  /** An order is cancelled. */
  | 'ORDER_CANCELLED'
  /** An order is confirmed (status change unconfirmed -> unfulfilled) by a staff user using the OrderConfirm mutation. It also triggers when the user completes the checkout and the shop setting `automatically_confirm_all_new_orders` is enabled. */
  | 'ORDER_CONFIRMED'
  /** A new order is placed. */
  | 'ORDER_CREATED'
  /** An order is expired. */
  | 'ORDER_EXPIRED'
  /** An order is fulfilled. */
  | 'ORDER_FULFILLED'
  /** Payment is made and an order is fully paid. */
  | 'ORDER_FULLY_PAID'
  /** The order is fully refunded. */
  | 'ORDER_FULLY_REFUNDED'
  /** An order metadata is updated. */
  | 'ORDER_METADATA_UPDATED'
  /** Payment has been made. The order may be partially or fully paid. */
  | 'ORDER_PAID'
  /** The order received a refund. The order may be partially or fully refunded. */
  | 'ORDER_REFUNDED'
  /** An order is updated; triggered for all changes related to an order; covers all other order webhooks, except for ORDER_CREATED. */
  | 'ORDER_UPDATED'
  /** A new page is created. */
  | 'PAGE_CREATED'
  /** A page is deleted. */
  | 'PAGE_DELETED'
  /** A new page type is created. */
  | 'PAGE_TYPE_CREATED'
  /** A page type is deleted. */
  | 'PAGE_TYPE_DELETED'
  /** A page type is updated. */
  | 'PAGE_TYPE_UPDATED'
  /** A page is updated. */
  | 'PAGE_UPDATED'
  /** A new permission group is created. */
  | 'PERMISSION_GROUP_CREATED'
  /** A permission group is deleted. */
  | 'PERMISSION_GROUP_DELETED'
  /** A permission group is updated. */
  | 'PERMISSION_GROUP_UPDATED'
  /** A new product is created. */
  | 'PRODUCT_CREATED'
  /** A product is deleted. */
  | 'PRODUCT_DELETED'
  /** A product export is completed. */
  | 'PRODUCT_EXPORT_COMPLETED'
  /** A new product media is created. */
  | 'PRODUCT_MEDIA_CREATED'
  /** A product media is deleted. */
  | 'PRODUCT_MEDIA_DELETED'
  /** A product media is updated. */
  | 'PRODUCT_MEDIA_UPDATED'
  /** A product metadata is updated. */
  | 'PRODUCT_METADATA_UPDATED'
  /** A product is updated. */
  | 'PRODUCT_UPDATED'
  /** A product variant is back in stock. */
  | 'PRODUCT_VARIANT_BACK_IN_STOCK'
  /** A new product variant is created. */
  | 'PRODUCT_VARIANT_CREATED'
  /** A product variant is deleted. Warning: this event will not be executed when parent product has been deleted. Check PRODUCT_DELETED. */
  | 'PRODUCT_VARIANT_DELETED'
  | 'PRODUCT_VARIANT_DISCOUNTED_PRICE_UPDATED'
  /** A product variant metadata is updated. */
  | 'PRODUCT_VARIANT_METADATA_UPDATED'
  /** A product variant is out of stock. */
  | 'PRODUCT_VARIANT_OUT_OF_STOCK'
  /** A product variant stock is updated */
  | 'PRODUCT_VARIANT_STOCK_UPDATED'
  /** A product variant is updated. */
  | 'PRODUCT_VARIANT_UPDATED'
  /** A promotion is created. */
  | 'PROMOTION_CREATED'
  /** A promotion is deleted. */
  | 'PROMOTION_DELETED'
  /** A promotion is deactivated. */
  | 'PROMOTION_ENDED'
  /** A promotion rule is created. */
  | 'PROMOTION_RULE_CREATED'
  /** A promotion rule is deleted. */
  | 'PROMOTION_RULE_DELETED'
  /** A promotion rule is updated. */
  | 'PROMOTION_RULE_UPDATED'
  /** A promotion is activated. */
  | 'PROMOTION_STARTED'
  /** A promotion is updated. */
  | 'PROMOTION_UPDATED'
  /** A sale is created. */
  | 'SALE_CREATED'
  /** A sale is deleted. */
  | 'SALE_DELETED'
  /** A sale is activated or deactivated. */
  | 'SALE_TOGGLE'
  /** A sale is updated. */
  | 'SALE_UPDATED'
  /** A new shipping price is created. */
  | 'SHIPPING_PRICE_CREATED'
  /** A shipping price is deleted. */
  | 'SHIPPING_PRICE_DELETED'
  /** A shipping price is updated. */
  | 'SHIPPING_PRICE_UPDATED'
  /** A new shipping zone is created. */
  | 'SHIPPING_ZONE_CREATED'
  /** A shipping zone is deleted. */
  | 'SHIPPING_ZONE_DELETED'
  /** A shipping zone metadata is updated. */
  | 'SHIPPING_ZONE_METADATA_UPDATED'
  /** A shipping zone is updated. */
  | 'SHIPPING_ZONE_UPDATED'
  /** Shop metadata is updated. */
  | 'SHOP_METADATA_UPDATED'
  /** A new staff user is created. */
  | 'STAFF_CREATED'
  /** A staff user is deleted. */
  | 'STAFF_DELETED'
  /** Setting a new password for the staff account is requested. */
  | 'STAFF_SET_PASSWORD_REQUESTED'
  /** A staff user is updated. */
  | 'STAFF_UPDATED'
  /** A thumbnail is created. */
  | 'THUMBNAIL_CREATED'
  /** Transaction item metadata is updated. */
  | 'TRANSACTION_ITEM_METADATA_UPDATED'
  /** A new translation is created. */
  | 'TRANSLATION_CREATED'
  /** A translation is updated. */
  | 'TRANSLATION_UPDATED'
  | 'VOUCHER_CODES_CREATED'
  | 'VOUCHER_CODES_DELETED'
  /**
   * A voucher code export is completed.
   *
   * Added in Saleor 3.18.
   */
  | 'VOUCHER_CODE_EXPORT_COMPLETED'
  /** A new voucher created. */
  | 'VOUCHER_CREATED'
  /** A voucher is deleted. */
  | 'VOUCHER_DELETED'
  /** A voucher metadata is updated. */
  | 'VOUCHER_METADATA_UPDATED'
  /** A voucher is updated. */
  | 'VOUCHER_UPDATED'
  /** A new warehouse created. */
  | 'WAREHOUSE_CREATED'
  /** A warehouse is deleted. */
  | 'WAREHOUSE_DELETED'
  /** A warehouse metadata is updated. */
  | 'WAREHOUSE_METADATA_UPDATED'
  /** A warehouse is updated. */
  | 'WAREHOUSE_UPDATED';

/** Enum determining type of webhook. */
export type WebhookEventTypeEnum =
  /** An account email change is requested. */
  | 'ACCOUNT_CHANGE_EMAIL_REQUESTED'
  /** An account confirmation is requested. */
  | 'ACCOUNT_CONFIRMATION_REQUESTED'
  /** An account is confirmed. */
  | 'ACCOUNT_CONFIRMED'
  /** An account is deleted. */
  | 'ACCOUNT_DELETED'
  /** An account delete is requested. */
  | 'ACCOUNT_DELETE_REQUESTED'
  /** An account email was changed */
  | 'ACCOUNT_EMAIL_CHANGED'
  /** Setting a new password for the account is requested. */
  | 'ACCOUNT_SET_PASSWORD_REQUESTED'
  /** A new address created. */
  | 'ADDRESS_CREATED'
  /** An address deleted. */
  | 'ADDRESS_DELETED'
  /** An address updated. */
  | 'ADDRESS_UPDATED'
  /** All the events. */
  | 'ANY_EVENTS'
  /** An app deleted. */
  | 'APP_DELETED'
  /** A new app installed. */
  | 'APP_INSTALLED'
  /** An app status is changed. */
  | 'APP_STATUS_CHANGED'
  /** An app updated. */
  | 'APP_UPDATED'
  /** A new attribute is created. */
  | 'ATTRIBUTE_CREATED'
  /** An attribute is deleted. */
  | 'ATTRIBUTE_DELETED'
  /** An attribute is updated. */
  | 'ATTRIBUTE_UPDATED'
  /** A new attribute value is created. */
  | 'ATTRIBUTE_VALUE_CREATED'
  /** An attribute value is deleted. */
  | 'ATTRIBUTE_VALUE_DELETED'
  /** An attribute value is updated. */
  | 'ATTRIBUTE_VALUE_UPDATED'
  /** A new category created. */
  | 'CATEGORY_CREATED'
  /** A category is deleted. */
  | 'CATEGORY_DELETED'
  /** A category is updated. */
  | 'CATEGORY_UPDATED'
  /** A new channel created. */
  | 'CHANNEL_CREATED'
  /** A channel is deleted. */
  | 'CHANNEL_DELETED'
  /** A channel metadata is updated. */
  | 'CHANNEL_METADATA_UPDATED'
  /** A channel status is changed. */
  | 'CHANNEL_STATUS_CHANGED'
  /** A channel is updated. */
  | 'CHANNEL_UPDATED'
  /** Event called for checkout tax calculation. */
  | 'CHECKOUT_CALCULATE_TAXES'
  /** A new checkout is created. */
  | 'CHECKOUT_CREATED'
  /** Filter shipping methods for checkout. */
  | 'CHECKOUT_FILTER_SHIPPING_METHODS'
  /**
   * A checkout was fully authorized (its `authorizeStatus` is `FULL`).
   *
   * This event is emitted only for checkouts whose payments are processed through the Transaction API.
   */
  | 'CHECKOUT_FULLY_AUTHORIZED'
  /**
   * A checkout was fully paid (its `chargeStatus` is `FULL` or `OVERCHARGED`). This event is not sent if payments are only authorized but not fully charged.
   *
   * This event is emitted only for checkouts whose payments are processed through the Transaction API.
   */
  | 'CHECKOUT_FULLY_PAID'
  /** A checkout metadata is updated. */
  | 'CHECKOUT_METADATA_UPDATED'
  /** A checkout is updated. It also triggers all updates related to the checkout. */
  | 'CHECKOUT_UPDATED'
  /** A new collection is created. */
  | 'COLLECTION_CREATED'
  /** A collection is deleted. */
  | 'COLLECTION_DELETED'
  /** A collection metadata is updated. */
  | 'COLLECTION_METADATA_UPDATED'
  /** A collection is updated. */
  | 'COLLECTION_UPDATED'
  /** A new customer account is created. */
  | 'CUSTOMER_CREATED'
  /** A customer account is deleted. */
  | 'CUSTOMER_DELETED'
  /** A customer account metadata is updated. */
  | 'CUSTOMER_METADATA_UPDATED'
  /** A customer account is updated. */
  | 'CUSTOMER_UPDATED'
  /** A draft order is created. */
  | 'DRAFT_ORDER_CREATED'
  /** A draft order is deleted. */
  | 'DRAFT_ORDER_DELETED'
  /** A draft order is updated. */
  | 'DRAFT_ORDER_UPDATED'
  /** A fulfillment is approved. */
  | 'FULFILLMENT_APPROVED'
  /** A fulfillment is cancelled. */
  | 'FULFILLMENT_CANCELED'
  /** A new fulfillment is created. */
  | 'FULFILLMENT_CREATED'
  /** A fulfillment metadata is updated. */
  | 'FULFILLMENT_METADATA_UPDATED'
  | 'FULFILLMENT_TRACKING_NUMBER_UPDATED'
  /** A new gift card created. */
  | 'GIFT_CARD_CREATED'
  /** A gift card is deleted. */
  | 'GIFT_CARD_DELETED'
  /** A gift card export is completed. */
  | 'GIFT_CARD_EXPORT_COMPLETED'
  /** A gift card metadata is updated. */
  | 'GIFT_CARD_METADATA_UPDATED'
  /** A gift card has been sent. */
  | 'GIFT_CARD_SENT'
  /** A gift card status is changed. */
  | 'GIFT_CARD_STATUS_CHANGED'
  /** A gift card is updated. */
  | 'GIFT_CARD_UPDATED'
  /** An invoice is deleted. */
  | 'INVOICE_DELETED'
  /** An invoice for order requested. */
  | 'INVOICE_REQUESTED'
  /** Invoice has been sent. */
  | 'INVOICE_SENT'
  | 'LIST_STORED_PAYMENT_METHODS'
  /** A new menu created. */
  | 'MENU_CREATED'
  /** A menu is deleted. */
  | 'MENU_DELETED'
  /** A new menu item created. */
  | 'MENU_ITEM_CREATED'
  /** A menu item is deleted. */
  | 'MENU_ITEM_DELETED'
  /** A menu item is updated. */
  | 'MENU_ITEM_UPDATED'
  /** A menu is updated. */
  | 'MENU_UPDATED'
  /** User notification triggered. */
  | 'NOTIFY_USER'
  /** An observability event is created. */
  | 'OBSERVABILITY'
  /** Orders are imported. */
  | 'ORDER_BULK_CREATED'
  /** Event called for order tax calculation. */
  | 'ORDER_CALCULATE_TAXES'
  /** An order is cancelled. */
  | 'ORDER_CANCELLED'
  /** An order is confirmed (status change unconfirmed -> unfulfilled) by a staff user using the OrderConfirm mutation. It also triggers when the user completes the checkout and the shop setting `automatically_confirm_all_new_orders` is enabled. */
  | 'ORDER_CONFIRMED'
  /** A new order is placed. */
  | 'ORDER_CREATED'
  /** An order is expired. */
  | 'ORDER_EXPIRED'
  /** Filter shipping methods for order. */
  | 'ORDER_FILTER_SHIPPING_METHODS'
  /** An order is fulfilled. */
  | 'ORDER_FULFILLED'
  /** Payment is made and an order is fully paid. */
  | 'ORDER_FULLY_PAID'
  /** The order is fully refunded. */
  | 'ORDER_FULLY_REFUNDED'
  /** An order metadata is updated. */
  | 'ORDER_METADATA_UPDATED'
  /** Payment has been made. The order may be partially or fully paid. */
  | 'ORDER_PAID'
  /** The order received a refund. The order may be partially or fully refunded. */
  | 'ORDER_REFUNDED'
  /** An order is updated; triggered for all changes related to an order; covers all other order webhooks, except for ORDER_CREATED. */
  | 'ORDER_UPDATED'
  /** A new page is created. */
  | 'PAGE_CREATED'
  /** A page is deleted. */
  | 'PAGE_DELETED'
  /** A new page type is created. */
  | 'PAGE_TYPE_CREATED'
  /** A page type is deleted. */
  | 'PAGE_TYPE_DELETED'
  /** A page type is updated. */
  | 'PAGE_TYPE_UPDATED'
  /** A page is updated. */
  | 'PAGE_UPDATED'
  /** Authorize payment. */
  | 'PAYMENT_AUTHORIZE'
  /** Capture payment. */
  | 'PAYMENT_CAPTURE'
  /** Confirm payment. */
  | 'PAYMENT_CONFIRM'
  | 'PAYMENT_GATEWAY_INITIALIZE_SESSION'
  | 'PAYMENT_GATEWAY_INITIALIZE_TOKENIZATION_SESSION'
  /** Listing available payment gateways. */
  | 'PAYMENT_LIST_GATEWAYS'
  | 'PAYMENT_METHOD_INITIALIZE_TOKENIZATION_SESSION'
  | 'PAYMENT_METHOD_PROCESS_TOKENIZATION_SESSION'
  /** Process payment. */
  | 'PAYMENT_PROCESS'
  /** Refund payment. */
  | 'PAYMENT_REFUND'
  /** Void payment. */
  | 'PAYMENT_VOID'
  /** A new permission group is created. */
  | 'PERMISSION_GROUP_CREATED'
  /** A permission group is deleted. */
  | 'PERMISSION_GROUP_DELETED'
  /** A permission group is updated. */
  | 'PERMISSION_GROUP_UPDATED'
  /** A new product is created. */
  | 'PRODUCT_CREATED'
  /** A product is deleted. */
  | 'PRODUCT_DELETED'
  /** A product export is completed. */
  | 'PRODUCT_EXPORT_COMPLETED'
  /** A new product media is created. */
  | 'PRODUCT_MEDIA_CREATED'
  /** A product media is deleted. */
  | 'PRODUCT_MEDIA_DELETED'
  /** A product media is updated. */
  | 'PRODUCT_MEDIA_UPDATED'
  /** A product metadata is updated. */
  | 'PRODUCT_METADATA_UPDATED'
  /** A product is updated. */
  | 'PRODUCT_UPDATED'
  /** A product variant is back in stock. */
  | 'PRODUCT_VARIANT_BACK_IN_STOCK'
  /** A new product variant is created. */
  | 'PRODUCT_VARIANT_CREATED'
  /** A product variant is deleted. Warning: this event will not be executed when parent product has been deleted. Check PRODUCT_DELETED. */
  | 'PRODUCT_VARIANT_DELETED'
  | 'PRODUCT_VARIANT_DISCOUNTED_PRICE_UPDATED'
  /** A product variant metadata is updated. */
  | 'PRODUCT_VARIANT_METADATA_UPDATED'
  /** A product variant is out of stock. */
  | 'PRODUCT_VARIANT_OUT_OF_STOCK'
  /** A product variant stock is updated */
  | 'PRODUCT_VARIANT_STOCK_UPDATED'
  /** A product variant is updated. */
  | 'PRODUCT_VARIANT_UPDATED'
  /** A promotion is created. */
  | 'PROMOTION_CREATED'
  /** A promotion is deleted. */
  | 'PROMOTION_DELETED'
  /** A promotion is deactivated. */
  | 'PROMOTION_ENDED'
  /** A promotion rule is created. */
  | 'PROMOTION_RULE_CREATED'
  /** A promotion rule is deleted. */
  | 'PROMOTION_RULE_DELETED'
  /** A promotion rule is updated. */
  | 'PROMOTION_RULE_UPDATED'
  /** A promotion is activated. */
  | 'PROMOTION_STARTED'
  /** A promotion is updated. */
  | 'PROMOTION_UPDATED'
  /** A sale is created. */
  | 'SALE_CREATED'
  /** A sale is deleted. */
  | 'SALE_DELETED'
  /** A sale is activated or deactivated. */
  | 'SALE_TOGGLE'
  /** A sale is updated. */
  | 'SALE_UPDATED'
  /** Fetch external shipping methods for checkout. */
  | 'SHIPPING_LIST_METHODS_FOR_CHECKOUT'
  /** A new shipping price is created. */
  | 'SHIPPING_PRICE_CREATED'
  /** A shipping price is deleted. */
  | 'SHIPPING_PRICE_DELETED'
  /** A shipping price is updated. */
  | 'SHIPPING_PRICE_UPDATED'
  /** A new shipping zone is created. */
  | 'SHIPPING_ZONE_CREATED'
  /** A shipping zone is deleted. */
  | 'SHIPPING_ZONE_DELETED'
  /** A shipping zone metadata is updated. */
  | 'SHIPPING_ZONE_METADATA_UPDATED'
  /** A shipping zone is updated. */
  | 'SHIPPING_ZONE_UPDATED'
  /** Shop metadata is updated. */
  | 'SHOP_METADATA_UPDATED'
  /** A new staff user is created. */
  | 'STAFF_CREATED'
  /** A staff user is deleted. */
  | 'STAFF_DELETED'
  /** Setting a new password for the staff account is requested. */
  | 'STAFF_SET_PASSWORD_REQUESTED'
  /** A staff user is updated. */
  | 'STAFF_UPDATED'
  | 'STORED_PAYMENT_METHOD_DELETE_REQUESTED'
  /** A thumbnail is created. */
  | 'THUMBNAIL_CREATED'
  /** Event called when cancel has been requested for transaction. */
  | 'TRANSACTION_CANCELATION_REQUESTED'
  /** Event called when charge has been requested for transaction. */
  | 'TRANSACTION_CHARGE_REQUESTED'
  | 'TRANSACTION_INITIALIZE_SESSION'
  /** Transaction item metadata is updated. */
  | 'TRANSACTION_ITEM_METADATA_UPDATED'
  | 'TRANSACTION_PROCESS_SESSION'
  /** Event called when refund has been requested for transaction. */
  | 'TRANSACTION_REFUND_REQUESTED'
  /** A new translation is created. */
  | 'TRANSLATION_CREATED'
  /** A translation is updated. */
  | 'TRANSLATION_UPDATED'
  | 'VOUCHER_CODES_CREATED'
  | 'VOUCHER_CODES_DELETED'
  /**
   * A voucher code export is completed.
   *
   * Added in Saleor 3.18.
   */
  | 'VOUCHER_CODE_EXPORT_COMPLETED'
  /** A new voucher created. */
  | 'VOUCHER_CREATED'
  /** A voucher is deleted. */
  | 'VOUCHER_DELETED'
  /** A voucher metadata is updated. */
  | 'VOUCHER_METADATA_UPDATED'
  /** A voucher is updated. */
  | 'VOUCHER_UPDATED'
  /** A new warehouse created. */
  | 'WAREHOUSE_CREATED'
  /** A warehouse is deleted. */
  | 'WAREHOUSE_DELETED'
  /** A warehouse metadata is updated. */
  | 'WAREHOUSE_METADATA_UPDATED'
  /** A warehouse is updated. */
  | 'WAREHOUSE_UPDATED';

/** Enum determining type of webhook. */
export type WebhookEventTypeSyncEnum =
  /** Event called for checkout tax calculation. */
  | 'CHECKOUT_CALCULATE_TAXES'
  /** Filter shipping methods for checkout. */
  | 'CHECKOUT_FILTER_SHIPPING_METHODS'
  | 'LIST_STORED_PAYMENT_METHODS'
  /** Event called for order tax calculation. */
  | 'ORDER_CALCULATE_TAXES'
  /** Filter shipping methods for order. */
  | 'ORDER_FILTER_SHIPPING_METHODS'
  /** Authorize payment. */
  | 'PAYMENT_AUTHORIZE'
  /** Capture payment. */
  | 'PAYMENT_CAPTURE'
  /** Confirm payment. */
  | 'PAYMENT_CONFIRM'
  | 'PAYMENT_GATEWAY_INITIALIZE_SESSION'
  | 'PAYMENT_GATEWAY_INITIALIZE_TOKENIZATION_SESSION'
  /** Listing available payment gateways. */
  | 'PAYMENT_LIST_GATEWAYS'
  | 'PAYMENT_METHOD_INITIALIZE_TOKENIZATION_SESSION'
  | 'PAYMENT_METHOD_PROCESS_TOKENIZATION_SESSION'
  /** Process payment. */
  | 'PAYMENT_PROCESS'
  /** Refund payment. */
  | 'PAYMENT_REFUND'
  /** Void payment. */
  | 'PAYMENT_VOID'
  /** Fetch external shipping methods for checkout. */
  | 'SHIPPING_LIST_METHODS_FOR_CHECKOUT'
  | 'STORED_PAYMENT_METHOD_DELETE_REQUESTED'
  /** Event called when cancel has been requested for transaction. */
  | 'TRANSACTION_CANCELATION_REQUESTED'
  /** Event called when charge has been requested for transaction. */
  | 'TRANSACTION_CHARGE_REQUESTED'
  | 'TRANSACTION_INITIALIZE_SESSION'
  | 'TRANSACTION_PROCESS_SESSION'
  /** Event called when refund has been requested for transaction. */
  | 'TRANSACTION_REFUND_REQUESTED';

export type WebhookSampleEventTypeEnum =
  | 'ACCOUNT_CHANGE_EMAIL_REQUESTED'
  | 'ACCOUNT_CONFIRMATION_REQUESTED'
  | 'ACCOUNT_CONFIRMED'
  | 'ACCOUNT_DELETED'
  | 'ACCOUNT_DELETE_REQUESTED'
  | 'ACCOUNT_EMAIL_CHANGED'
  | 'ACCOUNT_SET_PASSWORD_REQUESTED'
  | 'ADDRESS_CREATED'
  | 'ADDRESS_DELETED'
  | 'ADDRESS_UPDATED'
  | 'APP_DELETED'
  | 'APP_INSTALLED'
  | 'APP_STATUS_CHANGED'
  | 'APP_UPDATED'
  | 'ATTRIBUTE_CREATED'
  | 'ATTRIBUTE_DELETED'
  | 'ATTRIBUTE_UPDATED'
  | 'ATTRIBUTE_VALUE_CREATED'
  | 'ATTRIBUTE_VALUE_DELETED'
  | 'ATTRIBUTE_VALUE_UPDATED'
  | 'CATEGORY_CREATED'
  | 'CATEGORY_DELETED'
  | 'CATEGORY_UPDATED'
  | 'CHANNEL_CREATED'
  | 'CHANNEL_DELETED'
  | 'CHANNEL_METADATA_UPDATED'
  | 'CHANNEL_STATUS_CHANGED'
  | 'CHANNEL_UPDATED'
  | 'CHECKOUT_CREATED'
  | 'CHECKOUT_FULLY_AUTHORIZED'
  | 'CHECKOUT_FULLY_PAID'
  | 'CHECKOUT_METADATA_UPDATED'
  | 'CHECKOUT_UPDATED'
  | 'COLLECTION_CREATED'
  | 'COLLECTION_DELETED'
  | 'COLLECTION_METADATA_UPDATED'
  | 'COLLECTION_UPDATED'
  | 'CUSTOMER_CREATED'
  | 'CUSTOMER_DELETED'
  | 'CUSTOMER_METADATA_UPDATED'
  | 'CUSTOMER_UPDATED'
  | 'DRAFT_ORDER_CREATED'
  | 'DRAFT_ORDER_DELETED'
  | 'DRAFT_ORDER_UPDATED'
  | 'FULFILLMENT_APPROVED'
  | 'FULFILLMENT_CANCELED'
  | 'FULFILLMENT_CREATED'
  | 'FULFILLMENT_METADATA_UPDATED'
  | 'FULFILLMENT_TRACKING_NUMBER_UPDATED'
  | 'GIFT_CARD_CREATED'
  | 'GIFT_CARD_DELETED'
  | 'GIFT_CARD_EXPORT_COMPLETED'
  | 'GIFT_CARD_METADATA_UPDATED'
  | 'GIFT_CARD_SENT'
  | 'GIFT_CARD_STATUS_CHANGED'
  | 'GIFT_CARD_UPDATED'
  | 'INVOICE_DELETED'
  | 'INVOICE_REQUESTED'
  | 'INVOICE_SENT'
  | 'MENU_CREATED'
  | 'MENU_DELETED'
  | 'MENU_ITEM_CREATED'
  | 'MENU_ITEM_DELETED'
  | 'MENU_ITEM_UPDATED'
  | 'MENU_UPDATED'
  | 'NOTIFY_USER'
  | 'OBSERVABILITY'
  | 'ORDER_BULK_CREATED'
  | 'ORDER_CANCELLED'
  | 'ORDER_CONFIRMED'
  | 'ORDER_CREATED'
  | 'ORDER_EXPIRED'
  | 'ORDER_FULFILLED'
  | 'ORDER_FULLY_PAID'
  | 'ORDER_FULLY_REFUNDED'
  | 'ORDER_METADATA_UPDATED'
  | 'ORDER_PAID'
  | 'ORDER_REFUNDED'
  | 'ORDER_UPDATED'
  | 'PAGE_CREATED'
  | 'PAGE_DELETED'
  | 'PAGE_TYPE_CREATED'
  | 'PAGE_TYPE_DELETED'
  | 'PAGE_TYPE_UPDATED'
  | 'PAGE_UPDATED'
  | 'PERMISSION_GROUP_CREATED'
  | 'PERMISSION_GROUP_DELETED'
  | 'PERMISSION_GROUP_UPDATED'
  | 'PRODUCT_CREATED'
  | 'PRODUCT_DELETED'
  | 'PRODUCT_EXPORT_COMPLETED'
  | 'PRODUCT_MEDIA_CREATED'
  | 'PRODUCT_MEDIA_DELETED'
  | 'PRODUCT_MEDIA_UPDATED'
  | 'PRODUCT_METADATA_UPDATED'
  | 'PRODUCT_UPDATED'
  | 'PRODUCT_VARIANT_BACK_IN_STOCK'
  | 'PRODUCT_VARIANT_CREATED'
  | 'PRODUCT_VARIANT_DELETED'
  | 'PRODUCT_VARIANT_DISCOUNTED_PRICE_UPDATED'
  | 'PRODUCT_VARIANT_METADATA_UPDATED'
  | 'PRODUCT_VARIANT_OUT_OF_STOCK'
  | 'PRODUCT_VARIANT_STOCK_UPDATED'
  | 'PRODUCT_VARIANT_UPDATED'
  | 'PROMOTION_CREATED'
  | 'PROMOTION_DELETED'
  | 'PROMOTION_ENDED'
  | 'PROMOTION_RULE_CREATED'
  | 'PROMOTION_RULE_DELETED'
  | 'PROMOTION_RULE_UPDATED'
  | 'PROMOTION_STARTED'
  | 'PROMOTION_UPDATED'
  | 'SALE_CREATED'
  | 'SALE_DELETED'
  | 'SALE_TOGGLE'
  | 'SALE_UPDATED'
  | 'SHIPPING_PRICE_CREATED'
  | 'SHIPPING_PRICE_DELETED'
  | 'SHIPPING_PRICE_UPDATED'
  | 'SHIPPING_ZONE_CREATED'
  | 'SHIPPING_ZONE_DELETED'
  | 'SHIPPING_ZONE_METADATA_UPDATED'
  | 'SHIPPING_ZONE_UPDATED'
  | 'SHOP_METADATA_UPDATED'
  | 'STAFF_CREATED'
  | 'STAFF_DELETED'
  | 'STAFF_SET_PASSWORD_REQUESTED'
  | 'STAFF_UPDATED'
  | 'THUMBNAIL_CREATED'
  | 'TRANSACTION_ITEM_METADATA_UPDATED'
  | 'TRANSLATION_CREATED'
  | 'TRANSLATION_UPDATED'
  | 'VOUCHER_CODES_CREATED'
  | 'VOUCHER_CODES_DELETED'
  | 'VOUCHER_CODE_EXPORT_COMPLETED'
  | 'VOUCHER_CREATED'
  | 'VOUCHER_DELETED'
  | 'VOUCHER_METADATA_UPDATED'
  | 'VOUCHER_UPDATED'
  | 'WAREHOUSE_CREATED'
  | 'WAREHOUSE_DELETED'
  | 'WAREHOUSE_METADATA_UPDATED'
  | 'WAREHOUSE_UPDATED';

/**
 * Trigger a webhook event. Supports a single event (the first, if multiple provided in the `webhook.subscription_query`). Requires permission relevant to processed event. Successfully delivered webhook returns `delivery` with status='PENDING' and empty payload.
 *
 * Requires one of the following permissions: AUTHENTICATED_STAFF_USER.
 */
export type WebhookTrigger = {
  __typename?: 'WebhookTrigger';
  delivery?: Maybe<EventDelivery>;
  errors: Array<WebhookTriggerError>;
};

export type WebhookTriggerError = {
  __typename?: 'WebhookTriggerError';
  /** The error code. */
  code: WebhookTriggerErrorCode;
  /** Name of a field that caused the error. A value of `null` indicates that the error isn't associated with a particular field. */
  field?: Maybe<Scalars['String']['output']>;
  /** The error message. */
  message?: Maybe<Scalars['String']['output']>;
};

export type WebhookTriggerErrorCode =
  | 'GRAPHQL_ERROR'
  | 'INVALID_ID'
  | 'MISSING_EVENT'
  | 'MISSING_PERMISSION'
  | 'MISSING_QUERY'
  | 'MISSING_SUBSCRIPTION'
  | 'NOT_FOUND'
  | 'SYNTAX'
  | 'TYPE_NOT_SUPPORTED'
  | 'UNABLE_TO_PARSE';

/**
 * Updates a webhook subscription.
 *
 * Requires one of the following permissions: MANAGE_APPS, AUTHENTICATED_APP.
 */
export type WebhookUpdate = {
  __typename?: 'WebhookUpdate';
  errors: Array<WebhookError>;
  webhook?: Maybe<Webhook>;
  /** @deprecated Use `errors` field instead. */
  webhookErrors: Array<WebhookError>;
};

export type WebhookUpdateInput = {
  /** ID of the app to which webhook belongs. */
  app?: InputMaybe<Scalars['ID']['input']>;
  /** The asynchronous events that webhook wants to subscribe. */
  asyncEvents?: InputMaybe<Array<WebhookEventTypeAsyncEnum>>;
  /** Custom headers, which will be added to HTTP request. There is a limitation of 5 headers per webhook and 998 characters per header.Only `X-*`, `Authorization*`, and `BrokerProperties` keys are allowed. */
  customHeaders?: InputMaybe<Scalars['JSONString']['input']>;
  /**
   * The events that webhook wants to subscribe.
   *
   * DEPRECATED: this field will be removed. Use `asyncEvents` or `syncEvents` instead.
   */
  events?: InputMaybe<Array<WebhookEventTypeEnum>>;
  /** Determine if webhook will be set active or not. */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** The new name of the webhook. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Subscription query used to define a webhook payload. */
  query?: InputMaybe<Scalars['String']['input']>;
  /**
   * Use to create a hash signature with each payload.
   *
   * DEPRECATED: this field will be removed. As of Saleor 3.5, webhook payloads default to signing using a verifiable JWS.
   */
  secretKey?: InputMaybe<Scalars['String']['input']>;
  /** The synchronous events that webhook wants to subscribe. */
  syncEvents?: InputMaybe<Array<WebhookEventTypeSyncEnum>>;
  /** The url to receive the payload. */
  targetUrl?: InputMaybe<Scalars['String']['input']>;
};

/** Represents weight value in a specific weight unit. */
export type Weight = {
  __typename?: 'Weight';
  /** Weight unit. */
  unit: WeightUnitsEnum;
  /** Weight value. Returns a value with maximal three decimal places */
  value: Scalars['Float']['output'];
};

export type WeightUnitsEnum =
  | 'G'
  | 'KG'
  | 'LB'
  | 'OZ'
  | 'TONNE';

/** Represents the WIDGET target options for an app extension. */
export type WidgetTargetOptions = {
  __typename?: 'WidgetTargetOptions';
  /**
   * HTTP method for Widget target (GET or POST)
   * @deprecated Use `settings` field directly.
   */
  method: HttpMethod;
};

/** _Entity union as defined by Federation spec. */
export type _Entity = Address | App | Category | Collection | Group | Order | PageType | Product | ProductMedia | ProductType | ProductVariant | User;

/** _Service manifest as defined by Federation spec. */
export type _Service = {
  __typename?: '_Service';
  sdl?: Maybe<Scalars['String']['output']>;
};

export type AccountErrorFragment = { __typename?: 'AccountError', field?: string | null, message?: string | null, code: AccountErrorCode };

export type AddToBagStrapFragment = { __typename?: 'ProductVariant', id: string, sku?: string | null, product: { __typename?: 'Product', id: string, name: string, toolName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, buckleName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, productType: { __typename?: 'ProductType', slug: string, name: string }, thumbnail?: { __typename?: 'Image', alt?: string | null, url: string } | null }, pricing?: { __typename?: 'VariantPricingInfo', price?: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } } | null } | null };

export type AddressFragment = { __typename?: 'Address', id: string, city: string, cityArea: string, companyName: string, countryArea: string, firstName: string, isDefaultBillingAddress?: boolean | null, isDefaultShippingAddress?: boolean | null, lastName: string, phone?: string | null, postalCode: string, streetAddress1: string, streetAddress2: string, country: { __typename?: 'CountryDisplay', code: string, country: string }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> };

export type AddressValidationDataFragment = { __typename?: 'AddressValidationData', requiredFields: Array<string>, countryAreaType: string, postalCodeType: string, cityType: string, countryAreaChoices: Array<{ __typename?: 'ChoiceValue', raw?: string | null, verbose?: string | null }>, cityChoices: Array<{ __typename?: 'ChoiceValue', raw?: string | null, verbose?: string | null }> };

export type BoolAttributeFragment = { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', boolean?: boolean | null, slug?: string | null }> };

type BusinessIdMetadata_Address_Fragment = { __typename?: 'Address', businessId?: string | null };

type BusinessIdMetadata_App_Fragment = { __typename?: 'App', businessId?: string | null };

type BusinessIdMetadata_Attribute_Fragment = { __typename?: 'Attribute', businessId?: string | null };

type BusinessIdMetadata_Category_Fragment = { __typename?: 'Category', businessId?: string | null };

type BusinessIdMetadata_Channel_Fragment = { __typename?: 'Channel', businessId?: string | null };

type BusinessIdMetadata_Checkout_Fragment = { __typename?: 'Checkout', businessId?: string | null };

type BusinessIdMetadata_CheckoutLine_Fragment = { __typename?: 'CheckoutLine', businessId?: string | null };

type BusinessIdMetadata_Collection_Fragment = { __typename?: 'Collection', businessId?: string | null };

type BusinessIdMetadata_DigitalContent_Fragment = { __typename?: 'DigitalContent', businessId?: string | null };

type BusinessIdMetadata_Fulfillment_Fragment = { __typename?: 'Fulfillment', businessId?: string | null };

type BusinessIdMetadata_GiftCard_Fragment = { __typename?: 'GiftCard', businessId?: string | null };

type BusinessIdMetadata_Invoice_Fragment = { __typename?: 'Invoice', businessId?: string | null };

type BusinessIdMetadata_Menu_Fragment = { __typename?: 'Menu', businessId?: string | null };

type BusinessIdMetadata_MenuItem_Fragment = { __typename?: 'MenuItem', businessId?: string | null };

type BusinessIdMetadata_Order_Fragment = { __typename?: 'Order', businessId?: string | null };

type BusinessIdMetadata_OrderLine_Fragment = { __typename?: 'OrderLine', businessId?: string | null };

type BusinessIdMetadata_Page_Fragment = { __typename?: 'Page', businessId?: string | null };

type BusinessIdMetadata_PageType_Fragment = { __typename?: 'PageType', businessId?: string | null };

type BusinessIdMetadata_Payment_Fragment = { __typename?: 'Payment', businessId?: string | null };

type BusinessIdMetadata_Product_Fragment = { __typename?: 'Product', businessId?: string | null };

type BusinessIdMetadata_ProductMedia_Fragment = { __typename?: 'ProductMedia', businessId?: string | null };

type BusinessIdMetadata_ProductType_Fragment = { __typename?: 'ProductType', businessId?: string | null };

type BusinessIdMetadata_ProductVariant_Fragment = { __typename?: 'ProductVariant', businessId?: string | null };

type BusinessIdMetadata_Promotion_Fragment = { __typename?: 'Promotion', businessId?: string | null };

type BusinessIdMetadata_Sale_Fragment = { __typename?: 'Sale', businessId?: string | null };

type BusinessIdMetadata_ShippingMethod_Fragment = { __typename?: 'ShippingMethod', businessId?: string | null };

type BusinessIdMetadata_ShippingMethodType_Fragment = { __typename?: 'ShippingMethodType', businessId?: string | null };

type BusinessIdMetadata_ShippingZone_Fragment = { __typename?: 'ShippingZone', businessId?: string | null };

type BusinessIdMetadata_Shop_Fragment = { __typename?: 'Shop', businessId?: string | null };

type BusinessIdMetadata_TaxClass_Fragment = { __typename?: 'TaxClass', businessId?: string | null };

type BusinessIdMetadata_TaxConfiguration_Fragment = { __typename?: 'TaxConfiguration', businessId?: string | null };

type BusinessIdMetadata_TransactionItem_Fragment = { __typename?: 'TransactionItem', businessId?: string | null };

type BusinessIdMetadata_User_Fragment = { __typename?: 'User', businessId?: string | null };

type BusinessIdMetadata_Voucher_Fragment = { __typename?: 'Voucher', businessId?: string | null };

type BusinessIdMetadata_Warehouse_Fragment = { __typename?: 'Warehouse', businessId?: string | null };

export type BusinessIdMetadataFragment = BusinessIdMetadata_Address_Fragment | BusinessIdMetadata_App_Fragment | BusinessIdMetadata_Attribute_Fragment | BusinessIdMetadata_Category_Fragment | BusinessIdMetadata_Channel_Fragment | BusinessIdMetadata_Checkout_Fragment | BusinessIdMetadata_CheckoutLine_Fragment | BusinessIdMetadata_Collection_Fragment | BusinessIdMetadata_DigitalContent_Fragment | BusinessIdMetadata_Fulfillment_Fragment | BusinessIdMetadata_GiftCard_Fragment | BusinessIdMetadata_Invoice_Fragment | BusinessIdMetadata_Menu_Fragment | BusinessIdMetadata_MenuItem_Fragment | BusinessIdMetadata_Order_Fragment | BusinessIdMetadata_OrderLine_Fragment | BusinessIdMetadata_Page_Fragment | BusinessIdMetadata_PageType_Fragment | BusinessIdMetadata_Payment_Fragment | BusinessIdMetadata_Product_Fragment | BusinessIdMetadata_ProductMedia_Fragment | BusinessIdMetadata_ProductType_Fragment | BusinessIdMetadata_ProductVariant_Fragment | BusinessIdMetadata_Promotion_Fragment | BusinessIdMetadata_Sale_Fragment | BusinessIdMetadata_ShippingMethod_Fragment | BusinessIdMetadata_ShippingMethodType_Fragment | BusinessIdMetadata_ShippingZone_Fragment | BusinessIdMetadata_Shop_Fragment | BusinessIdMetadata_TaxClass_Fragment | BusinessIdMetadata_TaxConfiguration_Fragment | BusinessIdMetadata_TransactionItem_Fragment | BusinessIdMetadata_User_Fragment | BusinessIdMetadata_Voucher_Fragment | BusinessIdMetadata_Warehouse_Fragment;

export type CategoryBasicFragment = { __typename?: 'Category', id: string, name: string, slug: string, translation?: { __typename?: 'CategoryTranslation', id: string, name?: string | null } | null };

export type CategoryDetailsFragment = { __typename?: 'Category', id: string, seoTitle?: string | null, seoDescription?: string | null, description?: string | null, name: string, slug: string, translation?: { __typename?: 'CategoryTranslation', id: string, description?: string | null, name?: string | null } | null, backgroundImage?: { __typename?: 'Image', alt?: string | null, url: string } | null, ancestors?: { __typename?: 'CategoryCountableConnection', edges: Array<{ __typename?: 'CategoryCountableEdge', node: { __typename?: 'Category', id: string, name: string, slug: string, translation?: { __typename?: 'CategoryTranslation', id: string, name?: string | null } | null } }> } | null };

export type ChannelFragment = { __typename?: 'Channel', slug: string };

export type CheckoutFragment = { __typename?: 'Checkout', isShippingRequired: boolean, discountName?: string | null, voucherCode?: string | null, id: string, email?: string | null, languageCode: LanguageCodeEnum, deliveryMode?: string | null, boutiqueExtRef?: string | null, gwpProduct?: string | null, orderBid?: string | null, campaignVoucherCode?: string | null, isGift?: string | null, giftFrom?: string | null, giftMessage?: string | null, shippingTitle?: string | null, billingTitle?: string | null, timeSlot?: string | null, preOrderData?: string | null, orderType?: string | null, orderStatus?: string | null, orderCollectedDate?: string | null, payPerLinkToken?: string | null, payPerLinkExpiration?: string | null, paymentMethod?: string | null, orderFlowScTermsRequired?: string | null, orderFlowScTermsAccepted?: string | null, orderFlowWasUserAuthenticated?: string | null, orderFlowWasRegisterMyWatchChecked?: string | null, orderFlowWasCreateMyAccountWithoutWatchChecked?: string | null, orderFlowWasAccountCreated?: string | null, orderFlowUserJoinClub?: string | null, orderFlowUserAffiliated?: string | null, orderFlowReceiveReceipt?: string | null, checkoutId?: string | null, billingAddress?: { __typename?: 'Address', id: string, city: string, cityArea: string, companyName: string, countryArea: string, firstName: string, isDefaultBillingAddress?: boolean | null, isDefaultShippingAddress?: boolean | null, lastName: string, phone?: string | null, postalCode: string, streetAddress1: string, streetAddress2: string, country: { __typename?: 'CountryDisplay', code: string, country: string }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> } | null, shippingAddress?: { __typename?: 'Address', id: string, city: string, cityArea: string, companyName: string, countryArea: string, firstName: string, isDefaultBillingAddress?: boolean | null, isDefaultShippingAddress?: boolean | null, lastName: string, phone?: string | null, postalCode: string, streetAddress1: string, streetAddress2: string, country: { __typename?: 'CountryDisplay', code: string, country: string }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> } | null, shippingMethods: Array<{ __typename?: 'ShippingMethod', id: string, name: string, minimumDeliveryDays?: number | null, maximumDeliveryDays?: number | null, translation?: { __typename?: 'ShippingMethodTranslation', name?: string | null } | null, price: { __typename?: 'Money', amount: number, currency: string } }>, availableCollectionPoints: Array<{ __typename?: 'Warehouse', id: string, name: string, email: string, address: { __typename?: 'Address', id: string, city: string, cityArea: string, companyName: string, countryArea: string, firstName: string, isDefaultBillingAddress?: boolean | null, isDefaultShippingAddress?: boolean | null, lastName: string, phone?: string | null, postalCode: string, streetAddress1: string, streetAddress2: string, country: { __typename?: 'CountryDisplay', code: string, country: string }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> } }>, deliveryMethod?: { __typename?: 'ShippingMethod', id: string, name: string, minimumDeliveryDays?: number | null, maximumDeliveryDays?: number | null, translation?: { __typename?: 'ShippingMethodTranslation', name?: string | null } | null, price: { __typename?: 'Money', amount: number, currency: string } } | { __typename?: 'Warehouse', id: string, name: string, email: string, address: { __typename?: 'Address', id: string, city: string, cityArea: string, companyName: string, countryArea: string, firstName: string, isDefaultBillingAddress?: boolean | null, isDefaultShippingAddress?: boolean | null, lastName: string, phone?: string | null, postalCode: string, streetAddress1: string, streetAddress2: string, country: { __typename?: 'CountryDisplay', code: string, country: string }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> } } | null, discount?: { __typename?: 'Money', amount: number, currency: string } | null, subtotalPrice: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } }, shippingPrice: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } }, totalPrice: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } }, totalBalance: { __typename?: 'Money', amount: number, currency: string }, channel: { __typename?: 'Channel', slug: string }, lines: Array<{ __typename?: 'CheckoutLine', id: string, quantity: number, relatedProductBuckleId?: string | null, relatedProductStrapId?: string | null, relatedProductWatchId?: string | null, relatedBraceletSize?: string | null, relatedEngravingId?: string | null, strapPackReference?: string | null, strapReference?: string | null, strapSize?: string | null, preOrderData?: string | null, unitPrice: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } }, totalPrice: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } }, undiscountedTotalPrice: { __typename?: 'Money', amount: number, currency: string }, undiscountedUnitPrice: { __typename?: 'Money', amount: number, currency: string }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }>, variant: { __typename?: 'ProductVariant', id: string, sku?: string | null, product: { __typename?: 'Product', id: string, name: string, watchName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, strapName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, buckleName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, toolName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, warrantyName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, eyewearModel?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, digitalItemName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, translation?: { __typename?: 'ProductTranslation', name?: string | null } | null, defaultVariant?: { __typename?: 'ProductVariant', sku?: string | null, pricing?: { __typename?: 'VariantPricingInfo', price?: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } } | null } | null } | null, color?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, caseMaterial?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, strapMaterial?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, size?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, compatibleStraps?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, buckle?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, strapColor?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, warrantyExtensionDuration?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, warrantyMovementDuration?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, wristSizeMinInch?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, wristSizeMaxInch?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, wristSizeMinMm?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, wristSizeMaxMm?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, marketingPartner?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, media?: Array<{ __typename?: 'ProductMedia', url: string, alt: string, type: ProductMediaType, strapPreviewCoordinates?: string | null, backEngravingCoordinates?: string | null, shotType?: string | null }> | null, personalizedEngraving?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', boolean?: boolean | null, slug?: string | null }> } | null, productType: { __typename?: 'ProductType', slug: string, name: string }, thumbnail?: { __typename?: 'Image', alt?: string | null, url: string } | null, collections?: Array<{ __typename?: 'Collection', name: string, slug: string, translation?: { __typename?: 'CollectionTranslation', name?: string | null } | null }> | null, model?: { __typename?: 'SelectedAttribute', values: Array<{ __typename?: 'AttributeValue', slug?: string | null }> } | null, collectionName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null } } }>, user?: { __typename?: 'User', email: string } | null };

export type CheckoutBareFragment = { __typename?: 'Checkout', id: string, email?: string | null, languageCode: LanguageCodeEnum, user?: { __typename?: 'User', email: string } | null };

export type CheckoutBaseFragment = { __typename?: 'Checkout', id: string, email?: string | null, languageCode: LanguageCodeEnum, deliveryMode?: string | null, boutiqueExtRef?: string | null, gwpProduct?: string | null, orderBid?: string | null, campaignVoucherCode?: string | null, isGift?: string | null, giftFrom?: string | null, giftMessage?: string | null, shippingTitle?: string | null, billingTitle?: string | null, timeSlot?: string | null, preOrderData?: string | null, orderType?: string | null, orderStatus?: string | null, orderCollectedDate?: string | null, payPerLinkToken?: string | null, payPerLinkExpiration?: string | null, paymentMethod?: string | null, orderFlowScTermsRequired?: string | null, orderFlowScTermsAccepted?: string | null, orderFlowWasUserAuthenticated?: string | null, orderFlowWasRegisterMyWatchChecked?: string | null, orderFlowWasCreateMyAccountWithoutWatchChecked?: string | null, orderFlowWasAccountCreated?: string | null, orderFlowUserJoinClub?: string | null, orderFlowUserAffiliated?: string | null, orderFlowReceiveReceipt?: string | null, checkoutId?: string | null, totalPrice: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } }, totalBalance: { __typename?: 'Money', amount: number, currency: string }, subtotalPrice: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } }, channel: { __typename?: 'Channel', slug: string }, lines: Array<{ __typename?: 'CheckoutLine', id: string, quantity: number, relatedProductBuckleId?: string | null, relatedProductStrapId?: string | null, relatedProductWatchId?: string | null, relatedBraceletSize?: string | null, relatedEngravingId?: string | null, strapPackReference?: string | null, strapReference?: string | null, strapSize?: string | null, preOrderData?: string | null, unitPrice: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } }, totalPrice: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } }, undiscountedTotalPrice: { __typename?: 'Money', amount: number, currency: string }, undiscountedUnitPrice: { __typename?: 'Money', amount: number, currency: string }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }>, variant: { __typename?: 'ProductVariant', id: string, sku?: string | null, product: { __typename?: 'Product', id: string, name: string, watchName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, strapName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, buckleName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, toolName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, warrantyName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, eyewearModel?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, digitalItemName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, translation?: { __typename?: 'ProductTranslation', name?: string | null } | null, defaultVariant?: { __typename?: 'ProductVariant', sku?: string | null, pricing?: { __typename?: 'VariantPricingInfo', price?: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } } | null } | null } | null, color?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, caseMaterial?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, strapMaterial?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, size?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, compatibleStraps?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, buckle?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, strapColor?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, warrantyExtensionDuration?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, warrantyMovementDuration?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, wristSizeMinInch?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, wristSizeMaxInch?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, wristSizeMinMm?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, wristSizeMaxMm?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, marketingPartner?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, media?: Array<{ __typename?: 'ProductMedia', url: string, alt: string, type: ProductMediaType, strapPreviewCoordinates?: string | null, backEngravingCoordinates?: string | null, shotType?: string | null }> | null, personalizedEngraving?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', boolean?: boolean | null, slug?: string | null }> } | null, productType: { __typename?: 'ProductType', slug: string, name: string }, thumbnail?: { __typename?: 'Image', alt?: string | null, url: string } | null, collections?: Array<{ __typename?: 'Collection', name: string, slug: string, translation?: { __typename?: 'CollectionTranslation', name?: string | null } | null }> | null, model?: { __typename?: 'SelectedAttribute', values: Array<{ __typename?: 'AttributeValue', slug?: string | null }> } | null, collectionName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null } } }>, user?: { __typename?: 'User', email: string } | null };

type DeliveryScheduleMetadata_Address_Fragment = { __typename?: 'Address', timeSlot?: string | null };

type DeliveryScheduleMetadata_App_Fragment = { __typename?: 'App', timeSlot?: string | null };

type DeliveryScheduleMetadata_Attribute_Fragment = { __typename?: 'Attribute', timeSlot?: string | null };

type DeliveryScheduleMetadata_Category_Fragment = { __typename?: 'Category', timeSlot?: string | null };

type DeliveryScheduleMetadata_Channel_Fragment = { __typename?: 'Channel', timeSlot?: string | null };

type DeliveryScheduleMetadata_Checkout_Fragment = { __typename?: 'Checkout', timeSlot?: string | null };

type DeliveryScheduleMetadata_CheckoutLine_Fragment = { __typename?: 'CheckoutLine', timeSlot?: string | null };

type DeliveryScheduleMetadata_Collection_Fragment = { __typename?: 'Collection', timeSlot?: string | null };

type DeliveryScheduleMetadata_DigitalContent_Fragment = { __typename?: 'DigitalContent', timeSlot?: string | null };

type DeliveryScheduleMetadata_Fulfillment_Fragment = { __typename?: 'Fulfillment', timeSlot?: string | null };

type DeliveryScheduleMetadata_GiftCard_Fragment = { __typename?: 'GiftCard', timeSlot?: string | null };

type DeliveryScheduleMetadata_Invoice_Fragment = { __typename?: 'Invoice', timeSlot?: string | null };

type DeliveryScheduleMetadata_Menu_Fragment = { __typename?: 'Menu', timeSlot?: string | null };

type DeliveryScheduleMetadata_MenuItem_Fragment = { __typename?: 'MenuItem', timeSlot?: string | null };

type DeliveryScheduleMetadata_Order_Fragment = { __typename?: 'Order', timeSlot?: string | null };

type DeliveryScheduleMetadata_OrderLine_Fragment = { __typename?: 'OrderLine', timeSlot?: string | null };

type DeliveryScheduleMetadata_Page_Fragment = { __typename?: 'Page', timeSlot?: string | null };

type DeliveryScheduleMetadata_PageType_Fragment = { __typename?: 'PageType', timeSlot?: string | null };

type DeliveryScheduleMetadata_Payment_Fragment = { __typename?: 'Payment', timeSlot?: string | null };

type DeliveryScheduleMetadata_Product_Fragment = { __typename?: 'Product', timeSlot?: string | null };

type DeliveryScheduleMetadata_ProductMedia_Fragment = { __typename?: 'ProductMedia', timeSlot?: string | null };

type DeliveryScheduleMetadata_ProductType_Fragment = { __typename?: 'ProductType', timeSlot?: string | null };

type DeliveryScheduleMetadata_ProductVariant_Fragment = { __typename?: 'ProductVariant', timeSlot?: string | null };

type DeliveryScheduleMetadata_Promotion_Fragment = { __typename?: 'Promotion', timeSlot?: string | null };

type DeliveryScheduleMetadata_Sale_Fragment = { __typename?: 'Sale', timeSlot?: string | null };

type DeliveryScheduleMetadata_ShippingMethod_Fragment = { __typename?: 'ShippingMethod', timeSlot?: string | null };

type DeliveryScheduleMetadata_ShippingMethodType_Fragment = { __typename?: 'ShippingMethodType', timeSlot?: string | null };

type DeliveryScheduleMetadata_ShippingZone_Fragment = { __typename?: 'ShippingZone', timeSlot?: string | null };

type DeliveryScheduleMetadata_Shop_Fragment = { __typename?: 'Shop', timeSlot?: string | null };

type DeliveryScheduleMetadata_TaxClass_Fragment = { __typename?: 'TaxClass', timeSlot?: string | null };

type DeliveryScheduleMetadata_TaxConfiguration_Fragment = { __typename?: 'TaxConfiguration', timeSlot?: string | null };

type DeliveryScheduleMetadata_TransactionItem_Fragment = { __typename?: 'TransactionItem', timeSlot?: string | null };

type DeliveryScheduleMetadata_User_Fragment = { __typename?: 'User', timeSlot?: string | null };

type DeliveryScheduleMetadata_Voucher_Fragment = { __typename?: 'Voucher', timeSlot?: string | null };

type DeliveryScheduleMetadata_Warehouse_Fragment = { __typename?: 'Warehouse', timeSlot?: string | null };

export type DeliveryScheduleMetadataFragment = DeliveryScheduleMetadata_Address_Fragment | DeliveryScheduleMetadata_App_Fragment | DeliveryScheduleMetadata_Attribute_Fragment | DeliveryScheduleMetadata_Category_Fragment | DeliveryScheduleMetadata_Channel_Fragment | DeliveryScheduleMetadata_Checkout_Fragment | DeliveryScheduleMetadata_CheckoutLine_Fragment | DeliveryScheduleMetadata_Collection_Fragment | DeliveryScheduleMetadata_DigitalContent_Fragment | DeliveryScheduleMetadata_Fulfillment_Fragment | DeliveryScheduleMetadata_GiftCard_Fragment | DeliveryScheduleMetadata_Invoice_Fragment | DeliveryScheduleMetadata_Menu_Fragment | DeliveryScheduleMetadata_MenuItem_Fragment | DeliveryScheduleMetadata_Order_Fragment | DeliveryScheduleMetadata_OrderLine_Fragment | DeliveryScheduleMetadata_Page_Fragment | DeliveryScheduleMetadata_PageType_Fragment | DeliveryScheduleMetadata_Payment_Fragment | DeliveryScheduleMetadata_Product_Fragment | DeliveryScheduleMetadata_ProductMedia_Fragment | DeliveryScheduleMetadata_ProductType_Fragment | DeliveryScheduleMetadata_ProductVariant_Fragment | DeliveryScheduleMetadata_Promotion_Fragment | DeliveryScheduleMetadata_Sale_Fragment | DeliveryScheduleMetadata_ShippingMethod_Fragment | DeliveryScheduleMetadata_ShippingMethodType_Fragment | DeliveryScheduleMetadata_ShippingZone_Fragment | DeliveryScheduleMetadata_Shop_Fragment | DeliveryScheduleMetadata_TaxClass_Fragment | DeliveryScheduleMetadata_TaxConfiguration_Fragment | DeliveryScheduleMetadata_TransactionItem_Fragment | DeliveryScheduleMetadata_User_Fragment | DeliveryScheduleMetadata_Voucher_Fragment | DeliveryScheduleMetadata_Warehouse_Fragment;

export type CheckoutErrorFragment = { __typename?: 'CheckoutError', field?: string | null, code: CheckoutErrorCode, addressType?: AddressTypeEnum | null, message?: string | null };

export type CheckoutLineFragment = { __typename?: 'CheckoutLine', id: string, quantity: number, relatedProductBuckleId?: string | null, relatedProductStrapId?: string | null, relatedProductWatchId?: string | null, relatedBraceletSize?: string | null, relatedEngravingId?: string | null, strapPackReference?: string | null, strapReference?: string | null, strapSize?: string | null, preOrderData?: string | null, unitPrice: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } }, totalPrice: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } }, undiscountedTotalPrice: { __typename?: 'Money', amount: number, currency: string }, undiscountedUnitPrice: { __typename?: 'Money', amount: number, currency: string }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }>, variant: { __typename?: 'ProductVariant', id: string, sku?: string | null, product: { __typename?: 'Product', id: string, name: string, watchName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, strapName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, buckleName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, toolName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, warrantyName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, eyewearModel?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, digitalItemName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, translation?: { __typename?: 'ProductTranslation', name?: string | null } | null, defaultVariant?: { __typename?: 'ProductVariant', sku?: string | null, pricing?: { __typename?: 'VariantPricingInfo', price?: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } } | null } | null } | null, color?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, caseMaterial?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, strapMaterial?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, size?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, compatibleStraps?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, buckle?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, strapColor?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, warrantyExtensionDuration?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, warrantyMovementDuration?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, wristSizeMinInch?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, wristSizeMaxInch?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, wristSizeMinMm?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, wristSizeMaxMm?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, marketingPartner?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, media?: Array<{ __typename?: 'ProductMedia', url: string, alt: string, type: ProductMediaType, strapPreviewCoordinates?: string | null, backEngravingCoordinates?: string | null, shotType?: string | null }> | null, personalizedEngraving?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', boolean?: boolean | null, slug?: string | null }> } | null, productType: { __typename?: 'ProductType', slug: string, name: string }, thumbnail?: { __typename?: 'Image', alt?: string | null, url: string } | null, collections?: Array<{ __typename?: 'Collection', name: string, slug: string, translation?: { __typename?: 'CollectionTranslation', name?: string | null } | null }> | null, model?: { __typename?: 'SelectedAttribute', values: Array<{ __typename?: 'AttributeValue', slug?: string | null }> } | null, collectionName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null } } };

export type CheckoutMetadataFragment = { __typename?: 'Checkout', deliveryMode?: string | null, boutiqueExtRef?: string | null, gwpProduct?: string | null, orderBid?: string | null, campaignVoucherCode?: string | null, isGift?: string | null, giftFrom?: string | null, giftMessage?: string | null, shippingTitle?: string | null, billingTitle?: string | null, timeSlot?: string | null, preOrderData?: string | null, orderType?: string | null, orderStatus?: string | null, orderCollectedDate?: string | null, payPerLinkToken?: string | null, payPerLinkExpiration?: string | null, paymentMethod?: string | null, orderFlowScTermsRequired?: string | null, orderFlowScTermsAccepted?: string | null, orderFlowWasUserAuthenticated?: string | null, orderFlowWasRegisterMyWatchChecked?: string | null, orderFlowWasCreateMyAccountWithoutWatchChecked?: string | null, orderFlowWasAccountCreated?: string | null, orderFlowUserJoinClub?: string | null, orderFlowUserAffiliated?: string | null, orderFlowReceiveReceipt?: string | null, checkoutId?: string | null };

export type CheckoutRefreshFragment = { __typename?: 'Checkout', id: string, preOrderData?: string | null, orderType?: string | null, orderStatus?: string | null, orderCollectedDate?: string | null, payPerLinkToken?: string | null, payPerLinkExpiration?: string | null, orderFlowScTermsRequired?: string | null, orderFlowScTermsAccepted?: string | null, orderFlowWasUserAuthenticated?: string | null, orderFlowWasRegisterMyWatchChecked?: string | null, orderFlowWasCreateMyAccountWithoutWatchChecked?: string | null, orderFlowWasAccountCreated?: string | null, orderFlowUserJoinClub?: string | null, orderFlowUserAffiliated?: string | null, orderFlowReceiveReceipt?: string | null, checkoutId?: string | null, subtotalPrice: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } }, totalPrice: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } }, shippingPrice: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } }, lines: Array<{ __typename?: 'CheckoutLine', id: string, quantity: number, relatedProductBuckleId?: string | null, relatedProductStrapId?: string | null, relatedProductWatchId?: string | null, relatedBraceletSize?: string | null, relatedEngravingId?: string | null, strapPackReference?: string | null, strapReference?: string | null, strapSize?: string | null, preOrderData?: string | null, unitPrice: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } }, totalPrice: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } }, undiscountedTotalPrice: { __typename?: 'Money', amount: number, currency: string }, undiscountedUnitPrice: { __typename?: 'Money', amount: number, currency: string }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }>, variant: { __typename?: 'ProductVariant', id: string, sku?: string | null, product: { __typename?: 'Product', id: string, name: string, watchName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, strapName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, buckleName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, toolName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, warrantyName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, eyewearModel?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, digitalItemName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, translation?: { __typename?: 'ProductTranslation', name?: string | null } | null, defaultVariant?: { __typename?: 'ProductVariant', sku?: string | null, pricing?: { __typename?: 'VariantPricingInfo', price?: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } } | null } | null } | null, color?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, caseMaterial?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, strapMaterial?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, size?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, compatibleStraps?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, buckle?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, strapColor?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, warrantyExtensionDuration?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, warrantyMovementDuration?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, wristSizeMinInch?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, wristSizeMaxInch?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, wristSizeMinMm?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, wristSizeMaxMm?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, marketingPartner?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, media?: Array<{ __typename?: 'ProductMedia', url: string, alt: string, type: ProductMediaType, strapPreviewCoordinates?: string | null, backEngravingCoordinates?: string | null, shotType?: string | null }> | null, personalizedEngraving?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', boolean?: boolean | null, slug?: string | null }> } | null, productType: { __typename?: 'ProductType', slug: string, name: string }, thumbnail?: { __typename?: 'Image', alt?: string | null, url: string } | null, collections?: Array<{ __typename?: 'Collection', name: string, slug: string, translation?: { __typename?: 'CollectionTranslation', name?: string | null } | null }> | null, model?: { __typename?: 'SelectedAttribute', values: Array<{ __typename?: 'AttributeValue', slug?: string | null }> } | null, collectionName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null } } }> };

export type ChoiceValueFragment = { __typename?: 'ChoiceValue', raw?: string | null, verbose?: string | null };

export type CollectionBasicFragment = { __typename?: 'Collection', id: string, name: string, description?: string | null, slug: string, translation?: { __typename?: 'CollectionTranslation', id: string, name?: string | null, description?: string | null } | null };

export type CollectionDetailsFragment = { __typename?: 'Collection', id: string, seoTitle?: string | null, seoDescription?: string | null, description?: string | null, name: string, slug: string, translation?: { __typename?: 'CollectionTranslation', id: string, description?: string | null, name?: string | null } | null, backgroundImage?: { __typename?: 'Image', alt?: string | null, url: string } | null };

export type CountryFragment = { __typename?: 'CountryDisplay', code: string, country: string };

type CustomerTitleMetadata_Address_Fragment = { __typename?: 'Address', shippingTitle?: string | null, billingTitle?: string | null };

type CustomerTitleMetadata_App_Fragment = { __typename?: 'App', shippingTitle?: string | null, billingTitle?: string | null };

type CustomerTitleMetadata_Attribute_Fragment = { __typename?: 'Attribute', shippingTitle?: string | null, billingTitle?: string | null };

type CustomerTitleMetadata_Category_Fragment = { __typename?: 'Category', shippingTitle?: string | null, billingTitle?: string | null };

type CustomerTitleMetadata_Channel_Fragment = { __typename?: 'Channel', shippingTitle?: string | null, billingTitle?: string | null };

type CustomerTitleMetadata_Checkout_Fragment = { __typename?: 'Checkout', shippingTitle?: string | null, billingTitle?: string | null };

type CustomerTitleMetadata_CheckoutLine_Fragment = { __typename?: 'CheckoutLine', shippingTitle?: string | null, billingTitle?: string | null };

type CustomerTitleMetadata_Collection_Fragment = { __typename?: 'Collection', shippingTitle?: string | null, billingTitle?: string | null };

type CustomerTitleMetadata_DigitalContent_Fragment = { __typename?: 'DigitalContent', shippingTitle?: string | null, billingTitle?: string | null };

type CustomerTitleMetadata_Fulfillment_Fragment = { __typename?: 'Fulfillment', shippingTitle?: string | null, billingTitle?: string | null };

type CustomerTitleMetadata_GiftCard_Fragment = { __typename?: 'GiftCard', shippingTitle?: string | null, billingTitle?: string | null };

type CustomerTitleMetadata_Invoice_Fragment = { __typename?: 'Invoice', shippingTitle?: string | null, billingTitle?: string | null };

type CustomerTitleMetadata_Menu_Fragment = { __typename?: 'Menu', shippingTitle?: string | null, billingTitle?: string | null };

type CustomerTitleMetadata_MenuItem_Fragment = { __typename?: 'MenuItem', shippingTitle?: string | null, billingTitle?: string | null };

type CustomerTitleMetadata_Order_Fragment = { __typename?: 'Order', shippingTitle?: string | null, billingTitle?: string | null };

type CustomerTitleMetadata_OrderLine_Fragment = { __typename?: 'OrderLine', shippingTitle?: string | null, billingTitle?: string | null };

type CustomerTitleMetadata_Page_Fragment = { __typename?: 'Page', shippingTitle?: string | null, billingTitle?: string | null };

type CustomerTitleMetadata_PageType_Fragment = { __typename?: 'PageType', shippingTitle?: string | null, billingTitle?: string | null };

type CustomerTitleMetadata_Payment_Fragment = { __typename?: 'Payment', shippingTitle?: string | null, billingTitle?: string | null };

type CustomerTitleMetadata_Product_Fragment = { __typename?: 'Product', shippingTitle?: string | null, billingTitle?: string | null };

type CustomerTitleMetadata_ProductMedia_Fragment = { __typename?: 'ProductMedia', shippingTitle?: string | null, billingTitle?: string | null };

type CustomerTitleMetadata_ProductType_Fragment = { __typename?: 'ProductType', shippingTitle?: string | null, billingTitle?: string | null };

type CustomerTitleMetadata_ProductVariant_Fragment = { __typename?: 'ProductVariant', shippingTitle?: string | null, billingTitle?: string | null };

type CustomerTitleMetadata_Promotion_Fragment = { __typename?: 'Promotion', shippingTitle?: string | null, billingTitle?: string | null };

type CustomerTitleMetadata_Sale_Fragment = { __typename?: 'Sale', shippingTitle?: string | null, billingTitle?: string | null };

type CustomerTitleMetadata_ShippingMethod_Fragment = { __typename?: 'ShippingMethod', shippingTitle?: string | null, billingTitle?: string | null };

type CustomerTitleMetadata_ShippingMethodType_Fragment = { __typename?: 'ShippingMethodType', shippingTitle?: string | null, billingTitle?: string | null };

type CustomerTitleMetadata_ShippingZone_Fragment = { __typename?: 'ShippingZone', shippingTitle?: string | null, billingTitle?: string | null };

type CustomerTitleMetadata_Shop_Fragment = { __typename?: 'Shop', shippingTitle?: string | null, billingTitle?: string | null };

type CustomerTitleMetadata_TaxClass_Fragment = { __typename?: 'TaxClass', shippingTitle?: string | null, billingTitle?: string | null };

type CustomerTitleMetadata_TaxConfiguration_Fragment = { __typename?: 'TaxConfiguration', shippingTitle?: string | null, billingTitle?: string | null };

type CustomerTitleMetadata_TransactionItem_Fragment = { __typename?: 'TransactionItem', shippingTitle?: string | null, billingTitle?: string | null };

type CustomerTitleMetadata_User_Fragment = { __typename?: 'User', shippingTitle?: string | null, billingTitle?: string | null };

type CustomerTitleMetadata_Voucher_Fragment = { __typename?: 'Voucher', shippingTitle?: string | null, billingTitle?: string | null };

type CustomerTitleMetadata_Warehouse_Fragment = { __typename?: 'Warehouse', shippingTitle?: string | null, billingTitle?: string | null };

export type CustomerTitleMetadataFragment = CustomerTitleMetadata_Address_Fragment | CustomerTitleMetadata_App_Fragment | CustomerTitleMetadata_Attribute_Fragment | CustomerTitleMetadata_Category_Fragment | CustomerTitleMetadata_Channel_Fragment | CustomerTitleMetadata_Checkout_Fragment | CustomerTitleMetadata_CheckoutLine_Fragment | CustomerTitleMetadata_Collection_Fragment | CustomerTitleMetadata_DigitalContent_Fragment | CustomerTitleMetadata_Fulfillment_Fragment | CustomerTitleMetadata_GiftCard_Fragment | CustomerTitleMetadata_Invoice_Fragment | CustomerTitleMetadata_Menu_Fragment | CustomerTitleMetadata_MenuItem_Fragment | CustomerTitleMetadata_Order_Fragment | CustomerTitleMetadata_OrderLine_Fragment | CustomerTitleMetadata_Page_Fragment | CustomerTitleMetadata_PageType_Fragment | CustomerTitleMetadata_Payment_Fragment | CustomerTitleMetadata_Product_Fragment | CustomerTitleMetadata_ProductMedia_Fragment | CustomerTitleMetadata_ProductType_Fragment | CustomerTitleMetadata_ProductVariant_Fragment | CustomerTitleMetadata_Promotion_Fragment | CustomerTitleMetadata_Sale_Fragment | CustomerTitleMetadata_ShippingMethod_Fragment | CustomerTitleMetadata_ShippingMethodType_Fragment | CustomerTitleMetadata_ShippingZone_Fragment | CustomerTitleMetadata_Shop_Fragment | CustomerTitleMetadata_TaxClass_Fragment | CustomerTitleMetadata_TaxConfiguration_Fragment | CustomerTitleMetadata_TransactionItem_Fragment | CustomerTitleMetadata_User_Fragment | CustomerTitleMetadata_Voucher_Fragment | CustomerTitleMetadata_Warehouse_Fragment;

type DeliveryMethod_ShippingMethod_Fragment = { __typename?: 'ShippingMethod', id: string, name: string, minimumDeliveryDays?: number | null, maximumDeliveryDays?: number | null, translation?: { __typename?: 'ShippingMethodTranslation', name?: string | null } | null, price: { __typename?: 'Money', amount: number, currency: string } };

type DeliveryMethod_Warehouse_Fragment = { __typename?: 'Warehouse', id: string, name: string, email: string, address: { __typename?: 'Address', id: string, city: string, cityArea: string, companyName: string, countryArea: string, firstName: string, isDefaultBillingAddress?: boolean | null, isDefaultShippingAddress?: boolean | null, lastName: string, phone?: string | null, postalCode: string, streetAddress1: string, streetAddress2: string, country: { __typename?: 'CountryDisplay', code: string, country: string }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> } };

export type DeliveryMethodFragment = DeliveryMethod_ShippingMethod_Fragment | DeliveryMethod_Warehouse_Fragment;

export type DiscountsFragment = { __typename?: 'OrderDiscount', id: string, type: OrderDiscountType, name?: string | null, value: any, valueType: DiscountValueTypeEnum, amount: { __typename?: 'Money', amount: number, currency: string } };

export type DropdownAttributeFragment = { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> };

export type EyewearAttributesFragment = { __typename?: 'Product', marketingDescription?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, frameShape?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, frameColor?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, frameMaterial?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, coreWire?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, templeTipDetail?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, frontalPins?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, lensSurface?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, lensColor?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, lensCoating?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, uvProtection?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, frontalWidth?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string } | null }> } | null, templeLength?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string } | null }> } | null, lensWidth?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string } | null }> } | null, bridgeWidth?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string } | null }> } | null, bundleVariations?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, manualUrl?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, eyewearModelStory?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, marketingStatus?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, launchDate?: { __typename?: 'SelectedAttribute', values: Array<{ __typename?: 'AttributeValue', name?: string | null }> } | null };

export type FulfillmentFragment = { __typename?: 'Fulfillment', id: string, created: string, status: FulfillmentStatus, trackingNumber: string, returnBid?: string | null, returnCreatedAt?: string | null, returnCreatedBy?: string | null, returnStatus?: string | null, trackingUrl?: string | null, trackingCarrier?: string | null, lines?: Array<{ __typename?: 'FulfillmentLine', id: string, quantity: number, orderLine?: { __typename?: 'OrderLine', id: string, productName: string, unitDiscountValue: any, relatedWatchSku?: string | null, relatedWatchSn?: string | null, warrantyDuration?: string | null, relatedProductWatchId?: string | null, totalPrice: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } }, variant?: { __typename?: 'ProductVariant', sku?: string | null, product: { __typename?: 'Product', id: string, thumbnail?: { __typename?: 'Image', alt?: string | null, url: string } | null, media?: Array<{ __typename?: 'ProductMedia', url: string, alt: string, type: ProductMediaType, strapPreviewCoordinates?: string | null, backEngravingCoordinates?: string | null, shotType?: string | null }> | null, productType: { __typename?: 'ProductType', name: string, slug: string }, watchName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, strapName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, buckleName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, toolName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, warrantyName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, eyewearModel?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, digitalItemName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null } } | null, unitPrice: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } }, undiscountedUnitPrice: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } }, unitDiscount: { __typename?: 'Money', amount: number, currency: string }, thumbnail?: { __typename?: 'Image', alt?: string | null, url: string } | null, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> } | null }> | null };

type FulfillmentReturnMetadata_Address_Fragment = { __typename?: 'Address', returnBid?: string | null, returnCreatedAt?: string | null, returnCreatedBy?: string | null, returnStatus?: string | null };

type FulfillmentReturnMetadata_App_Fragment = { __typename?: 'App', returnBid?: string | null, returnCreatedAt?: string | null, returnCreatedBy?: string | null, returnStatus?: string | null };

type FulfillmentReturnMetadata_Attribute_Fragment = { __typename?: 'Attribute', returnBid?: string | null, returnCreatedAt?: string | null, returnCreatedBy?: string | null, returnStatus?: string | null };

type FulfillmentReturnMetadata_Category_Fragment = { __typename?: 'Category', returnBid?: string | null, returnCreatedAt?: string | null, returnCreatedBy?: string | null, returnStatus?: string | null };

type FulfillmentReturnMetadata_Channel_Fragment = { __typename?: 'Channel', returnBid?: string | null, returnCreatedAt?: string | null, returnCreatedBy?: string | null, returnStatus?: string | null };

type FulfillmentReturnMetadata_Checkout_Fragment = { __typename?: 'Checkout', returnBid?: string | null, returnCreatedAt?: string | null, returnCreatedBy?: string | null, returnStatus?: string | null };

type FulfillmentReturnMetadata_CheckoutLine_Fragment = { __typename?: 'CheckoutLine', returnBid?: string | null, returnCreatedAt?: string | null, returnCreatedBy?: string | null, returnStatus?: string | null };

type FulfillmentReturnMetadata_Collection_Fragment = { __typename?: 'Collection', returnBid?: string | null, returnCreatedAt?: string | null, returnCreatedBy?: string | null, returnStatus?: string | null };

type FulfillmentReturnMetadata_DigitalContent_Fragment = { __typename?: 'DigitalContent', returnBid?: string | null, returnCreatedAt?: string | null, returnCreatedBy?: string | null, returnStatus?: string | null };

type FulfillmentReturnMetadata_Fulfillment_Fragment = { __typename?: 'Fulfillment', returnBid?: string | null, returnCreatedAt?: string | null, returnCreatedBy?: string | null, returnStatus?: string | null };

type FulfillmentReturnMetadata_GiftCard_Fragment = { __typename?: 'GiftCard', returnBid?: string | null, returnCreatedAt?: string | null, returnCreatedBy?: string | null, returnStatus?: string | null };

type FulfillmentReturnMetadata_Invoice_Fragment = { __typename?: 'Invoice', returnBid?: string | null, returnCreatedAt?: string | null, returnCreatedBy?: string | null, returnStatus?: string | null };

type FulfillmentReturnMetadata_Menu_Fragment = { __typename?: 'Menu', returnBid?: string | null, returnCreatedAt?: string | null, returnCreatedBy?: string | null, returnStatus?: string | null };

type FulfillmentReturnMetadata_MenuItem_Fragment = { __typename?: 'MenuItem', returnBid?: string | null, returnCreatedAt?: string | null, returnCreatedBy?: string | null, returnStatus?: string | null };

type FulfillmentReturnMetadata_Order_Fragment = { __typename?: 'Order', returnBid?: string | null, returnCreatedAt?: string | null, returnCreatedBy?: string | null, returnStatus?: string | null };

type FulfillmentReturnMetadata_OrderLine_Fragment = { __typename?: 'OrderLine', returnBid?: string | null, returnCreatedAt?: string | null, returnCreatedBy?: string | null, returnStatus?: string | null };

type FulfillmentReturnMetadata_Page_Fragment = { __typename?: 'Page', returnBid?: string | null, returnCreatedAt?: string | null, returnCreatedBy?: string | null, returnStatus?: string | null };

type FulfillmentReturnMetadata_PageType_Fragment = { __typename?: 'PageType', returnBid?: string | null, returnCreatedAt?: string | null, returnCreatedBy?: string | null, returnStatus?: string | null };

type FulfillmentReturnMetadata_Payment_Fragment = { __typename?: 'Payment', returnBid?: string | null, returnCreatedAt?: string | null, returnCreatedBy?: string | null, returnStatus?: string | null };

type FulfillmentReturnMetadata_Product_Fragment = { __typename?: 'Product', returnBid?: string | null, returnCreatedAt?: string | null, returnCreatedBy?: string | null, returnStatus?: string | null };

type FulfillmentReturnMetadata_ProductMedia_Fragment = { __typename?: 'ProductMedia', returnBid?: string | null, returnCreatedAt?: string | null, returnCreatedBy?: string | null, returnStatus?: string | null };

type FulfillmentReturnMetadata_ProductType_Fragment = { __typename?: 'ProductType', returnBid?: string | null, returnCreatedAt?: string | null, returnCreatedBy?: string | null, returnStatus?: string | null };

type FulfillmentReturnMetadata_ProductVariant_Fragment = { __typename?: 'ProductVariant', returnBid?: string | null, returnCreatedAt?: string | null, returnCreatedBy?: string | null, returnStatus?: string | null };

type FulfillmentReturnMetadata_Promotion_Fragment = { __typename?: 'Promotion', returnBid?: string | null, returnCreatedAt?: string | null, returnCreatedBy?: string | null, returnStatus?: string | null };

type FulfillmentReturnMetadata_Sale_Fragment = { __typename?: 'Sale', returnBid?: string | null, returnCreatedAt?: string | null, returnCreatedBy?: string | null, returnStatus?: string | null };

type FulfillmentReturnMetadata_ShippingMethod_Fragment = { __typename?: 'ShippingMethod', returnBid?: string | null, returnCreatedAt?: string | null, returnCreatedBy?: string | null, returnStatus?: string | null };

type FulfillmentReturnMetadata_ShippingMethodType_Fragment = { __typename?: 'ShippingMethodType', returnBid?: string | null, returnCreatedAt?: string | null, returnCreatedBy?: string | null, returnStatus?: string | null };

type FulfillmentReturnMetadata_ShippingZone_Fragment = { __typename?: 'ShippingZone', returnBid?: string | null, returnCreatedAt?: string | null, returnCreatedBy?: string | null, returnStatus?: string | null };

type FulfillmentReturnMetadata_Shop_Fragment = { __typename?: 'Shop', returnBid?: string | null, returnCreatedAt?: string | null, returnCreatedBy?: string | null, returnStatus?: string | null };

type FulfillmentReturnMetadata_TaxClass_Fragment = { __typename?: 'TaxClass', returnBid?: string | null, returnCreatedAt?: string | null, returnCreatedBy?: string | null, returnStatus?: string | null };

type FulfillmentReturnMetadata_TaxConfiguration_Fragment = { __typename?: 'TaxConfiguration', returnBid?: string | null, returnCreatedAt?: string | null, returnCreatedBy?: string | null, returnStatus?: string | null };

type FulfillmentReturnMetadata_TransactionItem_Fragment = { __typename?: 'TransactionItem', returnBid?: string | null, returnCreatedAt?: string | null, returnCreatedBy?: string | null, returnStatus?: string | null };

type FulfillmentReturnMetadata_User_Fragment = { __typename?: 'User', returnBid?: string | null, returnCreatedAt?: string | null, returnCreatedBy?: string | null, returnStatus?: string | null };

type FulfillmentReturnMetadata_Voucher_Fragment = { __typename?: 'Voucher', returnBid?: string | null, returnCreatedAt?: string | null, returnCreatedBy?: string | null, returnStatus?: string | null };

type FulfillmentReturnMetadata_Warehouse_Fragment = { __typename?: 'Warehouse', returnBid?: string | null, returnCreatedAt?: string | null, returnCreatedBy?: string | null, returnStatus?: string | null };

export type FulfillmentReturnMetadataFragment = FulfillmentReturnMetadata_Address_Fragment | FulfillmentReturnMetadata_App_Fragment | FulfillmentReturnMetadata_Attribute_Fragment | FulfillmentReturnMetadata_Category_Fragment | FulfillmentReturnMetadata_Channel_Fragment | FulfillmentReturnMetadata_Checkout_Fragment | FulfillmentReturnMetadata_CheckoutLine_Fragment | FulfillmentReturnMetadata_Collection_Fragment | FulfillmentReturnMetadata_DigitalContent_Fragment | FulfillmentReturnMetadata_Fulfillment_Fragment | FulfillmentReturnMetadata_GiftCard_Fragment | FulfillmentReturnMetadata_Invoice_Fragment | FulfillmentReturnMetadata_Menu_Fragment | FulfillmentReturnMetadata_MenuItem_Fragment | FulfillmentReturnMetadata_Order_Fragment | FulfillmentReturnMetadata_OrderLine_Fragment | FulfillmentReturnMetadata_Page_Fragment | FulfillmentReturnMetadata_PageType_Fragment | FulfillmentReturnMetadata_Payment_Fragment | FulfillmentReturnMetadata_Product_Fragment | FulfillmentReturnMetadata_ProductMedia_Fragment | FulfillmentReturnMetadata_ProductType_Fragment | FulfillmentReturnMetadata_ProductVariant_Fragment | FulfillmentReturnMetadata_Promotion_Fragment | FulfillmentReturnMetadata_Sale_Fragment | FulfillmentReturnMetadata_ShippingMethod_Fragment | FulfillmentReturnMetadata_ShippingMethodType_Fragment | FulfillmentReturnMetadata_ShippingZone_Fragment | FulfillmentReturnMetadata_Shop_Fragment | FulfillmentReturnMetadata_TaxClass_Fragment | FulfillmentReturnMetadata_TaxConfiguration_Fragment | FulfillmentReturnMetadata_TransactionItem_Fragment | FulfillmentReturnMetadata_User_Fragment | FulfillmentReturnMetadata_Voucher_Fragment | FulfillmentReturnMetadata_Warehouse_Fragment;

type FulfillmentTrackingMetadata_Address_Fragment = { __typename?: 'Address', trackingUrl?: string | null, trackingCarrier?: string | null };

type FulfillmentTrackingMetadata_App_Fragment = { __typename?: 'App', trackingUrl?: string | null, trackingCarrier?: string | null };

type FulfillmentTrackingMetadata_Attribute_Fragment = { __typename?: 'Attribute', trackingUrl?: string | null, trackingCarrier?: string | null };

type FulfillmentTrackingMetadata_Category_Fragment = { __typename?: 'Category', trackingUrl?: string | null, trackingCarrier?: string | null };

type FulfillmentTrackingMetadata_Channel_Fragment = { __typename?: 'Channel', trackingUrl?: string | null, trackingCarrier?: string | null };

type FulfillmentTrackingMetadata_Checkout_Fragment = { __typename?: 'Checkout', trackingUrl?: string | null, trackingCarrier?: string | null };

type FulfillmentTrackingMetadata_CheckoutLine_Fragment = { __typename?: 'CheckoutLine', trackingUrl?: string | null, trackingCarrier?: string | null };

type FulfillmentTrackingMetadata_Collection_Fragment = { __typename?: 'Collection', trackingUrl?: string | null, trackingCarrier?: string | null };

type FulfillmentTrackingMetadata_DigitalContent_Fragment = { __typename?: 'DigitalContent', trackingUrl?: string | null, trackingCarrier?: string | null };

type FulfillmentTrackingMetadata_Fulfillment_Fragment = { __typename?: 'Fulfillment', trackingUrl?: string | null, trackingCarrier?: string | null };

type FulfillmentTrackingMetadata_GiftCard_Fragment = { __typename?: 'GiftCard', trackingUrl?: string | null, trackingCarrier?: string | null };

type FulfillmentTrackingMetadata_Invoice_Fragment = { __typename?: 'Invoice', trackingUrl?: string | null, trackingCarrier?: string | null };

type FulfillmentTrackingMetadata_Menu_Fragment = { __typename?: 'Menu', trackingUrl?: string | null, trackingCarrier?: string | null };

type FulfillmentTrackingMetadata_MenuItem_Fragment = { __typename?: 'MenuItem', trackingUrl?: string | null, trackingCarrier?: string | null };

type FulfillmentTrackingMetadata_Order_Fragment = { __typename?: 'Order', trackingUrl?: string | null, trackingCarrier?: string | null };

type FulfillmentTrackingMetadata_OrderLine_Fragment = { __typename?: 'OrderLine', trackingUrl?: string | null, trackingCarrier?: string | null };

type FulfillmentTrackingMetadata_Page_Fragment = { __typename?: 'Page', trackingUrl?: string | null, trackingCarrier?: string | null };

type FulfillmentTrackingMetadata_PageType_Fragment = { __typename?: 'PageType', trackingUrl?: string | null, trackingCarrier?: string | null };

type FulfillmentTrackingMetadata_Payment_Fragment = { __typename?: 'Payment', trackingUrl?: string | null, trackingCarrier?: string | null };

type FulfillmentTrackingMetadata_Product_Fragment = { __typename?: 'Product', trackingUrl?: string | null, trackingCarrier?: string | null };

type FulfillmentTrackingMetadata_ProductMedia_Fragment = { __typename?: 'ProductMedia', trackingUrl?: string | null, trackingCarrier?: string | null };

type FulfillmentTrackingMetadata_ProductType_Fragment = { __typename?: 'ProductType', trackingUrl?: string | null, trackingCarrier?: string | null };

type FulfillmentTrackingMetadata_ProductVariant_Fragment = { __typename?: 'ProductVariant', trackingUrl?: string | null, trackingCarrier?: string | null };

type FulfillmentTrackingMetadata_Promotion_Fragment = { __typename?: 'Promotion', trackingUrl?: string | null, trackingCarrier?: string | null };

type FulfillmentTrackingMetadata_Sale_Fragment = { __typename?: 'Sale', trackingUrl?: string | null, trackingCarrier?: string | null };

type FulfillmentTrackingMetadata_ShippingMethod_Fragment = { __typename?: 'ShippingMethod', trackingUrl?: string | null, trackingCarrier?: string | null };

type FulfillmentTrackingMetadata_ShippingMethodType_Fragment = { __typename?: 'ShippingMethodType', trackingUrl?: string | null, trackingCarrier?: string | null };

type FulfillmentTrackingMetadata_ShippingZone_Fragment = { __typename?: 'ShippingZone', trackingUrl?: string | null, trackingCarrier?: string | null };

type FulfillmentTrackingMetadata_Shop_Fragment = { __typename?: 'Shop', trackingUrl?: string | null, trackingCarrier?: string | null };

type FulfillmentTrackingMetadata_TaxClass_Fragment = { __typename?: 'TaxClass', trackingUrl?: string | null, trackingCarrier?: string | null };

type FulfillmentTrackingMetadata_TaxConfiguration_Fragment = { __typename?: 'TaxConfiguration', trackingUrl?: string | null, trackingCarrier?: string | null };

type FulfillmentTrackingMetadata_TransactionItem_Fragment = { __typename?: 'TransactionItem', trackingUrl?: string | null, trackingCarrier?: string | null };

type FulfillmentTrackingMetadata_User_Fragment = { __typename?: 'User', trackingUrl?: string | null, trackingCarrier?: string | null };

type FulfillmentTrackingMetadata_Voucher_Fragment = { __typename?: 'Voucher', trackingUrl?: string | null, trackingCarrier?: string | null };

type FulfillmentTrackingMetadata_Warehouse_Fragment = { __typename?: 'Warehouse', trackingUrl?: string | null, trackingCarrier?: string | null };

export type FulfillmentTrackingMetadataFragment = FulfillmentTrackingMetadata_Address_Fragment | FulfillmentTrackingMetadata_App_Fragment | FulfillmentTrackingMetadata_Attribute_Fragment | FulfillmentTrackingMetadata_Category_Fragment | FulfillmentTrackingMetadata_Channel_Fragment | FulfillmentTrackingMetadata_Checkout_Fragment | FulfillmentTrackingMetadata_CheckoutLine_Fragment | FulfillmentTrackingMetadata_Collection_Fragment | FulfillmentTrackingMetadata_DigitalContent_Fragment | FulfillmentTrackingMetadata_Fulfillment_Fragment | FulfillmentTrackingMetadata_GiftCard_Fragment | FulfillmentTrackingMetadata_Invoice_Fragment | FulfillmentTrackingMetadata_Menu_Fragment | FulfillmentTrackingMetadata_MenuItem_Fragment | FulfillmentTrackingMetadata_Order_Fragment | FulfillmentTrackingMetadata_OrderLine_Fragment | FulfillmentTrackingMetadata_Page_Fragment | FulfillmentTrackingMetadata_PageType_Fragment | FulfillmentTrackingMetadata_Payment_Fragment | FulfillmentTrackingMetadata_Product_Fragment | FulfillmentTrackingMetadata_ProductMedia_Fragment | FulfillmentTrackingMetadata_ProductType_Fragment | FulfillmentTrackingMetadata_ProductVariant_Fragment | FulfillmentTrackingMetadata_Promotion_Fragment | FulfillmentTrackingMetadata_Sale_Fragment | FulfillmentTrackingMetadata_ShippingMethod_Fragment | FulfillmentTrackingMetadata_ShippingMethodType_Fragment | FulfillmentTrackingMetadata_ShippingZone_Fragment | FulfillmentTrackingMetadata_Shop_Fragment | FulfillmentTrackingMetadata_TaxClass_Fragment | FulfillmentTrackingMetadata_TaxConfiguration_Fragment | FulfillmentTrackingMetadata_TransactionItem_Fragment | FulfillmentTrackingMetadata_User_Fragment | FulfillmentTrackingMetadata_Voucher_Fragment | FulfillmentTrackingMetadata_Warehouse_Fragment;

type GiftMetadata_Address_Fragment = { __typename?: 'Address', isGift?: string | null, giftFrom?: string | null, giftMessage?: string | null };

type GiftMetadata_App_Fragment = { __typename?: 'App', isGift?: string | null, giftFrom?: string | null, giftMessage?: string | null };

type GiftMetadata_Attribute_Fragment = { __typename?: 'Attribute', isGift?: string | null, giftFrom?: string | null, giftMessage?: string | null };

type GiftMetadata_Category_Fragment = { __typename?: 'Category', isGift?: string | null, giftFrom?: string | null, giftMessage?: string | null };

type GiftMetadata_Channel_Fragment = { __typename?: 'Channel', isGift?: string | null, giftFrom?: string | null, giftMessage?: string | null };

type GiftMetadata_Checkout_Fragment = { __typename?: 'Checkout', isGift?: string | null, giftFrom?: string | null, giftMessage?: string | null };

type GiftMetadata_CheckoutLine_Fragment = { __typename?: 'CheckoutLine', isGift?: string | null, giftFrom?: string | null, giftMessage?: string | null };

type GiftMetadata_Collection_Fragment = { __typename?: 'Collection', isGift?: string | null, giftFrom?: string | null, giftMessage?: string | null };

type GiftMetadata_DigitalContent_Fragment = { __typename?: 'DigitalContent', isGift?: string | null, giftFrom?: string | null, giftMessage?: string | null };

type GiftMetadata_Fulfillment_Fragment = { __typename?: 'Fulfillment', isGift?: string | null, giftFrom?: string | null, giftMessage?: string | null };

type GiftMetadata_GiftCard_Fragment = { __typename?: 'GiftCard', isGift?: string | null, giftFrom?: string | null, giftMessage?: string | null };

type GiftMetadata_Invoice_Fragment = { __typename?: 'Invoice', isGift?: string | null, giftFrom?: string | null, giftMessage?: string | null };

type GiftMetadata_Menu_Fragment = { __typename?: 'Menu', isGift?: string | null, giftFrom?: string | null, giftMessage?: string | null };

type GiftMetadata_MenuItem_Fragment = { __typename?: 'MenuItem', isGift?: string | null, giftFrom?: string | null, giftMessage?: string | null };

type GiftMetadata_Order_Fragment = { __typename?: 'Order', isGift?: string | null, giftFrom?: string | null, giftMessage?: string | null };

type GiftMetadata_OrderLine_Fragment = { __typename?: 'OrderLine', isGift?: string | null, giftFrom?: string | null, giftMessage?: string | null };

type GiftMetadata_Page_Fragment = { __typename?: 'Page', isGift?: string | null, giftFrom?: string | null, giftMessage?: string | null };

type GiftMetadata_PageType_Fragment = { __typename?: 'PageType', isGift?: string | null, giftFrom?: string | null, giftMessage?: string | null };

type GiftMetadata_Payment_Fragment = { __typename?: 'Payment', isGift?: string | null, giftFrom?: string | null, giftMessage?: string | null };

type GiftMetadata_Product_Fragment = { __typename?: 'Product', isGift?: string | null, giftFrom?: string | null, giftMessage?: string | null };

type GiftMetadata_ProductMedia_Fragment = { __typename?: 'ProductMedia', isGift?: string | null, giftFrom?: string | null, giftMessage?: string | null };

type GiftMetadata_ProductType_Fragment = { __typename?: 'ProductType', isGift?: string | null, giftFrom?: string | null, giftMessage?: string | null };

type GiftMetadata_ProductVariant_Fragment = { __typename?: 'ProductVariant', isGift?: string | null, giftFrom?: string | null, giftMessage?: string | null };

type GiftMetadata_Promotion_Fragment = { __typename?: 'Promotion', isGift?: string | null, giftFrom?: string | null, giftMessage?: string | null };

type GiftMetadata_Sale_Fragment = { __typename?: 'Sale', isGift?: string | null, giftFrom?: string | null, giftMessage?: string | null };

type GiftMetadata_ShippingMethod_Fragment = { __typename?: 'ShippingMethod', isGift?: string | null, giftFrom?: string | null, giftMessage?: string | null };

type GiftMetadata_ShippingMethodType_Fragment = { __typename?: 'ShippingMethodType', isGift?: string | null, giftFrom?: string | null, giftMessage?: string | null };

type GiftMetadata_ShippingZone_Fragment = { __typename?: 'ShippingZone', isGift?: string | null, giftFrom?: string | null, giftMessage?: string | null };

type GiftMetadata_Shop_Fragment = { __typename?: 'Shop', isGift?: string | null, giftFrom?: string | null, giftMessage?: string | null };

type GiftMetadata_TaxClass_Fragment = { __typename?: 'TaxClass', isGift?: string | null, giftFrom?: string | null, giftMessage?: string | null };

type GiftMetadata_TaxConfiguration_Fragment = { __typename?: 'TaxConfiguration', isGift?: string | null, giftFrom?: string | null, giftMessage?: string | null };

type GiftMetadata_TransactionItem_Fragment = { __typename?: 'TransactionItem', isGift?: string | null, giftFrom?: string | null, giftMessage?: string | null };

type GiftMetadata_User_Fragment = { __typename?: 'User', isGift?: string | null, giftFrom?: string | null, giftMessage?: string | null };

type GiftMetadata_Voucher_Fragment = { __typename?: 'Voucher', isGift?: string | null, giftFrom?: string | null, giftMessage?: string | null };

type GiftMetadata_Warehouse_Fragment = { __typename?: 'Warehouse', isGift?: string | null, giftFrom?: string | null, giftMessage?: string | null };

export type GiftMetadataFragment = GiftMetadata_Address_Fragment | GiftMetadata_App_Fragment | GiftMetadata_Attribute_Fragment | GiftMetadata_Category_Fragment | GiftMetadata_Channel_Fragment | GiftMetadata_Checkout_Fragment | GiftMetadata_CheckoutLine_Fragment | GiftMetadata_Collection_Fragment | GiftMetadata_DigitalContent_Fragment | GiftMetadata_Fulfillment_Fragment | GiftMetadata_GiftCard_Fragment | GiftMetadata_Invoice_Fragment | GiftMetadata_Menu_Fragment | GiftMetadata_MenuItem_Fragment | GiftMetadata_Order_Fragment | GiftMetadata_OrderLine_Fragment | GiftMetadata_Page_Fragment | GiftMetadata_PageType_Fragment | GiftMetadata_Payment_Fragment | GiftMetadata_Product_Fragment | GiftMetadata_ProductMedia_Fragment | GiftMetadata_ProductType_Fragment | GiftMetadata_ProductVariant_Fragment | GiftMetadata_Promotion_Fragment | GiftMetadata_Sale_Fragment | GiftMetadata_ShippingMethod_Fragment | GiftMetadata_ShippingMethodType_Fragment | GiftMetadata_ShippingZone_Fragment | GiftMetadata_Shop_Fragment | GiftMetadata_TaxClass_Fragment | GiftMetadata_TaxConfiguration_Fragment | GiftMetadata_TransactionItem_Fragment | GiftMetadata_User_Fragment | GiftMetadata_Voucher_Fragment | GiftMetadata_Warehouse_Fragment;

export type ImageFragment = { __typename?: 'Image', alt?: string | null, url: string };

export type LineProductFragment = { __typename?: 'Product', id: string, name: string, translation?: { __typename?: 'ProductTranslation', name?: string | null } | null, defaultVariant?: { __typename?: 'ProductVariant', sku?: string | null, pricing?: { __typename?: 'VariantPricingInfo', price?: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } } | null } | null } | null, color?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, caseMaterial?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, strapMaterial?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, size?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, compatibleStraps?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, buckle?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, strapColor?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, warrantyExtensionDuration?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, warrantyMovementDuration?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, wristSizeMinInch?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, wristSizeMaxInch?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, wristSizeMinMm?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, wristSizeMaxMm?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, marketingPartner?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, media?: Array<{ __typename?: 'ProductMedia', url: string, alt: string, type: ProductMediaType, strapPreviewCoordinates?: string | null, backEngravingCoordinates?: string | null, shotType?: string | null }> | null, personalizedEngraving?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', boolean?: boolean | null, slug?: string | null }> } | null, productType: { __typename?: 'ProductType', slug: string, name: string }, thumbnail?: { __typename?: 'Image', alt?: string | null, url: string } | null, collections?: Array<{ __typename?: 'Collection', name: string, slug: string, translation?: { __typename?: 'CollectionTranslation', name?: string | null } | null }> | null, model?: { __typename?: 'SelectedAttribute', values: Array<{ __typename?: 'AttributeValue', slug?: string | null }> } | null, watchName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, strapName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, collectionName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, warrantyName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, eyewearModel?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, toolName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, digitalItemName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null };

export type MenuItemFragment = { __typename?: 'MenuItem', id: string, name: string, url?: string | null, translation?: { __typename?: 'MenuItemTranslation', id: string, name: string } | null, parent?: { __typename?: 'MenuItem', id: string } | null, category?: { __typename?: 'Category', id: string, slug: string } | null, collection?: { __typename?: 'Collection', id: string, slug: string } | null, page?: { __typename?: 'Page', id: string, slug: string } | null };

export type MenuItemWithChildrenFragment = { __typename?: 'MenuItem', id: string, name: string, url?: string | null, translation?: { __typename?: 'MenuItemTranslation', id: string, name: string } | null, page?: { __typename?: 'Page', id: string, slug: string } | null, children?: Array<{ __typename?: 'MenuItem', id: string, name: string, url?: string | null, children?: Array<{ __typename?: 'MenuItem', id: string, name: string, url?: string | null, translation?: { __typename?: 'MenuItemTranslation', id: string, name: string } | null, parent?: { __typename?: 'MenuItem', id: string } | null, category?: { __typename?: 'Category', id: string, slug: string } | null, collection?: { __typename?: 'Collection', id: string, slug: string } | null, page?: { __typename?: 'Page', id: string, slug: string } | null }> | null, translation?: { __typename?: 'MenuItemTranslation', id: string, name: string } | null, parent?: { __typename?: 'MenuItem', id: string } | null, category?: { __typename?: 'Category', id: string, slug: string } | null, collection?: { __typename?: 'Collection', id: string, slug: string } | null, page?: { __typename?: 'Page', id: string, slug: string } | null }> | null };

export type MetadataErrorFragment = { __typename?: 'MetadataError', field?: string | null, message?: string | null, code: MetadataErrorCode };

export type MetadataItemFragment = { __typename?: 'MetadataItem', key: string, value: string };

export type MoneyFragment = { __typename?: 'Money', amount: number, currency: string };

export type MultiselectAttributeFragment = { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> };

export type MyOrderFragment = { __typename?: 'Order', id: string, number: string, created: string, userEmail?: string | null, collectionPointName?: string | null, voucherCode?: string | null, businessId?: string | null, preOrderData?: string | null, orderType?: string | null, orderStatus?: string | null, orderCollectedDate?: string | null, payPerLinkToken?: string | null, payPerLinkExpiration?: string | null, user?: { __typename?: 'User', id: string } | null, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }>, fulfillments: Array<{ __typename?: 'Fulfillment', id: string, created: string, status: FulfillmentStatus, trackingNumber: string, returnBid?: string | null, returnCreatedAt?: string | null, returnCreatedBy?: string | null, returnStatus?: string | null, trackingUrl?: string | null, trackingCarrier?: string | null, lines?: Array<{ __typename?: 'FulfillmentLine', id: string, quantity: number, orderLine?: { __typename?: 'OrderLine', id: string, productName: string, unitDiscountValue: any, relatedWatchSku?: string | null, relatedWatchSn?: string | null, warrantyDuration?: string | null, relatedProductWatchId?: string | null, totalPrice: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } }, variant?: { __typename?: 'ProductVariant', sku?: string | null, product: { __typename?: 'Product', id: string, thumbnail?: { __typename?: 'Image', alt?: string | null, url: string } | null, media?: Array<{ __typename?: 'ProductMedia', url: string, alt: string, type: ProductMediaType, strapPreviewCoordinates?: string | null, backEngravingCoordinates?: string | null, shotType?: string | null }> | null, productType: { __typename?: 'ProductType', name: string, slug: string }, watchName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, strapName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, buckleName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, toolName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, warrantyName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, eyewearModel?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, digitalItemName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null } } | null, unitPrice: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } }, undiscountedUnitPrice: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } }, unitDiscount: { __typename?: 'Money', amount: number, currency: string }, thumbnail?: { __typename?: 'Image', alt?: string | null, url: string } | null, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> } | null }> | null }>, subtotal: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } }, total: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } }, totalBalance: { __typename?: 'Money', amount: number, currency: string }, totalCharged: { __typename?: 'Money', amount: number, currency: string }, totalAuthorized: { __typename?: 'Money', amount: number, currency: string }, lines: Array<{ __typename?: 'OrderLine', id: string, productName: string, unitDiscountValue: any, relatedWatchSku?: string | null, relatedWatchSn?: string | null, warrantyDuration?: string | null, relatedProductWatchId?: string | null, totalPrice: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } }, variant?: { __typename?: 'ProductVariant', sku?: string | null, product: { __typename?: 'Product', id: string, thumbnail?: { __typename?: 'Image', alt?: string | null, url: string } | null, media?: Array<{ __typename?: 'ProductMedia', url: string, alt: string, type: ProductMediaType, strapPreviewCoordinates?: string | null, backEngravingCoordinates?: string | null, shotType?: string | null }> | null, productType: { __typename?: 'ProductType', name: string, slug: string }, watchName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, strapName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, buckleName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, toolName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, warrantyName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, eyewearModel?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, digitalItemName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null } } | null, unitPrice: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } }, undiscountedUnitPrice: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } }, unitDiscount: { __typename?: 'Money', amount: number, currency: string }, thumbnail?: { __typename?: 'Image', alt?: string | null, url: string } | null, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> }>, discounts: Array<{ __typename?: 'OrderDiscount', id: string, type: OrderDiscountType, name?: string | null, value: any, valueType: DiscountValueTypeEnum, amount: { __typename?: 'Money', amount: number, currency: string } }>, voucher?: { __typename?: 'Voucher', id: string, name?: string | null, discountValue?: number | null, discountValueType: DiscountValueTypeEnum } | null };

export type MyOrderLineFragment = { __typename?: 'OrderLine', id: string, productName: string, unitDiscountValue: any, relatedWatchSku?: string | null, relatedWatchSn?: string | null, warrantyDuration?: string | null, relatedProductWatchId?: string | null, totalPrice: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } }, variant?: { __typename?: 'ProductVariant', sku?: string | null, product: { __typename?: 'Product', id: string, thumbnail?: { __typename?: 'Image', alt?: string | null, url: string } | null, media?: Array<{ __typename?: 'ProductMedia', url: string, alt: string, type: ProductMediaType, strapPreviewCoordinates?: string | null, backEngravingCoordinates?: string | null, shotType?: string | null }> | null, productType: { __typename?: 'ProductType', name: string, slug: string }, watchName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, strapName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, buckleName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, toolName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, warrantyName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, eyewearModel?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, digitalItemName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null } } | null, unitPrice: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } }, undiscountedUnitPrice: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } }, unitDiscount: { __typename?: 'Money', amount: number, currency: string }, thumbnail?: { __typename?: 'Image', alt?: string | null, url: string } | null, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> };

export type NumericAttributeFragment = { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string } | null }> };

export type OrderFragment = { __typename?: 'Order', id: string, userEmail?: string | null, isShippingRequired: boolean, voucherCode?: string | null, isOfflinePayment?: string | null, deliveryMode?: string | null, shippingTitle?: string | null, billingTitle?: string | null, preOrderData?: string | null, orderType?: string | null, orderStatus?: string | null, orderCollectedDate?: string | null, payPerLinkToken?: string | null, payPerLinkExpiration?: string | null, isGift?: string | null, giftFrom?: string | null, giftMessage?: string | null, timeSlot?: string | null, paymentMethod?: string | null, orderFlowScTermsRequired?: string | null, orderFlowScTermsAccepted?: string | null, orderFlowWasUserAuthenticated?: string | null, orderFlowWasRegisterMyWatchChecked?: string | null, orderFlowWasCreateMyAccountWithoutWatchChecked?: string | null, orderFlowWasAccountCreated?: string | null, orderFlowUserJoinClub?: string | null, orderFlowUserAffiliated?: string | null, orderFlowReceiveReceipt?: string | null, checkoutId?: string | null, lines: Array<{ __typename?: 'OrderLine', id: string, productName: string, translatedProductName: string, quantity: number, relatedProductBuckleId?: string | null, relatedProductStrapId?: string | null, relatedProductWatchId?: string | null, relatedBraceletSize?: string | null, relatedEngravingId?: string | null, strapPackReference?: string | null, strapReference?: string | null, strapSize?: string | null, warrantyDuration?: string | null, unitPrice: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } }, totalPrice: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } }, variant?: { __typename?: 'ProductVariant', id: string, sku?: string | null, product: { __typename?: 'Product', id: string, name: string, watchName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, strapName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, buckleName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, toolName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, warrantyName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, eyewearModel?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, digitalItemName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, translation?: { __typename?: 'ProductTranslation', name?: string | null } | null, defaultVariant?: { __typename?: 'ProductVariant', sku?: string | null, pricing?: { __typename?: 'VariantPricingInfo', price?: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } } | null } | null } | null, color?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, caseMaterial?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, strapMaterial?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, size?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, compatibleStraps?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, buckle?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, strapColor?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, warrantyExtensionDuration?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, warrantyMovementDuration?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, wristSizeMinInch?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, wristSizeMaxInch?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, wristSizeMinMm?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, wristSizeMaxMm?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, marketingPartner?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, media?: Array<{ __typename?: 'ProductMedia', url: string, alt: string, type: ProductMediaType, strapPreviewCoordinates?: string | null, backEngravingCoordinates?: string | null, shotType?: string | null }> | null, personalizedEngraving?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', boolean?: boolean | null, slug?: string | null }> } | null, productType: { __typename?: 'ProductType', slug: string, name: string }, thumbnail?: { __typename?: 'Image', alt?: string | null, url: string } | null, collections?: Array<{ __typename?: 'Collection', name: string, slug: string, translation?: { __typename?: 'CollectionTranslation', name?: string | null } | null }> | null, model?: { __typename?: 'SelectedAttribute', values: Array<{ __typename?: 'AttributeValue', slug?: string | null }> } | null, collectionName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null } } | null, undiscountedUnitPrice: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } }, unitDiscount: { __typename?: 'Money', amount: number, currency: string }, thumbnail?: { __typename?: 'Image', alt?: string | null, url: string } | null, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> }>, subtotal: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } }, shippingPrice: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } }, total: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } }, channel: { __typename?: 'Channel', slug: string }, totalBalance: { __typename?: 'Money', amount: number, currency: string }, totalCharged: { __typename?: 'Money', amount: number, currency: string }, totalAuthorized: { __typename?: 'Money', amount: number, currency: string }, shippingAddress?: { __typename?: 'Address', id: string, city: string, cityArea: string, companyName: string, countryArea: string, firstName: string, isDefaultBillingAddress?: boolean | null, isDefaultShippingAddress?: boolean | null, lastName: string, phone?: string | null, postalCode: string, streetAddress1: string, streetAddress2: string, country: { __typename?: 'CountryDisplay', code: string, country: string }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> } | null, billingAddress?: { __typename?: 'Address', id: string, city: string, cityArea: string, companyName: string, countryArea: string, firstName: string, isDefaultBillingAddress?: boolean | null, isDefaultShippingAddress?: boolean | null, lastName: string, phone?: string | null, postalCode: string, streetAddress1: string, streetAddress2: string, country: { __typename?: 'CountryDisplay', code: string, country: string }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> } | null, discounts: Array<{ __typename?: 'OrderDiscount', id: string, type: OrderDiscountType, name?: string | null, value: any, valueType: DiscountValueTypeEnum, amount: { __typename?: 'Money', amount: number, currency: string } }>, voucher?: { __typename?: 'Voucher', id: string, name?: string | null, discountValue?: number | null, discountValueType: DiscountValueTypeEnum } | null };

export type OrderErrorFragment = { __typename?: 'OrderError', code: OrderErrorCode, field?: string | null, message?: string | null };

type OrderFlowMetadata_Address_Fragment = { __typename?: 'Address', orderFlowScTermsRequired?: string | null, orderFlowScTermsAccepted?: string | null, orderFlowWasUserAuthenticated?: string | null, orderFlowWasRegisterMyWatchChecked?: string | null, orderFlowWasCreateMyAccountWithoutWatchChecked?: string | null, orderFlowWasAccountCreated?: string | null, orderFlowUserJoinClub?: string | null, orderFlowUserAffiliated?: string | null, orderFlowReceiveReceipt?: string | null, checkoutId?: string | null };

type OrderFlowMetadata_App_Fragment = { __typename?: 'App', orderFlowScTermsRequired?: string | null, orderFlowScTermsAccepted?: string | null, orderFlowWasUserAuthenticated?: string | null, orderFlowWasRegisterMyWatchChecked?: string | null, orderFlowWasCreateMyAccountWithoutWatchChecked?: string | null, orderFlowWasAccountCreated?: string | null, orderFlowUserJoinClub?: string | null, orderFlowUserAffiliated?: string | null, orderFlowReceiveReceipt?: string | null, checkoutId?: string | null };

type OrderFlowMetadata_Attribute_Fragment = { __typename?: 'Attribute', orderFlowScTermsRequired?: string | null, orderFlowScTermsAccepted?: string | null, orderFlowWasUserAuthenticated?: string | null, orderFlowWasRegisterMyWatchChecked?: string | null, orderFlowWasCreateMyAccountWithoutWatchChecked?: string | null, orderFlowWasAccountCreated?: string | null, orderFlowUserJoinClub?: string | null, orderFlowUserAffiliated?: string | null, orderFlowReceiveReceipt?: string | null, checkoutId?: string | null };

type OrderFlowMetadata_Category_Fragment = { __typename?: 'Category', orderFlowScTermsRequired?: string | null, orderFlowScTermsAccepted?: string | null, orderFlowWasUserAuthenticated?: string | null, orderFlowWasRegisterMyWatchChecked?: string | null, orderFlowWasCreateMyAccountWithoutWatchChecked?: string | null, orderFlowWasAccountCreated?: string | null, orderFlowUserJoinClub?: string | null, orderFlowUserAffiliated?: string | null, orderFlowReceiveReceipt?: string | null, checkoutId?: string | null };

type OrderFlowMetadata_Channel_Fragment = { __typename?: 'Channel', orderFlowScTermsRequired?: string | null, orderFlowScTermsAccepted?: string | null, orderFlowWasUserAuthenticated?: string | null, orderFlowWasRegisterMyWatchChecked?: string | null, orderFlowWasCreateMyAccountWithoutWatchChecked?: string | null, orderFlowWasAccountCreated?: string | null, orderFlowUserJoinClub?: string | null, orderFlowUserAffiliated?: string | null, orderFlowReceiveReceipt?: string | null, checkoutId?: string | null };

type OrderFlowMetadata_Checkout_Fragment = { __typename?: 'Checkout', orderFlowScTermsRequired?: string | null, orderFlowScTermsAccepted?: string | null, orderFlowWasUserAuthenticated?: string | null, orderFlowWasRegisterMyWatchChecked?: string | null, orderFlowWasCreateMyAccountWithoutWatchChecked?: string | null, orderFlowWasAccountCreated?: string | null, orderFlowUserJoinClub?: string | null, orderFlowUserAffiliated?: string | null, orderFlowReceiveReceipt?: string | null, checkoutId?: string | null };

type OrderFlowMetadata_CheckoutLine_Fragment = { __typename?: 'CheckoutLine', orderFlowScTermsRequired?: string | null, orderFlowScTermsAccepted?: string | null, orderFlowWasUserAuthenticated?: string | null, orderFlowWasRegisterMyWatchChecked?: string | null, orderFlowWasCreateMyAccountWithoutWatchChecked?: string | null, orderFlowWasAccountCreated?: string | null, orderFlowUserJoinClub?: string | null, orderFlowUserAffiliated?: string | null, orderFlowReceiveReceipt?: string | null, checkoutId?: string | null };

type OrderFlowMetadata_Collection_Fragment = { __typename?: 'Collection', orderFlowScTermsRequired?: string | null, orderFlowScTermsAccepted?: string | null, orderFlowWasUserAuthenticated?: string | null, orderFlowWasRegisterMyWatchChecked?: string | null, orderFlowWasCreateMyAccountWithoutWatchChecked?: string | null, orderFlowWasAccountCreated?: string | null, orderFlowUserJoinClub?: string | null, orderFlowUserAffiliated?: string | null, orderFlowReceiveReceipt?: string | null, checkoutId?: string | null };

type OrderFlowMetadata_DigitalContent_Fragment = { __typename?: 'DigitalContent', orderFlowScTermsRequired?: string | null, orderFlowScTermsAccepted?: string | null, orderFlowWasUserAuthenticated?: string | null, orderFlowWasRegisterMyWatchChecked?: string | null, orderFlowWasCreateMyAccountWithoutWatchChecked?: string | null, orderFlowWasAccountCreated?: string | null, orderFlowUserJoinClub?: string | null, orderFlowUserAffiliated?: string | null, orderFlowReceiveReceipt?: string | null, checkoutId?: string | null };

type OrderFlowMetadata_Fulfillment_Fragment = { __typename?: 'Fulfillment', orderFlowScTermsRequired?: string | null, orderFlowScTermsAccepted?: string | null, orderFlowWasUserAuthenticated?: string | null, orderFlowWasRegisterMyWatchChecked?: string | null, orderFlowWasCreateMyAccountWithoutWatchChecked?: string | null, orderFlowWasAccountCreated?: string | null, orderFlowUserJoinClub?: string | null, orderFlowUserAffiliated?: string | null, orderFlowReceiveReceipt?: string | null, checkoutId?: string | null };

type OrderFlowMetadata_GiftCard_Fragment = { __typename?: 'GiftCard', orderFlowScTermsRequired?: string | null, orderFlowScTermsAccepted?: string | null, orderFlowWasUserAuthenticated?: string | null, orderFlowWasRegisterMyWatchChecked?: string | null, orderFlowWasCreateMyAccountWithoutWatchChecked?: string | null, orderFlowWasAccountCreated?: string | null, orderFlowUserJoinClub?: string | null, orderFlowUserAffiliated?: string | null, orderFlowReceiveReceipt?: string | null, checkoutId?: string | null };

type OrderFlowMetadata_Invoice_Fragment = { __typename?: 'Invoice', orderFlowScTermsRequired?: string | null, orderFlowScTermsAccepted?: string | null, orderFlowWasUserAuthenticated?: string | null, orderFlowWasRegisterMyWatchChecked?: string | null, orderFlowWasCreateMyAccountWithoutWatchChecked?: string | null, orderFlowWasAccountCreated?: string | null, orderFlowUserJoinClub?: string | null, orderFlowUserAffiliated?: string | null, orderFlowReceiveReceipt?: string | null, checkoutId?: string | null };

type OrderFlowMetadata_Menu_Fragment = { __typename?: 'Menu', orderFlowScTermsRequired?: string | null, orderFlowScTermsAccepted?: string | null, orderFlowWasUserAuthenticated?: string | null, orderFlowWasRegisterMyWatchChecked?: string | null, orderFlowWasCreateMyAccountWithoutWatchChecked?: string | null, orderFlowWasAccountCreated?: string | null, orderFlowUserJoinClub?: string | null, orderFlowUserAffiliated?: string | null, orderFlowReceiveReceipt?: string | null, checkoutId?: string | null };

type OrderFlowMetadata_MenuItem_Fragment = { __typename?: 'MenuItem', orderFlowScTermsRequired?: string | null, orderFlowScTermsAccepted?: string | null, orderFlowWasUserAuthenticated?: string | null, orderFlowWasRegisterMyWatchChecked?: string | null, orderFlowWasCreateMyAccountWithoutWatchChecked?: string | null, orderFlowWasAccountCreated?: string | null, orderFlowUserJoinClub?: string | null, orderFlowUserAffiliated?: string | null, orderFlowReceiveReceipt?: string | null, checkoutId?: string | null };

type OrderFlowMetadata_Order_Fragment = { __typename?: 'Order', orderFlowScTermsRequired?: string | null, orderFlowScTermsAccepted?: string | null, orderFlowWasUserAuthenticated?: string | null, orderFlowWasRegisterMyWatchChecked?: string | null, orderFlowWasCreateMyAccountWithoutWatchChecked?: string | null, orderFlowWasAccountCreated?: string | null, orderFlowUserJoinClub?: string | null, orderFlowUserAffiliated?: string | null, orderFlowReceiveReceipt?: string | null, checkoutId?: string | null };

type OrderFlowMetadata_OrderLine_Fragment = { __typename?: 'OrderLine', orderFlowScTermsRequired?: string | null, orderFlowScTermsAccepted?: string | null, orderFlowWasUserAuthenticated?: string | null, orderFlowWasRegisterMyWatchChecked?: string | null, orderFlowWasCreateMyAccountWithoutWatchChecked?: string | null, orderFlowWasAccountCreated?: string | null, orderFlowUserJoinClub?: string | null, orderFlowUserAffiliated?: string | null, orderFlowReceiveReceipt?: string | null, checkoutId?: string | null };

type OrderFlowMetadata_Page_Fragment = { __typename?: 'Page', orderFlowScTermsRequired?: string | null, orderFlowScTermsAccepted?: string | null, orderFlowWasUserAuthenticated?: string | null, orderFlowWasRegisterMyWatchChecked?: string | null, orderFlowWasCreateMyAccountWithoutWatchChecked?: string | null, orderFlowWasAccountCreated?: string | null, orderFlowUserJoinClub?: string | null, orderFlowUserAffiliated?: string | null, orderFlowReceiveReceipt?: string | null, checkoutId?: string | null };

type OrderFlowMetadata_PageType_Fragment = { __typename?: 'PageType', orderFlowScTermsRequired?: string | null, orderFlowScTermsAccepted?: string | null, orderFlowWasUserAuthenticated?: string | null, orderFlowWasRegisterMyWatchChecked?: string | null, orderFlowWasCreateMyAccountWithoutWatchChecked?: string | null, orderFlowWasAccountCreated?: string | null, orderFlowUserJoinClub?: string | null, orderFlowUserAffiliated?: string | null, orderFlowReceiveReceipt?: string | null, checkoutId?: string | null };

type OrderFlowMetadata_Payment_Fragment = { __typename?: 'Payment', orderFlowScTermsRequired?: string | null, orderFlowScTermsAccepted?: string | null, orderFlowWasUserAuthenticated?: string | null, orderFlowWasRegisterMyWatchChecked?: string | null, orderFlowWasCreateMyAccountWithoutWatchChecked?: string | null, orderFlowWasAccountCreated?: string | null, orderFlowUserJoinClub?: string | null, orderFlowUserAffiliated?: string | null, orderFlowReceiveReceipt?: string | null, checkoutId?: string | null };

type OrderFlowMetadata_Product_Fragment = { __typename?: 'Product', orderFlowScTermsRequired?: string | null, orderFlowScTermsAccepted?: string | null, orderFlowWasUserAuthenticated?: string | null, orderFlowWasRegisterMyWatchChecked?: string | null, orderFlowWasCreateMyAccountWithoutWatchChecked?: string | null, orderFlowWasAccountCreated?: string | null, orderFlowUserJoinClub?: string | null, orderFlowUserAffiliated?: string | null, orderFlowReceiveReceipt?: string | null, checkoutId?: string | null };

type OrderFlowMetadata_ProductMedia_Fragment = { __typename?: 'ProductMedia', orderFlowScTermsRequired?: string | null, orderFlowScTermsAccepted?: string | null, orderFlowWasUserAuthenticated?: string | null, orderFlowWasRegisterMyWatchChecked?: string | null, orderFlowWasCreateMyAccountWithoutWatchChecked?: string | null, orderFlowWasAccountCreated?: string | null, orderFlowUserJoinClub?: string | null, orderFlowUserAffiliated?: string | null, orderFlowReceiveReceipt?: string | null, checkoutId?: string | null };

type OrderFlowMetadata_ProductType_Fragment = { __typename?: 'ProductType', orderFlowScTermsRequired?: string | null, orderFlowScTermsAccepted?: string | null, orderFlowWasUserAuthenticated?: string | null, orderFlowWasRegisterMyWatchChecked?: string | null, orderFlowWasCreateMyAccountWithoutWatchChecked?: string | null, orderFlowWasAccountCreated?: string | null, orderFlowUserJoinClub?: string | null, orderFlowUserAffiliated?: string | null, orderFlowReceiveReceipt?: string | null, checkoutId?: string | null };

type OrderFlowMetadata_ProductVariant_Fragment = { __typename?: 'ProductVariant', orderFlowScTermsRequired?: string | null, orderFlowScTermsAccepted?: string | null, orderFlowWasUserAuthenticated?: string | null, orderFlowWasRegisterMyWatchChecked?: string | null, orderFlowWasCreateMyAccountWithoutWatchChecked?: string | null, orderFlowWasAccountCreated?: string | null, orderFlowUserJoinClub?: string | null, orderFlowUserAffiliated?: string | null, orderFlowReceiveReceipt?: string | null, checkoutId?: string | null };

type OrderFlowMetadata_Promotion_Fragment = { __typename?: 'Promotion', orderFlowScTermsRequired?: string | null, orderFlowScTermsAccepted?: string | null, orderFlowWasUserAuthenticated?: string | null, orderFlowWasRegisterMyWatchChecked?: string | null, orderFlowWasCreateMyAccountWithoutWatchChecked?: string | null, orderFlowWasAccountCreated?: string | null, orderFlowUserJoinClub?: string | null, orderFlowUserAffiliated?: string | null, orderFlowReceiveReceipt?: string | null, checkoutId?: string | null };

type OrderFlowMetadata_Sale_Fragment = { __typename?: 'Sale', orderFlowScTermsRequired?: string | null, orderFlowScTermsAccepted?: string | null, orderFlowWasUserAuthenticated?: string | null, orderFlowWasRegisterMyWatchChecked?: string | null, orderFlowWasCreateMyAccountWithoutWatchChecked?: string | null, orderFlowWasAccountCreated?: string | null, orderFlowUserJoinClub?: string | null, orderFlowUserAffiliated?: string | null, orderFlowReceiveReceipt?: string | null, checkoutId?: string | null };

type OrderFlowMetadata_ShippingMethod_Fragment = { __typename?: 'ShippingMethod', orderFlowScTermsRequired?: string | null, orderFlowScTermsAccepted?: string | null, orderFlowWasUserAuthenticated?: string | null, orderFlowWasRegisterMyWatchChecked?: string | null, orderFlowWasCreateMyAccountWithoutWatchChecked?: string | null, orderFlowWasAccountCreated?: string | null, orderFlowUserJoinClub?: string | null, orderFlowUserAffiliated?: string | null, orderFlowReceiveReceipt?: string | null, checkoutId?: string | null };

type OrderFlowMetadata_ShippingMethodType_Fragment = { __typename?: 'ShippingMethodType', orderFlowScTermsRequired?: string | null, orderFlowScTermsAccepted?: string | null, orderFlowWasUserAuthenticated?: string | null, orderFlowWasRegisterMyWatchChecked?: string | null, orderFlowWasCreateMyAccountWithoutWatchChecked?: string | null, orderFlowWasAccountCreated?: string | null, orderFlowUserJoinClub?: string | null, orderFlowUserAffiliated?: string | null, orderFlowReceiveReceipt?: string | null, checkoutId?: string | null };

type OrderFlowMetadata_ShippingZone_Fragment = { __typename?: 'ShippingZone', orderFlowScTermsRequired?: string | null, orderFlowScTermsAccepted?: string | null, orderFlowWasUserAuthenticated?: string | null, orderFlowWasRegisterMyWatchChecked?: string | null, orderFlowWasCreateMyAccountWithoutWatchChecked?: string | null, orderFlowWasAccountCreated?: string | null, orderFlowUserJoinClub?: string | null, orderFlowUserAffiliated?: string | null, orderFlowReceiveReceipt?: string | null, checkoutId?: string | null };

type OrderFlowMetadata_Shop_Fragment = { __typename?: 'Shop', orderFlowScTermsRequired?: string | null, orderFlowScTermsAccepted?: string | null, orderFlowWasUserAuthenticated?: string | null, orderFlowWasRegisterMyWatchChecked?: string | null, orderFlowWasCreateMyAccountWithoutWatchChecked?: string | null, orderFlowWasAccountCreated?: string | null, orderFlowUserJoinClub?: string | null, orderFlowUserAffiliated?: string | null, orderFlowReceiveReceipt?: string | null, checkoutId?: string | null };

type OrderFlowMetadata_TaxClass_Fragment = { __typename?: 'TaxClass', orderFlowScTermsRequired?: string | null, orderFlowScTermsAccepted?: string | null, orderFlowWasUserAuthenticated?: string | null, orderFlowWasRegisterMyWatchChecked?: string | null, orderFlowWasCreateMyAccountWithoutWatchChecked?: string | null, orderFlowWasAccountCreated?: string | null, orderFlowUserJoinClub?: string | null, orderFlowUserAffiliated?: string | null, orderFlowReceiveReceipt?: string | null, checkoutId?: string | null };

type OrderFlowMetadata_TaxConfiguration_Fragment = { __typename?: 'TaxConfiguration', orderFlowScTermsRequired?: string | null, orderFlowScTermsAccepted?: string | null, orderFlowWasUserAuthenticated?: string | null, orderFlowWasRegisterMyWatchChecked?: string | null, orderFlowWasCreateMyAccountWithoutWatchChecked?: string | null, orderFlowWasAccountCreated?: string | null, orderFlowUserJoinClub?: string | null, orderFlowUserAffiliated?: string | null, orderFlowReceiveReceipt?: string | null, checkoutId?: string | null };

type OrderFlowMetadata_TransactionItem_Fragment = { __typename?: 'TransactionItem', orderFlowScTermsRequired?: string | null, orderFlowScTermsAccepted?: string | null, orderFlowWasUserAuthenticated?: string | null, orderFlowWasRegisterMyWatchChecked?: string | null, orderFlowWasCreateMyAccountWithoutWatchChecked?: string | null, orderFlowWasAccountCreated?: string | null, orderFlowUserJoinClub?: string | null, orderFlowUserAffiliated?: string | null, orderFlowReceiveReceipt?: string | null, checkoutId?: string | null };

type OrderFlowMetadata_User_Fragment = { __typename?: 'User', orderFlowScTermsRequired?: string | null, orderFlowScTermsAccepted?: string | null, orderFlowWasUserAuthenticated?: string | null, orderFlowWasRegisterMyWatchChecked?: string | null, orderFlowWasCreateMyAccountWithoutWatchChecked?: string | null, orderFlowWasAccountCreated?: string | null, orderFlowUserJoinClub?: string | null, orderFlowUserAffiliated?: string | null, orderFlowReceiveReceipt?: string | null, checkoutId?: string | null };

type OrderFlowMetadata_Voucher_Fragment = { __typename?: 'Voucher', orderFlowScTermsRequired?: string | null, orderFlowScTermsAccepted?: string | null, orderFlowWasUserAuthenticated?: string | null, orderFlowWasRegisterMyWatchChecked?: string | null, orderFlowWasCreateMyAccountWithoutWatchChecked?: string | null, orderFlowWasAccountCreated?: string | null, orderFlowUserJoinClub?: string | null, orderFlowUserAffiliated?: string | null, orderFlowReceiveReceipt?: string | null, checkoutId?: string | null };

type OrderFlowMetadata_Warehouse_Fragment = { __typename?: 'Warehouse', orderFlowScTermsRequired?: string | null, orderFlowScTermsAccepted?: string | null, orderFlowWasUserAuthenticated?: string | null, orderFlowWasRegisterMyWatchChecked?: string | null, orderFlowWasCreateMyAccountWithoutWatchChecked?: string | null, orderFlowWasAccountCreated?: string | null, orderFlowUserJoinClub?: string | null, orderFlowUserAffiliated?: string | null, orderFlowReceiveReceipt?: string | null, checkoutId?: string | null };

export type OrderFlowMetadataFragment = OrderFlowMetadata_Address_Fragment | OrderFlowMetadata_App_Fragment | OrderFlowMetadata_Attribute_Fragment | OrderFlowMetadata_Category_Fragment | OrderFlowMetadata_Channel_Fragment | OrderFlowMetadata_Checkout_Fragment | OrderFlowMetadata_CheckoutLine_Fragment | OrderFlowMetadata_Collection_Fragment | OrderFlowMetadata_DigitalContent_Fragment | OrderFlowMetadata_Fulfillment_Fragment | OrderFlowMetadata_GiftCard_Fragment | OrderFlowMetadata_Invoice_Fragment | OrderFlowMetadata_Menu_Fragment | OrderFlowMetadata_MenuItem_Fragment | OrderFlowMetadata_Order_Fragment | OrderFlowMetadata_OrderLine_Fragment | OrderFlowMetadata_Page_Fragment | OrderFlowMetadata_PageType_Fragment | OrderFlowMetadata_Payment_Fragment | OrderFlowMetadata_Product_Fragment | OrderFlowMetadata_ProductMedia_Fragment | OrderFlowMetadata_ProductType_Fragment | OrderFlowMetadata_ProductVariant_Fragment | OrderFlowMetadata_Promotion_Fragment | OrderFlowMetadata_Sale_Fragment | OrderFlowMetadata_ShippingMethod_Fragment | OrderFlowMetadata_ShippingMethodType_Fragment | OrderFlowMetadata_ShippingZone_Fragment | OrderFlowMetadata_Shop_Fragment | OrderFlowMetadata_TaxClass_Fragment | OrderFlowMetadata_TaxConfiguration_Fragment | OrderFlowMetadata_TransactionItem_Fragment | OrderFlowMetadata_User_Fragment | OrderFlowMetadata_Voucher_Fragment | OrderFlowMetadata_Warehouse_Fragment;

export type OrderLineFragment = { __typename?: 'OrderLine', id: string, productName: string, translatedProductName: string, quantity: number, relatedProductBuckleId?: string | null, relatedProductStrapId?: string | null, relatedProductWatchId?: string | null, relatedBraceletSize?: string | null, relatedEngravingId?: string | null, strapPackReference?: string | null, strapReference?: string | null, strapSize?: string | null, warrantyDuration?: string | null, unitPrice: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } }, totalPrice: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } }, variant?: { __typename?: 'ProductVariant', id: string, sku?: string | null, product: { __typename?: 'Product', id: string, name: string, watchName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, strapName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, buckleName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, toolName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, warrantyName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, eyewearModel?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, digitalItemName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, translation?: { __typename?: 'ProductTranslation', name?: string | null } | null, defaultVariant?: { __typename?: 'ProductVariant', sku?: string | null, pricing?: { __typename?: 'VariantPricingInfo', price?: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } } | null } | null } | null, color?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, caseMaterial?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, strapMaterial?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, size?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, compatibleStraps?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, buckle?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, strapColor?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, warrantyExtensionDuration?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, warrantyMovementDuration?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, wristSizeMinInch?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, wristSizeMaxInch?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, wristSizeMinMm?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, wristSizeMaxMm?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, marketingPartner?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, media?: Array<{ __typename?: 'ProductMedia', url: string, alt: string, type: ProductMediaType, strapPreviewCoordinates?: string | null, backEngravingCoordinates?: string | null, shotType?: string | null }> | null, personalizedEngraving?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', boolean?: boolean | null, slug?: string | null }> } | null, productType: { __typename?: 'ProductType', slug: string, name: string }, thumbnail?: { __typename?: 'Image', alt?: string | null, url: string } | null, collections?: Array<{ __typename?: 'Collection', name: string, slug: string, translation?: { __typename?: 'CollectionTranslation', name?: string | null } | null }> | null, model?: { __typename?: 'SelectedAttribute', values: Array<{ __typename?: 'AttributeValue', slug?: string | null }> } | null, collectionName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null } } | null, undiscountedUnitPrice: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } }, unitDiscount: { __typename?: 'Money', amount: number, currency: string }, thumbnail?: { __typename?: 'Image', alt?: string | null, url: string } | null, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> };

export type PageInfoFragment = { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null };

export type PaymentGatewayFragment = { __typename?: 'PaymentGateway', id: string, name: string, config: Array<{ __typename?: 'GatewayConfigLine', field: string, value?: string | null }> };

export type PaymentGatewayConfigFragment = { __typename?: 'PaymentGatewayConfig', id: string, data?: any | null, errors?: Array<{ __typename?: 'PaymentGatewayConfigError', field?: string | null, message?: string | null, code: PaymentGatewayConfigErrorCode }> | null };

export type PaymentGatewayConfigErrorFragment = { __typename?: 'PaymentGatewayConfigError', field?: string | null, message?: string | null, code: PaymentGatewayConfigErrorCode };

export type PaymentGatewayInitializeErrorFragment = { __typename?: 'PaymentGatewayInitializeError', field?: string | null, message?: string | null, code: PaymentGatewayInitializeErrorCode };

type PaymentMethodMetadata_Address_Fragment = { __typename?: 'Address', paymentMethod?: string | null };

type PaymentMethodMetadata_App_Fragment = { __typename?: 'App', paymentMethod?: string | null };

type PaymentMethodMetadata_Attribute_Fragment = { __typename?: 'Attribute', paymentMethod?: string | null };

type PaymentMethodMetadata_Category_Fragment = { __typename?: 'Category', paymentMethod?: string | null };

type PaymentMethodMetadata_Channel_Fragment = { __typename?: 'Channel', paymentMethod?: string | null };

type PaymentMethodMetadata_Checkout_Fragment = { __typename?: 'Checkout', paymentMethod?: string | null };

type PaymentMethodMetadata_CheckoutLine_Fragment = { __typename?: 'CheckoutLine', paymentMethod?: string | null };

type PaymentMethodMetadata_Collection_Fragment = { __typename?: 'Collection', paymentMethod?: string | null };

type PaymentMethodMetadata_DigitalContent_Fragment = { __typename?: 'DigitalContent', paymentMethod?: string | null };

type PaymentMethodMetadata_Fulfillment_Fragment = { __typename?: 'Fulfillment', paymentMethod?: string | null };

type PaymentMethodMetadata_GiftCard_Fragment = { __typename?: 'GiftCard', paymentMethod?: string | null };

type PaymentMethodMetadata_Invoice_Fragment = { __typename?: 'Invoice', paymentMethod?: string | null };

type PaymentMethodMetadata_Menu_Fragment = { __typename?: 'Menu', paymentMethod?: string | null };

type PaymentMethodMetadata_MenuItem_Fragment = { __typename?: 'MenuItem', paymentMethod?: string | null };

type PaymentMethodMetadata_Order_Fragment = { __typename?: 'Order', paymentMethod?: string | null };

type PaymentMethodMetadata_OrderLine_Fragment = { __typename?: 'OrderLine', paymentMethod?: string | null };

type PaymentMethodMetadata_Page_Fragment = { __typename?: 'Page', paymentMethod?: string | null };

type PaymentMethodMetadata_PageType_Fragment = { __typename?: 'PageType', paymentMethod?: string | null };

type PaymentMethodMetadata_Payment_Fragment = { __typename?: 'Payment', paymentMethod?: string | null };

type PaymentMethodMetadata_Product_Fragment = { __typename?: 'Product', paymentMethod?: string | null };

type PaymentMethodMetadata_ProductMedia_Fragment = { __typename?: 'ProductMedia', paymentMethod?: string | null };

type PaymentMethodMetadata_ProductType_Fragment = { __typename?: 'ProductType', paymentMethod?: string | null };

type PaymentMethodMetadata_ProductVariant_Fragment = { __typename?: 'ProductVariant', paymentMethod?: string | null };

type PaymentMethodMetadata_Promotion_Fragment = { __typename?: 'Promotion', paymentMethod?: string | null };

type PaymentMethodMetadata_Sale_Fragment = { __typename?: 'Sale', paymentMethod?: string | null };

type PaymentMethodMetadata_ShippingMethod_Fragment = { __typename?: 'ShippingMethod', paymentMethod?: string | null };

type PaymentMethodMetadata_ShippingMethodType_Fragment = { __typename?: 'ShippingMethodType', paymentMethod?: string | null };

type PaymentMethodMetadata_ShippingZone_Fragment = { __typename?: 'ShippingZone', paymentMethod?: string | null };

type PaymentMethodMetadata_Shop_Fragment = { __typename?: 'Shop', paymentMethod?: string | null };

type PaymentMethodMetadata_TaxClass_Fragment = { __typename?: 'TaxClass', paymentMethod?: string | null };

type PaymentMethodMetadata_TaxConfiguration_Fragment = { __typename?: 'TaxConfiguration', paymentMethod?: string | null };

type PaymentMethodMetadata_TransactionItem_Fragment = { __typename?: 'TransactionItem', paymentMethod?: string | null };

type PaymentMethodMetadata_User_Fragment = { __typename?: 'User', paymentMethod?: string | null };

type PaymentMethodMetadata_Voucher_Fragment = { __typename?: 'Voucher', paymentMethod?: string | null };

type PaymentMethodMetadata_Warehouse_Fragment = { __typename?: 'Warehouse', paymentMethod?: string | null };

export type PaymentMethodMetadataFragment = PaymentMethodMetadata_Address_Fragment | PaymentMethodMetadata_App_Fragment | PaymentMethodMetadata_Attribute_Fragment | PaymentMethodMetadata_Category_Fragment | PaymentMethodMetadata_Channel_Fragment | PaymentMethodMetadata_Checkout_Fragment | PaymentMethodMetadata_CheckoutLine_Fragment | PaymentMethodMetadata_Collection_Fragment | PaymentMethodMetadata_DigitalContent_Fragment | PaymentMethodMetadata_Fulfillment_Fragment | PaymentMethodMetadata_GiftCard_Fragment | PaymentMethodMetadata_Invoice_Fragment | PaymentMethodMetadata_Menu_Fragment | PaymentMethodMetadata_MenuItem_Fragment | PaymentMethodMetadata_Order_Fragment | PaymentMethodMetadata_OrderLine_Fragment | PaymentMethodMetadata_Page_Fragment | PaymentMethodMetadata_PageType_Fragment | PaymentMethodMetadata_Payment_Fragment | PaymentMethodMetadata_Product_Fragment | PaymentMethodMetadata_ProductMedia_Fragment | PaymentMethodMetadata_ProductType_Fragment | PaymentMethodMetadata_ProductVariant_Fragment | PaymentMethodMetadata_Promotion_Fragment | PaymentMethodMetadata_Sale_Fragment | PaymentMethodMetadata_ShippingMethod_Fragment | PaymentMethodMetadata_ShippingMethodType_Fragment | PaymentMethodMetadata_ShippingZone_Fragment | PaymentMethodMetadata_Shop_Fragment | PaymentMethodMetadata_TaxClass_Fragment | PaymentMethodMetadata_TaxConfiguration_Fragment | PaymentMethodMetadata_TransactionItem_Fragment | PaymentMethodMetadata_User_Fragment | PaymentMethodMetadata_Voucher_Fragment | PaymentMethodMetadata_Warehouse_Fragment;

export type PlainTextAttributeFragment = { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', plainText?: string | null, translation?: { __typename?: 'AttributeValueTranslation', plainText?: string | null } | null }> };

type PreorderMetadata_Address_Fragment = { __typename?: 'Address', preOrderData?: string | null, orderType?: string | null, orderStatus?: string | null, orderCollectedDate?: string | null, payPerLinkToken?: string | null, payPerLinkExpiration?: string | null };

type PreorderMetadata_App_Fragment = { __typename?: 'App', preOrderData?: string | null, orderType?: string | null, orderStatus?: string | null, orderCollectedDate?: string | null, payPerLinkToken?: string | null, payPerLinkExpiration?: string | null };

type PreorderMetadata_Attribute_Fragment = { __typename?: 'Attribute', preOrderData?: string | null, orderType?: string | null, orderStatus?: string | null, orderCollectedDate?: string | null, payPerLinkToken?: string | null, payPerLinkExpiration?: string | null };

type PreorderMetadata_Category_Fragment = { __typename?: 'Category', preOrderData?: string | null, orderType?: string | null, orderStatus?: string | null, orderCollectedDate?: string | null, payPerLinkToken?: string | null, payPerLinkExpiration?: string | null };

type PreorderMetadata_Channel_Fragment = { __typename?: 'Channel', preOrderData?: string | null, orderType?: string | null, orderStatus?: string | null, orderCollectedDate?: string | null, payPerLinkToken?: string | null, payPerLinkExpiration?: string | null };

type PreorderMetadata_Checkout_Fragment = { __typename?: 'Checkout', preOrderData?: string | null, orderType?: string | null, orderStatus?: string | null, orderCollectedDate?: string | null, payPerLinkToken?: string | null, payPerLinkExpiration?: string | null };

type PreorderMetadata_CheckoutLine_Fragment = { __typename?: 'CheckoutLine', preOrderData?: string | null, orderType?: string | null, orderStatus?: string | null, orderCollectedDate?: string | null, payPerLinkToken?: string | null, payPerLinkExpiration?: string | null };

type PreorderMetadata_Collection_Fragment = { __typename?: 'Collection', preOrderData?: string | null, orderType?: string | null, orderStatus?: string | null, orderCollectedDate?: string | null, payPerLinkToken?: string | null, payPerLinkExpiration?: string | null };

type PreorderMetadata_DigitalContent_Fragment = { __typename?: 'DigitalContent', preOrderData?: string | null, orderType?: string | null, orderStatus?: string | null, orderCollectedDate?: string | null, payPerLinkToken?: string | null, payPerLinkExpiration?: string | null };

type PreorderMetadata_Fulfillment_Fragment = { __typename?: 'Fulfillment', preOrderData?: string | null, orderType?: string | null, orderStatus?: string | null, orderCollectedDate?: string | null, payPerLinkToken?: string | null, payPerLinkExpiration?: string | null };

type PreorderMetadata_GiftCard_Fragment = { __typename?: 'GiftCard', preOrderData?: string | null, orderType?: string | null, orderStatus?: string | null, orderCollectedDate?: string | null, payPerLinkToken?: string | null, payPerLinkExpiration?: string | null };

type PreorderMetadata_Invoice_Fragment = { __typename?: 'Invoice', preOrderData?: string | null, orderType?: string | null, orderStatus?: string | null, orderCollectedDate?: string | null, payPerLinkToken?: string | null, payPerLinkExpiration?: string | null };

type PreorderMetadata_Menu_Fragment = { __typename?: 'Menu', preOrderData?: string | null, orderType?: string | null, orderStatus?: string | null, orderCollectedDate?: string | null, payPerLinkToken?: string | null, payPerLinkExpiration?: string | null };

type PreorderMetadata_MenuItem_Fragment = { __typename?: 'MenuItem', preOrderData?: string | null, orderType?: string | null, orderStatus?: string | null, orderCollectedDate?: string | null, payPerLinkToken?: string | null, payPerLinkExpiration?: string | null };

type PreorderMetadata_Order_Fragment = { __typename?: 'Order', preOrderData?: string | null, orderType?: string | null, orderStatus?: string | null, orderCollectedDate?: string | null, payPerLinkToken?: string | null, payPerLinkExpiration?: string | null };

type PreorderMetadata_OrderLine_Fragment = { __typename?: 'OrderLine', preOrderData?: string | null, orderType?: string | null, orderStatus?: string | null, orderCollectedDate?: string | null, payPerLinkToken?: string | null, payPerLinkExpiration?: string | null };

type PreorderMetadata_Page_Fragment = { __typename?: 'Page', preOrderData?: string | null, orderType?: string | null, orderStatus?: string | null, orderCollectedDate?: string | null, payPerLinkToken?: string | null, payPerLinkExpiration?: string | null };

type PreorderMetadata_PageType_Fragment = { __typename?: 'PageType', preOrderData?: string | null, orderType?: string | null, orderStatus?: string | null, orderCollectedDate?: string | null, payPerLinkToken?: string | null, payPerLinkExpiration?: string | null };

type PreorderMetadata_Payment_Fragment = { __typename?: 'Payment', preOrderData?: string | null, orderType?: string | null, orderStatus?: string | null, orderCollectedDate?: string | null, payPerLinkToken?: string | null, payPerLinkExpiration?: string | null };

type PreorderMetadata_Product_Fragment = { __typename?: 'Product', preOrderData?: string | null, orderType?: string | null, orderStatus?: string | null, orderCollectedDate?: string | null, payPerLinkToken?: string | null, payPerLinkExpiration?: string | null };

type PreorderMetadata_ProductMedia_Fragment = { __typename?: 'ProductMedia', preOrderData?: string | null, orderType?: string | null, orderStatus?: string | null, orderCollectedDate?: string | null, payPerLinkToken?: string | null, payPerLinkExpiration?: string | null };

type PreorderMetadata_ProductType_Fragment = { __typename?: 'ProductType', preOrderData?: string | null, orderType?: string | null, orderStatus?: string | null, orderCollectedDate?: string | null, payPerLinkToken?: string | null, payPerLinkExpiration?: string | null };

type PreorderMetadata_ProductVariant_Fragment = { __typename?: 'ProductVariant', preOrderData?: string | null, orderType?: string | null, orderStatus?: string | null, orderCollectedDate?: string | null, payPerLinkToken?: string | null, payPerLinkExpiration?: string | null };

type PreorderMetadata_Promotion_Fragment = { __typename?: 'Promotion', preOrderData?: string | null, orderType?: string | null, orderStatus?: string | null, orderCollectedDate?: string | null, payPerLinkToken?: string | null, payPerLinkExpiration?: string | null };

type PreorderMetadata_Sale_Fragment = { __typename?: 'Sale', preOrderData?: string | null, orderType?: string | null, orderStatus?: string | null, orderCollectedDate?: string | null, payPerLinkToken?: string | null, payPerLinkExpiration?: string | null };

type PreorderMetadata_ShippingMethod_Fragment = { __typename?: 'ShippingMethod', preOrderData?: string | null, orderType?: string | null, orderStatus?: string | null, orderCollectedDate?: string | null, payPerLinkToken?: string | null, payPerLinkExpiration?: string | null };

type PreorderMetadata_ShippingMethodType_Fragment = { __typename?: 'ShippingMethodType', preOrderData?: string | null, orderType?: string | null, orderStatus?: string | null, orderCollectedDate?: string | null, payPerLinkToken?: string | null, payPerLinkExpiration?: string | null };

type PreorderMetadata_ShippingZone_Fragment = { __typename?: 'ShippingZone', preOrderData?: string | null, orderType?: string | null, orderStatus?: string | null, orderCollectedDate?: string | null, payPerLinkToken?: string | null, payPerLinkExpiration?: string | null };

type PreorderMetadata_Shop_Fragment = { __typename?: 'Shop', preOrderData?: string | null, orderType?: string | null, orderStatus?: string | null, orderCollectedDate?: string | null, payPerLinkToken?: string | null, payPerLinkExpiration?: string | null };

type PreorderMetadata_TaxClass_Fragment = { __typename?: 'TaxClass', preOrderData?: string | null, orderType?: string | null, orderStatus?: string | null, orderCollectedDate?: string | null, payPerLinkToken?: string | null, payPerLinkExpiration?: string | null };

type PreorderMetadata_TaxConfiguration_Fragment = { __typename?: 'TaxConfiguration', preOrderData?: string | null, orderType?: string | null, orderStatus?: string | null, orderCollectedDate?: string | null, payPerLinkToken?: string | null, payPerLinkExpiration?: string | null };

type PreorderMetadata_TransactionItem_Fragment = { __typename?: 'TransactionItem', preOrderData?: string | null, orderType?: string | null, orderStatus?: string | null, orderCollectedDate?: string | null, payPerLinkToken?: string | null, payPerLinkExpiration?: string | null };

type PreorderMetadata_User_Fragment = { __typename?: 'User', preOrderData?: string | null, orderType?: string | null, orderStatus?: string | null, orderCollectedDate?: string | null, payPerLinkToken?: string | null, payPerLinkExpiration?: string | null };

type PreorderMetadata_Voucher_Fragment = { __typename?: 'Voucher', preOrderData?: string | null, orderType?: string | null, orderStatus?: string | null, orderCollectedDate?: string | null, payPerLinkToken?: string | null, payPerLinkExpiration?: string | null };

type PreorderMetadata_Warehouse_Fragment = { __typename?: 'Warehouse', preOrderData?: string | null, orderType?: string | null, orderStatus?: string | null, orderCollectedDate?: string | null, payPerLinkToken?: string | null, payPerLinkExpiration?: string | null };

export type PreorderMetadataFragment = PreorderMetadata_Address_Fragment | PreorderMetadata_App_Fragment | PreorderMetadata_Attribute_Fragment | PreorderMetadata_Category_Fragment | PreorderMetadata_Channel_Fragment | PreorderMetadata_Checkout_Fragment | PreorderMetadata_CheckoutLine_Fragment | PreorderMetadata_Collection_Fragment | PreorderMetadata_DigitalContent_Fragment | PreorderMetadata_Fulfillment_Fragment | PreorderMetadata_GiftCard_Fragment | PreorderMetadata_Invoice_Fragment | PreorderMetadata_Menu_Fragment | PreorderMetadata_MenuItem_Fragment | PreorderMetadata_Order_Fragment | PreorderMetadata_OrderLine_Fragment | PreorderMetadata_Page_Fragment | PreorderMetadata_PageType_Fragment | PreorderMetadata_Payment_Fragment | PreorderMetadata_Product_Fragment | PreorderMetadata_ProductMedia_Fragment | PreorderMetadata_ProductType_Fragment | PreorderMetadata_ProductVariant_Fragment | PreorderMetadata_Promotion_Fragment | PreorderMetadata_Sale_Fragment | PreorderMetadata_ShippingMethod_Fragment | PreorderMetadata_ShippingMethodType_Fragment | PreorderMetadata_ShippingZone_Fragment | PreorderMetadata_Shop_Fragment | PreorderMetadata_TaxClass_Fragment | PreorderMetadata_TaxConfiguration_Fragment | PreorderMetadata_TransactionItem_Fragment | PreorderMetadata_User_Fragment | PreorderMetadata_Voucher_Fragment | PreorderMetadata_Warehouse_Fragment;

export type ProductCardFragment = { __typename?: 'Product', id: string, name: string, slug: string, translation?: { __typename?: 'ProductTranslation', name?: string | null } | null, thumbnail?: { __typename?: 'Image', alt?: string | null, url: string } | null, media?: Array<{ __typename?: 'ProductMedia', url: string, alt: string, type: ProductMediaType, strapPreviewCoordinates?: string | null, backEngravingCoordinates?: string | null, shotType?: string | null }> | null, defaultVariant?: { __typename?: 'ProductVariant', sku?: string | null, id: string, pricing?: { __typename?: 'VariantPricingInfo', price?: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } } | null } | null } | null, integratedBuckle?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', boolean?: boolean | null, slug?: string | null }> } | null, diameter?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string } | null }> } | null, marketingStatus?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, marketingPartner?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, marketingCampaign?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, launchDate?: { __typename?: 'SelectedAttribute', values: Array<{ __typename?: 'AttributeValue', name?: string | null }> } | null, collections?: Array<{ __typename?: 'Collection', name: string, slug: string, translation?: { __typename?: 'CollectionTranslation', name?: string | null } | null }> | null, model?: { __typename?: 'SelectedAttribute', values: Array<{ __typename?: 'AttributeValue', slug?: string | null }> } | null, strapMaterial?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, strapColor?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, watchName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, strapName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, collectionName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, warrantyName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, eyewearModel?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, toolName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, digitalItemName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, productType: { __typename?: 'ProductType', slug: string, name: string } };

export type ProductMediaFragment = { __typename?: 'ProductMedia', url: string, alt: string, type: ProductMediaType, strapPreviewCoordinates?: string | null, backEngravingCoordinates?: string | null, shotType?: string | null };

export type ProductSkuFragment = { __typename?: 'Product', id: string, name: string, slug: string, description?: string | null, translation?: { __typename?: 'ProductTranslation', description?: string | null, name?: string | null } | null, defaultVariant?: { __typename?: 'ProductVariant', sku?: string | null, id: string, quantityAvailable?: number | null, pricing?: { __typename?: 'VariantPricingInfo', price?: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } } | null } | null } | null, channelListings?: Array<{ __typename?: 'ProductChannelListing', channel: { __typename?: 'Channel', name: string }, pricing?: { __typename?: 'ProductPricingInfo', priceRange?: { __typename?: 'TaxedMoneyRange', start?: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } } | null } | null } | null }> | null, media?: Array<{ __typename?: 'ProductMedia', url: string, alt: string, type: ProductMediaType, strapPreviewCoordinates?: string | null, backEngravingCoordinates?: string | null, shotType?: string | null }> | null, mediaLarge?: Array<{ __typename?: 'ProductMedia', url: string, id: string }> | null, thumbnail?: { __typename?: 'Image', alt?: string | null, url: string } | null, relatedProducts?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, compatibleStraps?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, otherSizesSkus?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, integratedBuckle?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', boolean?: boolean | null, slug?: string | null }> } | null, collections?: Array<{ __typename?: 'Collection', name: string, slug: string, translation?: { __typename?: 'CollectionTranslation', name?: string | null } | null }> | null, model?: { __typename?: 'SelectedAttribute', values: Array<{ __typename?: 'AttributeValue', slug?: string | null }> } | null, strapMaterial?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, strapColor?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, watchName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, strapName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, collectionName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, warrantyName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, eyewearModel?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, toolName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, digitalItemName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, marketingStatus?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, marketingPartner?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, marketingCampaign?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, distributionStatus?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, launchDate?: { __typename?: 'SelectedAttribute', values: Array<{ __typename?: 'AttributeValue', name?: string | null }> } | null, limited?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', boolean?: boolean | null, slug?: string | null }> } | null, buckleMaterial?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, buckleType?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, buckleSize?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, dialColor?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, modelStory?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, caseMaterial?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, waterResistance?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, waterResistanceTextComputed?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, diameter?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string } | null }> } | null, thickness?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string } | null }> } | null, weight?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string } | null }> } | null, powerReserve?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, caliber?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, movement?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, chronograph?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, vibration?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, jewel?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, calendar?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, caseback?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, bezel?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, crown?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, crystal?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, headWeight?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string } | null }> } | null, height?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string } | null }> } | null, lugWidth?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string } | null }> } | null, strapType?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, lug?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, warrantyDuration?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, warrantyExtensionDuration?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, movementManufacture?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, manualUrl?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, bundleVariations?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, comCategories?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, designerChoice?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, personalizedEngraving?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', boolean?: boolean | null, slug?: string | null }> } | null, marketingDescription?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, frameShape?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, frameColor?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, frameMaterial?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, coreWire?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, templeTipDetail?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, frontalPins?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, lensSurface?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, lensColor?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, lensCoating?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, uvProtection?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, frontalWidth?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string } | null }> } | null, templeLength?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string } | null }> } | null, lensWidth?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string } | null }> } | null, bridgeWidth?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string } | null }> } | null, eyewearModelStory?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, productType: { __typename?: 'ProductType', slug: string, name: string } };

export type ProductThumbnailFragment = { __typename?: 'Product', thumbnail?: { __typename?: 'Image', alt?: string | null, url: string } | null };

export type ProductTileFragment = { __typename?: 'Product', id: string, slug: string, name: string, translation?: { __typename?: 'ProductTranslation', id: string, name?: string | null } | null, thumbnail?: { __typename?: 'Image', alt?: string | null, url: string } | null, pricing?: { __typename?: 'ProductPricingInfo', onSale?: boolean | null, priceRange?: { __typename?: 'TaxedMoneyRange', start?: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } } | null, stop?: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } } | null } | null, priceRangeUndiscounted?: { __typename?: 'TaxedMoneyRange', start?: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } } | null } | null } | null };

export type ProductTypeFragment = { __typename?: 'Product', productType: { __typename?: 'ProductType', slug: string, name: string } };

export type ProductUrlBaseFragment = { __typename?: 'Product', collections?: Array<{ __typename?: 'Collection', name: string, slug: string, translation?: { __typename?: 'CollectionTranslation', name?: string | null } | null }> | null, model?: { __typename?: 'SelectedAttribute', values: Array<{ __typename?: 'AttributeValue', slug?: string | null }> } | null, strapMaterial?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, strapColor?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, defaultVariant?: { __typename?: 'ProductVariant', sku?: string | null } | null, watchName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, strapName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, collectionName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, warrantyName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, eyewearModel?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, toolName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, digitalItemName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, productType: { __typename?: 'ProductType', slug: string, name: string } };

export type ProductVariantEyewearBasicDetailsFragment = { __typename?: 'ProductVariant', id: string, sku?: string | null, quantityAvailable?: number | null, pricing?: { __typename?: 'VariantPricingInfo', price?: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } } | null } | null, product: { __typename?: 'Product', id: string, name: string, slug: string, description?: string | null, translation?: { __typename?: 'ProductTranslation', id: string, description?: string | null, name?: string | null } | null, thumbnail?: { __typename?: 'Image', alt?: string | null, url: string } | null, media?: Array<{ __typename?: 'ProductMedia', url: string, alt: string, type: ProductMediaType, strapPreviewCoordinates?: string | null, backEngravingCoordinates?: string | null, shotType?: string | null }> | null, mediaLarge?: Array<{ __typename?: 'ProductMedia', url: string, id: string }> | null, collections?: Array<{ __typename?: 'Collection', name: string, slug: string, translation?: { __typename?: 'CollectionTranslation', name?: string | null } | null }> | null, model?: { __typename?: 'SelectedAttribute', values: Array<{ __typename?: 'AttributeValue', slug?: string | null }> } | null, strapMaterial?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, strapColor?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, defaultVariant?: { __typename?: 'ProductVariant', sku?: string | null } | null, watchName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, strapName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, collectionName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, warrantyName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, eyewearModel?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, toolName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, digitalItemName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, marketingDescription?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, frameShape?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, frameColor?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, frameMaterial?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, coreWire?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, templeTipDetail?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, frontalPins?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, lensSurface?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, lensColor?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, lensCoating?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, uvProtection?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, frontalWidth?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string } | null }> } | null, templeLength?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string } | null }> } | null, lensWidth?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string } | null }> } | null, bridgeWidth?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string } | null }> } | null, bundleVariations?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, manualUrl?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, eyewearModelStory?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, marketingStatus?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, launchDate?: { __typename?: 'SelectedAttribute', values: Array<{ __typename?: 'AttributeValue', name?: string | null }> } | null, productType: { __typename?: 'ProductType', slug: string, name: string } } };

export type ProductVariantLineFragment = { __typename?: 'ProductVariant', id: string, sku?: string | null, product: { __typename?: 'Product', id: string, name: string, watchName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, strapName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, buckleName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, toolName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, warrantyName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, eyewearModel?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, digitalItemName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, translation?: { __typename?: 'ProductTranslation', name?: string | null } | null, defaultVariant?: { __typename?: 'ProductVariant', sku?: string | null, pricing?: { __typename?: 'VariantPricingInfo', price?: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } } | null } | null } | null, color?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, caseMaterial?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, strapMaterial?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, size?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, compatibleStraps?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, buckle?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, strapColor?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, warrantyExtensionDuration?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, warrantyMovementDuration?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, wristSizeMinInch?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, wristSizeMaxInch?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, wristSizeMinMm?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, wristSizeMaxMm?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, marketingPartner?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, media?: Array<{ __typename?: 'ProductMedia', url: string, alt: string, type: ProductMediaType, strapPreviewCoordinates?: string | null, backEngravingCoordinates?: string | null, shotType?: string | null }> | null, personalizedEngraving?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', boolean?: boolean | null, slug?: string | null }> } | null, productType: { __typename?: 'ProductType', slug: string, name: string }, thumbnail?: { __typename?: 'Image', alt?: string | null, url: string } | null, collections?: Array<{ __typename?: 'Collection', name: string, slug: string, translation?: { __typename?: 'CollectionTranslation', name?: string | null } | null }> | null, model?: { __typename?: 'SelectedAttribute', values: Array<{ __typename?: 'AttributeValue', slug?: string | null }> } | null, collectionName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null } };

export type ProductVariantStrapBasicDetailsFragment = { __typename?: 'ProductVariant', id: string, sku?: string | null, product: { __typename?: 'Product', id: string, name: string, slug: string, description?: string | null, translation?: { __typename?: 'ProductTranslation', description?: string | null, name?: string | null } | null, thumbnail?: { __typename?: 'Image', alt?: string | null, url: string } | null, media?: Array<{ __typename?: 'ProductMedia', url: string, alt: string, type: ProductMediaType, strapPreviewCoordinates?: string | null, backEngravingCoordinates?: string | null, shotType?: string | null }> | null, mediaLarge?: Array<{ __typename?: 'ProductMedia', url: string, id: string }> | null, collections?: Array<{ __typename?: 'Collection', name: string, slug: string, translation?: { __typename?: 'CollectionTranslation', name?: string | null } | null }> | null, model?: { __typename?: 'SelectedAttribute', values: Array<{ __typename?: 'AttributeValue', slug?: string | null }> } | null, strapMaterial?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, strapColor?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, defaultVariant?: { __typename?: 'ProductVariant', sku?: string | null } | null, watchName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, strapName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, collectionName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, warrantyName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, eyewearModel?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, toolName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, digitalItemName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, otherSizesSkus?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, integratedBuckle?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', boolean?: boolean | null, slug?: string | null }> } | null, lugSize?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, color?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, lug?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, lugType?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, buckleType?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, compatibleBuckles?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, marketingDescription?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, productType: { __typename?: 'ProductType', slug: string, name: string } } };

export type ProductVariantStrapDetailsFragment = { __typename?: 'ProductVariant', quantityAvailable?: number | null, translation?: { __typename?: 'ProductVariantTranslation', id: string, name: string } | null, pricing?: { __typename?: 'VariantPricingInfo', price?: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } } | null } | null, product: { __typename?: 'Product', otherSizesSkus?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, integratedBuckle?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', boolean?: boolean | null, slug?: string | null }> } | null, lugSize?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, strapMaterial?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, color?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, lug?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, lugType?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, buckleType?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, compatibleBuckles?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, marketingDescription?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null } };

export type ProductVariantStrapSkuFragment = { __typename?: 'ProductVariant', id: string, sku?: string | null, product: { __typename?: 'Product', id: string, name: string, slug: string, description?: string | null, translation?: { __typename?: 'ProductTranslation', description?: string | null, name?: string | null } | null, defaultVariant?: { __typename?: 'ProductVariant', sku?: string | null, id: string, quantityAvailable?: number | null, pricing?: { __typename?: 'VariantPricingInfo', price?: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } } | null } | null } | null, thumbnail?: { __typename?: 'Image', alt?: string | null, url: string } | null, media?: Array<{ __typename?: 'ProductMedia', url: string, alt: string, type: ProductMediaType, strapPreviewCoordinates?: string | null, backEngravingCoordinates?: string | null, shotType?: string | null }> | null, mediaLarge?: Array<{ __typename?: 'ProductMedia', url: string, id: string }> | null, collections?: Array<{ __typename?: 'Collection', name: string, slug: string, translation?: { __typename?: 'CollectionTranslation', name?: string | null } | null }> | null, model?: { __typename?: 'SelectedAttribute', values: Array<{ __typename?: 'AttributeValue', slug?: string | null }> } | null, strapMaterial?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, strapColor?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, watchName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, strapName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, collectionName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, warrantyName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, eyewearModel?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, toolName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, digitalItemName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, productType: { __typename?: 'ProductType', slug: string, name: string } } };

export type ProductVariantWatchBasicDetailsFragment = { __typename?: 'ProductVariant', id: string, sku?: string | null, pricing?: { __typename?: 'VariantPricingInfo', price?: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } } | null } | null, product: { __typename?: 'Product', id: string, name: string, slug: string, description?: string | null, translation?: { __typename?: 'ProductTranslation', description?: string | null, name?: string | null } | null, media?: Array<{ __typename?: 'ProductMedia', url: string, alt: string, type: ProductMediaType, strapPreviewCoordinates?: string | null, backEngravingCoordinates?: string | null, shotType?: string | null }> | null, mediaLarge?: Array<{ __typename?: 'ProductMedia', url: string, id: string }> | null, specificText?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, relatedProducts?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, compatibleStraps?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, manualUrl?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, pricing?: { __typename?: 'ProductPricingInfo', displayGrossPrices: boolean } | null, thumbnail?: { __typename?: 'Image', alt?: string | null, url: string } | null, collections?: Array<{ __typename?: 'Collection', name: string, slug: string, translation?: { __typename?: 'CollectionTranslation', name?: string | null } | null }> | null, model?: { __typename?: 'SelectedAttribute', values: Array<{ __typename?: 'AttributeValue', slug?: string | null }> } | null, strapMaterial?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, strapColor?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, defaultVariant?: { __typename?: 'ProductVariant', sku?: string | null } | null, watchName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, strapName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, collectionName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, warrantyName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, eyewearModel?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, toolName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, digitalItemName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, marketingStatus?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, marketingPartner?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, marketingCampaign?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, distributionStatus?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, launchDate?: { __typename?: 'SelectedAttribute', values: Array<{ __typename?: 'AttributeValue', name?: string | null }> } | null, limited?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', boolean?: boolean | null, slug?: string | null }> } | null, buckleMaterial?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, buckleType?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, buckleSize?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, dialColor?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, modelStory?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, caseMaterial?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, waterResistance?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, waterResistanceTextComputed?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, diameter?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string } | null }> } | null, thickness?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string } | null }> } | null, weight?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string } | null }> } | null, powerReserve?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, caliber?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, movement?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, chronograph?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, vibration?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, jewel?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, calendar?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, caseback?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, bezel?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, crown?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, crystal?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, headWeight?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string } | null }> } | null, height?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string } | null }> } | null, lugWidth?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string } | null }> } | null, strapType?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, lug?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, warrantyDuration?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, warrantyExtensionDuration?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, movementManufacture?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, bundleVariations?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, comCategories?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, designerChoice?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, personalizedEngraving?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', boolean?: boolean | null, slug?: string | null }> } | null, productType: { __typename?: 'ProductType', slug: string, name: string } }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> };

export type ProductVariantWatchDetailsFragment = { __typename?: 'ProductVariant', id: string, name: string, quantityAvailable?: number | null, translation?: { __typename?: 'ProductVariantTranslation', id: string, name: string } | null, pricing?: { __typename?: 'VariantPricingInfo', price?: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } } | null } | null, product: { __typename?: 'Product', id: string, pricing?: { __typename?: 'ProductPricingInfo', displayGrossPrices: boolean } | null, media?: Array<{ __typename?: 'ProductMedia', strapPreviewCoordinates?: string | null }> | null, marketingStatus?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, marketingPartner?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, marketingCampaign?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, distributionStatus?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, launchDate?: { __typename?: 'SelectedAttribute', values: Array<{ __typename?: 'AttributeValue', name?: string | null }> } | null, limited?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', boolean?: boolean | null, slug?: string | null }> } | null, buckleMaterial?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, buckleType?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, buckleSize?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, dialColor?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, modelStory?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, caseMaterial?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, waterResistance?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, waterResistanceTextComputed?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, diameter?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string } | null }> } | null, thickness?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string } | null }> } | null, weight?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string } | null }> } | null, powerReserve?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, relatedProducts?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, compatibleStraps?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, caliber?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, movement?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, chronograph?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, vibration?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, jewel?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, calendar?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, caseback?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, bezel?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, crown?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, crystal?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, headWeight?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string } | null }> } | null, height?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string } | null }> } | null, lugWidth?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string } | null }> } | null, strapMaterial?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, strapColor?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, strapType?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, lug?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, warrantyDuration?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, warrantyExtensionDuration?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, movementManufacture?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, manualUrl?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, bundleVariations?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, comCategories?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, designerChoice?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, personalizedEngraving?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', boolean?: boolean | null, slug?: string | null }> } | null } };

export type ProductVariantWatchSkuFragment = { __typename?: 'ProductVariant', id: string, sku?: string | null, product: { __typename?: 'Product', id: string, name: string, slug: string, description?: string | null, translation?: { __typename?: 'ProductTranslation', description?: string | null, name?: string | null } | null, defaultVariant?: { __typename?: 'ProductVariant', sku?: string | null, id: string, quantityAvailable?: number | null, pricing?: { __typename?: 'VariantPricingInfo', price?: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } } | null } | null } | null, media?: Array<{ __typename?: 'ProductMedia', url: string, alt: string, type: ProductMediaType, strapPreviewCoordinates?: string | null, backEngravingCoordinates?: string | null, shotType?: string | null }> | null, mediaLarge?: Array<{ __typename?: 'ProductMedia', url: string, id: string }> | null, thumbnail?: { __typename?: 'Image', alt?: string | null, url: string } | null, relatedProducts?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, compatibleStraps?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, collections?: Array<{ __typename?: 'Collection', name: string, slug: string, translation?: { __typename?: 'CollectionTranslation', name?: string | null } | null }> | null, model?: { __typename?: 'SelectedAttribute', values: Array<{ __typename?: 'AttributeValue', slug?: string | null }> } | null, strapMaterial?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, strapColor?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, watchName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, strapName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, collectionName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, warrantyName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, eyewearModel?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, toolName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, digitalItemName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, marketingStatus?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, marketingPartner?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, marketingCampaign?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, distributionStatus?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, launchDate?: { __typename?: 'SelectedAttribute', values: Array<{ __typename?: 'AttributeValue', name?: string | null }> } | null, limited?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', boolean?: boolean | null, slug?: string | null }> } | null, buckleMaterial?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, buckleType?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, buckleSize?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, dialColor?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, modelStory?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, caseMaterial?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, waterResistance?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, waterResistanceTextComputed?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, diameter?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string } | null }> } | null, thickness?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string } | null }> } | null, weight?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string } | null }> } | null, powerReserve?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, caliber?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, movement?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, chronograph?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, vibration?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, jewel?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, calendar?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, caseback?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, bezel?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, crown?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, crystal?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, headWeight?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string } | null }> } | null, height?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string } | null }> } | null, lugWidth?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string } | null }> } | null, strapType?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, lug?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, warrantyDuration?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, warrantyExtensionDuration?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, movementManufacture?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, manualUrl?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, bundleVariations?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, comCategories?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, designerChoice?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, personalizedEngraving?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', boolean?: boolean | null, slug?: string | null }> } | null, productType: { __typename?: 'ProductType', slug: string, name: string } } };

export type ProductVariantsBySkusFragment = { __typename?: 'ProductVariant', id: string, name: string, quantityAvailable?: number | null, translation?: { __typename?: 'ProductVariantTranslation', id: string, name: string } | null, pricing?: { __typename?: 'VariantPricingInfo', price?: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } } | null } | null, product: { __typename?: 'Product', id: string, productType: { __typename?: 'ProductType', name: string, slug: string }, marketingStatus?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, marketingPartner?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, marketingCampaign?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, distributionStatus?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, launchDate?: { __typename?: 'SelectedAttribute', values: Array<{ __typename?: 'AttributeValue', name?: string | null }> } | null, limited?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', boolean?: boolean | null, slug?: string | null }> } | null, buckleMaterial?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, buckleType?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, buckleSize?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, dialColor?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, modelStory?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, caseMaterial?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, waterResistance?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, waterResistanceTextComputed?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, diameter?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string } | null }> } | null, thickness?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string } | null }> } | null, weight?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string } | null }> } | null, powerReserve?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, relatedProducts?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, compatibleStraps?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, caliber?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, movement?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, chronograph?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, vibration?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, jewel?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, calendar?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, caseback?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, bezel?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, crown?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, crystal?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, headWeight?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string } | null }> } | null, height?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string } | null }> } | null, lugWidth?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string } | null }> } | null, strapMaterial?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, strapColor?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, strapType?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, lug?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, warrantyDuration?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, warrantyExtensionDuration?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, movementManufacture?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, manualUrl?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, bundleVariations?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, comCategories?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, designerChoice?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, personalizedEngraving?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', boolean?: boolean | null, slug?: string | null }> } | null } };

export type SelectedAttributeDetailsFragment = { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', id: string, name?: string | null, type?: AttributeTypeEnum | null, unit?: MeasurementUnitsEnum | null, translation?: { __typename?: 'AttributeTranslation', id: string, name: string } | null }, values: Array<{ __typename?: 'AttributeValue', id: string, name?: string | null, value?: string | null, translation?: { __typename?: 'AttributeValueTranslation', id: string, name: string, richText?: string | null } | null }> };

export type ShippingMethodFragment = { __typename?: 'ShippingMethod', id: string, name: string, minimumDeliveryDays?: number | null, maximumDeliveryDays?: number | null, translation?: { __typename?: 'ShippingMethodTranslation', name?: string | null } | null, price: { __typename?: 'Money', amount: number, currency: string } };

export type ShoppingBagProductFragment = { __typename?: 'ProductVariant', id: string, sku?: string | null, product: { __typename?: 'Product', id: string, name: string, translation?: { __typename?: 'ProductTranslation', name?: string | null } | null, defaultVariant?: { __typename?: 'ProductVariant', sku?: string | null, pricing?: { __typename?: 'VariantPricingInfo', price?: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } } | null } | null } | null, color?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, caseMaterial?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, strapMaterial?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, size?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, compatibleStraps?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, buckle?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, strapColor?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, warrantyExtensionDuration?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, warrantyMovementDuration?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, wristSizeMinInch?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, wristSizeMaxInch?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, wristSizeMinMm?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, wristSizeMaxMm?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, marketingPartner?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, media?: Array<{ __typename?: 'ProductMedia', url: string, alt: string, type: ProductMediaType, strapPreviewCoordinates?: string | null, backEngravingCoordinates?: string | null, shotType?: string | null }> | null, personalizedEngraving?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', boolean?: boolean | null, slug?: string | null }> } | null, productType: { __typename?: 'ProductType', slug: string, name: string }, thumbnail?: { __typename?: 'Image', alt?: string | null, url: string } | null, collections?: Array<{ __typename?: 'Collection', name: string, slug: string, translation?: { __typename?: 'CollectionTranslation', name?: string | null } | null }> | null, model?: { __typename?: 'SelectedAttribute', values: Array<{ __typename?: 'AttributeValue', slug?: string | null }> } | null, watchName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, strapName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, collectionName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, warrantyName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, eyewearModel?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, toolName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, digitalItemName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null } };

export type ShoppingBagStrapsModalFragment = { __typename?: 'ProductVariant', id: string, sku?: string | null, pricing?: { __typename?: 'VariantPricingInfo', price?: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } } | null } | null, product: { __typename?: 'Product', id: string, name: string, translation?: { __typename?: 'ProductTranslation', name?: string | null } | null, compatibleBuckles?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, integratedBuckle?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', boolean?: boolean | null, slug?: string | null }> } | null, otherSizesSkus?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, strapName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, warrantyName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, toolName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, thumbnail?: { __typename?: 'Image', alt?: string | null, url: string } | null, productType: { __typename?: 'ProductType', slug: string, name: string } } };

export type StrapAttributesFragment = { __typename?: 'Product', otherSizesSkus?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, integratedBuckle?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', boolean?: boolean | null, slug?: string | null }> } | null, lugSize?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, strapMaterial?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, color?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, lug?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, lugType?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, buckleType?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, compatibleBuckles?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, marketingDescription?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null };

export type TaxedMoneyFragment = { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } };

export type TransactionEventFragment = { __typename?: 'TransactionEvent', type?: TransactionEventTypeEnum | null, createdAt: string, pspReference: string, message: string, amount: { __typename?: 'Money', amount: number, currency: string } };

export type TransactionInitializeErrorFragment = { __typename?: 'TransactionInitializeError', field?: string | null, message?: string | null, code: TransactionInitializeErrorCode };

export type TransactionItemFragment = { __typename?: 'TransactionItem', id: string, paymentData?: string | null, paymentMethod?: string | null, forGiftPaymentData?: string | null, oricoFinancingAppPaymentData?: string | null, genericPaymentData?: string | null, authorizedAmount: { __typename?: 'Money', amount: number, currency: string }, chargedAmount: { __typename?: 'Money', amount: number, currency: string }, chargePendingAmount: { __typename?: 'Money', amount: number, currency: string }, events: Array<{ __typename?: 'TransactionEvent', type?: TransactionEventTypeEnum | null, createdAt: string, pspReference: string, message: string, amount: { __typename?: 'Money', amount: number, currency: string } }> };

export type TransactionProcessErrorFragment = { __typename?: 'TransactionProcessError', field?: string | null, message?: string | null, code: TransactionProcessErrorCode };

export type UserFragment = { __typename?: 'User', id: string, email: string, firstName: string, lastName: string, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }>, addresses: Array<{ __typename?: 'Address', id: string, city: string, cityArea: string, companyName: string, countryArea: string, firstName: string, isDefaultBillingAddress?: boolean | null, isDefaultShippingAddress?: boolean | null, lastName: string, phone?: string | null, postalCode: string, streetAddress1: string, streetAddress2: string, country: { __typename?: 'CountryDisplay', code: string, country: string }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> }>, defaultBillingAddress?: { __typename?: 'Address', id: string, city: string, cityArea: string, companyName: string, countryArea: string, firstName: string, isDefaultBillingAddress?: boolean | null, isDefaultShippingAddress?: boolean | null, lastName: string, phone?: string | null, postalCode: string, streetAddress1: string, streetAddress2: string, country: { __typename?: 'CountryDisplay', code: string, country: string }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> } | null, defaultShippingAddress?: { __typename?: 'Address', id: string, city: string, cityArea: string, companyName: string, countryArea: string, firstName: string, isDefaultBillingAddress?: boolean | null, isDefaultShippingAddress?: boolean | null, lastName: string, phone?: string | null, postalCode: string, streetAddress1: string, streetAddress2: string, country: { __typename?: 'CountryDisplay', code: string, country: string }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> } | null, checkout?: { __typename?: 'Checkout', id: string, channel: { __typename?: 'Channel', slug: string } } | null };

export type VariantPricingFragment = { __typename?: 'VariantPricingInfo', price?: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } } | null };

export type WarehouseFragment = { __typename?: 'Warehouse', id: string, name: string, email: string, address: { __typename?: 'Address', id: string, city: string, cityArea: string, companyName: string, countryArea: string, firstName: string, isDefaultBillingAddress?: boolean | null, isDefaultShippingAddress?: boolean | null, lastName: string, phone?: string | null, postalCode: string, streetAddress1: string, streetAddress2: string, country: { __typename?: 'CountryDisplay', code: string, country: string }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> } };

type WarrantyRelatedWatchMetadata_Address_Fragment = { __typename?: 'Address', relatedWatchSku?: string | null, relatedWatchSn?: string | null, warrantyDuration?: string | null, relatedProductWatchId?: string | null };

type WarrantyRelatedWatchMetadata_App_Fragment = { __typename?: 'App', relatedWatchSku?: string | null, relatedWatchSn?: string | null, warrantyDuration?: string | null, relatedProductWatchId?: string | null };

type WarrantyRelatedWatchMetadata_Attribute_Fragment = { __typename?: 'Attribute', relatedWatchSku?: string | null, relatedWatchSn?: string | null, warrantyDuration?: string | null, relatedProductWatchId?: string | null };

type WarrantyRelatedWatchMetadata_Category_Fragment = { __typename?: 'Category', relatedWatchSku?: string | null, relatedWatchSn?: string | null, warrantyDuration?: string | null, relatedProductWatchId?: string | null };

type WarrantyRelatedWatchMetadata_Channel_Fragment = { __typename?: 'Channel', relatedWatchSku?: string | null, relatedWatchSn?: string | null, warrantyDuration?: string | null, relatedProductWatchId?: string | null };

type WarrantyRelatedWatchMetadata_Checkout_Fragment = { __typename?: 'Checkout', relatedWatchSku?: string | null, relatedWatchSn?: string | null, warrantyDuration?: string | null, relatedProductWatchId?: string | null };

type WarrantyRelatedWatchMetadata_CheckoutLine_Fragment = { __typename?: 'CheckoutLine', relatedWatchSku?: string | null, relatedWatchSn?: string | null, warrantyDuration?: string | null, relatedProductWatchId?: string | null };

type WarrantyRelatedWatchMetadata_Collection_Fragment = { __typename?: 'Collection', relatedWatchSku?: string | null, relatedWatchSn?: string | null, warrantyDuration?: string | null, relatedProductWatchId?: string | null };

type WarrantyRelatedWatchMetadata_DigitalContent_Fragment = { __typename?: 'DigitalContent', relatedWatchSku?: string | null, relatedWatchSn?: string | null, warrantyDuration?: string | null, relatedProductWatchId?: string | null };

type WarrantyRelatedWatchMetadata_Fulfillment_Fragment = { __typename?: 'Fulfillment', relatedWatchSku?: string | null, relatedWatchSn?: string | null, warrantyDuration?: string | null, relatedProductWatchId?: string | null };

type WarrantyRelatedWatchMetadata_GiftCard_Fragment = { __typename?: 'GiftCard', relatedWatchSku?: string | null, relatedWatchSn?: string | null, warrantyDuration?: string | null, relatedProductWatchId?: string | null };

type WarrantyRelatedWatchMetadata_Invoice_Fragment = { __typename?: 'Invoice', relatedWatchSku?: string | null, relatedWatchSn?: string | null, warrantyDuration?: string | null, relatedProductWatchId?: string | null };

type WarrantyRelatedWatchMetadata_Menu_Fragment = { __typename?: 'Menu', relatedWatchSku?: string | null, relatedWatchSn?: string | null, warrantyDuration?: string | null, relatedProductWatchId?: string | null };

type WarrantyRelatedWatchMetadata_MenuItem_Fragment = { __typename?: 'MenuItem', relatedWatchSku?: string | null, relatedWatchSn?: string | null, warrantyDuration?: string | null, relatedProductWatchId?: string | null };

type WarrantyRelatedWatchMetadata_Order_Fragment = { __typename?: 'Order', relatedWatchSku?: string | null, relatedWatchSn?: string | null, warrantyDuration?: string | null, relatedProductWatchId?: string | null };

type WarrantyRelatedWatchMetadata_OrderLine_Fragment = { __typename?: 'OrderLine', relatedWatchSku?: string | null, relatedWatchSn?: string | null, warrantyDuration?: string | null, relatedProductWatchId?: string | null };

type WarrantyRelatedWatchMetadata_Page_Fragment = { __typename?: 'Page', relatedWatchSku?: string | null, relatedWatchSn?: string | null, warrantyDuration?: string | null, relatedProductWatchId?: string | null };

type WarrantyRelatedWatchMetadata_PageType_Fragment = { __typename?: 'PageType', relatedWatchSku?: string | null, relatedWatchSn?: string | null, warrantyDuration?: string | null, relatedProductWatchId?: string | null };

type WarrantyRelatedWatchMetadata_Payment_Fragment = { __typename?: 'Payment', relatedWatchSku?: string | null, relatedWatchSn?: string | null, warrantyDuration?: string | null, relatedProductWatchId?: string | null };

type WarrantyRelatedWatchMetadata_Product_Fragment = { __typename?: 'Product', relatedWatchSku?: string | null, relatedWatchSn?: string | null, warrantyDuration?: string | null, relatedProductWatchId?: string | null };

type WarrantyRelatedWatchMetadata_ProductMedia_Fragment = { __typename?: 'ProductMedia', relatedWatchSku?: string | null, relatedWatchSn?: string | null, warrantyDuration?: string | null, relatedProductWatchId?: string | null };

type WarrantyRelatedWatchMetadata_ProductType_Fragment = { __typename?: 'ProductType', relatedWatchSku?: string | null, relatedWatchSn?: string | null, warrantyDuration?: string | null, relatedProductWatchId?: string | null };

type WarrantyRelatedWatchMetadata_ProductVariant_Fragment = { __typename?: 'ProductVariant', relatedWatchSku?: string | null, relatedWatchSn?: string | null, warrantyDuration?: string | null, relatedProductWatchId?: string | null };

type WarrantyRelatedWatchMetadata_Promotion_Fragment = { __typename?: 'Promotion', relatedWatchSku?: string | null, relatedWatchSn?: string | null, warrantyDuration?: string | null, relatedProductWatchId?: string | null };

type WarrantyRelatedWatchMetadata_Sale_Fragment = { __typename?: 'Sale', relatedWatchSku?: string | null, relatedWatchSn?: string | null, warrantyDuration?: string | null, relatedProductWatchId?: string | null };

type WarrantyRelatedWatchMetadata_ShippingMethod_Fragment = { __typename?: 'ShippingMethod', relatedWatchSku?: string | null, relatedWatchSn?: string | null, warrantyDuration?: string | null, relatedProductWatchId?: string | null };

type WarrantyRelatedWatchMetadata_ShippingMethodType_Fragment = { __typename?: 'ShippingMethodType', relatedWatchSku?: string | null, relatedWatchSn?: string | null, warrantyDuration?: string | null, relatedProductWatchId?: string | null };

type WarrantyRelatedWatchMetadata_ShippingZone_Fragment = { __typename?: 'ShippingZone', relatedWatchSku?: string | null, relatedWatchSn?: string | null, warrantyDuration?: string | null, relatedProductWatchId?: string | null };

type WarrantyRelatedWatchMetadata_Shop_Fragment = { __typename?: 'Shop', relatedWatchSku?: string | null, relatedWatchSn?: string | null, warrantyDuration?: string | null, relatedProductWatchId?: string | null };

type WarrantyRelatedWatchMetadata_TaxClass_Fragment = { __typename?: 'TaxClass', relatedWatchSku?: string | null, relatedWatchSn?: string | null, warrantyDuration?: string | null, relatedProductWatchId?: string | null };

type WarrantyRelatedWatchMetadata_TaxConfiguration_Fragment = { __typename?: 'TaxConfiguration', relatedWatchSku?: string | null, relatedWatchSn?: string | null, warrantyDuration?: string | null, relatedProductWatchId?: string | null };

type WarrantyRelatedWatchMetadata_TransactionItem_Fragment = { __typename?: 'TransactionItem', relatedWatchSku?: string | null, relatedWatchSn?: string | null, warrantyDuration?: string | null, relatedProductWatchId?: string | null };

type WarrantyRelatedWatchMetadata_User_Fragment = { __typename?: 'User', relatedWatchSku?: string | null, relatedWatchSn?: string | null, warrantyDuration?: string | null, relatedProductWatchId?: string | null };

type WarrantyRelatedWatchMetadata_Voucher_Fragment = { __typename?: 'Voucher', relatedWatchSku?: string | null, relatedWatchSn?: string | null, warrantyDuration?: string | null, relatedProductWatchId?: string | null };

type WarrantyRelatedWatchMetadata_Warehouse_Fragment = { __typename?: 'Warehouse', relatedWatchSku?: string | null, relatedWatchSn?: string | null, warrantyDuration?: string | null, relatedProductWatchId?: string | null };

export type WarrantyRelatedWatchMetadataFragment = WarrantyRelatedWatchMetadata_Address_Fragment | WarrantyRelatedWatchMetadata_App_Fragment | WarrantyRelatedWatchMetadata_Attribute_Fragment | WarrantyRelatedWatchMetadata_Category_Fragment | WarrantyRelatedWatchMetadata_Channel_Fragment | WarrantyRelatedWatchMetadata_Checkout_Fragment | WarrantyRelatedWatchMetadata_CheckoutLine_Fragment | WarrantyRelatedWatchMetadata_Collection_Fragment | WarrantyRelatedWatchMetadata_DigitalContent_Fragment | WarrantyRelatedWatchMetadata_Fulfillment_Fragment | WarrantyRelatedWatchMetadata_GiftCard_Fragment | WarrantyRelatedWatchMetadata_Invoice_Fragment | WarrantyRelatedWatchMetadata_Menu_Fragment | WarrantyRelatedWatchMetadata_MenuItem_Fragment | WarrantyRelatedWatchMetadata_Order_Fragment | WarrantyRelatedWatchMetadata_OrderLine_Fragment | WarrantyRelatedWatchMetadata_Page_Fragment | WarrantyRelatedWatchMetadata_PageType_Fragment | WarrantyRelatedWatchMetadata_Payment_Fragment | WarrantyRelatedWatchMetadata_Product_Fragment | WarrantyRelatedWatchMetadata_ProductMedia_Fragment | WarrantyRelatedWatchMetadata_ProductType_Fragment | WarrantyRelatedWatchMetadata_ProductVariant_Fragment | WarrantyRelatedWatchMetadata_Promotion_Fragment | WarrantyRelatedWatchMetadata_Sale_Fragment | WarrantyRelatedWatchMetadata_ShippingMethod_Fragment | WarrantyRelatedWatchMetadata_ShippingMethodType_Fragment | WarrantyRelatedWatchMetadata_ShippingZone_Fragment | WarrantyRelatedWatchMetadata_Shop_Fragment | WarrantyRelatedWatchMetadata_TaxClass_Fragment | WarrantyRelatedWatchMetadata_TaxConfiguration_Fragment | WarrantyRelatedWatchMetadata_TransactionItem_Fragment | WarrantyRelatedWatchMetadata_User_Fragment | WarrantyRelatedWatchMetadata_Voucher_Fragment | WarrantyRelatedWatchMetadata_Warehouse_Fragment;

export type WatchAttributesFragment = { __typename?: 'Product', marketingStatus?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, marketingPartner?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, marketingCampaign?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, distributionStatus?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, launchDate?: { __typename?: 'SelectedAttribute', values: Array<{ __typename?: 'AttributeValue', name?: string | null }> } | null, limited?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', boolean?: boolean | null, slug?: string | null }> } | null, buckleMaterial?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, buckleType?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, buckleSize?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, dialColor?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, modelStory?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, caseMaterial?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, waterResistance?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, waterResistanceTextComputed?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, diameter?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string } | null }> } | null, thickness?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string } | null }> } | null, weight?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string } | null }> } | null, powerReserve?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, relatedProducts?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, compatibleStraps?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, caliber?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, movement?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, chronograph?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, vibration?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, jewel?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, calendar?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, caseback?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, bezel?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, crown?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, crystal?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, headWeight?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string } | null }> } | null, height?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string } | null }> } | null, lugWidth?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string } | null }> } | null, strapMaterial?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, strapColor?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, strapType?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, lug?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, warrantyDuration?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, warrantyExtensionDuration?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, movementManufacture?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, manualUrl?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, bundleVariations?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, comCategories?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, designerChoice?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, personalizedEngraving?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', boolean?: boolean | null, slug?: string | null }> } | null };

export type WatchBasicDetailsForSkusFragment = { __typename?: 'ProductVariant', sku?: string | null, product: { __typename?: 'Product', name: string, thumbnail?: { __typename?: 'Image', alt?: string | null, url: string } | null } };

export type WatchLineAttributesFragment = { __typename?: 'Product', caseMaterial?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, dialColor?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null };

export type AccountAddressCreateMutationVariables = Exact<{
  input: AddressInput;
  type?: InputMaybe<AddressTypeEnum>;
}>;


export type AccountAddressCreateMutation = { __typename?: 'Mutation', accountAddressCreate?: { __typename?: 'AccountAddressCreate', user?: { __typename?: 'User', id: string, email: string, firstName: string, lastName: string, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }>, addresses: Array<{ __typename?: 'Address', id: string, city: string, cityArea: string, companyName: string, countryArea: string, firstName: string, isDefaultBillingAddress?: boolean | null, isDefaultShippingAddress?: boolean | null, lastName: string, phone?: string | null, postalCode: string, streetAddress1: string, streetAddress2: string, country: { __typename?: 'CountryDisplay', code: string, country: string }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> }>, defaultBillingAddress?: { __typename?: 'Address', id: string, city: string, cityArea: string, companyName: string, countryArea: string, firstName: string, isDefaultBillingAddress?: boolean | null, isDefaultShippingAddress?: boolean | null, lastName: string, phone?: string | null, postalCode: string, streetAddress1: string, streetAddress2: string, country: { __typename?: 'CountryDisplay', code: string, country: string }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> } | null, defaultShippingAddress?: { __typename?: 'Address', id: string, city: string, cityArea: string, companyName: string, countryArea: string, firstName: string, isDefaultBillingAddress?: boolean | null, isDefaultShippingAddress?: boolean | null, lastName: string, phone?: string | null, postalCode: string, streetAddress1: string, streetAddress2: string, country: { __typename?: 'CountryDisplay', code: string, country: string }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> } | null, checkout?: { __typename?: 'Checkout', id: string, channel: { __typename?: 'Channel', slug: string } } | null } | null, address?: { __typename?: 'Address', id: string, city: string, cityArea: string, companyName: string, countryArea: string, firstName: string, isDefaultBillingAddress?: boolean | null, isDefaultShippingAddress?: boolean | null, lastName: string, phone?: string | null, postalCode: string, streetAddress1: string, streetAddress2: string, country: { __typename?: 'CountryDisplay', code: string, country: string }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> } | null, errors: Array<{ __typename?: 'AccountError', field?: string | null, message?: string | null, code: AccountErrorCode }> } | null };

export type AddressDeleteMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type AddressDeleteMutation = { __typename?: 'Mutation', accountAddressDelete?: { __typename?: 'AccountAddressDelete', user?: { __typename?: 'User', id: string, email: string, firstName: string, lastName: string, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }>, addresses: Array<{ __typename?: 'Address', id: string, city: string, cityArea: string, companyName: string, countryArea: string, firstName: string, isDefaultBillingAddress?: boolean | null, isDefaultShippingAddress?: boolean | null, lastName: string, phone?: string | null, postalCode: string, streetAddress1: string, streetAddress2: string, country: { __typename?: 'CountryDisplay', code: string, country: string }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> }>, defaultBillingAddress?: { __typename?: 'Address', id: string, city: string, cityArea: string, companyName: string, countryArea: string, firstName: string, isDefaultBillingAddress?: boolean | null, isDefaultShippingAddress?: boolean | null, lastName: string, phone?: string | null, postalCode: string, streetAddress1: string, streetAddress2: string, country: { __typename?: 'CountryDisplay', code: string, country: string }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> } | null, defaultShippingAddress?: { __typename?: 'Address', id: string, city: string, cityArea: string, companyName: string, countryArea: string, firstName: string, isDefaultBillingAddress?: boolean | null, isDefaultShippingAddress?: boolean | null, lastName: string, phone?: string | null, postalCode: string, streetAddress1: string, streetAddress2: string, country: { __typename?: 'CountryDisplay', code: string, country: string }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> } | null, checkout?: { __typename?: 'Checkout', id: string, channel: { __typename?: 'Channel', slug: string } } | null } | null, address?: { __typename?: 'Address', id: string, city: string, cityArea: string, companyName: string, countryArea: string, firstName: string, isDefaultBillingAddress?: boolean | null, isDefaultShippingAddress?: boolean | null, lastName: string, phone?: string | null, postalCode: string, streetAddress1: string, streetAddress2: string, country: { __typename?: 'CountryDisplay', code: string, country: string }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> } | null, errors: Array<{ __typename?: 'AccountError', field?: string | null, message?: string | null, code: AccountErrorCode }> } | null };

export type AccountAddressUpdateMutationVariables = Exact<{
  input: AddressInput;
  id: Scalars['ID']['input'];
}>;


export type AccountAddressUpdateMutation = { __typename?: 'Mutation', accountAddressUpdate?: { __typename?: 'AccountAddressUpdate', user?: { __typename?: 'User', id: string, email: string, firstName: string, lastName: string, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }>, addresses: Array<{ __typename?: 'Address', id: string, city: string, cityArea: string, companyName: string, countryArea: string, firstName: string, isDefaultBillingAddress?: boolean | null, isDefaultShippingAddress?: boolean | null, lastName: string, phone?: string | null, postalCode: string, streetAddress1: string, streetAddress2: string, country: { __typename?: 'CountryDisplay', code: string, country: string }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> }>, defaultBillingAddress?: { __typename?: 'Address', id: string, city: string, cityArea: string, companyName: string, countryArea: string, firstName: string, isDefaultBillingAddress?: boolean | null, isDefaultShippingAddress?: boolean | null, lastName: string, phone?: string | null, postalCode: string, streetAddress1: string, streetAddress2: string, country: { __typename?: 'CountryDisplay', code: string, country: string }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> } | null, defaultShippingAddress?: { __typename?: 'Address', id: string, city: string, cityArea: string, companyName: string, countryArea: string, firstName: string, isDefaultBillingAddress?: boolean | null, isDefaultShippingAddress?: boolean | null, lastName: string, phone?: string | null, postalCode: string, streetAddress1: string, streetAddress2: string, country: { __typename?: 'CountryDisplay', code: string, country: string }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> } | null, checkout?: { __typename?: 'Checkout', id: string, channel: { __typename?: 'Channel', slug: string } } | null } | null, address?: { __typename?: 'Address', id: string, city: string, cityArea: string, companyName: string, countryArea: string, firstName: string, isDefaultBillingAddress?: boolean | null, isDefaultShippingAddress?: boolean | null, lastName: string, phone?: string | null, postalCode: string, streetAddress1: string, streetAddress2: string, country: { __typename?: 'CountryDisplay', code: string, country: string }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> } | null, errors: Array<{ __typename?: 'AccountError', field?: string | null, message?: string | null, code: AccountErrorCode }> } | null };

export type AccountConfirmMutationVariables = Exact<{
  email: Scalars['String']['input'];
  token: Scalars['String']['input'];
}>;


export type AccountConfirmMutation = { __typename?: 'Mutation', confirmAccount?: { __typename?: 'ConfirmAccount', errors: Array<{ __typename?: 'AccountError', field?: string | null, message?: string | null, code: AccountErrorCode }> } | null };

export type AccountRegisterMutationVariables = Exact<{
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
  redirectUrl: Scalars['String']['input'];
  channel: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  metadata: Array<MetadataInput> | MetadataInput;
}>;


export type AccountRegisterMutation = { __typename?: 'Mutation', accountRegister?: { __typename?: 'AccountRegister', user?: { __typename?: 'User', id: string, email: string, firstName: string, lastName: string, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }>, addresses: Array<{ __typename?: 'Address', id: string, city: string, cityArea: string, companyName: string, countryArea: string, firstName: string, isDefaultBillingAddress?: boolean | null, isDefaultShippingAddress?: boolean | null, lastName: string, phone?: string | null, postalCode: string, streetAddress1: string, streetAddress2: string, country: { __typename?: 'CountryDisplay', code: string, country: string }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> }>, defaultBillingAddress?: { __typename?: 'Address', id: string, city: string, cityArea: string, companyName: string, countryArea: string, firstName: string, isDefaultBillingAddress?: boolean | null, isDefaultShippingAddress?: boolean | null, lastName: string, phone?: string | null, postalCode: string, streetAddress1: string, streetAddress2: string, country: { __typename?: 'CountryDisplay', code: string, country: string }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> } | null, defaultShippingAddress?: { __typename?: 'Address', id: string, city: string, cityArea: string, companyName: string, countryArea: string, firstName: string, isDefaultBillingAddress?: boolean | null, isDefaultShippingAddress?: boolean | null, lastName: string, phone?: string | null, postalCode: string, streetAddress1: string, streetAddress2: string, country: { __typename?: 'CountryDisplay', code: string, country: string }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> } | null, checkout?: { __typename?: 'Checkout', id: string, channel: { __typename?: 'Channel', slug: string } } | null } | null, errors: Array<{ __typename?: 'AccountError', field?: string | null, message?: string | null, code: AccountErrorCode }> } | null };

export type AccountSetDefaultAddressMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  type: AddressTypeEnum;
}>;


export type AccountSetDefaultAddressMutation = { __typename?: 'Mutation', accountSetDefaultAddress?: { __typename?: 'AccountSetDefaultAddress', user?: { __typename?: 'User', id: string, email: string, firstName: string, lastName: string, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }>, addresses: Array<{ __typename?: 'Address', id: string, city: string, cityArea: string, companyName: string, countryArea: string, firstName: string, isDefaultBillingAddress?: boolean | null, isDefaultShippingAddress?: boolean | null, lastName: string, phone?: string | null, postalCode: string, streetAddress1: string, streetAddress2: string, country: { __typename?: 'CountryDisplay', code: string, country: string }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> }>, defaultBillingAddress?: { __typename?: 'Address', id: string, city: string, cityArea: string, companyName: string, countryArea: string, firstName: string, isDefaultBillingAddress?: boolean | null, isDefaultShippingAddress?: boolean | null, lastName: string, phone?: string | null, postalCode: string, streetAddress1: string, streetAddress2: string, country: { __typename?: 'CountryDisplay', code: string, country: string }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> } | null, defaultShippingAddress?: { __typename?: 'Address', id: string, city: string, cityArea: string, companyName: string, countryArea: string, firstName: string, isDefaultBillingAddress?: boolean | null, isDefaultShippingAddress?: boolean | null, lastName: string, phone?: string | null, postalCode: string, streetAddress1: string, streetAddress2: string, country: { __typename?: 'CountryDisplay', code: string, country: string }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> } | null, checkout?: { __typename?: 'Checkout', id: string, channel: { __typename?: 'Channel', slug: string } } | null } | null, errors: Array<{ __typename?: 'AccountError', field?: string | null, message?: string | null, code: AccountErrorCode }> } | null };

export type AccountTokenCreateMutationVariables = Exact<{
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
}>;


export type AccountTokenCreateMutation = { __typename?: 'Mutation', tokenCreate?: { __typename?: 'CreateToken', token?: string | null, refreshToken?: string | null, csrfToken?: string | null, user?: { __typename?: 'User', id: string, email: string, firstName: string, lastName: string, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }>, addresses: Array<{ __typename?: 'Address', id: string, city: string, cityArea: string, companyName: string, countryArea: string, firstName: string, isDefaultBillingAddress?: boolean | null, isDefaultShippingAddress?: boolean | null, lastName: string, phone?: string | null, postalCode: string, streetAddress1: string, streetAddress2: string, country: { __typename?: 'CountryDisplay', code: string, country: string }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> }>, defaultBillingAddress?: { __typename?: 'Address', id: string, city: string, cityArea: string, companyName: string, countryArea: string, firstName: string, isDefaultBillingAddress?: boolean | null, isDefaultShippingAddress?: boolean | null, lastName: string, phone?: string | null, postalCode: string, streetAddress1: string, streetAddress2: string, country: { __typename?: 'CountryDisplay', code: string, country: string }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> } | null, defaultShippingAddress?: { __typename?: 'Address', id: string, city: string, cityArea: string, companyName: string, countryArea: string, firstName: string, isDefaultBillingAddress?: boolean | null, isDefaultShippingAddress?: boolean | null, lastName: string, phone?: string | null, postalCode: string, streetAddress1: string, streetAddress2: string, country: { __typename?: 'CountryDisplay', code: string, country: string }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> } | null, checkout?: { __typename?: 'Checkout', id: string, channel: { __typename?: 'Channel', slug: string } } | null } | null, errors: Array<{ __typename?: 'AccountError', field?: string | null, message?: string | null, code: AccountErrorCode }> } | null };

export type AccountTokenVerifyMutationVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type AccountTokenVerifyMutation = { __typename?: 'Mutation', tokenVerify?: { __typename?: 'VerifyToken', isValid: boolean, user?: { __typename?: 'User', id: string, email: string, firstName: string, lastName: string, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }>, addresses: Array<{ __typename?: 'Address', id: string, city: string, cityArea: string, companyName: string, countryArea: string, firstName: string, isDefaultBillingAddress?: boolean | null, isDefaultShippingAddress?: boolean | null, lastName: string, phone?: string | null, postalCode: string, streetAddress1: string, streetAddress2: string, country: { __typename?: 'CountryDisplay', code: string, country: string }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> }>, defaultBillingAddress?: { __typename?: 'Address', id: string, city: string, cityArea: string, companyName: string, countryArea: string, firstName: string, isDefaultBillingAddress?: boolean | null, isDefaultShippingAddress?: boolean | null, lastName: string, phone?: string | null, postalCode: string, streetAddress1: string, streetAddress2: string, country: { __typename?: 'CountryDisplay', code: string, country: string }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> } | null, defaultShippingAddress?: { __typename?: 'Address', id: string, city: string, cityArea: string, companyName: string, countryArea: string, firstName: string, isDefaultBillingAddress?: boolean | null, isDefaultShippingAddress?: boolean | null, lastName: string, phone?: string | null, postalCode: string, streetAddress1: string, streetAddress2: string, country: { __typename?: 'CountryDisplay', code: string, country: string }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> } | null, checkout?: { __typename?: 'Checkout', id: string, channel: { __typename?: 'Channel', slug: string } } | null } | null, errors: Array<{ __typename?: 'AccountError', field?: string | null, message?: string | null, code: AccountErrorCode }> } | null };

export type AccountUpdateMutationVariables = Exact<{
  input: AccountInput;
}>;


export type AccountUpdateMutation = { __typename?: 'Mutation', accountUpdate?: { __typename?: 'AccountUpdate', user?: { __typename?: 'User', id: string, email: string, firstName: string, lastName: string, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }>, addresses: Array<{ __typename?: 'Address', id: string, city: string, cityArea: string, companyName: string, countryArea: string, firstName: string, isDefaultBillingAddress?: boolean | null, isDefaultShippingAddress?: boolean | null, lastName: string, phone?: string | null, postalCode: string, streetAddress1: string, streetAddress2: string, country: { __typename?: 'CountryDisplay', code: string, country: string }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> }>, defaultBillingAddress?: { __typename?: 'Address', id: string, city: string, cityArea: string, companyName: string, countryArea: string, firstName: string, isDefaultBillingAddress?: boolean | null, isDefaultShippingAddress?: boolean | null, lastName: string, phone?: string | null, postalCode: string, streetAddress1: string, streetAddress2: string, country: { __typename?: 'CountryDisplay', code: string, country: string }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> } | null, defaultShippingAddress?: { __typename?: 'Address', id: string, city: string, cityArea: string, companyName: string, countryArea: string, firstName: string, isDefaultBillingAddress?: boolean | null, isDefaultShippingAddress?: boolean | null, lastName: string, phone?: string | null, postalCode: string, streetAddress1: string, streetAddress2: string, country: { __typename?: 'CountryDisplay', code: string, country: string }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> } | null, checkout?: { __typename?: 'Checkout', id: string, channel: { __typename?: 'Channel', slug: string } } | null } | null, errors: Array<{ __typename?: 'AccountError', field?: string | null, message?: string | null, code: AccountErrorCode }> } | null };

export type CheckoutBillingAddressUpdateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  address: AddressInput;
  validationRules?: InputMaybe<CheckoutAddressValidationRules>;
}>;


export type CheckoutBillingAddressUpdateMutation = { __typename?: 'Mutation', checkoutBillingAddressUpdate?: { __typename?: 'CheckoutBillingAddressUpdate', checkout?: { __typename?: 'Checkout', id: string, billingAddress?: { __typename?: 'Address', id: string, city: string, cityArea: string, companyName: string, countryArea: string, firstName: string, isDefaultBillingAddress?: boolean | null, isDefaultShippingAddress?: boolean | null, lastName: string, phone?: string | null, postalCode: string, streetAddress1: string, streetAddress2: string, country: { __typename?: 'CountryDisplay', code: string, country: string }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> } | null } | null, errors: Array<{ __typename?: 'CheckoutError', field?: string | null, code: CheckoutErrorCode, addressType?: AddressTypeEnum | null, message?: string | null }> } | null };

export type CheckoutCustomerAttachMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  customerId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type CheckoutCustomerAttachMutation = { __typename?: 'Mutation', checkoutCustomerAttach?: { __typename?: 'CheckoutCustomerAttach', checkout?: { __typename?: 'Checkout', id: string, email?: string | null, languageCode: LanguageCodeEnum, user?: { __typename?: 'User', email: string } | null } | null, errors: Array<{ __typename?: 'CheckoutError', field?: string | null, code: CheckoutErrorCode, addressType?: AddressTypeEnum | null, message?: string | null }> } | null };

export type CheckoutDeliveryMethodUpdateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  deliveryMethodId: Scalars['ID']['input'];
  languageCode: LanguageCodeEnum;
  imagesFormat: ThumbnailFormatEnum;
  thumbnailSize: Scalars['Int']['input'];
}>;


export type CheckoutDeliveryMethodUpdateMutation = { __typename?: 'Mutation', checkoutDeliveryMethodUpdate?: { __typename?: 'CheckoutDeliveryMethodUpdate', checkout?: { __typename?: 'Checkout', isShippingRequired: boolean, discountName?: string | null, voucherCode?: string | null, id: string, email?: string | null, languageCode: LanguageCodeEnum, deliveryMode?: string | null, boutiqueExtRef?: string | null, gwpProduct?: string | null, orderBid?: string | null, campaignVoucherCode?: string | null, isGift?: string | null, giftFrom?: string | null, giftMessage?: string | null, shippingTitle?: string | null, billingTitle?: string | null, timeSlot?: string | null, preOrderData?: string | null, orderType?: string | null, orderStatus?: string | null, orderCollectedDate?: string | null, payPerLinkToken?: string | null, payPerLinkExpiration?: string | null, paymentMethod?: string | null, orderFlowScTermsRequired?: string | null, orderFlowScTermsAccepted?: string | null, orderFlowWasUserAuthenticated?: string | null, orderFlowWasRegisterMyWatchChecked?: string | null, orderFlowWasCreateMyAccountWithoutWatchChecked?: string | null, orderFlowWasAccountCreated?: string | null, orderFlowUserJoinClub?: string | null, orderFlowUserAffiliated?: string | null, orderFlowReceiveReceipt?: string | null, checkoutId?: string | null, billingAddress?: { __typename?: 'Address', id: string, city: string, cityArea: string, companyName: string, countryArea: string, firstName: string, isDefaultBillingAddress?: boolean | null, isDefaultShippingAddress?: boolean | null, lastName: string, phone?: string | null, postalCode: string, streetAddress1: string, streetAddress2: string, country: { __typename?: 'CountryDisplay', code: string, country: string }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> } | null, shippingAddress?: { __typename?: 'Address', id: string, city: string, cityArea: string, companyName: string, countryArea: string, firstName: string, isDefaultBillingAddress?: boolean | null, isDefaultShippingAddress?: boolean | null, lastName: string, phone?: string | null, postalCode: string, streetAddress1: string, streetAddress2: string, country: { __typename?: 'CountryDisplay', code: string, country: string }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> } | null, shippingMethods: Array<{ __typename?: 'ShippingMethod', id: string, name: string, minimumDeliveryDays?: number | null, maximumDeliveryDays?: number | null, translation?: { __typename?: 'ShippingMethodTranslation', name?: string | null } | null, price: { __typename?: 'Money', amount: number, currency: string } }>, availableCollectionPoints: Array<{ __typename?: 'Warehouse', id: string, name: string, email: string, address: { __typename?: 'Address', id: string, city: string, cityArea: string, companyName: string, countryArea: string, firstName: string, isDefaultBillingAddress?: boolean | null, isDefaultShippingAddress?: boolean | null, lastName: string, phone?: string | null, postalCode: string, streetAddress1: string, streetAddress2: string, country: { __typename?: 'CountryDisplay', code: string, country: string }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> } }>, deliveryMethod?: { __typename?: 'ShippingMethod', id: string, name: string, minimumDeliveryDays?: number | null, maximumDeliveryDays?: number | null, translation?: { __typename?: 'ShippingMethodTranslation', name?: string | null } | null, price: { __typename?: 'Money', amount: number, currency: string } } | { __typename?: 'Warehouse', id: string, name: string, email: string, address: { __typename?: 'Address', id: string, city: string, cityArea: string, companyName: string, countryArea: string, firstName: string, isDefaultBillingAddress?: boolean | null, isDefaultShippingAddress?: boolean | null, lastName: string, phone?: string | null, postalCode: string, streetAddress1: string, streetAddress2: string, country: { __typename?: 'CountryDisplay', code: string, country: string }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> } } | null, discount?: { __typename?: 'Money', amount: number, currency: string } | null, subtotalPrice: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } }, shippingPrice: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } }, totalPrice: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } }, totalBalance: { __typename?: 'Money', amount: number, currency: string }, channel: { __typename?: 'Channel', slug: string }, lines: Array<{ __typename?: 'CheckoutLine', id: string, quantity: number, relatedProductBuckleId?: string | null, relatedProductStrapId?: string | null, relatedProductWatchId?: string | null, relatedBraceletSize?: string | null, relatedEngravingId?: string | null, strapPackReference?: string | null, strapReference?: string | null, strapSize?: string | null, preOrderData?: string | null, unitPrice: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } }, totalPrice: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } }, undiscountedTotalPrice: { __typename?: 'Money', amount: number, currency: string }, undiscountedUnitPrice: { __typename?: 'Money', amount: number, currency: string }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }>, variant: { __typename?: 'ProductVariant', id: string, sku?: string | null, product: { __typename?: 'Product', id: string, name: string, watchName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, strapName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, buckleName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, toolName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, warrantyName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, eyewearModel?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, digitalItemName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, translation?: { __typename?: 'ProductTranslation', name?: string | null } | null, defaultVariant?: { __typename?: 'ProductVariant', sku?: string | null, pricing?: { __typename?: 'VariantPricingInfo', price?: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } } | null } | null } | null, color?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, caseMaterial?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, strapMaterial?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, size?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, compatibleStraps?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, buckle?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, strapColor?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, warrantyExtensionDuration?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, warrantyMovementDuration?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, wristSizeMinInch?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, wristSizeMaxInch?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, wristSizeMinMm?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, wristSizeMaxMm?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, marketingPartner?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, media?: Array<{ __typename?: 'ProductMedia', url: string, alt: string, type: ProductMediaType, strapPreviewCoordinates?: string | null, backEngravingCoordinates?: string | null, shotType?: string | null }> | null, personalizedEngraving?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', boolean?: boolean | null, slug?: string | null }> } | null, productType: { __typename?: 'ProductType', slug: string, name: string }, thumbnail?: { __typename?: 'Image', alt?: string | null, url: string } | null, collections?: Array<{ __typename?: 'Collection', name: string, slug: string, translation?: { __typename?: 'CollectionTranslation', name?: string | null } | null }> | null, model?: { __typename?: 'SelectedAttribute', values: Array<{ __typename?: 'AttributeValue', slug?: string | null }> } | null, collectionName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null } } }>, user?: { __typename?: 'User', email: string } | null } | null, errors: Array<{ __typename?: 'CheckoutError', field?: string | null, code: CheckoutErrorCode, addressType?: AddressTypeEnum | null, message?: string | null }> } | null };

export type CheckoutEmailUpdateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  email: Scalars['String']['input'];
}>;


export type CheckoutEmailUpdateMutation = { __typename?: 'Mutation', checkoutEmailUpdate?: { __typename?: 'CheckoutEmailUpdate', checkout?: { __typename?: 'Checkout', id: string, email?: string | null, languageCode: LanguageCodeEnum, user?: { __typename?: 'User', email: string } | null } | null, errors: Array<{ __typename?: 'CheckoutError', field?: string | null, code: CheckoutErrorCode, addressType?: AddressTypeEnum | null, message?: string | null }> } | null };

export type CheckoutLanguageCodeUpdateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  languageCode: LanguageCodeEnum;
}>;


export type CheckoutLanguageCodeUpdateMutation = { __typename?: 'Mutation', checkoutLanguageCodeUpdate?: { __typename?: 'CheckoutLanguageCodeUpdate', checkout?: { __typename?: 'Checkout', id: string, email?: string | null, languageCode: LanguageCodeEnum, user?: { __typename?: 'User', email: string } | null } | null, errors: Array<{ __typename?: 'CheckoutError', field?: string | null, code: CheckoutErrorCode, addressType?: AddressTypeEnum | null, message?: string | null }> } | null };

export type CheckoutShippingAddressUpdateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  address: AddressInput;
  languageCode: LanguageCodeEnum;
}>;


export type CheckoutShippingAddressUpdateMutation = { __typename?: 'Mutation', checkoutShippingAddressUpdate?: { __typename?: 'CheckoutShippingAddressUpdate', checkout?: { __typename?: 'Checkout', id: string, isShippingRequired: boolean, discountName?: string | null, totalPrice: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } }, totalBalance: { __typename?: 'Money', amount: number, currency: string }, subtotalPrice: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } }, shippingAddress?: { __typename?: 'Address', id: string, city: string, cityArea: string, companyName: string, countryArea: string, firstName: string, isDefaultBillingAddress?: boolean | null, isDefaultShippingAddress?: boolean | null, lastName: string, phone?: string | null, postalCode: string, streetAddress1: string, streetAddress2: string, country: { __typename?: 'CountryDisplay', code: string, country: string }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> } | null, shippingMethods: Array<{ __typename?: 'ShippingMethod', id: string, name: string, minimumDeliveryDays?: number | null, maximumDeliveryDays?: number | null, translation?: { __typename?: 'ShippingMethodTranslation', name?: string | null } | null, price: { __typename?: 'Money', amount: number, currency: string } }>, availableCollectionPoints: Array<{ __typename?: 'Warehouse', id: string, name: string, email: string, address: { __typename?: 'Address', id: string, city: string, cityArea: string, companyName: string, countryArea: string, firstName: string, isDefaultBillingAddress?: boolean | null, isDefaultShippingAddress?: boolean | null, lastName: string, phone?: string | null, postalCode: string, streetAddress1: string, streetAddress2: string, country: { __typename?: 'CountryDisplay', code: string, country: string }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> } }>, discount?: { __typename?: 'Money', amount: number, currency: string } | null } | null, errors: Array<{ __typename?: 'CheckoutError', field?: string | null, code: CheckoutErrorCode, addressType?: AddressTypeEnum | null, message?: string | null }> } | null };

export type ConfirmEmailChangeMutationVariables = Exact<{
  token: Scalars['String']['input'];
  channel?: InputMaybe<Scalars['String']['input']>;
}>;


export type ConfirmEmailChangeMutation = { __typename?: 'Mutation', confirmEmailChange?: { __typename?: 'ConfirmEmailChange', user?: { __typename?: 'User', id: string, email: string, firstName: string, lastName: string, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }>, addresses: Array<{ __typename?: 'Address', id: string, city: string, cityArea: string, companyName: string, countryArea: string, firstName: string, isDefaultBillingAddress?: boolean | null, isDefaultShippingAddress?: boolean | null, lastName: string, phone?: string | null, postalCode: string, streetAddress1: string, streetAddress2: string, country: { __typename?: 'CountryDisplay', code: string, country: string }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> }>, defaultBillingAddress?: { __typename?: 'Address', id: string, city: string, cityArea: string, companyName: string, countryArea: string, firstName: string, isDefaultBillingAddress?: boolean | null, isDefaultShippingAddress?: boolean | null, lastName: string, phone?: string | null, postalCode: string, streetAddress1: string, streetAddress2: string, country: { __typename?: 'CountryDisplay', code: string, country: string }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> } | null, defaultShippingAddress?: { __typename?: 'Address', id: string, city: string, cityArea: string, companyName: string, countryArea: string, firstName: string, isDefaultBillingAddress?: boolean | null, isDefaultShippingAddress?: boolean | null, lastName: string, phone?: string | null, postalCode: string, streetAddress1: string, streetAddress2: string, country: { __typename?: 'CountryDisplay', code: string, country: string }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> } | null, checkout?: { __typename?: 'Checkout', id: string, channel: { __typename?: 'Channel', slug: string } } | null } | null, errors: Array<{ __typename?: 'AccountError', field?: string | null, message?: string | null, code: AccountErrorCode }> } | null };

export type CustomerCreateMutationVariables = Exact<{
  input: UserCreateInput;
}>;


export type CustomerCreateMutation = { __typename?: 'Mutation', customerCreate?: { __typename?: 'CustomerCreate', user?: { __typename?: 'User', id: string, isActive: boolean, email: string } | null, errors: Array<{ __typename?: 'AccountError', field?: string | null, message?: string | null, code: AccountErrorCode }> } | null };

export type CustomerUpdateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: CustomerInput;
}>;


export type CustomerUpdateMutation = { __typename?: 'Mutation', customerUpdate?: { __typename?: 'CustomerUpdate', user?: { __typename?: 'User', id: string, isActive: boolean, email: string } | null, errors: Array<{ __typename?: 'AccountError', field?: string | null, message?: string | null, code: AccountErrorCode }> } | null };

export type OrderUpdateMutationVariables = Exact<{
  externalReference?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  input: OrderUpdateInput;
}>;


export type OrderUpdateMutation = { __typename?: 'Mutation', orderUpdate?: { __typename?: 'OrderUpdate', order?: { __typename?: 'Order', id: string, userEmail?: string | null, isShippingRequired: boolean, subtotal: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } }, shippingPrice: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } }, total: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } }, channel: { __typename?: 'Channel', slug: string }, totalBalance: { __typename?: 'Money', amount: number, currency: string }, totalCharged: { __typename?: 'Money', amount: number, currency: string }, totalAuthorized: { __typename?: 'Money', amount: number, currency: string }, shippingAddress?: { __typename?: 'Address', id: string, city: string, cityArea: string, companyName: string, countryArea: string, firstName: string, isDefaultBillingAddress?: boolean | null, isDefaultShippingAddress?: boolean | null, lastName: string, phone?: string | null, postalCode: string, streetAddress1: string, streetAddress2: string, country: { __typename?: 'CountryDisplay', code: string, country: string }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> } | null, billingAddress?: { __typename?: 'Address', id: string, city: string, cityArea: string, companyName: string, countryArea: string, firstName: string, isDefaultBillingAddress?: boolean | null, isDefaultShippingAddress?: boolean | null, lastName: string, phone?: string | null, postalCode: string, streetAddress1: string, streetAddress2: string, country: { __typename?: 'CountryDisplay', code: string, country: string }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> } | null } | null, errors: Array<{ __typename?: 'OrderError', code: OrderErrorCode, field?: string | null, message?: string | null }> } | null };

export type PasswordChangeMutationVariables = Exact<{
  oldPassword: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
}>;


export type PasswordChangeMutation = { __typename?: 'Mutation', passwordChange?: { __typename?: 'PasswordChange', user?: { __typename?: 'User', id: string, email: string, firstName: string, lastName: string, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }>, addresses: Array<{ __typename?: 'Address', id: string, city: string, cityArea: string, companyName: string, countryArea: string, firstName: string, isDefaultBillingAddress?: boolean | null, isDefaultShippingAddress?: boolean | null, lastName: string, phone?: string | null, postalCode: string, streetAddress1: string, streetAddress2: string, country: { __typename?: 'CountryDisplay', code: string, country: string }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> }>, defaultBillingAddress?: { __typename?: 'Address', id: string, city: string, cityArea: string, companyName: string, countryArea: string, firstName: string, isDefaultBillingAddress?: boolean | null, isDefaultShippingAddress?: boolean | null, lastName: string, phone?: string | null, postalCode: string, streetAddress1: string, streetAddress2: string, country: { __typename?: 'CountryDisplay', code: string, country: string }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> } | null, defaultShippingAddress?: { __typename?: 'Address', id: string, city: string, cityArea: string, companyName: string, countryArea: string, firstName: string, isDefaultBillingAddress?: boolean | null, isDefaultShippingAddress?: boolean | null, lastName: string, phone?: string | null, postalCode: string, streetAddress1: string, streetAddress2: string, country: { __typename?: 'CountryDisplay', code: string, country: string }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> } | null, checkout?: { __typename?: 'Checkout', id: string, channel: { __typename?: 'Channel', slug: string } } | null } | null, errors: Array<{ __typename?: 'AccountError', field?: string | null, message?: string | null, code: AccountErrorCode }> } | null };

export type PaymentGatewayInitializeMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  amount: Scalars['PositiveDecimal']['input'];
  paymentGateways?: InputMaybe<Array<PaymentGatewayToInitialize> | PaymentGatewayToInitialize>;
}>;


export type PaymentGatewayInitializeMutation = { __typename?: 'Mutation', paymentGatewayInitialize?: { __typename?: 'PaymentGatewayInitialize', gatewayConfigs?: Array<{ __typename?: 'PaymentGatewayConfig', id: string, data?: any | null, errors?: Array<{ __typename?: 'PaymentGatewayConfigError', field?: string | null, message?: string | null, code: PaymentGatewayConfigErrorCode }> | null }> | null, errors: Array<{ __typename?: 'PaymentGatewayInitializeError', field?: string | null, message?: string | null, code: PaymentGatewayInitializeErrorCode }> } | null };

export type RequestEmailChangeMutationVariables = Exact<{
  newEmail: Scalars['String']['input'];
  password: Scalars['String']['input'];
  redirectUrl: Scalars['String']['input'];
  channel?: InputMaybe<Scalars['String']['input']>;
}>;


export type RequestEmailChangeMutation = { __typename?: 'Mutation', requestEmailChange?: { __typename?: 'RequestEmailChange', user?: { __typename?: 'User', id: string, email: string, firstName: string, lastName: string, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }>, addresses: Array<{ __typename?: 'Address', id: string, city: string, cityArea: string, companyName: string, countryArea: string, firstName: string, isDefaultBillingAddress?: boolean | null, isDefaultShippingAddress?: boolean | null, lastName: string, phone?: string | null, postalCode: string, streetAddress1: string, streetAddress2: string, country: { __typename?: 'CountryDisplay', code: string, country: string }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> }>, defaultBillingAddress?: { __typename?: 'Address', id: string, city: string, cityArea: string, companyName: string, countryArea: string, firstName: string, isDefaultBillingAddress?: boolean | null, isDefaultShippingAddress?: boolean | null, lastName: string, phone?: string | null, postalCode: string, streetAddress1: string, streetAddress2: string, country: { __typename?: 'CountryDisplay', code: string, country: string }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> } | null, defaultShippingAddress?: { __typename?: 'Address', id: string, city: string, cityArea: string, companyName: string, countryArea: string, firstName: string, isDefaultBillingAddress?: boolean | null, isDefaultShippingAddress?: boolean | null, lastName: string, phone?: string | null, postalCode: string, streetAddress1: string, streetAddress2: string, country: { __typename?: 'CountryDisplay', code: string, country: string }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> } | null, checkout?: { __typename?: 'Checkout', id: string, channel: { __typename?: 'Channel', slug: string } } | null } | null, errors: Array<{ __typename?: 'AccountError', field?: string | null, message?: string | null, code: AccountErrorCode }> } | null };

export type RequestPasswordResetMutationVariables = Exact<{
  email: Scalars['String']['input'];
  redirectUrl: Scalars['String']['input'];
  channel: Scalars['String']['input'];
}>;


export type RequestPasswordResetMutation = { __typename?: 'Mutation', requestPasswordReset?: { __typename?: 'RequestPasswordReset', errors: Array<{ __typename?: 'AccountError', field?: string | null, message?: string | null, code: AccountErrorCode }> } | null };

export type SetPasswordMutationVariables = Exact<{
  password: Scalars['String']['input'];
  email: Scalars['String']['input'];
  token: Scalars['String']['input'];
}>;


export type SetPasswordMutation = { __typename?: 'Mutation', setPassword?: { __typename?: 'SetPassword', errors: Array<{ __typename?: 'AccountError', field?: string | null, message?: string | null, code: AccountErrorCode }> } | null };

export type SocialClubConsentUpdateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: Array<MetadataInput> | MetadataInput;
}>;


export type SocialClubConsentUpdateMutation = { __typename?: 'Mutation', updateMetadata?: { __typename?: 'UpdateMetadata', errors: Array<{ __typename?: 'MetadataError', code: MetadataErrorCode, field?: string | null, message?: string | null }>, item?: { __typename?: 'Address', metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> } | { __typename?: 'App', metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> } | { __typename?: 'Attribute', metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> } | { __typename?: 'Category', metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> } | { __typename?: 'Channel', metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> } | { __typename?: 'Checkout', metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> } | { __typename?: 'CheckoutLine', metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> } | { __typename?: 'Collection', metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> } | { __typename?: 'DigitalContent', metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> } | { __typename?: 'Fulfillment', metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> } | { __typename?: 'GiftCard', metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> } | { __typename?: 'Invoice', metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> } | { __typename?: 'Menu', metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> } | { __typename?: 'MenuItem', metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> } | { __typename?: 'Order', metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> } | { __typename?: 'OrderLine', metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> } | { __typename?: 'Page', metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> } | { __typename?: 'PageType', metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> } | { __typename?: 'Payment', metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> } | { __typename?: 'Product', metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> } | { __typename?: 'ProductMedia', metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> } | { __typename?: 'ProductType', metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> } | { __typename?: 'ProductVariant', metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> } | { __typename?: 'Promotion', metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> } | { __typename?: 'Sale', metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> } | { __typename?: 'ShippingMethod', metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> } | { __typename?: 'ShippingMethodType', metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> } | { __typename?: 'ShippingZone', metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> } | { __typename?: 'Shop', metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> } | { __typename?: 'TaxClass', metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> } | { __typename?: 'TaxConfiguration', metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> } | { __typename?: 'TransactionItem', metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> } | { __typename?: 'User', metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> } | { __typename?: 'Voucher', metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> } | { __typename?: 'Warehouse', metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> } | null } | null };

export type TransactionInitializeMutationVariables = Exact<{
  data: Scalars['JSON']['input'];
  amount: Scalars['PositiveDecimal']['input'];
  id: Scalars['ID']['input'];
  gatewayId: Scalars['String']['input'];
}>;


export type TransactionInitializeMutation = { __typename?: 'Mutation', transactionInitialize?: { __typename?: 'TransactionInitialize', data?: any | null, transaction?: { __typename?: 'TransactionItem', id: string, paymentData?: string | null, paymentMethod?: string | null, forGiftPaymentData?: string | null, oricoFinancingAppPaymentData?: string | null, genericPaymentData?: string | null, authorizedAmount: { __typename?: 'Money', amount: number, currency: string }, chargedAmount: { __typename?: 'Money', amount: number, currency: string }, chargePendingAmount: { __typename?: 'Money', amount: number, currency: string }, events: Array<{ __typename?: 'TransactionEvent', type?: TransactionEventTypeEnum | null, createdAt: string, pspReference: string, message: string, amount: { __typename?: 'Money', amount: number, currency: string } }> } | null, errors: Array<{ __typename?: 'TransactionInitializeError', field?: string | null, message?: string | null, code: TransactionInitializeErrorCode }> } | null };

export type TransactionProcessMutationVariables = Exact<{
  data: Scalars['JSON']['input'];
  id: Scalars['ID']['input'];
}>;


export type TransactionProcessMutation = { __typename?: 'Mutation', transactionProcess?: { __typename?: 'TransactionProcess', data?: any | null, transaction?: { __typename?: 'TransactionItem', id: string, paymentData?: string | null, paymentMethod?: string | null, forGiftPaymentData?: string | null, oricoFinancingAppPaymentData?: string | null, genericPaymentData?: string | null, authorizedAmount: { __typename?: 'Money', amount: number, currency: string }, chargedAmount: { __typename?: 'Money', amount: number, currency: string }, chargePendingAmount: { __typename?: 'Money', amount: number, currency: string }, events: Array<{ __typename?: 'TransactionEvent', type?: TransactionEventTypeEnum | null, createdAt: string, pspReference: string, message: string, amount: { __typename?: 'Money', amount: number, currency: string } }> } | null, errors: Array<{ __typename?: 'TransactionProcessError', field?: string | null, message?: string | null, code: TransactionProcessErrorCode }> } | null };

export type AddressQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type AddressQuery = { __typename?: 'Query', address?: { __typename?: 'Address', id: string, city: string, cityArea: string, companyName: string, countryArea: string, firstName: string, isDefaultBillingAddress?: boolean | null, isDefaultShippingAddress?: boolean | null, lastName: string, phone?: string | null, postalCode: string, streetAddress1: string, streetAddress2: string, country: { __typename?: 'CountryDisplay', code: string, country: string }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> } | null };

export type AddressValidationRulesQueryVariables = Exact<{
  countryCode: CountryCode;
}>;


export type AddressValidationRulesQuery = { __typename?: 'Query', addressValidationRules?: { __typename?: 'AddressValidationData', requiredFields: Array<string>, countryAreaType: string, postalCodeType: string, cityType: string, countryAreaChoices: Array<{ __typename?: 'ChoiceValue', raw?: string | null, verbose?: string | null }>, cityChoices: Array<{ __typename?: 'ChoiceValue', raw?: string | null, verbose?: string | null }> } | null };

export type CategoryPathsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type CategoryPathsQuery = { __typename?: 'Query', categories?: { __typename?: 'CategoryCountableConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null }, edges: Array<{ __typename?: 'CategoryCountableEdge', node: { __typename?: 'Category', slug: string, id: string } }> } | null };

export type CategorySearchQueryVariables = Exact<{
  first: Scalars['Int']['input'];
  filter?: InputMaybe<CategoryFilterInput>;
}>;


export type CategorySearchQuery = { __typename?: 'Query', categories?: { __typename?: 'CategoryCountableConnection', edges: Array<{ __typename?: 'CategoryCountableEdge', node: { __typename?: 'Category', id: string } }> } | null };

export type CheckoutQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  languageCode: LanguageCodeEnum;
  imagesFormat: ThumbnailFormatEnum;
  thumbnailSize: Scalars['Int']['input'];
}>;


export type CheckoutQuery = { __typename?: 'Query', checkout?: { __typename?: 'Checkout', isShippingRequired: boolean, discountName?: string | null, voucherCode?: string | null, id: string, email?: string | null, languageCode: LanguageCodeEnum, deliveryMode?: string | null, boutiqueExtRef?: string | null, gwpProduct?: string | null, orderBid?: string | null, campaignVoucherCode?: string | null, isGift?: string | null, giftFrom?: string | null, giftMessage?: string | null, shippingTitle?: string | null, billingTitle?: string | null, timeSlot?: string | null, preOrderData?: string | null, orderType?: string | null, orderStatus?: string | null, orderCollectedDate?: string | null, payPerLinkToken?: string | null, payPerLinkExpiration?: string | null, paymentMethod?: string | null, orderFlowScTermsRequired?: string | null, orderFlowScTermsAccepted?: string | null, orderFlowWasUserAuthenticated?: string | null, orderFlowWasRegisterMyWatchChecked?: string | null, orderFlowWasCreateMyAccountWithoutWatchChecked?: string | null, orderFlowWasAccountCreated?: string | null, orderFlowUserJoinClub?: string | null, orderFlowUserAffiliated?: string | null, orderFlowReceiveReceipt?: string | null, checkoutId?: string | null, billingAddress?: { __typename?: 'Address', id: string, city: string, cityArea: string, companyName: string, countryArea: string, firstName: string, isDefaultBillingAddress?: boolean | null, isDefaultShippingAddress?: boolean | null, lastName: string, phone?: string | null, postalCode: string, streetAddress1: string, streetAddress2: string, country: { __typename?: 'CountryDisplay', code: string, country: string }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> } | null, shippingAddress?: { __typename?: 'Address', id: string, city: string, cityArea: string, companyName: string, countryArea: string, firstName: string, isDefaultBillingAddress?: boolean | null, isDefaultShippingAddress?: boolean | null, lastName: string, phone?: string | null, postalCode: string, streetAddress1: string, streetAddress2: string, country: { __typename?: 'CountryDisplay', code: string, country: string }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> } | null, shippingMethods: Array<{ __typename?: 'ShippingMethod', id: string, name: string, minimumDeliveryDays?: number | null, maximumDeliveryDays?: number | null, translation?: { __typename?: 'ShippingMethodTranslation', name?: string | null } | null, price: { __typename?: 'Money', amount: number, currency: string } }>, availableCollectionPoints: Array<{ __typename?: 'Warehouse', id: string, name: string, email: string, address: { __typename?: 'Address', id: string, city: string, cityArea: string, companyName: string, countryArea: string, firstName: string, isDefaultBillingAddress?: boolean | null, isDefaultShippingAddress?: boolean | null, lastName: string, phone?: string | null, postalCode: string, streetAddress1: string, streetAddress2: string, country: { __typename?: 'CountryDisplay', code: string, country: string }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> } }>, deliveryMethod?: { __typename?: 'ShippingMethod', id: string, name: string, minimumDeliveryDays?: number | null, maximumDeliveryDays?: number | null, translation?: { __typename?: 'ShippingMethodTranslation', name?: string | null } | null, price: { __typename?: 'Money', amount: number, currency: string } } | { __typename?: 'Warehouse', id: string, name: string, email: string, address: { __typename?: 'Address', id: string, city: string, cityArea: string, companyName: string, countryArea: string, firstName: string, isDefaultBillingAddress?: boolean | null, isDefaultShippingAddress?: boolean | null, lastName: string, phone?: string | null, postalCode: string, streetAddress1: string, streetAddress2: string, country: { __typename?: 'CountryDisplay', code: string, country: string }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> } } | null, discount?: { __typename?: 'Money', amount: number, currency: string } | null, subtotalPrice: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } }, shippingPrice: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } }, totalPrice: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } }, totalBalance: { __typename?: 'Money', amount: number, currency: string }, channel: { __typename?: 'Channel', slug: string }, lines: Array<{ __typename?: 'CheckoutLine', id: string, quantity: number, relatedProductBuckleId?: string | null, relatedProductStrapId?: string | null, relatedProductWatchId?: string | null, relatedBraceletSize?: string | null, relatedEngravingId?: string | null, strapPackReference?: string | null, strapReference?: string | null, strapSize?: string | null, preOrderData?: string | null, unitPrice: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } }, totalPrice: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } }, undiscountedTotalPrice: { __typename?: 'Money', amount: number, currency: string }, undiscountedUnitPrice: { __typename?: 'Money', amount: number, currency: string }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }>, variant: { __typename?: 'ProductVariant', id: string, sku?: string | null, product: { __typename?: 'Product', id: string, name: string, watchName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, strapName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, buckleName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, toolName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, warrantyName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, eyewearModel?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, digitalItemName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, translation?: { __typename?: 'ProductTranslation', name?: string | null } | null, defaultVariant?: { __typename?: 'ProductVariant', sku?: string | null, pricing?: { __typename?: 'VariantPricingInfo', price?: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } } | null } | null } | null, color?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, caseMaterial?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, strapMaterial?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, size?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, compatibleStraps?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, buckle?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, strapColor?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, warrantyExtensionDuration?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, warrantyMovementDuration?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, wristSizeMinInch?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, wristSizeMaxInch?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, wristSizeMinMm?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, wristSizeMaxMm?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, marketingPartner?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, media?: Array<{ __typename?: 'ProductMedia', url: string, alt: string, type: ProductMediaType, strapPreviewCoordinates?: string | null, backEngravingCoordinates?: string | null, shotType?: string | null }> | null, personalizedEngraving?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', boolean?: boolean | null, slug?: string | null }> } | null, productType: { __typename?: 'ProductType', slug: string, name: string }, thumbnail?: { __typename?: 'Image', alt?: string | null, url: string } | null, collections?: Array<{ __typename?: 'Collection', name: string, slug: string, translation?: { __typename?: 'CollectionTranslation', name?: string | null } | null }> | null, model?: { __typename?: 'SelectedAttribute', values: Array<{ __typename?: 'AttributeValue', slug?: string | null }> } | null, collectionName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null } } }>, user?: { __typename?: 'User', email: string } | null } | null };

export type CheckoutBaseQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type CheckoutBaseQuery = { __typename?: 'Query', checkout?: { __typename?: 'Checkout', id: string, email?: string | null, orderFlowScTermsRequired?: string | null, orderFlowScTermsAccepted?: string | null, orderFlowWasUserAuthenticated?: string | null, orderFlowWasRegisterMyWatchChecked?: string | null, orderFlowWasCreateMyAccountWithoutWatchChecked?: string | null, orderFlowWasAccountCreated?: string | null, orderFlowUserJoinClub?: string | null, orderFlowUserAffiliated?: string | null, orderFlowReceiveReceipt?: string | null, checkoutId?: string | null, user?: { __typename?: 'User', id: string, email: string, firstName: string, lastName: string, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }>, addresses: Array<{ __typename?: 'Address', id: string, city: string, cityArea: string, companyName: string, countryArea: string, firstName: string, isDefaultBillingAddress?: boolean | null, isDefaultShippingAddress?: boolean | null, lastName: string, phone?: string | null, postalCode: string, streetAddress1: string, streetAddress2: string, country: { __typename?: 'CountryDisplay', code: string, country: string }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> }>, defaultBillingAddress?: { __typename?: 'Address', id: string, city: string, cityArea: string, companyName: string, countryArea: string, firstName: string, isDefaultBillingAddress?: boolean | null, isDefaultShippingAddress?: boolean | null, lastName: string, phone?: string | null, postalCode: string, streetAddress1: string, streetAddress2: string, country: { __typename?: 'CountryDisplay', code: string, country: string }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> } | null, defaultShippingAddress?: { __typename?: 'Address', id: string, city: string, cityArea: string, companyName: string, countryArea: string, firstName: string, isDefaultBillingAddress?: boolean | null, isDefaultShippingAddress?: boolean | null, lastName: string, phone?: string | null, postalCode: string, streetAddress1: string, streetAddress2: string, country: { __typename?: 'CountryDisplay', code: string, country: string }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> } | null, checkout?: { __typename?: 'Checkout', id: string, channel: { __typename?: 'Channel', slug: string } } | null } | null, billingAddress?: { __typename?: 'Address', id: string, city: string, cityArea: string, companyName: string, countryArea: string, firstName: string, isDefaultBillingAddress?: boolean | null, isDefaultShippingAddress?: boolean | null, lastName: string, phone?: string | null, postalCode: string, streetAddress1: string, streetAddress2: string, country: { __typename?: 'CountryDisplay', code: string, country: string }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> } | null } | null };

export type CheckoutRefreshQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  languageCode: LanguageCodeEnum;
  imagesFormat: ThumbnailFormatEnum;
  thumbnailSize: Scalars['Int']['input'];
}>;


export type CheckoutRefreshQuery = { __typename?: 'Query', checkout?: { __typename?: 'Checkout', id: string, email?: string | null, languageCode: LanguageCodeEnum, deliveryMode?: string | null, boutiqueExtRef?: string | null, gwpProduct?: string | null, orderBid?: string | null, campaignVoucherCode?: string | null, isGift?: string | null, giftFrom?: string | null, giftMessage?: string | null, shippingTitle?: string | null, billingTitle?: string | null, timeSlot?: string | null, preOrderData?: string | null, orderType?: string | null, orderStatus?: string | null, orderCollectedDate?: string | null, payPerLinkToken?: string | null, payPerLinkExpiration?: string | null, paymentMethod?: string | null, orderFlowScTermsRequired?: string | null, orderFlowScTermsAccepted?: string | null, orderFlowWasUserAuthenticated?: string | null, orderFlowWasRegisterMyWatchChecked?: string | null, orderFlowWasCreateMyAccountWithoutWatchChecked?: string | null, orderFlowWasAccountCreated?: string | null, orderFlowUserJoinClub?: string | null, orderFlowUserAffiliated?: string | null, orderFlowReceiveReceipt?: string | null, checkoutId?: string | null, totalPrice: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } }, totalBalance: { __typename?: 'Money', amount: number, currency: string }, subtotalPrice: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } }, channel: { __typename?: 'Channel', slug: string }, lines: Array<{ __typename?: 'CheckoutLine', id: string, quantity: number, relatedProductBuckleId?: string | null, relatedProductStrapId?: string | null, relatedProductWatchId?: string | null, relatedBraceletSize?: string | null, relatedEngravingId?: string | null, strapPackReference?: string | null, strapReference?: string | null, strapSize?: string | null, preOrderData?: string | null, unitPrice: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } }, totalPrice: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } }, undiscountedTotalPrice: { __typename?: 'Money', amount: number, currency: string }, undiscountedUnitPrice: { __typename?: 'Money', amount: number, currency: string }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }>, variant: { __typename?: 'ProductVariant', id: string, sku?: string | null, product: { __typename?: 'Product', id: string, name: string, watchName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, strapName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, buckleName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, toolName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, warrantyName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, eyewearModel?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, digitalItemName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, translation?: { __typename?: 'ProductTranslation', name?: string | null } | null, defaultVariant?: { __typename?: 'ProductVariant', sku?: string | null, pricing?: { __typename?: 'VariantPricingInfo', price?: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } } | null } | null } | null, color?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, caseMaterial?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, strapMaterial?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, size?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, compatibleStraps?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, buckle?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, strapColor?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, warrantyExtensionDuration?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, warrantyMovementDuration?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, wristSizeMinInch?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, wristSizeMaxInch?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, wristSizeMinMm?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, wristSizeMaxMm?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, marketingPartner?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, media?: Array<{ __typename?: 'ProductMedia', url: string, alt: string, type: ProductMediaType, strapPreviewCoordinates?: string | null, backEngravingCoordinates?: string | null, shotType?: string | null }> | null, personalizedEngraving?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', boolean?: boolean | null, slug?: string | null }> } | null, productType: { __typename?: 'ProductType', slug: string, name: string }, thumbnail?: { __typename?: 'Image', alt?: string | null, url: string } | null, collections?: Array<{ __typename?: 'Collection', name: string, slug: string, translation?: { __typename?: 'CollectionTranslation', name?: string | null } | null }> | null, model?: { __typename?: 'SelectedAttribute', values: Array<{ __typename?: 'AttributeValue', slug?: string | null }> } | null, collectionName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null } } }>, user?: { __typename?: 'User', email: string } | null } | null };

export type CheckoutTransactionsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type CheckoutTransactionsQuery = { __typename?: 'Query', checkout?: { __typename?: 'Checkout', orderSource?: string | null, deliveryMode?: string | null, boutiqueExtRef?: string | null, gwpProduct?: string | null, orderBid?: string | null, campaignVoucherCode?: string | null, isGift?: string | null, giftFrom?: string | null, giftMessage?: string | null, shippingTitle?: string | null, billingTitle?: string | null, timeSlot?: string | null, preOrderData?: string | null, orderType?: string | null, orderStatus?: string | null, orderCollectedDate?: string | null, payPerLinkToken?: string | null, payPerLinkExpiration?: string | null, paymentMethod?: string | null, orderFlowScTermsRequired?: string | null, orderFlowScTermsAccepted?: string | null, orderFlowWasUserAuthenticated?: string | null, orderFlowWasRegisterMyWatchChecked?: string | null, orderFlowWasCreateMyAccountWithoutWatchChecked?: string | null, orderFlowWasAccountCreated?: string | null, orderFlowUserJoinClub?: string | null, orderFlowUserAffiliated?: string | null, orderFlowReceiveReceipt?: string | null, checkoutId?: string | null, transactions?: Array<{ __typename?: 'TransactionItem', id: string, tokenData?: string | null, paymentData?: string | null, paymentMethod?: string | null, forGiftPaymentData?: string | null, oricoFinancingAppPaymentData?: string | null, genericPaymentData?: string | null, authorizedAmount: { __typename?: 'Money', amount: number, currency: string }, chargedAmount: { __typename?: 'Money', amount: number, currency: string }, chargePendingAmount: { __typename?: 'Money', amount: number, currency: string }, events: Array<{ __typename?: 'TransactionEvent', type?: TransactionEventTypeEnum | null, createdAt: string, pspReference: string, message: string, amount: { __typename?: 'Money', amount: number, currency: string } }> }> | null } | null };

export type CollectionCardsQueryVariables = Exact<{
  filter: CollectionFilterInput;
  languageCode: LanguageCodeEnum;
  channel: Scalars['String']['input'];
}>;


export type CollectionCardsQuery = { __typename?: 'Query', collections?: { __typename?: 'CollectionCountableConnection', edges: Array<{ __typename?: 'CollectionCountableEdge', node: { __typename?: 'Collection', id: string, slug: string, name: string, translation?: { __typename?: 'CollectionTranslation', name?: string | null } | null } }> } | null };

export type CollectionPathsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
  channel: Scalars['String']['input'];
}>;


export type CollectionPathsQuery = { __typename?: 'Query', collections?: { __typename?: 'CollectionCountableConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null }, edges: Array<{ __typename?: 'CollectionCountableEdge', node: { __typename?: 'Collection', slug: string } }> } | null };

export type FooterBarMenuQueryVariables = Exact<{
  locale: LanguageCodeEnum;
  channel: Scalars['String']['input'];
}>;


export type FooterBarMenuQuery = { __typename?: 'Query', menu?: { __typename?: 'Menu', id: string, items?: Array<{ __typename?: 'MenuItem', id: string, name: string, url?: string | null, children?: Array<{ __typename?: 'MenuItem', id: string, name: string, url?: string | null, translation?: { __typename?: 'MenuItemTranslation', id: string, name: string } | null, parent?: { __typename?: 'MenuItem', id: string } | null, category?: { __typename?: 'Category', id: string, slug: string } | null, collection?: { __typename?: 'Collection', id: string, slug: string } | null, page?: { __typename?: 'Page', id: string, slug: string } | null }> | null, translation?: { __typename?: 'MenuItemTranslation', id: string, name: string } | null, parent?: { __typename?: 'MenuItem', id: string } | null, category?: { __typename?: 'Category', id: string, slug: string } | null, collection?: { __typename?: 'Collection', id: string, slug: string } | null, page?: { __typename?: 'Page', id: string, slug: string } | null }> | null } | null };

export type FooterMenuQueryVariables = Exact<{
  locale: LanguageCodeEnum;
  channel: Scalars['String']['input'];
}>;


export type FooterMenuQuery = { __typename?: 'Query', menu?: { __typename?: 'Menu', id: string, items?: Array<{ __typename?: 'MenuItem', id: string, name: string, url?: string | null, children?: Array<{ __typename?: 'MenuItem', id: string, name: string, url?: string | null, translation?: { __typename?: 'MenuItemTranslation', id: string, name: string } | null, parent?: { __typename?: 'MenuItem', id: string } | null, category?: { __typename?: 'Category', id: string, slug: string } | null, collection?: { __typename?: 'Collection', id: string, slug: string } | null, page?: { __typename?: 'Page', id: string, slug: string } | null }> | null, translation?: { __typename?: 'MenuItemTranslation', id: string, name: string } | null, parent?: { __typename?: 'MenuItem', id: string } | null, category?: { __typename?: 'Category', id: string, slug: string } | null, collection?: { __typename?: 'Collection', id: string, slug: string } | null, page?: { __typename?: 'Page', id: string, slug: string } | null }> | null } | null };

export type GetCollectionsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
  channel: Scalars['String']['input'];
}>;


export type GetCollectionsQuery = { __typename?: 'Query', collections?: { __typename?: 'CollectionCountableConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null }, edges: Array<{ __typename?: 'CollectionCountableEdge', node: { __typename?: 'Collection', id: string, name: string, slug: string } }> } | null };

export type GwpDetailsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  channel: Scalars['String']['input'];
  languageCode: LanguageCodeEnum;
}>;


export type GwpDetailsQuery = { __typename?: 'Query', product?: { __typename?: 'Product', id: string, name: string, attribute?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', id: string, slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', id: string, name?: string | null, translation?: { __typename?: 'AttributeValueTranslation', plainText?: string | null, name: string } | null }> } | null } | null };

export type MainMenuQueryVariables = Exact<{
  locale: LanguageCodeEnum;
  channel: Scalars['String']['input'];
}>;


export type MainMenuQuery = { __typename?: 'Query', menu?: { __typename?: 'Menu', id: string, items?: Array<{ __typename?: 'MenuItem', id: string, name: string, url?: string | null, translation?: { __typename?: 'MenuItemTranslation', id: string, name: string } | null, page?: { __typename?: 'Page', id: string, slug: string } | null, children?: Array<{ __typename?: 'MenuItem', id: string, name: string, url?: string | null, children?: Array<{ __typename?: 'MenuItem', id: string, name: string, url?: string | null, translation?: { __typename?: 'MenuItemTranslation', id: string, name: string } | null, parent?: { __typename?: 'MenuItem', id: string } | null, category?: { __typename?: 'Category', id: string, slug: string } | null, collection?: { __typename?: 'Collection', id: string, slug: string } | null, page?: { __typename?: 'Page', id: string, slug: string } | null }> | null, translation?: { __typename?: 'MenuItemTranslation', id: string, name: string } | null, parent?: { __typename?: 'MenuItem', id: string } | null, category?: { __typename?: 'Category', id: string, slug: string } | null, collection?: { __typename?: 'Collection', id: string, slug: string } | null, page?: { __typename?: 'Page', id: string, slug: string } | null }> | null }> | null } | null };

export type MyOrderDetailsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  thumbnailSize: Scalars['Int']['input'];
  languageCode: LanguageCodeEnum;
}>;


export type MyOrderDetailsQuery = { __typename?: 'Query', order?: { __typename?: 'Order', id: string, number: string, created: string, userEmail?: string | null, collectionPointName?: string | null, voucherCode?: string | null, timeSlot?: string | null, shippingTitle?: string | null, billingTitle?: string | null, isGift?: string | null, giftFrom?: string | null, giftMessage?: string | null, businessId?: string | null, preOrderData?: string | null, orderType?: string | null, orderStatus?: string | null, orderCollectedDate?: string | null, payPerLinkToken?: string | null, payPerLinkExpiration?: string | null, subtotal: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } }, shippingAddress?: { __typename?: 'Address', id: string, city: string, cityArea: string, companyName: string, countryArea: string, firstName: string, isDefaultBillingAddress?: boolean | null, isDefaultShippingAddress?: boolean | null, lastName: string, phone?: string | null, postalCode: string, streetAddress1: string, streetAddress2: string, country: { __typename?: 'CountryDisplay', code: string, country: string }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> } | null, billingAddress?: { __typename?: 'Address', id: string, city: string, cityArea: string, companyName: string, countryArea: string, firstName: string, isDefaultBillingAddress?: boolean | null, isDefaultShippingAddress?: boolean | null, lastName: string, phone?: string | null, postalCode: string, streetAddress1: string, streetAddress2: string, country: { __typename?: 'CountryDisplay', code: string, country: string }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> } | null, shippingPrice: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } }, payments: Array<{ __typename?: 'Payment', paymentMethodType: string }>, channel: { __typename?: 'Channel', slug: string }, discounts: Array<{ __typename?: 'OrderDiscount', id: string, type: OrderDiscountType, name?: string | null, value: any, valueType: DiscountValueTypeEnum, amount: { __typename?: 'Money', amount: number, currency: string } }>, user?: { __typename?: 'User', id: string } | null, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }>, fulfillments: Array<{ __typename?: 'Fulfillment', id: string, created: string, status: FulfillmentStatus, trackingNumber: string, returnBid?: string | null, returnCreatedAt?: string | null, returnCreatedBy?: string | null, returnStatus?: string | null, trackingUrl?: string | null, trackingCarrier?: string | null, lines?: Array<{ __typename?: 'FulfillmentLine', id: string, quantity: number, orderLine?: { __typename?: 'OrderLine', id: string, productName: string, unitDiscountValue: any, relatedWatchSku?: string | null, relatedWatchSn?: string | null, warrantyDuration?: string | null, relatedProductWatchId?: string | null, totalPrice: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } }, variant?: { __typename?: 'ProductVariant', sku?: string | null, product: { __typename?: 'Product', id: string, thumbnail?: { __typename?: 'Image', alt?: string | null, url: string } | null, media?: Array<{ __typename?: 'ProductMedia', url: string, alt: string, type: ProductMediaType, strapPreviewCoordinates?: string | null, backEngravingCoordinates?: string | null, shotType?: string | null }> | null, productType: { __typename?: 'ProductType', name: string, slug: string }, watchName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, strapName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, buckleName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, toolName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, warrantyName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, eyewearModel?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, digitalItemName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null } } | null, unitPrice: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } }, undiscountedUnitPrice: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } }, unitDiscount: { __typename?: 'Money', amount: number, currency: string }, thumbnail?: { __typename?: 'Image', alt?: string | null, url: string } | null, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> } | null }> | null }>, total: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } }, totalBalance: { __typename?: 'Money', amount: number, currency: string }, totalCharged: { __typename?: 'Money', amount: number, currency: string }, totalAuthorized: { __typename?: 'Money', amount: number, currency: string }, lines: Array<{ __typename?: 'OrderLine', id: string, productName: string, unitDiscountValue: any, relatedWatchSku?: string | null, relatedWatchSn?: string | null, warrantyDuration?: string | null, relatedProductWatchId?: string | null, totalPrice: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } }, variant?: { __typename?: 'ProductVariant', sku?: string | null, product: { __typename?: 'Product', id: string, thumbnail?: { __typename?: 'Image', alt?: string | null, url: string } | null, media?: Array<{ __typename?: 'ProductMedia', url: string, alt: string, type: ProductMediaType, strapPreviewCoordinates?: string | null, backEngravingCoordinates?: string | null, shotType?: string | null }> | null, productType: { __typename?: 'ProductType', name: string, slug: string }, watchName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, strapName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, buckleName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, toolName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, warrantyName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, eyewearModel?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, digitalItemName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null } } | null, unitPrice: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } }, undiscountedUnitPrice: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } }, unitDiscount: { __typename?: 'Money', amount: number, currency: string }, thumbnail?: { __typename?: 'Image', alt?: string | null, url: string } | null, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> }>, voucher?: { __typename?: 'Voucher', id: string, name?: string | null, discountValue?: number | null, discountValueType: DiscountValueTypeEnum } | null } | null };

export type MyOrdersQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  thumbnailSize: Scalars['Int']['input'];
  languageCode: LanguageCodeEnum;
}>;


export type MyOrdersQuery = { __typename?: 'Query', me?: { __typename?: 'User', orders?: { __typename?: 'OrderCountableConnection', edges: Array<{ __typename?: 'OrderCountableEdge', node: { __typename?: 'Order', id: string, number: string, created: string, userEmail?: string | null, collectionPointName?: string | null, voucherCode?: string | null, businessId?: string | null, preOrderData?: string | null, orderType?: string | null, orderStatus?: string | null, orderCollectedDate?: string | null, payPerLinkToken?: string | null, payPerLinkExpiration?: string | null, user?: { __typename?: 'User', id: string } | null, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }>, fulfillments: Array<{ __typename?: 'Fulfillment', id: string, created: string, status: FulfillmentStatus, trackingNumber: string, returnBid?: string | null, returnCreatedAt?: string | null, returnCreatedBy?: string | null, returnStatus?: string | null, trackingUrl?: string | null, trackingCarrier?: string | null, lines?: Array<{ __typename?: 'FulfillmentLine', id: string, quantity: number, orderLine?: { __typename?: 'OrderLine', id: string, productName: string, unitDiscountValue: any, relatedWatchSku?: string | null, relatedWatchSn?: string | null, warrantyDuration?: string | null, relatedProductWatchId?: string | null, totalPrice: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } }, variant?: { __typename?: 'ProductVariant', sku?: string | null, product: { __typename?: 'Product', id: string, thumbnail?: { __typename?: 'Image', alt?: string | null, url: string } | null, media?: Array<{ __typename?: 'ProductMedia', url: string, alt: string, type: ProductMediaType, strapPreviewCoordinates?: string | null, backEngravingCoordinates?: string | null, shotType?: string | null }> | null, productType: { __typename?: 'ProductType', name: string, slug: string }, watchName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, strapName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, buckleName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, toolName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, warrantyName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, eyewearModel?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, digitalItemName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null } } | null, unitPrice: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } }, undiscountedUnitPrice: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } }, unitDiscount: { __typename?: 'Money', amount: number, currency: string }, thumbnail?: { __typename?: 'Image', alt?: string | null, url: string } | null, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> } | null }> | null }>, subtotal: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } }, total: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } }, totalBalance: { __typename?: 'Money', amount: number, currency: string }, totalCharged: { __typename?: 'Money', amount: number, currency: string }, totalAuthorized: { __typename?: 'Money', amount: number, currency: string }, lines: Array<{ __typename?: 'OrderLine', id: string, productName: string, unitDiscountValue: any, relatedWatchSku?: string | null, relatedWatchSn?: string | null, warrantyDuration?: string | null, relatedProductWatchId?: string | null, totalPrice: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } }, variant?: { __typename?: 'ProductVariant', sku?: string | null, product: { __typename?: 'Product', id: string, thumbnail?: { __typename?: 'Image', alt?: string | null, url: string } | null, media?: Array<{ __typename?: 'ProductMedia', url: string, alt: string, type: ProductMediaType, strapPreviewCoordinates?: string | null, backEngravingCoordinates?: string | null, shotType?: string | null }> | null, productType: { __typename?: 'ProductType', name: string, slug: string }, watchName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, strapName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, buckleName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, toolName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, warrantyName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, eyewearModel?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, digitalItemName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null } } | null, unitPrice: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } }, undiscountedUnitPrice: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } }, unitDiscount: { __typename?: 'Money', amount: number, currency: string }, thumbnail?: { __typename?: 'Image', alt?: string | null, url: string } | null, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> }>, discounts: Array<{ __typename?: 'OrderDiscount', id: string, type: OrderDiscountType, name?: string | null, value: any, valueType: DiscountValueTypeEnum, amount: { __typename?: 'Money', amount: number, currency: string } }>, voucher?: { __typename?: 'Voucher', id: string, name?: string | null, discountValue?: number | null, discountValueType: DiscountValueTypeEnum } | null } }> } | null } | null };

export type OrderQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
  languageCode: LanguageCodeEnum;
  thumbnailSize: Scalars['Int']['input'];
  imagesFormat: ThumbnailFormatEnum;
}>;


export type OrderQuery = { __typename?: 'Query', order?: { __typename?: 'Order', id: string, userEmail?: string | null, isShippingRequired: boolean, voucherCode?: string | null, isOfflinePayment?: string | null, deliveryMode?: string | null, shippingTitle?: string | null, billingTitle?: string | null, preOrderData?: string | null, orderType?: string | null, orderStatus?: string | null, orderCollectedDate?: string | null, payPerLinkToken?: string | null, payPerLinkExpiration?: string | null, isGift?: string | null, giftFrom?: string | null, giftMessage?: string | null, timeSlot?: string | null, paymentMethod?: string | null, orderFlowScTermsRequired?: string | null, orderFlowScTermsAccepted?: string | null, orderFlowWasUserAuthenticated?: string | null, orderFlowWasRegisterMyWatchChecked?: string | null, orderFlowWasCreateMyAccountWithoutWatchChecked?: string | null, orderFlowWasAccountCreated?: string | null, orderFlowUserJoinClub?: string | null, orderFlowUserAffiliated?: string | null, orderFlowReceiveReceipt?: string | null, checkoutId?: string | null, lines: Array<{ __typename?: 'OrderLine', id: string, productName: string, translatedProductName: string, quantity: number, relatedProductBuckleId?: string | null, relatedProductStrapId?: string | null, relatedProductWatchId?: string | null, relatedBraceletSize?: string | null, relatedEngravingId?: string | null, strapPackReference?: string | null, strapReference?: string | null, strapSize?: string | null, warrantyDuration?: string | null, unitPrice: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } }, totalPrice: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } }, variant?: { __typename?: 'ProductVariant', id: string, sku?: string | null, product: { __typename?: 'Product', id: string, name: string, watchName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, strapName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, buckleName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, toolName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, warrantyName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, eyewearModel?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, digitalItemName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, translation?: { __typename?: 'ProductTranslation', name?: string | null } | null, defaultVariant?: { __typename?: 'ProductVariant', sku?: string | null, pricing?: { __typename?: 'VariantPricingInfo', price?: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } } | null } | null } | null, color?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, caseMaterial?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, strapMaterial?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, size?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, compatibleStraps?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, buckle?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, strapColor?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, warrantyExtensionDuration?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, warrantyMovementDuration?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, wristSizeMinInch?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, wristSizeMaxInch?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, wristSizeMinMm?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, wristSizeMaxMm?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, marketingPartner?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, media?: Array<{ __typename?: 'ProductMedia', url: string, alt: string, type: ProductMediaType, strapPreviewCoordinates?: string | null, backEngravingCoordinates?: string | null, shotType?: string | null }> | null, personalizedEngraving?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', boolean?: boolean | null, slug?: string | null }> } | null, productType: { __typename?: 'ProductType', slug: string, name: string }, thumbnail?: { __typename?: 'Image', alt?: string | null, url: string } | null, collections?: Array<{ __typename?: 'Collection', name: string, slug: string, translation?: { __typename?: 'CollectionTranslation', name?: string | null } | null }> | null, model?: { __typename?: 'SelectedAttribute', values: Array<{ __typename?: 'AttributeValue', slug?: string | null }> } | null, collectionName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null } } | null, undiscountedUnitPrice: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } }, unitDiscount: { __typename?: 'Money', amount: number, currency: string }, thumbnail?: { __typename?: 'Image', alt?: string | null, url: string } | null, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> }>, subtotal: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } }, shippingPrice: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } }, total: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } }, channel: { __typename?: 'Channel', slug: string }, totalBalance: { __typename?: 'Money', amount: number, currency: string }, totalCharged: { __typename?: 'Money', amount: number, currency: string }, totalAuthorized: { __typename?: 'Money', amount: number, currency: string }, shippingAddress?: { __typename?: 'Address', id: string, city: string, cityArea: string, companyName: string, countryArea: string, firstName: string, isDefaultBillingAddress?: boolean | null, isDefaultShippingAddress?: boolean | null, lastName: string, phone?: string | null, postalCode: string, streetAddress1: string, streetAddress2: string, country: { __typename?: 'CountryDisplay', code: string, country: string }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> } | null, billingAddress?: { __typename?: 'Address', id: string, city: string, cityArea: string, companyName: string, countryArea: string, firstName: string, isDefaultBillingAddress?: boolean | null, isDefaultShippingAddress?: boolean | null, lastName: string, phone?: string | null, postalCode: string, streetAddress1: string, streetAddress2: string, country: { __typename?: 'CountryDisplay', code: string, country: string }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> } | null, discounts: Array<{ __typename?: 'OrderDiscount', id: string, type: OrderDiscountType, name?: string | null, value: any, valueType: DiscountValueTypeEnum, amount: { __typename?: 'Money', amount: number, currency: string } }>, voucher?: { __typename?: 'Voucher', id: string, name?: string | null, discountValue?: number | null, discountValueType: DiscountValueTypeEnum } | null } | null };

export type OrderByTransactionQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
}>;


export type OrderByTransactionQuery = { __typename?: 'Query', transaction?: { __typename?: 'TransactionItem', id: string, order?: { __typename?: 'Order', id: string, businessId?: string | null } | null } | null };

export type OrderTransactionsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type OrderTransactionsQuery = { __typename?: 'Query', order?: { __typename?: 'Order', orderSource?: string | null, paymentMethod?: string | null, transactions: Array<{ __typename?: 'TransactionItem', id: string, tokenData?: string | null, paymentData?: string | null, paymentMethod?: string | null, forGiftPaymentData?: string | null, oricoFinancingAppPaymentData?: string | null, genericPaymentData?: string | null, authorizedAmount: { __typename?: 'Money', amount: number, currency: string }, chargedAmount: { __typename?: 'Money', amount: number, currency: string }, chargePendingAmount: { __typename?: 'Money', amount: number, currency: string }, events: Array<{ __typename?: 'TransactionEvent', type?: TransactionEventTypeEnum | null, createdAt: string, pspReference: string, message: string, amount: { __typename?: 'Money', amount: number, currency: string } }> }> } | null };

export type OrdersQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<OrderFilterInput>;
  sort?: InputMaybe<OrderSortingInput>;
}>;


export type OrdersQuery = { __typename?: 'Query', orders?: { __typename?: 'OrderCountableConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null }, edges: Array<{ __typename?: 'OrderCountableEdge', node: { __typename?: 'Order', id: string, isOfflinePayment?: string | null, totalCharged: { __typename?: 'Money', amount: number, currency: string }, totalAuthorized: { __typename?: 'Money', amount: number, currency: string } } }> } | null };

export type PagePathsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type PagePathsQuery = { __typename?: 'Query', pages?: { __typename?: 'PageCountableConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null }, edges: Array<{ __typename?: 'PageCountableEdge', node: { __typename?: 'Page', slug: string } }> } | null };

export type PayPerLinkOrderDataQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type PayPerLinkOrderDataQuery = { __typename?: 'Query', order?: { __typename?: 'Order', id: string, payPerLinkToken?: string | null, payPerLinkExpiration?: string | null } | null };

export type ProductCardsQueryVariables = Exact<{
  first: Scalars['Int']['input'];
  channel?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ProductFilterInput>;
  languageCode: LanguageCodeEnum;
  thumbnailSize: Scalars['Int']['input'];
  imagesFormat: ThumbnailFormatEnum;
}>;


export type ProductCardsQuery = { __typename?: 'Query', products?: { __typename?: 'ProductCountableConnection', edges: Array<{ __typename?: 'ProductCountableEdge', node: { __typename?: 'Product', id: string, name: string, slug: string, translation?: { __typename?: 'ProductTranslation', name?: string | null } | null, thumbnail?: { __typename?: 'Image', alt?: string | null, url: string } | null, media?: Array<{ __typename?: 'ProductMedia', url: string, alt: string, type: ProductMediaType, strapPreviewCoordinates?: string | null, backEngravingCoordinates?: string | null, shotType?: string | null }> | null, defaultVariant?: { __typename?: 'ProductVariant', sku?: string | null, id: string, pricing?: { __typename?: 'VariantPricingInfo', price?: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } } | null } | null } | null, integratedBuckle?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', boolean?: boolean | null, slug?: string | null }> } | null, diameter?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string } | null }> } | null, marketingStatus?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, marketingPartner?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, marketingCampaign?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, launchDate?: { __typename?: 'SelectedAttribute', values: Array<{ __typename?: 'AttributeValue', name?: string | null }> } | null, collections?: Array<{ __typename?: 'Collection', name: string, slug: string, translation?: { __typename?: 'CollectionTranslation', name?: string | null } | null }> | null, model?: { __typename?: 'SelectedAttribute', values: Array<{ __typename?: 'AttributeValue', slug?: string | null }> } | null, strapMaterial?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, strapColor?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, watchName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, strapName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, collectionName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, warrantyName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, eyewearModel?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, toolName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, digitalItemName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, productType: { __typename?: 'ProductType', slug: string, name: string } } }> } | null };

export type ProductCardsAndPricesQueryVariables = Exact<{
  first: Scalars['Int']['input'];
  channel?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ProductFilterInput>;
  languageCode: LanguageCodeEnum;
  thumbnailSize: Scalars['Int']['input'];
  imagesFormat: ThumbnailFormatEnum;
}>;


export type ProductCardsAndPricesQuery = { __typename?: 'Query', products?: { __typename?: 'ProductCountableConnection', edges: Array<{ __typename?: 'ProductCountableEdge', node: { __typename?: 'Product', id: string, name: string, slug: string, translation?: { __typename?: 'ProductTranslation', name?: string | null } | null, thumbnail?: { __typename?: 'Image', alt?: string | null, url: string } | null, media?: Array<{ __typename?: 'ProductMedia', url: string, alt: string, type: ProductMediaType, strapPreviewCoordinates?: string | null, backEngravingCoordinates?: string | null, shotType?: string | null }> | null, defaultVariant?: { __typename?: 'ProductVariant', sku?: string | null, id: string, pricing?: { __typename?: 'VariantPricingInfo', price?: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } } | null } | null } | null, integratedBuckle?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', boolean?: boolean | null, slug?: string | null }> } | null, diameter?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string } | null }> } | null, marketingStatus?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, marketingPartner?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, marketingCampaign?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, launchDate?: { __typename?: 'SelectedAttribute', values: Array<{ __typename?: 'AttributeValue', name?: string | null }> } | null, collections?: Array<{ __typename?: 'Collection', name: string, slug: string, translation?: { __typename?: 'CollectionTranslation', name?: string | null } | null }> | null, model?: { __typename?: 'SelectedAttribute', values: Array<{ __typename?: 'AttributeValue', slug?: string | null }> } | null, strapMaterial?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, strapColor?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, watchName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, strapName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, collectionName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, warrantyName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, eyewearModel?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, toolName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, digitalItemName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, productType: { __typename?: 'ProductType', slug: string, name: string } } }> } | null, prices?: { __typename?: 'ProductCountableConnection', edges: Array<{ __typename?: 'ProductCountableEdge', node: { __typename?: 'Product', id: string, slug: string, defaultVariant?: { __typename?: 'ProductVariant', sku?: string | null, id: string, pricing?: { __typename?: 'VariantPricingInfo', price?: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } } | null } | null } | null } }> } | null };

export type ProductSearchQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<ProductFilterInput>;
  channel?: InputMaybe<Scalars['String']['input']>;
  languageCode: LanguageCodeEnum;
}>;


export type ProductSearchQuery = { __typename?: 'Query', products?: { __typename?: 'ProductCountableConnection', edges: Array<{ __typename?: 'ProductCountableEdge', node: { __typename?: 'Product', id: string, name: string, slug: string, defaultVariant?: { __typename?: 'ProductVariant', id: string, sku?: string | null } | null, translation?: { __typename?: 'ProductTranslation', name?: string | null } | null } }> } | null };

export type ProductTypesSearchQueryVariables = Exact<{
  first: Scalars['Int']['input'];
  filter: ProductTypeFilterInput;
}>;


export type ProductTypesSearchQuery = { __typename?: 'Query', productTypes?: { __typename?: 'ProductTypeCountableConnection', edges: Array<{ __typename?: 'ProductTypeCountableEdge', node: { __typename?: 'ProductType', id: string } }> } | null };

export type ProductVariantDetailImageQueryVariables = Exact<{
  sku: Scalars['String']['input'];
  thumbnailSize: Scalars['Int']['input'];
  channel?: InputMaybe<Scalars['String']['input']>;
  imagesFormat: ThumbnailFormatEnum;
}>;


export type ProductVariantDetailImageQuery = { __typename?: 'Query', productVariant?: { __typename?: 'ProductVariant', product: { __typename?: 'Product', thumbnail?: { __typename?: 'Image', alt?: string | null, url: string } | null } } | null };

export type ProductVariantEyewearBasicDetailsQueryVariables = Exact<{
  sku: Scalars['String']['input'];
  channel?: InputMaybe<Scalars['String']['input']>;
  languageCode: LanguageCodeEnum;
  thumbnailSize: Scalars['Int']['input'];
  largeMediaSize: Scalars['Int']['input'];
  imagesFormat: ThumbnailFormatEnum;
}>;


export type ProductVariantEyewearBasicDetailsQuery = { __typename?: 'Query', productVariant?: { __typename?: 'ProductVariant', id: string, sku?: string | null, quantityAvailable?: number | null, pricing?: { __typename?: 'VariantPricingInfo', price?: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } } | null } | null, product: { __typename?: 'Product', id: string, name: string, slug: string, description?: string | null, translation?: { __typename?: 'ProductTranslation', id: string, description?: string | null, name?: string | null } | null, thumbnail?: { __typename?: 'Image', alt?: string | null, url: string } | null, media?: Array<{ __typename?: 'ProductMedia', url: string, alt: string, type: ProductMediaType, strapPreviewCoordinates?: string | null, backEngravingCoordinates?: string | null, shotType?: string | null }> | null, mediaLarge?: Array<{ __typename?: 'ProductMedia', url: string, id: string }> | null, collections?: Array<{ __typename?: 'Collection', name: string, slug: string, translation?: { __typename?: 'CollectionTranslation', name?: string | null } | null }> | null, model?: { __typename?: 'SelectedAttribute', values: Array<{ __typename?: 'AttributeValue', slug?: string | null }> } | null, strapMaterial?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, strapColor?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, defaultVariant?: { __typename?: 'ProductVariant', sku?: string | null } | null, watchName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, strapName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, collectionName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, warrantyName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, eyewearModel?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, toolName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, digitalItemName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, marketingDescription?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, frameShape?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, frameColor?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, frameMaterial?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, coreWire?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, templeTipDetail?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, frontalPins?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, lensSurface?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, lensColor?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, lensCoating?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, uvProtection?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, frontalWidth?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string } | null }> } | null, templeLength?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string } | null }> } | null, lensWidth?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string } | null }> } | null, bridgeWidth?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string } | null }> } | null, bundleVariations?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, manualUrl?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, eyewearModelStory?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, marketingStatus?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, launchDate?: { __typename?: 'SelectedAttribute', values: Array<{ __typename?: 'AttributeValue', name?: string | null }> } | null, productType: { __typename?: 'ProductType', slug: string, name: string } } } | null };

export type ProductVariantPriceQueryVariables = Exact<{
  sku: Scalars['String']['input'];
  channel: Scalars['String']['input'];
}>;


export type ProductVariantPriceQuery = { __typename?: 'Query', productVariant?: { __typename?: 'ProductVariant', pricing?: { __typename?: 'VariantPricingInfo', price?: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } } | null } | null } | null };

export type ProductVariantStrapBasicDetailsQueryVariables = Exact<{
  sku: Scalars['String']['input'];
  channel?: InputMaybe<Scalars['String']['input']>;
  languageCode: LanguageCodeEnum;
  thumbnailSize: Scalars['Int']['input'];
  largeMediaSize: Scalars['Int']['input'];
  imagesFormat: ThumbnailFormatEnum;
}>;


export type ProductVariantStrapBasicDetailsQuery = { __typename?: 'Query', productVariant?: { __typename?: 'ProductVariant', id: string, sku?: string | null, product: { __typename?: 'Product', id: string, name: string, slug: string, description?: string | null, translation?: { __typename?: 'ProductTranslation', description?: string | null, name?: string | null } | null, thumbnail?: { __typename?: 'Image', alt?: string | null, url: string } | null, media?: Array<{ __typename?: 'ProductMedia', url: string, alt: string, type: ProductMediaType, strapPreviewCoordinates?: string | null, backEngravingCoordinates?: string | null, shotType?: string | null }> | null, mediaLarge?: Array<{ __typename?: 'ProductMedia', url: string, id: string }> | null, collections?: Array<{ __typename?: 'Collection', name: string, slug: string, translation?: { __typename?: 'CollectionTranslation', name?: string | null } | null }> | null, model?: { __typename?: 'SelectedAttribute', values: Array<{ __typename?: 'AttributeValue', slug?: string | null }> } | null, strapMaterial?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, strapColor?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, defaultVariant?: { __typename?: 'ProductVariant', sku?: string | null } | null, watchName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, strapName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, collectionName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, warrantyName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, eyewearModel?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, toolName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, digitalItemName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, otherSizesSkus?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, integratedBuckle?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', boolean?: boolean | null, slug?: string | null }> } | null, lugSize?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, color?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, lug?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, lugType?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, buckleType?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, compatibleBuckles?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, marketingDescription?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, productType: { __typename?: 'ProductType', slug: string, name: string } } } | null };

export type ProductVariantStrapDetailsQueryVariables = Exact<{
  sku: Scalars['String']['input'];
  channel: Scalars['String']['input'];
  languageCode: LanguageCodeEnum;
}>;


export type ProductVariantStrapDetailsQuery = { __typename?: 'Query', productVariant?: { __typename?: 'ProductVariant', quantityAvailable?: number | null, translation?: { __typename?: 'ProductVariantTranslation', id: string, name: string } | null, pricing?: { __typename?: 'VariantPricingInfo', price?: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } } | null } | null, product: { __typename?: 'Product', otherSizesSkus?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, integratedBuckle?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', boolean?: boolean | null, slug?: string | null }> } | null, lugSize?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, strapMaterial?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, color?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, lug?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, lugType?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, buckleType?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, compatibleBuckles?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, marketingDescription?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null } } | null };

export type ProductVariantWatchBasicDetailsQueryVariables = Exact<{
  sku: Scalars['String']['input'];
  channel?: InputMaybe<Scalars['String']['input']>;
  languageCode: LanguageCodeEnum;
  thumbnailSize: Scalars['Int']['input'];
  largeMediaSize: Scalars['Int']['input'];
  imagesFormat: ThumbnailFormatEnum;
}>;


export type ProductVariantWatchBasicDetailsQuery = { __typename?: 'Query', productVariant?: { __typename?: 'ProductVariant', id: string, sku?: string | null, pricing?: { __typename?: 'VariantPricingInfo', price?: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } } | null } | null, product: { __typename?: 'Product', id: string, name: string, slug: string, description?: string | null, translation?: { __typename?: 'ProductTranslation', description?: string | null, name?: string | null } | null, media?: Array<{ __typename?: 'ProductMedia', url: string, alt: string, type: ProductMediaType, strapPreviewCoordinates?: string | null, backEngravingCoordinates?: string | null, shotType?: string | null }> | null, mediaLarge?: Array<{ __typename?: 'ProductMedia', url: string, id: string }> | null, specificText?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, relatedProducts?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, compatibleStraps?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, manualUrl?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, pricing?: { __typename?: 'ProductPricingInfo', displayGrossPrices: boolean } | null, thumbnail?: { __typename?: 'Image', alt?: string | null, url: string } | null, collections?: Array<{ __typename?: 'Collection', name: string, slug: string, translation?: { __typename?: 'CollectionTranslation', name?: string | null } | null }> | null, model?: { __typename?: 'SelectedAttribute', values: Array<{ __typename?: 'AttributeValue', slug?: string | null }> } | null, strapMaterial?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, strapColor?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, defaultVariant?: { __typename?: 'ProductVariant', sku?: string | null } | null, watchName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, strapName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, collectionName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, warrantyName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, eyewearModel?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, toolName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, digitalItemName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, marketingStatus?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, marketingPartner?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, marketingCampaign?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, distributionStatus?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, launchDate?: { __typename?: 'SelectedAttribute', values: Array<{ __typename?: 'AttributeValue', name?: string | null }> } | null, limited?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', boolean?: boolean | null, slug?: string | null }> } | null, buckleMaterial?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, buckleType?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, buckleSize?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, dialColor?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, modelStory?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, caseMaterial?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, waterResistance?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, waterResistanceTextComputed?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, diameter?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string } | null }> } | null, thickness?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string } | null }> } | null, weight?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string } | null }> } | null, powerReserve?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, caliber?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, movement?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, chronograph?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, vibration?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, jewel?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, calendar?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, caseback?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, bezel?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, crown?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, crystal?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, headWeight?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string } | null }> } | null, height?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string } | null }> } | null, lugWidth?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string } | null }> } | null, strapType?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, lug?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, warrantyDuration?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, warrantyExtensionDuration?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, movementManufacture?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, bundleVariations?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, comCategories?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, designerChoice?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, personalizedEngraving?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', boolean?: boolean | null, slug?: string | null }> } | null, productType: { __typename?: 'ProductType', slug: string, name: string } }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> } | null };

export type ProductVariantWatchDetailsQueryVariables = Exact<{
  sku: Scalars['String']['input'];
  channel: Scalars['String']['input'];
  languageCode: LanguageCodeEnum;
}>;


export type ProductVariantWatchDetailsQuery = { __typename?: 'Query', productVariant?: { __typename?: 'ProductVariant', id: string, name: string, quantityAvailable?: number | null, translation?: { __typename?: 'ProductVariantTranslation', id: string, name: string } | null, pricing?: { __typename?: 'VariantPricingInfo', price?: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } } | null } | null, product: { __typename?: 'Product', id: string, pricing?: { __typename?: 'ProductPricingInfo', displayGrossPrices: boolean } | null, media?: Array<{ __typename?: 'ProductMedia', strapPreviewCoordinates?: string | null }> | null, marketingStatus?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, marketingPartner?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, marketingCampaign?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, distributionStatus?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, launchDate?: { __typename?: 'SelectedAttribute', values: Array<{ __typename?: 'AttributeValue', name?: string | null }> } | null, limited?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', boolean?: boolean | null, slug?: string | null }> } | null, buckleMaterial?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, buckleType?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, buckleSize?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, dialColor?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, modelStory?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, caseMaterial?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, waterResistance?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, waterResistanceTextComputed?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, diameter?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string } | null }> } | null, thickness?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string } | null }> } | null, weight?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string } | null }> } | null, powerReserve?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, relatedProducts?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, compatibleStraps?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, caliber?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, movement?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, chronograph?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, vibration?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, jewel?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, calendar?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, caseback?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, bezel?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, crown?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, crystal?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, headWeight?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string } | null }> } | null, height?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string } | null }> } | null, lugWidth?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string } | null }> } | null, strapMaterial?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, strapColor?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, strapType?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, lug?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, warrantyDuration?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, warrantyExtensionDuration?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, movementManufacture?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, manualUrl?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, bundleVariations?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, comCategories?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, designerChoice?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, personalizedEngraving?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', boolean?: boolean | null, slug?: string | null }> } | null } } | null };

export type ProductVariantsBySkusQueryVariables = Exact<{
  watchskus: Array<Scalars['String']['input']> | Scalars['String']['input'];
  strapskus: Array<Scalars['String']['input']> | Scalars['String']['input'];
  channel?: InputMaybe<Scalars['String']['input']>;
  languageCode: LanguageCodeEnum;
  thumbnailSize: Scalars['Int']['input'];
  imagesFormat: ThumbnailFormatEnum;
  largeMediaSize: Scalars['Int']['input'];
}>;


export type ProductVariantsBySkusQuery = { __typename?: 'Query', watchs?: { __typename?: 'ProductVariantCountableConnection', totalCount?: number | null, edges: Array<{ __typename?: 'ProductVariantCountableEdge', node: { __typename?: 'ProductVariant', id: string, sku?: string | null, product: { __typename?: 'Product', id: string, name: string, slug: string, description?: string | null, translation?: { __typename?: 'ProductTranslation', description?: string | null, name?: string | null } | null, defaultVariant?: { __typename?: 'ProductVariant', sku?: string | null, id: string, quantityAvailable?: number | null, pricing?: { __typename?: 'VariantPricingInfo', price?: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } } | null } | null } | null, media?: Array<{ __typename?: 'ProductMedia', url: string, alt: string, type: ProductMediaType, strapPreviewCoordinates?: string | null, backEngravingCoordinates?: string | null, shotType?: string | null }> | null, mediaLarge?: Array<{ __typename?: 'ProductMedia', url: string, id: string }> | null, thumbnail?: { __typename?: 'Image', alt?: string | null, url: string } | null, relatedProducts?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, compatibleStraps?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, collections?: Array<{ __typename?: 'Collection', name: string, slug: string, translation?: { __typename?: 'CollectionTranslation', name?: string | null } | null }> | null, model?: { __typename?: 'SelectedAttribute', values: Array<{ __typename?: 'AttributeValue', slug?: string | null }> } | null, strapMaterial?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, strapColor?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, watchName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, strapName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, collectionName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, warrantyName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, eyewearModel?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, toolName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, digitalItemName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, marketingStatus?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, marketingPartner?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, marketingCampaign?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, distributionStatus?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, launchDate?: { __typename?: 'SelectedAttribute', values: Array<{ __typename?: 'AttributeValue', name?: string | null }> } | null, limited?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', boolean?: boolean | null, slug?: string | null }> } | null, buckleMaterial?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, buckleType?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, buckleSize?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, dialColor?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, modelStory?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, caseMaterial?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, waterResistance?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, waterResistanceTextComputed?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, diameter?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string } | null }> } | null, thickness?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string } | null }> } | null, weight?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string } | null }> } | null, powerReserve?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, caliber?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, movement?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, chronograph?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, vibration?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, jewel?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, calendar?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, caseback?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, bezel?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, crown?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, crystal?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, headWeight?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string } | null }> } | null, height?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string } | null }> } | null, lugWidth?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string } | null }> } | null, strapType?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, lug?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, warrantyDuration?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, warrantyExtensionDuration?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, movementManufacture?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, manualUrl?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, bundleVariations?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, comCategories?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, designerChoice?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, personalizedEngraving?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', boolean?: boolean | null, slug?: string | null }> } | null, productType: { __typename?: 'ProductType', slug: string, name: string } } } }> } | null, straps?: { __typename?: 'ProductVariantCountableConnection', totalCount?: number | null, edges: Array<{ __typename?: 'ProductVariantCountableEdge', node: { __typename?: 'ProductVariant', id: string, sku?: string | null, product: { __typename?: 'Product', id: string, name: string, slug: string, description?: string | null, translation?: { __typename?: 'ProductTranslation', description?: string | null, name?: string | null } | null, defaultVariant?: { __typename?: 'ProductVariant', sku?: string | null, id: string, quantityAvailable?: number | null, pricing?: { __typename?: 'VariantPricingInfo', price?: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } } | null } | null } | null, thumbnail?: { __typename?: 'Image', alt?: string | null, url: string } | null, media?: Array<{ __typename?: 'ProductMedia', url: string, alt: string, type: ProductMediaType, strapPreviewCoordinates?: string | null, backEngravingCoordinates?: string | null, shotType?: string | null }> | null, mediaLarge?: Array<{ __typename?: 'ProductMedia', url: string, id: string }> | null, collections?: Array<{ __typename?: 'Collection', name: string, slug: string, translation?: { __typename?: 'CollectionTranslation', name?: string | null } | null }> | null, model?: { __typename?: 'SelectedAttribute', values: Array<{ __typename?: 'AttributeValue', slug?: string | null }> } | null, strapMaterial?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, strapColor?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, watchName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, strapName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, collectionName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, warrantyName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, eyewearModel?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, toolName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, digitalItemName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, productType: { __typename?: 'ProductType', slug: string, name: string } } } }> } | null };

export type ProductsByCategoryQueryVariables = Exact<{
  categoryId: Scalars['ID']['input'];
}>;


export type ProductsByCategoryQuery = { __typename?: 'Query', products?: { __typename?: 'ProductCountableConnection', edges: Array<{ __typename?: 'ProductCountableEdge', node: { __typename?: 'Product', id: string, slug: string, name: string } }> } | null };

export type ProductsByCollectionQueryVariables = Exact<{
  collectionId: Scalars['ID']['input'];
}>;


export type ProductsByCollectionQuery = { __typename?: 'Query', products?: { __typename?: 'ProductCountableConnection', edges: Array<{ __typename?: 'ProductCountableEdge', node: { __typename?: 'Product', id: string, slug: string, name: string } }> } | null };

export type ProductsByIdsQueryVariables = Exact<{
  channel: Scalars['String']['input'];
  filter: ProductFilterInput;
  languageCode: LanguageCodeEnum;
}>;


export type ProductsByIdsQuery = { __typename?: 'Query', products?: { __typename?: 'ProductCountableConnection', edges: Array<{ __typename?: 'ProductCountableEdge', node: { __typename?: 'Product', name: string, translation?: { __typename?: 'ProductTranslation', name?: string | null } | null, thumbnail?: { __typename?: 'Image', url: string, alt?: string | null } | null } }> } | null };

export type ProductsByMarketingPartnerQueryVariables = Exact<{
  modelName: Scalars['String']['input'];
  marketingPartner: Scalars['String']['input'];
  strapMaterial: Scalars['String']['input'];
}>;


export type ProductsByMarketingPartnerQuery = { __typename?: 'Query', products?: { __typename?: 'ProductCountableConnection', edges: Array<{ __typename?: 'ProductCountableEdge', node: { __typename?: 'Product', id: string, name: string, slug: string, attributes: Array<{ __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', id: string, name?: string | null, slug?: string | null, inputType?: AttributeInputTypeEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, externalReference?: string | null, slug?: string | null, inputType?: AttributeInputTypeEnum | null }> }> } }> } | null };

export type ProductsBySkusQueryVariables = Exact<{
  skus: Array<Scalars['String']['input']> | Scalars['String']['input'];
  languageCode: LanguageCodeEnum;
  thumbnailSize: Scalars['Int']['input'];
  imagesFormat: ThumbnailFormatEnum;
  largeMediaSize: Scalars['Int']['input'];
}>;


export type ProductsBySkusQuery = { __typename?: 'Query', products?: { __typename?: 'ProductCountableConnection', edges: Array<{ __typename?: 'ProductCountableEdge', node: { __typename?: 'Product', id: string, name: string, slug: string, description?: string | null, translation?: { __typename?: 'ProductTranslation', description?: string | null, name?: string | null } | null, defaultVariant?: { __typename?: 'ProductVariant', sku?: string | null, id: string, quantityAvailable?: number | null, pricing?: { __typename?: 'VariantPricingInfo', price?: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } } | null } | null } | null, channelListings?: Array<{ __typename?: 'ProductChannelListing', channel: { __typename?: 'Channel', name: string }, pricing?: { __typename?: 'ProductPricingInfo', priceRange?: { __typename?: 'TaxedMoneyRange', start?: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } } | null } | null } | null }> | null, media?: Array<{ __typename?: 'ProductMedia', url: string, alt: string, type: ProductMediaType, strapPreviewCoordinates?: string | null, backEngravingCoordinates?: string | null, shotType?: string | null }> | null, mediaLarge?: Array<{ __typename?: 'ProductMedia', url: string, id: string }> | null, thumbnail?: { __typename?: 'Image', alt?: string | null, url: string } | null, relatedProducts?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, compatibleStraps?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, otherSizesSkus?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, integratedBuckle?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', boolean?: boolean | null, slug?: string | null }> } | null, collections?: Array<{ __typename?: 'Collection', name: string, slug: string, translation?: { __typename?: 'CollectionTranslation', name?: string | null } | null }> | null, model?: { __typename?: 'SelectedAttribute', values: Array<{ __typename?: 'AttributeValue', slug?: string | null }> } | null, strapMaterial?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, strapColor?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, watchName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, strapName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, collectionName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, warrantyName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, eyewearModel?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, toolName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, digitalItemName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, marketingStatus?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, marketingPartner?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, marketingCampaign?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, distributionStatus?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, launchDate?: { __typename?: 'SelectedAttribute', values: Array<{ __typename?: 'AttributeValue', name?: string | null }> } | null, limited?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', boolean?: boolean | null, slug?: string | null }> } | null, buckleMaterial?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, buckleType?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, buckleSize?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, dialColor?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, modelStory?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, caseMaterial?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, waterResistance?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, waterResistanceTextComputed?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, diameter?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string } | null }> } | null, thickness?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string } | null }> } | null, weight?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string } | null }> } | null, powerReserve?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, caliber?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, movement?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, chronograph?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, vibration?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, jewel?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, calendar?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, caseback?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, bezel?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, crown?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, crystal?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, headWeight?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string } | null }> } | null, height?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string } | null }> } | null, lugWidth?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string } | null }> } | null, strapType?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, lug?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, warrantyDuration?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, warrantyExtensionDuration?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, movementManufacture?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, manualUrl?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, bundleVariations?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, comCategories?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, designerChoice?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, personalizedEngraving?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', boolean?: boolean | null, slug?: string | null }> } | null, marketingDescription?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, frameShape?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, frameColor?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, frameMaterial?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, coreWire?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, templeTipDetail?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, frontalPins?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, lensSurface?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, lensColor?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, lensCoating?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, uvProtection?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, frontalWidth?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string } | null }> } | null, templeLength?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string } | null }> } | null, lensWidth?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string } | null }> } | null, bridgeWidth?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string } | null }> } | null, eyewearModelStory?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, productType: { __typename?: 'ProductType', slug: string, name: string } } }> } | null };

export type ReportProductSalesQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  channel: Scalars['String']['input'];
  salePeriod: ReportingPeriod;
  languageCode: LanguageCodeEnum;
  thumbnailSize: Scalars['Int']['input'];
  imagesFormat: ThumbnailFormatEnum;
}>;


export type ReportProductSalesQuery = { __typename?: 'Query', reportProductSales?: { __typename?: 'ProductVariantCountableConnection', edges: Array<{ __typename?: 'ProductVariantCountableEdge', node: { __typename?: 'ProductVariant', product: { __typename?: 'Product', id: string, name: string, slug: string, translation?: { __typename?: 'ProductTranslation', name?: string | null } | null, thumbnail?: { __typename?: 'Image', alt?: string | null, url: string } | null, media?: Array<{ __typename?: 'ProductMedia', url: string, alt: string, type: ProductMediaType, strapPreviewCoordinates?: string | null, backEngravingCoordinates?: string | null, shotType?: string | null }> | null, defaultVariant?: { __typename?: 'ProductVariant', sku?: string | null, id: string, pricing?: { __typename?: 'VariantPricingInfo', price?: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } } | null } | null } | null, integratedBuckle?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', boolean?: boolean | null, slug?: string | null }> } | null, diameter?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string } | null }> } | null, marketingStatus?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, marketingPartner?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, marketingCampaign?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, launchDate?: { __typename?: 'SelectedAttribute', values: Array<{ __typename?: 'AttributeValue', name?: string | null }> } | null, collections?: Array<{ __typename?: 'Collection', name: string, slug: string, translation?: { __typename?: 'CollectionTranslation', name?: string | null } | null }> | null, model?: { __typename?: 'SelectedAttribute', values: Array<{ __typename?: 'AttributeValue', slug?: string | null }> } | null, strapMaterial?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, strapColor?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, watchName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, strapName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, collectionName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, warrantyName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, eyewearModel?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, toolName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, digitalItemName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, productType: { __typename?: 'ProductType', slug: string, name: string } } } }> } | null };

export type SearchStrapsPacksQueryVariables = Exact<{
  channel: Scalars['String']['input'];
  first: Scalars['Int']['input'];
  query: Scalars['String']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
  address?: InputMaybe<AddressInput>;
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  stockAvailability?: InputMaybe<StockAvailability>;
  productTypes?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  attributes?: InputMaybe<Array<AttributeInput> | AttributeInput>;
  price?: InputMaybe<PriceRangeInput>;
  ids?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type SearchStrapsPacksQuery = { __typename?: 'Query', search?: { __typename?: 'ProductCountableConnection', edges: Array<{ __typename?: 'ProductCountableEdge', node: { __typename?: 'Product', id: string, slug: string, name: string, productType: { __typename?: 'ProductType', name: string }, thumbnail?: { __typename?: 'Image', url: string, alt?: string | null } | null, variants?: Array<{ __typename?: 'ProductVariant', id: string, name: string, sku?: string | null, product: { __typename?: 'Product', isAvailable?: boolean | null }, pricing?: { __typename?: 'VariantPricingInfo', onSale?: boolean | null, priceUndiscounted?: { __typename?: 'TaxedMoney', gross: { __typename?: 'Money', currency: string, amount: number } } | null, price?: { __typename?: 'TaxedMoney', gross: { __typename?: 'Money', currency: string, amount: number } } | null } | null }> | null, attributes: Array<{ __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', id: string, name?: string | null }, values: Array<{ __typename?: 'AttributeValue', id: string, name?: string | null, value?: string | null, slug?: string | null, reference?: string | null }> }> } }>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } | null };

export type ShopSettingsDeliveryViewQueryVariables = Exact<{ [key: string]: never; }>;


export type ShopSettingsDeliveryViewQuery = { __typename?: 'Query', shop: { __typename?: 'Shop', phonePrefixes: Array<string>, countries: Array<{ __typename?: 'CountryDisplay', code: string, country: string }> } };

export type ShopSettingsSignUpViewQueryVariables = Exact<{ [key: string]: never; }>;


export type ShopSettingsSignUpViewQuery = { __typename?: 'Query', shop: { __typename?: 'Shop', phonePrefixes: Array<string> } };

export type ShoppingBagProductsQueryVariables = Exact<{
  languageCode: LanguageCodeEnum;
  channel: Scalars['String']['input'];
  filter: ProductVariantFilterInput;
  thumbnailSize: Scalars['Int']['input'];
  imagesFormat: ThumbnailFormatEnum;
}>;


export type ShoppingBagProductsQuery = { __typename?: 'Query', productVariants?: { __typename?: 'ProductVariantCountableConnection', edges: Array<{ __typename?: 'ProductVariantCountableEdge', node: { __typename?: 'ProductVariant', id: string, sku?: string | null, product: { __typename?: 'Product', id: string, name: string, translation?: { __typename?: 'ProductTranslation', name?: string | null } | null, defaultVariant?: { __typename?: 'ProductVariant', sku?: string | null, pricing?: { __typename?: 'VariantPricingInfo', price?: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } } | null } | null } | null, color?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, caseMaterial?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, strapMaterial?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, size?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, compatibleStraps?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, buckle?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, strapColor?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, warrantyExtensionDuration?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, warrantyMovementDuration?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, wristSizeMinInch?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, wristSizeMaxInch?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, wristSizeMinMm?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, wristSizeMaxMm?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, marketingPartner?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, media?: Array<{ __typename?: 'ProductMedia', url: string, alt: string, type: ProductMediaType, strapPreviewCoordinates?: string | null, backEngravingCoordinates?: string | null, shotType?: string | null }> | null, personalizedEngraving?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', boolean?: boolean | null, slug?: string | null }> } | null, productType: { __typename?: 'ProductType', slug: string, name: string }, thumbnail?: { __typename?: 'Image', alt?: string | null, url: string } | null, collections?: Array<{ __typename?: 'Collection', name: string, slug: string, translation?: { __typename?: 'CollectionTranslation', name?: string | null } | null }> | null, model?: { __typename?: 'SelectedAttribute', values: Array<{ __typename?: 'AttributeValue', slug?: string | null }> } | null, watchName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, strapName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, collectionName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, warrantyName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, eyewearModel?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, toolName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, digitalItemName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null } } }> } | null };

export type ShoppingBagStrapsModalQueryVariables = Exact<{
  languageCode: LanguageCodeEnum;
  filter: ProductFilterInput;
  channel: Scalars['String']['input'];
  thumbnailSize: Scalars['Int']['input'];
  imagesFormat: ThumbnailFormatEnum;
}>;


export type ShoppingBagStrapsModalQuery = { __typename?: 'Query', products?: { __typename?: 'ProductCountableConnection', edges: Array<{ __typename?: 'ProductCountableEdge', node: { __typename?: 'Product', defaultVariant?: { __typename?: 'ProductVariant', id: string, sku?: string | null, pricing?: { __typename?: 'VariantPricingInfo', price?: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } } | null } | null, product: { __typename?: 'Product', id: string, name: string, translation?: { __typename?: 'ProductTranslation', name?: string | null } | null, compatibleBuckles?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, integratedBuckle?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', boolean?: boolean | null, slug?: string | null }> } | null, otherSizesSkus?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, strapName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, warrantyName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, toolName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, thumbnail?: { __typename?: 'Image', alt?: string | null, url: string } | null, productType: { __typename?: 'ProductType', slug: string, name: string } } } | null } }> } | null };

export type SocialClubConsentOrderQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type SocialClubConsentOrderQuery = { __typename?: 'Query', order?: { __typename?: 'Order', id: string, checkoutId?: string | null, orderFlowScTermsRequired?: string | null, orderFlowScTermsAccepted?: string | null, userEmail?: string | null, channel: { __typename?: 'Channel', slug: string } } | null };

export type StrapAddToBagProductsQueryVariables = Exact<{
  channel: Scalars['String']['input'];
  limit: Scalars['Int']['input'];
  filter?: InputMaybe<ProductVariantFilterInput>;
  thumbnailSize: Scalars['Int']['input'];
  imagesFormat: ThumbnailFormatEnum;
  languageCode: LanguageCodeEnum;
}>;


export type StrapAddToBagProductsQuery = { __typename?: 'Query', productVariants?: { __typename?: 'ProductVariantCountableConnection', edges: Array<{ __typename?: 'ProductVariantCountableEdge', node: { __typename?: 'ProductVariant', id: string, sku?: string | null, product: { __typename?: 'Product', id: string, name: string, toolName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, buckleName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, productType: { __typename?: 'ProductType', slug: string, name: string }, thumbnail?: { __typename?: 'Image', alt?: string | null, url: string } | null }, pricing?: { __typename?: 'VariantPricingInfo', price?: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } } | null } | null } }> } | null };

export type StrapAddToBagToolsQueryVariables = Exact<{
  channel: Scalars['String']['input'];
  limit: Scalars['Int']['input'];
  filter?: InputMaybe<ProductFilterInput>;
  thumbnailSize: Scalars['Int']['input'];
  imagesFormat: ThumbnailFormatEnum;
  languageCode: LanguageCodeEnum;
}>;


export type StrapAddToBagToolsQuery = { __typename?: 'Query', products?: { __typename?: 'ProductCountableConnection', edges: Array<{ __typename?: 'ProductCountableEdge', node: { __typename?: 'Product', defaultVariant?: { __typename?: 'ProductVariant', id: string, sku?: string | null, product: { __typename?: 'Product', id: string, name: string, toolName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, buckleName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, productType: { __typename?: 'ProductType', slug: string, name: string }, thumbnail?: { __typename?: 'Image', alt?: string | null, url: string } | null }, pricing?: { __typename?: 'VariantPricingInfo', price?: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } } | null } | null } | null } }> } | null };

export type StrapBuckleSizesQueryVariables = Exact<{
  languageCode: LanguageCodeEnum;
  limit: Scalars['Int']['input'];
  filter?: InputMaybe<ProductFilterInput>;
}>;


export type StrapBuckleSizesQuery = { __typename?: 'Query', products?: { __typename?: 'ProductCountableConnection', edges: Array<{ __typename?: 'ProductCountableEdge', node: { __typename?: 'Product', size?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null } }> } | null };

export type SearchSingleStrapPackQueryVariables = Exact<{
  channel: Scalars['String']['input'];
  slug: Scalars['String']['input'];
}>;


export type SearchSingleStrapPackQuery = { __typename?: 'Query', product?: { __typename?: 'Product', id: string, slug: string, name: string, productType: { __typename?: 'ProductType', name: string }, thumbnail?: { __typename?: 'Image', url: string, alt?: string | null } | null, productVariants?: { __typename?: 'ProductVariantCountableConnection', totalCount?: number | null, edges: Array<{ __typename?: 'ProductVariantCountableEdge', node: { __typename?: 'ProductVariant', id: string, name: string, sku?: string | null, product: { __typename?: 'Product', isAvailable?: boolean | null }, pricing?: { __typename?: 'VariantPricingInfo', price?: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } } | null } | null } }> } | null, attributes: Array<{ __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', id: string, name?: string | null }, values: Array<{ __typename?: 'AttributeValue', id: string, name?: string | null, value?: string | null, slug?: string | null, reference?: string | null }> }> } | null };

export type StrapSizesQueryVariables = Exact<{
  channel: Scalars['String']['input'];
  languageCode: LanguageCodeEnum;
  limit: Scalars['Int']['input'];
  filter: ProductVariantFilterInput;
}>;


export type StrapSizesQuery = { __typename?: 'Query', productVariants?: { __typename?: 'ProductVariantCountableConnection', edges: Array<{ __typename?: 'ProductVariantCountableEdge', node: { __typename?: 'ProductVariant', id: string, sku?: string | null, product: { __typename?: 'Product', currentSize?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, material?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, productType: { __typename?: 'ProductType', slug: string, name: string } } } }> } | null };

export type UserCheckQueryVariables = Exact<{
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
}>;


export type UserCheckQuery = { __typename?: 'Query', user?: { __typename?: 'User', id: string, externalReference?: string | null, email: string, isActive: boolean, dateJoined: string, lastLogin?: string | null, isClubMember?: string | null, isAffiliated?: string | null } | null };

export type UserCheckoutsQueryVariables = Exact<{
  userEmail: Scalars['String']['input'];
  channel?: InputMaybe<Scalars['String']['input']>;
}>;


export type UserCheckoutsQuery = { __typename?: 'Query', checkouts?: { __typename?: 'CheckoutCountableConnection', edges: Array<{ __typename?: 'CheckoutCountableEdge', node: { __typename?: 'Checkout', id: string, created: string, updatedAt: string, orderBrand?: string | null, brand?: string | null, channel: { __typename?: 'Channel', slug: string }, user?: { __typename?: 'User', id: string, email: string } | null, lines: Array<{ __typename?: 'CheckoutLine', id: string, quantity: number }> } }> } | null };

export type UserDetailsQueryVariables = Exact<{ [key: string]: never; }>;


export type UserDetailsQuery = { __typename?: 'Query', me?: { __typename?: 'User', id: string, email: string, firstName: string, lastName: string, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }>, addresses: Array<{ __typename?: 'Address', id: string, city: string, cityArea: string, companyName: string, countryArea: string, firstName: string, isDefaultBillingAddress?: boolean | null, isDefaultShippingAddress?: boolean | null, lastName: string, phone?: string | null, postalCode: string, streetAddress1: string, streetAddress2: string, country: { __typename?: 'CountryDisplay', code: string, country: string }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> }>, defaultBillingAddress?: { __typename?: 'Address', id: string, city: string, cityArea: string, companyName: string, countryArea: string, firstName: string, isDefaultBillingAddress?: boolean | null, isDefaultShippingAddress?: boolean | null, lastName: string, phone?: string | null, postalCode: string, streetAddress1: string, streetAddress2: string, country: { __typename?: 'CountryDisplay', code: string, country: string }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> } | null, defaultShippingAddress?: { __typename?: 'Address', id: string, city: string, cityArea: string, companyName: string, countryArea: string, firstName: string, isDefaultBillingAddress?: boolean | null, isDefaultShippingAddress?: boolean | null, lastName: string, phone?: string | null, postalCode: string, streetAddress1: string, streetAddress2: string, country: { __typename?: 'CountryDisplay', code: string, country: string }, metadata: Array<{ __typename?: 'MetadataItem', key: string, value: string }> } | null, checkout?: { __typename?: 'Checkout', id: string, channel: { __typename?: 'Channel', slug: string } } | null } | null };

export type WatchBasicDetailsForSkusQueryVariables = Exact<{
  skus: Array<Scalars['String']['input']> | Scalars['String']['input'];
  channel: Scalars['String']['input'];
  thumbnailSize: Scalars['Int']['input'];
  imagesFormat: ThumbnailFormatEnum;
}>;


export type WatchBasicDetailsForSkusQuery = { __typename?: 'Query', productVariants?: { __typename?: 'ProductVariantCountableConnection', totalCount?: number | null, edges: Array<{ __typename?: 'ProductVariantCountableEdge', node: { __typename?: 'ProductVariant', sku?: string | null, product: { __typename?: 'Product', name: string, thumbnail?: { __typename?: 'Image', alt?: string | null, url: string } | null } } }> } | null };

export type WatchsBySkusQueryVariables = Exact<{
  skus: Array<Scalars['String']['input']> | Scalars['String']['input'];
  languageCode: LanguageCodeEnum;
  thumbnailSize: Scalars['Int']['input'];
  imagesFormat: ThumbnailFormatEnum;
  largeMediaSize: Scalars['Int']['input'];
  first: Scalars['Int']['input'];
  channel?: InputMaybe<Scalars['String']['input']>;
}>;


export type WatchsBySkusQuery = { __typename?: 'Query', watchs?: { __typename?: 'ProductVariantCountableConnection', totalCount?: number | null, edges: Array<{ __typename?: 'ProductVariantCountableEdge', node: { __typename?: 'ProductVariant', id: string, sku?: string | null, product: { __typename?: 'Product', id: string, name: string, slug: string, description?: string | null, translation?: { __typename?: 'ProductTranslation', description?: string | null, name?: string | null } | null, defaultVariant?: { __typename?: 'ProductVariant', sku?: string | null, id: string, quantityAvailable?: number | null, pricing?: { __typename?: 'VariantPricingInfo', price?: { __typename?: 'TaxedMoney', currency: string, gross: { __typename?: 'Money', amount: number, currency: string }, net: { __typename?: 'Money', amount: number, currency: string }, tax: { __typename?: 'Money', amount: number, currency: string } } | null } | null } | null, media?: Array<{ __typename?: 'ProductMedia', url: string, alt: string, type: ProductMediaType, strapPreviewCoordinates?: string | null, backEngravingCoordinates?: string | null, shotType?: string | null }> | null, mediaLarge?: Array<{ __typename?: 'ProductMedia', url: string, id: string }> | null, thumbnail?: { __typename?: 'Image', alt?: string | null, url: string } | null, relatedProducts?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, compatibleStraps?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, collections?: Array<{ __typename?: 'Collection', name: string, slug: string, translation?: { __typename?: 'CollectionTranslation', name?: string | null } | null }> | null, model?: { __typename?: 'SelectedAttribute', values: Array<{ __typename?: 'AttributeValue', slug?: string | null }> } | null, strapMaterial?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, strapColor?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, watchName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, strapName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, collectionName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, warrantyName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, eyewearModel?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, toolName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, digitalItemName?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, marketingStatus?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, marketingPartner?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, marketingCampaign?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, distributionStatus?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, launchDate?: { __typename?: 'SelectedAttribute', values: Array<{ __typename?: 'AttributeValue', name?: string | null }> } | null, limited?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', boolean?: boolean | null, slug?: string | null }> } | null, buckleMaterial?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, buckleType?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, buckleSize?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, dialColor?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, modelStory?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, caseMaterial?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, waterResistance?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, waterResistanceTextComputed?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, diameter?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string } | null }> } | null, thickness?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string } | null }> } | null, weight?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string } | null }> } | null, powerReserve?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, caliber?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, movement?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, chronograph?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, vibration?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, jewel?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, calendar?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, caseback?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, bezel?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, crown?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, crystal?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, headWeight?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string } | null }> } | null, height?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string } | null }> } | null, lugWidth?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string } | null }> } | null, strapType?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, lug?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, warrantyDuration?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, warrantyExtensionDuration?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, movementManufacture?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, manualUrl?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, slug?: string | null, externalReference?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, bundleVariations?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, comCategories?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, designerChoice?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null, unit?: MeasurementUnitsEnum | null }, values: Array<{ __typename?: 'AttributeValue', name?: string | null, plainText?: string | null, value?: string | null, slug?: string | null, translation?: { __typename?: 'AttributeValueTranslation', name: string, plainText?: string | null } | null }> } | null, personalizedEngraving?: { __typename?: 'SelectedAttribute', attribute: { __typename?: 'Attribute', slug?: string | null }, values: Array<{ __typename?: 'AttributeValue', boolean?: boolean | null, slug?: string | null }> } | null, productType: { __typename?: 'ProductType', slug: string, name: string } } } }> } | null };

export const AccountErrorFragmentDoc = gql`
    fragment AccountError on AccountError {
  field
  message
  code
}
    `;
export const ProductTypeFragmentDoc = gql`
    fragment ProductType on Product {
  productType {
    slug
    name
  }
}
    `;
export const ImageFragmentDoc = gql`
    fragment Image on Image {
  alt
  url
}
    `;
export const ProductThumbnailFragmentDoc = gql`
    fragment ProductThumbnailFragment on Product {
  thumbnail(size: $thumbnailSize, format: $imagesFormat) {
    ...Image
  }
}
    `;
export const MultiselectAttributeFragmentDoc = gql`
    fragment MultiselectAttribute on SelectedAttribute {
  attribute {
    slug
    unit
  }
  values {
    name
    plainText
    translation(languageCode: $languageCode) {
      name
      plainText
    }
    value
    slug
  }
}
    `;
export const MoneyFragmentDoc = gql`
    fragment Money on Money {
  amount
  currency
}
    `;
export const TaxedMoneyFragmentDoc = gql`
    fragment TaxedMoney on TaxedMoney {
  gross {
    ...Money
  }
  net {
    ...Money
  }
  tax {
    ...Money
  }
  currency
}
    `;
export const AddToBagStrapFragmentDoc = gql`
    fragment AddToBagStrap on ProductVariant {
  id
  sku
  product {
    id
    name
    ...ProductType
    ...ProductThumbnailFragment
    toolName: attribute(slug: "com-tool-name") {
      ...MultiselectAttribute
    }
    buckleName: attribute(slug: "wbu-name-mktg") {
      ...MultiselectAttribute
    }
  }
  pricing {
    price {
      ...TaxedMoney
    }
  }
}
    `;
export const ChoiceValueFragmentDoc = gql`
    fragment ChoiceValue on ChoiceValue {
  raw
  verbose
}
    `;
export const AddressValidationDataFragmentDoc = gql`
    fragment AddressValidationData on AddressValidationData {
  requiredFields
  countryAreaChoices {
    ...ChoiceValue
  }
  cityChoices {
    ...ChoiceValue
  }
  countryAreaType
  postalCodeType
  cityType
}
    `;
export const CategoryBasicFragmentDoc = gql`
    fragment CategoryBasicFragment on Category {
  id
  name
  slug
  translation(languageCode: $locale) {
    id
    name
  }
}
    `;
export const CategoryDetailsFragmentDoc = gql`
    fragment CategoryDetailsFragment on Category {
  id
  ...CategoryBasicFragment
  seoTitle
  seoDescription
  description
  translation(languageCode: $locale) {
    id
    description
  }
  backgroundImage {
    ...Image
  }
  ancestors(first: 5) {
    edges {
      node {
        ...CategoryBasicFragment
      }
    }
  }
}
    `;
export const CheckoutBareFragmentDoc = gql`
    fragment CheckoutBare on Checkout {
  id
  user {
    email
  }
  email
  languageCode
}
    `;
export const ChannelFragmentDoc = gql`
    fragment Channel on Channel {
  slug
}
    `;
export const MetadataItemFragmentDoc = gql`
    fragment MetadataItem on MetadataItem {
  key
  value
}
    `;
export const VariantPricingFragmentDoc = gql`
    fragment VariantPricing on VariantPricingInfo {
  price {
    ...TaxedMoney
  }
}
    `;
export const DropdownAttributeFragmentDoc = gql`
    fragment DropdownAttribute on SelectedAttribute {
  attribute {
    slug
  }
  values {
    name
    plainText
    slug
    translation(languageCode: $languageCode) {
      name
      plainText
    }
    externalReference
  }
}
    `;
export const ProductMediaFragmentDoc = gql`
    fragment ProductMediaFragment on ProductMedia {
  url(size: $thumbnailSize, format: $imagesFormat)
  alt
  type
  strapPreviewCoordinates: metafield(key: "asset.strap_preview_coordinates")
  backEngravingCoordinates: metafield(key: "asset.back_engraving_coordinates")
  shotType: metafield(key: "asset.shot_type")
}
    `;
export const BoolAttributeFragmentDoc = gql`
    fragment BoolAttribute on SelectedAttribute {
  attribute {
    slug
  }
  values {
    boolean
    slug
  }
}
    `;
export const ProductUrlBaseFragmentDoc = gql`
    fragment ProductUrlBase on Product {
  collections {
    name
    slug
    translation(languageCode: $languageCode) {
      name
    }
  }
  model: attribute(slug: "com-model") {
    values {
      slug
    }
  }
  strapMaterial: attribute(slug: "wbr-material-mktg") {
    ...DropdownAttribute
  }
  strapColor: attribute(slug: "wbr-color") {
    ...DropdownAttribute
  }
  ...ProductType
  defaultVariant {
    sku
  }
  watchName: attribute(slug: "com-product-name-mktg") {
    ...MultiselectAttribute
  }
  strapName: attribute(slug: "wbr-name-mktg") {
    ...MultiselectAttribute
  }
  collectionName: attribute(slug: "com-collection") {
    ...DropdownAttribute
  }
  warrantyName: attribute(slug: "com-warranty-name") {
    ...MultiselectAttribute
  }
  eyewearModel: attribute(slug: "mer-name-mktg") {
    ...MultiselectAttribute
  }
  toolName: attribute(slug: "com-tool-name") {
    ...MultiselectAttribute
  }
  digitalItemName: attribute(slug: "com-item-name") {
    ...MultiselectAttribute
  }
}
    `;
export const LineProductFragmentDoc = gql`
    fragment LineProduct on Product {
  id
  name
  translation(languageCode: $languageCode) {
    name
  }
  defaultVariant {
    sku
    pricing {
      ...VariantPricing
    }
  }
  color: attribute(slug: "wdi-color-of-dial") {
    ...DropdownAttribute
  }
  caseMaterial: attribute(slug: "wca-material-mktg") {
    ...DropdownAttribute
  }
  strapMaterial: attribute(slug: "wbr-material-mktg") {
    ...DropdownAttribute
  }
  size: attribute(slug: "wbr-current-size") {
    ...DropdownAttribute
  }
  compatibleStraps: attribute(slug: "wmf-compatible-straps") {
    ...MultiselectAttribute
  }
  buckle: attribute(slug: "wbr-s-buckle-type") {
    ...DropdownAttribute
  }
  strapColor: attribute(slug: "wbr-color") {
    ...DropdownAttribute
  }
  warrantyExtensionDuration: attribute(slug: "wmo-warranty-extension-duration") {
    ...DropdownAttribute
  }
  warrantyMovementDuration: attribute(slug: "wmo-movement-warranty-duration") {
    ...DropdownAttribute
  }
  wristSizeMinInch: attribute(slug: "wbr-wrist-size-min-inch") {
    ...DropdownAttribute
  }
  wristSizeMaxInch: attribute(slug: "wbr-wrist-size-max-inch") {
    ...DropdownAttribute
  }
  wristSizeMinMm: attribute(slug: "wbr-wrist-size-min-mm") {
    ...DropdownAttribute
  }
  wristSizeMaxMm: attribute(slug: "wbr-wrist-size-max-mm") {
    ...DropdownAttribute
  }
  marketingPartner: attribute(slug: "com-marketing-partner") {
    ...DropdownAttribute
  }
  media {
    ...ProductMediaFragment
  }
  personalizedEngraving: attribute(slug: "wba-personalized-engraving") {
    ...BoolAttribute
  }
  ...ProductType
  ...ProductThumbnailFragment
  ...ProductUrlBase
}
    `;
export const ProductVariantLineFragmentDoc = gql`
    fragment ProductVariantLine on ProductVariant {
  id
  sku
  product {
    ...LineProduct
    watchName: attribute(slug: "com-product-name-mktg") {
      ...MultiselectAttribute
    }
    strapName: attribute(slug: "wbr-name-mktg") {
      ...MultiselectAttribute
    }
    buckleName: attribute(slug: "wbu-name-mktg") {
      ...MultiselectAttribute
    }
    toolName: attribute(slug: "com-tool-name") {
      ...MultiselectAttribute
    }
    warrantyName: attribute(slug: "com-warranty-name") {
      ...MultiselectAttribute
    }
    eyewearModel: attribute(slug: "mer-name-mktg") {
      ...MultiselectAttribute
    }
    digitalItemName: attribute(slug: "com-item-name") {
      ...MultiselectAttribute
    }
  }
}
    `;
export const CheckoutLineFragmentDoc = gql`
    fragment CheckoutLine on CheckoutLine {
  id
  quantity
  unitPrice {
    ...TaxedMoney
  }
  totalPrice {
    ...TaxedMoney
  }
  undiscountedTotalPrice {
    ...Money
  }
  undiscountedUnitPrice {
    ...Money
  }
  metadata {
    ...MetadataItem
  }
  variant {
    ...ProductVariantLine
  }
  relatedProductBuckleId: metafield(key: "related.product.buckle")
  relatedProductStrapId: metafield(key: "related.product.strap")
  relatedProductWatchId: metafield(key: "related.watch")
  relatedBraceletSize: metafield(key: "relatedBraceletSize")
  relatedEngravingId: metafield(key: "related.engraving")
  strapPackReference: metafield(key: "strap_pack_reference")
  strapReference: metafield(key: "strap_reference")
  strapSize: metafield(key: "strap_size")
  preOrderData: metafield(key: "preorder_data")
}
    `;
export const GiftMetadataFragmentDoc = gql`
    fragment GiftMetadata on ObjectWithMetadata {
  isGift: metafield(key: "gift")
  giftFrom: metafield(key: "gift_from")
  giftMessage: metafield(key: "gift_message")
}
    `;
export const CustomerTitleMetadataFragmentDoc = gql`
    fragment CustomerTitleMetadata on ObjectWithMetadata {
  shippingTitle: metafield(key: "shipping.title")
  billingTitle: metafield(key: "billing.title")
}
    `;
export const DeliveryScheduleMetadataFragmentDoc = gql`
    fragment DeliveryScheduleMetadata on ObjectWithMetadata {
  timeSlot: metafield(key: "time_slot")
}
    `;
export const PreorderMetadataFragmentDoc = gql`
    fragment PreorderMetadata on ObjectWithMetadata {
  preOrderData: metafield(key: "preorder_data")
  orderType: metafield(key: "order.type")
  orderStatus: metafield(key: "order.status")
  orderCollectedDate: metafield(key: "order.collected_date")
  payPerLinkToken: metafield(key: "order.pay_per_link_token")
  payPerLinkExpiration: metafield(key: "order.pay_per_link_token_expiration_time")
}
    `;
export const PaymentMethodMetadataFragmentDoc = gql`
    fragment PaymentMethodMetadata on ObjectWithMetadata {
  paymentMethod: metafield(key: "paymentMethod")
}
    `;
export const OrderFlowMetadataFragmentDoc = gql`
    fragment OrderFlowMetadata on ObjectWithMetadata {
  orderFlowScTermsRequired: metafield(key: "orderFlow.scTermsRequired")
  orderFlowScTermsAccepted: metafield(key: "orderFlow.scTermsAccepted")
  orderFlowWasUserAuthenticated: metafield(key: "orderFlow.wasUserAuthenticated")
  orderFlowWasRegisterMyWatchChecked: metafield(
    key: "orderFlow.wasRegisterMyWatchChecked"
  )
  orderFlowWasCreateMyAccountWithoutWatchChecked: metafield(
    key: "orderFlow.wasCreateMyAccountWithoutWatchChecked"
  )
  orderFlowWasAccountCreated: metafield(key: "orderFlow.wasAccountCreated")
  orderFlowUserJoinClub: metafield(key: "orderFlow.userJoinClub")
  orderFlowUserAffiliated: metafield(key: "orderFlow.userAffiliated")
  orderFlowReceiveReceipt: metafield(key: "orderFlow.japanReceipt")
  checkoutId: metafield(key: "checkout.id")
}
    `;
export const CheckoutMetadataFragmentDoc = gql`
    fragment CheckoutMetadata on Checkout {
  ...GiftMetadata
  ...CustomerTitleMetadata
  ...DeliveryScheduleMetadata
  ...PreorderMetadata
  ...PaymentMethodMetadata
  ...OrderFlowMetadata
  deliveryMode: metafield(key: "order.delivery_mode")
  boutiqueExtRef: metafield(key: "order.boutique_external_reference")
  gwpProduct: metafield(key: "gwp.product")
  orderBid: metafield(key: "order.bid")
  campaignVoucherCode: metafield(key: "order.fake_voucher")
}
    `;
export const CheckoutBaseFragmentDoc = gql`
    fragment CheckoutBase on Checkout {
  ...CheckoutBare
  totalPrice {
    ...TaxedMoney
  }
  totalBalance {
    ...Money
  }
  subtotalPrice {
    ...TaxedMoney
  }
  channel {
    ...Channel
  }
  lines {
    ...CheckoutLine
  }
  ...CheckoutMetadata
}
    `;
export const AddressFragmentDoc = gql`
    fragment Address on Address {
  id
  city
  cityArea
  companyName
  countryArea
  firstName
  isDefaultBillingAddress
  isDefaultShippingAddress
  lastName
  phone
  postalCode
  streetAddress1
  streetAddress2
  country {
    code
    country
  }
  metadata {
    key
    value
  }
}
    `;
export const ShippingMethodFragmentDoc = gql`
    fragment ShippingMethod on ShippingMethod {
  id
  name
  translation(languageCode: $languageCode) {
    name
  }
  minimumDeliveryDays
  maximumDeliveryDays
  price {
    ...Money
  }
}
    `;
export const WarehouseFragmentDoc = gql`
    fragment Warehouse on Warehouse {
  id
  name
  email
  address {
    ...Address
  }
}
    `;
export const DeliveryMethodFragmentDoc = gql`
    fragment DeliveryMethod on DeliveryMethod {
  ...Warehouse
  ...ShippingMethod
}
    `;
export const CheckoutFragmentDoc = gql`
    fragment Checkout on Checkout {
  ...CheckoutBase
  billingAddress {
    ...Address
  }
  shippingAddress {
    ...Address
  }
  shippingMethods {
    ...ShippingMethod
  }
  isShippingRequired
  availableCollectionPoints {
    ...Warehouse
  }
  deliveryMethod {
    ...DeliveryMethod
  }
  discount {
    ...Money
  }
  discountName
  voucherCode
  subtotalPrice {
    ...TaxedMoney
  }
  shippingPrice {
    ...TaxedMoney
  }
}
    `;
export const CheckoutErrorFragmentDoc = gql`
    fragment CheckoutError on CheckoutError {
  field
  code
  addressType
  message
}
    `;
export const CheckoutRefreshFragmentDoc = gql`
    fragment CheckoutRefresh on Checkout {
  id
  subtotalPrice {
    ...TaxedMoney
  }
  totalPrice {
    ...TaxedMoney
  }
  shippingPrice {
    ...TaxedMoney
  }
  lines {
    ...CheckoutLine
  }
  ...PreorderMetadata
  ...OrderFlowMetadata
}
    `;
export const CollectionBasicFragmentDoc = gql`
    fragment CollectionBasicFragment on Collection {
  id
  name
  description
  translation(languageCode: $locale) {
    id
    name
    description
  }
  slug
}
    `;
export const CollectionDetailsFragmentDoc = gql`
    fragment CollectionDetailsFragment on Collection {
  id
  ...CollectionBasicFragment
  seoTitle
  seoDescription
  description
  translation(languageCode: $locale) {
    id
    description
  }
  backgroundImage {
    ...Image
  }
}
    `;
export const CountryFragmentDoc = gql`
    fragment Country on CountryDisplay {
  code
  country
}
    `;
export const MenuItemFragmentDoc = gql`
    fragment MenuItemFragment on MenuItem {
  id
  name
  translation(languageCode: $locale) {
    id
    name
  }
  parent {
    id
  }
  category {
    id
    slug
  }
  collection {
    id
    slug
  }
  page {
    id
    slug
  }
  url
}
    `;
export const MenuItemWithChildrenFragmentDoc = gql`
    fragment MenuItemWithChildrenFragment on MenuItem {
  id
  name
  translation(languageCode: $locale) {
    id
    name
  }
  page {
    id
    slug
  }
  children {
    ...MenuItemFragment
    children {
      ...MenuItemFragment
    }
  }
  url
}
    `;
export const MetadataErrorFragmentDoc = gql`
    fragment MetadataError on MetadataError {
  field
  message
  code
}
    `;
export const WarrantyRelatedWatchMetadataFragmentDoc = gql`
    fragment WarrantyRelatedWatchMetadata on ObjectWithMetadata {
  relatedWatchSku: metafield(key: "related.watch.model_reference")
  relatedWatchSn: metafield(key: "related.watch.serial_number")
  warrantyDuration: metafield(key: "warranty.duration")
  relatedProductWatchId: metafield(key: "related.watch")
}
    `;
export const MyOrderLineFragmentDoc = gql`
    fragment MyOrderLine on OrderLine {
  id
  totalPrice {
    ...TaxedMoney
  }
  productName
  variant {
    sku
    product {
      id
      thumbnail(size: $thumbnailSize, format: WEBP) {
        alt
        url
      }
      media {
        url(size: $thumbnailSize, format: WEBP)
        alt
        type
        strapPreviewCoordinates: metafield(key: "asset.strap_preview_coordinates")
        backEngravingCoordinates: metafield(key: "asset.back_engraving_coordinates")
        shotType: metafield(key: "asset.shot_type")
      }
      productType {
        name
        slug
      }
      watchName: attribute(slug: "com-product-name-mktg") {
        ...MultiselectAttribute
      }
      strapName: attribute(slug: "wbr-name-mktg") {
        ...MultiselectAttribute
      }
      buckleName: attribute(slug: "wbu-name-mktg") {
        ...MultiselectAttribute
      }
      toolName: attribute(slug: "com-tool-name") {
        ...MultiselectAttribute
      }
      warrantyName: attribute(slug: "com-warranty-name") {
        ...MultiselectAttribute
      }
      eyewearModel: attribute(slug: "mer-name-mktg") {
        ...MultiselectAttribute
      }
      digitalItemName: attribute(slug: "com-item-name") {
        ...MultiselectAttribute
      }
    }
  }
  unitPrice {
    ...TaxedMoney
  }
  undiscountedUnitPrice {
    ...TaxedMoney
  }
  unitDiscount {
    ...Money
  }
  ...WarrantyRelatedWatchMetadata
  unitDiscountValue
  thumbnail(size: $thumbnailSize, format: WEBP) {
    alt
    url
  }
  metadata {
    key
    value
  }
}
    `;
export const FulfillmentReturnMetadataFragmentDoc = gql`
    fragment FulfillmentReturnMetadata on ObjectWithMetadata {
  returnBid: metafield(key: "return.bid")
  returnCreatedAt: metafield(key: "return.created_at")
  returnCreatedBy: metafield(key: "return.created_by")
  returnStatus: metafield(key: "return.status")
}
    `;
export const FulfillmentTrackingMetadataFragmentDoc = gql`
    fragment FulfillmentTrackingMetadata on ObjectWithMetadata {
  trackingUrl: metafield(key: "fulfillment.tracking_url")
  trackingCarrier: metafield(key: "fulfillment.tracking_carrier")
}
    `;
export const FulfillmentFragmentDoc = gql`
    fragment Fulfillment on Fulfillment {
  id
  created
  status
  lines {
    id
    quantity
    orderLine {
      ...MyOrderLine
    }
  }
  trackingNumber
  ...FulfillmentReturnMetadata
  ...FulfillmentTrackingMetadata
}
    `;
export const DiscountsFragmentDoc = gql`
    fragment Discounts on OrderDiscount {
  id
  type
  name
  value
  valueType
  amount {
    ...Money
  }
}
    `;
export const BusinessIdMetadataFragmentDoc = gql`
    fragment BusinessIdMetadata on ObjectWithMetadata {
  businessId: metafield(key: "order.bid")
}
    `;
export const MyOrderFragmentDoc = gql`
    fragment MyOrder on Order {
  id
  number
  created
  userEmail
  collectionPointName
  user {
    id
  }
  metadata {
    key
    value
  }
  fulfillments {
    ...Fulfillment
  }
  subtotal {
    ...TaxedMoney
  }
  total {
    ...TaxedMoney
  }
  totalBalance {
    ...Money
  }
  totalCharged {
    ...Money
  }
  totalAuthorized {
    ...Money
  }
  lines {
    ...MyOrderLine
  }
  discounts {
    ...Discounts
  }
  voucher {
    id
    name
    discountValue
    discountValueType
  }
  voucherCode
  ...BusinessIdMetadata
  ...PreorderMetadata
}
    `;
export const OrderLineFragmentDoc = gql`
    fragment OrderLine on OrderLine {
  id
  productName
  translatedProductName
  quantity
  unitPrice {
    ...TaxedMoney
  }
  totalPrice {
    ...TaxedMoney
  }
  variant {
    ...ProductVariantLine
  }
  undiscountedUnitPrice {
    ...TaxedMoney
  }
  unitDiscount {
    ...Money
  }
  thumbnail(size: $thumbnailSize, format: $imagesFormat) {
    ...Image
  }
  metadata {
    ...MetadataItem
  }
  relatedProductBuckleId: metafield(key: "related.product.buckle")
  relatedProductStrapId: metafield(key: "related.product.strap")
  relatedProductWatchId: metafield(key: "related.watch")
  relatedBraceletSize: metafield(key: "relatedBraceletSize")
  relatedEngravingId: metafield(key: "related.engraving")
  strapPackReference: metafield(key: "strap_pack_reference")
  strapReference: metafield(key: "strap_reference")
  strapSize: metafield(key: "strap_size")
  warrantyDuration: metafield(key: "warranty.duration")
}
    `;
export const OrderFragmentDoc = gql`
    fragment Order on Order {
  id
  userEmail
  isShippingRequired
  lines {
    ...OrderLine
  }
  subtotal {
    ...TaxedMoney
  }
  shippingPrice {
    ...TaxedMoney
  }
  total {
    ...TaxedMoney
  }
  channel {
    ...Channel
  }
  totalBalance {
    ...Money
  }
  totalCharged {
    ...Money
  }
  totalAuthorized {
    ...Money
  }
  shippingAddress {
    ...Address
  }
  billingAddress {
    ...Address
  }
  discounts {
    ...Discounts
  }
  voucher {
    id
    name
    discountValue
    discountValueType
  }
  voucherCode
  ...CustomerTitleMetadata
  ...PreorderMetadata
  ...GiftMetadata
  ...DeliveryScheduleMetadata
  ...PaymentMethodMetadata
  ...OrderFlowMetadata
  isOfflinePayment: metafield(key: "order.is_offline_payment")
  deliveryMode: metafield(key: "order.delivery_mode")
}
    `;
export const OrderErrorFragmentDoc = gql`
    fragment OrderError on OrderError {
  code
  field
  message
}
    `;
export const PageInfoFragmentDoc = gql`
    fragment PageInfoFragment on PageInfo {
  hasNextPage
  endCursor
}
    `;
export const PaymentGatewayFragmentDoc = gql`
    fragment PaymentGateway on PaymentGateway {
  id
  name
  config {
    field
    value
  }
}
    `;
export const PaymentGatewayConfigErrorFragmentDoc = gql`
    fragment PaymentGatewayConfigError on PaymentGatewayConfigError {
  field
  message
  code
}
    `;
export const PaymentGatewayConfigFragmentDoc = gql`
    fragment PaymentGatewayConfig on PaymentGatewayConfig {
  id
  data
  errors {
    ...PaymentGatewayConfigError
  }
}
    `;
export const PaymentGatewayInitializeErrorFragmentDoc = gql`
    fragment PaymentGatewayInitializeError on PaymentGatewayInitializeError {
  field
  message
  code
}
    `;
export const PlainTextAttributeFragmentDoc = gql`
    fragment PlainTextAttribute on SelectedAttribute {
  attribute {
    slug
  }
  values {
    plainText
    translation(languageCode: $languageCode) {
      plainText
    }
  }
}
    `;
export const NumericAttributeFragmentDoc = gql`
    fragment NumericAttribute on SelectedAttribute {
  attribute {
    slug
    unit
  }
  values {
    name
    translation(languageCode: $languageCode) {
      name
    }
  }
}
    `;
export const ProductCardFragmentDoc = gql`
    fragment ProductCard on Product {
  ...ProductUrlBase
  id
  name
  slug
  translation(languageCode: $languageCode) {
    name
  }
  thumbnail(size: $thumbnailSize, format: $imagesFormat) {
    ...Image
  }
  media {
    ...ProductMediaFragment
  }
  defaultVariant {
    sku
    id
    pricing {
      ...VariantPricing
    }
  }
  integratedBuckle: attribute(slug: "wbr-integrated-buckle") {
    ...BoolAttribute
  }
  ...ProductType
  diameter: attribute(slug: "wca-diameter") {
    ...NumericAttribute
  }
  marketingStatus: attribute(slug: "com-marketing-status") {
    ...MultiselectAttribute
  }
  marketingPartner: attribute(slug: "com-marketing-partner") {
    ...MultiselectAttribute
  }
  marketingCampaign: attribute(slug: "com-marketing-campaign") {
    ...MultiselectAttribute
  }
  launchDate: attribute(slug: "com-launch-date") {
    values {
      name
    }
  }
}
    `;
export const WatchAttributesFragmentDoc = gql`
    fragment WatchAttributes on Product {
  marketingStatus: attribute(slug: "com-marketing-status") {
    ...MultiselectAttribute
  }
  marketingPartner: attribute(slug: "com-marketing-partner") {
    ...MultiselectAttribute
  }
  marketingCampaign: attribute(slug: "com-marketing-campaign") {
    ...MultiselectAttribute
  }
  distributionStatus: attribute(slug: "com-distribution-status") {
    ...DropdownAttribute
  }
  launchDate: attribute(slug: "com-launch-date") {
    values {
      name
    }
  }
  limited: attribute(slug: "com-limited-edition") {
    ...BoolAttribute
  }
  buckleMaterial: attribute(slug: "wbu-material-mktg") {
    ...DropdownAttribute
  }
  buckleType: attribute(slug: "wbu-type-mktg") {
    ...DropdownAttribute
  }
  buckleSize: attribute(slug: "wbu-size") {
    ...DropdownAttribute
  }
  dialColor: attribute(slug: "wdi-color-of-dial") {
    ...DropdownAttribute
  }
  modelStory: attribute(slug: "com-description-mktg") {
    ...DropdownAttribute
  }
  caseMaterial: attribute(slug: "wca-material-mktg") {
    ...DropdownAttribute
  }
  waterResistance: attribute(slug: "wca-water-resistant-mktg") {
    ...DropdownAttribute
  }
  waterResistanceTextComputed: attribute(
    slug: "wca-water-resistant-mktg-text-computed"
  ) {
    ...DropdownAttribute
  }
  diameter: attribute(slug: "wca-diameter") {
    ...NumericAttribute
  }
  thickness: attribute(slug: "wmf-thickness") {
    ...NumericAttribute
  }
  weight: attribute(slug: "com-net-product-weight") {
    ...NumericAttribute
  }
  powerReserve: attribute(slug: "wmo-power-reserve") {
    ...DropdownAttribute
  }
  relatedProducts: attribute(slug: "com-related-products") {
    ...MultiselectAttribute
  }
  compatibleStraps: attribute(slug: "wmf-compatible-straps") {
    ...MultiselectAttribute
  }
  caliber: attribute(slug: "wmo-calibre-name") {
    ...DropdownAttribute
  }
  movement: attribute(slug: "wmo-movement-desc-mktg") {
    ...DropdownAttribute
  }
  chronograph: attribute(slug: "wmo-chronograph") {
    ...DropdownAttribute
  }
  vibration: attribute(slug: "wmo-frequence-vph") {
    ...DropdownAttribute
  }
  jewel: attribute(slug: "wmo-number-of-jewels") {
    ...DropdownAttribute
  }
  calendar: attribute(slug: "wmo-calendar") {
    ...DropdownAttribute
  }
  caseback: attribute(slug: "wba-description-mktg") {
    ...DropdownAttribute
  }
  bezel: attribute(slug: "wbz-description-mktg") {
    ...DropdownAttribute
  }
  crown: attribute(slug: "wcr-description-mktg") {
    ...DropdownAttribute
  }
  crystal: attribute(slug: "wdu-description-mktg") {
    ...DropdownAttribute
  }
  headWeight: attribute(slug: "com-net-watch-head-weight") {
    ...NumericAttribute
  }
  height: attribute(slug: "wmf-height") {
    ...NumericAttribute
  }
  caliber: attribute(slug: "wmo-calibre-name") {
    ...DropdownAttribute
  }
  lugWidth: attribute(slug: "wca-distance-between-horns") {
    ...NumericAttribute
  }
  strapMaterial: attribute(slug: "wbr-material-mktg") {
    ...DropdownAttribute
  }
  strapColor: attribute(slug: "wbr-color") {
    ...DropdownAttribute
  }
  strapType: attribute(slug: "wbr-bar-shape") {
    ...DropdownAttribute
  }
  lug: attribute(slug: "wbr-distance-between-horns") {
    ...DropdownAttribute
  }
  warrantyDuration: attribute(slug: "wmo-movement-warranty-duration") {
    ...DropdownAttribute
  }
  warrantyExtensionDuration: attribute(slug: "wmo-warranty-extension-duration") {
    ...DropdownAttribute
  }
  movementManufacture: attribute(slug: "wmo-movement-manufacture") {
    ...DropdownAttribute
  }
  calendar: attribute(slug: "wmo-calendar") {
    ...DropdownAttribute
  }
  chronograph: attribute(slug: "wmo-chronograph") {
    ...DropdownAttribute
  }
  manualUrl: attribute(slug: "manual-url") {
    ...DropdownAttribute
  }
  bundleVariations: attribute(slug: "pim-bundle-variations") {
    ...MultiselectAttribute
  }
  comCategories: attribute(slug: "com-categories") {
    ...MultiselectAttribute
  }
  designerChoice: attribute(slug: "com-designerchoice") {
    ...MultiselectAttribute
  }
  personalizedEngraving: attribute(slug: "wba-personalized-engraving") {
    ...BoolAttribute
  }
}
    `;
export const EyewearAttributesFragmentDoc = gql`
    fragment EyewearAttributes on Product {
  marketingDescription: attribute(slug: "mer-short-description-mktg") {
    ...DropdownAttribute
  }
  frameShape: attribute(slug: "mer-frame-shape") {
    ...DropdownAttribute
  }
  frameColor: attribute(slug: "mer-frame-colour") {
    ...DropdownAttribute
  }
  frameMaterial: attribute(slug: "mer-frame-material") {
    ...DropdownAttribute
  }
  coreWire: attribute(slug: "mer-core-wire") {
    ...DropdownAttribute
  }
  templeTipDetail: attribute(slug: "mer-temple-tip-detail") {
    ...DropdownAttribute
  }
  frontalPins: attribute(slug: "mer-frontal-pins") {
    ...DropdownAttribute
  }
  lensSurface: attribute(slug: "mer-lens-surface") {
    ...DropdownAttribute
  }
  lensColor: attribute(slug: "mer-lens-colour") {
    ...DropdownAttribute
  }
  lensCoating: attribute(slug: "mer-lens-coating") {
    ...DropdownAttribute
  }
  uvProtection: attribute(slug: "mer-uv-protection") {
    ...DropdownAttribute
  }
  frontalWidth: attribute(slug: "mer-frontal-width") {
    ...NumericAttribute
  }
  templeLength: attribute(slug: "mer-temple-length") {
    ...NumericAttribute
  }
  lensWidth: attribute(slug: "mer-lens-width") {
    ...NumericAttribute
  }
  bridgeWidth: attribute(slug: "mer-bridge-width") {
    ...NumericAttribute
  }
  bundleVariations: attribute(slug: "pim-bundle-variations") {
    ...MultiselectAttribute
  }
  manualUrl: attribute(slug: "manual-url") {
    ...DropdownAttribute
  }
  eyewearModelStory: attribute(slug: "mer-description-mktg") {
    ...DropdownAttribute
  }
  marketingStatus: attribute(slug: "com-marketing-status") {
    ...MultiselectAttribute
  }
  launchDate: attribute(slug: "com-launch-date") {
    values {
      name
    }
  }
}
    `;
export const ProductSkuFragmentDoc = gql`
    fragment ProductSku on Product {
  ...ProductUrlBase
  id
  name
  slug
  description
  translation(languageCode: $languageCode) {
    description
    name
  }
  defaultVariant {
    sku
    id
    quantityAvailable
    pricing {
      ...VariantPricing
    }
  }
  channelListings {
    channel {
      name
    }
    pricing {
      priceRange {
        start {
          ...TaxedMoney
        }
      }
    }
  }
  media {
    ...ProductMediaFragment
  }
  mediaLarge: media {
    url(size: $largeMediaSize, format: $imagesFormat)
    id
  }
  thumbnail(size: $thumbnailSize, format: $imagesFormat) {
    ...Image
  }
  relatedProducts: attribute(slug: "com-related-products") {
    ...MultiselectAttribute
  }
  compatibleStraps: attribute(slug: "wmf-compatible-straps") {
    ...MultiselectAttribute
  }
  otherSizesSkus: attribute(slug: "wbr-other-sizes") {
    ...MultiselectAttribute
  }
  integratedBuckle: attribute(slug: "wbr-integrated-buckle") {
    ...BoolAttribute
  }
  ...WatchAttributes
  ...EyewearAttributes
}
    `;
export const ProductTileFragmentDoc = gql`
    fragment ProductTileFragment on Product {
  id
  slug
  name
  translation(languageCode: $locale) {
    id
    name
  }
  thumbnail(size: 400) {
    ...Image
  }
  pricing {
    onSale
    priceRange {
      start {
        ...TaxedMoney
      }
      stop {
        ...TaxedMoney
      }
    }
    priceRangeUndiscounted {
      start {
        ...TaxedMoney
      }
    }
  }
}
    `;
export const ProductVariantEyewearBasicDetailsFragmentDoc = gql`
    fragment ProductVariantEyewearBasicDetails on ProductVariant {
  id
  sku
  quantityAvailable
  pricing {
    price {
      ...TaxedMoney
    }
  }
  product {
    ...ProductUrlBase
    id
    name
    slug
    description
    translation(languageCode: $languageCode) {
      id
      description
      name
    }
    thumbnail(size: $thumbnailSize, format: $imagesFormat) {
      ...Image
    }
    media {
      ...ProductMediaFragment
    }
    mediaLarge: media {
      url(size: $largeMediaSize, format: $imagesFormat)
      id
    }
    ...EyewearAttributes
  }
}
    `;
export const StrapAttributesFragmentDoc = gql`
    fragment StrapAttributes on Product {
  otherSizesSkus: attribute(slug: "wbr-other-sizes") {
    ...MultiselectAttribute
  }
  integratedBuckle: attribute(slug: "wbr-integrated-buckle") {
    ...BoolAttribute
  }
  lugSize: attribute(slug: "wbr-lug-size") {
    ...DropdownAttribute
  }
  strapMaterial: attribute(slug: "wbr-material-mktg") {
    ...DropdownAttribute
  }
  color: attribute(slug: "wbr-color") {
    ...DropdownAttribute
  }
  lug: attribute(slug: "wbr-distance-between-horns") {
    ...DropdownAttribute
  }
  lugType: attribute(slug: "wbr-bar-shape") {
    ...DropdownAttribute
  }
  buckleType: attribute(slug: "wbr-s-buckle-type") {
    ...DropdownAttribute
  }
  compatibleBuckles: attribute(slug: "wbr-compatible-buckles") {
    ...MultiselectAttribute
  }
  marketingDescription: attribute(slug: "wbr-description-mktg") {
    ...DropdownAttribute
  }
}
    `;
export const ProductVariantStrapBasicDetailsFragmentDoc = gql`
    fragment ProductVariantStrapBasicDetails on ProductVariant {
  id
  sku
  product {
    ...ProductUrlBase
    id
    name
    slug
    description
    translation(languageCode: $languageCode) {
      description
      name
    }
    thumbnail(size: $thumbnailSize, format: $imagesFormat) {
      ...Image
    }
    media {
      ...ProductMediaFragment
    }
    mediaLarge: media {
      url(size: $largeMediaSize, format: $imagesFormat)
      id
    }
    ...StrapAttributes
  }
}
    `;
export const ProductVariantStrapDetailsFragmentDoc = gql`
    fragment ProductVariantStrapDetails on ProductVariant {
  translation(languageCode: $languageCode) {
    id
    name
  }
  quantityAvailable
  pricing {
    price {
      ...TaxedMoney
    }
  }
  product {
    ...StrapAttributes
  }
}
    `;
export const ProductVariantStrapSkuFragmentDoc = gql`
    fragment ProductVariantStrapSku on ProductVariant {
  id
  sku
  product {
    ...ProductUrlBase
    id
    name
    slug
    description
    translation(languageCode: $languageCode) {
      description
      name
    }
    defaultVariant {
      sku
      id
      quantityAvailable
      pricing {
        ...VariantPricing
      }
    }
    thumbnail(size: $thumbnailSize, format: $imagesFormat) {
      ...Image
    }
    media {
      ...ProductMediaFragment
    }
    mediaLarge: media {
      url(size: $largeMediaSize, format: $imagesFormat)
      id
    }
  }
}
    `;
export const ProductVariantWatchBasicDetailsFragmentDoc = gql`
    fragment ProductVariantWatchBasicDetails on ProductVariant {
  id
  sku
  pricing {
    price {
      ...TaxedMoney
    }
  }
  product {
    ...ProductUrlBase
    id
    name
    slug
    description
    translation(languageCode: $languageCode) {
      description
      name
    }
    media {
      ...ProductMediaFragment
    }
    mediaLarge: media {
      url(size: $largeMediaSize, format: $imagesFormat)
      id
    }
    specificText: attribute(slug: "com-specific-text") {
      ...MultiselectAttribute
    }
    relatedProducts: attribute(slug: "com-related-products") {
      ...MultiselectAttribute
    }
    compatibleStraps: attribute(slug: "wmf-compatible-straps") {
      ...MultiselectAttribute
    }
    manualUrl: attribute(slug: "manual-url") {
      ...DropdownAttribute
    }
    ...WatchAttributes
    pricing {
      displayGrossPrices
    }
    thumbnail(size: $thumbnailSize, format: $imagesFormat) {
      ...Image
    }
  }
  metadata {
    key
    value
  }
}
    `;
export const ProductVariantWatchDetailsFragmentDoc = gql`
    fragment ProductVariantWatchDetails on ProductVariant {
  id
  name
  translation(languageCode: $languageCode) {
    id
    name
  }
  quantityAvailable
  pricing {
    price {
      ...TaxedMoney
    }
  }
  product {
    id
    ...WatchAttributes
    pricing {
      displayGrossPrices
    }
    media {
      strapPreviewCoordinates: metafield(key: "asset.strap_preview_coordinates")
    }
  }
}
    `;
export const ProductVariantWatchSkuFragmentDoc = gql`
    fragment ProductVariantWatchSku on ProductVariant {
  id
  sku
  product {
    ...ProductUrlBase
    id
    name
    slug
    description
    translation(languageCode: $languageCode) {
      description
      name
    }
    defaultVariant {
      sku
      id
      quantityAvailable
      pricing {
        ...VariantPricing
      }
    }
    media {
      ...ProductMediaFragment
    }
    mediaLarge: media {
      url(size: $largeMediaSize, format: $imagesFormat)
      id
    }
    thumbnail(size: $thumbnailSize, format: $imagesFormat) {
      ...Image
    }
    relatedProducts: attribute(slug: "com-related-products") {
      ...MultiselectAttribute
    }
    compatibleStraps: attribute(slug: "wmf-compatible-straps") {
      ...MultiselectAttribute
    }
    ...WatchAttributes
  }
}
    `;
export const ProductVariantsBySkusFragmentDoc = gql`
    fragment ProductVariantsBySkus on ProductVariant {
  id
  name
  translation(languageCode: $languageCode) {
    id
    name
  }
  quantityAvailable
  pricing {
    price {
      ...TaxedMoney
    }
  }
  product {
    id
    productType {
      name
      slug
    }
    ...WatchAttributes
  }
}
    `;
export const SelectedAttributeDetailsFragmentDoc = gql`
    fragment SelectedAttributeDetailsFragment on SelectedAttribute {
  attribute {
    id
    name
    translation(languageCode: $locale) {
      id
      name
    }
    type
    unit
  }
  values {
    id
    name
    translation(languageCode: $locale) {
      id
      name
      richText
    }
    value
  }
}
    `;
export const ShoppingBagProductFragmentDoc = gql`
    fragment ShoppingBagProduct on ProductVariant {
  id
  sku
  product {
    ...LineProduct
  }
}
    `;
export const ShoppingBagStrapsModalFragmentDoc = gql`
    fragment ShoppingBagStrapsModal on ProductVariant {
  id
  sku
  pricing {
    price {
      ...TaxedMoney
    }
  }
  product {
    id
    translation(languageCode: $languageCode) {
      name
    }
    name
    compatibleBuckles: attribute(slug: "wbr-compatible-buckles") {
      ...MultiselectAttribute
    }
    integratedBuckle: attribute(slug: "wbr-integrated-buckle") {
      ...BoolAttribute
    }
    otherSizesSkus: attribute(slug: "wbr-other-sizes") {
      ...MultiselectAttribute
    }
    strapName: attribute(slug: "wbr-name-mktg") {
      ...MultiselectAttribute
    }
    warrantyName: attribute(slug: "com-warranty-name") {
      ...MultiselectAttribute
    }
    toolName: attribute(slug: "com-tool-name") {
      ...MultiselectAttribute
    }
    ...ProductThumbnailFragment
    ...ProductType
  }
}
    `;
export const TransactionInitializeErrorFragmentDoc = gql`
    fragment TransactionInitializeError on TransactionInitializeError {
  field
  message
  code
}
    `;
export const TransactionEventFragmentDoc = gql`
    fragment TransactionEvent on TransactionEvent {
  type
  createdAt
  pspReference
  message
  amount {
    amount
    currency
  }
}
    `;
export const TransactionItemFragmentDoc = gql`
    fragment TransactionItem on TransactionItem {
  id
  paymentData: metafield(key: "ADYEN_APP.PAYMENT_DATA")
  paymentMethod: metafield(key: "transaction.payment_method")
  forGiftPaymentData: metafield(key: "4GIFT.PAYMENT_DATA")
  oricoFinancingAppPaymentData: metafield(key: "ORICO_FINANCING_APP.PAYMENT_DATA")
  genericPaymentData: metafield(key: "transaction.payment_data")
  authorizedAmount {
    ...Money
  }
  chargedAmount {
    ...Money
  }
  chargePendingAmount {
    ...Money
  }
  events {
    ...TransactionEvent
  }
}
    `;
export const TransactionProcessErrorFragmentDoc = gql`
    fragment TransactionProcessError on TransactionProcessError {
  field
  message
  code
}
    `;
export const UserFragmentDoc = gql`
    fragment User on User {
  id
  email
  firstName
  lastName
  metadata {
    ...MetadataItem
  }
  addresses {
    ...Address
  }
  defaultBillingAddress {
    ...Address
  }
  defaultShippingAddress {
    ...Address
  }
  checkout {
    id
    channel {
      slug
    }
  }
}
    `;
export const WatchBasicDetailsForSkusFragmentDoc = gql`
    fragment WatchBasicDetailsForSkus on ProductVariant {
  sku
  product {
    name
    thumbnail(size: $thumbnailSize, format: $imagesFormat) {
      ...Image
    }
  }
}
    `;
export const WatchLineAttributesFragmentDoc = gql`
    fragment WatchLineAttributes on Product {
  caseMaterial: attribute(slug: "wca-material-mktg") {
    ...DropdownAttribute
  }
  dialColor: attribute(slug: "wdi-color-of-dial") {
    ...DropdownAttribute
  }
}
    `;
export const AccountAddressCreateDocument = gql`
    mutation AccountAddressCreate($input: AddressInput!, $type: AddressTypeEnum) {
  accountAddressCreate(input: $input, type: $type) {
    user {
      ...User
    }
    address {
      ...Address
    }
    errors {
      ...AccountError
    }
  }
}
    ${UserFragmentDoc}
${MetadataItemFragmentDoc}
${AddressFragmentDoc}
${AccountErrorFragmentDoc}`;
export type AccountAddressCreateMutationFn = Apollo.MutationFunction<AccountAddressCreateMutation, AccountAddressCreateMutationVariables>;

/**
 * __useAccountAddressCreateMutation__
 *
 * To run a mutation, you first call `useAccountAddressCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccountAddressCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accountAddressCreateMutation, { data, loading, error }] = useAccountAddressCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useAccountAddressCreateMutation(baseOptions?: Apollo.MutationHookOptions<AccountAddressCreateMutation, AccountAddressCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AccountAddressCreateMutation, AccountAddressCreateMutationVariables>(AccountAddressCreateDocument, options);
      }
export type AccountAddressCreateMutationHookResult = ReturnType<typeof useAccountAddressCreateMutation>;
export type AccountAddressCreateMutationResult = Apollo.MutationResult<AccountAddressCreateMutation>;
export type AccountAddressCreateMutationOptions = Apollo.BaseMutationOptions<AccountAddressCreateMutation, AccountAddressCreateMutationVariables>;
export const AddressDeleteDocument = gql`
    mutation AddressDelete($id: ID!) {
  accountAddressDelete(id: $id) {
    user {
      ...User
    }
    address {
      ...Address
    }
    errors {
      ...AccountError
    }
  }
}
    ${UserFragmentDoc}
${MetadataItemFragmentDoc}
${AddressFragmentDoc}
${AccountErrorFragmentDoc}`;
export type AddressDeleteMutationFn = Apollo.MutationFunction<AddressDeleteMutation, AddressDeleteMutationVariables>;

/**
 * __useAddressDeleteMutation__
 *
 * To run a mutation, you first call `useAddressDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddressDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addressDeleteMutation, { data, loading, error }] = useAddressDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAddressDeleteMutation(baseOptions?: Apollo.MutationHookOptions<AddressDeleteMutation, AddressDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddressDeleteMutation, AddressDeleteMutationVariables>(AddressDeleteDocument, options);
      }
export type AddressDeleteMutationHookResult = ReturnType<typeof useAddressDeleteMutation>;
export type AddressDeleteMutationResult = Apollo.MutationResult<AddressDeleteMutation>;
export type AddressDeleteMutationOptions = Apollo.BaseMutationOptions<AddressDeleteMutation, AddressDeleteMutationVariables>;
export const AccountAddressUpdateDocument = gql`
    mutation AccountAddressUpdate($input: AddressInput!, $id: ID!) {
  accountAddressUpdate(input: $input, id: $id) {
    user {
      ...User
    }
    address {
      ...Address
    }
    errors {
      ...AccountError
    }
  }
}
    ${UserFragmentDoc}
${MetadataItemFragmentDoc}
${AddressFragmentDoc}
${AccountErrorFragmentDoc}`;
export type AccountAddressUpdateMutationFn = Apollo.MutationFunction<AccountAddressUpdateMutation, AccountAddressUpdateMutationVariables>;

/**
 * __useAccountAddressUpdateMutation__
 *
 * To run a mutation, you first call `useAccountAddressUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccountAddressUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accountAddressUpdateMutation, { data, loading, error }] = useAccountAddressUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAccountAddressUpdateMutation(baseOptions?: Apollo.MutationHookOptions<AccountAddressUpdateMutation, AccountAddressUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AccountAddressUpdateMutation, AccountAddressUpdateMutationVariables>(AccountAddressUpdateDocument, options);
      }
export type AccountAddressUpdateMutationHookResult = ReturnType<typeof useAccountAddressUpdateMutation>;
export type AccountAddressUpdateMutationResult = Apollo.MutationResult<AccountAddressUpdateMutation>;
export type AccountAddressUpdateMutationOptions = Apollo.BaseMutationOptions<AccountAddressUpdateMutation, AccountAddressUpdateMutationVariables>;
export const AccountConfirmDocument = gql`
    mutation AccountConfirm($email: String!, $token: String!) {
  confirmAccount(email: $email, token: $token) {
    errors {
      field
      message
      code
    }
  }
}
    `;
export type AccountConfirmMutationFn = Apollo.MutationFunction<AccountConfirmMutation, AccountConfirmMutationVariables>;

/**
 * __useAccountConfirmMutation__
 *
 * To run a mutation, you first call `useAccountConfirmMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccountConfirmMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accountConfirmMutation, { data, loading, error }] = useAccountConfirmMutation({
 *   variables: {
 *      email: // value for 'email'
 *      token: // value for 'token'
 *   },
 * });
 */
export function useAccountConfirmMutation(baseOptions?: Apollo.MutationHookOptions<AccountConfirmMutation, AccountConfirmMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AccountConfirmMutation, AccountConfirmMutationVariables>(AccountConfirmDocument, options);
      }
export type AccountConfirmMutationHookResult = ReturnType<typeof useAccountConfirmMutation>;
export type AccountConfirmMutationResult = Apollo.MutationResult<AccountConfirmMutation>;
export type AccountConfirmMutationOptions = Apollo.BaseMutationOptions<AccountConfirmMutation, AccountConfirmMutationVariables>;
export const AccountRegisterDocument = gql`
    mutation AccountRegister($email: String!, $password: String!, $redirectUrl: String!, $channel: String!, $firstName: String, $lastName: String, $metadata: [MetadataInput!]!) {
  accountRegister(
    input: {email: $email, password: $password, redirectUrl: $redirectUrl, channel: $channel, firstName: $firstName, lastName: $lastName, metadata: $metadata}
  ) {
    user {
      ...User
    }
    errors {
      field
      message
      code
    }
  }
}
    ${UserFragmentDoc}
${MetadataItemFragmentDoc}
${AddressFragmentDoc}`;
export type AccountRegisterMutationFn = Apollo.MutationFunction<AccountRegisterMutation, AccountRegisterMutationVariables>;

/**
 * __useAccountRegisterMutation__
 *
 * To run a mutation, you first call `useAccountRegisterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccountRegisterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accountRegisterMutation, { data, loading, error }] = useAccountRegisterMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *      redirectUrl: // value for 'redirectUrl'
 *      channel: // value for 'channel'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      metadata: // value for 'metadata'
 *   },
 * });
 */
export function useAccountRegisterMutation(baseOptions?: Apollo.MutationHookOptions<AccountRegisterMutation, AccountRegisterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AccountRegisterMutation, AccountRegisterMutationVariables>(AccountRegisterDocument, options);
      }
export type AccountRegisterMutationHookResult = ReturnType<typeof useAccountRegisterMutation>;
export type AccountRegisterMutationResult = Apollo.MutationResult<AccountRegisterMutation>;
export type AccountRegisterMutationOptions = Apollo.BaseMutationOptions<AccountRegisterMutation, AccountRegisterMutationVariables>;
export const AccountSetDefaultAddressDocument = gql`
    mutation AccountSetDefaultAddress($id: ID!, $type: AddressTypeEnum!) {
  accountSetDefaultAddress(id: $id, type: $type) {
    user {
      ...User
    }
    errors {
      ...AccountError
    }
  }
}
    ${UserFragmentDoc}
${MetadataItemFragmentDoc}
${AddressFragmentDoc}
${AccountErrorFragmentDoc}`;
export type AccountSetDefaultAddressMutationFn = Apollo.MutationFunction<AccountSetDefaultAddressMutation, AccountSetDefaultAddressMutationVariables>;

/**
 * __useAccountSetDefaultAddressMutation__
 *
 * To run a mutation, you first call `useAccountSetDefaultAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccountSetDefaultAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accountSetDefaultAddressMutation, { data, loading, error }] = useAccountSetDefaultAddressMutation({
 *   variables: {
 *      id: // value for 'id'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useAccountSetDefaultAddressMutation(baseOptions?: Apollo.MutationHookOptions<AccountSetDefaultAddressMutation, AccountSetDefaultAddressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AccountSetDefaultAddressMutation, AccountSetDefaultAddressMutationVariables>(AccountSetDefaultAddressDocument, options);
      }
export type AccountSetDefaultAddressMutationHookResult = ReturnType<typeof useAccountSetDefaultAddressMutation>;
export type AccountSetDefaultAddressMutationResult = Apollo.MutationResult<AccountSetDefaultAddressMutation>;
export type AccountSetDefaultAddressMutationOptions = Apollo.BaseMutationOptions<AccountSetDefaultAddressMutation, AccountSetDefaultAddressMutationVariables>;
export const AccountTokenCreateDocument = gql`
    mutation AccountTokenCreate($email: String!, $password: String!) {
  tokenCreate(email: $email, password: $password) {
    user {
      ...User
    }
    token
    refreshToken
    csrfToken
    errors {
      ...AccountError
    }
  }
}
    ${UserFragmentDoc}
${MetadataItemFragmentDoc}
${AddressFragmentDoc}
${AccountErrorFragmentDoc}`;
export type AccountTokenCreateMutationFn = Apollo.MutationFunction<AccountTokenCreateMutation, AccountTokenCreateMutationVariables>;

/**
 * __useAccountTokenCreateMutation__
 *
 * To run a mutation, you first call `useAccountTokenCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccountTokenCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accountTokenCreateMutation, { data, loading, error }] = useAccountTokenCreateMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useAccountTokenCreateMutation(baseOptions?: Apollo.MutationHookOptions<AccountTokenCreateMutation, AccountTokenCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AccountTokenCreateMutation, AccountTokenCreateMutationVariables>(AccountTokenCreateDocument, options);
      }
export type AccountTokenCreateMutationHookResult = ReturnType<typeof useAccountTokenCreateMutation>;
export type AccountTokenCreateMutationResult = Apollo.MutationResult<AccountTokenCreateMutation>;
export type AccountTokenCreateMutationOptions = Apollo.BaseMutationOptions<AccountTokenCreateMutation, AccountTokenCreateMutationVariables>;
export const AccountTokenVerifyDocument = gql`
    mutation AccountTokenVerify($token: String!) {
  tokenVerify(token: $token) {
    user {
      ...User
    }
    isValid
    errors {
      ...AccountError
    }
  }
}
    ${UserFragmentDoc}
${MetadataItemFragmentDoc}
${AddressFragmentDoc}
${AccountErrorFragmentDoc}`;
export type AccountTokenVerifyMutationFn = Apollo.MutationFunction<AccountTokenVerifyMutation, AccountTokenVerifyMutationVariables>;

/**
 * __useAccountTokenVerifyMutation__
 *
 * To run a mutation, you first call `useAccountTokenVerifyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccountTokenVerifyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accountTokenVerifyMutation, { data, loading, error }] = useAccountTokenVerifyMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useAccountTokenVerifyMutation(baseOptions?: Apollo.MutationHookOptions<AccountTokenVerifyMutation, AccountTokenVerifyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AccountTokenVerifyMutation, AccountTokenVerifyMutationVariables>(AccountTokenVerifyDocument, options);
      }
export type AccountTokenVerifyMutationHookResult = ReturnType<typeof useAccountTokenVerifyMutation>;
export type AccountTokenVerifyMutationResult = Apollo.MutationResult<AccountTokenVerifyMutation>;
export type AccountTokenVerifyMutationOptions = Apollo.BaseMutationOptions<AccountTokenVerifyMutation, AccountTokenVerifyMutationVariables>;
export const AccountUpdateDocument = gql`
    mutation AccountUpdate($input: AccountInput!) {
  accountUpdate(input: $input) {
    user {
      ...User
    }
    errors {
      ...AccountError
    }
  }
}
    ${UserFragmentDoc}
${MetadataItemFragmentDoc}
${AddressFragmentDoc}
${AccountErrorFragmentDoc}`;
export type AccountUpdateMutationFn = Apollo.MutationFunction<AccountUpdateMutation, AccountUpdateMutationVariables>;

/**
 * __useAccountUpdateMutation__
 *
 * To run a mutation, you first call `useAccountUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccountUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accountUpdateMutation, { data, loading, error }] = useAccountUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAccountUpdateMutation(baseOptions?: Apollo.MutationHookOptions<AccountUpdateMutation, AccountUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AccountUpdateMutation, AccountUpdateMutationVariables>(AccountUpdateDocument, options);
      }
export type AccountUpdateMutationHookResult = ReturnType<typeof useAccountUpdateMutation>;
export type AccountUpdateMutationResult = Apollo.MutationResult<AccountUpdateMutation>;
export type AccountUpdateMutationOptions = Apollo.BaseMutationOptions<AccountUpdateMutation, AccountUpdateMutationVariables>;
export const CheckoutBillingAddressUpdateDocument = gql`
    mutation CheckoutBillingAddressUpdate($id: ID!, $address: AddressInput!, $validationRules: CheckoutAddressValidationRules) {
  checkoutBillingAddressUpdate(
    id: $id
    billingAddress: $address
    validationRules: $validationRules
  ) {
    checkout {
      id
      billingAddress {
        ...Address
      }
    }
    errors {
      ...CheckoutError
    }
  }
}
    ${AddressFragmentDoc}
${CheckoutErrorFragmentDoc}`;
export type CheckoutBillingAddressUpdateMutationFn = Apollo.MutationFunction<CheckoutBillingAddressUpdateMutation, CheckoutBillingAddressUpdateMutationVariables>;

/**
 * __useCheckoutBillingAddressUpdateMutation__
 *
 * To run a mutation, you first call `useCheckoutBillingAddressUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCheckoutBillingAddressUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [checkoutBillingAddressUpdateMutation, { data, loading, error }] = useCheckoutBillingAddressUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      address: // value for 'address'
 *      validationRules: // value for 'validationRules'
 *   },
 * });
 */
export function useCheckoutBillingAddressUpdateMutation(baseOptions?: Apollo.MutationHookOptions<CheckoutBillingAddressUpdateMutation, CheckoutBillingAddressUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CheckoutBillingAddressUpdateMutation, CheckoutBillingAddressUpdateMutationVariables>(CheckoutBillingAddressUpdateDocument, options);
      }
export type CheckoutBillingAddressUpdateMutationHookResult = ReturnType<typeof useCheckoutBillingAddressUpdateMutation>;
export type CheckoutBillingAddressUpdateMutationResult = Apollo.MutationResult<CheckoutBillingAddressUpdateMutation>;
export type CheckoutBillingAddressUpdateMutationOptions = Apollo.BaseMutationOptions<CheckoutBillingAddressUpdateMutation, CheckoutBillingAddressUpdateMutationVariables>;
export const CheckoutCustomerAttachDocument = gql`
    mutation CheckoutCustomerAttach($id: ID!, $customerId: ID) {
  checkoutCustomerAttach(checkoutId: $id, customerId: $customerId) {
    checkout {
      ...CheckoutBare
    }
    errors {
      ...CheckoutError
    }
  }
}
    ${CheckoutBareFragmentDoc}
${CheckoutErrorFragmentDoc}`;
export type CheckoutCustomerAttachMutationFn = Apollo.MutationFunction<CheckoutCustomerAttachMutation, CheckoutCustomerAttachMutationVariables>;

/**
 * __useCheckoutCustomerAttachMutation__
 *
 * To run a mutation, you first call `useCheckoutCustomerAttachMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCheckoutCustomerAttachMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [checkoutCustomerAttachMutation, { data, loading, error }] = useCheckoutCustomerAttachMutation({
 *   variables: {
 *      id: // value for 'id'
 *      customerId: // value for 'customerId'
 *   },
 * });
 */
export function useCheckoutCustomerAttachMutation(baseOptions?: Apollo.MutationHookOptions<CheckoutCustomerAttachMutation, CheckoutCustomerAttachMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CheckoutCustomerAttachMutation, CheckoutCustomerAttachMutationVariables>(CheckoutCustomerAttachDocument, options);
      }
export type CheckoutCustomerAttachMutationHookResult = ReturnType<typeof useCheckoutCustomerAttachMutation>;
export type CheckoutCustomerAttachMutationResult = Apollo.MutationResult<CheckoutCustomerAttachMutation>;
export type CheckoutCustomerAttachMutationOptions = Apollo.BaseMutationOptions<CheckoutCustomerAttachMutation, CheckoutCustomerAttachMutationVariables>;
export const CheckoutDeliveryMethodUpdateDocument = gql`
    mutation CheckoutDeliveryMethodUpdate($id: ID!, $deliveryMethodId: ID!, $languageCode: LanguageCodeEnum!, $imagesFormat: ThumbnailFormatEnum!, $thumbnailSize: Int!) {
  checkoutDeliveryMethodUpdate(id: $id, deliveryMethodId: $deliveryMethodId) {
    checkout {
      ...Checkout
    }
    errors {
      ...CheckoutError
    }
  }
}
    ${CheckoutFragmentDoc}
${CheckoutBaseFragmentDoc}
${CheckoutBareFragmentDoc}
${TaxedMoneyFragmentDoc}
${MoneyFragmentDoc}
${ChannelFragmentDoc}
${CheckoutLineFragmentDoc}
${MetadataItemFragmentDoc}
${ProductVariantLineFragmentDoc}
${LineProductFragmentDoc}
${VariantPricingFragmentDoc}
${DropdownAttributeFragmentDoc}
${MultiselectAttributeFragmentDoc}
${ProductMediaFragmentDoc}
${BoolAttributeFragmentDoc}
${ProductTypeFragmentDoc}
${ProductThumbnailFragmentDoc}
${ImageFragmentDoc}
${ProductUrlBaseFragmentDoc}
${CheckoutMetadataFragmentDoc}
${GiftMetadataFragmentDoc}
${CustomerTitleMetadataFragmentDoc}
${DeliveryScheduleMetadataFragmentDoc}
${PreorderMetadataFragmentDoc}
${PaymentMethodMetadataFragmentDoc}
${OrderFlowMetadataFragmentDoc}
${AddressFragmentDoc}
${ShippingMethodFragmentDoc}
${WarehouseFragmentDoc}
${DeliveryMethodFragmentDoc}
${CheckoutErrorFragmentDoc}`;
export type CheckoutDeliveryMethodUpdateMutationFn = Apollo.MutationFunction<CheckoutDeliveryMethodUpdateMutation, CheckoutDeliveryMethodUpdateMutationVariables>;

/**
 * __useCheckoutDeliveryMethodUpdateMutation__
 *
 * To run a mutation, you first call `useCheckoutDeliveryMethodUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCheckoutDeliveryMethodUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [checkoutDeliveryMethodUpdateMutation, { data, loading, error }] = useCheckoutDeliveryMethodUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      deliveryMethodId: // value for 'deliveryMethodId'
 *      languageCode: // value for 'languageCode'
 *      imagesFormat: // value for 'imagesFormat'
 *      thumbnailSize: // value for 'thumbnailSize'
 *   },
 * });
 */
export function useCheckoutDeliveryMethodUpdateMutation(baseOptions?: Apollo.MutationHookOptions<CheckoutDeliveryMethodUpdateMutation, CheckoutDeliveryMethodUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CheckoutDeliveryMethodUpdateMutation, CheckoutDeliveryMethodUpdateMutationVariables>(CheckoutDeliveryMethodUpdateDocument, options);
      }
export type CheckoutDeliveryMethodUpdateMutationHookResult = ReturnType<typeof useCheckoutDeliveryMethodUpdateMutation>;
export type CheckoutDeliveryMethodUpdateMutationResult = Apollo.MutationResult<CheckoutDeliveryMethodUpdateMutation>;
export type CheckoutDeliveryMethodUpdateMutationOptions = Apollo.BaseMutationOptions<CheckoutDeliveryMethodUpdateMutation, CheckoutDeliveryMethodUpdateMutationVariables>;
export const CheckoutEmailUpdateDocument = gql`
    mutation CheckoutEmailUpdate($id: ID!, $email: String!) {
  checkoutEmailUpdate(checkoutId: $id, email: $email) {
    checkout {
      ...CheckoutBare
    }
    errors {
      ...CheckoutError
    }
  }
}
    ${CheckoutBareFragmentDoc}
${CheckoutErrorFragmentDoc}`;
export type CheckoutEmailUpdateMutationFn = Apollo.MutationFunction<CheckoutEmailUpdateMutation, CheckoutEmailUpdateMutationVariables>;

/**
 * __useCheckoutEmailUpdateMutation__
 *
 * To run a mutation, you first call `useCheckoutEmailUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCheckoutEmailUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [checkoutEmailUpdateMutation, { data, loading, error }] = useCheckoutEmailUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      email: // value for 'email'
 *   },
 * });
 */
export function useCheckoutEmailUpdateMutation(baseOptions?: Apollo.MutationHookOptions<CheckoutEmailUpdateMutation, CheckoutEmailUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CheckoutEmailUpdateMutation, CheckoutEmailUpdateMutationVariables>(CheckoutEmailUpdateDocument, options);
      }
export type CheckoutEmailUpdateMutationHookResult = ReturnType<typeof useCheckoutEmailUpdateMutation>;
export type CheckoutEmailUpdateMutationResult = Apollo.MutationResult<CheckoutEmailUpdateMutation>;
export type CheckoutEmailUpdateMutationOptions = Apollo.BaseMutationOptions<CheckoutEmailUpdateMutation, CheckoutEmailUpdateMutationVariables>;
export const CheckoutLanguageCodeUpdateDocument = gql`
    mutation CheckoutLanguageCodeUpdate($id: ID!, $languageCode: LanguageCodeEnum!) {
  checkoutLanguageCodeUpdate(id: $id, languageCode: $languageCode) {
    checkout {
      ...CheckoutBare
    }
    errors {
      ...CheckoutError
    }
  }
}
    ${CheckoutBareFragmentDoc}
${CheckoutErrorFragmentDoc}`;
export type CheckoutLanguageCodeUpdateMutationFn = Apollo.MutationFunction<CheckoutLanguageCodeUpdateMutation, CheckoutLanguageCodeUpdateMutationVariables>;

/**
 * __useCheckoutLanguageCodeUpdateMutation__
 *
 * To run a mutation, you first call `useCheckoutLanguageCodeUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCheckoutLanguageCodeUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [checkoutLanguageCodeUpdateMutation, { data, loading, error }] = useCheckoutLanguageCodeUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      languageCode: // value for 'languageCode'
 *   },
 * });
 */
export function useCheckoutLanguageCodeUpdateMutation(baseOptions?: Apollo.MutationHookOptions<CheckoutLanguageCodeUpdateMutation, CheckoutLanguageCodeUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CheckoutLanguageCodeUpdateMutation, CheckoutLanguageCodeUpdateMutationVariables>(CheckoutLanguageCodeUpdateDocument, options);
      }
export type CheckoutLanguageCodeUpdateMutationHookResult = ReturnType<typeof useCheckoutLanguageCodeUpdateMutation>;
export type CheckoutLanguageCodeUpdateMutationResult = Apollo.MutationResult<CheckoutLanguageCodeUpdateMutation>;
export type CheckoutLanguageCodeUpdateMutationOptions = Apollo.BaseMutationOptions<CheckoutLanguageCodeUpdateMutation, CheckoutLanguageCodeUpdateMutationVariables>;
export const CheckoutShippingAddressUpdateDocument = gql`
    mutation CheckoutShippingAddressUpdate($id: ID!, $address: AddressInput!, $languageCode: LanguageCodeEnum!) {
  checkoutShippingAddressUpdate(id: $id, shippingAddress: $address) {
    checkout {
      id
      totalPrice {
        ...TaxedMoney
      }
      totalBalance {
        ...Money
      }
      subtotalPrice {
        ...TaxedMoney
      }
      shippingAddress {
        ...Address
      }
      isShippingRequired
      shippingMethods {
        ...ShippingMethod
      }
      availableCollectionPoints {
        ...Warehouse
      }
      discount {
        ...Money
      }
      discountName
    }
    errors {
      ...CheckoutError
    }
  }
}
    ${TaxedMoneyFragmentDoc}
${MoneyFragmentDoc}
${AddressFragmentDoc}
${ShippingMethodFragmentDoc}
${WarehouseFragmentDoc}
${CheckoutErrorFragmentDoc}`;
export type CheckoutShippingAddressUpdateMutationFn = Apollo.MutationFunction<CheckoutShippingAddressUpdateMutation, CheckoutShippingAddressUpdateMutationVariables>;

/**
 * __useCheckoutShippingAddressUpdateMutation__
 *
 * To run a mutation, you first call `useCheckoutShippingAddressUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCheckoutShippingAddressUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [checkoutShippingAddressUpdateMutation, { data, loading, error }] = useCheckoutShippingAddressUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      address: // value for 'address'
 *      languageCode: // value for 'languageCode'
 *   },
 * });
 */
export function useCheckoutShippingAddressUpdateMutation(baseOptions?: Apollo.MutationHookOptions<CheckoutShippingAddressUpdateMutation, CheckoutShippingAddressUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CheckoutShippingAddressUpdateMutation, CheckoutShippingAddressUpdateMutationVariables>(CheckoutShippingAddressUpdateDocument, options);
      }
export type CheckoutShippingAddressUpdateMutationHookResult = ReturnType<typeof useCheckoutShippingAddressUpdateMutation>;
export type CheckoutShippingAddressUpdateMutationResult = Apollo.MutationResult<CheckoutShippingAddressUpdateMutation>;
export type CheckoutShippingAddressUpdateMutationOptions = Apollo.BaseMutationOptions<CheckoutShippingAddressUpdateMutation, CheckoutShippingAddressUpdateMutationVariables>;
export const ConfirmEmailChangeDocument = gql`
    mutation ConfirmEmailChange($token: String!, $channel: String) {
  confirmEmailChange(token: $token, channel: $channel) {
    user {
      ...User
    }
    errors {
      ...AccountError
    }
  }
}
    ${UserFragmentDoc}
${MetadataItemFragmentDoc}
${AddressFragmentDoc}
${AccountErrorFragmentDoc}`;
export type ConfirmEmailChangeMutationFn = Apollo.MutationFunction<ConfirmEmailChangeMutation, ConfirmEmailChangeMutationVariables>;

/**
 * __useConfirmEmailChangeMutation__
 *
 * To run a mutation, you first call `useConfirmEmailChangeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmEmailChangeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmEmailChangeMutation, { data, loading, error }] = useConfirmEmailChangeMutation({
 *   variables: {
 *      token: // value for 'token'
 *      channel: // value for 'channel'
 *   },
 * });
 */
export function useConfirmEmailChangeMutation(baseOptions?: Apollo.MutationHookOptions<ConfirmEmailChangeMutation, ConfirmEmailChangeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConfirmEmailChangeMutation, ConfirmEmailChangeMutationVariables>(ConfirmEmailChangeDocument, options);
      }
export type ConfirmEmailChangeMutationHookResult = ReturnType<typeof useConfirmEmailChangeMutation>;
export type ConfirmEmailChangeMutationResult = Apollo.MutationResult<ConfirmEmailChangeMutation>;
export type ConfirmEmailChangeMutationOptions = Apollo.BaseMutationOptions<ConfirmEmailChangeMutation, ConfirmEmailChangeMutationVariables>;
export const CustomerCreateDocument = gql`
    mutation CustomerCreate($input: UserCreateInput!) {
  customerCreate(input: $input) {
    user {
      id
      isActive
      email
    }
    errors {
      ...AccountError
    }
  }
}
    ${AccountErrorFragmentDoc}`;
export type CustomerCreateMutationFn = Apollo.MutationFunction<CustomerCreateMutation, CustomerCreateMutationVariables>;

/**
 * __useCustomerCreateMutation__
 *
 * To run a mutation, you first call `useCustomerCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomerCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customerCreateMutation, { data, loading, error }] = useCustomerCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCustomerCreateMutation(baseOptions?: Apollo.MutationHookOptions<CustomerCreateMutation, CustomerCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CustomerCreateMutation, CustomerCreateMutationVariables>(CustomerCreateDocument, options);
      }
export type CustomerCreateMutationHookResult = ReturnType<typeof useCustomerCreateMutation>;
export type CustomerCreateMutationResult = Apollo.MutationResult<CustomerCreateMutation>;
export type CustomerCreateMutationOptions = Apollo.BaseMutationOptions<CustomerCreateMutation, CustomerCreateMutationVariables>;
export const CustomerUpdateDocument = gql`
    mutation CustomerUpdate($id: ID!, $input: CustomerInput!) {
  customerUpdate(id: $id, input: $input) {
    user {
      id
      isActive
      email
    }
    errors {
      ...AccountError
    }
  }
}
    ${AccountErrorFragmentDoc}`;
export type CustomerUpdateMutationFn = Apollo.MutationFunction<CustomerUpdateMutation, CustomerUpdateMutationVariables>;

/**
 * __useCustomerUpdateMutation__
 *
 * To run a mutation, you first call `useCustomerUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomerUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customerUpdateMutation, { data, loading, error }] = useCustomerUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCustomerUpdateMutation(baseOptions?: Apollo.MutationHookOptions<CustomerUpdateMutation, CustomerUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CustomerUpdateMutation, CustomerUpdateMutationVariables>(CustomerUpdateDocument, options);
      }
export type CustomerUpdateMutationHookResult = ReturnType<typeof useCustomerUpdateMutation>;
export type CustomerUpdateMutationResult = Apollo.MutationResult<CustomerUpdateMutation>;
export type CustomerUpdateMutationOptions = Apollo.BaseMutationOptions<CustomerUpdateMutation, CustomerUpdateMutationVariables>;
export const OrderUpdateDocument = gql`
    mutation OrderUpdate($externalReference: String, $id: ID, $input: OrderUpdateInput!) {
  orderUpdate(externalReference: $externalReference, id: $id, input: $input) {
    order {
      id
      userEmail
      isShippingRequired
      subtotal {
        ...TaxedMoney
      }
      shippingPrice {
        ...TaxedMoney
      }
      total {
        ...TaxedMoney
      }
      channel {
        ...Channel
      }
      totalBalance {
        ...Money
      }
      totalCharged {
        ...Money
      }
      totalAuthorized {
        ...Money
      }
      shippingAddress {
        ...Address
      }
      billingAddress {
        ...Address
      }
    }
    errors {
      ...OrderError
    }
  }
}
    ${TaxedMoneyFragmentDoc}
${MoneyFragmentDoc}
${ChannelFragmentDoc}
${AddressFragmentDoc}
${OrderErrorFragmentDoc}`;
export type OrderUpdateMutationFn = Apollo.MutationFunction<OrderUpdateMutation, OrderUpdateMutationVariables>;

/**
 * __useOrderUpdateMutation__
 *
 * To run a mutation, you first call `useOrderUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrderUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [orderUpdateMutation, { data, loading, error }] = useOrderUpdateMutation({
 *   variables: {
 *      externalReference: // value for 'externalReference'
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOrderUpdateMutation(baseOptions?: Apollo.MutationHookOptions<OrderUpdateMutation, OrderUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrderUpdateMutation, OrderUpdateMutationVariables>(OrderUpdateDocument, options);
      }
export type OrderUpdateMutationHookResult = ReturnType<typeof useOrderUpdateMutation>;
export type OrderUpdateMutationResult = Apollo.MutationResult<OrderUpdateMutation>;
export type OrderUpdateMutationOptions = Apollo.BaseMutationOptions<OrderUpdateMutation, OrderUpdateMutationVariables>;
export const PasswordChangeDocument = gql`
    mutation PasswordChange($oldPassword: String!, $newPassword: String!) {
  passwordChange(oldPassword: $oldPassword, newPassword: $newPassword) {
    user {
      ...User
    }
    errors {
      ...AccountError
    }
  }
}
    ${UserFragmentDoc}
${MetadataItemFragmentDoc}
${AddressFragmentDoc}
${AccountErrorFragmentDoc}`;
export type PasswordChangeMutationFn = Apollo.MutationFunction<PasswordChangeMutation, PasswordChangeMutationVariables>;

/**
 * __usePasswordChangeMutation__
 *
 * To run a mutation, you first call `usePasswordChangeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePasswordChangeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [passwordChangeMutation, { data, loading, error }] = usePasswordChangeMutation({
 *   variables: {
 *      oldPassword: // value for 'oldPassword'
 *      newPassword: // value for 'newPassword'
 *   },
 * });
 */
export function usePasswordChangeMutation(baseOptions?: Apollo.MutationHookOptions<PasswordChangeMutation, PasswordChangeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PasswordChangeMutation, PasswordChangeMutationVariables>(PasswordChangeDocument, options);
      }
export type PasswordChangeMutationHookResult = ReturnType<typeof usePasswordChangeMutation>;
export type PasswordChangeMutationResult = Apollo.MutationResult<PasswordChangeMutation>;
export type PasswordChangeMutationOptions = Apollo.BaseMutationOptions<PasswordChangeMutation, PasswordChangeMutationVariables>;
export const PaymentGatewayInitializeDocument = gql`
    mutation PaymentGatewayInitialize($id: ID!, $amount: PositiveDecimal!, $paymentGateways: [PaymentGatewayToInitialize!]) {
  paymentGatewayInitialize(
    id: $id
    amount: $amount
    paymentGateways: $paymentGateways
  ) {
    gatewayConfigs {
      ...PaymentGatewayConfig
    }
    errors {
      ...PaymentGatewayInitializeError
    }
  }
}
    ${PaymentGatewayConfigFragmentDoc}
${PaymentGatewayConfigErrorFragmentDoc}
${PaymentGatewayInitializeErrorFragmentDoc}`;
export type PaymentGatewayInitializeMutationFn = Apollo.MutationFunction<PaymentGatewayInitializeMutation, PaymentGatewayInitializeMutationVariables>;

/**
 * __usePaymentGatewayInitializeMutation__
 *
 * To run a mutation, you first call `usePaymentGatewayInitializeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePaymentGatewayInitializeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [paymentGatewayInitializeMutation, { data, loading, error }] = usePaymentGatewayInitializeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      amount: // value for 'amount'
 *      paymentGateways: // value for 'paymentGateways'
 *   },
 * });
 */
export function usePaymentGatewayInitializeMutation(baseOptions?: Apollo.MutationHookOptions<PaymentGatewayInitializeMutation, PaymentGatewayInitializeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PaymentGatewayInitializeMutation, PaymentGatewayInitializeMutationVariables>(PaymentGatewayInitializeDocument, options);
      }
export type PaymentGatewayInitializeMutationHookResult = ReturnType<typeof usePaymentGatewayInitializeMutation>;
export type PaymentGatewayInitializeMutationResult = Apollo.MutationResult<PaymentGatewayInitializeMutation>;
export type PaymentGatewayInitializeMutationOptions = Apollo.BaseMutationOptions<PaymentGatewayInitializeMutation, PaymentGatewayInitializeMutationVariables>;
export const RequestEmailChangeDocument = gql`
    mutation RequestEmailChange($newEmail: String!, $password: String!, $redirectUrl: String!, $channel: String) {
  requestEmailChange(
    newEmail: $newEmail
    password: $password
    redirectUrl: $redirectUrl
    channel: $channel
  ) {
    user {
      ...User
    }
    errors {
      ...AccountError
    }
  }
}
    ${UserFragmentDoc}
${MetadataItemFragmentDoc}
${AddressFragmentDoc}
${AccountErrorFragmentDoc}`;
export type RequestEmailChangeMutationFn = Apollo.MutationFunction<RequestEmailChangeMutation, RequestEmailChangeMutationVariables>;

/**
 * __useRequestEmailChangeMutation__
 *
 * To run a mutation, you first call `useRequestEmailChangeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestEmailChangeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestEmailChangeMutation, { data, loading, error }] = useRequestEmailChangeMutation({
 *   variables: {
 *      newEmail: // value for 'newEmail'
 *      password: // value for 'password'
 *      redirectUrl: // value for 'redirectUrl'
 *      channel: // value for 'channel'
 *   },
 * });
 */
export function useRequestEmailChangeMutation(baseOptions?: Apollo.MutationHookOptions<RequestEmailChangeMutation, RequestEmailChangeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestEmailChangeMutation, RequestEmailChangeMutationVariables>(RequestEmailChangeDocument, options);
      }
export type RequestEmailChangeMutationHookResult = ReturnType<typeof useRequestEmailChangeMutation>;
export type RequestEmailChangeMutationResult = Apollo.MutationResult<RequestEmailChangeMutation>;
export type RequestEmailChangeMutationOptions = Apollo.BaseMutationOptions<RequestEmailChangeMutation, RequestEmailChangeMutationVariables>;
export const RequestPasswordResetDocument = gql`
    mutation RequestPasswordReset($email: String!, $redirectUrl: String!, $channel: String!) {
  requestPasswordReset(
    email: $email
    redirectUrl: $redirectUrl
    channel: $channel
  ) {
    errors {
      ...AccountError
    }
  }
}
    ${AccountErrorFragmentDoc}`;
export type RequestPasswordResetMutationFn = Apollo.MutationFunction<RequestPasswordResetMutation, RequestPasswordResetMutationVariables>;

/**
 * __useRequestPasswordResetMutation__
 *
 * To run a mutation, you first call `useRequestPasswordResetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestPasswordResetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestPasswordResetMutation, { data, loading, error }] = useRequestPasswordResetMutation({
 *   variables: {
 *      email: // value for 'email'
 *      redirectUrl: // value for 'redirectUrl'
 *      channel: // value for 'channel'
 *   },
 * });
 */
export function useRequestPasswordResetMutation(baseOptions?: Apollo.MutationHookOptions<RequestPasswordResetMutation, RequestPasswordResetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestPasswordResetMutation, RequestPasswordResetMutationVariables>(RequestPasswordResetDocument, options);
      }
export type RequestPasswordResetMutationHookResult = ReturnType<typeof useRequestPasswordResetMutation>;
export type RequestPasswordResetMutationResult = Apollo.MutationResult<RequestPasswordResetMutation>;
export type RequestPasswordResetMutationOptions = Apollo.BaseMutationOptions<RequestPasswordResetMutation, RequestPasswordResetMutationVariables>;
export const SetPasswordDocument = gql`
    mutation SetPassword($password: String!, $email: String!, $token: String!) {
  setPassword(password: $password, email: $email, token: $token) {
    errors {
      ...AccountError
    }
  }
}
    ${AccountErrorFragmentDoc}`;
export type SetPasswordMutationFn = Apollo.MutationFunction<SetPasswordMutation, SetPasswordMutationVariables>;

/**
 * __useSetPasswordMutation__
 *
 * To run a mutation, you first call `useSetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setPasswordMutation, { data, loading, error }] = useSetPasswordMutation({
 *   variables: {
 *      password: // value for 'password'
 *      email: // value for 'email'
 *      token: // value for 'token'
 *   },
 * });
 */
export function useSetPasswordMutation(baseOptions?: Apollo.MutationHookOptions<SetPasswordMutation, SetPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetPasswordMutation, SetPasswordMutationVariables>(SetPasswordDocument, options);
      }
export type SetPasswordMutationHookResult = ReturnType<typeof useSetPasswordMutation>;
export type SetPasswordMutationResult = Apollo.MutationResult<SetPasswordMutation>;
export type SetPasswordMutationOptions = Apollo.BaseMutationOptions<SetPasswordMutation, SetPasswordMutationVariables>;
export const SocialClubConsentUpdateDocument = gql`
    mutation SocialClubConsentUpdate($id: ID!, $input: [MetadataInput!]!) {
  updateMetadata(id: $id, input: $input) {
    errors {
      code
      field
      message
    }
    item {
      metadata {
        ...MetadataItem
      }
    }
  }
}
    ${MetadataItemFragmentDoc}`;
export type SocialClubConsentUpdateMutationFn = Apollo.MutationFunction<SocialClubConsentUpdateMutation, SocialClubConsentUpdateMutationVariables>;

/**
 * __useSocialClubConsentUpdateMutation__
 *
 * To run a mutation, you first call `useSocialClubConsentUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSocialClubConsentUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [socialClubConsentUpdateMutation, { data, loading, error }] = useSocialClubConsentUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSocialClubConsentUpdateMutation(baseOptions?: Apollo.MutationHookOptions<SocialClubConsentUpdateMutation, SocialClubConsentUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SocialClubConsentUpdateMutation, SocialClubConsentUpdateMutationVariables>(SocialClubConsentUpdateDocument, options);
      }
export type SocialClubConsentUpdateMutationHookResult = ReturnType<typeof useSocialClubConsentUpdateMutation>;
export type SocialClubConsentUpdateMutationResult = Apollo.MutationResult<SocialClubConsentUpdateMutation>;
export type SocialClubConsentUpdateMutationOptions = Apollo.BaseMutationOptions<SocialClubConsentUpdateMutation, SocialClubConsentUpdateMutationVariables>;
export const TransactionInitializeDocument = gql`
    mutation TransactionInitialize($data: JSON!, $amount: PositiveDecimal!, $id: ID!, $gatewayId: String!) {
  transactionInitialize(
    amount: $amount
    id: $id
    paymentGateway: {id: $gatewayId, data: $data}
  ) {
    transaction {
      ...TransactionItem
    }
    data
    errors {
      ...TransactionInitializeError
    }
  }
}
    ${TransactionItemFragmentDoc}
${MoneyFragmentDoc}
${TransactionEventFragmentDoc}
${TransactionInitializeErrorFragmentDoc}`;
export type TransactionInitializeMutationFn = Apollo.MutationFunction<TransactionInitializeMutation, TransactionInitializeMutationVariables>;

/**
 * __useTransactionInitializeMutation__
 *
 * To run a mutation, you first call `useTransactionInitializeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTransactionInitializeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [transactionInitializeMutation, { data, loading, error }] = useTransactionInitializeMutation({
 *   variables: {
 *      data: // value for 'data'
 *      amount: // value for 'amount'
 *      id: // value for 'id'
 *      gatewayId: // value for 'gatewayId'
 *   },
 * });
 */
export function useTransactionInitializeMutation(baseOptions?: Apollo.MutationHookOptions<TransactionInitializeMutation, TransactionInitializeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TransactionInitializeMutation, TransactionInitializeMutationVariables>(TransactionInitializeDocument, options);
      }
export type TransactionInitializeMutationHookResult = ReturnType<typeof useTransactionInitializeMutation>;
export type TransactionInitializeMutationResult = Apollo.MutationResult<TransactionInitializeMutation>;
export type TransactionInitializeMutationOptions = Apollo.BaseMutationOptions<TransactionInitializeMutation, TransactionInitializeMutationVariables>;
export const TransactionProcessDocument = gql`
    mutation TransactionProcess($data: JSON!, $id: ID!) {
  transactionProcess(id: $id, data: $data) {
    transaction {
      ...TransactionItem
    }
    data
    errors {
      ...TransactionProcessError
    }
  }
}
    ${TransactionItemFragmentDoc}
${MoneyFragmentDoc}
${TransactionEventFragmentDoc}
${TransactionProcessErrorFragmentDoc}`;
export type TransactionProcessMutationFn = Apollo.MutationFunction<TransactionProcessMutation, TransactionProcessMutationVariables>;

/**
 * __useTransactionProcessMutation__
 *
 * To run a mutation, you first call `useTransactionProcessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTransactionProcessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [transactionProcessMutation, { data, loading, error }] = useTransactionProcessMutation({
 *   variables: {
 *      data: // value for 'data'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTransactionProcessMutation(baseOptions?: Apollo.MutationHookOptions<TransactionProcessMutation, TransactionProcessMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TransactionProcessMutation, TransactionProcessMutationVariables>(TransactionProcessDocument, options);
      }
export type TransactionProcessMutationHookResult = ReturnType<typeof useTransactionProcessMutation>;
export type TransactionProcessMutationResult = Apollo.MutationResult<TransactionProcessMutation>;
export type TransactionProcessMutationOptions = Apollo.BaseMutationOptions<TransactionProcessMutation, TransactionProcessMutationVariables>;
export const AddressDocument = gql`
    query Address($id: ID!) {
  address(id: $id) {
    ...Address
  }
}
    ${AddressFragmentDoc}`;

/**
 * __useAddressQuery__
 *
 * To run a query within a React component, call `useAddressQuery` and pass it any options that fit your needs.
 * When your component renders, `useAddressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAddressQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAddressQuery(baseOptions: Apollo.QueryHookOptions<AddressQuery, AddressQueryVariables> & ({ variables: AddressQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AddressQuery, AddressQueryVariables>(AddressDocument, options);
      }
export function useAddressLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AddressQuery, AddressQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AddressQuery, AddressQueryVariables>(AddressDocument, options);
        }
export function useAddressSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AddressQuery, AddressQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AddressQuery, AddressQueryVariables>(AddressDocument, options);
        }
export type AddressQueryHookResult = ReturnType<typeof useAddressQuery>;
export type AddressLazyQueryHookResult = ReturnType<typeof useAddressLazyQuery>;
export type AddressSuspenseQueryHookResult = ReturnType<typeof useAddressSuspenseQuery>;
export type AddressQueryResult = Apollo.QueryResult<AddressQuery, AddressQueryVariables>;
export const AddressValidationRulesDocument = gql`
    query AddressValidationRules($countryCode: CountryCode!) {
  addressValidationRules(countryCode: $countryCode) {
    ...AddressValidationData
  }
}
    ${AddressValidationDataFragmentDoc}
${ChoiceValueFragmentDoc}`;

/**
 * __useAddressValidationRulesQuery__
 *
 * To run a query within a React component, call `useAddressValidationRulesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAddressValidationRulesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAddressValidationRulesQuery({
 *   variables: {
 *      countryCode: // value for 'countryCode'
 *   },
 * });
 */
export function useAddressValidationRulesQuery(baseOptions: Apollo.QueryHookOptions<AddressValidationRulesQuery, AddressValidationRulesQueryVariables> & ({ variables: AddressValidationRulesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AddressValidationRulesQuery, AddressValidationRulesQueryVariables>(AddressValidationRulesDocument, options);
      }
export function useAddressValidationRulesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AddressValidationRulesQuery, AddressValidationRulesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AddressValidationRulesQuery, AddressValidationRulesQueryVariables>(AddressValidationRulesDocument, options);
        }
export function useAddressValidationRulesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AddressValidationRulesQuery, AddressValidationRulesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AddressValidationRulesQuery, AddressValidationRulesQueryVariables>(AddressValidationRulesDocument, options);
        }
export type AddressValidationRulesQueryHookResult = ReturnType<typeof useAddressValidationRulesQuery>;
export type AddressValidationRulesLazyQueryHookResult = ReturnType<typeof useAddressValidationRulesLazyQuery>;
export type AddressValidationRulesSuspenseQueryHookResult = ReturnType<typeof useAddressValidationRulesSuspenseQuery>;
export type AddressValidationRulesQueryResult = Apollo.QueryResult<AddressValidationRulesQuery, AddressValidationRulesQueryVariables>;
export const CategoryPathsDocument = gql`
    query CategoryPaths($after: String) {
  categories(first: 100, after: $after) {
    pageInfo {
      ...PageInfoFragment
    }
    edges {
      node {
        slug
        id
      }
    }
  }
}
    ${PageInfoFragmentDoc}`;

/**
 * __useCategoryPathsQuery__
 *
 * To run a query within a React component, call `useCategoryPathsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCategoryPathsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCategoryPathsQuery({
 *   variables: {
 *      after: // value for 'after'
 *   },
 * });
 */
export function useCategoryPathsQuery(baseOptions?: Apollo.QueryHookOptions<CategoryPathsQuery, CategoryPathsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CategoryPathsQuery, CategoryPathsQueryVariables>(CategoryPathsDocument, options);
      }
export function useCategoryPathsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CategoryPathsQuery, CategoryPathsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CategoryPathsQuery, CategoryPathsQueryVariables>(CategoryPathsDocument, options);
        }
export function useCategoryPathsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CategoryPathsQuery, CategoryPathsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CategoryPathsQuery, CategoryPathsQueryVariables>(CategoryPathsDocument, options);
        }
export type CategoryPathsQueryHookResult = ReturnType<typeof useCategoryPathsQuery>;
export type CategoryPathsLazyQueryHookResult = ReturnType<typeof useCategoryPathsLazyQuery>;
export type CategoryPathsSuspenseQueryHookResult = ReturnType<typeof useCategoryPathsSuspenseQuery>;
export type CategoryPathsQueryResult = Apollo.QueryResult<CategoryPathsQuery, CategoryPathsQueryVariables>;
export const CategorySearchDocument = gql`
    query CategorySearch($first: Int!, $filter: CategoryFilterInput) {
  categories(first: $first, filter: $filter) {
    edges {
      node {
        id
      }
    }
  }
}
    `;

/**
 * __useCategorySearchQuery__
 *
 * To run a query within a React component, call `useCategorySearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useCategorySearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCategorySearchQuery({
 *   variables: {
 *      first: // value for 'first'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useCategorySearchQuery(baseOptions: Apollo.QueryHookOptions<CategorySearchQuery, CategorySearchQueryVariables> & ({ variables: CategorySearchQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CategorySearchQuery, CategorySearchQueryVariables>(CategorySearchDocument, options);
      }
export function useCategorySearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CategorySearchQuery, CategorySearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CategorySearchQuery, CategorySearchQueryVariables>(CategorySearchDocument, options);
        }
export function useCategorySearchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CategorySearchQuery, CategorySearchQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CategorySearchQuery, CategorySearchQueryVariables>(CategorySearchDocument, options);
        }
export type CategorySearchQueryHookResult = ReturnType<typeof useCategorySearchQuery>;
export type CategorySearchLazyQueryHookResult = ReturnType<typeof useCategorySearchLazyQuery>;
export type CategorySearchSuspenseQueryHookResult = ReturnType<typeof useCategorySearchSuspenseQuery>;
export type CategorySearchQueryResult = Apollo.QueryResult<CategorySearchQuery, CategorySearchQueryVariables>;
export const CheckoutDocument = gql`
    query Checkout($id: ID!, $languageCode: LanguageCodeEnum!, $imagesFormat: ThumbnailFormatEnum!, $thumbnailSize: Int!) {
  checkout(id: $id) {
    ...Checkout
  }
}
    ${CheckoutFragmentDoc}
${CheckoutBaseFragmentDoc}
${CheckoutBareFragmentDoc}
${TaxedMoneyFragmentDoc}
${MoneyFragmentDoc}
${ChannelFragmentDoc}
${CheckoutLineFragmentDoc}
${MetadataItemFragmentDoc}
${ProductVariantLineFragmentDoc}
${LineProductFragmentDoc}
${VariantPricingFragmentDoc}
${DropdownAttributeFragmentDoc}
${MultiselectAttributeFragmentDoc}
${ProductMediaFragmentDoc}
${BoolAttributeFragmentDoc}
${ProductTypeFragmentDoc}
${ProductThumbnailFragmentDoc}
${ImageFragmentDoc}
${ProductUrlBaseFragmentDoc}
${CheckoutMetadataFragmentDoc}
${GiftMetadataFragmentDoc}
${CustomerTitleMetadataFragmentDoc}
${DeliveryScheduleMetadataFragmentDoc}
${PreorderMetadataFragmentDoc}
${PaymentMethodMetadataFragmentDoc}
${OrderFlowMetadataFragmentDoc}
${AddressFragmentDoc}
${ShippingMethodFragmentDoc}
${WarehouseFragmentDoc}
${DeliveryMethodFragmentDoc}`;

/**
 * __useCheckoutQuery__
 *
 * To run a query within a React component, call `useCheckoutQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckoutQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckoutQuery({
 *   variables: {
 *      id: // value for 'id'
 *      languageCode: // value for 'languageCode'
 *      imagesFormat: // value for 'imagesFormat'
 *      thumbnailSize: // value for 'thumbnailSize'
 *   },
 * });
 */
export function useCheckoutQuery(baseOptions: Apollo.QueryHookOptions<CheckoutQuery, CheckoutQueryVariables> & ({ variables: CheckoutQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckoutQuery, CheckoutQueryVariables>(CheckoutDocument, options);
      }
export function useCheckoutLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckoutQuery, CheckoutQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckoutQuery, CheckoutQueryVariables>(CheckoutDocument, options);
        }
export function useCheckoutSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CheckoutQuery, CheckoutQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CheckoutQuery, CheckoutQueryVariables>(CheckoutDocument, options);
        }
export type CheckoutQueryHookResult = ReturnType<typeof useCheckoutQuery>;
export type CheckoutLazyQueryHookResult = ReturnType<typeof useCheckoutLazyQuery>;
export type CheckoutSuspenseQueryHookResult = ReturnType<typeof useCheckoutSuspenseQuery>;
export type CheckoutQueryResult = Apollo.QueryResult<CheckoutQuery, CheckoutQueryVariables>;
export const CheckoutBaseDocument = gql`
    query CheckoutBase($id: ID!) {
  checkout(id: $id) {
    id
    email
    user {
      ...User
    }
    billingAddress {
      ...Address
    }
    ...OrderFlowMetadata
  }
}
    ${UserFragmentDoc}
${MetadataItemFragmentDoc}
${AddressFragmentDoc}
${OrderFlowMetadataFragmentDoc}`;

/**
 * __useCheckoutBaseQuery__
 *
 * To run a query within a React component, call `useCheckoutBaseQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckoutBaseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckoutBaseQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCheckoutBaseQuery(baseOptions: Apollo.QueryHookOptions<CheckoutBaseQuery, CheckoutBaseQueryVariables> & ({ variables: CheckoutBaseQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckoutBaseQuery, CheckoutBaseQueryVariables>(CheckoutBaseDocument, options);
      }
export function useCheckoutBaseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckoutBaseQuery, CheckoutBaseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckoutBaseQuery, CheckoutBaseQueryVariables>(CheckoutBaseDocument, options);
        }
export function useCheckoutBaseSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CheckoutBaseQuery, CheckoutBaseQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CheckoutBaseQuery, CheckoutBaseQueryVariables>(CheckoutBaseDocument, options);
        }
export type CheckoutBaseQueryHookResult = ReturnType<typeof useCheckoutBaseQuery>;
export type CheckoutBaseLazyQueryHookResult = ReturnType<typeof useCheckoutBaseLazyQuery>;
export type CheckoutBaseSuspenseQueryHookResult = ReturnType<typeof useCheckoutBaseSuspenseQuery>;
export type CheckoutBaseQueryResult = Apollo.QueryResult<CheckoutBaseQuery, CheckoutBaseQueryVariables>;
export const CheckoutRefreshDocument = gql`
    query CheckoutRefresh($id: ID!, $languageCode: LanguageCodeEnum!, $imagesFormat: ThumbnailFormatEnum!, $thumbnailSize: Int!) {
  checkout(id: $id) {
    ...CheckoutBase
  }
}
    ${CheckoutBaseFragmentDoc}
${CheckoutBareFragmentDoc}
${TaxedMoneyFragmentDoc}
${MoneyFragmentDoc}
${ChannelFragmentDoc}
${CheckoutLineFragmentDoc}
${MetadataItemFragmentDoc}
${ProductVariantLineFragmentDoc}
${LineProductFragmentDoc}
${VariantPricingFragmentDoc}
${DropdownAttributeFragmentDoc}
${MultiselectAttributeFragmentDoc}
${ProductMediaFragmentDoc}
${BoolAttributeFragmentDoc}
${ProductTypeFragmentDoc}
${ProductThumbnailFragmentDoc}
${ImageFragmentDoc}
${ProductUrlBaseFragmentDoc}
${CheckoutMetadataFragmentDoc}
${GiftMetadataFragmentDoc}
${CustomerTitleMetadataFragmentDoc}
${DeliveryScheduleMetadataFragmentDoc}
${PreorderMetadataFragmentDoc}
${PaymentMethodMetadataFragmentDoc}
${OrderFlowMetadataFragmentDoc}`;

/**
 * __useCheckoutRefreshQuery__
 *
 * To run a query within a React component, call `useCheckoutRefreshQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckoutRefreshQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckoutRefreshQuery({
 *   variables: {
 *      id: // value for 'id'
 *      languageCode: // value for 'languageCode'
 *      imagesFormat: // value for 'imagesFormat'
 *      thumbnailSize: // value for 'thumbnailSize'
 *   },
 * });
 */
export function useCheckoutRefreshQuery(baseOptions: Apollo.QueryHookOptions<CheckoutRefreshQuery, CheckoutRefreshQueryVariables> & ({ variables: CheckoutRefreshQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckoutRefreshQuery, CheckoutRefreshQueryVariables>(CheckoutRefreshDocument, options);
      }
export function useCheckoutRefreshLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckoutRefreshQuery, CheckoutRefreshQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckoutRefreshQuery, CheckoutRefreshQueryVariables>(CheckoutRefreshDocument, options);
        }
export function useCheckoutRefreshSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CheckoutRefreshQuery, CheckoutRefreshQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CheckoutRefreshQuery, CheckoutRefreshQueryVariables>(CheckoutRefreshDocument, options);
        }
export type CheckoutRefreshQueryHookResult = ReturnType<typeof useCheckoutRefreshQuery>;
export type CheckoutRefreshLazyQueryHookResult = ReturnType<typeof useCheckoutRefreshLazyQuery>;
export type CheckoutRefreshSuspenseQueryHookResult = ReturnType<typeof useCheckoutRefreshSuspenseQuery>;
export type CheckoutRefreshQueryResult = Apollo.QueryResult<CheckoutRefreshQuery, CheckoutRefreshQueryVariables>;
export const CheckoutTransactionsDocument = gql`
    query CheckoutTransactions($id: ID!) {
  checkout(id: $id) {
    ...CheckoutMetadata
    orderSource: metafield(key: "order.source")
    transactions {
      tokenData: privateMetafield(key: "ADYEN_APP.TOKEN_DATA")
      ...TransactionItem
    }
  }
}
    ${CheckoutMetadataFragmentDoc}
${GiftMetadataFragmentDoc}
${CustomerTitleMetadataFragmentDoc}
${DeliveryScheduleMetadataFragmentDoc}
${PreorderMetadataFragmentDoc}
${PaymentMethodMetadataFragmentDoc}
${OrderFlowMetadataFragmentDoc}
${TransactionItemFragmentDoc}
${MoneyFragmentDoc}
${TransactionEventFragmentDoc}`;

/**
 * __useCheckoutTransactionsQuery__
 *
 * To run a query within a React component, call `useCheckoutTransactionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckoutTransactionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckoutTransactionsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCheckoutTransactionsQuery(baseOptions: Apollo.QueryHookOptions<CheckoutTransactionsQuery, CheckoutTransactionsQueryVariables> & ({ variables: CheckoutTransactionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckoutTransactionsQuery, CheckoutTransactionsQueryVariables>(CheckoutTransactionsDocument, options);
      }
export function useCheckoutTransactionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckoutTransactionsQuery, CheckoutTransactionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckoutTransactionsQuery, CheckoutTransactionsQueryVariables>(CheckoutTransactionsDocument, options);
        }
export function useCheckoutTransactionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CheckoutTransactionsQuery, CheckoutTransactionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CheckoutTransactionsQuery, CheckoutTransactionsQueryVariables>(CheckoutTransactionsDocument, options);
        }
export type CheckoutTransactionsQueryHookResult = ReturnType<typeof useCheckoutTransactionsQuery>;
export type CheckoutTransactionsLazyQueryHookResult = ReturnType<typeof useCheckoutTransactionsLazyQuery>;
export type CheckoutTransactionsSuspenseQueryHookResult = ReturnType<typeof useCheckoutTransactionsSuspenseQuery>;
export type CheckoutTransactionsQueryResult = Apollo.QueryResult<CheckoutTransactionsQuery, CheckoutTransactionsQueryVariables>;
export const CollectionCardsDocument = gql`
    query CollectionCards($filter: CollectionFilterInput!, $languageCode: LanguageCodeEnum!, $channel: String!) {
  collections(filter: $filter, channel: $channel, first: 20) {
    edges {
      node {
        id
        slug
        name
        translation(languageCode: $languageCode) {
          name
        }
      }
    }
  }
}
    `;

/**
 * __useCollectionCardsQuery__
 *
 * To run a query within a React component, call `useCollectionCardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCollectionCardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCollectionCardsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      languageCode: // value for 'languageCode'
 *      channel: // value for 'channel'
 *   },
 * });
 */
export function useCollectionCardsQuery(baseOptions: Apollo.QueryHookOptions<CollectionCardsQuery, CollectionCardsQueryVariables> & ({ variables: CollectionCardsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CollectionCardsQuery, CollectionCardsQueryVariables>(CollectionCardsDocument, options);
      }
export function useCollectionCardsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CollectionCardsQuery, CollectionCardsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CollectionCardsQuery, CollectionCardsQueryVariables>(CollectionCardsDocument, options);
        }
export function useCollectionCardsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CollectionCardsQuery, CollectionCardsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CollectionCardsQuery, CollectionCardsQueryVariables>(CollectionCardsDocument, options);
        }
export type CollectionCardsQueryHookResult = ReturnType<typeof useCollectionCardsQuery>;
export type CollectionCardsLazyQueryHookResult = ReturnType<typeof useCollectionCardsLazyQuery>;
export type CollectionCardsSuspenseQueryHookResult = ReturnType<typeof useCollectionCardsSuspenseQuery>;
export type CollectionCardsQueryResult = Apollo.QueryResult<CollectionCardsQuery, CollectionCardsQueryVariables>;
export const CollectionPathsDocument = gql`
    query CollectionPaths($after: String, $channel: String!) {
  collections(first: 20, channel: $channel, after: $after) {
    pageInfo {
      ...PageInfoFragment
    }
    edges {
      node {
        slug
      }
    }
  }
}
    ${PageInfoFragmentDoc}`;

/**
 * __useCollectionPathsQuery__
 *
 * To run a query within a React component, call `useCollectionPathsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCollectionPathsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCollectionPathsQuery({
 *   variables: {
 *      after: // value for 'after'
 *      channel: // value for 'channel'
 *   },
 * });
 */
export function useCollectionPathsQuery(baseOptions: Apollo.QueryHookOptions<CollectionPathsQuery, CollectionPathsQueryVariables> & ({ variables: CollectionPathsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CollectionPathsQuery, CollectionPathsQueryVariables>(CollectionPathsDocument, options);
      }
export function useCollectionPathsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CollectionPathsQuery, CollectionPathsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CollectionPathsQuery, CollectionPathsQueryVariables>(CollectionPathsDocument, options);
        }
export function useCollectionPathsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CollectionPathsQuery, CollectionPathsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CollectionPathsQuery, CollectionPathsQueryVariables>(CollectionPathsDocument, options);
        }
export type CollectionPathsQueryHookResult = ReturnType<typeof useCollectionPathsQuery>;
export type CollectionPathsLazyQueryHookResult = ReturnType<typeof useCollectionPathsLazyQuery>;
export type CollectionPathsSuspenseQueryHookResult = ReturnType<typeof useCollectionPathsSuspenseQuery>;
export type CollectionPathsQueryResult = Apollo.QueryResult<CollectionPathsQuery, CollectionPathsQueryVariables>;
export const FooterBarMenuDocument = gql`
    query FooterBarMenu($locale: LanguageCodeEnum!, $channel: String!) {
  menu(slug: "footerbar", channel: $channel) {
    id
    items {
      children {
        ...MenuItemFragment
      }
      ...MenuItemFragment
    }
  }
}
    ${MenuItemFragmentDoc}`;

/**
 * __useFooterBarMenuQuery__
 *
 * To run a query within a React component, call `useFooterBarMenuQuery` and pass it any options that fit your needs.
 * When your component renders, `useFooterBarMenuQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFooterBarMenuQuery({
 *   variables: {
 *      locale: // value for 'locale'
 *      channel: // value for 'channel'
 *   },
 * });
 */
export function useFooterBarMenuQuery(baseOptions: Apollo.QueryHookOptions<FooterBarMenuQuery, FooterBarMenuQueryVariables> & ({ variables: FooterBarMenuQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FooterBarMenuQuery, FooterBarMenuQueryVariables>(FooterBarMenuDocument, options);
      }
export function useFooterBarMenuLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FooterBarMenuQuery, FooterBarMenuQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FooterBarMenuQuery, FooterBarMenuQueryVariables>(FooterBarMenuDocument, options);
        }
export function useFooterBarMenuSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FooterBarMenuQuery, FooterBarMenuQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FooterBarMenuQuery, FooterBarMenuQueryVariables>(FooterBarMenuDocument, options);
        }
export type FooterBarMenuQueryHookResult = ReturnType<typeof useFooterBarMenuQuery>;
export type FooterBarMenuLazyQueryHookResult = ReturnType<typeof useFooterBarMenuLazyQuery>;
export type FooterBarMenuSuspenseQueryHookResult = ReturnType<typeof useFooterBarMenuSuspenseQuery>;
export type FooterBarMenuQueryResult = Apollo.QueryResult<FooterBarMenuQuery, FooterBarMenuQueryVariables>;
export const FooterMenuDocument = gql`
    query FooterMenu($locale: LanguageCodeEnum!, $channel: String!) {
  menu(slug: "footer", channel: $channel) {
    id
    items {
      children {
        ...MenuItemFragment
      }
      ...MenuItemFragment
    }
  }
}
    ${MenuItemFragmentDoc}`;

/**
 * __useFooterMenuQuery__
 *
 * To run a query within a React component, call `useFooterMenuQuery` and pass it any options that fit your needs.
 * When your component renders, `useFooterMenuQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFooterMenuQuery({
 *   variables: {
 *      locale: // value for 'locale'
 *      channel: // value for 'channel'
 *   },
 * });
 */
export function useFooterMenuQuery(baseOptions: Apollo.QueryHookOptions<FooterMenuQuery, FooterMenuQueryVariables> & ({ variables: FooterMenuQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FooterMenuQuery, FooterMenuQueryVariables>(FooterMenuDocument, options);
      }
export function useFooterMenuLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FooterMenuQuery, FooterMenuQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FooterMenuQuery, FooterMenuQueryVariables>(FooterMenuDocument, options);
        }
export function useFooterMenuSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FooterMenuQuery, FooterMenuQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FooterMenuQuery, FooterMenuQueryVariables>(FooterMenuDocument, options);
        }
export type FooterMenuQueryHookResult = ReturnType<typeof useFooterMenuQuery>;
export type FooterMenuLazyQueryHookResult = ReturnType<typeof useFooterMenuLazyQuery>;
export type FooterMenuSuspenseQueryHookResult = ReturnType<typeof useFooterMenuSuspenseQuery>;
export type FooterMenuQueryResult = Apollo.QueryResult<FooterMenuQuery, FooterMenuQueryVariables>;
export const GetCollectionsDocument = gql`
    query GetCollections($after: String, $channel: String!) {
  collections(first: 20, channel: $channel, after: $after) {
    pageInfo {
      ...PageInfoFragment
    }
    edges {
      node {
        id
        name
        slug
      }
    }
  }
}
    ${PageInfoFragmentDoc}`;

/**
 * __useGetCollectionsQuery__
 *
 * To run a query within a React component, call `useGetCollectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCollectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCollectionsQuery({
 *   variables: {
 *      after: // value for 'after'
 *      channel: // value for 'channel'
 *   },
 * });
 */
export function useGetCollectionsQuery(baseOptions: Apollo.QueryHookOptions<GetCollectionsQuery, GetCollectionsQueryVariables> & ({ variables: GetCollectionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCollectionsQuery, GetCollectionsQueryVariables>(GetCollectionsDocument, options);
      }
export function useGetCollectionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCollectionsQuery, GetCollectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCollectionsQuery, GetCollectionsQueryVariables>(GetCollectionsDocument, options);
        }
export function useGetCollectionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCollectionsQuery, GetCollectionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCollectionsQuery, GetCollectionsQueryVariables>(GetCollectionsDocument, options);
        }
export type GetCollectionsQueryHookResult = ReturnType<typeof useGetCollectionsQuery>;
export type GetCollectionsLazyQueryHookResult = ReturnType<typeof useGetCollectionsLazyQuery>;
export type GetCollectionsSuspenseQueryHookResult = ReturnType<typeof useGetCollectionsSuspenseQuery>;
export type GetCollectionsQueryResult = Apollo.QueryResult<GetCollectionsQuery, GetCollectionsQueryVariables>;
export const GwpDetailsDocument = gql`
    query GwpDetails($id: ID!, $channel: String!, $languageCode: LanguageCodeEnum!) {
  product(id: $id, channel: $channel) {
    id
    name
    attribute(slug: "com-gwp-name") {
      attribute {
        id
        slug
      }
      values {
        id
        name
        translation(languageCode: $languageCode) {
          plainText
          name
        }
      }
    }
  }
}
    `;

/**
 * __useGwpDetailsQuery__
 *
 * To run a query within a React component, call `useGwpDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGwpDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGwpDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      channel: // value for 'channel'
 *      languageCode: // value for 'languageCode'
 *   },
 * });
 */
export function useGwpDetailsQuery(baseOptions: Apollo.QueryHookOptions<GwpDetailsQuery, GwpDetailsQueryVariables> & ({ variables: GwpDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GwpDetailsQuery, GwpDetailsQueryVariables>(GwpDetailsDocument, options);
      }
export function useGwpDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GwpDetailsQuery, GwpDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GwpDetailsQuery, GwpDetailsQueryVariables>(GwpDetailsDocument, options);
        }
export function useGwpDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GwpDetailsQuery, GwpDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GwpDetailsQuery, GwpDetailsQueryVariables>(GwpDetailsDocument, options);
        }
export type GwpDetailsQueryHookResult = ReturnType<typeof useGwpDetailsQuery>;
export type GwpDetailsLazyQueryHookResult = ReturnType<typeof useGwpDetailsLazyQuery>;
export type GwpDetailsSuspenseQueryHookResult = ReturnType<typeof useGwpDetailsSuspenseQuery>;
export type GwpDetailsQueryResult = Apollo.QueryResult<GwpDetailsQuery, GwpDetailsQueryVariables>;
export const MainMenuDocument = gql`
    query MainMenu($locale: LanguageCodeEnum!, $channel: String!) {
  menu(slug: "navbar", channel: $channel) {
    id
    items {
      ...MenuItemWithChildrenFragment
    }
  }
}
    ${MenuItemWithChildrenFragmentDoc}
${MenuItemFragmentDoc}`;

/**
 * __useMainMenuQuery__
 *
 * To run a query within a React component, call `useMainMenuQuery` and pass it any options that fit your needs.
 * When your component renders, `useMainMenuQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMainMenuQuery({
 *   variables: {
 *      locale: // value for 'locale'
 *      channel: // value for 'channel'
 *   },
 * });
 */
export function useMainMenuQuery(baseOptions: Apollo.QueryHookOptions<MainMenuQuery, MainMenuQueryVariables> & ({ variables: MainMenuQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MainMenuQuery, MainMenuQueryVariables>(MainMenuDocument, options);
      }
export function useMainMenuLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MainMenuQuery, MainMenuQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MainMenuQuery, MainMenuQueryVariables>(MainMenuDocument, options);
        }
export function useMainMenuSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MainMenuQuery, MainMenuQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MainMenuQuery, MainMenuQueryVariables>(MainMenuDocument, options);
        }
export type MainMenuQueryHookResult = ReturnType<typeof useMainMenuQuery>;
export type MainMenuLazyQueryHookResult = ReturnType<typeof useMainMenuLazyQuery>;
export type MainMenuSuspenseQueryHookResult = ReturnType<typeof useMainMenuSuspenseQuery>;
export type MainMenuQueryResult = Apollo.QueryResult<MainMenuQuery, MainMenuQueryVariables>;
export const MyOrderDetailsDocument = gql`
    query MyOrderDetails($id: ID!, $thumbnailSize: Int!, $languageCode: LanguageCodeEnum!) {
  order(id: $id) {
    ...MyOrder
    subtotal {
      ...TaxedMoney
    }
    timeSlot: metafield(key: "time_slot")
    shippingTitle: metafield(key: "order.shippingTitle")
    shippingAddress {
      ...Address
    }
    billingTitle: metafield(key: "order.billingTitle")
    billingAddress {
      ...Address
    }
    shippingPrice {
      ...TaxedMoney
    }
    subtotal {
      ...TaxedMoney
    }
    payments {
      paymentMethodType
    }
    channel {
      ...Channel
    }
    discounts {
      ...Discounts
    }
    ...GiftMetadata
  }
}
    ${MyOrderFragmentDoc}
${FulfillmentFragmentDoc}
${MyOrderLineFragmentDoc}
${TaxedMoneyFragmentDoc}
${MoneyFragmentDoc}
${MultiselectAttributeFragmentDoc}
${WarrantyRelatedWatchMetadataFragmentDoc}
${FulfillmentReturnMetadataFragmentDoc}
${FulfillmentTrackingMetadataFragmentDoc}
${DiscountsFragmentDoc}
${BusinessIdMetadataFragmentDoc}
${PreorderMetadataFragmentDoc}
${AddressFragmentDoc}
${ChannelFragmentDoc}
${GiftMetadataFragmentDoc}`;

/**
 * __useMyOrderDetailsQuery__
 *
 * To run a query within a React component, call `useMyOrderDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyOrderDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyOrderDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      thumbnailSize: // value for 'thumbnailSize'
 *      languageCode: // value for 'languageCode'
 *   },
 * });
 */
export function useMyOrderDetailsQuery(baseOptions: Apollo.QueryHookOptions<MyOrderDetailsQuery, MyOrderDetailsQueryVariables> & ({ variables: MyOrderDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyOrderDetailsQuery, MyOrderDetailsQueryVariables>(MyOrderDetailsDocument, options);
      }
export function useMyOrderDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyOrderDetailsQuery, MyOrderDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyOrderDetailsQuery, MyOrderDetailsQueryVariables>(MyOrderDetailsDocument, options);
        }
export function useMyOrderDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyOrderDetailsQuery, MyOrderDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MyOrderDetailsQuery, MyOrderDetailsQueryVariables>(MyOrderDetailsDocument, options);
        }
export type MyOrderDetailsQueryHookResult = ReturnType<typeof useMyOrderDetailsQuery>;
export type MyOrderDetailsLazyQueryHookResult = ReturnType<typeof useMyOrderDetailsLazyQuery>;
export type MyOrderDetailsSuspenseQueryHookResult = ReturnType<typeof useMyOrderDetailsSuspenseQuery>;
export type MyOrderDetailsQueryResult = Apollo.QueryResult<MyOrderDetailsQuery, MyOrderDetailsQueryVariables>;
export const MyOrdersDocument = gql`
    query MyOrders($first: Int = 100, $thumbnailSize: Int!, $languageCode: LanguageCodeEnum!) {
  me {
    orders(first: $first) {
      edges {
        node {
          ...MyOrder
        }
      }
    }
  }
}
    ${MyOrderFragmentDoc}
${FulfillmentFragmentDoc}
${MyOrderLineFragmentDoc}
${TaxedMoneyFragmentDoc}
${MoneyFragmentDoc}
${MultiselectAttributeFragmentDoc}
${WarrantyRelatedWatchMetadataFragmentDoc}
${FulfillmentReturnMetadataFragmentDoc}
${FulfillmentTrackingMetadataFragmentDoc}
${DiscountsFragmentDoc}
${BusinessIdMetadataFragmentDoc}
${PreorderMetadataFragmentDoc}`;

/**
 * __useMyOrdersQuery__
 *
 * To run a query within a React component, call `useMyOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyOrdersQuery({
 *   variables: {
 *      first: // value for 'first'
 *      thumbnailSize: // value for 'thumbnailSize'
 *      languageCode: // value for 'languageCode'
 *   },
 * });
 */
export function useMyOrdersQuery(baseOptions: Apollo.QueryHookOptions<MyOrdersQuery, MyOrdersQueryVariables> & ({ variables: MyOrdersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyOrdersQuery, MyOrdersQueryVariables>(MyOrdersDocument, options);
      }
export function useMyOrdersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyOrdersQuery, MyOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyOrdersQuery, MyOrdersQueryVariables>(MyOrdersDocument, options);
        }
export function useMyOrdersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyOrdersQuery, MyOrdersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MyOrdersQuery, MyOrdersQueryVariables>(MyOrdersDocument, options);
        }
export type MyOrdersQueryHookResult = ReturnType<typeof useMyOrdersQuery>;
export type MyOrdersLazyQueryHookResult = ReturnType<typeof useMyOrdersLazyQuery>;
export type MyOrdersSuspenseQueryHookResult = ReturnType<typeof useMyOrdersSuspenseQuery>;
export type MyOrdersQueryResult = Apollo.QueryResult<MyOrdersQuery, MyOrdersQueryVariables>;
export const OrderDocument = gql`
    query Order($id: ID, $languageCode: LanguageCodeEnum!, $thumbnailSize: Int!, $imagesFormat: ThumbnailFormatEnum!) {
  order(id: $id) {
    ...Order
  }
}
    ${OrderFragmentDoc}
${OrderLineFragmentDoc}
${TaxedMoneyFragmentDoc}
${MoneyFragmentDoc}
${ProductVariantLineFragmentDoc}
${LineProductFragmentDoc}
${VariantPricingFragmentDoc}
${DropdownAttributeFragmentDoc}
${MultiselectAttributeFragmentDoc}
${ProductMediaFragmentDoc}
${BoolAttributeFragmentDoc}
${ProductTypeFragmentDoc}
${ProductThumbnailFragmentDoc}
${ImageFragmentDoc}
${ProductUrlBaseFragmentDoc}
${MetadataItemFragmentDoc}
${ChannelFragmentDoc}
${AddressFragmentDoc}
${DiscountsFragmentDoc}
${CustomerTitleMetadataFragmentDoc}
${PreorderMetadataFragmentDoc}
${GiftMetadataFragmentDoc}
${DeliveryScheduleMetadataFragmentDoc}
${PaymentMethodMetadataFragmentDoc}
${OrderFlowMetadataFragmentDoc}`;

/**
 * __useOrderQuery__
 *
 * To run a query within a React component, call `useOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderQuery({
 *   variables: {
 *      id: // value for 'id'
 *      languageCode: // value for 'languageCode'
 *      thumbnailSize: // value for 'thumbnailSize'
 *      imagesFormat: // value for 'imagesFormat'
 *   },
 * });
 */
export function useOrderQuery(baseOptions: Apollo.QueryHookOptions<OrderQuery, OrderQueryVariables> & ({ variables: OrderQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrderQuery, OrderQueryVariables>(OrderDocument, options);
      }
export function useOrderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrderQuery, OrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrderQuery, OrderQueryVariables>(OrderDocument, options);
        }
export function useOrderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrderQuery, OrderQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrderQuery, OrderQueryVariables>(OrderDocument, options);
        }
export type OrderQueryHookResult = ReturnType<typeof useOrderQuery>;
export type OrderLazyQueryHookResult = ReturnType<typeof useOrderLazyQuery>;
export type OrderSuspenseQueryHookResult = ReturnType<typeof useOrderSuspenseQuery>;
export type OrderQueryResult = Apollo.QueryResult<OrderQuery, OrderQueryVariables>;
export const OrderByTransactionDocument = gql`
    query OrderByTransaction($id: ID) {
  transaction(id: $id) {
    id
    order {
      id
      businessId: metafield(key: "order.bid")
    }
  }
}
    `;

/**
 * __useOrderByTransactionQuery__
 *
 * To run a query within a React component, call `useOrderByTransactionQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderByTransactionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderByTransactionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOrderByTransactionQuery(baseOptions?: Apollo.QueryHookOptions<OrderByTransactionQuery, OrderByTransactionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrderByTransactionQuery, OrderByTransactionQueryVariables>(OrderByTransactionDocument, options);
      }
export function useOrderByTransactionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrderByTransactionQuery, OrderByTransactionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrderByTransactionQuery, OrderByTransactionQueryVariables>(OrderByTransactionDocument, options);
        }
export function useOrderByTransactionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrderByTransactionQuery, OrderByTransactionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrderByTransactionQuery, OrderByTransactionQueryVariables>(OrderByTransactionDocument, options);
        }
export type OrderByTransactionQueryHookResult = ReturnType<typeof useOrderByTransactionQuery>;
export type OrderByTransactionLazyQueryHookResult = ReturnType<typeof useOrderByTransactionLazyQuery>;
export type OrderByTransactionSuspenseQueryHookResult = ReturnType<typeof useOrderByTransactionSuspenseQuery>;
export type OrderByTransactionQueryResult = Apollo.QueryResult<OrderByTransactionQuery, OrderByTransactionQueryVariables>;
export const OrderTransactionsDocument = gql`
    query OrderTransactions($id: ID!) {
  order(id: $id) {
    ...PaymentMethodMetadata
    orderSource: metafield(key: "order.source")
    transactions {
      tokenData: privateMetafield(key: "ADYEN_APP.TOKEN_DATA")
      ...TransactionItem
    }
  }
}
    ${PaymentMethodMetadataFragmentDoc}
${TransactionItemFragmentDoc}
${MoneyFragmentDoc}
${TransactionEventFragmentDoc}`;

/**
 * __useOrderTransactionsQuery__
 *
 * To run a query within a React component, call `useOrderTransactionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderTransactionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderTransactionsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOrderTransactionsQuery(baseOptions: Apollo.QueryHookOptions<OrderTransactionsQuery, OrderTransactionsQueryVariables> & ({ variables: OrderTransactionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrderTransactionsQuery, OrderTransactionsQueryVariables>(OrderTransactionsDocument, options);
      }
export function useOrderTransactionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrderTransactionsQuery, OrderTransactionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrderTransactionsQuery, OrderTransactionsQueryVariables>(OrderTransactionsDocument, options);
        }
export function useOrderTransactionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrderTransactionsQuery, OrderTransactionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrderTransactionsQuery, OrderTransactionsQueryVariables>(OrderTransactionsDocument, options);
        }
export type OrderTransactionsQueryHookResult = ReturnType<typeof useOrderTransactionsQuery>;
export type OrderTransactionsLazyQueryHookResult = ReturnType<typeof useOrderTransactionsLazyQuery>;
export type OrderTransactionsSuspenseQueryHookResult = ReturnType<typeof useOrderTransactionsSuspenseQuery>;
export type OrderTransactionsQueryResult = Apollo.QueryResult<OrderTransactionsQuery, OrderTransactionsQueryVariables>;
export const OrdersDocument = gql`
    query Orders($first: Int, $last: Int, $before: String, $after: String, $filter: OrderFilterInput, $sort: OrderSortingInput) {
  orders(
    filter: $filter
    sortBy: $sort
    first: $first
    last: $last
    before: $before
    after: $after
  ) {
    pageInfo {
      ...PageInfoFragment
    }
    edges {
      node {
        id
        totalCharged {
          ...Money
        }
        totalAuthorized {
          ...Money
        }
        isOfflinePayment: metafield(key: "order.is_offline_payment")
      }
    }
  }
}
    ${PageInfoFragmentDoc}
${MoneyFragmentDoc}`;

/**
 * __useOrdersQuery__
 *
 * To run a query within a React component, call `useOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrdersQuery({
 *   variables: {
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useOrdersQuery(baseOptions?: Apollo.QueryHookOptions<OrdersQuery, OrdersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrdersQuery, OrdersQueryVariables>(OrdersDocument, options);
      }
export function useOrdersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrdersQuery, OrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrdersQuery, OrdersQueryVariables>(OrdersDocument, options);
        }
export function useOrdersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrdersQuery, OrdersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrdersQuery, OrdersQueryVariables>(OrdersDocument, options);
        }
export type OrdersQueryHookResult = ReturnType<typeof useOrdersQuery>;
export type OrdersLazyQueryHookResult = ReturnType<typeof useOrdersLazyQuery>;
export type OrdersSuspenseQueryHookResult = ReturnType<typeof useOrdersSuspenseQuery>;
export type OrdersQueryResult = Apollo.QueryResult<OrdersQuery, OrdersQueryVariables>;
export const PagePathsDocument = gql`
    query PagePaths($after: String) {
  pages(first: 100, after: $after) {
    pageInfo {
      ...PageInfoFragment
    }
    edges {
      node {
        slug
      }
    }
  }
}
    ${PageInfoFragmentDoc}`;

/**
 * __usePagePathsQuery__
 *
 * To run a query within a React component, call `usePagePathsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePagePathsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePagePathsQuery({
 *   variables: {
 *      after: // value for 'after'
 *   },
 * });
 */
export function usePagePathsQuery(baseOptions?: Apollo.QueryHookOptions<PagePathsQuery, PagePathsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PagePathsQuery, PagePathsQueryVariables>(PagePathsDocument, options);
      }
export function usePagePathsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PagePathsQuery, PagePathsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PagePathsQuery, PagePathsQueryVariables>(PagePathsDocument, options);
        }
export function usePagePathsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PagePathsQuery, PagePathsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PagePathsQuery, PagePathsQueryVariables>(PagePathsDocument, options);
        }
export type PagePathsQueryHookResult = ReturnType<typeof usePagePathsQuery>;
export type PagePathsLazyQueryHookResult = ReturnType<typeof usePagePathsLazyQuery>;
export type PagePathsSuspenseQueryHookResult = ReturnType<typeof usePagePathsSuspenseQuery>;
export type PagePathsQueryResult = Apollo.QueryResult<PagePathsQuery, PagePathsQueryVariables>;
export const PayPerLinkOrderDataDocument = gql`
    query PayPerLinkOrderData($id: ID!) {
  order(id: $id) {
    id
    payPerLinkToken: metafield(key: "order.pay_per_link_token")
    payPerLinkExpiration: metafield(key: "order.pay_per_link_token_expiration_time")
  }
}
    `;

/**
 * __usePayPerLinkOrderDataQuery__
 *
 * To run a query within a React component, call `usePayPerLinkOrderDataQuery` and pass it any options that fit your needs.
 * When your component renders, `usePayPerLinkOrderDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePayPerLinkOrderDataQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePayPerLinkOrderDataQuery(baseOptions: Apollo.QueryHookOptions<PayPerLinkOrderDataQuery, PayPerLinkOrderDataQueryVariables> & ({ variables: PayPerLinkOrderDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PayPerLinkOrderDataQuery, PayPerLinkOrderDataQueryVariables>(PayPerLinkOrderDataDocument, options);
      }
export function usePayPerLinkOrderDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PayPerLinkOrderDataQuery, PayPerLinkOrderDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PayPerLinkOrderDataQuery, PayPerLinkOrderDataQueryVariables>(PayPerLinkOrderDataDocument, options);
        }
export function usePayPerLinkOrderDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PayPerLinkOrderDataQuery, PayPerLinkOrderDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PayPerLinkOrderDataQuery, PayPerLinkOrderDataQueryVariables>(PayPerLinkOrderDataDocument, options);
        }
export type PayPerLinkOrderDataQueryHookResult = ReturnType<typeof usePayPerLinkOrderDataQuery>;
export type PayPerLinkOrderDataLazyQueryHookResult = ReturnType<typeof usePayPerLinkOrderDataLazyQuery>;
export type PayPerLinkOrderDataSuspenseQueryHookResult = ReturnType<typeof usePayPerLinkOrderDataSuspenseQuery>;
export type PayPerLinkOrderDataQueryResult = Apollo.QueryResult<PayPerLinkOrderDataQuery, PayPerLinkOrderDataQueryVariables>;
export const ProductCardsDocument = gql`
    query ProductCards($first: Int!, $channel: String, $filter: ProductFilterInput, $languageCode: LanguageCodeEnum!, $thumbnailSize: Int!, $imagesFormat: ThumbnailFormatEnum!) {
  products(first: $first, channel: $channel, filter: $filter) {
    edges {
      node {
        ...ProductCard
      }
    }
  }
}
    ${ProductCardFragmentDoc}
${ProductUrlBaseFragmentDoc}
${DropdownAttributeFragmentDoc}
${ProductTypeFragmentDoc}
${MultiselectAttributeFragmentDoc}
${ImageFragmentDoc}
${ProductMediaFragmentDoc}
${VariantPricingFragmentDoc}
${TaxedMoneyFragmentDoc}
${MoneyFragmentDoc}
${BoolAttributeFragmentDoc}
${NumericAttributeFragmentDoc}`;

/**
 * __useProductCardsQuery__
 *
 * To run a query within a React component, call `useProductCardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductCardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductCardsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      channel: // value for 'channel'
 *      filter: // value for 'filter'
 *      languageCode: // value for 'languageCode'
 *      thumbnailSize: // value for 'thumbnailSize'
 *      imagesFormat: // value for 'imagesFormat'
 *   },
 * });
 */
export function useProductCardsQuery(baseOptions: Apollo.QueryHookOptions<ProductCardsQuery, ProductCardsQueryVariables> & ({ variables: ProductCardsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductCardsQuery, ProductCardsQueryVariables>(ProductCardsDocument, options);
      }
export function useProductCardsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductCardsQuery, ProductCardsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductCardsQuery, ProductCardsQueryVariables>(ProductCardsDocument, options);
        }
export function useProductCardsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductCardsQuery, ProductCardsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductCardsQuery, ProductCardsQueryVariables>(ProductCardsDocument, options);
        }
export type ProductCardsQueryHookResult = ReturnType<typeof useProductCardsQuery>;
export type ProductCardsLazyQueryHookResult = ReturnType<typeof useProductCardsLazyQuery>;
export type ProductCardsSuspenseQueryHookResult = ReturnType<typeof useProductCardsSuspenseQuery>;
export type ProductCardsQueryResult = Apollo.QueryResult<ProductCardsQuery, ProductCardsQueryVariables>;
export const ProductCardsAndPricesDocument = gql`
    query ProductCardsAndPrices($first: Int!, $channel: String, $filter: ProductFilterInput, $languageCode: LanguageCodeEnum!, $thumbnailSize: Int!, $imagesFormat: ThumbnailFormatEnum!) {
  products: products(first: $first, filter: $filter) {
    edges {
      node {
        ...ProductCard
      }
    }
  }
  prices: products(first: $first, channel: $channel, filter: $filter) {
    edges {
      node {
        id
        slug
        defaultVariant {
          sku
          id
          pricing {
            ...VariantPricing
          }
        }
      }
    }
  }
}
    ${ProductCardFragmentDoc}
${ProductUrlBaseFragmentDoc}
${DropdownAttributeFragmentDoc}
${ProductTypeFragmentDoc}
${MultiselectAttributeFragmentDoc}
${ImageFragmentDoc}
${ProductMediaFragmentDoc}
${VariantPricingFragmentDoc}
${TaxedMoneyFragmentDoc}
${MoneyFragmentDoc}
${BoolAttributeFragmentDoc}
${NumericAttributeFragmentDoc}`;

/**
 * __useProductCardsAndPricesQuery__
 *
 * To run a query within a React component, call `useProductCardsAndPricesQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductCardsAndPricesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductCardsAndPricesQuery({
 *   variables: {
 *      first: // value for 'first'
 *      channel: // value for 'channel'
 *      filter: // value for 'filter'
 *      languageCode: // value for 'languageCode'
 *      thumbnailSize: // value for 'thumbnailSize'
 *      imagesFormat: // value for 'imagesFormat'
 *   },
 * });
 */
export function useProductCardsAndPricesQuery(baseOptions: Apollo.QueryHookOptions<ProductCardsAndPricesQuery, ProductCardsAndPricesQueryVariables> & ({ variables: ProductCardsAndPricesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductCardsAndPricesQuery, ProductCardsAndPricesQueryVariables>(ProductCardsAndPricesDocument, options);
      }
export function useProductCardsAndPricesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductCardsAndPricesQuery, ProductCardsAndPricesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductCardsAndPricesQuery, ProductCardsAndPricesQueryVariables>(ProductCardsAndPricesDocument, options);
        }
export function useProductCardsAndPricesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductCardsAndPricesQuery, ProductCardsAndPricesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductCardsAndPricesQuery, ProductCardsAndPricesQueryVariables>(ProductCardsAndPricesDocument, options);
        }
export type ProductCardsAndPricesQueryHookResult = ReturnType<typeof useProductCardsAndPricesQuery>;
export type ProductCardsAndPricesLazyQueryHookResult = ReturnType<typeof useProductCardsAndPricesLazyQuery>;
export type ProductCardsAndPricesSuspenseQueryHookResult = ReturnType<typeof useProductCardsAndPricesSuspenseQuery>;
export type ProductCardsAndPricesQueryResult = Apollo.QueryResult<ProductCardsAndPricesQuery, ProductCardsAndPricesQueryVariables>;
export const ProductSearchDocument = gql`
    query ProductSearch($first: Int = 9, $filter: ProductFilterInput, $channel: String, $languageCode: LanguageCodeEnum!) {
  products(first: $first, channel: $channel, filter: $filter) {
    edges {
      node {
        defaultVariant {
          id
          sku
        }
        id
        name
        slug
        translation(languageCode: $languageCode) {
          name
        }
      }
    }
  }
}
    `;

/**
 * __useProductSearchQuery__
 *
 * To run a query within a React component, call `useProductSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductSearchQuery({
 *   variables: {
 *      first: // value for 'first'
 *      filter: // value for 'filter'
 *      channel: // value for 'channel'
 *      languageCode: // value for 'languageCode'
 *   },
 * });
 */
export function useProductSearchQuery(baseOptions: Apollo.QueryHookOptions<ProductSearchQuery, ProductSearchQueryVariables> & ({ variables: ProductSearchQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductSearchQuery, ProductSearchQueryVariables>(ProductSearchDocument, options);
      }
export function useProductSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductSearchQuery, ProductSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductSearchQuery, ProductSearchQueryVariables>(ProductSearchDocument, options);
        }
export function useProductSearchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductSearchQuery, ProductSearchQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductSearchQuery, ProductSearchQueryVariables>(ProductSearchDocument, options);
        }
export type ProductSearchQueryHookResult = ReturnType<typeof useProductSearchQuery>;
export type ProductSearchLazyQueryHookResult = ReturnType<typeof useProductSearchLazyQuery>;
export type ProductSearchSuspenseQueryHookResult = ReturnType<typeof useProductSearchSuspenseQuery>;
export type ProductSearchQueryResult = Apollo.QueryResult<ProductSearchQuery, ProductSearchQueryVariables>;
export const ProductTypesSearchDocument = gql`
    query ProductTypesSearch($first: Int!, $filter: ProductTypeFilterInput!) {
  productTypes(first: $first, filter: $filter) {
    edges {
      node {
        id
      }
    }
  }
}
    `;

/**
 * __useProductTypesSearchQuery__
 *
 * To run a query within a React component, call `useProductTypesSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductTypesSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductTypesSearchQuery({
 *   variables: {
 *      first: // value for 'first'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useProductTypesSearchQuery(baseOptions: Apollo.QueryHookOptions<ProductTypesSearchQuery, ProductTypesSearchQueryVariables> & ({ variables: ProductTypesSearchQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductTypesSearchQuery, ProductTypesSearchQueryVariables>(ProductTypesSearchDocument, options);
      }
export function useProductTypesSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductTypesSearchQuery, ProductTypesSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductTypesSearchQuery, ProductTypesSearchQueryVariables>(ProductTypesSearchDocument, options);
        }
export function useProductTypesSearchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductTypesSearchQuery, ProductTypesSearchQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductTypesSearchQuery, ProductTypesSearchQueryVariables>(ProductTypesSearchDocument, options);
        }
export type ProductTypesSearchQueryHookResult = ReturnType<typeof useProductTypesSearchQuery>;
export type ProductTypesSearchLazyQueryHookResult = ReturnType<typeof useProductTypesSearchLazyQuery>;
export type ProductTypesSearchSuspenseQueryHookResult = ReturnType<typeof useProductTypesSearchSuspenseQuery>;
export type ProductTypesSearchQueryResult = Apollo.QueryResult<ProductTypesSearchQuery, ProductTypesSearchQueryVariables>;
export const ProductVariantDetailImageDocument = gql`
    query ProductVariantDetailImage($sku: String!, $thumbnailSize: Int!, $channel: String, $imagesFormat: ThumbnailFormatEnum!) {
  productVariant(sku: $sku, channel: $channel) {
    product {
      thumbnail(size: $thumbnailSize, format: $imagesFormat) {
        ...Image
      }
    }
  }
}
    ${ImageFragmentDoc}`;

/**
 * __useProductVariantDetailImageQuery__
 *
 * To run a query within a React component, call `useProductVariantDetailImageQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductVariantDetailImageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductVariantDetailImageQuery({
 *   variables: {
 *      sku: // value for 'sku'
 *      thumbnailSize: // value for 'thumbnailSize'
 *      channel: // value for 'channel'
 *      imagesFormat: // value for 'imagesFormat'
 *   },
 * });
 */
export function useProductVariantDetailImageQuery(baseOptions: Apollo.QueryHookOptions<ProductVariantDetailImageQuery, ProductVariantDetailImageQueryVariables> & ({ variables: ProductVariantDetailImageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductVariantDetailImageQuery, ProductVariantDetailImageQueryVariables>(ProductVariantDetailImageDocument, options);
      }
export function useProductVariantDetailImageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductVariantDetailImageQuery, ProductVariantDetailImageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductVariantDetailImageQuery, ProductVariantDetailImageQueryVariables>(ProductVariantDetailImageDocument, options);
        }
export function useProductVariantDetailImageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductVariantDetailImageQuery, ProductVariantDetailImageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductVariantDetailImageQuery, ProductVariantDetailImageQueryVariables>(ProductVariantDetailImageDocument, options);
        }
export type ProductVariantDetailImageQueryHookResult = ReturnType<typeof useProductVariantDetailImageQuery>;
export type ProductVariantDetailImageLazyQueryHookResult = ReturnType<typeof useProductVariantDetailImageLazyQuery>;
export type ProductVariantDetailImageSuspenseQueryHookResult = ReturnType<typeof useProductVariantDetailImageSuspenseQuery>;
export type ProductVariantDetailImageQueryResult = Apollo.QueryResult<ProductVariantDetailImageQuery, ProductVariantDetailImageQueryVariables>;
export const ProductVariantEyewearBasicDetailsDocument = gql`
    query ProductVariantEyewearBasicDetails($sku: String!, $channel: String, $languageCode: LanguageCodeEnum!, $thumbnailSize: Int!, $largeMediaSize: Int!, $imagesFormat: ThumbnailFormatEnum!) {
  productVariant(sku: $sku, channel: $channel) {
    ...ProductVariantEyewearBasicDetails
  }
}
    ${ProductVariantEyewearBasicDetailsFragmentDoc}
${TaxedMoneyFragmentDoc}
${MoneyFragmentDoc}
${ProductUrlBaseFragmentDoc}
${DropdownAttributeFragmentDoc}
${ProductTypeFragmentDoc}
${MultiselectAttributeFragmentDoc}
${ImageFragmentDoc}
${ProductMediaFragmentDoc}
${EyewearAttributesFragmentDoc}
${NumericAttributeFragmentDoc}`;

/**
 * __useProductVariantEyewearBasicDetailsQuery__
 *
 * To run a query within a React component, call `useProductVariantEyewearBasicDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductVariantEyewearBasicDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductVariantEyewearBasicDetailsQuery({
 *   variables: {
 *      sku: // value for 'sku'
 *      channel: // value for 'channel'
 *      languageCode: // value for 'languageCode'
 *      thumbnailSize: // value for 'thumbnailSize'
 *      largeMediaSize: // value for 'largeMediaSize'
 *      imagesFormat: // value for 'imagesFormat'
 *   },
 * });
 */
export function useProductVariantEyewearBasicDetailsQuery(baseOptions: Apollo.QueryHookOptions<ProductVariantEyewearBasicDetailsQuery, ProductVariantEyewearBasicDetailsQueryVariables> & ({ variables: ProductVariantEyewearBasicDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductVariantEyewearBasicDetailsQuery, ProductVariantEyewearBasicDetailsQueryVariables>(ProductVariantEyewearBasicDetailsDocument, options);
      }
export function useProductVariantEyewearBasicDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductVariantEyewearBasicDetailsQuery, ProductVariantEyewearBasicDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductVariantEyewearBasicDetailsQuery, ProductVariantEyewearBasicDetailsQueryVariables>(ProductVariantEyewearBasicDetailsDocument, options);
        }
export function useProductVariantEyewearBasicDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductVariantEyewearBasicDetailsQuery, ProductVariantEyewearBasicDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductVariantEyewearBasicDetailsQuery, ProductVariantEyewearBasicDetailsQueryVariables>(ProductVariantEyewearBasicDetailsDocument, options);
        }
export type ProductVariantEyewearBasicDetailsQueryHookResult = ReturnType<typeof useProductVariantEyewearBasicDetailsQuery>;
export type ProductVariantEyewearBasicDetailsLazyQueryHookResult = ReturnType<typeof useProductVariantEyewearBasicDetailsLazyQuery>;
export type ProductVariantEyewearBasicDetailsSuspenseQueryHookResult = ReturnType<typeof useProductVariantEyewearBasicDetailsSuspenseQuery>;
export type ProductVariantEyewearBasicDetailsQueryResult = Apollo.QueryResult<ProductVariantEyewearBasicDetailsQuery, ProductVariantEyewearBasicDetailsQueryVariables>;
export const ProductVariantPriceDocument = gql`
    query ProductVariantPrice($sku: String!, $channel: String!) {
  productVariant(sku: $sku, channel: $channel) {
    pricing {
      price {
        ...TaxedMoney
      }
    }
  }
}
    ${TaxedMoneyFragmentDoc}
${MoneyFragmentDoc}`;

/**
 * __useProductVariantPriceQuery__
 *
 * To run a query within a React component, call `useProductVariantPriceQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductVariantPriceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductVariantPriceQuery({
 *   variables: {
 *      sku: // value for 'sku'
 *      channel: // value for 'channel'
 *   },
 * });
 */
export function useProductVariantPriceQuery(baseOptions: Apollo.QueryHookOptions<ProductVariantPriceQuery, ProductVariantPriceQueryVariables> & ({ variables: ProductVariantPriceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductVariantPriceQuery, ProductVariantPriceQueryVariables>(ProductVariantPriceDocument, options);
      }
export function useProductVariantPriceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductVariantPriceQuery, ProductVariantPriceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductVariantPriceQuery, ProductVariantPriceQueryVariables>(ProductVariantPriceDocument, options);
        }
export function useProductVariantPriceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductVariantPriceQuery, ProductVariantPriceQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductVariantPriceQuery, ProductVariantPriceQueryVariables>(ProductVariantPriceDocument, options);
        }
export type ProductVariantPriceQueryHookResult = ReturnType<typeof useProductVariantPriceQuery>;
export type ProductVariantPriceLazyQueryHookResult = ReturnType<typeof useProductVariantPriceLazyQuery>;
export type ProductVariantPriceSuspenseQueryHookResult = ReturnType<typeof useProductVariantPriceSuspenseQuery>;
export type ProductVariantPriceQueryResult = Apollo.QueryResult<ProductVariantPriceQuery, ProductVariantPriceQueryVariables>;
export const ProductVariantStrapBasicDetailsDocument = gql`
    query ProductVariantStrapBasicDetails($sku: String!, $channel: String, $languageCode: LanguageCodeEnum!, $thumbnailSize: Int!, $largeMediaSize: Int!, $imagesFormat: ThumbnailFormatEnum!) {
  productVariant(sku: $sku, channel: $channel) {
    ...ProductVariantStrapBasicDetails
  }
}
    ${ProductVariantStrapBasicDetailsFragmentDoc}
${ProductUrlBaseFragmentDoc}
${DropdownAttributeFragmentDoc}
${ProductTypeFragmentDoc}
${MultiselectAttributeFragmentDoc}
${ImageFragmentDoc}
${ProductMediaFragmentDoc}
${StrapAttributesFragmentDoc}
${BoolAttributeFragmentDoc}`;

/**
 * __useProductVariantStrapBasicDetailsQuery__
 *
 * To run a query within a React component, call `useProductVariantStrapBasicDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductVariantStrapBasicDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductVariantStrapBasicDetailsQuery({
 *   variables: {
 *      sku: // value for 'sku'
 *      channel: // value for 'channel'
 *      languageCode: // value for 'languageCode'
 *      thumbnailSize: // value for 'thumbnailSize'
 *      largeMediaSize: // value for 'largeMediaSize'
 *      imagesFormat: // value for 'imagesFormat'
 *   },
 * });
 */
export function useProductVariantStrapBasicDetailsQuery(baseOptions: Apollo.QueryHookOptions<ProductVariantStrapBasicDetailsQuery, ProductVariantStrapBasicDetailsQueryVariables> & ({ variables: ProductVariantStrapBasicDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductVariantStrapBasicDetailsQuery, ProductVariantStrapBasicDetailsQueryVariables>(ProductVariantStrapBasicDetailsDocument, options);
      }
export function useProductVariantStrapBasicDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductVariantStrapBasicDetailsQuery, ProductVariantStrapBasicDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductVariantStrapBasicDetailsQuery, ProductVariantStrapBasicDetailsQueryVariables>(ProductVariantStrapBasicDetailsDocument, options);
        }
export function useProductVariantStrapBasicDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductVariantStrapBasicDetailsQuery, ProductVariantStrapBasicDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductVariantStrapBasicDetailsQuery, ProductVariantStrapBasicDetailsQueryVariables>(ProductVariantStrapBasicDetailsDocument, options);
        }
export type ProductVariantStrapBasicDetailsQueryHookResult = ReturnType<typeof useProductVariantStrapBasicDetailsQuery>;
export type ProductVariantStrapBasicDetailsLazyQueryHookResult = ReturnType<typeof useProductVariantStrapBasicDetailsLazyQuery>;
export type ProductVariantStrapBasicDetailsSuspenseQueryHookResult = ReturnType<typeof useProductVariantStrapBasicDetailsSuspenseQuery>;
export type ProductVariantStrapBasicDetailsQueryResult = Apollo.QueryResult<ProductVariantStrapBasicDetailsQuery, ProductVariantStrapBasicDetailsQueryVariables>;
export const ProductVariantStrapDetailsDocument = gql`
    query ProductVariantStrapDetails($sku: String!, $channel: String!, $languageCode: LanguageCodeEnum!) {
  productVariant(sku: $sku, channel: $channel) {
    ...ProductVariantStrapDetails
  }
}
    ${ProductVariantStrapDetailsFragmentDoc}
${TaxedMoneyFragmentDoc}
${MoneyFragmentDoc}
${StrapAttributesFragmentDoc}
${MultiselectAttributeFragmentDoc}
${BoolAttributeFragmentDoc}
${DropdownAttributeFragmentDoc}`;

/**
 * __useProductVariantStrapDetailsQuery__
 *
 * To run a query within a React component, call `useProductVariantStrapDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductVariantStrapDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductVariantStrapDetailsQuery({
 *   variables: {
 *      sku: // value for 'sku'
 *      channel: // value for 'channel'
 *      languageCode: // value for 'languageCode'
 *   },
 * });
 */
export function useProductVariantStrapDetailsQuery(baseOptions: Apollo.QueryHookOptions<ProductVariantStrapDetailsQuery, ProductVariantStrapDetailsQueryVariables> & ({ variables: ProductVariantStrapDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductVariantStrapDetailsQuery, ProductVariantStrapDetailsQueryVariables>(ProductVariantStrapDetailsDocument, options);
      }
export function useProductVariantStrapDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductVariantStrapDetailsQuery, ProductVariantStrapDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductVariantStrapDetailsQuery, ProductVariantStrapDetailsQueryVariables>(ProductVariantStrapDetailsDocument, options);
        }
export function useProductVariantStrapDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductVariantStrapDetailsQuery, ProductVariantStrapDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductVariantStrapDetailsQuery, ProductVariantStrapDetailsQueryVariables>(ProductVariantStrapDetailsDocument, options);
        }
export type ProductVariantStrapDetailsQueryHookResult = ReturnType<typeof useProductVariantStrapDetailsQuery>;
export type ProductVariantStrapDetailsLazyQueryHookResult = ReturnType<typeof useProductVariantStrapDetailsLazyQuery>;
export type ProductVariantStrapDetailsSuspenseQueryHookResult = ReturnType<typeof useProductVariantStrapDetailsSuspenseQuery>;
export type ProductVariantStrapDetailsQueryResult = Apollo.QueryResult<ProductVariantStrapDetailsQuery, ProductVariantStrapDetailsQueryVariables>;
export const ProductVariantWatchBasicDetailsDocument = gql`
    query ProductVariantWatchBasicDetails($sku: String!, $channel: String, $languageCode: LanguageCodeEnum!, $thumbnailSize: Int!, $largeMediaSize: Int!, $imagesFormat: ThumbnailFormatEnum!) {
  productVariant(sku: $sku, channel: $channel) {
    ...ProductVariantWatchBasicDetails
  }
}
    ${ProductVariantWatchBasicDetailsFragmentDoc}
${TaxedMoneyFragmentDoc}
${MoneyFragmentDoc}
${ProductUrlBaseFragmentDoc}
${DropdownAttributeFragmentDoc}
${ProductTypeFragmentDoc}
${MultiselectAttributeFragmentDoc}
${ProductMediaFragmentDoc}
${WatchAttributesFragmentDoc}
${BoolAttributeFragmentDoc}
${NumericAttributeFragmentDoc}
${ImageFragmentDoc}`;

/**
 * __useProductVariantWatchBasicDetailsQuery__
 *
 * To run a query within a React component, call `useProductVariantWatchBasicDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductVariantWatchBasicDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductVariantWatchBasicDetailsQuery({
 *   variables: {
 *      sku: // value for 'sku'
 *      channel: // value for 'channel'
 *      languageCode: // value for 'languageCode'
 *      thumbnailSize: // value for 'thumbnailSize'
 *      largeMediaSize: // value for 'largeMediaSize'
 *      imagesFormat: // value for 'imagesFormat'
 *   },
 * });
 */
export function useProductVariantWatchBasicDetailsQuery(baseOptions: Apollo.QueryHookOptions<ProductVariantWatchBasicDetailsQuery, ProductVariantWatchBasicDetailsQueryVariables> & ({ variables: ProductVariantWatchBasicDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductVariantWatchBasicDetailsQuery, ProductVariantWatchBasicDetailsQueryVariables>(ProductVariantWatchBasicDetailsDocument, options);
      }
export function useProductVariantWatchBasicDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductVariantWatchBasicDetailsQuery, ProductVariantWatchBasicDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductVariantWatchBasicDetailsQuery, ProductVariantWatchBasicDetailsQueryVariables>(ProductVariantWatchBasicDetailsDocument, options);
        }
export function useProductVariantWatchBasicDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductVariantWatchBasicDetailsQuery, ProductVariantWatchBasicDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductVariantWatchBasicDetailsQuery, ProductVariantWatchBasicDetailsQueryVariables>(ProductVariantWatchBasicDetailsDocument, options);
        }
export type ProductVariantWatchBasicDetailsQueryHookResult = ReturnType<typeof useProductVariantWatchBasicDetailsQuery>;
export type ProductVariantWatchBasicDetailsLazyQueryHookResult = ReturnType<typeof useProductVariantWatchBasicDetailsLazyQuery>;
export type ProductVariantWatchBasicDetailsSuspenseQueryHookResult = ReturnType<typeof useProductVariantWatchBasicDetailsSuspenseQuery>;
export type ProductVariantWatchBasicDetailsQueryResult = Apollo.QueryResult<ProductVariantWatchBasicDetailsQuery, ProductVariantWatchBasicDetailsQueryVariables>;
export const ProductVariantWatchDetailsDocument = gql`
    query ProductVariantWatchDetails($sku: String!, $channel: String!, $languageCode: LanguageCodeEnum!) {
  productVariant(sku: $sku, channel: $channel) {
    ...ProductVariantWatchDetails
  }
}
    ${ProductVariantWatchDetailsFragmentDoc}
${TaxedMoneyFragmentDoc}
${MoneyFragmentDoc}
${WatchAttributesFragmentDoc}
${MultiselectAttributeFragmentDoc}
${DropdownAttributeFragmentDoc}
${BoolAttributeFragmentDoc}
${NumericAttributeFragmentDoc}`;

/**
 * __useProductVariantWatchDetailsQuery__
 *
 * To run a query within a React component, call `useProductVariantWatchDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductVariantWatchDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductVariantWatchDetailsQuery({
 *   variables: {
 *      sku: // value for 'sku'
 *      channel: // value for 'channel'
 *      languageCode: // value for 'languageCode'
 *   },
 * });
 */
export function useProductVariantWatchDetailsQuery(baseOptions: Apollo.QueryHookOptions<ProductVariantWatchDetailsQuery, ProductVariantWatchDetailsQueryVariables> & ({ variables: ProductVariantWatchDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductVariantWatchDetailsQuery, ProductVariantWatchDetailsQueryVariables>(ProductVariantWatchDetailsDocument, options);
      }
export function useProductVariantWatchDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductVariantWatchDetailsQuery, ProductVariantWatchDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductVariantWatchDetailsQuery, ProductVariantWatchDetailsQueryVariables>(ProductVariantWatchDetailsDocument, options);
        }
export function useProductVariantWatchDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductVariantWatchDetailsQuery, ProductVariantWatchDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductVariantWatchDetailsQuery, ProductVariantWatchDetailsQueryVariables>(ProductVariantWatchDetailsDocument, options);
        }
export type ProductVariantWatchDetailsQueryHookResult = ReturnType<typeof useProductVariantWatchDetailsQuery>;
export type ProductVariantWatchDetailsLazyQueryHookResult = ReturnType<typeof useProductVariantWatchDetailsLazyQuery>;
export type ProductVariantWatchDetailsSuspenseQueryHookResult = ReturnType<typeof useProductVariantWatchDetailsSuspenseQuery>;
export type ProductVariantWatchDetailsQueryResult = Apollo.QueryResult<ProductVariantWatchDetailsQuery, ProductVariantWatchDetailsQueryVariables>;
export const ProductVariantsBySkusDocument = gql`
    query productVariantsBySkus($watchskus: [String!]!, $strapskus: [String!]!, $channel: String, $languageCode: LanguageCodeEnum!, $thumbnailSize: Int!, $imagesFormat: ThumbnailFormatEnum!, $largeMediaSize: Int!) {
  watchs: productVariants(
    filter: {sku: $watchskus}
    channel: $channel
    first: 100
  ) {
    totalCount
    edges {
      node {
        ...ProductVariantWatchSku
      }
    }
  }
  straps: productVariants(
    filter: {sku: $strapskus}
    channel: $channel
    first: 100
  ) {
    totalCount
    edges {
      node {
        ...ProductVariantStrapSku
      }
    }
  }
}
    ${ProductVariantWatchSkuFragmentDoc}
${ProductUrlBaseFragmentDoc}
${DropdownAttributeFragmentDoc}
${ProductTypeFragmentDoc}
${MultiselectAttributeFragmentDoc}
${VariantPricingFragmentDoc}
${TaxedMoneyFragmentDoc}
${MoneyFragmentDoc}
${ProductMediaFragmentDoc}
${ImageFragmentDoc}
${WatchAttributesFragmentDoc}
${BoolAttributeFragmentDoc}
${NumericAttributeFragmentDoc}
${ProductVariantStrapSkuFragmentDoc}`;

/**
 * __useProductVariantsBySkusQuery__
 *
 * To run a query within a React component, call `useProductVariantsBySkusQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductVariantsBySkusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductVariantsBySkusQuery({
 *   variables: {
 *      watchskus: // value for 'watchskus'
 *      strapskus: // value for 'strapskus'
 *      channel: // value for 'channel'
 *      languageCode: // value for 'languageCode'
 *      thumbnailSize: // value for 'thumbnailSize'
 *      imagesFormat: // value for 'imagesFormat'
 *      largeMediaSize: // value for 'largeMediaSize'
 *   },
 * });
 */
export function useProductVariantsBySkusQuery(baseOptions: Apollo.QueryHookOptions<ProductVariantsBySkusQuery, ProductVariantsBySkusQueryVariables> & ({ variables: ProductVariantsBySkusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductVariantsBySkusQuery, ProductVariantsBySkusQueryVariables>(ProductVariantsBySkusDocument, options);
      }
export function useProductVariantsBySkusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductVariantsBySkusQuery, ProductVariantsBySkusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductVariantsBySkusQuery, ProductVariantsBySkusQueryVariables>(ProductVariantsBySkusDocument, options);
        }
export function useProductVariantsBySkusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductVariantsBySkusQuery, ProductVariantsBySkusQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductVariantsBySkusQuery, ProductVariantsBySkusQueryVariables>(ProductVariantsBySkusDocument, options);
        }
export type ProductVariantsBySkusQueryHookResult = ReturnType<typeof useProductVariantsBySkusQuery>;
export type ProductVariantsBySkusLazyQueryHookResult = ReturnType<typeof useProductVariantsBySkusLazyQuery>;
export type ProductVariantsBySkusSuspenseQueryHookResult = ReturnType<typeof useProductVariantsBySkusSuspenseQuery>;
export type ProductVariantsBySkusQueryResult = Apollo.QueryResult<ProductVariantsBySkusQuery, ProductVariantsBySkusQueryVariables>;
export const ProductsByCategoryDocument = gql`
    query ProductsByCategory($categoryId: ID!) {
  products(filter: {categories: [$categoryId]}, first: 100) {
    edges {
      node {
        id
        slug
        name
      }
    }
  }
}
    `;

/**
 * __useProductsByCategoryQuery__
 *
 * To run a query within a React component, call `useProductsByCategoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductsByCategoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductsByCategoryQuery({
 *   variables: {
 *      categoryId: // value for 'categoryId'
 *   },
 * });
 */
export function useProductsByCategoryQuery(baseOptions: Apollo.QueryHookOptions<ProductsByCategoryQuery, ProductsByCategoryQueryVariables> & ({ variables: ProductsByCategoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductsByCategoryQuery, ProductsByCategoryQueryVariables>(ProductsByCategoryDocument, options);
      }
export function useProductsByCategoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductsByCategoryQuery, ProductsByCategoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductsByCategoryQuery, ProductsByCategoryQueryVariables>(ProductsByCategoryDocument, options);
        }
export function useProductsByCategorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductsByCategoryQuery, ProductsByCategoryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductsByCategoryQuery, ProductsByCategoryQueryVariables>(ProductsByCategoryDocument, options);
        }
export type ProductsByCategoryQueryHookResult = ReturnType<typeof useProductsByCategoryQuery>;
export type ProductsByCategoryLazyQueryHookResult = ReturnType<typeof useProductsByCategoryLazyQuery>;
export type ProductsByCategorySuspenseQueryHookResult = ReturnType<typeof useProductsByCategorySuspenseQuery>;
export type ProductsByCategoryQueryResult = Apollo.QueryResult<ProductsByCategoryQuery, ProductsByCategoryQueryVariables>;
export const ProductsByCollectionDocument = gql`
    query ProductsByCollection($collectionId: ID!) {
  products(filter: {collections: [$collectionId]}, first: 100) {
    edges {
      node {
        id
        slug
        name
      }
    }
  }
}
    `;

/**
 * __useProductsByCollectionQuery__
 *
 * To run a query within a React component, call `useProductsByCollectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductsByCollectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductsByCollectionQuery({
 *   variables: {
 *      collectionId: // value for 'collectionId'
 *   },
 * });
 */
export function useProductsByCollectionQuery(baseOptions: Apollo.QueryHookOptions<ProductsByCollectionQuery, ProductsByCollectionQueryVariables> & ({ variables: ProductsByCollectionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductsByCollectionQuery, ProductsByCollectionQueryVariables>(ProductsByCollectionDocument, options);
      }
export function useProductsByCollectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductsByCollectionQuery, ProductsByCollectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductsByCollectionQuery, ProductsByCollectionQueryVariables>(ProductsByCollectionDocument, options);
        }
export function useProductsByCollectionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductsByCollectionQuery, ProductsByCollectionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductsByCollectionQuery, ProductsByCollectionQueryVariables>(ProductsByCollectionDocument, options);
        }
export type ProductsByCollectionQueryHookResult = ReturnType<typeof useProductsByCollectionQuery>;
export type ProductsByCollectionLazyQueryHookResult = ReturnType<typeof useProductsByCollectionLazyQuery>;
export type ProductsByCollectionSuspenseQueryHookResult = ReturnType<typeof useProductsByCollectionSuspenseQuery>;
export type ProductsByCollectionQueryResult = Apollo.QueryResult<ProductsByCollectionQuery, ProductsByCollectionQueryVariables>;
export const ProductsByIdsDocument = gql`
    query ProductsByIds($channel: String!, $filter: ProductFilterInput!, $languageCode: LanguageCodeEnum!) {
  products(channel: $channel, filter: $filter, first: 10) {
    edges {
      node {
        name
        translation(languageCode: $languageCode) {
          name
        }
        thumbnail {
          url
          alt
        }
      }
    }
  }
}
    `;

/**
 * __useProductsByIdsQuery__
 *
 * To run a query within a React component, call `useProductsByIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductsByIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductsByIdsQuery({
 *   variables: {
 *      channel: // value for 'channel'
 *      filter: // value for 'filter'
 *      languageCode: // value for 'languageCode'
 *   },
 * });
 */
export function useProductsByIdsQuery(baseOptions: Apollo.QueryHookOptions<ProductsByIdsQuery, ProductsByIdsQueryVariables> & ({ variables: ProductsByIdsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductsByIdsQuery, ProductsByIdsQueryVariables>(ProductsByIdsDocument, options);
      }
export function useProductsByIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductsByIdsQuery, ProductsByIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductsByIdsQuery, ProductsByIdsQueryVariables>(ProductsByIdsDocument, options);
        }
export function useProductsByIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductsByIdsQuery, ProductsByIdsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductsByIdsQuery, ProductsByIdsQueryVariables>(ProductsByIdsDocument, options);
        }
export type ProductsByIdsQueryHookResult = ReturnType<typeof useProductsByIdsQuery>;
export type ProductsByIdsLazyQueryHookResult = ReturnType<typeof useProductsByIdsLazyQuery>;
export type ProductsByIdsSuspenseQueryHookResult = ReturnType<typeof useProductsByIdsSuspenseQuery>;
export type ProductsByIdsQueryResult = Apollo.QueryResult<ProductsByIdsQuery, ProductsByIdsQueryVariables>;
export const ProductsByMarketingPartnerDocument = gql`
    query ProductsByMarketingPartner($modelName: String!, $marketingPartner: String!, $strapMaterial: String!) {
  products(
    first: 32
    filter: {attributes: [{slug: "com-model", values: [$modelName]}, {slug: "com-marketing-partner", values: [$marketingPartner]}, {slug: "wbr-material-mktg", values: [$strapMaterial]}]}
  ) {
    edges {
      node {
        id
        name
        slug
        attributes {
          attribute {
            id
            name
            slug
            inputType
          }
          values {
            name
            externalReference
            slug
            inputType
          }
        }
      }
    }
  }
}
    `;

/**
 * __useProductsByMarketingPartnerQuery__
 *
 * To run a query within a React component, call `useProductsByMarketingPartnerQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductsByMarketingPartnerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductsByMarketingPartnerQuery({
 *   variables: {
 *      modelName: // value for 'modelName'
 *      marketingPartner: // value for 'marketingPartner'
 *      strapMaterial: // value for 'strapMaterial'
 *   },
 * });
 */
export function useProductsByMarketingPartnerQuery(baseOptions: Apollo.QueryHookOptions<ProductsByMarketingPartnerQuery, ProductsByMarketingPartnerQueryVariables> & ({ variables: ProductsByMarketingPartnerQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductsByMarketingPartnerQuery, ProductsByMarketingPartnerQueryVariables>(ProductsByMarketingPartnerDocument, options);
      }
export function useProductsByMarketingPartnerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductsByMarketingPartnerQuery, ProductsByMarketingPartnerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductsByMarketingPartnerQuery, ProductsByMarketingPartnerQueryVariables>(ProductsByMarketingPartnerDocument, options);
        }
export function useProductsByMarketingPartnerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductsByMarketingPartnerQuery, ProductsByMarketingPartnerQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductsByMarketingPartnerQuery, ProductsByMarketingPartnerQueryVariables>(ProductsByMarketingPartnerDocument, options);
        }
export type ProductsByMarketingPartnerQueryHookResult = ReturnType<typeof useProductsByMarketingPartnerQuery>;
export type ProductsByMarketingPartnerLazyQueryHookResult = ReturnType<typeof useProductsByMarketingPartnerLazyQuery>;
export type ProductsByMarketingPartnerSuspenseQueryHookResult = ReturnType<typeof useProductsByMarketingPartnerSuspenseQuery>;
export type ProductsByMarketingPartnerQueryResult = Apollo.QueryResult<ProductsByMarketingPartnerQuery, ProductsByMarketingPartnerQueryVariables>;
export const ProductsBySkusDocument = gql`
    query ProductsBySkus($skus: [String!]!, $languageCode: LanguageCodeEnum!, $thumbnailSize: Int!, $imagesFormat: ThumbnailFormatEnum!, $largeMediaSize: Int!) {
  products(filter: {slugs: $skus}, first: 100) {
    edges {
      node {
        ...ProductSku
      }
    }
  }
}
    ${ProductSkuFragmentDoc}
${ProductUrlBaseFragmentDoc}
${DropdownAttributeFragmentDoc}
${ProductTypeFragmentDoc}
${MultiselectAttributeFragmentDoc}
${VariantPricingFragmentDoc}
${TaxedMoneyFragmentDoc}
${MoneyFragmentDoc}
${ProductMediaFragmentDoc}
${ImageFragmentDoc}
${BoolAttributeFragmentDoc}
${WatchAttributesFragmentDoc}
${NumericAttributeFragmentDoc}
${EyewearAttributesFragmentDoc}`;

/**
 * __useProductsBySkusQuery__
 *
 * To run a query within a React component, call `useProductsBySkusQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductsBySkusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductsBySkusQuery({
 *   variables: {
 *      skus: // value for 'skus'
 *      languageCode: // value for 'languageCode'
 *      thumbnailSize: // value for 'thumbnailSize'
 *      imagesFormat: // value for 'imagesFormat'
 *      largeMediaSize: // value for 'largeMediaSize'
 *   },
 * });
 */
export function useProductsBySkusQuery(baseOptions: Apollo.QueryHookOptions<ProductsBySkusQuery, ProductsBySkusQueryVariables> & ({ variables: ProductsBySkusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductsBySkusQuery, ProductsBySkusQueryVariables>(ProductsBySkusDocument, options);
      }
export function useProductsBySkusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductsBySkusQuery, ProductsBySkusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductsBySkusQuery, ProductsBySkusQueryVariables>(ProductsBySkusDocument, options);
        }
export function useProductsBySkusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductsBySkusQuery, ProductsBySkusQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductsBySkusQuery, ProductsBySkusQueryVariables>(ProductsBySkusDocument, options);
        }
export type ProductsBySkusQueryHookResult = ReturnType<typeof useProductsBySkusQuery>;
export type ProductsBySkusLazyQueryHookResult = ReturnType<typeof useProductsBySkusLazyQuery>;
export type ProductsBySkusSuspenseQueryHookResult = ReturnType<typeof useProductsBySkusSuspenseQuery>;
export type ProductsBySkusQueryResult = Apollo.QueryResult<ProductsBySkusQuery, ProductsBySkusQueryVariables>;
export const ReportProductSalesDocument = gql`
    query reportProductSales($first: Int, $channel: String!, $salePeriod: ReportingPeriod!, $languageCode: LanguageCodeEnum!, $thumbnailSize: Int!, $imagesFormat: ThumbnailFormatEnum!) {
  reportProductSales(first: $first, channel: $channel, period: $salePeriod) {
    edges {
      node {
        product {
          ...ProductCard
        }
      }
    }
  }
}
    ${ProductCardFragmentDoc}
${ProductUrlBaseFragmentDoc}
${DropdownAttributeFragmentDoc}
${ProductTypeFragmentDoc}
${MultiselectAttributeFragmentDoc}
${ImageFragmentDoc}
${ProductMediaFragmentDoc}
${VariantPricingFragmentDoc}
${TaxedMoneyFragmentDoc}
${MoneyFragmentDoc}
${BoolAttributeFragmentDoc}
${NumericAttributeFragmentDoc}`;

/**
 * __useReportProductSalesQuery__
 *
 * To run a query within a React component, call `useReportProductSalesQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportProductSalesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportProductSalesQuery({
 *   variables: {
 *      first: // value for 'first'
 *      channel: // value for 'channel'
 *      salePeriod: // value for 'salePeriod'
 *      languageCode: // value for 'languageCode'
 *      thumbnailSize: // value for 'thumbnailSize'
 *      imagesFormat: // value for 'imagesFormat'
 *   },
 * });
 */
export function useReportProductSalesQuery(baseOptions: Apollo.QueryHookOptions<ReportProductSalesQuery, ReportProductSalesQueryVariables> & ({ variables: ReportProductSalesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportProductSalesQuery, ReportProductSalesQueryVariables>(ReportProductSalesDocument, options);
      }
export function useReportProductSalesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportProductSalesQuery, ReportProductSalesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportProductSalesQuery, ReportProductSalesQueryVariables>(ReportProductSalesDocument, options);
        }
export function useReportProductSalesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReportProductSalesQuery, ReportProductSalesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReportProductSalesQuery, ReportProductSalesQueryVariables>(ReportProductSalesDocument, options);
        }
export type ReportProductSalesQueryHookResult = ReturnType<typeof useReportProductSalesQuery>;
export type ReportProductSalesLazyQueryHookResult = ReturnType<typeof useReportProductSalesLazyQuery>;
export type ReportProductSalesSuspenseQueryHookResult = ReturnType<typeof useReportProductSalesSuspenseQuery>;
export type ReportProductSalesQueryResult = Apollo.QueryResult<ReportProductSalesQuery, ReportProductSalesQueryVariables>;
export const SearchStrapsPacksDocument = gql`
    query SearchStrapsPacks($channel: String!, $first: Int!, $query: String!, $after: String, $address: AddressInput, $isPublished: Boolean, $stockAvailability: StockAvailability, $productTypes: [ID!], $attributes: [AttributeInput!], $price: PriceRangeInput, $ids: [ID!]) {
  search: products(
    first: $first
    after: $after
    filter: {search: $query, isPublished: $isPublished, stockAvailability: $stockAvailability, productTypes: $productTypes, attributes: $attributes, price: $price, ids: $ids}
    channel: $channel
  ) {
    edges {
      node {
        id
        slug
        name
        productType {
          name
        }
        thumbnail(size: 256, format: WEBP) {
          url
          alt
        }
        variants {
          id
          name
          sku
          product {
            isAvailable
          }
          pricing(address: $address) {
            priceUndiscounted {
              gross {
                currency
                amount
              }
            }
            price {
              gross {
                currency
                amount
              }
            }
            onSale
          }
        }
        attributes {
          attribute {
            id
            name
          }
          values {
            id
            name
            value
            slug
            reference
          }
        }
      }
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
  }
}
    `;

/**
 * __useSearchStrapsPacksQuery__
 *
 * To run a query within a React component, call `useSearchStrapsPacksQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchStrapsPacksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchStrapsPacksQuery({
 *   variables: {
 *      channel: // value for 'channel'
 *      first: // value for 'first'
 *      query: // value for 'query'
 *      after: // value for 'after'
 *      address: // value for 'address'
 *      isPublished: // value for 'isPublished'
 *      stockAvailability: // value for 'stockAvailability'
 *      productTypes: // value for 'productTypes'
 *      attributes: // value for 'attributes'
 *      price: // value for 'price'
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useSearchStrapsPacksQuery(baseOptions: Apollo.QueryHookOptions<SearchStrapsPacksQuery, SearchStrapsPacksQueryVariables> & ({ variables: SearchStrapsPacksQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchStrapsPacksQuery, SearchStrapsPacksQueryVariables>(SearchStrapsPacksDocument, options);
      }
export function useSearchStrapsPacksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchStrapsPacksQuery, SearchStrapsPacksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchStrapsPacksQuery, SearchStrapsPacksQueryVariables>(SearchStrapsPacksDocument, options);
        }
export function useSearchStrapsPacksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchStrapsPacksQuery, SearchStrapsPacksQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchStrapsPacksQuery, SearchStrapsPacksQueryVariables>(SearchStrapsPacksDocument, options);
        }
export type SearchStrapsPacksQueryHookResult = ReturnType<typeof useSearchStrapsPacksQuery>;
export type SearchStrapsPacksLazyQueryHookResult = ReturnType<typeof useSearchStrapsPacksLazyQuery>;
export type SearchStrapsPacksSuspenseQueryHookResult = ReturnType<typeof useSearchStrapsPacksSuspenseQuery>;
export type SearchStrapsPacksQueryResult = Apollo.QueryResult<SearchStrapsPacksQuery, SearchStrapsPacksQueryVariables>;
export const ShopSettingsDeliveryViewDocument = gql`
    query ShopSettingsDeliveryView {
  shop {
    countries {
      ...Country
    }
    phonePrefixes
  }
}
    ${CountryFragmentDoc}`;

/**
 * __useShopSettingsDeliveryViewQuery__
 *
 * To run a query within a React component, call `useShopSettingsDeliveryViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useShopSettingsDeliveryViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShopSettingsDeliveryViewQuery({
 *   variables: {
 *   },
 * });
 */
export function useShopSettingsDeliveryViewQuery(baseOptions?: Apollo.QueryHookOptions<ShopSettingsDeliveryViewQuery, ShopSettingsDeliveryViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ShopSettingsDeliveryViewQuery, ShopSettingsDeliveryViewQueryVariables>(ShopSettingsDeliveryViewDocument, options);
      }
export function useShopSettingsDeliveryViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ShopSettingsDeliveryViewQuery, ShopSettingsDeliveryViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ShopSettingsDeliveryViewQuery, ShopSettingsDeliveryViewQueryVariables>(ShopSettingsDeliveryViewDocument, options);
        }
export function useShopSettingsDeliveryViewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ShopSettingsDeliveryViewQuery, ShopSettingsDeliveryViewQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ShopSettingsDeliveryViewQuery, ShopSettingsDeliveryViewQueryVariables>(ShopSettingsDeliveryViewDocument, options);
        }
export type ShopSettingsDeliveryViewQueryHookResult = ReturnType<typeof useShopSettingsDeliveryViewQuery>;
export type ShopSettingsDeliveryViewLazyQueryHookResult = ReturnType<typeof useShopSettingsDeliveryViewLazyQuery>;
export type ShopSettingsDeliveryViewSuspenseQueryHookResult = ReturnType<typeof useShopSettingsDeliveryViewSuspenseQuery>;
export type ShopSettingsDeliveryViewQueryResult = Apollo.QueryResult<ShopSettingsDeliveryViewQuery, ShopSettingsDeliveryViewQueryVariables>;
export const ShopSettingsSignUpViewDocument = gql`
    query ShopSettingsSignUpView {
  shop {
    phonePrefixes
  }
}
    `;

/**
 * __useShopSettingsSignUpViewQuery__
 *
 * To run a query within a React component, call `useShopSettingsSignUpViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useShopSettingsSignUpViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShopSettingsSignUpViewQuery({
 *   variables: {
 *   },
 * });
 */
export function useShopSettingsSignUpViewQuery(baseOptions?: Apollo.QueryHookOptions<ShopSettingsSignUpViewQuery, ShopSettingsSignUpViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ShopSettingsSignUpViewQuery, ShopSettingsSignUpViewQueryVariables>(ShopSettingsSignUpViewDocument, options);
      }
export function useShopSettingsSignUpViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ShopSettingsSignUpViewQuery, ShopSettingsSignUpViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ShopSettingsSignUpViewQuery, ShopSettingsSignUpViewQueryVariables>(ShopSettingsSignUpViewDocument, options);
        }
export function useShopSettingsSignUpViewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ShopSettingsSignUpViewQuery, ShopSettingsSignUpViewQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ShopSettingsSignUpViewQuery, ShopSettingsSignUpViewQueryVariables>(ShopSettingsSignUpViewDocument, options);
        }
export type ShopSettingsSignUpViewQueryHookResult = ReturnType<typeof useShopSettingsSignUpViewQuery>;
export type ShopSettingsSignUpViewLazyQueryHookResult = ReturnType<typeof useShopSettingsSignUpViewLazyQuery>;
export type ShopSettingsSignUpViewSuspenseQueryHookResult = ReturnType<typeof useShopSettingsSignUpViewSuspenseQuery>;
export type ShopSettingsSignUpViewQueryResult = Apollo.QueryResult<ShopSettingsSignUpViewQuery, ShopSettingsSignUpViewQueryVariables>;
export const ShoppingBagProductsDocument = gql`
    query ShoppingBagProducts($languageCode: LanguageCodeEnum!, $channel: String!, $filter: ProductVariantFilterInput!, $thumbnailSize: Int!, $imagesFormat: ThumbnailFormatEnum!) {
  productVariants(first: 100, channel: $channel, filter: $filter) {
    edges {
      node {
        ...ShoppingBagProduct
      }
    }
  }
}
    ${ShoppingBagProductFragmentDoc}
${LineProductFragmentDoc}
${VariantPricingFragmentDoc}
${TaxedMoneyFragmentDoc}
${MoneyFragmentDoc}
${DropdownAttributeFragmentDoc}
${MultiselectAttributeFragmentDoc}
${ProductMediaFragmentDoc}
${BoolAttributeFragmentDoc}
${ProductTypeFragmentDoc}
${ProductThumbnailFragmentDoc}
${ImageFragmentDoc}
${ProductUrlBaseFragmentDoc}`;

/**
 * __useShoppingBagProductsQuery__
 *
 * To run a query within a React component, call `useShoppingBagProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useShoppingBagProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShoppingBagProductsQuery({
 *   variables: {
 *      languageCode: // value for 'languageCode'
 *      channel: // value for 'channel'
 *      filter: // value for 'filter'
 *      thumbnailSize: // value for 'thumbnailSize'
 *      imagesFormat: // value for 'imagesFormat'
 *   },
 * });
 */
export function useShoppingBagProductsQuery(baseOptions: Apollo.QueryHookOptions<ShoppingBagProductsQuery, ShoppingBagProductsQueryVariables> & ({ variables: ShoppingBagProductsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ShoppingBagProductsQuery, ShoppingBagProductsQueryVariables>(ShoppingBagProductsDocument, options);
      }
export function useShoppingBagProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ShoppingBagProductsQuery, ShoppingBagProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ShoppingBagProductsQuery, ShoppingBagProductsQueryVariables>(ShoppingBagProductsDocument, options);
        }
export function useShoppingBagProductsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ShoppingBagProductsQuery, ShoppingBagProductsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ShoppingBagProductsQuery, ShoppingBagProductsQueryVariables>(ShoppingBagProductsDocument, options);
        }
export type ShoppingBagProductsQueryHookResult = ReturnType<typeof useShoppingBagProductsQuery>;
export type ShoppingBagProductsLazyQueryHookResult = ReturnType<typeof useShoppingBagProductsLazyQuery>;
export type ShoppingBagProductsSuspenseQueryHookResult = ReturnType<typeof useShoppingBagProductsSuspenseQuery>;
export type ShoppingBagProductsQueryResult = Apollo.QueryResult<ShoppingBagProductsQuery, ShoppingBagProductsQueryVariables>;
export const ShoppingBagStrapsModalDocument = gql`
    query ShoppingBagStrapsModal($languageCode: LanguageCodeEnum!, $filter: ProductFilterInput!, $channel: String!, $thumbnailSize: Int!, $imagesFormat: ThumbnailFormatEnum!) {
  products(filter: $filter, first: 100, channel: $channel) {
    edges {
      node {
        defaultVariant {
          ...ShoppingBagStrapsModal
        }
      }
    }
  }
}
    ${ShoppingBagStrapsModalFragmentDoc}
${TaxedMoneyFragmentDoc}
${MoneyFragmentDoc}
${MultiselectAttributeFragmentDoc}
${BoolAttributeFragmentDoc}
${ProductThumbnailFragmentDoc}
${ImageFragmentDoc}
${ProductTypeFragmentDoc}`;

/**
 * __useShoppingBagStrapsModalQuery__
 *
 * To run a query within a React component, call `useShoppingBagStrapsModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useShoppingBagStrapsModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShoppingBagStrapsModalQuery({
 *   variables: {
 *      languageCode: // value for 'languageCode'
 *      filter: // value for 'filter'
 *      channel: // value for 'channel'
 *      thumbnailSize: // value for 'thumbnailSize'
 *      imagesFormat: // value for 'imagesFormat'
 *   },
 * });
 */
export function useShoppingBagStrapsModalQuery(baseOptions: Apollo.QueryHookOptions<ShoppingBagStrapsModalQuery, ShoppingBagStrapsModalQueryVariables> & ({ variables: ShoppingBagStrapsModalQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ShoppingBagStrapsModalQuery, ShoppingBagStrapsModalQueryVariables>(ShoppingBagStrapsModalDocument, options);
      }
export function useShoppingBagStrapsModalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ShoppingBagStrapsModalQuery, ShoppingBagStrapsModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ShoppingBagStrapsModalQuery, ShoppingBagStrapsModalQueryVariables>(ShoppingBagStrapsModalDocument, options);
        }
export function useShoppingBagStrapsModalSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ShoppingBagStrapsModalQuery, ShoppingBagStrapsModalQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ShoppingBagStrapsModalQuery, ShoppingBagStrapsModalQueryVariables>(ShoppingBagStrapsModalDocument, options);
        }
export type ShoppingBagStrapsModalQueryHookResult = ReturnType<typeof useShoppingBagStrapsModalQuery>;
export type ShoppingBagStrapsModalLazyQueryHookResult = ReturnType<typeof useShoppingBagStrapsModalLazyQuery>;
export type ShoppingBagStrapsModalSuspenseQueryHookResult = ReturnType<typeof useShoppingBagStrapsModalSuspenseQuery>;
export type ShoppingBagStrapsModalQueryResult = Apollo.QueryResult<ShoppingBagStrapsModalQuery, ShoppingBagStrapsModalQueryVariables>;
export const SocialClubConsentOrderDocument = gql`
    query SocialClubConsentOrder($id: ID!) {
  order(id: $id) {
    id
    checkoutId: metafield(key: "checkout.id")
    orderFlowScTermsRequired: metafield(key: "orderFlow.scTermsRequired")
    orderFlowScTermsAccepted: metafield(key: "orderFlow.scTermsAccepted")
    userEmail
    channel {
      slug
    }
  }
}
    `;

/**
 * __useSocialClubConsentOrderQuery__
 *
 * To run a query within a React component, call `useSocialClubConsentOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useSocialClubConsentOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSocialClubConsentOrderQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSocialClubConsentOrderQuery(baseOptions: Apollo.QueryHookOptions<SocialClubConsentOrderQuery, SocialClubConsentOrderQueryVariables> & ({ variables: SocialClubConsentOrderQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SocialClubConsentOrderQuery, SocialClubConsentOrderQueryVariables>(SocialClubConsentOrderDocument, options);
      }
export function useSocialClubConsentOrderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SocialClubConsentOrderQuery, SocialClubConsentOrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SocialClubConsentOrderQuery, SocialClubConsentOrderQueryVariables>(SocialClubConsentOrderDocument, options);
        }
export function useSocialClubConsentOrderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SocialClubConsentOrderQuery, SocialClubConsentOrderQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SocialClubConsentOrderQuery, SocialClubConsentOrderQueryVariables>(SocialClubConsentOrderDocument, options);
        }
export type SocialClubConsentOrderQueryHookResult = ReturnType<typeof useSocialClubConsentOrderQuery>;
export type SocialClubConsentOrderLazyQueryHookResult = ReturnType<typeof useSocialClubConsentOrderLazyQuery>;
export type SocialClubConsentOrderSuspenseQueryHookResult = ReturnType<typeof useSocialClubConsentOrderSuspenseQuery>;
export type SocialClubConsentOrderQueryResult = Apollo.QueryResult<SocialClubConsentOrderQuery, SocialClubConsentOrderQueryVariables>;
export const StrapAddToBagProductsDocument = gql`
    query StrapAddToBagProducts($channel: String!, $limit: Int!, $filter: ProductVariantFilterInput, $thumbnailSize: Int!, $imagesFormat: ThumbnailFormatEnum!, $languageCode: LanguageCodeEnum!) {
  productVariants(channel: $channel, first: $limit, filter: $filter) {
    edges {
      node {
        ...AddToBagStrap
      }
    }
  }
}
    ${AddToBagStrapFragmentDoc}
${ProductTypeFragmentDoc}
${ProductThumbnailFragmentDoc}
${ImageFragmentDoc}
${MultiselectAttributeFragmentDoc}
${TaxedMoneyFragmentDoc}
${MoneyFragmentDoc}`;

/**
 * __useStrapAddToBagProductsQuery__
 *
 * To run a query within a React component, call `useStrapAddToBagProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useStrapAddToBagProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStrapAddToBagProductsQuery({
 *   variables: {
 *      channel: // value for 'channel'
 *      limit: // value for 'limit'
 *      filter: // value for 'filter'
 *      thumbnailSize: // value for 'thumbnailSize'
 *      imagesFormat: // value for 'imagesFormat'
 *      languageCode: // value for 'languageCode'
 *   },
 * });
 */
export function useStrapAddToBagProductsQuery(baseOptions: Apollo.QueryHookOptions<StrapAddToBagProductsQuery, StrapAddToBagProductsQueryVariables> & ({ variables: StrapAddToBagProductsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StrapAddToBagProductsQuery, StrapAddToBagProductsQueryVariables>(StrapAddToBagProductsDocument, options);
      }
export function useStrapAddToBagProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StrapAddToBagProductsQuery, StrapAddToBagProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StrapAddToBagProductsQuery, StrapAddToBagProductsQueryVariables>(StrapAddToBagProductsDocument, options);
        }
export function useStrapAddToBagProductsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<StrapAddToBagProductsQuery, StrapAddToBagProductsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<StrapAddToBagProductsQuery, StrapAddToBagProductsQueryVariables>(StrapAddToBagProductsDocument, options);
        }
export type StrapAddToBagProductsQueryHookResult = ReturnType<typeof useStrapAddToBagProductsQuery>;
export type StrapAddToBagProductsLazyQueryHookResult = ReturnType<typeof useStrapAddToBagProductsLazyQuery>;
export type StrapAddToBagProductsSuspenseQueryHookResult = ReturnType<typeof useStrapAddToBagProductsSuspenseQuery>;
export type StrapAddToBagProductsQueryResult = Apollo.QueryResult<StrapAddToBagProductsQuery, StrapAddToBagProductsQueryVariables>;
export const StrapAddToBagToolsDocument = gql`
    query StrapAddToBagTools($channel: String!, $limit: Int!, $filter: ProductFilterInput, $thumbnailSize: Int!, $imagesFormat: ThumbnailFormatEnum!, $languageCode: LanguageCodeEnum!) {
  products(channel: $channel, first: $limit, filter: $filter) {
    edges {
      node {
        defaultVariant {
          ...AddToBagStrap
        }
      }
    }
  }
}
    ${AddToBagStrapFragmentDoc}
${ProductTypeFragmentDoc}
${ProductThumbnailFragmentDoc}
${ImageFragmentDoc}
${MultiselectAttributeFragmentDoc}
${TaxedMoneyFragmentDoc}
${MoneyFragmentDoc}`;

/**
 * __useStrapAddToBagToolsQuery__
 *
 * To run a query within a React component, call `useStrapAddToBagToolsQuery` and pass it any options that fit your needs.
 * When your component renders, `useStrapAddToBagToolsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStrapAddToBagToolsQuery({
 *   variables: {
 *      channel: // value for 'channel'
 *      limit: // value for 'limit'
 *      filter: // value for 'filter'
 *      thumbnailSize: // value for 'thumbnailSize'
 *      imagesFormat: // value for 'imagesFormat'
 *      languageCode: // value for 'languageCode'
 *   },
 * });
 */
export function useStrapAddToBagToolsQuery(baseOptions: Apollo.QueryHookOptions<StrapAddToBagToolsQuery, StrapAddToBagToolsQueryVariables> & ({ variables: StrapAddToBagToolsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StrapAddToBagToolsQuery, StrapAddToBagToolsQueryVariables>(StrapAddToBagToolsDocument, options);
      }
export function useStrapAddToBagToolsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StrapAddToBagToolsQuery, StrapAddToBagToolsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StrapAddToBagToolsQuery, StrapAddToBagToolsQueryVariables>(StrapAddToBagToolsDocument, options);
        }
export function useStrapAddToBagToolsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<StrapAddToBagToolsQuery, StrapAddToBagToolsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<StrapAddToBagToolsQuery, StrapAddToBagToolsQueryVariables>(StrapAddToBagToolsDocument, options);
        }
export type StrapAddToBagToolsQueryHookResult = ReturnType<typeof useStrapAddToBagToolsQuery>;
export type StrapAddToBagToolsLazyQueryHookResult = ReturnType<typeof useStrapAddToBagToolsLazyQuery>;
export type StrapAddToBagToolsSuspenseQueryHookResult = ReturnType<typeof useStrapAddToBagToolsSuspenseQuery>;
export type StrapAddToBagToolsQueryResult = Apollo.QueryResult<StrapAddToBagToolsQuery, StrapAddToBagToolsQueryVariables>;
export const StrapBuckleSizesDocument = gql`
    query StrapBuckleSizes($languageCode: LanguageCodeEnum!, $limit: Int!, $filter: ProductFilterInput) {
  products(first: $limit, filter: $filter) {
    edges {
      node {
        size: attribute(slug: "wbu-size") {
          ...DropdownAttribute
        }
      }
    }
  }
}
    ${DropdownAttributeFragmentDoc}`;

/**
 * __useStrapBuckleSizesQuery__
 *
 * To run a query within a React component, call `useStrapBuckleSizesQuery` and pass it any options that fit your needs.
 * When your component renders, `useStrapBuckleSizesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStrapBuckleSizesQuery({
 *   variables: {
 *      languageCode: // value for 'languageCode'
 *      limit: // value for 'limit'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useStrapBuckleSizesQuery(baseOptions: Apollo.QueryHookOptions<StrapBuckleSizesQuery, StrapBuckleSizesQueryVariables> & ({ variables: StrapBuckleSizesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StrapBuckleSizesQuery, StrapBuckleSizesQueryVariables>(StrapBuckleSizesDocument, options);
      }
export function useStrapBuckleSizesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StrapBuckleSizesQuery, StrapBuckleSizesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StrapBuckleSizesQuery, StrapBuckleSizesQueryVariables>(StrapBuckleSizesDocument, options);
        }
export function useStrapBuckleSizesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<StrapBuckleSizesQuery, StrapBuckleSizesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<StrapBuckleSizesQuery, StrapBuckleSizesQueryVariables>(StrapBuckleSizesDocument, options);
        }
export type StrapBuckleSizesQueryHookResult = ReturnType<typeof useStrapBuckleSizesQuery>;
export type StrapBuckleSizesLazyQueryHookResult = ReturnType<typeof useStrapBuckleSizesLazyQuery>;
export type StrapBuckleSizesSuspenseQueryHookResult = ReturnType<typeof useStrapBuckleSizesSuspenseQuery>;
export type StrapBuckleSizesQueryResult = Apollo.QueryResult<StrapBuckleSizesQuery, StrapBuckleSizesQueryVariables>;
export const SearchSingleStrapPackDocument = gql`
    query SearchSingleStrapPack($channel: String!, $slug: String!) {
  product(slug: $slug, channel: $channel) {
    id
    slug
    name
    productType {
      name
    }
    thumbnail(size: 256, format: WEBP) {
      url
      alt
    }
    productVariants(first: 100) {
      totalCount
      edges {
        node {
          id
          name
          sku
          product {
            isAvailable
          }
          pricing {
            ...VariantPricing
          }
        }
      }
    }
    attributes {
      attribute {
        id
        name
      }
      values {
        id
        name
        value
        slug
        reference
      }
    }
  }
}
    ${VariantPricingFragmentDoc}
${TaxedMoneyFragmentDoc}
${MoneyFragmentDoc}`;

/**
 * __useSearchSingleStrapPackQuery__
 *
 * To run a query within a React component, call `useSearchSingleStrapPackQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchSingleStrapPackQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchSingleStrapPackQuery({
 *   variables: {
 *      channel: // value for 'channel'
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useSearchSingleStrapPackQuery(baseOptions: Apollo.QueryHookOptions<SearchSingleStrapPackQuery, SearchSingleStrapPackQueryVariables> & ({ variables: SearchSingleStrapPackQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchSingleStrapPackQuery, SearchSingleStrapPackQueryVariables>(SearchSingleStrapPackDocument, options);
      }
export function useSearchSingleStrapPackLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchSingleStrapPackQuery, SearchSingleStrapPackQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchSingleStrapPackQuery, SearchSingleStrapPackQueryVariables>(SearchSingleStrapPackDocument, options);
        }
export function useSearchSingleStrapPackSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchSingleStrapPackQuery, SearchSingleStrapPackQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchSingleStrapPackQuery, SearchSingleStrapPackQueryVariables>(SearchSingleStrapPackDocument, options);
        }
export type SearchSingleStrapPackQueryHookResult = ReturnType<typeof useSearchSingleStrapPackQuery>;
export type SearchSingleStrapPackLazyQueryHookResult = ReturnType<typeof useSearchSingleStrapPackLazyQuery>;
export type SearchSingleStrapPackSuspenseQueryHookResult = ReturnType<typeof useSearchSingleStrapPackSuspenseQuery>;
export type SearchSingleStrapPackQueryResult = Apollo.QueryResult<SearchSingleStrapPackQuery, SearchSingleStrapPackQueryVariables>;
export const StrapSizesDocument = gql`
    query StrapSizes($channel: String!, $languageCode: LanguageCodeEnum!, $limit: Int!, $filter: ProductVariantFilterInput!) {
  productVariants(channel: $channel, first: $limit, filter: $filter) {
    edges {
      node {
        id
        sku
        product {
          currentSize: attribute(slug: "wbr-current-size") {
            ...MultiselectAttribute
          }
          material: attribute(slug: "wbr-material-mktg") {
            ...MultiselectAttribute
          }
          ...ProductType
        }
      }
    }
  }
}
    ${MultiselectAttributeFragmentDoc}
${ProductTypeFragmentDoc}`;

/**
 * __useStrapSizesQuery__
 *
 * To run a query within a React component, call `useStrapSizesQuery` and pass it any options that fit your needs.
 * When your component renders, `useStrapSizesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStrapSizesQuery({
 *   variables: {
 *      channel: // value for 'channel'
 *      languageCode: // value for 'languageCode'
 *      limit: // value for 'limit'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useStrapSizesQuery(baseOptions: Apollo.QueryHookOptions<StrapSizesQuery, StrapSizesQueryVariables> & ({ variables: StrapSizesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StrapSizesQuery, StrapSizesQueryVariables>(StrapSizesDocument, options);
      }
export function useStrapSizesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StrapSizesQuery, StrapSizesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StrapSizesQuery, StrapSizesQueryVariables>(StrapSizesDocument, options);
        }
export function useStrapSizesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<StrapSizesQuery, StrapSizesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<StrapSizesQuery, StrapSizesQueryVariables>(StrapSizesDocument, options);
        }
export type StrapSizesQueryHookResult = ReturnType<typeof useStrapSizesQuery>;
export type StrapSizesLazyQueryHookResult = ReturnType<typeof useStrapSizesLazyQuery>;
export type StrapSizesSuspenseQueryHookResult = ReturnType<typeof useStrapSizesSuspenseQuery>;
export type StrapSizesQueryResult = Apollo.QueryResult<StrapSizesQuery, StrapSizesQueryVariables>;
export const UserCheckDocument = gql`
    query UserCheck($email: String, $id: ID, $externalReference: String) {
  user(email: $email, id: $id, externalReference: $externalReference) {
    id
    externalReference
    email
    isActive
    dateJoined
    lastLogin
    isClubMember: metafield(key: "user.is_club_member")
    isAffiliated: metafield(key: "user.is_affiliated")
  }
}
    `;

/**
 * __useUserCheckQuery__
 *
 * To run a query within a React component, call `useUserCheckQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserCheckQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserCheckQuery({
 *   variables: {
 *      email: // value for 'email'
 *      id: // value for 'id'
 *      externalReference: // value for 'externalReference'
 *   },
 * });
 */
export function useUserCheckQuery(baseOptions?: Apollo.QueryHookOptions<UserCheckQuery, UserCheckQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserCheckQuery, UserCheckQueryVariables>(UserCheckDocument, options);
      }
export function useUserCheckLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserCheckQuery, UserCheckQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserCheckQuery, UserCheckQueryVariables>(UserCheckDocument, options);
        }
export function useUserCheckSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserCheckQuery, UserCheckQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserCheckQuery, UserCheckQueryVariables>(UserCheckDocument, options);
        }
export type UserCheckQueryHookResult = ReturnType<typeof useUserCheckQuery>;
export type UserCheckLazyQueryHookResult = ReturnType<typeof useUserCheckLazyQuery>;
export type UserCheckSuspenseQueryHookResult = ReturnType<typeof useUserCheckSuspenseQuery>;
export type UserCheckQueryResult = Apollo.QueryResult<UserCheckQuery, UserCheckQueryVariables>;
export const UserCheckoutsDocument = gql`
    query UserCheckouts($userEmail: String!, $channel: String) {
  checkouts(
    channel: $channel
    sortBy: {field: CREATION_DATE, direction: DESC}
    filter: {customer: $userEmail}
    first: 20
  ) {
    edges {
      node {
        id
        created
        updatedAt
        orderBrand: metafield(key: "order.brand")
        brand: metafield(key: "brand")
        channel {
          slug
        }
        user {
          id
          email
        }
        lines {
          id
          quantity
        }
      }
    }
  }
}
    `;

/**
 * __useUserCheckoutsQuery__
 *
 * To run a query within a React component, call `useUserCheckoutsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserCheckoutsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserCheckoutsQuery({
 *   variables: {
 *      userEmail: // value for 'userEmail'
 *      channel: // value for 'channel'
 *   },
 * });
 */
export function useUserCheckoutsQuery(baseOptions: Apollo.QueryHookOptions<UserCheckoutsQuery, UserCheckoutsQueryVariables> & ({ variables: UserCheckoutsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserCheckoutsQuery, UserCheckoutsQueryVariables>(UserCheckoutsDocument, options);
      }
export function useUserCheckoutsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserCheckoutsQuery, UserCheckoutsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserCheckoutsQuery, UserCheckoutsQueryVariables>(UserCheckoutsDocument, options);
        }
export function useUserCheckoutsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserCheckoutsQuery, UserCheckoutsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserCheckoutsQuery, UserCheckoutsQueryVariables>(UserCheckoutsDocument, options);
        }
export type UserCheckoutsQueryHookResult = ReturnType<typeof useUserCheckoutsQuery>;
export type UserCheckoutsLazyQueryHookResult = ReturnType<typeof useUserCheckoutsLazyQuery>;
export type UserCheckoutsSuspenseQueryHookResult = ReturnType<typeof useUserCheckoutsSuspenseQuery>;
export type UserCheckoutsQueryResult = Apollo.QueryResult<UserCheckoutsQuery, UserCheckoutsQueryVariables>;
export const UserDetailsDocument = gql`
    query UserDetails {
  me {
    ...User
  }
}
    ${UserFragmentDoc}
${MetadataItemFragmentDoc}
${AddressFragmentDoc}`;

/**
 * __useUserDetailsQuery__
 *
 * To run a query within a React component, call `useUserDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserDetailsQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserDetailsQuery(baseOptions?: Apollo.QueryHookOptions<UserDetailsQuery, UserDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserDetailsQuery, UserDetailsQueryVariables>(UserDetailsDocument, options);
      }
export function useUserDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserDetailsQuery, UserDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserDetailsQuery, UserDetailsQueryVariables>(UserDetailsDocument, options);
        }
export function useUserDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserDetailsQuery, UserDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserDetailsQuery, UserDetailsQueryVariables>(UserDetailsDocument, options);
        }
export type UserDetailsQueryHookResult = ReturnType<typeof useUserDetailsQuery>;
export type UserDetailsLazyQueryHookResult = ReturnType<typeof useUserDetailsLazyQuery>;
export type UserDetailsSuspenseQueryHookResult = ReturnType<typeof useUserDetailsSuspenseQuery>;
export type UserDetailsQueryResult = Apollo.QueryResult<UserDetailsQuery, UserDetailsQueryVariables>;
export const WatchBasicDetailsForSkusDocument = gql`
    query WatchBasicDetailsForSkus($skus: [String!]!, $channel: String!, $thumbnailSize: Int!, $imagesFormat: ThumbnailFormatEnum!) {
  productVariants(filter: {sku: $skus}, channel: $channel, first: 100) {
    totalCount
    edges {
      node {
        ...WatchBasicDetailsForSkus
      }
    }
  }
}
    ${WatchBasicDetailsForSkusFragmentDoc}
${ImageFragmentDoc}`;

/**
 * __useWatchBasicDetailsForSkusQuery__
 *
 * To run a query within a React component, call `useWatchBasicDetailsForSkusQuery` and pass it any options that fit your needs.
 * When your component renders, `useWatchBasicDetailsForSkusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWatchBasicDetailsForSkusQuery({
 *   variables: {
 *      skus: // value for 'skus'
 *      channel: // value for 'channel'
 *      thumbnailSize: // value for 'thumbnailSize'
 *      imagesFormat: // value for 'imagesFormat'
 *   },
 * });
 */
export function useWatchBasicDetailsForSkusQuery(baseOptions: Apollo.QueryHookOptions<WatchBasicDetailsForSkusQuery, WatchBasicDetailsForSkusQueryVariables> & ({ variables: WatchBasicDetailsForSkusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WatchBasicDetailsForSkusQuery, WatchBasicDetailsForSkusQueryVariables>(WatchBasicDetailsForSkusDocument, options);
      }
export function useWatchBasicDetailsForSkusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WatchBasicDetailsForSkusQuery, WatchBasicDetailsForSkusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WatchBasicDetailsForSkusQuery, WatchBasicDetailsForSkusQueryVariables>(WatchBasicDetailsForSkusDocument, options);
        }
export function useWatchBasicDetailsForSkusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WatchBasicDetailsForSkusQuery, WatchBasicDetailsForSkusQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WatchBasicDetailsForSkusQuery, WatchBasicDetailsForSkusQueryVariables>(WatchBasicDetailsForSkusDocument, options);
        }
export type WatchBasicDetailsForSkusQueryHookResult = ReturnType<typeof useWatchBasicDetailsForSkusQuery>;
export type WatchBasicDetailsForSkusLazyQueryHookResult = ReturnType<typeof useWatchBasicDetailsForSkusLazyQuery>;
export type WatchBasicDetailsForSkusSuspenseQueryHookResult = ReturnType<typeof useWatchBasicDetailsForSkusSuspenseQuery>;
export type WatchBasicDetailsForSkusQueryResult = Apollo.QueryResult<WatchBasicDetailsForSkusQuery, WatchBasicDetailsForSkusQueryVariables>;
export const WatchsBySkusDocument = gql`
    query WatchsBySkus($skus: [String!]!, $languageCode: LanguageCodeEnum!, $thumbnailSize: Int!, $imagesFormat: ThumbnailFormatEnum!, $largeMediaSize: Int!, $first: Int!, $channel: String) {
  watchs: productVariants(filter: {sku: $skus}, first: $first, channel: $channel) {
    totalCount
    edges {
      node {
        ...ProductVariantWatchSku
      }
    }
  }
}
    ${ProductVariantWatchSkuFragmentDoc}
${ProductUrlBaseFragmentDoc}
${DropdownAttributeFragmentDoc}
${ProductTypeFragmentDoc}
${MultiselectAttributeFragmentDoc}
${VariantPricingFragmentDoc}
${TaxedMoneyFragmentDoc}
${MoneyFragmentDoc}
${ProductMediaFragmentDoc}
${ImageFragmentDoc}
${WatchAttributesFragmentDoc}
${BoolAttributeFragmentDoc}
${NumericAttributeFragmentDoc}`;

/**
 * __useWatchsBySkusQuery__
 *
 * To run a query within a React component, call `useWatchsBySkusQuery` and pass it any options that fit your needs.
 * When your component renders, `useWatchsBySkusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWatchsBySkusQuery({
 *   variables: {
 *      skus: // value for 'skus'
 *      languageCode: // value for 'languageCode'
 *      thumbnailSize: // value for 'thumbnailSize'
 *      imagesFormat: // value for 'imagesFormat'
 *      largeMediaSize: // value for 'largeMediaSize'
 *      first: // value for 'first'
 *      channel: // value for 'channel'
 *   },
 * });
 */
export function useWatchsBySkusQuery(baseOptions: Apollo.QueryHookOptions<WatchsBySkusQuery, WatchsBySkusQueryVariables> & ({ variables: WatchsBySkusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WatchsBySkusQuery, WatchsBySkusQueryVariables>(WatchsBySkusDocument, options);
      }
export function useWatchsBySkusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WatchsBySkusQuery, WatchsBySkusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WatchsBySkusQuery, WatchsBySkusQueryVariables>(WatchsBySkusDocument, options);
        }
export function useWatchsBySkusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WatchsBySkusQuery, WatchsBySkusQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WatchsBySkusQuery, WatchsBySkusQueryVariables>(WatchsBySkusDocument, options);
        }
export type WatchsBySkusQueryHookResult = ReturnType<typeof useWatchsBySkusQuery>;
export type WatchsBySkusLazyQueryHookResult = ReturnType<typeof useWatchsBySkusLazyQuery>;
export type WatchsBySkusSuspenseQueryHookResult = ReturnType<typeof useWatchsBySkusSuspenseQuery>;
export type WatchsBySkusQueryResult = Apollo.QueryResult<WatchsBySkusQuery, WatchsBySkusQueryVariables>;
export type AccountAddressCreateKeySpecifier = ('accountErrors' | 'address' | 'errors' | 'user' | AccountAddressCreateKeySpecifier)[];
export type AccountAddressCreateFieldPolicy = {
	accountErrors?: FieldPolicy<any> | FieldReadFunction<any>,
	address?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AccountAddressDeleteKeySpecifier = ('accountErrors' | 'address' | 'errors' | 'user' | AccountAddressDeleteKeySpecifier)[];
export type AccountAddressDeleteFieldPolicy = {
	accountErrors?: FieldPolicy<any> | FieldReadFunction<any>,
	address?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AccountAddressUpdateKeySpecifier = ('accountErrors' | 'address' | 'errors' | 'user' | AccountAddressUpdateKeySpecifier)[];
export type AccountAddressUpdateFieldPolicy = {
	accountErrors?: FieldPolicy<any> | FieldReadFunction<any>,
	address?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AccountChangeEmailRequestedKeySpecifier = ('channel' | 'issuedAt' | 'issuingPrincipal' | 'newEmail' | 'recipient' | 'redirectUrl' | 'shop' | 'token' | 'user' | 'version' | AccountChangeEmailRequestedKeySpecifier)[];
export type AccountChangeEmailRequestedFieldPolicy = {
	channel?: FieldPolicy<any> | FieldReadFunction<any>,
	issuedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	issuingPrincipal?: FieldPolicy<any> | FieldReadFunction<any>,
	newEmail?: FieldPolicy<any> | FieldReadFunction<any>,
	recipient?: FieldPolicy<any> | FieldReadFunction<any>,
	redirectUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	shop?: FieldPolicy<any> | FieldReadFunction<any>,
	token?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AccountConfirmationRequestedKeySpecifier = ('channel' | 'issuedAt' | 'issuingPrincipal' | 'recipient' | 'redirectUrl' | 'shop' | 'token' | 'user' | 'version' | AccountConfirmationRequestedKeySpecifier)[];
export type AccountConfirmationRequestedFieldPolicy = {
	channel?: FieldPolicy<any> | FieldReadFunction<any>,
	issuedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	issuingPrincipal?: FieldPolicy<any> | FieldReadFunction<any>,
	recipient?: FieldPolicy<any> | FieldReadFunction<any>,
	redirectUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	shop?: FieldPolicy<any> | FieldReadFunction<any>,
	token?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AccountConfirmedKeySpecifier = ('channel' | 'issuedAt' | 'issuingPrincipal' | 'recipient' | 'redirectUrl' | 'shop' | 'token' | 'user' | 'version' | AccountConfirmedKeySpecifier)[];
export type AccountConfirmedFieldPolicy = {
	channel?: FieldPolicy<any> | FieldReadFunction<any>,
	issuedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	issuingPrincipal?: FieldPolicy<any> | FieldReadFunction<any>,
	recipient?: FieldPolicy<any> | FieldReadFunction<any>,
	redirectUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	shop?: FieldPolicy<any> | FieldReadFunction<any>,
	token?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AccountDeleteKeySpecifier = ('accountErrors' | 'errors' | 'user' | AccountDeleteKeySpecifier)[];
export type AccountDeleteFieldPolicy = {
	accountErrors?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AccountDeleteRequestedKeySpecifier = ('channel' | 'issuedAt' | 'issuingPrincipal' | 'recipient' | 'redirectUrl' | 'shop' | 'token' | 'user' | 'version' | AccountDeleteRequestedKeySpecifier)[];
export type AccountDeleteRequestedFieldPolicy = {
	channel?: FieldPolicy<any> | FieldReadFunction<any>,
	issuedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	issuingPrincipal?: FieldPolicy<any> | FieldReadFunction<any>,
	recipient?: FieldPolicy<any> | FieldReadFunction<any>,
	redirectUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	shop?: FieldPolicy<any> | FieldReadFunction<any>,
	token?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AccountDeletedKeySpecifier = ('channel' | 'issuedAt' | 'issuingPrincipal' | 'recipient' | 'redirectUrl' | 'shop' | 'token' | 'user' | 'version' | AccountDeletedKeySpecifier)[];
export type AccountDeletedFieldPolicy = {
	channel?: FieldPolicy<any> | FieldReadFunction<any>,
	issuedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	issuingPrincipal?: FieldPolicy<any> | FieldReadFunction<any>,
	recipient?: FieldPolicy<any> | FieldReadFunction<any>,
	redirectUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	shop?: FieldPolicy<any> | FieldReadFunction<any>,
	token?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AccountEmailChangedKeySpecifier = ('channel' | 'issuedAt' | 'issuingPrincipal' | 'newEmail' | 'recipient' | 'redirectUrl' | 'shop' | 'token' | 'user' | 'version' | AccountEmailChangedKeySpecifier)[];
export type AccountEmailChangedFieldPolicy = {
	channel?: FieldPolicy<any> | FieldReadFunction<any>,
	issuedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	issuingPrincipal?: FieldPolicy<any> | FieldReadFunction<any>,
	newEmail?: FieldPolicy<any> | FieldReadFunction<any>,
	recipient?: FieldPolicy<any> | FieldReadFunction<any>,
	redirectUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	shop?: FieldPolicy<any> | FieldReadFunction<any>,
	token?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AccountErrorKeySpecifier = ('addressType' | 'code' | 'field' | 'message' | AccountErrorKeySpecifier)[];
export type AccountErrorFieldPolicy = {
	addressType?: FieldPolicy<any> | FieldReadFunction<any>,
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	field?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AccountRegisterKeySpecifier = ('accountErrors' | 'errors' | 'requiresConfirmation' | 'user' | AccountRegisterKeySpecifier)[];
export type AccountRegisterFieldPolicy = {
	accountErrors?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	requiresConfirmation?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AccountRequestDeletionKeySpecifier = ('accountErrors' | 'errors' | AccountRequestDeletionKeySpecifier)[];
export type AccountRequestDeletionFieldPolicy = {
	accountErrors?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AccountSetDefaultAddressKeySpecifier = ('accountErrors' | 'errors' | 'user' | AccountSetDefaultAddressKeySpecifier)[];
export type AccountSetDefaultAddressFieldPolicy = {
	accountErrors?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AccountSetPasswordRequestedKeySpecifier = ('channel' | 'issuedAt' | 'issuingPrincipal' | 'recipient' | 'redirectUrl' | 'shop' | 'token' | 'user' | 'version' | AccountSetPasswordRequestedKeySpecifier)[];
export type AccountSetPasswordRequestedFieldPolicy = {
	channel?: FieldPolicy<any> | FieldReadFunction<any>,
	issuedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	issuingPrincipal?: FieldPolicy<any> | FieldReadFunction<any>,
	recipient?: FieldPolicy<any> | FieldReadFunction<any>,
	redirectUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	shop?: FieldPolicy<any> | FieldReadFunction<any>,
	token?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AccountUpdateKeySpecifier = ('accountErrors' | 'errors' | 'user' | AccountUpdateKeySpecifier)[];
export type AccountUpdateFieldPolicy = {
	accountErrors?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AddressKeySpecifier = ('city' | 'cityArea' | 'companyName' | 'country' | 'countryArea' | 'firstName' | 'id' | 'isDefaultBillingAddress' | 'isDefaultShippingAddress' | 'lastName' | 'metadata' | 'metafield' | 'metafields' | 'phone' | 'postalCode' | 'privateMetadata' | 'privateMetafield' | 'privateMetafields' | 'streetAddress1' | 'streetAddress2' | AddressKeySpecifier)[];
export type AddressFieldPolicy = {
	city?: FieldPolicy<any> | FieldReadFunction<any>,
	cityArea?: FieldPolicy<any> | FieldReadFunction<any>,
	companyName?: FieldPolicy<any> | FieldReadFunction<any>,
	country?: FieldPolicy<any> | FieldReadFunction<any>,
	countryArea?: FieldPolicy<any> | FieldReadFunction<any>,
	firstName?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isDefaultBillingAddress?: FieldPolicy<any> | FieldReadFunction<any>,
	isDefaultShippingAddress?: FieldPolicy<any> | FieldReadFunction<any>,
	lastName?: FieldPolicy<any> | FieldReadFunction<any>,
	metadata?: FieldPolicy<any> | FieldReadFunction<any>,
	metafield?: FieldPolicy<any> | FieldReadFunction<any>,
	metafields?: FieldPolicy<any> | FieldReadFunction<any>,
	phone?: FieldPolicy<any> | FieldReadFunction<any>,
	postalCode?: FieldPolicy<any> | FieldReadFunction<any>,
	privateMetadata?: FieldPolicy<any> | FieldReadFunction<any>,
	privateMetafield?: FieldPolicy<any> | FieldReadFunction<any>,
	privateMetafields?: FieldPolicy<any> | FieldReadFunction<any>,
	streetAddress1?: FieldPolicy<any> | FieldReadFunction<any>,
	streetAddress2?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AddressCreateKeySpecifier = ('accountErrors' | 'address' | 'errors' | 'user' | AddressCreateKeySpecifier)[];
export type AddressCreateFieldPolicy = {
	accountErrors?: FieldPolicy<any> | FieldReadFunction<any>,
	address?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AddressCreatedKeySpecifier = ('address' | 'issuedAt' | 'issuingPrincipal' | 'recipient' | 'version' | AddressCreatedKeySpecifier)[];
export type AddressCreatedFieldPolicy = {
	address?: FieldPolicy<any> | FieldReadFunction<any>,
	issuedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	issuingPrincipal?: FieldPolicy<any> | FieldReadFunction<any>,
	recipient?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AddressDeleteKeySpecifier = ('accountErrors' | 'address' | 'errors' | 'user' | AddressDeleteKeySpecifier)[];
export type AddressDeleteFieldPolicy = {
	accountErrors?: FieldPolicy<any> | FieldReadFunction<any>,
	address?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AddressDeletedKeySpecifier = ('address' | 'issuedAt' | 'issuingPrincipal' | 'recipient' | 'version' | AddressDeletedKeySpecifier)[];
export type AddressDeletedFieldPolicy = {
	address?: FieldPolicy<any> | FieldReadFunction<any>,
	issuedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	issuingPrincipal?: FieldPolicy<any> | FieldReadFunction<any>,
	recipient?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AddressSetDefaultKeySpecifier = ('accountErrors' | 'errors' | 'user' | AddressSetDefaultKeySpecifier)[];
export type AddressSetDefaultFieldPolicy = {
	accountErrors?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AddressUpdateKeySpecifier = ('accountErrors' | 'address' | 'errors' | 'user' | AddressUpdateKeySpecifier)[];
export type AddressUpdateFieldPolicy = {
	accountErrors?: FieldPolicy<any> | FieldReadFunction<any>,
	address?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AddressUpdatedKeySpecifier = ('address' | 'issuedAt' | 'issuingPrincipal' | 'recipient' | 'version' | AddressUpdatedKeySpecifier)[];
export type AddressUpdatedFieldPolicy = {
	address?: FieldPolicy<any> | FieldReadFunction<any>,
	issuedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	issuingPrincipal?: FieldPolicy<any> | FieldReadFunction<any>,
	recipient?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AddressValidationDataKeySpecifier = ('addressFormat' | 'addressLatinFormat' | 'allowedFields' | 'cityAreaChoices' | 'cityAreaType' | 'cityChoices' | 'cityType' | 'countryAreaChoices' | 'countryAreaType' | 'countryCode' | 'countryName' | 'postalCodeExamples' | 'postalCodeMatchers' | 'postalCodePrefix' | 'postalCodeType' | 'requiredFields' | 'upperFields' | AddressValidationDataKeySpecifier)[];
export type AddressValidationDataFieldPolicy = {
	addressFormat?: FieldPolicy<any> | FieldReadFunction<any>,
	addressLatinFormat?: FieldPolicy<any> | FieldReadFunction<any>,
	allowedFields?: FieldPolicy<any> | FieldReadFunction<any>,
	cityAreaChoices?: FieldPolicy<any> | FieldReadFunction<any>,
	cityAreaType?: FieldPolicy<any> | FieldReadFunction<any>,
	cityChoices?: FieldPolicy<any> | FieldReadFunction<any>,
	cityType?: FieldPolicy<any> | FieldReadFunction<any>,
	countryAreaChoices?: FieldPolicy<any> | FieldReadFunction<any>,
	countryAreaType?: FieldPolicy<any> | FieldReadFunction<any>,
	countryCode?: FieldPolicy<any> | FieldReadFunction<any>,
	countryName?: FieldPolicy<any> | FieldReadFunction<any>,
	postalCodeExamples?: FieldPolicy<any> | FieldReadFunction<any>,
	postalCodeMatchers?: FieldPolicy<any> | FieldReadFunction<any>,
	postalCodePrefix?: FieldPolicy<any> | FieldReadFunction<any>,
	postalCodeType?: FieldPolicy<any> | FieldReadFunction<any>,
	requiredFields?: FieldPolicy<any> | FieldReadFunction<any>,
	upperFields?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AllocationKeySpecifier = ('id' | 'quantity' | 'warehouse' | AllocationKeySpecifier)[];
export type AllocationFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	quantity?: FieldPolicy<any> | FieldReadFunction<any>,
	warehouse?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AppKeySpecifier = ('aboutApp' | 'accessToken' | 'appUrl' | 'author' | 'brand' | 'breakerLastStateChange' | 'breakerState' | 'configurationUrl' | 'created' | 'dataPrivacy' | 'dataPrivacyUrl' | 'extensions' | 'homepageUrl' | 'id' | 'identifier' | 'isActive' | 'manifestUrl' | 'metadata' | 'metafield' | 'metafields' | 'name' | 'permissions' | 'privateMetadata' | 'privateMetafield' | 'privateMetafields' | 'problems' | 'supportUrl' | 'tokens' | 'type' | 'version' | 'webhooks' | AppKeySpecifier)[];
export type AppFieldPolicy = {
	aboutApp?: FieldPolicy<any> | FieldReadFunction<any>,
	accessToken?: FieldPolicy<any> | FieldReadFunction<any>,
	appUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	author?: FieldPolicy<any> | FieldReadFunction<any>,
	brand?: FieldPolicy<any> | FieldReadFunction<any>,
	breakerLastStateChange?: FieldPolicy<any> | FieldReadFunction<any>,
	breakerState?: FieldPolicy<any> | FieldReadFunction<any>,
	configurationUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	created?: FieldPolicy<any> | FieldReadFunction<any>,
	dataPrivacy?: FieldPolicy<any> | FieldReadFunction<any>,
	dataPrivacyUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	extensions?: FieldPolicy<any> | FieldReadFunction<any>,
	homepageUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	identifier?: FieldPolicy<any> | FieldReadFunction<any>,
	isActive?: FieldPolicy<any> | FieldReadFunction<any>,
	manifestUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	metadata?: FieldPolicy<any> | FieldReadFunction<any>,
	metafield?: FieldPolicy<any> | FieldReadFunction<any>,
	metafields?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	permissions?: FieldPolicy<any> | FieldReadFunction<any>,
	privateMetadata?: FieldPolicy<any> | FieldReadFunction<any>,
	privateMetafield?: FieldPolicy<any> | FieldReadFunction<any>,
	privateMetafields?: FieldPolicy<any> | FieldReadFunction<any>,
	problems?: FieldPolicy<any> | FieldReadFunction<any>,
	supportUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	tokens?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>,
	webhooks?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AppActivateKeySpecifier = ('app' | 'appErrors' | 'errors' | AppActivateKeySpecifier)[];
export type AppActivateFieldPolicy = {
	app?: FieldPolicy<any> | FieldReadFunction<any>,
	appErrors?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AppBrandKeySpecifier = ('logo' | AppBrandKeySpecifier)[];
export type AppBrandFieldPolicy = {
	logo?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AppBrandLogoKeySpecifier = ('default' | AppBrandLogoKeySpecifier)[];
export type AppBrandLogoFieldPolicy = {
	default?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AppCountableConnectionKeySpecifier = ('edges' | 'pageInfo' | 'totalCount' | AppCountableConnectionKeySpecifier)[];
export type AppCountableConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AppCountableEdgeKeySpecifier = ('cursor' | 'node' | AppCountableEdgeKeySpecifier)[];
export type AppCountableEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AppCreateKeySpecifier = ('app' | 'appErrors' | 'authToken' | 'errors' | AppCreateKeySpecifier)[];
export type AppCreateFieldPolicy = {
	app?: FieldPolicy<any> | FieldReadFunction<any>,
	appErrors?: FieldPolicy<any> | FieldReadFunction<any>,
	authToken?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AppDeactivateKeySpecifier = ('app' | 'appErrors' | 'errors' | AppDeactivateKeySpecifier)[];
export type AppDeactivateFieldPolicy = {
	app?: FieldPolicy<any> | FieldReadFunction<any>,
	appErrors?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AppDeleteKeySpecifier = ('app' | 'appErrors' | 'errors' | AppDeleteKeySpecifier)[];
export type AppDeleteFieldPolicy = {
	app?: FieldPolicy<any> | FieldReadFunction<any>,
	appErrors?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AppDeleteFailedInstallationKeySpecifier = ('appErrors' | 'appInstallation' | 'errors' | AppDeleteFailedInstallationKeySpecifier)[];
export type AppDeleteFailedInstallationFieldPolicy = {
	appErrors?: FieldPolicy<any> | FieldReadFunction<any>,
	appInstallation?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AppDeletedKeySpecifier = ('app' | 'issuedAt' | 'issuingPrincipal' | 'recipient' | 'version' | AppDeletedKeySpecifier)[];
export type AppDeletedFieldPolicy = {
	app?: FieldPolicy<any> | FieldReadFunction<any>,
	issuedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	issuingPrincipal?: FieldPolicy<any> | FieldReadFunction<any>,
	recipient?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AppErrorKeySpecifier = ('code' | 'field' | 'message' | 'permissions' | AppErrorKeySpecifier)[];
export type AppErrorFieldPolicy = {
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	field?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>,
	permissions?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AppExtensionKeySpecifier = ('accessToken' | 'app' | 'id' | 'label' | 'mount' | 'mountName' | 'options' | 'permissions' | 'settings' | 'target' | 'targetName' | 'url' | AppExtensionKeySpecifier)[];
export type AppExtensionFieldPolicy = {
	accessToken?: FieldPolicy<any> | FieldReadFunction<any>,
	app?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	label?: FieldPolicy<any> | FieldReadFunction<any>,
	mount?: FieldPolicy<any> | FieldReadFunction<any>,
	mountName?: FieldPolicy<any> | FieldReadFunction<any>,
	options?: FieldPolicy<any> | FieldReadFunction<any>,
	permissions?: FieldPolicy<any> | FieldReadFunction<any>,
	settings?: FieldPolicy<any> | FieldReadFunction<any>,
	target?: FieldPolicy<any> | FieldReadFunction<any>,
	targetName?: FieldPolicy<any> | FieldReadFunction<any>,
	url?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AppExtensionCountableConnectionKeySpecifier = ('edges' | 'pageInfo' | 'totalCount' | AppExtensionCountableConnectionKeySpecifier)[];
export type AppExtensionCountableConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AppExtensionCountableEdgeKeySpecifier = ('cursor' | 'node' | AppExtensionCountableEdgeKeySpecifier)[];
export type AppExtensionCountableEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AppExtensionOptionsNewTabKeySpecifier = ('newTabTarget' | AppExtensionOptionsNewTabKeySpecifier)[];
export type AppExtensionOptionsNewTabFieldPolicy = {
	newTabTarget?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AppExtensionOptionsWidgetKeySpecifier = ('widgetTarget' | AppExtensionOptionsWidgetKeySpecifier)[];
export type AppExtensionOptionsWidgetFieldPolicy = {
	widgetTarget?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AppFetchManifestKeySpecifier = ('appErrors' | 'errors' | 'manifest' | AppFetchManifestKeySpecifier)[];
export type AppFetchManifestFieldPolicy = {
	appErrors?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	manifest?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AppInstallKeySpecifier = ('appErrors' | 'appInstallation' | 'errors' | AppInstallKeySpecifier)[];
export type AppInstallFieldPolicy = {
	appErrors?: FieldPolicy<any> | FieldReadFunction<any>,
	appInstallation?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AppInstallationKeySpecifier = ('appName' | 'brand' | 'createdAt' | 'id' | 'manifestUrl' | 'message' | 'status' | 'updatedAt' | AppInstallationKeySpecifier)[];
export type AppInstallationFieldPolicy = {
	appName?: FieldPolicy<any> | FieldReadFunction<any>,
	brand?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	manifestUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AppInstalledKeySpecifier = ('app' | 'issuedAt' | 'issuingPrincipal' | 'recipient' | 'version' | AppInstalledKeySpecifier)[];
export type AppInstalledFieldPolicy = {
	app?: FieldPolicy<any> | FieldReadFunction<any>,
	issuedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	issuingPrincipal?: FieldPolicy<any> | FieldReadFunction<any>,
	recipient?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AppManifestBrandKeySpecifier = ('logo' | AppManifestBrandKeySpecifier)[];
export type AppManifestBrandFieldPolicy = {
	logo?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AppManifestBrandLogoKeySpecifier = ('default' | AppManifestBrandLogoKeySpecifier)[];
export type AppManifestBrandLogoFieldPolicy = {
	default?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AppManifestExtensionKeySpecifier = ('label' | 'mount' | 'mountName' | 'permissions' | 'settings' | 'target' | 'targetName' | 'url' | AppManifestExtensionKeySpecifier)[];
export type AppManifestExtensionFieldPolicy = {
	label?: FieldPolicy<any> | FieldReadFunction<any>,
	mount?: FieldPolicy<any> | FieldReadFunction<any>,
	mountName?: FieldPolicy<any> | FieldReadFunction<any>,
	permissions?: FieldPolicy<any> | FieldReadFunction<any>,
	settings?: FieldPolicy<any> | FieldReadFunction<any>,
	target?: FieldPolicy<any> | FieldReadFunction<any>,
	targetName?: FieldPolicy<any> | FieldReadFunction<any>,
	url?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AppManifestRequiredSaleorVersionKeySpecifier = ('constraint' | 'satisfied' | AppManifestRequiredSaleorVersionKeySpecifier)[];
export type AppManifestRequiredSaleorVersionFieldPolicy = {
	constraint?: FieldPolicy<any> | FieldReadFunction<any>,
	satisfied?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AppManifestWebhookKeySpecifier = ('asyncEvents' | 'name' | 'query' | 'syncEvents' | 'targetUrl' | AppManifestWebhookKeySpecifier)[];
export type AppManifestWebhookFieldPolicy = {
	asyncEvents?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	query?: FieldPolicy<any> | FieldReadFunction<any>,
	syncEvents?: FieldPolicy<any> | FieldReadFunction<any>,
	targetUrl?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AppProblemKeySpecifier = ('count' | 'createdAt' | 'dismissed' | 'id' | 'isCritical' | 'key' | 'message' | 'updatedAt' | AppProblemKeySpecifier)[];
export type AppProblemFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	dismissed?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isCritical?: FieldPolicy<any> | FieldReadFunction<any>,
	key?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AppProblemCreateKeySpecifier = ('appProblem' | 'errors' | AppProblemCreateKeySpecifier)[];
export type AppProblemCreateFieldPolicy = {
	appProblem?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AppProblemCreateErrorKeySpecifier = ('code' | 'field' | 'message' | AppProblemCreateErrorKeySpecifier)[];
export type AppProblemCreateErrorFieldPolicy = {
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	field?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AppProblemDismissKeySpecifier = ('errors' | AppProblemDismissKeySpecifier)[];
export type AppProblemDismissFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AppProblemDismissErrorKeySpecifier = ('code' | 'field' | 'message' | AppProblemDismissErrorKeySpecifier)[];
export type AppProblemDismissErrorFieldPolicy = {
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	field?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AppProblemDismissedKeySpecifier = ('by' | 'user' | 'userEmail' | AppProblemDismissedKeySpecifier)[];
export type AppProblemDismissedFieldPolicy = {
	by?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>,
	userEmail?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AppReenableSyncWebhooksKeySpecifier = ('app' | 'appErrors' | 'errors' | AppReenableSyncWebhooksKeySpecifier)[];
export type AppReenableSyncWebhooksFieldPolicy = {
	app?: FieldPolicy<any> | FieldReadFunction<any>,
	appErrors?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AppRetryInstallKeySpecifier = ('appErrors' | 'appInstallation' | 'errors' | AppRetryInstallKeySpecifier)[];
export type AppRetryInstallFieldPolicy = {
	appErrors?: FieldPolicy<any> | FieldReadFunction<any>,
	appInstallation?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AppStatusChangedKeySpecifier = ('app' | 'issuedAt' | 'issuingPrincipal' | 'recipient' | 'version' | AppStatusChangedKeySpecifier)[];
export type AppStatusChangedFieldPolicy = {
	app?: FieldPolicy<any> | FieldReadFunction<any>,
	issuedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	issuingPrincipal?: FieldPolicy<any> | FieldReadFunction<any>,
	recipient?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AppTokenKeySpecifier = ('authToken' | 'id' | 'name' | AppTokenKeySpecifier)[];
export type AppTokenFieldPolicy = {
	authToken?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AppTokenCreateKeySpecifier = ('appErrors' | 'appToken' | 'authToken' | 'errors' | AppTokenCreateKeySpecifier)[];
export type AppTokenCreateFieldPolicy = {
	appErrors?: FieldPolicy<any> | FieldReadFunction<any>,
	appToken?: FieldPolicy<any> | FieldReadFunction<any>,
	authToken?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AppTokenDeleteKeySpecifier = ('appErrors' | 'appToken' | 'errors' | AppTokenDeleteKeySpecifier)[];
export type AppTokenDeleteFieldPolicy = {
	appErrors?: FieldPolicy<any> | FieldReadFunction<any>,
	appToken?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AppTokenVerifyKeySpecifier = ('appErrors' | 'errors' | 'valid' | AppTokenVerifyKeySpecifier)[];
export type AppTokenVerifyFieldPolicy = {
	appErrors?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	valid?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AppUpdateKeySpecifier = ('app' | 'appErrors' | 'errors' | AppUpdateKeySpecifier)[];
export type AppUpdateFieldPolicy = {
	app?: FieldPolicy<any> | FieldReadFunction<any>,
	appErrors?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AppUpdatedKeySpecifier = ('app' | 'issuedAt' | 'issuingPrincipal' | 'recipient' | 'version' | AppUpdatedKeySpecifier)[];
export type AppUpdatedFieldPolicy = {
	app?: FieldPolicy<any> | FieldReadFunction<any>,
	issuedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	issuingPrincipal?: FieldPolicy<any> | FieldReadFunction<any>,
	recipient?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AssignNavigationKeySpecifier = ('errors' | 'menu' | 'menuErrors' | AssignNavigationKeySpecifier)[];
export type AssignNavigationFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	menu?: FieldPolicy<any> | FieldReadFunction<any>,
	menuErrors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AssignedAttributeKeySpecifier = ('attribute' | AssignedAttributeKeySpecifier)[];
export type AssignedAttributeFieldPolicy = {
	attribute?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AssignedBooleanAttributeKeySpecifier = ('attribute' | 'value' | AssignedBooleanAttributeKeySpecifier)[];
export type AssignedBooleanAttributeFieldPolicy = {
	attribute?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AssignedChoiceAttributeValueKeySpecifier = ('name' | 'slug' | 'translation' | AssignedChoiceAttributeValueKeySpecifier)[];
export type AssignedChoiceAttributeValueFieldPolicy = {
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	slug?: FieldPolicy<any> | FieldReadFunction<any>,
	translation?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AssignedDateAttributeKeySpecifier = ('attribute' | 'value' | AssignedDateAttributeKeySpecifier)[];
export type AssignedDateAttributeFieldPolicy = {
	attribute?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AssignedDateTimeAttributeKeySpecifier = ('attribute' | 'value' | AssignedDateTimeAttributeKeySpecifier)[];
export type AssignedDateTimeAttributeFieldPolicy = {
	attribute?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AssignedFileAttributeKeySpecifier = ('attribute' | 'value' | AssignedFileAttributeKeySpecifier)[];
export type AssignedFileAttributeFieldPolicy = {
	attribute?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AssignedMultiCategoryReferenceAttributeKeySpecifier = ('attribute' | 'value' | AssignedMultiCategoryReferenceAttributeKeySpecifier)[];
export type AssignedMultiCategoryReferenceAttributeFieldPolicy = {
	attribute?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AssignedMultiChoiceAttributeKeySpecifier = ('attribute' | 'value' | AssignedMultiChoiceAttributeKeySpecifier)[];
export type AssignedMultiChoiceAttributeFieldPolicy = {
	attribute?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AssignedMultiCollectionReferenceAttributeKeySpecifier = ('attribute' | 'value' | AssignedMultiCollectionReferenceAttributeKeySpecifier)[];
export type AssignedMultiCollectionReferenceAttributeFieldPolicy = {
	attribute?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AssignedMultiPageReferenceAttributeKeySpecifier = ('attribute' | 'value' | AssignedMultiPageReferenceAttributeKeySpecifier)[];
export type AssignedMultiPageReferenceAttributeFieldPolicy = {
	attribute?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AssignedMultiProductReferenceAttributeKeySpecifier = ('attribute' | 'value' | AssignedMultiProductReferenceAttributeKeySpecifier)[];
export type AssignedMultiProductReferenceAttributeFieldPolicy = {
	attribute?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AssignedMultiProductVariantReferenceAttributeKeySpecifier = ('attribute' | 'value' | AssignedMultiProductVariantReferenceAttributeKeySpecifier)[];
export type AssignedMultiProductVariantReferenceAttributeFieldPolicy = {
	attribute?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AssignedNumericAttributeKeySpecifier = ('attribute' | 'value' | AssignedNumericAttributeKeySpecifier)[];
export type AssignedNumericAttributeFieldPolicy = {
	attribute?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AssignedPlainTextAttributeKeySpecifier = ('attribute' | 'translation' | 'value' | AssignedPlainTextAttributeKeySpecifier)[];
export type AssignedPlainTextAttributeFieldPolicy = {
	attribute?: FieldPolicy<any> | FieldReadFunction<any>,
	translation?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AssignedSingleCategoryReferenceAttributeKeySpecifier = ('attribute' | 'value' | AssignedSingleCategoryReferenceAttributeKeySpecifier)[];
export type AssignedSingleCategoryReferenceAttributeFieldPolicy = {
	attribute?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AssignedSingleChoiceAttributeKeySpecifier = ('attribute' | 'value' | AssignedSingleChoiceAttributeKeySpecifier)[];
export type AssignedSingleChoiceAttributeFieldPolicy = {
	attribute?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AssignedSingleCollectionReferenceAttributeKeySpecifier = ('attribute' | 'value' | AssignedSingleCollectionReferenceAttributeKeySpecifier)[];
export type AssignedSingleCollectionReferenceAttributeFieldPolicy = {
	attribute?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AssignedSinglePageReferenceAttributeKeySpecifier = ('attribute' | 'value' | AssignedSinglePageReferenceAttributeKeySpecifier)[];
export type AssignedSinglePageReferenceAttributeFieldPolicy = {
	attribute?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AssignedSingleProductReferenceAttributeKeySpecifier = ('attribute' | 'value' | AssignedSingleProductReferenceAttributeKeySpecifier)[];
export type AssignedSingleProductReferenceAttributeFieldPolicy = {
	attribute?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AssignedSingleProductVariantReferenceAttributeKeySpecifier = ('attribute' | 'value' | AssignedSingleProductVariantReferenceAttributeKeySpecifier)[];
export type AssignedSingleProductVariantReferenceAttributeFieldPolicy = {
	attribute?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AssignedSwatchAttributeKeySpecifier = ('attribute' | 'value' | AssignedSwatchAttributeKeySpecifier)[];
export type AssignedSwatchAttributeFieldPolicy = {
	attribute?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AssignedSwatchAttributeValueKeySpecifier = ('file' | 'hexColor' | 'name' | 'slug' | AssignedSwatchAttributeValueKeySpecifier)[];
export type AssignedSwatchAttributeValueFieldPolicy = {
	file?: FieldPolicy<any> | FieldReadFunction<any>,
	hexColor?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	slug?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AssignedTextAttributeKeySpecifier = ('attribute' | 'translation' | 'value' | AssignedTextAttributeKeySpecifier)[];
export type AssignedTextAttributeFieldPolicy = {
	attribute?: FieldPolicy<any> | FieldReadFunction<any>,
	translation?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AssignedVariantAttributeKeySpecifier = ('attribute' | 'variantSelection' | AssignedVariantAttributeKeySpecifier)[];
export type AssignedVariantAttributeFieldPolicy = {
	attribute?: FieldPolicy<any> | FieldReadFunction<any>,
	variantSelection?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AttributeKeySpecifier = ('availableInGrid' | 'choices' | 'entityType' | 'externalReference' | 'filterableInDashboard' | 'filterableInStorefront' | 'id' | 'inputType' | 'metadata' | 'metafield' | 'metafields' | 'name' | 'privateMetadata' | 'privateMetafield' | 'privateMetafields' | 'productTypes' | 'productVariantTypes' | 'referenceTypes' | 'slug' | 'storefrontSearchPosition' | 'translation' | 'type' | 'unit' | 'valueRequired' | 'visibleInStorefront' | 'withChoices' | AttributeKeySpecifier)[];
export type AttributeFieldPolicy = {
	availableInGrid?: FieldPolicy<any> | FieldReadFunction<any>,
	choices?: FieldPolicy<any> | FieldReadFunction<any>,
	entityType?: FieldPolicy<any> | FieldReadFunction<any>,
	externalReference?: FieldPolicy<any> | FieldReadFunction<any>,
	filterableInDashboard?: FieldPolicy<any> | FieldReadFunction<any>,
	filterableInStorefront?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	inputType?: FieldPolicy<any> | FieldReadFunction<any>,
	metadata?: FieldPolicy<any> | FieldReadFunction<any>,
	metafield?: FieldPolicy<any> | FieldReadFunction<any>,
	metafields?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	privateMetadata?: FieldPolicy<any> | FieldReadFunction<any>,
	privateMetafield?: FieldPolicy<any> | FieldReadFunction<any>,
	privateMetafields?: FieldPolicy<any> | FieldReadFunction<any>,
	productTypes?: FieldPolicy<any> | FieldReadFunction<any>,
	productVariantTypes?: FieldPolicy<any> | FieldReadFunction<any>,
	referenceTypes?: FieldPolicy<any> | FieldReadFunction<any>,
	slug?: FieldPolicy<any> | FieldReadFunction<any>,
	storefrontSearchPosition?: FieldPolicy<any> | FieldReadFunction<any>,
	translation?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	unit?: FieldPolicy<any> | FieldReadFunction<any>,
	valueRequired?: FieldPolicy<any> | FieldReadFunction<any>,
	visibleInStorefront?: FieldPolicy<any> | FieldReadFunction<any>,
	withChoices?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AttributeBulkCreateKeySpecifier = ('count' | 'errors' | 'results' | AttributeBulkCreateKeySpecifier)[];
export type AttributeBulkCreateFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	results?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AttributeBulkCreateErrorKeySpecifier = ('code' | 'message' | 'path' | AttributeBulkCreateErrorKeySpecifier)[];
export type AttributeBulkCreateErrorFieldPolicy = {
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>,
	path?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AttributeBulkCreateResultKeySpecifier = ('attribute' | 'errors' | AttributeBulkCreateResultKeySpecifier)[];
export type AttributeBulkCreateResultFieldPolicy = {
	attribute?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AttributeBulkDeleteKeySpecifier = ('attributeErrors' | 'count' | 'errors' | AttributeBulkDeleteKeySpecifier)[];
export type AttributeBulkDeleteFieldPolicy = {
	attributeErrors?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AttributeBulkTranslateKeySpecifier = ('count' | 'errors' | 'results' | AttributeBulkTranslateKeySpecifier)[];
export type AttributeBulkTranslateFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	results?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AttributeBulkTranslateErrorKeySpecifier = ('code' | 'message' | 'path' | AttributeBulkTranslateErrorKeySpecifier)[];
export type AttributeBulkTranslateErrorFieldPolicy = {
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>,
	path?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AttributeBulkTranslateResultKeySpecifier = ('errors' | 'translation' | AttributeBulkTranslateResultKeySpecifier)[];
export type AttributeBulkTranslateResultFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	translation?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AttributeBulkUpdateKeySpecifier = ('count' | 'errors' | 'results' | AttributeBulkUpdateKeySpecifier)[];
export type AttributeBulkUpdateFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	results?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AttributeBulkUpdateErrorKeySpecifier = ('code' | 'message' | 'path' | AttributeBulkUpdateErrorKeySpecifier)[];
export type AttributeBulkUpdateErrorFieldPolicy = {
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>,
	path?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AttributeBulkUpdateResultKeySpecifier = ('attribute' | 'errors' | AttributeBulkUpdateResultKeySpecifier)[];
export type AttributeBulkUpdateResultFieldPolicy = {
	attribute?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AttributeCountableConnectionKeySpecifier = ('edges' | 'pageInfo' | 'totalCount' | AttributeCountableConnectionKeySpecifier)[];
export type AttributeCountableConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AttributeCountableEdgeKeySpecifier = ('cursor' | 'node' | AttributeCountableEdgeKeySpecifier)[];
export type AttributeCountableEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AttributeCreateKeySpecifier = ('attribute' | 'attributeErrors' | 'errors' | AttributeCreateKeySpecifier)[];
export type AttributeCreateFieldPolicy = {
	attribute?: FieldPolicy<any> | FieldReadFunction<any>,
	attributeErrors?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AttributeCreatedKeySpecifier = ('attribute' | 'issuedAt' | 'issuingPrincipal' | 'recipient' | 'version' | AttributeCreatedKeySpecifier)[];
export type AttributeCreatedFieldPolicy = {
	attribute?: FieldPolicy<any> | FieldReadFunction<any>,
	issuedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	issuingPrincipal?: FieldPolicy<any> | FieldReadFunction<any>,
	recipient?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AttributeDeleteKeySpecifier = ('attribute' | 'attributeErrors' | 'errors' | AttributeDeleteKeySpecifier)[];
export type AttributeDeleteFieldPolicy = {
	attribute?: FieldPolicy<any> | FieldReadFunction<any>,
	attributeErrors?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AttributeDeletedKeySpecifier = ('attribute' | 'issuedAt' | 'issuingPrincipal' | 'recipient' | 'version' | AttributeDeletedKeySpecifier)[];
export type AttributeDeletedFieldPolicy = {
	attribute?: FieldPolicy<any> | FieldReadFunction<any>,
	issuedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	issuingPrincipal?: FieldPolicy<any> | FieldReadFunction<any>,
	recipient?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AttributeErrorKeySpecifier = ('code' | 'field' | 'message' | AttributeErrorKeySpecifier)[];
export type AttributeErrorFieldPolicy = {
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	field?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AttributeReorderValuesKeySpecifier = ('attribute' | 'attributeErrors' | 'errors' | AttributeReorderValuesKeySpecifier)[];
export type AttributeReorderValuesFieldPolicy = {
	attribute?: FieldPolicy<any> | FieldReadFunction<any>,
	attributeErrors?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AttributeTranslatableContentKeySpecifier = ('attribute' | 'attributeId' | 'id' | 'name' | 'translation' | AttributeTranslatableContentKeySpecifier)[];
export type AttributeTranslatableContentFieldPolicy = {
	attribute?: FieldPolicy<any> | FieldReadFunction<any>,
	attributeId?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	translation?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AttributeTranslateKeySpecifier = ('attribute' | 'errors' | 'translationErrors' | AttributeTranslateKeySpecifier)[];
export type AttributeTranslateFieldPolicy = {
	attribute?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	translationErrors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AttributeTranslationKeySpecifier = ('id' | 'language' | 'name' | 'translatableContent' | AttributeTranslationKeySpecifier)[];
export type AttributeTranslationFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	language?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	translatableContent?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AttributeUpdateKeySpecifier = ('attribute' | 'attributeErrors' | 'errors' | AttributeUpdateKeySpecifier)[];
export type AttributeUpdateFieldPolicy = {
	attribute?: FieldPolicy<any> | FieldReadFunction<any>,
	attributeErrors?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AttributeUpdatedKeySpecifier = ('attribute' | 'issuedAt' | 'issuingPrincipal' | 'recipient' | 'version' | AttributeUpdatedKeySpecifier)[];
export type AttributeUpdatedFieldPolicy = {
	attribute?: FieldPolicy<any> | FieldReadFunction<any>,
	issuedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	issuingPrincipal?: FieldPolicy<any> | FieldReadFunction<any>,
	recipient?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AttributeValueKeySpecifier = ('boolean' | 'date' | 'dateTime' | 'externalReference' | 'file' | 'id' | 'inputType' | 'name' | 'plainText' | 'reference' | 'richText' | 'slug' | 'translation' | 'value' | AttributeValueKeySpecifier)[];
export type AttributeValueFieldPolicy = {
	boolean?: FieldPolicy<any> | FieldReadFunction<any>,
	date?: FieldPolicy<any> | FieldReadFunction<any>,
	dateTime?: FieldPolicy<any> | FieldReadFunction<any>,
	externalReference?: FieldPolicy<any> | FieldReadFunction<any>,
	file?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	inputType?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	plainText?: FieldPolicy<any> | FieldReadFunction<any>,
	reference?: FieldPolicy<any> | FieldReadFunction<any>,
	richText?: FieldPolicy<any> | FieldReadFunction<any>,
	slug?: FieldPolicy<any> | FieldReadFunction<any>,
	translation?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AttributeValueBulkDeleteKeySpecifier = ('attributeErrors' | 'count' | 'errors' | AttributeValueBulkDeleteKeySpecifier)[];
export type AttributeValueBulkDeleteFieldPolicy = {
	attributeErrors?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AttributeValueBulkTranslateKeySpecifier = ('count' | 'errors' | 'results' | AttributeValueBulkTranslateKeySpecifier)[];
export type AttributeValueBulkTranslateFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	results?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AttributeValueBulkTranslateErrorKeySpecifier = ('code' | 'message' | 'path' | AttributeValueBulkTranslateErrorKeySpecifier)[];
export type AttributeValueBulkTranslateErrorFieldPolicy = {
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>,
	path?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AttributeValueBulkTranslateResultKeySpecifier = ('errors' | 'translation' | AttributeValueBulkTranslateResultKeySpecifier)[];
export type AttributeValueBulkTranslateResultFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	translation?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AttributeValueCountableConnectionKeySpecifier = ('edges' | 'pageInfo' | 'totalCount' | AttributeValueCountableConnectionKeySpecifier)[];
export type AttributeValueCountableConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AttributeValueCountableEdgeKeySpecifier = ('cursor' | 'node' | AttributeValueCountableEdgeKeySpecifier)[];
export type AttributeValueCountableEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AttributeValueCreateKeySpecifier = ('attribute' | 'attributeErrors' | 'attributeValue' | 'errors' | AttributeValueCreateKeySpecifier)[];
export type AttributeValueCreateFieldPolicy = {
	attribute?: FieldPolicy<any> | FieldReadFunction<any>,
	attributeErrors?: FieldPolicy<any> | FieldReadFunction<any>,
	attributeValue?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AttributeValueCreatedKeySpecifier = ('attributeValue' | 'issuedAt' | 'issuingPrincipal' | 'recipient' | 'version' | AttributeValueCreatedKeySpecifier)[];
export type AttributeValueCreatedFieldPolicy = {
	attributeValue?: FieldPolicy<any> | FieldReadFunction<any>,
	issuedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	issuingPrincipal?: FieldPolicy<any> | FieldReadFunction<any>,
	recipient?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AttributeValueDeleteKeySpecifier = ('attribute' | 'attributeErrors' | 'attributeValue' | 'errors' | AttributeValueDeleteKeySpecifier)[];
export type AttributeValueDeleteFieldPolicy = {
	attribute?: FieldPolicy<any> | FieldReadFunction<any>,
	attributeErrors?: FieldPolicy<any> | FieldReadFunction<any>,
	attributeValue?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AttributeValueDeletedKeySpecifier = ('attributeValue' | 'issuedAt' | 'issuingPrincipal' | 'recipient' | 'version' | AttributeValueDeletedKeySpecifier)[];
export type AttributeValueDeletedFieldPolicy = {
	attributeValue?: FieldPolicy<any> | FieldReadFunction<any>,
	issuedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	issuingPrincipal?: FieldPolicy<any> | FieldReadFunction<any>,
	recipient?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AttributeValueTranslatableContentKeySpecifier = ('attribute' | 'attributeValue' | 'attributeValueId' | 'id' | 'name' | 'plainText' | 'richText' | 'translation' | AttributeValueTranslatableContentKeySpecifier)[];
export type AttributeValueTranslatableContentFieldPolicy = {
	attribute?: FieldPolicy<any> | FieldReadFunction<any>,
	attributeValue?: FieldPolicy<any> | FieldReadFunction<any>,
	attributeValueId?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	plainText?: FieldPolicy<any> | FieldReadFunction<any>,
	richText?: FieldPolicy<any> | FieldReadFunction<any>,
	translation?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AttributeValueTranslateKeySpecifier = ('attributeValue' | 'errors' | 'translationErrors' | AttributeValueTranslateKeySpecifier)[];
export type AttributeValueTranslateFieldPolicy = {
	attributeValue?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	translationErrors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AttributeValueTranslationKeySpecifier = ('id' | 'language' | 'name' | 'plainText' | 'richText' | 'translatableContent' | AttributeValueTranslationKeySpecifier)[];
export type AttributeValueTranslationFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	language?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	plainText?: FieldPolicy<any> | FieldReadFunction<any>,
	richText?: FieldPolicy<any> | FieldReadFunction<any>,
	translatableContent?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AttributeValueUpdateKeySpecifier = ('attribute' | 'attributeErrors' | 'attributeValue' | 'errors' | AttributeValueUpdateKeySpecifier)[];
export type AttributeValueUpdateFieldPolicy = {
	attribute?: FieldPolicy<any> | FieldReadFunction<any>,
	attributeErrors?: FieldPolicy<any> | FieldReadFunction<any>,
	attributeValue?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AttributeValueUpdatedKeySpecifier = ('attributeValue' | 'issuedAt' | 'issuingPrincipal' | 'recipient' | 'version' | AttributeValueUpdatedKeySpecifier)[];
export type AttributeValueUpdatedFieldPolicy = {
	attributeValue?: FieldPolicy<any> | FieldReadFunction<any>,
	issuedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	issuingPrincipal?: FieldPolicy<any> | FieldReadFunction<any>,
	recipient?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BulkProductErrorKeySpecifier = ('attributes' | 'channels' | 'code' | 'field' | 'index' | 'message' | 'values' | 'warehouses' | BulkProductErrorKeySpecifier)[];
export type BulkProductErrorFieldPolicy = {
	attributes?: FieldPolicy<any> | FieldReadFunction<any>,
	channels?: FieldPolicy<any> | FieldReadFunction<any>,
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	field?: FieldPolicy<any> | FieldReadFunction<any>,
	index?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>,
	values?: FieldPolicy<any> | FieldReadFunction<any>,
	warehouses?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BulkStockErrorKeySpecifier = ('attributes' | 'code' | 'field' | 'index' | 'message' | 'values' | BulkStockErrorKeySpecifier)[];
export type BulkStockErrorFieldPolicy = {
	attributes?: FieldPolicy<any> | FieldReadFunction<any>,
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	field?: FieldPolicy<any> | FieldReadFunction<any>,
	index?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>,
	values?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CalculateTaxesKeySpecifier = ('issuedAt' | 'issuingPrincipal' | 'recipient' | 'taxBase' | 'version' | CalculateTaxesKeySpecifier)[];
export type CalculateTaxesFieldPolicy = {
	issuedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	issuingPrincipal?: FieldPolicy<any> | FieldReadFunction<any>,
	recipient?: FieldPolicy<any> | FieldReadFunction<any>,
	taxBase?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CardPaymentMethodDetailsKeySpecifier = ('brand' | 'expMonth' | 'expYear' | 'firstDigits' | 'lastDigits' | 'name' | CardPaymentMethodDetailsKeySpecifier)[];
export type CardPaymentMethodDetailsFieldPolicy = {
	brand?: FieldPolicy<any> | FieldReadFunction<any>,
	expMonth?: FieldPolicy<any> | FieldReadFunction<any>,
	expYear?: FieldPolicy<any> | FieldReadFunction<any>,
	firstDigits?: FieldPolicy<any> | FieldReadFunction<any>,
	lastDigits?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CategoryKeySpecifier = ('ancestors' | 'backgroundImage' | 'children' | 'description' | 'descriptionJson' | 'id' | 'level' | 'metadata' | 'metafield' | 'metafields' | 'name' | 'parent' | 'privateMetadata' | 'privateMetafield' | 'privateMetafields' | 'products' | 'seoDescription' | 'seoTitle' | 'slug' | 'translation' | 'updatedAt' | CategoryKeySpecifier)[];
export type CategoryFieldPolicy = {
	ancestors?: FieldPolicy<any> | FieldReadFunction<any>,
	backgroundImage?: FieldPolicy<any> | FieldReadFunction<any>,
	children?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	descriptionJson?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	level?: FieldPolicy<any> | FieldReadFunction<any>,
	metadata?: FieldPolicy<any> | FieldReadFunction<any>,
	metafield?: FieldPolicy<any> | FieldReadFunction<any>,
	metafields?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	parent?: FieldPolicy<any> | FieldReadFunction<any>,
	privateMetadata?: FieldPolicy<any> | FieldReadFunction<any>,
	privateMetafield?: FieldPolicy<any> | FieldReadFunction<any>,
	privateMetafields?: FieldPolicy<any> | FieldReadFunction<any>,
	products?: FieldPolicy<any> | FieldReadFunction<any>,
	seoDescription?: FieldPolicy<any> | FieldReadFunction<any>,
	seoTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	slug?: FieldPolicy<any> | FieldReadFunction<any>,
	translation?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CategoryBulkDeleteKeySpecifier = ('count' | 'errors' | 'productErrors' | CategoryBulkDeleteKeySpecifier)[];
export type CategoryBulkDeleteFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	productErrors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CategoryCountableConnectionKeySpecifier = ('edges' | 'pageInfo' | 'totalCount' | CategoryCountableConnectionKeySpecifier)[];
export type CategoryCountableConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CategoryCountableEdgeKeySpecifier = ('cursor' | 'node' | CategoryCountableEdgeKeySpecifier)[];
export type CategoryCountableEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CategoryCreateKeySpecifier = ('category' | 'errors' | 'productErrors' | CategoryCreateKeySpecifier)[];
export type CategoryCreateFieldPolicy = {
	category?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	productErrors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CategoryCreatedKeySpecifier = ('category' | 'issuedAt' | 'issuingPrincipal' | 'recipient' | 'version' | CategoryCreatedKeySpecifier)[];
export type CategoryCreatedFieldPolicy = {
	category?: FieldPolicy<any> | FieldReadFunction<any>,
	issuedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	issuingPrincipal?: FieldPolicy<any> | FieldReadFunction<any>,
	recipient?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CategoryDeleteKeySpecifier = ('category' | 'errors' | 'productErrors' | CategoryDeleteKeySpecifier)[];
export type CategoryDeleteFieldPolicy = {
	category?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	productErrors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CategoryDeletedKeySpecifier = ('category' | 'issuedAt' | 'issuingPrincipal' | 'recipient' | 'version' | CategoryDeletedKeySpecifier)[];
export type CategoryDeletedFieldPolicy = {
	category?: FieldPolicy<any> | FieldReadFunction<any>,
	issuedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	issuingPrincipal?: FieldPolicy<any> | FieldReadFunction<any>,
	recipient?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CategoryTranslatableContentKeySpecifier = ('category' | 'categoryId' | 'description' | 'descriptionJson' | 'id' | 'name' | 'seoDescription' | 'seoTitle' | 'slug' | 'translation' | CategoryTranslatableContentKeySpecifier)[];
export type CategoryTranslatableContentFieldPolicy = {
	category?: FieldPolicy<any> | FieldReadFunction<any>,
	categoryId?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	descriptionJson?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	seoDescription?: FieldPolicy<any> | FieldReadFunction<any>,
	seoTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	slug?: FieldPolicy<any> | FieldReadFunction<any>,
	translation?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CategoryTranslateKeySpecifier = ('category' | 'errors' | 'translationErrors' | CategoryTranslateKeySpecifier)[];
export type CategoryTranslateFieldPolicy = {
	category?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	translationErrors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CategoryTranslationKeySpecifier = ('description' | 'descriptionJson' | 'id' | 'language' | 'name' | 'seoDescription' | 'seoTitle' | 'slug' | 'translatableContent' | CategoryTranslationKeySpecifier)[];
export type CategoryTranslationFieldPolicy = {
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	descriptionJson?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	language?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	seoDescription?: FieldPolicy<any> | FieldReadFunction<any>,
	seoTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	slug?: FieldPolicy<any> | FieldReadFunction<any>,
	translatableContent?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CategoryUpdateKeySpecifier = ('category' | 'errors' | 'productErrors' | CategoryUpdateKeySpecifier)[];
export type CategoryUpdateFieldPolicy = {
	category?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	productErrors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CategoryUpdatedKeySpecifier = ('category' | 'issuedAt' | 'issuingPrincipal' | 'recipient' | 'version' | CategoryUpdatedKeySpecifier)[];
export type CategoryUpdatedFieldPolicy = {
	category?: FieldPolicy<any> | FieldReadFunction<any>,
	issuedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	issuingPrincipal?: FieldPolicy<any> | FieldReadFunction<any>,
	recipient?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ChannelKeySpecifier = ('availableShippingMethodsPerCountry' | 'checkoutSettings' | 'countries' | 'currencyCode' | 'defaultCountry' | 'hasOrders' | 'id' | 'isActive' | 'metadata' | 'metafield' | 'metafields' | 'name' | 'orderSettings' | 'paymentSettings' | 'privateMetadata' | 'privateMetafield' | 'privateMetafields' | 'slug' | 'stockSettings' | 'taxConfiguration' | 'warehouses' | ChannelKeySpecifier)[];
export type ChannelFieldPolicy = {
	availableShippingMethodsPerCountry?: FieldPolicy<any> | FieldReadFunction<any>,
	checkoutSettings?: FieldPolicy<any> | FieldReadFunction<any>,
	countries?: FieldPolicy<any> | FieldReadFunction<any>,
	currencyCode?: FieldPolicy<any> | FieldReadFunction<any>,
	defaultCountry?: FieldPolicy<any> | FieldReadFunction<any>,
	hasOrders?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isActive?: FieldPolicy<any> | FieldReadFunction<any>,
	metadata?: FieldPolicy<any> | FieldReadFunction<any>,
	metafield?: FieldPolicy<any> | FieldReadFunction<any>,
	metafields?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	orderSettings?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentSettings?: FieldPolicy<any> | FieldReadFunction<any>,
	privateMetadata?: FieldPolicy<any> | FieldReadFunction<any>,
	privateMetafield?: FieldPolicy<any> | FieldReadFunction<any>,
	privateMetafields?: FieldPolicy<any> | FieldReadFunction<any>,
	slug?: FieldPolicy<any> | FieldReadFunction<any>,
	stockSettings?: FieldPolicy<any> | FieldReadFunction<any>,
	taxConfiguration?: FieldPolicy<any> | FieldReadFunction<any>,
	warehouses?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ChannelActivateKeySpecifier = ('channel' | 'channelErrors' | 'errors' | ChannelActivateKeySpecifier)[];
export type ChannelActivateFieldPolicy = {
	channel?: FieldPolicy<any> | FieldReadFunction<any>,
	channelErrors?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ChannelCreateKeySpecifier = ('channel' | 'channelErrors' | 'errors' | ChannelCreateKeySpecifier)[];
export type ChannelCreateFieldPolicy = {
	channel?: FieldPolicy<any> | FieldReadFunction<any>,
	channelErrors?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ChannelCreatedKeySpecifier = ('channel' | 'issuedAt' | 'issuingPrincipal' | 'recipient' | 'version' | ChannelCreatedKeySpecifier)[];
export type ChannelCreatedFieldPolicy = {
	channel?: FieldPolicy<any> | FieldReadFunction<any>,
	issuedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	issuingPrincipal?: FieldPolicy<any> | FieldReadFunction<any>,
	recipient?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ChannelDeactivateKeySpecifier = ('channel' | 'channelErrors' | 'errors' | ChannelDeactivateKeySpecifier)[];
export type ChannelDeactivateFieldPolicy = {
	channel?: FieldPolicy<any> | FieldReadFunction<any>,
	channelErrors?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ChannelDeleteKeySpecifier = ('channel' | 'channelErrors' | 'errors' | ChannelDeleteKeySpecifier)[];
export type ChannelDeleteFieldPolicy = {
	channel?: FieldPolicy<any> | FieldReadFunction<any>,
	channelErrors?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ChannelDeletedKeySpecifier = ('channel' | 'issuedAt' | 'issuingPrincipal' | 'recipient' | 'version' | ChannelDeletedKeySpecifier)[];
export type ChannelDeletedFieldPolicy = {
	channel?: FieldPolicy<any> | FieldReadFunction<any>,
	issuedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	issuingPrincipal?: FieldPolicy<any> | FieldReadFunction<any>,
	recipient?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ChannelErrorKeySpecifier = ('code' | 'field' | 'message' | 'shippingZones' | 'warehouses' | ChannelErrorKeySpecifier)[];
export type ChannelErrorFieldPolicy = {
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	field?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>,
	shippingZones?: FieldPolicy<any> | FieldReadFunction<any>,
	warehouses?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ChannelMetadataUpdatedKeySpecifier = ('channel' | 'issuedAt' | 'issuingPrincipal' | 'recipient' | 'version' | ChannelMetadataUpdatedKeySpecifier)[];
export type ChannelMetadataUpdatedFieldPolicy = {
	channel?: FieldPolicy<any> | FieldReadFunction<any>,
	issuedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	issuingPrincipal?: FieldPolicy<any> | FieldReadFunction<any>,
	recipient?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ChannelReorderWarehousesKeySpecifier = ('channel' | 'errors' | ChannelReorderWarehousesKeySpecifier)[];
export type ChannelReorderWarehousesFieldPolicy = {
	channel?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ChannelStatusChangedKeySpecifier = ('channel' | 'issuedAt' | 'issuingPrincipal' | 'recipient' | 'version' | ChannelStatusChangedKeySpecifier)[];
export type ChannelStatusChangedFieldPolicy = {
	channel?: FieldPolicy<any> | FieldReadFunction<any>,
	issuedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	issuingPrincipal?: FieldPolicy<any> | FieldReadFunction<any>,
	recipient?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ChannelUpdateKeySpecifier = ('channel' | 'channelErrors' | 'errors' | ChannelUpdateKeySpecifier)[];
export type ChannelUpdateFieldPolicy = {
	channel?: FieldPolicy<any> | FieldReadFunction<any>,
	channelErrors?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ChannelUpdatedKeySpecifier = ('channel' | 'issuedAt' | 'issuingPrincipal' | 'recipient' | 'version' | ChannelUpdatedKeySpecifier)[];
export type ChannelUpdatedFieldPolicy = {
	channel?: FieldPolicy<any> | FieldReadFunction<any>,
	issuedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	issuingPrincipal?: FieldPolicy<any> | FieldReadFunction<any>,
	recipient?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CheckoutKeySpecifier = ('authorizeStatus' | 'availableCollectionPoints' | 'availablePaymentGateways' | 'availableShippingMethods' | 'billingAddress' | 'channel' | 'chargeStatus' | 'created' | 'customerNote' | 'deliveryMethod' | 'discount' | 'discountName' | 'displayGrossPrices' | 'email' | 'giftCards' | 'id' | 'isShippingRequired' | 'languageCode' | 'lastChange' | 'lines' | 'metadata' | 'metafield' | 'metafields' | 'note' | 'privateMetadata' | 'privateMetafield' | 'privateMetafields' | 'problems' | 'quantity' | 'shippingAddress' | 'shippingMethod' | 'shippingMethods' | 'shippingPrice' | 'stockReservationExpires' | 'storedPaymentMethods' | 'subtotalPrice' | 'taxExemption' | 'token' | 'totalBalance' | 'totalPrice' | 'transactions' | 'translatedDiscountName' | 'updatedAt' | 'user' | 'voucher' | 'voucherCode' | CheckoutKeySpecifier)[];
export type CheckoutFieldPolicy = {
	authorizeStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	availableCollectionPoints?: FieldPolicy<any> | FieldReadFunction<any>,
	availablePaymentGateways?: FieldPolicy<any> | FieldReadFunction<any>,
	availableShippingMethods?: FieldPolicy<any> | FieldReadFunction<any>,
	billingAddress?: FieldPolicy<any> | FieldReadFunction<any>,
	channel?: FieldPolicy<any> | FieldReadFunction<any>,
	chargeStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	created?: FieldPolicy<any> | FieldReadFunction<any>,
	customerNote?: FieldPolicy<any> | FieldReadFunction<any>,
	deliveryMethod?: FieldPolicy<any> | FieldReadFunction<any>,
	discount?: FieldPolicy<any> | FieldReadFunction<any>,
	discountName?: FieldPolicy<any> | FieldReadFunction<any>,
	displayGrossPrices?: FieldPolicy<any> | FieldReadFunction<any>,
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	giftCards?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isShippingRequired?: FieldPolicy<any> | FieldReadFunction<any>,
	languageCode?: FieldPolicy<any> | FieldReadFunction<any>,
	lastChange?: FieldPolicy<any> | FieldReadFunction<any>,
	lines?: FieldPolicy<any> | FieldReadFunction<any>,
	metadata?: FieldPolicy<any> | FieldReadFunction<any>,
	metafield?: FieldPolicy<any> | FieldReadFunction<any>,
	metafields?: FieldPolicy<any> | FieldReadFunction<any>,
	note?: FieldPolicy<any> | FieldReadFunction<any>,
	privateMetadata?: FieldPolicy<any> | FieldReadFunction<any>,
	privateMetafield?: FieldPolicy<any> | FieldReadFunction<any>,
	privateMetafields?: FieldPolicy<any> | FieldReadFunction<any>,
	problems?: FieldPolicy<any> | FieldReadFunction<any>,
	quantity?: FieldPolicy<any> | FieldReadFunction<any>,
	shippingAddress?: FieldPolicy<any> | FieldReadFunction<any>,
	shippingMethod?: FieldPolicy<any> | FieldReadFunction<any>,
	shippingMethods?: FieldPolicy<any> | FieldReadFunction<any>,
	shippingPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	stockReservationExpires?: FieldPolicy<any> | FieldReadFunction<any>,
	storedPaymentMethods?: FieldPolicy<any> | FieldReadFunction<any>,
	subtotalPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	taxExemption?: FieldPolicy<any> | FieldReadFunction<any>,
	token?: FieldPolicy<any> | FieldReadFunction<any>,
	totalBalance?: FieldPolicy<any> | FieldReadFunction<any>,
	totalPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	transactions?: FieldPolicy<any> | FieldReadFunction<any>,
	translatedDiscountName?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>,
	voucher?: FieldPolicy<any> | FieldReadFunction<any>,
	voucherCode?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CheckoutAddPromoCodeKeySpecifier = ('checkout' | 'checkoutErrors' | 'errors' | CheckoutAddPromoCodeKeySpecifier)[];
export type CheckoutAddPromoCodeFieldPolicy = {
	checkout?: FieldPolicy<any> | FieldReadFunction<any>,
	checkoutErrors?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CheckoutBillingAddressUpdateKeySpecifier = ('checkout' | 'checkoutErrors' | 'errors' | CheckoutBillingAddressUpdateKeySpecifier)[];
export type CheckoutBillingAddressUpdateFieldPolicy = {
	checkout?: FieldPolicy<any> | FieldReadFunction<any>,
	checkoutErrors?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CheckoutCompleteKeySpecifier = ('checkoutErrors' | 'confirmationData' | 'confirmationNeeded' | 'errors' | 'order' | CheckoutCompleteKeySpecifier)[];
export type CheckoutCompleteFieldPolicy = {
	checkoutErrors?: FieldPolicy<any> | FieldReadFunction<any>,
	confirmationData?: FieldPolicy<any> | FieldReadFunction<any>,
	confirmationNeeded?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	order?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CheckoutCountableConnectionKeySpecifier = ('edges' | 'pageInfo' | 'totalCount' | CheckoutCountableConnectionKeySpecifier)[];
export type CheckoutCountableConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CheckoutCountableEdgeKeySpecifier = ('cursor' | 'node' | CheckoutCountableEdgeKeySpecifier)[];
export type CheckoutCountableEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CheckoutCreateKeySpecifier = ('checkout' | 'checkoutErrors' | 'created' | 'errors' | CheckoutCreateKeySpecifier)[];
export type CheckoutCreateFieldPolicy = {
	checkout?: FieldPolicy<any> | FieldReadFunction<any>,
	checkoutErrors?: FieldPolicy<any> | FieldReadFunction<any>,
	created?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CheckoutCreateFromOrderKeySpecifier = ('checkout' | 'errors' | 'unavailableVariants' | CheckoutCreateFromOrderKeySpecifier)[];
export type CheckoutCreateFromOrderFieldPolicy = {
	checkout?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	unavailableVariants?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CheckoutCreateFromOrderErrorKeySpecifier = ('code' | 'field' | 'message' | CheckoutCreateFromOrderErrorKeySpecifier)[];
export type CheckoutCreateFromOrderErrorFieldPolicy = {
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	field?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CheckoutCreateFromOrderUnavailableVariantKeySpecifier = ('code' | 'lineId' | 'message' | 'variantId' | CheckoutCreateFromOrderUnavailableVariantKeySpecifier)[];
export type CheckoutCreateFromOrderUnavailableVariantFieldPolicy = {
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	lineId?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>,
	variantId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CheckoutCreatedKeySpecifier = ('checkout' | 'issuedAt' | 'issuingPrincipal' | 'recipient' | 'version' | CheckoutCreatedKeySpecifier)[];
export type CheckoutCreatedFieldPolicy = {
	checkout?: FieldPolicy<any> | FieldReadFunction<any>,
	issuedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	issuingPrincipal?: FieldPolicy<any> | FieldReadFunction<any>,
	recipient?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CheckoutCustomerAttachKeySpecifier = ('checkout' | 'checkoutErrors' | 'errors' | CheckoutCustomerAttachKeySpecifier)[];
export type CheckoutCustomerAttachFieldPolicy = {
	checkout?: FieldPolicy<any> | FieldReadFunction<any>,
	checkoutErrors?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CheckoutCustomerDetachKeySpecifier = ('checkout' | 'checkoutErrors' | 'errors' | CheckoutCustomerDetachKeySpecifier)[];
export type CheckoutCustomerDetachFieldPolicy = {
	checkout?: FieldPolicy<any> | FieldReadFunction<any>,
	checkoutErrors?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CheckoutCustomerNoteUpdateKeySpecifier = ('checkout' | 'checkoutErrors' | 'errors' | CheckoutCustomerNoteUpdateKeySpecifier)[];
export type CheckoutCustomerNoteUpdateFieldPolicy = {
	checkout?: FieldPolicy<any> | FieldReadFunction<any>,
	checkoutErrors?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CheckoutDeliveryMethodUpdateKeySpecifier = ('checkout' | 'errors' | CheckoutDeliveryMethodUpdateKeySpecifier)[];
export type CheckoutDeliveryMethodUpdateFieldPolicy = {
	checkout?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CheckoutEmailUpdateKeySpecifier = ('checkout' | 'checkoutErrors' | 'errors' | CheckoutEmailUpdateKeySpecifier)[];
export type CheckoutEmailUpdateFieldPolicy = {
	checkout?: FieldPolicy<any> | FieldReadFunction<any>,
	checkoutErrors?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CheckoutErrorKeySpecifier = ('addressType' | 'code' | 'field' | 'lines' | 'message' | 'variants' | CheckoutErrorKeySpecifier)[];
export type CheckoutErrorFieldPolicy = {
	addressType?: FieldPolicy<any> | FieldReadFunction<any>,
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	field?: FieldPolicy<any> | FieldReadFunction<any>,
	lines?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>,
	variants?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CheckoutFilterShippingMethodsKeySpecifier = ('checkout' | 'issuedAt' | 'issuingPrincipal' | 'recipient' | 'shippingMethods' | 'version' | CheckoutFilterShippingMethodsKeySpecifier)[];
export type CheckoutFilterShippingMethodsFieldPolicy = {
	checkout?: FieldPolicy<any> | FieldReadFunction<any>,
	issuedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	issuingPrincipal?: FieldPolicy<any> | FieldReadFunction<any>,
	recipient?: FieldPolicy<any> | FieldReadFunction<any>,
	shippingMethods?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CheckoutFullyAuthorizedKeySpecifier = ('checkout' | 'issuedAt' | 'issuingPrincipal' | 'recipient' | 'version' | CheckoutFullyAuthorizedKeySpecifier)[];
export type CheckoutFullyAuthorizedFieldPolicy = {
	checkout?: FieldPolicy<any> | FieldReadFunction<any>,
	issuedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	issuingPrincipal?: FieldPolicy<any> | FieldReadFunction<any>,
	recipient?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CheckoutFullyPaidKeySpecifier = ('checkout' | 'issuedAt' | 'issuingPrincipal' | 'recipient' | 'version' | CheckoutFullyPaidKeySpecifier)[];
export type CheckoutFullyPaidFieldPolicy = {
	checkout?: FieldPolicy<any> | FieldReadFunction<any>,
	issuedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	issuingPrincipal?: FieldPolicy<any> | FieldReadFunction<any>,
	recipient?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CheckoutLanguageCodeUpdateKeySpecifier = ('checkout' | 'checkoutErrors' | 'errors' | CheckoutLanguageCodeUpdateKeySpecifier)[];
export type CheckoutLanguageCodeUpdateFieldPolicy = {
	checkout?: FieldPolicy<any> | FieldReadFunction<any>,
	checkoutErrors?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CheckoutLineKeySpecifier = ('id' | 'isGift' | 'metadata' | 'metafield' | 'metafields' | 'priorTotalPrice' | 'priorUnitPrice' | 'privateMetadata' | 'privateMetafield' | 'privateMetafields' | 'problems' | 'quantity' | 'requiresShipping' | 'totalPrice' | 'undiscountedTotalPrice' | 'undiscountedUnitPrice' | 'unitPrice' | 'variant' | CheckoutLineKeySpecifier)[];
export type CheckoutLineFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isGift?: FieldPolicy<any> | FieldReadFunction<any>,
	metadata?: FieldPolicy<any> | FieldReadFunction<any>,
	metafield?: FieldPolicy<any> | FieldReadFunction<any>,
	metafields?: FieldPolicy<any> | FieldReadFunction<any>,
	priorTotalPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	priorUnitPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	privateMetadata?: FieldPolicy<any> | FieldReadFunction<any>,
	privateMetafield?: FieldPolicy<any> | FieldReadFunction<any>,
	privateMetafields?: FieldPolicy<any> | FieldReadFunction<any>,
	problems?: FieldPolicy<any> | FieldReadFunction<any>,
	quantity?: FieldPolicy<any> | FieldReadFunction<any>,
	requiresShipping?: FieldPolicy<any> | FieldReadFunction<any>,
	totalPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	undiscountedTotalPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	undiscountedUnitPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	unitPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	variant?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CheckoutLineCountableConnectionKeySpecifier = ('edges' | 'pageInfo' | 'totalCount' | CheckoutLineCountableConnectionKeySpecifier)[];
export type CheckoutLineCountableConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CheckoutLineCountableEdgeKeySpecifier = ('cursor' | 'node' | CheckoutLineCountableEdgeKeySpecifier)[];
export type CheckoutLineCountableEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CheckoutLineDeleteKeySpecifier = ('checkout' | 'checkoutErrors' | 'errors' | CheckoutLineDeleteKeySpecifier)[];
export type CheckoutLineDeleteFieldPolicy = {
	checkout?: FieldPolicy<any> | FieldReadFunction<any>,
	checkoutErrors?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CheckoutLineProblemInsufficientStockKeySpecifier = ('availableQuantity' | 'line' | 'variant' | CheckoutLineProblemInsufficientStockKeySpecifier)[];
export type CheckoutLineProblemInsufficientStockFieldPolicy = {
	availableQuantity?: FieldPolicy<any> | FieldReadFunction<any>,
	line?: FieldPolicy<any> | FieldReadFunction<any>,
	variant?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CheckoutLineProblemVariantNotAvailableKeySpecifier = ('line' | CheckoutLineProblemVariantNotAvailableKeySpecifier)[];
export type CheckoutLineProblemVariantNotAvailableFieldPolicy = {
	line?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CheckoutLinesAddKeySpecifier = ('checkout' | 'checkoutErrors' | 'errors' | CheckoutLinesAddKeySpecifier)[];
export type CheckoutLinesAddFieldPolicy = {
	checkout?: FieldPolicy<any> | FieldReadFunction<any>,
	checkoutErrors?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CheckoutLinesDeleteKeySpecifier = ('checkout' | 'errors' | CheckoutLinesDeleteKeySpecifier)[];
export type CheckoutLinesDeleteFieldPolicy = {
	checkout?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CheckoutLinesUpdateKeySpecifier = ('checkout' | 'checkoutErrors' | 'errors' | CheckoutLinesUpdateKeySpecifier)[];
export type CheckoutLinesUpdateFieldPolicy = {
	checkout?: FieldPolicy<any> | FieldReadFunction<any>,
	checkoutErrors?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CheckoutMetadataUpdatedKeySpecifier = ('checkout' | 'issuedAt' | 'issuingPrincipal' | 'recipient' | 'version' | CheckoutMetadataUpdatedKeySpecifier)[];
export type CheckoutMetadataUpdatedFieldPolicy = {
	checkout?: FieldPolicy<any> | FieldReadFunction<any>,
	issuedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	issuingPrincipal?: FieldPolicy<any> | FieldReadFunction<any>,
	recipient?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CheckoutPaymentCreateKeySpecifier = ('checkout' | 'errors' | 'payment' | 'paymentErrors' | CheckoutPaymentCreateKeySpecifier)[];
export type CheckoutPaymentCreateFieldPolicy = {
	checkout?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	payment?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentErrors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CheckoutRemovePromoCodeKeySpecifier = ('checkout' | 'checkoutErrors' | 'errors' | CheckoutRemovePromoCodeKeySpecifier)[];
export type CheckoutRemovePromoCodeFieldPolicy = {
	checkout?: FieldPolicy<any> | FieldReadFunction<any>,
	checkoutErrors?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CheckoutSettingsKeySpecifier = ('automaticCompletionCutOffDate' | 'automaticCompletionDelay' | 'automaticallyCompleteFullyPaidCheckouts' | 'useLegacyErrorFlow' | CheckoutSettingsKeySpecifier)[];
export type CheckoutSettingsFieldPolicy = {
	automaticCompletionCutOffDate?: FieldPolicy<any> | FieldReadFunction<any>,
	automaticCompletionDelay?: FieldPolicy<any> | FieldReadFunction<any>,
	automaticallyCompleteFullyPaidCheckouts?: FieldPolicy<any> | FieldReadFunction<any>,
	useLegacyErrorFlow?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CheckoutShippingAddressUpdateKeySpecifier = ('checkout' | 'checkoutErrors' | 'errors' | CheckoutShippingAddressUpdateKeySpecifier)[];
export type CheckoutShippingAddressUpdateFieldPolicy = {
	checkout?: FieldPolicy<any> | FieldReadFunction<any>,
	checkoutErrors?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CheckoutShippingMethodUpdateKeySpecifier = ('checkout' | 'checkoutErrors' | 'errors' | CheckoutShippingMethodUpdateKeySpecifier)[];
export type CheckoutShippingMethodUpdateFieldPolicy = {
	checkout?: FieldPolicy<any> | FieldReadFunction<any>,
	checkoutErrors?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CheckoutUpdatedKeySpecifier = ('checkout' | 'issuedAt' | 'issuingPrincipal' | 'recipient' | 'version' | CheckoutUpdatedKeySpecifier)[];
export type CheckoutUpdatedFieldPolicy = {
	checkout?: FieldPolicy<any> | FieldReadFunction<any>,
	issuedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	issuingPrincipal?: FieldPolicy<any> | FieldReadFunction<any>,
	recipient?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ChoiceValueKeySpecifier = ('raw' | 'verbose' | ChoiceValueKeySpecifier)[];
export type ChoiceValueFieldPolicy = {
	raw?: FieldPolicy<any> | FieldReadFunction<any>,
	verbose?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CollectionKeySpecifier = ('backgroundImage' | 'channel' | 'channelListings' | 'description' | 'descriptionJson' | 'id' | 'metadata' | 'metafield' | 'metafields' | 'name' | 'privateMetadata' | 'privateMetafield' | 'privateMetafields' | 'products' | 'seoDescription' | 'seoTitle' | 'slug' | 'translation' | CollectionKeySpecifier)[];
export type CollectionFieldPolicy = {
	backgroundImage?: FieldPolicy<any> | FieldReadFunction<any>,
	channel?: FieldPolicy<any> | FieldReadFunction<any>,
	channelListings?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	descriptionJson?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	metadata?: FieldPolicy<any> | FieldReadFunction<any>,
	metafield?: FieldPolicy<any> | FieldReadFunction<any>,
	metafields?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	privateMetadata?: FieldPolicy<any> | FieldReadFunction<any>,
	privateMetafield?: FieldPolicy<any> | FieldReadFunction<any>,
	privateMetafields?: FieldPolicy<any> | FieldReadFunction<any>,
	products?: FieldPolicy<any> | FieldReadFunction<any>,
	seoDescription?: FieldPolicy<any> | FieldReadFunction<any>,
	seoTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	slug?: FieldPolicy<any> | FieldReadFunction<any>,
	translation?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CollectionAddProductsKeySpecifier = ('collection' | 'collectionErrors' | 'errors' | CollectionAddProductsKeySpecifier)[];
export type CollectionAddProductsFieldPolicy = {
	collection?: FieldPolicy<any> | FieldReadFunction<any>,
	collectionErrors?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CollectionBulkDeleteKeySpecifier = ('collectionErrors' | 'count' | 'errors' | CollectionBulkDeleteKeySpecifier)[];
export type CollectionBulkDeleteFieldPolicy = {
	collectionErrors?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CollectionChannelListingKeySpecifier = ('channel' | 'id' | 'isPublished' | 'publicationDate' | 'publishedAt' | CollectionChannelListingKeySpecifier)[];
export type CollectionChannelListingFieldPolicy = {
	channel?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isPublished?: FieldPolicy<any> | FieldReadFunction<any>,
	publicationDate?: FieldPolicy<any> | FieldReadFunction<any>,
	publishedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CollectionChannelListingErrorKeySpecifier = ('attributes' | 'channels' | 'code' | 'field' | 'message' | 'values' | CollectionChannelListingErrorKeySpecifier)[];
export type CollectionChannelListingErrorFieldPolicy = {
	attributes?: FieldPolicy<any> | FieldReadFunction<any>,
	channels?: FieldPolicy<any> | FieldReadFunction<any>,
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	field?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>,
	values?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CollectionChannelListingUpdateKeySpecifier = ('collection' | 'collectionChannelListingErrors' | 'errors' | CollectionChannelListingUpdateKeySpecifier)[];
export type CollectionChannelListingUpdateFieldPolicy = {
	collection?: FieldPolicy<any> | FieldReadFunction<any>,
	collectionChannelListingErrors?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CollectionCountableConnectionKeySpecifier = ('edges' | 'pageInfo' | 'totalCount' | CollectionCountableConnectionKeySpecifier)[];
export type CollectionCountableConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CollectionCountableEdgeKeySpecifier = ('cursor' | 'node' | CollectionCountableEdgeKeySpecifier)[];
export type CollectionCountableEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CollectionCreateKeySpecifier = ('collection' | 'collectionErrors' | 'errors' | CollectionCreateKeySpecifier)[];
export type CollectionCreateFieldPolicy = {
	collection?: FieldPolicy<any> | FieldReadFunction<any>,
	collectionErrors?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CollectionCreatedKeySpecifier = ('collection' | 'issuedAt' | 'issuingPrincipal' | 'recipient' | 'version' | CollectionCreatedKeySpecifier)[];
export type CollectionCreatedFieldPolicy = {
	collection?: FieldPolicy<any> | FieldReadFunction<any>,
	issuedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	issuingPrincipal?: FieldPolicy<any> | FieldReadFunction<any>,
	recipient?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CollectionDeleteKeySpecifier = ('collection' | 'collectionErrors' | 'errors' | CollectionDeleteKeySpecifier)[];
export type CollectionDeleteFieldPolicy = {
	collection?: FieldPolicy<any> | FieldReadFunction<any>,
	collectionErrors?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CollectionDeletedKeySpecifier = ('collection' | 'issuedAt' | 'issuingPrincipal' | 'recipient' | 'version' | CollectionDeletedKeySpecifier)[];
export type CollectionDeletedFieldPolicy = {
	collection?: FieldPolicy<any> | FieldReadFunction<any>,
	issuedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	issuingPrincipal?: FieldPolicy<any> | FieldReadFunction<any>,
	recipient?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CollectionErrorKeySpecifier = ('code' | 'field' | 'message' | 'products' | CollectionErrorKeySpecifier)[];
export type CollectionErrorFieldPolicy = {
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	field?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>,
	products?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CollectionMetadataUpdatedKeySpecifier = ('collection' | 'issuedAt' | 'issuingPrincipal' | 'recipient' | 'version' | CollectionMetadataUpdatedKeySpecifier)[];
export type CollectionMetadataUpdatedFieldPolicy = {
	collection?: FieldPolicy<any> | FieldReadFunction<any>,
	issuedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	issuingPrincipal?: FieldPolicy<any> | FieldReadFunction<any>,
	recipient?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CollectionRemoveProductsKeySpecifier = ('collection' | 'collectionErrors' | 'errors' | CollectionRemoveProductsKeySpecifier)[];
export type CollectionRemoveProductsFieldPolicy = {
	collection?: FieldPolicy<any> | FieldReadFunction<any>,
	collectionErrors?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CollectionReorderProductsKeySpecifier = ('collection' | 'collectionErrors' | 'errors' | CollectionReorderProductsKeySpecifier)[];
export type CollectionReorderProductsFieldPolicy = {
	collection?: FieldPolicy<any> | FieldReadFunction<any>,
	collectionErrors?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CollectionTranslatableContentKeySpecifier = ('collection' | 'collectionId' | 'description' | 'descriptionJson' | 'id' | 'name' | 'seoDescription' | 'seoTitle' | 'slug' | 'translation' | CollectionTranslatableContentKeySpecifier)[];
export type CollectionTranslatableContentFieldPolicy = {
	collection?: FieldPolicy<any> | FieldReadFunction<any>,
	collectionId?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	descriptionJson?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	seoDescription?: FieldPolicy<any> | FieldReadFunction<any>,
	seoTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	slug?: FieldPolicy<any> | FieldReadFunction<any>,
	translation?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CollectionTranslateKeySpecifier = ('collection' | 'errors' | 'translationErrors' | CollectionTranslateKeySpecifier)[];
export type CollectionTranslateFieldPolicy = {
	collection?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	translationErrors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CollectionTranslationKeySpecifier = ('description' | 'descriptionJson' | 'id' | 'language' | 'name' | 'seoDescription' | 'seoTitle' | 'slug' | 'translatableContent' | CollectionTranslationKeySpecifier)[];
export type CollectionTranslationFieldPolicy = {
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	descriptionJson?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	language?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	seoDescription?: FieldPolicy<any> | FieldReadFunction<any>,
	seoTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	slug?: FieldPolicy<any> | FieldReadFunction<any>,
	translatableContent?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CollectionUpdateKeySpecifier = ('collection' | 'collectionErrors' | 'errors' | CollectionUpdateKeySpecifier)[];
export type CollectionUpdateFieldPolicy = {
	collection?: FieldPolicy<any> | FieldReadFunction<any>,
	collectionErrors?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CollectionUpdatedKeySpecifier = ('collection' | 'issuedAt' | 'issuingPrincipal' | 'recipient' | 'version' | CollectionUpdatedKeySpecifier)[];
export type CollectionUpdatedFieldPolicy = {
	collection?: FieldPolicy<any> | FieldReadFunction<any>,
	issuedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	issuingPrincipal?: FieldPolicy<any> | FieldReadFunction<any>,
	recipient?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ConfigurationItemKeySpecifier = ('helpText' | 'label' | 'name' | 'type' | 'value' | ConfigurationItemKeySpecifier)[];
export type ConfigurationItemFieldPolicy = {
	helpText?: FieldPolicy<any> | FieldReadFunction<any>,
	label?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ConfirmAccountKeySpecifier = ('accountErrors' | 'errors' | 'user' | ConfirmAccountKeySpecifier)[];
export type ConfirmAccountFieldPolicy = {
	accountErrors?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ConfirmEmailChangeKeySpecifier = ('accountErrors' | 'errors' | 'user' | ConfirmEmailChangeKeySpecifier)[];
export type ConfirmEmailChangeFieldPolicy = {
	accountErrors?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CountryDisplayKeySpecifier = ('code' | 'country' | 'vat' | CountryDisplayKeySpecifier)[];
export type CountryDisplayFieldPolicy = {
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	country?: FieldPolicy<any> | FieldReadFunction<any>,
	vat?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CreateTokenKeySpecifier = ('accountErrors' | 'csrfToken' | 'errors' | 'refreshToken' | 'token' | 'user' | CreateTokenKeySpecifier)[];
export type CreateTokenFieldPolicy = {
	accountErrors?: FieldPolicy<any> | FieldReadFunction<any>,
	csrfToken?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	refreshToken?: FieldPolicy<any> | FieldReadFunction<any>,
	token?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CreditCardKeySpecifier = ('brand' | 'expMonth' | 'expYear' | 'firstDigits' | 'lastDigits' | CreditCardKeySpecifier)[];
export type CreditCardFieldPolicy = {
	brand?: FieldPolicy<any> | FieldReadFunction<any>,
	expMonth?: FieldPolicy<any> | FieldReadFunction<any>,
	expYear?: FieldPolicy<any> | FieldReadFunction<any>,
	firstDigits?: FieldPolicy<any> | FieldReadFunction<any>,
	lastDigits?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CustomerBulkDeleteKeySpecifier = ('accountErrors' | 'count' | 'errors' | CustomerBulkDeleteKeySpecifier)[];
export type CustomerBulkDeleteFieldPolicy = {
	accountErrors?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CustomerBulkResultKeySpecifier = ('customer' | 'errors' | CustomerBulkResultKeySpecifier)[];
export type CustomerBulkResultFieldPolicy = {
	customer?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CustomerBulkUpdateKeySpecifier = ('count' | 'errors' | 'results' | CustomerBulkUpdateKeySpecifier)[];
export type CustomerBulkUpdateFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	results?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CustomerBulkUpdateErrorKeySpecifier = ('code' | 'message' | 'path' | CustomerBulkUpdateErrorKeySpecifier)[];
export type CustomerBulkUpdateErrorFieldPolicy = {
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>,
	path?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CustomerCreateKeySpecifier = ('accountErrors' | 'errors' | 'user' | CustomerCreateKeySpecifier)[];
export type CustomerCreateFieldPolicy = {
	accountErrors?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CustomerCreatedKeySpecifier = ('issuedAt' | 'issuingPrincipal' | 'recipient' | 'user' | 'version' | CustomerCreatedKeySpecifier)[];
export type CustomerCreatedFieldPolicy = {
	issuedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	issuingPrincipal?: FieldPolicy<any> | FieldReadFunction<any>,
	recipient?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CustomerDeleteKeySpecifier = ('accountErrors' | 'errors' | 'user' | CustomerDeleteKeySpecifier)[];
export type CustomerDeleteFieldPolicy = {
	accountErrors?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CustomerEventKeySpecifier = ('app' | 'count' | 'date' | 'id' | 'message' | 'order' | 'orderLine' | 'type' | 'user' | CustomerEventKeySpecifier)[];
export type CustomerEventFieldPolicy = {
	app?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	date?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>,
	order?: FieldPolicy<any> | FieldReadFunction<any>,
	orderLine?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CustomerMetadataUpdatedKeySpecifier = ('issuedAt' | 'issuingPrincipal' | 'recipient' | 'user' | 'version' | CustomerMetadataUpdatedKeySpecifier)[];
export type CustomerMetadataUpdatedFieldPolicy = {
	issuedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	issuingPrincipal?: FieldPolicy<any> | FieldReadFunction<any>,
	recipient?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CustomerUpdateKeySpecifier = ('accountErrors' | 'errors' | 'user' | CustomerUpdateKeySpecifier)[];
export type CustomerUpdateFieldPolicy = {
	accountErrors?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CustomerUpdatedKeySpecifier = ('issuedAt' | 'issuingPrincipal' | 'recipient' | 'user' | 'version' | CustomerUpdatedKeySpecifier)[];
export type CustomerUpdatedFieldPolicy = {
	issuedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	issuingPrincipal?: FieldPolicy<any> | FieldReadFunction<any>,
	recipient?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeactivateAllUserTokensKeySpecifier = ('accountErrors' | 'errors' | DeactivateAllUserTokensKeySpecifier)[];
export type DeactivateAllUserTokensFieldPolicy = {
	accountErrors?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeleteMetadataKeySpecifier = ('errors' | 'item' | 'metadataErrors' | DeleteMetadataKeySpecifier)[];
export type DeleteMetadataFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	item?: FieldPolicy<any> | FieldReadFunction<any>,
	metadataErrors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeletePrivateMetadataKeySpecifier = ('errors' | 'item' | 'metadataErrors' | DeletePrivateMetadataKeySpecifier)[];
export type DeletePrivateMetadataFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	item?: FieldPolicy<any> | FieldReadFunction<any>,
	metadataErrors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DigitalContentKeySpecifier = ('automaticFulfillment' | 'contentFile' | 'id' | 'maxDownloads' | 'metadata' | 'metafield' | 'metafields' | 'privateMetadata' | 'privateMetafield' | 'privateMetafields' | 'productVariant' | 'urlValidDays' | 'urls' | 'useDefaultSettings' | DigitalContentKeySpecifier)[];
export type DigitalContentFieldPolicy = {
	automaticFulfillment?: FieldPolicy<any> | FieldReadFunction<any>,
	contentFile?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	maxDownloads?: FieldPolicy<any> | FieldReadFunction<any>,
	metadata?: FieldPolicy<any> | FieldReadFunction<any>,
	metafield?: FieldPolicy<any> | FieldReadFunction<any>,
	metafields?: FieldPolicy<any> | FieldReadFunction<any>,
	privateMetadata?: FieldPolicy<any> | FieldReadFunction<any>,
	privateMetafield?: FieldPolicy<any> | FieldReadFunction<any>,
	privateMetafields?: FieldPolicy<any> | FieldReadFunction<any>,
	productVariant?: FieldPolicy<any> | FieldReadFunction<any>,
	urlValidDays?: FieldPolicy<any> | FieldReadFunction<any>,
	urls?: FieldPolicy<any> | FieldReadFunction<any>,
	useDefaultSettings?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DigitalContentCountableConnectionKeySpecifier = ('edges' | 'pageInfo' | 'totalCount' | DigitalContentCountableConnectionKeySpecifier)[];
export type DigitalContentCountableConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DigitalContentCountableEdgeKeySpecifier = ('cursor' | 'node' | DigitalContentCountableEdgeKeySpecifier)[];
export type DigitalContentCountableEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DigitalContentCreateKeySpecifier = ('content' | 'errors' | 'productErrors' | 'variant' | DigitalContentCreateKeySpecifier)[];
export type DigitalContentCreateFieldPolicy = {
	content?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	productErrors?: FieldPolicy<any> | FieldReadFunction<any>,
	variant?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DigitalContentDeleteKeySpecifier = ('errors' | 'productErrors' | 'variant' | DigitalContentDeleteKeySpecifier)[];
export type DigitalContentDeleteFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	productErrors?: FieldPolicy<any> | FieldReadFunction<any>,
	variant?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DigitalContentUpdateKeySpecifier = ('content' | 'errors' | 'productErrors' | 'variant' | DigitalContentUpdateKeySpecifier)[];
export type DigitalContentUpdateFieldPolicy = {
	content?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	productErrors?: FieldPolicy<any> | FieldReadFunction<any>,
	variant?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DigitalContentUrlKeySpecifier = ('content' | 'created' | 'downloadNum' | 'id' | 'token' | 'url' | DigitalContentUrlKeySpecifier)[];
export type DigitalContentUrlFieldPolicy = {
	content?: FieldPolicy<any> | FieldReadFunction<any>,
	created?: FieldPolicy<any> | FieldReadFunction<any>,
	downloadNum?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	token?: FieldPolicy<any> | FieldReadFunction<any>,
	url?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DigitalContentUrlCreateKeySpecifier = ('digitalContentUrl' | 'errors' | 'productErrors' | DigitalContentUrlCreateKeySpecifier)[];
export type DigitalContentUrlCreateFieldPolicy = {
	digitalContentUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	productErrors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DiscountErrorKeySpecifier = ('channels' | 'code' | 'field' | 'message' | 'products' | 'voucherCodes' | DiscountErrorKeySpecifier)[];
export type DiscountErrorFieldPolicy = {
	channels?: FieldPolicy<any> | FieldReadFunction<any>,
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	field?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>,
	products?: FieldPolicy<any> | FieldReadFunction<any>,
	voucherCodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DomainKeySpecifier = ('host' | 'sslEnabled' | 'url' | DomainKeySpecifier)[];
export type DomainFieldPolicy = {
	host?: FieldPolicy<any> | FieldReadFunction<any>,
	sslEnabled?: FieldPolicy<any> | FieldReadFunction<any>,
	url?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DraftOrderBulkDeleteKeySpecifier = ('count' | 'errors' | 'orderErrors' | DraftOrderBulkDeleteKeySpecifier)[];
export type DraftOrderBulkDeleteFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	orderErrors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DraftOrderCompleteKeySpecifier = ('errors' | 'order' | 'orderErrors' | DraftOrderCompleteKeySpecifier)[];
export type DraftOrderCompleteFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	order?: FieldPolicy<any> | FieldReadFunction<any>,
	orderErrors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DraftOrderCreateKeySpecifier = ('errors' | 'order' | 'orderErrors' | DraftOrderCreateKeySpecifier)[];
export type DraftOrderCreateFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	order?: FieldPolicy<any> | FieldReadFunction<any>,
	orderErrors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DraftOrderCreatedKeySpecifier = ('issuedAt' | 'issuingPrincipal' | 'order' | 'recipient' | 'version' | DraftOrderCreatedKeySpecifier)[];
export type DraftOrderCreatedFieldPolicy = {
	issuedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	issuingPrincipal?: FieldPolicy<any> | FieldReadFunction<any>,
	order?: FieldPolicy<any> | FieldReadFunction<any>,
	recipient?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DraftOrderDeleteKeySpecifier = ('errors' | 'order' | 'orderErrors' | DraftOrderDeleteKeySpecifier)[];
export type DraftOrderDeleteFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	order?: FieldPolicy<any> | FieldReadFunction<any>,
	orderErrors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DraftOrderDeletedKeySpecifier = ('issuedAt' | 'issuingPrincipal' | 'order' | 'recipient' | 'version' | DraftOrderDeletedKeySpecifier)[];
export type DraftOrderDeletedFieldPolicy = {
	issuedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	issuingPrincipal?: FieldPolicy<any> | FieldReadFunction<any>,
	order?: FieldPolicy<any> | FieldReadFunction<any>,
	recipient?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DraftOrderLinesBulkDeleteKeySpecifier = ('count' | 'errors' | 'orderErrors' | DraftOrderLinesBulkDeleteKeySpecifier)[];
export type DraftOrderLinesBulkDeleteFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	orderErrors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DraftOrderUpdateKeySpecifier = ('errors' | 'order' | 'orderErrors' | DraftOrderUpdateKeySpecifier)[];
export type DraftOrderUpdateFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	order?: FieldPolicy<any> | FieldReadFunction<any>,
	orderErrors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DraftOrderUpdatedKeySpecifier = ('issuedAt' | 'issuingPrincipal' | 'order' | 'recipient' | 'version' | DraftOrderUpdatedKeySpecifier)[];
export type DraftOrderUpdatedFieldPolicy = {
	issuedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	issuingPrincipal?: FieldPolicy<any> | FieldReadFunction<any>,
	order?: FieldPolicy<any> | FieldReadFunction<any>,
	recipient?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EventKeySpecifier = ('issuedAt' | 'issuingPrincipal' | 'recipient' | 'version' | EventKeySpecifier)[];
export type EventFieldPolicy = {
	issuedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	issuingPrincipal?: FieldPolicy<any> | FieldReadFunction<any>,
	recipient?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EventDeliveryKeySpecifier = ('attempts' | 'createdAt' | 'eventType' | 'id' | 'payload' | 'status' | EventDeliveryKeySpecifier)[];
export type EventDeliveryFieldPolicy = {
	attempts?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	eventType?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	payload?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EventDeliveryAttemptKeySpecifier = ('createdAt' | 'duration' | 'id' | 'requestHeaders' | 'response' | 'responseHeaders' | 'responseStatusCode' | 'status' | 'taskId' | EventDeliveryAttemptKeySpecifier)[];
export type EventDeliveryAttemptFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	duration?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	requestHeaders?: FieldPolicy<any> | FieldReadFunction<any>,
	response?: FieldPolicy<any> | FieldReadFunction<any>,
	responseHeaders?: FieldPolicy<any> | FieldReadFunction<any>,
	responseStatusCode?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	taskId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EventDeliveryAttemptCountableConnectionKeySpecifier = ('edges' | 'pageInfo' | 'totalCount' | EventDeliveryAttemptCountableConnectionKeySpecifier)[];
export type EventDeliveryAttemptCountableConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EventDeliveryAttemptCountableEdgeKeySpecifier = ('cursor' | 'node' | EventDeliveryAttemptCountableEdgeKeySpecifier)[];
export type EventDeliveryAttemptCountableEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EventDeliveryCountableConnectionKeySpecifier = ('edges' | 'pageInfo' | 'totalCount' | EventDeliveryCountableConnectionKeySpecifier)[];
export type EventDeliveryCountableConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EventDeliveryCountableEdgeKeySpecifier = ('cursor' | 'node' | EventDeliveryCountableEdgeKeySpecifier)[];
export type EventDeliveryCountableEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EventDeliveryRetryKeySpecifier = ('delivery' | 'errors' | EventDeliveryRetryKeySpecifier)[];
export type EventDeliveryRetryFieldPolicy = {
	delivery?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ExportErrorKeySpecifier = ('code' | 'field' | 'message' | ExportErrorKeySpecifier)[];
export type ExportErrorFieldPolicy = {
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	field?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ExportEventKeySpecifier = ('app' | 'date' | 'id' | 'message' | 'type' | 'user' | ExportEventKeySpecifier)[];
export type ExportEventFieldPolicy = {
	app?: FieldPolicy<any> | FieldReadFunction<any>,
	date?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ExportFileKeySpecifier = ('app' | 'createdAt' | 'events' | 'id' | 'message' | 'status' | 'updatedAt' | 'url' | 'user' | ExportFileKeySpecifier)[];
export type ExportFileFieldPolicy = {
	app?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	events?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	url?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ExportFileCountableConnectionKeySpecifier = ('edges' | 'pageInfo' | 'totalCount' | ExportFileCountableConnectionKeySpecifier)[];
export type ExportFileCountableConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ExportFileCountableEdgeKeySpecifier = ('cursor' | 'node' | ExportFileCountableEdgeKeySpecifier)[];
export type ExportFileCountableEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ExportGiftCardsKeySpecifier = ('errors' | 'exportFile' | ExportGiftCardsKeySpecifier)[];
export type ExportGiftCardsFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	exportFile?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ExportProductsKeySpecifier = ('errors' | 'exportErrors' | 'exportFile' | ExportProductsKeySpecifier)[];
export type ExportProductsFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	exportErrors?: FieldPolicy<any> | FieldReadFunction<any>,
	exportFile?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ExportVoucherCodesKeySpecifier = ('errors' | 'exportFile' | ExportVoucherCodesKeySpecifier)[];
export type ExportVoucherCodesFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	exportFile?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ExternalAuthenticationKeySpecifier = ('id' | 'name' | ExternalAuthenticationKeySpecifier)[];
export type ExternalAuthenticationFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ExternalAuthenticationUrlKeySpecifier = ('accountErrors' | 'authenticationData' | 'errors' | ExternalAuthenticationUrlKeySpecifier)[];
export type ExternalAuthenticationUrlFieldPolicy = {
	accountErrors?: FieldPolicy<any> | FieldReadFunction<any>,
	authenticationData?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ExternalLogoutKeySpecifier = ('accountErrors' | 'errors' | 'logoutData' | ExternalLogoutKeySpecifier)[];
export type ExternalLogoutFieldPolicy = {
	accountErrors?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	logoutData?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ExternalNotificationErrorKeySpecifier = ('code' | 'field' | 'message' | ExternalNotificationErrorKeySpecifier)[];
export type ExternalNotificationErrorFieldPolicy = {
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	field?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ExternalNotificationTriggerKeySpecifier = ('errors' | ExternalNotificationTriggerKeySpecifier)[];
export type ExternalNotificationTriggerFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ExternalObtainAccessTokensKeySpecifier = ('accountErrors' | 'csrfToken' | 'errors' | 'refreshToken' | 'token' | 'user' | ExternalObtainAccessTokensKeySpecifier)[];
export type ExternalObtainAccessTokensFieldPolicy = {
	accountErrors?: FieldPolicy<any> | FieldReadFunction<any>,
	csrfToken?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	refreshToken?: FieldPolicy<any> | FieldReadFunction<any>,
	token?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ExternalRefreshKeySpecifier = ('accountErrors' | 'csrfToken' | 'errors' | 'refreshToken' | 'token' | 'user' | ExternalRefreshKeySpecifier)[];
export type ExternalRefreshFieldPolicy = {
	accountErrors?: FieldPolicy<any> | FieldReadFunction<any>,
	csrfToken?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	refreshToken?: FieldPolicy<any> | FieldReadFunction<any>,
	token?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ExternalVerifyKeySpecifier = ('accountErrors' | 'errors' | 'isValid' | 'user' | 'verifyData' | ExternalVerifyKeySpecifier)[];
export type ExternalVerifyFieldPolicy = {
	accountErrors?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	isValid?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>,
	verifyData?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FileKeySpecifier = ('contentType' | 'url' | FileKeySpecifier)[];
export type FileFieldPolicy = {
	contentType?: FieldPolicy<any> | FieldReadFunction<any>,
	url?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FileUploadKeySpecifier = ('errors' | 'uploadErrors' | 'uploadedFile' | FileUploadKeySpecifier)[];
export type FileUploadFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	uploadErrors?: FieldPolicy<any> | FieldReadFunction<any>,
	uploadedFile?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FulfillmentKeySpecifier = ('created' | 'fulfillmentOrder' | 'id' | 'lines' | 'metadata' | 'metafield' | 'metafields' | 'privateMetadata' | 'privateMetafield' | 'privateMetafields' | 'shippingRefundedAmount' | 'status' | 'statusDisplay' | 'totalRefundedAmount' | 'trackingNumber' | 'warehouse' | FulfillmentKeySpecifier)[];
export type FulfillmentFieldPolicy = {
	created?: FieldPolicy<any> | FieldReadFunction<any>,
	fulfillmentOrder?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	lines?: FieldPolicy<any> | FieldReadFunction<any>,
	metadata?: FieldPolicy<any> | FieldReadFunction<any>,
	metafield?: FieldPolicy<any> | FieldReadFunction<any>,
	metafields?: FieldPolicy<any> | FieldReadFunction<any>,
	privateMetadata?: FieldPolicy<any> | FieldReadFunction<any>,
	privateMetafield?: FieldPolicy<any> | FieldReadFunction<any>,
	privateMetafields?: FieldPolicy<any> | FieldReadFunction<any>,
	shippingRefundedAmount?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	statusDisplay?: FieldPolicy<any> | FieldReadFunction<any>,
	totalRefundedAmount?: FieldPolicy<any> | FieldReadFunction<any>,
	trackingNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	warehouse?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FulfillmentApproveKeySpecifier = ('errors' | 'fulfillment' | 'order' | 'orderErrors' | FulfillmentApproveKeySpecifier)[];
export type FulfillmentApproveFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	fulfillment?: FieldPolicy<any> | FieldReadFunction<any>,
	order?: FieldPolicy<any> | FieldReadFunction<any>,
	orderErrors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FulfillmentApprovedKeySpecifier = ('fulfillment' | 'issuedAt' | 'issuingPrincipal' | 'notifyCustomer' | 'order' | 'recipient' | 'version' | FulfillmentApprovedKeySpecifier)[];
export type FulfillmentApprovedFieldPolicy = {
	fulfillment?: FieldPolicy<any> | FieldReadFunction<any>,
	issuedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	issuingPrincipal?: FieldPolicy<any> | FieldReadFunction<any>,
	notifyCustomer?: FieldPolicy<any> | FieldReadFunction<any>,
	order?: FieldPolicy<any> | FieldReadFunction<any>,
	recipient?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FulfillmentCancelKeySpecifier = ('errors' | 'fulfillment' | 'order' | 'orderErrors' | FulfillmentCancelKeySpecifier)[];
export type FulfillmentCancelFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	fulfillment?: FieldPolicy<any> | FieldReadFunction<any>,
	order?: FieldPolicy<any> | FieldReadFunction<any>,
	orderErrors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FulfillmentCanceledKeySpecifier = ('fulfillment' | 'issuedAt' | 'issuingPrincipal' | 'order' | 'recipient' | 'version' | FulfillmentCanceledKeySpecifier)[];
export type FulfillmentCanceledFieldPolicy = {
	fulfillment?: FieldPolicy<any> | FieldReadFunction<any>,
	issuedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	issuingPrincipal?: FieldPolicy<any> | FieldReadFunction<any>,
	order?: FieldPolicy<any> | FieldReadFunction<any>,
	recipient?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FulfillmentCreatedKeySpecifier = ('fulfillment' | 'issuedAt' | 'issuingPrincipal' | 'notifyCustomer' | 'order' | 'recipient' | 'version' | FulfillmentCreatedKeySpecifier)[];
export type FulfillmentCreatedFieldPolicy = {
	fulfillment?: FieldPolicy<any> | FieldReadFunction<any>,
	issuedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	issuingPrincipal?: FieldPolicy<any> | FieldReadFunction<any>,
	notifyCustomer?: FieldPolicy<any> | FieldReadFunction<any>,
	order?: FieldPolicy<any> | FieldReadFunction<any>,
	recipient?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FulfillmentLineKeySpecifier = ('id' | 'orderLine' | 'quantity' | FulfillmentLineKeySpecifier)[];
export type FulfillmentLineFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	orderLine?: FieldPolicy<any> | FieldReadFunction<any>,
	quantity?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FulfillmentMetadataUpdatedKeySpecifier = ('fulfillment' | 'issuedAt' | 'issuingPrincipal' | 'order' | 'recipient' | 'version' | FulfillmentMetadataUpdatedKeySpecifier)[];
export type FulfillmentMetadataUpdatedFieldPolicy = {
	fulfillment?: FieldPolicy<any> | FieldReadFunction<any>,
	issuedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	issuingPrincipal?: FieldPolicy<any> | FieldReadFunction<any>,
	order?: FieldPolicy<any> | FieldReadFunction<any>,
	recipient?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FulfillmentRefundProductsKeySpecifier = ('errors' | 'fulfillment' | 'order' | 'orderErrors' | FulfillmentRefundProductsKeySpecifier)[];
export type FulfillmentRefundProductsFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	fulfillment?: FieldPolicy<any> | FieldReadFunction<any>,
	order?: FieldPolicy<any> | FieldReadFunction<any>,
	orderErrors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FulfillmentReturnProductsKeySpecifier = ('errors' | 'order' | 'orderErrors' | 'replaceFulfillment' | 'replaceOrder' | 'returnFulfillment' | FulfillmentReturnProductsKeySpecifier)[];
export type FulfillmentReturnProductsFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	order?: FieldPolicy<any> | FieldReadFunction<any>,
	orderErrors?: FieldPolicy<any> | FieldReadFunction<any>,
	replaceFulfillment?: FieldPolicy<any> | FieldReadFunction<any>,
	replaceOrder?: FieldPolicy<any> | FieldReadFunction<any>,
	returnFulfillment?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FulfillmentTrackingNumberUpdatedKeySpecifier = ('fulfillment' | 'issuedAt' | 'issuingPrincipal' | 'order' | 'recipient' | 'version' | FulfillmentTrackingNumberUpdatedKeySpecifier)[];
export type FulfillmentTrackingNumberUpdatedFieldPolicy = {
	fulfillment?: FieldPolicy<any> | FieldReadFunction<any>,
	issuedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	issuingPrincipal?: FieldPolicy<any> | FieldReadFunction<any>,
	order?: FieldPolicy<any> | FieldReadFunction<any>,
	recipient?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FulfillmentUpdateTrackingKeySpecifier = ('errors' | 'fulfillment' | 'order' | 'orderErrors' | FulfillmentUpdateTrackingKeySpecifier)[];
export type FulfillmentUpdateTrackingFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	fulfillment?: FieldPolicy<any> | FieldReadFunction<any>,
	order?: FieldPolicy<any> | FieldReadFunction<any>,
	orderErrors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GatewayConfigLineKeySpecifier = ('field' | 'value' | GatewayConfigLineKeySpecifier)[];
export type GatewayConfigLineFieldPolicy = {
	field?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GiftCardKeySpecifier = ('app' | 'boughtInChannel' | 'code' | 'created' | 'createdBy' | 'createdByEmail' | 'currentBalance' | 'displayCode' | 'endDate' | 'events' | 'expiryDate' | 'id' | 'initialBalance' | 'isActive' | 'last4CodeChars' | 'lastUsedOn' | 'metadata' | 'metafield' | 'metafields' | 'privateMetadata' | 'privateMetafield' | 'privateMetafields' | 'product' | 'startDate' | 'tags' | 'usedBy' | 'usedByEmail' | 'user' | GiftCardKeySpecifier)[];
export type GiftCardFieldPolicy = {
	app?: FieldPolicy<any> | FieldReadFunction<any>,
	boughtInChannel?: FieldPolicy<any> | FieldReadFunction<any>,
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	created?: FieldPolicy<any> | FieldReadFunction<any>,
	createdBy?: FieldPolicy<any> | FieldReadFunction<any>,
	createdByEmail?: FieldPolicy<any> | FieldReadFunction<any>,
	currentBalance?: FieldPolicy<any> | FieldReadFunction<any>,
	displayCode?: FieldPolicy<any> | FieldReadFunction<any>,
	endDate?: FieldPolicy<any> | FieldReadFunction<any>,
	events?: FieldPolicy<any> | FieldReadFunction<any>,
	expiryDate?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	initialBalance?: FieldPolicy<any> | FieldReadFunction<any>,
	isActive?: FieldPolicy<any> | FieldReadFunction<any>,
	last4CodeChars?: FieldPolicy<any> | FieldReadFunction<any>,
	lastUsedOn?: FieldPolicy<any> | FieldReadFunction<any>,
	metadata?: FieldPolicy<any> | FieldReadFunction<any>,
	metafield?: FieldPolicy<any> | FieldReadFunction<any>,
	metafields?: FieldPolicy<any> | FieldReadFunction<any>,
	privateMetadata?: FieldPolicy<any> | FieldReadFunction<any>,
	privateMetafield?: FieldPolicy<any> | FieldReadFunction<any>,
	privateMetafields?: FieldPolicy<any> | FieldReadFunction<any>,
	product?: FieldPolicy<any> | FieldReadFunction<any>,
	startDate?: FieldPolicy<any> | FieldReadFunction<any>,
	tags?: FieldPolicy<any> | FieldReadFunction<any>,
	usedBy?: FieldPolicy<any> | FieldReadFunction<any>,
	usedByEmail?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GiftCardActivateKeySpecifier = ('errors' | 'giftCard' | 'giftCardErrors' | GiftCardActivateKeySpecifier)[];
export type GiftCardActivateFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	giftCard?: FieldPolicy<any> | FieldReadFunction<any>,
	giftCardErrors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GiftCardAddNoteKeySpecifier = ('errors' | 'event' | 'giftCard' | GiftCardAddNoteKeySpecifier)[];
export type GiftCardAddNoteFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	event?: FieldPolicy<any> | FieldReadFunction<any>,
	giftCard?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GiftCardBulkActivateKeySpecifier = ('count' | 'errors' | GiftCardBulkActivateKeySpecifier)[];
export type GiftCardBulkActivateFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GiftCardBulkCreateKeySpecifier = ('count' | 'errors' | 'giftCards' | GiftCardBulkCreateKeySpecifier)[];
export type GiftCardBulkCreateFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	giftCards?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GiftCardBulkDeactivateKeySpecifier = ('count' | 'errors' | GiftCardBulkDeactivateKeySpecifier)[];
export type GiftCardBulkDeactivateFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GiftCardBulkDeleteKeySpecifier = ('count' | 'errors' | GiftCardBulkDeleteKeySpecifier)[];
export type GiftCardBulkDeleteFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GiftCardCountableConnectionKeySpecifier = ('edges' | 'pageInfo' | 'totalCount' | GiftCardCountableConnectionKeySpecifier)[];
export type GiftCardCountableConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GiftCardCountableEdgeKeySpecifier = ('cursor' | 'node' | GiftCardCountableEdgeKeySpecifier)[];
export type GiftCardCountableEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GiftCardCreateKeySpecifier = ('errors' | 'giftCard' | 'giftCardErrors' | GiftCardCreateKeySpecifier)[];
export type GiftCardCreateFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	giftCard?: FieldPolicy<any> | FieldReadFunction<any>,
	giftCardErrors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GiftCardCreatedKeySpecifier = ('giftCard' | 'issuedAt' | 'issuingPrincipal' | 'recipient' | 'version' | GiftCardCreatedKeySpecifier)[];
export type GiftCardCreatedFieldPolicy = {
	giftCard?: FieldPolicy<any> | FieldReadFunction<any>,
	issuedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	issuingPrincipal?: FieldPolicy<any> | FieldReadFunction<any>,
	recipient?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GiftCardDeactivateKeySpecifier = ('errors' | 'giftCard' | 'giftCardErrors' | GiftCardDeactivateKeySpecifier)[];
export type GiftCardDeactivateFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	giftCard?: FieldPolicy<any> | FieldReadFunction<any>,
	giftCardErrors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GiftCardDeleteKeySpecifier = ('errors' | 'giftCard' | 'giftCardErrors' | GiftCardDeleteKeySpecifier)[];
export type GiftCardDeleteFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	giftCard?: FieldPolicy<any> | FieldReadFunction<any>,
	giftCardErrors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GiftCardDeletedKeySpecifier = ('giftCard' | 'issuedAt' | 'issuingPrincipal' | 'recipient' | 'version' | GiftCardDeletedKeySpecifier)[];
export type GiftCardDeletedFieldPolicy = {
	giftCard?: FieldPolicy<any> | FieldReadFunction<any>,
	issuedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	issuingPrincipal?: FieldPolicy<any> | FieldReadFunction<any>,
	recipient?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GiftCardErrorKeySpecifier = ('code' | 'field' | 'message' | 'tags' | GiftCardErrorKeySpecifier)[];
export type GiftCardErrorFieldPolicy = {
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	field?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>,
	tags?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GiftCardEventKeySpecifier = ('app' | 'balance' | 'date' | 'email' | 'expiryDate' | 'id' | 'message' | 'oldExpiryDate' | 'oldTags' | 'orderId' | 'orderNumber' | 'tags' | 'type' | 'user' | GiftCardEventKeySpecifier)[];
export type GiftCardEventFieldPolicy = {
	app?: FieldPolicy<any> | FieldReadFunction<any>,
	balance?: FieldPolicy<any> | FieldReadFunction<any>,
	date?: FieldPolicy<any> | FieldReadFunction<any>,
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	expiryDate?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>,
	oldExpiryDate?: FieldPolicy<any> | FieldReadFunction<any>,
	oldTags?: FieldPolicy<any> | FieldReadFunction<any>,
	orderId?: FieldPolicy<any> | FieldReadFunction<any>,
	orderNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	tags?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GiftCardEventBalanceKeySpecifier = ('currentBalance' | 'initialBalance' | 'oldCurrentBalance' | 'oldInitialBalance' | GiftCardEventBalanceKeySpecifier)[];
export type GiftCardEventBalanceFieldPolicy = {
	currentBalance?: FieldPolicy<any> | FieldReadFunction<any>,
	initialBalance?: FieldPolicy<any> | FieldReadFunction<any>,
	oldCurrentBalance?: FieldPolicy<any> | FieldReadFunction<any>,
	oldInitialBalance?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GiftCardExportCompletedKeySpecifier = ('export' | 'issuedAt' | 'issuingPrincipal' | 'recipient' | 'version' | GiftCardExportCompletedKeySpecifier)[];
export type GiftCardExportCompletedFieldPolicy = {
	export?: FieldPolicy<any> | FieldReadFunction<any>,
	issuedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	issuingPrincipal?: FieldPolicy<any> | FieldReadFunction<any>,
	recipient?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GiftCardMetadataUpdatedKeySpecifier = ('giftCard' | 'issuedAt' | 'issuingPrincipal' | 'recipient' | 'version' | GiftCardMetadataUpdatedKeySpecifier)[];
export type GiftCardMetadataUpdatedFieldPolicy = {
	giftCard?: FieldPolicy<any> | FieldReadFunction<any>,
	issuedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	issuingPrincipal?: FieldPolicy<any> | FieldReadFunction<any>,
	recipient?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GiftCardResendKeySpecifier = ('errors' | 'giftCard' | GiftCardResendKeySpecifier)[];
export type GiftCardResendFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	giftCard?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GiftCardSentKeySpecifier = ('channel' | 'giftCard' | 'issuedAt' | 'issuingPrincipal' | 'recipient' | 'sentToEmail' | 'version' | GiftCardSentKeySpecifier)[];
export type GiftCardSentFieldPolicy = {
	channel?: FieldPolicy<any> | FieldReadFunction<any>,
	giftCard?: FieldPolicy<any> | FieldReadFunction<any>,
	issuedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	issuingPrincipal?: FieldPolicy<any> | FieldReadFunction<any>,
	recipient?: FieldPolicy<any> | FieldReadFunction<any>,
	sentToEmail?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GiftCardSettingsKeySpecifier = ('expiryPeriod' | 'expiryType' | GiftCardSettingsKeySpecifier)[];
export type GiftCardSettingsFieldPolicy = {
	expiryPeriod?: FieldPolicy<any> | FieldReadFunction<any>,
	expiryType?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GiftCardSettingsErrorKeySpecifier = ('code' | 'field' | 'message' | GiftCardSettingsErrorKeySpecifier)[];
export type GiftCardSettingsErrorFieldPolicy = {
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	field?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GiftCardSettingsUpdateKeySpecifier = ('errors' | 'giftCardSettings' | GiftCardSettingsUpdateKeySpecifier)[];
export type GiftCardSettingsUpdateFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	giftCardSettings?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GiftCardStatusChangedKeySpecifier = ('giftCard' | 'issuedAt' | 'issuingPrincipal' | 'recipient' | 'version' | GiftCardStatusChangedKeySpecifier)[];
export type GiftCardStatusChangedFieldPolicy = {
	giftCard?: FieldPolicy<any> | FieldReadFunction<any>,
	issuedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	issuingPrincipal?: FieldPolicy<any> | FieldReadFunction<any>,
	recipient?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GiftCardTagKeySpecifier = ('id' | 'name' | GiftCardTagKeySpecifier)[];
export type GiftCardTagFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GiftCardTagCountableConnectionKeySpecifier = ('edges' | 'pageInfo' | 'totalCount' | GiftCardTagCountableConnectionKeySpecifier)[];
export type GiftCardTagCountableConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GiftCardTagCountableEdgeKeySpecifier = ('cursor' | 'node' | GiftCardTagCountableEdgeKeySpecifier)[];
export type GiftCardTagCountableEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GiftCardUpdateKeySpecifier = ('errors' | 'giftCard' | 'giftCardErrors' | GiftCardUpdateKeySpecifier)[];
export type GiftCardUpdateFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	giftCard?: FieldPolicy<any> | FieldReadFunction<any>,
	giftCardErrors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GiftCardUpdatedKeySpecifier = ('giftCard' | 'issuedAt' | 'issuingPrincipal' | 'recipient' | 'version' | GiftCardUpdatedKeySpecifier)[];
export type GiftCardUpdatedFieldPolicy = {
	giftCard?: FieldPolicy<any> | FieldReadFunction<any>,
	issuedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	issuingPrincipal?: FieldPolicy<any> | FieldReadFunction<any>,
	recipient?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GroupKeySpecifier = ('accessibleChannels' | 'id' | 'name' | 'permissions' | 'restrictedAccessToChannels' | 'userCanManage' | 'users' | GroupKeySpecifier)[];
export type GroupFieldPolicy = {
	accessibleChannels?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	permissions?: FieldPolicy<any> | FieldReadFunction<any>,
	restrictedAccessToChannels?: FieldPolicy<any> | FieldReadFunction<any>,
	userCanManage?: FieldPolicy<any> | FieldReadFunction<any>,
	users?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GroupCountableConnectionKeySpecifier = ('edges' | 'pageInfo' | 'totalCount' | GroupCountableConnectionKeySpecifier)[];
export type GroupCountableConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GroupCountableEdgeKeySpecifier = ('cursor' | 'node' | GroupCountableEdgeKeySpecifier)[];
export type GroupCountableEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ImageKeySpecifier = ('alt' | 'url' | ImageKeySpecifier)[];
export type ImageFieldPolicy = {
	alt?: FieldPolicy<any> | FieldReadFunction<any>,
	url?: FieldPolicy<any> | FieldReadFunction<any>
};
export type InvoiceKeySpecifier = ('createdAt' | 'externalUrl' | 'id' | 'message' | 'metadata' | 'metafield' | 'metafields' | 'number' | 'order' | 'privateMetadata' | 'privateMetafield' | 'privateMetafields' | 'status' | 'updatedAt' | 'url' | InvoiceKeySpecifier)[];
export type InvoiceFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	externalUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>,
	metadata?: FieldPolicy<any> | FieldReadFunction<any>,
	metafield?: FieldPolicy<any> | FieldReadFunction<any>,
	metafields?: FieldPolicy<any> | FieldReadFunction<any>,
	number?: FieldPolicy<any> | FieldReadFunction<any>,
	order?: FieldPolicy<any> | FieldReadFunction<any>,
	privateMetadata?: FieldPolicy<any> | FieldReadFunction<any>,
	privateMetafield?: FieldPolicy<any> | FieldReadFunction<any>,
	privateMetafields?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	url?: FieldPolicy<any> | FieldReadFunction<any>
};
export type InvoiceCreateKeySpecifier = ('errors' | 'invoice' | 'invoiceErrors' | InvoiceCreateKeySpecifier)[];
export type InvoiceCreateFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	invoice?: FieldPolicy<any> | FieldReadFunction<any>,
	invoiceErrors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type InvoiceDeleteKeySpecifier = ('errors' | 'invoice' | 'invoiceErrors' | InvoiceDeleteKeySpecifier)[];
export type InvoiceDeleteFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	invoice?: FieldPolicy<any> | FieldReadFunction<any>,
	invoiceErrors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type InvoiceDeletedKeySpecifier = ('invoice' | 'issuedAt' | 'issuingPrincipal' | 'order' | 'recipient' | 'version' | InvoiceDeletedKeySpecifier)[];
export type InvoiceDeletedFieldPolicy = {
	invoice?: FieldPolicy<any> | FieldReadFunction<any>,
	issuedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	issuingPrincipal?: FieldPolicy<any> | FieldReadFunction<any>,
	order?: FieldPolicy<any> | FieldReadFunction<any>,
	recipient?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type InvoiceErrorKeySpecifier = ('code' | 'field' | 'message' | InvoiceErrorKeySpecifier)[];
export type InvoiceErrorFieldPolicy = {
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	field?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>
};
export type InvoiceRequestKeySpecifier = ('errors' | 'invoice' | 'invoiceErrors' | 'order' | InvoiceRequestKeySpecifier)[];
export type InvoiceRequestFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	invoice?: FieldPolicy<any> | FieldReadFunction<any>,
	invoiceErrors?: FieldPolicy<any> | FieldReadFunction<any>,
	order?: FieldPolicy<any> | FieldReadFunction<any>
};
export type InvoiceRequestDeleteKeySpecifier = ('errors' | 'invoice' | 'invoiceErrors' | InvoiceRequestDeleteKeySpecifier)[];
export type InvoiceRequestDeleteFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	invoice?: FieldPolicy<any> | FieldReadFunction<any>,
	invoiceErrors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type InvoiceRequestedKeySpecifier = ('invoice' | 'issuedAt' | 'issuingPrincipal' | 'order' | 'recipient' | 'version' | InvoiceRequestedKeySpecifier)[];
export type InvoiceRequestedFieldPolicy = {
	invoice?: FieldPolicy<any> | FieldReadFunction<any>,
	issuedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	issuingPrincipal?: FieldPolicy<any> | FieldReadFunction<any>,
	order?: FieldPolicy<any> | FieldReadFunction<any>,
	recipient?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type InvoiceSendNotificationKeySpecifier = ('errors' | 'invoice' | 'invoiceErrors' | InvoiceSendNotificationKeySpecifier)[];
export type InvoiceSendNotificationFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	invoice?: FieldPolicy<any> | FieldReadFunction<any>,
	invoiceErrors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type InvoiceSentKeySpecifier = ('invoice' | 'issuedAt' | 'issuingPrincipal' | 'order' | 'recipient' | 'version' | InvoiceSentKeySpecifier)[];
export type InvoiceSentFieldPolicy = {
	invoice?: FieldPolicy<any> | FieldReadFunction<any>,
	issuedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	issuingPrincipal?: FieldPolicy<any> | FieldReadFunction<any>,
	order?: FieldPolicy<any> | FieldReadFunction<any>,
	recipient?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type InvoiceUpdateKeySpecifier = ('errors' | 'invoice' | 'invoiceErrors' | InvoiceUpdateKeySpecifier)[];
export type InvoiceUpdateFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	invoice?: FieldPolicy<any> | FieldReadFunction<any>,
	invoiceErrors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type JobKeySpecifier = ('createdAt' | 'message' | 'status' | 'updatedAt' | JobKeySpecifier)[];
export type JobFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LanguageDisplayKeySpecifier = ('code' | 'language' | LanguageDisplayKeySpecifier)[];
export type LanguageDisplayFieldPolicy = {
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	language?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LimitInfoKeySpecifier = ('allowedUsage' | 'currentUsage' | LimitInfoKeySpecifier)[];
export type LimitInfoFieldPolicy = {
	allowedUsage?: FieldPolicy<any> | FieldReadFunction<any>,
	currentUsage?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LimitsKeySpecifier = ('channels' | 'orders' | 'productVariants' | 'staffUsers' | 'warehouses' | LimitsKeySpecifier)[];
export type LimitsFieldPolicy = {
	channels?: FieldPolicy<any> | FieldReadFunction<any>,
	orders?: FieldPolicy<any> | FieldReadFunction<any>,
	productVariants?: FieldPolicy<any> | FieldReadFunction<any>,
	staffUsers?: FieldPolicy<any> | FieldReadFunction<any>,
	warehouses?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ListStoredPaymentMethodsKeySpecifier = ('channel' | 'issuedAt' | 'issuingPrincipal' | 'recipient' | 'user' | 'version' | ListStoredPaymentMethodsKeySpecifier)[];
export type ListStoredPaymentMethodsFieldPolicy = {
	channel?: FieldPolicy<any> | FieldReadFunction<any>,
	issuedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	issuingPrincipal?: FieldPolicy<any> | FieldReadFunction<any>,
	recipient?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ManifestKeySpecifier = ('about' | 'appUrl' | 'audience' | 'author' | 'brand' | 'configurationUrl' | 'dataPrivacy' | 'dataPrivacyUrl' | 'extensions' | 'homepageUrl' | 'identifier' | 'name' | 'permissions' | 'requiredSaleorVersion' | 'supportUrl' | 'tokenTargetUrl' | 'version' | 'webhooks' | ManifestKeySpecifier)[];
export type ManifestFieldPolicy = {
	about?: FieldPolicy<any> | FieldReadFunction<any>,
	appUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	audience?: FieldPolicy<any> | FieldReadFunction<any>,
	author?: FieldPolicy<any> | FieldReadFunction<any>,
	brand?: FieldPolicy<any> | FieldReadFunction<any>,
	configurationUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	dataPrivacy?: FieldPolicy<any> | FieldReadFunction<any>,
	dataPrivacyUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	extensions?: FieldPolicy<any> | FieldReadFunction<any>,
	homepageUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	identifier?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	permissions?: FieldPolicy<any> | FieldReadFunction<any>,
	requiredSaleorVersion?: FieldPolicy<any> | FieldReadFunction<any>,
	supportUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	tokenTargetUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>,
	webhooks?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MarginKeySpecifier = ('start' | 'stop' | MarginKeySpecifier)[];
export type MarginFieldPolicy = {
	start?: FieldPolicy<any> | FieldReadFunction<any>,
	stop?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MenuKeySpecifier = ('id' | 'items' | 'metadata' | 'metafield' | 'metafields' | 'name' | 'privateMetadata' | 'privateMetafield' | 'privateMetafields' | 'slug' | MenuKeySpecifier)[];
export type MenuFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	metadata?: FieldPolicy<any> | FieldReadFunction<any>,
	metafield?: FieldPolicy<any> | FieldReadFunction<any>,
	metafields?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	privateMetadata?: FieldPolicy<any> | FieldReadFunction<any>,
	privateMetafield?: FieldPolicy<any> | FieldReadFunction<any>,
	privateMetafields?: FieldPolicy<any> | FieldReadFunction<any>,
	slug?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MenuBulkDeleteKeySpecifier = ('count' | 'errors' | 'menuErrors' | MenuBulkDeleteKeySpecifier)[];
export type MenuBulkDeleteFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	menuErrors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MenuCountableConnectionKeySpecifier = ('edges' | 'pageInfo' | 'totalCount' | MenuCountableConnectionKeySpecifier)[];
export type MenuCountableConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MenuCountableEdgeKeySpecifier = ('cursor' | 'node' | MenuCountableEdgeKeySpecifier)[];
export type MenuCountableEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MenuCreateKeySpecifier = ('errors' | 'menu' | 'menuErrors' | MenuCreateKeySpecifier)[];
export type MenuCreateFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	menu?: FieldPolicy<any> | FieldReadFunction<any>,
	menuErrors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MenuCreatedKeySpecifier = ('issuedAt' | 'issuingPrincipal' | 'menu' | 'recipient' | 'version' | MenuCreatedKeySpecifier)[];
export type MenuCreatedFieldPolicy = {
	issuedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	issuingPrincipal?: FieldPolicy<any> | FieldReadFunction<any>,
	menu?: FieldPolicy<any> | FieldReadFunction<any>,
	recipient?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MenuDeleteKeySpecifier = ('errors' | 'menu' | 'menuErrors' | MenuDeleteKeySpecifier)[];
export type MenuDeleteFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	menu?: FieldPolicy<any> | FieldReadFunction<any>,
	menuErrors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MenuDeletedKeySpecifier = ('issuedAt' | 'issuingPrincipal' | 'menu' | 'recipient' | 'version' | MenuDeletedKeySpecifier)[];
export type MenuDeletedFieldPolicy = {
	issuedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	issuingPrincipal?: FieldPolicy<any> | FieldReadFunction<any>,
	menu?: FieldPolicy<any> | FieldReadFunction<any>,
	recipient?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MenuErrorKeySpecifier = ('code' | 'field' | 'message' | MenuErrorKeySpecifier)[];
export type MenuErrorFieldPolicy = {
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	field?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MenuItemKeySpecifier = ('category' | 'children' | 'collection' | 'id' | 'level' | 'menu' | 'metadata' | 'metafield' | 'metafields' | 'name' | 'page' | 'parent' | 'privateMetadata' | 'privateMetafield' | 'privateMetafields' | 'translation' | 'url' | MenuItemKeySpecifier)[];
export type MenuItemFieldPolicy = {
	category?: FieldPolicy<any> | FieldReadFunction<any>,
	children?: FieldPolicy<any> | FieldReadFunction<any>,
	collection?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	level?: FieldPolicy<any> | FieldReadFunction<any>,
	menu?: FieldPolicy<any> | FieldReadFunction<any>,
	metadata?: FieldPolicy<any> | FieldReadFunction<any>,
	metafield?: FieldPolicy<any> | FieldReadFunction<any>,
	metafields?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	page?: FieldPolicy<any> | FieldReadFunction<any>,
	parent?: FieldPolicy<any> | FieldReadFunction<any>,
	privateMetadata?: FieldPolicy<any> | FieldReadFunction<any>,
	privateMetafield?: FieldPolicy<any> | FieldReadFunction<any>,
	privateMetafields?: FieldPolicy<any> | FieldReadFunction<any>,
	translation?: FieldPolicy<any> | FieldReadFunction<any>,
	url?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MenuItemBulkDeleteKeySpecifier = ('count' | 'errors' | 'menuErrors' | MenuItemBulkDeleteKeySpecifier)[];
export type MenuItemBulkDeleteFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	menuErrors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MenuItemCountableConnectionKeySpecifier = ('edges' | 'pageInfo' | 'totalCount' | MenuItemCountableConnectionKeySpecifier)[];
export type MenuItemCountableConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MenuItemCountableEdgeKeySpecifier = ('cursor' | 'node' | MenuItemCountableEdgeKeySpecifier)[];
export type MenuItemCountableEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MenuItemCreateKeySpecifier = ('errors' | 'menuErrors' | 'menuItem' | MenuItemCreateKeySpecifier)[];
export type MenuItemCreateFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	menuErrors?: FieldPolicy<any> | FieldReadFunction<any>,
	menuItem?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MenuItemCreatedKeySpecifier = ('issuedAt' | 'issuingPrincipal' | 'menuItem' | 'recipient' | 'version' | MenuItemCreatedKeySpecifier)[];
export type MenuItemCreatedFieldPolicy = {
	issuedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	issuingPrincipal?: FieldPolicy<any> | FieldReadFunction<any>,
	menuItem?: FieldPolicy<any> | FieldReadFunction<any>,
	recipient?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MenuItemDeleteKeySpecifier = ('errors' | 'menuErrors' | 'menuItem' | MenuItemDeleteKeySpecifier)[];
export type MenuItemDeleteFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	menuErrors?: FieldPolicy<any> | FieldReadFunction<any>,
	menuItem?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MenuItemDeletedKeySpecifier = ('issuedAt' | 'issuingPrincipal' | 'menuItem' | 'recipient' | 'version' | MenuItemDeletedKeySpecifier)[];
export type MenuItemDeletedFieldPolicy = {
	issuedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	issuingPrincipal?: FieldPolicy<any> | FieldReadFunction<any>,
	menuItem?: FieldPolicy<any> | FieldReadFunction<any>,
	recipient?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MenuItemMoveKeySpecifier = ('errors' | 'menu' | 'menuErrors' | MenuItemMoveKeySpecifier)[];
export type MenuItemMoveFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	menu?: FieldPolicy<any> | FieldReadFunction<any>,
	menuErrors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MenuItemTranslatableContentKeySpecifier = ('id' | 'menuItem' | 'menuItemId' | 'name' | 'translation' | MenuItemTranslatableContentKeySpecifier)[];
export type MenuItemTranslatableContentFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	menuItem?: FieldPolicy<any> | FieldReadFunction<any>,
	menuItemId?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	translation?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MenuItemTranslateKeySpecifier = ('errors' | 'menuItem' | 'translationErrors' | MenuItemTranslateKeySpecifier)[];
export type MenuItemTranslateFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	menuItem?: FieldPolicy<any> | FieldReadFunction<any>,
	translationErrors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MenuItemTranslationKeySpecifier = ('id' | 'language' | 'name' | 'translatableContent' | MenuItemTranslationKeySpecifier)[];
export type MenuItemTranslationFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	language?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	translatableContent?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MenuItemUpdateKeySpecifier = ('errors' | 'menuErrors' | 'menuItem' | MenuItemUpdateKeySpecifier)[];
export type MenuItemUpdateFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	menuErrors?: FieldPolicy<any> | FieldReadFunction<any>,
	menuItem?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MenuItemUpdatedKeySpecifier = ('issuedAt' | 'issuingPrincipal' | 'menuItem' | 'recipient' | 'version' | MenuItemUpdatedKeySpecifier)[];
export type MenuItemUpdatedFieldPolicy = {
	issuedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	issuingPrincipal?: FieldPolicy<any> | FieldReadFunction<any>,
	menuItem?: FieldPolicy<any> | FieldReadFunction<any>,
	recipient?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MenuUpdateKeySpecifier = ('errors' | 'menu' | 'menuErrors' | MenuUpdateKeySpecifier)[];
export type MenuUpdateFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	menu?: FieldPolicy<any> | FieldReadFunction<any>,
	menuErrors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MenuUpdatedKeySpecifier = ('issuedAt' | 'issuingPrincipal' | 'menu' | 'recipient' | 'version' | MenuUpdatedKeySpecifier)[];
export type MenuUpdatedFieldPolicy = {
	issuedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	issuingPrincipal?: FieldPolicy<any> | FieldReadFunction<any>,
	menu?: FieldPolicy<any> | FieldReadFunction<any>,
	recipient?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MetadataErrorKeySpecifier = ('code' | 'field' | 'message' | MetadataErrorKeySpecifier)[];
export type MetadataErrorFieldPolicy = {
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	field?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MetadataItemKeySpecifier = ('key' | 'value' | MetadataItemKeySpecifier)[];
export type MetadataItemFieldPolicy = {
	key?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MoneyKeySpecifier = ('amount' | 'currency' | 'fractionDigits' | 'fractionalAmount' | MoneyKeySpecifier)[];
export type MoneyFieldPolicy = {
	amount?: FieldPolicy<any> | FieldReadFunction<any>,
	currency?: FieldPolicy<any> | FieldReadFunction<any>,
	fractionDigits?: FieldPolicy<any> | FieldReadFunction<any>,
	fractionalAmount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MoneyRangeKeySpecifier = ('start' | 'stop' | MoneyRangeKeySpecifier)[];
export type MoneyRangeFieldPolicy = {
	start?: FieldPolicy<any> | FieldReadFunction<any>,
	stop?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MutationKeySpecifier = ('accountAddressCreate' | 'accountAddressDelete' | 'accountAddressUpdate' | 'accountDelete' | 'accountRegister' | 'accountRequestDeletion' | 'accountSetDefaultAddress' | 'accountUpdate' | 'addressCreate' | 'addressDelete' | 'addressSetDefault' | 'addressUpdate' | 'appActivate' | 'appCreate' | 'appDeactivate' | 'appDelete' | 'appDeleteFailedInstallation' | 'appFetchManifest' | 'appInstall' | 'appProblemCreate' | 'appProblemDismiss' | 'appReenableSyncWebhooks' | 'appRetryInstall' | 'appTokenCreate' | 'appTokenDelete' | 'appTokenVerify' | 'appUpdate' | 'assignNavigation' | 'assignWarehouseShippingZone' | 'attributeBulkCreate' | 'attributeBulkDelete' | 'attributeBulkTranslate' | 'attributeBulkUpdate' | 'attributeCreate' | 'attributeDelete' | 'attributeReorderValues' | 'attributeTranslate' | 'attributeUpdate' | 'attributeValueBulkDelete' | 'attributeValueBulkTranslate' | 'attributeValueCreate' | 'attributeValueDelete' | 'attributeValueTranslate' | 'attributeValueUpdate' | 'categoryBulkDelete' | 'categoryCreate' | 'categoryDelete' | 'categoryTranslate' | 'categoryUpdate' | 'channelActivate' | 'channelCreate' | 'channelDeactivate' | 'channelDelete' | 'channelReorderWarehouses' | 'channelUpdate' | 'checkoutAddPromoCode' | 'checkoutBillingAddressUpdate' | 'checkoutComplete' | 'checkoutCreate' | 'checkoutCreateFromOrder' | 'checkoutCustomerAttach' | 'checkoutCustomerDetach' | 'checkoutCustomerNoteUpdate' | 'checkoutDeliveryMethodUpdate' | 'checkoutEmailUpdate' | 'checkoutLanguageCodeUpdate' | 'checkoutLineDelete' | 'checkoutLinesAdd' | 'checkoutLinesDelete' | 'checkoutLinesUpdate' | 'checkoutPaymentCreate' | 'checkoutRemovePromoCode' | 'checkoutShippingAddressUpdate' | 'checkoutShippingMethodUpdate' | 'collectionAddProducts' | 'collectionBulkDelete' | 'collectionChannelListingUpdate' | 'collectionCreate' | 'collectionDelete' | 'collectionRemoveProducts' | 'collectionReorderProducts' | 'collectionTranslate' | 'collectionUpdate' | 'confirmAccount' | 'confirmEmailChange' | 'createWarehouse' | 'customerBulkDelete' | 'customerBulkUpdate' | 'customerCreate' | 'customerDelete' | 'customerUpdate' | 'deleteMetadata' | 'deletePrivateMetadata' | 'deleteWarehouse' | 'digitalContentCreate' | 'digitalContentDelete' | 'digitalContentUpdate' | 'digitalContentUrlCreate' | 'draftOrderBulkDelete' | 'draftOrderComplete' | 'draftOrderCreate' | 'draftOrderDelete' | 'draftOrderLinesBulkDelete' | 'draftOrderUpdate' | 'eventDeliveryRetry' | 'exportGiftCards' | 'exportProducts' | 'exportVoucherCodes' | 'externalAuthenticationUrl' | 'externalLogout' | 'externalNotificationTrigger' | 'externalObtainAccessTokens' | 'externalRefresh' | 'externalVerify' | 'fileUpload' | 'giftCardActivate' | 'giftCardAddNote' | 'giftCardBulkActivate' | 'giftCardBulkCreate' | 'giftCardBulkDeactivate' | 'giftCardBulkDelete' | 'giftCardCreate' | 'giftCardDeactivate' | 'giftCardDelete' | 'giftCardResend' | 'giftCardSettingsUpdate' | 'giftCardUpdate' | 'invoiceCreate' | 'invoiceDelete' | 'invoiceRequest' | 'invoiceRequestDelete' | 'invoiceSendNotification' | 'invoiceUpdate' | 'menuBulkDelete' | 'menuCreate' | 'menuDelete' | 'menuItemBulkDelete' | 'menuItemCreate' | 'menuItemDelete' | 'menuItemMove' | 'menuItemTranslate' | 'menuItemUpdate' | 'menuUpdate' | 'orderAddNote' | 'orderBulkCancel' | 'orderBulkCreate' | 'orderCancel' | 'orderCapture' | 'orderConfirm' | 'orderCreateFromCheckout' | 'orderDiscountAdd' | 'orderDiscountDelete' | 'orderDiscountUpdate' | 'orderFulfill' | 'orderFulfillmentApprove' | 'orderFulfillmentCancel' | 'orderFulfillmentRefundProducts' | 'orderFulfillmentReturnProducts' | 'orderFulfillmentUpdateTracking' | 'orderGrantRefundCreate' | 'orderGrantRefundUpdate' | 'orderLineDelete' | 'orderLineDiscountRemove' | 'orderLineDiscountUpdate' | 'orderLineUpdate' | 'orderLinesCreate' | 'orderMarkAsPaid' | 'orderNoteAdd' | 'orderNoteUpdate' | 'orderRefund' | 'orderSettingsUpdate' | 'orderUpdate' | 'orderUpdateShipping' | 'orderVoid' | 'pageAttributeAssign' | 'pageAttributeUnassign' | 'pageBulkDelete' | 'pageBulkPublish' | 'pageCreate' | 'pageDelete' | 'pageReorderAttributeValues' | 'pageTranslate' | 'pageTypeBulkDelete' | 'pageTypeCreate' | 'pageTypeDelete' | 'pageTypeReorderAttributes' | 'pageTypeUpdate' | 'pageUpdate' | 'passwordChange' | 'paymentCapture' | 'paymentCheckBalance' | 'paymentGatewayInitialize' | 'paymentGatewayInitializeTokenization' | 'paymentInitialize' | 'paymentMethodInitializeTokenization' | 'paymentMethodProcessTokenization' | 'paymentRefund' | 'paymentVoid' | 'permissionGroupCreate' | 'permissionGroupDelete' | 'permissionGroupUpdate' | 'pluginUpdate' | 'productAttributeAssign' | 'productAttributeAssignmentUpdate' | 'productAttributeUnassign' | 'productBulkCreate' | 'productBulkDelete' | 'productBulkTranslate' | 'productChannelListingUpdate' | 'productCreate' | 'productDelete' | 'productMediaBulkDelete' | 'productMediaCreate' | 'productMediaDelete' | 'productMediaReorder' | 'productMediaUpdate' | 'productReorderAttributeValues' | 'productTranslate' | 'productTypeBulkDelete' | 'productTypeCreate' | 'productTypeDelete' | 'productTypeReorderAttributes' | 'productTypeUpdate' | 'productUpdate' | 'productVariantBulkCreate' | 'productVariantBulkDelete' | 'productVariantBulkTranslate' | 'productVariantBulkUpdate' | 'productVariantChannelListingUpdate' | 'productVariantCreate' | 'productVariantDelete' | 'productVariantPreorderDeactivate' | 'productVariantReorder' | 'productVariantReorderAttributeValues' | 'productVariantSetDefault' | 'productVariantStocksCreate' | 'productVariantStocksDelete' | 'productVariantStocksUpdate' | 'productVariantTranslate' | 'productVariantUpdate' | 'promotionBulkDelete' | 'promotionCreate' | 'promotionDelete' | 'promotionRuleCreate' | 'promotionRuleDelete' | 'promotionRuleTranslate' | 'promotionRuleUpdate' | 'promotionTranslate' | 'promotionUpdate' | 'refundReasonReferenceClear' | 'refundSettingsUpdate' | 'requestEmailChange' | 'requestPasswordReset' | 'saleBulkDelete' | 'saleCataloguesAdd' | 'saleCataloguesRemove' | 'saleChannelListingUpdate' | 'saleCreate' | 'saleDelete' | 'saleTranslate' | 'saleUpdate' | 'sendConfirmationEmail' | 'setPassword' | 'shippingMethodChannelListingUpdate' | 'shippingPriceBulkDelete' | 'shippingPriceCreate' | 'shippingPriceDelete' | 'shippingPriceExcludeProducts' | 'shippingPriceRemoveProductFromExclude' | 'shippingPriceTranslate' | 'shippingPriceUpdate' | 'shippingZoneBulkDelete' | 'shippingZoneCreate' | 'shippingZoneDelete' | 'shippingZoneUpdate' | 'shopAddressUpdate' | 'shopDomainUpdate' | 'shopFetchTaxRates' | 'shopSettingsTranslate' | 'shopSettingsUpdate' | 'staffBulkDelete' | 'staffCreate' | 'staffDelete' | 'staffNotificationRecipientCreate' | 'staffNotificationRecipientDelete' | 'staffNotificationRecipientUpdate' | 'staffUpdate' | 'stockBulkUpdate' | 'storedPaymentMethodRequestDelete' | 'taxClassCreate' | 'taxClassDelete' | 'taxClassUpdate' | 'taxConfigurationUpdate' | 'taxCountryConfigurationDelete' | 'taxCountryConfigurationUpdate' | 'taxExemptionManage' | 'tokenCreate' | 'tokenRefresh' | 'tokenVerify' | 'tokensDeactivateAll' | 'transactionCreate' | 'transactionEventReport' | 'transactionInitialize' | 'transactionProcess' | 'transactionRequestAction' | 'transactionRequestRefundForGrantedRefund' | 'transactionUpdate' | 'unassignWarehouseShippingZone' | 'updateMetadata' | 'updatePrivateMetadata' | 'updateWarehouse' | 'userAvatarDelete' | 'userAvatarUpdate' | 'userBulkSetActive' | 'variantMediaAssign' | 'variantMediaUnassign' | 'voucherBulkDelete' | 'voucherCataloguesAdd' | 'voucherCataloguesRemove' | 'voucherChannelListingUpdate' | 'voucherCodeBulkDelete' | 'voucherCreate' | 'voucherDelete' | 'voucherTranslate' | 'voucherUpdate' | 'webhookCreate' | 'webhookDelete' | 'webhookDryRun' | 'webhookTrigger' | 'webhookUpdate' | MutationKeySpecifier)[];
export type MutationFieldPolicy = {
	accountAddressCreate?: FieldPolicy<any> | FieldReadFunction<any>,
	accountAddressDelete?: FieldPolicy<any> | FieldReadFunction<any>,
	accountAddressUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	accountDelete?: FieldPolicy<any> | FieldReadFunction<any>,
	accountRegister?: FieldPolicy<any> | FieldReadFunction<any>,
	accountRequestDeletion?: FieldPolicy<any> | FieldReadFunction<any>,
	accountSetDefaultAddress?: FieldPolicy<any> | FieldReadFunction<any>,
	accountUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	addressCreate?: FieldPolicy<any> | FieldReadFunction<any>,
	addressDelete?: FieldPolicy<any> | FieldReadFunction<any>,
	addressSetDefault?: FieldPolicy<any> | FieldReadFunction<any>,
	addressUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	appActivate?: FieldPolicy<any> | FieldReadFunction<any>,
	appCreate?: FieldPolicy<any> | FieldReadFunction<any>,
	appDeactivate?: FieldPolicy<any> | FieldReadFunction<any>,
	appDelete?: FieldPolicy<any> | FieldReadFunction<any>,
	appDeleteFailedInstallation?: FieldPolicy<any> | FieldReadFunction<any>,
	appFetchManifest?: FieldPolicy<any> | FieldReadFunction<any>,
	appInstall?: FieldPolicy<any> | FieldReadFunction<any>,
	appProblemCreate?: FieldPolicy<any> | FieldReadFunction<any>,
	appProblemDismiss?: FieldPolicy<any> | FieldReadFunction<any>,
	appReenableSyncWebhooks?: FieldPolicy<any> | FieldReadFunction<any>,
	appRetryInstall?: FieldPolicy<any> | FieldReadFunction<any>,
	appTokenCreate?: FieldPolicy<any> | FieldReadFunction<any>,
	appTokenDelete?: FieldPolicy<any> | FieldReadFunction<any>,
	appTokenVerify?: FieldPolicy<any> | FieldReadFunction<any>,
	appUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	assignNavigation?: FieldPolicy<any> | FieldReadFunction<any>,
	assignWarehouseShippingZone?: FieldPolicy<any> | FieldReadFunction<any>,
	attributeBulkCreate?: FieldPolicy<any> | FieldReadFunction<any>,
	attributeBulkDelete?: FieldPolicy<any> | FieldReadFunction<any>,
	attributeBulkTranslate?: FieldPolicy<any> | FieldReadFunction<any>,
	attributeBulkUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	attributeCreate?: FieldPolicy<any> | FieldReadFunction<any>,
	attributeDelete?: FieldPolicy<any> | FieldReadFunction<any>,
	attributeReorderValues?: FieldPolicy<any> | FieldReadFunction<any>,
	attributeTranslate?: FieldPolicy<any> | FieldReadFunction<any>,
	attributeUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	attributeValueBulkDelete?: FieldPolicy<any> | FieldReadFunction<any>,
	attributeValueBulkTranslate?: FieldPolicy<any> | FieldReadFunction<any>,
	attributeValueCreate?: FieldPolicy<any> | FieldReadFunction<any>,
	attributeValueDelete?: FieldPolicy<any> | FieldReadFunction<any>,
	attributeValueTranslate?: FieldPolicy<any> | FieldReadFunction<any>,
	attributeValueUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	categoryBulkDelete?: FieldPolicy<any> | FieldReadFunction<any>,
	categoryCreate?: FieldPolicy<any> | FieldReadFunction<any>,
	categoryDelete?: FieldPolicy<any> | FieldReadFunction<any>,
	categoryTranslate?: FieldPolicy<any> | FieldReadFunction<any>,
	categoryUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	channelActivate?: FieldPolicy<any> | FieldReadFunction<any>,
	channelCreate?: FieldPolicy<any> | FieldReadFunction<any>,
	channelDeactivate?: FieldPolicy<any> | FieldReadFunction<any>,
	channelDelete?: FieldPolicy<any> | FieldReadFunction<any>,
	channelReorderWarehouses?: FieldPolicy<any> | FieldReadFunction<any>,
	channelUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	checkoutAddPromoCode?: FieldPolicy<any> | FieldReadFunction<any>,
	checkoutBillingAddressUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	checkoutComplete?: FieldPolicy<any> | FieldReadFunction<any>,
	checkoutCreate?: FieldPolicy<any> | FieldReadFunction<any>,
	checkoutCreateFromOrder?: FieldPolicy<any> | FieldReadFunction<any>,
	checkoutCustomerAttach?: FieldPolicy<any> | FieldReadFunction<any>,
	checkoutCustomerDetach?: FieldPolicy<any> | FieldReadFunction<any>,
	checkoutCustomerNoteUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	checkoutDeliveryMethodUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	checkoutEmailUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	checkoutLanguageCodeUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	checkoutLineDelete?: FieldPolicy<any> | FieldReadFunction<any>,
	checkoutLinesAdd?: FieldPolicy<any> | FieldReadFunction<any>,
	checkoutLinesDelete?: FieldPolicy<any> | FieldReadFunction<any>,
	checkoutLinesUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	checkoutPaymentCreate?: FieldPolicy<any> | FieldReadFunction<any>,
	checkoutRemovePromoCode?: FieldPolicy<any> | FieldReadFunction<any>,
	checkoutShippingAddressUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	checkoutShippingMethodUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	collectionAddProducts?: FieldPolicy<any> | FieldReadFunction<any>,
	collectionBulkDelete?: FieldPolicy<any> | FieldReadFunction<any>,
	collectionChannelListingUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	collectionCreate?: FieldPolicy<any> | FieldReadFunction<any>,
	collectionDelete?: FieldPolicy<any> | FieldReadFunction<any>,
	collectionRemoveProducts?: FieldPolicy<any> | FieldReadFunction<any>,
	collectionReorderProducts?: FieldPolicy<any> | FieldReadFunction<any>,
	collectionTranslate?: FieldPolicy<any> | FieldReadFunction<any>,
	collectionUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	confirmAccount?: FieldPolicy<any> | FieldReadFunction<any>,
	confirmEmailChange?: FieldPolicy<any> | FieldReadFunction<any>,
	createWarehouse?: FieldPolicy<any> | FieldReadFunction<any>,
	customerBulkDelete?: FieldPolicy<any> | FieldReadFunction<any>,
	customerBulkUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	customerCreate?: FieldPolicy<any> | FieldReadFunction<any>,
	customerDelete?: FieldPolicy<any> | FieldReadFunction<any>,
	customerUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteMetadata?: FieldPolicy<any> | FieldReadFunction<any>,
	deletePrivateMetadata?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteWarehouse?: FieldPolicy<any> | FieldReadFunction<any>,
	digitalContentCreate?: FieldPolicy<any> | FieldReadFunction<any>,
	digitalContentDelete?: FieldPolicy<any> | FieldReadFunction<any>,
	digitalContentUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	digitalContentUrlCreate?: FieldPolicy<any> | FieldReadFunction<any>,
	draftOrderBulkDelete?: FieldPolicy<any> | FieldReadFunction<any>,
	draftOrderComplete?: FieldPolicy<any> | FieldReadFunction<any>,
	draftOrderCreate?: FieldPolicy<any> | FieldReadFunction<any>,
	draftOrderDelete?: FieldPolicy<any> | FieldReadFunction<any>,
	draftOrderLinesBulkDelete?: FieldPolicy<any> | FieldReadFunction<any>,
	draftOrderUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	eventDeliveryRetry?: FieldPolicy<any> | FieldReadFunction<any>,
	exportGiftCards?: FieldPolicy<any> | FieldReadFunction<any>,
	exportProducts?: FieldPolicy<any> | FieldReadFunction<any>,
	exportVoucherCodes?: FieldPolicy<any> | FieldReadFunction<any>,
	externalAuthenticationUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	externalLogout?: FieldPolicy<any> | FieldReadFunction<any>,
	externalNotificationTrigger?: FieldPolicy<any> | FieldReadFunction<any>,
	externalObtainAccessTokens?: FieldPolicy<any> | FieldReadFunction<any>,
	externalRefresh?: FieldPolicy<any> | FieldReadFunction<any>,
	externalVerify?: FieldPolicy<any> | FieldReadFunction<any>,
	fileUpload?: FieldPolicy<any> | FieldReadFunction<any>,
	giftCardActivate?: FieldPolicy<any> | FieldReadFunction<any>,
	giftCardAddNote?: FieldPolicy<any> | FieldReadFunction<any>,
	giftCardBulkActivate?: FieldPolicy<any> | FieldReadFunction<any>,
	giftCardBulkCreate?: FieldPolicy<any> | FieldReadFunction<any>,
	giftCardBulkDeactivate?: FieldPolicy<any> | FieldReadFunction<any>,
	giftCardBulkDelete?: FieldPolicy<any> | FieldReadFunction<any>,
	giftCardCreate?: FieldPolicy<any> | FieldReadFunction<any>,
	giftCardDeactivate?: FieldPolicy<any> | FieldReadFunction<any>,
	giftCardDelete?: FieldPolicy<any> | FieldReadFunction<any>,
	giftCardResend?: FieldPolicy<any> | FieldReadFunction<any>,
	giftCardSettingsUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	giftCardUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	invoiceCreate?: FieldPolicy<any> | FieldReadFunction<any>,
	invoiceDelete?: FieldPolicy<any> | FieldReadFunction<any>,
	invoiceRequest?: FieldPolicy<any> | FieldReadFunction<any>,
	invoiceRequestDelete?: FieldPolicy<any> | FieldReadFunction<any>,
	invoiceSendNotification?: FieldPolicy<any> | FieldReadFunction<any>,
	invoiceUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	menuBulkDelete?: FieldPolicy<any> | FieldReadFunction<any>,
	menuCreate?: FieldPolicy<any> | FieldReadFunction<any>,
	menuDelete?: FieldPolicy<any> | FieldReadFunction<any>,
	menuItemBulkDelete?: FieldPolicy<any> | FieldReadFunction<any>,
	menuItemCreate?: FieldPolicy<any> | FieldReadFunction<any>,
	menuItemDelete?: FieldPolicy<any> | FieldReadFunction<any>,
	menuItemMove?: FieldPolicy<any> | FieldReadFunction<any>,
	menuItemTranslate?: FieldPolicy<any> | FieldReadFunction<any>,
	menuItemUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	menuUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	orderAddNote?: FieldPolicy<any> | FieldReadFunction<any>,
	orderBulkCancel?: FieldPolicy<any> | FieldReadFunction<any>,
	orderBulkCreate?: FieldPolicy<any> | FieldReadFunction<any>,
	orderCancel?: FieldPolicy<any> | FieldReadFunction<any>,
	orderCapture?: FieldPolicy<any> | FieldReadFunction<any>,
	orderConfirm?: FieldPolicy<any> | FieldReadFunction<any>,
	orderCreateFromCheckout?: FieldPolicy<any> | FieldReadFunction<any>,
	orderDiscountAdd?: FieldPolicy<any> | FieldReadFunction<any>,
	orderDiscountDelete?: FieldPolicy<any> | FieldReadFunction<any>,
	orderDiscountUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	orderFulfill?: FieldPolicy<any> | FieldReadFunction<any>,
	orderFulfillmentApprove?: FieldPolicy<any> | FieldReadFunction<any>,
	orderFulfillmentCancel?: FieldPolicy<any> | FieldReadFunction<any>,
	orderFulfillmentRefundProducts?: FieldPolicy<any> | FieldReadFunction<any>,
	orderFulfillmentReturnProducts?: FieldPolicy<any> | FieldReadFunction<any>,
	orderFulfillmentUpdateTracking?: FieldPolicy<any> | FieldReadFunction<any>,
	orderGrantRefundCreate?: FieldPolicy<any> | FieldReadFunction<any>,
	orderGrantRefundUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	orderLineDelete?: FieldPolicy<any> | FieldReadFunction<any>,
	orderLineDiscountRemove?: FieldPolicy<any> | FieldReadFunction<any>,
	orderLineDiscountUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	orderLineUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	orderLinesCreate?: FieldPolicy<any> | FieldReadFunction<any>,
	orderMarkAsPaid?: FieldPolicy<any> | FieldReadFunction<any>,
	orderNoteAdd?: FieldPolicy<any> | FieldReadFunction<any>,
	orderNoteUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	orderRefund?: FieldPolicy<any> | FieldReadFunction<any>,
	orderSettingsUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	orderUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	orderUpdateShipping?: FieldPolicy<any> | FieldReadFunction<any>,
	orderVoid?: FieldPolicy<any> | FieldReadFunction<any>,
	pageAttributeAssign?: FieldPolicy<any> | FieldReadFunction<any>,
	pageAttributeUnassign?: FieldPolicy<any> | FieldReadFunction<any>,
	pageBulkDelete?: FieldPolicy<any> | FieldReadFunction<any>,
	pageBulkPublish?: FieldPolicy<any> | FieldReadFunction<any>,
	pageCreate?: FieldPolicy<any> | FieldReadFunction<any>,
	pageDelete?: FieldPolicy<any> | FieldReadFunction<any>,
	pageReorderAttributeValues?: FieldPolicy<any> | FieldReadFunction<any>,
	pageTranslate?: FieldPolicy<any> | FieldReadFunction<any>,
	pageTypeBulkDelete?: FieldPolicy<any> | FieldReadFunction<any>,
	pageTypeCreate?: FieldPolicy<any> | FieldReadFunction<any>,
	pageTypeDelete?: FieldPolicy<any> | FieldReadFunction<any>,
	pageTypeReorderAttributes?: FieldPolicy<any> | FieldReadFunction<any>,
	pageTypeUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	pageUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	passwordChange?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentCapture?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentCheckBalance?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentGatewayInitialize?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentGatewayInitializeTokenization?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentInitialize?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentMethodInitializeTokenization?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentMethodProcessTokenization?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentRefund?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentVoid?: FieldPolicy<any> | FieldReadFunction<any>,
	permissionGroupCreate?: FieldPolicy<any> | FieldReadFunction<any>,
	permissionGroupDelete?: FieldPolicy<any> | FieldReadFunction<any>,
	permissionGroupUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	pluginUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	productAttributeAssign?: FieldPolicy<any> | FieldReadFunction<any>,
	productAttributeAssignmentUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	productAttributeUnassign?: FieldPolicy<any> | FieldReadFunction<any>,
	productBulkCreate?: FieldPolicy<any> | FieldReadFunction<any>,
	productBulkDelete?: FieldPolicy<any> | FieldReadFunction<any>,
	productBulkTranslate?: FieldPolicy<any> | FieldReadFunction<any>,
	productChannelListingUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	productCreate?: FieldPolicy<any> | FieldReadFunction<any>,
	productDelete?: FieldPolicy<any> | FieldReadFunction<any>,
	productMediaBulkDelete?: FieldPolicy<any> | FieldReadFunction<any>,
	productMediaCreate?: FieldPolicy<any> | FieldReadFunction<any>,
	productMediaDelete?: FieldPolicy<any> | FieldReadFunction<any>,
	productMediaReorder?: FieldPolicy<any> | FieldReadFunction<any>,
	productMediaUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	productReorderAttributeValues?: FieldPolicy<any> | FieldReadFunction<any>,
	productTranslate?: FieldPolicy<any> | FieldReadFunction<any>,
	productTypeBulkDelete?: FieldPolicy<any> | FieldReadFunction<any>,
	productTypeCreate?: FieldPolicy<any> | FieldReadFunction<any>,
	productTypeDelete?: FieldPolicy<any> | FieldReadFunction<any>,
	productTypeReorderAttributes?: FieldPolicy<any> | FieldReadFunction<any>,
	productTypeUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	productUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	productVariantBulkCreate?: FieldPolicy<any> | FieldReadFunction<any>,
	productVariantBulkDelete?: FieldPolicy<any> | FieldReadFunction<any>,
	productVariantBulkTranslate?: FieldPolicy<any> | FieldReadFunction<any>,
	productVariantBulkUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	productVariantChannelListingUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	productVariantCreate?: FieldPolicy<any> | FieldReadFunction<any>,
	productVariantDelete?: FieldPolicy<any> | FieldReadFunction<any>,
	productVariantPreorderDeactivate?: FieldPolicy<any> | FieldReadFunction<any>,
	productVariantReorder?: FieldPolicy<any> | FieldReadFunction<any>,
	productVariantReorderAttributeValues?: FieldPolicy<any> | FieldReadFunction<any>,
	productVariantSetDefault?: FieldPolicy<any> | FieldReadFunction<any>,
	productVariantStocksCreate?: FieldPolicy<any> | FieldReadFunction<any>,
	productVariantStocksDelete?: FieldPolicy<any> | FieldReadFunction<any>,
	productVariantStocksUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	productVariantTranslate?: FieldPolicy<any> | FieldReadFunction<any>,
	productVariantUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	promotionBulkDelete?: FieldPolicy<any> | FieldReadFunction<any>,
	promotionCreate?: FieldPolicy<any> | FieldReadFunction<any>,
	promotionDelete?: FieldPolicy<any> | FieldReadFunction<any>,
	promotionRuleCreate?: FieldPolicy<any> | FieldReadFunction<any>,
	promotionRuleDelete?: FieldPolicy<any> | FieldReadFunction<any>,
	promotionRuleTranslate?: FieldPolicy<any> | FieldReadFunction<any>,
	promotionRuleUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	promotionTranslate?: FieldPolicy<any> | FieldReadFunction<any>,
	promotionUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	refundReasonReferenceClear?: FieldPolicy<any> | FieldReadFunction<any>,
	refundSettingsUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	requestEmailChange?: FieldPolicy<any> | FieldReadFunction<any>,
	requestPasswordReset?: FieldPolicy<any> | FieldReadFunction<any>,
	saleBulkDelete?: FieldPolicy<any> | FieldReadFunction<any>,
	saleCataloguesAdd?: FieldPolicy<any> | FieldReadFunction<any>,
	saleCataloguesRemove?: FieldPolicy<any> | FieldReadFunction<any>,
	saleChannelListingUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	saleCreate?: FieldPolicy<any> | FieldReadFunction<any>,
	saleDelete?: FieldPolicy<any> | FieldReadFunction<any>,
	saleTranslate?: FieldPolicy<any> | FieldReadFunction<any>,
	saleUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	sendConfirmationEmail?: FieldPolicy<any> | FieldReadFunction<any>,
	setPassword?: FieldPolicy<any> | FieldReadFunction<any>,
	shippingMethodChannelListingUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	shippingPriceBulkDelete?: FieldPolicy<any> | FieldReadFunction<any>,
	shippingPriceCreate?: FieldPolicy<any> | FieldReadFunction<any>,
	shippingPriceDelete?: FieldPolicy<any> | FieldReadFunction<any>,
	shippingPriceExcludeProducts?: FieldPolicy<any> | FieldReadFunction<any>,
	shippingPriceRemoveProductFromExclude?: FieldPolicy<any> | FieldReadFunction<any>,
	shippingPriceTranslate?: FieldPolicy<any> | FieldReadFunction<any>,
	shippingPriceUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	shippingZoneBulkDelete?: FieldPolicy<any> | FieldReadFunction<any>,
	shippingZoneCreate?: FieldPolicy<any> | FieldReadFunction<any>,
	shippingZoneDelete?: FieldPolicy<any> | FieldReadFunction<any>,
	shippingZoneUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	shopAddressUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	shopDomainUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	shopFetchTaxRates?: FieldPolicy<any> | FieldReadFunction<any>,
	shopSettingsTranslate?: FieldPolicy<any> | FieldReadFunction<any>,
	shopSettingsUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	staffBulkDelete?: FieldPolicy<any> | FieldReadFunction<any>,
	staffCreate?: FieldPolicy<any> | FieldReadFunction<any>,
	staffDelete?: FieldPolicy<any> | FieldReadFunction<any>,
	staffNotificationRecipientCreate?: FieldPolicy<any> | FieldReadFunction<any>,
	staffNotificationRecipientDelete?: FieldPolicy<any> | FieldReadFunction<any>,
	staffNotificationRecipientUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	staffUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	stockBulkUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	storedPaymentMethodRequestDelete?: FieldPolicy<any> | FieldReadFunction<any>,
	taxClassCreate?: FieldPolicy<any> | FieldReadFunction<any>,
	taxClassDelete?: FieldPolicy<any> | FieldReadFunction<any>,
	taxClassUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	taxConfigurationUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	taxCountryConfigurationDelete?: FieldPolicy<any> | FieldReadFunction<any>,
	taxCountryConfigurationUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	taxExemptionManage?: FieldPolicy<any> | FieldReadFunction<any>,
	tokenCreate?: FieldPolicy<any> | FieldReadFunction<any>,
	tokenRefresh?: FieldPolicy<any> | FieldReadFunction<any>,
	tokenVerify?: FieldPolicy<any> | FieldReadFunction<any>,
	tokensDeactivateAll?: FieldPolicy<any> | FieldReadFunction<any>,
	transactionCreate?: FieldPolicy<any> | FieldReadFunction<any>,
	transactionEventReport?: FieldPolicy<any> | FieldReadFunction<any>,
	transactionInitialize?: FieldPolicy<any> | FieldReadFunction<any>,
	transactionProcess?: FieldPolicy<any> | FieldReadFunction<any>,
	transactionRequestAction?: FieldPolicy<any> | FieldReadFunction<any>,
	transactionRequestRefundForGrantedRefund?: FieldPolicy<any> | FieldReadFunction<any>,
	transactionUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	unassignWarehouseShippingZone?: FieldPolicy<any> | FieldReadFunction<any>,
	updateMetadata?: FieldPolicy<any> | FieldReadFunction<any>,
	updatePrivateMetadata?: FieldPolicy<any> | FieldReadFunction<any>,
	updateWarehouse?: FieldPolicy<any> | FieldReadFunction<any>,
	userAvatarDelete?: FieldPolicy<any> | FieldReadFunction<any>,
	userAvatarUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	userBulkSetActive?: FieldPolicy<any> | FieldReadFunction<any>,
	variantMediaAssign?: FieldPolicy<any> | FieldReadFunction<any>,
	variantMediaUnassign?: FieldPolicy<any> | FieldReadFunction<any>,
	voucherBulkDelete?: FieldPolicy<any> | FieldReadFunction<any>,
	voucherCataloguesAdd?: FieldPolicy<any> | FieldReadFunction<any>,
	voucherCataloguesRemove?: FieldPolicy<any> | FieldReadFunction<any>,
	voucherChannelListingUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	voucherCodeBulkDelete?: FieldPolicy<any> | FieldReadFunction<any>,
	voucherCreate?: FieldPolicy<any> | FieldReadFunction<any>,
	voucherDelete?: FieldPolicy<any> | FieldReadFunction<any>,
	voucherTranslate?: FieldPolicy<any> | FieldReadFunction<any>,
	voucherUpdate?: FieldPolicy<any> | FieldReadFunction<any>,
	webhookCreate?: FieldPolicy<any> | FieldReadFunction<any>,
	webhookDelete?: FieldPolicy<any> | FieldReadFunction<any>,
	webhookDryRun?: FieldPolicy<any> | FieldReadFunction<any>,
	webhookTrigger?: FieldPolicy<any> | FieldReadFunction<any>,
	webhookUpdate?: FieldPolicy<any> | FieldReadFunction<any>
};
export type NewTabTargetOptionsKeySpecifier = ('method' | NewTabTargetOptionsKeySpecifier)[];
export type NewTabTargetOptionsFieldPolicy = {
	method?: FieldPolicy<any> | FieldReadFunction<any>
};
export type NodeKeySpecifier = ('id' | NodeKeySpecifier)[];
export type NodeFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ObjectWithAttributesKeySpecifier = ('assignedAttribute' | 'assignedAttributes' | ObjectWithAttributesKeySpecifier)[];
export type ObjectWithAttributesFieldPolicy = {
	assignedAttribute?: FieldPolicy<any> | FieldReadFunction<any>,
	assignedAttributes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ObjectWithMetadataKeySpecifier = ('metadata' | 'metafield' | 'metafields' | 'privateMetadata' | 'privateMetafield' | 'privateMetafields' | ObjectWithMetadataKeySpecifier)[];
export type ObjectWithMetadataFieldPolicy = {
	metadata?: FieldPolicy<any> | FieldReadFunction<any>,
	metafield?: FieldPolicy<any> | FieldReadFunction<any>,
	metafields?: FieldPolicy<any> | FieldReadFunction<any>,
	privateMetadata?: FieldPolicy<any> | FieldReadFunction<any>,
	privateMetafield?: FieldPolicy<any> | FieldReadFunction<any>,
	privateMetafields?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OrderKeySpecifier = ('actions' | 'authorizeStatus' | 'availableCollectionPoints' | 'availableShippingMethods' | 'billingAddress' | 'canFinalize' | 'channel' | 'chargeStatus' | 'checkoutId' | 'collectionPointName' | 'created' | 'customerNote' | 'deliveryMethod' | 'discount' | 'discountName' | 'discounts' | 'displayGrossPrices' | 'errors' | 'events' | 'externalReference' | 'fulfillments' | 'giftCards' | 'grantedRefunds' | 'id' | 'invoices' | 'isPaid' | 'isShippingRequired' | 'languageCode' | 'languageCodeEnum' | 'lines' | 'metadata' | 'metafield' | 'metafields' | 'number' | 'origin' | 'original' | 'paymentStatus' | 'paymentStatusDisplay' | 'payments' | 'privateMetadata' | 'privateMetafield' | 'privateMetafields' | 'redirectUrl' | 'shippingAddress' | 'shippingMethod' | 'shippingMethodName' | 'shippingMethods' | 'shippingPrice' | 'shippingTaxClass' | 'shippingTaxClassMetadata' | 'shippingTaxClassName' | 'shippingTaxClassPrivateMetadata' | 'shippingTaxRate' | 'status' | 'statusDisplay' | 'subtotal' | 'taxExemption' | 'token' | 'total' | 'totalAuthorizePending' | 'totalAuthorized' | 'totalBalance' | 'totalCancelPending' | 'totalCanceled' | 'totalCaptured' | 'totalChargePending' | 'totalCharged' | 'totalGrantedRefund' | 'totalRefundPending' | 'totalRefunded' | 'totalRemainingGrant' | 'trackingClientId' | 'transactions' | 'translatedDiscountName' | 'undiscountedShippingPrice' | 'undiscountedTotal' | 'updatedAt' | 'user' | 'userEmail' | 'voucher' | 'voucherCode' | 'weight' | OrderKeySpecifier)[];
export type OrderFieldPolicy = {
	actions?: FieldPolicy<any> | FieldReadFunction<any>,
	authorizeStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	availableCollectionPoints?: FieldPolicy<any> | FieldReadFunction<any>,
	availableShippingMethods?: FieldPolicy<any> | FieldReadFunction<any>,
	billingAddress?: FieldPolicy<any> | FieldReadFunction<any>,
	canFinalize?: FieldPolicy<any> | FieldReadFunction<any>,
	channel?: FieldPolicy<any> | FieldReadFunction<any>,
	chargeStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	checkoutId?: FieldPolicy<any> | FieldReadFunction<any>,
	collectionPointName?: FieldPolicy<any> | FieldReadFunction<any>,
	created?: FieldPolicy<any> | FieldReadFunction<any>,
	customerNote?: FieldPolicy<any> | FieldReadFunction<any>,
	deliveryMethod?: FieldPolicy<any> | FieldReadFunction<any>,
	discount?: FieldPolicy<any> | FieldReadFunction<any>,
	discountName?: FieldPolicy<any> | FieldReadFunction<any>,
	discounts?: FieldPolicy<any> | FieldReadFunction<any>,
	displayGrossPrices?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	events?: FieldPolicy<any> | FieldReadFunction<any>,
	externalReference?: FieldPolicy<any> | FieldReadFunction<any>,
	fulfillments?: FieldPolicy<any> | FieldReadFunction<any>,
	giftCards?: FieldPolicy<any> | FieldReadFunction<any>,
	grantedRefunds?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	invoices?: FieldPolicy<any> | FieldReadFunction<any>,
	isPaid?: FieldPolicy<any> | FieldReadFunction<any>,
	isShippingRequired?: FieldPolicy<any> | FieldReadFunction<any>,
	languageCode?: FieldPolicy<any> | FieldReadFunction<any>,
	languageCodeEnum?: FieldPolicy<any> | FieldReadFunction<any>,
	lines?: FieldPolicy<any> | FieldReadFunction<any>,
	metadata?: FieldPolicy<any> | FieldReadFunction<any>,
	metafield?: FieldPolicy<any> | FieldReadFunction<any>,
	metafields?: FieldPolicy<any> | FieldReadFunction<any>,
	number?: FieldPolicy<any> | FieldReadFunction<any>,
	origin?: FieldPolicy<any> | FieldReadFunction<any>,
	original?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentStatusDisplay?: FieldPolicy<any> | FieldReadFunction<any>,
	payments?: FieldPolicy<any> | FieldReadFunction<any>,
	privateMetadata?: FieldPolicy<any> | FieldReadFunction<any>,
	privateMetafield?: FieldPolicy<any> | FieldReadFunction<any>,
	privateMetafields?: FieldPolicy<any> | FieldReadFunction<any>,
	redirectUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	shippingAddress?: FieldPolicy<any> | FieldReadFunction<any>,
	shippingMethod?: FieldPolicy<any> | FieldReadFunction<any>,
	shippingMethodName?: FieldPolicy<any> | FieldReadFunction<any>,
	shippingMethods?: FieldPolicy<any> | FieldReadFunction<any>,
	shippingPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	shippingTaxClass?: FieldPolicy<any> | FieldReadFunction<any>,
	shippingTaxClassMetadata?: FieldPolicy<any> | FieldReadFunction<any>,
	shippingTaxClassName?: FieldPolicy<any> | FieldReadFunction<any>,
	shippingTaxClassPrivateMetadata?: FieldPolicy<any> | FieldReadFunction<any>,
	shippingTaxRate?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	statusDisplay?: FieldPolicy<any> | FieldReadFunction<any>,
	subtotal?: FieldPolicy<any> | FieldReadFunction<any>,
	taxExemption?: FieldPolicy<any> | FieldReadFunction<any>,
	token?: FieldPolicy<any> | FieldReadFunction<any>,
	total?: FieldPolicy<any> | FieldReadFunction<any>,
	totalAuthorizePending?: FieldPolicy<any> | FieldReadFunction<any>,
	totalAuthorized?: FieldPolicy<any> | FieldReadFunction<any>,
	totalBalance?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCancelPending?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCanceled?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCaptured?: FieldPolicy<any> | FieldReadFunction<any>,
	totalChargePending?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCharged?: FieldPolicy<any> | FieldReadFunction<any>,
	totalGrantedRefund?: FieldPolicy<any> | FieldReadFunction<any>,
	totalRefundPending?: FieldPolicy<any> | FieldReadFunction<any>,
	totalRefunded?: FieldPolicy<any> | FieldReadFunction<any>,
	totalRemainingGrant?: FieldPolicy<any> | FieldReadFunction<any>,
	trackingClientId?: FieldPolicy<any> | FieldReadFunction<any>,
	transactions?: FieldPolicy<any> | FieldReadFunction<any>,
	translatedDiscountName?: FieldPolicy<any> | FieldReadFunction<any>,
	undiscountedShippingPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	undiscountedTotal?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>,
	userEmail?: FieldPolicy<any> | FieldReadFunction<any>,
	voucher?: FieldPolicy<any> | FieldReadFunction<any>,
	voucherCode?: FieldPolicy<any> | FieldReadFunction<any>,
	weight?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OrderAddNoteKeySpecifier = ('errors' | 'event' | 'order' | 'orderErrors' | OrderAddNoteKeySpecifier)[];
export type OrderAddNoteFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	event?: FieldPolicy<any> | FieldReadFunction<any>,
	order?: FieldPolicy<any> | FieldReadFunction<any>,
	orderErrors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OrderBulkCancelKeySpecifier = ('count' | 'errors' | 'orderErrors' | OrderBulkCancelKeySpecifier)[];
export type OrderBulkCancelFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	orderErrors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OrderBulkCreateKeySpecifier = ('count' | 'errors' | 'results' | OrderBulkCreateKeySpecifier)[];
export type OrderBulkCreateFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	results?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OrderBulkCreateErrorKeySpecifier = ('code' | 'message' | 'path' | OrderBulkCreateErrorKeySpecifier)[];
export type OrderBulkCreateErrorFieldPolicy = {
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>,
	path?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OrderBulkCreateResultKeySpecifier = ('errors' | 'order' | OrderBulkCreateResultKeySpecifier)[];
export type OrderBulkCreateResultFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	order?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OrderBulkCreatedKeySpecifier = ('issuedAt' | 'issuingPrincipal' | 'orders' | 'recipient' | 'version' | OrderBulkCreatedKeySpecifier)[];
export type OrderBulkCreatedFieldPolicy = {
	issuedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	issuingPrincipal?: FieldPolicy<any> | FieldReadFunction<any>,
	orders?: FieldPolicy<any> | FieldReadFunction<any>,
	recipient?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OrderCancelKeySpecifier = ('errors' | 'order' | 'orderErrors' | OrderCancelKeySpecifier)[];
export type OrderCancelFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	order?: FieldPolicy<any> | FieldReadFunction<any>,
	orderErrors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OrderCancelledKeySpecifier = ('issuedAt' | 'issuingPrincipal' | 'order' | 'recipient' | 'version' | OrderCancelledKeySpecifier)[];
export type OrderCancelledFieldPolicy = {
	issuedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	issuingPrincipal?: FieldPolicy<any> | FieldReadFunction<any>,
	order?: FieldPolicy<any> | FieldReadFunction<any>,
	recipient?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OrderCaptureKeySpecifier = ('errors' | 'order' | 'orderErrors' | OrderCaptureKeySpecifier)[];
export type OrderCaptureFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	order?: FieldPolicy<any> | FieldReadFunction<any>,
	orderErrors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OrderConfirmKeySpecifier = ('errors' | 'order' | 'orderErrors' | OrderConfirmKeySpecifier)[];
export type OrderConfirmFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	order?: FieldPolicy<any> | FieldReadFunction<any>,
	orderErrors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OrderConfirmedKeySpecifier = ('issuedAt' | 'issuingPrincipal' | 'order' | 'recipient' | 'version' | OrderConfirmedKeySpecifier)[];
export type OrderConfirmedFieldPolicy = {
	issuedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	issuingPrincipal?: FieldPolicy<any> | FieldReadFunction<any>,
	order?: FieldPolicy<any> | FieldReadFunction<any>,
	recipient?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OrderCountableConnectionKeySpecifier = ('edges' | 'pageInfo' | 'totalCount' | OrderCountableConnectionKeySpecifier)[];
export type OrderCountableConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OrderCountableEdgeKeySpecifier = ('cursor' | 'node' | OrderCountableEdgeKeySpecifier)[];
export type OrderCountableEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OrderCreateFromCheckoutKeySpecifier = ('errors' | 'order' | OrderCreateFromCheckoutKeySpecifier)[];
export type OrderCreateFromCheckoutFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	order?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OrderCreateFromCheckoutErrorKeySpecifier = ('code' | 'field' | 'lines' | 'message' | 'variants' | OrderCreateFromCheckoutErrorKeySpecifier)[];
export type OrderCreateFromCheckoutErrorFieldPolicy = {
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	field?: FieldPolicy<any> | FieldReadFunction<any>,
	lines?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>,
	variants?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OrderCreatedKeySpecifier = ('issuedAt' | 'issuingPrincipal' | 'order' | 'recipient' | 'version' | OrderCreatedKeySpecifier)[];
export type OrderCreatedFieldPolicy = {
	issuedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	issuingPrincipal?: FieldPolicy<any> | FieldReadFunction<any>,
	order?: FieldPolicy<any> | FieldReadFunction<any>,
	recipient?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OrderDiscountKeySpecifier = ('amount' | 'id' | 'name' | 'reason' | 'total' | 'translatedName' | 'type' | 'value' | 'valueType' | OrderDiscountKeySpecifier)[];
export type OrderDiscountFieldPolicy = {
	amount?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	reason?: FieldPolicy<any> | FieldReadFunction<any>,
	total?: FieldPolicy<any> | FieldReadFunction<any>,
	translatedName?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>,
	valueType?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OrderDiscountAddKeySpecifier = ('errors' | 'order' | 'orderErrors' | OrderDiscountAddKeySpecifier)[];
export type OrderDiscountAddFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	order?: FieldPolicy<any> | FieldReadFunction<any>,
	orderErrors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OrderDiscountDeleteKeySpecifier = ('errors' | 'order' | 'orderErrors' | OrderDiscountDeleteKeySpecifier)[];
export type OrderDiscountDeleteFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	order?: FieldPolicy<any> | FieldReadFunction<any>,
	orderErrors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OrderDiscountUpdateKeySpecifier = ('errors' | 'order' | 'orderErrors' | OrderDiscountUpdateKeySpecifier)[];
export type OrderDiscountUpdateFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	order?: FieldPolicy<any> | FieldReadFunction<any>,
	orderErrors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OrderErrorKeySpecifier = ('addressType' | 'code' | 'field' | 'message' | 'orderLines' | 'variants' | 'warehouse' | OrderErrorKeySpecifier)[];
export type OrderErrorFieldPolicy = {
	addressType?: FieldPolicy<any> | FieldReadFunction<any>,
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	field?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>,
	orderLines?: FieldPolicy<any> | FieldReadFunction<any>,
	variants?: FieldPolicy<any> | FieldReadFunction<any>,
	warehouse?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OrderEventKeySpecifier = ('amount' | 'app' | 'composedId' | 'date' | 'discount' | 'email' | 'emailType' | 'fulfilledItems' | 'id' | 'invoiceNumber' | 'lines' | 'message' | 'orderNumber' | 'oversoldItems' | 'paymentGateway' | 'paymentId' | 'quantity' | 'reference' | 'related' | 'relatedOrder' | 'shippingCostsIncluded' | 'transactionReference' | 'type' | 'user' | 'warehouse' | OrderEventKeySpecifier)[];
export type OrderEventFieldPolicy = {
	amount?: FieldPolicy<any> | FieldReadFunction<any>,
	app?: FieldPolicy<any> | FieldReadFunction<any>,
	composedId?: FieldPolicy<any> | FieldReadFunction<any>,
	date?: FieldPolicy<any> | FieldReadFunction<any>,
	discount?: FieldPolicy<any> | FieldReadFunction<any>,
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	emailType?: FieldPolicy<any> | FieldReadFunction<any>,
	fulfilledItems?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	invoiceNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	lines?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>,
	orderNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	oversoldItems?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentGateway?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentId?: FieldPolicy<any> | FieldReadFunction<any>,
	quantity?: FieldPolicy<any> | FieldReadFunction<any>,
	reference?: FieldPolicy<any> | FieldReadFunction<any>,
	related?: FieldPolicy<any> | FieldReadFunction<any>,
	relatedOrder?: FieldPolicy<any> | FieldReadFunction<any>,
	shippingCostsIncluded?: FieldPolicy<any> | FieldReadFunction<any>,
	transactionReference?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>,
	warehouse?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OrderEventCountableConnectionKeySpecifier = ('edges' | 'pageInfo' | 'totalCount' | OrderEventCountableConnectionKeySpecifier)[];
export type OrderEventCountableConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OrderEventCountableEdgeKeySpecifier = ('cursor' | 'node' | OrderEventCountableEdgeKeySpecifier)[];
export type OrderEventCountableEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OrderEventDiscountObjectKeySpecifier = ('amount' | 'oldAmount' | 'oldValue' | 'oldValueType' | 'reason' | 'value' | 'valueType' | OrderEventDiscountObjectKeySpecifier)[];
export type OrderEventDiscountObjectFieldPolicy = {
	amount?: FieldPolicy<any> | FieldReadFunction<any>,
	oldAmount?: FieldPolicy<any> | FieldReadFunction<any>,
	oldValue?: FieldPolicy<any> | FieldReadFunction<any>,
	oldValueType?: FieldPolicy<any> | FieldReadFunction<any>,
	reason?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>,
	valueType?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OrderEventOrderLineObjectKeySpecifier = ('discount' | 'itemName' | 'orderLine' | 'quantity' | OrderEventOrderLineObjectKeySpecifier)[];
export type OrderEventOrderLineObjectFieldPolicy = {
	discount?: FieldPolicy<any> | FieldReadFunction<any>,
	itemName?: FieldPolicy<any> | FieldReadFunction<any>,
	orderLine?: FieldPolicy<any> | FieldReadFunction<any>,
	quantity?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OrderExpiredKeySpecifier = ('issuedAt' | 'issuingPrincipal' | 'order' | 'recipient' | 'version' | OrderExpiredKeySpecifier)[];
export type OrderExpiredFieldPolicy = {
	issuedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	issuingPrincipal?: FieldPolicy<any> | FieldReadFunction<any>,
	order?: FieldPolicy<any> | FieldReadFunction<any>,
	recipient?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OrderFilterShippingMethodsKeySpecifier = ('issuedAt' | 'issuingPrincipal' | 'order' | 'recipient' | 'shippingMethods' | 'version' | OrderFilterShippingMethodsKeySpecifier)[];
export type OrderFilterShippingMethodsFieldPolicy = {
	issuedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	issuingPrincipal?: FieldPolicy<any> | FieldReadFunction<any>,
	order?: FieldPolicy<any> | FieldReadFunction<any>,
	recipient?: FieldPolicy<any> | FieldReadFunction<any>,
	shippingMethods?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OrderFulfillKeySpecifier = ('errors' | 'fulfillments' | 'order' | 'orderErrors' | OrderFulfillKeySpecifier)[];
export type OrderFulfillFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	fulfillments?: FieldPolicy<any> | FieldReadFunction<any>,
	order?: FieldPolicy<any> | FieldReadFunction<any>,
	orderErrors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OrderFulfilledKeySpecifier = ('issuedAt' | 'issuingPrincipal' | 'order' | 'recipient' | 'version' | OrderFulfilledKeySpecifier)[];
export type OrderFulfilledFieldPolicy = {
	issuedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	issuingPrincipal?: FieldPolicy<any> | FieldReadFunction<any>,
	order?: FieldPolicy<any> | FieldReadFunction<any>,
	recipient?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OrderFullyPaidKeySpecifier = ('issuedAt' | 'issuingPrincipal' | 'order' | 'recipient' | 'version' | OrderFullyPaidKeySpecifier)[];
export type OrderFullyPaidFieldPolicy = {
	issuedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	issuingPrincipal?: FieldPolicy<any> | FieldReadFunction<any>,
	order?: FieldPolicy<any> | FieldReadFunction<any>,
	recipient?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OrderFullyRefundedKeySpecifier = ('issuedAt' | 'issuingPrincipal' | 'order' | 'recipient' | 'version' | OrderFullyRefundedKeySpecifier)[];
export type OrderFullyRefundedFieldPolicy = {
	issuedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	issuingPrincipal?: FieldPolicy<any> | FieldReadFunction<any>,
	order?: FieldPolicy<any> | FieldReadFunction<any>,
	recipient?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OrderGrantRefundCreateKeySpecifier = ('errors' | 'grantedRefund' | 'order' | OrderGrantRefundCreateKeySpecifier)[];
export type OrderGrantRefundCreateFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	grantedRefund?: FieldPolicy<any> | FieldReadFunction<any>,
	order?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OrderGrantRefundCreateErrorKeySpecifier = ('code' | 'field' | 'lines' | 'message' | OrderGrantRefundCreateErrorKeySpecifier)[];
export type OrderGrantRefundCreateErrorFieldPolicy = {
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	field?: FieldPolicy<any> | FieldReadFunction<any>,
	lines?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OrderGrantRefundCreateLineErrorKeySpecifier = ('code' | 'field' | 'lineId' | 'message' | OrderGrantRefundCreateLineErrorKeySpecifier)[];
export type OrderGrantRefundCreateLineErrorFieldPolicy = {
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	field?: FieldPolicy<any> | FieldReadFunction<any>,
	lineId?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OrderGrantRefundUpdateKeySpecifier = ('errors' | 'grantedRefund' | 'order' | OrderGrantRefundUpdateKeySpecifier)[];
export type OrderGrantRefundUpdateFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	grantedRefund?: FieldPolicy<any> | FieldReadFunction<any>,
	order?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OrderGrantRefundUpdateErrorKeySpecifier = ('addLines' | 'code' | 'field' | 'message' | 'removeLines' | OrderGrantRefundUpdateErrorKeySpecifier)[];
export type OrderGrantRefundUpdateErrorFieldPolicy = {
	addLines?: FieldPolicy<any> | FieldReadFunction<any>,
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	field?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>,
	removeLines?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OrderGrantRefundUpdateLineErrorKeySpecifier = ('code' | 'field' | 'lineId' | 'message' | OrderGrantRefundUpdateLineErrorKeySpecifier)[];
export type OrderGrantRefundUpdateLineErrorFieldPolicy = {
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	field?: FieldPolicy<any> | FieldReadFunction<any>,
	lineId?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OrderGrantedRefundKeySpecifier = ('amount' | 'app' | 'createdAt' | 'id' | 'lines' | 'reason' | 'reasonReference' | 'shippingCostsIncluded' | 'status' | 'transaction' | 'transactionEvents' | 'updatedAt' | 'user' | OrderGrantedRefundKeySpecifier)[];
export type OrderGrantedRefundFieldPolicy = {
	amount?: FieldPolicy<any> | FieldReadFunction<any>,
	app?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	lines?: FieldPolicy<any> | FieldReadFunction<any>,
	reason?: FieldPolicy<any> | FieldReadFunction<any>,
	reasonReference?: FieldPolicy<any> | FieldReadFunction<any>,
	shippingCostsIncluded?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	transaction?: FieldPolicy<any> | FieldReadFunction<any>,
	transactionEvents?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OrderGrantedRefundLineKeySpecifier = ('id' | 'orderLine' | 'quantity' | 'reason' | OrderGrantedRefundLineKeySpecifier)[];
export type OrderGrantedRefundLineFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	orderLine?: FieldPolicy<any> | FieldReadFunction<any>,
	quantity?: FieldPolicy<any> | FieldReadFunction<any>,
	reason?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OrderLineKeySpecifier = ('allocations' | 'digitalContentUrl' | 'discounts' | 'id' | 'isGift' | 'isPriceOverridden' | 'isShippingRequired' | 'metadata' | 'metafield' | 'metafields' | 'privateMetadata' | 'privateMetafield' | 'privateMetafields' | 'productName' | 'productSku' | 'productVariantId' | 'quantity' | 'quantityFulfilled' | 'quantityToFulfill' | 'saleId' | 'taxClass' | 'taxClassMetadata' | 'taxClassName' | 'taxClassPrivateMetadata' | 'taxRate' | 'thumbnail' | 'totalPrice' | 'translatedProductName' | 'translatedVariantName' | 'undiscountedTotalPrice' | 'undiscountedUnitPrice' | 'unitDiscount' | 'unitDiscountReason' | 'unitDiscountType' | 'unitDiscountValue' | 'unitPrice' | 'variant' | 'variantName' | 'voucherCode' | OrderLineKeySpecifier)[];
export type OrderLineFieldPolicy = {
	allocations?: FieldPolicy<any> | FieldReadFunction<any>,
	digitalContentUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	discounts?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isGift?: FieldPolicy<any> | FieldReadFunction<any>,
	isPriceOverridden?: FieldPolicy<any> | FieldReadFunction<any>,
	isShippingRequired?: FieldPolicy<any> | FieldReadFunction<any>,
	metadata?: FieldPolicy<any> | FieldReadFunction<any>,
	metafield?: FieldPolicy<any> | FieldReadFunction<any>,
	metafields?: FieldPolicy<any> | FieldReadFunction<any>,
	privateMetadata?: FieldPolicy<any> | FieldReadFunction<any>,
	privateMetafield?: FieldPolicy<any> | FieldReadFunction<any>,
	privateMetafields?: FieldPolicy<any> | FieldReadFunction<any>,
	productName?: FieldPolicy<any> | FieldReadFunction<any>,
	productSku?: FieldPolicy<any> | FieldReadFunction<any>,
	productVariantId?: FieldPolicy<any> | FieldReadFunction<any>,
	quantity?: FieldPolicy<any> | FieldReadFunction<any>,
	quantityFulfilled?: FieldPolicy<any> | FieldReadFunction<any>,
	quantityToFulfill?: FieldPolicy<any> | FieldReadFunction<any>,
	saleId?: FieldPolicy<any> | FieldReadFunction<any>,
	taxClass?: FieldPolicy<any> | FieldReadFunction<any>,
	taxClassMetadata?: FieldPolicy<any> | FieldReadFunction<any>,
	taxClassName?: FieldPolicy<any> | FieldReadFunction<any>,
	taxClassPrivateMetadata?: FieldPolicy<any> | FieldReadFunction<any>,
	taxRate?: FieldPolicy<any> | FieldReadFunction<any>,
	thumbnail?: FieldPolicy<any> | FieldReadFunction<any>,
	totalPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	translatedProductName?: FieldPolicy<any> | FieldReadFunction<any>,
	translatedVariantName?: FieldPolicy<any> | FieldReadFunction<any>,
	undiscountedTotalPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	undiscountedUnitPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	unitDiscount?: FieldPolicy<any> | FieldReadFunction<any>,
	unitDiscountReason?: FieldPolicy<any> | FieldReadFunction<any>,
	unitDiscountType?: FieldPolicy<any> | FieldReadFunction<any>,
	unitDiscountValue?: FieldPolicy<any> | FieldReadFunction<any>,
	unitPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	variant?: FieldPolicy<any> | FieldReadFunction<any>,
	variantName?: FieldPolicy<any> | FieldReadFunction<any>,
	voucherCode?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OrderLineDeleteKeySpecifier = ('errors' | 'order' | 'orderErrors' | 'orderLine' | OrderLineDeleteKeySpecifier)[];
export type OrderLineDeleteFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	order?: FieldPolicy<any> | FieldReadFunction<any>,
	orderErrors?: FieldPolicy<any> | FieldReadFunction<any>,
	orderLine?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OrderLineDiscountKeySpecifier = ('id' | 'name' | 'reason' | 'total' | 'translatedName' | 'type' | 'unit' | 'value' | 'valueType' | OrderLineDiscountKeySpecifier)[];
export type OrderLineDiscountFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	reason?: FieldPolicy<any> | FieldReadFunction<any>,
	total?: FieldPolicy<any> | FieldReadFunction<any>,
	translatedName?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	unit?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>,
	valueType?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OrderLineDiscountRemoveKeySpecifier = ('errors' | 'order' | 'orderErrors' | 'orderLine' | OrderLineDiscountRemoveKeySpecifier)[];
export type OrderLineDiscountRemoveFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	order?: FieldPolicy<any> | FieldReadFunction<any>,
	orderErrors?: FieldPolicy<any> | FieldReadFunction<any>,
	orderLine?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OrderLineDiscountUpdateKeySpecifier = ('errors' | 'order' | 'orderErrors' | 'orderLine' | OrderLineDiscountUpdateKeySpecifier)[];
export type OrderLineDiscountUpdateFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	order?: FieldPolicy<any> | FieldReadFunction<any>,
	orderErrors?: FieldPolicy<any> | FieldReadFunction<any>,
	orderLine?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OrderLineUpdateKeySpecifier = ('errors' | 'order' | 'orderErrors' | 'orderLine' | OrderLineUpdateKeySpecifier)[];
export type OrderLineUpdateFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	order?: FieldPolicy<any> | FieldReadFunction<any>,
	orderErrors?: FieldPolicy<any> | FieldReadFunction<any>,
	orderLine?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OrderLinesCreateKeySpecifier = ('errors' | 'order' | 'orderErrors' | 'orderLines' | OrderLinesCreateKeySpecifier)[];
export type OrderLinesCreateFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	order?: FieldPolicy<any> | FieldReadFunction<any>,
	orderErrors?: FieldPolicy<any> | FieldReadFunction<any>,
	orderLines?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OrderMarkAsPaidKeySpecifier = ('errors' | 'order' | 'orderErrors' | OrderMarkAsPaidKeySpecifier)[];
export type OrderMarkAsPaidFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	order?: FieldPolicy<any> | FieldReadFunction<any>,
	orderErrors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OrderMetadataUpdatedKeySpecifier = ('issuedAt' | 'issuingPrincipal' | 'order' | 'recipient' | 'version' | OrderMetadataUpdatedKeySpecifier)[];
export type OrderMetadataUpdatedFieldPolicy = {
	issuedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	issuingPrincipal?: FieldPolicy<any> | FieldReadFunction<any>,
	order?: FieldPolicy<any> | FieldReadFunction<any>,
	recipient?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OrderNoteAddKeySpecifier = ('errors' | 'event' | 'order' | OrderNoteAddKeySpecifier)[];
export type OrderNoteAddFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	event?: FieldPolicy<any> | FieldReadFunction<any>,
	order?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OrderNoteAddErrorKeySpecifier = ('code' | 'field' | 'message' | OrderNoteAddErrorKeySpecifier)[];
export type OrderNoteAddErrorFieldPolicy = {
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	field?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OrderNoteUpdateKeySpecifier = ('errors' | 'event' | 'order' | OrderNoteUpdateKeySpecifier)[];
export type OrderNoteUpdateFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	event?: FieldPolicy<any> | FieldReadFunction<any>,
	order?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OrderNoteUpdateErrorKeySpecifier = ('code' | 'field' | 'message' | OrderNoteUpdateErrorKeySpecifier)[];
export type OrderNoteUpdateErrorFieldPolicy = {
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	field?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OrderPaidKeySpecifier = ('issuedAt' | 'issuingPrincipal' | 'order' | 'recipient' | 'version' | OrderPaidKeySpecifier)[];
export type OrderPaidFieldPolicy = {
	issuedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	issuingPrincipal?: FieldPolicy<any> | FieldReadFunction<any>,
	order?: FieldPolicy<any> | FieldReadFunction<any>,
	recipient?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OrderRefundKeySpecifier = ('errors' | 'order' | 'orderErrors' | OrderRefundKeySpecifier)[];
export type OrderRefundFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	order?: FieldPolicy<any> | FieldReadFunction<any>,
	orderErrors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OrderRefundedKeySpecifier = ('issuedAt' | 'issuingPrincipal' | 'order' | 'recipient' | 'version' | OrderRefundedKeySpecifier)[];
export type OrderRefundedFieldPolicy = {
	issuedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	issuingPrincipal?: FieldPolicy<any> | FieldReadFunction<any>,
	order?: FieldPolicy<any> | FieldReadFunction<any>,
	recipient?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OrderSettingsKeySpecifier = ('allowUnpaidOrders' | 'automaticallyConfirmAllNewOrders' | 'automaticallyFulfillNonShippableGiftCard' | 'deleteExpiredOrdersAfter' | 'draftOrderLinePriceFreezePeriod' | 'expireOrdersAfter' | 'includeDraftOrderInVoucherUsage' | 'markAsPaidStrategy' | 'useLegacyLineDiscountPropagation' | OrderSettingsKeySpecifier)[];
export type OrderSettingsFieldPolicy = {
	allowUnpaidOrders?: FieldPolicy<any> | FieldReadFunction<any>,
	automaticallyConfirmAllNewOrders?: FieldPolicy<any> | FieldReadFunction<any>,
	automaticallyFulfillNonShippableGiftCard?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteExpiredOrdersAfter?: FieldPolicy<any> | FieldReadFunction<any>,
	draftOrderLinePriceFreezePeriod?: FieldPolicy<any> | FieldReadFunction<any>,
	expireOrdersAfter?: FieldPolicy<any> | FieldReadFunction<any>,
	includeDraftOrderInVoucherUsage?: FieldPolicy<any> | FieldReadFunction<any>,
	markAsPaidStrategy?: FieldPolicy<any> | FieldReadFunction<any>,
	useLegacyLineDiscountPropagation?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OrderSettingsErrorKeySpecifier = ('code' | 'field' | 'message' | OrderSettingsErrorKeySpecifier)[];
export type OrderSettingsErrorFieldPolicy = {
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	field?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OrderSettingsUpdateKeySpecifier = ('errors' | 'orderSettings' | 'orderSettingsErrors' | OrderSettingsUpdateKeySpecifier)[];
export type OrderSettingsUpdateFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	orderSettings?: FieldPolicy<any> | FieldReadFunction<any>,
	orderSettingsErrors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OrderUpdateKeySpecifier = ('errors' | 'order' | 'orderErrors' | OrderUpdateKeySpecifier)[];
export type OrderUpdateFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	order?: FieldPolicy<any> | FieldReadFunction<any>,
	orderErrors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OrderUpdateShippingKeySpecifier = ('errors' | 'order' | 'orderErrors' | OrderUpdateShippingKeySpecifier)[];
export type OrderUpdateShippingFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	order?: FieldPolicy<any> | FieldReadFunction<any>,
	orderErrors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OrderUpdatedKeySpecifier = ('issuedAt' | 'issuingPrincipal' | 'order' | 'recipient' | 'version' | OrderUpdatedKeySpecifier)[];
export type OrderUpdatedFieldPolicy = {
	issuedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	issuingPrincipal?: FieldPolicy<any> | FieldReadFunction<any>,
	order?: FieldPolicy<any> | FieldReadFunction<any>,
	recipient?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OrderVoidKeySpecifier = ('errors' | 'order' | 'orderErrors' | OrderVoidKeySpecifier)[];
export type OrderVoidFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	order?: FieldPolicy<any> | FieldReadFunction<any>,
	orderErrors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OtherPaymentMethodDetailsKeySpecifier = ('name' | OtherPaymentMethodDetailsKeySpecifier)[];
export type OtherPaymentMethodDetailsFieldPolicy = {
	name?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PageKeySpecifier = ('assignedAttribute' | 'assignedAttributes' | 'attribute' | 'attributes' | 'content' | 'contentJson' | 'created' | 'id' | 'isPublished' | 'metadata' | 'metafield' | 'metafields' | 'pageType' | 'privateMetadata' | 'privateMetafield' | 'privateMetafields' | 'publicationDate' | 'publishedAt' | 'seoDescription' | 'seoTitle' | 'slug' | 'title' | 'translation' | PageKeySpecifier)[];
export type PageFieldPolicy = {
	assignedAttribute?: FieldPolicy<any> | FieldReadFunction<any>,
	assignedAttributes?: FieldPolicy<any> | FieldReadFunction<any>,
	attribute?: FieldPolicy<any> | FieldReadFunction<any>,
	attributes?: FieldPolicy<any> | FieldReadFunction<any>,
	content?: FieldPolicy<any> | FieldReadFunction<any>,
	contentJson?: FieldPolicy<any> | FieldReadFunction<any>,
	created?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isPublished?: FieldPolicy<any> | FieldReadFunction<any>,
	metadata?: FieldPolicy<any> | FieldReadFunction<any>,
	metafield?: FieldPolicy<any> | FieldReadFunction<any>,
	metafields?: FieldPolicy<any> | FieldReadFunction<any>,
	pageType?: FieldPolicy<any> | FieldReadFunction<any>,
	privateMetadata?: FieldPolicy<any> | FieldReadFunction<any>,
	privateMetafield?: FieldPolicy<any> | FieldReadFunction<any>,
	privateMetafields?: FieldPolicy<any> | FieldReadFunction<any>,
	publicationDate?: FieldPolicy<any> | FieldReadFunction<any>,
	publishedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	seoDescription?: FieldPolicy<any> | FieldReadFunction<any>,
	seoTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	slug?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>,
	translation?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PageAttributeAssignKeySpecifier = ('errors' | 'pageErrors' | 'pageType' | PageAttributeAssignKeySpecifier)[];
export type PageAttributeAssignFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	pageErrors?: FieldPolicy<any> | FieldReadFunction<any>,
	pageType?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PageAttributeUnassignKeySpecifier = ('errors' | 'pageErrors' | 'pageType' | PageAttributeUnassignKeySpecifier)[];
export type PageAttributeUnassignFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	pageErrors?: FieldPolicy<any> | FieldReadFunction<any>,
	pageType?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PageBulkDeleteKeySpecifier = ('count' | 'errors' | 'pageErrors' | PageBulkDeleteKeySpecifier)[];
export type PageBulkDeleteFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	pageErrors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PageBulkPublishKeySpecifier = ('count' | 'errors' | 'pageErrors' | PageBulkPublishKeySpecifier)[];
export type PageBulkPublishFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	pageErrors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PageCountableConnectionKeySpecifier = ('edges' | 'pageInfo' | 'totalCount' | PageCountableConnectionKeySpecifier)[];
export type PageCountableConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PageCountableEdgeKeySpecifier = ('cursor' | 'node' | PageCountableEdgeKeySpecifier)[];
export type PageCountableEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PageCreateKeySpecifier = ('errors' | 'page' | 'pageErrors' | PageCreateKeySpecifier)[];
export type PageCreateFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	page?: FieldPolicy<any> | FieldReadFunction<any>,
	pageErrors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PageCreatedKeySpecifier = ('issuedAt' | 'issuingPrincipal' | 'page' | 'recipient' | 'version' | PageCreatedKeySpecifier)[];
export type PageCreatedFieldPolicy = {
	issuedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	issuingPrincipal?: FieldPolicy<any> | FieldReadFunction<any>,
	page?: FieldPolicy<any> | FieldReadFunction<any>,
	recipient?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PageDeleteKeySpecifier = ('errors' | 'page' | 'pageErrors' | PageDeleteKeySpecifier)[];
export type PageDeleteFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	page?: FieldPolicy<any> | FieldReadFunction<any>,
	pageErrors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PageDeletedKeySpecifier = ('issuedAt' | 'issuingPrincipal' | 'page' | 'recipient' | 'version' | PageDeletedKeySpecifier)[];
export type PageDeletedFieldPolicy = {
	issuedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	issuingPrincipal?: FieldPolicy<any> | FieldReadFunction<any>,
	page?: FieldPolicy<any> | FieldReadFunction<any>,
	recipient?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PageErrorKeySpecifier = ('attributes' | 'code' | 'field' | 'message' | 'values' | PageErrorKeySpecifier)[];
export type PageErrorFieldPolicy = {
	attributes?: FieldPolicy<any> | FieldReadFunction<any>,
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	field?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>,
	values?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PageInfoKeySpecifier = ('endCursor' | 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | PageInfoKeySpecifier)[];
export type PageInfoFieldPolicy = {
	endCursor?: FieldPolicy<any> | FieldReadFunction<any>,
	hasNextPage?: FieldPolicy<any> | FieldReadFunction<any>,
	hasPreviousPage?: FieldPolicy<any> | FieldReadFunction<any>,
	startCursor?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PageReorderAttributeValuesKeySpecifier = ('errors' | 'page' | 'pageErrors' | PageReorderAttributeValuesKeySpecifier)[];
export type PageReorderAttributeValuesFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	page?: FieldPolicy<any> | FieldReadFunction<any>,
	pageErrors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PageTranslatableContentKeySpecifier = ('attributeValues' | 'content' | 'contentJson' | 'id' | 'page' | 'pageId' | 'seoDescription' | 'seoTitle' | 'slug' | 'title' | 'translation' | PageTranslatableContentKeySpecifier)[];
export type PageTranslatableContentFieldPolicy = {
	attributeValues?: FieldPolicy<any> | FieldReadFunction<any>,
	content?: FieldPolicy<any> | FieldReadFunction<any>,
	contentJson?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	page?: FieldPolicy<any> | FieldReadFunction<any>,
	pageId?: FieldPolicy<any> | FieldReadFunction<any>,
	seoDescription?: FieldPolicy<any> | FieldReadFunction<any>,
	seoTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	slug?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>,
	translation?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PageTranslateKeySpecifier = ('errors' | 'page' | 'translationErrors' | PageTranslateKeySpecifier)[];
export type PageTranslateFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	page?: FieldPolicy<any> | FieldReadFunction<any>,
	translationErrors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PageTranslationKeySpecifier = ('content' | 'contentJson' | 'id' | 'language' | 'seoDescription' | 'seoTitle' | 'slug' | 'title' | 'translatableContent' | PageTranslationKeySpecifier)[];
export type PageTranslationFieldPolicy = {
	content?: FieldPolicy<any> | FieldReadFunction<any>,
	contentJson?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	language?: FieldPolicy<any> | FieldReadFunction<any>,
	seoDescription?: FieldPolicy<any> | FieldReadFunction<any>,
	seoTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	slug?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>,
	translatableContent?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PageTypeKeySpecifier = ('attributes' | 'availableAttributes' | 'hasPages' | 'id' | 'metadata' | 'metafield' | 'metafields' | 'name' | 'privateMetadata' | 'privateMetafield' | 'privateMetafields' | 'slug' | PageTypeKeySpecifier)[];
export type PageTypeFieldPolicy = {
	attributes?: FieldPolicy<any> | FieldReadFunction<any>,
	availableAttributes?: FieldPolicy<any> | FieldReadFunction<any>,
	hasPages?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	metadata?: FieldPolicy<any> | FieldReadFunction<any>,
	metafield?: FieldPolicy<any> | FieldReadFunction<any>,
	metafields?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	privateMetadata?: FieldPolicy<any> | FieldReadFunction<any>,
	privateMetafield?: FieldPolicy<any> | FieldReadFunction<any>,
	privateMetafields?: FieldPolicy<any> | FieldReadFunction<any>,
	slug?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PageTypeBulkDeleteKeySpecifier = ('count' | 'errors' | 'pageErrors' | PageTypeBulkDeleteKeySpecifier)[];
export type PageTypeBulkDeleteFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	pageErrors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PageTypeCountableConnectionKeySpecifier = ('edges' | 'pageInfo' | 'totalCount' | PageTypeCountableConnectionKeySpecifier)[];
export type PageTypeCountableConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PageTypeCountableEdgeKeySpecifier = ('cursor' | 'node' | PageTypeCountableEdgeKeySpecifier)[];
export type PageTypeCountableEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PageTypeCreateKeySpecifier = ('errors' | 'pageErrors' | 'pageType' | PageTypeCreateKeySpecifier)[];
export type PageTypeCreateFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	pageErrors?: FieldPolicy<any> | FieldReadFunction<any>,
	pageType?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PageTypeCreatedKeySpecifier = ('issuedAt' | 'issuingPrincipal' | 'pageType' | 'recipient' | 'version' | PageTypeCreatedKeySpecifier)[];
export type PageTypeCreatedFieldPolicy = {
	issuedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	issuingPrincipal?: FieldPolicy<any> | FieldReadFunction<any>,
	pageType?: FieldPolicy<any> | FieldReadFunction<any>,
	recipient?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PageTypeDeleteKeySpecifier = ('errors' | 'pageErrors' | 'pageType' | PageTypeDeleteKeySpecifier)[];
export type PageTypeDeleteFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	pageErrors?: FieldPolicy<any> | FieldReadFunction<any>,
	pageType?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PageTypeDeletedKeySpecifier = ('issuedAt' | 'issuingPrincipal' | 'pageType' | 'recipient' | 'version' | PageTypeDeletedKeySpecifier)[];
export type PageTypeDeletedFieldPolicy = {
	issuedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	issuingPrincipal?: FieldPolicy<any> | FieldReadFunction<any>,
	pageType?: FieldPolicy<any> | FieldReadFunction<any>,
	recipient?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PageTypeReorderAttributesKeySpecifier = ('errors' | 'pageErrors' | 'pageType' | PageTypeReorderAttributesKeySpecifier)[];
export type PageTypeReorderAttributesFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	pageErrors?: FieldPolicy<any> | FieldReadFunction<any>,
	pageType?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PageTypeUpdateKeySpecifier = ('errors' | 'pageErrors' | 'pageType' | PageTypeUpdateKeySpecifier)[];
export type PageTypeUpdateFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	pageErrors?: FieldPolicy<any> | FieldReadFunction<any>,
	pageType?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PageTypeUpdatedKeySpecifier = ('issuedAt' | 'issuingPrincipal' | 'pageType' | 'recipient' | 'version' | PageTypeUpdatedKeySpecifier)[];
export type PageTypeUpdatedFieldPolicy = {
	issuedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	issuingPrincipal?: FieldPolicy<any> | FieldReadFunction<any>,
	pageType?: FieldPolicy<any> | FieldReadFunction<any>,
	recipient?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PageUpdateKeySpecifier = ('errors' | 'page' | 'pageErrors' | PageUpdateKeySpecifier)[];
export type PageUpdateFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	page?: FieldPolicy<any> | FieldReadFunction<any>,
	pageErrors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PageUpdatedKeySpecifier = ('issuedAt' | 'issuingPrincipal' | 'page' | 'recipient' | 'version' | PageUpdatedKeySpecifier)[];
export type PageUpdatedFieldPolicy = {
	issuedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	issuingPrincipal?: FieldPolicy<any> | FieldReadFunction<any>,
	page?: FieldPolicy<any> | FieldReadFunction<any>,
	recipient?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PasswordChangeKeySpecifier = ('accountErrors' | 'errors' | 'user' | PasswordChangeKeySpecifier)[];
export type PasswordChangeFieldPolicy = {
	accountErrors?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PaymentKeySpecifier = ('actions' | 'availableCaptureAmount' | 'availableRefundAmount' | 'capturedAmount' | 'chargeStatus' | 'checkout' | 'created' | 'creditCard' | 'customerIpAddress' | 'gateway' | 'id' | 'isActive' | 'metadata' | 'metafield' | 'metafields' | 'modified' | 'order' | 'partial' | 'paymentMethodType' | 'privateMetadata' | 'privateMetafield' | 'privateMetafields' | 'pspReference' | 'token' | 'total' | 'transactions' | PaymentKeySpecifier)[];
export type PaymentFieldPolicy = {
	actions?: FieldPolicy<any> | FieldReadFunction<any>,
	availableCaptureAmount?: FieldPolicy<any> | FieldReadFunction<any>,
	availableRefundAmount?: FieldPolicy<any> | FieldReadFunction<any>,
	capturedAmount?: FieldPolicy<any> | FieldReadFunction<any>,
	chargeStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	checkout?: FieldPolicy<any> | FieldReadFunction<any>,
	created?: FieldPolicy<any> | FieldReadFunction<any>,
	creditCard?: FieldPolicy<any> | FieldReadFunction<any>,
	customerIpAddress?: FieldPolicy<any> | FieldReadFunction<any>,
	gateway?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isActive?: FieldPolicy<any> | FieldReadFunction<any>,
	metadata?: FieldPolicy<any> | FieldReadFunction<any>,
	metafield?: FieldPolicy<any> | FieldReadFunction<any>,
	metafields?: FieldPolicy<any> | FieldReadFunction<any>,
	modified?: FieldPolicy<any> | FieldReadFunction<any>,
	order?: FieldPolicy<any> | FieldReadFunction<any>,
	partial?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentMethodType?: FieldPolicy<any> | FieldReadFunction<any>,
	privateMetadata?: FieldPolicy<any> | FieldReadFunction<any>,
	privateMetafield?: FieldPolicy<any> | FieldReadFunction<any>,
	privateMetafields?: FieldPolicy<any> | FieldReadFunction<any>,
	pspReference?: FieldPolicy<any> | FieldReadFunction<any>,
	token?: FieldPolicy<any> | FieldReadFunction<any>,
	total?: FieldPolicy<any> | FieldReadFunction<any>,
	transactions?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PaymentAuthorizeKeySpecifier = ('issuedAt' | 'issuingPrincipal' | 'payment' | 'recipient' | 'version' | PaymentAuthorizeKeySpecifier)[];
export type PaymentAuthorizeFieldPolicy = {
	issuedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	issuingPrincipal?: FieldPolicy<any> | FieldReadFunction<any>,
	payment?: FieldPolicy<any> | FieldReadFunction<any>,
	recipient?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PaymentCaptureKeySpecifier = ('errors' | 'payment' | 'paymentErrors' | PaymentCaptureKeySpecifier)[];
export type PaymentCaptureFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	payment?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentErrors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PaymentCaptureEventKeySpecifier = ('issuedAt' | 'issuingPrincipal' | 'payment' | 'recipient' | 'version' | PaymentCaptureEventKeySpecifier)[];
export type PaymentCaptureEventFieldPolicy = {
	issuedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	issuingPrincipal?: FieldPolicy<any> | FieldReadFunction<any>,
	payment?: FieldPolicy<any> | FieldReadFunction<any>,
	recipient?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PaymentCheckBalanceKeySpecifier = ('data' | 'errors' | 'paymentErrors' | PaymentCheckBalanceKeySpecifier)[];
export type PaymentCheckBalanceFieldPolicy = {
	data?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentErrors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PaymentConfirmEventKeySpecifier = ('issuedAt' | 'issuingPrincipal' | 'payment' | 'recipient' | 'version' | PaymentConfirmEventKeySpecifier)[];
export type PaymentConfirmEventFieldPolicy = {
	issuedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	issuingPrincipal?: FieldPolicy<any> | FieldReadFunction<any>,
	payment?: FieldPolicy<any> | FieldReadFunction<any>,
	recipient?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PaymentCountableConnectionKeySpecifier = ('edges' | 'pageInfo' | 'totalCount' | PaymentCountableConnectionKeySpecifier)[];
export type PaymentCountableConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PaymentCountableEdgeKeySpecifier = ('cursor' | 'node' | PaymentCountableEdgeKeySpecifier)[];
export type PaymentCountableEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PaymentErrorKeySpecifier = ('code' | 'field' | 'message' | 'variants' | PaymentErrorKeySpecifier)[];
export type PaymentErrorFieldPolicy = {
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	field?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>,
	variants?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PaymentGatewayKeySpecifier = ('config' | 'currencies' | 'id' | 'name' | PaymentGatewayKeySpecifier)[];
export type PaymentGatewayFieldPolicy = {
	config?: FieldPolicy<any> | FieldReadFunction<any>,
	currencies?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PaymentGatewayConfigKeySpecifier = ('data' | 'errors' | 'id' | PaymentGatewayConfigKeySpecifier)[];
export type PaymentGatewayConfigFieldPolicy = {
	data?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PaymentGatewayConfigErrorKeySpecifier = ('code' | 'field' | 'message' | PaymentGatewayConfigErrorKeySpecifier)[];
export type PaymentGatewayConfigErrorFieldPolicy = {
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	field?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PaymentGatewayInitializeKeySpecifier = ('errors' | 'gatewayConfigs' | PaymentGatewayInitializeKeySpecifier)[];
export type PaymentGatewayInitializeFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	gatewayConfigs?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PaymentGatewayInitializeErrorKeySpecifier = ('code' | 'field' | 'message' | PaymentGatewayInitializeErrorKeySpecifier)[];
export type PaymentGatewayInitializeErrorFieldPolicy = {
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	field?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PaymentGatewayInitializeSessionKeySpecifier = ('amount' | 'data' | 'issuedAt' | 'issuingPrincipal' | 'recipient' | 'sourceObject' | 'version' | PaymentGatewayInitializeSessionKeySpecifier)[];
export type PaymentGatewayInitializeSessionFieldPolicy = {
	amount?: FieldPolicy<any> | FieldReadFunction<any>,
	data?: FieldPolicy<any> | FieldReadFunction<any>,
	issuedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	issuingPrincipal?: FieldPolicy<any> | FieldReadFunction<any>,
	recipient?: FieldPolicy<any> | FieldReadFunction<any>,
	sourceObject?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PaymentGatewayInitializeTokenizationKeySpecifier = ('data' | 'errors' | 'result' | PaymentGatewayInitializeTokenizationKeySpecifier)[];
export type PaymentGatewayInitializeTokenizationFieldPolicy = {
	data?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	result?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PaymentGatewayInitializeTokenizationErrorKeySpecifier = ('code' | 'field' | 'message' | PaymentGatewayInitializeTokenizationErrorKeySpecifier)[];
export type PaymentGatewayInitializeTokenizationErrorFieldPolicy = {
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	field?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PaymentGatewayInitializeTokenizationSessionKeySpecifier = ('channel' | 'data' | 'issuedAt' | 'issuingPrincipal' | 'recipient' | 'user' | 'version' | PaymentGatewayInitializeTokenizationSessionKeySpecifier)[];
export type PaymentGatewayInitializeTokenizationSessionFieldPolicy = {
	channel?: FieldPolicy<any> | FieldReadFunction<any>,
	data?: FieldPolicy<any> | FieldReadFunction<any>,
	issuedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	issuingPrincipal?: FieldPolicy<any> | FieldReadFunction<any>,
	recipient?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PaymentInitializeKeySpecifier = ('errors' | 'initializedPayment' | 'paymentErrors' | PaymentInitializeKeySpecifier)[];
export type PaymentInitializeFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	initializedPayment?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentErrors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PaymentInitializedKeySpecifier = ('data' | 'gateway' | 'name' | PaymentInitializedKeySpecifier)[];
export type PaymentInitializedFieldPolicy = {
	data?: FieldPolicy<any> | FieldReadFunction<any>,
	gateway?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PaymentListGatewaysKeySpecifier = ('checkout' | 'issuedAt' | 'issuingPrincipal' | 'recipient' | 'version' | PaymentListGatewaysKeySpecifier)[];
export type PaymentListGatewaysFieldPolicy = {
	checkout?: FieldPolicy<any> | FieldReadFunction<any>,
	issuedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	issuingPrincipal?: FieldPolicy<any> | FieldReadFunction<any>,
	recipient?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PaymentMethodDetailsKeySpecifier = ('name' | PaymentMethodDetailsKeySpecifier)[];
export type PaymentMethodDetailsFieldPolicy = {
	name?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PaymentMethodInitializeTokenizationKeySpecifier = ('data' | 'errors' | 'id' | 'result' | PaymentMethodInitializeTokenizationKeySpecifier)[];
export type PaymentMethodInitializeTokenizationFieldPolicy = {
	data?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	result?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PaymentMethodInitializeTokenizationErrorKeySpecifier = ('code' | 'field' | 'message' | PaymentMethodInitializeTokenizationErrorKeySpecifier)[];
export type PaymentMethodInitializeTokenizationErrorFieldPolicy = {
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	field?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PaymentMethodInitializeTokenizationSessionKeySpecifier = ('channel' | 'data' | 'issuedAt' | 'issuingPrincipal' | 'paymentFlowToSupport' | 'recipient' | 'user' | 'version' | PaymentMethodInitializeTokenizationSessionKeySpecifier)[];
export type PaymentMethodInitializeTokenizationSessionFieldPolicy = {
	channel?: FieldPolicy<any> | FieldReadFunction<any>,
	data?: FieldPolicy<any> | FieldReadFunction<any>,
	issuedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	issuingPrincipal?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentFlowToSupport?: FieldPolicy<any> | FieldReadFunction<any>,
	recipient?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PaymentMethodProcessTokenizationKeySpecifier = ('data' | 'errors' | 'id' | 'result' | PaymentMethodProcessTokenizationKeySpecifier)[];
export type PaymentMethodProcessTokenizationFieldPolicy = {
	data?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	result?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PaymentMethodProcessTokenizationErrorKeySpecifier = ('code' | 'field' | 'message' | PaymentMethodProcessTokenizationErrorKeySpecifier)[];
export type PaymentMethodProcessTokenizationErrorFieldPolicy = {
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	field?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PaymentMethodProcessTokenizationSessionKeySpecifier = ('channel' | 'data' | 'id' | 'issuedAt' | 'issuingPrincipal' | 'recipient' | 'user' | 'version' | PaymentMethodProcessTokenizationSessionKeySpecifier)[];
export type PaymentMethodProcessTokenizationSessionFieldPolicy = {
	channel?: FieldPolicy<any> | FieldReadFunction<any>,
	data?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	issuedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	issuingPrincipal?: FieldPolicy<any> | FieldReadFunction<any>,
	recipient?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PaymentMethodRequestDeleteErrorKeySpecifier = ('code' | 'field' | 'message' | PaymentMethodRequestDeleteErrorKeySpecifier)[];
export type PaymentMethodRequestDeleteErrorFieldPolicy = {
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	field?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PaymentProcessEventKeySpecifier = ('issuedAt' | 'issuingPrincipal' | 'payment' | 'recipient' | 'version' | PaymentProcessEventKeySpecifier)[];
export type PaymentProcessEventFieldPolicy = {
	issuedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	issuingPrincipal?: FieldPolicy<any> | FieldReadFunction<any>,
	payment?: FieldPolicy<any> | FieldReadFunction<any>,
	recipient?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PaymentRefundKeySpecifier = ('errors' | 'payment' | 'paymentErrors' | PaymentRefundKeySpecifier)[];
export type PaymentRefundFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	payment?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentErrors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PaymentRefundEventKeySpecifier = ('issuedAt' | 'issuingPrincipal' | 'payment' | 'recipient' | 'version' | PaymentRefundEventKeySpecifier)[];
export type PaymentRefundEventFieldPolicy = {
	issuedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	issuingPrincipal?: FieldPolicy<any> | FieldReadFunction<any>,
	payment?: FieldPolicy<any> | FieldReadFunction<any>,
	recipient?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PaymentSettingsKeySpecifier = ('checkoutReleaseFundsCutOffDate' | 'checkoutTtlBeforeReleasingFunds' | 'defaultTransactionFlowStrategy' | 'releaseFundsForExpiredCheckouts' | PaymentSettingsKeySpecifier)[];
export type PaymentSettingsFieldPolicy = {
	checkoutReleaseFundsCutOffDate?: FieldPolicy<any> | FieldReadFunction<any>,
	checkoutTtlBeforeReleasingFunds?: FieldPolicy<any> | FieldReadFunction<any>,
	defaultTransactionFlowStrategy?: FieldPolicy<any> | FieldReadFunction<any>,
	releaseFundsForExpiredCheckouts?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PaymentSourceKeySpecifier = ('creditCardInfo' | 'gateway' | 'metadata' | 'paymentMethodId' | PaymentSourceKeySpecifier)[];
export type PaymentSourceFieldPolicy = {
	creditCardInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	gateway?: FieldPolicy<any> | FieldReadFunction<any>,
	metadata?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentMethodId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PaymentVoidKeySpecifier = ('errors' | 'payment' | 'paymentErrors' | PaymentVoidKeySpecifier)[];
export type PaymentVoidFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	payment?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentErrors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PaymentVoidEventKeySpecifier = ('issuedAt' | 'issuingPrincipal' | 'payment' | 'recipient' | 'version' | PaymentVoidEventKeySpecifier)[];
export type PaymentVoidEventFieldPolicy = {
	issuedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	issuingPrincipal?: FieldPolicy<any> | FieldReadFunction<any>,
	payment?: FieldPolicy<any> | FieldReadFunction<any>,
	recipient?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PermissionKeySpecifier = ('code' | 'name' | PermissionKeySpecifier)[];
export type PermissionFieldPolicy = {
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PermissionGroupCreateKeySpecifier = ('errors' | 'group' | 'permissionGroupErrors' | PermissionGroupCreateKeySpecifier)[];
export type PermissionGroupCreateFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	group?: FieldPolicy<any> | FieldReadFunction<any>,
	permissionGroupErrors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PermissionGroupCreatedKeySpecifier = ('issuedAt' | 'issuingPrincipal' | 'permissionGroup' | 'recipient' | 'version' | PermissionGroupCreatedKeySpecifier)[];
export type PermissionGroupCreatedFieldPolicy = {
	issuedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	issuingPrincipal?: FieldPolicy<any> | FieldReadFunction<any>,
	permissionGroup?: FieldPolicy<any> | FieldReadFunction<any>,
	recipient?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PermissionGroupDeleteKeySpecifier = ('errors' | 'group' | 'permissionGroupErrors' | PermissionGroupDeleteKeySpecifier)[];
export type PermissionGroupDeleteFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	group?: FieldPolicy<any> | FieldReadFunction<any>,
	permissionGroupErrors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PermissionGroupDeletedKeySpecifier = ('issuedAt' | 'issuingPrincipal' | 'permissionGroup' | 'recipient' | 'version' | PermissionGroupDeletedKeySpecifier)[];
export type PermissionGroupDeletedFieldPolicy = {
	issuedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	issuingPrincipal?: FieldPolicy<any> | FieldReadFunction<any>,
	permissionGroup?: FieldPolicy<any> | FieldReadFunction<any>,
	recipient?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PermissionGroupErrorKeySpecifier = ('channels' | 'code' | 'field' | 'message' | 'permissions' | 'users' | PermissionGroupErrorKeySpecifier)[];
export type PermissionGroupErrorFieldPolicy = {
	channels?: FieldPolicy<any> | FieldReadFunction<any>,
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	field?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>,
	permissions?: FieldPolicy<any> | FieldReadFunction<any>,
	users?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PermissionGroupUpdateKeySpecifier = ('errors' | 'group' | 'permissionGroupErrors' | PermissionGroupUpdateKeySpecifier)[];
export type PermissionGroupUpdateFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	group?: FieldPolicy<any> | FieldReadFunction<any>,
	permissionGroupErrors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PermissionGroupUpdatedKeySpecifier = ('issuedAt' | 'issuingPrincipal' | 'permissionGroup' | 'recipient' | 'version' | PermissionGroupUpdatedKeySpecifier)[];
export type PermissionGroupUpdatedFieldPolicy = {
	issuedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	issuingPrincipal?: FieldPolicy<any> | FieldReadFunction<any>,
	permissionGroup?: FieldPolicy<any> | FieldReadFunction<any>,
	recipient?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PluginKeySpecifier = ('channelConfigurations' | 'description' | 'globalConfiguration' | 'id' | 'name' | PluginKeySpecifier)[];
export type PluginFieldPolicy = {
	channelConfigurations?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	globalConfiguration?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PluginConfigurationKeySpecifier = ('active' | 'channel' | 'configuration' | PluginConfigurationKeySpecifier)[];
export type PluginConfigurationFieldPolicy = {
	active?: FieldPolicy<any> | FieldReadFunction<any>,
	channel?: FieldPolicy<any> | FieldReadFunction<any>,
	configuration?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PluginCountableConnectionKeySpecifier = ('edges' | 'pageInfo' | 'totalCount' | PluginCountableConnectionKeySpecifier)[];
export type PluginCountableConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PluginCountableEdgeKeySpecifier = ('cursor' | 'node' | PluginCountableEdgeKeySpecifier)[];
export type PluginCountableEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PluginErrorKeySpecifier = ('code' | 'field' | 'message' | PluginErrorKeySpecifier)[];
export type PluginErrorFieldPolicy = {
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	field?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PluginUpdateKeySpecifier = ('errors' | 'plugin' | 'pluginsErrors' | PluginUpdateKeySpecifier)[];
export type PluginUpdateFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	plugin?: FieldPolicy<any> | FieldReadFunction<any>,
	pluginsErrors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PreorderDataKeySpecifier = ('endDate' | 'globalSoldUnits' | 'globalThreshold' | PreorderDataKeySpecifier)[];
export type PreorderDataFieldPolicy = {
	endDate?: FieldPolicy<any> | FieldReadFunction<any>,
	globalSoldUnits?: FieldPolicy<any> | FieldReadFunction<any>,
	globalThreshold?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PreorderThresholdKeySpecifier = ('quantity' | 'soldUnits' | PreorderThresholdKeySpecifier)[];
export type PreorderThresholdFieldPolicy = {
	quantity?: FieldPolicy<any> | FieldReadFunction<any>,
	soldUnits?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductKeySpecifier = ('assignedAttribute' | 'assignedAttributes' | 'attribute' | 'attributes' | 'availableForPurchase' | 'availableForPurchaseAt' | 'category' | 'channel' | 'channelListings' | 'chargeTaxes' | 'collections' | 'created' | 'defaultVariant' | 'description' | 'descriptionJson' | 'externalReference' | 'id' | 'imageById' | 'images' | 'isAvailable' | 'isAvailableForPurchase' | 'media' | 'mediaById' | 'metadata' | 'metafield' | 'metafields' | 'name' | 'pricing' | 'privateMetadata' | 'privateMetafield' | 'privateMetafields' | 'productType' | 'productVariants' | 'rating' | 'seoDescription' | 'seoTitle' | 'slug' | 'taxClass' | 'taxType' | 'thumbnail' | 'translation' | 'updatedAt' | 'variant' | 'variants' | 'weight' | ProductKeySpecifier)[];
export type ProductFieldPolicy = {
	assignedAttribute?: FieldPolicy<any> | FieldReadFunction<any>,
	assignedAttributes?: FieldPolicy<any> | FieldReadFunction<any>,
	attribute?: FieldPolicy<any> | FieldReadFunction<any>,
	attributes?: FieldPolicy<any> | FieldReadFunction<any>,
	availableForPurchase?: FieldPolicy<any> | FieldReadFunction<any>,
	availableForPurchaseAt?: FieldPolicy<any> | FieldReadFunction<any>,
	category?: FieldPolicy<any> | FieldReadFunction<any>,
	channel?: FieldPolicy<any> | FieldReadFunction<any>,
	channelListings?: FieldPolicy<any> | FieldReadFunction<any>,
	chargeTaxes?: FieldPolicy<any> | FieldReadFunction<any>,
	collections?: FieldPolicy<any> | FieldReadFunction<any>,
	created?: FieldPolicy<any> | FieldReadFunction<any>,
	defaultVariant?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	descriptionJson?: FieldPolicy<any> | FieldReadFunction<any>,
	externalReference?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	imageById?: FieldPolicy<any> | FieldReadFunction<any>,
	images?: FieldPolicy<any> | FieldReadFunction<any>,
	isAvailable?: FieldPolicy<any> | FieldReadFunction<any>,
	isAvailableForPurchase?: FieldPolicy<any> | FieldReadFunction<any>,
	media?: FieldPolicy<any> | FieldReadFunction<any>,
	mediaById?: FieldPolicy<any> | FieldReadFunction<any>,
	metadata?: FieldPolicy<any> | FieldReadFunction<any>,
	metafield?: FieldPolicy<any> | FieldReadFunction<any>,
	metafields?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	pricing?: FieldPolicy<any> | FieldReadFunction<any>,
	privateMetadata?: FieldPolicy<any> | FieldReadFunction<any>,
	privateMetafield?: FieldPolicy<any> | FieldReadFunction<any>,
	privateMetafields?: FieldPolicy<any> | FieldReadFunction<any>,
	productType?: FieldPolicy<any> | FieldReadFunction<any>,
	productVariants?: FieldPolicy<any> | FieldReadFunction<any>,
	rating?: FieldPolicy<any> | FieldReadFunction<any>,
	seoDescription?: FieldPolicy<any> | FieldReadFunction<any>,
	seoTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	slug?: FieldPolicy<any> | FieldReadFunction<any>,
	taxClass?: FieldPolicy<any> | FieldReadFunction<any>,
	taxType?: FieldPolicy<any> | FieldReadFunction<any>,
	thumbnail?: FieldPolicy<any> | FieldReadFunction<any>,
	translation?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	variant?: FieldPolicy<any> | FieldReadFunction<any>,
	variants?: FieldPolicy<any> | FieldReadFunction<any>,
	weight?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductAttributeAssignKeySpecifier = ('errors' | 'productErrors' | 'productType' | ProductAttributeAssignKeySpecifier)[];
export type ProductAttributeAssignFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	productErrors?: FieldPolicy<any> | FieldReadFunction<any>,
	productType?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductAttributeAssignmentUpdateKeySpecifier = ('errors' | 'productErrors' | 'productType' | ProductAttributeAssignmentUpdateKeySpecifier)[];
export type ProductAttributeAssignmentUpdateFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	productErrors?: FieldPolicy<any> | FieldReadFunction<any>,
	productType?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductAttributeUnassignKeySpecifier = ('errors' | 'productErrors' | 'productType' | ProductAttributeUnassignKeySpecifier)[];
export type ProductAttributeUnassignFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	productErrors?: FieldPolicy<any> | FieldReadFunction<any>,
	productType?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductBulkCreateKeySpecifier = ('count' | 'errors' | 'results' | ProductBulkCreateKeySpecifier)[];
export type ProductBulkCreateFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	results?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductBulkCreateErrorKeySpecifier = ('attributes' | 'channels' | 'code' | 'message' | 'path' | 'values' | 'warehouses' | ProductBulkCreateErrorKeySpecifier)[];
export type ProductBulkCreateErrorFieldPolicy = {
	attributes?: FieldPolicy<any> | FieldReadFunction<any>,
	channels?: FieldPolicy<any> | FieldReadFunction<any>,
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>,
	path?: FieldPolicy<any> | FieldReadFunction<any>,
	values?: FieldPolicy<any> | FieldReadFunction<any>,
	warehouses?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductBulkDeleteKeySpecifier = ('count' | 'errors' | 'productErrors' | ProductBulkDeleteKeySpecifier)[];
export type ProductBulkDeleteFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	productErrors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductBulkResultKeySpecifier = ('errors' | 'product' | ProductBulkResultKeySpecifier)[];
export type ProductBulkResultFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	product?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductBulkTranslateKeySpecifier = ('count' | 'errors' | 'results' | ProductBulkTranslateKeySpecifier)[];
export type ProductBulkTranslateFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	results?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductBulkTranslateErrorKeySpecifier = ('code' | 'message' | 'path' | ProductBulkTranslateErrorKeySpecifier)[];
export type ProductBulkTranslateErrorFieldPolicy = {
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>,
	path?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductBulkTranslateResultKeySpecifier = ('errors' | 'translation' | ProductBulkTranslateResultKeySpecifier)[];
export type ProductBulkTranslateResultFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	translation?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductChannelListingKeySpecifier = ('availableForPurchase' | 'availableForPurchaseAt' | 'channel' | 'discountedPrice' | 'id' | 'isAvailableForPurchase' | 'isPublished' | 'margin' | 'pricing' | 'publicationDate' | 'publishedAt' | 'purchaseCost' | 'visibleInListings' | ProductChannelListingKeySpecifier)[];
export type ProductChannelListingFieldPolicy = {
	availableForPurchase?: FieldPolicy<any> | FieldReadFunction<any>,
	availableForPurchaseAt?: FieldPolicy<any> | FieldReadFunction<any>,
	channel?: FieldPolicy<any> | FieldReadFunction<any>,
	discountedPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isAvailableForPurchase?: FieldPolicy<any> | FieldReadFunction<any>,
	isPublished?: FieldPolicy<any> | FieldReadFunction<any>,
	margin?: FieldPolicy<any> | FieldReadFunction<any>,
	pricing?: FieldPolicy<any> | FieldReadFunction<any>,
	publicationDate?: FieldPolicy<any> | FieldReadFunction<any>,
	publishedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	purchaseCost?: FieldPolicy<any> | FieldReadFunction<any>,
	visibleInListings?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductChannelListingErrorKeySpecifier = ('attributes' | 'channels' | 'code' | 'field' | 'message' | 'values' | 'variants' | ProductChannelListingErrorKeySpecifier)[];
export type ProductChannelListingErrorFieldPolicy = {
	attributes?: FieldPolicy<any> | FieldReadFunction<any>,
	channels?: FieldPolicy<any> | FieldReadFunction<any>,
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	field?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>,
	values?: FieldPolicy<any> | FieldReadFunction<any>,
	variants?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductChannelListingUpdateKeySpecifier = ('errors' | 'product' | 'productChannelListingErrors' | ProductChannelListingUpdateKeySpecifier)[];
export type ProductChannelListingUpdateFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	product?: FieldPolicy<any> | FieldReadFunction<any>,
	productChannelListingErrors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductCountableConnectionKeySpecifier = ('edges' | 'pageInfo' | 'totalCount' | ProductCountableConnectionKeySpecifier)[];
export type ProductCountableConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductCountableEdgeKeySpecifier = ('cursor' | 'node' | ProductCountableEdgeKeySpecifier)[];
export type ProductCountableEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductCreateKeySpecifier = ('errors' | 'product' | 'productErrors' | ProductCreateKeySpecifier)[];
export type ProductCreateFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	product?: FieldPolicy<any> | FieldReadFunction<any>,
	productErrors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductCreatedKeySpecifier = ('category' | 'issuedAt' | 'issuingPrincipal' | 'product' | 'recipient' | 'version' | ProductCreatedKeySpecifier)[];
export type ProductCreatedFieldPolicy = {
	category?: FieldPolicy<any> | FieldReadFunction<any>,
	issuedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	issuingPrincipal?: FieldPolicy<any> | FieldReadFunction<any>,
	product?: FieldPolicy<any> | FieldReadFunction<any>,
	recipient?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductDeleteKeySpecifier = ('errors' | 'product' | 'productErrors' | ProductDeleteKeySpecifier)[];
export type ProductDeleteFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	product?: FieldPolicy<any> | FieldReadFunction<any>,
	productErrors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductDeletedKeySpecifier = ('category' | 'issuedAt' | 'issuingPrincipal' | 'product' | 'recipient' | 'version' | ProductDeletedKeySpecifier)[];
export type ProductDeletedFieldPolicy = {
	category?: FieldPolicy<any> | FieldReadFunction<any>,
	issuedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	issuingPrincipal?: FieldPolicy<any> | FieldReadFunction<any>,
	product?: FieldPolicy<any> | FieldReadFunction<any>,
	recipient?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductErrorKeySpecifier = ('attributes' | 'code' | 'field' | 'message' | 'values' | ProductErrorKeySpecifier)[];
export type ProductErrorFieldPolicy = {
	attributes?: FieldPolicy<any> | FieldReadFunction<any>,
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	field?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>,
	values?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductExportCompletedKeySpecifier = ('export' | 'issuedAt' | 'issuingPrincipal' | 'recipient' | 'version' | ProductExportCompletedKeySpecifier)[];
export type ProductExportCompletedFieldPolicy = {
	export?: FieldPolicy<any> | FieldReadFunction<any>,
	issuedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	issuingPrincipal?: FieldPolicy<any> | FieldReadFunction<any>,
	recipient?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductImageKeySpecifier = ('alt' | 'id' | 'sortOrder' | 'url' | ProductImageKeySpecifier)[];
export type ProductImageFieldPolicy = {
	alt?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	sortOrder?: FieldPolicy<any> | FieldReadFunction<any>,
	url?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductMediaKeySpecifier = ('alt' | 'id' | 'metadata' | 'metafield' | 'metafields' | 'oembedData' | 'privateMetadata' | 'privateMetafield' | 'privateMetafields' | 'productId' | 'sortOrder' | 'type' | 'url' | ProductMediaKeySpecifier)[];
export type ProductMediaFieldPolicy = {
	alt?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	metadata?: FieldPolicy<any> | FieldReadFunction<any>,
	metafield?: FieldPolicy<any> | FieldReadFunction<any>,
	metafields?: FieldPolicy<any> | FieldReadFunction<any>,
	oembedData?: FieldPolicy<any> | FieldReadFunction<any>,
	privateMetadata?: FieldPolicy<any> | FieldReadFunction<any>,
	privateMetafield?: FieldPolicy<any> | FieldReadFunction<any>,
	privateMetafields?: FieldPolicy<any> | FieldReadFunction<any>,
	productId?: FieldPolicy<any> | FieldReadFunction<any>,
	sortOrder?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	url?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductMediaBulkDeleteKeySpecifier = ('count' | 'errors' | 'productErrors' | ProductMediaBulkDeleteKeySpecifier)[];
export type ProductMediaBulkDeleteFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	productErrors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductMediaCreateKeySpecifier = ('errors' | 'media' | 'product' | 'productErrors' | ProductMediaCreateKeySpecifier)[];
export type ProductMediaCreateFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	media?: FieldPolicy<any> | FieldReadFunction<any>,
	product?: FieldPolicy<any> | FieldReadFunction<any>,
	productErrors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductMediaCreatedKeySpecifier = ('issuedAt' | 'issuingPrincipal' | 'productMedia' | 'recipient' | 'version' | ProductMediaCreatedKeySpecifier)[];
export type ProductMediaCreatedFieldPolicy = {
	issuedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	issuingPrincipal?: FieldPolicy<any> | FieldReadFunction<any>,
	productMedia?: FieldPolicy<any> | FieldReadFunction<any>,
	recipient?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductMediaDeleteKeySpecifier = ('errors' | 'media' | 'product' | 'productErrors' | ProductMediaDeleteKeySpecifier)[];
export type ProductMediaDeleteFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	media?: FieldPolicy<any> | FieldReadFunction<any>,
	product?: FieldPolicy<any> | FieldReadFunction<any>,
	productErrors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductMediaDeletedKeySpecifier = ('issuedAt' | 'issuingPrincipal' | 'productMedia' | 'recipient' | 'version' | ProductMediaDeletedKeySpecifier)[];
export type ProductMediaDeletedFieldPolicy = {
	issuedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	issuingPrincipal?: FieldPolicy<any> | FieldReadFunction<any>,
	productMedia?: FieldPolicy<any> | FieldReadFunction<any>,
	recipient?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductMediaReorderKeySpecifier = ('errors' | 'media' | 'product' | 'productErrors' | ProductMediaReorderKeySpecifier)[];
export type ProductMediaReorderFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	media?: FieldPolicy<any> | FieldReadFunction<any>,
	product?: FieldPolicy<any> | FieldReadFunction<any>,
	productErrors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductMediaUpdateKeySpecifier = ('errors' | 'media' | 'product' | 'productErrors' | ProductMediaUpdateKeySpecifier)[];
export type ProductMediaUpdateFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	media?: FieldPolicy<any> | FieldReadFunction<any>,
	product?: FieldPolicy<any> | FieldReadFunction<any>,
	productErrors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductMediaUpdatedKeySpecifier = ('issuedAt' | 'issuingPrincipal' | 'productMedia' | 'recipient' | 'version' | ProductMediaUpdatedKeySpecifier)[];
export type ProductMediaUpdatedFieldPolicy = {
	issuedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	issuingPrincipal?: FieldPolicy<any> | FieldReadFunction<any>,
	productMedia?: FieldPolicy<any> | FieldReadFunction<any>,
	recipient?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductMetadataUpdatedKeySpecifier = ('category' | 'issuedAt' | 'issuingPrincipal' | 'product' | 'recipient' | 'version' | ProductMetadataUpdatedKeySpecifier)[];
export type ProductMetadataUpdatedFieldPolicy = {
	category?: FieldPolicy<any> | FieldReadFunction<any>,
	issuedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	issuingPrincipal?: FieldPolicy<any> | FieldReadFunction<any>,
	product?: FieldPolicy<any> | FieldReadFunction<any>,
	recipient?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductPricingInfoKeySpecifier = ('discount' | 'discountLocalCurrency' | 'discountPrior' | 'displayGrossPrices' | 'onSale' | 'priceRange' | 'priceRangeLocalCurrency' | 'priceRangePrior' | 'priceRangeUndiscounted' | ProductPricingInfoKeySpecifier)[];
export type ProductPricingInfoFieldPolicy = {
	discount?: FieldPolicy<any> | FieldReadFunction<any>,
	discountLocalCurrency?: FieldPolicy<any> | FieldReadFunction<any>,
	discountPrior?: FieldPolicy<any> | FieldReadFunction<any>,
	displayGrossPrices?: FieldPolicy<any> | FieldReadFunction<any>,
	onSale?: FieldPolicy<any> | FieldReadFunction<any>,
	priceRange?: FieldPolicy<any> | FieldReadFunction<any>,
	priceRangeLocalCurrency?: FieldPolicy<any> | FieldReadFunction<any>,
	priceRangePrior?: FieldPolicy<any> | FieldReadFunction<any>,
	priceRangeUndiscounted?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductReorderAttributeValuesKeySpecifier = ('errors' | 'product' | 'productErrors' | ProductReorderAttributeValuesKeySpecifier)[];
export type ProductReorderAttributeValuesFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	product?: FieldPolicy<any> | FieldReadFunction<any>,
	productErrors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductTranslatableContentKeySpecifier = ('attributeValues' | 'description' | 'descriptionJson' | 'id' | 'name' | 'product' | 'productId' | 'seoDescription' | 'seoTitle' | 'slug' | 'translation' | ProductTranslatableContentKeySpecifier)[];
export type ProductTranslatableContentFieldPolicy = {
	attributeValues?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	descriptionJson?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	product?: FieldPolicy<any> | FieldReadFunction<any>,
	productId?: FieldPolicy<any> | FieldReadFunction<any>,
	seoDescription?: FieldPolicy<any> | FieldReadFunction<any>,
	seoTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	slug?: FieldPolicy<any> | FieldReadFunction<any>,
	translation?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductTranslateKeySpecifier = ('errors' | 'product' | 'translationErrors' | ProductTranslateKeySpecifier)[];
export type ProductTranslateFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	product?: FieldPolicy<any> | FieldReadFunction<any>,
	translationErrors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductTranslationKeySpecifier = ('description' | 'descriptionJson' | 'id' | 'language' | 'name' | 'seoDescription' | 'seoTitle' | 'slug' | 'translatableContent' | ProductTranslationKeySpecifier)[];
export type ProductTranslationFieldPolicy = {
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	descriptionJson?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	language?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	seoDescription?: FieldPolicy<any> | FieldReadFunction<any>,
	seoTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	slug?: FieldPolicy<any> | FieldReadFunction<any>,
	translatableContent?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductTypeKeySpecifier = ('assignedVariantAttributes' | 'availableAttributes' | 'hasVariants' | 'id' | 'isDigital' | 'isShippingRequired' | 'kind' | 'metadata' | 'metafield' | 'metafields' | 'name' | 'privateMetadata' | 'privateMetafield' | 'privateMetafields' | 'productAttributes' | 'products' | 'slug' | 'taxClass' | 'taxType' | 'variantAttributes' | 'weight' | ProductTypeKeySpecifier)[];
export type ProductTypeFieldPolicy = {
	assignedVariantAttributes?: FieldPolicy<any> | FieldReadFunction<any>,
	availableAttributes?: FieldPolicy<any> | FieldReadFunction<any>,
	hasVariants?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isDigital?: FieldPolicy<any> | FieldReadFunction<any>,
	isShippingRequired?: FieldPolicy<any> | FieldReadFunction<any>,
	kind?: FieldPolicy<any> | FieldReadFunction<any>,
	metadata?: FieldPolicy<any> | FieldReadFunction<any>,
	metafield?: FieldPolicy<any> | FieldReadFunction<any>,
	metafields?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	privateMetadata?: FieldPolicy<any> | FieldReadFunction<any>,
	privateMetafield?: FieldPolicy<any> | FieldReadFunction<any>,
	privateMetafields?: FieldPolicy<any> | FieldReadFunction<any>,
	productAttributes?: FieldPolicy<any> | FieldReadFunction<any>,
	products?: FieldPolicy<any> | FieldReadFunction<any>,
	slug?: FieldPolicy<any> | FieldReadFunction<any>,
	taxClass?: FieldPolicy<any> | FieldReadFunction<any>,
	taxType?: FieldPolicy<any> | FieldReadFunction<any>,
	variantAttributes?: FieldPolicy<any> | FieldReadFunction<any>,
	weight?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductTypeBulkDeleteKeySpecifier = ('count' | 'errors' | 'productErrors' | ProductTypeBulkDeleteKeySpecifier)[];
export type ProductTypeBulkDeleteFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	productErrors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductTypeCountableConnectionKeySpecifier = ('edges' | 'pageInfo' | 'totalCount' | ProductTypeCountableConnectionKeySpecifier)[];
export type ProductTypeCountableConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductTypeCountableEdgeKeySpecifier = ('cursor' | 'node' | ProductTypeCountableEdgeKeySpecifier)[];
export type ProductTypeCountableEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductTypeCreateKeySpecifier = ('errors' | 'productErrors' | 'productType' | ProductTypeCreateKeySpecifier)[];
export type ProductTypeCreateFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	productErrors?: FieldPolicy<any> | FieldReadFunction<any>,
	productType?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductTypeDeleteKeySpecifier = ('errors' | 'productErrors' | 'productType' | ProductTypeDeleteKeySpecifier)[];
export type ProductTypeDeleteFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	productErrors?: FieldPolicy<any> | FieldReadFunction<any>,
	productType?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductTypeReorderAttributesKeySpecifier = ('errors' | 'productErrors' | 'productType' | ProductTypeReorderAttributesKeySpecifier)[];
export type ProductTypeReorderAttributesFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	productErrors?: FieldPolicy<any> | FieldReadFunction<any>,
	productType?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductTypeUpdateKeySpecifier = ('errors' | 'productErrors' | 'productType' | ProductTypeUpdateKeySpecifier)[];
export type ProductTypeUpdateFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	productErrors?: FieldPolicy<any> | FieldReadFunction<any>,
	productType?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductUpdateKeySpecifier = ('errors' | 'product' | 'productErrors' | ProductUpdateKeySpecifier)[];
export type ProductUpdateFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	product?: FieldPolicy<any> | FieldReadFunction<any>,
	productErrors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductUpdatedKeySpecifier = ('category' | 'issuedAt' | 'issuingPrincipal' | 'product' | 'recipient' | 'version' | ProductUpdatedKeySpecifier)[];
export type ProductUpdatedFieldPolicy = {
	category?: FieldPolicy<any> | FieldReadFunction<any>,
	issuedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	issuingPrincipal?: FieldPolicy<any> | FieldReadFunction<any>,
	product?: FieldPolicy<any> | FieldReadFunction<any>,
	recipient?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductVariantKeySpecifier = ('assignedAttribute' | 'assignedAttributes' | 'attributes' | 'channel' | 'channelListings' | 'created' | 'digitalContent' | 'externalReference' | 'id' | 'images' | 'margin' | 'media' | 'metadata' | 'metafield' | 'metafields' | 'name' | 'preorder' | 'pricing' | 'privateMetadata' | 'privateMetafield' | 'privateMetafields' | 'product' | 'quantityAvailable' | 'quantityLimitPerCustomer' | 'quantityOrdered' | 'revenue' | 'sku' | 'stocks' | 'trackInventory' | 'translation' | 'updatedAt' | 'weight' | ProductVariantKeySpecifier)[];
export type ProductVariantFieldPolicy = {
	assignedAttribute?: FieldPolicy<any> | FieldReadFunction<any>,
	assignedAttributes?: FieldPolicy<any> | FieldReadFunction<any>,
	attributes?: FieldPolicy<any> | FieldReadFunction<any>,
	channel?: FieldPolicy<any> | FieldReadFunction<any>,
	channelListings?: FieldPolicy<any> | FieldReadFunction<any>,
	created?: FieldPolicy<any> | FieldReadFunction<any>,
	digitalContent?: FieldPolicy<any> | FieldReadFunction<any>,
	externalReference?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	images?: FieldPolicy<any> | FieldReadFunction<any>,
	margin?: FieldPolicy<any> | FieldReadFunction<any>,
	media?: FieldPolicy<any> | FieldReadFunction<any>,
	metadata?: FieldPolicy<any> | FieldReadFunction<any>,
	metafield?: FieldPolicy<any> | FieldReadFunction<any>,
	metafields?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	preorder?: FieldPolicy<any> | FieldReadFunction<any>,
	pricing?: FieldPolicy<any> | FieldReadFunction<any>,
	privateMetadata?: FieldPolicy<any> | FieldReadFunction<any>,
	privateMetafield?: FieldPolicy<any> | FieldReadFunction<any>,
	privateMetafields?: FieldPolicy<any> | FieldReadFunction<any>,
	product?: FieldPolicy<any> | FieldReadFunction<any>,
	quantityAvailable?: FieldPolicy<any> | FieldReadFunction<any>,
	quantityLimitPerCustomer?: FieldPolicy<any> | FieldReadFunction<any>,
	quantityOrdered?: FieldPolicy<any> | FieldReadFunction<any>,
	revenue?: FieldPolicy<any> | FieldReadFunction<any>,
	sku?: FieldPolicy<any> | FieldReadFunction<any>,
	stocks?: FieldPolicy<any> | FieldReadFunction<any>,
	trackInventory?: FieldPolicy<any> | FieldReadFunction<any>,
	translation?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	weight?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductVariantBackInStockKeySpecifier = ('issuedAt' | 'issuingPrincipal' | 'productVariant' | 'recipient' | 'version' | 'warehouse' | ProductVariantBackInStockKeySpecifier)[];
export type ProductVariantBackInStockFieldPolicy = {
	issuedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	issuingPrincipal?: FieldPolicy<any> | FieldReadFunction<any>,
	productVariant?: FieldPolicy<any> | FieldReadFunction<any>,
	recipient?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>,
	warehouse?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductVariantBulkCreateKeySpecifier = ('bulkProductErrors' | 'count' | 'errors' | 'productVariants' | 'results' | ProductVariantBulkCreateKeySpecifier)[];
export type ProductVariantBulkCreateFieldPolicy = {
	bulkProductErrors?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	productVariants?: FieldPolicy<any> | FieldReadFunction<any>,
	results?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductVariantBulkDeleteKeySpecifier = ('count' | 'errors' | 'productErrors' | ProductVariantBulkDeleteKeySpecifier)[];
export type ProductVariantBulkDeleteFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	productErrors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductVariantBulkErrorKeySpecifier = ('attributes' | 'channelListings' | 'channels' | 'code' | 'field' | 'message' | 'path' | 'stocks' | 'values' | 'warehouses' | ProductVariantBulkErrorKeySpecifier)[];
export type ProductVariantBulkErrorFieldPolicy = {
	attributes?: FieldPolicy<any> | FieldReadFunction<any>,
	channelListings?: FieldPolicy<any> | FieldReadFunction<any>,
	channels?: FieldPolicy<any> | FieldReadFunction<any>,
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	field?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>,
	path?: FieldPolicy<any> | FieldReadFunction<any>,
	stocks?: FieldPolicy<any> | FieldReadFunction<any>,
	values?: FieldPolicy<any> | FieldReadFunction<any>,
	warehouses?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductVariantBulkResultKeySpecifier = ('errors' | 'productVariant' | ProductVariantBulkResultKeySpecifier)[];
export type ProductVariantBulkResultFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	productVariant?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductVariantBulkTranslateKeySpecifier = ('count' | 'errors' | 'results' | ProductVariantBulkTranslateKeySpecifier)[];
export type ProductVariantBulkTranslateFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	results?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductVariantBulkTranslateErrorKeySpecifier = ('code' | 'message' | 'path' | ProductVariantBulkTranslateErrorKeySpecifier)[];
export type ProductVariantBulkTranslateErrorFieldPolicy = {
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>,
	path?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductVariantBulkTranslateResultKeySpecifier = ('errors' | 'translation' | ProductVariantBulkTranslateResultKeySpecifier)[];
export type ProductVariantBulkTranslateResultFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	translation?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductVariantBulkUpdateKeySpecifier = ('count' | 'errors' | 'results' | ProductVariantBulkUpdateKeySpecifier)[];
export type ProductVariantBulkUpdateFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	results?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductVariantChannelListingKeySpecifier = ('channel' | 'costPrice' | 'id' | 'margin' | 'preorderThreshold' | 'price' | 'priorPrice' | ProductVariantChannelListingKeySpecifier)[];
export type ProductVariantChannelListingFieldPolicy = {
	channel?: FieldPolicy<any> | FieldReadFunction<any>,
	costPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	margin?: FieldPolicy<any> | FieldReadFunction<any>,
	preorderThreshold?: FieldPolicy<any> | FieldReadFunction<any>,
	price?: FieldPolicy<any> | FieldReadFunction<any>,
	priorPrice?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductVariantChannelListingUpdateKeySpecifier = ('errors' | 'productChannelListingErrors' | 'variant' | ProductVariantChannelListingUpdateKeySpecifier)[];
export type ProductVariantChannelListingUpdateFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	productChannelListingErrors?: FieldPolicy<any> | FieldReadFunction<any>,
	variant?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductVariantCountableConnectionKeySpecifier = ('edges' | 'pageInfo' | 'totalCount' | ProductVariantCountableConnectionKeySpecifier)[];
export type ProductVariantCountableConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductVariantCountableEdgeKeySpecifier = ('cursor' | 'node' | ProductVariantCountableEdgeKeySpecifier)[];
export type ProductVariantCountableEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductVariantCreateKeySpecifier = ('errors' | 'productErrors' | 'productVariant' | ProductVariantCreateKeySpecifier)[];
export type ProductVariantCreateFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	productErrors?: FieldPolicy<any> | FieldReadFunction<any>,
	productVariant?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductVariantCreatedKeySpecifier = ('issuedAt' | 'issuingPrincipal' | 'productVariant' | 'recipient' | 'version' | ProductVariantCreatedKeySpecifier)[];
export type ProductVariantCreatedFieldPolicy = {
	issuedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	issuingPrincipal?: FieldPolicy<any> | FieldReadFunction<any>,
	productVariant?: FieldPolicy<any> | FieldReadFunction<any>,
	recipient?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductVariantDeleteKeySpecifier = ('errors' | 'productErrors' | 'productVariant' | ProductVariantDeleteKeySpecifier)[];
export type ProductVariantDeleteFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	productErrors?: FieldPolicy<any> | FieldReadFunction<any>,
	productVariant?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductVariantDeletedKeySpecifier = ('issuedAt' | 'issuingPrincipal' | 'productVariant' | 'recipient' | 'version' | ProductVariantDeletedKeySpecifier)[];
export type ProductVariantDeletedFieldPolicy = {
	issuedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	issuingPrincipal?: FieldPolicy<any> | FieldReadFunction<any>,
	productVariant?: FieldPolicy<any> | FieldReadFunction<any>,
	recipient?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductVariantDiscountedPriceUpdatedKeySpecifier = ('channel' | 'issuedAt' | 'issuingPrincipal' | 'newPrice' | 'previousPrice' | 'productVariant' | 'recipient' | 'version' | ProductVariantDiscountedPriceUpdatedKeySpecifier)[];
export type ProductVariantDiscountedPriceUpdatedFieldPolicy = {
	channel?: FieldPolicy<any> | FieldReadFunction<any>,
	issuedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	issuingPrincipal?: FieldPolicy<any> | FieldReadFunction<any>,
	newPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	previousPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	productVariant?: FieldPolicy<any> | FieldReadFunction<any>,
	recipient?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductVariantMetadataUpdatedKeySpecifier = ('issuedAt' | 'issuingPrincipal' | 'productVariant' | 'recipient' | 'version' | ProductVariantMetadataUpdatedKeySpecifier)[];
export type ProductVariantMetadataUpdatedFieldPolicy = {
	issuedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	issuingPrincipal?: FieldPolicy<any> | FieldReadFunction<any>,
	productVariant?: FieldPolicy<any> | FieldReadFunction<any>,
	recipient?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductVariantOutOfStockKeySpecifier = ('issuedAt' | 'issuingPrincipal' | 'productVariant' | 'recipient' | 'version' | 'warehouse' | ProductVariantOutOfStockKeySpecifier)[];
export type ProductVariantOutOfStockFieldPolicy = {
	issuedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	issuingPrincipal?: FieldPolicy<any> | FieldReadFunction<any>,
	productVariant?: FieldPolicy<any> | FieldReadFunction<any>,
	recipient?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>,
	warehouse?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductVariantPreorderDeactivateKeySpecifier = ('errors' | 'productVariant' | ProductVariantPreorderDeactivateKeySpecifier)[];
export type ProductVariantPreorderDeactivateFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	productVariant?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductVariantReorderKeySpecifier = ('errors' | 'product' | 'productErrors' | ProductVariantReorderKeySpecifier)[];
export type ProductVariantReorderFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	product?: FieldPolicy<any> | FieldReadFunction<any>,
	productErrors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductVariantReorderAttributeValuesKeySpecifier = ('errors' | 'productErrors' | 'productVariant' | ProductVariantReorderAttributeValuesKeySpecifier)[];
export type ProductVariantReorderAttributeValuesFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	productErrors?: FieldPolicy<any> | FieldReadFunction<any>,
	productVariant?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductVariantSetDefaultKeySpecifier = ('errors' | 'product' | 'productErrors' | ProductVariantSetDefaultKeySpecifier)[];
export type ProductVariantSetDefaultFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	product?: FieldPolicy<any> | FieldReadFunction<any>,
	productErrors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductVariantStockUpdatedKeySpecifier = ('issuedAt' | 'issuingPrincipal' | 'productVariant' | 'recipient' | 'version' | 'warehouse' | ProductVariantStockUpdatedKeySpecifier)[];
export type ProductVariantStockUpdatedFieldPolicy = {
	issuedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	issuingPrincipal?: FieldPolicy<any> | FieldReadFunction<any>,
	productVariant?: FieldPolicy<any> | FieldReadFunction<any>,
	recipient?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>,
	warehouse?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductVariantStocksCreateKeySpecifier = ('bulkStockErrors' | 'errors' | 'productVariant' | ProductVariantStocksCreateKeySpecifier)[];
export type ProductVariantStocksCreateFieldPolicy = {
	bulkStockErrors?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	productVariant?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductVariantStocksDeleteKeySpecifier = ('errors' | 'productVariant' | 'stockErrors' | ProductVariantStocksDeleteKeySpecifier)[];
export type ProductVariantStocksDeleteFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	productVariant?: FieldPolicy<any> | FieldReadFunction<any>,
	stockErrors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductVariantStocksUpdateKeySpecifier = ('bulkStockErrors' | 'errors' | 'productVariant' | ProductVariantStocksUpdateKeySpecifier)[];
export type ProductVariantStocksUpdateFieldPolicy = {
	bulkStockErrors?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	productVariant?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductVariantTranslatableContentKeySpecifier = ('attributeValues' | 'id' | 'name' | 'productVariant' | 'productVariantId' | 'translation' | ProductVariantTranslatableContentKeySpecifier)[];
export type ProductVariantTranslatableContentFieldPolicy = {
	attributeValues?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	productVariant?: FieldPolicy<any> | FieldReadFunction<any>,
	productVariantId?: FieldPolicy<any> | FieldReadFunction<any>,
	translation?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductVariantTranslateKeySpecifier = ('errors' | 'productVariant' | 'translationErrors' | ProductVariantTranslateKeySpecifier)[];
export type ProductVariantTranslateFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	productVariant?: FieldPolicy<any> | FieldReadFunction<any>,
	translationErrors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductVariantTranslationKeySpecifier = ('id' | 'language' | 'name' | 'translatableContent' | ProductVariantTranslationKeySpecifier)[];
export type ProductVariantTranslationFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	language?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	translatableContent?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductVariantUpdateKeySpecifier = ('errors' | 'productErrors' | 'productVariant' | ProductVariantUpdateKeySpecifier)[];
export type ProductVariantUpdateFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	productErrors?: FieldPolicy<any> | FieldReadFunction<any>,
	productVariant?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductVariantUpdatedKeySpecifier = ('issuedAt' | 'issuingPrincipal' | 'productVariant' | 'recipient' | 'version' | ProductVariantUpdatedKeySpecifier)[];
export type ProductVariantUpdatedFieldPolicy = {
	issuedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	issuingPrincipal?: FieldPolicy<any> | FieldReadFunction<any>,
	productVariant?: FieldPolicy<any> | FieldReadFunction<any>,
	recipient?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PromotionKeySpecifier = ('createdAt' | 'description' | 'endDate' | 'events' | 'id' | 'metadata' | 'metafield' | 'metafields' | 'name' | 'privateMetadata' | 'privateMetafield' | 'privateMetafields' | 'rules' | 'startDate' | 'translation' | 'type' | 'updatedAt' | PromotionKeySpecifier)[];
export type PromotionFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	endDate?: FieldPolicy<any> | FieldReadFunction<any>,
	events?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	metadata?: FieldPolicy<any> | FieldReadFunction<any>,
	metafield?: FieldPolicy<any> | FieldReadFunction<any>,
	metafields?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	privateMetadata?: FieldPolicy<any> | FieldReadFunction<any>,
	privateMetafield?: FieldPolicy<any> | FieldReadFunction<any>,
	privateMetafields?: FieldPolicy<any> | FieldReadFunction<any>,
	rules?: FieldPolicy<any> | FieldReadFunction<any>,
	startDate?: FieldPolicy<any> | FieldReadFunction<any>,
	translation?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PromotionBulkDeleteKeySpecifier = ('count' | 'errors' | PromotionBulkDeleteKeySpecifier)[];
export type PromotionBulkDeleteFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PromotionCountableConnectionKeySpecifier = ('edges' | 'pageInfo' | 'totalCount' | PromotionCountableConnectionKeySpecifier)[];
export type PromotionCountableConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PromotionCountableEdgeKeySpecifier = ('cursor' | 'node' | PromotionCountableEdgeKeySpecifier)[];
export type PromotionCountableEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PromotionCreateKeySpecifier = ('errors' | 'promotion' | PromotionCreateKeySpecifier)[];
export type PromotionCreateFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	promotion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PromotionCreateErrorKeySpecifier = ('code' | 'field' | 'giftsLimit' | 'giftsLimitExceedBy' | 'index' | 'message' | 'rulesLimit' | 'rulesLimitExceedBy' | PromotionCreateErrorKeySpecifier)[];
export type PromotionCreateErrorFieldPolicy = {
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	field?: FieldPolicy<any> | FieldReadFunction<any>,
	giftsLimit?: FieldPolicy<any> | FieldReadFunction<any>,
	giftsLimitExceedBy?: FieldPolicy<any> | FieldReadFunction<any>,
	index?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>,
	rulesLimit?: FieldPolicy<any> | FieldReadFunction<any>,
	rulesLimitExceedBy?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PromotionCreatedKeySpecifier = ('issuedAt' | 'issuingPrincipal' | 'promotion' | 'recipient' | 'version' | PromotionCreatedKeySpecifier)[];
export type PromotionCreatedFieldPolicy = {
	issuedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	issuingPrincipal?: FieldPolicy<any> | FieldReadFunction<any>,
	promotion?: FieldPolicy<any> | FieldReadFunction<any>,
	recipient?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PromotionCreatedEventKeySpecifier = ('createdBy' | 'date' | 'id' | 'type' | PromotionCreatedEventKeySpecifier)[];
export type PromotionCreatedEventFieldPolicy = {
	createdBy?: FieldPolicy<any> | FieldReadFunction<any>,
	date?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PromotionDeleteKeySpecifier = ('errors' | 'promotion' | PromotionDeleteKeySpecifier)[];
export type PromotionDeleteFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	promotion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PromotionDeleteErrorKeySpecifier = ('code' | 'field' | 'message' | PromotionDeleteErrorKeySpecifier)[];
export type PromotionDeleteErrorFieldPolicy = {
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	field?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PromotionDeletedKeySpecifier = ('issuedAt' | 'issuingPrincipal' | 'promotion' | 'recipient' | 'version' | PromotionDeletedKeySpecifier)[];
export type PromotionDeletedFieldPolicy = {
	issuedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	issuingPrincipal?: FieldPolicy<any> | FieldReadFunction<any>,
	promotion?: FieldPolicy<any> | FieldReadFunction<any>,
	recipient?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PromotionEndedKeySpecifier = ('issuedAt' | 'issuingPrincipal' | 'promotion' | 'recipient' | 'version' | PromotionEndedKeySpecifier)[];
export type PromotionEndedFieldPolicy = {
	issuedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	issuingPrincipal?: FieldPolicy<any> | FieldReadFunction<any>,
	promotion?: FieldPolicy<any> | FieldReadFunction<any>,
	recipient?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PromotionEndedEventKeySpecifier = ('createdBy' | 'date' | 'id' | 'type' | PromotionEndedEventKeySpecifier)[];
export type PromotionEndedEventFieldPolicy = {
	createdBy?: FieldPolicy<any> | FieldReadFunction<any>,
	date?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PromotionEventInterfaceKeySpecifier = ('createdBy' | 'date' | 'id' | 'type' | PromotionEventInterfaceKeySpecifier)[];
export type PromotionEventInterfaceFieldPolicy = {
	createdBy?: FieldPolicy<any> | FieldReadFunction<any>,
	date?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PromotionRuleKeySpecifier = ('cataloguePredicate' | 'channels' | 'description' | 'giftIds' | 'giftsLimit' | 'id' | 'name' | 'orderPredicate' | 'predicateType' | 'promotion' | 'rewardType' | 'rewardValue' | 'rewardValueType' | 'translation' | PromotionRuleKeySpecifier)[];
export type PromotionRuleFieldPolicy = {
	cataloguePredicate?: FieldPolicy<any> | FieldReadFunction<any>,
	channels?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	giftIds?: FieldPolicy<any> | FieldReadFunction<any>,
	giftsLimit?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	orderPredicate?: FieldPolicy<any> | FieldReadFunction<any>,
	predicateType?: FieldPolicy<any> | FieldReadFunction<any>,
	promotion?: FieldPolicy<any> | FieldReadFunction<any>,
	rewardType?: FieldPolicy<any> | FieldReadFunction<any>,
	rewardValue?: FieldPolicy<any> | FieldReadFunction<any>,
	rewardValueType?: FieldPolicy<any> | FieldReadFunction<any>,
	translation?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PromotionRuleCreateKeySpecifier = ('errors' | 'promotionRule' | PromotionRuleCreateKeySpecifier)[];
export type PromotionRuleCreateFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	promotionRule?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PromotionRuleCreateErrorKeySpecifier = ('code' | 'field' | 'giftsLimit' | 'giftsLimitExceedBy' | 'message' | 'rulesLimit' | 'rulesLimitExceedBy' | PromotionRuleCreateErrorKeySpecifier)[];
export type PromotionRuleCreateErrorFieldPolicy = {
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	field?: FieldPolicy<any> | FieldReadFunction<any>,
	giftsLimit?: FieldPolicy<any> | FieldReadFunction<any>,
	giftsLimitExceedBy?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>,
	rulesLimit?: FieldPolicy<any> | FieldReadFunction<any>,
	rulesLimitExceedBy?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PromotionRuleCreatedKeySpecifier = ('issuedAt' | 'issuingPrincipal' | 'promotionRule' | 'recipient' | 'version' | PromotionRuleCreatedKeySpecifier)[];
export type PromotionRuleCreatedFieldPolicy = {
	issuedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	issuingPrincipal?: FieldPolicy<any> | FieldReadFunction<any>,
	promotionRule?: FieldPolicy<any> | FieldReadFunction<any>,
	recipient?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PromotionRuleCreatedEventKeySpecifier = ('createdBy' | 'date' | 'id' | 'ruleId' | 'type' | PromotionRuleCreatedEventKeySpecifier)[];
export type PromotionRuleCreatedEventFieldPolicy = {
	createdBy?: FieldPolicy<any> | FieldReadFunction<any>,
	date?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	ruleId?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PromotionRuleDeleteKeySpecifier = ('errors' | 'promotionRule' | PromotionRuleDeleteKeySpecifier)[];
export type PromotionRuleDeleteFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	promotionRule?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PromotionRuleDeleteErrorKeySpecifier = ('code' | 'field' | 'message' | PromotionRuleDeleteErrorKeySpecifier)[];
export type PromotionRuleDeleteErrorFieldPolicy = {
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	field?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PromotionRuleDeletedKeySpecifier = ('issuedAt' | 'issuingPrincipal' | 'promotionRule' | 'recipient' | 'version' | PromotionRuleDeletedKeySpecifier)[];
export type PromotionRuleDeletedFieldPolicy = {
	issuedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	issuingPrincipal?: FieldPolicy<any> | FieldReadFunction<any>,
	promotionRule?: FieldPolicy<any> | FieldReadFunction<any>,
	recipient?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PromotionRuleDeletedEventKeySpecifier = ('createdBy' | 'date' | 'id' | 'ruleId' | 'type' | PromotionRuleDeletedEventKeySpecifier)[];
export type PromotionRuleDeletedEventFieldPolicy = {
	createdBy?: FieldPolicy<any> | FieldReadFunction<any>,
	date?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	ruleId?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PromotionRuleEventInterfaceKeySpecifier = ('ruleId' | PromotionRuleEventInterfaceKeySpecifier)[];
export type PromotionRuleEventInterfaceFieldPolicy = {
	ruleId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PromotionRuleTranslatableContentKeySpecifier = ('description' | 'id' | 'name' | 'promotionRuleId' | 'translation' | PromotionRuleTranslatableContentKeySpecifier)[];
export type PromotionRuleTranslatableContentFieldPolicy = {
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	promotionRuleId?: FieldPolicy<any> | FieldReadFunction<any>,
	translation?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PromotionRuleTranslateKeySpecifier = ('errors' | 'promotionRule' | PromotionRuleTranslateKeySpecifier)[];
export type PromotionRuleTranslateFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	promotionRule?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PromotionRuleTranslationKeySpecifier = ('description' | 'id' | 'language' | 'name' | 'translatableContent' | PromotionRuleTranslationKeySpecifier)[];
export type PromotionRuleTranslationFieldPolicy = {
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	language?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	translatableContent?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PromotionRuleUpdateKeySpecifier = ('errors' | 'promotionRule' | PromotionRuleUpdateKeySpecifier)[];
export type PromotionRuleUpdateFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	promotionRule?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PromotionRuleUpdateErrorKeySpecifier = ('channels' | 'code' | 'field' | 'giftsLimit' | 'giftsLimitExceedBy' | 'message' | PromotionRuleUpdateErrorKeySpecifier)[];
export type PromotionRuleUpdateErrorFieldPolicy = {
	channels?: FieldPolicy<any> | FieldReadFunction<any>,
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	field?: FieldPolicy<any> | FieldReadFunction<any>,
	giftsLimit?: FieldPolicy<any> | FieldReadFunction<any>,
	giftsLimitExceedBy?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PromotionRuleUpdatedKeySpecifier = ('issuedAt' | 'issuingPrincipal' | 'promotionRule' | 'recipient' | 'version' | PromotionRuleUpdatedKeySpecifier)[];
export type PromotionRuleUpdatedFieldPolicy = {
	issuedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	issuingPrincipal?: FieldPolicy<any> | FieldReadFunction<any>,
	promotionRule?: FieldPolicy<any> | FieldReadFunction<any>,
	recipient?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PromotionRuleUpdatedEventKeySpecifier = ('createdBy' | 'date' | 'id' | 'ruleId' | 'type' | PromotionRuleUpdatedEventKeySpecifier)[];
export type PromotionRuleUpdatedEventFieldPolicy = {
	createdBy?: FieldPolicy<any> | FieldReadFunction<any>,
	date?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	ruleId?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PromotionStartedKeySpecifier = ('issuedAt' | 'issuingPrincipal' | 'promotion' | 'recipient' | 'version' | PromotionStartedKeySpecifier)[];
export type PromotionStartedFieldPolicy = {
	issuedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	issuingPrincipal?: FieldPolicy<any> | FieldReadFunction<any>,
	promotion?: FieldPolicy<any> | FieldReadFunction<any>,
	recipient?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PromotionStartedEventKeySpecifier = ('createdBy' | 'date' | 'id' | 'type' | PromotionStartedEventKeySpecifier)[];
export type PromotionStartedEventFieldPolicy = {
	createdBy?: FieldPolicy<any> | FieldReadFunction<any>,
	date?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PromotionTranslatableContentKeySpecifier = ('description' | 'id' | 'name' | 'promotionId' | 'translation' | PromotionTranslatableContentKeySpecifier)[];
export type PromotionTranslatableContentFieldPolicy = {
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	promotionId?: FieldPolicy<any> | FieldReadFunction<any>,
	translation?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PromotionTranslateKeySpecifier = ('errors' | 'promotion' | PromotionTranslateKeySpecifier)[];
export type PromotionTranslateFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	promotion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PromotionTranslationKeySpecifier = ('description' | 'id' | 'language' | 'name' | 'translatableContent' | PromotionTranslationKeySpecifier)[];
export type PromotionTranslationFieldPolicy = {
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	language?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	translatableContent?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PromotionUpdateKeySpecifier = ('errors' | 'promotion' | PromotionUpdateKeySpecifier)[];
export type PromotionUpdateFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	promotion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PromotionUpdateErrorKeySpecifier = ('code' | 'field' | 'message' | PromotionUpdateErrorKeySpecifier)[];
export type PromotionUpdateErrorFieldPolicy = {
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	field?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PromotionUpdatedKeySpecifier = ('issuedAt' | 'issuingPrincipal' | 'promotion' | 'recipient' | 'version' | PromotionUpdatedKeySpecifier)[];
export type PromotionUpdatedFieldPolicy = {
	issuedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	issuingPrincipal?: FieldPolicy<any> | FieldReadFunction<any>,
	promotion?: FieldPolicy<any> | FieldReadFunction<any>,
	recipient?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PromotionUpdatedEventKeySpecifier = ('createdBy' | 'date' | 'id' | 'type' | PromotionUpdatedEventKeySpecifier)[];
export type PromotionUpdatedEventFieldPolicy = {
	createdBy?: FieldPolicy<any> | FieldReadFunction<any>,
	date?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type QueryKeySpecifier = ('_entities' | '_service' | 'address' | 'addressValidationRules' | 'app' | 'appExtension' | 'appExtensions' | 'apps' | 'appsInstallations' | 'attribute' | 'attributes' | 'categories' | 'category' | 'channel' | 'channels' | 'checkout' | 'checkoutLines' | 'checkouts' | 'collection' | 'collections' | 'customers' | 'digitalContent' | 'digitalContents' | 'draftOrders' | 'exportFile' | 'exportFiles' | 'giftCard' | 'giftCardCurrencies' | 'giftCardSettings' | 'giftCardTags' | 'giftCards' | 'homepageEvents' | 'me' | 'menu' | 'menuItem' | 'menuItems' | 'menus' | 'order' | 'orderByToken' | 'orderSettings' | 'orders' | 'ordersTotal' | 'page' | 'pageType' | 'pageTypes' | 'pages' | 'payment' | 'payments' | 'permissionGroup' | 'permissionGroups' | 'plugin' | 'plugins' | 'product' | 'productType' | 'productTypes' | 'productVariant' | 'productVariants' | 'products' | 'promotion' | 'promotions' | 'refundSettings' | 'reportProductSales' | 'sale' | 'sales' | 'shippingZone' | 'shippingZones' | 'shop' | 'staffUsers' | 'stock' | 'stocks' | 'taxClass' | 'taxClasses' | 'taxConfiguration' | 'taxConfigurations' | 'taxCountryConfiguration' | 'taxCountryConfigurations' | 'taxTypes' | 'transaction' | 'transactions' | 'translation' | 'translations' | 'user' | 'voucher' | 'vouchers' | 'warehouse' | 'warehouses' | 'webhook' | 'webhookEvents' | 'webhookSamplePayload' | QueryKeySpecifier)[];
export type QueryFieldPolicy = {
	_entities?: FieldPolicy<any> | FieldReadFunction<any>,
	_service?: FieldPolicy<any> | FieldReadFunction<any>,
	address?: FieldPolicy<any> | FieldReadFunction<any>,
	addressValidationRules?: FieldPolicy<any> | FieldReadFunction<any>,
	app?: FieldPolicy<any> | FieldReadFunction<any>,
	appExtension?: FieldPolicy<any> | FieldReadFunction<any>,
	appExtensions?: FieldPolicy<any> | FieldReadFunction<any>,
	apps?: FieldPolicy<any> | FieldReadFunction<any>,
	appsInstallations?: FieldPolicy<any> | FieldReadFunction<any>,
	attribute?: FieldPolicy<any> | FieldReadFunction<any>,
	attributes?: FieldPolicy<any> | FieldReadFunction<any>,
	categories?: FieldPolicy<any> | FieldReadFunction<any>,
	category?: FieldPolicy<any> | FieldReadFunction<any>,
	channel?: FieldPolicy<any> | FieldReadFunction<any>,
	channels?: FieldPolicy<any> | FieldReadFunction<any>,
	checkout?: FieldPolicy<any> | FieldReadFunction<any>,
	checkoutLines?: FieldPolicy<any> | FieldReadFunction<any>,
	checkouts?: FieldPolicy<any> | FieldReadFunction<any>,
	collection?: FieldPolicy<any> | FieldReadFunction<any>,
	collections?: FieldPolicy<any> | FieldReadFunction<any>,
	customers?: FieldPolicy<any> | FieldReadFunction<any>,
	digitalContent?: FieldPolicy<any> | FieldReadFunction<any>,
	digitalContents?: FieldPolicy<any> | FieldReadFunction<any>,
	draftOrders?: FieldPolicy<any> | FieldReadFunction<any>,
	exportFile?: FieldPolicy<any> | FieldReadFunction<any>,
	exportFiles?: FieldPolicy<any> | FieldReadFunction<any>,
	giftCard?: FieldPolicy<any> | FieldReadFunction<any>,
	giftCardCurrencies?: FieldPolicy<any> | FieldReadFunction<any>,
	giftCardSettings?: FieldPolicy<any> | FieldReadFunction<any>,
	giftCardTags?: FieldPolicy<any> | FieldReadFunction<any>,
	giftCards?: FieldPolicy<any> | FieldReadFunction<any>,
	homepageEvents?: FieldPolicy<any> | FieldReadFunction<any>,
	me?: FieldPolicy<any> | FieldReadFunction<any>,
	menu?: FieldPolicy<any> | FieldReadFunction<any>,
	menuItem?: FieldPolicy<any> | FieldReadFunction<any>,
	menuItems?: FieldPolicy<any> | FieldReadFunction<any>,
	menus?: FieldPolicy<any> | FieldReadFunction<any>,
	order?: FieldPolicy<any> | FieldReadFunction<any>,
	orderByToken?: FieldPolicy<any> | FieldReadFunction<any>,
	orderSettings?: FieldPolicy<any> | FieldReadFunction<any>,
	orders?: FieldPolicy<any> | FieldReadFunction<any>,
	ordersTotal?: FieldPolicy<any> | FieldReadFunction<any>,
	page?: FieldPolicy<any> | FieldReadFunction<any>,
	pageType?: FieldPolicy<any> | FieldReadFunction<any>,
	pageTypes?: FieldPolicy<any> | FieldReadFunction<any>,
	pages?: FieldPolicy<any> | FieldReadFunction<any>,
	payment?: FieldPolicy<any> | FieldReadFunction<any>,
	payments?: FieldPolicy<any> | FieldReadFunction<any>,
	permissionGroup?: FieldPolicy<any> | FieldReadFunction<any>,
	permissionGroups?: FieldPolicy<any> | FieldReadFunction<any>,
	plugin?: FieldPolicy<any> | FieldReadFunction<any>,
	plugins?: FieldPolicy<any> | FieldReadFunction<any>,
	product?: FieldPolicy<any> | FieldReadFunction<any>,
	productType?: FieldPolicy<any> | FieldReadFunction<any>,
	productTypes?: FieldPolicy<any> | FieldReadFunction<any>,
	productVariant?: FieldPolicy<any> | FieldReadFunction<any>,
	productVariants?: FieldPolicy<any> | FieldReadFunction<any>,
	products?: FieldPolicy<any> | FieldReadFunction<any>,
	promotion?: FieldPolicy<any> | FieldReadFunction<any>,
	promotions?: FieldPolicy<any> | FieldReadFunction<any>,
	refundSettings?: FieldPolicy<any> | FieldReadFunction<any>,
	reportProductSales?: FieldPolicy<any> | FieldReadFunction<any>,
	sale?: FieldPolicy<any> | FieldReadFunction<any>,
	sales?: FieldPolicy<any> | FieldReadFunction<any>,
	shippingZone?: FieldPolicy<any> | FieldReadFunction<any>,
	shippingZones?: FieldPolicy<any> | FieldReadFunction<any>,
	shop?: FieldPolicy<any> | FieldReadFunction<any>,
	staffUsers?: FieldPolicy<any> | FieldReadFunction<any>,
	stock?: FieldPolicy<any> | FieldReadFunction<any>,
	stocks?: FieldPolicy<any> | FieldReadFunction<any>,
	taxClass?: FieldPolicy<any> | FieldReadFunction<any>,
	taxClasses?: FieldPolicy<any> | FieldReadFunction<any>,
	taxConfiguration?: FieldPolicy<any> | FieldReadFunction<any>,
	taxConfigurations?: FieldPolicy<any> | FieldReadFunction<any>,
	taxCountryConfiguration?: FieldPolicy<any> | FieldReadFunction<any>,
	taxCountryConfigurations?: FieldPolicy<any> | FieldReadFunction<any>,
	taxTypes?: FieldPolicy<any> | FieldReadFunction<any>,
	transaction?: FieldPolicy<any> | FieldReadFunction<any>,
	transactions?: FieldPolicy<any> | FieldReadFunction<any>,
	translation?: FieldPolicy<any> | FieldReadFunction<any>,
	translations?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>,
	voucher?: FieldPolicy<any> | FieldReadFunction<any>,
	vouchers?: FieldPolicy<any> | FieldReadFunction<any>,
	warehouse?: FieldPolicy<any> | FieldReadFunction<any>,
	warehouses?: FieldPolicy<any> | FieldReadFunction<any>,
	webhook?: FieldPolicy<any> | FieldReadFunction<any>,
	webhookEvents?: FieldPolicy<any> | FieldReadFunction<any>,
	webhookSamplePayload?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ReducedRateKeySpecifier = ('rate' | 'rateType' | ReducedRateKeySpecifier)[];
export type ReducedRateFieldPolicy = {
	rate?: FieldPolicy<any> | FieldReadFunction<any>,
	rateType?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RefreshTokenKeySpecifier = ('accountErrors' | 'errors' | 'token' | 'user' | RefreshTokenKeySpecifier)[];
export type RefreshTokenFieldPolicy = {
	accountErrors?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	token?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RefundReasonReferenceTypeClearKeySpecifier = ('errors' | 'refundSettings' | 'refundSettingsErrors' | RefundReasonReferenceTypeClearKeySpecifier)[];
export type RefundReasonReferenceTypeClearFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	refundSettings?: FieldPolicy<any> | FieldReadFunction<any>,
	refundSettingsErrors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RefundReasonReferenceTypeClearErrorKeySpecifier = ('code' | 'field' | 'message' | RefundReasonReferenceTypeClearErrorKeySpecifier)[];
export type RefundReasonReferenceTypeClearErrorFieldPolicy = {
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	field?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RefundSettingsKeySpecifier = ('reasonReferenceType' | RefundSettingsKeySpecifier)[];
export type RefundSettingsFieldPolicy = {
	reasonReferenceType?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RefundSettingsUpdateKeySpecifier = ('errors' | 'refundSettings' | 'refundSettingsErrors' | RefundSettingsUpdateKeySpecifier)[];
export type RefundSettingsUpdateFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	refundSettings?: FieldPolicy<any> | FieldReadFunction<any>,
	refundSettingsErrors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RefundSettingsUpdateErrorKeySpecifier = ('code' | 'field' | 'message' | RefundSettingsUpdateErrorKeySpecifier)[];
export type RefundSettingsUpdateErrorFieldPolicy = {
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	field?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RequestEmailChangeKeySpecifier = ('accountErrors' | 'errors' | 'user' | RequestEmailChangeKeySpecifier)[];
export type RequestEmailChangeFieldPolicy = {
	accountErrors?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RequestPasswordResetKeySpecifier = ('accountErrors' | 'errors' | RequestPasswordResetKeySpecifier)[];
export type RequestPasswordResetFieldPolicy = {
	accountErrors?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SaleKeySpecifier = ('categories' | 'channelListings' | 'collections' | 'created' | 'currency' | 'discountValue' | 'endDate' | 'id' | 'metadata' | 'metafield' | 'metafields' | 'name' | 'privateMetadata' | 'privateMetafield' | 'privateMetafields' | 'products' | 'startDate' | 'translation' | 'type' | 'updatedAt' | 'variants' | SaleKeySpecifier)[];
export type SaleFieldPolicy = {
	categories?: FieldPolicy<any> | FieldReadFunction<any>,
	channelListings?: FieldPolicy<any> | FieldReadFunction<any>,
	collections?: FieldPolicy<any> | FieldReadFunction<any>,
	created?: FieldPolicy<any> | FieldReadFunction<any>,
	currency?: FieldPolicy<any> | FieldReadFunction<any>,
	discountValue?: FieldPolicy<any> | FieldReadFunction<any>,
	endDate?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	metadata?: FieldPolicy<any> | FieldReadFunction<any>,
	metafield?: FieldPolicy<any> | FieldReadFunction<any>,
	metafields?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	privateMetadata?: FieldPolicy<any> | FieldReadFunction<any>,
	privateMetafield?: FieldPolicy<any> | FieldReadFunction<any>,
	privateMetafields?: FieldPolicy<any> | FieldReadFunction<any>,
	products?: FieldPolicy<any> | FieldReadFunction<any>,
	startDate?: FieldPolicy<any> | FieldReadFunction<any>,
	translation?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	variants?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SaleAddCataloguesKeySpecifier = ('discountErrors' | 'errors' | 'sale' | SaleAddCataloguesKeySpecifier)[];
export type SaleAddCataloguesFieldPolicy = {
	discountErrors?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	sale?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SaleBulkDeleteKeySpecifier = ('count' | 'discountErrors' | 'errors' | SaleBulkDeleteKeySpecifier)[];
export type SaleBulkDeleteFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	discountErrors?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SaleChannelListingKeySpecifier = ('channel' | 'currency' | 'discountValue' | 'id' | SaleChannelListingKeySpecifier)[];
export type SaleChannelListingFieldPolicy = {
	channel?: FieldPolicy<any> | FieldReadFunction<any>,
	currency?: FieldPolicy<any> | FieldReadFunction<any>,
	discountValue?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SaleChannelListingUpdateKeySpecifier = ('discountErrors' | 'errors' | 'sale' | SaleChannelListingUpdateKeySpecifier)[];
export type SaleChannelListingUpdateFieldPolicy = {
	discountErrors?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	sale?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SaleCountableConnectionKeySpecifier = ('edges' | 'pageInfo' | 'totalCount' | SaleCountableConnectionKeySpecifier)[];
export type SaleCountableConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SaleCountableEdgeKeySpecifier = ('cursor' | 'node' | SaleCountableEdgeKeySpecifier)[];
export type SaleCountableEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SaleCreateKeySpecifier = ('discountErrors' | 'errors' | 'sale' | SaleCreateKeySpecifier)[];
export type SaleCreateFieldPolicy = {
	discountErrors?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	sale?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SaleCreatedKeySpecifier = ('issuedAt' | 'issuingPrincipal' | 'recipient' | 'sale' | 'version' | SaleCreatedKeySpecifier)[];
export type SaleCreatedFieldPolicy = {
	issuedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	issuingPrincipal?: FieldPolicy<any> | FieldReadFunction<any>,
	recipient?: FieldPolicy<any> | FieldReadFunction<any>,
	sale?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SaleDeleteKeySpecifier = ('discountErrors' | 'errors' | 'sale' | SaleDeleteKeySpecifier)[];
export type SaleDeleteFieldPolicy = {
	discountErrors?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	sale?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SaleDeletedKeySpecifier = ('issuedAt' | 'issuingPrincipal' | 'recipient' | 'sale' | 'version' | SaleDeletedKeySpecifier)[];
export type SaleDeletedFieldPolicy = {
	issuedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	issuingPrincipal?: FieldPolicy<any> | FieldReadFunction<any>,
	recipient?: FieldPolicy<any> | FieldReadFunction<any>,
	sale?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SaleRemoveCataloguesKeySpecifier = ('discountErrors' | 'errors' | 'sale' | SaleRemoveCataloguesKeySpecifier)[];
export type SaleRemoveCataloguesFieldPolicy = {
	discountErrors?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	sale?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SaleToggleKeySpecifier = ('issuedAt' | 'issuingPrincipal' | 'recipient' | 'sale' | 'version' | SaleToggleKeySpecifier)[];
export type SaleToggleFieldPolicy = {
	issuedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	issuingPrincipal?: FieldPolicy<any> | FieldReadFunction<any>,
	recipient?: FieldPolicy<any> | FieldReadFunction<any>,
	sale?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SaleTranslatableContentKeySpecifier = ('id' | 'name' | 'sale' | 'saleId' | 'translation' | SaleTranslatableContentKeySpecifier)[];
export type SaleTranslatableContentFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	sale?: FieldPolicy<any> | FieldReadFunction<any>,
	saleId?: FieldPolicy<any> | FieldReadFunction<any>,
	translation?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SaleTranslateKeySpecifier = ('errors' | 'sale' | 'translationErrors' | SaleTranslateKeySpecifier)[];
export type SaleTranslateFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	sale?: FieldPolicy<any> | FieldReadFunction<any>,
	translationErrors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SaleTranslationKeySpecifier = ('id' | 'language' | 'name' | 'translatableContent' | SaleTranslationKeySpecifier)[];
export type SaleTranslationFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	language?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	translatableContent?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SaleUpdateKeySpecifier = ('discountErrors' | 'errors' | 'sale' | SaleUpdateKeySpecifier)[];
export type SaleUpdateFieldPolicy = {
	discountErrors?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	sale?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SaleUpdatedKeySpecifier = ('issuedAt' | 'issuingPrincipal' | 'recipient' | 'sale' | 'version' | SaleUpdatedKeySpecifier)[];
export type SaleUpdatedFieldPolicy = {
	issuedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	issuingPrincipal?: FieldPolicy<any> | FieldReadFunction<any>,
	recipient?: FieldPolicy<any> | FieldReadFunction<any>,
	sale?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SelectedAttributeKeySpecifier = ('attribute' | 'values' | SelectedAttributeKeySpecifier)[];
export type SelectedAttributeFieldPolicy = {
	attribute?: FieldPolicy<any> | FieldReadFunction<any>,
	values?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SendConfirmationEmailKeySpecifier = ('errors' | SendConfirmationEmailKeySpecifier)[];
export type SendConfirmationEmailFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SendConfirmationEmailErrorKeySpecifier = ('code' | 'field' | 'message' | SendConfirmationEmailErrorKeySpecifier)[];
export type SendConfirmationEmailErrorFieldPolicy = {
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	field?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SetPasswordKeySpecifier = ('accountErrors' | 'csrfToken' | 'errors' | 'refreshToken' | 'token' | 'user' | SetPasswordKeySpecifier)[];
export type SetPasswordFieldPolicy = {
	accountErrors?: FieldPolicy<any> | FieldReadFunction<any>,
	csrfToken?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	refreshToken?: FieldPolicy<any> | FieldReadFunction<any>,
	token?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ShippingErrorKeySpecifier = ('channels' | 'code' | 'field' | 'message' | 'warehouses' | ShippingErrorKeySpecifier)[];
export type ShippingErrorFieldPolicy = {
	channels?: FieldPolicy<any> | FieldReadFunction<any>,
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	field?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>,
	warehouses?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ShippingListMethodsForCheckoutKeySpecifier = ('checkout' | 'issuedAt' | 'issuingPrincipal' | 'recipient' | 'shippingMethods' | 'version' | ShippingListMethodsForCheckoutKeySpecifier)[];
export type ShippingListMethodsForCheckoutFieldPolicy = {
	checkout?: FieldPolicy<any> | FieldReadFunction<any>,
	issuedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	issuingPrincipal?: FieldPolicy<any> | FieldReadFunction<any>,
	recipient?: FieldPolicy<any> | FieldReadFunction<any>,
	shippingMethods?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ShippingMethodKeySpecifier = ('active' | 'description' | 'id' | 'maximumDeliveryDays' | 'maximumOrderPrice' | 'maximumOrderWeight' | 'message' | 'metadata' | 'metafield' | 'metafields' | 'minimumDeliveryDays' | 'minimumOrderPrice' | 'minimumOrderWeight' | 'name' | 'price' | 'privateMetadata' | 'privateMetafield' | 'privateMetafields' | 'translation' | 'type' | ShippingMethodKeySpecifier)[];
export type ShippingMethodFieldPolicy = {
	active?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	maximumDeliveryDays?: FieldPolicy<any> | FieldReadFunction<any>,
	maximumOrderPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	maximumOrderWeight?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>,
	metadata?: FieldPolicy<any> | FieldReadFunction<any>,
	metafield?: FieldPolicy<any> | FieldReadFunction<any>,
	metafields?: FieldPolicy<any> | FieldReadFunction<any>,
	minimumDeliveryDays?: FieldPolicy<any> | FieldReadFunction<any>,
	minimumOrderPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	minimumOrderWeight?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	price?: FieldPolicy<any> | FieldReadFunction<any>,
	privateMetadata?: FieldPolicy<any> | FieldReadFunction<any>,
	privateMetafield?: FieldPolicy<any> | FieldReadFunction<any>,
	privateMetafields?: FieldPolicy<any> | FieldReadFunction<any>,
	translation?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ShippingMethodChannelListingKeySpecifier = ('channel' | 'id' | 'maximumOrderPrice' | 'minimumOrderPrice' | 'price' | ShippingMethodChannelListingKeySpecifier)[];
export type ShippingMethodChannelListingFieldPolicy = {
	channel?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	maximumOrderPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	minimumOrderPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	price?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ShippingMethodChannelListingUpdateKeySpecifier = ('errors' | 'shippingErrors' | 'shippingMethod' | ShippingMethodChannelListingUpdateKeySpecifier)[];
export type ShippingMethodChannelListingUpdateFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	shippingErrors?: FieldPolicy<any> | FieldReadFunction<any>,
	shippingMethod?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ShippingMethodPostalCodeRuleKeySpecifier = ('end' | 'id' | 'inclusionType' | 'start' | ShippingMethodPostalCodeRuleKeySpecifier)[];
export type ShippingMethodPostalCodeRuleFieldPolicy = {
	end?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	inclusionType?: FieldPolicy<any> | FieldReadFunction<any>,
	start?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ShippingMethodTranslatableContentKeySpecifier = ('description' | 'id' | 'name' | 'shippingMethod' | 'shippingMethodId' | 'translation' | ShippingMethodTranslatableContentKeySpecifier)[];
export type ShippingMethodTranslatableContentFieldPolicy = {
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	shippingMethod?: FieldPolicy<any> | FieldReadFunction<any>,
	shippingMethodId?: FieldPolicy<any> | FieldReadFunction<any>,
	translation?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ShippingMethodTranslationKeySpecifier = ('description' | 'id' | 'language' | 'name' | 'translatableContent' | ShippingMethodTranslationKeySpecifier)[];
export type ShippingMethodTranslationFieldPolicy = {
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	language?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	translatableContent?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ShippingMethodTypeKeySpecifier = ('channelListings' | 'description' | 'excludedProducts' | 'id' | 'maximumDeliveryDays' | 'maximumOrderPrice' | 'maximumOrderWeight' | 'metadata' | 'metafield' | 'metafields' | 'minimumDeliveryDays' | 'minimumOrderPrice' | 'minimumOrderWeight' | 'name' | 'postalCodeRules' | 'privateMetadata' | 'privateMetafield' | 'privateMetafields' | 'taxClass' | 'translation' | 'type' | ShippingMethodTypeKeySpecifier)[];
export type ShippingMethodTypeFieldPolicy = {
	channelListings?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	excludedProducts?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	maximumDeliveryDays?: FieldPolicy<any> | FieldReadFunction<any>,
	maximumOrderPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	maximumOrderWeight?: FieldPolicy<any> | FieldReadFunction<any>,
	metadata?: FieldPolicy<any> | FieldReadFunction<any>,
	metafield?: FieldPolicy<any> | FieldReadFunction<any>,
	metafields?: FieldPolicy<any> | FieldReadFunction<any>,
	minimumDeliveryDays?: FieldPolicy<any> | FieldReadFunction<any>,
	minimumOrderPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	minimumOrderWeight?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	postalCodeRules?: FieldPolicy<any> | FieldReadFunction<any>,
	privateMetadata?: FieldPolicy<any> | FieldReadFunction<any>,
	privateMetafield?: FieldPolicy<any> | FieldReadFunction<any>,
	privateMetafields?: FieldPolicy<any> | FieldReadFunction<any>,
	taxClass?: FieldPolicy<any> | FieldReadFunction<any>,
	translation?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ShippingMethodsPerCountryKeySpecifier = ('countryCode' | 'shippingMethods' | ShippingMethodsPerCountryKeySpecifier)[];
export type ShippingMethodsPerCountryFieldPolicy = {
	countryCode?: FieldPolicy<any> | FieldReadFunction<any>,
	shippingMethods?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ShippingPriceBulkDeleteKeySpecifier = ('count' | 'errors' | 'shippingErrors' | ShippingPriceBulkDeleteKeySpecifier)[];
export type ShippingPriceBulkDeleteFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	shippingErrors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ShippingPriceCreateKeySpecifier = ('errors' | 'shippingErrors' | 'shippingMethod' | 'shippingZone' | ShippingPriceCreateKeySpecifier)[];
export type ShippingPriceCreateFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	shippingErrors?: FieldPolicy<any> | FieldReadFunction<any>,
	shippingMethod?: FieldPolicy<any> | FieldReadFunction<any>,
	shippingZone?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ShippingPriceCreatedKeySpecifier = ('issuedAt' | 'issuingPrincipal' | 'recipient' | 'shippingMethod' | 'shippingZone' | 'version' | ShippingPriceCreatedKeySpecifier)[];
export type ShippingPriceCreatedFieldPolicy = {
	issuedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	issuingPrincipal?: FieldPolicy<any> | FieldReadFunction<any>,
	recipient?: FieldPolicy<any> | FieldReadFunction<any>,
	shippingMethod?: FieldPolicy<any> | FieldReadFunction<any>,
	shippingZone?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ShippingPriceDeleteKeySpecifier = ('errors' | 'shippingErrors' | 'shippingMethod' | 'shippingZone' | ShippingPriceDeleteKeySpecifier)[];
export type ShippingPriceDeleteFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	shippingErrors?: FieldPolicy<any> | FieldReadFunction<any>,
	shippingMethod?: FieldPolicy<any> | FieldReadFunction<any>,
	shippingZone?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ShippingPriceDeletedKeySpecifier = ('issuedAt' | 'issuingPrincipal' | 'recipient' | 'shippingMethod' | 'shippingZone' | 'version' | ShippingPriceDeletedKeySpecifier)[];
export type ShippingPriceDeletedFieldPolicy = {
	issuedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	issuingPrincipal?: FieldPolicy<any> | FieldReadFunction<any>,
	recipient?: FieldPolicy<any> | FieldReadFunction<any>,
	shippingMethod?: FieldPolicy<any> | FieldReadFunction<any>,
	shippingZone?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ShippingPriceExcludeProductsKeySpecifier = ('errors' | 'shippingErrors' | 'shippingMethod' | ShippingPriceExcludeProductsKeySpecifier)[];
export type ShippingPriceExcludeProductsFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	shippingErrors?: FieldPolicy<any> | FieldReadFunction<any>,
	shippingMethod?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ShippingPriceRemoveProductFromExcludeKeySpecifier = ('errors' | 'shippingErrors' | 'shippingMethod' | ShippingPriceRemoveProductFromExcludeKeySpecifier)[];
export type ShippingPriceRemoveProductFromExcludeFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	shippingErrors?: FieldPolicy<any> | FieldReadFunction<any>,
	shippingMethod?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ShippingPriceTranslateKeySpecifier = ('errors' | 'shippingMethod' | 'translationErrors' | ShippingPriceTranslateKeySpecifier)[];
export type ShippingPriceTranslateFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	shippingMethod?: FieldPolicy<any> | FieldReadFunction<any>,
	translationErrors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ShippingPriceUpdateKeySpecifier = ('errors' | 'shippingErrors' | 'shippingMethod' | 'shippingZone' | ShippingPriceUpdateKeySpecifier)[];
export type ShippingPriceUpdateFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	shippingErrors?: FieldPolicy<any> | FieldReadFunction<any>,
	shippingMethod?: FieldPolicy<any> | FieldReadFunction<any>,
	shippingZone?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ShippingPriceUpdatedKeySpecifier = ('issuedAt' | 'issuingPrincipal' | 'recipient' | 'shippingMethod' | 'shippingZone' | 'version' | ShippingPriceUpdatedKeySpecifier)[];
export type ShippingPriceUpdatedFieldPolicy = {
	issuedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	issuingPrincipal?: FieldPolicy<any> | FieldReadFunction<any>,
	recipient?: FieldPolicy<any> | FieldReadFunction<any>,
	shippingMethod?: FieldPolicy<any> | FieldReadFunction<any>,
	shippingZone?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ShippingZoneKeySpecifier = ('channels' | 'countries' | 'default' | 'description' | 'id' | 'metadata' | 'metafield' | 'metafields' | 'name' | 'priceRange' | 'privateMetadata' | 'privateMetafield' | 'privateMetafields' | 'shippingMethods' | 'warehouses' | ShippingZoneKeySpecifier)[];
export type ShippingZoneFieldPolicy = {
	channels?: FieldPolicy<any> | FieldReadFunction<any>,
	countries?: FieldPolicy<any> | FieldReadFunction<any>,
	default?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	metadata?: FieldPolicy<any> | FieldReadFunction<any>,
	metafield?: FieldPolicy<any> | FieldReadFunction<any>,
	metafields?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	priceRange?: FieldPolicy<any> | FieldReadFunction<any>,
	privateMetadata?: FieldPolicy<any> | FieldReadFunction<any>,
	privateMetafield?: FieldPolicy<any> | FieldReadFunction<any>,
	privateMetafields?: FieldPolicy<any> | FieldReadFunction<any>,
	shippingMethods?: FieldPolicy<any> | FieldReadFunction<any>,
	warehouses?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ShippingZoneBulkDeleteKeySpecifier = ('count' | 'errors' | 'shippingErrors' | ShippingZoneBulkDeleteKeySpecifier)[];
export type ShippingZoneBulkDeleteFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	shippingErrors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ShippingZoneCountableConnectionKeySpecifier = ('edges' | 'pageInfo' | 'totalCount' | ShippingZoneCountableConnectionKeySpecifier)[];
export type ShippingZoneCountableConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ShippingZoneCountableEdgeKeySpecifier = ('cursor' | 'node' | ShippingZoneCountableEdgeKeySpecifier)[];
export type ShippingZoneCountableEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ShippingZoneCreateKeySpecifier = ('errors' | 'shippingErrors' | 'shippingZone' | ShippingZoneCreateKeySpecifier)[];
export type ShippingZoneCreateFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	shippingErrors?: FieldPolicy<any> | FieldReadFunction<any>,
	shippingZone?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ShippingZoneCreatedKeySpecifier = ('issuedAt' | 'issuingPrincipal' | 'recipient' | 'shippingZone' | 'version' | ShippingZoneCreatedKeySpecifier)[];
export type ShippingZoneCreatedFieldPolicy = {
	issuedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	issuingPrincipal?: FieldPolicy<any> | FieldReadFunction<any>,
	recipient?: FieldPolicy<any> | FieldReadFunction<any>,
	shippingZone?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ShippingZoneDeleteKeySpecifier = ('errors' | 'shippingErrors' | 'shippingZone' | ShippingZoneDeleteKeySpecifier)[];
export type ShippingZoneDeleteFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	shippingErrors?: FieldPolicy<any> | FieldReadFunction<any>,
	shippingZone?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ShippingZoneDeletedKeySpecifier = ('issuedAt' | 'issuingPrincipal' | 'recipient' | 'shippingZone' | 'version' | ShippingZoneDeletedKeySpecifier)[];
export type ShippingZoneDeletedFieldPolicy = {
	issuedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	issuingPrincipal?: FieldPolicy<any> | FieldReadFunction<any>,
	recipient?: FieldPolicy<any> | FieldReadFunction<any>,
	shippingZone?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ShippingZoneMetadataUpdatedKeySpecifier = ('issuedAt' | 'issuingPrincipal' | 'recipient' | 'shippingZone' | 'version' | ShippingZoneMetadataUpdatedKeySpecifier)[];
export type ShippingZoneMetadataUpdatedFieldPolicy = {
	issuedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	issuingPrincipal?: FieldPolicy<any> | FieldReadFunction<any>,
	recipient?: FieldPolicy<any> | FieldReadFunction<any>,
	shippingZone?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ShippingZoneUpdateKeySpecifier = ('errors' | 'shippingErrors' | 'shippingZone' | ShippingZoneUpdateKeySpecifier)[];
export type ShippingZoneUpdateFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	shippingErrors?: FieldPolicy<any> | FieldReadFunction<any>,
	shippingZone?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ShippingZoneUpdatedKeySpecifier = ('issuedAt' | 'issuingPrincipal' | 'recipient' | 'shippingZone' | 'version' | ShippingZoneUpdatedKeySpecifier)[];
export type ShippingZoneUpdatedFieldPolicy = {
	issuedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	issuingPrincipal?: FieldPolicy<any> | FieldReadFunction<any>,
	recipient?: FieldPolicy<any> | FieldReadFunction<any>,
	shippingZone?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ShopKeySpecifier = ('allowLoginWithoutConfirmation' | 'automaticFulfillmentDigitalProducts' | 'availableExternalAuthentications' | 'availablePaymentGateways' | 'availableShippingMethods' | 'availableTaxApps' | 'channelCurrencies' | 'chargeTaxesOnShipping' | 'companyAddress' | 'countries' | 'customerSetPasswordUrl' | 'defaultCountry' | 'defaultDigitalMaxDownloads' | 'defaultDigitalUrlValidDays' | 'defaultMailSenderAddress' | 'defaultMailSenderName' | 'defaultWeightUnit' | 'description' | 'displayGrossPrices' | 'domain' | 'enableAccountConfirmationByEmail' | 'fulfillmentAllowUnpaid' | 'fulfillmentAutoApprove' | 'headerText' | 'id' | 'includeTaxesInPrices' | 'languages' | 'limitQuantityPerCheckout' | 'limits' | 'metadata' | 'metafield' | 'metafields' | 'name' | 'permissions' | 'phonePrefixes' | 'preserveAllAddressFields' | 'privateMetadata' | 'privateMetafield' | 'privateMetafields' | 'reserveStockDurationAnonymousUser' | 'reserveStockDurationAuthenticatedUser' | 'schemaVersion' | 'staffNotificationRecipients' | 'trackInventoryByDefault' | 'translation' | 'useLegacyUpdateWebhookEmission' | 'version' | ShopKeySpecifier)[];
export type ShopFieldPolicy = {
	allowLoginWithoutConfirmation?: FieldPolicy<any> | FieldReadFunction<any>,
	automaticFulfillmentDigitalProducts?: FieldPolicy<any> | FieldReadFunction<any>,
	availableExternalAuthentications?: FieldPolicy<any> | FieldReadFunction<any>,
	availablePaymentGateways?: FieldPolicy<any> | FieldReadFunction<any>,
	availableShippingMethods?: FieldPolicy<any> | FieldReadFunction<any>,
	availableTaxApps?: FieldPolicy<any> | FieldReadFunction<any>,
	channelCurrencies?: FieldPolicy<any> | FieldReadFunction<any>,
	chargeTaxesOnShipping?: FieldPolicy<any> | FieldReadFunction<any>,
	companyAddress?: FieldPolicy<any> | FieldReadFunction<any>,
	countries?: FieldPolicy<any> | FieldReadFunction<any>,
	customerSetPasswordUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	defaultCountry?: FieldPolicy<any> | FieldReadFunction<any>,
	defaultDigitalMaxDownloads?: FieldPolicy<any> | FieldReadFunction<any>,
	defaultDigitalUrlValidDays?: FieldPolicy<any> | FieldReadFunction<any>,
	defaultMailSenderAddress?: FieldPolicy<any> | FieldReadFunction<any>,
	defaultMailSenderName?: FieldPolicy<any> | FieldReadFunction<any>,
	defaultWeightUnit?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	displayGrossPrices?: FieldPolicy<any> | FieldReadFunction<any>,
	domain?: FieldPolicy<any> | FieldReadFunction<any>,
	enableAccountConfirmationByEmail?: FieldPolicy<any> | FieldReadFunction<any>,
	fulfillmentAllowUnpaid?: FieldPolicy<any> | FieldReadFunction<any>,
	fulfillmentAutoApprove?: FieldPolicy<any> | FieldReadFunction<any>,
	headerText?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	includeTaxesInPrices?: FieldPolicy<any> | FieldReadFunction<any>,
	languages?: FieldPolicy<any> | FieldReadFunction<any>,
	limitQuantityPerCheckout?: FieldPolicy<any> | FieldReadFunction<any>,
	limits?: FieldPolicy<any> | FieldReadFunction<any>,
	metadata?: FieldPolicy<any> | FieldReadFunction<any>,
	metafield?: FieldPolicy<any> | FieldReadFunction<any>,
	metafields?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	permissions?: FieldPolicy<any> | FieldReadFunction<any>,
	phonePrefixes?: FieldPolicy<any> | FieldReadFunction<any>,
	preserveAllAddressFields?: FieldPolicy<any> | FieldReadFunction<any>,
	privateMetadata?: FieldPolicy<any> | FieldReadFunction<any>,
	privateMetafield?: FieldPolicy<any> | FieldReadFunction<any>,
	privateMetafields?: FieldPolicy<any> | FieldReadFunction<any>,
	reserveStockDurationAnonymousUser?: FieldPolicy<any> | FieldReadFunction<any>,
	reserveStockDurationAuthenticatedUser?: FieldPolicy<any> | FieldReadFunction<any>,
	schemaVersion?: FieldPolicy<any> | FieldReadFunction<any>,
	staffNotificationRecipients?: FieldPolicy<any> | FieldReadFunction<any>,
	trackInventoryByDefault?: FieldPolicy<any> | FieldReadFunction<any>,
	translation?: FieldPolicy<any> | FieldReadFunction<any>,
	useLegacyUpdateWebhookEmission?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ShopAddressUpdateKeySpecifier = ('errors' | 'shop' | 'shopErrors' | ShopAddressUpdateKeySpecifier)[];
export type ShopAddressUpdateFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	shop?: FieldPolicy<any> | FieldReadFunction<any>,
	shopErrors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ShopDomainUpdateKeySpecifier = ('errors' | 'shop' | 'shopErrors' | ShopDomainUpdateKeySpecifier)[];
export type ShopDomainUpdateFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	shop?: FieldPolicy<any> | FieldReadFunction<any>,
	shopErrors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ShopErrorKeySpecifier = ('code' | 'field' | 'message' | ShopErrorKeySpecifier)[];
export type ShopErrorFieldPolicy = {
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	field?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ShopFetchTaxRatesKeySpecifier = ('errors' | 'shop' | 'shopErrors' | ShopFetchTaxRatesKeySpecifier)[];
export type ShopFetchTaxRatesFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	shop?: FieldPolicy<any> | FieldReadFunction<any>,
	shopErrors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ShopMetadataUpdatedKeySpecifier = ('issuedAt' | 'issuingPrincipal' | 'recipient' | 'shop' | 'version' | ShopMetadataUpdatedKeySpecifier)[];
export type ShopMetadataUpdatedFieldPolicy = {
	issuedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	issuingPrincipal?: FieldPolicy<any> | FieldReadFunction<any>,
	recipient?: FieldPolicy<any> | FieldReadFunction<any>,
	shop?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ShopSettingsTranslateKeySpecifier = ('errors' | 'shop' | 'translationErrors' | ShopSettingsTranslateKeySpecifier)[];
export type ShopSettingsTranslateFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	shop?: FieldPolicy<any> | FieldReadFunction<any>,
	translationErrors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ShopSettingsUpdateKeySpecifier = ('errors' | 'shop' | 'shopErrors' | ShopSettingsUpdateKeySpecifier)[];
export type ShopSettingsUpdateFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	shop?: FieldPolicy<any> | FieldReadFunction<any>,
	shopErrors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ShopTranslationKeySpecifier = ('description' | 'headerText' | 'id' | 'language' | ShopTranslationKeySpecifier)[];
export type ShopTranslationFieldPolicy = {
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	headerText?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	language?: FieldPolicy<any> | FieldReadFunction<any>
};
export type StaffBulkDeleteKeySpecifier = ('count' | 'errors' | 'staffErrors' | StaffBulkDeleteKeySpecifier)[];
export type StaffBulkDeleteFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	staffErrors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type StaffCreateKeySpecifier = ('errors' | 'staffErrors' | 'user' | StaffCreateKeySpecifier)[];
export type StaffCreateFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	staffErrors?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>
};
export type StaffCreatedKeySpecifier = ('issuedAt' | 'issuingPrincipal' | 'recipient' | 'user' | 'version' | StaffCreatedKeySpecifier)[];
export type StaffCreatedFieldPolicy = {
	issuedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	issuingPrincipal?: FieldPolicy<any> | FieldReadFunction<any>,
	recipient?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type StaffDeleteKeySpecifier = ('errors' | 'staffErrors' | 'user' | StaffDeleteKeySpecifier)[];
export type StaffDeleteFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	staffErrors?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>
};
export type StaffDeletedKeySpecifier = ('issuedAt' | 'issuingPrincipal' | 'recipient' | 'user' | 'version' | StaffDeletedKeySpecifier)[];
export type StaffDeletedFieldPolicy = {
	issuedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	issuingPrincipal?: FieldPolicy<any> | FieldReadFunction<any>,
	recipient?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type StaffErrorKeySpecifier = ('addressType' | 'code' | 'field' | 'groups' | 'message' | 'permissions' | 'users' | StaffErrorKeySpecifier)[];
export type StaffErrorFieldPolicy = {
	addressType?: FieldPolicy<any> | FieldReadFunction<any>,
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	field?: FieldPolicy<any> | FieldReadFunction<any>,
	groups?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>,
	permissions?: FieldPolicy<any> | FieldReadFunction<any>,
	users?: FieldPolicy<any> | FieldReadFunction<any>
};
export type StaffNotificationRecipientKeySpecifier = ('active' | 'email' | 'id' | 'user' | StaffNotificationRecipientKeySpecifier)[];
export type StaffNotificationRecipientFieldPolicy = {
	active?: FieldPolicy<any> | FieldReadFunction<any>,
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>
};
export type StaffNotificationRecipientCreateKeySpecifier = ('errors' | 'shopErrors' | 'staffNotificationRecipient' | StaffNotificationRecipientCreateKeySpecifier)[];
export type StaffNotificationRecipientCreateFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	shopErrors?: FieldPolicy<any> | FieldReadFunction<any>,
	staffNotificationRecipient?: FieldPolicy<any> | FieldReadFunction<any>
};
export type StaffNotificationRecipientDeleteKeySpecifier = ('errors' | 'shopErrors' | 'staffNotificationRecipient' | StaffNotificationRecipientDeleteKeySpecifier)[];
export type StaffNotificationRecipientDeleteFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	shopErrors?: FieldPolicy<any> | FieldReadFunction<any>,
	staffNotificationRecipient?: FieldPolicy<any> | FieldReadFunction<any>
};
export type StaffNotificationRecipientUpdateKeySpecifier = ('errors' | 'shopErrors' | 'staffNotificationRecipient' | StaffNotificationRecipientUpdateKeySpecifier)[];
export type StaffNotificationRecipientUpdateFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	shopErrors?: FieldPolicy<any> | FieldReadFunction<any>,
	staffNotificationRecipient?: FieldPolicy<any> | FieldReadFunction<any>
};
export type StaffSetPasswordRequestedKeySpecifier = ('channel' | 'issuedAt' | 'issuingPrincipal' | 'recipient' | 'redirectUrl' | 'shop' | 'token' | 'user' | 'version' | StaffSetPasswordRequestedKeySpecifier)[];
export type StaffSetPasswordRequestedFieldPolicy = {
	channel?: FieldPolicy<any> | FieldReadFunction<any>,
	issuedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	issuingPrincipal?: FieldPolicy<any> | FieldReadFunction<any>,
	recipient?: FieldPolicy<any> | FieldReadFunction<any>,
	redirectUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	shop?: FieldPolicy<any> | FieldReadFunction<any>,
	token?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type StaffUpdateKeySpecifier = ('errors' | 'staffErrors' | 'user' | StaffUpdateKeySpecifier)[];
export type StaffUpdateFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	staffErrors?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>
};
export type StaffUpdatedKeySpecifier = ('issuedAt' | 'issuingPrincipal' | 'recipient' | 'user' | 'version' | StaffUpdatedKeySpecifier)[];
export type StaffUpdatedFieldPolicy = {
	issuedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	issuingPrincipal?: FieldPolicy<any> | FieldReadFunction<any>,
	recipient?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type StockKeySpecifier = ('id' | 'productVariant' | 'quantity' | 'quantityAllocated' | 'quantityReserved' | 'warehouse' | StockKeySpecifier)[];
export type StockFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	productVariant?: FieldPolicy<any> | FieldReadFunction<any>,
	quantity?: FieldPolicy<any> | FieldReadFunction<any>,
	quantityAllocated?: FieldPolicy<any> | FieldReadFunction<any>,
	quantityReserved?: FieldPolicy<any> | FieldReadFunction<any>,
	warehouse?: FieldPolicy<any> | FieldReadFunction<any>
};
export type StockBulkResultKeySpecifier = ('errors' | 'stock' | StockBulkResultKeySpecifier)[];
export type StockBulkResultFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	stock?: FieldPolicy<any> | FieldReadFunction<any>
};
export type StockBulkUpdateKeySpecifier = ('count' | 'errors' | 'results' | StockBulkUpdateKeySpecifier)[];
export type StockBulkUpdateFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	results?: FieldPolicy<any> | FieldReadFunction<any>
};
export type StockBulkUpdateErrorKeySpecifier = ('code' | 'field' | 'message' | StockBulkUpdateErrorKeySpecifier)[];
export type StockBulkUpdateErrorFieldPolicy = {
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	field?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>
};
export type StockCountableConnectionKeySpecifier = ('edges' | 'pageInfo' | 'totalCount' | StockCountableConnectionKeySpecifier)[];
export type StockCountableConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type StockCountableEdgeKeySpecifier = ('cursor' | 'node' | StockCountableEdgeKeySpecifier)[];
export type StockCountableEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type StockErrorKeySpecifier = ('code' | 'field' | 'message' | StockErrorKeySpecifier)[];
export type StockErrorFieldPolicy = {
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	field?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>
};
export type StockSettingsKeySpecifier = ('allocationStrategy' | StockSettingsKeySpecifier)[];
export type StockSettingsFieldPolicy = {
	allocationStrategy?: FieldPolicy<any> | FieldReadFunction<any>
};
export type StoredPaymentMethodKeySpecifier = ('creditCardInfo' | 'data' | 'gateway' | 'id' | 'name' | 'paymentMethodId' | 'supportedPaymentFlows' | 'type' | StoredPaymentMethodKeySpecifier)[];
export type StoredPaymentMethodFieldPolicy = {
	creditCardInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	data?: FieldPolicy<any> | FieldReadFunction<any>,
	gateway?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentMethodId?: FieldPolicy<any> | FieldReadFunction<any>,
	supportedPaymentFlows?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type StoredPaymentMethodDeleteRequestedKeySpecifier = ('channel' | 'issuedAt' | 'issuingPrincipal' | 'paymentMethodId' | 'recipient' | 'user' | 'version' | StoredPaymentMethodDeleteRequestedKeySpecifier)[];
export type StoredPaymentMethodDeleteRequestedFieldPolicy = {
	channel?: FieldPolicy<any> | FieldReadFunction<any>,
	issuedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	issuingPrincipal?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentMethodId?: FieldPolicy<any> | FieldReadFunction<any>,
	recipient?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type StoredPaymentMethodRequestDeleteKeySpecifier = ('errors' | 'result' | StoredPaymentMethodRequestDeleteKeySpecifier)[];
export type StoredPaymentMethodRequestDeleteFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	result?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SubscriptionKeySpecifier = ('checkoutCreated' | 'checkoutFullyAuthorized' | 'checkoutFullyPaid' | 'checkoutMetadataUpdated' | 'checkoutUpdated' | 'draftOrderCreated' | 'draftOrderDeleted' | 'draftOrderUpdated' | 'event' | 'orderBulkCreated' | 'orderCancelled' | 'orderConfirmed' | 'orderCreated' | 'orderExpired' | 'orderFulfilled' | 'orderFullyPaid' | 'orderFullyRefunded' | 'orderMetadataUpdated' | 'orderPaid' | 'orderRefunded' | 'orderUpdated' | 'productVariantDiscountedPriceUpdated' | SubscriptionKeySpecifier)[];
export type SubscriptionFieldPolicy = {
	checkoutCreated?: FieldPolicy<any> | FieldReadFunction<any>,
	checkoutFullyAuthorized?: FieldPolicy<any> | FieldReadFunction<any>,
	checkoutFullyPaid?: FieldPolicy<any> | FieldReadFunction<any>,
	checkoutMetadataUpdated?: FieldPolicy<any> | FieldReadFunction<any>,
	checkoutUpdated?: FieldPolicy<any> | FieldReadFunction<any>,
	draftOrderCreated?: FieldPolicy<any> | FieldReadFunction<any>,
	draftOrderDeleted?: FieldPolicy<any> | FieldReadFunction<any>,
	draftOrderUpdated?: FieldPolicy<any> | FieldReadFunction<any>,
	event?: FieldPolicy<any> | FieldReadFunction<any>,
	orderBulkCreated?: FieldPolicy<any> | FieldReadFunction<any>,
	orderCancelled?: FieldPolicy<any> | FieldReadFunction<any>,
	orderConfirmed?: FieldPolicy<any> | FieldReadFunction<any>,
	orderCreated?: FieldPolicy<any> | FieldReadFunction<any>,
	orderExpired?: FieldPolicy<any> | FieldReadFunction<any>,
	orderFulfilled?: FieldPolicy<any> | FieldReadFunction<any>,
	orderFullyPaid?: FieldPolicy<any> | FieldReadFunction<any>,
	orderFullyRefunded?: FieldPolicy<any> | FieldReadFunction<any>,
	orderMetadataUpdated?: FieldPolicy<any> | FieldReadFunction<any>,
	orderPaid?: FieldPolicy<any> | FieldReadFunction<any>,
	orderRefunded?: FieldPolicy<any> | FieldReadFunction<any>,
	orderUpdated?: FieldPolicy<any> | FieldReadFunction<any>,
	productVariantDiscountedPriceUpdated?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TaxClassKeySpecifier = ('countries' | 'id' | 'metadata' | 'metafield' | 'metafields' | 'name' | 'privateMetadata' | 'privateMetafield' | 'privateMetafields' | TaxClassKeySpecifier)[];
export type TaxClassFieldPolicy = {
	countries?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	metadata?: FieldPolicy<any> | FieldReadFunction<any>,
	metafield?: FieldPolicy<any> | FieldReadFunction<any>,
	metafields?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	privateMetadata?: FieldPolicy<any> | FieldReadFunction<any>,
	privateMetafield?: FieldPolicy<any> | FieldReadFunction<any>,
	privateMetafields?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TaxClassCountableConnectionKeySpecifier = ('edges' | 'pageInfo' | 'totalCount' | TaxClassCountableConnectionKeySpecifier)[];
export type TaxClassCountableConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TaxClassCountableEdgeKeySpecifier = ('cursor' | 'node' | TaxClassCountableEdgeKeySpecifier)[];
export type TaxClassCountableEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TaxClassCountryRateKeySpecifier = ('country' | 'rate' | 'taxClass' | TaxClassCountryRateKeySpecifier)[];
export type TaxClassCountryRateFieldPolicy = {
	country?: FieldPolicy<any> | FieldReadFunction<any>,
	rate?: FieldPolicy<any> | FieldReadFunction<any>,
	taxClass?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TaxClassCreateKeySpecifier = ('errors' | 'taxClass' | TaxClassCreateKeySpecifier)[];
export type TaxClassCreateFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	taxClass?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TaxClassCreateErrorKeySpecifier = ('code' | 'countryCodes' | 'field' | 'message' | TaxClassCreateErrorKeySpecifier)[];
export type TaxClassCreateErrorFieldPolicy = {
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	countryCodes?: FieldPolicy<any> | FieldReadFunction<any>,
	field?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TaxClassDeleteKeySpecifier = ('errors' | 'taxClass' | TaxClassDeleteKeySpecifier)[];
export type TaxClassDeleteFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	taxClass?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TaxClassDeleteErrorKeySpecifier = ('code' | 'field' | 'message' | TaxClassDeleteErrorKeySpecifier)[];
export type TaxClassDeleteErrorFieldPolicy = {
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	field?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TaxClassUpdateKeySpecifier = ('errors' | 'taxClass' | TaxClassUpdateKeySpecifier)[];
export type TaxClassUpdateFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	taxClass?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TaxClassUpdateErrorKeySpecifier = ('code' | 'countryCodes' | 'field' | 'message' | TaxClassUpdateErrorKeySpecifier)[];
export type TaxClassUpdateErrorFieldPolicy = {
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	countryCodes?: FieldPolicy<any> | FieldReadFunction<any>,
	field?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TaxConfigurationKeySpecifier = ('channel' | 'chargeTaxes' | 'countries' | 'displayGrossPrices' | 'id' | 'metadata' | 'metafield' | 'metafields' | 'pricesEnteredWithTax' | 'privateMetadata' | 'privateMetafield' | 'privateMetafields' | 'taxAppId' | 'taxCalculationStrategy' | 'useWeightedTaxForShipping' | TaxConfigurationKeySpecifier)[];
export type TaxConfigurationFieldPolicy = {
	channel?: FieldPolicy<any> | FieldReadFunction<any>,
	chargeTaxes?: FieldPolicy<any> | FieldReadFunction<any>,
	countries?: FieldPolicy<any> | FieldReadFunction<any>,
	displayGrossPrices?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	metadata?: FieldPolicy<any> | FieldReadFunction<any>,
	metafield?: FieldPolicy<any> | FieldReadFunction<any>,
	metafields?: FieldPolicy<any> | FieldReadFunction<any>,
	pricesEnteredWithTax?: FieldPolicy<any> | FieldReadFunction<any>,
	privateMetadata?: FieldPolicy<any> | FieldReadFunction<any>,
	privateMetafield?: FieldPolicy<any> | FieldReadFunction<any>,
	privateMetafields?: FieldPolicy<any> | FieldReadFunction<any>,
	taxAppId?: FieldPolicy<any> | FieldReadFunction<any>,
	taxCalculationStrategy?: FieldPolicy<any> | FieldReadFunction<any>,
	useWeightedTaxForShipping?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TaxConfigurationCountableConnectionKeySpecifier = ('edges' | 'pageInfo' | 'totalCount' | TaxConfigurationCountableConnectionKeySpecifier)[];
export type TaxConfigurationCountableConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TaxConfigurationCountableEdgeKeySpecifier = ('cursor' | 'node' | TaxConfigurationCountableEdgeKeySpecifier)[];
export type TaxConfigurationCountableEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TaxConfigurationPerCountryKeySpecifier = ('chargeTaxes' | 'country' | 'displayGrossPrices' | 'taxAppId' | 'taxCalculationStrategy' | 'useWeightedTaxForShipping' | TaxConfigurationPerCountryKeySpecifier)[];
export type TaxConfigurationPerCountryFieldPolicy = {
	chargeTaxes?: FieldPolicy<any> | FieldReadFunction<any>,
	country?: FieldPolicy<any> | FieldReadFunction<any>,
	displayGrossPrices?: FieldPolicy<any> | FieldReadFunction<any>,
	taxAppId?: FieldPolicy<any> | FieldReadFunction<any>,
	taxCalculationStrategy?: FieldPolicy<any> | FieldReadFunction<any>,
	useWeightedTaxForShipping?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TaxConfigurationUpdateKeySpecifier = ('errors' | 'taxConfiguration' | TaxConfigurationUpdateKeySpecifier)[];
export type TaxConfigurationUpdateFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	taxConfiguration?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TaxConfigurationUpdateErrorKeySpecifier = ('code' | 'countryCodes' | 'field' | 'message' | TaxConfigurationUpdateErrorKeySpecifier)[];
export type TaxConfigurationUpdateErrorFieldPolicy = {
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	countryCodes?: FieldPolicy<any> | FieldReadFunction<any>,
	field?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TaxCountryConfigurationKeySpecifier = ('country' | 'taxClassCountryRates' | TaxCountryConfigurationKeySpecifier)[];
export type TaxCountryConfigurationFieldPolicy = {
	country?: FieldPolicy<any> | FieldReadFunction<any>,
	taxClassCountryRates?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TaxCountryConfigurationDeleteKeySpecifier = ('errors' | 'taxCountryConfiguration' | TaxCountryConfigurationDeleteKeySpecifier)[];
export type TaxCountryConfigurationDeleteFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	taxCountryConfiguration?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TaxCountryConfigurationDeleteErrorKeySpecifier = ('code' | 'field' | 'message' | TaxCountryConfigurationDeleteErrorKeySpecifier)[];
export type TaxCountryConfigurationDeleteErrorFieldPolicy = {
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	field?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TaxCountryConfigurationUpdateKeySpecifier = ('errors' | 'taxCountryConfiguration' | TaxCountryConfigurationUpdateKeySpecifier)[];
export type TaxCountryConfigurationUpdateFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	taxCountryConfiguration?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TaxCountryConfigurationUpdateErrorKeySpecifier = ('code' | 'field' | 'message' | 'taxClassIds' | TaxCountryConfigurationUpdateErrorKeySpecifier)[];
export type TaxCountryConfigurationUpdateErrorFieldPolicy = {
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	field?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>,
	taxClassIds?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TaxExemptionManageKeySpecifier = ('errors' | 'taxableObject' | TaxExemptionManageKeySpecifier)[];
export type TaxExemptionManageFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	taxableObject?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TaxExemptionManageErrorKeySpecifier = ('code' | 'field' | 'message' | TaxExemptionManageErrorKeySpecifier)[];
export type TaxExemptionManageErrorFieldPolicy = {
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	field?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TaxTypeKeySpecifier = ('description' | 'taxCode' | TaxTypeKeySpecifier)[];
export type TaxTypeFieldPolicy = {
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	taxCode?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TaxableObjectKeySpecifier = ('address' | 'channel' | 'currency' | 'discounts' | 'lines' | 'pricesEnteredWithTax' | 'shippingPrice' | 'sourceObject' | TaxableObjectKeySpecifier)[];
export type TaxableObjectFieldPolicy = {
	address?: FieldPolicy<any> | FieldReadFunction<any>,
	channel?: FieldPolicy<any> | FieldReadFunction<any>,
	currency?: FieldPolicy<any> | FieldReadFunction<any>,
	discounts?: FieldPolicy<any> | FieldReadFunction<any>,
	lines?: FieldPolicy<any> | FieldReadFunction<any>,
	pricesEnteredWithTax?: FieldPolicy<any> | FieldReadFunction<any>,
	shippingPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	sourceObject?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TaxableObjectDiscountKeySpecifier = ('amount' | 'name' | 'type' | TaxableObjectDiscountKeySpecifier)[];
export type TaxableObjectDiscountFieldPolicy = {
	amount?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TaxableObjectLineKeySpecifier = ('chargeTaxes' | 'productName' | 'productSku' | 'quantity' | 'sourceLine' | 'totalPrice' | 'unitPrice' | 'variantName' | TaxableObjectLineKeySpecifier)[];
export type TaxableObjectLineFieldPolicy = {
	chargeTaxes?: FieldPolicy<any> | FieldReadFunction<any>,
	productName?: FieldPolicy<any> | FieldReadFunction<any>,
	productSku?: FieldPolicy<any> | FieldReadFunction<any>,
	quantity?: FieldPolicy<any> | FieldReadFunction<any>,
	sourceLine?: FieldPolicy<any> | FieldReadFunction<any>,
	totalPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	unitPrice?: FieldPolicy<any> | FieldReadFunction<any>,
	variantName?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TaxedMoneyKeySpecifier = ('currency' | 'gross' | 'net' | 'tax' | TaxedMoneyKeySpecifier)[];
export type TaxedMoneyFieldPolicy = {
	currency?: FieldPolicy<any> | FieldReadFunction<any>,
	gross?: FieldPolicy<any> | FieldReadFunction<any>,
	net?: FieldPolicy<any> | FieldReadFunction<any>,
	tax?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TaxedMoneyRangeKeySpecifier = ('start' | 'stop' | TaxedMoneyRangeKeySpecifier)[];
export type TaxedMoneyRangeFieldPolicy = {
	start?: FieldPolicy<any> | FieldReadFunction<any>,
	stop?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ThumbnailCreatedKeySpecifier = ('id' | 'issuedAt' | 'issuingPrincipal' | 'mediaUrl' | 'objectId' | 'recipient' | 'url' | 'version' | ThumbnailCreatedKeySpecifier)[];
export type ThumbnailCreatedFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	issuedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	issuingPrincipal?: FieldPolicy<any> | FieldReadFunction<any>,
	mediaUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	objectId?: FieldPolicy<any> | FieldReadFunction<any>,
	recipient?: FieldPolicy<any> | FieldReadFunction<any>,
	url?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TimePeriodKeySpecifier = ('amount' | 'type' | TimePeriodKeySpecifier)[];
export type TimePeriodFieldPolicy = {
	amount?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TransactionKeySpecifier = ('amount' | 'created' | 'error' | 'gatewayResponse' | 'id' | 'isSuccess' | 'kind' | 'payment' | 'token' | TransactionKeySpecifier)[];
export type TransactionFieldPolicy = {
	amount?: FieldPolicy<any> | FieldReadFunction<any>,
	created?: FieldPolicy<any> | FieldReadFunction<any>,
	error?: FieldPolicy<any> | FieldReadFunction<any>,
	gatewayResponse?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isSuccess?: FieldPolicy<any> | FieldReadFunction<any>,
	kind?: FieldPolicy<any> | FieldReadFunction<any>,
	payment?: FieldPolicy<any> | FieldReadFunction<any>,
	token?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TransactionActionKeySpecifier = ('actionType' | 'amount' | 'currency' | TransactionActionKeySpecifier)[];
export type TransactionActionFieldPolicy = {
	actionType?: FieldPolicy<any> | FieldReadFunction<any>,
	amount?: FieldPolicy<any> | FieldReadFunction<any>,
	currency?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TransactionCancelationRequestedKeySpecifier = ('action' | 'issuedAt' | 'issuingPrincipal' | 'recipient' | 'transaction' | 'version' | TransactionCancelationRequestedKeySpecifier)[];
export type TransactionCancelationRequestedFieldPolicy = {
	action?: FieldPolicy<any> | FieldReadFunction<any>,
	issuedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	issuingPrincipal?: FieldPolicy<any> | FieldReadFunction<any>,
	recipient?: FieldPolicy<any> | FieldReadFunction<any>,
	transaction?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TransactionChargeRequestedKeySpecifier = ('action' | 'issuedAt' | 'issuingPrincipal' | 'recipient' | 'transaction' | 'version' | TransactionChargeRequestedKeySpecifier)[];
export type TransactionChargeRequestedFieldPolicy = {
	action?: FieldPolicy<any> | FieldReadFunction<any>,
	issuedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	issuingPrincipal?: FieldPolicy<any> | FieldReadFunction<any>,
	recipient?: FieldPolicy<any> | FieldReadFunction<any>,
	transaction?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TransactionCountableConnectionKeySpecifier = ('edges' | 'pageInfo' | 'totalCount' | TransactionCountableConnectionKeySpecifier)[];
export type TransactionCountableConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TransactionCountableEdgeKeySpecifier = ('cursor' | 'node' | TransactionCountableEdgeKeySpecifier)[];
export type TransactionCountableEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TransactionCreateKeySpecifier = ('errors' | 'transaction' | TransactionCreateKeySpecifier)[];
export type TransactionCreateFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	transaction?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TransactionCreateErrorKeySpecifier = ('code' | 'field' | 'message' | TransactionCreateErrorKeySpecifier)[];
export type TransactionCreateErrorFieldPolicy = {
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	field?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TransactionEventKeySpecifier = ('amount' | 'createdAt' | 'createdBy' | 'externalUrl' | 'id' | 'idempotencyKey' | 'message' | 'pspReference' | 'reasonReference' | 'type' | TransactionEventKeySpecifier)[];
export type TransactionEventFieldPolicy = {
	amount?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	createdBy?: FieldPolicy<any> | FieldReadFunction<any>,
	externalUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	idempotencyKey?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>,
	pspReference?: FieldPolicy<any> | FieldReadFunction<any>,
	reasonReference?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TransactionEventReportKeySpecifier = ('alreadyProcessed' | 'errors' | 'transaction' | 'transactionEvent' | TransactionEventReportKeySpecifier)[];
export type TransactionEventReportFieldPolicy = {
	alreadyProcessed?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	transaction?: FieldPolicy<any> | FieldReadFunction<any>,
	transactionEvent?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TransactionEventReportErrorKeySpecifier = ('code' | 'field' | 'message' | TransactionEventReportErrorKeySpecifier)[];
export type TransactionEventReportErrorFieldPolicy = {
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	field?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TransactionInitializeKeySpecifier = ('data' | 'errors' | 'transaction' | 'transactionEvent' | TransactionInitializeKeySpecifier)[];
export type TransactionInitializeFieldPolicy = {
	data?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	transaction?: FieldPolicy<any> | FieldReadFunction<any>,
	transactionEvent?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TransactionInitializeErrorKeySpecifier = ('code' | 'field' | 'message' | TransactionInitializeErrorKeySpecifier)[];
export type TransactionInitializeErrorFieldPolicy = {
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	field?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TransactionInitializeSessionKeySpecifier = ('action' | 'customerIpAddress' | 'data' | 'idempotencyKey' | 'issuedAt' | 'issuingPrincipal' | 'merchantReference' | 'recipient' | 'sourceObject' | 'transaction' | 'version' | TransactionInitializeSessionKeySpecifier)[];
export type TransactionInitializeSessionFieldPolicy = {
	action?: FieldPolicy<any> | FieldReadFunction<any>,
	customerIpAddress?: FieldPolicy<any> | FieldReadFunction<any>,
	data?: FieldPolicy<any> | FieldReadFunction<any>,
	idempotencyKey?: FieldPolicy<any> | FieldReadFunction<any>,
	issuedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	issuingPrincipal?: FieldPolicy<any> | FieldReadFunction<any>,
	merchantReference?: FieldPolicy<any> | FieldReadFunction<any>,
	recipient?: FieldPolicy<any> | FieldReadFunction<any>,
	sourceObject?: FieldPolicy<any> | FieldReadFunction<any>,
	transaction?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TransactionItemKeySpecifier = ('actions' | 'authorizePendingAmount' | 'authorizedAmount' | 'cancelPendingAmount' | 'canceledAmount' | 'chargePendingAmount' | 'chargedAmount' | 'checkout' | 'createdAt' | 'createdBy' | 'events' | 'externalUrl' | 'id' | 'message' | 'metadata' | 'metafield' | 'metafields' | 'modifiedAt' | 'name' | 'order' | 'paymentMethodDetails' | 'privateMetadata' | 'privateMetafield' | 'privateMetafields' | 'pspReference' | 'reason' | 'reasonReference' | 'refundPendingAmount' | 'refundedAmount' | 'token' | TransactionItemKeySpecifier)[];
export type TransactionItemFieldPolicy = {
	actions?: FieldPolicy<any> | FieldReadFunction<any>,
	authorizePendingAmount?: FieldPolicy<any> | FieldReadFunction<any>,
	authorizedAmount?: FieldPolicy<any> | FieldReadFunction<any>,
	cancelPendingAmount?: FieldPolicy<any> | FieldReadFunction<any>,
	canceledAmount?: FieldPolicy<any> | FieldReadFunction<any>,
	chargePendingAmount?: FieldPolicy<any> | FieldReadFunction<any>,
	chargedAmount?: FieldPolicy<any> | FieldReadFunction<any>,
	checkout?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	createdBy?: FieldPolicy<any> | FieldReadFunction<any>,
	events?: FieldPolicy<any> | FieldReadFunction<any>,
	externalUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>,
	metadata?: FieldPolicy<any> | FieldReadFunction<any>,
	metafield?: FieldPolicy<any> | FieldReadFunction<any>,
	metafields?: FieldPolicy<any> | FieldReadFunction<any>,
	modifiedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	order?: FieldPolicy<any> | FieldReadFunction<any>,
	paymentMethodDetails?: FieldPolicy<any> | FieldReadFunction<any>,
	privateMetadata?: FieldPolicy<any> | FieldReadFunction<any>,
	privateMetafield?: FieldPolicy<any> | FieldReadFunction<any>,
	privateMetafields?: FieldPolicy<any> | FieldReadFunction<any>,
	pspReference?: FieldPolicy<any> | FieldReadFunction<any>,
	reason?: FieldPolicy<any> | FieldReadFunction<any>,
	reasonReference?: FieldPolicy<any> | FieldReadFunction<any>,
	refundPendingAmount?: FieldPolicy<any> | FieldReadFunction<any>,
	refundedAmount?: FieldPolicy<any> | FieldReadFunction<any>,
	token?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TransactionItemMetadataUpdatedKeySpecifier = ('issuedAt' | 'issuingPrincipal' | 'recipient' | 'transaction' | 'version' | TransactionItemMetadataUpdatedKeySpecifier)[];
export type TransactionItemMetadataUpdatedFieldPolicy = {
	issuedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	issuingPrincipal?: FieldPolicy<any> | FieldReadFunction<any>,
	recipient?: FieldPolicy<any> | FieldReadFunction<any>,
	transaction?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TransactionProcessKeySpecifier = ('data' | 'errors' | 'transaction' | 'transactionEvent' | TransactionProcessKeySpecifier)[];
export type TransactionProcessFieldPolicy = {
	data?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	transaction?: FieldPolicy<any> | FieldReadFunction<any>,
	transactionEvent?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TransactionProcessActionKeySpecifier = ('actionType' | 'amount' | 'currency' | TransactionProcessActionKeySpecifier)[];
export type TransactionProcessActionFieldPolicy = {
	actionType?: FieldPolicy<any> | FieldReadFunction<any>,
	amount?: FieldPolicy<any> | FieldReadFunction<any>,
	currency?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TransactionProcessErrorKeySpecifier = ('code' | 'field' | 'message' | TransactionProcessErrorKeySpecifier)[];
export type TransactionProcessErrorFieldPolicy = {
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	field?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TransactionProcessSessionKeySpecifier = ('action' | 'customerIpAddress' | 'data' | 'issuedAt' | 'issuingPrincipal' | 'merchantReference' | 'recipient' | 'sourceObject' | 'transaction' | 'version' | TransactionProcessSessionKeySpecifier)[];
export type TransactionProcessSessionFieldPolicy = {
	action?: FieldPolicy<any> | FieldReadFunction<any>,
	customerIpAddress?: FieldPolicy<any> | FieldReadFunction<any>,
	data?: FieldPolicy<any> | FieldReadFunction<any>,
	issuedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	issuingPrincipal?: FieldPolicy<any> | FieldReadFunction<any>,
	merchantReference?: FieldPolicy<any> | FieldReadFunction<any>,
	recipient?: FieldPolicy<any> | FieldReadFunction<any>,
	sourceObject?: FieldPolicy<any> | FieldReadFunction<any>,
	transaction?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TransactionRefundRequestedKeySpecifier = ('action' | 'grantedRefund' | 'issuedAt' | 'issuingPrincipal' | 'recipient' | 'transaction' | 'version' | TransactionRefundRequestedKeySpecifier)[];
export type TransactionRefundRequestedFieldPolicy = {
	action?: FieldPolicy<any> | FieldReadFunction<any>,
	grantedRefund?: FieldPolicy<any> | FieldReadFunction<any>,
	issuedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	issuingPrincipal?: FieldPolicy<any> | FieldReadFunction<any>,
	recipient?: FieldPolicy<any> | FieldReadFunction<any>,
	transaction?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TransactionRequestActionKeySpecifier = ('errors' | 'transaction' | TransactionRequestActionKeySpecifier)[];
export type TransactionRequestActionFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	transaction?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TransactionRequestActionErrorKeySpecifier = ('code' | 'field' | 'message' | TransactionRequestActionErrorKeySpecifier)[];
export type TransactionRequestActionErrorFieldPolicy = {
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	field?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TransactionRequestRefundForGrantedRefundKeySpecifier = ('errors' | 'transaction' | TransactionRequestRefundForGrantedRefundKeySpecifier)[];
export type TransactionRequestRefundForGrantedRefundFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	transaction?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TransactionRequestRefundForGrantedRefundErrorKeySpecifier = ('code' | 'field' | 'message' | TransactionRequestRefundForGrantedRefundErrorKeySpecifier)[];
export type TransactionRequestRefundForGrantedRefundErrorFieldPolicy = {
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	field?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TransactionUpdateKeySpecifier = ('errors' | 'transaction' | TransactionUpdateKeySpecifier)[];
export type TransactionUpdateFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	transaction?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TransactionUpdateErrorKeySpecifier = ('code' | 'field' | 'message' | TransactionUpdateErrorKeySpecifier)[];
export type TransactionUpdateErrorFieldPolicy = {
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	field?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TranslatableItemConnectionKeySpecifier = ('edges' | 'pageInfo' | 'totalCount' | TranslatableItemConnectionKeySpecifier)[];
export type TranslatableItemConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TranslatableItemEdgeKeySpecifier = ('cursor' | 'node' | TranslatableItemEdgeKeySpecifier)[];
export type TranslatableItemEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TranslationCreatedKeySpecifier = ('issuedAt' | 'issuingPrincipal' | 'recipient' | 'translation' | 'version' | TranslationCreatedKeySpecifier)[];
export type TranslationCreatedFieldPolicy = {
	issuedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	issuingPrincipal?: FieldPolicy<any> | FieldReadFunction<any>,
	recipient?: FieldPolicy<any> | FieldReadFunction<any>,
	translation?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TranslationErrorKeySpecifier = ('code' | 'field' | 'message' | TranslationErrorKeySpecifier)[];
export type TranslationErrorFieldPolicy = {
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	field?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TranslationUpdatedKeySpecifier = ('issuedAt' | 'issuingPrincipal' | 'recipient' | 'translation' | 'version' | TranslationUpdatedKeySpecifier)[];
export type TranslationUpdatedFieldPolicy = {
	issuedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	issuingPrincipal?: FieldPolicy<any> | FieldReadFunction<any>,
	recipient?: FieldPolicy<any> | FieldReadFunction<any>,
	translation?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateMetadataKeySpecifier = ('errors' | 'item' | 'metadataErrors' | UpdateMetadataKeySpecifier)[];
export type UpdateMetadataFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	item?: FieldPolicy<any> | FieldReadFunction<any>,
	metadataErrors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdatePrivateMetadataKeySpecifier = ('errors' | 'item' | 'metadataErrors' | UpdatePrivateMetadataKeySpecifier)[];
export type UpdatePrivateMetadataFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	item?: FieldPolicy<any> | FieldReadFunction<any>,
	metadataErrors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UploadErrorKeySpecifier = ('code' | 'field' | 'message' | UploadErrorKeySpecifier)[];
export type UploadErrorFieldPolicy = {
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	field?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UserKeySpecifier = ('accessibleChannels' | 'addresses' | 'avatar' | 'checkout' | 'checkoutIds' | 'checkoutTokens' | 'checkouts' | 'dateJoined' | 'defaultBillingAddress' | 'defaultShippingAddress' | 'editableGroups' | 'email' | 'events' | 'externalReference' | 'firstName' | 'giftCards' | 'id' | 'isActive' | 'isConfirmed' | 'isStaff' | 'languageCode' | 'lastLogin' | 'lastName' | 'metadata' | 'metafield' | 'metafields' | 'note' | 'orders' | 'permissionGroups' | 'privateMetadata' | 'privateMetafield' | 'privateMetafields' | 'restrictedAccessToChannels' | 'storedPaymentMethods' | 'storedPaymentSources' | 'updatedAt' | 'userPermissions' | UserKeySpecifier)[];
export type UserFieldPolicy = {
	accessibleChannels?: FieldPolicy<any> | FieldReadFunction<any>,
	addresses?: FieldPolicy<any> | FieldReadFunction<any>,
	avatar?: FieldPolicy<any> | FieldReadFunction<any>,
	checkout?: FieldPolicy<any> | FieldReadFunction<any>,
	checkoutIds?: FieldPolicy<any> | FieldReadFunction<any>,
	checkoutTokens?: FieldPolicy<any> | FieldReadFunction<any>,
	checkouts?: FieldPolicy<any> | FieldReadFunction<any>,
	dateJoined?: FieldPolicy<any> | FieldReadFunction<any>,
	defaultBillingAddress?: FieldPolicy<any> | FieldReadFunction<any>,
	defaultShippingAddress?: FieldPolicy<any> | FieldReadFunction<any>,
	editableGroups?: FieldPolicy<any> | FieldReadFunction<any>,
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	events?: FieldPolicy<any> | FieldReadFunction<any>,
	externalReference?: FieldPolicy<any> | FieldReadFunction<any>,
	firstName?: FieldPolicy<any> | FieldReadFunction<any>,
	giftCards?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isActive?: FieldPolicy<any> | FieldReadFunction<any>,
	isConfirmed?: FieldPolicy<any> | FieldReadFunction<any>,
	isStaff?: FieldPolicy<any> | FieldReadFunction<any>,
	languageCode?: FieldPolicy<any> | FieldReadFunction<any>,
	lastLogin?: FieldPolicy<any> | FieldReadFunction<any>,
	lastName?: FieldPolicy<any> | FieldReadFunction<any>,
	metadata?: FieldPolicy<any> | FieldReadFunction<any>,
	metafield?: FieldPolicy<any> | FieldReadFunction<any>,
	metafields?: FieldPolicy<any> | FieldReadFunction<any>,
	note?: FieldPolicy<any> | FieldReadFunction<any>,
	orders?: FieldPolicy<any> | FieldReadFunction<any>,
	permissionGroups?: FieldPolicy<any> | FieldReadFunction<any>,
	privateMetadata?: FieldPolicy<any> | FieldReadFunction<any>,
	privateMetafield?: FieldPolicy<any> | FieldReadFunction<any>,
	privateMetafields?: FieldPolicy<any> | FieldReadFunction<any>,
	restrictedAccessToChannels?: FieldPolicy<any> | FieldReadFunction<any>,
	storedPaymentMethods?: FieldPolicy<any> | FieldReadFunction<any>,
	storedPaymentSources?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	userPermissions?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UserAvatarDeleteKeySpecifier = ('accountErrors' | 'errors' | 'user' | UserAvatarDeleteKeySpecifier)[];
export type UserAvatarDeleteFieldPolicy = {
	accountErrors?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UserAvatarUpdateKeySpecifier = ('accountErrors' | 'errors' | 'user' | UserAvatarUpdateKeySpecifier)[];
export type UserAvatarUpdateFieldPolicy = {
	accountErrors?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UserBulkSetActiveKeySpecifier = ('accountErrors' | 'count' | 'errors' | UserBulkSetActiveKeySpecifier)[];
export type UserBulkSetActiveFieldPolicy = {
	accountErrors?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UserCountableConnectionKeySpecifier = ('edges' | 'pageInfo' | 'totalCount' | UserCountableConnectionKeySpecifier)[];
export type UserCountableConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UserCountableEdgeKeySpecifier = ('cursor' | 'node' | UserCountableEdgeKeySpecifier)[];
export type UserCountableEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UserPermissionKeySpecifier = ('code' | 'name' | 'sourcePermissionGroups' | UserPermissionKeySpecifier)[];
export type UserPermissionFieldPolicy = {
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	sourcePermissionGroups?: FieldPolicy<any> | FieldReadFunction<any>
};
export type VATKeySpecifier = ('countryCode' | 'reducedRates' | 'standardRate' | VATKeySpecifier)[];
export type VATFieldPolicy = {
	countryCode?: FieldPolicy<any> | FieldReadFunction<any>,
	reducedRates?: FieldPolicy<any> | FieldReadFunction<any>,
	standardRate?: FieldPolicy<any> | FieldReadFunction<any>
};
export type VariantMediaAssignKeySpecifier = ('errors' | 'media' | 'productErrors' | 'productVariant' | VariantMediaAssignKeySpecifier)[];
export type VariantMediaAssignFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	media?: FieldPolicy<any> | FieldReadFunction<any>,
	productErrors?: FieldPolicy<any> | FieldReadFunction<any>,
	productVariant?: FieldPolicy<any> | FieldReadFunction<any>
};
export type VariantMediaUnassignKeySpecifier = ('errors' | 'media' | 'productErrors' | 'productVariant' | VariantMediaUnassignKeySpecifier)[];
export type VariantMediaUnassignFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	media?: FieldPolicy<any> | FieldReadFunction<any>,
	productErrors?: FieldPolicy<any> | FieldReadFunction<any>,
	productVariant?: FieldPolicy<any> | FieldReadFunction<any>
};
export type VariantPricingInfoKeySpecifier = ('discount' | 'discountLocalCurrency' | 'discountPrior' | 'onSale' | 'price' | 'priceLocalCurrency' | 'pricePrior' | 'priceUndiscounted' | VariantPricingInfoKeySpecifier)[];
export type VariantPricingInfoFieldPolicy = {
	discount?: FieldPolicy<any> | FieldReadFunction<any>,
	discountLocalCurrency?: FieldPolicy<any> | FieldReadFunction<any>,
	discountPrior?: FieldPolicy<any> | FieldReadFunction<any>,
	onSale?: FieldPolicy<any> | FieldReadFunction<any>,
	price?: FieldPolicy<any> | FieldReadFunction<any>,
	priceLocalCurrency?: FieldPolicy<any> | FieldReadFunction<any>,
	pricePrior?: FieldPolicy<any> | FieldReadFunction<any>,
	priceUndiscounted?: FieldPolicy<any> | FieldReadFunction<any>
};
export type VerifyTokenKeySpecifier = ('accountErrors' | 'errors' | 'isValid' | 'payload' | 'user' | VerifyTokenKeySpecifier)[];
export type VerifyTokenFieldPolicy = {
	accountErrors?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	isValid?: FieldPolicy<any> | FieldReadFunction<any>,
	payload?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>
};
export type VoucherKeySpecifier = ('applyOncePerCustomer' | 'applyOncePerOrder' | 'categories' | 'channelListings' | 'code' | 'codes' | 'collections' | 'countries' | 'currency' | 'discountValue' | 'discountValueType' | 'endDate' | 'id' | 'metadata' | 'metafield' | 'metafields' | 'minCheckoutItemsQuantity' | 'minSpent' | 'name' | 'onlyForStaff' | 'privateMetadata' | 'privateMetafield' | 'privateMetafields' | 'products' | 'singleUse' | 'startDate' | 'translation' | 'type' | 'usageLimit' | 'used' | 'variants' | VoucherKeySpecifier)[];
export type VoucherFieldPolicy = {
	applyOncePerCustomer?: FieldPolicy<any> | FieldReadFunction<any>,
	applyOncePerOrder?: FieldPolicy<any> | FieldReadFunction<any>,
	categories?: FieldPolicy<any> | FieldReadFunction<any>,
	channelListings?: FieldPolicy<any> | FieldReadFunction<any>,
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	codes?: FieldPolicy<any> | FieldReadFunction<any>,
	collections?: FieldPolicy<any> | FieldReadFunction<any>,
	countries?: FieldPolicy<any> | FieldReadFunction<any>,
	currency?: FieldPolicy<any> | FieldReadFunction<any>,
	discountValue?: FieldPolicy<any> | FieldReadFunction<any>,
	discountValueType?: FieldPolicy<any> | FieldReadFunction<any>,
	endDate?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	metadata?: FieldPolicy<any> | FieldReadFunction<any>,
	metafield?: FieldPolicy<any> | FieldReadFunction<any>,
	metafields?: FieldPolicy<any> | FieldReadFunction<any>,
	minCheckoutItemsQuantity?: FieldPolicy<any> | FieldReadFunction<any>,
	minSpent?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	onlyForStaff?: FieldPolicy<any> | FieldReadFunction<any>,
	privateMetadata?: FieldPolicy<any> | FieldReadFunction<any>,
	privateMetafield?: FieldPolicy<any> | FieldReadFunction<any>,
	privateMetafields?: FieldPolicy<any> | FieldReadFunction<any>,
	products?: FieldPolicy<any> | FieldReadFunction<any>,
	singleUse?: FieldPolicy<any> | FieldReadFunction<any>,
	startDate?: FieldPolicy<any> | FieldReadFunction<any>,
	translation?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	usageLimit?: FieldPolicy<any> | FieldReadFunction<any>,
	used?: FieldPolicy<any> | FieldReadFunction<any>,
	variants?: FieldPolicy<any> | FieldReadFunction<any>
};
export type VoucherAddCataloguesKeySpecifier = ('discountErrors' | 'errors' | 'voucher' | VoucherAddCataloguesKeySpecifier)[];
export type VoucherAddCataloguesFieldPolicy = {
	discountErrors?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	voucher?: FieldPolicy<any> | FieldReadFunction<any>
};
export type VoucherBulkDeleteKeySpecifier = ('count' | 'discountErrors' | 'errors' | VoucherBulkDeleteKeySpecifier)[];
export type VoucherBulkDeleteFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	discountErrors?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type VoucherChannelListingKeySpecifier = ('channel' | 'currency' | 'discountValue' | 'id' | 'minSpent' | VoucherChannelListingKeySpecifier)[];
export type VoucherChannelListingFieldPolicy = {
	channel?: FieldPolicy<any> | FieldReadFunction<any>,
	currency?: FieldPolicy<any> | FieldReadFunction<any>,
	discountValue?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	minSpent?: FieldPolicy<any> | FieldReadFunction<any>
};
export type VoucherChannelListingUpdateKeySpecifier = ('discountErrors' | 'errors' | 'voucher' | VoucherChannelListingUpdateKeySpecifier)[];
export type VoucherChannelListingUpdateFieldPolicy = {
	discountErrors?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	voucher?: FieldPolicy<any> | FieldReadFunction<any>
};
export type VoucherCodeKeySpecifier = ('code' | 'createdAt' | 'id' | 'isActive' | 'used' | VoucherCodeKeySpecifier)[];
export type VoucherCodeFieldPolicy = {
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isActive?: FieldPolicy<any> | FieldReadFunction<any>,
	used?: FieldPolicy<any> | FieldReadFunction<any>
};
export type VoucherCodeBulkDeleteKeySpecifier = ('count' | 'errors' | VoucherCodeBulkDeleteKeySpecifier)[];
export type VoucherCodeBulkDeleteFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type VoucherCodeBulkDeleteErrorKeySpecifier = ('code' | 'message' | 'path' | 'voucherCodes' | VoucherCodeBulkDeleteErrorKeySpecifier)[];
export type VoucherCodeBulkDeleteErrorFieldPolicy = {
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>,
	path?: FieldPolicy<any> | FieldReadFunction<any>,
	voucherCodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type VoucherCodeCountableConnectionKeySpecifier = ('edges' | 'pageInfo' | 'totalCount' | VoucherCodeCountableConnectionKeySpecifier)[];
export type VoucherCodeCountableConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type VoucherCodeCountableEdgeKeySpecifier = ('cursor' | 'node' | VoucherCodeCountableEdgeKeySpecifier)[];
export type VoucherCodeCountableEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type VoucherCodeExportCompletedKeySpecifier = ('export' | 'issuedAt' | 'issuingPrincipal' | 'recipient' | 'version' | VoucherCodeExportCompletedKeySpecifier)[];
export type VoucherCodeExportCompletedFieldPolicy = {
	export?: FieldPolicy<any> | FieldReadFunction<any>,
	issuedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	issuingPrincipal?: FieldPolicy<any> | FieldReadFunction<any>,
	recipient?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type VoucherCodesCreatedKeySpecifier = ('issuedAt' | 'issuingPrincipal' | 'recipient' | 'version' | 'voucherCodes' | VoucherCodesCreatedKeySpecifier)[];
export type VoucherCodesCreatedFieldPolicy = {
	issuedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	issuingPrincipal?: FieldPolicy<any> | FieldReadFunction<any>,
	recipient?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>,
	voucherCodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type VoucherCodesDeletedKeySpecifier = ('issuedAt' | 'issuingPrincipal' | 'recipient' | 'version' | 'voucherCodes' | VoucherCodesDeletedKeySpecifier)[];
export type VoucherCodesDeletedFieldPolicy = {
	issuedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	issuingPrincipal?: FieldPolicy<any> | FieldReadFunction<any>,
	recipient?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>,
	voucherCodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type VoucherCountableConnectionKeySpecifier = ('edges' | 'pageInfo' | 'totalCount' | VoucherCountableConnectionKeySpecifier)[];
export type VoucherCountableConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type VoucherCountableEdgeKeySpecifier = ('cursor' | 'node' | VoucherCountableEdgeKeySpecifier)[];
export type VoucherCountableEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type VoucherCreateKeySpecifier = ('discountErrors' | 'errors' | 'voucher' | VoucherCreateKeySpecifier)[];
export type VoucherCreateFieldPolicy = {
	discountErrors?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	voucher?: FieldPolicy<any> | FieldReadFunction<any>
};
export type VoucherCreatedKeySpecifier = ('issuedAt' | 'issuingPrincipal' | 'recipient' | 'version' | 'voucher' | VoucherCreatedKeySpecifier)[];
export type VoucherCreatedFieldPolicy = {
	issuedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	issuingPrincipal?: FieldPolicy<any> | FieldReadFunction<any>,
	recipient?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>,
	voucher?: FieldPolicy<any> | FieldReadFunction<any>
};
export type VoucherDeleteKeySpecifier = ('discountErrors' | 'errors' | 'voucher' | VoucherDeleteKeySpecifier)[];
export type VoucherDeleteFieldPolicy = {
	discountErrors?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	voucher?: FieldPolicy<any> | FieldReadFunction<any>
};
export type VoucherDeletedKeySpecifier = ('issuedAt' | 'issuingPrincipal' | 'recipient' | 'version' | 'voucher' | VoucherDeletedKeySpecifier)[];
export type VoucherDeletedFieldPolicy = {
	issuedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	issuingPrincipal?: FieldPolicy<any> | FieldReadFunction<any>,
	recipient?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>,
	voucher?: FieldPolicy<any> | FieldReadFunction<any>
};
export type VoucherMetadataUpdatedKeySpecifier = ('issuedAt' | 'issuingPrincipal' | 'recipient' | 'version' | 'voucher' | VoucherMetadataUpdatedKeySpecifier)[];
export type VoucherMetadataUpdatedFieldPolicy = {
	issuedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	issuingPrincipal?: FieldPolicy<any> | FieldReadFunction<any>,
	recipient?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>,
	voucher?: FieldPolicy<any> | FieldReadFunction<any>
};
export type VoucherRemoveCataloguesKeySpecifier = ('discountErrors' | 'errors' | 'voucher' | VoucherRemoveCataloguesKeySpecifier)[];
export type VoucherRemoveCataloguesFieldPolicy = {
	discountErrors?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	voucher?: FieldPolicy<any> | FieldReadFunction<any>
};
export type VoucherTranslatableContentKeySpecifier = ('id' | 'name' | 'translation' | 'voucher' | 'voucherId' | VoucherTranslatableContentKeySpecifier)[];
export type VoucherTranslatableContentFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	translation?: FieldPolicy<any> | FieldReadFunction<any>,
	voucher?: FieldPolicy<any> | FieldReadFunction<any>,
	voucherId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type VoucherTranslateKeySpecifier = ('errors' | 'translationErrors' | 'voucher' | VoucherTranslateKeySpecifier)[];
export type VoucherTranslateFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	translationErrors?: FieldPolicy<any> | FieldReadFunction<any>,
	voucher?: FieldPolicy<any> | FieldReadFunction<any>
};
export type VoucherTranslationKeySpecifier = ('id' | 'language' | 'name' | 'translatableContent' | VoucherTranslationKeySpecifier)[];
export type VoucherTranslationFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	language?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	translatableContent?: FieldPolicy<any> | FieldReadFunction<any>
};
export type VoucherUpdateKeySpecifier = ('discountErrors' | 'errors' | 'voucher' | VoucherUpdateKeySpecifier)[];
export type VoucherUpdateFieldPolicy = {
	discountErrors?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	voucher?: FieldPolicy<any> | FieldReadFunction<any>
};
export type VoucherUpdatedKeySpecifier = ('issuedAt' | 'issuingPrincipal' | 'recipient' | 'version' | 'voucher' | VoucherUpdatedKeySpecifier)[];
export type VoucherUpdatedFieldPolicy = {
	issuedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	issuingPrincipal?: FieldPolicy<any> | FieldReadFunction<any>,
	recipient?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>,
	voucher?: FieldPolicy<any> | FieldReadFunction<any>
};
export type WarehouseKeySpecifier = ('address' | 'clickAndCollectOption' | 'companyName' | 'email' | 'externalReference' | 'id' | 'isPrivate' | 'metadata' | 'metafield' | 'metafields' | 'name' | 'privateMetadata' | 'privateMetafield' | 'privateMetafields' | 'shippingZones' | 'slug' | 'stocks' | WarehouseKeySpecifier)[];
export type WarehouseFieldPolicy = {
	address?: FieldPolicy<any> | FieldReadFunction<any>,
	clickAndCollectOption?: FieldPolicy<any> | FieldReadFunction<any>,
	companyName?: FieldPolicy<any> | FieldReadFunction<any>,
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	externalReference?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isPrivate?: FieldPolicy<any> | FieldReadFunction<any>,
	metadata?: FieldPolicy<any> | FieldReadFunction<any>,
	metafield?: FieldPolicy<any> | FieldReadFunction<any>,
	metafields?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	privateMetadata?: FieldPolicy<any> | FieldReadFunction<any>,
	privateMetafield?: FieldPolicy<any> | FieldReadFunction<any>,
	privateMetafields?: FieldPolicy<any> | FieldReadFunction<any>,
	shippingZones?: FieldPolicy<any> | FieldReadFunction<any>,
	slug?: FieldPolicy<any> | FieldReadFunction<any>,
	stocks?: FieldPolicy<any> | FieldReadFunction<any>
};
export type WarehouseCountableConnectionKeySpecifier = ('edges' | 'pageInfo' | 'totalCount' | WarehouseCountableConnectionKeySpecifier)[];
export type WarehouseCountableConnectionFieldPolicy = {
	edges?: FieldPolicy<any> | FieldReadFunction<any>,
	pageInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	totalCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type WarehouseCountableEdgeKeySpecifier = ('cursor' | 'node' | WarehouseCountableEdgeKeySpecifier)[];
export type WarehouseCountableEdgeFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	node?: FieldPolicy<any> | FieldReadFunction<any>
};
export type WarehouseCreateKeySpecifier = ('errors' | 'warehouse' | 'warehouseErrors' | WarehouseCreateKeySpecifier)[];
export type WarehouseCreateFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	warehouse?: FieldPolicy<any> | FieldReadFunction<any>,
	warehouseErrors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type WarehouseCreatedKeySpecifier = ('issuedAt' | 'issuingPrincipal' | 'recipient' | 'version' | 'warehouse' | WarehouseCreatedKeySpecifier)[];
export type WarehouseCreatedFieldPolicy = {
	issuedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	issuingPrincipal?: FieldPolicy<any> | FieldReadFunction<any>,
	recipient?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>,
	warehouse?: FieldPolicy<any> | FieldReadFunction<any>
};
export type WarehouseDeleteKeySpecifier = ('errors' | 'warehouse' | 'warehouseErrors' | WarehouseDeleteKeySpecifier)[];
export type WarehouseDeleteFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	warehouse?: FieldPolicy<any> | FieldReadFunction<any>,
	warehouseErrors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type WarehouseDeletedKeySpecifier = ('issuedAt' | 'issuingPrincipal' | 'recipient' | 'version' | 'warehouse' | WarehouseDeletedKeySpecifier)[];
export type WarehouseDeletedFieldPolicy = {
	issuedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	issuingPrincipal?: FieldPolicy<any> | FieldReadFunction<any>,
	recipient?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>,
	warehouse?: FieldPolicy<any> | FieldReadFunction<any>
};
export type WarehouseErrorKeySpecifier = ('code' | 'field' | 'message' | 'shippingZones' | WarehouseErrorKeySpecifier)[];
export type WarehouseErrorFieldPolicy = {
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	field?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>,
	shippingZones?: FieldPolicy<any> | FieldReadFunction<any>
};
export type WarehouseMetadataUpdatedKeySpecifier = ('issuedAt' | 'issuingPrincipal' | 'recipient' | 'version' | 'warehouse' | WarehouseMetadataUpdatedKeySpecifier)[];
export type WarehouseMetadataUpdatedFieldPolicy = {
	issuedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	issuingPrincipal?: FieldPolicy<any> | FieldReadFunction<any>,
	recipient?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>,
	warehouse?: FieldPolicy<any> | FieldReadFunction<any>
};
export type WarehouseShippingZoneAssignKeySpecifier = ('errors' | 'warehouse' | 'warehouseErrors' | WarehouseShippingZoneAssignKeySpecifier)[];
export type WarehouseShippingZoneAssignFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	warehouse?: FieldPolicy<any> | FieldReadFunction<any>,
	warehouseErrors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type WarehouseShippingZoneUnassignKeySpecifier = ('errors' | 'warehouse' | 'warehouseErrors' | WarehouseShippingZoneUnassignKeySpecifier)[];
export type WarehouseShippingZoneUnassignFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	warehouse?: FieldPolicy<any> | FieldReadFunction<any>,
	warehouseErrors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type WarehouseUpdateKeySpecifier = ('errors' | 'warehouse' | 'warehouseErrors' | WarehouseUpdateKeySpecifier)[];
export type WarehouseUpdateFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	warehouse?: FieldPolicy<any> | FieldReadFunction<any>,
	warehouseErrors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type WarehouseUpdatedKeySpecifier = ('issuedAt' | 'issuingPrincipal' | 'recipient' | 'version' | 'warehouse' | WarehouseUpdatedKeySpecifier)[];
export type WarehouseUpdatedFieldPolicy = {
	issuedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	issuingPrincipal?: FieldPolicy<any> | FieldReadFunction<any>,
	recipient?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>,
	warehouse?: FieldPolicy<any> | FieldReadFunction<any>
};
export type WebhookKeySpecifier = ('app' | 'asyncEvents' | 'customHeaders' | 'eventDeliveries' | 'events' | 'id' | 'isActive' | 'name' | 'secretKey' | 'subscriptionQuery' | 'syncEvents' | 'targetUrl' | WebhookKeySpecifier)[];
export type WebhookFieldPolicy = {
	app?: FieldPolicy<any> | FieldReadFunction<any>,
	asyncEvents?: FieldPolicy<any> | FieldReadFunction<any>,
	customHeaders?: FieldPolicy<any> | FieldReadFunction<any>,
	eventDeliveries?: FieldPolicy<any> | FieldReadFunction<any>,
	events?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isActive?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	secretKey?: FieldPolicy<any> | FieldReadFunction<any>,
	subscriptionQuery?: FieldPolicy<any> | FieldReadFunction<any>,
	syncEvents?: FieldPolicy<any> | FieldReadFunction<any>,
	targetUrl?: FieldPolicy<any> | FieldReadFunction<any>
};
export type WebhookCreateKeySpecifier = ('errors' | 'webhook' | 'webhookErrors' | WebhookCreateKeySpecifier)[];
export type WebhookCreateFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	webhook?: FieldPolicy<any> | FieldReadFunction<any>,
	webhookErrors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type WebhookDeleteKeySpecifier = ('errors' | 'webhook' | 'webhookErrors' | WebhookDeleteKeySpecifier)[];
export type WebhookDeleteFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	webhook?: FieldPolicy<any> | FieldReadFunction<any>,
	webhookErrors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type WebhookDryRunKeySpecifier = ('errors' | 'payload' | WebhookDryRunKeySpecifier)[];
export type WebhookDryRunFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	payload?: FieldPolicy<any> | FieldReadFunction<any>
};
export type WebhookDryRunErrorKeySpecifier = ('code' | 'field' | 'message' | WebhookDryRunErrorKeySpecifier)[];
export type WebhookDryRunErrorFieldPolicy = {
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	field?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>
};
export type WebhookErrorKeySpecifier = ('code' | 'field' | 'message' | WebhookErrorKeySpecifier)[];
export type WebhookErrorFieldPolicy = {
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	field?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>
};
export type WebhookEventKeySpecifier = ('eventType' | 'name' | WebhookEventKeySpecifier)[];
export type WebhookEventFieldPolicy = {
	eventType?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>
};
export type WebhookEventAsyncKeySpecifier = ('eventType' | 'name' | WebhookEventAsyncKeySpecifier)[];
export type WebhookEventAsyncFieldPolicy = {
	eventType?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>
};
export type WebhookEventSyncKeySpecifier = ('eventType' | 'name' | WebhookEventSyncKeySpecifier)[];
export type WebhookEventSyncFieldPolicy = {
	eventType?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>
};
export type WebhookTriggerKeySpecifier = ('delivery' | 'errors' | WebhookTriggerKeySpecifier)[];
export type WebhookTriggerFieldPolicy = {
	delivery?: FieldPolicy<any> | FieldReadFunction<any>,
	errors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type WebhookTriggerErrorKeySpecifier = ('code' | 'field' | 'message' | WebhookTriggerErrorKeySpecifier)[];
export type WebhookTriggerErrorFieldPolicy = {
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	field?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>
};
export type WebhookUpdateKeySpecifier = ('errors' | 'webhook' | 'webhookErrors' | WebhookUpdateKeySpecifier)[];
export type WebhookUpdateFieldPolicy = {
	errors?: FieldPolicy<any> | FieldReadFunction<any>,
	webhook?: FieldPolicy<any> | FieldReadFunction<any>,
	webhookErrors?: FieldPolicy<any> | FieldReadFunction<any>
};
export type WeightKeySpecifier = ('unit' | 'value' | WeightKeySpecifier)[];
export type WeightFieldPolicy = {
	unit?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type WidgetTargetOptionsKeySpecifier = ('method' | WidgetTargetOptionsKeySpecifier)[];
export type WidgetTargetOptionsFieldPolicy = {
	method?: FieldPolicy<any> | FieldReadFunction<any>
};
export type _ServiceKeySpecifier = ('sdl' | _ServiceKeySpecifier)[];
export type _ServiceFieldPolicy = {
	sdl?: FieldPolicy<any> | FieldReadFunction<any>
};
export type StrictTypedTypePolicies = {
	AccountAddressCreate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AccountAddressCreateKeySpecifier | (() => undefined | AccountAddressCreateKeySpecifier),
		fields?: AccountAddressCreateFieldPolicy,
	},
	AccountAddressDelete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AccountAddressDeleteKeySpecifier | (() => undefined | AccountAddressDeleteKeySpecifier),
		fields?: AccountAddressDeleteFieldPolicy,
	},
	AccountAddressUpdate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AccountAddressUpdateKeySpecifier | (() => undefined | AccountAddressUpdateKeySpecifier),
		fields?: AccountAddressUpdateFieldPolicy,
	},
	AccountChangeEmailRequested?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AccountChangeEmailRequestedKeySpecifier | (() => undefined | AccountChangeEmailRequestedKeySpecifier),
		fields?: AccountChangeEmailRequestedFieldPolicy,
	},
	AccountConfirmationRequested?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AccountConfirmationRequestedKeySpecifier | (() => undefined | AccountConfirmationRequestedKeySpecifier),
		fields?: AccountConfirmationRequestedFieldPolicy,
	},
	AccountConfirmed?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AccountConfirmedKeySpecifier | (() => undefined | AccountConfirmedKeySpecifier),
		fields?: AccountConfirmedFieldPolicy,
	},
	AccountDelete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AccountDeleteKeySpecifier | (() => undefined | AccountDeleteKeySpecifier),
		fields?: AccountDeleteFieldPolicy,
	},
	AccountDeleteRequested?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AccountDeleteRequestedKeySpecifier | (() => undefined | AccountDeleteRequestedKeySpecifier),
		fields?: AccountDeleteRequestedFieldPolicy,
	},
	AccountDeleted?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AccountDeletedKeySpecifier | (() => undefined | AccountDeletedKeySpecifier),
		fields?: AccountDeletedFieldPolicy,
	},
	AccountEmailChanged?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AccountEmailChangedKeySpecifier | (() => undefined | AccountEmailChangedKeySpecifier),
		fields?: AccountEmailChangedFieldPolicy,
	},
	AccountError?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AccountErrorKeySpecifier | (() => undefined | AccountErrorKeySpecifier),
		fields?: AccountErrorFieldPolicy,
	},
	AccountRegister?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AccountRegisterKeySpecifier | (() => undefined | AccountRegisterKeySpecifier),
		fields?: AccountRegisterFieldPolicy,
	},
	AccountRequestDeletion?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AccountRequestDeletionKeySpecifier | (() => undefined | AccountRequestDeletionKeySpecifier),
		fields?: AccountRequestDeletionFieldPolicy,
	},
	AccountSetDefaultAddress?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AccountSetDefaultAddressKeySpecifier | (() => undefined | AccountSetDefaultAddressKeySpecifier),
		fields?: AccountSetDefaultAddressFieldPolicy,
	},
	AccountSetPasswordRequested?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AccountSetPasswordRequestedKeySpecifier | (() => undefined | AccountSetPasswordRequestedKeySpecifier),
		fields?: AccountSetPasswordRequestedFieldPolicy,
	},
	AccountUpdate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AccountUpdateKeySpecifier | (() => undefined | AccountUpdateKeySpecifier),
		fields?: AccountUpdateFieldPolicy,
	},
	Address?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AddressKeySpecifier | (() => undefined | AddressKeySpecifier),
		fields?: AddressFieldPolicy,
	},
	AddressCreate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AddressCreateKeySpecifier | (() => undefined | AddressCreateKeySpecifier),
		fields?: AddressCreateFieldPolicy,
	},
	AddressCreated?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AddressCreatedKeySpecifier | (() => undefined | AddressCreatedKeySpecifier),
		fields?: AddressCreatedFieldPolicy,
	},
	AddressDelete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AddressDeleteKeySpecifier | (() => undefined | AddressDeleteKeySpecifier),
		fields?: AddressDeleteFieldPolicy,
	},
	AddressDeleted?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AddressDeletedKeySpecifier | (() => undefined | AddressDeletedKeySpecifier),
		fields?: AddressDeletedFieldPolicy,
	},
	AddressSetDefault?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AddressSetDefaultKeySpecifier | (() => undefined | AddressSetDefaultKeySpecifier),
		fields?: AddressSetDefaultFieldPolicy,
	},
	AddressUpdate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AddressUpdateKeySpecifier | (() => undefined | AddressUpdateKeySpecifier),
		fields?: AddressUpdateFieldPolicy,
	},
	AddressUpdated?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AddressUpdatedKeySpecifier | (() => undefined | AddressUpdatedKeySpecifier),
		fields?: AddressUpdatedFieldPolicy,
	},
	AddressValidationData?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AddressValidationDataKeySpecifier | (() => undefined | AddressValidationDataKeySpecifier),
		fields?: AddressValidationDataFieldPolicy,
	},
	Allocation?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AllocationKeySpecifier | (() => undefined | AllocationKeySpecifier),
		fields?: AllocationFieldPolicy,
	},
	App?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AppKeySpecifier | (() => undefined | AppKeySpecifier),
		fields?: AppFieldPolicy,
	},
	AppActivate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AppActivateKeySpecifier | (() => undefined | AppActivateKeySpecifier),
		fields?: AppActivateFieldPolicy,
	},
	AppBrand?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AppBrandKeySpecifier | (() => undefined | AppBrandKeySpecifier),
		fields?: AppBrandFieldPolicy,
	},
	AppBrandLogo?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AppBrandLogoKeySpecifier | (() => undefined | AppBrandLogoKeySpecifier),
		fields?: AppBrandLogoFieldPolicy,
	},
	AppCountableConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AppCountableConnectionKeySpecifier | (() => undefined | AppCountableConnectionKeySpecifier),
		fields?: AppCountableConnectionFieldPolicy,
	},
	AppCountableEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AppCountableEdgeKeySpecifier | (() => undefined | AppCountableEdgeKeySpecifier),
		fields?: AppCountableEdgeFieldPolicy,
	},
	AppCreate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AppCreateKeySpecifier | (() => undefined | AppCreateKeySpecifier),
		fields?: AppCreateFieldPolicy,
	},
	AppDeactivate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AppDeactivateKeySpecifier | (() => undefined | AppDeactivateKeySpecifier),
		fields?: AppDeactivateFieldPolicy,
	},
	AppDelete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AppDeleteKeySpecifier | (() => undefined | AppDeleteKeySpecifier),
		fields?: AppDeleteFieldPolicy,
	},
	AppDeleteFailedInstallation?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AppDeleteFailedInstallationKeySpecifier | (() => undefined | AppDeleteFailedInstallationKeySpecifier),
		fields?: AppDeleteFailedInstallationFieldPolicy,
	},
	AppDeleted?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AppDeletedKeySpecifier | (() => undefined | AppDeletedKeySpecifier),
		fields?: AppDeletedFieldPolicy,
	},
	AppError?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AppErrorKeySpecifier | (() => undefined | AppErrorKeySpecifier),
		fields?: AppErrorFieldPolicy,
	},
	AppExtension?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AppExtensionKeySpecifier | (() => undefined | AppExtensionKeySpecifier),
		fields?: AppExtensionFieldPolicy,
	},
	AppExtensionCountableConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AppExtensionCountableConnectionKeySpecifier | (() => undefined | AppExtensionCountableConnectionKeySpecifier),
		fields?: AppExtensionCountableConnectionFieldPolicy,
	},
	AppExtensionCountableEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AppExtensionCountableEdgeKeySpecifier | (() => undefined | AppExtensionCountableEdgeKeySpecifier),
		fields?: AppExtensionCountableEdgeFieldPolicy,
	},
	AppExtensionOptionsNewTab?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AppExtensionOptionsNewTabKeySpecifier | (() => undefined | AppExtensionOptionsNewTabKeySpecifier),
		fields?: AppExtensionOptionsNewTabFieldPolicy,
	},
	AppExtensionOptionsWidget?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AppExtensionOptionsWidgetKeySpecifier | (() => undefined | AppExtensionOptionsWidgetKeySpecifier),
		fields?: AppExtensionOptionsWidgetFieldPolicy,
	},
	AppFetchManifest?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AppFetchManifestKeySpecifier | (() => undefined | AppFetchManifestKeySpecifier),
		fields?: AppFetchManifestFieldPolicy,
	},
	AppInstall?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AppInstallKeySpecifier | (() => undefined | AppInstallKeySpecifier),
		fields?: AppInstallFieldPolicy,
	},
	AppInstallation?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AppInstallationKeySpecifier | (() => undefined | AppInstallationKeySpecifier),
		fields?: AppInstallationFieldPolicy,
	},
	AppInstalled?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AppInstalledKeySpecifier | (() => undefined | AppInstalledKeySpecifier),
		fields?: AppInstalledFieldPolicy,
	},
	AppManifestBrand?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AppManifestBrandKeySpecifier | (() => undefined | AppManifestBrandKeySpecifier),
		fields?: AppManifestBrandFieldPolicy,
	},
	AppManifestBrandLogo?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AppManifestBrandLogoKeySpecifier | (() => undefined | AppManifestBrandLogoKeySpecifier),
		fields?: AppManifestBrandLogoFieldPolicy,
	},
	AppManifestExtension?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AppManifestExtensionKeySpecifier | (() => undefined | AppManifestExtensionKeySpecifier),
		fields?: AppManifestExtensionFieldPolicy,
	},
	AppManifestRequiredSaleorVersion?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AppManifestRequiredSaleorVersionKeySpecifier | (() => undefined | AppManifestRequiredSaleorVersionKeySpecifier),
		fields?: AppManifestRequiredSaleorVersionFieldPolicy,
	},
	AppManifestWebhook?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AppManifestWebhookKeySpecifier | (() => undefined | AppManifestWebhookKeySpecifier),
		fields?: AppManifestWebhookFieldPolicy,
	},
	AppProblem?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AppProblemKeySpecifier | (() => undefined | AppProblemKeySpecifier),
		fields?: AppProblemFieldPolicy,
	},
	AppProblemCreate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AppProblemCreateKeySpecifier | (() => undefined | AppProblemCreateKeySpecifier),
		fields?: AppProblemCreateFieldPolicy,
	},
	AppProblemCreateError?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AppProblemCreateErrorKeySpecifier | (() => undefined | AppProblemCreateErrorKeySpecifier),
		fields?: AppProblemCreateErrorFieldPolicy,
	},
	AppProblemDismiss?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AppProblemDismissKeySpecifier | (() => undefined | AppProblemDismissKeySpecifier),
		fields?: AppProblemDismissFieldPolicy,
	},
	AppProblemDismissError?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AppProblemDismissErrorKeySpecifier | (() => undefined | AppProblemDismissErrorKeySpecifier),
		fields?: AppProblemDismissErrorFieldPolicy,
	},
	AppProblemDismissed?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AppProblemDismissedKeySpecifier | (() => undefined | AppProblemDismissedKeySpecifier),
		fields?: AppProblemDismissedFieldPolicy,
	},
	AppReenableSyncWebhooks?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AppReenableSyncWebhooksKeySpecifier | (() => undefined | AppReenableSyncWebhooksKeySpecifier),
		fields?: AppReenableSyncWebhooksFieldPolicy,
	},
	AppRetryInstall?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AppRetryInstallKeySpecifier | (() => undefined | AppRetryInstallKeySpecifier),
		fields?: AppRetryInstallFieldPolicy,
	},
	AppStatusChanged?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AppStatusChangedKeySpecifier | (() => undefined | AppStatusChangedKeySpecifier),
		fields?: AppStatusChangedFieldPolicy,
	},
	AppToken?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AppTokenKeySpecifier | (() => undefined | AppTokenKeySpecifier),
		fields?: AppTokenFieldPolicy,
	},
	AppTokenCreate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AppTokenCreateKeySpecifier | (() => undefined | AppTokenCreateKeySpecifier),
		fields?: AppTokenCreateFieldPolicy,
	},
	AppTokenDelete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AppTokenDeleteKeySpecifier | (() => undefined | AppTokenDeleteKeySpecifier),
		fields?: AppTokenDeleteFieldPolicy,
	},
	AppTokenVerify?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AppTokenVerifyKeySpecifier | (() => undefined | AppTokenVerifyKeySpecifier),
		fields?: AppTokenVerifyFieldPolicy,
	},
	AppUpdate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AppUpdateKeySpecifier | (() => undefined | AppUpdateKeySpecifier),
		fields?: AppUpdateFieldPolicy,
	},
	AppUpdated?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AppUpdatedKeySpecifier | (() => undefined | AppUpdatedKeySpecifier),
		fields?: AppUpdatedFieldPolicy,
	},
	AssignNavigation?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AssignNavigationKeySpecifier | (() => undefined | AssignNavigationKeySpecifier),
		fields?: AssignNavigationFieldPolicy,
	},
	AssignedAttribute?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AssignedAttributeKeySpecifier | (() => undefined | AssignedAttributeKeySpecifier),
		fields?: AssignedAttributeFieldPolicy,
	},
	AssignedBooleanAttribute?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AssignedBooleanAttributeKeySpecifier | (() => undefined | AssignedBooleanAttributeKeySpecifier),
		fields?: AssignedBooleanAttributeFieldPolicy,
	},
	AssignedChoiceAttributeValue?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AssignedChoiceAttributeValueKeySpecifier | (() => undefined | AssignedChoiceAttributeValueKeySpecifier),
		fields?: AssignedChoiceAttributeValueFieldPolicy,
	},
	AssignedDateAttribute?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AssignedDateAttributeKeySpecifier | (() => undefined | AssignedDateAttributeKeySpecifier),
		fields?: AssignedDateAttributeFieldPolicy,
	},
	AssignedDateTimeAttribute?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AssignedDateTimeAttributeKeySpecifier | (() => undefined | AssignedDateTimeAttributeKeySpecifier),
		fields?: AssignedDateTimeAttributeFieldPolicy,
	},
	AssignedFileAttribute?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AssignedFileAttributeKeySpecifier | (() => undefined | AssignedFileAttributeKeySpecifier),
		fields?: AssignedFileAttributeFieldPolicy,
	},
	AssignedMultiCategoryReferenceAttribute?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AssignedMultiCategoryReferenceAttributeKeySpecifier | (() => undefined | AssignedMultiCategoryReferenceAttributeKeySpecifier),
		fields?: AssignedMultiCategoryReferenceAttributeFieldPolicy,
	},
	AssignedMultiChoiceAttribute?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AssignedMultiChoiceAttributeKeySpecifier | (() => undefined | AssignedMultiChoiceAttributeKeySpecifier),
		fields?: AssignedMultiChoiceAttributeFieldPolicy,
	},
	AssignedMultiCollectionReferenceAttribute?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AssignedMultiCollectionReferenceAttributeKeySpecifier | (() => undefined | AssignedMultiCollectionReferenceAttributeKeySpecifier),
		fields?: AssignedMultiCollectionReferenceAttributeFieldPolicy,
	},
	AssignedMultiPageReferenceAttribute?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AssignedMultiPageReferenceAttributeKeySpecifier | (() => undefined | AssignedMultiPageReferenceAttributeKeySpecifier),
		fields?: AssignedMultiPageReferenceAttributeFieldPolicy,
	},
	AssignedMultiProductReferenceAttribute?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AssignedMultiProductReferenceAttributeKeySpecifier | (() => undefined | AssignedMultiProductReferenceAttributeKeySpecifier),
		fields?: AssignedMultiProductReferenceAttributeFieldPolicy,
	},
	AssignedMultiProductVariantReferenceAttribute?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AssignedMultiProductVariantReferenceAttributeKeySpecifier | (() => undefined | AssignedMultiProductVariantReferenceAttributeKeySpecifier),
		fields?: AssignedMultiProductVariantReferenceAttributeFieldPolicy,
	},
	AssignedNumericAttribute?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AssignedNumericAttributeKeySpecifier | (() => undefined | AssignedNumericAttributeKeySpecifier),
		fields?: AssignedNumericAttributeFieldPolicy,
	},
	AssignedPlainTextAttribute?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AssignedPlainTextAttributeKeySpecifier | (() => undefined | AssignedPlainTextAttributeKeySpecifier),
		fields?: AssignedPlainTextAttributeFieldPolicy,
	},
	AssignedSingleCategoryReferenceAttribute?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AssignedSingleCategoryReferenceAttributeKeySpecifier | (() => undefined | AssignedSingleCategoryReferenceAttributeKeySpecifier),
		fields?: AssignedSingleCategoryReferenceAttributeFieldPolicy,
	},
	AssignedSingleChoiceAttribute?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AssignedSingleChoiceAttributeKeySpecifier | (() => undefined | AssignedSingleChoiceAttributeKeySpecifier),
		fields?: AssignedSingleChoiceAttributeFieldPolicy,
	},
	AssignedSingleCollectionReferenceAttribute?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AssignedSingleCollectionReferenceAttributeKeySpecifier | (() => undefined | AssignedSingleCollectionReferenceAttributeKeySpecifier),
		fields?: AssignedSingleCollectionReferenceAttributeFieldPolicy,
	},
	AssignedSinglePageReferenceAttribute?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AssignedSinglePageReferenceAttributeKeySpecifier | (() => undefined | AssignedSinglePageReferenceAttributeKeySpecifier),
		fields?: AssignedSinglePageReferenceAttributeFieldPolicy,
	},
	AssignedSingleProductReferenceAttribute?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AssignedSingleProductReferenceAttributeKeySpecifier | (() => undefined | AssignedSingleProductReferenceAttributeKeySpecifier),
		fields?: AssignedSingleProductReferenceAttributeFieldPolicy,
	},
	AssignedSingleProductVariantReferenceAttribute?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AssignedSingleProductVariantReferenceAttributeKeySpecifier | (() => undefined | AssignedSingleProductVariantReferenceAttributeKeySpecifier),
		fields?: AssignedSingleProductVariantReferenceAttributeFieldPolicy,
	},
	AssignedSwatchAttribute?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AssignedSwatchAttributeKeySpecifier | (() => undefined | AssignedSwatchAttributeKeySpecifier),
		fields?: AssignedSwatchAttributeFieldPolicy,
	},
	AssignedSwatchAttributeValue?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AssignedSwatchAttributeValueKeySpecifier | (() => undefined | AssignedSwatchAttributeValueKeySpecifier),
		fields?: AssignedSwatchAttributeValueFieldPolicy,
	},
	AssignedTextAttribute?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AssignedTextAttributeKeySpecifier | (() => undefined | AssignedTextAttributeKeySpecifier),
		fields?: AssignedTextAttributeFieldPolicy,
	},
	AssignedVariantAttribute?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AssignedVariantAttributeKeySpecifier | (() => undefined | AssignedVariantAttributeKeySpecifier),
		fields?: AssignedVariantAttributeFieldPolicy,
	},
	Attribute?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AttributeKeySpecifier | (() => undefined | AttributeKeySpecifier),
		fields?: AttributeFieldPolicy,
	},
	AttributeBulkCreate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AttributeBulkCreateKeySpecifier | (() => undefined | AttributeBulkCreateKeySpecifier),
		fields?: AttributeBulkCreateFieldPolicy,
	},
	AttributeBulkCreateError?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AttributeBulkCreateErrorKeySpecifier | (() => undefined | AttributeBulkCreateErrorKeySpecifier),
		fields?: AttributeBulkCreateErrorFieldPolicy,
	},
	AttributeBulkCreateResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AttributeBulkCreateResultKeySpecifier | (() => undefined | AttributeBulkCreateResultKeySpecifier),
		fields?: AttributeBulkCreateResultFieldPolicy,
	},
	AttributeBulkDelete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AttributeBulkDeleteKeySpecifier | (() => undefined | AttributeBulkDeleteKeySpecifier),
		fields?: AttributeBulkDeleteFieldPolicy,
	},
	AttributeBulkTranslate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AttributeBulkTranslateKeySpecifier | (() => undefined | AttributeBulkTranslateKeySpecifier),
		fields?: AttributeBulkTranslateFieldPolicy,
	},
	AttributeBulkTranslateError?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AttributeBulkTranslateErrorKeySpecifier | (() => undefined | AttributeBulkTranslateErrorKeySpecifier),
		fields?: AttributeBulkTranslateErrorFieldPolicy,
	},
	AttributeBulkTranslateResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AttributeBulkTranslateResultKeySpecifier | (() => undefined | AttributeBulkTranslateResultKeySpecifier),
		fields?: AttributeBulkTranslateResultFieldPolicy,
	},
	AttributeBulkUpdate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AttributeBulkUpdateKeySpecifier | (() => undefined | AttributeBulkUpdateKeySpecifier),
		fields?: AttributeBulkUpdateFieldPolicy,
	},
	AttributeBulkUpdateError?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AttributeBulkUpdateErrorKeySpecifier | (() => undefined | AttributeBulkUpdateErrorKeySpecifier),
		fields?: AttributeBulkUpdateErrorFieldPolicy,
	},
	AttributeBulkUpdateResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AttributeBulkUpdateResultKeySpecifier | (() => undefined | AttributeBulkUpdateResultKeySpecifier),
		fields?: AttributeBulkUpdateResultFieldPolicy,
	},
	AttributeCountableConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AttributeCountableConnectionKeySpecifier | (() => undefined | AttributeCountableConnectionKeySpecifier),
		fields?: AttributeCountableConnectionFieldPolicy,
	},
	AttributeCountableEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AttributeCountableEdgeKeySpecifier | (() => undefined | AttributeCountableEdgeKeySpecifier),
		fields?: AttributeCountableEdgeFieldPolicy,
	},
	AttributeCreate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AttributeCreateKeySpecifier | (() => undefined | AttributeCreateKeySpecifier),
		fields?: AttributeCreateFieldPolicy,
	},
	AttributeCreated?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AttributeCreatedKeySpecifier | (() => undefined | AttributeCreatedKeySpecifier),
		fields?: AttributeCreatedFieldPolicy,
	},
	AttributeDelete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AttributeDeleteKeySpecifier | (() => undefined | AttributeDeleteKeySpecifier),
		fields?: AttributeDeleteFieldPolicy,
	},
	AttributeDeleted?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AttributeDeletedKeySpecifier | (() => undefined | AttributeDeletedKeySpecifier),
		fields?: AttributeDeletedFieldPolicy,
	},
	AttributeError?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AttributeErrorKeySpecifier | (() => undefined | AttributeErrorKeySpecifier),
		fields?: AttributeErrorFieldPolicy,
	},
	AttributeReorderValues?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AttributeReorderValuesKeySpecifier | (() => undefined | AttributeReorderValuesKeySpecifier),
		fields?: AttributeReorderValuesFieldPolicy,
	},
	AttributeTranslatableContent?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AttributeTranslatableContentKeySpecifier | (() => undefined | AttributeTranslatableContentKeySpecifier),
		fields?: AttributeTranslatableContentFieldPolicy,
	},
	AttributeTranslate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AttributeTranslateKeySpecifier | (() => undefined | AttributeTranslateKeySpecifier),
		fields?: AttributeTranslateFieldPolicy,
	},
	AttributeTranslation?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AttributeTranslationKeySpecifier | (() => undefined | AttributeTranslationKeySpecifier),
		fields?: AttributeTranslationFieldPolicy,
	},
	AttributeUpdate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AttributeUpdateKeySpecifier | (() => undefined | AttributeUpdateKeySpecifier),
		fields?: AttributeUpdateFieldPolicy,
	},
	AttributeUpdated?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AttributeUpdatedKeySpecifier | (() => undefined | AttributeUpdatedKeySpecifier),
		fields?: AttributeUpdatedFieldPolicy,
	},
	AttributeValue?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AttributeValueKeySpecifier | (() => undefined | AttributeValueKeySpecifier),
		fields?: AttributeValueFieldPolicy,
	},
	AttributeValueBulkDelete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AttributeValueBulkDeleteKeySpecifier | (() => undefined | AttributeValueBulkDeleteKeySpecifier),
		fields?: AttributeValueBulkDeleteFieldPolicy,
	},
	AttributeValueBulkTranslate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AttributeValueBulkTranslateKeySpecifier | (() => undefined | AttributeValueBulkTranslateKeySpecifier),
		fields?: AttributeValueBulkTranslateFieldPolicy,
	},
	AttributeValueBulkTranslateError?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AttributeValueBulkTranslateErrorKeySpecifier | (() => undefined | AttributeValueBulkTranslateErrorKeySpecifier),
		fields?: AttributeValueBulkTranslateErrorFieldPolicy,
	},
	AttributeValueBulkTranslateResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AttributeValueBulkTranslateResultKeySpecifier | (() => undefined | AttributeValueBulkTranslateResultKeySpecifier),
		fields?: AttributeValueBulkTranslateResultFieldPolicy,
	},
	AttributeValueCountableConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AttributeValueCountableConnectionKeySpecifier | (() => undefined | AttributeValueCountableConnectionKeySpecifier),
		fields?: AttributeValueCountableConnectionFieldPolicy,
	},
	AttributeValueCountableEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AttributeValueCountableEdgeKeySpecifier | (() => undefined | AttributeValueCountableEdgeKeySpecifier),
		fields?: AttributeValueCountableEdgeFieldPolicy,
	},
	AttributeValueCreate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AttributeValueCreateKeySpecifier | (() => undefined | AttributeValueCreateKeySpecifier),
		fields?: AttributeValueCreateFieldPolicy,
	},
	AttributeValueCreated?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AttributeValueCreatedKeySpecifier | (() => undefined | AttributeValueCreatedKeySpecifier),
		fields?: AttributeValueCreatedFieldPolicy,
	},
	AttributeValueDelete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AttributeValueDeleteKeySpecifier | (() => undefined | AttributeValueDeleteKeySpecifier),
		fields?: AttributeValueDeleteFieldPolicy,
	},
	AttributeValueDeleted?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AttributeValueDeletedKeySpecifier | (() => undefined | AttributeValueDeletedKeySpecifier),
		fields?: AttributeValueDeletedFieldPolicy,
	},
	AttributeValueTranslatableContent?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AttributeValueTranslatableContentKeySpecifier | (() => undefined | AttributeValueTranslatableContentKeySpecifier),
		fields?: AttributeValueTranslatableContentFieldPolicy,
	},
	AttributeValueTranslate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AttributeValueTranslateKeySpecifier | (() => undefined | AttributeValueTranslateKeySpecifier),
		fields?: AttributeValueTranslateFieldPolicy,
	},
	AttributeValueTranslation?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AttributeValueTranslationKeySpecifier | (() => undefined | AttributeValueTranslationKeySpecifier),
		fields?: AttributeValueTranslationFieldPolicy,
	},
	AttributeValueUpdate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AttributeValueUpdateKeySpecifier | (() => undefined | AttributeValueUpdateKeySpecifier),
		fields?: AttributeValueUpdateFieldPolicy,
	},
	AttributeValueUpdated?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AttributeValueUpdatedKeySpecifier | (() => undefined | AttributeValueUpdatedKeySpecifier),
		fields?: AttributeValueUpdatedFieldPolicy,
	},
	BulkProductError?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BulkProductErrorKeySpecifier | (() => undefined | BulkProductErrorKeySpecifier),
		fields?: BulkProductErrorFieldPolicy,
	},
	BulkStockError?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BulkStockErrorKeySpecifier | (() => undefined | BulkStockErrorKeySpecifier),
		fields?: BulkStockErrorFieldPolicy,
	},
	CalculateTaxes?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CalculateTaxesKeySpecifier | (() => undefined | CalculateTaxesKeySpecifier),
		fields?: CalculateTaxesFieldPolicy,
	},
	CardPaymentMethodDetails?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CardPaymentMethodDetailsKeySpecifier | (() => undefined | CardPaymentMethodDetailsKeySpecifier),
		fields?: CardPaymentMethodDetailsFieldPolicy,
	},
	Category?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CategoryKeySpecifier | (() => undefined | CategoryKeySpecifier),
		fields?: CategoryFieldPolicy,
	},
	CategoryBulkDelete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CategoryBulkDeleteKeySpecifier | (() => undefined | CategoryBulkDeleteKeySpecifier),
		fields?: CategoryBulkDeleteFieldPolicy,
	},
	CategoryCountableConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CategoryCountableConnectionKeySpecifier | (() => undefined | CategoryCountableConnectionKeySpecifier),
		fields?: CategoryCountableConnectionFieldPolicy,
	},
	CategoryCountableEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CategoryCountableEdgeKeySpecifier | (() => undefined | CategoryCountableEdgeKeySpecifier),
		fields?: CategoryCountableEdgeFieldPolicy,
	},
	CategoryCreate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CategoryCreateKeySpecifier | (() => undefined | CategoryCreateKeySpecifier),
		fields?: CategoryCreateFieldPolicy,
	},
	CategoryCreated?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CategoryCreatedKeySpecifier | (() => undefined | CategoryCreatedKeySpecifier),
		fields?: CategoryCreatedFieldPolicy,
	},
	CategoryDelete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CategoryDeleteKeySpecifier | (() => undefined | CategoryDeleteKeySpecifier),
		fields?: CategoryDeleteFieldPolicy,
	},
	CategoryDeleted?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CategoryDeletedKeySpecifier | (() => undefined | CategoryDeletedKeySpecifier),
		fields?: CategoryDeletedFieldPolicy,
	},
	CategoryTranslatableContent?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CategoryTranslatableContentKeySpecifier | (() => undefined | CategoryTranslatableContentKeySpecifier),
		fields?: CategoryTranslatableContentFieldPolicy,
	},
	CategoryTranslate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CategoryTranslateKeySpecifier | (() => undefined | CategoryTranslateKeySpecifier),
		fields?: CategoryTranslateFieldPolicy,
	},
	CategoryTranslation?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CategoryTranslationKeySpecifier | (() => undefined | CategoryTranslationKeySpecifier),
		fields?: CategoryTranslationFieldPolicy,
	},
	CategoryUpdate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CategoryUpdateKeySpecifier | (() => undefined | CategoryUpdateKeySpecifier),
		fields?: CategoryUpdateFieldPolicy,
	},
	CategoryUpdated?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CategoryUpdatedKeySpecifier | (() => undefined | CategoryUpdatedKeySpecifier),
		fields?: CategoryUpdatedFieldPolicy,
	},
	Channel?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ChannelKeySpecifier | (() => undefined | ChannelKeySpecifier),
		fields?: ChannelFieldPolicy,
	},
	ChannelActivate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ChannelActivateKeySpecifier | (() => undefined | ChannelActivateKeySpecifier),
		fields?: ChannelActivateFieldPolicy,
	},
	ChannelCreate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ChannelCreateKeySpecifier | (() => undefined | ChannelCreateKeySpecifier),
		fields?: ChannelCreateFieldPolicy,
	},
	ChannelCreated?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ChannelCreatedKeySpecifier | (() => undefined | ChannelCreatedKeySpecifier),
		fields?: ChannelCreatedFieldPolicy,
	},
	ChannelDeactivate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ChannelDeactivateKeySpecifier | (() => undefined | ChannelDeactivateKeySpecifier),
		fields?: ChannelDeactivateFieldPolicy,
	},
	ChannelDelete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ChannelDeleteKeySpecifier | (() => undefined | ChannelDeleteKeySpecifier),
		fields?: ChannelDeleteFieldPolicy,
	},
	ChannelDeleted?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ChannelDeletedKeySpecifier | (() => undefined | ChannelDeletedKeySpecifier),
		fields?: ChannelDeletedFieldPolicy,
	},
	ChannelError?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ChannelErrorKeySpecifier | (() => undefined | ChannelErrorKeySpecifier),
		fields?: ChannelErrorFieldPolicy,
	},
	ChannelMetadataUpdated?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ChannelMetadataUpdatedKeySpecifier | (() => undefined | ChannelMetadataUpdatedKeySpecifier),
		fields?: ChannelMetadataUpdatedFieldPolicy,
	},
	ChannelReorderWarehouses?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ChannelReorderWarehousesKeySpecifier | (() => undefined | ChannelReorderWarehousesKeySpecifier),
		fields?: ChannelReorderWarehousesFieldPolicy,
	},
	ChannelStatusChanged?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ChannelStatusChangedKeySpecifier | (() => undefined | ChannelStatusChangedKeySpecifier),
		fields?: ChannelStatusChangedFieldPolicy,
	},
	ChannelUpdate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ChannelUpdateKeySpecifier | (() => undefined | ChannelUpdateKeySpecifier),
		fields?: ChannelUpdateFieldPolicy,
	},
	ChannelUpdated?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ChannelUpdatedKeySpecifier | (() => undefined | ChannelUpdatedKeySpecifier),
		fields?: ChannelUpdatedFieldPolicy,
	},
	Checkout?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CheckoutKeySpecifier | (() => undefined | CheckoutKeySpecifier),
		fields?: CheckoutFieldPolicy,
	},
	CheckoutAddPromoCode?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CheckoutAddPromoCodeKeySpecifier | (() => undefined | CheckoutAddPromoCodeKeySpecifier),
		fields?: CheckoutAddPromoCodeFieldPolicy,
	},
	CheckoutBillingAddressUpdate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CheckoutBillingAddressUpdateKeySpecifier | (() => undefined | CheckoutBillingAddressUpdateKeySpecifier),
		fields?: CheckoutBillingAddressUpdateFieldPolicy,
	},
	CheckoutComplete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CheckoutCompleteKeySpecifier | (() => undefined | CheckoutCompleteKeySpecifier),
		fields?: CheckoutCompleteFieldPolicy,
	},
	CheckoutCountableConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CheckoutCountableConnectionKeySpecifier | (() => undefined | CheckoutCountableConnectionKeySpecifier),
		fields?: CheckoutCountableConnectionFieldPolicy,
	},
	CheckoutCountableEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CheckoutCountableEdgeKeySpecifier | (() => undefined | CheckoutCountableEdgeKeySpecifier),
		fields?: CheckoutCountableEdgeFieldPolicy,
	},
	CheckoutCreate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CheckoutCreateKeySpecifier | (() => undefined | CheckoutCreateKeySpecifier),
		fields?: CheckoutCreateFieldPolicy,
	},
	CheckoutCreateFromOrder?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CheckoutCreateFromOrderKeySpecifier | (() => undefined | CheckoutCreateFromOrderKeySpecifier),
		fields?: CheckoutCreateFromOrderFieldPolicy,
	},
	CheckoutCreateFromOrderError?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CheckoutCreateFromOrderErrorKeySpecifier | (() => undefined | CheckoutCreateFromOrderErrorKeySpecifier),
		fields?: CheckoutCreateFromOrderErrorFieldPolicy,
	},
	CheckoutCreateFromOrderUnavailableVariant?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CheckoutCreateFromOrderUnavailableVariantKeySpecifier | (() => undefined | CheckoutCreateFromOrderUnavailableVariantKeySpecifier),
		fields?: CheckoutCreateFromOrderUnavailableVariantFieldPolicy,
	},
	CheckoutCreated?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CheckoutCreatedKeySpecifier | (() => undefined | CheckoutCreatedKeySpecifier),
		fields?: CheckoutCreatedFieldPolicy,
	},
	CheckoutCustomerAttach?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CheckoutCustomerAttachKeySpecifier | (() => undefined | CheckoutCustomerAttachKeySpecifier),
		fields?: CheckoutCustomerAttachFieldPolicy,
	},
	CheckoutCustomerDetach?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CheckoutCustomerDetachKeySpecifier | (() => undefined | CheckoutCustomerDetachKeySpecifier),
		fields?: CheckoutCustomerDetachFieldPolicy,
	},
	CheckoutCustomerNoteUpdate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CheckoutCustomerNoteUpdateKeySpecifier | (() => undefined | CheckoutCustomerNoteUpdateKeySpecifier),
		fields?: CheckoutCustomerNoteUpdateFieldPolicy,
	},
	CheckoutDeliveryMethodUpdate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CheckoutDeliveryMethodUpdateKeySpecifier | (() => undefined | CheckoutDeliveryMethodUpdateKeySpecifier),
		fields?: CheckoutDeliveryMethodUpdateFieldPolicy,
	},
	CheckoutEmailUpdate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CheckoutEmailUpdateKeySpecifier | (() => undefined | CheckoutEmailUpdateKeySpecifier),
		fields?: CheckoutEmailUpdateFieldPolicy,
	},
	CheckoutError?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CheckoutErrorKeySpecifier | (() => undefined | CheckoutErrorKeySpecifier),
		fields?: CheckoutErrorFieldPolicy,
	},
	CheckoutFilterShippingMethods?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CheckoutFilterShippingMethodsKeySpecifier | (() => undefined | CheckoutFilterShippingMethodsKeySpecifier),
		fields?: CheckoutFilterShippingMethodsFieldPolicy,
	},
	CheckoutFullyAuthorized?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CheckoutFullyAuthorizedKeySpecifier | (() => undefined | CheckoutFullyAuthorizedKeySpecifier),
		fields?: CheckoutFullyAuthorizedFieldPolicy,
	},
	CheckoutFullyPaid?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CheckoutFullyPaidKeySpecifier | (() => undefined | CheckoutFullyPaidKeySpecifier),
		fields?: CheckoutFullyPaidFieldPolicy,
	},
	CheckoutLanguageCodeUpdate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CheckoutLanguageCodeUpdateKeySpecifier | (() => undefined | CheckoutLanguageCodeUpdateKeySpecifier),
		fields?: CheckoutLanguageCodeUpdateFieldPolicy,
	},
	CheckoutLine?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CheckoutLineKeySpecifier | (() => undefined | CheckoutLineKeySpecifier),
		fields?: CheckoutLineFieldPolicy,
	},
	CheckoutLineCountableConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CheckoutLineCountableConnectionKeySpecifier | (() => undefined | CheckoutLineCountableConnectionKeySpecifier),
		fields?: CheckoutLineCountableConnectionFieldPolicy,
	},
	CheckoutLineCountableEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CheckoutLineCountableEdgeKeySpecifier | (() => undefined | CheckoutLineCountableEdgeKeySpecifier),
		fields?: CheckoutLineCountableEdgeFieldPolicy,
	},
	CheckoutLineDelete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CheckoutLineDeleteKeySpecifier | (() => undefined | CheckoutLineDeleteKeySpecifier),
		fields?: CheckoutLineDeleteFieldPolicy,
	},
	CheckoutLineProblemInsufficientStock?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CheckoutLineProblemInsufficientStockKeySpecifier | (() => undefined | CheckoutLineProblemInsufficientStockKeySpecifier),
		fields?: CheckoutLineProblemInsufficientStockFieldPolicy,
	},
	CheckoutLineProblemVariantNotAvailable?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CheckoutLineProblemVariantNotAvailableKeySpecifier | (() => undefined | CheckoutLineProblemVariantNotAvailableKeySpecifier),
		fields?: CheckoutLineProblemVariantNotAvailableFieldPolicy,
	},
	CheckoutLinesAdd?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CheckoutLinesAddKeySpecifier | (() => undefined | CheckoutLinesAddKeySpecifier),
		fields?: CheckoutLinesAddFieldPolicy,
	},
	CheckoutLinesDelete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CheckoutLinesDeleteKeySpecifier | (() => undefined | CheckoutLinesDeleteKeySpecifier),
		fields?: CheckoutLinesDeleteFieldPolicy,
	},
	CheckoutLinesUpdate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CheckoutLinesUpdateKeySpecifier | (() => undefined | CheckoutLinesUpdateKeySpecifier),
		fields?: CheckoutLinesUpdateFieldPolicy,
	},
	CheckoutMetadataUpdated?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CheckoutMetadataUpdatedKeySpecifier | (() => undefined | CheckoutMetadataUpdatedKeySpecifier),
		fields?: CheckoutMetadataUpdatedFieldPolicy,
	},
	CheckoutPaymentCreate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CheckoutPaymentCreateKeySpecifier | (() => undefined | CheckoutPaymentCreateKeySpecifier),
		fields?: CheckoutPaymentCreateFieldPolicy,
	},
	CheckoutRemovePromoCode?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CheckoutRemovePromoCodeKeySpecifier | (() => undefined | CheckoutRemovePromoCodeKeySpecifier),
		fields?: CheckoutRemovePromoCodeFieldPolicy,
	},
	CheckoutSettings?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CheckoutSettingsKeySpecifier | (() => undefined | CheckoutSettingsKeySpecifier),
		fields?: CheckoutSettingsFieldPolicy,
	},
	CheckoutShippingAddressUpdate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CheckoutShippingAddressUpdateKeySpecifier | (() => undefined | CheckoutShippingAddressUpdateKeySpecifier),
		fields?: CheckoutShippingAddressUpdateFieldPolicy,
	},
	CheckoutShippingMethodUpdate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CheckoutShippingMethodUpdateKeySpecifier | (() => undefined | CheckoutShippingMethodUpdateKeySpecifier),
		fields?: CheckoutShippingMethodUpdateFieldPolicy,
	},
	CheckoutUpdated?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CheckoutUpdatedKeySpecifier | (() => undefined | CheckoutUpdatedKeySpecifier),
		fields?: CheckoutUpdatedFieldPolicy,
	},
	ChoiceValue?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ChoiceValueKeySpecifier | (() => undefined | ChoiceValueKeySpecifier),
		fields?: ChoiceValueFieldPolicy,
	},
	Collection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CollectionKeySpecifier | (() => undefined | CollectionKeySpecifier),
		fields?: CollectionFieldPolicy,
	},
	CollectionAddProducts?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CollectionAddProductsKeySpecifier | (() => undefined | CollectionAddProductsKeySpecifier),
		fields?: CollectionAddProductsFieldPolicy,
	},
	CollectionBulkDelete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CollectionBulkDeleteKeySpecifier | (() => undefined | CollectionBulkDeleteKeySpecifier),
		fields?: CollectionBulkDeleteFieldPolicy,
	},
	CollectionChannelListing?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CollectionChannelListingKeySpecifier | (() => undefined | CollectionChannelListingKeySpecifier),
		fields?: CollectionChannelListingFieldPolicy,
	},
	CollectionChannelListingError?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CollectionChannelListingErrorKeySpecifier | (() => undefined | CollectionChannelListingErrorKeySpecifier),
		fields?: CollectionChannelListingErrorFieldPolicy,
	},
	CollectionChannelListingUpdate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CollectionChannelListingUpdateKeySpecifier | (() => undefined | CollectionChannelListingUpdateKeySpecifier),
		fields?: CollectionChannelListingUpdateFieldPolicy,
	},
	CollectionCountableConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CollectionCountableConnectionKeySpecifier | (() => undefined | CollectionCountableConnectionKeySpecifier),
		fields?: CollectionCountableConnectionFieldPolicy,
	},
	CollectionCountableEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CollectionCountableEdgeKeySpecifier | (() => undefined | CollectionCountableEdgeKeySpecifier),
		fields?: CollectionCountableEdgeFieldPolicy,
	},
	CollectionCreate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CollectionCreateKeySpecifier | (() => undefined | CollectionCreateKeySpecifier),
		fields?: CollectionCreateFieldPolicy,
	},
	CollectionCreated?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CollectionCreatedKeySpecifier | (() => undefined | CollectionCreatedKeySpecifier),
		fields?: CollectionCreatedFieldPolicy,
	},
	CollectionDelete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CollectionDeleteKeySpecifier | (() => undefined | CollectionDeleteKeySpecifier),
		fields?: CollectionDeleteFieldPolicy,
	},
	CollectionDeleted?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CollectionDeletedKeySpecifier | (() => undefined | CollectionDeletedKeySpecifier),
		fields?: CollectionDeletedFieldPolicy,
	},
	CollectionError?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CollectionErrorKeySpecifier | (() => undefined | CollectionErrorKeySpecifier),
		fields?: CollectionErrorFieldPolicy,
	},
	CollectionMetadataUpdated?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CollectionMetadataUpdatedKeySpecifier | (() => undefined | CollectionMetadataUpdatedKeySpecifier),
		fields?: CollectionMetadataUpdatedFieldPolicy,
	},
	CollectionRemoveProducts?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CollectionRemoveProductsKeySpecifier | (() => undefined | CollectionRemoveProductsKeySpecifier),
		fields?: CollectionRemoveProductsFieldPolicy,
	},
	CollectionReorderProducts?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CollectionReorderProductsKeySpecifier | (() => undefined | CollectionReorderProductsKeySpecifier),
		fields?: CollectionReorderProductsFieldPolicy,
	},
	CollectionTranslatableContent?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CollectionTranslatableContentKeySpecifier | (() => undefined | CollectionTranslatableContentKeySpecifier),
		fields?: CollectionTranslatableContentFieldPolicy,
	},
	CollectionTranslate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CollectionTranslateKeySpecifier | (() => undefined | CollectionTranslateKeySpecifier),
		fields?: CollectionTranslateFieldPolicy,
	},
	CollectionTranslation?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CollectionTranslationKeySpecifier | (() => undefined | CollectionTranslationKeySpecifier),
		fields?: CollectionTranslationFieldPolicy,
	},
	CollectionUpdate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CollectionUpdateKeySpecifier | (() => undefined | CollectionUpdateKeySpecifier),
		fields?: CollectionUpdateFieldPolicy,
	},
	CollectionUpdated?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CollectionUpdatedKeySpecifier | (() => undefined | CollectionUpdatedKeySpecifier),
		fields?: CollectionUpdatedFieldPolicy,
	},
	ConfigurationItem?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ConfigurationItemKeySpecifier | (() => undefined | ConfigurationItemKeySpecifier),
		fields?: ConfigurationItemFieldPolicy,
	},
	ConfirmAccount?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ConfirmAccountKeySpecifier | (() => undefined | ConfirmAccountKeySpecifier),
		fields?: ConfirmAccountFieldPolicy,
	},
	ConfirmEmailChange?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ConfirmEmailChangeKeySpecifier | (() => undefined | ConfirmEmailChangeKeySpecifier),
		fields?: ConfirmEmailChangeFieldPolicy,
	},
	CountryDisplay?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CountryDisplayKeySpecifier | (() => undefined | CountryDisplayKeySpecifier),
		fields?: CountryDisplayFieldPolicy,
	},
	CreateToken?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CreateTokenKeySpecifier | (() => undefined | CreateTokenKeySpecifier),
		fields?: CreateTokenFieldPolicy,
	},
	CreditCard?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CreditCardKeySpecifier | (() => undefined | CreditCardKeySpecifier),
		fields?: CreditCardFieldPolicy,
	},
	CustomerBulkDelete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CustomerBulkDeleteKeySpecifier | (() => undefined | CustomerBulkDeleteKeySpecifier),
		fields?: CustomerBulkDeleteFieldPolicy,
	},
	CustomerBulkResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CustomerBulkResultKeySpecifier | (() => undefined | CustomerBulkResultKeySpecifier),
		fields?: CustomerBulkResultFieldPolicy,
	},
	CustomerBulkUpdate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CustomerBulkUpdateKeySpecifier | (() => undefined | CustomerBulkUpdateKeySpecifier),
		fields?: CustomerBulkUpdateFieldPolicy,
	},
	CustomerBulkUpdateError?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CustomerBulkUpdateErrorKeySpecifier | (() => undefined | CustomerBulkUpdateErrorKeySpecifier),
		fields?: CustomerBulkUpdateErrorFieldPolicy,
	},
	CustomerCreate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CustomerCreateKeySpecifier | (() => undefined | CustomerCreateKeySpecifier),
		fields?: CustomerCreateFieldPolicy,
	},
	CustomerCreated?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CustomerCreatedKeySpecifier | (() => undefined | CustomerCreatedKeySpecifier),
		fields?: CustomerCreatedFieldPolicy,
	},
	CustomerDelete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CustomerDeleteKeySpecifier | (() => undefined | CustomerDeleteKeySpecifier),
		fields?: CustomerDeleteFieldPolicy,
	},
	CustomerEvent?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CustomerEventKeySpecifier | (() => undefined | CustomerEventKeySpecifier),
		fields?: CustomerEventFieldPolicy,
	},
	CustomerMetadataUpdated?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CustomerMetadataUpdatedKeySpecifier | (() => undefined | CustomerMetadataUpdatedKeySpecifier),
		fields?: CustomerMetadataUpdatedFieldPolicy,
	},
	CustomerUpdate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CustomerUpdateKeySpecifier | (() => undefined | CustomerUpdateKeySpecifier),
		fields?: CustomerUpdateFieldPolicy,
	},
	CustomerUpdated?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CustomerUpdatedKeySpecifier | (() => undefined | CustomerUpdatedKeySpecifier),
		fields?: CustomerUpdatedFieldPolicy,
	},
	DeactivateAllUserTokens?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeactivateAllUserTokensKeySpecifier | (() => undefined | DeactivateAllUserTokensKeySpecifier),
		fields?: DeactivateAllUserTokensFieldPolicy,
	},
	DeleteMetadata?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeleteMetadataKeySpecifier | (() => undefined | DeleteMetadataKeySpecifier),
		fields?: DeleteMetadataFieldPolicy,
	},
	DeletePrivateMetadata?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeletePrivateMetadataKeySpecifier | (() => undefined | DeletePrivateMetadataKeySpecifier),
		fields?: DeletePrivateMetadataFieldPolicy,
	},
	DigitalContent?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DigitalContentKeySpecifier | (() => undefined | DigitalContentKeySpecifier),
		fields?: DigitalContentFieldPolicy,
	},
	DigitalContentCountableConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DigitalContentCountableConnectionKeySpecifier | (() => undefined | DigitalContentCountableConnectionKeySpecifier),
		fields?: DigitalContentCountableConnectionFieldPolicy,
	},
	DigitalContentCountableEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DigitalContentCountableEdgeKeySpecifier | (() => undefined | DigitalContentCountableEdgeKeySpecifier),
		fields?: DigitalContentCountableEdgeFieldPolicy,
	},
	DigitalContentCreate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DigitalContentCreateKeySpecifier | (() => undefined | DigitalContentCreateKeySpecifier),
		fields?: DigitalContentCreateFieldPolicy,
	},
	DigitalContentDelete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DigitalContentDeleteKeySpecifier | (() => undefined | DigitalContentDeleteKeySpecifier),
		fields?: DigitalContentDeleteFieldPolicy,
	},
	DigitalContentUpdate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DigitalContentUpdateKeySpecifier | (() => undefined | DigitalContentUpdateKeySpecifier),
		fields?: DigitalContentUpdateFieldPolicy,
	},
	DigitalContentUrl?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DigitalContentUrlKeySpecifier | (() => undefined | DigitalContentUrlKeySpecifier),
		fields?: DigitalContentUrlFieldPolicy,
	},
	DigitalContentUrlCreate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DigitalContentUrlCreateKeySpecifier | (() => undefined | DigitalContentUrlCreateKeySpecifier),
		fields?: DigitalContentUrlCreateFieldPolicy,
	},
	DiscountError?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DiscountErrorKeySpecifier | (() => undefined | DiscountErrorKeySpecifier),
		fields?: DiscountErrorFieldPolicy,
	},
	Domain?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DomainKeySpecifier | (() => undefined | DomainKeySpecifier),
		fields?: DomainFieldPolicy,
	},
	DraftOrderBulkDelete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DraftOrderBulkDeleteKeySpecifier | (() => undefined | DraftOrderBulkDeleteKeySpecifier),
		fields?: DraftOrderBulkDeleteFieldPolicy,
	},
	DraftOrderComplete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DraftOrderCompleteKeySpecifier | (() => undefined | DraftOrderCompleteKeySpecifier),
		fields?: DraftOrderCompleteFieldPolicy,
	},
	DraftOrderCreate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DraftOrderCreateKeySpecifier | (() => undefined | DraftOrderCreateKeySpecifier),
		fields?: DraftOrderCreateFieldPolicy,
	},
	DraftOrderCreated?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DraftOrderCreatedKeySpecifier | (() => undefined | DraftOrderCreatedKeySpecifier),
		fields?: DraftOrderCreatedFieldPolicy,
	},
	DraftOrderDelete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DraftOrderDeleteKeySpecifier | (() => undefined | DraftOrderDeleteKeySpecifier),
		fields?: DraftOrderDeleteFieldPolicy,
	},
	DraftOrderDeleted?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DraftOrderDeletedKeySpecifier | (() => undefined | DraftOrderDeletedKeySpecifier),
		fields?: DraftOrderDeletedFieldPolicy,
	},
	DraftOrderLinesBulkDelete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DraftOrderLinesBulkDeleteKeySpecifier | (() => undefined | DraftOrderLinesBulkDeleteKeySpecifier),
		fields?: DraftOrderLinesBulkDeleteFieldPolicy,
	},
	DraftOrderUpdate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DraftOrderUpdateKeySpecifier | (() => undefined | DraftOrderUpdateKeySpecifier),
		fields?: DraftOrderUpdateFieldPolicy,
	},
	DraftOrderUpdated?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DraftOrderUpdatedKeySpecifier | (() => undefined | DraftOrderUpdatedKeySpecifier),
		fields?: DraftOrderUpdatedFieldPolicy,
	},
	Event?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EventKeySpecifier | (() => undefined | EventKeySpecifier),
		fields?: EventFieldPolicy,
	},
	EventDelivery?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EventDeliveryKeySpecifier | (() => undefined | EventDeliveryKeySpecifier),
		fields?: EventDeliveryFieldPolicy,
	},
	EventDeliveryAttempt?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EventDeliveryAttemptKeySpecifier | (() => undefined | EventDeliveryAttemptKeySpecifier),
		fields?: EventDeliveryAttemptFieldPolicy,
	},
	EventDeliveryAttemptCountableConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EventDeliveryAttemptCountableConnectionKeySpecifier | (() => undefined | EventDeliveryAttemptCountableConnectionKeySpecifier),
		fields?: EventDeliveryAttemptCountableConnectionFieldPolicy,
	},
	EventDeliveryAttemptCountableEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EventDeliveryAttemptCountableEdgeKeySpecifier | (() => undefined | EventDeliveryAttemptCountableEdgeKeySpecifier),
		fields?: EventDeliveryAttemptCountableEdgeFieldPolicy,
	},
	EventDeliveryCountableConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EventDeliveryCountableConnectionKeySpecifier | (() => undefined | EventDeliveryCountableConnectionKeySpecifier),
		fields?: EventDeliveryCountableConnectionFieldPolicy,
	},
	EventDeliveryCountableEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EventDeliveryCountableEdgeKeySpecifier | (() => undefined | EventDeliveryCountableEdgeKeySpecifier),
		fields?: EventDeliveryCountableEdgeFieldPolicy,
	},
	EventDeliveryRetry?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EventDeliveryRetryKeySpecifier | (() => undefined | EventDeliveryRetryKeySpecifier),
		fields?: EventDeliveryRetryFieldPolicy,
	},
	ExportError?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ExportErrorKeySpecifier | (() => undefined | ExportErrorKeySpecifier),
		fields?: ExportErrorFieldPolicy,
	},
	ExportEvent?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ExportEventKeySpecifier | (() => undefined | ExportEventKeySpecifier),
		fields?: ExportEventFieldPolicy,
	},
	ExportFile?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ExportFileKeySpecifier | (() => undefined | ExportFileKeySpecifier),
		fields?: ExportFileFieldPolicy,
	},
	ExportFileCountableConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ExportFileCountableConnectionKeySpecifier | (() => undefined | ExportFileCountableConnectionKeySpecifier),
		fields?: ExportFileCountableConnectionFieldPolicy,
	},
	ExportFileCountableEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ExportFileCountableEdgeKeySpecifier | (() => undefined | ExportFileCountableEdgeKeySpecifier),
		fields?: ExportFileCountableEdgeFieldPolicy,
	},
	ExportGiftCards?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ExportGiftCardsKeySpecifier | (() => undefined | ExportGiftCardsKeySpecifier),
		fields?: ExportGiftCardsFieldPolicy,
	},
	ExportProducts?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ExportProductsKeySpecifier | (() => undefined | ExportProductsKeySpecifier),
		fields?: ExportProductsFieldPolicy,
	},
	ExportVoucherCodes?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ExportVoucherCodesKeySpecifier | (() => undefined | ExportVoucherCodesKeySpecifier),
		fields?: ExportVoucherCodesFieldPolicy,
	},
	ExternalAuthentication?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ExternalAuthenticationKeySpecifier | (() => undefined | ExternalAuthenticationKeySpecifier),
		fields?: ExternalAuthenticationFieldPolicy,
	},
	ExternalAuthenticationUrl?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ExternalAuthenticationUrlKeySpecifier | (() => undefined | ExternalAuthenticationUrlKeySpecifier),
		fields?: ExternalAuthenticationUrlFieldPolicy,
	},
	ExternalLogout?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ExternalLogoutKeySpecifier | (() => undefined | ExternalLogoutKeySpecifier),
		fields?: ExternalLogoutFieldPolicy,
	},
	ExternalNotificationError?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ExternalNotificationErrorKeySpecifier | (() => undefined | ExternalNotificationErrorKeySpecifier),
		fields?: ExternalNotificationErrorFieldPolicy,
	},
	ExternalNotificationTrigger?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ExternalNotificationTriggerKeySpecifier | (() => undefined | ExternalNotificationTriggerKeySpecifier),
		fields?: ExternalNotificationTriggerFieldPolicy,
	},
	ExternalObtainAccessTokens?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ExternalObtainAccessTokensKeySpecifier | (() => undefined | ExternalObtainAccessTokensKeySpecifier),
		fields?: ExternalObtainAccessTokensFieldPolicy,
	},
	ExternalRefresh?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ExternalRefreshKeySpecifier | (() => undefined | ExternalRefreshKeySpecifier),
		fields?: ExternalRefreshFieldPolicy,
	},
	ExternalVerify?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ExternalVerifyKeySpecifier | (() => undefined | ExternalVerifyKeySpecifier),
		fields?: ExternalVerifyFieldPolicy,
	},
	File?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FileKeySpecifier | (() => undefined | FileKeySpecifier),
		fields?: FileFieldPolicy,
	},
	FileUpload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FileUploadKeySpecifier | (() => undefined | FileUploadKeySpecifier),
		fields?: FileUploadFieldPolicy,
	},
	Fulfillment?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FulfillmentKeySpecifier | (() => undefined | FulfillmentKeySpecifier),
		fields?: FulfillmentFieldPolicy,
	},
	FulfillmentApprove?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FulfillmentApproveKeySpecifier | (() => undefined | FulfillmentApproveKeySpecifier),
		fields?: FulfillmentApproveFieldPolicy,
	},
	FulfillmentApproved?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FulfillmentApprovedKeySpecifier | (() => undefined | FulfillmentApprovedKeySpecifier),
		fields?: FulfillmentApprovedFieldPolicy,
	},
	FulfillmentCancel?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FulfillmentCancelKeySpecifier | (() => undefined | FulfillmentCancelKeySpecifier),
		fields?: FulfillmentCancelFieldPolicy,
	},
	FulfillmentCanceled?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FulfillmentCanceledKeySpecifier | (() => undefined | FulfillmentCanceledKeySpecifier),
		fields?: FulfillmentCanceledFieldPolicy,
	},
	FulfillmentCreated?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FulfillmentCreatedKeySpecifier | (() => undefined | FulfillmentCreatedKeySpecifier),
		fields?: FulfillmentCreatedFieldPolicy,
	},
	FulfillmentLine?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FulfillmentLineKeySpecifier | (() => undefined | FulfillmentLineKeySpecifier),
		fields?: FulfillmentLineFieldPolicy,
	},
	FulfillmentMetadataUpdated?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FulfillmentMetadataUpdatedKeySpecifier | (() => undefined | FulfillmentMetadataUpdatedKeySpecifier),
		fields?: FulfillmentMetadataUpdatedFieldPolicy,
	},
	FulfillmentRefundProducts?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FulfillmentRefundProductsKeySpecifier | (() => undefined | FulfillmentRefundProductsKeySpecifier),
		fields?: FulfillmentRefundProductsFieldPolicy,
	},
	FulfillmentReturnProducts?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FulfillmentReturnProductsKeySpecifier | (() => undefined | FulfillmentReturnProductsKeySpecifier),
		fields?: FulfillmentReturnProductsFieldPolicy,
	},
	FulfillmentTrackingNumberUpdated?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FulfillmentTrackingNumberUpdatedKeySpecifier | (() => undefined | FulfillmentTrackingNumberUpdatedKeySpecifier),
		fields?: FulfillmentTrackingNumberUpdatedFieldPolicy,
	},
	FulfillmentUpdateTracking?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FulfillmentUpdateTrackingKeySpecifier | (() => undefined | FulfillmentUpdateTrackingKeySpecifier),
		fields?: FulfillmentUpdateTrackingFieldPolicy,
	},
	GatewayConfigLine?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GatewayConfigLineKeySpecifier | (() => undefined | GatewayConfigLineKeySpecifier),
		fields?: GatewayConfigLineFieldPolicy,
	},
	GiftCard?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GiftCardKeySpecifier | (() => undefined | GiftCardKeySpecifier),
		fields?: GiftCardFieldPolicy,
	},
	GiftCardActivate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GiftCardActivateKeySpecifier | (() => undefined | GiftCardActivateKeySpecifier),
		fields?: GiftCardActivateFieldPolicy,
	},
	GiftCardAddNote?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GiftCardAddNoteKeySpecifier | (() => undefined | GiftCardAddNoteKeySpecifier),
		fields?: GiftCardAddNoteFieldPolicy,
	},
	GiftCardBulkActivate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GiftCardBulkActivateKeySpecifier | (() => undefined | GiftCardBulkActivateKeySpecifier),
		fields?: GiftCardBulkActivateFieldPolicy,
	},
	GiftCardBulkCreate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GiftCardBulkCreateKeySpecifier | (() => undefined | GiftCardBulkCreateKeySpecifier),
		fields?: GiftCardBulkCreateFieldPolicy,
	},
	GiftCardBulkDeactivate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GiftCardBulkDeactivateKeySpecifier | (() => undefined | GiftCardBulkDeactivateKeySpecifier),
		fields?: GiftCardBulkDeactivateFieldPolicy,
	},
	GiftCardBulkDelete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GiftCardBulkDeleteKeySpecifier | (() => undefined | GiftCardBulkDeleteKeySpecifier),
		fields?: GiftCardBulkDeleteFieldPolicy,
	},
	GiftCardCountableConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GiftCardCountableConnectionKeySpecifier | (() => undefined | GiftCardCountableConnectionKeySpecifier),
		fields?: GiftCardCountableConnectionFieldPolicy,
	},
	GiftCardCountableEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GiftCardCountableEdgeKeySpecifier | (() => undefined | GiftCardCountableEdgeKeySpecifier),
		fields?: GiftCardCountableEdgeFieldPolicy,
	},
	GiftCardCreate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GiftCardCreateKeySpecifier | (() => undefined | GiftCardCreateKeySpecifier),
		fields?: GiftCardCreateFieldPolicy,
	},
	GiftCardCreated?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GiftCardCreatedKeySpecifier | (() => undefined | GiftCardCreatedKeySpecifier),
		fields?: GiftCardCreatedFieldPolicy,
	},
	GiftCardDeactivate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GiftCardDeactivateKeySpecifier | (() => undefined | GiftCardDeactivateKeySpecifier),
		fields?: GiftCardDeactivateFieldPolicy,
	},
	GiftCardDelete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GiftCardDeleteKeySpecifier | (() => undefined | GiftCardDeleteKeySpecifier),
		fields?: GiftCardDeleteFieldPolicy,
	},
	GiftCardDeleted?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GiftCardDeletedKeySpecifier | (() => undefined | GiftCardDeletedKeySpecifier),
		fields?: GiftCardDeletedFieldPolicy,
	},
	GiftCardError?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GiftCardErrorKeySpecifier | (() => undefined | GiftCardErrorKeySpecifier),
		fields?: GiftCardErrorFieldPolicy,
	},
	GiftCardEvent?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GiftCardEventKeySpecifier | (() => undefined | GiftCardEventKeySpecifier),
		fields?: GiftCardEventFieldPolicy,
	},
	GiftCardEventBalance?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GiftCardEventBalanceKeySpecifier | (() => undefined | GiftCardEventBalanceKeySpecifier),
		fields?: GiftCardEventBalanceFieldPolicy,
	},
	GiftCardExportCompleted?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GiftCardExportCompletedKeySpecifier | (() => undefined | GiftCardExportCompletedKeySpecifier),
		fields?: GiftCardExportCompletedFieldPolicy,
	},
	GiftCardMetadataUpdated?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GiftCardMetadataUpdatedKeySpecifier | (() => undefined | GiftCardMetadataUpdatedKeySpecifier),
		fields?: GiftCardMetadataUpdatedFieldPolicy,
	},
	GiftCardResend?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GiftCardResendKeySpecifier | (() => undefined | GiftCardResendKeySpecifier),
		fields?: GiftCardResendFieldPolicy,
	},
	GiftCardSent?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GiftCardSentKeySpecifier | (() => undefined | GiftCardSentKeySpecifier),
		fields?: GiftCardSentFieldPolicy,
	},
	GiftCardSettings?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GiftCardSettingsKeySpecifier | (() => undefined | GiftCardSettingsKeySpecifier),
		fields?: GiftCardSettingsFieldPolicy,
	},
	GiftCardSettingsError?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GiftCardSettingsErrorKeySpecifier | (() => undefined | GiftCardSettingsErrorKeySpecifier),
		fields?: GiftCardSettingsErrorFieldPolicy,
	},
	GiftCardSettingsUpdate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GiftCardSettingsUpdateKeySpecifier | (() => undefined | GiftCardSettingsUpdateKeySpecifier),
		fields?: GiftCardSettingsUpdateFieldPolicy,
	},
	GiftCardStatusChanged?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GiftCardStatusChangedKeySpecifier | (() => undefined | GiftCardStatusChangedKeySpecifier),
		fields?: GiftCardStatusChangedFieldPolicy,
	},
	GiftCardTag?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GiftCardTagKeySpecifier | (() => undefined | GiftCardTagKeySpecifier),
		fields?: GiftCardTagFieldPolicy,
	},
	GiftCardTagCountableConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GiftCardTagCountableConnectionKeySpecifier | (() => undefined | GiftCardTagCountableConnectionKeySpecifier),
		fields?: GiftCardTagCountableConnectionFieldPolicy,
	},
	GiftCardTagCountableEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GiftCardTagCountableEdgeKeySpecifier | (() => undefined | GiftCardTagCountableEdgeKeySpecifier),
		fields?: GiftCardTagCountableEdgeFieldPolicy,
	},
	GiftCardUpdate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GiftCardUpdateKeySpecifier | (() => undefined | GiftCardUpdateKeySpecifier),
		fields?: GiftCardUpdateFieldPolicy,
	},
	GiftCardUpdated?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GiftCardUpdatedKeySpecifier | (() => undefined | GiftCardUpdatedKeySpecifier),
		fields?: GiftCardUpdatedFieldPolicy,
	},
	Group?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GroupKeySpecifier | (() => undefined | GroupKeySpecifier),
		fields?: GroupFieldPolicy,
	},
	GroupCountableConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GroupCountableConnectionKeySpecifier | (() => undefined | GroupCountableConnectionKeySpecifier),
		fields?: GroupCountableConnectionFieldPolicy,
	},
	GroupCountableEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GroupCountableEdgeKeySpecifier | (() => undefined | GroupCountableEdgeKeySpecifier),
		fields?: GroupCountableEdgeFieldPolicy,
	},
	Image?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ImageKeySpecifier | (() => undefined | ImageKeySpecifier),
		fields?: ImageFieldPolicy,
	},
	Invoice?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | InvoiceKeySpecifier | (() => undefined | InvoiceKeySpecifier),
		fields?: InvoiceFieldPolicy,
	},
	InvoiceCreate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | InvoiceCreateKeySpecifier | (() => undefined | InvoiceCreateKeySpecifier),
		fields?: InvoiceCreateFieldPolicy,
	},
	InvoiceDelete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | InvoiceDeleteKeySpecifier | (() => undefined | InvoiceDeleteKeySpecifier),
		fields?: InvoiceDeleteFieldPolicy,
	},
	InvoiceDeleted?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | InvoiceDeletedKeySpecifier | (() => undefined | InvoiceDeletedKeySpecifier),
		fields?: InvoiceDeletedFieldPolicy,
	},
	InvoiceError?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | InvoiceErrorKeySpecifier | (() => undefined | InvoiceErrorKeySpecifier),
		fields?: InvoiceErrorFieldPolicy,
	},
	InvoiceRequest?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | InvoiceRequestKeySpecifier | (() => undefined | InvoiceRequestKeySpecifier),
		fields?: InvoiceRequestFieldPolicy,
	},
	InvoiceRequestDelete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | InvoiceRequestDeleteKeySpecifier | (() => undefined | InvoiceRequestDeleteKeySpecifier),
		fields?: InvoiceRequestDeleteFieldPolicy,
	},
	InvoiceRequested?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | InvoiceRequestedKeySpecifier | (() => undefined | InvoiceRequestedKeySpecifier),
		fields?: InvoiceRequestedFieldPolicy,
	},
	InvoiceSendNotification?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | InvoiceSendNotificationKeySpecifier | (() => undefined | InvoiceSendNotificationKeySpecifier),
		fields?: InvoiceSendNotificationFieldPolicy,
	},
	InvoiceSent?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | InvoiceSentKeySpecifier | (() => undefined | InvoiceSentKeySpecifier),
		fields?: InvoiceSentFieldPolicy,
	},
	InvoiceUpdate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | InvoiceUpdateKeySpecifier | (() => undefined | InvoiceUpdateKeySpecifier),
		fields?: InvoiceUpdateFieldPolicy,
	},
	Job?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | JobKeySpecifier | (() => undefined | JobKeySpecifier),
		fields?: JobFieldPolicy,
	},
	LanguageDisplay?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LanguageDisplayKeySpecifier | (() => undefined | LanguageDisplayKeySpecifier),
		fields?: LanguageDisplayFieldPolicy,
	},
	LimitInfo?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LimitInfoKeySpecifier | (() => undefined | LimitInfoKeySpecifier),
		fields?: LimitInfoFieldPolicy,
	},
	Limits?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LimitsKeySpecifier | (() => undefined | LimitsKeySpecifier),
		fields?: LimitsFieldPolicy,
	},
	ListStoredPaymentMethods?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ListStoredPaymentMethodsKeySpecifier | (() => undefined | ListStoredPaymentMethodsKeySpecifier),
		fields?: ListStoredPaymentMethodsFieldPolicy,
	},
	Manifest?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ManifestKeySpecifier | (() => undefined | ManifestKeySpecifier),
		fields?: ManifestFieldPolicy,
	},
	Margin?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MarginKeySpecifier | (() => undefined | MarginKeySpecifier),
		fields?: MarginFieldPolicy,
	},
	Menu?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MenuKeySpecifier | (() => undefined | MenuKeySpecifier),
		fields?: MenuFieldPolicy,
	},
	MenuBulkDelete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MenuBulkDeleteKeySpecifier | (() => undefined | MenuBulkDeleteKeySpecifier),
		fields?: MenuBulkDeleteFieldPolicy,
	},
	MenuCountableConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MenuCountableConnectionKeySpecifier | (() => undefined | MenuCountableConnectionKeySpecifier),
		fields?: MenuCountableConnectionFieldPolicy,
	},
	MenuCountableEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MenuCountableEdgeKeySpecifier | (() => undefined | MenuCountableEdgeKeySpecifier),
		fields?: MenuCountableEdgeFieldPolicy,
	},
	MenuCreate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MenuCreateKeySpecifier | (() => undefined | MenuCreateKeySpecifier),
		fields?: MenuCreateFieldPolicy,
	},
	MenuCreated?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MenuCreatedKeySpecifier | (() => undefined | MenuCreatedKeySpecifier),
		fields?: MenuCreatedFieldPolicy,
	},
	MenuDelete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MenuDeleteKeySpecifier | (() => undefined | MenuDeleteKeySpecifier),
		fields?: MenuDeleteFieldPolicy,
	},
	MenuDeleted?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MenuDeletedKeySpecifier | (() => undefined | MenuDeletedKeySpecifier),
		fields?: MenuDeletedFieldPolicy,
	},
	MenuError?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MenuErrorKeySpecifier | (() => undefined | MenuErrorKeySpecifier),
		fields?: MenuErrorFieldPolicy,
	},
	MenuItem?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MenuItemKeySpecifier | (() => undefined | MenuItemKeySpecifier),
		fields?: MenuItemFieldPolicy,
	},
	MenuItemBulkDelete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MenuItemBulkDeleteKeySpecifier | (() => undefined | MenuItemBulkDeleteKeySpecifier),
		fields?: MenuItemBulkDeleteFieldPolicy,
	},
	MenuItemCountableConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MenuItemCountableConnectionKeySpecifier | (() => undefined | MenuItemCountableConnectionKeySpecifier),
		fields?: MenuItemCountableConnectionFieldPolicy,
	},
	MenuItemCountableEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MenuItemCountableEdgeKeySpecifier | (() => undefined | MenuItemCountableEdgeKeySpecifier),
		fields?: MenuItemCountableEdgeFieldPolicy,
	},
	MenuItemCreate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MenuItemCreateKeySpecifier | (() => undefined | MenuItemCreateKeySpecifier),
		fields?: MenuItemCreateFieldPolicy,
	},
	MenuItemCreated?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MenuItemCreatedKeySpecifier | (() => undefined | MenuItemCreatedKeySpecifier),
		fields?: MenuItemCreatedFieldPolicy,
	},
	MenuItemDelete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MenuItemDeleteKeySpecifier | (() => undefined | MenuItemDeleteKeySpecifier),
		fields?: MenuItemDeleteFieldPolicy,
	},
	MenuItemDeleted?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MenuItemDeletedKeySpecifier | (() => undefined | MenuItemDeletedKeySpecifier),
		fields?: MenuItemDeletedFieldPolicy,
	},
	MenuItemMove?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MenuItemMoveKeySpecifier | (() => undefined | MenuItemMoveKeySpecifier),
		fields?: MenuItemMoveFieldPolicy,
	},
	MenuItemTranslatableContent?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MenuItemTranslatableContentKeySpecifier | (() => undefined | MenuItemTranslatableContentKeySpecifier),
		fields?: MenuItemTranslatableContentFieldPolicy,
	},
	MenuItemTranslate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MenuItemTranslateKeySpecifier | (() => undefined | MenuItemTranslateKeySpecifier),
		fields?: MenuItemTranslateFieldPolicy,
	},
	MenuItemTranslation?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MenuItemTranslationKeySpecifier | (() => undefined | MenuItemTranslationKeySpecifier),
		fields?: MenuItemTranslationFieldPolicy,
	},
	MenuItemUpdate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MenuItemUpdateKeySpecifier | (() => undefined | MenuItemUpdateKeySpecifier),
		fields?: MenuItemUpdateFieldPolicy,
	},
	MenuItemUpdated?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MenuItemUpdatedKeySpecifier | (() => undefined | MenuItemUpdatedKeySpecifier),
		fields?: MenuItemUpdatedFieldPolicy,
	},
	MenuUpdate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MenuUpdateKeySpecifier | (() => undefined | MenuUpdateKeySpecifier),
		fields?: MenuUpdateFieldPolicy,
	},
	MenuUpdated?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MenuUpdatedKeySpecifier | (() => undefined | MenuUpdatedKeySpecifier),
		fields?: MenuUpdatedFieldPolicy,
	},
	MetadataError?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MetadataErrorKeySpecifier | (() => undefined | MetadataErrorKeySpecifier),
		fields?: MetadataErrorFieldPolicy,
	},
	MetadataItem?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MetadataItemKeySpecifier | (() => undefined | MetadataItemKeySpecifier),
		fields?: MetadataItemFieldPolicy,
	},
	Money?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MoneyKeySpecifier | (() => undefined | MoneyKeySpecifier),
		fields?: MoneyFieldPolicy,
	},
	MoneyRange?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MoneyRangeKeySpecifier | (() => undefined | MoneyRangeKeySpecifier),
		fields?: MoneyRangeFieldPolicy,
	},
	Mutation?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MutationKeySpecifier | (() => undefined | MutationKeySpecifier),
		fields?: MutationFieldPolicy,
	},
	NewTabTargetOptions?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | NewTabTargetOptionsKeySpecifier | (() => undefined | NewTabTargetOptionsKeySpecifier),
		fields?: NewTabTargetOptionsFieldPolicy,
	},
	Node?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | NodeKeySpecifier | (() => undefined | NodeKeySpecifier),
		fields?: NodeFieldPolicy,
	},
	ObjectWithAttributes?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ObjectWithAttributesKeySpecifier | (() => undefined | ObjectWithAttributesKeySpecifier),
		fields?: ObjectWithAttributesFieldPolicy,
	},
	ObjectWithMetadata?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ObjectWithMetadataKeySpecifier | (() => undefined | ObjectWithMetadataKeySpecifier),
		fields?: ObjectWithMetadataFieldPolicy,
	},
	Order?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OrderKeySpecifier | (() => undefined | OrderKeySpecifier),
		fields?: OrderFieldPolicy,
	},
	OrderAddNote?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OrderAddNoteKeySpecifier | (() => undefined | OrderAddNoteKeySpecifier),
		fields?: OrderAddNoteFieldPolicy,
	},
	OrderBulkCancel?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OrderBulkCancelKeySpecifier | (() => undefined | OrderBulkCancelKeySpecifier),
		fields?: OrderBulkCancelFieldPolicy,
	},
	OrderBulkCreate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OrderBulkCreateKeySpecifier | (() => undefined | OrderBulkCreateKeySpecifier),
		fields?: OrderBulkCreateFieldPolicy,
	},
	OrderBulkCreateError?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OrderBulkCreateErrorKeySpecifier | (() => undefined | OrderBulkCreateErrorKeySpecifier),
		fields?: OrderBulkCreateErrorFieldPolicy,
	},
	OrderBulkCreateResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OrderBulkCreateResultKeySpecifier | (() => undefined | OrderBulkCreateResultKeySpecifier),
		fields?: OrderBulkCreateResultFieldPolicy,
	},
	OrderBulkCreated?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OrderBulkCreatedKeySpecifier | (() => undefined | OrderBulkCreatedKeySpecifier),
		fields?: OrderBulkCreatedFieldPolicy,
	},
	OrderCancel?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OrderCancelKeySpecifier | (() => undefined | OrderCancelKeySpecifier),
		fields?: OrderCancelFieldPolicy,
	},
	OrderCancelled?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OrderCancelledKeySpecifier | (() => undefined | OrderCancelledKeySpecifier),
		fields?: OrderCancelledFieldPolicy,
	},
	OrderCapture?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OrderCaptureKeySpecifier | (() => undefined | OrderCaptureKeySpecifier),
		fields?: OrderCaptureFieldPolicy,
	},
	OrderConfirm?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OrderConfirmKeySpecifier | (() => undefined | OrderConfirmKeySpecifier),
		fields?: OrderConfirmFieldPolicy,
	},
	OrderConfirmed?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OrderConfirmedKeySpecifier | (() => undefined | OrderConfirmedKeySpecifier),
		fields?: OrderConfirmedFieldPolicy,
	},
	OrderCountableConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OrderCountableConnectionKeySpecifier | (() => undefined | OrderCountableConnectionKeySpecifier),
		fields?: OrderCountableConnectionFieldPolicy,
	},
	OrderCountableEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OrderCountableEdgeKeySpecifier | (() => undefined | OrderCountableEdgeKeySpecifier),
		fields?: OrderCountableEdgeFieldPolicy,
	},
	OrderCreateFromCheckout?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OrderCreateFromCheckoutKeySpecifier | (() => undefined | OrderCreateFromCheckoutKeySpecifier),
		fields?: OrderCreateFromCheckoutFieldPolicy,
	},
	OrderCreateFromCheckoutError?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OrderCreateFromCheckoutErrorKeySpecifier | (() => undefined | OrderCreateFromCheckoutErrorKeySpecifier),
		fields?: OrderCreateFromCheckoutErrorFieldPolicy,
	},
	OrderCreated?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OrderCreatedKeySpecifier | (() => undefined | OrderCreatedKeySpecifier),
		fields?: OrderCreatedFieldPolicy,
	},
	OrderDiscount?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OrderDiscountKeySpecifier | (() => undefined | OrderDiscountKeySpecifier),
		fields?: OrderDiscountFieldPolicy,
	},
	OrderDiscountAdd?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OrderDiscountAddKeySpecifier | (() => undefined | OrderDiscountAddKeySpecifier),
		fields?: OrderDiscountAddFieldPolicy,
	},
	OrderDiscountDelete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OrderDiscountDeleteKeySpecifier | (() => undefined | OrderDiscountDeleteKeySpecifier),
		fields?: OrderDiscountDeleteFieldPolicy,
	},
	OrderDiscountUpdate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OrderDiscountUpdateKeySpecifier | (() => undefined | OrderDiscountUpdateKeySpecifier),
		fields?: OrderDiscountUpdateFieldPolicy,
	},
	OrderError?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OrderErrorKeySpecifier | (() => undefined | OrderErrorKeySpecifier),
		fields?: OrderErrorFieldPolicy,
	},
	OrderEvent?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OrderEventKeySpecifier | (() => undefined | OrderEventKeySpecifier),
		fields?: OrderEventFieldPolicy,
	},
	OrderEventCountableConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OrderEventCountableConnectionKeySpecifier | (() => undefined | OrderEventCountableConnectionKeySpecifier),
		fields?: OrderEventCountableConnectionFieldPolicy,
	},
	OrderEventCountableEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OrderEventCountableEdgeKeySpecifier | (() => undefined | OrderEventCountableEdgeKeySpecifier),
		fields?: OrderEventCountableEdgeFieldPolicy,
	},
	OrderEventDiscountObject?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OrderEventDiscountObjectKeySpecifier | (() => undefined | OrderEventDiscountObjectKeySpecifier),
		fields?: OrderEventDiscountObjectFieldPolicy,
	},
	OrderEventOrderLineObject?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OrderEventOrderLineObjectKeySpecifier | (() => undefined | OrderEventOrderLineObjectKeySpecifier),
		fields?: OrderEventOrderLineObjectFieldPolicy,
	},
	OrderExpired?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OrderExpiredKeySpecifier | (() => undefined | OrderExpiredKeySpecifier),
		fields?: OrderExpiredFieldPolicy,
	},
	OrderFilterShippingMethods?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OrderFilterShippingMethodsKeySpecifier | (() => undefined | OrderFilterShippingMethodsKeySpecifier),
		fields?: OrderFilterShippingMethodsFieldPolicy,
	},
	OrderFulfill?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OrderFulfillKeySpecifier | (() => undefined | OrderFulfillKeySpecifier),
		fields?: OrderFulfillFieldPolicy,
	},
	OrderFulfilled?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OrderFulfilledKeySpecifier | (() => undefined | OrderFulfilledKeySpecifier),
		fields?: OrderFulfilledFieldPolicy,
	},
	OrderFullyPaid?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OrderFullyPaidKeySpecifier | (() => undefined | OrderFullyPaidKeySpecifier),
		fields?: OrderFullyPaidFieldPolicy,
	},
	OrderFullyRefunded?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OrderFullyRefundedKeySpecifier | (() => undefined | OrderFullyRefundedKeySpecifier),
		fields?: OrderFullyRefundedFieldPolicy,
	},
	OrderGrantRefundCreate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OrderGrantRefundCreateKeySpecifier | (() => undefined | OrderGrantRefundCreateKeySpecifier),
		fields?: OrderGrantRefundCreateFieldPolicy,
	},
	OrderGrantRefundCreateError?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OrderGrantRefundCreateErrorKeySpecifier | (() => undefined | OrderGrantRefundCreateErrorKeySpecifier),
		fields?: OrderGrantRefundCreateErrorFieldPolicy,
	},
	OrderGrantRefundCreateLineError?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OrderGrantRefundCreateLineErrorKeySpecifier | (() => undefined | OrderGrantRefundCreateLineErrorKeySpecifier),
		fields?: OrderGrantRefundCreateLineErrorFieldPolicy,
	},
	OrderGrantRefundUpdate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OrderGrantRefundUpdateKeySpecifier | (() => undefined | OrderGrantRefundUpdateKeySpecifier),
		fields?: OrderGrantRefundUpdateFieldPolicy,
	},
	OrderGrantRefundUpdateError?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OrderGrantRefundUpdateErrorKeySpecifier | (() => undefined | OrderGrantRefundUpdateErrorKeySpecifier),
		fields?: OrderGrantRefundUpdateErrorFieldPolicy,
	},
	OrderGrantRefundUpdateLineError?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OrderGrantRefundUpdateLineErrorKeySpecifier | (() => undefined | OrderGrantRefundUpdateLineErrorKeySpecifier),
		fields?: OrderGrantRefundUpdateLineErrorFieldPolicy,
	},
	OrderGrantedRefund?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OrderGrantedRefundKeySpecifier | (() => undefined | OrderGrantedRefundKeySpecifier),
		fields?: OrderGrantedRefundFieldPolicy,
	},
	OrderGrantedRefundLine?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OrderGrantedRefundLineKeySpecifier | (() => undefined | OrderGrantedRefundLineKeySpecifier),
		fields?: OrderGrantedRefundLineFieldPolicy,
	},
	OrderLine?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OrderLineKeySpecifier | (() => undefined | OrderLineKeySpecifier),
		fields?: OrderLineFieldPolicy,
	},
	OrderLineDelete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OrderLineDeleteKeySpecifier | (() => undefined | OrderLineDeleteKeySpecifier),
		fields?: OrderLineDeleteFieldPolicy,
	},
	OrderLineDiscount?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OrderLineDiscountKeySpecifier | (() => undefined | OrderLineDiscountKeySpecifier),
		fields?: OrderLineDiscountFieldPolicy,
	},
	OrderLineDiscountRemove?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OrderLineDiscountRemoveKeySpecifier | (() => undefined | OrderLineDiscountRemoveKeySpecifier),
		fields?: OrderLineDiscountRemoveFieldPolicy,
	},
	OrderLineDiscountUpdate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OrderLineDiscountUpdateKeySpecifier | (() => undefined | OrderLineDiscountUpdateKeySpecifier),
		fields?: OrderLineDiscountUpdateFieldPolicy,
	},
	OrderLineUpdate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OrderLineUpdateKeySpecifier | (() => undefined | OrderLineUpdateKeySpecifier),
		fields?: OrderLineUpdateFieldPolicy,
	},
	OrderLinesCreate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OrderLinesCreateKeySpecifier | (() => undefined | OrderLinesCreateKeySpecifier),
		fields?: OrderLinesCreateFieldPolicy,
	},
	OrderMarkAsPaid?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OrderMarkAsPaidKeySpecifier | (() => undefined | OrderMarkAsPaidKeySpecifier),
		fields?: OrderMarkAsPaidFieldPolicy,
	},
	OrderMetadataUpdated?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OrderMetadataUpdatedKeySpecifier | (() => undefined | OrderMetadataUpdatedKeySpecifier),
		fields?: OrderMetadataUpdatedFieldPolicy,
	},
	OrderNoteAdd?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OrderNoteAddKeySpecifier | (() => undefined | OrderNoteAddKeySpecifier),
		fields?: OrderNoteAddFieldPolicy,
	},
	OrderNoteAddError?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OrderNoteAddErrorKeySpecifier | (() => undefined | OrderNoteAddErrorKeySpecifier),
		fields?: OrderNoteAddErrorFieldPolicy,
	},
	OrderNoteUpdate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OrderNoteUpdateKeySpecifier | (() => undefined | OrderNoteUpdateKeySpecifier),
		fields?: OrderNoteUpdateFieldPolicy,
	},
	OrderNoteUpdateError?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OrderNoteUpdateErrorKeySpecifier | (() => undefined | OrderNoteUpdateErrorKeySpecifier),
		fields?: OrderNoteUpdateErrorFieldPolicy,
	},
	OrderPaid?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OrderPaidKeySpecifier | (() => undefined | OrderPaidKeySpecifier),
		fields?: OrderPaidFieldPolicy,
	},
	OrderRefund?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OrderRefundKeySpecifier | (() => undefined | OrderRefundKeySpecifier),
		fields?: OrderRefundFieldPolicy,
	},
	OrderRefunded?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OrderRefundedKeySpecifier | (() => undefined | OrderRefundedKeySpecifier),
		fields?: OrderRefundedFieldPolicy,
	},
	OrderSettings?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OrderSettingsKeySpecifier | (() => undefined | OrderSettingsKeySpecifier),
		fields?: OrderSettingsFieldPolicy,
	},
	OrderSettingsError?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OrderSettingsErrorKeySpecifier | (() => undefined | OrderSettingsErrorKeySpecifier),
		fields?: OrderSettingsErrorFieldPolicy,
	},
	OrderSettingsUpdate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OrderSettingsUpdateKeySpecifier | (() => undefined | OrderSettingsUpdateKeySpecifier),
		fields?: OrderSettingsUpdateFieldPolicy,
	},
	OrderUpdate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OrderUpdateKeySpecifier | (() => undefined | OrderUpdateKeySpecifier),
		fields?: OrderUpdateFieldPolicy,
	},
	OrderUpdateShipping?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OrderUpdateShippingKeySpecifier | (() => undefined | OrderUpdateShippingKeySpecifier),
		fields?: OrderUpdateShippingFieldPolicy,
	},
	OrderUpdated?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OrderUpdatedKeySpecifier | (() => undefined | OrderUpdatedKeySpecifier),
		fields?: OrderUpdatedFieldPolicy,
	},
	OrderVoid?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OrderVoidKeySpecifier | (() => undefined | OrderVoidKeySpecifier),
		fields?: OrderVoidFieldPolicy,
	},
	OtherPaymentMethodDetails?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OtherPaymentMethodDetailsKeySpecifier | (() => undefined | OtherPaymentMethodDetailsKeySpecifier),
		fields?: OtherPaymentMethodDetailsFieldPolicy,
	},
	Page?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PageKeySpecifier | (() => undefined | PageKeySpecifier),
		fields?: PageFieldPolicy,
	},
	PageAttributeAssign?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PageAttributeAssignKeySpecifier | (() => undefined | PageAttributeAssignKeySpecifier),
		fields?: PageAttributeAssignFieldPolicy,
	},
	PageAttributeUnassign?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PageAttributeUnassignKeySpecifier | (() => undefined | PageAttributeUnassignKeySpecifier),
		fields?: PageAttributeUnassignFieldPolicy,
	},
	PageBulkDelete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PageBulkDeleteKeySpecifier | (() => undefined | PageBulkDeleteKeySpecifier),
		fields?: PageBulkDeleteFieldPolicy,
	},
	PageBulkPublish?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PageBulkPublishKeySpecifier | (() => undefined | PageBulkPublishKeySpecifier),
		fields?: PageBulkPublishFieldPolicy,
	},
	PageCountableConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PageCountableConnectionKeySpecifier | (() => undefined | PageCountableConnectionKeySpecifier),
		fields?: PageCountableConnectionFieldPolicy,
	},
	PageCountableEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PageCountableEdgeKeySpecifier | (() => undefined | PageCountableEdgeKeySpecifier),
		fields?: PageCountableEdgeFieldPolicy,
	},
	PageCreate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PageCreateKeySpecifier | (() => undefined | PageCreateKeySpecifier),
		fields?: PageCreateFieldPolicy,
	},
	PageCreated?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PageCreatedKeySpecifier | (() => undefined | PageCreatedKeySpecifier),
		fields?: PageCreatedFieldPolicy,
	},
	PageDelete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PageDeleteKeySpecifier | (() => undefined | PageDeleteKeySpecifier),
		fields?: PageDeleteFieldPolicy,
	},
	PageDeleted?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PageDeletedKeySpecifier | (() => undefined | PageDeletedKeySpecifier),
		fields?: PageDeletedFieldPolicy,
	},
	PageError?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PageErrorKeySpecifier | (() => undefined | PageErrorKeySpecifier),
		fields?: PageErrorFieldPolicy,
	},
	PageInfo?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PageInfoKeySpecifier | (() => undefined | PageInfoKeySpecifier),
		fields?: PageInfoFieldPolicy,
	},
	PageReorderAttributeValues?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PageReorderAttributeValuesKeySpecifier | (() => undefined | PageReorderAttributeValuesKeySpecifier),
		fields?: PageReorderAttributeValuesFieldPolicy,
	},
	PageTranslatableContent?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PageTranslatableContentKeySpecifier | (() => undefined | PageTranslatableContentKeySpecifier),
		fields?: PageTranslatableContentFieldPolicy,
	},
	PageTranslate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PageTranslateKeySpecifier | (() => undefined | PageTranslateKeySpecifier),
		fields?: PageTranslateFieldPolicy,
	},
	PageTranslation?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PageTranslationKeySpecifier | (() => undefined | PageTranslationKeySpecifier),
		fields?: PageTranslationFieldPolicy,
	},
	PageType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PageTypeKeySpecifier | (() => undefined | PageTypeKeySpecifier),
		fields?: PageTypeFieldPolicy,
	},
	PageTypeBulkDelete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PageTypeBulkDeleteKeySpecifier | (() => undefined | PageTypeBulkDeleteKeySpecifier),
		fields?: PageTypeBulkDeleteFieldPolicy,
	},
	PageTypeCountableConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PageTypeCountableConnectionKeySpecifier | (() => undefined | PageTypeCountableConnectionKeySpecifier),
		fields?: PageTypeCountableConnectionFieldPolicy,
	},
	PageTypeCountableEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PageTypeCountableEdgeKeySpecifier | (() => undefined | PageTypeCountableEdgeKeySpecifier),
		fields?: PageTypeCountableEdgeFieldPolicy,
	},
	PageTypeCreate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PageTypeCreateKeySpecifier | (() => undefined | PageTypeCreateKeySpecifier),
		fields?: PageTypeCreateFieldPolicy,
	},
	PageTypeCreated?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PageTypeCreatedKeySpecifier | (() => undefined | PageTypeCreatedKeySpecifier),
		fields?: PageTypeCreatedFieldPolicy,
	},
	PageTypeDelete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PageTypeDeleteKeySpecifier | (() => undefined | PageTypeDeleteKeySpecifier),
		fields?: PageTypeDeleteFieldPolicy,
	},
	PageTypeDeleted?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PageTypeDeletedKeySpecifier | (() => undefined | PageTypeDeletedKeySpecifier),
		fields?: PageTypeDeletedFieldPolicy,
	},
	PageTypeReorderAttributes?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PageTypeReorderAttributesKeySpecifier | (() => undefined | PageTypeReorderAttributesKeySpecifier),
		fields?: PageTypeReorderAttributesFieldPolicy,
	},
	PageTypeUpdate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PageTypeUpdateKeySpecifier | (() => undefined | PageTypeUpdateKeySpecifier),
		fields?: PageTypeUpdateFieldPolicy,
	},
	PageTypeUpdated?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PageTypeUpdatedKeySpecifier | (() => undefined | PageTypeUpdatedKeySpecifier),
		fields?: PageTypeUpdatedFieldPolicy,
	},
	PageUpdate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PageUpdateKeySpecifier | (() => undefined | PageUpdateKeySpecifier),
		fields?: PageUpdateFieldPolicy,
	},
	PageUpdated?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PageUpdatedKeySpecifier | (() => undefined | PageUpdatedKeySpecifier),
		fields?: PageUpdatedFieldPolicy,
	},
	PasswordChange?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PasswordChangeKeySpecifier | (() => undefined | PasswordChangeKeySpecifier),
		fields?: PasswordChangeFieldPolicy,
	},
	Payment?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PaymentKeySpecifier | (() => undefined | PaymentKeySpecifier),
		fields?: PaymentFieldPolicy,
	},
	PaymentAuthorize?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PaymentAuthorizeKeySpecifier | (() => undefined | PaymentAuthorizeKeySpecifier),
		fields?: PaymentAuthorizeFieldPolicy,
	},
	PaymentCapture?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PaymentCaptureKeySpecifier | (() => undefined | PaymentCaptureKeySpecifier),
		fields?: PaymentCaptureFieldPolicy,
	},
	PaymentCaptureEvent?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PaymentCaptureEventKeySpecifier | (() => undefined | PaymentCaptureEventKeySpecifier),
		fields?: PaymentCaptureEventFieldPolicy,
	},
	PaymentCheckBalance?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PaymentCheckBalanceKeySpecifier | (() => undefined | PaymentCheckBalanceKeySpecifier),
		fields?: PaymentCheckBalanceFieldPolicy,
	},
	PaymentConfirmEvent?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PaymentConfirmEventKeySpecifier | (() => undefined | PaymentConfirmEventKeySpecifier),
		fields?: PaymentConfirmEventFieldPolicy,
	},
	PaymentCountableConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PaymentCountableConnectionKeySpecifier | (() => undefined | PaymentCountableConnectionKeySpecifier),
		fields?: PaymentCountableConnectionFieldPolicy,
	},
	PaymentCountableEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PaymentCountableEdgeKeySpecifier | (() => undefined | PaymentCountableEdgeKeySpecifier),
		fields?: PaymentCountableEdgeFieldPolicy,
	},
	PaymentError?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PaymentErrorKeySpecifier | (() => undefined | PaymentErrorKeySpecifier),
		fields?: PaymentErrorFieldPolicy,
	},
	PaymentGateway?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PaymentGatewayKeySpecifier | (() => undefined | PaymentGatewayKeySpecifier),
		fields?: PaymentGatewayFieldPolicy,
	},
	PaymentGatewayConfig?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PaymentGatewayConfigKeySpecifier | (() => undefined | PaymentGatewayConfigKeySpecifier),
		fields?: PaymentGatewayConfigFieldPolicy,
	},
	PaymentGatewayConfigError?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PaymentGatewayConfigErrorKeySpecifier | (() => undefined | PaymentGatewayConfigErrorKeySpecifier),
		fields?: PaymentGatewayConfigErrorFieldPolicy,
	},
	PaymentGatewayInitialize?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PaymentGatewayInitializeKeySpecifier | (() => undefined | PaymentGatewayInitializeKeySpecifier),
		fields?: PaymentGatewayInitializeFieldPolicy,
	},
	PaymentGatewayInitializeError?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PaymentGatewayInitializeErrorKeySpecifier | (() => undefined | PaymentGatewayInitializeErrorKeySpecifier),
		fields?: PaymentGatewayInitializeErrorFieldPolicy,
	},
	PaymentGatewayInitializeSession?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PaymentGatewayInitializeSessionKeySpecifier | (() => undefined | PaymentGatewayInitializeSessionKeySpecifier),
		fields?: PaymentGatewayInitializeSessionFieldPolicy,
	},
	PaymentGatewayInitializeTokenization?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PaymentGatewayInitializeTokenizationKeySpecifier | (() => undefined | PaymentGatewayInitializeTokenizationKeySpecifier),
		fields?: PaymentGatewayInitializeTokenizationFieldPolicy,
	},
	PaymentGatewayInitializeTokenizationError?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PaymentGatewayInitializeTokenizationErrorKeySpecifier | (() => undefined | PaymentGatewayInitializeTokenizationErrorKeySpecifier),
		fields?: PaymentGatewayInitializeTokenizationErrorFieldPolicy,
	},
	PaymentGatewayInitializeTokenizationSession?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PaymentGatewayInitializeTokenizationSessionKeySpecifier | (() => undefined | PaymentGatewayInitializeTokenizationSessionKeySpecifier),
		fields?: PaymentGatewayInitializeTokenizationSessionFieldPolicy,
	},
	PaymentInitialize?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PaymentInitializeKeySpecifier | (() => undefined | PaymentInitializeKeySpecifier),
		fields?: PaymentInitializeFieldPolicy,
	},
	PaymentInitialized?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PaymentInitializedKeySpecifier | (() => undefined | PaymentInitializedKeySpecifier),
		fields?: PaymentInitializedFieldPolicy,
	},
	PaymentListGateways?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PaymentListGatewaysKeySpecifier | (() => undefined | PaymentListGatewaysKeySpecifier),
		fields?: PaymentListGatewaysFieldPolicy,
	},
	PaymentMethodDetails?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PaymentMethodDetailsKeySpecifier | (() => undefined | PaymentMethodDetailsKeySpecifier),
		fields?: PaymentMethodDetailsFieldPolicy,
	},
	PaymentMethodInitializeTokenization?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PaymentMethodInitializeTokenizationKeySpecifier | (() => undefined | PaymentMethodInitializeTokenizationKeySpecifier),
		fields?: PaymentMethodInitializeTokenizationFieldPolicy,
	},
	PaymentMethodInitializeTokenizationError?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PaymentMethodInitializeTokenizationErrorKeySpecifier | (() => undefined | PaymentMethodInitializeTokenizationErrorKeySpecifier),
		fields?: PaymentMethodInitializeTokenizationErrorFieldPolicy,
	},
	PaymentMethodInitializeTokenizationSession?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PaymentMethodInitializeTokenizationSessionKeySpecifier | (() => undefined | PaymentMethodInitializeTokenizationSessionKeySpecifier),
		fields?: PaymentMethodInitializeTokenizationSessionFieldPolicy,
	},
	PaymentMethodProcessTokenization?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PaymentMethodProcessTokenizationKeySpecifier | (() => undefined | PaymentMethodProcessTokenizationKeySpecifier),
		fields?: PaymentMethodProcessTokenizationFieldPolicy,
	},
	PaymentMethodProcessTokenizationError?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PaymentMethodProcessTokenizationErrorKeySpecifier | (() => undefined | PaymentMethodProcessTokenizationErrorKeySpecifier),
		fields?: PaymentMethodProcessTokenizationErrorFieldPolicy,
	},
	PaymentMethodProcessTokenizationSession?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PaymentMethodProcessTokenizationSessionKeySpecifier | (() => undefined | PaymentMethodProcessTokenizationSessionKeySpecifier),
		fields?: PaymentMethodProcessTokenizationSessionFieldPolicy,
	},
	PaymentMethodRequestDeleteError?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PaymentMethodRequestDeleteErrorKeySpecifier | (() => undefined | PaymentMethodRequestDeleteErrorKeySpecifier),
		fields?: PaymentMethodRequestDeleteErrorFieldPolicy,
	},
	PaymentProcessEvent?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PaymentProcessEventKeySpecifier | (() => undefined | PaymentProcessEventKeySpecifier),
		fields?: PaymentProcessEventFieldPolicy,
	},
	PaymentRefund?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PaymentRefundKeySpecifier | (() => undefined | PaymentRefundKeySpecifier),
		fields?: PaymentRefundFieldPolicy,
	},
	PaymentRefundEvent?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PaymentRefundEventKeySpecifier | (() => undefined | PaymentRefundEventKeySpecifier),
		fields?: PaymentRefundEventFieldPolicy,
	},
	PaymentSettings?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PaymentSettingsKeySpecifier | (() => undefined | PaymentSettingsKeySpecifier),
		fields?: PaymentSettingsFieldPolicy,
	},
	PaymentSource?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PaymentSourceKeySpecifier | (() => undefined | PaymentSourceKeySpecifier),
		fields?: PaymentSourceFieldPolicy,
	},
	PaymentVoid?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PaymentVoidKeySpecifier | (() => undefined | PaymentVoidKeySpecifier),
		fields?: PaymentVoidFieldPolicy,
	},
	PaymentVoidEvent?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PaymentVoidEventKeySpecifier | (() => undefined | PaymentVoidEventKeySpecifier),
		fields?: PaymentVoidEventFieldPolicy,
	},
	Permission?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PermissionKeySpecifier | (() => undefined | PermissionKeySpecifier),
		fields?: PermissionFieldPolicy,
	},
	PermissionGroupCreate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PermissionGroupCreateKeySpecifier | (() => undefined | PermissionGroupCreateKeySpecifier),
		fields?: PermissionGroupCreateFieldPolicy,
	},
	PermissionGroupCreated?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PermissionGroupCreatedKeySpecifier | (() => undefined | PermissionGroupCreatedKeySpecifier),
		fields?: PermissionGroupCreatedFieldPolicy,
	},
	PermissionGroupDelete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PermissionGroupDeleteKeySpecifier | (() => undefined | PermissionGroupDeleteKeySpecifier),
		fields?: PermissionGroupDeleteFieldPolicy,
	},
	PermissionGroupDeleted?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PermissionGroupDeletedKeySpecifier | (() => undefined | PermissionGroupDeletedKeySpecifier),
		fields?: PermissionGroupDeletedFieldPolicy,
	},
	PermissionGroupError?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PermissionGroupErrorKeySpecifier | (() => undefined | PermissionGroupErrorKeySpecifier),
		fields?: PermissionGroupErrorFieldPolicy,
	},
	PermissionGroupUpdate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PermissionGroupUpdateKeySpecifier | (() => undefined | PermissionGroupUpdateKeySpecifier),
		fields?: PermissionGroupUpdateFieldPolicy,
	},
	PermissionGroupUpdated?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PermissionGroupUpdatedKeySpecifier | (() => undefined | PermissionGroupUpdatedKeySpecifier),
		fields?: PermissionGroupUpdatedFieldPolicy,
	},
	Plugin?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PluginKeySpecifier | (() => undefined | PluginKeySpecifier),
		fields?: PluginFieldPolicy,
	},
	PluginConfiguration?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PluginConfigurationKeySpecifier | (() => undefined | PluginConfigurationKeySpecifier),
		fields?: PluginConfigurationFieldPolicy,
	},
	PluginCountableConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PluginCountableConnectionKeySpecifier | (() => undefined | PluginCountableConnectionKeySpecifier),
		fields?: PluginCountableConnectionFieldPolicy,
	},
	PluginCountableEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PluginCountableEdgeKeySpecifier | (() => undefined | PluginCountableEdgeKeySpecifier),
		fields?: PluginCountableEdgeFieldPolicy,
	},
	PluginError?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PluginErrorKeySpecifier | (() => undefined | PluginErrorKeySpecifier),
		fields?: PluginErrorFieldPolicy,
	},
	PluginUpdate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PluginUpdateKeySpecifier | (() => undefined | PluginUpdateKeySpecifier),
		fields?: PluginUpdateFieldPolicy,
	},
	PreorderData?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PreorderDataKeySpecifier | (() => undefined | PreorderDataKeySpecifier),
		fields?: PreorderDataFieldPolicy,
	},
	PreorderThreshold?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PreorderThresholdKeySpecifier | (() => undefined | PreorderThresholdKeySpecifier),
		fields?: PreorderThresholdFieldPolicy,
	},
	Product?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductKeySpecifier | (() => undefined | ProductKeySpecifier),
		fields?: ProductFieldPolicy,
	},
	ProductAttributeAssign?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductAttributeAssignKeySpecifier | (() => undefined | ProductAttributeAssignKeySpecifier),
		fields?: ProductAttributeAssignFieldPolicy,
	},
	ProductAttributeAssignmentUpdate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductAttributeAssignmentUpdateKeySpecifier | (() => undefined | ProductAttributeAssignmentUpdateKeySpecifier),
		fields?: ProductAttributeAssignmentUpdateFieldPolicy,
	},
	ProductAttributeUnassign?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductAttributeUnassignKeySpecifier | (() => undefined | ProductAttributeUnassignKeySpecifier),
		fields?: ProductAttributeUnassignFieldPolicy,
	},
	ProductBulkCreate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductBulkCreateKeySpecifier | (() => undefined | ProductBulkCreateKeySpecifier),
		fields?: ProductBulkCreateFieldPolicy,
	},
	ProductBulkCreateError?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductBulkCreateErrorKeySpecifier | (() => undefined | ProductBulkCreateErrorKeySpecifier),
		fields?: ProductBulkCreateErrorFieldPolicy,
	},
	ProductBulkDelete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductBulkDeleteKeySpecifier | (() => undefined | ProductBulkDeleteKeySpecifier),
		fields?: ProductBulkDeleteFieldPolicy,
	},
	ProductBulkResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductBulkResultKeySpecifier | (() => undefined | ProductBulkResultKeySpecifier),
		fields?: ProductBulkResultFieldPolicy,
	},
	ProductBulkTranslate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductBulkTranslateKeySpecifier | (() => undefined | ProductBulkTranslateKeySpecifier),
		fields?: ProductBulkTranslateFieldPolicy,
	},
	ProductBulkTranslateError?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductBulkTranslateErrorKeySpecifier | (() => undefined | ProductBulkTranslateErrorKeySpecifier),
		fields?: ProductBulkTranslateErrorFieldPolicy,
	},
	ProductBulkTranslateResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductBulkTranslateResultKeySpecifier | (() => undefined | ProductBulkTranslateResultKeySpecifier),
		fields?: ProductBulkTranslateResultFieldPolicy,
	},
	ProductChannelListing?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductChannelListingKeySpecifier | (() => undefined | ProductChannelListingKeySpecifier),
		fields?: ProductChannelListingFieldPolicy,
	},
	ProductChannelListingError?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductChannelListingErrorKeySpecifier | (() => undefined | ProductChannelListingErrorKeySpecifier),
		fields?: ProductChannelListingErrorFieldPolicy,
	},
	ProductChannelListingUpdate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductChannelListingUpdateKeySpecifier | (() => undefined | ProductChannelListingUpdateKeySpecifier),
		fields?: ProductChannelListingUpdateFieldPolicy,
	},
	ProductCountableConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductCountableConnectionKeySpecifier | (() => undefined | ProductCountableConnectionKeySpecifier),
		fields?: ProductCountableConnectionFieldPolicy,
	},
	ProductCountableEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductCountableEdgeKeySpecifier | (() => undefined | ProductCountableEdgeKeySpecifier),
		fields?: ProductCountableEdgeFieldPolicy,
	},
	ProductCreate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductCreateKeySpecifier | (() => undefined | ProductCreateKeySpecifier),
		fields?: ProductCreateFieldPolicy,
	},
	ProductCreated?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductCreatedKeySpecifier | (() => undefined | ProductCreatedKeySpecifier),
		fields?: ProductCreatedFieldPolicy,
	},
	ProductDelete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductDeleteKeySpecifier | (() => undefined | ProductDeleteKeySpecifier),
		fields?: ProductDeleteFieldPolicy,
	},
	ProductDeleted?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductDeletedKeySpecifier | (() => undefined | ProductDeletedKeySpecifier),
		fields?: ProductDeletedFieldPolicy,
	},
	ProductError?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductErrorKeySpecifier | (() => undefined | ProductErrorKeySpecifier),
		fields?: ProductErrorFieldPolicy,
	},
	ProductExportCompleted?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductExportCompletedKeySpecifier | (() => undefined | ProductExportCompletedKeySpecifier),
		fields?: ProductExportCompletedFieldPolicy,
	},
	ProductImage?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductImageKeySpecifier | (() => undefined | ProductImageKeySpecifier),
		fields?: ProductImageFieldPolicy,
	},
	ProductMedia?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductMediaKeySpecifier | (() => undefined | ProductMediaKeySpecifier),
		fields?: ProductMediaFieldPolicy,
	},
	ProductMediaBulkDelete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductMediaBulkDeleteKeySpecifier | (() => undefined | ProductMediaBulkDeleteKeySpecifier),
		fields?: ProductMediaBulkDeleteFieldPolicy,
	},
	ProductMediaCreate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductMediaCreateKeySpecifier | (() => undefined | ProductMediaCreateKeySpecifier),
		fields?: ProductMediaCreateFieldPolicy,
	},
	ProductMediaCreated?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductMediaCreatedKeySpecifier | (() => undefined | ProductMediaCreatedKeySpecifier),
		fields?: ProductMediaCreatedFieldPolicy,
	},
	ProductMediaDelete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductMediaDeleteKeySpecifier | (() => undefined | ProductMediaDeleteKeySpecifier),
		fields?: ProductMediaDeleteFieldPolicy,
	},
	ProductMediaDeleted?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductMediaDeletedKeySpecifier | (() => undefined | ProductMediaDeletedKeySpecifier),
		fields?: ProductMediaDeletedFieldPolicy,
	},
	ProductMediaReorder?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductMediaReorderKeySpecifier | (() => undefined | ProductMediaReorderKeySpecifier),
		fields?: ProductMediaReorderFieldPolicy,
	},
	ProductMediaUpdate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductMediaUpdateKeySpecifier | (() => undefined | ProductMediaUpdateKeySpecifier),
		fields?: ProductMediaUpdateFieldPolicy,
	},
	ProductMediaUpdated?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductMediaUpdatedKeySpecifier | (() => undefined | ProductMediaUpdatedKeySpecifier),
		fields?: ProductMediaUpdatedFieldPolicy,
	},
	ProductMetadataUpdated?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductMetadataUpdatedKeySpecifier | (() => undefined | ProductMetadataUpdatedKeySpecifier),
		fields?: ProductMetadataUpdatedFieldPolicy,
	},
	ProductPricingInfo?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductPricingInfoKeySpecifier | (() => undefined | ProductPricingInfoKeySpecifier),
		fields?: ProductPricingInfoFieldPolicy,
	},
	ProductReorderAttributeValues?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductReorderAttributeValuesKeySpecifier | (() => undefined | ProductReorderAttributeValuesKeySpecifier),
		fields?: ProductReorderAttributeValuesFieldPolicy,
	},
	ProductTranslatableContent?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductTranslatableContentKeySpecifier | (() => undefined | ProductTranslatableContentKeySpecifier),
		fields?: ProductTranslatableContentFieldPolicy,
	},
	ProductTranslate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductTranslateKeySpecifier | (() => undefined | ProductTranslateKeySpecifier),
		fields?: ProductTranslateFieldPolicy,
	},
	ProductTranslation?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductTranslationKeySpecifier | (() => undefined | ProductTranslationKeySpecifier),
		fields?: ProductTranslationFieldPolicy,
	},
	ProductType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductTypeKeySpecifier | (() => undefined | ProductTypeKeySpecifier),
		fields?: ProductTypeFieldPolicy,
	},
	ProductTypeBulkDelete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductTypeBulkDeleteKeySpecifier | (() => undefined | ProductTypeBulkDeleteKeySpecifier),
		fields?: ProductTypeBulkDeleteFieldPolicy,
	},
	ProductTypeCountableConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductTypeCountableConnectionKeySpecifier | (() => undefined | ProductTypeCountableConnectionKeySpecifier),
		fields?: ProductTypeCountableConnectionFieldPolicy,
	},
	ProductTypeCountableEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductTypeCountableEdgeKeySpecifier | (() => undefined | ProductTypeCountableEdgeKeySpecifier),
		fields?: ProductTypeCountableEdgeFieldPolicy,
	},
	ProductTypeCreate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductTypeCreateKeySpecifier | (() => undefined | ProductTypeCreateKeySpecifier),
		fields?: ProductTypeCreateFieldPolicy,
	},
	ProductTypeDelete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductTypeDeleteKeySpecifier | (() => undefined | ProductTypeDeleteKeySpecifier),
		fields?: ProductTypeDeleteFieldPolicy,
	},
	ProductTypeReorderAttributes?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductTypeReorderAttributesKeySpecifier | (() => undefined | ProductTypeReorderAttributesKeySpecifier),
		fields?: ProductTypeReorderAttributesFieldPolicy,
	},
	ProductTypeUpdate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductTypeUpdateKeySpecifier | (() => undefined | ProductTypeUpdateKeySpecifier),
		fields?: ProductTypeUpdateFieldPolicy,
	},
	ProductUpdate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductUpdateKeySpecifier | (() => undefined | ProductUpdateKeySpecifier),
		fields?: ProductUpdateFieldPolicy,
	},
	ProductUpdated?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductUpdatedKeySpecifier | (() => undefined | ProductUpdatedKeySpecifier),
		fields?: ProductUpdatedFieldPolicy,
	},
	ProductVariant?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductVariantKeySpecifier | (() => undefined | ProductVariantKeySpecifier),
		fields?: ProductVariantFieldPolicy,
	},
	ProductVariantBackInStock?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductVariantBackInStockKeySpecifier | (() => undefined | ProductVariantBackInStockKeySpecifier),
		fields?: ProductVariantBackInStockFieldPolicy,
	},
	ProductVariantBulkCreate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductVariantBulkCreateKeySpecifier | (() => undefined | ProductVariantBulkCreateKeySpecifier),
		fields?: ProductVariantBulkCreateFieldPolicy,
	},
	ProductVariantBulkDelete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductVariantBulkDeleteKeySpecifier | (() => undefined | ProductVariantBulkDeleteKeySpecifier),
		fields?: ProductVariantBulkDeleteFieldPolicy,
	},
	ProductVariantBulkError?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductVariantBulkErrorKeySpecifier | (() => undefined | ProductVariantBulkErrorKeySpecifier),
		fields?: ProductVariantBulkErrorFieldPolicy,
	},
	ProductVariantBulkResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductVariantBulkResultKeySpecifier | (() => undefined | ProductVariantBulkResultKeySpecifier),
		fields?: ProductVariantBulkResultFieldPolicy,
	},
	ProductVariantBulkTranslate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductVariantBulkTranslateKeySpecifier | (() => undefined | ProductVariantBulkTranslateKeySpecifier),
		fields?: ProductVariantBulkTranslateFieldPolicy,
	},
	ProductVariantBulkTranslateError?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductVariantBulkTranslateErrorKeySpecifier | (() => undefined | ProductVariantBulkTranslateErrorKeySpecifier),
		fields?: ProductVariantBulkTranslateErrorFieldPolicy,
	},
	ProductVariantBulkTranslateResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductVariantBulkTranslateResultKeySpecifier | (() => undefined | ProductVariantBulkTranslateResultKeySpecifier),
		fields?: ProductVariantBulkTranslateResultFieldPolicy,
	},
	ProductVariantBulkUpdate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductVariantBulkUpdateKeySpecifier | (() => undefined | ProductVariantBulkUpdateKeySpecifier),
		fields?: ProductVariantBulkUpdateFieldPolicy,
	},
	ProductVariantChannelListing?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductVariantChannelListingKeySpecifier | (() => undefined | ProductVariantChannelListingKeySpecifier),
		fields?: ProductVariantChannelListingFieldPolicy,
	},
	ProductVariantChannelListingUpdate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductVariantChannelListingUpdateKeySpecifier | (() => undefined | ProductVariantChannelListingUpdateKeySpecifier),
		fields?: ProductVariantChannelListingUpdateFieldPolicy,
	},
	ProductVariantCountableConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductVariantCountableConnectionKeySpecifier | (() => undefined | ProductVariantCountableConnectionKeySpecifier),
		fields?: ProductVariantCountableConnectionFieldPolicy,
	},
	ProductVariantCountableEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductVariantCountableEdgeKeySpecifier | (() => undefined | ProductVariantCountableEdgeKeySpecifier),
		fields?: ProductVariantCountableEdgeFieldPolicy,
	},
	ProductVariantCreate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductVariantCreateKeySpecifier | (() => undefined | ProductVariantCreateKeySpecifier),
		fields?: ProductVariantCreateFieldPolicy,
	},
	ProductVariantCreated?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductVariantCreatedKeySpecifier | (() => undefined | ProductVariantCreatedKeySpecifier),
		fields?: ProductVariantCreatedFieldPolicy,
	},
	ProductVariantDelete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductVariantDeleteKeySpecifier | (() => undefined | ProductVariantDeleteKeySpecifier),
		fields?: ProductVariantDeleteFieldPolicy,
	},
	ProductVariantDeleted?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductVariantDeletedKeySpecifier | (() => undefined | ProductVariantDeletedKeySpecifier),
		fields?: ProductVariantDeletedFieldPolicy,
	},
	ProductVariantDiscountedPriceUpdated?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductVariantDiscountedPriceUpdatedKeySpecifier | (() => undefined | ProductVariantDiscountedPriceUpdatedKeySpecifier),
		fields?: ProductVariantDiscountedPriceUpdatedFieldPolicy,
	},
	ProductVariantMetadataUpdated?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductVariantMetadataUpdatedKeySpecifier | (() => undefined | ProductVariantMetadataUpdatedKeySpecifier),
		fields?: ProductVariantMetadataUpdatedFieldPolicy,
	},
	ProductVariantOutOfStock?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductVariantOutOfStockKeySpecifier | (() => undefined | ProductVariantOutOfStockKeySpecifier),
		fields?: ProductVariantOutOfStockFieldPolicy,
	},
	ProductVariantPreorderDeactivate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductVariantPreorderDeactivateKeySpecifier | (() => undefined | ProductVariantPreorderDeactivateKeySpecifier),
		fields?: ProductVariantPreorderDeactivateFieldPolicy,
	},
	ProductVariantReorder?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductVariantReorderKeySpecifier | (() => undefined | ProductVariantReorderKeySpecifier),
		fields?: ProductVariantReorderFieldPolicy,
	},
	ProductVariantReorderAttributeValues?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductVariantReorderAttributeValuesKeySpecifier | (() => undefined | ProductVariantReorderAttributeValuesKeySpecifier),
		fields?: ProductVariantReorderAttributeValuesFieldPolicy,
	},
	ProductVariantSetDefault?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductVariantSetDefaultKeySpecifier | (() => undefined | ProductVariantSetDefaultKeySpecifier),
		fields?: ProductVariantSetDefaultFieldPolicy,
	},
	ProductVariantStockUpdated?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductVariantStockUpdatedKeySpecifier | (() => undefined | ProductVariantStockUpdatedKeySpecifier),
		fields?: ProductVariantStockUpdatedFieldPolicy,
	},
	ProductVariantStocksCreate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductVariantStocksCreateKeySpecifier | (() => undefined | ProductVariantStocksCreateKeySpecifier),
		fields?: ProductVariantStocksCreateFieldPolicy,
	},
	ProductVariantStocksDelete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductVariantStocksDeleteKeySpecifier | (() => undefined | ProductVariantStocksDeleteKeySpecifier),
		fields?: ProductVariantStocksDeleteFieldPolicy,
	},
	ProductVariantStocksUpdate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductVariantStocksUpdateKeySpecifier | (() => undefined | ProductVariantStocksUpdateKeySpecifier),
		fields?: ProductVariantStocksUpdateFieldPolicy,
	},
	ProductVariantTranslatableContent?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductVariantTranslatableContentKeySpecifier | (() => undefined | ProductVariantTranslatableContentKeySpecifier),
		fields?: ProductVariantTranslatableContentFieldPolicy,
	},
	ProductVariantTranslate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductVariantTranslateKeySpecifier | (() => undefined | ProductVariantTranslateKeySpecifier),
		fields?: ProductVariantTranslateFieldPolicy,
	},
	ProductVariantTranslation?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductVariantTranslationKeySpecifier | (() => undefined | ProductVariantTranslationKeySpecifier),
		fields?: ProductVariantTranslationFieldPolicy,
	},
	ProductVariantUpdate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductVariantUpdateKeySpecifier | (() => undefined | ProductVariantUpdateKeySpecifier),
		fields?: ProductVariantUpdateFieldPolicy,
	},
	ProductVariantUpdated?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductVariantUpdatedKeySpecifier | (() => undefined | ProductVariantUpdatedKeySpecifier),
		fields?: ProductVariantUpdatedFieldPolicy,
	},
	Promotion?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PromotionKeySpecifier | (() => undefined | PromotionKeySpecifier),
		fields?: PromotionFieldPolicy,
	},
	PromotionBulkDelete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PromotionBulkDeleteKeySpecifier | (() => undefined | PromotionBulkDeleteKeySpecifier),
		fields?: PromotionBulkDeleteFieldPolicy,
	},
	PromotionCountableConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PromotionCountableConnectionKeySpecifier | (() => undefined | PromotionCountableConnectionKeySpecifier),
		fields?: PromotionCountableConnectionFieldPolicy,
	},
	PromotionCountableEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PromotionCountableEdgeKeySpecifier | (() => undefined | PromotionCountableEdgeKeySpecifier),
		fields?: PromotionCountableEdgeFieldPolicy,
	},
	PromotionCreate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PromotionCreateKeySpecifier | (() => undefined | PromotionCreateKeySpecifier),
		fields?: PromotionCreateFieldPolicy,
	},
	PromotionCreateError?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PromotionCreateErrorKeySpecifier | (() => undefined | PromotionCreateErrorKeySpecifier),
		fields?: PromotionCreateErrorFieldPolicy,
	},
	PromotionCreated?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PromotionCreatedKeySpecifier | (() => undefined | PromotionCreatedKeySpecifier),
		fields?: PromotionCreatedFieldPolicy,
	},
	PromotionCreatedEvent?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PromotionCreatedEventKeySpecifier | (() => undefined | PromotionCreatedEventKeySpecifier),
		fields?: PromotionCreatedEventFieldPolicy,
	},
	PromotionDelete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PromotionDeleteKeySpecifier | (() => undefined | PromotionDeleteKeySpecifier),
		fields?: PromotionDeleteFieldPolicy,
	},
	PromotionDeleteError?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PromotionDeleteErrorKeySpecifier | (() => undefined | PromotionDeleteErrorKeySpecifier),
		fields?: PromotionDeleteErrorFieldPolicy,
	},
	PromotionDeleted?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PromotionDeletedKeySpecifier | (() => undefined | PromotionDeletedKeySpecifier),
		fields?: PromotionDeletedFieldPolicy,
	},
	PromotionEnded?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PromotionEndedKeySpecifier | (() => undefined | PromotionEndedKeySpecifier),
		fields?: PromotionEndedFieldPolicy,
	},
	PromotionEndedEvent?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PromotionEndedEventKeySpecifier | (() => undefined | PromotionEndedEventKeySpecifier),
		fields?: PromotionEndedEventFieldPolicy,
	},
	PromotionEventInterface?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PromotionEventInterfaceKeySpecifier | (() => undefined | PromotionEventInterfaceKeySpecifier),
		fields?: PromotionEventInterfaceFieldPolicy,
	},
	PromotionRule?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PromotionRuleKeySpecifier | (() => undefined | PromotionRuleKeySpecifier),
		fields?: PromotionRuleFieldPolicy,
	},
	PromotionRuleCreate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PromotionRuleCreateKeySpecifier | (() => undefined | PromotionRuleCreateKeySpecifier),
		fields?: PromotionRuleCreateFieldPolicy,
	},
	PromotionRuleCreateError?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PromotionRuleCreateErrorKeySpecifier | (() => undefined | PromotionRuleCreateErrorKeySpecifier),
		fields?: PromotionRuleCreateErrorFieldPolicy,
	},
	PromotionRuleCreated?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PromotionRuleCreatedKeySpecifier | (() => undefined | PromotionRuleCreatedKeySpecifier),
		fields?: PromotionRuleCreatedFieldPolicy,
	},
	PromotionRuleCreatedEvent?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PromotionRuleCreatedEventKeySpecifier | (() => undefined | PromotionRuleCreatedEventKeySpecifier),
		fields?: PromotionRuleCreatedEventFieldPolicy,
	},
	PromotionRuleDelete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PromotionRuleDeleteKeySpecifier | (() => undefined | PromotionRuleDeleteKeySpecifier),
		fields?: PromotionRuleDeleteFieldPolicy,
	},
	PromotionRuleDeleteError?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PromotionRuleDeleteErrorKeySpecifier | (() => undefined | PromotionRuleDeleteErrorKeySpecifier),
		fields?: PromotionRuleDeleteErrorFieldPolicy,
	},
	PromotionRuleDeleted?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PromotionRuleDeletedKeySpecifier | (() => undefined | PromotionRuleDeletedKeySpecifier),
		fields?: PromotionRuleDeletedFieldPolicy,
	},
	PromotionRuleDeletedEvent?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PromotionRuleDeletedEventKeySpecifier | (() => undefined | PromotionRuleDeletedEventKeySpecifier),
		fields?: PromotionRuleDeletedEventFieldPolicy,
	},
	PromotionRuleEventInterface?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PromotionRuleEventInterfaceKeySpecifier | (() => undefined | PromotionRuleEventInterfaceKeySpecifier),
		fields?: PromotionRuleEventInterfaceFieldPolicy,
	},
	PromotionRuleTranslatableContent?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PromotionRuleTranslatableContentKeySpecifier | (() => undefined | PromotionRuleTranslatableContentKeySpecifier),
		fields?: PromotionRuleTranslatableContentFieldPolicy,
	},
	PromotionRuleTranslate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PromotionRuleTranslateKeySpecifier | (() => undefined | PromotionRuleTranslateKeySpecifier),
		fields?: PromotionRuleTranslateFieldPolicy,
	},
	PromotionRuleTranslation?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PromotionRuleTranslationKeySpecifier | (() => undefined | PromotionRuleTranslationKeySpecifier),
		fields?: PromotionRuleTranslationFieldPolicy,
	},
	PromotionRuleUpdate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PromotionRuleUpdateKeySpecifier | (() => undefined | PromotionRuleUpdateKeySpecifier),
		fields?: PromotionRuleUpdateFieldPolicy,
	},
	PromotionRuleUpdateError?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PromotionRuleUpdateErrorKeySpecifier | (() => undefined | PromotionRuleUpdateErrorKeySpecifier),
		fields?: PromotionRuleUpdateErrorFieldPolicy,
	},
	PromotionRuleUpdated?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PromotionRuleUpdatedKeySpecifier | (() => undefined | PromotionRuleUpdatedKeySpecifier),
		fields?: PromotionRuleUpdatedFieldPolicy,
	},
	PromotionRuleUpdatedEvent?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PromotionRuleUpdatedEventKeySpecifier | (() => undefined | PromotionRuleUpdatedEventKeySpecifier),
		fields?: PromotionRuleUpdatedEventFieldPolicy,
	},
	PromotionStarted?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PromotionStartedKeySpecifier | (() => undefined | PromotionStartedKeySpecifier),
		fields?: PromotionStartedFieldPolicy,
	},
	PromotionStartedEvent?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PromotionStartedEventKeySpecifier | (() => undefined | PromotionStartedEventKeySpecifier),
		fields?: PromotionStartedEventFieldPolicy,
	},
	PromotionTranslatableContent?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PromotionTranslatableContentKeySpecifier | (() => undefined | PromotionTranslatableContentKeySpecifier),
		fields?: PromotionTranslatableContentFieldPolicy,
	},
	PromotionTranslate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PromotionTranslateKeySpecifier | (() => undefined | PromotionTranslateKeySpecifier),
		fields?: PromotionTranslateFieldPolicy,
	},
	PromotionTranslation?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PromotionTranslationKeySpecifier | (() => undefined | PromotionTranslationKeySpecifier),
		fields?: PromotionTranslationFieldPolicy,
	},
	PromotionUpdate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PromotionUpdateKeySpecifier | (() => undefined | PromotionUpdateKeySpecifier),
		fields?: PromotionUpdateFieldPolicy,
	},
	PromotionUpdateError?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PromotionUpdateErrorKeySpecifier | (() => undefined | PromotionUpdateErrorKeySpecifier),
		fields?: PromotionUpdateErrorFieldPolicy,
	},
	PromotionUpdated?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PromotionUpdatedKeySpecifier | (() => undefined | PromotionUpdatedKeySpecifier),
		fields?: PromotionUpdatedFieldPolicy,
	},
	PromotionUpdatedEvent?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PromotionUpdatedEventKeySpecifier | (() => undefined | PromotionUpdatedEventKeySpecifier),
		fields?: PromotionUpdatedEventFieldPolicy,
	},
	Query?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | QueryKeySpecifier | (() => undefined | QueryKeySpecifier),
		fields?: QueryFieldPolicy,
	},
	ReducedRate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ReducedRateKeySpecifier | (() => undefined | ReducedRateKeySpecifier),
		fields?: ReducedRateFieldPolicy,
	},
	RefreshToken?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RefreshTokenKeySpecifier | (() => undefined | RefreshTokenKeySpecifier),
		fields?: RefreshTokenFieldPolicy,
	},
	RefundReasonReferenceTypeClear?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RefundReasonReferenceTypeClearKeySpecifier | (() => undefined | RefundReasonReferenceTypeClearKeySpecifier),
		fields?: RefundReasonReferenceTypeClearFieldPolicy,
	},
	RefundReasonReferenceTypeClearError?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RefundReasonReferenceTypeClearErrorKeySpecifier | (() => undefined | RefundReasonReferenceTypeClearErrorKeySpecifier),
		fields?: RefundReasonReferenceTypeClearErrorFieldPolicy,
	},
	RefundSettings?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RefundSettingsKeySpecifier | (() => undefined | RefundSettingsKeySpecifier),
		fields?: RefundSettingsFieldPolicy,
	},
	RefundSettingsUpdate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RefundSettingsUpdateKeySpecifier | (() => undefined | RefundSettingsUpdateKeySpecifier),
		fields?: RefundSettingsUpdateFieldPolicy,
	},
	RefundSettingsUpdateError?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RefundSettingsUpdateErrorKeySpecifier | (() => undefined | RefundSettingsUpdateErrorKeySpecifier),
		fields?: RefundSettingsUpdateErrorFieldPolicy,
	},
	RequestEmailChange?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RequestEmailChangeKeySpecifier | (() => undefined | RequestEmailChangeKeySpecifier),
		fields?: RequestEmailChangeFieldPolicy,
	},
	RequestPasswordReset?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RequestPasswordResetKeySpecifier | (() => undefined | RequestPasswordResetKeySpecifier),
		fields?: RequestPasswordResetFieldPolicy,
	},
	Sale?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SaleKeySpecifier | (() => undefined | SaleKeySpecifier),
		fields?: SaleFieldPolicy,
	},
	SaleAddCatalogues?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SaleAddCataloguesKeySpecifier | (() => undefined | SaleAddCataloguesKeySpecifier),
		fields?: SaleAddCataloguesFieldPolicy,
	},
	SaleBulkDelete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SaleBulkDeleteKeySpecifier | (() => undefined | SaleBulkDeleteKeySpecifier),
		fields?: SaleBulkDeleteFieldPolicy,
	},
	SaleChannelListing?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SaleChannelListingKeySpecifier | (() => undefined | SaleChannelListingKeySpecifier),
		fields?: SaleChannelListingFieldPolicy,
	},
	SaleChannelListingUpdate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SaleChannelListingUpdateKeySpecifier | (() => undefined | SaleChannelListingUpdateKeySpecifier),
		fields?: SaleChannelListingUpdateFieldPolicy,
	},
	SaleCountableConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SaleCountableConnectionKeySpecifier | (() => undefined | SaleCountableConnectionKeySpecifier),
		fields?: SaleCountableConnectionFieldPolicy,
	},
	SaleCountableEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SaleCountableEdgeKeySpecifier | (() => undefined | SaleCountableEdgeKeySpecifier),
		fields?: SaleCountableEdgeFieldPolicy,
	},
	SaleCreate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SaleCreateKeySpecifier | (() => undefined | SaleCreateKeySpecifier),
		fields?: SaleCreateFieldPolicy,
	},
	SaleCreated?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SaleCreatedKeySpecifier | (() => undefined | SaleCreatedKeySpecifier),
		fields?: SaleCreatedFieldPolicy,
	},
	SaleDelete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SaleDeleteKeySpecifier | (() => undefined | SaleDeleteKeySpecifier),
		fields?: SaleDeleteFieldPolicy,
	},
	SaleDeleted?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SaleDeletedKeySpecifier | (() => undefined | SaleDeletedKeySpecifier),
		fields?: SaleDeletedFieldPolicy,
	},
	SaleRemoveCatalogues?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SaleRemoveCataloguesKeySpecifier | (() => undefined | SaleRemoveCataloguesKeySpecifier),
		fields?: SaleRemoveCataloguesFieldPolicy,
	},
	SaleToggle?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SaleToggleKeySpecifier | (() => undefined | SaleToggleKeySpecifier),
		fields?: SaleToggleFieldPolicy,
	},
	SaleTranslatableContent?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SaleTranslatableContentKeySpecifier | (() => undefined | SaleTranslatableContentKeySpecifier),
		fields?: SaleTranslatableContentFieldPolicy,
	},
	SaleTranslate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SaleTranslateKeySpecifier | (() => undefined | SaleTranslateKeySpecifier),
		fields?: SaleTranslateFieldPolicy,
	},
	SaleTranslation?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SaleTranslationKeySpecifier | (() => undefined | SaleTranslationKeySpecifier),
		fields?: SaleTranslationFieldPolicy,
	},
	SaleUpdate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SaleUpdateKeySpecifier | (() => undefined | SaleUpdateKeySpecifier),
		fields?: SaleUpdateFieldPolicy,
	},
	SaleUpdated?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SaleUpdatedKeySpecifier | (() => undefined | SaleUpdatedKeySpecifier),
		fields?: SaleUpdatedFieldPolicy,
	},
	SelectedAttribute?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SelectedAttributeKeySpecifier | (() => undefined | SelectedAttributeKeySpecifier),
		fields?: SelectedAttributeFieldPolicy,
	},
	SendConfirmationEmail?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SendConfirmationEmailKeySpecifier | (() => undefined | SendConfirmationEmailKeySpecifier),
		fields?: SendConfirmationEmailFieldPolicy,
	},
	SendConfirmationEmailError?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SendConfirmationEmailErrorKeySpecifier | (() => undefined | SendConfirmationEmailErrorKeySpecifier),
		fields?: SendConfirmationEmailErrorFieldPolicy,
	},
	SetPassword?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SetPasswordKeySpecifier | (() => undefined | SetPasswordKeySpecifier),
		fields?: SetPasswordFieldPolicy,
	},
	ShippingError?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ShippingErrorKeySpecifier | (() => undefined | ShippingErrorKeySpecifier),
		fields?: ShippingErrorFieldPolicy,
	},
	ShippingListMethodsForCheckout?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ShippingListMethodsForCheckoutKeySpecifier | (() => undefined | ShippingListMethodsForCheckoutKeySpecifier),
		fields?: ShippingListMethodsForCheckoutFieldPolicy,
	},
	ShippingMethod?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ShippingMethodKeySpecifier | (() => undefined | ShippingMethodKeySpecifier),
		fields?: ShippingMethodFieldPolicy,
	},
	ShippingMethodChannelListing?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ShippingMethodChannelListingKeySpecifier | (() => undefined | ShippingMethodChannelListingKeySpecifier),
		fields?: ShippingMethodChannelListingFieldPolicy,
	},
	ShippingMethodChannelListingUpdate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ShippingMethodChannelListingUpdateKeySpecifier | (() => undefined | ShippingMethodChannelListingUpdateKeySpecifier),
		fields?: ShippingMethodChannelListingUpdateFieldPolicy,
	},
	ShippingMethodPostalCodeRule?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ShippingMethodPostalCodeRuleKeySpecifier | (() => undefined | ShippingMethodPostalCodeRuleKeySpecifier),
		fields?: ShippingMethodPostalCodeRuleFieldPolicy,
	},
	ShippingMethodTranslatableContent?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ShippingMethodTranslatableContentKeySpecifier | (() => undefined | ShippingMethodTranslatableContentKeySpecifier),
		fields?: ShippingMethodTranslatableContentFieldPolicy,
	},
	ShippingMethodTranslation?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ShippingMethodTranslationKeySpecifier | (() => undefined | ShippingMethodTranslationKeySpecifier),
		fields?: ShippingMethodTranslationFieldPolicy,
	},
	ShippingMethodType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ShippingMethodTypeKeySpecifier | (() => undefined | ShippingMethodTypeKeySpecifier),
		fields?: ShippingMethodTypeFieldPolicy,
	},
	ShippingMethodsPerCountry?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ShippingMethodsPerCountryKeySpecifier | (() => undefined | ShippingMethodsPerCountryKeySpecifier),
		fields?: ShippingMethodsPerCountryFieldPolicy,
	},
	ShippingPriceBulkDelete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ShippingPriceBulkDeleteKeySpecifier | (() => undefined | ShippingPriceBulkDeleteKeySpecifier),
		fields?: ShippingPriceBulkDeleteFieldPolicy,
	},
	ShippingPriceCreate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ShippingPriceCreateKeySpecifier | (() => undefined | ShippingPriceCreateKeySpecifier),
		fields?: ShippingPriceCreateFieldPolicy,
	},
	ShippingPriceCreated?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ShippingPriceCreatedKeySpecifier | (() => undefined | ShippingPriceCreatedKeySpecifier),
		fields?: ShippingPriceCreatedFieldPolicy,
	},
	ShippingPriceDelete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ShippingPriceDeleteKeySpecifier | (() => undefined | ShippingPriceDeleteKeySpecifier),
		fields?: ShippingPriceDeleteFieldPolicy,
	},
	ShippingPriceDeleted?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ShippingPriceDeletedKeySpecifier | (() => undefined | ShippingPriceDeletedKeySpecifier),
		fields?: ShippingPriceDeletedFieldPolicy,
	},
	ShippingPriceExcludeProducts?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ShippingPriceExcludeProductsKeySpecifier | (() => undefined | ShippingPriceExcludeProductsKeySpecifier),
		fields?: ShippingPriceExcludeProductsFieldPolicy,
	},
	ShippingPriceRemoveProductFromExclude?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ShippingPriceRemoveProductFromExcludeKeySpecifier | (() => undefined | ShippingPriceRemoveProductFromExcludeKeySpecifier),
		fields?: ShippingPriceRemoveProductFromExcludeFieldPolicy,
	},
	ShippingPriceTranslate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ShippingPriceTranslateKeySpecifier | (() => undefined | ShippingPriceTranslateKeySpecifier),
		fields?: ShippingPriceTranslateFieldPolicy,
	},
	ShippingPriceUpdate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ShippingPriceUpdateKeySpecifier | (() => undefined | ShippingPriceUpdateKeySpecifier),
		fields?: ShippingPriceUpdateFieldPolicy,
	},
	ShippingPriceUpdated?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ShippingPriceUpdatedKeySpecifier | (() => undefined | ShippingPriceUpdatedKeySpecifier),
		fields?: ShippingPriceUpdatedFieldPolicy,
	},
	ShippingZone?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ShippingZoneKeySpecifier | (() => undefined | ShippingZoneKeySpecifier),
		fields?: ShippingZoneFieldPolicy,
	},
	ShippingZoneBulkDelete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ShippingZoneBulkDeleteKeySpecifier | (() => undefined | ShippingZoneBulkDeleteKeySpecifier),
		fields?: ShippingZoneBulkDeleteFieldPolicy,
	},
	ShippingZoneCountableConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ShippingZoneCountableConnectionKeySpecifier | (() => undefined | ShippingZoneCountableConnectionKeySpecifier),
		fields?: ShippingZoneCountableConnectionFieldPolicy,
	},
	ShippingZoneCountableEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ShippingZoneCountableEdgeKeySpecifier | (() => undefined | ShippingZoneCountableEdgeKeySpecifier),
		fields?: ShippingZoneCountableEdgeFieldPolicy,
	},
	ShippingZoneCreate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ShippingZoneCreateKeySpecifier | (() => undefined | ShippingZoneCreateKeySpecifier),
		fields?: ShippingZoneCreateFieldPolicy,
	},
	ShippingZoneCreated?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ShippingZoneCreatedKeySpecifier | (() => undefined | ShippingZoneCreatedKeySpecifier),
		fields?: ShippingZoneCreatedFieldPolicy,
	},
	ShippingZoneDelete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ShippingZoneDeleteKeySpecifier | (() => undefined | ShippingZoneDeleteKeySpecifier),
		fields?: ShippingZoneDeleteFieldPolicy,
	},
	ShippingZoneDeleted?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ShippingZoneDeletedKeySpecifier | (() => undefined | ShippingZoneDeletedKeySpecifier),
		fields?: ShippingZoneDeletedFieldPolicy,
	},
	ShippingZoneMetadataUpdated?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ShippingZoneMetadataUpdatedKeySpecifier | (() => undefined | ShippingZoneMetadataUpdatedKeySpecifier),
		fields?: ShippingZoneMetadataUpdatedFieldPolicy,
	},
	ShippingZoneUpdate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ShippingZoneUpdateKeySpecifier | (() => undefined | ShippingZoneUpdateKeySpecifier),
		fields?: ShippingZoneUpdateFieldPolicy,
	},
	ShippingZoneUpdated?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ShippingZoneUpdatedKeySpecifier | (() => undefined | ShippingZoneUpdatedKeySpecifier),
		fields?: ShippingZoneUpdatedFieldPolicy,
	},
	Shop?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ShopKeySpecifier | (() => undefined | ShopKeySpecifier),
		fields?: ShopFieldPolicy,
	},
	ShopAddressUpdate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ShopAddressUpdateKeySpecifier | (() => undefined | ShopAddressUpdateKeySpecifier),
		fields?: ShopAddressUpdateFieldPolicy,
	},
	ShopDomainUpdate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ShopDomainUpdateKeySpecifier | (() => undefined | ShopDomainUpdateKeySpecifier),
		fields?: ShopDomainUpdateFieldPolicy,
	},
	ShopError?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ShopErrorKeySpecifier | (() => undefined | ShopErrorKeySpecifier),
		fields?: ShopErrorFieldPolicy,
	},
	ShopFetchTaxRates?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ShopFetchTaxRatesKeySpecifier | (() => undefined | ShopFetchTaxRatesKeySpecifier),
		fields?: ShopFetchTaxRatesFieldPolicy,
	},
	ShopMetadataUpdated?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ShopMetadataUpdatedKeySpecifier | (() => undefined | ShopMetadataUpdatedKeySpecifier),
		fields?: ShopMetadataUpdatedFieldPolicy,
	},
	ShopSettingsTranslate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ShopSettingsTranslateKeySpecifier | (() => undefined | ShopSettingsTranslateKeySpecifier),
		fields?: ShopSettingsTranslateFieldPolicy,
	},
	ShopSettingsUpdate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ShopSettingsUpdateKeySpecifier | (() => undefined | ShopSettingsUpdateKeySpecifier),
		fields?: ShopSettingsUpdateFieldPolicy,
	},
	ShopTranslation?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ShopTranslationKeySpecifier | (() => undefined | ShopTranslationKeySpecifier),
		fields?: ShopTranslationFieldPolicy,
	},
	StaffBulkDelete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | StaffBulkDeleteKeySpecifier | (() => undefined | StaffBulkDeleteKeySpecifier),
		fields?: StaffBulkDeleteFieldPolicy,
	},
	StaffCreate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | StaffCreateKeySpecifier | (() => undefined | StaffCreateKeySpecifier),
		fields?: StaffCreateFieldPolicy,
	},
	StaffCreated?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | StaffCreatedKeySpecifier | (() => undefined | StaffCreatedKeySpecifier),
		fields?: StaffCreatedFieldPolicy,
	},
	StaffDelete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | StaffDeleteKeySpecifier | (() => undefined | StaffDeleteKeySpecifier),
		fields?: StaffDeleteFieldPolicy,
	},
	StaffDeleted?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | StaffDeletedKeySpecifier | (() => undefined | StaffDeletedKeySpecifier),
		fields?: StaffDeletedFieldPolicy,
	},
	StaffError?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | StaffErrorKeySpecifier | (() => undefined | StaffErrorKeySpecifier),
		fields?: StaffErrorFieldPolicy,
	},
	StaffNotificationRecipient?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | StaffNotificationRecipientKeySpecifier | (() => undefined | StaffNotificationRecipientKeySpecifier),
		fields?: StaffNotificationRecipientFieldPolicy,
	},
	StaffNotificationRecipientCreate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | StaffNotificationRecipientCreateKeySpecifier | (() => undefined | StaffNotificationRecipientCreateKeySpecifier),
		fields?: StaffNotificationRecipientCreateFieldPolicy,
	},
	StaffNotificationRecipientDelete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | StaffNotificationRecipientDeleteKeySpecifier | (() => undefined | StaffNotificationRecipientDeleteKeySpecifier),
		fields?: StaffNotificationRecipientDeleteFieldPolicy,
	},
	StaffNotificationRecipientUpdate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | StaffNotificationRecipientUpdateKeySpecifier | (() => undefined | StaffNotificationRecipientUpdateKeySpecifier),
		fields?: StaffNotificationRecipientUpdateFieldPolicy,
	},
	StaffSetPasswordRequested?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | StaffSetPasswordRequestedKeySpecifier | (() => undefined | StaffSetPasswordRequestedKeySpecifier),
		fields?: StaffSetPasswordRequestedFieldPolicy,
	},
	StaffUpdate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | StaffUpdateKeySpecifier | (() => undefined | StaffUpdateKeySpecifier),
		fields?: StaffUpdateFieldPolicy,
	},
	StaffUpdated?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | StaffUpdatedKeySpecifier | (() => undefined | StaffUpdatedKeySpecifier),
		fields?: StaffUpdatedFieldPolicy,
	},
	Stock?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | StockKeySpecifier | (() => undefined | StockKeySpecifier),
		fields?: StockFieldPolicy,
	},
	StockBulkResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | StockBulkResultKeySpecifier | (() => undefined | StockBulkResultKeySpecifier),
		fields?: StockBulkResultFieldPolicy,
	},
	StockBulkUpdate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | StockBulkUpdateKeySpecifier | (() => undefined | StockBulkUpdateKeySpecifier),
		fields?: StockBulkUpdateFieldPolicy,
	},
	StockBulkUpdateError?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | StockBulkUpdateErrorKeySpecifier | (() => undefined | StockBulkUpdateErrorKeySpecifier),
		fields?: StockBulkUpdateErrorFieldPolicy,
	},
	StockCountableConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | StockCountableConnectionKeySpecifier | (() => undefined | StockCountableConnectionKeySpecifier),
		fields?: StockCountableConnectionFieldPolicy,
	},
	StockCountableEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | StockCountableEdgeKeySpecifier | (() => undefined | StockCountableEdgeKeySpecifier),
		fields?: StockCountableEdgeFieldPolicy,
	},
	StockError?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | StockErrorKeySpecifier | (() => undefined | StockErrorKeySpecifier),
		fields?: StockErrorFieldPolicy,
	},
	StockSettings?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | StockSettingsKeySpecifier | (() => undefined | StockSettingsKeySpecifier),
		fields?: StockSettingsFieldPolicy,
	},
	StoredPaymentMethod?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | StoredPaymentMethodKeySpecifier | (() => undefined | StoredPaymentMethodKeySpecifier),
		fields?: StoredPaymentMethodFieldPolicy,
	},
	StoredPaymentMethodDeleteRequested?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | StoredPaymentMethodDeleteRequestedKeySpecifier | (() => undefined | StoredPaymentMethodDeleteRequestedKeySpecifier),
		fields?: StoredPaymentMethodDeleteRequestedFieldPolicy,
	},
	StoredPaymentMethodRequestDelete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | StoredPaymentMethodRequestDeleteKeySpecifier | (() => undefined | StoredPaymentMethodRequestDeleteKeySpecifier),
		fields?: StoredPaymentMethodRequestDeleteFieldPolicy,
	},
	Subscription?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SubscriptionKeySpecifier | (() => undefined | SubscriptionKeySpecifier),
		fields?: SubscriptionFieldPolicy,
	},
	TaxClass?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TaxClassKeySpecifier | (() => undefined | TaxClassKeySpecifier),
		fields?: TaxClassFieldPolicy,
	},
	TaxClassCountableConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TaxClassCountableConnectionKeySpecifier | (() => undefined | TaxClassCountableConnectionKeySpecifier),
		fields?: TaxClassCountableConnectionFieldPolicy,
	},
	TaxClassCountableEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TaxClassCountableEdgeKeySpecifier | (() => undefined | TaxClassCountableEdgeKeySpecifier),
		fields?: TaxClassCountableEdgeFieldPolicy,
	},
	TaxClassCountryRate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TaxClassCountryRateKeySpecifier | (() => undefined | TaxClassCountryRateKeySpecifier),
		fields?: TaxClassCountryRateFieldPolicy,
	},
	TaxClassCreate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TaxClassCreateKeySpecifier | (() => undefined | TaxClassCreateKeySpecifier),
		fields?: TaxClassCreateFieldPolicy,
	},
	TaxClassCreateError?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TaxClassCreateErrorKeySpecifier | (() => undefined | TaxClassCreateErrorKeySpecifier),
		fields?: TaxClassCreateErrorFieldPolicy,
	},
	TaxClassDelete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TaxClassDeleteKeySpecifier | (() => undefined | TaxClassDeleteKeySpecifier),
		fields?: TaxClassDeleteFieldPolicy,
	},
	TaxClassDeleteError?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TaxClassDeleteErrorKeySpecifier | (() => undefined | TaxClassDeleteErrorKeySpecifier),
		fields?: TaxClassDeleteErrorFieldPolicy,
	},
	TaxClassUpdate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TaxClassUpdateKeySpecifier | (() => undefined | TaxClassUpdateKeySpecifier),
		fields?: TaxClassUpdateFieldPolicy,
	},
	TaxClassUpdateError?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TaxClassUpdateErrorKeySpecifier | (() => undefined | TaxClassUpdateErrorKeySpecifier),
		fields?: TaxClassUpdateErrorFieldPolicy,
	},
	TaxConfiguration?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TaxConfigurationKeySpecifier | (() => undefined | TaxConfigurationKeySpecifier),
		fields?: TaxConfigurationFieldPolicy,
	},
	TaxConfigurationCountableConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TaxConfigurationCountableConnectionKeySpecifier | (() => undefined | TaxConfigurationCountableConnectionKeySpecifier),
		fields?: TaxConfigurationCountableConnectionFieldPolicy,
	},
	TaxConfigurationCountableEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TaxConfigurationCountableEdgeKeySpecifier | (() => undefined | TaxConfigurationCountableEdgeKeySpecifier),
		fields?: TaxConfigurationCountableEdgeFieldPolicy,
	},
	TaxConfigurationPerCountry?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TaxConfigurationPerCountryKeySpecifier | (() => undefined | TaxConfigurationPerCountryKeySpecifier),
		fields?: TaxConfigurationPerCountryFieldPolicy,
	},
	TaxConfigurationUpdate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TaxConfigurationUpdateKeySpecifier | (() => undefined | TaxConfigurationUpdateKeySpecifier),
		fields?: TaxConfigurationUpdateFieldPolicy,
	},
	TaxConfigurationUpdateError?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TaxConfigurationUpdateErrorKeySpecifier | (() => undefined | TaxConfigurationUpdateErrorKeySpecifier),
		fields?: TaxConfigurationUpdateErrorFieldPolicy,
	},
	TaxCountryConfiguration?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TaxCountryConfigurationKeySpecifier | (() => undefined | TaxCountryConfigurationKeySpecifier),
		fields?: TaxCountryConfigurationFieldPolicy,
	},
	TaxCountryConfigurationDelete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TaxCountryConfigurationDeleteKeySpecifier | (() => undefined | TaxCountryConfigurationDeleteKeySpecifier),
		fields?: TaxCountryConfigurationDeleteFieldPolicy,
	},
	TaxCountryConfigurationDeleteError?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TaxCountryConfigurationDeleteErrorKeySpecifier | (() => undefined | TaxCountryConfigurationDeleteErrorKeySpecifier),
		fields?: TaxCountryConfigurationDeleteErrorFieldPolicy,
	},
	TaxCountryConfigurationUpdate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TaxCountryConfigurationUpdateKeySpecifier | (() => undefined | TaxCountryConfigurationUpdateKeySpecifier),
		fields?: TaxCountryConfigurationUpdateFieldPolicy,
	},
	TaxCountryConfigurationUpdateError?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TaxCountryConfigurationUpdateErrorKeySpecifier | (() => undefined | TaxCountryConfigurationUpdateErrorKeySpecifier),
		fields?: TaxCountryConfigurationUpdateErrorFieldPolicy,
	},
	TaxExemptionManage?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TaxExemptionManageKeySpecifier | (() => undefined | TaxExemptionManageKeySpecifier),
		fields?: TaxExemptionManageFieldPolicy,
	},
	TaxExemptionManageError?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TaxExemptionManageErrorKeySpecifier | (() => undefined | TaxExemptionManageErrorKeySpecifier),
		fields?: TaxExemptionManageErrorFieldPolicy,
	},
	TaxType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TaxTypeKeySpecifier | (() => undefined | TaxTypeKeySpecifier),
		fields?: TaxTypeFieldPolicy,
	},
	TaxableObject?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TaxableObjectKeySpecifier | (() => undefined | TaxableObjectKeySpecifier),
		fields?: TaxableObjectFieldPolicy,
	},
	TaxableObjectDiscount?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TaxableObjectDiscountKeySpecifier | (() => undefined | TaxableObjectDiscountKeySpecifier),
		fields?: TaxableObjectDiscountFieldPolicy,
	},
	TaxableObjectLine?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TaxableObjectLineKeySpecifier | (() => undefined | TaxableObjectLineKeySpecifier),
		fields?: TaxableObjectLineFieldPolicy,
	},
	TaxedMoney?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TaxedMoneyKeySpecifier | (() => undefined | TaxedMoneyKeySpecifier),
		fields?: TaxedMoneyFieldPolicy,
	},
	TaxedMoneyRange?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TaxedMoneyRangeKeySpecifier | (() => undefined | TaxedMoneyRangeKeySpecifier),
		fields?: TaxedMoneyRangeFieldPolicy,
	},
	ThumbnailCreated?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ThumbnailCreatedKeySpecifier | (() => undefined | ThumbnailCreatedKeySpecifier),
		fields?: ThumbnailCreatedFieldPolicy,
	},
	TimePeriod?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TimePeriodKeySpecifier | (() => undefined | TimePeriodKeySpecifier),
		fields?: TimePeriodFieldPolicy,
	},
	Transaction?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TransactionKeySpecifier | (() => undefined | TransactionKeySpecifier),
		fields?: TransactionFieldPolicy,
	},
	TransactionAction?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TransactionActionKeySpecifier | (() => undefined | TransactionActionKeySpecifier),
		fields?: TransactionActionFieldPolicy,
	},
	TransactionCancelationRequested?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TransactionCancelationRequestedKeySpecifier | (() => undefined | TransactionCancelationRequestedKeySpecifier),
		fields?: TransactionCancelationRequestedFieldPolicy,
	},
	TransactionChargeRequested?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TransactionChargeRequestedKeySpecifier | (() => undefined | TransactionChargeRequestedKeySpecifier),
		fields?: TransactionChargeRequestedFieldPolicy,
	},
	TransactionCountableConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TransactionCountableConnectionKeySpecifier | (() => undefined | TransactionCountableConnectionKeySpecifier),
		fields?: TransactionCountableConnectionFieldPolicy,
	},
	TransactionCountableEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TransactionCountableEdgeKeySpecifier | (() => undefined | TransactionCountableEdgeKeySpecifier),
		fields?: TransactionCountableEdgeFieldPolicy,
	},
	TransactionCreate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TransactionCreateKeySpecifier | (() => undefined | TransactionCreateKeySpecifier),
		fields?: TransactionCreateFieldPolicy,
	},
	TransactionCreateError?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TransactionCreateErrorKeySpecifier | (() => undefined | TransactionCreateErrorKeySpecifier),
		fields?: TransactionCreateErrorFieldPolicy,
	},
	TransactionEvent?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TransactionEventKeySpecifier | (() => undefined | TransactionEventKeySpecifier),
		fields?: TransactionEventFieldPolicy,
	},
	TransactionEventReport?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TransactionEventReportKeySpecifier | (() => undefined | TransactionEventReportKeySpecifier),
		fields?: TransactionEventReportFieldPolicy,
	},
	TransactionEventReportError?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TransactionEventReportErrorKeySpecifier | (() => undefined | TransactionEventReportErrorKeySpecifier),
		fields?: TransactionEventReportErrorFieldPolicy,
	},
	TransactionInitialize?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TransactionInitializeKeySpecifier | (() => undefined | TransactionInitializeKeySpecifier),
		fields?: TransactionInitializeFieldPolicy,
	},
	TransactionInitializeError?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TransactionInitializeErrorKeySpecifier | (() => undefined | TransactionInitializeErrorKeySpecifier),
		fields?: TransactionInitializeErrorFieldPolicy,
	},
	TransactionInitializeSession?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TransactionInitializeSessionKeySpecifier | (() => undefined | TransactionInitializeSessionKeySpecifier),
		fields?: TransactionInitializeSessionFieldPolicy,
	},
	TransactionItem?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TransactionItemKeySpecifier | (() => undefined | TransactionItemKeySpecifier),
		fields?: TransactionItemFieldPolicy,
	},
	TransactionItemMetadataUpdated?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TransactionItemMetadataUpdatedKeySpecifier | (() => undefined | TransactionItemMetadataUpdatedKeySpecifier),
		fields?: TransactionItemMetadataUpdatedFieldPolicy,
	},
	TransactionProcess?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TransactionProcessKeySpecifier | (() => undefined | TransactionProcessKeySpecifier),
		fields?: TransactionProcessFieldPolicy,
	},
	TransactionProcessAction?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TransactionProcessActionKeySpecifier | (() => undefined | TransactionProcessActionKeySpecifier),
		fields?: TransactionProcessActionFieldPolicy,
	},
	TransactionProcessError?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TransactionProcessErrorKeySpecifier | (() => undefined | TransactionProcessErrorKeySpecifier),
		fields?: TransactionProcessErrorFieldPolicy,
	},
	TransactionProcessSession?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TransactionProcessSessionKeySpecifier | (() => undefined | TransactionProcessSessionKeySpecifier),
		fields?: TransactionProcessSessionFieldPolicy,
	},
	TransactionRefundRequested?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TransactionRefundRequestedKeySpecifier | (() => undefined | TransactionRefundRequestedKeySpecifier),
		fields?: TransactionRefundRequestedFieldPolicy,
	},
	TransactionRequestAction?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TransactionRequestActionKeySpecifier | (() => undefined | TransactionRequestActionKeySpecifier),
		fields?: TransactionRequestActionFieldPolicy,
	},
	TransactionRequestActionError?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TransactionRequestActionErrorKeySpecifier | (() => undefined | TransactionRequestActionErrorKeySpecifier),
		fields?: TransactionRequestActionErrorFieldPolicy,
	},
	TransactionRequestRefundForGrantedRefund?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TransactionRequestRefundForGrantedRefundKeySpecifier | (() => undefined | TransactionRequestRefundForGrantedRefundKeySpecifier),
		fields?: TransactionRequestRefundForGrantedRefundFieldPolicy,
	},
	TransactionRequestRefundForGrantedRefundError?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TransactionRequestRefundForGrantedRefundErrorKeySpecifier | (() => undefined | TransactionRequestRefundForGrantedRefundErrorKeySpecifier),
		fields?: TransactionRequestRefundForGrantedRefundErrorFieldPolicy,
	},
	TransactionUpdate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TransactionUpdateKeySpecifier | (() => undefined | TransactionUpdateKeySpecifier),
		fields?: TransactionUpdateFieldPolicy,
	},
	TransactionUpdateError?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TransactionUpdateErrorKeySpecifier | (() => undefined | TransactionUpdateErrorKeySpecifier),
		fields?: TransactionUpdateErrorFieldPolicy,
	},
	TranslatableItemConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TranslatableItemConnectionKeySpecifier | (() => undefined | TranslatableItemConnectionKeySpecifier),
		fields?: TranslatableItemConnectionFieldPolicy,
	},
	TranslatableItemEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TranslatableItemEdgeKeySpecifier | (() => undefined | TranslatableItemEdgeKeySpecifier),
		fields?: TranslatableItemEdgeFieldPolicy,
	},
	TranslationCreated?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TranslationCreatedKeySpecifier | (() => undefined | TranslationCreatedKeySpecifier),
		fields?: TranslationCreatedFieldPolicy,
	},
	TranslationError?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TranslationErrorKeySpecifier | (() => undefined | TranslationErrorKeySpecifier),
		fields?: TranslationErrorFieldPolicy,
	},
	TranslationUpdated?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TranslationUpdatedKeySpecifier | (() => undefined | TranslationUpdatedKeySpecifier),
		fields?: TranslationUpdatedFieldPolicy,
	},
	UpdateMetadata?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateMetadataKeySpecifier | (() => undefined | UpdateMetadataKeySpecifier),
		fields?: UpdateMetadataFieldPolicy,
	},
	UpdatePrivateMetadata?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdatePrivateMetadataKeySpecifier | (() => undefined | UpdatePrivateMetadataKeySpecifier),
		fields?: UpdatePrivateMetadataFieldPolicy,
	},
	UploadError?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UploadErrorKeySpecifier | (() => undefined | UploadErrorKeySpecifier),
		fields?: UploadErrorFieldPolicy,
	},
	User?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UserKeySpecifier | (() => undefined | UserKeySpecifier),
		fields?: UserFieldPolicy,
	},
	UserAvatarDelete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UserAvatarDeleteKeySpecifier | (() => undefined | UserAvatarDeleteKeySpecifier),
		fields?: UserAvatarDeleteFieldPolicy,
	},
	UserAvatarUpdate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UserAvatarUpdateKeySpecifier | (() => undefined | UserAvatarUpdateKeySpecifier),
		fields?: UserAvatarUpdateFieldPolicy,
	},
	UserBulkSetActive?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UserBulkSetActiveKeySpecifier | (() => undefined | UserBulkSetActiveKeySpecifier),
		fields?: UserBulkSetActiveFieldPolicy,
	},
	UserCountableConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UserCountableConnectionKeySpecifier | (() => undefined | UserCountableConnectionKeySpecifier),
		fields?: UserCountableConnectionFieldPolicy,
	},
	UserCountableEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UserCountableEdgeKeySpecifier | (() => undefined | UserCountableEdgeKeySpecifier),
		fields?: UserCountableEdgeFieldPolicy,
	},
	UserPermission?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UserPermissionKeySpecifier | (() => undefined | UserPermissionKeySpecifier),
		fields?: UserPermissionFieldPolicy,
	},
	VAT?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | VATKeySpecifier | (() => undefined | VATKeySpecifier),
		fields?: VATFieldPolicy,
	},
	VariantMediaAssign?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | VariantMediaAssignKeySpecifier | (() => undefined | VariantMediaAssignKeySpecifier),
		fields?: VariantMediaAssignFieldPolicy,
	},
	VariantMediaUnassign?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | VariantMediaUnassignKeySpecifier | (() => undefined | VariantMediaUnassignKeySpecifier),
		fields?: VariantMediaUnassignFieldPolicy,
	},
	VariantPricingInfo?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | VariantPricingInfoKeySpecifier | (() => undefined | VariantPricingInfoKeySpecifier),
		fields?: VariantPricingInfoFieldPolicy,
	},
	VerifyToken?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | VerifyTokenKeySpecifier | (() => undefined | VerifyTokenKeySpecifier),
		fields?: VerifyTokenFieldPolicy,
	},
	Voucher?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | VoucherKeySpecifier | (() => undefined | VoucherKeySpecifier),
		fields?: VoucherFieldPolicy,
	},
	VoucherAddCatalogues?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | VoucherAddCataloguesKeySpecifier | (() => undefined | VoucherAddCataloguesKeySpecifier),
		fields?: VoucherAddCataloguesFieldPolicy,
	},
	VoucherBulkDelete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | VoucherBulkDeleteKeySpecifier | (() => undefined | VoucherBulkDeleteKeySpecifier),
		fields?: VoucherBulkDeleteFieldPolicy,
	},
	VoucherChannelListing?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | VoucherChannelListingKeySpecifier | (() => undefined | VoucherChannelListingKeySpecifier),
		fields?: VoucherChannelListingFieldPolicy,
	},
	VoucherChannelListingUpdate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | VoucherChannelListingUpdateKeySpecifier | (() => undefined | VoucherChannelListingUpdateKeySpecifier),
		fields?: VoucherChannelListingUpdateFieldPolicy,
	},
	VoucherCode?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | VoucherCodeKeySpecifier | (() => undefined | VoucherCodeKeySpecifier),
		fields?: VoucherCodeFieldPolicy,
	},
	VoucherCodeBulkDelete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | VoucherCodeBulkDeleteKeySpecifier | (() => undefined | VoucherCodeBulkDeleteKeySpecifier),
		fields?: VoucherCodeBulkDeleteFieldPolicy,
	},
	VoucherCodeBulkDeleteError?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | VoucherCodeBulkDeleteErrorKeySpecifier | (() => undefined | VoucherCodeBulkDeleteErrorKeySpecifier),
		fields?: VoucherCodeBulkDeleteErrorFieldPolicy,
	},
	VoucherCodeCountableConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | VoucherCodeCountableConnectionKeySpecifier | (() => undefined | VoucherCodeCountableConnectionKeySpecifier),
		fields?: VoucherCodeCountableConnectionFieldPolicy,
	},
	VoucherCodeCountableEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | VoucherCodeCountableEdgeKeySpecifier | (() => undefined | VoucherCodeCountableEdgeKeySpecifier),
		fields?: VoucherCodeCountableEdgeFieldPolicy,
	},
	VoucherCodeExportCompleted?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | VoucherCodeExportCompletedKeySpecifier | (() => undefined | VoucherCodeExportCompletedKeySpecifier),
		fields?: VoucherCodeExportCompletedFieldPolicy,
	},
	VoucherCodesCreated?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | VoucherCodesCreatedKeySpecifier | (() => undefined | VoucherCodesCreatedKeySpecifier),
		fields?: VoucherCodesCreatedFieldPolicy,
	},
	VoucherCodesDeleted?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | VoucherCodesDeletedKeySpecifier | (() => undefined | VoucherCodesDeletedKeySpecifier),
		fields?: VoucherCodesDeletedFieldPolicy,
	},
	VoucherCountableConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | VoucherCountableConnectionKeySpecifier | (() => undefined | VoucherCountableConnectionKeySpecifier),
		fields?: VoucherCountableConnectionFieldPolicy,
	},
	VoucherCountableEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | VoucherCountableEdgeKeySpecifier | (() => undefined | VoucherCountableEdgeKeySpecifier),
		fields?: VoucherCountableEdgeFieldPolicy,
	},
	VoucherCreate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | VoucherCreateKeySpecifier | (() => undefined | VoucherCreateKeySpecifier),
		fields?: VoucherCreateFieldPolicy,
	},
	VoucherCreated?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | VoucherCreatedKeySpecifier | (() => undefined | VoucherCreatedKeySpecifier),
		fields?: VoucherCreatedFieldPolicy,
	},
	VoucherDelete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | VoucherDeleteKeySpecifier | (() => undefined | VoucherDeleteKeySpecifier),
		fields?: VoucherDeleteFieldPolicy,
	},
	VoucherDeleted?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | VoucherDeletedKeySpecifier | (() => undefined | VoucherDeletedKeySpecifier),
		fields?: VoucherDeletedFieldPolicy,
	},
	VoucherMetadataUpdated?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | VoucherMetadataUpdatedKeySpecifier | (() => undefined | VoucherMetadataUpdatedKeySpecifier),
		fields?: VoucherMetadataUpdatedFieldPolicy,
	},
	VoucherRemoveCatalogues?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | VoucherRemoveCataloguesKeySpecifier | (() => undefined | VoucherRemoveCataloguesKeySpecifier),
		fields?: VoucherRemoveCataloguesFieldPolicy,
	},
	VoucherTranslatableContent?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | VoucherTranslatableContentKeySpecifier | (() => undefined | VoucherTranslatableContentKeySpecifier),
		fields?: VoucherTranslatableContentFieldPolicy,
	},
	VoucherTranslate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | VoucherTranslateKeySpecifier | (() => undefined | VoucherTranslateKeySpecifier),
		fields?: VoucherTranslateFieldPolicy,
	},
	VoucherTranslation?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | VoucherTranslationKeySpecifier | (() => undefined | VoucherTranslationKeySpecifier),
		fields?: VoucherTranslationFieldPolicy,
	},
	VoucherUpdate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | VoucherUpdateKeySpecifier | (() => undefined | VoucherUpdateKeySpecifier),
		fields?: VoucherUpdateFieldPolicy,
	},
	VoucherUpdated?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | VoucherUpdatedKeySpecifier | (() => undefined | VoucherUpdatedKeySpecifier),
		fields?: VoucherUpdatedFieldPolicy,
	},
	Warehouse?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | WarehouseKeySpecifier | (() => undefined | WarehouseKeySpecifier),
		fields?: WarehouseFieldPolicy,
	},
	WarehouseCountableConnection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | WarehouseCountableConnectionKeySpecifier | (() => undefined | WarehouseCountableConnectionKeySpecifier),
		fields?: WarehouseCountableConnectionFieldPolicy,
	},
	WarehouseCountableEdge?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | WarehouseCountableEdgeKeySpecifier | (() => undefined | WarehouseCountableEdgeKeySpecifier),
		fields?: WarehouseCountableEdgeFieldPolicy,
	},
	WarehouseCreate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | WarehouseCreateKeySpecifier | (() => undefined | WarehouseCreateKeySpecifier),
		fields?: WarehouseCreateFieldPolicy,
	},
	WarehouseCreated?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | WarehouseCreatedKeySpecifier | (() => undefined | WarehouseCreatedKeySpecifier),
		fields?: WarehouseCreatedFieldPolicy,
	},
	WarehouseDelete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | WarehouseDeleteKeySpecifier | (() => undefined | WarehouseDeleteKeySpecifier),
		fields?: WarehouseDeleteFieldPolicy,
	},
	WarehouseDeleted?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | WarehouseDeletedKeySpecifier | (() => undefined | WarehouseDeletedKeySpecifier),
		fields?: WarehouseDeletedFieldPolicy,
	},
	WarehouseError?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | WarehouseErrorKeySpecifier | (() => undefined | WarehouseErrorKeySpecifier),
		fields?: WarehouseErrorFieldPolicy,
	},
	WarehouseMetadataUpdated?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | WarehouseMetadataUpdatedKeySpecifier | (() => undefined | WarehouseMetadataUpdatedKeySpecifier),
		fields?: WarehouseMetadataUpdatedFieldPolicy,
	},
	WarehouseShippingZoneAssign?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | WarehouseShippingZoneAssignKeySpecifier | (() => undefined | WarehouseShippingZoneAssignKeySpecifier),
		fields?: WarehouseShippingZoneAssignFieldPolicy,
	},
	WarehouseShippingZoneUnassign?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | WarehouseShippingZoneUnassignKeySpecifier | (() => undefined | WarehouseShippingZoneUnassignKeySpecifier),
		fields?: WarehouseShippingZoneUnassignFieldPolicy,
	},
	WarehouseUpdate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | WarehouseUpdateKeySpecifier | (() => undefined | WarehouseUpdateKeySpecifier),
		fields?: WarehouseUpdateFieldPolicy,
	},
	WarehouseUpdated?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | WarehouseUpdatedKeySpecifier | (() => undefined | WarehouseUpdatedKeySpecifier),
		fields?: WarehouseUpdatedFieldPolicy,
	},
	Webhook?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | WebhookKeySpecifier | (() => undefined | WebhookKeySpecifier),
		fields?: WebhookFieldPolicy,
	},
	WebhookCreate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | WebhookCreateKeySpecifier | (() => undefined | WebhookCreateKeySpecifier),
		fields?: WebhookCreateFieldPolicy,
	},
	WebhookDelete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | WebhookDeleteKeySpecifier | (() => undefined | WebhookDeleteKeySpecifier),
		fields?: WebhookDeleteFieldPolicy,
	},
	WebhookDryRun?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | WebhookDryRunKeySpecifier | (() => undefined | WebhookDryRunKeySpecifier),
		fields?: WebhookDryRunFieldPolicy,
	},
	WebhookDryRunError?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | WebhookDryRunErrorKeySpecifier | (() => undefined | WebhookDryRunErrorKeySpecifier),
		fields?: WebhookDryRunErrorFieldPolicy,
	},
	WebhookError?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | WebhookErrorKeySpecifier | (() => undefined | WebhookErrorKeySpecifier),
		fields?: WebhookErrorFieldPolicy,
	},
	WebhookEvent?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | WebhookEventKeySpecifier | (() => undefined | WebhookEventKeySpecifier),
		fields?: WebhookEventFieldPolicy,
	},
	WebhookEventAsync?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | WebhookEventAsyncKeySpecifier | (() => undefined | WebhookEventAsyncKeySpecifier),
		fields?: WebhookEventAsyncFieldPolicy,
	},
	WebhookEventSync?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | WebhookEventSyncKeySpecifier | (() => undefined | WebhookEventSyncKeySpecifier),
		fields?: WebhookEventSyncFieldPolicy,
	},
	WebhookTrigger?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | WebhookTriggerKeySpecifier | (() => undefined | WebhookTriggerKeySpecifier),
		fields?: WebhookTriggerFieldPolicy,
	},
	WebhookTriggerError?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | WebhookTriggerErrorKeySpecifier | (() => undefined | WebhookTriggerErrorKeySpecifier),
		fields?: WebhookTriggerErrorFieldPolicy,
	},
	WebhookUpdate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | WebhookUpdateKeySpecifier | (() => undefined | WebhookUpdateKeySpecifier),
		fields?: WebhookUpdateFieldPolicy,
	},
	Weight?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | WeightKeySpecifier | (() => undefined | WeightKeySpecifier),
		fields?: WeightFieldPolicy,
	},
	WidgetTargetOptions?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | WidgetTargetOptionsKeySpecifier | (() => undefined | WidgetTargetOptionsKeySpecifier),
		fields?: WidgetTargetOptionsFieldPolicy,
	},
	_Service?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | _ServiceKeySpecifier | (() => undefined | _ServiceKeySpecifier),
		fields?: _ServiceFieldPolicy,
	}
};
export type TypedTypePolicies = StrictTypedTypePolicies & TypePolicies;
